/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/assets/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ((function(modules) {
	// Check all modules for deduplicated modules
	for(var i in modules) {
		if(Object.prototype.hasOwnProperty.call(modules, i)) {
			switch(typeof modules[i]) {
			case "function": break;
			case "object":
				// Module can be created from a template
				modules[i] = (function(_m) {
					var args = _m.slice(1), fn = modules[_m[0]];
					return function (a,b,c) {
						fn.apply(this, [a,b,c].concat(args));
					};
				}(modules[i]));
				break;
			default:
				// Module is a copy of another module
				modules[i] = modules[modules[i]];
				break;
			}
		}
	}
	return modules;
}([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(355);
	
	var _react = __webpack_require__(64);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(416);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _Main = __webpack_require__(353);
	
	var _Main2 = _interopRequireDefault(_Main);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Render the main component into the dom
	_reactDom2.default.render(_react2.default.createElement(_Main2.default, null), document.getElementById('app'));

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var assert_1 = __webpack_require__(174);
	exports.assert = assert_1.assert;
	exports.assertionError = assert_1.assertionError;
	var crypt_1 = __webpack_require__(175);
	exports.base64 = crypt_1.base64;
	exports.base64Decode = crypt_1.base64Decode;
	exports.base64Encode = crypt_1.base64Encode;
	var constants_1 = __webpack_require__(110);
	exports.CONSTANTS = constants_1.CONSTANTS;
	var deepCopy_1 = __webpack_require__(321);
	exports.deepCopy = deepCopy_1.deepCopy;
	exports.deepExtend = deepCopy_1.deepExtend;
	exports.patchProperty = deepCopy_1.patchProperty;
	var deferred_1 = __webpack_require__(322);
	exports.Deferred = deferred_1.Deferred;
	var environment_1 = __webpack_require__(323);
	exports.getUA = environment_1.getUA;
	exports.isMobileCordova = environment_1.isMobileCordova;
	exports.isNodeSdk = environment_1.isNodeSdk;
	exports.isReactNative = environment_1.isReactNative;
	var errors_1 = __webpack_require__(324);
	exports.ErrorFactory = errors_1.ErrorFactory;
	exports.FirebaseError = errors_1.FirebaseError;
	exports.patchCapture = errors_1.patchCapture;
	var json_1 = __webpack_require__(176);
	exports.jsonEval = json_1.jsonEval;
	exports.stringify = json_1.stringify;
	var jwt_1 = __webpack_require__(326);
	exports.decode = jwt_1.decode;
	exports.isAdmin = jwt_1.isAdmin;
	exports.issuedAtTime = jwt_1.issuedAtTime;
	exports.isValidFormat = jwt_1.isValidFormat;
	exports.isValidTimestamp = jwt_1.isValidTimestamp;
	var obj_1 = __webpack_require__(177);
	exports.clone = obj_1.clone;
	exports.contains = obj_1.contains;
	exports.every = obj_1.every;
	exports.extend = obj_1.extend;
	exports.findKey = obj_1.findKey;
	exports.findValue = obj_1.findValue;
	exports.forEach = obj_1.forEach;
	exports.getAnyKey = obj_1.getAnyKey;
	exports.getCount = obj_1.getCount;
	exports.getValues = obj_1.getValues;
	exports.isEmpty = obj_1.isEmpty;
	exports.isNonNullObject = obj_1.isNonNullObject;
	exports.map = obj_1.map;
	exports.safeGet = obj_1.safeGet;
	var query_1 = __webpack_require__(327);
	exports.querystring = query_1.querystring;
	exports.querystringDecode = query_1.querystringDecode;
	var sha1_1 = __webpack_require__(328);
	exports.Sha1 = sha1_1.Sha1;
	var subscribe_1 = __webpack_require__(329);
	exports.async = subscribe_1.async;
	exports.createSubscribe = subscribe_1.createSubscribe;
	var validation_1 = __webpack_require__(331);
	exports.errorPrefix = validation_1.errorPrefix;
	exports.validateArgCount = validation_1.validateArgCount;
	exports.validateCallback = validation_1.validateCallback;
	exports.validateContextObject = validation_1.validateContextObject;
	exports.validateNamespace = validation_1.validateNamespace;
	var utf8_1 = __webpack_require__(330);
	exports.stringLength = utf8_1.stringLength;
	exports.stringToByteArray = utf8_1.stringToByteArray;
	
	//# sourceMappingURL=index.js.map


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var version_1 = __webpack_require__(100);
	var log_1 = __webpack_require__(13);
	/**
	 * Unconditionally fails, throwing an Error with the given message.
	 *
	 * Returns any so it can be used in expressions:
	 * @example
	 * let futureVar = fail('not implemented yet');
	 */
	function fail(failure) {
	    // Log the failure in addition to throw an exception, just in case the
	    // exception is swallowed.
	    var message = "FIRESTORE (" + version_1.SDK_VERSION + ") INTERNAL ASSERTION FAILED: " + failure;
	    log_1.error(message);
	    // NOTE: We don't use FirestoreError here because these are internal failures
	    // that cannot be handled by the user. (Also it would create a circular
	    // dependency between the error and assert modules which doesn't work.)
	    throw new Error(message);
	}
	exports.fail = fail;
	/**
	 * Fails if the given assertion condition is false, throwing an Error with the
	 * given message if it did.
	 */
	function assert(assertion, message) {
	    if (!assertion) {
	        fail(message);
	    }
	}
	exports.assert = assert;
	
	//# sourceMappingURL=assert.js.map


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var validateFormat = function validateFormat(format) {};
	
	if (false) {
	  validateFormat = function validateFormat(format) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  };
	}
	
	function invariant(condition, format, a, b, c, d, e, f) {
	  validateFormat(format);
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(format.replace(/%s/g, function () {
	        return args[argIndex++];
	      }));
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	}
	
	module.exports = invariant;

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var util_1 = __webpack_require__(1);
	var util_2 = __webpack_require__(1);
	var util_3 = __webpack_require__(1);
	var util_4 = __webpack_require__(1);
	var util_5 = __webpack_require__(1);
	var util_6 = __webpack_require__(1);
	var storage_1 = __webpack_require__(68);
	var util_7 = __webpack_require__(1);
	/**
	 * Returns a locally-unique ID (generated by just incrementing up from 0 each time its called).
	 * @type {function(): number} Generated ID.
	 */
	exports.LUIDGenerator = (function () {
	    var id = 1;
	    return function () {
	        return id++;
	    };
	})();
	/**
	 * Sha1 hash of the input string
	 * @param {!string} str The string to hash
	 * @return {!string} The resulting hash
	 */
	exports.sha1 = function (str) {
	    var utf8Bytes = util_5.stringToByteArray(str);
	    var sha1 = new util_4.Sha1();
	    sha1.update(utf8Bytes);
	    var sha1Bytes = sha1.digest();
	    return util_3.base64.encodeByteArray(sha1Bytes);
	};
	/**
	 * @param {...*} var_args
	 * @return {string}
	 * @private
	 */
	var buildLogMessage_ = function () {
	    var var_args = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        var_args[_i] = arguments[_i];
	    }
	    var message = '';
	    for (var i = 0; i < var_args.length; i++) {
	        if (Array.isArray(var_args[i]) ||
	            (var_args[i] &&
	                typeof var_args[i] === 'object' &&
	                typeof var_args[i].length === 'number')) {
	            message += buildLogMessage_.apply(null, var_args[i]);
	        }
	        else if (typeof var_args[i] === 'object') {
	            message += util_6.stringify(var_args[i]);
	        }
	        else {
	            message += var_args[i];
	        }
	        message += ' ';
	    }
	    return message;
	};
	/**
	 * Use this for all debug messages in Firebase.
	 * @type {?function(string)}
	 */
	exports.logger = null;
	/**
	 * Flag to check for log availability on first log message
	 * @type {boolean}
	 * @private
	 */
	var firstLog_ = true;
	/**
	 * The implementation of Firebase.enableLogging (defined here to break dependencies)
	 * @param {boolean|?function(string)} logger_ A flag to turn on logging, or a custom logger
	 * @param {boolean=} persistent Whether or not to persist logging settings across refreshes
	 */
	exports.enableLogging = function (logger_, persistent) {
	    util_1.assert(!persistent || (logger_ === true || logger_ === false), "Can't turn on custom loggers persistently.");
	    if (logger_ === true) {
	        if (typeof console !== 'undefined') {
	            if (typeof console.log === 'function') {
	                exports.logger = console.log.bind(console);
	            }
	            else if (typeof console.log === 'object') {
	                // IE does this.
	                exports.logger = function (message) {
	                    console.log(message);
	                };
	            }
	        }
	        if (persistent)
	            storage_1.SessionStorage.set('logging_enabled', true);
	    }
	    else if (typeof logger_ === 'function') {
	        exports.logger = logger_;
	    }
	    else {
	        exports.logger = null;
	        storage_1.SessionStorage.remove('logging_enabled');
	    }
	};
	/**
	 *
	 * @param {...(string|Arguments)} var_args
	 */
	exports.log = function () {
	    var var_args = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        var_args[_i] = arguments[_i];
	    }
	    if (firstLog_ === true) {
	        firstLog_ = false;
	        if (exports.logger === null && storage_1.SessionStorage.get('logging_enabled') === true)
	            exports.enableLogging(true);
	    }
	    if (exports.logger) {
	        var message = buildLogMessage_.apply(null, var_args);
	        exports.logger(message);
	    }
	};
	/**
	 * @param {!string} prefix
	 * @return {function(...[*])}
	 */
	exports.logWrapper = function (prefix) {
	    return function () {
	        var var_args = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            var_args[_i] = arguments[_i];
	        }
	        exports.log.apply(void 0, [prefix].concat(var_args));
	    };
	};
	/**
	 * @param {...string} var_args
	 */
	exports.error = function () {
	    var var_args = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        var_args[_i] = arguments[_i];
	    }
	    if (typeof console !== 'undefined') {
	        var message = 'FIREBASE INTERNAL ERROR: ' + buildLogMessage_.apply(void 0, var_args);
	        if (typeof console.error !== 'undefined') {
	            console.error(message);
	        }
	        else {
	            console.log(message);
	        }
	    }
	};
	/**
	 * @param {...string} var_args
	 */
	exports.fatal = function () {
	    var var_args = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        var_args[_i] = arguments[_i];
	    }
	    var message = buildLogMessage_.apply(void 0, var_args);
	    throw new Error('FIREBASE FATAL ERROR: ' + message);
	};
	/**
	 * @param {...*} var_args
	 */
	exports.warn = function () {
	    var var_args = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        var_args[_i] = arguments[_i];
	    }
	    if (typeof console !== 'undefined') {
	        var message = 'FIREBASE WARNING: ' + buildLogMessage_.apply(void 0, var_args);
	        if (typeof console.warn !== 'undefined') {
	            console.warn(message);
	        }
	        else {
	            console.log(message);
	        }
	    }
	};
	/**
	 * Logs a warning if the containing page uses https. Called when a call to new Firebase
	 * does not use https.
	 */
	exports.warnIfPageIsSecure = function () {
	    // Be very careful accessing browser globals. Who knows what may or may not exist.
	    if (typeof window !== 'undefined' &&
	        window.location &&
	        window.location.protocol &&
	        window.location.protocol.indexOf('https:') !== -1) {
	        exports.warn('Insecure Firebase access from a secure page. ' +
	            'Please use https in calls to new Firebase().');
	    }
	};
	/**
	 * @param {!String} methodName
	 */
	exports.warnAboutUnsupportedMethod = function (methodName) {
	    exports.warn(methodName +
	        ' is unsupported and will likely change soon.  ' +
	        'Please do not use.');
	};
	/**
	 * Returns true if data is NaN, or +/- Infinity.
	 * @param {*} data
	 * @return {boolean}
	 */
	exports.isInvalidJSONNumber = function (data) {
	    return (typeof data === 'number' &&
	        (data != data || // NaN
	            data == Number.POSITIVE_INFINITY ||
	            data == Number.NEGATIVE_INFINITY));
	};
	/**
	 * @param {function()} fn
	 */
	exports.executeWhenDOMReady = function (fn) {
	    if (util_7.isNodeSdk() || document.readyState === 'complete') {
	        fn();
	    }
	    else {
	        // Modeled after jQuery. Try DOMContentLoaded and onreadystatechange (which
	        // fire before onload), but fall back to onload.
	        var called_1 = false;
	        var wrappedFn_1 = function () {
	            if (!document.body) {
	                setTimeout(wrappedFn_1, Math.floor(10));
	                return;
	            }
	            if (!called_1) {
	                called_1 = true;
	                fn();
	            }
	        };
	        if (document.addEventListener) {
	            document.addEventListener('DOMContentLoaded', wrappedFn_1, false);
	            // fallback to onload.
	            window.addEventListener('load', wrappedFn_1, false);
	        }
	        else if (document.attachEvent) {
	            // IE.
	            document.attachEvent('onreadystatechange', function () {
	                if (document.readyState === 'complete')
	                    wrappedFn_1();
	            });
	            // fallback to onload.
	            window.attachEvent('onload', wrappedFn_1);
	            // jQuery has an extra hack for IE that we could employ (based on
	            // http://javascript.nwbox.com/IEContentLoaded/) But it looks really old.
	            // I'm hoping we don't need it.
	        }
	    }
	};
	/**
	 * Minimum key name. Invalid for actual data, used as a marker to sort before any valid names
	 * @type {!string}
	 */
	exports.MIN_NAME = '[MIN_NAME]';
	/**
	 * Maximum key name. Invalid for actual data, used as a marker to sort above any valid names
	 * @type {!string}
	 */
	exports.MAX_NAME = '[MAX_NAME]';
	/**
	 * Compares valid Firebase key names, plus min and max name
	 * @param {!string} a
	 * @param {!string} b
	 * @return {!number}
	 */
	exports.nameCompare = function (a, b) {
	    if (a === b) {
	        return 0;
	    }
	    else if (a === exports.MIN_NAME || b === exports.MAX_NAME) {
	        return -1;
	    }
	    else if (b === exports.MIN_NAME || a === exports.MAX_NAME) {
	        return 1;
	    }
	    else {
	        var aAsInt = exports.tryParseInt(a), bAsInt = exports.tryParseInt(b);
	        if (aAsInt !== null) {
	            if (bAsInt !== null) {
	                return aAsInt - bAsInt == 0 ? a.length - b.length : aAsInt - bAsInt;
	            }
	            else {
	                return -1;
	            }
	        }
	        else if (bAsInt !== null) {
	            return 1;
	        }
	        else {
	            return a < b ? -1 : 1;
	        }
	    }
	};
	/**
	 * @param {!string} a
	 * @param {!string} b
	 * @return {!number} comparison result.
	 */
	exports.stringCompare = function (a, b) {
	    if (a === b) {
	        return 0;
	    }
	    else if (a < b) {
	        return -1;
	    }
	    else {
	        return 1;
	    }
	};
	/**
	 * @param {string} key
	 * @param {Object} obj
	 * @return {*}
	 */
	exports.requireKey = function (key, obj) {
	    if (obj && key in obj) {
	        return obj[key];
	    }
	    else {
	        throw new Error('Missing required key (' + key + ') in object: ' + util_6.stringify(obj));
	    }
	};
	/**
	 * @param {*} obj
	 * @return {string}
	 */
	exports.ObjectToUniqueKey = function (obj) {
	    if (typeof obj !== 'object' || obj === null)
	        return util_6.stringify(obj);
	    var keys = [];
	    for (var k in obj) {
	        keys.push(k);
	    }
	    // Export as json, but with the keys sorted.
	    keys.sort();
	    var key = '{';
	    for (var i = 0; i < keys.length; i++) {
	        if (i !== 0)
	            key += ',';
	        key += util_6.stringify(keys[i]);
	        key += ':';
	        key += exports.ObjectToUniqueKey(obj[keys[i]]);
	    }
	    key += '}';
	    return key;
	};
	/**
	 * Splits a string into a number of smaller segments of maximum size
	 * @param {!string} str The string
	 * @param {!number} segsize The maximum number of chars in the string.
	 * @return {Array.<string>} The string, split into appropriately-sized chunks
	 */
	exports.splitStringBySize = function (str, segsize) {
	    var len = str.length;
	    if (len <= segsize) {
	        return [str];
	    }
	    var dataSegs = [];
	    for (var c = 0; c < len; c += segsize) {
	        if (c + segsize > len) {
	            dataSegs.push(str.substring(c, len));
	        }
	        else {
	            dataSegs.push(str.substring(c, c + segsize));
	        }
	    }
	    return dataSegs;
	};
	/**
	 * Apply a function to each (key, value) pair in an object or
	 * apply a function to each (index, value) pair in an array
	 * @param {!(Object|Array)} obj The object or array to iterate over
	 * @param {function(?, ?)} fn The function to apply
	 */
	exports.each = function (obj, fn) {
	    if (Array.isArray(obj)) {
	        for (var i = 0; i < obj.length; ++i) {
	            fn(i, obj[i]);
	        }
	    }
	    else {
	        /**
	         * in the conversion of code we removed the goog.object.forEach
	         * function which did a value,key callback. We standardized on
	         * a single impl that does a key, value callback. So we invert
	         * to not have to touch the `each` code points
	         */
	        util_2.forEach(obj, function (key, val) { return fn(val, key); });
	    }
	};
	/**
	 * Like goog.bind, but doesn't bother to create a closure if opt_context is null/undefined.
	 * @param {function(*)} callback Callback function.
	 * @param {?Object=} context Optional context to bind to.
	 * @return {function(*)}
	 */
	exports.bindCallback = function (callback, context) {
	    return context ? callback.bind(context) : callback;
	};
	/**
	 * Borrowed from http://hg.secondlife.com/llsd/src/tip/js/typedarray.js (MIT License)
	 * I made one modification at the end and removed the NaN / Infinity
	 * handling (since it seemed broken [caused an overflow] and we don't need it).  See MJL comments.
	 * @param {!number} v A double
	 * @return {string}
	 */
	exports.doubleToIEEE754String = function (v) {
	    util_1.assert(!exports.isInvalidJSONNumber(v), 'Invalid JSON number'); // MJL
	    var ebits = 11, fbits = 52;
	    var bias = (1 << (ebits - 1)) - 1, s, e, f, ln, i, bits, str;
	    // Compute sign, exponent, fraction
	    // Skip NaN / Infinity handling --MJL.
	    if (v === 0) {
	        e = 0;
	        f = 0;
	        s = 1 / v === -Infinity ? 1 : 0;
	    }
	    else {
	        s = v < 0;
	        v = Math.abs(v);
	        if (v >= Math.pow(2, 1 - bias)) {
	            // Normalized
	            ln = Math.min(Math.floor(Math.log(v) / Math.LN2), bias);
	            e = ln + bias;
	            f = Math.round(v * Math.pow(2, fbits - ln) - Math.pow(2, fbits));
	        }
	        else {
	            // Denormalized
	            e = 0;
	            f = Math.round(v / Math.pow(2, 1 - bias - fbits));
	        }
	    }
	    // Pack sign, exponent, fraction
	    bits = [];
	    for (i = fbits; i; i -= 1) {
	        bits.push(f % 2 ? 1 : 0);
	        f = Math.floor(f / 2);
	    }
	    for (i = ebits; i; i -= 1) {
	        bits.push(e % 2 ? 1 : 0);
	        e = Math.floor(e / 2);
	    }
	    bits.push(s ? 1 : 0);
	    bits.reverse();
	    str = bits.join('');
	    // Return the data as a hex string. --MJL
	    var hexByteString = '';
	    for (i = 0; i < 64; i += 8) {
	        var hexByte = parseInt(str.substr(i, 8), 2).toString(16);
	        if (hexByte.length === 1)
	            hexByte = '0' + hexByte;
	        hexByteString = hexByteString + hexByte;
	    }
	    return hexByteString.toLowerCase();
	};
	/**
	 * Used to detect if we're in a Chrome content script (which executes in an
	 * isolated environment where long-polling doesn't work).
	 * @return {boolean}
	 */
	exports.isChromeExtensionContentScript = function () {
	    return !!(typeof window === 'object' &&
	        window['chrome'] &&
	        window['chrome']['extension'] &&
	        !/^chrome/.test(window.location.href));
	};
	/**
	 * Used to detect if we're in a Windows 8 Store app.
	 * @return {boolean}
	 */
	exports.isWindowsStoreApp = function () {
	    // Check for the presence of a couple WinRT globals
	    return typeof Windows === 'object' && typeof Windows.UI === 'object';
	};
	/**
	 * Converts a server error code to a Javascript Error
	 * @param {!string} code
	 * @param {!Query} query
	 * @return {Error}
	 */
	exports.errorForServerCode = function (code, query) {
	    var reason = 'Unknown Error';
	    if (code === 'too_big') {
	        reason =
	            'The data requested exceeds the maximum size ' +
	                'that can be accessed with a single request.';
	    }
	    else if (code == 'permission_denied') {
	        reason = "Client doesn't have permission to access the desired data.";
	    }
	    else if (code == 'unavailable') {
	        reason = 'The service is unavailable';
	    }
	    var error = new Error(code + ' at ' + query.path.toString() + ': ' + reason);
	    error.code = code.toUpperCase();
	    return error;
	};
	/**
	 * Used to test for integer-looking strings
	 * @type {RegExp}
	 * @private
	 */
	exports.INTEGER_REGEXP_ = new RegExp('^-?\\d{1,10}$');
	/**
	 * If the string contains a 32-bit integer, return it.  Else return null.
	 * @param {!string} str
	 * @return {?number}
	 */
	exports.tryParseInt = function (str) {
	    if (exports.INTEGER_REGEXP_.test(str)) {
	        var intVal = Number(str);
	        if (intVal >= -2147483648 && intVal <= 2147483647) {
	            return intVal;
	        }
	    }
	    return null;
	};
	/**
	 * Helper to run some code but catch any exceptions and re-throw them later.
	 * Useful for preventing user callbacks from breaking internal code.
	 *
	 * Re-throwing the exception from a setTimeout is a little evil, but it's very
	 * convenient (we don't have to try to figure out when is a safe point to
	 * re-throw it), and the behavior seems reasonable:
	 *
	 * * If you aren't pausing on exceptions, you get an error in the console with
	 *   the correct stack trace.
	 * * If you're pausing on all exceptions, the debugger will pause on your
	 *   exception and then again when we rethrow it.
	 * * If you're only pausing on uncaught exceptions, the debugger will only pause
	 *   on us re-throwing it.
	 *
	 * @param {!function()} fn The code to guard.
	 */
	exports.exceptionGuard = function (fn) {
	    try {
	        fn();
	    }
	    catch (e) {
	        // Re-throw exception when it's safe.
	        setTimeout(function () {
	            // It used to be that "throw e" would result in a good console error with
	            // relevant context, but as of Chrome 39, you just get the firebase.js
	            // file/line number where we re-throw it, which is useless. So we log
	            // e.stack explicitly.
	            var stack = e.stack || '';
	            exports.warn('Exception was thrown by user callback.', stack);
	            throw e;
	        }, Math.floor(0));
	    }
	};
	/**
	 * Helper function to safely call opt_callback with the specified arguments.  It:
	 * 1. Turns into a no-op if opt_callback is null or undefined.
	 * 2. Wraps the call inside exceptionGuard to prevent exceptions from breaking our state.
	 *
	 * @param {?Function=} callback Optional onComplete callback.
	 * @param {...*} var_args Arbitrary args to be passed to opt_onComplete
	 */
	exports.callUserCallback = function (callback) {
	    var var_args = [];
	    for (var _i = 1; _i < arguments.length; _i++) {
	        var_args[_i - 1] = arguments[_i];
	    }
	    if (typeof callback === 'function') {
	        exports.exceptionGuard(function () {
	            callback.apply(void 0, var_args);
	        });
	    }
	};
	/**
	 * @return {boolean} true if we think we're currently being crawled.
	 */
	exports.beingCrawled = function () {
	    var userAgent = (typeof window === 'object' &&
	        window['navigator'] &&
	        window['navigator']['userAgent']) ||
	        '';
	    // For now we whitelist the most popular crawlers.  We should refine this to be the set of crawlers we
	    // believe to support JavaScript/AJAX rendering.
	    // NOTE: Google Webmaster Tools doesn't really belong, but their "This is how a visitor to your website
	    // would have seen the page" is flaky if we don't treat it as a crawler.
	    return (userAgent.search(/googlebot|google webmaster tools|bingbot|yahoo! slurp|baiduspider|yandexbot|duckduckbot/i) >= 0);
	};
	/**
	 * Export a property of an object using a getter function.
	 *
	 * @param {!Object} object
	 * @param {string} name
	 * @param {!function(): *} fnGet
	 */
	exports.exportPropGetter = function (object, name, fnGet) {
	    Object.defineProperty(object, name, { get: fnGet });
	};
	/**
	 * Same as setTimeout() except on Node.JS it will /not/ prevent the process from exiting.
	 *
	 * It is removed with clearTimeout() as normal.
	 *
	 * @param {Function} fn Function to run.
	 * @param {number} time Milliseconds to wait before running.
	 * @return {number|Object} The setTimeout() return value.
	 */
	exports.setTimeoutNonBlocking = function (fn, time) {
	    var timeout = setTimeout(fn, time);
	    if (typeof timeout === 'object' && timeout['unref']) {
	        timeout['unref']();
	    }
	    return timeout;
	};
	
	//# sourceMappingURL=util.js.map


/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var emptyFunction = __webpack_require__(24);
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var warning = emptyFunction;
	
	if (false) {
	  var printWarning = function printWarning(format) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    var argIndex = 0;
	    var message = 'Warning: ' + format.replace(/%s/g, function () {
	      return args[argIndex++];
	    });
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	
	  warning = function warning(condition, format) {
	    if (format === undefined) {
	      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
	    }
	
	    if (format.indexOf('Failed Composite propType: ') === 0) {
	      return; // Ignore CompositeComponent proptype check.
	    }
	
	    if (!condition) {
	      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
	        args[_key2 - 2] = arguments[_key2];
	      }
	
	      printWarning.apply(undefined, [format].concat(args));
	    }
	  };
	}
	
	module.exports = warning;

/***/ }),
/* 6 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	'use strict';
	
	/**
	 * WARNING: DO NOT manually require this module.
	 * This is a replacement for `invariant(...)` used by the error code system
	 * and will _only_ be required by the corresponding babel pass.
	 * It always throws.
	 */
	
	function reactProdInvariant(code) {
	  var argCount = arguments.length - 1;
	
	  var message = 'Minified React error #' + code + '; visit ' + 'http://facebook.github.io/react/docs/error-decoder.html?invariant=' + code;
	
	  for (var argIdx = 0; argIdx < argCount; argIdx++) {
	    message += '&args[]=' + encodeURIComponent(arguments[argIdx + 1]);
	  }
	
	  message += ' for the full message or use the non-minified dev environment' + ' for full errors and additional helpful warnings.';
	
	  var error = new Error(message);
	  error.name = 'Invariant Violation';
	  error.framesToPop = 1; // we don't care about reactProdInvariant's own frame
	
	  throw error;
	}
	
	module.exports = reactProdInvariant;

/***/ }),
/* 7 */
/***/ (function(module, exports) {

	/*
	object-assign
	(c) Sindre Sorhus
	@license MIT
	*/
	
	'use strict';
	/* eslint-disable no-unused-vars */
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}
	
			// Detect buggy property enumeration order in older V8 versions.
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}
	
			return true;
		} catch (err) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}
	
	module.exports = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;
	
		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);
	
			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}
	
			if (getOwnPropertySymbols) {
				symbols = getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}
	
		return to;
	};


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var util_1 = __webpack_require__(4);
	var util_2 = __webpack_require__(1);
	/**
	 * An immutable object representing a parsed path.  It's immutable so that you
	 * can pass them around to other functions without worrying about them changing
	 * it.
	 */
	var Path = /** @class */ (function () {
	    /**
	     * @param {string|Array.<string>} pathOrString Path string to parse,
	     *      or another path, or the raw tokens array
	     * @param {number=} pieceNum
	     */
	    function Path(pathOrString, pieceNum) {
	        if (pieceNum === void 0) {
	            this.pieces_ = pathOrString.split('/');
	            // Remove empty pieces.
	            var copyTo = 0;
	            for (var i = 0; i < this.pieces_.length; i++) {
	                if (this.pieces_[i].length > 0) {
	                    this.pieces_[copyTo] = this.pieces_[i];
	                    copyTo++;
	                }
	            }
	            this.pieces_.length = copyTo;
	            this.pieceNum_ = 0;
	        }
	        else {
	            this.pieces_ = pathOrString;
	            this.pieceNum_ = pieceNum;
	        }
	    }
	    Object.defineProperty(Path, "Empty", {
	        /**
	         * Singleton to represent an empty path
	         *
	         * @const
	         */
	        get: function () {
	            return new Path('');
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Path.prototype.getFront = function () {
	        if (this.pieceNum_ >= this.pieces_.length)
	            return null;
	        return this.pieces_[this.pieceNum_];
	    };
	    /**
	     * @return {number} The number of segments in this path
	     */
	    Path.prototype.getLength = function () {
	        return this.pieces_.length - this.pieceNum_;
	    };
	    /**
	     * @return {!Path}
	     */
	    Path.prototype.popFront = function () {
	        var pieceNum = this.pieceNum_;
	        if (pieceNum < this.pieces_.length) {
	            pieceNum++;
	        }
	        return new Path(this.pieces_, pieceNum);
	    };
	    /**
	     * @return {?string}
	     */
	    Path.prototype.getBack = function () {
	        if (this.pieceNum_ < this.pieces_.length)
	            return this.pieces_[this.pieces_.length - 1];
	        return null;
	    };
	    Path.prototype.toString = function () {
	        var pathString = '';
	        for (var i = this.pieceNum_; i < this.pieces_.length; i++) {
	            if (this.pieces_[i] !== '')
	                pathString += '/' + this.pieces_[i];
	        }
	        return pathString || '/';
	    };
	    Path.prototype.toUrlEncodedString = function () {
	        var pathString = '';
	        for (var i = this.pieceNum_; i < this.pieces_.length; i++) {
	            if (this.pieces_[i] !== '')
	                pathString += '/' + encodeURIComponent(String(this.pieces_[i]));
	        }
	        return pathString || '/';
	    };
	    /**
	     * Shallow copy of the parts of the path.
	     *
	     * @param {number=} begin
	     * @return {!Array<string>}
	     */
	    Path.prototype.slice = function (begin) {
	        if (begin === void 0) { begin = 0; }
	        return this.pieces_.slice(this.pieceNum_ + begin);
	    };
	    /**
	     * @return {?Path}
	     */
	    Path.prototype.parent = function () {
	        if (this.pieceNum_ >= this.pieces_.length)
	            return null;
	        var pieces = [];
	        for (var i = this.pieceNum_; i < this.pieces_.length - 1; i++)
	            pieces.push(this.pieces_[i]);
	        return new Path(pieces, 0);
	    };
	    /**
	     * @param {string|!Path} childPathObj
	     * @return {!Path}
	     */
	    Path.prototype.child = function (childPathObj) {
	        var pieces = [];
	        for (var i = this.pieceNum_; i < this.pieces_.length; i++)
	            pieces.push(this.pieces_[i]);
	        if (childPathObj instanceof Path) {
	            for (var i = childPathObj.pieceNum_; i < childPathObj.pieces_.length; i++) {
	                pieces.push(childPathObj.pieces_[i]);
	            }
	        }
	        else {
	            var childPieces = childPathObj.split('/');
	            for (var i = 0; i < childPieces.length; i++) {
	                if (childPieces[i].length > 0)
	                    pieces.push(childPieces[i]);
	            }
	        }
	        return new Path(pieces, 0);
	    };
	    /**
	     * @return {boolean} True if there are no segments in this path
	     */
	    Path.prototype.isEmpty = function () {
	        return this.pieceNum_ >= this.pieces_.length;
	    };
	    /**
	     * @param {!Path} outerPath
	     * @param {!Path} innerPath
	     * @return {!Path} The path from outerPath to innerPath
	     */
	    Path.relativePath = function (outerPath, innerPath) {
	        var outer = outerPath.getFront(), inner = innerPath.getFront();
	        if (outer === null) {
	            return innerPath;
	        }
	        else if (outer === inner) {
	            return Path.relativePath(outerPath.popFront(), innerPath.popFront());
	        }
	        else {
	            throw new Error('INTERNAL ERROR: innerPath (' +
	                innerPath +
	                ') is not within ' +
	                'outerPath (' +
	                outerPath +
	                ')');
	        }
	    };
	    /**
	     * @param {!Path} left
	     * @param {!Path} right
	     * @return {number} -1, 0, 1 if left is less, equal, or greater than the right.
	     */
	    Path.comparePaths = function (left, right) {
	        var leftKeys = left.slice();
	        var rightKeys = right.slice();
	        for (var i = 0; i < leftKeys.length && i < rightKeys.length; i++) {
	            var cmp = util_1.nameCompare(leftKeys[i], rightKeys[i]);
	            if (cmp !== 0)
	                return cmp;
	        }
	        if (leftKeys.length === rightKeys.length)
	            return 0;
	        return leftKeys.length < rightKeys.length ? -1 : 1;
	    };
	    /**
	     *
	     * @param {Path} other
	     * @return {boolean} true if paths are the same.
	     */
	    Path.prototype.equals = function (other) {
	        if (this.getLength() !== other.getLength()) {
	            return false;
	        }
	        for (var i = this.pieceNum_, j = other.pieceNum_; i <= this.pieces_.length; i++, j++) {
	            if (this.pieces_[i] !== other.pieces_[j]) {
	                return false;
	            }
	        }
	        return true;
	    };
	    /**
	     *
	     * @param {!Path} other
	     * @return {boolean} True if this path is a parent (or the same as) other
	     */
	    Path.prototype.contains = function (other) {
	        var i = this.pieceNum_;
	        var j = other.pieceNum_;
	        if (this.getLength() > other.getLength()) {
	            return false;
	        }
	        while (i < this.pieces_.length) {
	            if (this.pieces_[i] !== other.pieces_[j]) {
	                return false;
	            }
	            ++i;
	            ++j;
	        }
	        return true;
	    };
	    return Path;
	}()); // end Path
	exports.Path = Path;
	/**
	 * Dynamic (mutable) path used to count path lengths.
	 *
	 * This class is used to efficiently check paths for valid
	 * length (in UTF8 bytes) and depth (used in path validation).
	 *
	 * Throws Error exception if path is ever invalid.
	 *
	 * The definition of a path always begins with '/'.
	 */
	var ValidationPath = /** @class */ (function () {
	    /**
	     * @param {!Path} path Initial Path.
	     * @param {string} errorPrefix_ Prefix for any error messages.
	     */
	    function ValidationPath(path, errorPrefix_) {
	        this.errorPrefix_ = errorPrefix_;
	        /** @type {!Array<string>} */
	        this.parts_ = path.slice();
	        /** @type {number} Initialize to number of '/' chars needed in path. */
	        this.byteLength_ = Math.max(1, this.parts_.length);
	        for (var i = 0; i < this.parts_.length; i++) {
	            this.byteLength_ += util_2.stringLength(this.parts_[i]);
	        }
	        this.checkValid_();
	    }
	    Object.defineProperty(ValidationPath, "MAX_PATH_DEPTH", {
	        /** @const {number} Maximum key depth. */
	        get: function () {
	            return 32;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(ValidationPath, "MAX_PATH_LENGTH_BYTES", {
	        /** @const {number} Maximum number of (UTF8) bytes in a Firebase path. */
	        get: function () {
	            return 768;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    /** @param {string} child */
	    ValidationPath.prototype.push = function (child) {
	        // Count the needed '/'
	        if (this.parts_.length > 0) {
	            this.byteLength_ += 1;
	        }
	        this.parts_.push(child);
	        this.byteLength_ += util_2.stringLength(child);
	        this.checkValid_();
	    };
	    ValidationPath.prototype.pop = function () {
	        var last = this.parts_.pop();
	        this.byteLength_ -= util_2.stringLength(last);
	        // Un-count the previous '/'
	        if (this.parts_.length > 0) {
	            this.byteLength_ -= 1;
	        }
	    };
	    ValidationPath.prototype.checkValid_ = function () {
	        if (this.byteLength_ > ValidationPath.MAX_PATH_LENGTH_BYTES) {
	            throw new Error(this.errorPrefix_ +
	                'has a key path longer than ' +
	                ValidationPath.MAX_PATH_LENGTH_BYTES +
	                ' bytes (' +
	                this.byteLength_ +
	                ').');
	        }
	        if (this.parts_.length > ValidationPath.MAX_PATH_DEPTH) {
	            throw new Error(this.errorPrefix_ +
	                'path specified exceeds the maximum depth that can be written (' +
	                ValidationPath.MAX_PATH_DEPTH +
	                ') or object contains a cycle ' +
	                this.toErrorString());
	        }
	    };
	    /**
	     * String for use in error messages - uses '.' notation for path.
	     *
	     * @return {string}
	     */
	    ValidationPath.prototype.toErrorString = function () {
	        if (this.parts_.length == 0) {
	            return '';
	        }
	        return "in property '" + this.parts_.join('.') + "'";
	    };
	    return ValidationPath;
	}());
	exports.ValidationPath = ValidationPath;
	
	//# sourceMappingURL=Path.js.map


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(6);
	
	var DOMProperty = __webpack_require__(45);
	var ReactDOMComponentFlags = __webpack_require__(199);
	
	var invariant = __webpack_require__(3);
	
	var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
	var Flags = ReactDOMComponentFlags;
	
	var internalInstanceKey = '__reactInternalInstance$' + Math.random().toString(36).slice(2);
	
	/**
	 * Check if a given node should be cached.
	 */
	function shouldPrecacheNode(node, nodeID) {
	  return node.nodeType === 1 && node.getAttribute(ATTR_NAME) === String(nodeID) || node.nodeType === 8 && node.nodeValue === ' react-text: ' + nodeID + ' ' || node.nodeType === 8 && node.nodeValue === ' react-empty: ' + nodeID + ' ';
	}
	
	/**
	 * Drill down (through composites and empty components) until we get a host or
	 * host text component.
	 *
	 * This is pretty polymorphic but unavoidable with the current structure we have
	 * for `_renderedChildren`.
	 */
	function getRenderedHostOrTextFromComponent(component) {
	  var rendered;
	  while (rendered = component._renderedComponent) {
	    component = rendered;
	  }
	  return component;
	}
	
	/**
	 * Populate `_hostNode` on the rendered host/text component with the given
	 * DOM node. The passed `inst` can be a composite.
	 */
	function precacheNode(inst, node) {
	  var hostInst = getRenderedHostOrTextFromComponent(inst);
	  hostInst._hostNode = node;
	  node[internalInstanceKey] = hostInst;
	}
	
	function uncacheNode(inst) {
	  var node = inst._hostNode;
	  if (node) {
	    delete node[internalInstanceKey];
	    inst._hostNode = null;
	  }
	}
	
	/**
	 * Populate `_hostNode` on each child of `inst`, assuming that the children
	 * match up with the DOM (element) children of `node`.
	 *
	 * We cache entire levels at once to avoid an n^2 problem where we access the
	 * children of a node sequentially and have to walk from the start to our target
	 * node every time.
	 *
	 * Since we update `_renderedChildren` and the actual DOM at (slightly)
	 * different times, we could race here and see a newer `_renderedChildren` than
	 * the DOM nodes we see. To avoid this, ReactMultiChild calls
	 * `prepareToManageChildren` before we change `_renderedChildren`, at which
	 * time the container's child nodes are always cached (until it unmounts).
	 */
	function precacheChildNodes(inst, node) {
	  if (inst._flags & Flags.hasCachedChildNodes) {
	    return;
	  }
	  var children = inst._renderedChildren;
	  var childNode = node.firstChild;
	  outer: for (var name in children) {
	    if (!children.hasOwnProperty(name)) {
	      continue;
	    }
	    var childInst = children[name];
	    var childID = getRenderedHostOrTextFromComponent(childInst)._domID;
	    if (childID === 0) {
	      // We're currently unmounting this child in ReactMultiChild; skip it.
	      continue;
	    }
	    // We assume the child nodes are in the same order as the child instances.
	    for (; childNode !== null; childNode = childNode.nextSibling) {
	      if (shouldPrecacheNode(childNode, childID)) {
	        precacheNode(childInst, childNode);
	        continue outer;
	      }
	    }
	    // We reached the end of the DOM children without finding an ID match.
	     true ?  false ? invariant(false, 'Unable to find element with ID %s.', childID) : _prodInvariant('32', childID) : void 0;
	  }
	  inst._flags |= Flags.hasCachedChildNodes;
	}
	
	/**
	 * Given a DOM node, return the closest ReactDOMComponent or
	 * ReactDOMTextComponent instance ancestor.
	 */
	function getClosestInstanceFromNode(node) {
	  if (node[internalInstanceKey]) {
	    return node[internalInstanceKey];
	  }
	
	  // Walk up the tree until we find an ancestor whose instance we have cached.
	  var parents = [];
	  while (!node[internalInstanceKey]) {
	    parents.push(node);
	    if (node.parentNode) {
	      node = node.parentNode;
	    } else {
	      // Top of the tree. This node must not be part of a React tree (or is
	      // unmounted, potentially).
	      return null;
	    }
	  }
	
	  var closest;
	  var inst;
	  for (; node && (inst = node[internalInstanceKey]); node = parents.pop()) {
	    closest = inst;
	    if (parents.length) {
	      precacheChildNodes(inst, node);
	    }
	  }
	
	  return closest;
	}
	
	/**
	 * Given a DOM node, return the ReactDOMComponent or ReactDOMTextComponent
	 * instance, or null if the node was not rendered by this React.
	 */
	function getInstanceFromNode(node) {
	  var inst = getClosestInstanceFromNode(node);
	  if (inst != null && inst._hostNode === node) {
	    return inst;
	  } else {
	    return null;
	  }
	}
	
	/**
	 * Given a ReactDOMComponent or ReactDOMTextComponent, return the corresponding
	 * DOM node.
	 */
	function getNodeFromInstance(inst) {
	  // Without this first invariant, passing a non-DOM-component triggers the next
	  // invariant for a missing parent, which is super confusing.
	  !(inst._hostNode !== undefined) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
	
	  if (inst._hostNode) {
	    return inst._hostNode;
	  }
	
	  // Walk up the tree until we find an ancestor whose DOM node we have cached.
	  var parents = [];
	  while (!inst._hostNode) {
	    parents.push(inst);
	    !inst._hostParent ?  false ? invariant(false, 'React DOM tree root should always have a node reference.') : _prodInvariant('34') : void 0;
	    inst = inst._hostParent;
	  }
	
	  // Now parents contains each ancestor that does *not* have a cached native
	  // node, and `inst` is the deepest ancestor that does.
	  for (; parents.length; inst = parents.pop()) {
	    precacheChildNodes(inst, inst._hostNode);
	  }
	
	  return inst._hostNode;
	}
	
	var ReactDOMComponentTree = {
	  getClosestInstanceFromNode: getClosestInstanceFromNode,
	  getInstanceFromNode: getInstanceFromNode,
	  getNodeFromInstance: getNodeFromInstance,
	  precacheChildNodes: precacheChildNodes,
	  precacheNode: precacheNode,
	  uncacheNode: uncacheNode
	};
	
	module.exports = ReactDOMComponentTree;

/***/ }),
/* 10 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	// TODO(mcg): Change to a string enum once we've upgraded to typescript 2.4.
	//  tslint:disable-next-line:variable-name Intended to look like a TS 2.4 enum
	exports.Code = {
	    // Causes are copied from:
	    // https://github.com/grpc/grpc/blob/bceec94ea4fc5f0085d81235d8e1c06798dc341a/include/grpc%2B%2B/impl/codegen/status_code_enum.h
	    /** Not an error; returned on success. */
	    OK: 'ok',
	    /** The operation was cancelled (typically by the caller). */
	    CANCELLED: 'cancelled',
	    /** Unknown error or an error from a different error domain. */
	    UNKNOWN: 'unknown',
	    /**
	     * Client specified an invalid argument. Note that this differs from
	     * FAILED_PRECONDITION. INVALID_ARGUMENT indicates arguments that are
	     * problematic regardless of the state of the system (e.g., a malformed file
	     * name).
	     */
	    INVALID_ARGUMENT: 'invalid-argument',
	    /**
	     * Deadline expired before operation could complete. For operations that
	     * change the state of the system, this error may be returned even if the
	     * operation has completed successfully. For example, a successful response
	     * from a server could have been delayed long enough for the deadline to
	     * expire.
	     */
	    DEADLINE_EXCEEDED: 'deadline-exceeded',
	    /** Some requested entity (e.g., file or directory) was not found. */
	    NOT_FOUND: 'not-found',
	    /**
	     * Some entity that we attempted to create (e.g., file or directory) already
	     * exists.
	     */
	    ALREADY_EXISTS: 'already-exists',
	    /**
	     * The caller does not have permission to execute the specified operation.
	     * PERMISSION_DENIED must not be used for rejections caused by exhausting
	     * some resource (use RESOURCE_EXHAUSTED instead for those errors).
	     * PERMISSION_DENIED must not be used if the caller can not be identified
	     * (use UNAUTHENTICATED instead for those errors).
	     */
	    PERMISSION_DENIED: 'permission-denied',
	    /**
	     * The request does not have valid authentication credentials for the
	     * operation.
	     */
	    UNAUTHENTICATED: 'unauthenticated',
	    /**
	     * Some resource has been exhausted, perhaps a per-user quota, or perhaps the
	     * entire file system is out of space.
	     */
	    RESOURCE_EXHAUSTED: 'resource-exhausted',
	    /**
	     * Operation was rejected because the system is not in a state required for
	     * the operation's execution. For example, directory to be deleted may be
	     * non-empty, an rmdir operation is applied to a non-directory, etc.
	     *
	     * A litmus test that may help a service implementor in deciding
	     * between FAILED_PRECONDITION, ABORTED, and UNAVAILABLE:
	     *  (a) Use UNAVAILABLE if the client can retry just the failing call.
	     *  (b) Use ABORTED if the client should retry at a higher-level
	     *      (e.g., restarting a read-modify-write sequence).
	     *  (c) Use FAILED_PRECONDITION if the client should not retry until
	     *      the system state has been explicitly fixed. E.g., if an "rmdir"
	     *      fails because the directory is non-empty, FAILED_PRECONDITION
	     *      should be returned since the client should not retry unless
	     *      they have first fixed up the directory by deleting files from it.
	     *  (d) Use FAILED_PRECONDITION if the client performs conditional
	     *      REST Get/Update/Delete on a resource and the resource on the
	     *      server does not match the condition. E.g., conflicting
	     *      read-modify-write on the same resource.
	     */
	    FAILED_PRECONDITION: 'failed-precondition',
	    /**
	     * The operation was aborted, typically due to a concurrency issue like
	     * sequencer check failures, transaction aborts, etc.
	     *
	     * See litmus test above for deciding between FAILED_PRECONDITION, ABORTED,
	     * and UNAVAILABLE.
	     */
	    ABORTED: 'aborted',
	    /**
	     * Operation was attempted past the valid range. E.g., seeking or reading
	     * past end of file.
	     *
	     * Unlike INVALID_ARGUMENT, this error indicates a problem that may be fixed
	     * if the system state changes. For example, a 32-bit file system will
	     * generate INVALID_ARGUMENT if asked to read at an offset that is not in the
	     * range [0,2^32-1], but it will generate OUT_OF_RANGE if asked to read from
	     * an offset past the current file size.
	     *
	     * There is a fair bit of overlap between FAILED_PRECONDITION and
	     * OUT_OF_RANGE. We recommend using OUT_OF_RANGE (the more specific error)
	     * when it applies so that callers who are iterating through a space can
	     * easily look for an OUT_OF_RANGE error to detect when they are done.
	     */
	    OUT_OF_RANGE: 'out-of-range',
	    /** Operation is not implemented or not supported/enabled in this service. */
	    UNIMPLEMENTED: 'unimplemented',
	    /**
	     * Internal errors. Means some invariants expected by underlying System has
	     * been broken. If you see one of these errors, Something is very broken.
	     */
	    INTERNAL: 'internal',
	    /**
	     * The service is currently unavailable. This is a most likely a transient
	     * condition and may be corrected by retrying with a backoff.
	     *
	     * See litmus test above for deciding between FAILED_PRECONDITION, ABORTED,
	     * and UNAVAILABLE.
	     */
	    UNAVAILABLE: 'unavailable',
	    /** Unrecoverable data loss or corruption. */
	    DATA_LOSS: 'data-loss'
	};
	/**
	 * An error class used for Firestore-generated errors. Ideally we should be
	 * using FirebaseError, but integrating with it is overly arduous at the moment,
	 * so we define our own compatible error class (with a `name` of 'FirebaseError'
	 * and compatible `code` and `message` fields.)
	 */
	var FirestoreError = /** @class */ (function (_super) {
	    __extends(FirestoreError, _super);
	    function FirestoreError(code, message) {
	        var _this = _super.call(this, message) || this;
	        _this.code = code;
	        _this.message = message;
	        _this.name = 'FirebaseError';
	        // HACK: We write a toString property directly because Error is not a real
	        // class and so inheritance does not work correctly. We could alternatively
	        // do the same "back-door inheritance" trick that FirebaseError does.
	        _this.toString = function () { return _this.name + ": [code=" + _this.code + "]: " + _this.message; };
	        return _this;
	    }
	    return FirestoreError;
	}(Error));
	exports.FirestoreError = FirestoreError;
	
	//# sourceMappingURL=error.js.map


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var sorted_map_1 = __webpack_require__(36);
	var sorted_set_1 = __webpack_require__(76);
	var document_key_1 = __webpack_require__(12);
	var EMPTY_MAYBE_DOCUMENT_MAP = new sorted_map_1.SortedMap(document_key_1.DocumentKey.comparator);
	function maybeDocumentMap() {
	    return EMPTY_MAYBE_DOCUMENT_MAP;
	}
	exports.maybeDocumentMap = maybeDocumentMap;
	var EMPTY_DOCUMENT_MAP = new sorted_map_1.SortedMap(document_key_1.DocumentKey.comparator);
	function documentMap() {
	    return EMPTY_DOCUMENT_MAP;
	}
	exports.documentMap = documentMap;
	var EMPTY_DOCUMENT_VERSION_MAP = new sorted_map_1.SortedMap(document_key_1.DocumentKey.comparator);
	function documentVersionMap() {
	    return EMPTY_DOCUMENT_VERSION_MAP;
	}
	exports.documentVersionMap = documentVersionMap;
	var EMPTY_DOCUMENT_KEY_SET = new sorted_set_1.SortedSet(document_key_1.DocumentKey.comparator);
	function documentKeySet() {
	    return EMPTY_DOCUMENT_KEY_SET;
	}
	exports.documentKeySet = documentKeySet;
	
	//# sourceMappingURL=collections.js.map


/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var assert_1 = __webpack_require__(2);
	var path_1 = __webpack_require__(35);
	var DocumentKey = /** @class */ (function () {
	    function DocumentKey(path) {
	        this.path = path;
	        assert_1.assert(DocumentKey.isDocumentKey(path), 'Invalid DocumentKey with an odd number of segments: ' +
	            path.toArray().join('/'));
	    }
	    DocumentKey.prototype.isEqual = function (other) {
	        return (other !== null && path_1.ResourcePath.comparator(this.path, other.path) === 0);
	    };
	    DocumentKey.prototype.toString = function () {
	        return this.path.toString();
	    };
	    DocumentKey.comparator = function (k1, k2) {
	        return path_1.ResourcePath.comparator(k1.path, k2.path);
	    };
	    DocumentKey.isDocumentKey = function (path) {
	        return path.length % 2 === 0;
	    };
	    /**
	     * Creates and returns a new document key with the given segments.
	     *
	     * @param path The segments of the path to the document
	     * @return A new instance of DocumentKey
	     */
	    DocumentKey.fromSegments = function (segments) {
	        return new DocumentKey(new path_1.ResourcePath(segments.slice()));
	    };
	    /**
	     * Creates and returns a new document key using '/' to split the string into
	     * segments.
	     *
	     * @param path The slash-separated path string to the document
	     * @return A new instance of DocumentKey
	     */
	    DocumentKey.fromPathString = function (path) {
	        return new DocumentKey(path_1.ResourcePath.fromString(path));
	    };
	    DocumentKey.EMPTY = new DocumentKey(new path_1.ResourcePath([]));
	    return DocumentKey;
	}());
	exports.DocumentKey = DocumentKey;
	
	//# sourceMappingURL=document_key.js.map


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	/* tslint:disable:no-console */
	var version_1 = __webpack_require__(100);
	var platform_1 = __webpack_require__(29);
	var LogLevel;
	(function (LogLevel) {
	    LogLevel[LogLevel["DEBUG"] = 0] = "DEBUG";
	    LogLevel[LogLevel["ERROR"] = 1] = "ERROR";
	    LogLevel[LogLevel["SILENT"] = 2] = "SILENT";
	})(LogLevel = exports.LogLevel || (exports.LogLevel = {}));
	var logLevel = LogLevel.ERROR;
	// Helper methods are needed because variables can't be exported as read/write
	function getLogLevel() {
	    return logLevel;
	}
	exports.getLogLevel = getLogLevel;
	function setLogLevel(newLevel) {
	    logLevel = newLevel;
	}
	exports.setLogLevel = setLogLevel;
	function debug(tag, msg) {
	    var obj = [];
	    for (var _i = 2; _i < arguments.length; _i++) {
	        obj[_i - 2] = arguments[_i];
	    }
	    if (logLevel <= LogLevel.DEBUG) {
	        var time = new Date().toISOString();
	        var args = obj.map(argToString);
	        console.log.apply(console, ["Firestore (" + version_1.SDK_VERSION + ") " + time + " [" + tag + "]: " + msg].concat(args));
	    }
	}
	exports.debug = debug;
	function error(msg) {
	    var obj = [];
	    for (var _i = 1; _i < arguments.length; _i++) {
	        obj[_i - 1] = arguments[_i];
	    }
	    if (logLevel <= LogLevel.ERROR) {
	        var time = new Date().toISOString();
	        var args = obj.map(argToString);
	        console.error.apply(console, ["Firestore (" + version_1.SDK_VERSION + ") " + time + ": " + msg].concat(args));
	    }
	}
	exports.error = error;
	/**
	 * Converts an additional log parameter to a string representation.
	 */
	function argToString(obj) {
	    if (typeof obj === 'string') {
	        return obj;
	    }
	    else {
	        var platform = platform_1.PlatformSupport.getPlatform();
	        try {
	            return platform.formatJSON(obj);
	        }
	        catch (e) {
	            // Converting to JSON failed, just log the object directly
	            return obj;
	        }
	    }
	}
	
	//# sourceMappingURL=log.js.map


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var assert_1 = __webpack_require__(2);
	// tslint:disable-next-line:class-as-namespace
	var AutoId = /** @class */ (function () {
	    function AutoId() {
	    }
	    AutoId.newId = function () {
	        // Alphanumeric characters
	        var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
	        var autoId = '';
	        for (var i = 0; i < 20; i++) {
	            autoId += chars.charAt(Math.floor(Math.random() * chars.length));
	        }
	        assert_1.assert(autoId.length === 20, 'Invalid auto ID: ' + autoId);
	        return autoId;
	    };
	    return AutoId;
	}());
	exports.AutoId = AutoId;
	function primitiveComparator(left, right) {
	    if (left < right)
	        return -1;
	    if (left > right)
	        return 1;
	    return 0;
	}
	exports.primitiveComparator = primitiveComparator;
	/** Helper to compare nullable (or undefined-able) objects using isEqual(). */
	function equals(left, right) {
	    if (left !== null && left !== undefined) {
	        return !!(right && left.isEqual(right));
	    }
	    else {
	        // HACK: Explicitly cast since TypeScript's type narrowing apparently isn't
	        // smart enough.
	        return left === right;
	    }
	}
	exports.equals = equals;
	/** Helper to compare arrays using isEqual(). */
	function arrayEquals(left, right) {
	    if (left.length !== right.length) {
	        return false;
	    }
	    for (var i = 0; i < left.length; i++) {
	        if (!left[i].isEqual(right[i])) {
	            return false;
	        }
	    }
	    return true;
	}
	exports.arrayEquals = arrayEquals;
	/**
	 * Returns the largest lexicographically smaller string of equal or smaller
	 * length. Returns an empty string if there is no such predecessor (if the input
	 * is empty).
	 *
	 * Strings returned from this method can be invalid UTF-16 but this is sufficent
	 * in use for indexeddb because that depends on lexicographical ordering but
	 * shouldn't be used elsewhere.
	 */
	function immediatePredecessor(s) {
	    // We can decrement the last character in the string and be done
	    // unless that character is 0 (0x0000), in which case we have to erase the
	    // last character.
	    var lastIndex = s.length - 1;
	    if (s.length === 0) {
	        // Special case the empty string.
	        return '';
	    }
	    else if (s.charAt(lastIndex) === '\0') {
	        return s.substring(0, lastIndex);
	    }
	    else {
	        return (s.substring(0, lastIndex) +
	            String.fromCharCode(s.charCodeAt(lastIndex) - 1));
	    }
	}
	exports.immediatePredecessor = immediatePredecessor;
	/**
	 * Returns the immediate lexicographically-following string. This is useful to
	 * construct an inclusive range for indexeddb iterators.
	 */
	function immediateSuccessor(s) {
	    // Return the input string, with an additional NUL byte appended.
	    return s + '\0';
	}
	exports.immediateSuccessor = immediateSuccessor;
	
	//# sourceMappingURL=misc.js.map


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var Index_1 = __webpack_require__(67);
	var util_1 = __webpack_require__(4);
	var Node_1 = __webpack_require__(19);
	var LeafNode_1 = __webpack_require__(66);
	var nodeFromJSON;
	var MAX_NODE;
	function setNodeFromJSON(val) {
	    nodeFromJSON = val;
	}
	exports.setNodeFromJSON = setNodeFromJSON;
	function setMaxNode(val) {
	    MAX_NODE = val;
	}
	exports.setMaxNode = setMaxNode;
	/**
	 * @constructor
	 * @extends {Index}
	 * @private
	 */
	var PriorityIndex = /** @class */ (function (_super) {
	    __extends(PriorityIndex, _super);
	    function PriorityIndex() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    /**
	     * @inheritDoc
	     */
	    PriorityIndex.prototype.compare = function (a, b) {
	        var aPriority = a.node.getPriority();
	        var bPriority = b.node.getPriority();
	        var indexCmp = aPriority.compareTo(bPriority);
	        if (indexCmp === 0) {
	            return util_1.nameCompare(a.name, b.name);
	        }
	        else {
	            return indexCmp;
	        }
	    };
	    /**
	     * @inheritDoc
	     */
	    PriorityIndex.prototype.isDefinedOn = function (node) {
	        return !node.getPriority().isEmpty();
	    };
	    /**
	     * @inheritDoc
	     */
	    PriorityIndex.prototype.indexedValueChanged = function (oldNode, newNode) {
	        return !oldNode.getPriority().equals(newNode.getPriority());
	    };
	    /**
	     * @inheritDoc
	     */
	    PriorityIndex.prototype.minPost = function () {
	        return Node_1.NamedNode.MIN;
	    };
	    /**
	     * @inheritDoc
	     */
	    PriorityIndex.prototype.maxPost = function () {
	        return new Node_1.NamedNode(util_1.MAX_NAME, new LeafNode_1.LeafNode('[PRIORITY-POST]', MAX_NODE));
	    };
	    /**
	     * @param {*} indexValue
	     * @param {string} name
	     * @return {!NamedNode}
	     */
	    PriorityIndex.prototype.makePost = function (indexValue, name) {
	        var priorityNode = nodeFromJSON(indexValue);
	        return new Node_1.NamedNode(name, new LeafNode_1.LeafNode('[PRIORITY-POST]', priorityNode));
	    };
	    /**
	     * @return {!string} String representation for inclusion in a query spec
	     */
	    PriorityIndex.prototype.toString = function () {
	        return '.priority';
	    };
	    return PriorityIndex;
	}(Index_1.Index));
	exports.PriorityIndex = PriorityIndex;
	exports.PRIORITY_INDEX = new PriorityIndex();
	
	//# sourceMappingURL=PriorityIndex.js.map


/***/ }),
/* 16 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	/**
	 * Simple, lightweight module assisting with the detection and context of
	 * Worker. Helps avoid circular dependencies and allows code to reason about
	 * whether or not they are in a Worker, even if they never include the main
	 * `ReactWorker` dependency.
	 */
	var ExecutionEnvironment = {
	
	  canUseDOM: canUseDOM,
	
	  canUseWorkers: typeof Worker !== 'undefined',
	
	  canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),
	
	  canUseViewport: canUseDOM && !!window.screen,
	
	  isInWorker: !canUseDOM // For now, this is true - might change in the future.
	
	};
	
	module.exports = ExecutionEnvironment;

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var util_1 = __webpack_require__(1);
	var util_2 = __webpack_require__(4);
	var SortedMap_1 = __webpack_require__(69);
	var Node_1 = __webpack_require__(19);
	var snap_1 = __webpack_require__(147);
	var PriorityIndex_1 = __webpack_require__(15);
	var KeyIndex_1 = __webpack_require__(49);
	var IndexMap_1 = __webpack_require__(142);
	var LeafNode_1 = __webpack_require__(66);
	var comparators_1 = __webpack_require__(144);
	// TODO: For memory savings, don't store priorityNode_ if it's empty.
	var EMPTY_NODE;
	/**
	 * ChildrenNode is a class for storing internal nodes in a DataSnapshot
	 * (i.e. nodes with children).  It implements Node and stores the
	 * list of children in the children property, sorted by child name.
	 *
	 * @constructor
	 * @implements {Node}
	 */
	var ChildrenNode = /** @class */ (function () {
	    /**
	     *
	     * @param {!SortedMap.<string, !Node>} children_ List of children
	     * of this node..
	     * @param {?Node} priorityNode_ The priority of this node (as a snapshot node).
	     * @param {!IndexMap} indexMap_
	     */
	    function ChildrenNode(children_, priorityNode_, indexMap_) {
	        this.children_ = children_;
	        this.priorityNode_ = priorityNode_;
	        this.indexMap_ = indexMap_;
	        this.lazyHash_ = null;
	        /**
	         * Note: The only reason we allow null priority is for EMPTY_NODE, since we can't use
	         * EMPTY_NODE as the priority of EMPTY_NODE.  We might want to consider making EMPTY_NODE its own
	         * class instead of an empty ChildrenNode.
	         */
	        if (this.priorityNode_) {
	            snap_1.validatePriorityNode(this.priorityNode_);
	        }
	        if (this.children_.isEmpty()) {
	            util_1.assert(!this.priorityNode_ || this.priorityNode_.isEmpty(), 'An empty node cannot have a priority');
	        }
	    }
	    Object.defineProperty(ChildrenNode, "EMPTY_NODE", {
	        get: function () {
	            return (EMPTY_NODE ||
	                (EMPTY_NODE = new ChildrenNode(new SortedMap_1.SortedMap(comparators_1.NAME_COMPARATOR), null, IndexMap_1.IndexMap.Default)));
	        },
	        enumerable: true,
	        configurable: true
	    });
	    /** @inheritDoc */
	    ChildrenNode.prototype.isLeafNode = function () {
	        return false;
	    };
	    /** @inheritDoc */
	    ChildrenNode.prototype.getPriority = function () {
	        return this.priorityNode_ || EMPTY_NODE;
	    };
	    /** @inheritDoc */
	    ChildrenNode.prototype.updatePriority = function (newPriorityNode) {
	        if (this.children_.isEmpty()) {
	            // Don't allow priorities on empty nodes
	            return this;
	        }
	        else {
	            return new ChildrenNode(this.children_, newPriorityNode, this.indexMap_);
	        }
	    };
	    /** @inheritDoc */
	    ChildrenNode.prototype.getImmediateChild = function (childName) {
	        // Hack to treat priority as a regular child
	        if (childName === '.priority') {
	            return this.getPriority();
	        }
	        else {
	            var child = this.children_.get(childName);
	            return child === null ? EMPTY_NODE : child;
	        }
	    };
	    /** @inheritDoc */
	    ChildrenNode.prototype.getChild = function (path) {
	        var front = path.getFront();
	        if (front === null)
	            return this;
	        return this.getImmediateChild(front).getChild(path.popFront());
	    };
	    /** @inheritDoc */
	    ChildrenNode.prototype.hasChild = function (childName) {
	        return this.children_.get(childName) !== null;
	    };
	    /** @inheritDoc */
	    ChildrenNode.prototype.updateImmediateChild = function (childName, newChildNode) {
	        util_1.assert(newChildNode, 'We should always be passing snapshot nodes');
	        if (childName === '.priority') {
	            return this.updatePriority(newChildNode);
	        }
	        else {
	            var namedNode = new Node_1.NamedNode(childName, newChildNode);
	            var newChildren = void 0, newIndexMap = void 0, newPriority = void 0;
	            if (newChildNode.isEmpty()) {
	                newChildren = this.children_.remove(childName);
	                newIndexMap = this.indexMap_.removeFromIndexes(namedNode, this.children_);
	            }
	            else {
	                newChildren = this.children_.insert(childName, newChildNode);
	                newIndexMap = this.indexMap_.addToIndexes(namedNode, this.children_);
	            }
	            newPriority = newChildren.isEmpty() ? EMPTY_NODE : this.priorityNode_;
	            return new ChildrenNode(newChildren, newPriority, newIndexMap);
	        }
	    };
	    /** @inheritDoc */
	    ChildrenNode.prototype.updateChild = function (path, newChildNode) {
	        var front = path.getFront();
	        if (front === null) {
	            return newChildNode;
	        }
	        else {
	            util_1.assert(path.getFront() !== '.priority' || path.getLength() === 1, '.priority must be the last token in a path');
	            var newImmediateChild = this.getImmediateChild(front).updateChild(path.popFront(), newChildNode);
	            return this.updateImmediateChild(front, newImmediateChild);
	        }
	    };
	    /** @inheritDoc */
	    ChildrenNode.prototype.isEmpty = function () {
	        return this.children_.isEmpty();
	    };
	    /** @inheritDoc */
	    ChildrenNode.prototype.numChildren = function () {
	        return this.children_.count();
	    };
	    /** @inheritDoc */
	    ChildrenNode.prototype.val = function (exportFormat) {
	        if (this.isEmpty())
	            return null;
	        var obj = {};
	        var numKeys = 0, maxKey = 0, allIntegerKeys = true;
	        this.forEachChild(PriorityIndex_1.PRIORITY_INDEX, function (key, childNode) {
	            obj[key] = childNode.val(exportFormat);
	            numKeys++;
	            if (allIntegerKeys && ChildrenNode.INTEGER_REGEXP_.test(key)) {
	                maxKey = Math.max(maxKey, Number(key));
	            }
	            else {
	                allIntegerKeys = false;
	            }
	        });
	        if (!exportFormat && allIntegerKeys && maxKey < 2 * numKeys) {
	            // convert to array.
	            var array = [];
	            for (var key in obj)
	                array[key] = obj[key];
	            return array;
	        }
	        else {
	            if (exportFormat && !this.getPriority().isEmpty()) {
	                obj['.priority'] = this.getPriority().val();
	            }
	            return obj;
	        }
	    };
	    /** @inheritDoc */
	    ChildrenNode.prototype.hash = function () {
	        if (this.lazyHash_ === null) {
	            var toHash_1 = '';
	            if (!this.getPriority().isEmpty())
	                toHash_1 +=
	                    'priority:' +
	                        snap_1.priorityHashText(this.getPriority().val()) +
	                        ':';
	            this.forEachChild(PriorityIndex_1.PRIORITY_INDEX, function (key, childNode) {
	                var childHash = childNode.hash();
	                if (childHash !== '')
	                    toHash_1 += ':' + key + ':' + childHash;
	            });
	            this.lazyHash_ = toHash_1 === '' ? '' : util_2.sha1(toHash_1);
	        }
	        return this.lazyHash_;
	    };
	    /** @inheritDoc */
	    ChildrenNode.prototype.getPredecessorChildName = function (childName, childNode, index) {
	        var idx = this.resolveIndex_(index);
	        if (idx) {
	            var predecessor = idx.getPredecessorKey(new Node_1.NamedNode(childName, childNode));
	            return predecessor ? predecessor.name : null;
	        }
	        else {
	            return this.children_.getPredecessorKey(childName);
	        }
	    };
	    /**
	     * @param {!Index} indexDefinition
	     * @return {?string}
	     */
	    ChildrenNode.prototype.getFirstChildName = function (indexDefinition) {
	        var idx = this.resolveIndex_(indexDefinition);
	        if (idx) {
	            var minKey = idx.minKey();
	            return minKey && minKey.name;
	        }
	        else {
	            return this.children_.minKey();
	        }
	    };
	    /**
	     * @param {!Index} indexDefinition
	     * @return {?NamedNode}
	     */
	    ChildrenNode.prototype.getFirstChild = function (indexDefinition) {
	        var minKey = this.getFirstChildName(indexDefinition);
	        if (minKey) {
	            return new Node_1.NamedNode(minKey, this.children_.get(minKey));
	        }
	        else {
	            return null;
	        }
	    };
	    /**
	     * Given an index, return the key name of the largest value we have, according to that index
	     * @param {!Index} indexDefinition
	     * @return {?string}
	     */
	    ChildrenNode.prototype.getLastChildName = function (indexDefinition) {
	        var idx = this.resolveIndex_(indexDefinition);
	        if (idx) {
	            var maxKey = idx.maxKey();
	            return maxKey && maxKey.name;
	        }
	        else {
	            return this.children_.maxKey();
	        }
	    };
	    /**
	     * @param {!Index} indexDefinition
	     * @return {?NamedNode}
	     */
	    ChildrenNode.prototype.getLastChild = function (indexDefinition) {
	        var maxKey = this.getLastChildName(indexDefinition);
	        if (maxKey) {
	            return new Node_1.NamedNode(maxKey, this.children_.get(maxKey));
	        }
	        else {
	            return null;
	        }
	    };
	    /**
	     * @inheritDoc
	     */
	    ChildrenNode.prototype.forEachChild = function (index, action) {
	        var idx = this.resolveIndex_(index);
	        if (idx) {
	            return idx.inorderTraversal(function (wrappedNode) {
	                return action(wrappedNode.name, wrappedNode.node);
	            });
	        }
	        else {
	            return this.children_.inorderTraversal(action);
	        }
	    };
	    /**
	     * @param {!Index} indexDefinition
	     * @return {SortedMapIterator}
	     */
	    ChildrenNode.prototype.getIterator = function (indexDefinition) {
	        return this.getIteratorFrom(indexDefinition.minPost(), indexDefinition);
	    };
	    /**
	     *
	     * @param {!NamedNode} startPost
	     * @param {!Index} indexDefinition
	     * @return {!SortedMapIterator}
	     */
	    ChildrenNode.prototype.getIteratorFrom = function (startPost, indexDefinition) {
	        var idx = this.resolveIndex_(indexDefinition);
	        if (idx) {
	            return idx.getIteratorFrom(startPost, function (key) { return key; });
	        }
	        else {
	            var iterator = this.children_.getIteratorFrom(startPost.name, Node_1.NamedNode.Wrap);
	            var next = iterator.peek();
	            while (next != null && indexDefinition.compare(next, startPost) < 0) {
	                iterator.getNext();
	                next = iterator.peek();
	            }
	            return iterator;
	        }
	    };
	    /**
	     * @param {!Index} indexDefinition
	     * @return {!SortedMapIterator}
	     */
	    ChildrenNode.prototype.getReverseIterator = function (indexDefinition) {
	        return this.getReverseIteratorFrom(indexDefinition.maxPost(), indexDefinition);
	    };
	    /**
	     * @param {!NamedNode} endPost
	     * @param {!Index} indexDefinition
	     * @return {!SortedMapIterator}
	     */
	    ChildrenNode.prototype.getReverseIteratorFrom = function (endPost, indexDefinition) {
	        var idx = this.resolveIndex_(indexDefinition);
	        if (idx) {
	            return idx.getReverseIteratorFrom(endPost, function (key) {
	                return key;
	            });
	        }
	        else {
	            var iterator = this.children_.getReverseIteratorFrom(endPost.name, Node_1.NamedNode.Wrap);
	            var next = iterator.peek();
	            while (next != null && indexDefinition.compare(next, endPost) > 0) {
	                iterator.getNext();
	                next = iterator.peek();
	            }
	            return iterator;
	        }
	    };
	    /**
	     * @inheritDoc
	     */
	    ChildrenNode.prototype.compareTo = function (other) {
	        if (this.isEmpty()) {
	            if (other.isEmpty()) {
	                return 0;
	            }
	            else {
	                return -1;
	            }
	        }
	        else if (other.isLeafNode() || other.isEmpty()) {
	            return 1;
	        }
	        else if (other === exports.MAX_NODE) {
	            return -1;
	        }
	        else {
	            // Must be another node with children.
	            return 0;
	        }
	    };
	    /**
	     * @inheritDoc
	     */
	    ChildrenNode.prototype.withIndex = function (indexDefinition) {
	        if (indexDefinition === KeyIndex_1.KEY_INDEX ||
	            this.indexMap_.hasIndex(indexDefinition)) {
	            return this;
	        }
	        else {
	            var newIndexMap = this.indexMap_.addIndex(indexDefinition, this.children_);
	            return new ChildrenNode(this.children_, this.priorityNode_, newIndexMap);
	        }
	    };
	    /**
	     * @inheritDoc
	     */
	    ChildrenNode.prototype.isIndexed = function (index) {
	        return index === KeyIndex_1.KEY_INDEX || this.indexMap_.hasIndex(index);
	    };
	    /**
	     * @inheritDoc
	     */
	    ChildrenNode.prototype.equals = function (other) {
	        if (other === this) {
	            return true;
	        }
	        else if (other.isLeafNode()) {
	            return false;
	        }
	        else {
	            var otherChildrenNode = other;
	            if (!this.getPriority().equals(otherChildrenNode.getPriority())) {
	                return false;
	            }
	            else if (this.children_.count() === otherChildrenNode.children_.count()) {
	                var thisIter = this.getIterator(PriorityIndex_1.PRIORITY_INDEX);
	                var otherIter = otherChildrenNode.getIterator(PriorityIndex_1.PRIORITY_INDEX);
	                var thisCurrent = thisIter.getNext();
	                var otherCurrent = otherIter.getNext();
	                while (thisCurrent && otherCurrent) {
	                    if (thisCurrent.name !== otherCurrent.name ||
	                        !thisCurrent.node.equals(otherCurrent.node)) {
	                        return false;
	                    }
	                    thisCurrent = thisIter.getNext();
	                    otherCurrent = otherIter.getNext();
	                }
	                return thisCurrent === null && otherCurrent === null;
	            }
	            else {
	                return false;
	            }
	        }
	    };
	    /**
	     * Returns a SortedMap ordered by index, or null if the default (by-key) ordering can be used
	     * instead.
	     *
	     * @private
	     * @param {!Index} indexDefinition
	     * @return {?SortedMap.<NamedNode, Node>}
	     */
	    ChildrenNode.prototype.resolveIndex_ = function (indexDefinition) {
	        if (indexDefinition === KeyIndex_1.KEY_INDEX) {
	            return null;
	        }
	        else {
	            return this.indexMap_.get(indexDefinition.toString());
	        }
	    };
	    /**
	     * @private
	     * @type {RegExp}
	     */
	    ChildrenNode.INTEGER_REGEXP_ = /^(0|[1-9]\d*)$/;
	    return ChildrenNode;
	}());
	exports.ChildrenNode = ChildrenNode;
	/**
	 * @constructor
	 * @extends {ChildrenNode}
	 * @private
	 */
	var MaxNode = /** @class */ (function (_super) {
	    __extends(MaxNode, _super);
	    function MaxNode() {
	        return _super.call(this, new SortedMap_1.SortedMap(comparators_1.NAME_COMPARATOR), ChildrenNode.EMPTY_NODE, IndexMap_1.IndexMap.Default) || this;
	    }
	    MaxNode.prototype.compareTo = function (other) {
	        if (other === this) {
	            return 0;
	        }
	        else {
	            return 1;
	        }
	    };
	    MaxNode.prototype.equals = function (other) {
	        // Not that we every compare it, but MAX_NODE is only ever equal to itself
	        return other === this;
	    };
	    MaxNode.prototype.getPriority = function () {
	        return this;
	    };
	    MaxNode.prototype.getImmediateChild = function (childName) {
	        return ChildrenNode.EMPTY_NODE;
	    };
	    MaxNode.prototype.isEmpty = function () {
	        return false;
	    };
	    return MaxNode;
	}(ChildrenNode));
	exports.MaxNode = MaxNode;
	/**
	 * Marker that will sort higher than any other snapshot.
	 * @type {!MAX_NODE}
	 * @const
	 */
	exports.MAX_NODE = new MaxNode();
	Object.defineProperties(Node_1.NamedNode, {
	    MIN: {
	        value: new Node_1.NamedNode(util_2.MIN_NAME, ChildrenNode.EMPTY_NODE)
	    },
	    MAX: {
	        value: new Node_1.NamedNode(util_2.MAX_NAME, exports.MAX_NODE)
	    }
	});
	/**
	 * Reference Extensions
	 */
	KeyIndex_1.KeyIndex.__EMPTY_NODE = ChildrenNode.EMPTY_NODE;
	LeafNode_1.LeafNode.__childrenNodeConstructor = ChildrenNode;
	snap_1.setMaxNode(exports.MAX_NODE);
	PriorityIndex_1.setMaxNode(exports.MAX_NODE);
	
	//# sourceMappingURL=ChildrenNode.js.map


/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var assert_1 = __webpack_require__(2);
	/**
	 * PersistencePromise<> is essentially a re-implementation of Promise<> except
	 * it has a .next() method instead of .then() and .next() and .catch() callbacks
	 * are executed synchronously when a PersistencePromise resolves rather than
	 * asynchronously (Promise<> implementations use setImmediate() or similar).
	 *
	 * This is necessary to interoperate with IndexedDB which will automatically
	 * commit transactions if control is returned to the event loop without
	 * synchronously initiating another operation on the transaction.
	 *
	 * NOTE: .then() and .catch() only allow a single consumer, unlike normal
	 * Promises.
	 */
	var PersistencePromise = /** @class */ (function () {
	    function PersistencePromise(callback) {
	        var _this = this;
	        // NOTE: next/catchCallback will always point to our own wrapper functions,
	        // not the user's raw next() or catch() callbacks.
	        // tslint:disable-next-line:no-any Accept any result type for the next call in the Promise chain.
	        this.nextCallback = null;
	        // tslint:disable-next-line:no-any Accept any result type for the error handler.
	        this.catchCallback = null;
	        // When the operation resolves, we'll set result or error and mark isDone.
	        this.result = undefined;
	        this.error = undefined;
	        this.isDone = false;
	        // Set to true when .then() or .catch() are called and prevents additional
	        // chaining.
	        this.callbackAttached = false;
	        callback(function (value) {
	            _this.isDone = true;
	            _this.result = value;
	            if (_this.nextCallback) {
	                // value should be defined unless T is Void, but we can't express
	                // that in the type system.
	                _this.nextCallback(value);
	            }
	        }, function (error) {
	            _this.isDone = true;
	            _this.error = error;
	            if (_this.catchCallback) {
	                _this.catchCallback(error);
	            }
	        });
	    }
	    PersistencePromise.prototype.catch = function (fn) {
	        return this.next(undefined, fn);
	    };
	    PersistencePromise.prototype.next = function (nextFn, catchFn) {
	        var _this = this;
	        if (this.callbackAttached) {
	            assert_1.fail('Called next() or catch() twice for PersistencePromise');
	        }
	        this.callbackAttached = true;
	        if (this.isDone) {
	            if (!this.error) {
	                return this.wrapSuccess(nextFn, this.result);
	            }
	            else {
	                return this.wrapFailure(catchFn, this.error);
	            }
	        }
	        else {
	            return new PersistencePromise(function (resolve, reject) {
	                _this.nextCallback = function (value) {
	                    _this.wrapSuccess(nextFn, value).next(resolve, reject);
	                };
	                _this.catchCallback = function (error) {
	                    _this.wrapFailure(catchFn, error).next(resolve, reject);
	                };
	            });
	        }
	    };
	    PersistencePromise.prototype.toPromise = function () {
	        var _this = this;
	        return new Promise(function (resolve, reject) {
	            _this.next(resolve, reject);
	        });
	    };
	    PersistencePromise.prototype.wrapUserFunction = function (fn) {
	        try {
	            var result = fn();
	            if (result instanceof PersistencePromise) {
	                return result;
	            }
	            else {
	                return PersistencePromise.resolve(result);
	            }
	        }
	        catch (e) {
	            return PersistencePromise.reject(e);
	        }
	    };
	    PersistencePromise.prototype.wrapSuccess = function (nextFn, value) {
	        if (nextFn) {
	            return this.wrapUserFunction(function () { return nextFn(value); });
	        }
	        else {
	            // If there's no nextFn, then R must be the same as T but we
	            // can't express that in the type system.
	            // tslint:disable-next-line:no-any
	            return PersistencePromise.resolve(value);
	        }
	    };
	    PersistencePromise.prototype.wrapFailure = function (catchFn, error) {
	        if (catchFn) {
	            return this.wrapUserFunction(function () { return catchFn(error); });
	        }
	        else {
	            return PersistencePromise.reject(error);
	        }
	    };
	    PersistencePromise.resolve = function (result) {
	        return new PersistencePromise(function (resolve, reject) {
	            resolve(result);
	        });
	    };
	    PersistencePromise.reject = function (error) {
	        return new PersistencePromise(function (resolve, reject) {
	            reject(error);
	        });
	    };
	    PersistencePromise.waitFor = function (
	        // tslint:disable-next-line:no-any Accept all Promise types in waitFor().
	        all) {
	        return all.reduce(function (promise, nextPromise, idx) {
	            return promise.next(function () {
	                return nextPromise;
	            });
	        }, PersistencePromise.resolve());
	    };
	    PersistencePromise.map = function (all) {
	        var results = [];
	        var first = true;
	        // initial is ignored, so we can cheat on the type.
	        // tslint:disable-next-line:no-any
	        var initial = PersistencePromise.resolve(null);
	        return all
	            .reduce(function (promise, nextPromise) {
	            return promise.next(function (result) {
	                if (!first) {
	                    results.push(result);
	                }
	                first = false;
	                return nextPromise;
	            });
	        }, initial)
	            .next(function (result) {
	            results.push(result);
	            return results;
	        });
	    };
	    return PersistencePromise;
	}());
	exports.PersistencePromise = PersistencePromise;
	
	//# sourceMappingURL=persistence_promise.js.map


/***/ }),
/* 19 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 *
	 * @param {!string} name
	 * @param {!Node} node
	 * @constructor
	 * @struct
	 */
	var NamedNode = /** @class */ (function () {
	    function NamedNode(name, node) {
	        this.name = name;
	        this.node = node;
	    }
	    /**
	     *
	     * @param {!string} name
	     * @param {!Node} node
	     * @return {NamedNode}
	     */
	    NamedNode.Wrap = function (name, node) {
	        return new NamedNode(name, node);
	    };
	    return NamedNode;
	}());
	exports.NamedNode = NamedNode;
	
	//# sourceMappingURL=Node.js.map


/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var timestamp_1 = __webpack_require__(40);
	/**
	 * A version of a document in Firestore. This corresponds to the version
	 * timestamp, such as update_time or read_time.
	 */
	var SnapshotVersion = /** @class */ (function () {
	    function SnapshotVersion(timestamp) {
	        this.timestamp = timestamp;
	    }
	    // TODO(b/34176344): Once we no longer need to use the old alpha protos,
	    // delete this constructor and use a timestamp-backed version everywhere.
	    SnapshotVersion.fromMicroseconds = function (value) {
	        var seconds = Math.floor(value / 1e6);
	        var nanos = (value % 1e6) * 1e3;
	        return new SnapshotVersion(new timestamp_1.Timestamp(seconds, nanos));
	    };
	    SnapshotVersion.fromTimestamp = function (value) {
	        return new SnapshotVersion(value);
	    };
	    SnapshotVersion.forDeletedDoc = function () {
	        return SnapshotVersion.MIN;
	    };
	    SnapshotVersion.prototype.compareTo = function (other) {
	        return this.timestamp.compareTo(other.timestamp);
	    };
	    SnapshotVersion.prototype.isEqual = function (other) {
	        return this.timestamp.isEqual(other.timestamp);
	    };
	    /** Returns a number representation of the version for use in spec tests. */
	    SnapshotVersion.prototype.toMicroseconds = function () {
	        // Convert to microseconds.
	        return this.timestamp.seconds * 1e6 + this.timestamp.nanos / 1000;
	    };
	    SnapshotVersion.prototype.toString = function () {
	        return 'SnapshotVersion(' + this.timestamp.toString() + ')';
	    };
	    SnapshotVersion.prototype.toTimestamp = function () {
	        return this.timestamp;
	    };
	    SnapshotVersion.MIN = new SnapshotVersion(new timestamp_1.Timestamp(0, 0));
	    return SnapshotVersion;
	}());
	exports.SnapshotVersion = SnapshotVersion;
	
	//# sourceMappingURL=snapshot_version.js.map


/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var assert_1 = __webpack_require__(2);
	var document_key_1 = __webpack_require__(12);
	var Document = /** @class */ (function () {
	    function Document(key, version, data, options) {
	        this.key = key;
	        this.version = version;
	        this.data = data;
	        this.hasLocalMutations = options.hasLocalMutations;
	    }
	    Document.prototype.field = function (path) {
	        return this.data.field(path);
	    };
	    Document.prototype.fieldValue = function (path) {
	        var field = this.field(path);
	        return field ? field.value() : undefined;
	    };
	    Document.prototype.value = function () {
	        return this.data.value();
	    };
	    Document.prototype.isEqual = function (other) {
	        return (other instanceof Document &&
	            this.key.isEqual(other.key) &&
	            this.version.isEqual(other.version) &&
	            this.data.isEqual(other.data) &&
	            this.hasLocalMutations === other.hasLocalMutations);
	    };
	    Document.prototype.toString = function () {
	        return ("Document(" + this.key + ", " + this.version + ", " + this.data.toString() + ", " +
	            ("{hasLocalMutations: " + this.hasLocalMutations + "})"));
	    };
	    Document.compareByKey = function (d1, d2) {
	        return document_key_1.DocumentKey.comparator(d1.key, d2.key);
	    };
	    Document.compareByField = function (field, d1, d2) {
	        var v1 = d1.field(field);
	        var v2 = d2.field(field);
	        if (v1 !== undefined && v2 !== undefined) {
	            return v1.compareTo(v2);
	        }
	        else {
	            return assert_1.fail("Trying to compare documents on fields that don't exist");
	        }
	    };
	    return Document;
	}());
	exports.Document = Document;
	/**
	 * A class representing a deleted document.
	 * Version is set to 0 if we don't point to any specific time, otherwise it
	 * denotes time we know it didn't exist at.
	 */
	var NoDocument = /** @class */ (function () {
	    function NoDocument(key, version) {
	        this.key = key;
	        this.version = version;
	    }
	    NoDocument.prototype.toString = function () {
	        return "NoDocument(" + this.key + ", " + this.version + ")";
	    };
	    NoDocument.prototype.isEqual = function (other) {
	        return (other &&
	            other.version.isEqual(this.version) &&
	            other.key.isEqual(this.key));
	    };
	    NoDocument.compareByKey = function (d1, d2) {
	        return document_key_1.DocumentKey.comparator(d1.key, d2.key);
	    };
	    return NoDocument;
	}());
	exports.NoDocument = NoDocument;
	
	//# sourceMappingURL=document.js.map


/***/ }),
/* 22 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * @return False if the object is undefined or null, true otherwise.
	 */
	function isDef(p) {
	    return p != null;
	}
	exports.isDef = isDef;
	function isJustDef(p) {
	    return p !== void 0;
	}
	exports.isJustDef = isJustDef;
	function isFunction(p) {
	    return typeof p === 'function';
	}
	exports.isFunction = isFunction;
	function isObject(p) {
	    return typeof p === 'object';
	}
	exports.isObject = isObject;
	function isNonNullObject(p) {
	    return isObject(p) && p !== null;
	}
	exports.isNonNullObject = isNonNullObject;
	function isNonArrayObject(p) {
	    return isObject(p) && !Array.isArray(p);
	}
	exports.isNonArrayObject = isNonArrayObject;
	function isString(p) {
	    return typeof p === 'string' || p instanceof String;
	}
	exports.isString = isString;
	function isNumber(p) {
	    return typeof p === 'number' || p instanceof Number;
	}
	exports.isNumber = isNumber;
	function isNativeBlob(p) {
	    return isNativeBlobDefined() && p instanceof Blob;
	}
	exports.isNativeBlob = isNativeBlob;
	function isNativeBlobDefined() {
	    return typeof Blob !== 'undefined';
	}
	exports.isNativeBlobDefined = isNativeBlobDefined;
	
	//# sourceMappingURL=type.js.map


/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var bind = __webpack_require__(182);
	var isBuffer = __webpack_require__(411);
	
	/*global toString:true*/
	
	// utils is a library of generic helper functions non-specific to axios
	
	var toString = Object.prototype.toString;
	
	/**
	 * Determine if a value is an Array
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an Array, otherwise false
	 */
	function isArray(val) {
	  return toString.call(val) === '[object Array]';
	}
	
	/**
	 * Determine if a value is an ArrayBuffer
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
	 */
	function isArrayBuffer(val) {
	  return toString.call(val) === '[object ArrayBuffer]';
	}
	
	/**
	 * Determine if a value is a FormData
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an FormData, otherwise false
	 */
	function isFormData(val) {
	  return (typeof FormData !== 'undefined') && (val instanceof FormData);
	}
	
	/**
	 * Determine if a value is a view on an ArrayBuffer
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
	 */
	function isArrayBufferView(val) {
	  var result;
	  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
	    result = ArrayBuffer.isView(val);
	  } else {
	    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
	  }
	  return result;
	}
	
	/**
	 * Determine if a value is a String
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a String, otherwise false
	 */
	function isString(val) {
	  return typeof val === 'string';
	}
	
	/**
	 * Determine if a value is a Number
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Number, otherwise false
	 */
	function isNumber(val) {
	  return typeof val === 'number';
	}
	
	/**
	 * Determine if a value is undefined
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if the value is undefined, otherwise false
	 */
	function isUndefined(val) {
	  return typeof val === 'undefined';
	}
	
	/**
	 * Determine if a value is an Object
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an Object, otherwise false
	 */
	function isObject(val) {
	  return val !== null && typeof val === 'object';
	}
	
	/**
	 * Determine if a value is a Date
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Date, otherwise false
	 */
	function isDate(val) {
	  return toString.call(val) === '[object Date]';
	}
	
	/**
	 * Determine if a value is a File
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a File, otherwise false
	 */
	function isFile(val) {
	  return toString.call(val) === '[object File]';
	}
	
	/**
	 * Determine if a value is a Blob
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Blob, otherwise false
	 */
	function isBlob(val) {
	  return toString.call(val) === '[object Blob]';
	}
	
	/**
	 * Determine if a value is a Function
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Function, otherwise false
	 */
	function isFunction(val) {
	  return toString.call(val) === '[object Function]';
	}
	
	/**
	 * Determine if a value is a Stream
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Stream, otherwise false
	 */
	function isStream(val) {
	  return isObject(val) && isFunction(val.pipe);
	}
	
	/**
	 * Determine if a value is a URLSearchParams object
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
	 */
	function isURLSearchParams(val) {
	  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
	}
	
	/**
	 * Trim excess whitespace off the beginning and end of a string
	 *
	 * @param {String} str The String to trim
	 * @returns {String} The String freed of excess whitespace
	 */
	function trim(str) {
	  return str.replace(/^\s*/, '').replace(/\s*$/, '');
	}
	
	/**
	 * Determine if we're running in a standard browser environment
	 *
	 * This allows axios to run in a web worker, and react-native.
	 * Both environments support XMLHttpRequest, but not fully standard globals.
	 *
	 * web workers:
	 *  typeof window -> undefined
	 *  typeof document -> undefined
	 *
	 * react-native:
	 *  navigator.product -> 'ReactNative'
	 */
	function isStandardBrowserEnv() {
	  if (typeof navigator !== 'undefined' && navigator.product === 'ReactNative') {
	    return false;
	  }
	  return (
	    typeof window !== 'undefined' &&
	    typeof document !== 'undefined'
	  );
	}
	
	/**
	 * Iterate over an Array or an Object invoking a function for each item.
	 *
	 * If `obj` is an Array callback will be called passing
	 * the value, index, and complete array for each item.
	 *
	 * If 'obj' is an Object callback will be called passing
	 * the value, key, and complete object for each property.
	 *
	 * @param {Object|Array} obj The object to iterate
	 * @param {Function} fn The callback to invoke for each item
	 */
	function forEach(obj, fn) {
	  // Don't bother if no value provided
	  if (obj === null || typeof obj === 'undefined') {
	    return;
	  }
	
	  // Force an array if not already something iterable
	  if (typeof obj !== 'object') {
	    /*eslint no-param-reassign:0*/
	    obj = [obj];
	  }
	
	  if (isArray(obj)) {
	    // Iterate over array values
	    for (var i = 0, l = obj.length; i < l; i++) {
	      fn.call(null, obj[i], i, obj);
	    }
	  } else {
	    // Iterate over object keys
	    for (var key in obj) {
	      if (Object.prototype.hasOwnProperty.call(obj, key)) {
	        fn.call(null, obj[key], key, obj);
	      }
	    }
	  }
	}
	
	/**
	 * Accepts varargs expecting each argument to be an object, then
	 * immutably merges the properties of each object and returns result.
	 *
	 * When multiple objects contain the same key the later object in
	 * the arguments list will take precedence.
	 *
	 * Example:
	 *
	 * ```js
	 * var result = merge({foo: 123}, {foo: 456});
	 * console.log(result.foo); // outputs 456
	 * ```
	 *
	 * @param {Object} obj1 Object to merge
	 * @returns {Object} Result of all merge properties
	 */
	function merge(/* obj1, obj2, obj3, ... */) {
	  var result = {};
	  function assignValue(val, key) {
	    if (typeof result[key] === 'object' && typeof val === 'object') {
	      result[key] = merge(result[key], val);
	    } else {
	      result[key] = val;
	    }
	  }
	
	  for (var i = 0, l = arguments.length; i < l; i++) {
	    forEach(arguments[i], assignValue);
	  }
	  return result;
	}
	
	/**
	 * Extends object a by mutably adding to it the properties of object b.
	 *
	 * @param {Object} a The object to be extended
	 * @param {Object} b The object to copy properties from
	 * @param {Object} thisArg The object to bind function to
	 * @return {Object} The resulting value of object a
	 */
	function extend(a, b, thisArg) {
	  forEach(b, function assignValue(val, key) {
	    if (thisArg && typeof val === 'function') {
	      a[key] = bind(val, thisArg);
	    } else {
	      a[key] = val;
	    }
	  });
	  return a;
	}
	
	module.exports = {
	  isArray: isArray,
	  isArrayBuffer: isArrayBuffer,
	  isBuffer: isBuffer,
	  isFormData: isFormData,
	  isArrayBufferView: isArrayBufferView,
	  isString: isString,
	  isNumber: isNumber,
	  isObject: isObject,
	  isUndefined: isUndefined,
	  isDate: isDate,
	  isFile: isFile,
	  isBlob: isBlob,
	  isFunction: isFunction,
	  isStream: isStream,
	  isURLSearchParams: isURLSearchParams,
	  isStandardBrowserEnv: isStandardBrowserEnv,
	  forEach: forEach,
	  merge: merge,
	  extend: extend,
	  trim: trim
	};


/***/ }),
/* 24 */
/***/ (function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	function makeEmptyFunction(arg) {
	  return function () {
	    return arg;
	  };
	}
	
	/**
	 * This function accepts and discards inputs; it has no side effects. This is
	 * primarily useful idiomatically for overridable function endpoints which
	 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
	 */
	var emptyFunction = function emptyFunction() {};
	
	emptyFunction.thatReturns = makeEmptyFunction;
	emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
	emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
	emptyFunction.thatReturnsNull = makeEmptyFunction(null);
	emptyFunction.thatReturnsThis = function () {
	  return this;
	};
	emptyFunction.thatReturnsArgument = function (arg) {
	  return arg;
	};
	
	module.exports = emptyFunction;

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2016-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	// Trust the developer to only use ReactInstrumentation with a __DEV__ check
	
	var debugTool = null;
	
	if (false) {
	  var ReactDebugTool = require('./ReactDebugTool');
	  debugTool = ReactDebugTool;
	}
	
	module.exports = { debugTool: debugTool };

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var firebaseApp_1 = __webpack_require__(222);
	exports.firebase = firebaseApp_1.createFirebaseNamespace();
	exports.default = exports.firebase;
	
	
	//# sourceMappingURL=index.js.map


/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var assert_1 = __webpack_require__(2);
	function contains(obj, key) {
	    return Object.prototype.hasOwnProperty.call(obj, key);
	}
	exports.contains = contains;
	function get(obj, key) {
	    return Object.prototype.hasOwnProperty.call(obj, key) ? obj[key] : null;
	}
	exports.get = get;
	function size(obj) {
	    var count = 0;
	    for (var key in obj) {
	        if (Object.prototype.hasOwnProperty.call(obj, key)) {
	            count++;
	        }
	    }
	    return count;
	}
	exports.size = size;
	/** Returns the given value if it's defined or the defaultValue otherwise. */
	function defaulted(value, defaultValue) {
	    return value !== undefined ? value : defaultValue;
	}
	exports.defaulted = defaulted;
	function forEachNumber(obj, fn) {
	    for (var key in obj) {
	        if (Object.prototype.hasOwnProperty.call(obj, key)) {
	            var num = Number(key);
	            if (!isNaN(num)) {
	                fn(num, obj[key]);
	            }
	        }
	    }
	}
	exports.forEachNumber = forEachNumber;
	function forEach(obj, fn) {
	    for (var key in obj) {
	        if (Object.prototype.hasOwnProperty.call(obj, key)) {
	            fn(key, obj[key]);
	        }
	    }
	}
	exports.forEach = forEach;
	function lookupOrInsert(obj, key, valFn) {
	    if (!contains(obj, key)) {
	        obj[key] = valFn();
	    }
	    return obj[key];
	}
	exports.lookupOrInsert = lookupOrInsert;
	function isEmpty(obj) {
	    assert_1.assert(obj != null && typeof obj === 'object', 'isEmpty() expects object parameter.');
	    for (var key in obj) {
	        if (Object.prototype.hasOwnProperty.call(obj, key)) {
	            return false;
	        }
	    }
	    return true;
	}
	exports.isEmpty = isEmpty;
	function shallowCopy(obj) {
	    assert_1.assert(obj && typeof obj === 'object', 'shallowCopy() expects object parameter.');
	    var result = {};
	    for (var key in obj) {
	        if (Object.prototype.hasOwnProperty.call(obj, key)) {
	            result[key] = obj[key];
	        }
	    }
	    return result;
	}
	exports.shallowCopy = shallowCopy;
	
	//# sourceMappingURL=obj.js.map


/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(6),
	    _assign = __webpack_require__(7);
	
	var CallbackQueue = __webpack_require__(197);
	var PooledClass = __webpack_require__(38);
	var ReactFeatureFlags = __webpack_require__(202);
	var ReactReconciler = __webpack_require__(46);
	var Transaction = __webpack_require__(85);
	
	var invariant = __webpack_require__(3);
	
	var dirtyComponents = [];
	var updateBatchNumber = 0;
	var asapCallbackQueue = CallbackQueue.getPooled();
	var asapEnqueued = false;
	
	var batchingStrategy = null;
	
	function ensureInjected() {
	  !(ReactUpdates.ReactReconcileTransaction && batchingStrategy) ?  false ? invariant(false, 'ReactUpdates: must inject a reconcile transaction class and batching strategy') : _prodInvariant('123') : void 0;
	}
	
	var NESTED_UPDATES = {
	  initialize: function () {
	    this.dirtyComponentsLength = dirtyComponents.length;
	  },
	  close: function () {
	    if (this.dirtyComponentsLength !== dirtyComponents.length) {
	      // Additional updates were enqueued by componentDidUpdate handlers or
	      // similar; before our own UPDATE_QUEUEING wrapper closes, we want to run
	      // these new updates so that if A's componentDidUpdate calls setState on
	      // B, B will update before the callback A's updater provided when calling
	      // setState.
	      dirtyComponents.splice(0, this.dirtyComponentsLength);
	      flushBatchedUpdates();
	    } else {
	      dirtyComponents.length = 0;
	    }
	  }
	};
	
	var UPDATE_QUEUEING = {
	  initialize: function () {
	    this.callbackQueue.reset();
	  },
	  close: function () {
	    this.callbackQueue.notifyAll();
	  }
	};
	
	var TRANSACTION_WRAPPERS = [NESTED_UPDATES, UPDATE_QUEUEING];
	
	function ReactUpdatesFlushTransaction() {
	  this.reinitializeTransaction();
	  this.dirtyComponentsLength = null;
	  this.callbackQueue = CallbackQueue.getPooled();
	  this.reconcileTransaction = ReactUpdates.ReactReconcileTransaction.getPooled(
	  /* useCreateElement */true);
	}
	
	_assign(ReactUpdatesFlushTransaction.prototype, Transaction, {
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  destructor: function () {
	    this.dirtyComponentsLength = null;
	    CallbackQueue.release(this.callbackQueue);
	    this.callbackQueue = null;
	    ReactUpdates.ReactReconcileTransaction.release(this.reconcileTransaction);
	    this.reconcileTransaction = null;
	  },
	
	  perform: function (method, scope, a) {
	    // Essentially calls `this.reconcileTransaction.perform(method, scope, a)`
	    // with this transaction's wrappers around it.
	    return Transaction.perform.call(this, this.reconcileTransaction.perform, this.reconcileTransaction, method, scope, a);
	  }
	});
	
	PooledClass.addPoolingTo(ReactUpdatesFlushTransaction);
	
	function batchedUpdates(callback, a, b, c, d, e) {
	  ensureInjected();
	  return batchingStrategy.batchedUpdates(callback, a, b, c, d, e);
	}
	
	/**
	 * Array comparator for ReactComponents by mount ordering.
	 *
	 * @param {ReactComponent} c1 first component you're comparing
	 * @param {ReactComponent} c2 second component you're comparing
	 * @return {number} Return value usable by Array.prototype.sort().
	 */
	function mountOrderComparator(c1, c2) {
	  return c1._mountOrder - c2._mountOrder;
	}
	
	function runBatchedUpdates(transaction) {
	  var len = transaction.dirtyComponentsLength;
	  !(len === dirtyComponents.length) ?  false ? invariant(false, 'Expected flush transaction\'s stored dirty-components length (%s) to match dirty-components array length (%s).', len, dirtyComponents.length) : _prodInvariant('124', len, dirtyComponents.length) : void 0;
	
	  // Since reconciling a component higher in the owner hierarchy usually (not
	  // always -- see shouldComponentUpdate()) will reconcile children, reconcile
	  // them before their children by sorting the array.
	  dirtyComponents.sort(mountOrderComparator);
	
	  // Any updates enqueued while reconciling must be performed after this entire
	  // batch. Otherwise, if dirtyComponents is [A, B] where A has children B and
	  // C, B could update twice in a single batch if C's render enqueues an update
	  // to B (since B would have already updated, we should skip it, and the only
	  // way we can know to do so is by checking the batch counter).
	  updateBatchNumber++;
	
	  for (var i = 0; i < len; i++) {
	    // If a component is unmounted before pending changes apply, it will still
	    // be here, but we assume that it has cleared its _pendingCallbacks and
	    // that performUpdateIfNecessary is a noop.
	    var component = dirtyComponents[i];
	
	    // If performUpdateIfNecessary happens to enqueue any new updates, we
	    // shouldn't execute the callbacks until the next render happens, so
	    // stash the callbacks first
	    var callbacks = component._pendingCallbacks;
	    component._pendingCallbacks = null;
	
	    var markerName;
	    if (ReactFeatureFlags.logTopLevelRenders) {
	      var namedComponent = component;
	      // Duck type TopLevelWrapper. This is probably always true.
	      if (component._currentElement.type.isReactTopLevelWrapper) {
	        namedComponent = component._renderedComponent;
	      }
	      markerName = 'React update: ' + namedComponent.getName();
	      console.time(markerName);
	    }
	
	    ReactReconciler.performUpdateIfNecessary(component, transaction.reconcileTransaction, updateBatchNumber);
	
	    if (markerName) {
	      console.timeEnd(markerName);
	    }
	
	    if (callbacks) {
	      for (var j = 0; j < callbacks.length; j++) {
	        transaction.callbackQueue.enqueue(callbacks[j], component.getPublicInstance());
	      }
	    }
	  }
	}
	
	var flushBatchedUpdates = function () {
	  // ReactUpdatesFlushTransaction's wrappers will clear the dirtyComponents
	  // array and perform any updates enqueued by mount-ready handlers (i.e.,
	  // componentDidUpdate) but we need to check here too in order to catch
	  // updates enqueued by setState callbacks and asap calls.
	  while (dirtyComponents.length || asapEnqueued) {
	    if (dirtyComponents.length) {
	      var transaction = ReactUpdatesFlushTransaction.getPooled();
	      transaction.perform(runBatchedUpdates, null, transaction);
	      ReactUpdatesFlushTransaction.release(transaction);
	    }
	
	    if (asapEnqueued) {
	      asapEnqueued = false;
	      var queue = asapCallbackQueue;
	      asapCallbackQueue = CallbackQueue.getPooled();
	      queue.notifyAll();
	      CallbackQueue.release(queue);
	    }
	  }
	};
	
	/**
	 * Mark a component as needing a rerender, adding an optional callback to a
	 * list of functions which will be executed once the rerender occurs.
	 */
	function enqueueUpdate(component) {
	  ensureInjected();
	
	  // Various parts of our code (such as ReactCompositeComponent's
	  // _renderValidatedComponent) assume that calls to render aren't nested;
	  // verify that that's the case. (This is called by each top-level update
	  // function, like setState, forceUpdate, etc.; creation and
	  // destruction of top-level components is guarded in ReactMount.)
	
	  if (!batchingStrategy.isBatchingUpdates) {
	    batchingStrategy.batchedUpdates(enqueueUpdate, component);
	    return;
	  }
	
	  dirtyComponents.push(component);
	  if (component._updateBatchNumber == null) {
	    component._updateBatchNumber = updateBatchNumber + 1;
	  }
	}
	
	/**
	 * Enqueue a callback to be run at the end of the current batching cycle. Throws
	 * if no updates are currently being performed.
	 */
	function asap(callback, context) {
	  invariant(batchingStrategy.isBatchingUpdates, "ReactUpdates.asap: Can't enqueue an asap callback in a context where" + 'updates are not being batched.');
	  asapCallbackQueue.enqueue(callback, context);
	  asapEnqueued = true;
	}
	
	var ReactUpdatesInjection = {
	  injectReconcileTransaction: function (ReconcileTransaction) {
	    !ReconcileTransaction ?  false ? invariant(false, 'ReactUpdates: must provide a reconcile transaction class') : _prodInvariant('126') : void 0;
	    ReactUpdates.ReactReconcileTransaction = ReconcileTransaction;
	  },
	
	  injectBatchingStrategy: function (_batchingStrategy) {
	    !_batchingStrategy ?  false ? invariant(false, 'ReactUpdates: must provide a batching strategy') : _prodInvariant('127') : void 0;
	    !(typeof _batchingStrategy.batchedUpdates === 'function') ?  false ? invariant(false, 'ReactUpdates: must provide a batchedUpdates() function') : _prodInvariant('128') : void 0;
	    !(typeof _batchingStrategy.isBatchingUpdates === 'boolean') ?  false ? invariant(false, 'ReactUpdates: must provide an isBatchingUpdates boolean attribute') : _prodInvariant('129') : void 0;
	    batchingStrategy = _batchingStrategy;
	  }
	};
	
	var ReactUpdates = {
	  /**
	   * React references `ReactReconcileTransaction` using this property in order
	   * to allow dependency injection.
	   *
	   * @internal
	   */
	  ReactReconcileTransaction: null,
	
	  batchedUpdates: batchedUpdates,
	  enqueueUpdate: enqueueUpdate,
	  flushBatchedUpdates: flushBatchedUpdates,
	  injection: ReactUpdatesInjection,
	  asap: asap
	};
	
	module.exports = ReactUpdates;

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var assert_1 = __webpack_require__(2);
	/**
	 * Provides singleton helpers where setup code can inject a platform at runtime.
	 * setPlatform needs to be set before Firestore is used and must be set exactly
	 * once.
	 */
	var PlatformSupport = /** @class */ (function () {
	    function PlatformSupport() {
	    }
	    PlatformSupport.setPlatform = function (platform) {
	        if (PlatformSupport.platform) {
	            assert_1.fail('Platform already defined');
	        }
	        PlatformSupport.platform = platform;
	    };
	    PlatformSupport.getPlatform = function () {
	        if (!PlatformSupport.platform) {
	            assert_1.fail('Platform not set');
	        }
	        return PlatformSupport.platform;
	    };
	    return PlatformSupport;
	}());
	exports.PlatformSupport = PlatformSupport;
	/**
	 * Returns the representation of an empty "proto" byte string for the
	 * platform.
	 */
	function emptyByteString() {
	    return PlatformSupport.getPlatform().emptyByteString;
	}
	exports.emptyByteString = emptyByteString;
	
	//# sourceMappingURL=platform.js.map


/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var constants_1 = __webpack_require__(78);
	var FirebaseStorageError = /** @class */ (function () {
	    function FirebaseStorageError(code, message) {
	        this.code_ = prependCode(code);
	        this.message_ = 'Firebase Storage: ' + message;
	        this.serverResponse_ = null;
	        this.name_ = 'FirebaseError';
	    }
	    FirebaseStorageError.prototype.codeProp = function () {
	        return this.code;
	    };
	    FirebaseStorageError.prototype.codeEquals = function (code) {
	        return prependCode(code) === this.codeProp();
	    };
	    FirebaseStorageError.prototype.serverResponseProp = function () {
	        return this.serverResponse_;
	    };
	    FirebaseStorageError.prototype.setServerResponseProp = function (serverResponse) {
	        this.serverResponse_ = serverResponse;
	    };
	    Object.defineProperty(FirebaseStorageError.prototype, "name", {
	        get: function () {
	            return this.name_;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(FirebaseStorageError.prototype, "code", {
	        get: function () {
	            return this.code_;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(FirebaseStorageError.prototype, "message", {
	        get: function () {
	            return this.message_;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(FirebaseStorageError.prototype, "serverResponse", {
	        get: function () {
	            return this.serverResponse_;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    return FirebaseStorageError;
	}());
	exports.FirebaseStorageError = FirebaseStorageError;
	exports.errors = {};
	exports.Code = {
	    // Shared between all platforms
	    UNKNOWN: 'unknown',
	    OBJECT_NOT_FOUND: 'object-not-found',
	    BUCKET_NOT_FOUND: 'bucket-not-found',
	    PROJECT_NOT_FOUND: 'project-not-found',
	    QUOTA_EXCEEDED: 'quota-exceeded',
	    UNAUTHENTICATED: 'unauthenticated',
	    UNAUTHORIZED: 'unauthorized',
	    RETRY_LIMIT_EXCEEDED: 'retry-limit-exceeded',
	    INVALID_CHECKSUM: 'invalid-checksum',
	    CANCELED: 'canceled',
	    // JS specific
	    INVALID_EVENT_NAME: 'invalid-event-name',
	    INVALID_URL: 'invalid-url',
	    INVALID_DEFAULT_BUCKET: 'invalid-default-bucket',
	    NO_DEFAULT_BUCKET: 'no-default-bucket',
	    CANNOT_SLICE_BLOB: 'cannot-slice-blob',
	    SERVER_FILE_WRONG_SIZE: 'server-file-wrong-size',
	    NO_DOWNLOAD_URL: 'no-download-url',
	    INVALID_ARGUMENT: 'invalid-argument',
	    INVALID_ARGUMENT_COUNT: 'invalid-argument-count',
	    APP_DELETED: 'app-deleted',
	    INVALID_ROOT_OPERATION: 'invalid-root-operation',
	    INVALID_FORMAT: 'invalid-format',
	    INTERNAL_ERROR: 'internal-error'
	};
	function prependCode(code) {
	    return 'storage/' + code;
	}
	exports.prependCode = prependCode;
	function unknown() {
	    var message = 'An unknown error occurred, please check the error payload for ' +
	        'server response.';
	    return new FirebaseStorageError(exports.Code.UNKNOWN, message);
	}
	exports.unknown = unknown;
	function objectNotFound(path) {
	    return new FirebaseStorageError(exports.Code.OBJECT_NOT_FOUND, "Object '" + path + "' does not exist.");
	}
	exports.objectNotFound = objectNotFound;
	function bucketNotFound(bucket) {
	    return new FirebaseStorageError(exports.Code.BUCKET_NOT_FOUND, "Bucket '" + bucket + "' does not exist.");
	}
	exports.bucketNotFound = bucketNotFound;
	function projectNotFound(project) {
	    return new FirebaseStorageError(exports.Code.PROJECT_NOT_FOUND, "Project '" + project + "' does not exist.");
	}
	exports.projectNotFound = projectNotFound;
	function quotaExceeded(bucket) {
	    return new FirebaseStorageError(exports.Code.QUOTA_EXCEEDED, "Quota for bucket '" +
	        bucket +
	        "' exceeded, please view quota on " +
	        'https://firebase.google.com/pricing/.');
	}
	exports.quotaExceeded = quotaExceeded;
	function unauthenticated() {
	    var message = 'User is not authenticated, please authenticate using Firebase ' +
	        'Authentication and try again.';
	    return new FirebaseStorageError(exports.Code.UNAUTHENTICATED, message);
	}
	exports.unauthenticated = unauthenticated;
	function unauthorized(path) {
	    return new FirebaseStorageError(exports.Code.UNAUTHORIZED, "User does not have permission to access '" + path + "'.");
	}
	exports.unauthorized = unauthorized;
	function retryLimitExceeded() {
	    return new FirebaseStorageError(exports.Code.RETRY_LIMIT_EXCEEDED, 'Max retry time for operation exceeded, please try again.');
	}
	exports.retryLimitExceeded = retryLimitExceeded;
	function invalidChecksum(path, checksum, calculated) {
	    return new FirebaseStorageError(exports.Code.INVALID_CHECKSUM, "Uploaded/downloaded object '" +
	        path +
	        "' has checksum '" +
	        checksum +
	        "' which does not match '" +
	        calculated +
	        "'. Please retry the upload/download.");
	}
	exports.invalidChecksum = invalidChecksum;
	function canceled() {
	    return new FirebaseStorageError(exports.Code.CANCELED, 'User canceled the upload/download.');
	}
	exports.canceled = canceled;
	function invalidEventName(name) {
	    return new FirebaseStorageError(exports.Code.INVALID_EVENT_NAME, "Invalid event name '" + name + "'.");
	}
	exports.invalidEventName = invalidEventName;
	function invalidUrl(url) {
	    return new FirebaseStorageError(exports.Code.INVALID_URL, "Invalid URL '" + url + "'.");
	}
	exports.invalidUrl = invalidUrl;
	function invalidDefaultBucket(bucket) {
	    return new FirebaseStorageError(exports.Code.INVALID_DEFAULT_BUCKET, "Invalid default bucket '" + bucket + "'.");
	}
	exports.invalidDefaultBucket = invalidDefaultBucket;
	function noDefaultBucket() {
	    return new FirebaseStorageError(exports.Code.NO_DEFAULT_BUCKET, 'No default bucket ' +
	        "found. Did you set the '" +
	        constants_1.configOption +
	        "' property when initializing the app?");
	}
	exports.noDefaultBucket = noDefaultBucket;
	function cannotSliceBlob() {
	    return new FirebaseStorageError(exports.Code.CANNOT_SLICE_BLOB, 'Cannot slice blob for upload. Please retry the upload.');
	}
	exports.cannotSliceBlob = cannotSliceBlob;
	function serverFileWrongSize() {
	    return new FirebaseStorageError(exports.Code.SERVER_FILE_WRONG_SIZE, 'Server recorded incorrect upload file size, please retry the upload.');
	}
	exports.serverFileWrongSize = serverFileWrongSize;
	function noDownloadURL() {
	    return new FirebaseStorageError(exports.Code.NO_DOWNLOAD_URL, 'The given file does not have any download URLs.');
	}
	exports.noDownloadURL = noDownloadURL;
	function invalidArgument(index, fnName, message) {
	    return new FirebaseStorageError(exports.Code.INVALID_ARGUMENT, 'Invalid argument in `' + fnName + '` at index ' + index + ': ' + message);
	}
	exports.invalidArgument = invalidArgument;
	function invalidArgumentCount(argMin, argMax, fnName, real) {
	    var countPart;
	    var plural;
	    if (argMin === argMax) {
	        countPart = argMin;
	        plural = argMin === 1 ? 'argument' : 'arguments';
	    }
	    else {
	        countPart = 'between ' + argMin + ' and ' + argMax;
	        plural = 'arguments';
	    }
	    return new FirebaseStorageError(exports.Code.INVALID_ARGUMENT_COUNT, 'Invalid argument count in `' +
	        fnName +
	        '`: Expected ' +
	        countPart +
	        ' ' +
	        plural +
	        ', received ' +
	        real +
	        '.');
	}
	exports.invalidArgumentCount = invalidArgumentCount;
	function appDeleted() {
	    return new FirebaseStorageError(exports.Code.APP_DELETED, 'The Firebase app was deleted.');
	}
	exports.appDeleted = appDeleted;
	/**
	 * @param name The name of the operation that was invalid.
	 */
	function invalidRootOperation(name) {
	    return new FirebaseStorageError(exports.Code.INVALID_ROOT_OPERATION, "The operation '" +
	        name +
	        "' cannot be performed on a root reference, create a non-root " +
	        "reference using child, such as .child('file.png').");
	}
	exports.invalidRootOperation = invalidRootOperation;
	/**
	 * @param format The format that was not valid.
	 * @param message A message describing the format violation.
	 */
	function invalidFormat(format, message) {
	    return new FirebaseStorageError(exports.Code.INVALID_FORMAT, "String does not match format '" + format + "': " + message);
	}
	exports.invalidFormat = invalidFormat;
	/**
	 * @param message A message describing the internal error.
	 */
	function internalError(message) {
	    throw new FirebaseStorageError(exports.Code.INTERNAL_ERROR, 'Internal error: ' + message);
	}
	exports.internalError = internalError;
	
	//# sourceMappingURL=error.js.map


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(7);
	
	var PooledClass = __webpack_require__(38);
	
	var emptyFunction = __webpack_require__(24);
	var warning = __webpack_require__(5);
	
	var didWarnForAddedNewProperty = false;
	var isProxySupported = typeof Proxy === 'function';
	
	var shouldBeReleasedProperties = ['dispatchConfig', '_targetInst', 'nativeEvent', 'isDefaultPrevented', 'isPropagationStopped', '_dispatchListeners', '_dispatchInstances'];
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var EventInterface = {
	  type: null,
	  target: null,
	  // currentTarget is set when dispatching; no use in copying it here
	  currentTarget: emptyFunction.thatReturnsNull,
	  eventPhase: null,
	  bubbles: null,
	  cancelable: null,
	  timeStamp: function (event) {
	    return event.timeStamp || Date.now();
	  },
	  defaultPrevented: null,
	  isTrusted: null
	};
	
	/**
	 * Synthetic events are dispatched by event plugins, typically in response to a
	 * top-level event delegation handler.
	 *
	 * These systems should generally use pooling to reduce the frequency of garbage
	 * collection. The system should check `isPersistent` to determine whether the
	 * event should be released into the pool after being dispatched. Users that
	 * need a persisted event should invoke `persist`.
	 *
	 * Synthetic events (and subclasses) implement the DOM Level 3 Events API by
	 * normalizing browser quirks. Subclasses do not necessarily have to implement a
	 * DOM interface; custom application-specific events can also subclass this.
	 *
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {*} targetInst Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @param {DOMEventTarget} nativeEventTarget Target node.
	 */
	function SyntheticEvent(dispatchConfig, targetInst, nativeEvent, nativeEventTarget) {
	  if (false) {
	    // these have a getter/setter for warnings
	    delete this.nativeEvent;
	    delete this.preventDefault;
	    delete this.stopPropagation;
	  }
	
	  this.dispatchConfig = dispatchConfig;
	  this._targetInst = targetInst;
	  this.nativeEvent = nativeEvent;
	
	  var Interface = this.constructor.Interface;
	  for (var propName in Interface) {
	    if (!Interface.hasOwnProperty(propName)) {
	      continue;
	    }
	    if (false) {
	      delete this[propName]; // this has a getter/setter for warnings
	    }
	    var normalize = Interface[propName];
	    if (normalize) {
	      this[propName] = normalize(nativeEvent);
	    } else {
	      if (propName === 'target') {
	        this.target = nativeEventTarget;
	      } else {
	        this[propName] = nativeEvent[propName];
	      }
	    }
	  }
	
	  var defaultPrevented = nativeEvent.defaultPrevented != null ? nativeEvent.defaultPrevented : nativeEvent.returnValue === false;
	  if (defaultPrevented) {
	    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
	  } else {
	    this.isDefaultPrevented = emptyFunction.thatReturnsFalse;
	  }
	  this.isPropagationStopped = emptyFunction.thatReturnsFalse;
	  return this;
	}
	
	_assign(SyntheticEvent.prototype, {
	  preventDefault: function () {
	    this.defaultPrevented = true;
	    var event = this.nativeEvent;
	    if (!event) {
	      return;
	    }
	
	    if (event.preventDefault) {
	      event.preventDefault();
	      // eslint-disable-next-line valid-typeof
	    } else if (typeof event.returnValue !== 'unknown') {
	      event.returnValue = false;
	    }
	    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
	  },
	
	  stopPropagation: function () {
	    var event = this.nativeEvent;
	    if (!event) {
	      return;
	    }
	
	    if (event.stopPropagation) {
	      event.stopPropagation();
	      // eslint-disable-next-line valid-typeof
	    } else if (typeof event.cancelBubble !== 'unknown') {
	      // The ChangeEventPlugin registers a "propertychange" event for
	      // IE. This event does not support bubbling or cancelling, and
	      // any references to cancelBubble throw "Member not found".  A
	      // typeof check of "unknown" circumvents this issue (and is also
	      // IE specific).
	      event.cancelBubble = true;
	    }
	
	    this.isPropagationStopped = emptyFunction.thatReturnsTrue;
	  },
	
	  /**
	   * We release all dispatched `SyntheticEvent`s after each event loop, adding
	   * them back into the pool. This allows a way to hold onto a reference that
	   * won't be added back into the pool.
	   */
	  persist: function () {
	    this.isPersistent = emptyFunction.thatReturnsTrue;
	  },
	
	  /**
	   * Checks if this event should be released back into the pool.
	   *
	   * @return {boolean} True if this should not be released, false otherwise.
	   */
	  isPersistent: emptyFunction.thatReturnsFalse,
	
	  /**
	   * `PooledClass` looks for `destructor` on each instance it releases.
	   */
	  destructor: function () {
	    var Interface = this.constructor.Interface;
	    for (var propName in Interface) {
	      if (false) {
	        Object.defineProperty(this, propName, getPooledWarningPropertyDefinition(propName, Interface[propName]));
	      } else {
	        this[propName] = null;
	      }
	    }
	    for (var i = 0; i < shouldBeReleasedProperties.length; i++) {
	      this[shouldBeReleasedProperties[i]] = null;
	    }
	    if (false) {
	      Object.defineProperty(this, 'nativeEvent', getPooledWarningPropertyDefinition('nativeEvent', null));
	      Object.defineProperty(this, 'preventDefault', getPooledWarningPropertyDefinition('preventDefault', emptyFunction));
	      Object.defineProperty(this, 'stopPropagation', getPooledWarningPropertyDefinition('stopPropagation', emptyFunction));
	    }
	  }
	});
	
	SyntheticEvent.Interface = EventInterface;
	
	/**
	 * Helper to reduce boilerplate when creating subclasses.
	 *
	 * @param {function} Class
	 * @param {?object} Interface
	 */
	SyntheticEvent.augmentClass = function (Class, Interface) {
	  var Super = this;
	
	  var E = function () {};
	  E.prototype = Super.prototype;
	  var prototype = new E();
	
	  _assign(prototype, Class.prototype);
	  Class.prototype = prototype;
	  Class.prototype.constructor = Class;
	
	  Class.Interface = _assign({}, Super.Interface, Interface);
	  Class.augmentClass = Super.augmentClass;
	
	  PooledClass.addPoolingTo(Class, PooledClass.fourArgumentPooler);
	};
	
	/** Proxying after everything set on SyntheticEvent
	  * to resolve Proxy issue on some WebKit browsers
	  * in which some Event properties are set to undefined (GH#10010)
	  */
	if (false) {
	  if (isProxySupported) {
	    /*eslint-disable no-func-assign */
	    SyntheticEvent = new Proxy(SyntheticEvent, {
	      construct: function (target, args) {
	        return this.apply(target, Object.create(target.prototype), args);
	      },
	      apply: function (constructor, that, args) {
	        return new Proxy(constructor.apply(that, args), {
	          set: function (target, prop, value) {
	            if (prop !== 'isPersistent' && !target.constructor.Interface.hasOwnProperty(prop) && shouldBeReleasedProperties.indexOf(prop) === -1) {
	              process.env.NODE_ENV !== 'production' ? warning(didWarnForAddedNewProperty || target.isPersistent(), "This synthetic event is reused for performance reasons. If you're " + "seeing this, you're adding a new property in the synthetic event object. " + 'The property is never released. See ' + 'https://fb.me/react-event-pooling for more information.') : void 0;
	              didWarnForAddedNewProperty = true;
	            }
	            target[prop] = value;
	            return true;
	          }
	        });
	      }
	    });
	    /*eslint-enable no-func-assign */
	  }
	}
	
	PooledClass.addPoolingTo(SyntheticEvent, PooledClass.fourArgumentPooler);
	
	module.exports = SyntheticEvent;
	
	/**
	  * Helper to nullify syntheticEvent instance properties when destructing
	  *
	  * @param {object} SyntheticEvent
	  * @param {String} propName
	  * @return {object} defineProperty object
	  */
	function getPooledWarningPropertyDefinition(propName, getVal) {
	  var isFunction = typeof getVal === 'function';
	  return {
	    configurable: true,
	    set: set,
	    get: get
	  };
	
	  function set(val) {
	    var action = isFunction ? 'setting the method' : 'setting the property';
	    warn(action, 'This is effectively a no-op');
	    return val;
	  }
	
	  function get() {
	    var action = isFunction ? 'accessing the method' : 'accessing the property';
	    var result = isFunction ? 'This is a no-op function' : 'This is set to null';
	    warn(action, result);
	    return getVal;
	  }
	
	  function warn(action, result) {
	    var warningCondition = false;
	     false ? warning(warningCondition, "This synthetic event is reused for performance reasons. If you're seeing this, " + "you're %s `%s` on a released/nullified synthetic event. %s. " + 'If you must keep the original synthetic event around, use event.persist(). ' + 'See https://fb.me/react-event-pooling for more information.', action, propName, result) : void 0;
	  }
	}

/***/ }),
/* 32 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * Keeps track of the current owner.
	 *
	 * The current owner is the component who should own any components that are
	 * currently being constructed.
	 */
	var ReactCurrentOwner = {
	  /**
	   * @internal
	   * @type {ReactComponent}
	   */
	  current: null
	};
	
	module.exports = ReactCurrentOwner;

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var util_1 = __webpack_require__(1);
	/**
	 *
	 * @enum
	 */
	var OperationType;
	(function (OperationType) {
	    OperationType[OperationType["OVERWRITE"] = 0] = "OVERWRITE";
	    OperationType[OperationType["MERGE"] = 1] = "MERGE";
	    OperationType[OperationType["ACK_USER_WRITE"] = 2] = "ACK_USER_WRITE";
	    OperationType[OperationType["LISTEN_COMPLETE"] = 3] = "LISTEN_COMPLETE";
	})(OperationType = exports.OperationType || (exports.OperationType = {}));
	/**
	 * @param {boolean} fromUser
	 * @param {boolean} fromServer
	 * @param {?string} queryId
	 * @param {boolean} tagged
	 * @constructor
	 */
	var OperationSource = /** @class */ (function () {
	    function OperationSource(fromUser, fromServer, queryId, tagged) {
	        this.fromUser = fromUser;
	        this.fromServer = fromServer;
	        this.queryId = queryId;
	        this.tagged = tagged;
	        util_1.assert(!tagged || fromServer, 'Tagged queries must be from server.');
	    }
	    /**
	     * @const
	     * @type {!OperationSource}
	     */
	    OperationSource.User = new OperationSource(
	    /*fromUser=*/ true, false, null, 
	    /*tagged=*/ false);
	    /**
	     * @const
	     * @type {!OperationSource}
	     */
	    OperationSource.Server = new OperationSource(false, 
	    /*fromServer=*/ true, null, 
	    /*tagged=*/ false);
	    /**
	     * @param {string} queryId
	     * @return {!OperationSource}
	     */
	    OperationSource.forServerTaggedQuery = function (queryId) {
	        return new OperationSource(false, 
	        /*fromServer=*/ true, queryId, 
	        /*tagged=*/ true);
	    };
	    return OperationSource;
	}());
	exports.OperationSource = OperationSource;
	
	//# sourceMappingURL=Operation.js.map


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var Path_1 = __webpack_require__(8);
	var util_1 = __webpack_require__(1);
	var util_2 = __webpack_require__(4);
	var util_3 = __webpack_require__(1);
	var util_4 = __webpack_require__(1);
	/**
	 * True for invalid Firebase keys
	 * @type {RegExp}
	 * @private
	 */
	exports.INVALID_KEY_REGEX_ = /[\[\].#$\/\u0000-\u001F\u007F]/;
	/**
	 * True for invalid Firebase paths.
	 * Allows '/' in paths.
	 * @type {RegExp}
	 * @private
	 */
	exports.INVALID_PATH_REGEX_ = /[\[\].#$\u0000-\u001F\u007F]/;
	/**
	 * Maximum number of characters to allow in leaf value
	 * @type {number}
	 * @private
	 */
	exports.MAX_LEAF_SIZE_ = 10 * 1024 * 1024;
	/**
	 * @param {*} key
	 * @return {boolean}
	 */
	exports.isValidKey = function (key) {
	    return (typeof key === 'string' && key.length !== 0 && !exports.INVALID_KEY_REGEX_.test(key));
	};
	/**
	 * @param {string} pathString
	 * @return {boolean}
	 */
	exports.isValidPathString = function (pathString) {
	    return (typeof pathString === 'string' &&
	        pathString.length !== 0 &&
	        !exports.INVALID_PATH_REGEX_.test(pathString));
	};
	/**
	 * @param {string} pathString
	 * @return {boolean}
	 */
	exports.isValidRootPathString = function (pathString) {
	    if (pathString) {
	        // Allow '/.info/' at the beginning.
	        pathString = pathString.replace(/^\/*\.info(\/|$)/, '/');
	    }
	    return exports.isValidPathString(pathString);
	};
	/**
	 * @param {*} priority
	 * @return {boolean}
	 */
	exports.isValidPriority = function (priority) {
	    return (priority === null ||
	        typeof priority === 'string' ||
	        (typeof priority === 'number' && !util_2.isInvalidJSONNumber(priority)) ||
	        (priority && typeof priority === 'object' && util_1.contains(priority, '.sv')));
	};
	/**
	 * Pre-validate a datum passed as an argument to Firebase function.
	 *
	 * @param {string} fnName
	 * @param {number} argumentNumber
	 * @param {*} data
	 * @param {!Path} path
	 * @param {boolean} optional
	 */
	exports.validateFirebaseDataArg = function (fnName, argumentNumber, data, path, optional) {
	    if (optional && data === undefined)
	        return;
	    exports.validateFirebaseData(util_3.errorPrefix(fnName, argumentNumber, optional), data, path);
	};
	/**
	 * Validate a data object client-side before sending to server.
	 *
	 * @param {string} errorPrefix
	 * @param {*} data
	 * @param {!Path|!ValidationPath} path_
	 */
	exports.validateFirebaseData = function (errorPrefix, data, path_) {
	    var path = path_ instanceof Path_1.Path ? new Path_1.ValidationPath(path_, errorPrefix) : path_;
	    if (data === undefined) {
	        throw new Error(errorPrefix + 'contains undefined ' + path.toErrorString());
	    }
	    if (typeof data === 'function') {
	        throw new Error(errorPrefix +
	            'contains a function ' +
	            path.toErrorString() +
	            ' with contents = ' +
	            data.toString());
	    }
	    if (util_2.isInvalidJSONNumber(data)) {
	        throw new Error(errorPrefix + 'contains ' + data.toString() + ' ' + path.toErrorString());
	    }
	    // Check max leaf size, but try to avoid the utf8 conversion if we can.
	    if (typeof data === 'string' &&
	        data.length > exports.MAX_LEAF_SIZE_ / 3 &&
	        util_4.stringLength(data) > exports.MAX_LEAF_SIZE_) {
	        throw new Error(errorPrefix +
	            'contains a string greater than ' +
	            exports.MAX_LEAF_SIZE_ +
	            ' utf8 bytes ' +
	            path.toErrorString() +
	            " ('" +
	            data.substring(0, 50) +
	            "...')");
	    }
	    // TODO = Perf = Consider combining the recursive validation of keys into NodeFromJSON
	    // to save extra walking of large objects.
	    if (data && typeof data === 'object') {
	        var hasDotValue_1 = false, hasActualChild_1 = false;
	        util_1.forEach(data, function (key, value) {
	            if (key === '.value') {
	                hasDotValue_1 = true;
	            }
	            else if (key !== '.priority' && key !== '.sv') {
	                hasActualChild_1 = true;
	                if (!exports.isValidKey(key)) {
	                    throw new Error(errorPrefix +
	                        ' contains an invalid key (' +
	                        key +
	                        ') ' +
	                        path.toErrorString() +
	                        '.  Keys must be non-empty strings ' +
	                        'and can\'t contain ".", "#", "$", "/", "[", or "]"');
	                }
	            }
	            path.push(key);
	            exports.validateFirebaseData(errorPrefix, value, path);
	            path.pop();
	        });
	        if (hasDotValue_1 && hasActualChild_1) {
	            throw new Error(errorPrefix +
	                ' contains ".value" child ' +
	                path.toErrorString() +
	                ' in addition to actual children.');
	        }
	    }
	};
	/**
	 * Pre-validate paths passed in the firebase function.
	 *
	 * @param {string} errorPrefix
	 * @param {Array<!Path>} mergePaths
	 */
	exports.validateFirebaseMergePaths = function (errorPrefix, mergePaths) {
	    var i, curPath;
	    for (i = 0; i < mergePaths.length; i++) {
	        curPath = mergePaths[i];
	        var keys = curPath.slice();
	        for (var j = 0; j < keys.length; j++) {
	            if (keys[j] === '.priority' && j === keys.length - 1) {
	                // .priority is OK
	            }
	            else if (!exports.isValidKey(keys[j])) {
	                throw new Error(errorPrefix +
	                    'contains an invalid key (' +
	                    keys[j] +
	                    ') in path ' +
	                    curPath.toString() +
	                    '. Keys must be non-empty strings ' +
	                    'and can\'t contain ".", "#", "$", "/", "[", or "]"');
	            }
	        }
	    }
	    // Check that update keys are not descendants of each other.
	    // We rely on the property that sorting guarantees that ancestors come
	    // right before descendants.
	    mergePaths.sort(Path_1.Path.comparePaths);
	    var prevPath = null;
	    for (i = 0; i < mergePaths.length; i++) {
	        curPath = mergePaths[i];
	        if (prevPath !== null && prevPath.contains(curPath)) {
	            throw new Error(errorPrefix +
	                'contains a path ' +
	                prevPath.toString() +
	                ' that is ancestor of another path ' +
	                curPath.toString());
	        }
	        prevPath = curPath;
	    }
	};
	/**
	 * pre-validate an object passed as an argument to firebase function (
	 * must be an object - e.g. for firebase.update()).
	 *
	 * @param {string} fnName
	 * @param {number} argumentNumber
	 * @param {*} data
	 * @param {!Path} path
	 * @param {boolean} optional
	 */
	exports.validateFirebaseMergeDataArg = function (fnName, argumentNumber, data, path, optional) {
	    if (optional && data === undefined)
	        return;
	    var errorPrefix = util_3.errorPrefix(fnName, argumentNumber, optional);
	    if (!(data && typeof data === 'object') || Array.isArray(data)) {
	        throw new Error(errorPrefix + ' must be an object containing the children to replace.');
	    }
	    var mergePaths = [];
	    util_1.forEach(data, function (key, value) {
	        var curPath = new Path_1.Path(key);
	        exports.validateFirebaseData(errorPrefix, value, path.child(curPath));
	        if (curPath.getBack() === '.priority') {
	            if (!exports.isValidPriority(value)) {
	                throw new Error(errorPrefix +
	                    "contains an invalid value for '" +
	                    curPath.toString() +
	                    "', which must be a valid " +
	                    'Firebase priority (a string, finite number, server value, or null).');
	            }
	        }
	        mergePaths.push(curPath);
	    });
	    exports.validateFirebaseMergePaths(errorPrefix, mergePaths);
	};
	exports.validatePriority = function (fnName, argumentNumber, priority, optional) {
	    if (optional && priority === undefined)
	        return;
	    if (util_2.isInvalidJSONNumber(priority))
	        throw new Error(util_3.errorPrefix(fnName, argumentNumber, optional) +
	            'is ' +
	            priority.toString() +
	            ', but must be a valid Firebase priority (a string, finite number, ' +
	            'server value, or null).');
	    // Special case to allow importing data with a .sv.
	    if (!exports.isValidPriority(priority))
	        throw new Error(util_3.errorPrefix(fnName, argumentNumber, optional) +
	            'must be a valid Firebase priority ' +
	            '(a string, finite number, server value, or null).');
	};
	exports.validateEventType = function (fnName, argumentNumber, eventType, optional) {
	    if (optional && eventType === undefined)
	        return;
	    switch (eventType) {
	        case 'value':
	        case 'child_added':
	        case 'child_removed':
	        case 'child_changed':
	        case 'child_moved':
	            break;
	        default:
	            throw new Error(util_3.errorPrefix(fnName, argumentNumber, optional) +
	                'must be a valid event type = "value", "child_added", "child_removed", ' +
	                '"child_changed", or "child_moved".');
	    }
	};
	exports.validateKey = function (fnName, argumentNumber, key, optional) {
	    if (optional && key === undefined)
	        return;
	    if (!exports.isValidKey(key))
	        throw new Error(util_3.errorPrefix(fnName, argumentNumber, optional) +
	            'was an invalid key = "' +
	            key +
	            '".  Firebase keys must be non-empty strings and ' +
	            'can\'t contain ".", "#", "$", "/", "[", or "]").');
	};
	exports.validatePathString = function (fnName, argumentNumber, pathString, optional) {
	    if (optional && pathString === undefined)
	        return;
	    if (!exports.isValidPathString(pathString))
	        throw new Error(util_3.errorPrefix(fnName, argumentNumber, optional) +
	            'was an invalid path = "' +
	            pathString +
	            '". Paths must be non-empty strings and ' +
	            'can\'t contain ".", "#", "$", "[", or "]"');
	};
	exports.validateRootPathString = function (fnName, argumentNumber, pathString, optional) {
	    if (pathString) {
	        // Allow '/.info/' at the beginning.
	        pathString = pathString.replace(/^\/*\.info(\/|$)/, '/');
	    }
	    exports.validatePathString(fnName, argumentNumber, pathString, optional);
	};
	exports.validateWritablePath = function (fnName, path) {
	    if (path.getFront() === '.info') {
	        throw new Error(fnName + " failed = Can't modify data under /.info/");
	    }
	};
	exports.validateUrl = function (fnName, argumentNumber, parsedUrl) {
	    // TODO = Validate server better.
	    var pathString = parsedUrl.path.toString();
	    if (!(typeof parsedUrl.repoInfo.host === 'string') ||
	        parsedUrl.repoInfo.host.length === 0 ||
	        (!exports.isValidKey(parsedUrl.repoInfo.namespace) &&
	            parsedUrl.repoInfo.host.split(':')[0] !== 'localhost') ||
	        (pathString.length !== 0 && !exports.isValidRootPathString(pathString))) {
	        throw new Error(util_3.errorPrefix(fnName, argumentNumber, false) +
	            'must be a valid firebase URL and ' +
	            'the path can\'t contain ".", "#", "$", "[", or "]".');
	    }
	};
	exports.validateCredential = function (fnName, argumentNumber, cred, optional) {
	    if (optional && cred === undefined)
	        return;
	    if (!(typeof cred === 'string'))
	        throw new Error(util_3.errorPrefix(fnName, argumentNumber, optional) +
	            'must be a valid credential (a string).');
	};
	exports.validateBoolean = function (fnName, argumentNumber, bool, optional) {
	    if (optional && bool === undefined)
	        return;
	    if (typeof bool !== 'boolean')
	        throw new Error(util_3.errorPrefix(fnName, argumentNumber, optional) + 'must be a boolean.');
	};
	exports.validateString = function (fnName, argumentNumber, string, optional) {
	    if (optional && string === undefined)
	        return;
	    if (!(typeof string === 'string')) {
	        throw new Error(util_3.errorPrefix(fnName, argumentNumber, optional) +
	            'must be a valid string.');
	    }
	};
	exports.validateObject = function (fnName, argumentNumber, obj, optional) {
	    if (optional && obj === undefined)
	        return;
	    if (!(obj && typeof obj === 'object') || obj === null) {
	        throw new Error(util_3.errorPrefix(fnName, argumentNumber, optional) +
	            'must be a valid object.');
	    }
	};
	exports.validateObjectContainsKey = function (fnName, argumentNumber, obj, key, optional, opt_type) {
	    var objectContainsKey = obj && typeof obj === 'object' && util_1.contains(obj, key);
	    if (!objectContainsKey) {
	        if (optional) {
	            return;
	        }
	        else {
	            throw new Error(util_3.errorPrefix(fnName, argumentNumber, optional) +
	                'must contain the key "' +
	                key +
	                '"');
	        }
	    }
	    if (opt_type) {
	        var val = util_1.safeGet(obj, key);
	        if ((opt_type === 'number' && !(typeof val === 'number')) ||
	            (opt_type === 'string' && !(typeof val === 'string')) ||
	            (opt_type === 'boolean' && !(typeof val === 'boolean')) ||
	            (opt_type === 'function' && !(typeof val === 'function')) ||
	            (opt_type === 'object' && !(typeof val === 'object') && val)) {
	            if (optional) {
	                throw new Error(util_3.errorPrefix(fnName, argumentNumber, optional) +
	                    'contains invalid value for key "' +
	                    key +
	                    '" (must be of type "' +
	                    opt_type +
	                    '")');
	            }
	            else {
	                throw new Error(util_3.errorPrefix(fnName, argumentNumber, optional) +
	                    'must contain the key "' +
	                    key +
	                    '" with type "' +
	                    opt_type +
	                    '"');
	            }
	        }
	    }
	};
	
	//# sourceMappingURL=validation.js.map


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var assert_1 = __webpack_require__(2);
	var error_1 = __webpack_require__(10);
	exports.DOCUMENT_KEY_NAME = '__name__';
	/**
	 * Path represents an ordered sequence of string segments.
	 */
	var Path = /** @class */ (function () {
	    function Path(segments, offset, length) {
	        this.init(segments, offset, length);
	    }
	    /**
	     * An initialization method that can be called from outside the constructor.
	     * We need this so that we can have a non-static construct method that returns
	     * the polymorphic `this` type.
	     */
	    Path.prototype.init = function (segments, offset, length) {
	        if (offset === undefined) {
	            offset = 0;
	        }
	        else if (offset > segments.length) {
	            assert_1.fail('offset ' + offset + ' out of range ' + segments.length);
	        }
	        if (length === undefined) {
	            length = segments.length - offset;
	        }
	        else if (length > segments.length - offset) {
	            assert_1.fail('length ' + length + ' out of range ' + (segments.length - offset));
	        }
	        this.segments = segments;
	        this.offset = offset;
	        this.len = length;
	    };
	    /**
	     * Constructs a new instance of Path using the same concrete type as `this`.
	     * We need this instead of using the normal constructor, because polymorphic
	     * `this` doesn't work on static methods.
	     */
	    Path.prototype.construct = function (segments, offset, length) {
	        var path = Object.create(Object.getPrototypeOf(this));
	        path.init(segments, offset, length);
	        return path;
	    };
	    Object.defineProperty(Path.prototype, "length", {
	        get: function () {
	            return this.len;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Path.prototype.isEqual = function (other) {
	        return Path.comparator(this, other) === 0;
	    };
	    Path.prototype.child = function (nameOrPath) {
	        var segments = this.segments.slice(this.offset, this.limit());
	        if (nameOrPath instanceof Path) {
	            nameOrPath.forEach(function (segment) {
	                segments.push(segment);
	            });
	        }
	        else if (typeof nameOrPath === 'string') {
	            segments.push(nameOrPath);
	        }
	        else {
	            assert_1.fail('Unknown parameter type for Path.child(): ' + nameOrPath);
	        }
	        return this.construct(segments);
	    };
	    /** The index of one past the last segment of the path. */
	    Path.prototype.limit = function () {
	        return this.offset + this.length;
	    };
	    Path.prototype.popFirst = function (size) {
	        size = size === undefined ? 1 : size;
	        assert_1.assert(this.length >= size, "Can't call popFirst() with less segments");
	        return this.construct(this.segments, this.offset + size, this.length - size);
	    };
	    Path.prototype.popLast = function () {
	        assert_1.assert(!this.isEmpty(), "Can't call popLast() on empty path");
	        return this.construct(this.segments, this.offset, this.length - 1);
	    };
	    Path.prototype.firstSegment = function () {
	        assert_1.assert(!this.isEmpty(), "Can't call firstSegment() on empty path");
	        return this.segments[this.offset];
	    };
	    Path.prototype.lastSegment = function () {
	        assert_1.assert(!this.isEmpty(), "Can't call lastSegment() on empty path");
	        return this.segments[this.limit() - 1];
	    };
	    Path.prototype.get = function (index) {
	        assert_1.assert(index < this.length, 'Index out of range');
	        return this.segments[this.offset + index];
	    };
	    Path.prototype.isEmpty = function () {
	        return this.length === 0;
	    };
	    Path.prototype.isPrefixOf = function (other) {
	        if (other.length < this.length) {
	            return false;
	        }
	        for (var i = 0; i < this.length; i++) {
	            if (this.get(i) !== other.get(i)) {
	                return false;
	            }
	        }
	        return true;
	    };
	    Path.prototype.forEach = function (fn) {
	        for (var i = this.offset, end = this.limit(); i < end; i++) {
	            fn(this.segments[i]);
	        }
	    };
	    Path.prototype.toArray = function () {
	        return this.segments.slice(this.offset, this.limit());
	    };
	    Path.comparator = function (p1, p2) {
	        var len = Math.min(p1.length, p2.length);
	        for (var i = 0; i < len; i++) {
	            var left = p1.get(i);
	            var right = p2.get(i);
	            if (left < right)
	                return -1;
	            if (left > right)
	                return 1;
	        }
	        if (p1.length < p2.length)
	            return -1;
	        if (p1.length > p2.length)
	            return 1;
	        return 0;
	    };
	    return Path;
	}());
	exports.Path = Path;
	/**
	 * A slash-separated path for navigating resources (documents and collections)
	 * within Firestore.
	 */
	var ResourcePath = /** @class */ (function (_super) {
	    __extends(ResourcePath, _super);
	    function ResourcePath() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    ResourcePath.prototype.canonicalString = function () {
	        // NOTE: The client is ignorant of any path segments containing escape
	        // sequences (e.g. __id123__) and just passes them through raw (they exist
	        // for legacy reasons and should not be used frequently).
	        return this.toArray().join('/');
	    };
	    ResourcePath.prototype.toString = function () {
	        return this.canonicalString();
	    };
	    /**
	     * Creates a resource path from the given slash-delimited string.
	     */
	    ResourcePath.fromString = function (path) {
	        // NOTE: The client is ignorant of any path segments containing escape
	        // sequences (e.g. __id123__) and just passes them through raw (they exist
	        // for legacy reasons and should not be used frequently).
	        if (path.indexOf('//') >= 0) {
	            throw new error_1.FirestoreError(error_1.Code.INVALID_ARGUMENT, "Invalid path (" + path + "). Paths must not contain // in them.");
	        }
	        // We may still have an empty segment at the beginning or end if they had a
	        // leading or trailing slash (which we allow).
	        var segments = path.split('/').filter(function (segment) { return segment.length > 0; });
	        return new ResourcePath(segments);
	    };
	    ResourcePath.EMPTY_PATH = new ResourcePath([]);
	    return ResourcePath;
	}(Path));
	exports.ResourcePath = ResourcePath;
	var identifierRegExp = /^[_a-zA-Z][_a-zA-Z0-9]*$/;
	/** A dot-separated path for navigating sub-objects within a document. */
	var FieldPath = /** @class */ (function (_super) {
	    __extends(FieldPath, _super);
	    function FieldPath() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    /**
	     * Returns true if the string could be used as a segment in a field path
	     * without escaping.
	     */
	    FieldPath.isValidIdentifier = function (segment) {
	        return identifierRegExp.test(segment);
	    };
	    FieldPath.prototype.canonicalString = function () {
	        return this.toArray()
	            .map(function (str) {
	            str = str.replace('\\', '\\\\').replace('`', '\\`');
	            if (!FieldPath.isValidIdentifier(str)) {
	                str = '`' + str + '`';
	            }
	            return str;
	        })
	            .join('.');
	    };
	    FieldPath.prototype.toString = function () {
	        return this.canonicalString();
	    };
	    /**
	     * Returns true if this field references the key of a document.
	     */
	    FieldPath.prototype.isKeyField = function () {
	        return this.length === 1 && this.get(0) === exports.DOCUMENT_KEY_NAME;
	    };
	    /**
	     * The field designating the key of a document.
	     */
	    FieldPath.keyField = function () {
	        return new FieldPath([exports.DOCUMENT_KEY_NAME]);
	    };
	    /**
	     * Parses a field string from the given server-formatted string.
	     *
	     * - Splitting the empty string is not allowed (for now at least).
	     * - Empty segments within the string (e.g. if there are two consecutive
	     *   separators) are not allowed.
	     *
	     * TODO(b/37244157): we should make this more strict. Right now, it allows
	     * non-identifier path components, even if they aren't escaped.
	     */
	    FieldPath.fromServerFormat = function (path) {
	        var segments = [];
	        var current = '';
	        var i = 0;
	        var addCurrentSegment = function () {
	            if (current.length === 0) {
	                throw new error_1.FirestoreError(error_1.Code.INVALID_ARGUMENT, "Invalid field path (" + path + "). Paths must not be empty, begin " +
	                    "with '.', end with '.', or contain '..'");
	            }
	            segments.push(current);
	            current = '';
	        };
	        var inBackticks = false;
	        while (i < path.length) {
	            var c = path[i];
	            if (c === '\\') {
	                if (i + 1 === path.length) {
	                    throw new error_1.FirestoreError(error_1.Code.INVALID_ARGUMENT, 'Path has trailing escape character: ' + path);
	                }
	                var next = path[i + 1];
	                if (!(next === '\\' || next === '.' || next === '`')) {
	                    throw new error_1.FirestoreError(error_1.Code.INVALID_ARGUMENT, 'Path has invalid escape sequence: ' + path);
	                }
	                current += next;
	                i += 2;
	            }
	            else if (c === '`') {
	                inBackticks = !inBackticks;
	                i++;
	            }
	            else if (c === '.' && !inBackticks) {
	                addCurrentSegment();
	                i++;
	            }
	            else {
	                current += c;
	                i++;
	            }
	        }
	        addCurrentSegment();
	        if (inBackticks) {
	            throw new error_1.FirestoreError(error_1.Code.INVALID_ARGUMENT, 'Unterminated ` in path: ' + path);
	        }
	        return new FieldPath(segments);
	    };
	    FieldPath.EMPTY_PATH = new FieldPath([]);
	    return FieldPath;
	}(Path));
	exports.FieldPath = FieldPath;
	
	//# sourceMappingURL=path.js.map


/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var assert_1 = __webpack_require__(2);
	// An immutable sorted map implementation, based on a Left-leaning Red-Black
	// tree.
	var SortedMap = /** @class */ (function () {
	    function SortedMap(comparator, root) {
	        this.comparator = comparator;
	        this.root = root ? root : LLRBNode.EMPTY;
	    }
	    // Returns a copy of the map, with the specified key/value added or replaced.
	    SortedMap.prototype.insert = function (key, value) {
	        return new SortedMap(this.comparator, this.root
	            .insert(key, value, this.comparator)
	            .copy(null, null, LLRBNode.BLACK, null, null));
	    };
	    // Returns a copy of the map, with the specified key removed.
	    SortedMap.prototype.remove = function (key) {
	        return new SortedMap(this.comparator, this.root
	            .remove(key, this.comparator)
	            .copy(null, null, LLRBNode.BLACK, null, null));
	    };
	    // Returns the value of the node with the given key, or null.
	    SortedMap.prototype.get = function (key) {
	        var node = this.root;
	        while (!node.isEmpty()) {
	            var cmp = this.comparator(key, node.key);
	            if (cmp === 0) {
	                return node.value;
	            }
	            else if (cmp < 0) {
	                node = node.left;
	            }
	            else if (cmp > 0) {
	                node = node.right;
	            }
	        }
	        return null;
	    };
	    // Returns the index of the element in this sorted map, or -1 if it doesn't
	    // exist.
	    SortedMap.prototype.indexOf = function (key) {
	        // Number of nodes that were pruned when descending right
	        var prunedNodes = 0;
	        var node = this.root;
	        while (!node.isEmpty()) {
	            var cmp = this.comparator(key, node.key);
	            if (cmp === 0) {
	                return prunedNodes + node.left.size;
	            }
	            else if (cmp < 0) {
	                node = node.left;
	            }
	            else {
	                // Count all nodes left of the node plus the node itself
	                prunedNodes += node.left.size + 1;
	                node = node.right;
	            }
	        }
	        // Node not found
	        return -1;
	    };
	    SortedMap.prototype.isEmpty = function () {
	        return this.root.isEmpty();
	    };
	    Object.defineProperty(SortedMap.prototype, "size", {
	        // Returns the total number of nodes in the map.
	        get: function () {
	            return this.root.size;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    // Returns the minimum key in the map.
	    SortedMap.prototype.minKey = function () {
	        return this.root.minKey();
	    };
	    // Returns the maximum key in the map.
	    SortedMap.prototype.maxKey = function () {
	        return this.root.maxKey();
	    };
	    // Traverses the map in key order and calls the specified action function
	    // for each key/value pair. If action returns true, traversal is aborted.
	    // Returns the first truthy value returned by action, or the last falsey
	    // value returned by action.
	    SortedMap.prototype.inorderTraversal = function (action) {
	        return this.root.inorderTraversal(action);
	    };
	    SortedMap.prototype.forEach = function (fn) {
	        this.inorderTraversal(function (k, v) {
	            fn(k, v);
	            return false;
	        });
	    };
	    // Traverses the map in reverse key order and calls the specified action
	    // function for each key/value pair. If action returns true, traversal is
	    // aborted.
	    // Returns the first truthy value returned by action, or the last falsey
	    // value returned by action.
	    SortedMap.prototype.reverseTraversal = function (action) {
	        return this.root.reverseTraversal(action);
	    };
	    // Returns an iterator over the SortedMap.
	    SortedMap.prototype.getIterator = function () {
	        return new SortedMapIterator(this.root, null, this.comparator, false);
	    };
	    SortedMap.prototype.getIteratorFrom = function (key) {
	        return new SortedMapIterator(this.root, key, this.comparator, false);
	    };
	    SortedMap.prototype.getReverseIterator = function () {
	        return new SortedMapIterator(this.root, null, this.comparator, true);
	    };
	    SortedMap.prototype.getReverseIteratorFrom = function (key) {
	        return new SortedMapIterator(this.root, key, this.comparator, true);
	    };
	    return SortedMap;
	}()); // end SortedMap
	exports.SortedMap = SortedMap;
	// An iterator over an LLRBNode.
	var SortedMapIterator = /** @class */ (function () {
	    function SortedMapIterator(node, startKey, comparator, isReverse) {
	        this.isReverse = isReverse;
	        this.nodeStack = [];
	        var cmp = 1;
	        while (!node.isEmpty()) {
	            cmp = startKey ? comparator(node.key, startKey) : 1;
	            // flip the comparison if we're going in reverse
	            if (isReverse)
	                cmp *= -1;
	            if (cmp < 0) {
	                // This node is less than our start key. ignore it
	                if (this.isReverse) {
	                    node = node.left;
	                }
	                else {
	                    node = node.right;
	                }
	            }
	            else if (cmp === 0) {
	                // This node is exactly equal to our start key. Push it on the stack,
	                // but stop iterating;
	                this.nodeStack.push(node);
	                break;
	            }
	            else {
	                // This node is greater than our start key, add it to the stack and move
	                // to the next one
	                this.nodeStack.push(node);
	                if (this.isReverse) {
	                    node = node.right;
	                }
	                else {
	                    node = node.left;
	                }
	            }
	        }
	    }
	    SortedMapIterator.prototype.getNext = function () {
	        assert_1.assert(this.nodeStack.length > 0, 'getNext() called on iterator when hasNext() is false.');
	        var node = this.nodeStack.pop();
	        var result = { key: node.key, value: node.value };
	        if (this.isReverse) {
	            node = node.left;
	            while (!node.isEmpty()) {
	                this.nodeStack.push(node);
	                node = node.right;
	            }
	        }
	        else {
	            node = node.right;
	            while (!node.isEmpty()) {
	                this.nodeStack.push(node);
	                node = node.left;
	            }
	        }
	        return result;
	    };
	    SortedMapIterator.prototype.hasNext = function () {
	        return this.nodeStack.length > 0;
	    };
	    SortedMapIterator.prototype.peek = function () {
	        if (this.nodeStack.length === 0)
	            return null;
	        var node = this.nodeStack[this.nodeStack.length - 1];
	        return { key: node.key, value: node.value };
	    };
	    return SortedMapIterator;
	}()); // end SortedMapIterator
	exports.SortedMapIterator = SortedMapIterator;
	// Represents a node in a Left-leaning Red-Black tree.
	var LLRBNode = /** @class */ (function () {
	    function LLRBNode(key, value, color, left, right) {
	        this.key = key;
	        this.value = value;
	        this.color = color != null ? color : LLRBNode.RED;
	        this.left = left != null ? left : LLRBNode.EMPTY;
	        this.right = right != null ? right : LLRBNode.EMPTY;
	        this.size = this.left.size + 1 + this.right.size;
	    }
	    // Returns a copy of the current node, optionally replacing pieces of it.
	    LLRBNode.prototype.copy = function (key, value, color, left, right) {
	        return new LLRBNode(key != null ? key : this.key, value != null ? value : this.value, color != null ? color : this.color, left != null ? left : this.left, right != null ? right : this.right);
	    };
	    LLRBNode.prototype.isEmpty = function () {
	        return false;
	    };
	    // Traverses the tree in key order and calls the specified action function
	    // for each node. If action returns true, traversal is aborted.
	    // Returns the first truthy value returned by action, or the last falsey
	    // value returned by action.
	    LLRBNode.prototype.inorderTraversal = function (action) {
	        return (this.left.inorderTraversal(action) ||
	            action(this.key, this.value) ||
	            this.right.inorderTraversal(action));
	    };
	    // Traverses the tree in reverse key order and calls the specified action
	    // function for each node. If action returns true, traversal is aborted.
	    // Returns the first truthy value returned by action, or the last falsey
	    // value returned by action.
	    LLRBNode.prototype.reverseTraversal = function (action) {
	        return (this.right.reverseTraversal(action) ||
	            action(this.key, this.value) ||
	            this.left.reverseTraversal(action));
	    };
	    // Returns the minimum node in the tree.
	    LLRBNode.prototype.min = function () {
	        if (this.left.isEmpty()) {
	            return this;
	        }
	        else {
	            return this.left.min();
	        }
	    };
	    // Returns the maximum key in the tree.
	    LLRBNode.prototype.minKey = function () {
	        return this.min().key;
	    };
	    // Returns the maximum key in the tree.
	    LLRBNode.prototype.maxKey = function () {
	        if (this.right.isEmpty()) {
	            return this.key;
	        }
	        else {
	            return this.right.maxKey();
	        }
	    };
	    // Returns new tree, with the key/value added.
	    LLRBNode.prototype.insert = function (key, value, comparator) {
	        var n = this;
	        var cmp = comparator(key, n.key);
	        if (cmp < 0) {
	            n = n.copy(null, null, null, n.left.insert(key, value, comparator), null);
	        }
	        else if (cmp === 0) {
	            n = n.copy(null, value, null, null, null);
	        }
	        else {
	            n = n.copy(null, null, null, null, n.right.insert(key, value, comparator));
	        }
	        return n.fixUp();
	    };
	    LLRBNode.prototype.removeMin = function () {
	        if (this.left.isEmpty()) {
	            return LLRBNode.EMPTY;
	        }
	        var n = this;
	        if (!n.left.isRed() && !n.left.left.isRed())
	            n = n.moveRedLeft();
	        n = n.copy(null, null, null, n.left.removeMin(), null);
	        return n.fixUp();
	    };
	    // Returns new tree, with the specified item removed.
	    LLRBNode.prototype.remove = function (key, comparator) {
	        var smallest;
	        var n = this;
	        if (comparator(key, n.key) < 0) {
	            if (!n.left.isEmpty() && !n.left.isRed() && !n.left.left.isRed()) {
	                n = n.moveRedLeft();
	            }
	            n = n.copy(null, null, null, n.left.remove(key, comparator), null);
	        }
	        else {
	            if (n.left.isRed())
	                n = n.rotateRight();
	            if (!n.right.isEmpty() && !n.right.isRed() && !n.right.left.isRed()) {
	                n = n.moveRedRight();
	            }
	            if (comparator(key, n.key) === 0) {
	                if (n.right.isEmpty()) {
	                    return LLRBNode.EMPTY;
	                }
	                else {
	                    smallest = n.right.min();
	                    n = n.copy(smallest.key, smallest.value, null, null, n.right.removeMin());
	                }
	            }
	            n = n.copy(null, null, null, null, n.right.remove(key, comparator));
	        }
	        return n.fixUp();
	    };
	    LLRBNode.prototype.isRed = function () {
	        return this.color;
	    };
	    // Returns new tree after performing any needed rotations.
	    LLRBNode.prototype.fixUp = function () {
	        var n = this;
	        if (n.right.isRed() && !n.left.isRed())
	            n = n.rotateLeft();
	        if (n.left.isRed() && n.left.left.isRed())
	            n = n.rotateRight();
	        if (n.left.isRed() && n.right.isRed())
	            n = n.colorFlip();
	        return n;
	    };
	    LLRBNode.prototype.moveRedLeft = function () {
	        var n = this.colorFlip();
	        if (n.right.left.isRed()) {
	            n = n.copy(null, null, null, null, n.right.rotateRight());
	            n = n.rotateLeft();
	            n = n.colorFlip();
	        }
	        return n;
	    };
	    LLRBNode.prototype.moveRedRight = function () {
	        var n = this.colorFlip();
	        if (n.left.left.isRed()) {
	            n = n.rotateRight();
	            n = n.colorFlip();
	        }
	        return n;
	    };
	    LLRBNode.prototype.rotateLeft = function () {
	        var nl = this.copy(null, null, LLRBNode.RED, null, this.right.left);
	        return this.right.copy(null, null, this.color, nl, null);
	    };
	    LLRBNode.prototype.rotateRight = function () {
	        var nr = this.copy(null, null, LLRBNode.RED, this.left.right, null);
	        return this.left.copy(null, null, this.color, null, nr);
	    };
	    LLRBNode.prototype.colorFlip = function () {
	        var left = this.left.copy(null, null, !this.left.color, null, null);
	        var right = this.right.copy(null, null, !this.right.color, null, null);
	        return this.copy(null, null, !this.color, left, right);
	    };
	    // For testing.
	    LLRBNode.prototype.checkMaxDepth = function () {
	        var blackDepth = this.check();
	        if (Math.pow(2.0, blackDepth) <= this.size + 1) {
	            return true;
	        }
	        else {
	            return false;
	        }
	    };
	    // In a balanced RB tree, the black-depth (number of black nodes) from root to
	    // leaves is equal on both sides.  This function verifies that or asserts.
	    LLRBNode.prototype.check = function () {
	        if (this.isRed() && this.left.isRed()) {
	            throw assert_1.fail('Red node has red child(' + this.key + ',' + this.value + ')');
	        }
	        if (this.right.isRed()) {
	            throw assert_1.fail('Right child of (' + this.key + ',' + this.value + ') is red');
	        }
	        var blackDepth = this.left.check();
	        if (blackDepth !== this.right.check()) {
	            throw assert_1.fail('Black depths differ');
	        }
	        else {
	            return blackDepth + (this.isRed() ? 0 : 1);
	        }
	    };
	    // tslint:disable-next-line:no-any Empty node is shared between all LLRB trees.
	    LLRBNode.EMPTY = null;
	    LLRBNode.RED = true;
	    LLRBNode.BLACK = false;
	    return LLRBNode;
	}()); // end LLRBNode
	exports.LLRBNode = LLRBNode;
	// Represents an empty node (a leaf node in the Red-Black Tree).
	var LLRBEmptyNode = /** @class */ (function () {
	    function LLRBEmptyNode() {
	        this.size = 0;
	    }
	    // Returns a copy of the current node.
	    LLRBEmptyNode.prototype.copy = function (key, value, color, left, right) {
	        return this;
	    };
	    // Returns a copy of the tree, with the specified key/value added.
	    LLRBEmptyNode.prototype.insert = function (key, value, comparator) {
	        return new LLRBNode(key, value);
	    };
	    // Returns a copy of the tree, with the specified key removed.
	    LLRBEmptyNode.prototype.remove = function (key, comparator) {
	        return this;
	    };
	    LLRBEmptyNode.prototype.isEmpty = function () {
	        return true;
	    };
	    LLRBEmptyNode.prototype.inorderTraversal = function (action) {
	        return false;
	    };
	    LLRBEmptyNode.prototype.reverseTraversal = function (action) {
	        return false;
	    };
	    LLRBEmptyNode.prototype.minKey = function () {
	        return null;
	    };
	    LLRBEmptyNode.prototype.maxKey = function () {
	        return null;
	    };
	    LLRBEmptyNode.prototype.isRed = function () {
	        return false;
	    };
	    // For testing.
	    LLRBEmptyNode.prototype.checkMaxDepth = function () {
	        return true;
	    };
	    LLRBEmptyNode.prototype.check = function () {
	        return 0;
	    };
	    return LLRBEmptyNode;
	}()); // end LLRBEmptyNode
	exports.LLRBEmptyNode = LLRBEmptyNode;
	LLRBNode.EMPTY = new LLRBEmptyNode();
	
	//# sourceMappingURL=sorted_map.js.map


/***/ }),
/* 37 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * @fileoverview Implements the promise abstraction interface for external
	 * (public SDK) packaging, which just passes through to the firebase-app impl.
	 */
	/**
	 * @template T
	 * @param {function((function(T): void),
	 *                  (function(!Error): void))} resolver
	 */
	function make(resolver) {
	    return new Promise(resolver);
	}
	exports.make = make;
	/**
	 * @template T
	 */
	function resolve(value) {
	    return Promise.resolve(value);
	}
	exports.resolve = resolve;
	function reject(error) {
	    return Promise.reject(error);
	}
	exports.reject = reject;
	
	//# sourceMappingURL=promise_external.js.map


/***/ }),
/* 38 */
[500, 6],
/* 39 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * @constructor
	 * @struct
	 * @param {!string} type The event type
	 * @param {!Node} snapshotNode The data
	 * @param {string=} childName The name for this child, if it's a child event
	 * @param {Node=} oldSnap Used for intermediate processing of child changed events
	 * @param {string=} prevName The name for the previous child, if applicable
	 */
	var Change = /** @class */ (function () {
	    function Change(type, snapshotNode, childName, oldSnap, prevName) {
	        this.type = type;
	        this.snapshotNode = snapshotNode;
	        this.childName = childName;
	        this.oldSnap = oldSnap;
	        this.prevName = prevName;
	    }
	    /**
	     * @param {!Node} snapshot
	     * @return {!Change}
	     */
	    Change.valueChange = function (snapshot) {
	        return new Change(Change.VALUE, snapshot);
	    };
	    /**
	     * @param {string} childKey
	     * @param {!Node} snapshot
	     * @return {!Change}
	     */
	    Change.childAddedChange = function (childKey, snapshot) {
	        return new Change(Change.CHILD_ADDED, snapshot, childKey);
	    };
	    /**
	     * @param {string} childKey
	     * @param {!Node} snapshot
	     * @return {!Change}
	     */
	    Change.childRemovedChange = function (childKey, snapshot) {
	        return new Change(Change.CHILD_REMOVED, snapshot, childKey);
	    };
	    /**
	     * @param {string} childKey
	     * @param {!Node} newSnapshot
	     * @param {!Node} oldSnapshot
	     * @return {!Change}
	     */
	    Change.childChangedChange = function (childKey, newSnapshot, oldSnapshot) {
	        return new Change(Change.CHILD_CHANGED, newSnapshot, childKey, oldSnapshot);
	    };
	    /**
	     * @param {string} childKey
	     * @param {!Node} snapshot
	     * @return {!Change}
	     */
	    Change.childMovedChange = function (childKey, snapshot) {
	        return new Change(Change.CHILD_MOVED, snapshot, childKey);
	    };
	    //event types
	    /** Event type for a child added */
	    Change.CHILD_ADDED = 'child_added';
	    /** Event type for a child removed */
	    Change.CHILD_REMOVED = 'child_removed';
	    /** Event type for a child changed */
	    Change.CHILD_CHANGED = 'child_changed';
	    /** Event type for a child moved */
	    Change.CHILD_MOVED = 'child_moved';
	    /** Event type for a value change */
	    Change.VALUE = 'value';
	    return Change;
	}());
	exports.Change = Change;
	
	//# sourceMappingURL=Change.js.map


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var assert_1 = __webpack_require__(2);
	var misc_1 = __webpack_require__(14);
	// A RegExp matching ISO 8601 UTC timestamps with optional fraction.
	var isoRegExp = new RegExp(/^\d{4}-\d\d-\d\dT\d\d:\d\d:\d\d(?:\.(\d+))?Z$/);
	var Timestamp = /** @class */ (function () {
	    function Timestamp(seconds, nanos) {
	        this.seconds = seconds;
	        this.nanos = nanos;
	        assert_1.assert(nanos >= 0, 'timestamp nanoseconds out of range: ' + nanos);
	        assert_1.assert(nanos < 1e9, 'timestamp nanoseconds out of range' + nanos);
	        // Midnight at the beginning of 1/1/1 is the earliest Firestore supports.
	        assert_1.assert(seconds >= -62135596800, 'timestamp seconds out of range: ' + seconds);
	        // This will break in the year 10,000.
	        assert_1.assert(seconds < 253402300800, 'timestamp seconds out of range' + seconds);
	    }
	    Timestamp.now = function () {
	        return Timestamp.fromEpochMilliseconds(Date.now());
	    };
	    Timestamp.fromDate = function (date) {
	        return Timestamp.fromEpochMilliseconds(date.getTime());
	    };
	    Timestamp.fromEpochMilliseconds = function (milliseconds) {
	        var seconds = Math.floor(milliseconds / 1000);
	        var nanos = (milliseconds - seconds * 1000) * 1e6;
	        return new Timestamp(seconds, nanos);
	    };
	    Timestamp.fromISOString = function (utc) {
	        // The date string can have higher precision (nanos) than the Date class
	        // (millis), so we do some custom parsing here.
	        // Parse the nanos right out of the string.
	        var nanos = 0;
	        var fraction = isoRegExp.exec(utc);
	        assert_1.assert(!!fraction, 'invalid timestamp: ' + utc);
	        if (fraction[1]) {
	            // Pad the fraction out to 9 digits (nanos).
	            var nanoStr = fraction[1];
	            nanoStr = (nanoStr + '000000000').substr(0, 9);
	            nanos = Number(nanoStr);
	        }
	        // Parse the date to get the seconds.
	        var date = new Date(utc);
	        var seconds = Math.floor(date.getTime() / 1000);
	        return new Timestamp(seconds, nanos);
	    };
	    Timestamp.prototype.toDate = function () {
	        return new Date(this.toEpochMilliseconds());
	    };
	    Timestamp.prototype.toEpochMilliseconds = function () {
	        return this.seconds * 1000 + this.nanos / 1e6;
	    };
	    Timestamp.prototype.compareTo = function (other) {
	        if (this.seconds === other.seconds) {
	            return misc_1.primitiveComparator(this.nanos, other.nanos);
	        }
	        return misc_1.primitiveComparator(this.seconds, other.seconds);
	    };
	    Timestamp.prototype.isEqual = function (other) {
	        return other.seconds === this.seconds && other.nanos === this.nanos;
	    };
	    Timestamp.prototype.toString = function () {
	        return 'Timestamp(seconds=' + this.seconds + ', nanos=' + this.nanos + ')';
	    };
	    return Timestamp;
	}());
	exports.Timestamp = Timestamp;
	
	//# sourceMappingURL=timestamp.js.map


/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var assert_1 = __webpack_require__(2);
	var encoded_resource_path_1 = __webpack_require__(101);
	exports.SCHEMA_VERSION = 1;
	/** Performs database creation and (in the future) upgrades between versions. */
	function createOrUpgradeDb(db, oldVersion) {
	    assert_1.assert(oldVersion === 0, 'Unexpected upgrade from version ' + oldVersion);
	    db.createObjectStore(DbMutationQueue.store, {
	        keyPath: DbMutationQueue.keyPath
	    });
	    // TODO(mikelehen): Get rid of "as any" if/when TypeScript fixes their
	    // types. https://github.com/Microsoft/TypeScript/issues/14322
	    db.createObjectStore(DbMutationBatch.store, 
	    // tslint:disable-next-line:no-any
	    { keyPath: DbMutationBatch.keyPath });
	    var targetDocumentsStore = db.createObjectStore(DbTargetDocument.store, 
	    // tslint:disable-next-line:no-any
	    { keyPath: DbTargetDocument.keyPath });
	    targetDocumentsStore.createIndex(DbTargetDocument.documentTargetsIndex, DbTargetDocument.documentTargetsKeyPath, { unique: true });
	    var targetStore = db.createObjectStore(DbTarget.store, {
	        keyPath: DbTarget.keyPath
	    });
	    // NOTE: This is unique only because the TargetId is the suffix.
	    targetStore.createIndex(DbTarget.queryTargetsIndexName, DbTarget.queryTargetsKeyPath, { unique: true });
	    // NOTE: keys for these stores are specified explicitly rather than using a
	    // keyPath.
	    db.createObjectStore(DbDocumentMutation.store);
	    db.createObjectStore(DbRemoteDocument.store);
	    db.createObjectStore(DbOwner.store);
	    db.createObjectStore(DbTargetGlobal.store);
	}
	exports.createOrUpgradeDb = createOrUpgradeDb;
	/**
	 * Wrapper class to store timestamps (seconds and nanos) in IndexedDb objects.
	 */
	var DbTimestamp = /** @class */ (function () {
	    function DbTimestamp(seconds, nanos) {
	        this.seconds = seconds;
	        this.nanos = nanos;
	    }
	    return DbTimestamp;
	}());
	exports.DbTimestamp = DbTimestamp;
	/**
	 * A singleton object to be stored in the 'owner' store in IndexedDb.
	 *
	 * A given database can be owned by a single tab at a given time. That tab
	 * must validate that it is still the owner before every write operation and
	 * should regularly write an updated timestamp to prevent other tabs from
	 * "stealing" ownership of the db.
	 */
	var DbOwner = /** @class */ (function () {
	    function DbOwner(ownerId, leaseTimestampMs) {
	        this.ownerId = ownerId;
	        this.leaseTimestampMs = leaseTimestampMs;
	    }
	    /** Name of the IndexedDb object store. */
	    DbOwner.store = 'owner';
	    return DbOwner;
	}());
	exports.DbOwner = DbOwner;
	/**
	 * An object to be stored in the 'mutationQueues' store in IndexedDb.
	 *
	 * Each user gets a single queue of MutationBatches to apply to the server.
	 * DbMutationQueue tracks the metadata about the queue.
	 */
	var DbMutationQueue = /** @class */ (function () {
	    function DbMutationQueue(
	        /**
	         * The normalized user ID to which this queue belongs.
	         */
	        userId, 
	        /**
	         * An identifier for the highest numbered batch that has been acknowledged
	         * by the server. All MutationBatches in this queue with batchIds less
	         * than or equal to this value are considered to have been acknowledged by
	         * the server.
	         */
	        lastAcknowledgedBatchId, 
	        /**
	         * A stream token that was previously sent by the server.
	         *
	         * See StreamingWriteRequest in datastore.proto for more details about
	         * usage.
	         *
	         * After sending this token, earlier tokens may not be used anymore so
	         * only a single stream token is retained.
	         */
	        lastStreamToken) {
	        this.userId = userId;
	        this.lastAcknowledgedBatchId = lastAcknowledgedBatchId;
	        this.lastStreamToken = lastStreamToken;
	    }
	    /** Name of the IndexedDb object store.  */
	    DbMutationQueue.store = 'mutationQueues';
	    /** Keys are automatically assigned via the userId property. */
	    DbMutationQueue.keyPath = 'userId';
	    return DbMutationQueue;
	}());
	exports.DbMutationQueue = DbMutationQueue;
	/**
	 * An object to be stored in the 'mutations' store in IndexedDb.
	 *
	 * Represents a batch of user-level mutations intended to be sent to the server
	 * in a single write. Each user-level batch gets a separate DbMutationBatch
	 * with a new batchId.
	 */
	var DbMutationBatch = /** @class */ (function () {
	    function DbMutationBatch(
	        /**
	         * The normalized user ID to which this batch belongs.
	         */
	        userId, 
	        /**
	         * An identifier for this batch, allocated by the mutation queue in a
	         * monotonically increasing manner.
	         */
	        batchId, 
	        /**
	         * The local write time of the batch, stored as milliseconds since the
	         * epoch.
	         */
	        localWriteTimeMs, 
	        /**
	         * A list of mutations to apply. All mutations will be applied atomically.
	         *
	         * Mutations are serialized via JsonProtoSerializer.toMutation().
	         */
	        mutations) {
	        this.userId = userId;
	        this.batchId = batchId;
	        this.localWriteTimeMs = localWriteTimeMs;
	        this.mutations = mutations;
	    }
	    /** Name of the IndexedDb object store.  */
	    DbMutationBatch.store = 'mutations';
	    /** Keys are automatically assigned via the userId, batchId properties. */
	    DbMutationBatch.keyPath = ['userId', 'batchId'];
	    return DbMutationBatch;
	}());
	exports.DbMutationBatch = DbMutationBatch;
	/**
	 * An object to be stored in the 'documentMutations' store in IndexedDb.
	 *
	 * A manually maintained index of all the mutation batches that affect a given
	 * document key. The rows in this table are references based on the contents of
	 * DbMutationBatch.mutations.
	 */
	var DbDocumentMutation = /** @class */ (function () {
	    function DbDocumentMutation() {
	    }
	    /**
	     * Creates a [userId] key for use in the DbDocumentMutations index to iterate
	     * over all of a user's document mutations.
	     */
	    DbDocumentMutation.prefixForUser = function (userId) {
	        return [userId];
	    };
	    /**
	     * Creates a [userId, encodedPath] key for use in the DbDocumentMutations
	     * index to iterate over all at document mutations for a given path or lower.
	     */
	    DbDocumentMutation.prefixForPath = function (userId, path) {
	        return [userId, encoded_resource_path_1.encode(path)];
	    };
	    /**
	     * Creates a full index key of [userId, encodedPath, batchId] for inserting
	     * and deleting into the DbDocumentMutations index.
	     */
	    DbDocumentMutation.key = function (userId, path, batchId) {
	        return [userId, encoded_resource_path_1.encode(path), batchId];
	    };
	    DbDocumentMutation.store = 'documentMutations';
	    /**
	     * Because we store all the useful information for this store in the key,
	     * there is no useful information to store as the value. The raw (unencoded)
	     * path cannot be stored because IndexedDb doesn't store prototype
	     * information.
	     */
	    DbDocumentMutation.PLACEHOLDER = new DbDocumentMutation();
	    return DbDocumentMutation;
	}());
	exports.DbDocumentMutation = DbDocumentMutation;
	/**
	 * Represents the known absence of a document at a particular version.
	 * Stored in IndexedDb as part of a DbRemoteDocument object.
	 */
	var DbNoDocument = /** @class */ (function () {
	    function DbNoDocument(path, readTime) {
	        this.path = path;
	        this.readTime = readTime;
	    }
	    return DbNoDocument;
	}());
	exports.DbNoDocument = DbNoDocument;
	/**
	 * An object to be stored in the 'remoteDocuments' store in IndexedDb. It
	 * represents either a cached document (if it exists) or a cached "no-document"
	 * (if it is known to not exist).
	 *
	 * Note: This is the persisted equivalent of a MaybeDocument and could perhaps
	 * be made more general if necessary.
	 */
	var DbRemoteDocument = /** @class */ (function () {
	    function DbRemoteDocument(
	        /**
	         * Set to an instance of a DbNoDocument if it is known that no document
	         * exists.
	         */
	        noDocument, 
	        /**
	         * Set to an instance of a Document if there's a cached version of the
	         * document.
	         */
	        document) {
	        this.noDocument = noDocument;
	        this.document = document;
	    }
	    DbRemoteDocument.store = 'remoteDocuments';
	    return DbRemoteDocument;
	}());
	exports.DbRemoteDocument = DbRemoteDocument;
	/**
	 * An object to be stored in the 'targets' store in IndexedDb.
	 *
	 * This is based on and should be kept in sync with the proto used in the iOS
	 * client.
	 *
	 * Each query the client listens to against the server is tracked on disk so
	 * that the query can be efficiently resumed on restart.
	 */
	var DbTarget = /** @class */ (function () {
	    function DbTarget(
	        /**
	         * An auto-generated sequential numeric identifier for the query.
	         *
	         * Queries are stored using their canonicalId as the key, but these
	         * canonicalIds can be quite long so we additionally assign a unique
	         * queryId which can be used by referenced data structures (e.g.
	         * indexes) to minimize the on-disk cost.
	         */
	        targetId, 
	        /**
	         * The canonical string representing this query. This is not unique.
	         */
	        canonicalId, 
	        /**
	         * The last readTime received from the Watch Service for this query.
	         *
	         * This is the same value as TargetChange.read_time in the protos.
	         */
	        readTime, 
	        /**
	         * An opaque, server-assigned token that allows watching a query to be
	         * resumed after disconnecting without retransmitting all the data
	         * that matches the query. The resume token essentially identifies a
	         * point in time from which the server should resume sending results.
	         *
	         * This is related to the snapshotVersion in that the resumeToken
	         * effectively also encodes that value, but the resumeToken is opaque
	         * and sometimes encodes additional information.
	         *
	         * A consequence of this is that the resumeToken should be used when
	         * asking the server to reason about where this client is in the watch
	         * stream, but the client should use the snapshotVersion for its own
	         * purposes.
	         *
	         * This is the same value as TargetChange.resume_token in the protos.
	         */
	        resumeToken, 
	        /**
	         * A sequence number representing the last time this query was
	         * listened to, used for garbage collection purposes.
	         *
	         * Conventionally this would be a timestamp value, but device-local
	         * clocks are unreliable and they must be able to create new listens
	         * even while disconnected. Instead this should be a monotonically
	         * increasing number that's incremented on each listen call.
	         *
	         * This is different from the queryId since the queryId is an
	         * immutable identifier assigned to the Query on first use while
	         * lastListenSequenceNumber is updated every time the query is
	         * listened to.
	         */
	        lastListenSequenceNumber, 
	        /**
	         * The query for this target.
	         *
	         * Because canonical ids are not unique we must store the actual query. We
	         * use the proto to have an object we can persist without having to
	         * duplicate translation logic to and from a `Query` object.
	         */
	        query) {
	        this.targetId = targetId;
	        this.canonicalId = canonicalId;
	        this.readTime = readTime;
	        this.resumeToken = resumeToken;
	        this.lastListenSequenceNumber = lastListenSequenceNumber;
	        this.query = query;
	    }
	    DbTarget.store = 'targets';
	    /** Keys are automatically assigned via the targetId property. */
	    DbTarget.keyPath = 'targetId';
	    /** The name of the queryTargets index. */
	    DbTarget.queryTargetsIndexName = 'queryTargetsIndex';
	    /**
	     * The index of all canonicalIds to the targets that they match. This is not
	     * a unique mapping because canonicalId does not promise a unique name for all
	     * possible queries, so we append the targetId to make the mapping unique.
	     */
	    DbTarget.queryTargetsKeyPath = ['canonicalId', 'targetId'];
	    return DbTarget;
	}());
	exports.DbTarget = DbTarget;
	/**
	 * An object representing an association between a target and a document.
	 * Stored in the targetDocument object store to store the documents tracked by a
	 * particular target.
	 */
	var DbTargetDocument = /** @class */ (function () {
	    function DbTargetDocument(
	        /**
	         * The targetId identifying a target.
	         */
	        targetId, 
	        /**
	         * The path to the document, as encoded in the key.
	         */
	        path) {
	        this.targetId = targetId;
	        this.path = path;
	    }
	    /** Name of the IndexedDb object store.  */
	    DbTargetDocument.store = 'targetDocuments';
	    /** Keys are automatically assigned via the targetId, path properties. */
	    DbTargetDocument.keyPath = ['targetId', 'path'];
	    /** The index name for the reverse index. */
	    DbTargetDocument.documentTargetsIndex = 'documentTargetsIndex';
	    /** We also need to create the reverse index for these properties. */
	    DbTargetDocument.documentTargetsKeyPath = ['path', 'targetId'];
	    return DbTargetDocument;
	}());
	exports.DbTargetDocument = DbTargetDocument;
	/**
	 * A record of global state tracked across all Targets, tracked separately
	 * to avoid the need for extra indexes.
	 *
	 * This should be kept in-sync with the proto used in the iOS client.
	 */
	var DbTargetGlobal = /** @class */ (function () {
	    function DbTargetGlobal(
	        /**
	         * The highest numbered target id across all targets.
	         *
	         * See DbTarget.targetId.
	         */
	        highestTargetId, 
	        /**
	         * The highest numbered lastListenSequenceNumber across all targets.
	         *
	         * See DbTarget.lastListenSequenceNumber.
	         */
	        highestListenSequenceNumber, 
	        /**
	         * A global snapshot version representing the last consistent snapshot we
	         * received from the backend. This is monotonically increasing and any
	         * snapshots received from the backend prior to this version (e.g. for
	         * targets resumed with a resumeToken) should be suppressed (buffered)
	         * until the backend has caught up to this snapshot version again. This
	         * prevents our cache from ever going backwards in time.
	         */
	        lastRemoteSnapshotVersion) {
	        this.highestTargetId = highestTargetId;
	        this.highestListenSequenceNumber = highestListenSequenceNumber;
	        this.lastRemoteSnapshotVersion = lastRemoteSnapshotVersion;
	    }
	    /**
	     * The key string used for the single object that exists in the
	     * DbTargetGlobal store.
	     */
	    DbTargetGlobal.key = 'targetGlobalKey';
	    DbTargetGlobal.store = 'targetGlobal';
	    return DbTargetGlobal;
	}());
	exports.DbTargetGlobal = DbTargetGlobal;
	/**
	 * The list of all IndexedDB stored used by the SDK. This is used when creating
	 * transactions so that access across all stores is done atomically.
	 */
	exports.ALL_STORES = [
	    DbMutationQueue.store,
	    DbMutationBatch.store,
	    DbDocumentMutation.store,
	    DbRemoteDocument.store,
	    DbTarget.store,
	    DbOwner.store,
	    DbTargetGlobal.store,
	    DbTargetDocument.store
	];
	
	//# sourceMappingURL=indexeddb_schema.js.map


/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var assert_1 = __webpack_require__(2);
	var misc_1 = __webpack_require__(14);
	var sorted_map_1 = __webpack_require__(36);
	var document_key_1 = __webpack_require__(12);
	var TypeOrder;
	(function (TypeOrder) {
	    // This order is defined by the backend.
	    TypeOrder[TypeOrder["NullValue"] = 0] = "NullValue";
	    TypeOrder[TypeOrder["BooleanValue"] = 1] = "BooleanValue";
	    TypeOrder[TypeOrder["NumberValue"] = 2] = "NumberValue";
	    TypeOrder[TypeOrder["TimestampValue"] = 3] = "TimestampValue";
	    TypeOrder[TypeOrder["StringValue"] = 4] = "StringValue";
	    TypeOrder[TypeOrder["BlobValue"] = 5] = "BlobValue";
	    TypeOrder[TypeOrder["RefValue"] = 6] = "RefValue";
	    TypeOrder[TypeOrder["GeoPointValue"] = 7] = "GeoPointValue";
	    TypeOrder[TypeOrder["ArrayValue"] = 8] = "ArrayValue";
	    TypeOrder[TypeOrder["ObjectValue"] = 9] = "ObjectValue";
	})(TypeOrder = exports.TypeOrder || (exports.TypeOrder = {}));
	/** Defines the return value for pending server timestamps. */
	var ServerTimestampBehavior;
	(function (ServerTimestampBehavior) {
	    ServerTimestampBehavior[ServerTimestampBehavior["Default"] = 0] = "Default";
	    ServerTimestampBehavior[ServerTimestampBehavior["Estimate"] = 1] = "Estimate";
	    ServerTimestampBehavior[ServerTimestampBehavior["Previous"] = 2] = "Previous";
	})(ServerTimestampBehavior = exports.ServerTimestampBehavior || (exports.ServerTimestampBehavior = {}));
	/** Holds properties that define field value deserialization options. */
	var FieldValueOptions = /** @class */ (function () {
	    function FieldValueOptions(serverTimestampBehavior) {
	        this.serverTimestampBehavior = serverTimestampBehavior;
	    }
	    FieldValueOptions.fromSnapshotOptions = function (options) {
	        switch (options.serverTimestamps) {
	            case 'estimate':
	                return new FieldValueOptions(ServerTimestampBehavior.Estimate);
	            case 'previous':
	                return new FieldValueOptions(ServerTimestampBehavior.Previous);
	            case 'none': // Fall-through intended.
	            case undefined:
	                return FieldValueOptions.defaultOptions;
	            default:
	                return assert_1.fail('fromSnapshotOptions() called with invalid options.');
	        }
	    };
	    FieldValueOptions.defaultOptions = new FieldValueOptions(ServerTimestampBehavior.Default);
	    return FieldValueOptions;
	}());
	exports.FieldValueOptions = FieldValueOptions;
	/**
	 * A field value represents a datatype as stored by Firestore.
	 */
	var FieldValue = /** @class */ (function () {
	    function FieldValue() {
	    }
	    FieldValue.prototype.toString = function () {
	        var val = this.value();
	        return val === null ? 'null' : val.toString();
	    };
	    FieldValue.prototype.defaultCompareTo = function (other) {
	        assert_1.assert(this.typeOrder !== other.typeOrder, 'Default compareTo should not be used for values of same type.');
	        var cmp = misc_1.primitiveComparator(this.typeOrder, other.typeOrder);
	        return cmp;
	    };
	    return FieldValue;
	}());
	exports.FieldValue = FieldValue;
	var NullValue = /** @class */ (function (_super) {
	    __extends(NullValue, _super);
	    function NullValue() {
	        var _this = _super.call(this) || this;
	        _this.typeOrder = TypeOrder.NullValue;
	        // internalValue is unused but we add it to work around
	        // https://github.com/Microsoft/TypeScript/issues/15585
	        _this.internalValue = null;
	        return _this;
	    }
	    NullValue.prototype.value = function (options) {
	        return null;
	    };
	    NullValue.prototype.isEqual = function (other) {
	        return other instanceof NullValue;
	    };
	    NullValue.prototype.compareTo = function (other) {
	        if (other instanceof NullValue) {
	            return 0;
	        }
	        return this.defaultCompareTo(other);
	    };
	    NullValue.INSTANCE = new NullValue();
	    return NullValue;
	}(FieldValue));
	exports.NullValue = NullValue;
	var BooleanValue = /** @class */ (function (_super) {
	    __extends(BooleanValue, _super);
	    function BooleanValue(internalValue) {
	        var _this = _super.call(this) || this;
	        _this.internalValue = internalValue;
	        _this.typeOrder = TypeOrder.BooleanValue;
	        return _this;
	    }
	    BooleanValue.prototype.value = function (options) {
	        return this.internalValue;
	    };
	    BooleanValue.prototype.isEqual = function (other) {
	        return (other instanceof BooleanValue &&
	            this.internalValue === other.internalValue);
	    };
	    BooleanValue.prototype.compareTo = function (other) {
	        if (other instanceof BooleanValue) {
	            return misc_1.primitiveComparator(this, other);
	        }
	        return this.defaultCompareTo(other);
	    };
	    BooleanValue.of = function (value) {
	        return value ? BooleanValue.TRUE : BooleanValue.FALSE;
	    };
	    BooleanValue.TRUE = new BooleanValue(true);
	    BooleanValue.FALSE = new BooleanValue(false);
	    return BooleanValue;
	}(FieldValue));
	exports.BooleanValue = BooleanValue;
	/** Base class for IntegerValue and DoubleValue. */
	var NumberValue = /** @class */ (function (_super) {
	    __extends(NumberValue, _super);
	    function NumberValue(internalValue) {
	        var _this = _super.call(this) || this;
	        _this.internalValue = internalValue;
	        _this.typeOrder = TypeOrder.NumberValue;
	        return _this;
	    }
	    NumberValue.prototype.value = function (options) {
	        return this.internalValue;
	    };
	    NumberValue.prototype.compareTo = function (other) {
	        if (other instanceof NumberValue) {
	            return numericComparator(this.internalValue, other.internalValue);
	        }
	        return this.defaultCompareTo(other);
	    };
	    return NumberValue;
	}(FieldValue));
	exports.NumberValue = NumberValue;
	/** Utility function to compare doubles (using Firestore semantics for NaN). */
	function numericComparator(left, right) {
	    if (left < right) {
	        return -1;
	    }
	    else if (left > right) {
	        return 1;
	    }
	    else if (left === right) {
	        return 0;
	    }
	    else {
	        // one or both are NaN.
	        if (isNaN(left)) {
	            return isNaN(right) ? 0 : -1;
	        }
	        else {
	            return 1;
	        }
	    }
	}
	/**
	 * Utility function to check numbers for equality using Firestore semantics
	 * (NaN === NaN, -0.0 !== 0.0).
	 */
	function numericEquals(left, right) {
	    // Implemented based on Object.is() polyfill from
	    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	    if (left === right) {
	        // +0 != -0
	        return left !== 0 || 1 / left === 1 / right;
	    }
	    else {
	        // NaN == NaN
	        return left !== left && right !== right;
	    }
	}
	var IntegerValue = /** @class */ (function (_super) {
	    __extends(IntegerValue, _super);
	    function IntegerValue(internalValue) {
	        return _super.call(this, internalValue) || this;
	    }
	    IntegerValue.prototype.isEqual = function (other) {
	        // NOTE: DoubleValue and IntegerValue instances may compareTo() the same,
	        // but that doesn't make them equal via isEqual().
	        if (other instanceof IntegerValue) {
	            return numericEquals(this.internalValue, other.internalValue);
	        }
	        else {
	            return false;
	        }
	    };
	    return IntegerValue;
	}(NumberValue));
	exports.IntegerValue = IntegerValue;
	var DoubleValue = /** @class */ (function (_super) {
	    __extends(DoubleValue, _super);
	    function DoubleValue(internalValue) {
	        var _this = _super.call(this, internalValue) || this;
	        _this.internalValue = internalValue;
	        return _this;
	    }
	    DoubleValue.prototype.isEqual = function (other) {
	        // NOTE: DoubleValue and IntegerValue instances may compareTo() the same,
	        // but that doesn't make them equal via isEqual().
	        if (other instanceof DoubleValue) {
	            return numericEquals(this.internalValue, other.internalValue);
	        }
	        else {
	            return false;
	        }
	    };
	    DoubleValue.NAN = new DoubleValue(NaN);
	    DoubleValue.POSITIVE_INFINITY = new DoubleValue(Infinity);
	    DoubleValue.NEGATIVE_INFINITY = new DoubleValue(-Infinity);
	    return DoubleValue;
	}(NumberValue));
	exports.DoubleValue = DoubleValue;
	// TODO(b/37267885): Add truncation support
	var StringValue = /** @class */ (function (_super) {
	    __extends(StringValue, _super);
	    function StringValue(internalValue) {
	        var _this = _super.call(this) || this;
	        _this.internalValue = internalValue;
	        _this.typeOrder = TypeOrder.StringValue;
	        return _this;
	    }
	    StringValue.prototype.value = function (options) {
	        return this.internalValue;
	    };
	    StringValue.prototype.isEqual = function (other) {
	        return (other instanceof StringValue && this.internalValue === other.internalValue);
	    };
	    StringValue.prototype.compareTo = function (other) {
	        if (other instanceof StringValue) {
	            return misc_1.primitiveComparator(this.internalValue, other.internalValue);
	        }
	        return this.defaultCompareTo(other);
	    };
	    return StringValue;
	}(FieldValue));
	exports.StringValue = StringValue;
	var TimestampValue = /** @class */ (function (_super) {
	    __extends(TimestampValue, _super);
	    function TimestampValue(internalValue) {
	        var _this = _super.call(this) || this;
	        _this.internalValue = internalValue;
	        _this.typeOrder = TypeOrder.TimestampValue;
	        return _this;
	    }
	    TimestampValue.prototype.value = function (options) {
	        return this.internalValue.toDate();
	    };
	    TimestampValue.prototype.isEqual = function (other) {
	        return (other instanceof TimestampValue &&
	            this.internalValue.isEqual(other.internalValue));
	    };
	    TimestampValue.prototype.compareTo = function (other) {
	        if (other instanceof TimestampValue) {
	            return this.internalValue.compareTo(other.internalValue);
	        }
	        else if (other instanceof ServerTimestampValue) {
	            // Concrete timestamps come before server timestamps.
	            return -1;
	        }
	        else {
	            return this.defaultCompareTo(other);
	        }
	    };
	    return TimestampValue;
	}(FieldValue));
	exports.TimestampValue = TimestampValue;
	/**
	 * Represents a locally-applied ServerTimestamp.
	 *
	 * Notes:
	 * - ServerTimestampValue instances are created as the result of applying a
	 *   TransformMutation (see TransformMutation.applyTo()). They can only exist in
	 *   the local view of a document. Therefore they do not need to be parsed or
	 *   serialized.
	 * - When evaluated locally (e.g. for snapshot.data()), they by default
	 *   evaluate to `null`. This behavior can be configured by passing custom
	 *   FieldValueOptions to value().
	 * - With respect to other ServerTimestampValues, they sort by their
	 *   localWriteTime.
	 */
	var ServerTimestampValue = /** @class */ (function (_super) {
	    __extends(ServerTimestampValue, _super);
	    function ServerTimestampValue(localWriteTime, previousValue) {
	        var _this = _super.call(this) || this;
	        _this.localWriteTime = localWriteTime;
	        _this.previousValue = previousValue;
	        _this.typeOrder = TypeOrder.TimestampValue;
	        return _this;
	    }
	    ServerTimestampValue.prototype.value = function (options) {
	        if (options &&
	            options.serverTimestampBehavior === ServerTimestampBehavior.Estimate) {
	            return this.localWriteTime.toDate();
	        }
	        else if (options &&
	            options.serverTimestampBehavior === ServerTimestampBehavior.Previous) {
	            return this.previousValue ? this.previousValue.value(options) : null;
	        }
	        else {
	            return null;
	        }
	    };
	    ServerTimestampValue.prototype.isEqual = function (other) {
	        return (other instanceof ServerTimestampValue &&
	            this.localWriteTime.isEqual(other.localWriteTime));
	    };
	    ServerTimestampValue.prototype.compareTo = function (other) {
	        if (other instanceof ServerTimestampValue) {
	            return this.localWriteTime.compareTo(other.localWriteTime);
	        }
	        else if (other instanceof TimestampValue) {
	            // Server timestamps come after all concrete timestamps.
	            return 1;
	        }
	        else {
	            return this.defaultCompareTo(other);
	        }
	    };
	    ServerTimestampValue.prototype.toString = function () {
	        return '<ServerTimestamp localTime=' + this.localWriteTime.toString() + '>';
	    };
	    return ServerTimestampValue;
	}(FieldValue));
	exports.ServerTimestampValue = ServerTimestampValue;
	var BlobValue = /** @class */ (function (_super) {
	    __extends(BlobValue, _super);
	    function BlobValue(internalValue) {
	        var _this = _super.call(this) || this;
	        _this.internalValue = internalValue;
	        _this.typeOrder = TypeOrder.BlobValue;
	        return _this;
	    }
	    BlobValue.prototype.value = function (options) {
	        return this.internalValue;
	    };
	    BlobValue.prototype.isEqual = function (other) {
	        return (other instanceof BlobValue &&
	            this.internalValue.isEqual(other.internalValue));
	    };
	    BlobValue.prototype.compareTo = function (other) {
	        if (other instanceof BlobValue) {
	            return this.internalValue._compareTo(other.internalValue);
	        }
	        return this.defaultCompareTo(other);
	    };
	    return BlobValue;
	}(FieldValue));
	exports.BlobValue = BlobValue;
	var RefValue = /** @class */ (function (_super) {
	    __extends(RefValue, _super);
	    function RefValue(databaseId, key) {
	        var _this = _super.call(this) || this;
	        _this.databaseId = databaseId;
	        _this.key = key;
	        _this.typeOrder = TypeOrder.RefValue;
	        return _this;
	    }
	    RefValue.prototype.value = function (options) {
	        return this.key;
	    };
	    RefValue.prototype.isEqual = function (other) {
	        if (other instanceof RefValue) {
	            return (this.key.isEqual(other.key) && this.databaseId.isEqual(other.databaseId));
	        }
	        else {
	            return false;
	        }
	    };
	    RefValue.prototype.compareTo = function (other) {
	        if (other instanceof RefValue) {
	            var cmp = this.databaseId.compareTo(other.databaseId);
	            return cmp !== 0 ? cmp : document_key_1.DocumentKey.comparator(this.key, other.key);
	        }
	        return this.defaultCompareTo(other);
	    };
	    return RefValue;
	}(FieldValue));
	exports.RefValue = RefValue;
	var GeoPointValue = /** @class */ (function (_super) {
	    __extends(GeoPointValue, _super);
	    function GeoPointValue(internalValue) {
	        var _this = _super.call(this) || this;
	        _this.internalValue = internalValue;
	        _this.typeOrder = TypeOrder.GeoPointValue;
	        return _this;
	    }
	    GeoPointValue.prototype.value = function (options) {
	        return this.internalValue;
	    };
	    GeoPointValue.prototype.isEqual = function (other) {
	        return (other instanceof GeoPointValue &&
	            this.internalValue.isEqual(other.internalValue));
	    };
	    GeoPointValue.prototype.compareTo = function (other) {
	        if (other instanceof GeoPointValue) {
	            return this.internalValue._compareTo(other.internalValue);
	        }
	        return this.defaultCompareTo(other);
	    };
	    return GeoPointValue;
	}(FieldValue));
	exports.GeoPointValue = GeoPointValue;
	var ObjectValue = /** @class */ (function (_super) {
	    __extends(ObjectValue, _super);
	    function ObjectValue(internalValue) {
	        var _this = _super.call(this) || this;
	        _this.internalValue = internalValue;
	        _this.typeOrder = TypeOrder.ObjectValue;
	        return _this;
	    }
	    ObjectValue.prototype.value = function (options) {
	        var result = {};
	        this.internalValue.inorderTraversal(function (key, val) {
	            result[key] = val.value(options);
	        });
	        return result;
	    };
	    ObjectValue.prototype.forEach = function (action) {
	        this.internalValue.inorderTraversal(action);
	    };
	    ObjectValue.prototype.isEqual = function (other) {
	        if (other instanceof ObjectValue) {
	            var it1 = this.internalValue.getIterator();
	            var it2 = other.internalValue.getIterator();
	            while (it1.hasNext() && it2.hasNext()) {
	                var next1 = it1.getNext();
	                var next2 = it2.getNext();
	                if (next1.key !== next2.key || !next1.value.isEqual(next2.value)) {
	                    return false;
	                }
	            }
	            return !it1.hasNext() && !it2.hasNext();
	        }
	        return false;
	    };
	    ObjectValue.prototype.compareTo = function (other) {
	        if (other instanceof ObjectValue) {
	            var it1 = this.internalValue.getIterator();
	            var it2 = other.internalValue.getIterator();
	            while (it1.hasNext() && it2.hasNext()) {
	                var next1 = it1.getNext();
	                var next2 = it2.getNext();
	                var cmp = misc_1.primitiveComparator(next1.key, next2.key) ||
	                    next1.value.compareTo(next2.value);
	                if (cmp) {
	                    return cmp;
	                }
	            }
	            // Only equal if both iterators are exhausted
	            return misc_1.primitiveComparator(it1.hasNext(), it2.hasNext());
	        }
	        else {
	            return this.defaultCompareTo(other);
	        }
	    };
	    ObjectValue.prototype.set = function (path, to) {
	        assert_1.assert(!path.isEmpty(), 'Cannot set field for empty path on ObjectValue');
	        if (path.length === 1) {
	            return this.setChild(path.firstSegment(), to);
	        }
	        else {
	            var child = this.child(path.firstSegment());
	            if (!(child instanceof ObjectValue)) {
	                child = ObjectValue.EMPTY;
	            }
	            var newChild = child.set(path.popFirst(), to);
	            return this.setChild(path.firstSegment(), newChild);
	        }
	    };
	    ObjectValue.prototype.delete = function (path) {
	        assert_1.assert(!path.isEmpty(), 'Cannot delete field for empty path on ObjectValue');
	        if (path.length === 1) {
	            return new ObjectValue(this.internalValue.remove(path.firstSegment()));
	        }
	        else {
	            // nested field
	            var child = this.child(path.firstSegment());
	            if (child instanceof ObjectValue) {
	                var newChild = child.delete(path.popFirst());
	                return new ObjectValue(this.internalValue.insert(path.firstSegment(), newChild));
	            }
	            else {
	                // Don't actually change a primitive value to an object for a delete
	                return this;
	            }
	        }
	    };
	    ObjectValue.prototype.contains = function (path) {
	        return this.field(path) !== undefined;
	    };
	    ObjectValue.prototype.field = function (path) {
	        assert_1.assert(!path.isEmpty(), "Can't get field of empty path");
	        var field = this;
	        path.forEach(function (pathSegment) {
	            if (field instanceof ObjectValue) {
	                field = field.internalValue.get(pathSegment) || undefined;
	            }
	            else {
	                field = undefined;
	            }
	        });
	        return field;
	    };
	    ObjectValue.prototype.toString = function () {
	        return JSON.stringify(this.value());
	    };
	    ObjectValue.prototype.child = function (childName) {
	        return this.internalValue.get(childName) || undefined;
	    };
	    ObjectValue.prototype.setChild = function (childName, value) {
	        return new ObjectValue(this.internalValue.insert(childName, value));
	    };
	    ObjectValue.EMPTY = new ObjectValue(new sorted_map_1.SortedMap(misc_1.primitiveComparator));
	    return ObjectValue;
	}(FieldValue));
	exports.ObjectValue = ObjectValue;
	var ArrayValue = /** @class */ (function (_super) {
	    __extends(ArrayValue, _super);
	    function ArrayValue(internalValue) {
	        var _this = _super.call(this) || this;
	        _this.internalValue = internalValue;
	        _this.typeOrder = TypeOrder.ArrayValue;
	        return _this;
	    }
	    ArrayValue.prototype.value = function (options) {
	        return this.internalValue.map(function (v) { return v.value(options); });
	    };
	    ArrayValue.prototype.forEach = function (action) {
	        this.internalValue.forEach(action);
	    };
	    ArrayValue.prototype.isEqual = function (other) {
	        if (other instanceof ArrayValue) {
	            if (this.internalValue.length !== other.internalValue.length) {
	                return false;
	            }
	            for (var i = 0; i < this.internalValue.length; i++) {
	                if (!this.internalValue[i].isEqual(other.internalValue[i])) {
	                    return false;
	                }
	            }
	            return true;
	        }
	        return false;
	    };
	    ArrayValue.prototype.compareTo = function (other) {
	        if (other instanceof ArrayValue) {
	            var minLength = Math.min(this.internalValue.length, other.internalValue.length);
	            for (var i = 0; i < minLength; i++) {
	                var cmp = this.internalValue[i].compareTo(other.internalValue[i]);
	                if (cmp) {
	                    return cmp;
	                }
	            }
	            return misc_1.primitiveComparator(this.internalValue.length, other.internalValue.length);
	        }
	        else {
	            return this.defaultCompareTo(other);
	        }
	    };
	    ArrayValue.prototype.toString = function () {
	        return JSON.stringify(this.value());
	    };
	    return ArrayValue;
	}(FieldValue));
	exports.ArrayValue = ArrayValue;
	
	//# sourceMappingURL=field_value.js.map


/***/ }),
/* 43 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * @fileoverview Contains methods for working with objects.
	 */
	function contains(obj, prop) {
	    return Object.prototype.hasOwnProperty.call(obj, prop);
	}
	exports.contains = contains;
	function forEach(obj, f) {
	    for (var key in obj) {
	        if (contains(obj, key)) {
	            f(key, obj[key]);
	        }
	    }
	}
	exports.forEach = forEach;
	function clone(obj) {
	    if (obj == null) {
	        return {};
	    }
	    var c = {};
	    forEach(obj, function (key, val) {
	        c[key] = val;
	    });
	    return c;
	}
	exports.clone = clone;
	
	//# sourceMappingURL=object.js.map


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMNamespaces = __webpack_require__(118);
	var setInnerHTML = __webpack_require__(87);
	
	var createMicrosoftUnsafeLocalFunction = __webpack_require__(126);
	var setTextContent = __webpack_require__(215);
	
	var ELEMENT_NODE_TYPE = 1;
	var DOCUMENT_FRAGMENT_NODE_TYPE = 11;
	
	/**
	 * In IE (8-11) and Edge, appending nodes with no children is dramatically
	 * faster than appending a full subtree, so we essentially queue up the
	 * .appendChild calls here and apply them so each node is added to its parent
	 * before any children are added.
	 *
	 * In other browsers, doing so is slower or neutral compared to the other order
	 * (in Firefox, twice as slow) so we only do this inversion in IE.
	 *
	 * See https://github.com/spicyj/innerhtml-vs-createelement-vs-clonenode.
	 */
	var enableLazy = typeof document !== 'undefined' && typeof document.documentMode === 'number' || typeof navigator !== 'undefined' && typeof navigator.userAgent === 'string' && /\bEdge\/\d/.test(navigator.userAgent);
	
	function insertTreeChildren(tree) {
	  if (!enableLazy) {
	    return;
	  }
	  var node = tree.node;
	  var children = tree.children;
	  if (children.length) {
	    for (var i = 0; i < children.length; i++) {
	      insertTreeBefore(node, children[i], null);
	    }
	  } else if (tree.html != null) {
	    setInnerHTML(node, tree.html);
	  } else if (tree.text != null) {
	    setTextContent(node, tree.text);
	  }
	}
	
	var insertTreeBefore = createMicrosoftUnsafeLocalFunction(function (parentNode, tree, referenceNode) {
	  // DocumentFragments aren't actually part of the DOM after insertion so
	  // appending children won't update the DOM. We need to ensure the fragment
	  // is properly populated first, breaking out of our lazy approach for just
	  // this level. Also, some <object> plugins (like Flash Player) will read
	  // <param> nodes immediately upon insertion into the DOM, so <object>
	  // must also be populated prior to insertion into the DOM.
	  if (tree.node.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE || tree.node.nodeType === ELEMENT_NODE_TYPE && tree.node.nodeName.toLowerCase() === 'object' && (tree.node.namespaceURI == null || tree.node.namespaceURI === DOMNamespaces.html)) {
	    insertTreeChildren(tree);
	    parentNode.insertBefore(tree.node, referenceNode);
	  } else {
	    parentNode.insertBefore(tree.node, referenceNode);
	    insertTreeChildren(tree);
	  }
	});
	
	function replaceChildWithTree(oldNode, newTree) {
	  oldNode.parentNode.replaceChild(newTree.node, oldNode);
	  insertTreeChildren(newTree);
	}
	
	function queueChild(parentTree, childTree) {
	  if (enableLazy) {
	    parentTree.children.push(childTree);
	  } else {
	    parentTree.node.appendChild(childTree.node);
	  }
	}
	
	function queueHTML(tree, html) {
	  if (enableLazy) {
	    tree.html = html;
	  } else {
	    setInnerHTML(tree.node, html);
	  }
	}
	
	function queueText(tree, text) {
	  if (enableLazy) {
	    tree.text = text;
	  } else {
	    setTextContent(tree.node, text);
	  }
	}
	
	function toString() {
	  return this.node.nodeName;
	}
	
	function DOMLazyTree(node) {
	  return {
	    node: node,
	    children: [],
	    html: null,
	    text: null,
	    toString: toString
	  };
	}
	
	DOMLazyTree.insertTreeBefore = insertTreeBefore;
	DOMLazyTree.replaceChildWithTree = replaceChildWithTree;
	DOMLazyTree.queueChild = queueChild;
	DOMLazyTree.queueHTML = queueHTML;
	DOMLazyTree.queueText = queueText;
	
	module.exports = DOMLazyTree;

/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(6);
	
	var invariant = __webpack_require__(3);
	
	function checkMask(value, bitmask) {
	  return (value & bitmask) === bitmask;
	}
	
	var DOMPropertyInjection = {
	  /**
	   * Mapping from normalized, camelcased property names to a configuration that
	   * specifies how the associated DOM property should be accessed or rendered.
	   */
	  MUST_USE_PROPERTY: 0x1,
	  HAS_BOOLEAN_VALUE: 0x4,
	  HAS_NUMERIC_VALUE: 0x8,
	  HAS_POSITIVE_NUMERIC_VALUE: 0x10 | 0x8,
	  HAS_OVERLOADED_BOOLEAN_VALUE: 0x20,
	
	  /**
	   * Inject some specialized knowledge about the DOM. This takes a config object
	   * with the following properties:
	   *
	   * isCustomAttribute: function that given an attribute name will return true
	   * if it can be inserted into the DOM verbatim. Useful for data-* or aria-*
	   * attributes where it's impossible to enumerate all of the possible
	   * attribute names,
	   *
	   * Properties: object mapping DOM property name to one of the
	   * DOMPropertyInjection constants or null. If your attribute isn't in here,
	   * it won't get written to the DOM.
	   *
	   * DOMAttributeNames: object mapping React attribute name to the DOM
	   * attribute name. Attribute names not specified use the **lowercase**
	   * normalized name.
	   *
	   * DOMAttributeNamespaces: object mapping React attribute name to the DOM
	   * attribute namespace URL. (Attribute names not specified use no namespace.)
	   *
	   * DOMPropertyNames: similar to DOMAttributeNames but for DOM properties.
	   * Property names not specified use the normalized name.
	   *
	   * DOMMutationMethods: Properties that require special mutation methods. If
	   * `value` is undefined, the mutation method should unset the property.
	   *
	   * @param {object} domPropertyConfig the config as described above.
	   */
	  injectDOMPropertyConfig: function (domPropertyConfig) {
	    var Injection = DOMPropertyInjection;
	    var Properties = domPropertyConfig.Properties || {};
	    var DOMAttributeNamespaces = domPropertyConfig.DOMAttributeNamespaces || {};
	    var DOMAttributeNames = domPropertyConfig.DOMAttributeNames || {};
	    var DOMPropertyNames = domPropertyConfig.DOMPropertyNames || {};
	    var DOMMutationMethods = domPropertyConfig.DOMMutationMethods || {};
	
	    if (domPropertyConfig.isCustomAttribute) {
	      DOMProperty._isCustomAttributeFunctions.push(domPropertyConfig.isCustomAttribute);
	    }
	
	    for (var propName in Properties) {
	      !!DOMProperty.properties.hasOwnProperty(propName) ?  false ? invariant(false, 'injectDOMPropertyConfig(...): You\'re trying to inject DOM property \'%s\' which has already been injected. You may be accidentally injecting the same DOM property config twice, or you may be injecting two configs that have conflicting property names.', propName) : _prodInvariant('48', propName) : void 0;
	
	      var lowerCased = propName.toLowerCase();
	      var propConfig = Properties[propName];
	
	      var propertyInfo = {
	        attributeName: lowerCased,
	        attributeNamespace: null,
	        propertyName: propName,
	        mutationMethod: null,
	
	        mustUseProperty: checkMask(propConfig, Injection.MUST_USE_PROPERTY),
	        hasBooleanValue: checkMask(propConfig, Injection.HAS_BOOLEAN_VALUE),
	        hasNumericValue: checkMask(propConfig, Injection.HAS_NUMERIC_VALUE),
	        hasPositiveNumericValue: checkMask(propConfig, Injection.HAS_POSITIVE_NUMERIC_VALUE),
	        hasOverloadedBooleanValue: checkMask(propConfig, Injection.HAS_OVERLOADED_BOOLEAN_VALUE)
	      };
	      !(propertyInfo.hasBooleanValue + propertyInfo.hasNumericValue + propertyInfo.hasOverloadedBooleanValue <= 1) ?  false ? invariant(false, 'DOMProperty: Value can be one of boolean, overloaded boolean, or numeric value, but not a combination: %s', propName) : _prodInvariant('50', propName) : void 0;
	
	      if (false) {
	        DOMProperty.getPossibleStandardName[lowerCased] = propName;
	      }
	
	      if (DOMAttributeNames.hasOwnProperty(propName)) {
	        var attributeName = DOMAttributeNames[propName];
	        propertyInfo.attributeName = attributeName;
	        if (false) {
	          DOMProperty.getPossibleStandardName[attributeName] = propName;
	        }
	      }
	
	      if (DOMAttributeNamespaces.hasOwnProperty(propName)) {
	        propertyInfo.attributeNamespace = DOMAttributeNamespaces[propName];
	      }
	
	      if (DOMPropertyNames.hasOwnProperty(propName)) {
	        propertyInfo.propertyName = DOMPropertyNames[propName];
	      }
	
	      if (DOMMutationMethods.hasOwnProperty(propName)) {
	        propertyInfo.mutationMethod = DOMMutationMethods[propName];
	      }
	
	      DOMProperty.properties[propName] = propertyInfo;
	    }
	  }
	};
	
	/* eslint-disable max-len */
	var ATTRIBUTE_NAME_START_CHAR = ':A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD';
	/* eslint-enable max-len */
	
	/**
	 * DOMProperty exports lookup objects that can be used like functions:
	 *
	 *   > DOMProperty.isValid['id']
	 *   true
	 *   > DOMProperty.isValid['foobar']
	 *   undefined
	 *
	 * Although this may be confusing, it performs better in general.
	 *
	 * @see http://jsperf.com/key-exists
	 * @see http://jsperf.com/key-missing
	 */
	var DOMProperty = {
	  ID_ATTRIBUTE_NAME: 'data-reactid',
	  ROOT_ATTRIBUTE_NAME: 'data-reactroot',
	
	  ATTRIBUTE_NAME_START_CHAR: ATTRIBUTE_NAME_START_CHAR,
	  ATTRIBUTE_NAME_CHAR: ATTRIBUTE_NAME_START_CHAR + '\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040',
	
	  /**
	   * Map from property "standard name" to an object with info about how to set
	   * the property in the DOM. Each object contains:
	   *
	   * attributeName:
	   *   Used when rendering markup or with `*Attribute()`.
	   * attributeNamespace
	   * propertyName:
	   *   Used on DOM node instances. (This includes properties that mutate due to
	   *   external factors.)
	   * mutationMethod:
	   *   If non-null, used instead of the property or `setAttribute()` after
	   *   initial render.
	   * mustUseProperty:
	   *   Whether the property must be accessed and mutated as an object property.
	   * hasBooleanValue:
	   *   Whether the property should be removed when set to a falsey value.
	   * hasNumericValue:
	   *   Whether the property must be numeric or parse as a numeric and should be
	   *   removed when set to a falsey value.
	   * hasPositiveNumericValue:
	   *   Whether the property must be positive numeric or parse as a positive
	   *   numeric and should be removed when set to a falsey value.
	   * hasOverloadedBooleanValue:
	   *   Whether the property can be used as a flag as well as with a value.
	   *   Removed when strictly equal to false; present without a value when
	   *   strictly equal to true; present with a value otherwise.
	   */
	  properties: {},
	
	  /**
	   * Mapping from lowercase property names to the properly cased version, used
	   * to warn in the case of missing properties. Available only in __DEV__.
	   *
	   * autofocus is predefined, because adding it to the property whitelist
	   * causes unintended side effects.
	   *
	   * @type {Object}
	   */
	  getPossibleStandardName:  false ? { autofocus: 'autoFocus' } : null,
	
	  /**
	   * All of the isCustomAttribute() functions that have been injected.
	   */
	  _isCustomAttributeFunctions: [],
	
	  /**
	   * Checks whether a property name is a custom attribute.
	   * @method
	   */
	  isCustomAttribute: function (attributeName) {
	    for (var i = 0; i < DOMProperty._isCustomAttributeFunctions.length; i++) {
	      var isCustomAttributeFn = DOMProperty._isCustomAttributeFunctions[i];
	      if (isCustomAttributeFn(attributeName)) {
	        return true;
	      }
	    }
	    return false;
	  },
	
	  injection: DOMPropertyInjection
	};
	
	module.exports = DOMProperty;

/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactRef = __webpack_require__(453);
	var ReactInstrumentation = __webpack_require__(25);
	
	var warning = __webpack_require__(5);
	
	/**
	 * Helper to call ReactRef.attachRefs with this composite component, split out
	 * to avoid allocations in the transaction mount-ready queue.
	 */
	function attachRefs() {
	  ReactRef.attachRefs(this, this._currentElement);
	}
	
	var ReactReconciler = {
	  /**
	   * Initializes the component, renders markup, and registers event listeners.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {?object} the containing host component instance
	   * @param {?object} info about the host container
	   * @return {?string} Rendered markup to be inserted into the DOM.
	   * @final
	   * @internal
	   */
	  mountComponent: function (internalInstance, transaction, hostParent, hostContainerInfo, context, parentDebugID) // 0 in production and for roots
	  {
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeMountComponent(internalInstance._debugID, internalInstance._currentElement, parentDebugID);
	      }
	    }
	    var markup = internalInstance.mountComponent(transaction, hostParent, hostContainerInfo, context, parentDebugID);
	    if (internalInstance._currentElement && internalInstance._currentElement.ref != null) {
	      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
	    }
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onMountComponent(internalInstance._debugID);
	      }
	    }
	    return markup;
	  },
	
	  /**
	   * Returns a value that can be passed to
	   * ReactComponentEnvironment.replaceNodeWithMarkup.
	   */
	  getHostNode: function (internalInstance) {
	    return internalInstance.getHostNode();
	  },
	
	  /**
	   * Releases any resources allocated by `mountComponent`.
	   *
	   * @final
	   * @internal
	   */
	  unmountComponent: function (internalInstance, safely) {
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeUnmountComponent(internalInstance._debugID);
	      }
	    }
	    ReactRef.detachRefs(internalInstance, internalInstance._currentElement);
	    internalInstance.unmountComponent(safely);
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onUnmountComponent(internalInstance._debugID);
	      }
	    }
	  },
	
	  /**
	   * Update a component using a new element.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactElement} nextElement
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   * @internal
	   */
	  receiveComponent: function (internalInstance, nextElement, transaction, context) {
	    var prevElement = internalInstance._currentElement;
	
	    if (nextElement === prevElement && context === internalInstance._context) {
	      // Since elements are immutable after the owner is rendered,
	      // we can do a cheap identity compare here to determine if this is a
	      // superfluous reconcile. It's possible for state to be mutable but such
	      // change should trigger an update of the owner which would recreate
	      // the element. We explicitly check for the existence of an owner since
	      // it's possible for an element created outside a composite to be
	      // deeply mutated and reused.
	
	      // TODO: Bailing out early is just a perf optimization right?
	      // TODO: Removing the return statement should affect correctness?
	      return;
	    }
	
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeUpdateComponent(internalInstance._debugID, nextElement);
	      }
	    }
	
	    var refsChanged = ReactRef.shouldUpdateRefs(prevElement, nextElement);
	
	    if (refsChanged) {
	      ReactRef.detachRefs(internalInstance, prevElement);
	    }
	
	    internalInstance.receiveComponent(nextElement, transaction, context);
	
	    if (refsChanged && internalInstance._currentElement && internalInstance._currentElement.ref != null) {
	      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
	    }
	
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onUpdateComponent(internalInstance._debugID);
	      }
	    }
	  },
	
	  /**
	   * Flush any dirty changes in a component.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  performUpdateIfNecessary: function (internalInstance, transaction, updateBatchNumber) {
	    if (internalInstance._updateBatchNumber !== updateBatchNumber) {
	      // The component's enqueued batch number should always be the current
	      // batch or the following one.
	       false ? warning(internalInstance._updateBatchNumber == null || internalInstance._updateBatchNumber === updateBatchNumber + 1, 'performUpdateIfNecessary: Unexpected batch number (current %s, ' + 'pending %s)', updateBatchNumber, internalInstance._updateBatchNumber) : void 0;
	      return;
	    }
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeUpdateComponent(internalInstance._debugID, internalInstance._currentElement);
	      }
	    }
	    internalInstance.performUpdateIfNecessary(transaction);
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onUpdateComponent(internalInstance._debugID);
	      }
	    }
	  }
	};
	
	module.exports = ReactReconciler;

/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(7);
	
	var ReactBaseClasses = __webpack_require__(217);
	var ReactChildren = __webpack_require__(482);
	var ReactDOMFactories = __webpack_require__(483);
	var ReactElement = __webpack_require__(48);
	var ReactPropTypes = __webpack_require__(484);
	var ReactVersion = __webpack_require__(485);
	
	var createReactClass = __webpack_require__(486);
	var onlyChild = __webpack_require__(490);
	
	var createElement = ReactElement.createElement;
	var createFactory = ReactElement.createFactory;
	var cloneElement = ReactElement.cloneElement;
	
	if (false) {
	  var lowPriorityWarning = require('./lowPriorityWarning');
	  var canDefineProperty = require('./canDefineProperty');
	  var ReactElementValidator = require('./ReactElementValidator');
	  var didWarnPropTypesDeprecated = false;
	  createElement = ReactElementValidator.createElement;
	  createFactory = ReactElementValidator.createFactory;
	  cloneElement = ReactElementValidator.cloneElement;
	}
	
	var __spread = _assign;
	var createMixin = function (mixin) {
	  return mixin;
	};
	
	if (false) {
	  var warnedForSpread = false;
	  var warnedForCreateMixin = false;
	  __spread = function () {
	    lowPriorityWarning(warnedForSpread, 'React.__spread is deprecated and should not be used. Use ' + 'Object.assign directly or another helper function with similar ' + 'semantics. You may be seeing this warning due to your compiler. ' + 'See https://fb.me/react-spread-deprecation for more details.');
	    warnedForSpread = true;
	    return _assign.apply(null, arguments);
	  };
	
	  createMixin = function (mixin) {
	    lowPriorityWarning(warnedForCreateMixin, 'React.createMixin is deprecated and should not be used. ' + 'In React v16.0, it will be removed. ' + 'You can use this mixin directly instead. ' + 'See https://fb.me/createmixin-was-never-implemented for more info.');
	    warnedForCreateMixin = true;
	    return mixin;
	  };
	}
	
	var React = {
	  // Modern
	
	  Children: {
	    map: ReactChildren.map,
	    forEach: ReactChildren.forEach,
	    count: ReactChildren.count,
	    toArray: ReactChildren.toArray,
	    only: onlyChild
	  },
	
	  Component: ReactBaseClasses.Component,
	  PureComponent: ReactBaseClasses.PureComponent,
	
	  createElement: createElement,
	  cloneElement: cloneElement,
	  isValidElement: ReactElement.isValidElement,
	
	  // Classic
	
	  PropTypes: ReactPropTypes,
	  createClass: createReactClass,
	  createFactory: createFactory,
	  createMixin: createMixin,
	
	  // This looks DOM specific but these are actually isomorphic helpers
	  // since they are just generating DOM strings.
	  DOM: ReactDOMFactories,
	
	  version: ReactVersion,
	
	  // Deprecated hook for JSX spread, don't use this for anything.
	  __spread: __spread
	};
	
	if (false) {
	  var warnedForCreateClass = false;
	  if (canDefineProperty) {
	    Object.defineProperty(React, 'PropTypes', {
	      get: function () {
	        lowPriorityWarning(didWarnPropTypesDeprecated, 'Accessing PropTypes via the main React package is deprecated,' + ' and will be removed in  React v16.0.' + ' Use the latest available v15.* prop-types package from npm instead.' + ' For info on usage, compatibility, migration and more, see ' + 'https://fb.me/prop-types-docs');
	        didWarnPropTypesDeprecated = true;
	        return ReactPropTypes;
	      }
	    });
	
	    Object.defineProperty(React, 'createClass', {
	      get: function () {
	        lowPriorityWarning(warnedForCreateClass, 'Accessing createClass via the main React package is deprecated,' + ' and will be removed in React v16.0.' + " Use a plain JavaScript class instead. If you're not yet " + 'ready to migrate, create-react-class v15.* is available ' + 'on npm as a temporary, drop-in replacement. ' + 'For more info see https://fb.me/react-create-class');
	        warnedForCreateClass = true;
	        return createReactClass;
	      }
	    });
	  }
	
	  // React.DOM factories are deprecated. Wrap these methods so that
	  // invocations of the React.DOM namespace and alert users to switch
	  // to the `react-dom-factories` package.
	  React.DOM = {};
	  var warnedForFactories = false;
	  Object.keys(ReactDOMFactories).forEach(function (factory) {
	    React.DOM[factory] = function () {
	      if (!warnedForFactories) {
	        lowPriorityWarning(false, 'Accessing factories like React.DOM.%s has been deprecated ' + 'and will be removed in v16.0+. Use the ' + 'react-dom-factories package instead. ' + ' Version 1.0 provides a drop-in replacement.' + ' For more info, see https://fb.me/react-dom-factories', factory);
	        warnedForFactories = true;
	      }
	      return ReactDOMFactories[factory].apply(ReactDOMFactories, arguments);
	    };
	  });
	}
	
	module.exports = React;

/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(7);
	
	var ReactCurrentOwner = __webpack_require__(32);
	
	var warning = __webpack_require__(5);
	var canDefineProperty = __webpack_require__(221);
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	var REACT_ELEMENT_TYPE = __webpack_require__(219);
	
	var RESERVED_PROPS = {
	  key: true,
	  ref: true,
	  __self: true,
	  __source: true
	};
	
	var specialPropKeyWarningShown, specialPropRefWarningShown;
	
	function hasValidRef(config) {
	  if (false) {
	    if (hasOwnProperty.call(config, 'ref')) {
	      var getter = Object.getOwnPropertyDescriptor(config, 'ref').get;
	      if (getter && getter.isReactWarning) {
	        return false;
	      }
	    }
	  }
	  return config.ref !== undefined;
	}
	
	function hasValidKey(config) {
	  if (false) {
	    if (hasOwnProperty.call(config, 'key')) {
	      var getter = Object.getOwnPropertyDescriptor(config, 'key').get;
	      if (getter && getter.isReactWarning) {
	        return false;
	      }
	    }
	  }
	  return config.key !== undefined;
	}
	
	function defineKeyPropWarningGetter(props, displayName) {
	  var warnAboutAccessingKey = function () {
	    if (!specialPropKeyWarningShown) {
	      specialPropKeyWarningShown = true;
	       false ? warning(false, '%s: `key` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
	    }
	  };
	  warnAboutAccessingKey.isReactWarning = true;
	  Object.defineProperty(props, 'key', {
	    get: warnAboutAccessingKey,
	    configurable: true
	  });
	}
	
	function defineRefPropWarningGetter(props, displayName) {
	  var warnAboutAccessingRef = function () {
	    if (!specialPropRefWarningShown) {
	      specialPropRefWarningShown = true;
	       false ? warning(false, '%s: `ref` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
	    }
	  };
	  warnAboutAccessingRef.isReactWarning = true;
	  Object.defineProperty(props, 'ref', {
	    get: warnAboutAccessingRef,
	    configurable: true
	  });
	}
	
	/**
	 * Factory method to create a new React element. This no longer adheres to
	 * the class pattern, so do not use new to call it. Also, no instanceof check
	 * will work. Instead test $$typeof field against Symbol.for('react.element') to check
	 * if something is a React Element.
	 *
	 * @param {*} type
	 * @param {*} key
	 * @param {string|object} ref
	 * @param {*} self A *temporary* helper to detect places where `this` is
	 * different from the `owner` when React.createElement is called, so that we
	 * can warn. We want to get rid of owner and replace string `ref`s with arrow
	 * functions, and as long as `this` and owner are the same, there will be no
	 * change in behavior.
	 * @param {*} source An annotation object (added by a transpiler or otherwise)
	 * indicating filename, line number, and/or other information.
	 * @param {*} owner
	 * @param {*} props
	 * @internal
	 */
	var ReactElement = function (type, key, ref, self, source, owner, props) {
	  var element = {
	    // This tag allow us to uniquely identify this as a React Element
	    $$typeof: REACT_ELEMENT_TYPE,
	
	    // Built-in properties that belong on the element
	    type: type,
	    key: key,
	    ref: ref,
	    props: props,
	
	    // Record the component responsible for creating this element.
	    _owner: owner
	  };
	
	  if (false) {
	    // The validation flag is currently mutative. We put it on
	    // an external backing store so that we can freeze the whole object.
	    // This can be replaced with a WeakMap once they are implemented in
	    // commonly used development environments.
	    element._store = {};
	
	    // To make comparing ReactElements easier for testing purposes, we make
	    // the validation flag non-enumerable (where possible, which should
	    // include every environment we run tests in), so the test framework
	    // ignores it.
	    if (canDefineProperty) {
	      Object.defineProperty(element._store, 'validated', {
	        configurable: false,
	        enumerable: false,
	        writable: true,
	        value: false
	      });
	      // self and source are DEV only properties.
	      Object.defineProperty(element, '_self', {
	        configurable: false,
	        enumerable: false,
	        writable: false,
	        value: self
	      });
	      // Two elements created in two different places should be considered
	      // equal for testing purposes and therefore we hide it from enumeration.
	      Object.defineProperty(element, '_source', {
	        configurable: false,
	        enumerable: false,
	        writable: false,
	        value: source
	      });
	    } else {
	      element._store.validated = false;
	      element._self = self;
	      element._source = source;
	    }
	    if (Object.freeze) {
	      Object.freeze(element.props);
	      Object.freeze(element);
	    }
	  }
	
	  return element;
	};
	
	/**
	 * Create and return a new ReactElement of the given type.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.createelement
	 */
	ReactElement.createElement = function (type, config, children) {
	  var propName;
	
	  // Reserved names are extracted
	  var props = {};
	
	  var key = null;
	  var ref = null;
	  var self = null;
	  var source = null;
	
	  if (config != null) {
	    if (hasValidRef(config)) {
	      ref = config.ref;
	    }
	    if (hasValidKey(config)) {
	      key = '' + config.key;
	    }
	
	    self = config.__self === undefined ? null : config.__self;
	    source = config.__source === undefined ? null : config.__source;
	    // Remaining properties are added to a new props object
	    for (propName in config) {
	      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
	        props[propName] = config[propName];
	      }
	    }
	  }
	
	  // Children can be more than one argument, and those are transferred onto
	  // the newly allocated props object.
	  var childrenLength = arguments.length - 2;
	  if (childrenLength === 1) {
	    props.children = children;
	  } else if (childrenLength > 1) {
	    var childArray = Array(childrenLength);
	    for (var i = 0; i < childrenLength; i++) {
	      childArray[i] = arguments[i + 2];
	    }
	    if (false) {
	      if (Object.freeze) {
	        Object.freeze(childArray);
	      }
	    }
	    props.children = childArray;
	  }
	
	  // Resolve default props
	  if (type && type.defaultProps) {
	    var defaultProps = type.defaultProps;
	    for (propName in defaultProps) {
	      if (props[propName] === undefined) {
	        props[propName] = defaultProps[propName];
	      }
	    }
	  }
	  if (false) {
	    if (key || ref) {
	      if (typeof props.$$typeof === 'undefined' || props.$$typeof !== REACT_ELEMENT_TYPE) {
	        var displayName = typeof type === 'function' ? type.displayName || type.name || 'Unknown' : type;
	        if (key) {
	          defineKeyPropWarningGetter(props, displayName);
	        }
	        if (ref) {
	          defineRefPropWarningGetter(props, displayName);
	        }
	      }
	    }
	  }
	  return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
	};
	
	/**
	 * Return a function that produces ReactElements of a given type.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.createfactory
	 */
	ReactElement.createFactory = function (type) {
	  var factory = ReactElement.createElement.bind(null, type);
	  // Expose the type on the factory and the prototype so that it can be
	  // easily accessed on elements. E.g. `<Foo />.type === Foo`.
	  // This should not be named `constructor` since this may not be the function
	  // that created the element, and it may not even be a constructor.
	  // Legacy hook TODO: Warn if this is accessed
	  factory.type = type;
	  return factory;
	};
	
	ReactElement.cloneAndReplaceKey = function (oldElement, newKey) {
	  var newElement = ReactElement(oldElement.type, newKey, oldElement.ref, oldElement._self, oldElement._source, oldElement._owner, oldElement.props);
	
	  return newElement;
	};
	
	/**
	 * Clone and return a new ReactElement using element as the starting point.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.cloneelement
	 */
	ReactElement.cloneElement = function (element, config, children) {
	  var propName;
	
	  // Original props are copied
	  var props = _assign({}, element.props);
	
	  // Reserved names are extracted
	  var key = element.key;
	  var ref = element.ref;
	  // Self is preserved since the owner is preserved.
	  var self = element._self;
	  // Source is preserved since cloneElement is unlikely to be targeted by a
	  // transpiler, and the original source is probably a better indicator of the
	  // true owner.
	  var source = element._source;
	
	  // Owner will be preserved, unless ref is overridden
	  var owner = element._owner;
	
	  if (config != null) {
	    if (hasValidRef(config)) {
	      // Silently steal the ref from the parent.
	      ref = config.ref;
	      owner = ReactCurrentOwner.current;
	    }
	    if (hasValidKey(config)) {
	      key = '' + config.key;
	    }
	
	    // Remaining properties override existing props
	    var defaultProps;
	    if (element.type && element.type.defaultProps) {
	      defaultProps = element.type.defaultProps;
	    }
	    for (propName in config) {
	      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
	        if (config[propName] === undefined && defaultProps !== undefined) {
	          // Resolve default props
	          props[propName] = defaultProps[propName];
	        } else {
	          props[propName] = config[propName];
	        }
	      }
	    }
	  }
	
	  // Children can be more than one argument, and those are transferred onto
	  // the newly allocated props object.
	  var childrenLength = arguments.length - 2;
	  if (childrenLength === 1) {
	    props.children = children;
	  } else if (childrenLength > 1) {
	    var childArray = Array(childrenLength);
	    for (var i = 0; i < childrenLength; i++) {
	      childArray[i] = arguments[i + 2];
	    }
	    props.children = childArray;
	  }
	
	  return ReactElement(element.type, key, ref, self, source, owner, props);
	};
	
	/**
	 * Verifies the object is a ReactElement.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.isvalidelement
	 * @param {?object} object
	 * @return {boolean} True if `object` is a valid component.
	 * @final
	 */
	ReactElement.isValidElement = function (object) {
	  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
	};
	
	module.exports = ReactElement;

/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var Index_1 = __webpack_require__(67);
	var Node_1 = __webpack_require__(19);
	var util_1 = __webpack_require__(4);
	var util_2 = __webpack_require__(1);
	var __EMPTY_NODE;
	var KeyIndex = /** @class */ (function (_super) {
	    __extends(KeyIndex, _super);
	    function KeyIndex() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    Object.defineProperty(KeyIndex, "__EMPTY_NODE", {
	        get: function () {
	            return __EMPTY_NODE;
	        },
	        set: function (val) {
	            __EMPTY_NODE = val;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    /**
	     * @inheritDoc
	     */
	    KeyIndex.prototype.compare = function (a, b) {
	        return util_1.nameCompare(a.name, b.name);
	    };
	    /**
	     * @inheritDoc
	     */
	    KeyIndex.prototype.isDefinedOn = function (node) {
	        // We could probably return true here (since every node has a key), but it's never called
	        // so just leaving unimplemented for now.
	        throw util_2.assertionError('KeyIndex.isDefinedOn not expected to be called.');
	    };
	    /**
	     * @inheritDoc
	     */
	    KeyIndex.prototype.indexedValueChanged = function (oldNode, newNode) {
	        return false; // The key for a node never changes.
	    };
	    /**
	     * @inheritDoc
	     */
	    KeyIndex.prototype.minPost = function () {
	        return Node_1.NamedNode.MIN;
	    };
	    /**
	     * @inheritDoc
	     */
	    KeyIndex.prototype.maxPost = function () {
	        // TODO: This should really be created once and cached in a static property, but
	        // NamedNode isn't defined yet, so I can't use it in a static.  Bleh.
	        return new Node_1.NamedNode(util_1.MAX_NAME, __EMPTY_NODE);
	    };
	    /**
	     * @param {*} indexValue
	     * @param {string} name
	     * @return {!NamedNode}
	     */
	    KeyIndex.prototype.makePost = function (indexValue, name) {
	        util_2.assert(typeof indexValue === 'string', 'KeyIndex indexValue must always be a string.');
	        // We just use empty node, but it'll never be compared, since our comparator only looks at name.
	        return new Node_1.NamedNode(indexValue, __EMPTY_NODE);
	    };
	    /**
	     * @return {!string} String representation for inclusion in a query spec
	     */
	    KeyIndex.prototype.toString = function () {
	        return '.key';
	    };
	    return KeyIndex;
	}(Index_1.Index));
	exports.KeyIndex = KeyIndex;
	exports.KEY_INDEX = new KeyIndex();
	
	//# sourceMappingURL=KeyIndex.js.map


/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var ChildrenNode_1 = __webpack_require__(17);
	var LeafNode_1 = __webpack_require__(66);
	var Node_1 = __webpack_require__(19);
	var util_1 = __webpack_require__(1);
	var util_2 = __webpack_require__(1);
	var childSet_1 = __webpack_require__(143);
	var comparators_1 = __webpack_require__(144);
	var IndexMap_1 = __webpack_require__(142);
	var PriorityIndex_1 = __webpack_require__(15);
	var USE_HINZE = true;
	/**
	 * Constructs a snapshot node representing the passed JSON and returns it.
	 * @param {*} json JSON to create a node for.
	 * @param {?string|?number=} priority Optional priority to use.  This will be ignored if the
	 * passed JSON contains a .priority property.
	 * @return {!Node}
	 */
	function nodeFromJSON(json, priority) {
	    if (priority === void 0) { priority = null; }
	    if (json === null) {
	        return ChildrenNode_1.ChildrenNode.EMPTY_NODE;
	    }
	    if (typeof json === 'object' && '.priority' in json) {
	        priority = json['.priority'];
	    }
	    util_2.assert(priority === null ||
	        typeof priority === 'string' ||
	        typeof priority === 'number' ||
	        (typeof priority === 'object' && '.sv' in priority), 'Invalid priority type found: ' + typeof priority);
	    if (typeof json === 'object' && '.value' in json && json['.value'] !== null) {
	        json = json['.value'];
	    }
	    // Valid leaf nodes include non-objects or server-value wrapper objects
	    if (typeof json !== 'object' || '.sv' in json) {
	        var jsonLeaf = json;
	        return new LeafNode_1.LeafNode(jsonLeaf, nodeFromJSON(priority));
	    }
	    if (!(json instanceof Array) && USE_HINZE) {
	        var children_1 = [];
	        var childrenHavePriority_1 = false;
	        var hinzeJsonObj_1 = json;
	        util_1.forEach(hinzeJsonObj_1, function (key, child) {
	            if (typeof key !== 'string' || key.substring(0, 1) !== '.') {
	                // Ignore metadata nodes
	                var childNode = nodeFromJSON(hinzeJsonObj_1[key]);
	                if (!childNode.isEmpty()) {
	                    childrenHavePriority_1 =
	                        childrenHavePriority_1 || !childNode.getPriority().isEmpty();
	                    children_1.push(new Node_1.NamedNode(key, childNode));
	                }
	            }
	        });
	        if (children_1.length == 0) {
	            return ChildrenNode_1.ChildrenNode.EMPTY_NODE;
	        }
	        var childSet = childSet_1.buildChildSet(children_1, comparators_1.NAME_ONLY_COMPARATOR, function (namedNode) { return namedNode.name; }, comparators_1.NAME_COMPARATOR);
	        if (childrenHavePriority_1) {
	            var sortedChildSet = childSet_1.buildChildSet(children_1, PriorityIndex_1.PRIORITY_INDEX.getCompare());
	            return new ChildrenNode_1.ChildrenNode(childSet, nodeFromJSON(priority), new IndexMap_1.IndexMap({ '.priority': sortedChildSet }, { '.priority': PriorityIndex_1.PRIORITY_INDEX }));
	        }
	        else {
	            return new ChildrenNode_1.ChildrenNode(childSet, nodeFromJSON(priority), IndexMap_1.IndexMap.Default);
	        }
	    }
	    else {
	        var node_1 = ChildrenNode_1.ChildrenNode.EMPTY_NODE;
	        var jsonObj_1 = json;
	        util_1.forEach(jsonObj_1, function (key, childData) {
	            if (util_1.contains(jsonObj_1, key)) {
	                if (key.substring(0, 1) !== '.') {
	                    // ignore metadata nodes.
	                    var childNode = nodeFromJSON(childData);
	                    if (childNode.isLeafNode() || !childNode.isEmpty())
	                        node_1 = node_1.updateImmediateChild(key, childNode);
	                }
	            }
	        });
	        return node_1.updatePriority(nodeFromJSON(priority));
	    }
	}
	exports.nodeFromJSON = nodeFromJSON;
	PriorityIndex_1.setNodeFromJSON(nodeFromJSON);
	
	//# sourceMappingURL=nodeFromJSON.js.map


/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var snapshot_version_1 = __webpack_require__(20);
	var platform_1 = __webpack_require__(29);
	/** An enumeration of the different purposes we have for queries. */
	var QueryPurpose;
	(function (QueryPurpose) {
	    /** A regular, normal query. */
	    QueryPurpose[QueryPurpose["Listen"] = 0] = "Listen";
	    /**
	     * The query was used to refill a query after an existence filter mismatch.
	     */
	    QueryPurpose[QueryPurpose["ExistenceFilterMismatch"] = 1] = "ExistenceFilterMismatch";
	    /** The query was used to resolve a limbo document. */
	    QueryPurpose[QueryPurpose["LimboResolution"] = 2] = "LimboResolution";
	})(QueryPurpose = exports.QueryPurpose || (exports.QueryPurpose = {}));
	/**
	 * An immutable set of metadata that the local store tracks for each query.
	 */
	var QueryData = /** @class */ (function () {
	    function QueryData(
	        /** The query being listened to. */
	        query, 
	        /**
	         * The target ID to which the query corresponds; Assigned by the
	         * LocalStore for user listens and by the SyncEngine for limbo watches.
	         */
	        targetId, 
	        /** The purpose of the query. */
	        purpose, 
	        /** The latest snapshot version seen for this target. */
	        snapshotVersion, 
	        /**
	         * An opaque, server-assigned token that allows watching a query to be
	         * resumed after disconnecting without retransmitting all the data that
	         * matches the query. The resume token essentially identifies a point in
	         * time from which the server should resume sending results.
	         */
	        resumeToken) {
	        if (snapshotVersion === void 0) { snapshotVersion = snapshot_version_1.SnapshotVersion.MIN; }
	        if (resumeToken === void 0) { resumeToken = platform_1.emptyByteString(); }
	        this.query = query;
	        this.targetId = targetId;
	        this.purpose = purpose;
	        this.snapshotVersion = snapshotVersion;
	        this.resumeToken = resumeToken;
	    }
	    /**
	     * Creates a new query data instance with an updated snapshot version and
	     * resume token.
	     */
	    QueryData.prototype.update = function (updated) {
	        return new QueryData(this.query, this.targetId, this.purpose, updated.snapshotVersion, updated.resumeToken);
	    };
	    QueryData.prototype.isEqual = function (other) {
	        return (this.targetId === other.targetId &&
	            this.purpose === other.purpose &&
	            this.snapshotVersion.isEqual(other.snapshotVersion) &&
	            this.resumeToken === other.resumeToken &&
	            this.query.isEqual(other.query));
	    };
	    return QueryData;
	}());
	exports.QueryData = QueryData;
	
	//# sourceMappingURL=query_data.js.map


/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var collections_1 = __webpack_require__(11);
	var assert_1 = __webpack_require__(2);
	var misc = __webpack_require__(14);
	exports.BATCHID_UNKNOWN = -1;
	/**
	 * A batch of mutations that will be sent as one unit to the backend.
	 */
	var MutationBatch = /** @class */ (function () {
	    function MutationBatch(batchId, localWriteTime, mutations) {
	        this.batchId = batchId;
	        this.localWriteTime = localWriteTime;
	        this.mutations = mutations;
	    }
	    /**
	     * Applies all the mutations in this MutationBatch to the specified document
	     * to create a new remote document
	     *
	     * @param docKey The key of the document to apply mutations to.
	     * @param maybeDoc The document to apply mutations to.
	     * @param batchResult The result of applying the MutationBatch to the
	     * backend.
	     */
	    MutationBatch.prototype.applyToRemoteDocument = function (docKey, maybeDoc, batchResult) {
	        if (maybeDoc) {
	            assert_1.assert(maybeDoc.key.isEqual(docKey), "applyToRemoteDocument: key " + docKey + " should match maybeDoc key\n        " + maybeDoc.key);
	        }
	        var mutationResults = batchResult.mutationResults;
	        assert_1.assert(mutationResults.length === this.mutations.length, "Mismatch between mutations length\n      (" + this.mutations.length + ") and mutation results length\n      (" + mutationResults.length + ").");
	        for (var i = 0; i < this.mutations.length; i++) {
	            var mutation = this.mutations[i];
	            if (mutation.key.isEqual(docKey)) {
	                var mutationResult = mutationResults[i];
	                maybeDoc = mutation.applyToRemoteDocument(maybeDoc, mutationResult);
	            }
	        }
	        return maybeDoc;
	    };
	    /**
	     * Computes the local view of a document given all the mutations in this
	     * batch.
	     *
	     * @param docKey The key of the document to apply mutations to.
	     * @param maybeDoc The document to apply mutations to.
	     */
	    MutationBatch.prototype.applyToLocalView = function (docKey, maybeDoc) {
	        if (maybeDoc) {
	            assert_1.assert(maybeDoc.key.isEqual(docKey), "applyToLocalDocument: key " + docKey + " should match maybeDoc key\n        " + maybeDoc.key);
	        }
	        var baseDoc = maybeDoc;
	        for (var i = 0; i < this.mutations.length; i++) {
	            var mutation = this.mutations[i];
	            if (mutation.key.isEqual(docKey)) {
	                maybeDoc = mutation.applyToLocalView(maybeDoc, baseDoc, this.localWriteTime);
	            }
	        }
	        return maybeDoc;
	    };
	    MutationBatch.prototype.keys = function () {
	        var keySet = collections_1.documentKeySet();
	        for (var _i = 0, _a = this.mutations; _i < _a.length; _i++) {
	            var mutation = _a[_i];
	            keySet = keySet.add(mutation.key);
	        }
	        return keySet;
	    };
	    MutationBatch.prototype.isEqual = function (other) {
	        return (this.batchId === other.batchId &&
	            misc.arrayEquals(this.mutations, other.mutations));
	    };
	    /**
	     * Returns true if this mutation batch has already been removed from the
	     * mutation queue.
	     *
	     * Note that not all implementations of the MutationQueue necessarily use
	     * tombstones as part of their implementation and generally speaking no code
	     * outside the mutation queues should really care about this.
	     */
	    MutationBatch.prototype.isTombstone = function () {
	        return this.mutations.length === 0;
	    };
	    /** Converts this batch into a tombstone */
	    MutationBatch.prototype.toTombstone = function () {
	        return new MutationBatch(this.batchId, this.localWriteTime, []);
	    };
	    return MutationBatch;
	}());
	exports.MutationBatch = MutationBatch;
	/** The result of applying a mutation batch to the backend. */
	var MutationBatchResult = /** @class */ (function () {
	    function MutationBatchResult(batch, commitVersion, mutationResults, streamToken, 
	        /**
	         * A pre-computed mapping from each mutated document to the resulting
	         * version.
	         */
	        docVersions) {
	        this.batch = batch;
	        this.commitVersion = commitVersion;
	        this.mutationResults = mutationResults;
	        this.streamToken = streamToken;
	        this.docVersions = docVersions;
	    }
	    /**
	     * Creates a new MutationBatchResult for the given batch and results. There
	     * must be one result for each mutation in the batch. This static factory
	     * caches a document=>version mapping (docVersions).
	     */
	    MutationBatchResult.from = function (batch, commitVersion, results, streamToken) {
	        assert_1.assert(batch.mutations.length === results.length, 'Mutations sent ' +
	            batch.mutations.length +
	            ' must equal results received ' +
	            results.length);
	        var versionMap = collections_1.documentVersionMap();
	        var mutations = batch.mutations;
	        for (var i = 0; i < mutations.length; i++) {
	            var version = results[i].version;
	            if (version === null) {
	                // deletes don't have a version, so we substitute the commitVersion
	                // of the entire batch.
	                version = commitVersion;
	            }
	            versionMap = versionMap.insert(mutations[i].key, version);
	        }
	        return new MutationBatchResult(batch, commitVersion, results, streamToken, versionMap);
	    };
	    return MutationBatchResult;
	}());
	exports.MutationBatchResult = MutationBatchResult;
	
	//# sourceMappingURL=mutation_batch.js.map


/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var snapshot_version_1 = __webpack_require__(20);
	var collections_1 = __webpack_require__(11);
	var platform_1 = __webpack_require__(29);
	/**
	 * An event from the RemoteStore. It is split into targetChanges (changes to the
	 * state or the set of documents in our watched targets) and documentUpdates
	 * (changes to the actual documents).
	 */
	var RemoteEvent = /** @class */ (function () {
	    function RemoteEvent(
	        /**
	         * The snapshot version this event brings us up to, or MIN if not set.
	         */
	        snapshotVersion, 
	        /**
	         * A map from target to changes to the target. See TargetChange.
	         */
	        targetChanges, 
	        /**
	         * A set of which documents have changed or been deleted, along with the
	         * doc's new values (if not deleted).
	         */
	        documentUpdates) {
	        this.snapshotVersion = snapshotVersion;
	        this.targetChanges = targetChanges;
	        this.documentUpdates = documentUpdates;
	    }
	    RemoteEvent.prototype.addDocumentUpdate = function (doc) {
	        this.documentUpdates = this.documentUpdates.insert(doc.key, doc);
	    };
	    RemoteEvent.prototype.handleExistenceFilterMismatch = function (targetId) {
	        /*
	         * An existence filter mismatch will reset the query and we need to reset
	         * the mapping to contain no documents and an empty resume token.
	         *
	         * Note:
	         *   * The reset mapping is empty, specifically forcing the consumer of the
	         *     change to forget all keys for this targetID;
	         *   * The resume snapshot for this target must be reset
	         *   * The target must be unacked because unwatching and rewatching
	         *     introduces a race for changes.
	         */
	        this.targetChanges[targetId] = {
	            mapping: new ResetMapping(),
	            snapshotVersion: snapshot_version_1.SnapshotVersion.MIN,
	            currentStatusUpdate: CurrentStatusUpdate.MarkNotCurrent,
	            resumeToken: platform_1.emptyByteString()
	        };
	    };
	    return RemoteEvent;
	}());
	exports.RemoteEvent = RemoteEvent;
	/**
	 * Represents an update to the current status of a target, either explicitly
	 * having no new state, or the new value to set. Note "current" has special
	 * meaning for in the RPC protocol that implies that a target is both up-to-date
	 * and consistent with the rest of the watch stream.
	 */
	var CurrentStatusUpdate;
	(function (CurrentStatusUpdate) {
	    /** The current status is not affected and should not be modified. */
	    CurrentStatusUpdate[CurrentStatusUpdate["None"] = 0] = "None";
	    /** The target must be marked as no longer "current". */
	    CurrentStatusUpdate[CurrentStatusUpdate["MarkNotCurrent"] = 1] = "MarkNotCurrent";
	    /** The target must be marked as "current". */
	    CurrentStatusUpdate[CurrentStatusUpdate["MarkCurrent"] = 2] = "MarkCurrent";
	})(CurrentStatusUpdate = exports.CurrentStatusUpdate || (exports.CurrentStatusUpdate = {}));
	var EMPTY_KEY_SET = collections_1.documentKeySet();
	var ResetMapping = /** @class */ (function () {
	    function ResetMapping() {
	        this.docs = EMPTY_KEY_SET;
	    }
	    Object.defineProperty(ResetMapping.prototype, "documents", {
	        get: function () {
	            return this.docs;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    ResetMapping.prototype.add = function (key) {
	        this.docs = this.docs.add(key);
	    };
	    ResetMapping.prototype.delete = function (key) {
	        this.docs = this.docs.delete(key);
	    };
	    ResetMapping.prototype.isEqual = function (other) {
	        return other !== null && this.docs.isEqual(other.docs);
	    };
	    return ResetMapping;
	}());
	exports.ResetMapping = ResetMapping;
	var UpdateMapping = /** @class */ (function () {
	    function UpdateMapping() {
	        this.addedDocuments = EMPTY_KEY_SET;
	        this.removedDocuments = EMPTY_KEY_SET;
	    }
	    UpdateMapping.prototype.applyToKeySet = function (keys) {
	        var result = keys;
	        this.addedDocuments.forEach(function (key) { return (result = result.add(key)); });
	        this.removedDocuments.forEach(function (key) { return (result = result.delete(key)); });
	        return result;
	    };
	    UpdateMapping.prototype.add = function (key) {
	        this.addedDocuments = this.addedDocuments.add(key);
	        this.removedDocuments = this.removedDocuments.delete(key);
	    };
	    UpdateMapping.prototype.delete = function (key) {
	        this.addedDocuments = this.addedDocuments.delete(key);
	        this.removedDocuments = this.removedDocuments.add(key);
	    };
	    UpdateMapping.prototype.isEqual = function (other) {
	        return (other !== null &&
	            this.addedDocuments.isEqual(other.addedDocuments) &&
	            this.removedDocuments.isEqual(other.removedDocuments));
	    };
	    return UpdateMapping;
	}());
	exports.UpdateMapping = UpdateMapping;
	
	//# sourceMappingURL=remote_event.js.map


/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var assert_1 = __webpack_require__(2);
	var error_1 = __webpack_require__(10);
	var obj = __webpack_require__(27);
	/**
	 * Validates the invocation of functionName has the exact number of arguments.
	 *
	 * Forward the magic "arguments" variable as second parameter on which the
	 * parameter validation is performed:
	 * validateExactNumberOfArgs('myFunction', arguments, 2);
	 */
	function validateExactNumberOfArgs(functionName, args, numberOfArgs) {
	    if (args.length !== numberOfArgs) {
	        throw new error_1.FirestoreError(error_1.Code.INVALID_ARGUMENT, "Function " + functionName + "() requires " +
	            formatPlural(numberOfArgs, 'argument') +
	            ', but was called with ' +
	            formatPlural(args.length, 'argument') +
	            '.');
	    }
	}
	exports.validateExactNumberOfArgs = validateExactNumberOfArgs;
	/**
	 * Validates the invocation of functionName has at least the provided number of
	 * arguments (but can have many more).
	 *
	 * Forward the magic "arguments" variable as second parameter on which the
	 * parameter validation is performed:
	 * validateAtLeastNumberOfArgs('myFunction', arguments, 2);
	 */
	function validateAtLeastNumberOfArgs(functionName, args, minNumberOfArgs) {
	    if (args.length < minNumberOfArgs) {
	        throw new error_1.FirestoreError(error_1.Code.INVALID_ARGUMENT, "Function " + functionName + "() requires at least " +
	            formatPlural(minNumberOfArgs, 'argument') +
	            ', but was called with ' +
	            formatPlural(args.length, 'argument') +
	            '.');
	    }
	}
	exports.validateAtLeastNumberOfArgs = validateAtLeastNumberOfArgs;
	/**
	 * Validates the invocation of functionName has number of arguments between
	 * the values provided.
	 *
	 * Forward the magic "arguments" variable as second parameter on which the
	 * parameter validation is performed:
	 * validateBetweenNumberOfArgs('myFunction', arguments, 2, 3);
	 */
	function validateBetweenNumberOfArgs(functionName, args, minNumberOfArgs, maxNumberOfArgs) {
	    if (args.length < minNumberOfArgs || args.length > maxNumberOfArgs) {
	        throw new error_1.FirestoreError(error_1.Code.INVALID_ARGUMENT, "Function " + functionName + "() requires between " + minNumberOfArgs + " and " +
	            (maxNumberOfArgs + " arguments, but was called with ") +
	            formatPlural(args.length, 'argument') +
	            '.');
	    }
	}
	exports.validateBetweenNumberOfArgs = validateBetweenNumberOfArgs;
	/**
	 * Validates the provided argument is an array and has as least the expected
	 * number of elements.
	 */
	function validateNamedArrayAtLeastNumberOfElements(functionName, value, name, minNumberOfElements) {
	    if (!(value instanceof Array) || value.length < minNumberOfElements) {
	        throw new error_1.FirestoreError(error_1.Code.INVALID_ARGUMENT, "Function " + functionName + "() requires its " + name + " argument to be an " +
	            'array with at least ' +
	            (formatPlural(minNumberOfElements, 'element') + "."));
	    }
	}
	exports.validateNamedArrayAtLeastNumberOfElements = validateNamedArrayAtLeastNumberOfElements;
	/**
	 * Validates the provided positional argument has the native JavaScript type
	 * using typeof checks.
	 */
	function validateArgType(functionName, type, position, argument) {
	    validateType(functionName, type, ordinal(position) + " argument", argument);
	}
	exports.validateArgType = validateArgType;
	/**
	 * Validates the provided argument has the native JavaScript type using
	 * typeof checks or is undefined.
	 */
	function validateOptionalArgType(functionName, type, position, argument) {
	    if (argument !== undefined) {
	        validateArgType(functionName, type, position, argument);
	    }
	}
	exports.validateOptionalArgType = validateOptionalArgType;
	/**
	 * Validates the provided named option has the native JavaScript type using
	 * typeof checks.
	 */
	function validateNamedType(functionName, type, optionName, argument) {
	    validateType(functionName, type, optionName + " option", argument);
	}
	exports.validateNamedType = validateNamedType;
	/**
	 * Validates the provided named option has the native JavaScript type using
	 * typeof checks or is undefined.
	 */
	function validateNamedOptionalType(functionName, type, optionName, argument) {
	    if (argument !== undefined) {
	        validateNamedType(functionName, type, optionName, argument);
	    }
	}
	exports.validateNamedOptionalType = validateNamedOptionalType;
	/**
	 * Validates that the provided named option equals one of the expected values.
	 */
	function validateNamedPropertyEquals(functionName, inputName, optionName, input, expected) {
	    var expectedDescription = [];
	    for (var _i = 0, expected_1 = expected; _i < expected_1.length; _i++) {
	        var val = expected_1[_i];
	        if (val === input) {
	            return;
	        }
	        expectedDescription.push(valueDescription(val));
	    }
	    var actualDescription = valueDescription(input);
	    throw new error_1.FirestoreError(error_1.Code.INVALID_ARGUMENT, "Invalid value " + actualDescription + " provided to function " + functionName + "() for option \"" + optionName + "\". Acceptable values: " + expectedDescription.join(', '));
	}
	exports.validateNamedPropertyEquals = validateNamedPropertyEquals;
	/**
	 * Validates that the provided named option equals one of the expected values or
	 * is undefined.
	 */
	function validateNamedOptionalPropertyEquals(functionName, inputName, optionName, input, expected) {
	    if (input !== undefined) {
	        validateNamedPropertyEquals(functionName, inputName, optionName, input, expected);
	    }
	}
	exports.validateNamedOptionalPropertyEquals = validateNamedOptionalPropertyEquals;
	/** Helper to validate the type of a provided input. */
	function validateType(functionName, type, inputName, input) {
	    if (typeof input !== type || (type === 'object' && !isPlainObject(input))) {
	        var description = valueDescription(input);
	        throw new error_1.FirestoreError(error_1.Code.INVALID_ARGUMENT, "Function " + functionName + "() requires its " + inputName + " " +
	            ("to be of type " + type + ", but it was: " + description));
	    }
	}
	/**
	 * Returns true iff it's a non-null object without a custom prototype
	 * (i.e. excludes Array, Date, etc.).
	 */
	function isPlainObject(input) {
	    return (typeof input === 'object' &&
	        input !== null &&
	        Object.getPrototypeOf(input) === Object.prototype);
	}
	exports.isPlainObject = isPlainObject;
	/** Returns a string describing the type / value of the provided input. */
	function valueDescription(input) {
	    if (input === undefined) {
	        return 'undefined';
	    }
	    else if (input === null) {
	        return 'null';
	    }
	    else if (typeof input === 'string') {
	        if (input.length > 20) {
	            input = input.substring(0, 20) + "...";
	        }
	        return JSON.stringify(input);
	    }
	    else if (typeof input === 'number' || typeof input === 'boolean') {
	        return '' + input;
	    }
	    else if (typeof input === 'object') {
	        if (input instanceof Array) {
	            return 'an array';
	        }
	        else {
	            var customObjectName = tryGetCustomObjectType(input);
	            if (customObjectName) {
	                return "a custom " + customObjectName + " object";
	            }
	            else {
	                return 'an object';
	            }
	        }
	    }
	    else if (typeof input === 'function') {
	        return 'a function';
	    }
	    else {
	        return assert_1.fail('Unknown wrong type: ' + typeof input);
	    }
	}
	exports.valueDescription = valueDescription;
	/** Hacky method to try to get the constructor name for an object. */
	function tryGetCustomObjectType(input) {
	    if (input.constructor) {
	        var funcNameRegex = /function\s+([^\s(]+)\s*\(/;
	        var results = funcNameRegex.exec(input.constructor.toString());
	        if (results && results.length > 1) {
	            return results[1];
	        }
	    }
	    return null;
	}
	exports.tryGetCustomObjectType = tryGetCustomObjectType;
	/** Validates the provided argument is defined. */
	function validateDefined(functionName, position, argument) {
	    if (argument === undefined) {
	        throw new error_1.FirestoreError(error_1.Code.INVALID_ARGUMENT, "Function " + functionName + "() requires a valid " + ordinal(position) + " " +
	            "argument, but it was undefined.");
	    }
	}
	exports.validateDefined = validateDefined;
	/**
	 * Validates the provided positional argument is an object, and its keys and
	 * values match the expected keys and types provided in optionTypes.
	 */
	function validateOptionNames(functionName, options, optionNames) {
	    obj.forEach(options, function (key, _) {
	        if (optionNames.indexOf(key) < 0) {
	            throw new error_1.FirestoreError(error_1.Code.INVALID_ARGUMENT, "Unknown option '" + key + "' passed to function " + functionName + "(). " +
	                'Available options: ' +
	                optionNames.join(', '));
	        }
	    });
	}
	exports.validateOptionNames = validateOptionNames;
	/**
	 * Helper method to throw an error that the provided argument did not pass
	 * an instanceof check.
	 */
	function invalidClassError(functionName, type, position, argument) {
	    var description = valueDescription(argument);
	    return new error_1.FirestoreError(error_1.Code.INVALID_ARGUMENT, "Function " + functionName + "() requires its " + ordinal(position) + " " +
	        ("argument to be a " + type + ", but it was: " + description));
	}
	exports.invalidClassError = invalidClassError;
	/** Converts a number to its english word representation */
	function ordinal(num) {
	    switch (num) {
	        case 1:
	            return 'first';
	        case 2:
	            return 'second';
	        case 3:
	            return 'third';
	        default:
	            return num + 'th';
	    }
	}
	/**
	 * Formats the given word as plural conditionally given the preceding number.
	 */
	function formatPlural(num, str) {
	    return num + " " + str + (num === 1 ? '' : 's');
	}
	
	//# sourceMappingURL=input_validation.js.map


/***/ }),
/* 55 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	// Untyped Number alias we can use to check for ES6 methods / properties.
	// tslint:disable-next-line:no-any variable-name
	var NumberAsAny = Number;
	/**
	 * Minimum safe integer in Javascript because of floating point precision.
	 * Added to not rely on ES6 features.
	 */
	exports.MIN_SAFE_INTEGER = NumberAsAny.MIN_SAFE_INTEGER || -(Math.pow(2, 53) - 1);
	/**
	 * Maximum safe integer in Javascript because of floating point precision.
	 * Added to not rely on ES6 features.
	 */
	exports.MAX_SAFE_INTEGER = NumberAsAny.MAX_SAFE_INTEGER || Math.pow(2, 53) - 1;
	/**
	 * Returns whether an number is an integer, uses native implementation if
	 * available.
	 * Added to not rely on ES6 features.
	 * @param value The value to test for being an integer
	 */
	exports.isInteger = NumberAsAny.isInteger ||
	    (function (value) {
	        return typeof value === 'number' &&
	            isFinite(value) &&
	            Math.floor(value) === value;
	    });
	/**
	 * Returns whether a variable is either undefined or null.
	 */
	function isNullOrUndefined(value) {
	    return value === null || value === undefined;
	}
	exports.isNullOrUndefined = isNullOrUndefined;
	/**
	 * Returns whether a value is an integer and in the safe integer range
	 * @param value The value to test for being an integer and in the safe range
	 */
	function isSafeInteger(value) {
	    return (exports.isInteger(value) &&
	        value <= exports.MAX_SAFE_INTEGER &&
	        value >= exports.MIN_SAFE_INTEGER);
	}
	exports.isSafeInteger = isSafeInteger;
	/**
	 * Safely checks if the number is NaN.
	 */
	function safeIsNaN(value) {
	    if (NumberAsAny.IsNaN) {
	        return NumberAsAny.IsNaN(value);
	    }
	    else {
	        return typeof value === 'number' && isNaN(value);
	    }
	}
	exports.safeIsNaN = safeIsNaN;
	
	//# sourceMappingURL=types.js.map


/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var errorsExports = __webpack_require__(30);
	exports.StringFormat = {
	    RAW: 'raw',
	    BASE64: 'base64',
	    BASE64URL: 'base64url',
	    DATA_URL: 'data_url'
	};
	function formatValidator(stringFormat) {
	    switch (stringFormat) {
	        case exports.StringFormat.RAW:
	        case exports.StringFormat.BASE64:
	        case exports.StringFormat.BASE64URL:
	        case exports.StringFormat.DATA_URL:
	            return;
	        default:
	            throw 'Expected one of the event types: [' +
	                exports.StringFormat.RAW +
	                ', ' +
	                exports.StringFormat.BASE64 +
	                ', ' +
	                exports.StringFormat.BASE64URL +
	                ', ' +
	                exports.StringFormat.DATA_URL +
	                '].';
	    }
	}
	exports.formatValidator = formatValidator;
	/**
	 * @struct
	 */
	var StringData = /** @class */ (function () {
	    function StringData(data, opt_contentType) {
	        this.data = data;
	        this.contentType = opt_contentType || null;
	    }
	    return StringData;
	}());
	exports.StringData = StringData;
	function dataFromString(format, string) {
	    switch (format) {
	        case exports.StringFormat.RAW:
	            return new StringData(utf8Bytes_(string));
	        case exports.StringFormat.BASE64:
	        case exports.StringFormat.BASE64URL:
	            return new StringData(base64Bytes_(format, string));
	        case exports.StringFormat.DATA_URL:
	            return new StringData(dataURLBytes_(string), dataURLContentType_(string));
	    }
	    // assert(false);
	    throw errorsExports.unknown();
	}
	exports.dataFromString = dataFromString;
	function utf8Bytes_(string) {
	    var b = [];
	    for (var i = 0; i < string.length; i++) {
	        var c = string.charCodeAt(i);
	        if (c <= 127) {
	            b.push(c);
	        }
	        else {
	            if (c <= 2047) {
	                b.push(192 | (c >> 6), 128 | (c & 63));
	            }
	            else {
	                if ((c & 64512) == 55296) {
	                    // The start of a surrogate pair.
	                    var valid = i < string.length - 1 &&
	                        (string.charCodeAt(i + 1) & 64512) == 56320;
	                    if (!valid) {
	                        // The second surrogate wasn't there.
	                        b.push(239, 191, 189);
	                    }
	                    else {
	                        var hi = c;
	                        var lo = string.charCodeAt(++i);
	                        c = 65536 | ((hi & 1023) << 10) | (lo & 1023);
	                        b.push(240 | (c >> 18), 128 | ((c >> 12) & 63), 128 | ((c >> 6) & 63), 128 | (c & 63));
	                    }
	                }
	                else {
	                    if ((c & 64512) == 56320) {
	                        // Invalid low surrogate.
	                        b.push(239, 191, 189);
	                    }
	                    else {
	                        b.push(224 | (c >> 12), 128 | ((c >> 6) & 63), 128 | (c & 63));
	                    }
	                }
	            }
	        }
	    }
	    return new Uint8Array(b);
	}
	exports.utf8Bytes_ = utf8Bytes_;
	function percentEncodedBytes_(string) {
	    var decoded;
	    try {
	        decoded = decodeURIComponent(string);
	    }
	    catch (e) {
	        throw errorsExports.invalidFormat(exports.StringFormat.DATA_URL, 'Malformed data URL.');
	    }
	    return utf8Bytes_(decoded);
	}
	exports.percentEncodedBytes_ = percentEncodedBytes_;
	function base64Bytes_(format, string) {
	    switch (format) {
	        case exports.StringFormat.BASE64: {
	            var hasMinus = string.indexOf('-') !== -1;
	            var hasUnder = string.indexOf('_') !== -1;
	            if (hasMinus || hasUnder) {
	                var invalidChar = hasMinus ? '-' : '_';
	                throw errorsExports.invalidFormat(format, "Invalid character '" +
	                    invalidChar +
	                    "' found: is it base64url encoded?");
	            }
	            break;
	        }
	        case exports.StringFormat.BASE64URL: {
	            var hasPlus = string.indexOf('+') !== -1;
	            var hasSlash = string.indexOf('/') !== -1;
	            if (hasPlus || hasSlash) {
	                var invalidChar = hasPlus ? '+' : '/';
	                throw errorsExports.invalidFormat(format, "Invalid character '" + invalidChar + "' found: is it base64 encoded?");
	            }
	            string = string.replace(/-/g, '+').replace(/_/g, '/');
	            break;
	        }
	    }
	    var bytes;
	    try {
	        bytes = atob(string);
	    }
	    catch (e) {
	        throw errorsExports.invalidFormat(format, 'Invalid character found');
	    }
	    var array = new Uint8Array(bytes.length);
	    for (var i = 0; i < bytes.length; i++) {
	        array[i] = bytes.charCodeAt(i);
	    }
	    return array;
	}
	exports.base64Bytes_ = base64Bytes_;
	/**
	 * @struct
	 */
	var DataURLParts = /** @class */ (function () {
	    function DataURLParts(dataURL) {
	        this.base64 = false;
	        this.contentType = null;
	        var matches = dataURL.match(/^data:([^,]+)?,/);
	        if (matches === null) {
	            throw errorsExports.invalidFormat(exports.StringFormat.DATA_URL, "Must be formatted 'data:[<mediatype>][;base64],<data>");
	        }
	        var middle = matches[1] || null;
	        if (middle != null) {
	            this.base64 = endsWith(middle, ';base64');
	            this.contentType = this.base64
	                ? middle.substring(0, middle.length - ';base64'.length)
	                : middle;
	        }
	        this.rest = dataURL.substring(dataURL.indexOf(',') + 1);
	    }
	    return DataURLParts;
	}());
	function dataURLBytes_(string) {
	    var parts = new DataURLParts(string);
	    if (parts.base64) {
	        return base64Bytes_(exports.StringFormat.BASE64, parts.rest);
	    }
	    else {
	        return percentEncodedBytes_(parts.rest);
	    }
	}
	exports.dataURLBytes_ = dataURLBytes_;
	function dataURLContentType_(string) {
	    var parts = new DataURLParts(string);
	    return parts.contentType;
	}
	exports.dataURLContentType_ = dataURLContentType_;
	function endsWith(s, end) {
	    var longEnough = s.length >= end.length;
	    if (!longEnough) {
	        return false;
	    }
	    return s.substring(s.length - end.length) === end;
	}
	
	//# sourceMappingURL=string.js.map


/***/ }),
/* 57 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.TaskEvent = {
	    /** Triggered whenever the task changes or progress is updated. */
	    STATE_CHANGED: 'state_changed'
	};
	exports.InternalTaskState = {
	    RUNNING: 'running',
	    PAUSING: 'pausing',
	    PAUSED: 'paused',
	    SUCCESS: 'success',
	    CANCELING: 'canceling',
	    CANCELED: 'canceled',
	    ERROR: 'error'
	};
	exports.TaskState = {
	    /** The task is currently transferring data. */
	    RUNNING: 'running',
	    /** The task was paused by the user. */
	    PAUSED: 'paused',
	    /** The task completed successfully. */
	    SUCCESS: 'success',
	    /** The task was canceled. */
	    CANCELED: 'canceled',
	    /** The task failed with an error. */
	    ERROR: 'error'
	};
	function taskStateFromInternalTaskState(state) {
	    switch (state) {
	        case exports.InternalTaskState.RUNNING:
	        case exports.InternalTaskState.PAUSING:
	        case exports.InternalTaskState.CANCELING:
	            return exports.TaskState.RUNNING;
	        case exports.InternalTaskState.PAUSED:
	            return exports.TaskState.PAUSED;
	        case exports.InternalTaskState.SUCCESS:
	            return exports.TaskState.SUCCESS;
	        case exports.InternalTaskState.CANCELED:
	            return exports.TaskState.CANCELED;
	        case exports.InternalTaskState.ERROR:
	            return exports.TaskState.ERROR;
	        default:
	            // TODO(andysoto): assert(false);
	            return exports.TaskState.ERROR;
	    }
	}
	exports.taskStateFromInternalTaskState = taskStateFromInternalTaskState;
	
	//# sourceMappingURL=taskenums.js.map


/***/ }),
/* 58 */
/***/ (function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;
	
	process.listeners = function (name) { return [] }
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(6);
	
	var EventPluginRegistry = __webpack_require__(119);
	var EventPluginUtils = __webpack_require__(120);
	var ReactErrorUtils = __webpack_require__(124);
	
	var accumulateInto = __webpack_require__(208);
	var forEachAccumulated = __webpack_require__(209);
	var invariant = __webpack_require__(3);
	
	/**
	 * Internal store for event listeners
	 */
	var listenerBank = {};
	
	/**
	 * Internal queue of events that have accumulated their dispatches and are
	 * waiting to have their dispatches executed.
	 */
	var eventQueue = null;
	
	/**
	 * Dispatches an event and releases it back into the pool, unless persistent.
	 *
	 * @param {?object} event Synthetic event to be dispatched.
	 * @param {boolean} simulated If the event is simulated (changes exn behavior)
	 * @private
	 */
	var executeDispatchesAndRelease = function (event, simulated) {
	  if (event) {
	    EventPluginUtils.executeDispatchesInOrder(event, simulated);
	
	    if (!event.isPersistent()) {
	      event.constructor.release(event);
	    }
	  }
	};
	var executeDispatchesAndReleaseSimulated = function (e) {
	  return executeDispatchesAndRelease(e, true);
	};
	var executeDispatchesAndReleaseTopLevel = function (e) {
	  return executeDispatchesAndRelease(e, false);
	};
	
	var getDictionaryKey = function (inst) {
	  // Prevents V8 performance issue:
	  // https://github.com/facebook/react/pull/7232
	  return '.' + inst._rootNodeID;
	};
	
	function isInteractive(tag) {
	  return tag === 'button' || tag === 'input' || tag === 'select' || tag === 'textarea';
	}
	
	function shouldPreventMouseEvent(name, type, props) {
	  switch (name) {
	    case 'onClick':
	    case 'onClickCapture':
	    case 'onDoubleClick':
	    case 'onDoubleClickCapture':
	    case 'onMouseDown':
	    case 'onMouseDownCapture':
	    case 'onMouseMove':
	    case 'onMouseMoveCapture':
	    case 'onMouseUp':
	    case 'onMouseUpCapture':
	      return !!(props.disabled && isInteractive(type));
	    default:
	      return false;
	  }
	}
	
	/**
	 * This is a unified interface for event plugins to be installed and configured.
	 *
	 * Event plugins can implement the following properties:
	 *
	 *   `extractEvents` {function(string, DOMEventTarget, string, object): *}
	 *     Required. When a top-level event is fired, this method is expected to
	 *     extract synthetic events that will in turn be queued and dispatched.
	 *
	 *   `eventTypes` {object}
	 *     Optional, plugins that fire events must publish a mapping of registration
	 *     names that are used to register listeners. Values of this mapping must
	 *     be objects that contain `registrationName` or `phasedRegistrationNames`.
	 *
	 *   `executeDispatch` {function(object, function, string)}
	 *     Optional, allows plugins to override how an event gets dispatched. By
	 *     default, the listener is simply invoked.
	 *
	 * Each plugin that is injected into `EventsPluginHub` is immediately operable.
	 *
	 * @public
	 */
	var EventPluginHub = {
	  /**
	   * Methods for injecting dependencies.
	   */
	  injection: {
	    /**
	     * @param {array} InjectedEventPluginOrder
	     * @public
	     */
	    injectEventPluginOrder: EventPluginRegistry.injectEventPluginOrder,
	
	    /**
	     * @param {object} injectedNamesToPlugins Map from names to plugin modules.
	     */
	    injectEventPluginsByName: EventPluginRegistry.injectEventPluginsByName
	  },
	
	  /**
	   * Stores `listener` at `listenerBank[registrationName][key]`. Is idempotent.
	   *
	   * @param {object} inst The instance, which is the source of events.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @param {function} listener The callback to store.
	   */
	  putListener: function (inst, registrationName, listener) {
	    !(typeof listener === 'function') ?  false ? invariant(false, 'Expected %s listener to be a function, instead got type %s', registrationName, typeof listener) : _prodInvariant('94', registrationName, typeof listener) : void 0;
	
	    var key = getDictionaryKey(inst);
	    var bankForRegistrationName = listenerBank[registrationName] || (listenerBank[registrationName] = {});
	    bankForRegistrationName[key] = listener;
	
	    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	    if (PluginModule && PluginModule.didPutListener) {
	      PluginModule.didPutListener(inst, registrationName, listener);
	    }
	  },
	
	  /**
	   * @param {object} inst The instance, which is the source of events.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @return {?function} The stored callback.
	   */
	  getListener: function (inst, registrationName) {
	    // TODO: shouldPreventMouseEvent is DOM-specific and definitely should not
	    // live here; needs to be moved to a better place soon
	    var bankForRegistrationName = listenerBank[registrationName];
	    if (shouldPreventMouseEvent(registrationName, inst._currentElement.type, inst._currentElement.props)) {
	      return null;
	    }
	    var key = getDictionaryKey(inst);
	    return bankForRegistrationName && bankForRegistrationName[key];
	  },
	
	  /**
	   * Deletes a listener from the registration bank.
	   *
	   * @param {object} inst The instance, which is the source of events.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   */
	  deleteListener: function (inst, registrationName) {
	    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	    if (PluginModule && PluginModule.willDeleteListener) {
	      PluginModule.willDeleteListener(inst, registrationName);
	    }
	
	    var bankForRegistrationName = listenerBank[registrationName];
	    // TODO: This should never be null -- when is it?
	    if (bankForRegistrationName) {
	      var key = getDictionaryKey(inst);
	      delete bankForRegistrationName[key];
	    }
	  },
	
	  /**
	   * Deletes all listeners for the DOM element with the supplied ID.
	   *
	   * @param {object} inst The instance, which is the source of events.
	   */
	  deleteAllListeners: function (inst) {
	    var key = getDictionaryKey(inst);
	    for (var registrationName in listenerBank) {
	      if (!listenerBank.hasOwnProperty(registrationName)) {
	        continue;
	      }
	
	      if (!listenerBank[registrationName][key]) {
	        continue;
	      }
	
	      var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	      if (PluginModule && PluginModule.willDeleteListener) {
	        PluginModule.willDeleteListener(inst, registrationName);
	      }
	
	      delete listenerBank[registrationName][key];
	    }
	  },
	
	  /**
	   * Allows registered plugins an opportunity to extract events from top-level
	   * native browser events.
	   *
	   * @return {*} An accumulation of synthetic events.
	   * @internal
	   */
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var events;
	    var plugins = EventPluginRegistry.plugins;
	    for (var i = 0; i < plugins.length; i++) {
	      // Not every plugin in the ordering may be loaded at runtime.
	      var possiblePlugin = plugins[i];
	      if (possiblePlugin) {
	        var extractedEvents = possiblePlugin.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
	        if (extractedEvents) {
	          events = accumulateInto(events, extractedEvents);
	        }
	      }
	    }
	    return events;
	  },
	
	  /**
	   * Enqueues a synthetic event that should be dispatched when
	   * `processEventQueue` is invoked.
	   *
	   * @param {*} events An accumulation of synthetic events.
	   * @internal
	   */
	  enqueueEvents: function (events) {
	    if (events) {
	      eventQueue = accumulateInto(eventQueue, events);
	    }
	  },
	
	  /**
	   * Dispatches all synthetic events on the event queue.
	   *
	   * @internal
	   */
	  processEventQueue: function (simulated) {
	    // Set `eventQueue` to null before processing it so that we can tell if more
	    // events get enqueued while processing.
	    var processingEventQueue = eventQueue;
	    eventQueue = null;
	    if (simulated) {
	      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseSimulated);
	    } else {
	      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseTopLevel);
	    }
	    !!eventQueue ?  false ? invariant(false, 'processEventQueue(): Additional events were enqueued while processing an event queue. Support for this has not yet been implemented.') : _prodInvariant('95') : void 0;
	    // This would be a good time to rethrow if any of the event handlers threw.
	    ReactErrorUtils.rethrowCaughtError();
	  },
	
	  /**
	   * These are needed for tests only. Do not use!
	   */
	  __purge: function () {
	    listenerBank = {};
	  },
	
	  __getListenerBank: function () {
	    return listenerBank;
	  }
	};
	
	module.exports = EventPluginHub;

/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var EventPluginHub = __webpack_require__(59);
	var EventPluginUtils = __webpack_require__(120);
	
	var accumulateInto = __webpack_require__(208);
	var forEachAccumulated = __webpack_require__(209);
	var warning = __webpack_require__(5);
	
	var getListener = EventPluginHub.getListener;
	
	/**
	 * Some event types have a notion of different registration names for different
	 * "phases" of propagation. This finds listeners by a given phase.
	 */
	function listenerAtPhase(inst, event, propagationPhase) {
	  var registrationName = event.dispatchConfig.phasedRegistrationNames[propagationPhase];
	  return getListener(inst, registrationName);
	}
	
	/**
	 * Tags a `SyntheticEvent` with dispatched listeners. Creating this function
	 * here, allows us to not have to bind or create functions for each event.
	 * Mutating the event's members allows us to not have to create a wrapping
	 * "dispatch" object that pairs the event with the listener.
	 */
	function accumulateDirectionalDispatches(inst, phase, event) {
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(inst, 'Dispatching inst must not be null') : void 0;
	  }
	  var listener = listenerAtPhase(inst, event, phase);
	  if (listener) {
	    event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
	    event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
	  }
	}
	
	/**
	 * Collect dispatches (must be entirely collected before dispatching - see unit
	 * tests). Lazily allocate the array to conserve memory.  We must loop through
	 * each event and perform the traversal for each one. We cannot perform a
	 * single traversal for the entire collection of events because each event may
	 * have a different target.
	 */
	function accumulateTwoPhaseDispatchesSingle(event) {
	  if (event && event.dispatchConfig.phasedRegistrationNames) {
	    EventPluginUtils.traverseTwoPhase(event._targetInst, accumulateDirectionalDispatches, event);
	  }
	}
	
	/**
	 * Same as `accumulateTwoPhaseDispatchesSingle`, but skips over the targetID.
	 */
	function accumulateTwoPhaseDispatchesSingleSkipTarget(event) {
	  if (event && event.dispatchConfig.phasedRegistrationNames) {
	    var targetInst = event._targetInst;
	    var parentInst = targetInst ? EventPluginUtils.getParentInstance(targetInst) : null;
	    EventPluginUtils.traverseTwoPhase(parentInst, accumulateDirectionalDispatches, event);
	  }
	}
	
	/**
	 * Accumulates without regard to direction, does not look for phased
	 * registration names. Same as `accumulateDirectDispatchesSingle` but without
	 * requiring that the `dispatchMarker` be the same as the dispatched ID.
	 */
	function accumulateDispatches(inst, ignoredDirection, event) {
	  if (event && event.dispatchConfig.registrationName) {
	    var registrationName = event.dispatchConfig.registrationName;
	    var listener = getListener(inst, registrationName);
	    if (listener) {
	      event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
	      event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
	    }
	  }
	}
	
	/**
	 * Accumulates dispatches on an `SyntheticEvent`, but only for the
	 * `dispatchMarker`.
	 * @param {SyntheticEvent} event
	 */
	function accumulateDirectDispatchesSingle(event) {
	  if (event && event.dispatchConfig.registrationName) {
	    accumulateDispatches(event._targetInst, null, event);
	  }
	}
	
	function accumulateTwoPhaseDispatches(events) {
	  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingle);
	}
	
	function accumulateTwoPhaseDispatchesSkipTarget(events) {
	  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingleSkipTarget);
	}
	
	function accumulateEnterLeaveDispatches(leave, enter, from, to) {
	  EventPluginUtils.traverseEnterLeave(from, to, accumulateDispatches, leave, enter);
	}
	
	function accumulateDirectDispatches(events) {
	  forEachAccumulated(events, accumulateDirectDispatchesSingle);
	}
	
	/**
	 * A small set of propagation patterns, each of which will accept a small amount
	 * of information, and generate a set of "dispatch ready event objects" - which
	 * are sets of events that have already been annotated with a set of dispatched
	 * listener functions/ids. The API is designed this way to discourage these
	 * propagation strategies from actually executing the dispatches, since we
	 * always want to collect the entire set of dispatches before executing event a
	 * single one.
	 *
	 * @constructor EventPropagators
	 */
	var EventPropagators = {
	  accumulateTwoPhaseDispatches: accumulateTwoPhaseDispatches,
	  accumulateTwoPhaseDispatchesSkipTarget: accumulateTwoPhaseDispatchesSkipTarget,
	  accumulateDirectDispatches: accumulateDirectDispatches,
	  accumulateEnterLeaveDispatches: accumulateEnterLeaveDispatches
	};
	
	module.exports = EventPropagators;

/***/ }),
/* 61 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * `ReactInstanceMap` maintains a mapping from a public facing stateful
	 * instance (key) and the internal representation (value). This allows public
	 * methods to accept the user facing instance as an argument and map them back
	 * to internal methods.
	 */
	
	// TODO: Replace this with ES6: var ReactInstanceMap = new Map();
	
	var ReactInstanceMap = {
	  /**
	   * This API should be called `delete` but we'd have to make sure to always
	   * transform these to strings for IE support. When this transform is fully
	   * supported we can rename it.
	   */
	  remove: function (key) {
	    key._reactInternalInstance = undefined;
	  },
	
	  get: function (key) {
	    return key._reactInternalInstance;
	  },
	
	  has: function (key) {
	    return key._reactInternalInstance !== undefined;
	  },
	
	  set: function (key, value) {
	    key._reactInternalInstance = value;
	  }
	};
	
	module.exports = ReactInstanceMap;

/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(31);
	
	var getEventTarget = __webpack_require__(129);
	
	/**
	 * @interface UIEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var UIEventInterface = {
	  view: function (event) {
	    if (event.view) {
	      return event.view;
	    }
	
	    var target = getEventTarget(event);
	    if (target.window === target) {
	      // target is a window object
	      return target;
	    }
	
	    var doc = target.ownerDocument;
	    // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
	    if (doc) {
	      return doc.defaultView || doc.parentWindow;
	    } else {
	      return window;
	    }
	  },
	  detail: function (event) {
	    return event.detail || 0;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticUIEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticUIEvent, UIEventInterface);
	
	module.exports = SyntheticUIEvent;

/***/ }),
/* 63 */
6,
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(47);


/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var ServerValues_1 = __webpack_require__(151);
	var nodeFromJSON_1 = __webpack_require__(50);
	var Path_1 = __webpack_require__(8);
	var SparseSnapshotTree_1 = __webpack_require__(139);
	var SyncTree_1 = __webpack_require__(233);
	var SnapshotHolder_1 = __webpack_require__(232);
	var util_1 = __webpack_require__(1);
	var util_2 = __webpack_require__(4);
	var util_3 = __webpack_require__(1);
	var AuthTokenProvider_1 = __webpack_require__(228);
	var StatsManager_1 = __webpack_require__(92);
	var StatsReporter_1 = __webpack_require__(239);
	var StatsListener_1 = __webpack_require__(148);
	var EventQueue_1 = __webpack_require__(250);
	var PersistentConnection_1 = __webpack_require__(136);
	var ReadonlyRestClient_1 = __webpack_require__(230);
	var Database_1 = __webpack_require__(133);
	var INTERRUPT_REASON = 'repo_interrupt';
	/**
	 * A connection to a single data repository.
	 */
	var Repo = /** @class */ (function () {
	    /**
	     * @param {!RepoInfo} repoInfo_
	     * @param {boolean} forceRestClient
	     * @param {!FirebaseApp} app
	     */
	    function Repo(repoInfo_, forceRestClient, app) {
	        var _this = this;
	        this.repoInfo_ = repoInfo_;
	        this.app = app;
	        this.dataUpdateCount = 0;
	        this.statsListener_ = null;
	        this.eventQueue_ = new EventQueue_1.EventQueue();
	        this.nextWriteId_ = 1;
	        this.interceptServerDataCallback_ = null;
	        // A list of data pieces and paths to be set when this client disconnects.
	        this.onDisconnect_ = new SparseSnapshotTree_1.SparseSnapshotTree();
	        /**
	         * TODO: This should be @private but it's used by test_access.js and internal.js
	         * @type {?PersistentConnection}
	         */
	        this.persistentConnection_ = null;
	        /** @type {!AuthTokenProvider} */
	        var authTokenProvider = new AuthTokenProvider_1.AuthTokenProvider(app);
	        this.stats_ = StatsManager_1.StatsManager.getCollection(repoInfo_);
	        if (forceRestClient || util_2.beingCrawled()) {
	            this.server_ = new ReadonlyRestClient_1.ReadonlyRestClient(this.repoInfo_, this.onDataUpdate_.bind(this), authTokenProvider);
	            // Minor hack: Fire onConnect immediately, since there's no actual connection.
	            setTimeout(this.onConnectStatus_.bind(this, true), 0);
	        }
	        else {
	            var authOverride = app.options['databaseAuthVariableOverride'];
	            // Validate authOverride
	            if (typeof authOverride !== 'undefined' && authOverride !== null) {
	                if (typeof authOverride !== 'object') {
	                    throw new Error('Only objects are supported for option databaseAuthVariableOverride');
	                }
	                try {
	                    util_1.stringify(authOverride);
	                }
	                catch (e) {
	                    throw new Error('Invalid authOverride provided: ' + e);
	                }
	            }
	            this.persistentConnection_ = new PersistentConnection_1.PersistentConnection(this.repoInfo_, this.onDataUpdate_.bind(this), this.onConnectStatus_.bind(this), this.onServerInfoUpdate_.bind(this), authTokenProvider, authOverride);
	            this.server_ = this.persistentConnection_;
	        }
	        authTokenProvider.addTokenChangeListener(function (token) {
	            _this.server_.refreshAuthToken(token);
	        });
	        // In the case of multiple Repos for the same repoInfo (i.e. there are multiple Firebase.Contexts being used),
	        // we only want to create one StatsReporter.  As such, we'll report stats over the first Repo created.
	        this.statsReporter_ = StatsManager_1.StatsManager.getOrCreateReporter(repoInfo_, function () { return new StatsReporter_1.StatsReporter(_this.stats_, _this.server_); });
	        this.transactions_init_();
	        // Used for .info.
	        this.infoData_ = new SnapshotHolder_1.SnapshotHolder();
	        this.infoSyncTree_ = new SyncTree_1.SyncTree({
	            startListening: function (query, tag, currentHashFn, onComplete) {
	                var infoEvents = [];
	                var node = _this.infoData_.getNode(query.path);
	                // This is possibly a hack, but we have different semantics for .info endpoints. We don't raise null events
	                // on initial data...
	                if (!node.isEmpty()) {
	                    infoEvents = _this.infoSyncTree_.applyServerOverwrite(query.path, node);
	                    setTimeout(function () {
	                        onComplete('ok');
	                    }, 0);
	                }
	                return infoEvents;
	            },
	            stopListening: function () { }
	        });
	        this.updateInfo_('connected', false);
	        this.serverSyncTree_ = new SyncTree_1.SyncTree({
	            startListening: function (query, tag, currentHashFn, onComplete) {
	                _this.server_.listen(query, currentHashFn, tag, function (status, data) {
	                    var events = onComplete(status, data);
	                    _this.eventQueue_.raiseEventsForChangedPath(query.path, events);
	                });
	                // No synchronous events for network-backed sync trees
	                return [];
	            },
	            stopListening: function (query, tag) {
	                _this.server_.unlisten(query, tag);
	            }
	        });
	    }
	    /**
	     * @return {string}  The URL corresponding to the root of this Firebase.
	     */
	    Repo.prototype.toString = function () {
	        return ((this.repoInfo_.secure ? 'https://' : 'http://') + this.repoInfo_.host);
	    };
	    /**
	     * @return {!string} The namespace represented by the repo.
	     */
	    Repo.prototype.name = function () {
	        return this.repoInfo_.namespace;
	    };
	    /**
	     * @return {!number} The time in milliseconds, taking the server offset into account if we have one.
	     */
	    Repo.prototype.serverTime = function () {
	        var offsetNode = this.infoData_.getNode(new Path_1.Path('.info/serverTimeOffset'));
	        var offset = offsetNode.val() || 0;
	        return new Date().getTime() + offset;
	    };
	    /**
	     * Generate ServerValues using some variables from the repo object.
	     * @return {!Object}
	     */
	    Repo.prototype.generateServerValues = function () {
	        return ServerValues_1.generateWithValues({
	            timestamp: this.serverTime()
	        });
	    };
	    /**
	     * Called by realtime when we get new messages from the server.
	     *
	     * @private
	     * @param {string} pathString
	     * @param {*} data
	     * @param {boolean} isMerge
	     * @param {?number} tag
	     */
	    Repo.prototype.onDataUpdate_ = function (pathString, data, isMerge, tag) {
	        // For testing.
	        this.dataUpdateCount++;
	        var path = new Path_1.Path(pathString);
	        data = this.interceptServerDataCallback_
	            ? this.interceptServerDataCallback_(pathString, data)
	            : data;
	        var events = [];
	        if (tag) {
	            if (isMerge) {
	                var taggedChildren = util_3.map(data, function (raw) {
	                    return nodeFromJSON_1.nodeFromJSON(raw);
	                });
	                events = this.serverSyncTree_.applyTaggedQueryMerge(path, taggedChildren, tag);
	            }
	            else {
	                var taggedSnap = nodeFromJSON_1.nodeFromJSON(data);
	                events = this.serverSyncTree_.applyTaggedQueryOverwrite(path, taggedSnap, tag);
	            }
	        }
	        else if (isMerge) {
	            var changedChildren = util_3.map(data, function (raw) {
	                return nodeFromJSON_1.nodeFromJSON(raw);
	            });
	            events = this.serverSyncTree_.applyServerMerge(path, changedChildren);
	        }
	        else {
	            var snap = nodeFromJSON_1.nodeFromJSON(data);
	            events = this.serverSyncTree_.applyServerOverwrite(path, snap);
	        }
	        var affectedPath = path;
	        if (events.length > 0) {
	            // Since we have a listener outstanding for each transaction, receiving any events
	            // is a proxy for some change having occurred.
	            affectedPath = this.rerunTransactions_(path);
	        }
	        this.eventQueue_.raiseEventsForChangedPath(affectedPath, events);
	    };
	    /**
	     * TODO: This should be @private but it's used by test_access.js and internal.js
	     * @param {?function(!string, *):*} callback
	     * @private
	     */
	    Repo.prototype.interceptServerData_ = function (callback) {
	        this.interceptServerDataCallback_ = callback;
	    };
	    /**
	     * @param {!boolean} connectStatus
	     * @private
	     */
	    Repo.prototype.onConnectStatus_ = function (connectStatus) {
	        this.updateInfo_('connected', connectStatus);
	        if (connectStatus === false) {
	            this.runOnDisconnectEvents_();
	        }
	    };
	    /**
	     * @param {!Object} updates
	     * @private
	     */
	    Repo.prototype.onServerInfoUpdate_ = function (updates) {
	        var _this = this;
	        util_2.each(updates, function (value, key) {
	            _this.updateInfo_(key, value);
	        });
	    };
	    /**
	     *
	     * @param {!string} pathString
	     * @param {*} value
	     * @private
	     */
	    Repo.prototype.updateInfo_ = function (pathString, value) {
	        var path = new Path_1.Path('/.info/' + pathString);
	        var newNode = nodeFromJSON_1.nodeFromJSON(value);
	        this.infoData_.updateSnapshot(path, newNode);
	        var events = this.infoSyncTree_.applyServerOverwrite(path, newNode);
	        this.eventQueue_.raiseEventsForChangedPath(path, events);
	    };
	    /**
	     * @return {!number}
	     * @private
	     */
	    Repo.prototype.getNextWriteId_ = function () {
	        return this.nextWriteId_++;
	    };
	    /**
	     * @param {!Path} path
	     * @param {*} newVal
	     * @param {number|string|null} newPriority
	     * @param {?function(?Error, *=)} onComplete
	     */
	    Repo.prototype.setWithPriority = function (path, newVal, newPriority, onComplete) {
	        var _this = this;
	        this.log_('set', {
	            path: path.toString(),
	            value: newVal,
	            priority: newPriority
	        });
	        // TODO: Optimize this behavior to either (a) store flag to skip resolving where possible and / or
	        // (b) store unresolved paths on JSON parse
	        var serverValues = this.generateServerValues();
	        var newNodeUnresolved = nodeFromJSON_1.nodeFromJSON(newVal, newPriority);
	        var newNode = ServerValues_1.resolveDeferredValueSnapshot(newNodeUnresolved, serverValues);
	        var writeId = this.getNextWriteId_();
	        var events = this.serverSyncTree_.applyUserOverwrite(path, newNode, writeId, true);
	        this.eventQueue_.queueEvents(events);
	        this.server_.put(path.toString(), newNodeUnresolved.val(/*export=*/ true), function (status, errorReason) {
	            var success = status === 'ok';
	            if (!success) {
	                util_2.warn('set at ' + path + ' failed: ' + status);
	            }
	            var clearEvents = _this.serverSyncTree_.ackUserWrite(writeId, !success);
	            _this.eventQueue_.raiseEventsForChangedPath(path, clearEvents);
	            _this.callOnCompleteCallback(onComplete, status, errorReason);
	        });
	        var affectedPath = this.abortTransactions_(path);
	        this.rerunTransactions_(affectedPath);
	        // We queued the events above, so just flush the queue here
	        this.eventQueue_.raiseEventsForChangedPath(affectedPath, []);
	    };
	    /**
	     * @param {!Path} path
	     * @param {!Object} childrenToMerge
	     * @param {?function(?Error, *=)} onComplete
	     */
	    Repo.prototype.update = function (path, childrenToMerge, onComplete) {
	        var _this = this;
	        this.log_('update', { path: path.toString(), value: childrenToMerge });
	        // Start with our existing data and merge each child into it.
	        var empty = true;
	        var serverValues = this.generateServerValues();
	        var changedChildren = {};
	        util_3.forEach(childrenToMerge, function (changedKey, changedValue) {
	            empty = false;
	            var newNodeUnresolved = nodeFromJSON_1.nodeFromJSON(changedValue);
	            changedChildren[changedKey] = ServerValues_1.resolveDeferredValueSnapshot(newNodeUnresolved, serverValues);
	        });
	        if (!empty) {
	            var writeId_1 = this.getNextWriteId_();
	            var events = this.serverSyncTree_.applyUserMerge(path, changedChildren, writeId_1);
	            this.eventQueue_.queueEvents(events);
	            this.server_.merge(path.toString(), childrenToMerge, function (status, errorReason) {
	                var success = status === 'ok';
	                if (!success) {
	                    util_2.warn('update at ' + path + ' failed: ' + status);
	                }
	                var clearEvents = _this.serverSyncTree_.ackUserWrite(writeId_1, !success);
	                var affectedPath = clearEvents.length > 0 ? _this.rerunTransactions_(path) : path;
	                _this.eventQueue_.raiseEventsForChangedPath(affectedPath, clearEvents);
	                _this.callOnCompleteCallback(onComplete, status, errorReason);
	            });
	            util_3.forEach(childrenToMerge, function (changedPath) {
	                var affectedPath = _this.abortTransactions_(path.child(changedPath));
	                _this.rerunTransactions_(affectedPath);
	            });
	            // We queued the events above, so just flush the queue here
	            this.eventQueue_.raiseEventsForChangedPath(path, []);
	        }
	        else {
	            util_2.log("update() called with empty data.  Don't do anything.");
	            this.callOnCompleteCallback(onComplete, 'ok');
	        }
	    };
	    /**
	     * Applies all of the changes stored up in the onDisconnect_ tree.
	     * @private
	     */
	    Repo.prototype.runOnDisconnectEvents_ = function () {
	        var _this = this;
	        this.log_('onDisconnectEvents');
	        var serverValues = this.generateServerValues();
	        var resolvedOnDisconnectTree = ServerValues_1.resolveDeferredValueTree(this.onDisconnect_, serverValues);
	        var events = [];
	        resolvedOnDisconnectTree.forEachTree(Path_1.Path.Empty, function (path, snap) {
	            events = events.concat(_this.serverSyncTree_.applyServerOverwrite(path, snap));
	            var affectedPath = _this.abortTransactions_(path);
	            _this.rerunTransactions_(affectedPath);
	        });
	        this.onDisconnect_ = new SparseSnapshotTree_1.SparseSnapshotTree();
	        this.eventQueue_.raiseEventsForChangedPath(Path_1.Path.Empty, events);
	    };
	    /**
	     * @param {!Path} path
	     * @param {?function(?Error, *=)} onComplete
	     */
	    Repo.prototype.onDisconnectCancel = function (path, onComplete) {
	        var _this = this;
	        this.server_.onDisconnectCancel(path.toString(), function (status, errorReason) {
	            if (status === 'ok') {
	                _this.onDisconnect_.forget(path);
	            }
	            _this.callOnCompleteCallback(onComplete, status, errorReason);
	        });
	    };
	    /**
	     * @param {!Path} path
	     * @param {*} value
	     * @param {?function(?Error, *=)} onComplete
	     */
	    Repo.prototype.onDisconnectSet = function (path, value, onComplete) {
	        var _this = this;
	        var newNode = nodeFromJSON_1.nodeFromJSON(value);
	        this.server_.onDisconnectPut(path.toString(), newNode.val(/*export=*/ true), function (status, errorReason) {
	            if (status === 'ok') {
	                _this.onDisconnect_.remember(path, newNode);
	            }
	            _this.callOnCompleteCallback(onComplete, status, errorReason);
	        });
	    };
	    /**
	     * @param {!Path} path
	     * @param {*} value
	     * @param {*} priority
	     * @param {?function(?Error, *=)} onComplete
	     */
	    Repo.prototype.onDisconnectSetWithPriority = function (path, value, priority, onComplete) {
	        var _this = this;
	        var newNode = nodeFromJSON_1.nodeFromJSON(value, priority);
	        this.server_.onDisconnectPut(path.toString(), newNode.val(/*export=*/ true), function (status, errorReason) {
	            if (status === 'ok') {
	                _this.onDisconnect_.remember(path, newNode);
	            }
	            _this.callOnCompleteCallback(onComplete, status, errorReason);
	        });
	    };
	    /**
	     * @param {!Path} path
	     * @param {*} childrenToMerge
	     * @param {?function(?Error, *=)} onComplete
	     */
	    Repo.prototype.onDisconnectUpdate = function (path, childrenToMerge, onComplete) {
	        var _this = this;
	        if (util_3.isEmpty(childrenToMerge)) {
	            util_2.log("onDisconnect().update() called with empty data.  Don't do anything.");
	            this.callOnCompleteCallback(onComplete, 'ok');
	            return;
	        }
	        this.server_.onDisconnectMerge(path.toString(), childrenToMerge, function (status, errorReason) {
	            if (status === 'ok') {
	                util_3.forEach(childrenToMerge, function (childName, childNode) {
	                    var newChildNode = nodeFromJSON_1.nodeFromJSON(childNode);
	                    _this.onDisconnect_.remember(path.child(childName), newChildNode);
	                });
	            }
	            _this.callOnCompleteCallback(onComplete, status, errorReason);
	        });
	    };
	    /**
	     * @param {!Query} query
	     * @param {!EventRegistration} eventRegistration
	     */
	    Repo.prototype.addEventCallbackForQuery = function (query, eventRegistration) {
	        var events;
	        if (query.path.getFront() === '.info') {
	            events = this.infoSyncTree_.addEventRegistration(query, eventRegistration);
	        }
	        else {
	            events = this.serverSyncTree_.addEventRegistration(query, eventRegistration);
	        }
	        this.eventQueue_.raiseEventsAtPath(query.path, events);
	    };
	    /**
	     * @param {!Query} query
	     * @param {?EventRegistration} eventRegistration
	     */
	    Repo.prototype.removeEventCallbackForQuery = function (query, eventRegistration) {
	        // These are guaranteed not to raise events, since we're not passing in a cancelError. However, we can future-proof
	        // a little bit by handling the return values anyways.
	        var events;
	        if (query.path.getFront() === '.info') {
	            events = this.infoSyncTree_.removeEventRegistration(query, eventRegistration);
	        }
	        else {
	            events = this.serverSyncTree_.removeEventRegistration(query, eventRegistration);
	        }
	        this.eventQueue_.raiseEventsAtPath(query.path, events);
	    };
	    Repo.prototype.interrupt = function () {
	        if (this.persistentConnection_) {
	            this.persistentConnection_.interrupt(INTERRUPT_REASON);
	        }
	    };
	    Repo.prototype.resume = function () {
	        if (this.persistentConnection_) {
	            this.persistentConnection_.resume(INTERRUPT_REASON);
	        }
	    };
	    Repo.prototype.stats = function (showDelta) {
	        if (showDelta === void 0) { showDelta = false; }
	        if (typeof console === 'undefined')
	            return;
	        var stats;
	        if (showDelta) {
	            if (!this.statsListener_)
	                this.statsListener_ = new StatsListener_1.StatsListener(this.stats_);
	            stats = this.statsListener_.get();
	        }
	        else {
	            stats = this.stats_.get();
	        }
	        var longestName = Object.keys(stats).reduce(function (previousValue, currentValue) {
	            return Math.max(currentValue.length, previousValue);
	        }, 0);
	        util_3.forEach(stats, function (stat, value) {
	            // pad stat names to be the same length (plus 2 extra spaces).
	            for (var i = stat.length; i < longestName + 2; i++)
	                stat += ' ';
	            console.log(stat + value);
	        });
	    };
	    Repo.prototype.statsIncrementCounter = function (metric) {
	        this.stats_.incrementCounter(metric);
	        this.statsReporter_.includeStat(metric);
	    };
	    /**
	     * @param {...*} var_args
	     * @private
	     */
	    Repo.prototype.log_ = function () {
	        var var_args = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            var_args[_i] = arguments[_i];
	        }
	        var prefix = '';
	        if (this.persistentConnection_) {
	            prefix = this.persistentConnection_.id + ':';
	        }
	        util_2.log.apply(void 0, [prefix].concat(var_args));
	    };
	    /**
	     * @param {?function(?Error, *=)} callback
	     * @param {!string} status
	     * @param {?string=} errorReason
	     */
	    Repo.prototype.callOnCompleteCallback = function (callback, status, errorReason) {
	        if (callback) {
	            util_2.exceptionGuard(function () {
	                if (status == 'ok') {
	                    callback(null);
	                }
	                else {
	                    var code = (status || 'error').toUpperCase();
	                    var message = code;
	                    if (errorReason)
	                        message += ': ' + errorReason;
	                    var error = new Error(message);
	                    error.code = code;
	                    callback(error);
	                }
	            });
	        }
	    };
	    Object.defineProperty(Repo.prototype, "database", {
	        get: function () {
	            return this.__database || (this.__database = new Database_1.Database(this));
	        },
	        enumerable: true,
	        configurable: true
	    });
	    return Repo;
	}());
	exports.Repo = Repo;
	
	//# sourceMappingURL=Repo.js.map


/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var util_1 = __webpack_require__(1);
	var util_2 = __webpack_require__(4);
	var snap_1 = __webpack_require__(147);
	var __childrenNodeConstructor;
	/**
	 * LeafNode is a class for storing leaf nodes in a DataSnapshot.  It
	 * implements Node and stores the value of the node (a string,
	 * number, or boolean) accessible via getValue().
	 */
	var LeafNode = /** @class */ (function () {
	    /**
	     * @implements {Node}
	     * @param {!(string|number|boolean|Object)} value_ The value to store in this leaf node.
	     *                                         The object type is possible in the event of a deferred value
	     * @param {!Node=} priorityNode_ The priority of this node.
	     */
	    function LeafNode(value_, priorityNode_) {
	        if (priorityNode_ === void 0) { priorityNode_ = LeafNode.__childrenNodeConstructor.EMPTY_NODE; }
	        this.value_ = value_;
	        this.priorityNode_ = priorityNode_;
	        this.lazyHash_ = null;
	        util_1.assert(this.value_ !== undefined && this.value_ !== null, "LeafNode shouldn't be created with null/undefined value.");
	        snap_1.validatePriorityNode(this.priorityNode_);
	    }
	    Object.defineProperty(LeafNode, "__childrenNodeConstructor", {
	        get: function () {
	            return __childrenNodeConstructor;
	        },
	        set: function (val) {
	            __childrenNodeConstructor = val;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    /** @inheritDoc */
	    LeafNode.prototype.isLeafNode = function () {
	        return true;
	    };
	    /** @inheritDoc */
	    LeafNode.prototype.getPriority = function () {
	        return this.priorityNode_;
	    };
	    /** @inheritDoc */
	    LeafNode.prototype.updatePriority = function (newPriorityNode) {
	        return new LeafNode(this.value_, newPriorityNode);
	    };
	    /** @inheritDoc */
	    LeafNode.prototype.getImmediateChild = function (childName) {
	        // Hack to treat priority as a regular child
	        if (childName === '.priority') {
	            return this.priorityNode_;
	        }
	        else {
	            return LeafNode.__childrenNodeConstructor.EMPTY_NODE;
	        }
	    };
	    /** @inheritDoc */
	    LeafNode.prototype.getChild = function (path) {
	        if (path.isEmpty()) {
	            return this;
	        }
	        else if (path.getFront() === '.priority') {
	            return this.priorityNode_;
	        }
	        else {
	            return LeafNode.__childrenNodeConstructor.EMPTY_NODE;
	        }
	    };
	    /**
	     * @inheritDoc
	     */
	    LeafNode.prototype.hasChild = function () {
	        return false;
	    };
	    /** @inheritDoc */
	    LeafNode.prototype.getPredecessorChildName = function (childName, childNode) {
	        return null;
	    };
	    /** @inheritDoc */
	    LeafNode.prototype.updateImmediateChild = function (childName, newChildNode) {
	        if (childName === '.priority') {
	            return this.updatePriority(newChildNode);
	        }
	        else if (newChildNode.isEmpty() && childName !== '.priority') {
	            return this;
	        }
	        else {
	            return LeafNode.__childrenNodeConstructor.EMPTY_NODE.updateImmediateChild(childName, newChildNode).updatePriority(this.priorityNode_);
	        }
	    };
	    /** @inheritDoc */
	    LeafNode.prototype.updateChild = function (path, newChildNode) {
	        var front = path.getFront();
	        if (front === null) {
	            return newChildNode;
	        }
	        else if (newChildNode.isEmpty() && front !== '.priority') {
	            return this;
	        }
	        else {
	            util_1.assert(front !== '.priority' || path.getLength() === 1, '.priority must be the last token in a path');
	            return this.updateImmediateChild(front, LeafNode.__childrenNodeConstructor.EMPTY_NODE.updateChild(path.popFront(), newChildNode));
	        }
	    };
	    /** @inheritDoc */
	    LeafNode.prototype.isEmpty = function () {
	        return false;
	    };
	    /** @inheritDoc */
	    LeafNode.prototype.numChildren = function () {
	        return 0;
	    };
	    /** @inheritDoc */
	    LeafNode.prototype.forEachChild = function (index, action) {
	        return false;
	    };
	    /**
	     * @inheritDoc
	     */
	    LeafNode.prototype.val = function (exportFormat) {
	        if (exportFormat && !this.getPriority().isEmpty())
	            return {
	                '.value': this.getValue(),
	                '.priority': this.getPriority().val()
	            };
	        else
	            return this.getValue();
	    };
	    /** @inheritDoc */
	    LeafNode.prototype.hash = function () {
	        if (this.lazyHash_ === null) {
	            var toHash = '';
	            if (!this.priorityNode_.isEmpty())
	                toHash +=
	                    'priority:' +
	                        snap_1.priorityHashText(this.priorityNode_.val()) +
	                        ':';
	            var type = typeof this.value_;
	            toHash += type + ':';
	            if (type === 'number') {
	                toHash += util_2.doubleToIEEE754String(this.value_);
	            }
	            else {
	                toHash += this.value_;
	            }
	            this.lazyHash_ = util_2.sha1(toHash);
	        }
	        return this.lazyHash_;
	    };
	    /**
	     * Returns the value of the leaf node.
	     * @return {Object|string|number|boolean} The value of the node.
	     */
	    LeafNode.prototype.getValue = function () {
	        return this.value_;
	    };
	    /**
	     * @inheritDoc
	     */
	    LeafNode.prototype.compareTo = function (other) {
	        if (other === LeafNode.__childrenNodeConstructor.EMPTY_NODE) {
	            return 1;
	        }
	        else if (other instanceof LeafNode.__childrenNodeConstructor) {
	            return -1;
	        }
	        else {
	            util_1.assert(other.isLeafNode(), 'Unknown node type');
	            return this.compareToLeafNode_(other);
	        }
	    };
	    /**
	     * Comparison specifically for two leaf nodes
	     * @param {!LeafNode} otherLeaf
	     * @return {!number}
	     * @private
	     */
	    LeafNode.prototype.compareToLeafNode_ = function (otherLeaf) {
	        var otherLeafType = typeof otherLeaf.value_;
	        var thisLeafType = typeof this.value_;
	        var otherIndex = LeafNode.VALUE_TYPE_ORDER.indexOf(otherLeafType);
	        var thisIndex = LeafNode.VALUE_TYPE_ORDER.indexOf(thisLeafType);
	        util_1.assert(otherIndex >= 0, 'Unknown leaf type: ' + otherLeafType);
	        util_1.assert(thisIndex >= 0, 'Unknown leaf type: ' + thisLeafType);
	        if (otherIndex === thisIndex) {
	            // Same type, compare values
	            if (thisLeafType === 'object') {
	                // Deferred value nodes are all equal, but we should also never get to this point...
	                return 0;
	            }
	            else {
	                // Note that this works because true > false, all others are number or string comparisons
	                if (this.value_ < otherLeaf.value_) {
	                    return -1;
	                }
	                else if (this.value_ === otherLeaf.value_) {
	                    return 0;
	                }
	                else {
	                    return 1;
	                }
	            }
	        }
	        else {
	            return thisIndex - otherIndex;
	        }
	    };
	    /**
	     * @inheritDoc
	     */
	    LeafNode.prototype.withIndex = function () {
	        return this;
	    };
	    /**
	     * @inheritDoc
	     */
	    LeafNode.prototype.isIndexed = function () {
	        return true;
	    };
	    /**
	     * @inheritDoc
	     */
	    LeafNode.prototype.equals = function (other) {
	        /**
	         * @inheritDoc
	         */
	        if (other === this) {
	            return true;
	        }
	        else if (other.isLeafNode()) {
	            var otherLeaf = other;
	            return (this.value_ === otherLeaf.value_ &&
	                this.priorityNode_.equals(otherLeaf.priorityNode_));
	        }
	        else {
	            return false;
	        }
	    };
	    /**
	     * The sort order for comparing leaf nodes of different types. If two leaf nodes have
	     * the same type, the comparison falls back to their value
	     * @type {Array.<!string>}
	     * @const
	     */
	    LeafNode.VALUE_TYPE_ORDER = ['object', 'boolean', 'number', 'string'];
	    return LeafNode;
	}());
	exports.LeafNode = LeafNode;
	
	//# sourceMappingURL=LeafNode.js.map


/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var Node_1 = __webpack_require__(19);
	var util_1 = __webpack_require__(4);
	/**
	 *
	 * @constructor
	 */
	var Index = /** @class */ (function () {
	    function Index() {
	    }
	    /**
	     * @return {function(!NamedNode, !NamedNode):number} A standalone comparison function for
	     * this index
	     */
	    Index.prototype.getCompare = function () {
	        return this.compare.bind(this);
	    };
	    /**
	     * Given a before and after value for a node, determine if the indexed value has changed. Even if they are different,
	     * it's possible that the changes are isolated to parts of the snapshot that are not indexed.
	     *
	     * @param {!Node} oldNode
	     * @param {!Node} newNode
	     * @return {boolean} True if the portion of the snapshot being indexed changed between oldNode and newNode
	     */
	    Index.prototype.indexedValueChanged = function (oldNode, newNode) {
	        var oldWrapped = new Node_1.NamedNode(util_1.MIN_NAME, oldNode);
	        var newWrapped = new Node_1.NamedNode(util_1.MIN_NAME, newNode);
	        return this.compare(oldWrapped, newWrapped) !== 0;
	    };
	    /**
	     * @return {!NamedNode} a node wrapper that will sort equal to or less than
	     * any other node wrapper, using this index
	     */
	    Index.prototype.minPost = function () {
	        return Node_1.NamedNode.MIN;
	    };
	    return Index;
	}());
	exports.Index = Index;
	
	//# sourceMappingURL=Index.js.map


/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var DOMStorageWrapper_1 = __webpack_require__(240);
	var MemoryStorage_1 = __webpack_require__(241);
	/**
	 * Helper to create a DOMStorageWrapper or else fall back to MemoryStorage.
	 * TODO: Once MemoryStorage and DOMStorageWrapper have a shared interface this method annotation should change
	 * to reflect this type
	 *
	 * @param {string} domStorageName Name of the underlying storage object
	 *   (e.g. 'localStorage' or 'sessionStorage').
	 * @return {?} Turning off type information until a common interface is defined.
	 */
	var createStoragefor = function (domStorageName) {
	    try {
	        // NOTE: just accessing "localStorage" or "window['localStorage']" may throw a security exception,
	        // so it must be inside the try/catch.
	        if (typeof window !== 'undefined' &&
	            typeof window[domStorageName] !== 'undefined') {
	            // Need to test cache. Just because it's here doesn't mean it works
	            var domStorage = window[domStorageName];
	            domStorage.setItem('firebase:sentinel', 'cache');
	            domStorage.removeItem('firebase:sentinel');
	            return new DOMStorageWrapper_1.DOMStorageWrapper(domStorage);
	        }
	    }
	    catch (e) { }
	    // Failed to create wrapper.  Just return in-memory storage.
	    // TODO: log?
	    return new MemoryStorage_1.MemoryStorage();
	};
	/** A storage object that lasts across sessions */
	exports.PersistentStorage = createStoragefor('localStorage');
	/** A storage object that only lasts one session */
	exports.SessionStorage = createStoragefor('sessionStorage');
	
	//# sourceMappingURL=storage.js.map


/***/ }),
/* 69 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * An iterator over an LLRBNode.
	 */
	var SortedMapIterator = /** @class */ (function () {
	    /**
	     * @template K, V, T
	     * @param {LLRBNode|LLRBEmptyNode} node Node to iterate.
	     * @param {?K} startKey
	     * @param {function(K, K): number} comparator
	     * @param {boolean} isReverse_ Whether or not to iterate in reverse
	     * @param {(function(K, V):T)=} resultGenerator_
	     */
	    function SortedMapIterator(node, startKey, comparator, isReverse_, resultGenerator_) {
	        if (resultGenerator_ === void 0) { resultGenerator_ = null; }
	        this.isReverse_ = isReverse_;
	        this.resultGenerator_ = resultGenerator_;
	        /** @private
	         * @type {Array.<!LLRBNode>}
	         */
	        this.nodeStack_ = [];
	        var cmp = 1;
	        while (!node.isEmpty()) {
	            node = node;
	            cmp = startKey ? comparator(node.key, startKey) : 1;
	            // flip the comparison if we're going in reverse
	            if (isReverse_)
	                cmp *= -1;
	            if (cmp < 0) {
	                // This node is less than our start key. ignore it
	                if (this.isReverse_) {
	                    node = node.left;
	                }
	                else {
	                    node = node.right;
	                }
	            }
	            else if (cmp === 0) {
	                // This node is exactly equal to our start key. Push it on the stack, but stop iterating;
	                this.nodeStack_.push(node);
	                break;
	            }
	            else {
	                // This node is greater than our start key, add it to the stack and move to the next one
	                this.nodeStack_.push(node);
	                if (this.isReverse_) {
	                    node = node.right;
	                }
	                else {
	                    node = node.left;
	                }
	            }
	        }
	    }
	    SortedMapIterator.prototype.getNext = function () {
	        if (this.nodeStack_.length === 0)
	            return null;
	        var node = this.nodeStack_.pop();
	        var result;
	        if (this.resultGenerator_)
	            result = this.resultGenerator_(node.key, node.value);
	        else
	            result = { key: node.key, value: node.value };
	        if (this.isReverse_) {
	            node = node.left;
	            while (!node.isEmpty()) {
	                this.nodeStack_.push(node);
	                node = node.right;
	            }
	        }
	        else {
	            node = node.right;
	            while (!node.isEmpty()) {
	                this.nodeStack_.push(node);
	                node = node.left;
	            }
	        }
	        return result;
	    };
	    SortedMapIterator.prototype.hasNext = function () {
	        return this.nodeStack_.length > 0;
	    };
	    SortedMapIterator.prototype.peek = function () {
	        if (this.nodeStack_.length === 0)
	            return null;
	        var node = this.nodeStack_[this.nodeStack_.length - 1];
	        if (this.resultGenerator_) {
	            return this.resultGenerator_(node.key, node.value);
	        }
	        else {
	            return { key: node.key, value: node.value };
	        }
	    };
	    return SortedMapIterator;
	}());
	exports.SortedMapIterator = SortedMapIterator;
	/**
	 * Represents a node in a Left-leaning Red-Black tree.
	 */
	var LLRBNode = /** @class */ (function () {
	    /**
	     * @template K, V
	     * @param {!K} key Key associated with this node.
	     * @param {!V} value Value associated with this node.
	     * @param {?boolean} color Whether this node is red.
	     * @param {?(LLRBNode|LLRBEmptyNode)=} left Left child.
	     * @param {?(LLRBNode|LLRBEmptyNode)=} right Right child.
	     */
	    function LLRBNode(key, value, color, left, right) {
	        this.key = key;
	        this.value = value;
	        this.color = color != null ? color : LLRBNode.RED;
	        this.left =
	            left != null ? left : SortedMap.EMPTY_NODE;
	        this.right =
	            right != null ? right : SortedMap.EMPTY_NODE;
	    }
	    /**
	     * Returns a copy of the current node, optionally replacing pieces of it.
	     *
	     * @param {?K} key New key for the node, or null.
	     * @param {?V} value New value for the node, or null.
	     * @param {?boolean} color New color for the node, or null.
	     * @param {?LLRBNode|LLRBEmptyNode} left New left child for the node, or null.
	     * @param {?LLRBNode|LLRBEmptyNode} right New right child for the node, or null.
	     * @return {!LLRBNode} The node copy.
	     */
	    LLRBNode.prototype.copy = function (key, value, color, left, right) {
	        return new LLRBNode(key != null ? key : this.key, value != null ? value : this.value, color != null ? color : this.color, left != null ? left : this.left, right != null ? right : this.right);
	    };
	    /**
	     * @return {number} The total number of nodes in the tree.
	     */
	    LLRBNode.prototype.count = function () {
	        return this.left.count() + 1 + this.right.count();
	    };
	    /**
	     * @return {boolean} True if the tree is empty.
	     */
	    LLRBNode.prototype.isEmpty = function () {
	        return false;
	    };
	    /**
	     * Traverses the tree in key order and calls the specified action function
	     * for each node.
	     *
	     * @param {function(!K, !V):*} action Callback function to be called for each
	     *   node.  If it returns true, traversal is aborted.
	     * @return {*} The first truthy value returned by action, or the last falsey
	     *   value returned by action
	     */
	    LLRBNode.prototype.inorderTraversal = function (action) {
	        return (this.left.inorderTraversal(action) ||
	            action(this.key, this.value) ||
	            this.right.inorderTraversal(action));
	    };
	    /**
	     * Traverses the tree in reverse key order and calls the specified action function
	     * for each node.
	     *
	     * @param {function(!Object, !Object)} action Callback function to be called for each
	     * node.  If it returns true, traversal is aborted.
	     * @return {*} True if traversal was aborted.
	     */
	    LLRBNode.prototype.reverseTraversal = function (action) {
	        return (this.right.reverseTraversal(action) ||
	            action(this.key, this.value) ||
	            this.left.reverseTraversal(action));
	    };
	    /**
	     * @return {!Object} The minimum node in the tree.
	     * @private
	     */
	    LLRBNode.prototype.min_ = function () {
	        if (this.left.isEmpty()) {
	            return this;
	        }
	        else {
	            return this.left.min_();
	        }
	    };
	    /**
	     * @return {!K} The maximum key in the tree.
	     */
	    LLRBNode.prototype.minKey = function () {
	        return this.min_().key;
	    };
	    /**
	     * @return {!K} The maximum key in the tree.
	     */
	    LLRBNode.prototype.maxKey = function () {
	        if (this.right.isEmpty()) {
	            return this.key;
	        }
	        else {
	            return this.right.maxKey();
	        }
	    };
	    /**
	     *
	     * @param {!Object} key Key to insert.
	     * @param {!Object} value Value to insert.
	     * @param {Comparator} comparator Comparator.
	     * @return {!LLRBNode} New tree, with the key/value added.
	     */
	    LLRBNode.prototype.insert = function (key, value, comparator) {
	        var cmp, n;
	        n = this;
	        cmp = comparator(key, n.key);
	        if (cmp < 0) {
	            n = n.copy(null, null, null, n.left.insert(key, value, comparator), null);
	        }
	        else if (cmp === 0) {
	            n = n.copy(null, value, null, null, null);
	        }
	        else {
	            n = n.copy(null, null, null, null, n.right.insert(key, value, comparator));
	        }
	        return n.fixUp_();
	    };
	    /**
	     * @private
	     * @return {!LLRBNode|LLRBEmptyNode} New tree, with the minimum key removed.
	     */
	    LLRBNode.prototype.removeMin_ = function () {
	        if (this.left.isEmpty()) {
	            return SortedMap.EMPTY_NODE;
	        }
	        var n = this;
	        if (!n.left.isRed_() && !n.left.left.isRed_())
	            n = n.moveRedLeft_();
	        n = n.copy(null, null, null, n.left.removeMin_(), null);
	        return n.fixUp_();
	    };
	    /**
	     * @param {!Object} key The key of the item to remove.
	     * @param {Comparator} comparator Comparator.
	     * @return {!LLRBNode|LLRBEmptyNode} New tree, with the specified item removed.
	     */
	    LLRBNode.prototype.remove = function (key, comparator) {
	        var n, smallest;
	        n = this;
	        if (comparator(key, n.key) < 0) {
	            if (!n.left.isEmpty() && !n.left.isRed_() && !n.left.left.isRed_()) {
	                n = n.moveRedLeft_();
	            }
	            n = n.copy(null, null, null, n.left.remove(key, comparator), null);
	        }
	        else {
	            if (n.left.isRed_())
	                n = n.rotateRight_();
	            if (!n.right.isEmpty() && !n.right.isRed_() && !n.right.left.isRed_()) {
	                n = n.moveRedRight_();
	            }
	            if (comparator(key, n.key) === 0) {
	                if (n.right.isEmpty()) {
	                    return SortedMap.EMPTY_NODE;
	                }
	                else {
	                    smallest = n.right.min_();
	                    n = n.copy(smallest.key, smallest.value, null, null, n.right.removeMin_());
	                }
	            }
	            n = n.copy(null, null, null, null, n.right.remove(key, comparator));
	        }
	        return n.fixUp_();
	    };
	    /**
	     * @private
	     * @return {boolean} Whether this is a RED node.
	     */
	    LLRBNode.prototype.isRed_ = function () {
	        return this.color;
	    };
	    /**
	     * @private
	     * @return {!LLRBNode} New tree after performing any needed rotations.
	     */
	    LLRBNode.prototype.fixUp_ = function () {
	        var n = this;
	        if (n.right.isRed_() && !n.left.isRed_())
	            n = n.rotateLeft_();
	        if (n.left.isRed_() && n.left.left.isRed_())
	            n = n.rotateRight_();
	        if (n.left.isRed_() && n.right.isRed_())
	            n = n.colorFlip_();
	        return n;
	    };
	    /**
	     * @private
	     * @return {!LLRBNode} New tree, after moveRedLeft.
	     */
	    LLRBNode.prototype.moveRedLeft_ = function () {
	        var n = this.colorFlip_();
	        if (n.right.left.isRed_()) {
	            n = n.copy(null, null, null, null, n.right.rotateRight_());
	            n = n.rotateLeft_();
	            n = n.colorFlip_();
	        }
	        return n;
	    };
	    /**
	     * @private
	     * @return {!LLRBNode} New tree, after moveRedRight.
	     */
	    LLRBNode.prototype.moveRedRight_ = function () {
	        var n = this.colorFlip_();
	        if (n.left.left.isRed_()) {
	            n = n.rotateRight_();
	            n = n.colorFlip_();
	        }
	        return n;
	    };
	    /**
	     * @private
	     * @return {!LLRBNode} New tree, after rotateLeft.
	     */
	    LLRBNode.prototype.rotateLeft_ = function () {
	        var nl = this.copy(null, null, LLRBNode.RED, null, this.right.left);
	        return this.right.copy(null, null, this.color, nl, null);
	    };
	    /**
	     * @private
	     * @return {!LLRBNode} New tree, after rotateRight.
	     */
	    LLRBNode.prototype.rotateRight_ = function () {
	        var nr = this.copy(null, null, LLRBNode.RED, this.left.right, null);
	        return this.left.copy(null, null, this.color, null, nr);
	    };
	    /**
	     * @private
	     * @return {!LLRBNode} New tree, after colorFlip.
	     */
	    LLRBNode.prototype.colorFlip_ = function () {
	        var left = this.left.copy(null, null, !this.left.color, null, null);
	        var right = this.right.copy(null, null, !this.right.color, null, null);
	        return this.copy(null, null, !this.color, left, right);
	    };
	    /**
	     * For testing.
	     *
	     * @private
	     * @return {boolean} True if all is well.
	     */
	    LLRBNode.prototype.checkMaxDepth_ = function () {
	        var blackDepth = this.check_();
	        return Math.pow(2.0, blackDepth) <= this.count() + 1;
	    };
	    /**
	     * @private
	     * @return {number} Not sure what this returns exactly. :-).
	     */
	    LLRBNode.prototype.check_ = function () {
	        var blackDepth;
	        if (this.isRed_() && this.left.isRed_()) {
	            throw new Error('Red node has red child(' + this.key + ',' + this.value + ')');
	        }
	        if (this.right.isRed_()) {
	            throw new Error('Right child of (' + this.key + ',' + this.value + ') is red');
	        }
	        blackDepth = this.left.check_();
	        if (blackDepth !== this.right.check_()) {
	            throw new Error('Black depths differ');
	        }
	        else {
	            return blackDepth + (this.isRed_() ? 0 : 1);
	        }
	    };
	    LLRBNode.RED = true;
	    LLRBNode.BLACK = false;
	    return LLRBNode;
	}());
	exports.LLRBNode = LLRBNode;
	/**
	 * Represents an empty node (a leaf node in the Red-Black Tree).
	 */
	var LLRBEmptyNode = /** @class */ (function () {
	    function LLRBEmptyNode() {
	    }
	    /**
	     * Returns a copy of the current node.
	     *
	     * @return {!LLRBEmptyNode} The node copy.
	     */
	    LLRBEmptyNode.prototype.copy = function (key, value, color, left, right) {
	        return this;
	    };
	    /**
	     * Returns a copy of the tree, with the specified key/value added.
	     *
	     * @param {!K} key Key to be added.
	     * @param {!V} value Value to be added.
	     * @param {Comparator} comparator Comparator.
	     * @return {!LLRBNode} New tree, with item added.
	     */
	    LLRBEmptyNode.prototype.insert = function (key, value, comparator) {
	        return new LLRBNode(key, value, null);
	    };
	    /**
	     * Returns a copy of the tree, with the specified key removed.
	     *
	     * @param {!K} key The key to remove.
	     * @param {Comparator} comparator Comparator.
	     * @return {!LLRBEmptyNode} New tree, with item removed.
	     */
	    LLRBEmptyNode.prototype.remove = function (key, comparator) {
	        return this;
	    };
	    /**
	     * @return {number} The total number of nodes in the tree.
	     */
	    LLRBEmptyNode.prototype.count = function () {
	        return 0;
	    };
	    /**
	     * @return {boolean} True if the tree is empty.
	     */
	    LLRBEmptyNode.prototype.isEmpty = function () {
	        return true;
	    };
	    /**
	     * Traverses the tree in key order and calls the specified action function
	     * for each node.
	     *
	     * @param {function(!K, !V):*} action Callback function to be called for each
	     * node.  If it returns true, traversal is aborted.
	     * @return {boolean} True if traversal was aborted.
	     */
	    LLRBEmptyNode.prototype.inorderTraversal = function (action) {
	        return false;
	    };
	    /**
	     * Traverses the tree in reverse key order and calls the specified action function
	     * for each node.
	     *
	     * @param {function(!K, !V)} action Callback function to be called for each
	     * node.  If it returns true, traversal is aborted.
	     * @return {boolean} True if traversal was aborted.
	     */
	    LLRBEmptyNode.prototype.reverseTraversal = function (action) {
	        return false;
	    };
	    /**
	     * @return {null}
	     */
	    LLRBEmptyNode.prototype.minKey = function () {
	        return null;
	    };
	    /**
	     * @return {null}
	     */
	    LLRBEmptyNode.prototype.maxKey = function () {
	        return null;
	    };
	    /**
	     * @private
	     * @return {number} Not sure what this returns exactly. :-).
	     */
	    LLRBEmptyNode.prototype.check_ = function () {
	        return 0;
	    };
	    /**
	     * @private
	     * @return {boolean} Whether this node is red.
	     */
	    LLRBEmptyNode.prototype.isRed_ = function () {
	        return false;
	    };
	    return LLRBEmptyNode;
	}());
	exports.LLRBEmptyNode = LLRBEmptyNode;
	/**
	 * An immutable sorted map implementation, based on a Left-leaning Red-Black
	 * tree.
	 */
	var SortedMap = /** @class */ (function () {
	    /**
	     * @template K, V
	     * @param {function(K, K):number} comparator_ Key comparator.
	     * @param {LLRBNode=} root_ (Optional) Root node for the map.
	     */
	    function SortedMap(comparator_, root_) {
	        if (root_ === void 0) { root_ = SortedMap.EMPTY_NODE; }
	        this.comparator_ = comparator_;
	        this.root_ = root_;
	    }
	    /**
	     * Returns a copy of the map, with the specified key/value added or replaced.
	     * (TODO: We should perhaps rename this method to 'put')
	     *
	     * @param {!K} key Key to be added.
	     * @param {!V} value Value to be added.
	     * @return {!SortedMap.<K, V>} New map, with item added.
	     */
	    SortedMap.prototype.insert = function (key, value) {
	        return new SortedMap(this.comparator_, this.root_
	            .insert(key, value, this.comparator_)
	            .copy(null, null, LLRBNode.BLACK, null, null));
	    };
	    /**
	     * Returns a copy of the map, with the specified key removed.
	     *
	     * @param {!K} key The key to remove.
	     * @return {!SortedMap.<K, V>} New map, with item removed.
	     */
	    SortedMap.prototype.remove = function (key) {
	        return new SortedMap(this.comparator_, this.root_
	            .remove(key, this.comparator_)
	            .copy(null, null, LLRBNode.BLACK, null, null));
	    };
	    /**
	     * Returns the value of the node with the given key, or null.
	     *
	     * @param {!K} key The key to look up.
	     * @return {?V} The value of the node with the given key, or null if the
	     * key doesn't exist.
	     */
	    SortedMap.prototype.get = function (key) {
	        var cmp;
	        var node = this.root_;
	        while (!node.isEmpty()) {
	            cmp = this.comparator_(key, node.key);
	            if (cmp === 0) {
	                return node.value;
	            }
	            else if (cmp < 0) {
	                node = node.left;
	            }
	            else if (cmp > 0) {
	                node = node.right;
	            }
	        }
	        return null;
	    };
	    /**
	     * Returns the key of the item *before* the specified key, or null if key is the first item.
	     * @param {K} key The key to find the predecessor of
	     * @return {?K} The predecessor key.
	     */
	    SortedMap.prototype.getPredecessorKey = function (key) {
	        var cmp, node = this.root_, rightParent = null;
	        while (!node.isEmpty()) {
	            cmp = this.comparator_(key, node.key);
	            if (cmp === 0) {
	                if (!node.left.isEmpty()) {
	                    node = node.left;
	                    while (!node.right.isEmpty())
	                        node = node.right;
	                    return node.key;
	                }
	                else if (rightParent) {
	                    return rightParent.key;
	                }
	                else {
	                    return null; // first item.
	                }
	            }
	            else if (cmp < 0) {
	                node = node.left;
	            }
	            else if (cmp > 0) {
	                rightParent = node;
	                node = node.right;
	            }
	        }
	        throw new Error('Attempted to find predecessor key for a nonexistent key.  What gives?');
	    };
	    /**
	     * @return {boolean} True if the map is empty.
	     */
	    SortedMap.prototype.isEmpty = function () {
	        return this.root_.isEmpty();
	    };
	    /**
	     * @return {number} The total number of nodes in the map.
	     */
	    SortedMap.prototype.count = function () {
	        return this.root_.count();
	    };
	    /**
	     * @return {?K} The minimum key in the map.
	     */
	    SortedMap.prototype.minKey = function () {
	        return this.root_.minKey();
	    };
	    /**
	     * @return {?K} The maximum key in the map.
	     */
	    SortedMap.prototype.maxKey = function () {
	        return this.root_.maxKey();
	    };
	    /**
	     * Traverses the map in key order and calls the specified action function
	     * for each key/value pair.
	     *
	     * @param {function(!K, !V):*} action Callback function to be called
	     * for each key/value pair.  If action returns true, traversal is aborted.
	     * @return {*} The first truthy value returned by action, or the last falsey
	     *   value returned by action
	     */
	    SortedMap.prototype.inorderTraversal = function (action) {
	        return this.root_.inorderTraversal(action);
	    };
	    /**
	     * Traverses the map in reverse key order and calls the specified action function
	     * for each key/value pair.
	     *
	     * @param {function(!Object, !Object)} action Callback function to be called
	     * for each key/value pair.  If action returns true, traversal is aborted.
	     * @return {*} True if the traversal was aborted.
	     */
	    SortedMap.prototype.reverseTraversal = function (action) {
	        return this.root_.reverseTraversal(action);
	    };
	    /**
	     * Returns an iterator over the SortedMap.
	     * @template T
	     * @param {(function(K, V):T)=} resultGenerator
	     * @return {SortedMapIterator.<K, V, T>} The iterator.
	     */
	    SortedMap.prototype.getIterator = function (resultGenerator) {
	        return new SortedMapIterator(this.root_, null, this.comparator_, false, resultGenerator);
	    };
	    SortedMap.prototype.getIteratorFrom = function (key, resultGenerator) {
	        return new SortedMapIterator(this.root_, key, this.comparator_, false, resultGenerator);
	    };
	    SortedMap.prototype.getReverseIteratorFrom = function (key, resultGenerator) {
	        return new SortedMapIterator(this.root_, key, this.comparator_, true, resultGenerator);
	    };
	    SortedMap.prototype.getReverseIterator = function (resultGenerator) {
	        return new SortedMapIterator(this.root_, null, this.comparator_, true, resultGenerator);
	    };
	    /**
	     * Always use the same empty node, to reduce memory.
	     * @const
	     */
	    SortedMap.EMPTY_NODE = new LLRBEmptyNode();
	    return SortedMap;
	}());
	exports.SortedMap = SortedMap;
	
	//# sourceMappingURL=SortedMap.js.map


/***/ }),
/* 70 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * A cache node only stores complete children. Additionally it holds a flag whether the node can be considered fully
	 * initialized in the sense that we know at one point in time this represented a valid state of the world, e.g.
	 * initialized with data from the server, or a complete overwrite by the client. The filtered flag also tracks
	 * whether a node potentially had children removed due to a filter.
	 */
	var CacheNode = /** @class */ (function () {
	    /**
	     * @param {!Node} node_
	     * @param {boolean} fullyInitialized_
	     * @param {boolean} filtered_
	     */
	    function CacheNode(node_, fullyInitialized_, filtered_) {
	        this.node_ = node_;
	        this.fullyInitialized_ = fullyInitialized_;
	        this.filtered_ = filtered_;
	    }
	    /**
	     * Returns whether this node was fully initialized with either server data or a complete overwrite by the client
	     * @return {boolean}
	     */
	    CacheNode.prototype.isFullyInitialized = function () {
	        return this.fullyInitialized_;
	    };
	    /**
	     * Returns whether this node is potentially missing children due to a filter applied to the node
	     * @return {boolean}
	     */
	    CacheNode.prototype.isFiltered = function () {
	        return this.filtered_;
	    };
	    /**
	     * @param {!Path} path
	     * @return {boolean}
	     */
	    CacheNode.prototype.isCompleteForPath = function (path) {
	        if (path.isEmpty()) {
	            return this.isFullyInitialized() && !this.filtered_;
	        }
	        var childKey = path.getFront();
	        return this.isCompleteForChild(childKey);
	    };
	    /**
	     * @param {!string} key
	     * @return {boolean}
	     */
	    CacheNode.prototype.isCompleteForChild = function (key) {
	        return ((this.isFullyInitialized() && !this.filtered_) || this.node_.hasChild(key));
	    };
	    /**
	     * @return {!Node}
	     */
	    CacheNode.prototype.getNode = function () {
	        return this.node_;
	    };
	    return CacheNode;
	}());
	exports.CacheNode = CacheNode;
	
	//# sourceMappingURL=CacheNode.js.map


/***/ }),
/* 71 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.PROTOCOL_VERSION = '5';
	exports.VERSION_PARAM = 'v';
	exports.TRANSPORT_SESSION_PARAM = 's';
	exports.REFERER_PARAM = 'r';
	exports.FORGE_REF = 'f';
	exports.FORGE_DOMAIN = 'firebaseio.com';
	exports.LAST_SESSION_PARAM = 'ls';
	exports.WEBSOCKET = 'websocket';
	exports.LONG_POLLING = 'long_polling';
	
	//# sourceMappingURL=Constants.js.map


/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var document_key_1 = __webpack_require__(12);
	var assert_1 = __webpack_require__(2);
	var sorted_map_1 = __webpack_require__(36);
	var ChangeType;
	(function (ChangeType) {
	    ChangeType[ChangeType["Added"] = 0] = "Added";
	    ChangeType[ChangeType["Removed"] = 1] = "Removed";
	    ChangeType[ChangeType["Modified"] = 2] = "Modified";
	    ChangeType[ChangeType["Metadata"] = 3] = "Metadata";
	})(ChangeType = exports.ChangeType || (exports.ChangeType = {}));
	var SyncState;
	(function (SyncState) {
	    SyncState[SyncState["Local"] = 0] = "Local";
	    SyncState[SyncState["Synced"] = 1] = "Synced";
	})(SyncState = exports.SyncState || (exports.SyncState = {}));
	/**
	 * DocumentChangeSet keeps track of a set of changes to docs in a query, merging
	 * duplicate events for the same doc.
	 */
	var DocumentChangeSet = /** @class */ (function () {
	    function DocumentChangeSet() {
	        this.changeMap = new sorted_map_1.SortedMap(document_key_1.DocumentKey.comparator);
	    }
	    DocumentChangeSet.prototype.track = function (change) {
	        var key = change.doc.key;
	        var oldChange = this.changeMap.get(key);
	        if (!oldChange) {
	            this.changeMap = this.changeMap.insert(key, change);
	            return;
	        }
	        // Merge the new change with the existing change.
	        if (change.type !== ChangeType.Added &&
	            oldChange.type === ChangeType.Metadata) {
	            this.changeMap = this.changeMap.insert(key, change);
	        }
	        else if (change.type === ChangeType.Metadata &&
	            oldChange.type !== ChangeType.Removed) {
	            this.changeMap = this.changeMap.insert(key, {
	                type: oldChange.type,
	                doc: change.doc
	            });
	        }
	        else if (change.type === ChangeType.Modified &&
	            oldChange.type === ChangeType.Modified) {
	            this.changeMap = this.changeMap.insert(key, {
	                type: ChangeType.Modified,
	                doc: change.doc
	            });
	        }
	        else if (change.type === ChangeType.Modified &&
	            oldChange.type === ChangeType.Added) {
	            this.changeMap = this.changeMap.insert(key, {
	                type: ChangeType.Added,
	                doc: change.doc
	            });
	        }
	        else if (change.type === ChangeType.Removed &&
	            oldChange.type === ChangeType.Added) {
	            this.changeMap = this.changeMap.remove(key);
	        }
	        else if (change.type === ChangeType.Removed &&
	            oldChange.type === ChangeType.Modified) {
	            this.changeMap = this.changeMap.insert(key, {
	                type: ChangeType.Removed,
	                doc: oldChange.doc
	            });
	        }
	        else if (change.type === ChangeType.Added &&
	            oldChange.type === ChangeType.Removed) {
	            this.changeMap = this.changeMap.insert(key, {
	                type: ChangeType.Modified,
	                doc: change.doc
	            });
	        }
	        else {
	            // This includes these cases, which don't make sense:
	            // Added->Added
	            // Removed->Removed
	            // Modified->Added
	            // Removed->Modified
	            // Metadata->Added
	            // Removed->Metadata
	            assert_1.fail('unsupported combination of changes: ' +
	                JSON.stringify(change) +
	                ' after ' +
	                JSON.stringify(oldChange));
	        }
	    };
	    DocumentChangeSet.prototype.getChanges = function () {
	        var changes = [];
	        this.changeMap.inorderTraversal(function (key, change) {
	            changes.push(change);
	        });
	        return changes;
	    };
	    return DocumentChangeSet;
	}());
	exports.DocumentChangeSet = DocumentChangeSet;
	var ViewSnapshot = /** @class */ (function () {
	    function ViewSnapshot(query, docs, oldDocs, docChanges, fromCache, hasPendingWrites, syncStateChanged) {
	        this.query = query;
	        this.docs = docs;
	        this.oldDocs = oldDocs;
	        this.docChanges = docChanges;
	        this.fromCache = fromCache;
	        this.hasPendingWrites = hasPendingWrites;
	        this.syncStateChanged = syncStateChanged;
	    }
	    ViewSnapshot.prototype.isEqual = function (other) {
	        if (this.fromCache !== other.fromCache ||
	            this.hasPendingWrites !== other.hasPendingWrites ||
	            this.syncStateChanged !== other.syncStateChanged ||
	            !this.query.isEqual(other.query) ||
	            !this.docs.isEqual(other.docs) ||
	            !this.oldDocs.isEqual(other.oldDocs)) {
	            return false;
	        }
	        var changes = this.docChanges;
	        var otherChanges = other.docChanges;
	        if (changes.length !== otherChanges.length) {
	            return false;
	        }
	        for (var i = 0; i < changes.length; i++) {
	            if (changes[i].type !== otherChanges[i].type ||
	                !changes[i].doc.isEqual(otherChanges[i].doc)) {
	                return false;
	            }
	        }
	        return true;
	    };
	    return ViewSnapshot;
	}());
	exports.ViewSnapshot = ViewSnapshot;
	
	//# sourceMappingURL=view_snapshot.js.map


/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var collections_1 = __webpack_require__(11);
	var document_key_1 = __webpack_require__(12);
	var misc_1 = __webpack_require__(14);
	var sorted_set_1 = __webpack_require__(76);
	var persistence_promise_1 = __webpack_require__(18);
	/**
	 * A collection of references to a document from some kind of numbered entity
	 * (either a target ID or batch ID). As references are added to or removed from
	 * the set corresponding events are emitted to a registered garbage collector.
	 *
	 * Each reference is represented by a DocumentReference object. Each of them
	 * contains enough information to uniquely identify the reference. They are all
	 * stored primarily in a set sorted by key. A document is considered garbage if
	 * there's no references in that set (this can be efficiently checked thanks to
	 * sorting by key).
	 *
	 * ReferenceSet also keeps a secondary set that contains references sorted by
	 * IDs. This one is used to efficiently implement removal of all references by
	 * some target ID.
	 */
	var ReferenceSet = /** @class */ (function () {
	    function ReferenceSet() {
	        // A set of outstanding references to a document sorted by key.
	        this.refsByKey = new sorted_set_1.SortedSet(DocReference.compareByKey);
	        // A set of outstanding references to a document sorted by target id.
	        this.refsByTarget = new sorted_set_1.SortedSet(DocReference.compareByTargetId);
	        /** Keeps track of keys that have references */
	        this.garbageCollector = null;
	    }
	    /** Returns true if the reference set contains no references. */
	    ReferenceSet.prototype.isEmpty = function () {
	        return this.refsByKey.isEmpty();
	    };
	    /** Adds a reference to the given document key for the given ID. */
	    ReferenceSet.prototype.addReference = function (key, id) {
	        var ref = new DocReference(key, id);
	        this.refsByKey = this.refsByKey.add(ref);
	        this.refsByTarget = this.refsByTarget.add(ref);
	    };
	    /** Add references to the given document keys for the given ID. */
	    ReferenceSet.prototype.addReferences = function (keys, id) {
	        var _this = this;
	        keys.forEach(function (key) { return _this.addReference(key, id); });
	    };
	    /**
	     * Removes a reference to the given document key for the given
	     * ID.
	     */
	    ReferenceSet.prototype.removeReference = function (key, id) {
	        this.removeRef(new DocReference(key, id));
	    };
	    ReferenceSet.prototype.removeReferences = function (keys, id) {
	        var _this = this;
	        keys.forEach(function (key) { return _this.removeReference(key, id); });
	    };
	    /**
	     * Clears all references with a given ID. Calls removeRef() for each key
	     * removed.
	     */
	    ReferenceSet.prototype.removeReferencesForId = function (id) {
	        var _this = this;
	        var emptyKey = document_key_1.DocumentKey.EMPTY;
	        var startRef = new DocReference(emptyKey, id);
	        var endRef = new DocReference(emptyKey, id + 1);
	        this.refsByTarget.forEachInRange([startRef, endRef], function (ref) {
	            _this.removeRef(ref);
	        });
	    };
	    ReferenceSet.prototype.removeAllReferences = function () {
	        var _this = this;
	        this.refsByKey.forEach(function (ref) { return _this.removeRef(ref); });
	    };
	    ReferenceSet.prototype.removeRef = function (ref) {
	        this.refsByKey = this.refsByKey.delete(ref);
	        this.refsByTarget = this.refsByTarget.delete(ref);
	        if (this.garbageCollector !== null) {
	            this.garbageCollector.addPotentialGarbageKey(ref.key);
	        }
	    };
	    ReferenceSet.prototype.referencesForId = function (id) {
	        var emptyKey = document_key_1.DocumentKey.EMPTY;
	        var startRef = new DocReference(emptyKey, id);
	        var endRef = new DocReference(emptyKey, id + 1);
	        var keys = collections_1.documentKeySet();
	        this.refsByTarget.forEachInRange([startRef, endRef], function (ref) {
	            keys = keys.add(ref.key);
	        });
	        return keys;
	    };
	    ReferenceSet.prototype.setGarbageCollector = function (garbageCollector) {
	        this.garbageCollector = garbageCollector;
	    };
	    ReferenceSet.prototype.containsKey = function (txn, key) {
	        var ref = new DocReference(key, 0);
	        var firstRef = this.refsByKey.firstAfterOrEqual(ref);
	        return persistence_promise_1.PersistencePromise.resolve(firstRef !== null && key.isEqual(firstRef.key));
	    };
	    return ReferenceSet;
	}());
	exports.ReferenceSet = ReferenceSet;
	var DocReference = /** @class */ (function () {
	    function DocReference(key, targetOrBatchId) {
	        this.key = key;
	        this.targetOrBatchId = targetOrBatchId;
	    }
	    /** Compare by key then by ID */
	    DocReference.compareByKey = function (left, right) {
	        return (document_key_1.DocumentKey.comparator(left.key, right.key) ||
	            misc_1.primitiveComparator(left.targetOrBatchId, right.targetOrBatchId));
	    };
	    /** Compare by ID then by key */
	    DocReference.compareByTargetId = function (left, right) {
	        return (misc_1.primitiveComparator(left.targetOrBatchId, right.targetOrBatchId) ||
	            document_key_1.DocumentKey.comparator(left.key, right.key));
	    };
	    return DocReference;
	}());
	exports.DocReference = DocReference;
	
	//# sourceMappingURL=reference_set.js.map


/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var assert_1 = __webpack_require__(2);
	var log_1 = __webpack_require__(13);
	var persistence_promise_1 = __webpack_require__(18);
	var LOG_TAG = 'SimpleDb';
	/**
	 * Provides a wrapper around IndexedDb with a simplified interface that uses
	 * Promise-like return values to chain operations. Real promises cannot be used
	 * since .then() continuations are executed asynchronously (e.g. via
	 * .setImmediate), which would cause IndexedDB to end the transaction.
	 * See PersistencePromise for more details.
	 */
	var SimpleDb = /** @class */ (function () {
	    function SimpleDb(db) {
	        this.db = db;
	    }
	    /** Opens the specified database, creating or upgrading it if necessary. */
	    SimpleDb.openOrCreate = function (name, version, runUpgrade) {
	        assert_1.assert(SimpleDb.isAvailable(), 'IndexedDB not supported in current environment.');
	        log_1.debug(LOG_TAG, 'Opening database:', name);
	        return new persistence_promise_1.PersistencePromise(function (resolve, reject) {
	            // TODO(mikelehen): Investigate browser compatibility.
	            // https://developer.mozilla.org/en-US/docs/Web/API/IndexedDB_API/Using_IndexedDB
	            // suggests IE9 and older WebKit browsers handle upgrade
	            // differently.
	            var request = window.indexedDB.open(name, version);
	            request.onsuccess = function (event) {
	                var db = event.target.result;
	                resolve(new SimpleDb(db));
	            };
	            request.onerror = function (event) {
	                reject(event.target.error);
	            };
	            request.onupgradeneeded = function (event) {
	                log_1.debug(LOG_TAG, 'Database "' + name + '" requires upgrade from version:', event.oldVersion);
	                // TODO(mikelehen): If/when we need to do an actual data
	                // migration, we'll want to wrap db in a SimpleDb and have the
	                // runUpgrade function return a PersistencePromise, since we'll
	                // likely need to do async reads and writes. For now we're
	                // cheating and just passing the raw IndexedDB in, since
	                // createObjectStore(), etc. are synchronous.
	                var db = event.target.result;
	                runUpgrade(db, event.oldVersion);
	            };
	        }).toPromise();
	    };
	    /** Deletes the specified database. */
	    SimpleDb.delete = function (name) {
	        log_1.debug(LOG_TAG, 'Removing database:', name);
	        return wrapRequest(window.indexedDB.deleteDatabase(name)).toPromise();
	    };
	    /** Returns true if IndexedDB is available in the current environment. */
	    SimpleDb.isAvailable = function () {
	        if (typeof window === 'undefined' || window.indexedDB == null) {
	            return false;
	        }
	        // We extensively use indexed array values and compound keys,
	        // which IE and Edge do not support. However, they still have indexedDB
	        // defined on the window, so we need to check for them here and make sure
	        // to return that persistence is not enabled for those browsers.
	        // For tracking support of this feature, see here:
	        // https://developer.microsoft.com/en-us/microsoft-edge/platform/status/indexeddbarraysandmultientrysupport/
	        // Check the UA string to find out the browser.
	        var ua = window.navigator.userAgent;
	        // IE 10
	        // ua = 'Mozilla/5.0 (compatible; MSIE 10.0; Windows NT 6.2; Trident/6.0)';
	        // IE 11
	        // ua = 'Mozilla/5.0 (Windows NT 6.3; Trident/7.0; rv:11.0) like Gecko';
	        // Edge
	        // ua = 'Mozilla/5.0 (Windows NT 10.0; WOW64) AppleWebKit/537.36 (KHTML,
	        // like Gecko) Chrome/39.0.2171.71 Safari/537.36 Edge/12.0';
	        if (ua.indexOf('MSIE ') > 0 ||
	            ua.indexOf('Trident/') > 0 ||
	            ua.indexOf('Edge/') > 0) {
	            return false;
	        }
	        else {
	            return true;
	        }
	    };
	    SimpleDb.prototype.runTransaction = function (mode, objectStores, transactionFn) {
	        var transaction = new SimpleDbTransaction(this.db, mode, objectStores);
	        var transactionFnResult = transactionFn(transaction)
	            .catch(function (error) {
	            // Abort the transaction if there was an
	            // error.
	            transaction.abort();
	            return persistence_promise_1.PersistencePromise.reject(error);
	        })
	            .toPromise();
	        // Wait for the transaction to complete (i.e. IndexedDb's onsuccess event to
	        // fire), but still return the original transactionFnResult back to the
	        // caller.
	        return transaction.completionPromise.then(function () { return transactionFnResult; });
	    };
	    SimpleDb.prototype.close = function () {
	        this.db.close();
	    };
	    return SimpleDb;
	}());
	exports.SimpleDb = SimpleDb;
	/**
	 * A controller for iterating over a key range or index. It allows an iterate
	 * callback to delete the currently-referenced object, or jump to a new key
	 * within the key range or index.
	 */
	var IterationController = /** @class */ (function () {
	    function IterationController(dbCursor) {
	        this.dbCursor = dbCursor;
	        this.shouldStop = false;
	        this.nextKey = null;
	    }
	    Object.defineProperty(IterationController.prototype, "isDone", {
	        get: function () {
	            return this.shouldStop;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(IterationController.prototype, "skipToKey", {
	        get: function () {
	            return this.nextKey;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(IterationController.prototype, "cursor", {
	        set: function (value) {
	            this.dbCursor = value;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    /**
	     * This function can be called to stop iteration at any point.
	     */
	    IterationController.prototype.done = function () {
	        this.shouldStop = true;
	    };
	    /**
	     * This function can be called to skip to that next key, which could be
	     * an index or a primary key.
	     */
	    IterationController.prototype.skip = function (key) {
	        this.nextKey = key;
	    };
	    /**
	     * Delete the current cursor value from the object store.
	     *
	     * NOTE: You CANNOT do this with a keysOnly query.
	     */
	    IterationController.prototype.delete = function () {
	        return wrapRequest(this.dbCursor.delete());
	    };
	    return IterationController;
	}());
	exports.IterationController = IterationController;
	/**
	 * Wraps an IDBTransaction and exposes a store() method to get a handle to a
	 * specific object store.
	 */
	var SimpleDbTransaction = /** @class */ (function () {
	    function SimpleDbTransaction(db, mode, objectStoresNames) {
	        var _this = this;
	        this.aborted = false;
	        this.transaction = db.transaction(objectStoresNames, mode);
	        this.completionPromise = new Promise(function (resolve, reject) {
	            // We consider aborting to be "normal" and just resolve the promise.
	            // May need to revisit if/when we actually need to abort transactions.
	            _this.transaction.onabort = _this.transaction.oncomplete = function (event) {
	                resolve();
	            };
	            _this.transaction.onerror = function (event) {
	                reject(event.target.error);
	            };
	        });
	    }
	    SimpleDbTransaction.prototype.abort = function () {
	        if (!this.aborted) {
	            log_1.debug(LOG_TAG, 'Aborting transaction.');
	            this.aborted = true;
	            this.transaction.abort();
	        }
	    };
	    /**
	     * Returns a SimpleDbStore<KeyType, ValueType> for the specified store. All
	     * operations performed on the SimpleDbStore happen within the context of this
	     * transaction and it cannot be used anymore once the transaction is
	     * completed.
	     *
	     * Note that we can't actually enforce that the KeyType and ValueType are
	     * correct, but they allow type safety through the rest of the consuming code.
	     */
	    SimpleDbTransaction.prototype.store = function (storeName) {
	        var store = this.transaction.objectStore(storeName);
	        assert_1.assert(!!store, 'Object store not part of transaction: ' + storeName);
	        return new SimpleDbStore(store);
	    };
	    return SimpleDbTransaction;
	}());
	exports.SimpleDbTransaction = SimpleDbTransaction;
	/**
	 * A wrapper around an IDBObjectStore providing an API that:
	 *
	 * 1) Has generic KeyType / ValueType parameters to provide strongly-typed
	 * methods for acting against the object store.
	 * 2) Deals with IndexedDB's onsuccess / onerror event callbacks, making every
	 * method return a PersistencePromise instead.
	 * 3) Provides a higher-level API to avoid needing to do excessive wrapping of
	 * intermediate IndexedDB types (IDBCursorWithValue, etc.)
	 */
	var SimpleDbStore = /** @class */ (function () {
	    function SimpleDbStore(store) {
	        this.store = store;
	    }
	    SimpleDbStore.prototype.put = function (keyOrValue, value) {
	        var request;
	        if (value !== undefined) {
	            log_1.debug(LOG_TAG, 'PUT', this.store.name, keyOrValue, value);
	            request = this.store.put(value, keyOrValue);
	        }
	        else {
	            log_1.debug(LOG_TAG, 'PUT', this.store.name, '<auto-key>', keyOrValue);
	            request = this.store.put(keyOrValue);
	        }
	        return wrapRequest(request);
	    };
	    /**
	     * Gets the object with the specified key from the specified store, or null
	     * if no object exists with the specified key.
	     *
	     * @key The key of the object to get.
	     * @return The object with the specified key or null if no object exists.
	     */
	    SimpleDbStore.prototype.get = function (key) {
	        var _this = this;
	        var request = this.store.get(key);
	        // tslint:disable-next-line:no-any We're doing an unsafe cast to ValueType.
	        return wrapRequest(request).next(function (result) {
	            // Normalize nonexistence to null.
	            if (result === undefined) {
	                result = null;
	            }
	            log_1.debug(LOG_TAG, 'GET', _this.store.name, key, result);
	            return result;
	        });
	    };
	    SimpleDbStore.prototype.delete = function (key) {
	        log_1.debug(LOG_TAG, 'DELETE', this.store.name, key);
	        var request = this.store.delete(key);
	        return wrapRequest(request);
	    };
	    SimpleDbStore.prototype.loadAll = function (indexOrRange, range) {
	        var cursor = this.cursor(this.options(indexOrRange, range));
	        var results = [];
	        return this.iterateCursor(cursor, function (key, value) {
	            results.push(value);
	        }).next(function () {
	            return results;
	        });
	    };
	    SimpleDbStore.prototype.deleteAll = function (indexOrRange, range) {
	        log_1.debug(LOG_TAG, 'DELETE ALL', this.store.name);
	        var options = this.options(indexOrRange, range);
	        options.keysOnly = false;
	        var cursor = this.cursor(options);
	        return this.iterateCursor(cursor, function (key, value, control) {
	            // NOTE: Calling delete() on a cursor is documented as more efficient than
	            // calling delete() on an object store with a single key
	            // (https://developer.mozilla.org/en-US/docs/Web/API/IDBObjectStore/delete),
	            // however, this requires us *not* to use a keysOnly cursor
	            // (https://developer.mozilla.org/en-US/docs/Web/API/IDBCursor/delete). We
	            // may want to compare the performance of each method.
	            return control.delete();
	        });
	    };
	    SimpleDbStore.prototype.iterate = function (optionsOrCallback, callback) {
	        var options;
	        if (!callback) {
	            options = {};
	            callback = optionsOrCallback;
	        }
	        else {
	            options = optionsOrCallback;
	        }
	        var cursor = this.cursor(options);
	        return this.iterateCursor(cursor, callback);
	    };
	    SimpleDbStore.prototype.iterateCursor = function (cursorRequest, fn) {
	        var results = [];
	        return new persistence_promise_1.PersistencePromise(function (resolve, reject) {
	            cursorRequest.onerror = function (event) {
	                reject(event.target.error);
	            };
	            cursorRequest.onsuccess = function (event) {
	                var cursor = event.target.result;
	                if (!cursor) {
	                    resolve();
	                    return;
	                }
	                var controller = new IterationController(cursor);
	                var userResult = fn(cursor.primaryKey, cursor.value, controller);
	                if (userResult instanceof persistence_promise_1.PersistencePromise) {
	                    results.push(userResult);
	                }
	                if (controller.isDone) {
	                    resolve();
	                }
	                else if (controller.skipToKey === null) {
	                    cursor.continue();
	                }
	                else {
	                    cursor.continue(controller.skipToKey);
	                }
	            };
	        }).next(function () {
	            return persistence_promise_1.PersistencePromise.waitFor(results);
	        });
	    };
	    SimpleDbStore.prototype.options = function (indexOrRange, range) {
	        var indexName = undefined;
	        if (indexOrRange !== undefined) {
	            if (typeof indexOrRange === 'string') {
	                indexName = indexOrRange;
	            }
	            else {
	                assert_1.assert(range === undefined, '3rd argument must not be defined if 2nd is a range.');
	                range = indexOrRange;
	            }
	        }
	        return { index: indexName, range: range };
	    };
	    SimpleDbStore.prototype.cursor = function (options) {
	        var direction = 'next';
	        if (options.reverse) {
	            direction = 'prev';
	        }
	        if (options.index) {
	            var index = this.store.index(options.index);
	            if (options.keysOnly) {
	                return index.openKeyCursor(options.range, direction);
	            }
	            else {
	                return index.openCursor(options.range, direction);
	            }
	        }
	        else {
	            return this.store.openCursor(options.range, direction);
	        }
	    };
	    return SimpleDbStore;
	}());
	exports.SimpleDbStore = SimpleDbStore;
	/**
	 * Wraps an IDBRequest in a PersistencePromise, using the onsuccess / onerror
	 * handlers to resolve / reject the PersistencePromise as appropriate.
	 */
	function wrapRequest(request) {
	    return new persistence_promise_1.PersistencePromise(function (resolve, reject) {
	        request.onsuccess = function (event) {
	            var result = event.target.result;
	            resolve(result);
	        };
	        request.onerror = function (event) {
	            reject(event.target.error);
	        };
	    });
	}
	
	//# sourceMappingURL=simple_db.js.map


/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var snapshot_version_1 = __webpack_require__(20);
	var assert_1 = __webpack_require__(2);
	var misc = __webpack_require__(14);
	var document_1 = __webpack_require__(21);
	var field_value_1 = __webpack_require__(42);
	/**
	 * Provides a set of fields that can be used to partially patch a document.
	 * FieldMask is used in conjunction with ObjectValue.
	 * Examples:
	 *   foo - Overwrites foo entirely with the provided value. If foo is not
	 *         present in the companion ObjectValue, the field is deleted.
	 *   foo.bar - Overwrites only the field bar of the object foo.
	 *             If foo is not an object, foo is replaced with an object
	 *             containing foo
	 */
	var FieldMask = /** @class */ (function () {
	    function FieldMask(fields) {
	        this.fields = fields;
	        // TODO(dimond): validation of FieldMask
	    }
	    FieldMask.prototype.isEqual = function (other) {
	        return misc.arrayEquals(this.fields, other.fields);
	    };
	    return FieldMask;
	}());
	exports.FieldMask = FieldMask;
	/** Transforms a value into a server-generated timestamp. */
	var ServerTimestampTransform = /** @class */ (function () {
	    function ServerTimestampTransform() {
	    }
	    ServerTimestampTransform.prototype.isEqual = function (other) {
	        return other instanceof ServerTimestampTransform;
	    };
	    ServerTimestampTransform.instance = new ServerTimestampTransform();
	    return ServerTimestampTransform;
	}());
	exports.ServerTimestampTransform = ServerTimestampTransform;
	/** A field path and the TransformOperation to perform upon it. */
	var FieldTransform = /** @class */ (function () {
	    function FieldTransform(field, transform) {
	        this.field = field;
	        this.transform = transform;
	    }
	    FieldTransform.prototype.isEqual = function (other) {
	        return (this.field.isEqual(other.field) && this.transform.isEqual(other.transform));
	    };
	    return FieldTransform;
	}());
	exports.FieldTransform = FieldTransform;
	/** The result of successfully applying a mutation to the backend. */
	var MutationResult = /** @class */ (function () {
	    function MutationResult(
	        /**
	         * The version at which the mutation was committed or null for a delete.
	         */
	        version, 
	        /**
	         * The resulting fields returned from the backend after a
	         * TransformMutation has been committed. Contains one FieldValue for each
	         * FieldTransform that was in the mutation.
	         *
	         * Will be null if the mutation was not a TransformMutation.
	         */
	        transformResults) {
	        this.version = version;
	        this.transformResults = transformResults;
	    }
	    return MutationResult;
	}());
	exports.MutationResult = MutationResult;
	var MutationType;
	(function (MutationType) {
	    MutationType[MutationType["Set"] = 0] = "Set";
	    MutationType[MutationType["Patch"] = 1] = "Patch";
	    MutationType[MutationType["Transform"] = 2] = "Transform";
	    MutationType[MutationType["Delete"] = 3] = "Delete";
	})(MutationType = exports.MutationType || (exports.MutationType = {}));
	/**
	 * Encodes a precondition for a mutation. This follows the model that the
	 * backend accepts with the special case of an explicit "empty" precondition
	 * (meaning no precondition).
	 */
	var Precondition = /** @class */ (function () {
	    function Precondition(updateTime, exists) {
	        this.updateTime = updateTime;
	        this.exists = exists;
	        assert_1.assert(updateTime === undefined || exists === undefined, 'Precondition can specify "exists" or "updateTime" but not both');
	    }
	    /** Creates a new Precondition with an exists flag. */
	    Precondition.exists = function (exists) {
	        return new Precondition(undefined, exists);
	    };
	    /** Creates a new Precondition based on a version a document exists at. */
	    Precondition.updateTime = function (version) {
	        return new Precondition(version);
	    };
	    Object.defineProperty(Precondition.prototype, "isNone", {
	        /** Returns whether this Precondition is empty. */
	        get: function () {
	            return this.updateTime === undefined && this.exists === undefined;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    /**
	     * Returns true if the preconditions is valid for the given document
	     * (or null if no document is available).
	     */
	    Precondition.prototype.isValidFor = function (maybeDoc) {
	        if (this.updateTime !== undefined) {
	            return (maybeDoc instanceof document_1.Document &&
	                maybeDoc.version.isEqual(this.updateTime));
	        }
	        else if (this.exists !== undefined) {
	            if (this.exists) {
	                return maybeDoc instanceof document_1.Document;
	            }
	            else {
	                return maybeDoc === null || maybeDoc instanceof document_1.NoDocument;
	            }
	        }
	        else {
	            assert_1.assert(this.isNone, 'Precondition should be empty');
	            return true;
	        }
	    };
	    Precondition.prototype.isEqual = function (other) {
	        return (misc.equals(this.updateTime, other.updateTime) &&
	            this.exists === other.exists);
	    };
	    Precondition.NONE = new Precondition();
	    return Precondition;
	}());
	exports.Precondition = Precondition;
	/**
	 * A mutation describes a self-contained change to a document. Mutations can
	 * create, replace, delete, and update subsets of documents.
	 *
	 * Mutations not only act on the value of the document but also it version.
	 * In the case of Set, Patch, and Transform mutations we preserve the existing
	 * version. In the case of Delete mutations, we reset the version to 0.
	 *
	 * Here's the expected transition table.
	 *
	 * MUTATION           APPLIED TO            RESULTS IN
	 *
	 * SetMutation        Document(v3)          Document(v3)
	 * SetMutation        NoDocument(v3)        Document(v0)
	 * SetMutation        null                  Document(v0)
	 * PatchMutation      Document(v3)          Document(v3)
	 * PatchMutation      NoDocument(v3)        NoDocument(v3)
	 * PatchMutation      null                  null
	 * TransformMutation  Document(v3)          Document(v3)
	 * TransformMutation  NoDocument(v3)        NoDocument(v3)
	 * TransformMutation  null                  null
	 * DeleteMutation     Document(v3)          NoDocument(v0)
	 * DeleteMutation     NoDocument(v3)        NoDocument(v0)
	 * DeleteMutation     null                  NoDocument(v0)
	 *
	 * Note that TransformMutations don't create Documents (in the case of being
	 * applied to a NoDocument), even though they would on the backend. This is
	 * because the client always combines the TransformMutation with a SetMutation
	 * or PatchMutation and we only want to apply the transform if the prior
	 * mutation resulted in a Document (always true for a SetMutation, but not
	 * necessarily for a PatchMutation).
	 *
	 * ## Subclassing Notes
	 *
	 * Subclasses of Mutation need to implement applyToRemoteDocument() and
	 * applyToLocalView() to implement the actual behavior of applying the mutation
	 * to some source document.
	 */
	var Mutation = /** @class */ (function () {
	    function Mutation() {
	    }
	    Mutation.prototype.verifyKeyMatches = function (maybeDoc) {
	        if (maybeDoc != null) {
	            assert_1.assert(maybeDoc.key.isEqual(this.key), 'Can only apply a mutation to a document with the same key');
	        }
	    };
	    /**
	     * Returns the version from the given document for use as the result of a
	     * mutation. Mutations are defined to return the version of the base document
	     * only if it is an existing document. Deleted and unknown documents have a
	     * post-mutation version of SnapshotVersion.MIN.
	     */
	    Mutation.getPostMutationVersion = function (maybeDoc) {
	        if (maybeDoc instanceof document_1.Document) {
	            return maybeDoc.version;
	        }
	        else {
	            return snapshot_version_1.SnapshotVersion.MIN;
	        }
	    };
	    return Mutation;
	}());
	exports.Mutation = Mutation;
	/**
	 * A mutation that creates or replaces the document at the given key with the
	 * object value contents.
	 */
	var SetMutation = /** @class */ (function (_super) {
	    __extends(SetMutation, _super);
	    function SetMutation(key, value, precondition) {
	        var _this = _super.call(this) || this;
	        _this.key = key;
	        _this.value = value;
	        _this.precondition = precondition;
	        _this.type = MutationType.Set;
	        return _this;
	    }
	    SetMutation.prototype.applyToRemoteDocument = function (maybeDoc, mutationResult) {
	        this.verifyKeyMatches(maybeDoc);
	        assert_1.assert(mutationResult.transformResults == null, 'Transform results received by SetMutation.');
	        // Unlike applyToLocalView, if we're applying a mutation to a remote
	        // document the server has accepted the mutation so the precondition must
	        // have held.
	        var version = Mutation.getPostMutationVersion(maybeDoc);
	        return new document_1.Document(this.key, version, this.value, {
	            hasLocalMutations: false
	        });
	    };
	    SetMutation.prototype.applyToLocalView = function (maybeDoc, baseDoc, localWriteTime) {
	        this.verifyKeyMatches(maybeDoc);
	        if (!this.precondition.isValidFor(maybeDoc)) {
	            return maybeDoc;
	        }
	        var version = Mutation.getPostMutationVersion(maybeDoc);
	        return new document_1.Document(this.key, version, this.value, {
	            hasLocalMutations: true
	        });
	    };
	    SetMutation.prototype.isEqual = function (other) {
	        return (other instanceof SetMutation &&
	            this.key.isEqual(other.key) &&
	            this.value.isEqual(other.value) &&
	            this.precondition.isEqual(other.precondition));
	    };
	    return SetMutation;
	}(Mutation));
	exports.SetMutation = SetMutation;
	/**
	 * A mutation that modifies fields of the document at the given key with the
	 * given values. The values are applied through a field mask:
	 *
	 *  * When a field is in both the mask and the values, the corresponding field
	 *    is updated.
	 *  * When a field is in neither the mask nor the values, the corresponding
	 *    field is unmodified.
	 *  * When a field is in the mask but not in the values, the corresponding field
	 *    is deleted.
	 *  * When a field is not in the mask but is in the values, the values map is
	 *    ignored.
	 */
	var PatchMutation = /** @class */ (function (_super) {
	    __extends(PatchMutation, _super);
	    function PatchMutation(key, data, fieldMask, precondition) {
	        var _this = _super.call(this) || this;
	        _this.key = key;
	        _this.data = data;
	        _this.fieldMask = fieldMask;
	        _this.precondition = precondition;
	        _this.type = MutationType.Patch;
	        return _this;
	    }
	    PatchMutation.prototype.applyToRemoteDocument = function (maybeDoc, mutationResult) {
	        this.verifyKeyMatches(maybeDoc);
	        assert_1.assert(mutationResult.transformResults == null, 'Transform results received by PatchMutation.');
	        // TODO(mcg): Relax enforcement of this precondition
	        //
	        // We shouldn't actually enforce the precondition since it already passed on
	        // the backend, but we may not have a local version of the document to
	        // patch, so we use the precondition to prevent incorrectly putting a
	        // partial document into our cache.
	        if (!this.precondition.isValidFor(maybeDoc)) {
	            return maybeDoc;
	        }
	        var version = Mutation.getPostMutationVersion(maybeDoc);
	        var newData = this.patchDocument(maybeDoc);
	        return new document_1.Document(this.key, version, newData, {
	            hasLocalMutations: false
	        });
	    };
	    PatchMutation.prototype.applyToLocalView = function (maybeDoc, baseDoc, localWriteTime) {
	        this.verifyKeyMatches(maybeDoc);
	        if (!this.precondition.isValidFor(maybeDoc)) {
	            return maybeDoc;
	        }
	        var version = Mutation.getPostMutationVersion(maybeDoc);
	        var newData = this.patchDocument(maybeDoc);
	        return new document_1.Document(this.key, version, newData, {
	            hasLocalMutations: true
	        });
	    };
	    PatchMutation.prototype.isEqual = function (other) {
	        return (other instanceof PatchMutation &&
	            this.key.isEqual(other.key) &&
	            this.fieldMask.isEqual(other.fieldMask) &&
	            this.precondition.isEqual(other.precondition));
	    };
	    /**
	     * Patches the data of document if available or creates a new document. Note
	     * that this does not check whether or not the precondition of this patch
	     * holds.
	     */
	    PatchMutation.prototype.patchDocument = function (maybeDoc) {
	        var data;
	        if (maybeDoc instanceof document_1.Document) {
	            data = maybeDoc.data;
	        }
	        else {
	            data = field_value_1.ObjectValue.EMPTY;
	        }
	        return this.patchObject(data);
	    };
	    PatchMutation.prototype.patchObject = function (data) {
	        for (var _i = 0, _a = this.fieldMask.fields; _i < _a.length; _i++) {
	            var fieldPath = _a[_i];
	            var newValue = this.data.field(fieldPath);
	            if (newValue !== undefined) {
	                data = data.set(fieldPath, newValue);
	            }
	            else {
	                data = data.delete(fieldPath);
	            }
	        }
	        return data;
	    };
	    return PatchMutation;
	}(Mutation));
	exports.PatchMutation = PatchMutation;
	/**
	 * A mutation that modifies specific fields of the document with transform
	 * operations. Currently the only supported transform is a server timestamp, but
	 * IP Address, increment(n), etc. could be supported in the future.
	 *
	 * It is somewhat similar to a PatchMutation in that it patches specific fields
	 * and has no effect when applied to a null or NoDocument (see comment on
	 * Mutation for rationale).
	 */
	var TransformMutation = /** @class */ (function (_super) {
	    __extends(TransformMutation, _super);
	    function TransformMutation(key, fieldTransforms) {
	        var _this = _super.call(this) || this;
	        _this.key = key;
	        _this.fieldTransforms = fieldTransforms;
	        _this.type = MutationType.Transform;
	        // NOTE: We set a precondition of exists: true as a safety-check, since we
	        // always combine TransformMutations with a SetMutation or PatchMutation which
	        // (if successful) should end up with an existing document.
	        _this.precondition = Precondition.exists(true);
	        return _this;
	    }
	    TransformMutation.prototype.applyToRemoteDocument = function (maybeDoc, mutationResult) {
	        this.verifyKeyMatches(maybeDoc);
	        assert_1.assert(mutationResult.transformResults != null, 'Transform results missing for TransformMutation.');
	        var transformResults = mutationResult.transformResults;
	        // TODO(mcg): Relax enforcement of this precondition
	        //
	        // We shouldn't actually enforce the precondition since it already passed on
	        // the backend, but we may not have a local version of the document to
	        // patch, so we use the precondition to prevent incorrectly putting a
	        // partial document into our cache.
	        if (!this.precondition.isValidFor(maybeDoc)) {
	            return maybeDoc;
	        }
	        var doc = this.requireDocument(maybeDoc);
	        var newData = this.transformObject(doc.data, transformResults);
	        return new document_1.Document(this.key, doc.version, newData, {
	            hasLocalMutations: false
	        });
	    };
	    TransformMutation.prototype.applyToLocalView = function (maybeDoc, baseDoc, localWriteTime) {
	        this.verifyKeyMatches(maybeDoc);
	        if (!this.precondition.isValidFor(maybeDoc)) {
	            return maybeDoc;
	        }
	        var doc = this.requireDocument(maybeDoc);
	        var transformResults = this.localTransformResults(localWriteTime, baseDoc);
	        var newData = this.transformObject(doc.data, transformResults);
	        return new document_1.Document(this.key, doc.version, newData, {
	            hasLocalMutations: true
	        });
	    };
	    TransformMutation.prototype.isEqual = function (other) {
	        return (other instanceof TransformMutation &&
	            this.key.isEqual(other.key) &&
	            misc.arrayEquals(this.fieldTransforms, other.fieldTransforms) &&
	            this.precondition.isEqual(other.precondition));
	    };
	    /**
	     * Asserts that the given MaybeDocument is actually a Document and verifies
	     * that it matches the key for this mutation. Since we only support
	     * transformations with precondition exists this method is guaranteed to be
	     * safe.
	     */
	    TransformMutation.prototype.requireDocument = function (maybeDoc) {
	        assert_1.assert(maybeDoc instanceof document_1.Document, 'Unknown MaybeDocument type ' + maybeDoc);
	        var doc = maybeDoc;
	        assert_1.assert(doc.key.isEqual(this.key), 'Can only transform a document with the same key');
	        return doc;
	    };
	    /**
	     * Creates a list of "transform results" (a transform result is a field value
	     * representing the result of applying a transform) for use when applying a
	     * TransformMutation locally.
	     *
	     * @param localWriteTime The local time of the transform mutation (used to
	     *     generate ServerTimestampValues).
	     * @param baseDoc The document prior to applying this mutation batch.
	     * @return The transform results list.
	     */
	    TransformMutation.prototype.localTransformResults = function (localWriteTime, baseDoc) {
	        var transformResults = [];
	        for (var _i = 0, _a = this.fieldTransforms; _i < _a.length; _i++) {
	            var fieldTransform = _a[_i];
	            var transform = fieldTransform.transform;
	            if (transform instanceof ServerTimestampTransform) {
	                var previousValue = null;
	                if (baseDoc instanceof document_1.Document) {
	                    previousValue = baseDoc.field(fieldTransform.field) || null;
	                }
	                transformResults.push(new field_value_1.ServerTimestampValue(localWriteTime, previousValue));
	            }
	            else {
	                return assert_1.fail('Encountered unknown transform: ' + transform);
	            }
	        }
	        return transformResults;
	    };
	    TransformMutation.prototype.transformObject = function (data, transformResults) {
	        assert_1.assert(transformResults.length === this.fieldTransforms.length, 'TransformResults length mismatch.');
	        for (var i = 0; i < this.fieldTransforms.length; i++) {
	            var fieldTransform = this.fieldTransforms[i];
	            var transform = fieldTransform.transform;
	            var fieldPath = fieldTransform.field;
	            if (transform instanceof ServerTimestampTransform) {
	                data = data.set(fieldPath, transformResults[i]);
	            }
	            else {
	                return assert_1.fail('Encountered unknown transform: ' + transform);
	            }
	        }
	        return data;
	    };
	    return TransformMutation;
	}(Mutation));
	exports.TransformMutation = TransformMutation;
	/** A mutation that deletes the document at the given key. */
	var DeleteMutation = /** @class */ (function (_super) {
	    __extends(DeleteMutation, _super);
	    function DeleteMutation(key, precondition) {
	        var _this = _super.call(this) || this;
	        _this.key = key;
	        _this.precondition = precondition;
	        _this.type = MutationType.Delete;
	        return _this;
	    }
	    DeleteMutation.prototype.applyToRemoteDocument = function (maybeDoc, mutationResult) {
	        this.verifyKeyMatches(maybeDoc);
	        assert_1.assert(mutationResult.transformResults == null, 'Transform results received by DeleteMutation.');
	        // Unlike applyToLocalView, if we're applying a mutation to a remote
	        // document the server has accepted the mutation so the precondition must
	        // have held.
	        return new document_1.NoDocument(this.key, snapshot_version_1.SnapshotVersion.MIN);
	    };
	    DeleteMutation.prototype.applyToLocalView = function (maybeDoc, baseDoc, localWriteTime) {
	        this.verifyKeyMatches(maybeDoc);
	        if (!this.precondition.isValidFor(maybeDoc)) {
	            return maybeDoc;
	        }
	        if (maybeDoc) {
	            assert_1.assert(maybeDoc.key.isEqual(this.key), 'Can only apply mutation to document with same key');
	        }
	        return new document_1.NoDocument(this.key, snapshot_version_1.SnapshotVersion.forDeletedDoc());
	    };
	    DeleteMutation.prototype.isEqual = function (other) {
	        return (other instanceof DeleteMutation &&
	            this.key.isEqual(other.key) &&
	            this.precondition.isEqual(other.precondition));
	    };
	    return DeleteMutation;
	}(Mutation));
	exports.DeleteMutation = DeleteMutation;
	
	//# sourceMappingURL=mutation.js.map


/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var sorted_map_1 = __webpack_require__(36);
	/**
	 * SortedSet is an immutable (copy-on-write) collection that holds elements
	 * in order specified by the provided comparator.
	 *
	 * NOTE: if provided comparator returns 0 for two elements, we consider them to
	 * be equal!
	 */
	var SortedSet = /** @class */ (function () {
	    function SortedSet(comparator) {
	        this.comparator = comparator;
	        this.data = new sorted_map_1.SortedMap(this.comparator);
	    }
	    /**
	     * Creates a SortedSet from the keys of the map.
	     * This is currently implemented as an O(n) copy.
	     */
	    SortedSet.fromMapKeys = function (map) {
	        var keys = new SortedSet(map.comparator);
	        map.forEach(function (key) {
	            keys = keys.add(key);
	        });
	        return keys;
	    };
	    SortedSet.prototype.has = function (elem) {
	        return this.data.get(elem) !== null;
	    };
	    SortedSet.prototype.first = function () {
	        return this.data.minKey();
	    };
	    SortedSet.prototype.last = function () {
	        return this.data.maxKey();
	    };
	    Object.defineProperty(SortedSet.prototype, "size", {
	        get: function () {
	            return this.data.size;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    SortedSet.prototype.indexOf = function (elem) {
	        return this.data.indexOf(elem);
	    };
	    /** Iterates elements in order defined by "comparator" */
	    SortedSet.prototype.forEach = function (cb) {
	        this.data.inorderTraversal(function (k, v) {
	            cb(k);
	            return false;
	        });
	    };
	    /** Iterates over `elem`s such that: range[0] <= elem < range[1]. */
	    SortedSet.prototype.forEachInRange = function (range, cb) {
	        var iter = this.data.getIteratorFrom(range[0]);
	        while (iter.hasNext()) {
	            var elem = iter.getNext();
	            if (this.comparator(elem.key, range[1]) >= 0)
	                return;
	            cb(elem.key);
	        }
	    };
	    /**
	     * Iterates over `elem`s such that: start <= elem until false is returned.
	     */
	    SortedSet.prototype.forEachWhile = function (cb, start) {
	        var iter;
	        if (start !== undefined) {
	            iter = this.data.getIteratorFrom(start);
	        }
	        else {
	            iter = this.data.getIterator();
	        }
	        while (iter.hasNext()) {
	            var elem = iter.getNext();
	            var result = cb(elem.key);
	            if (!result)
	                return;
	        }
	    };
	    /** Finds the least element greater than or equal to `elem`. */
	    SortedSet.prototype.firstAfterOrEqual = function (elem) {
	        var iter = this.data.getIteratorFrom(elem);
	        return iter.hasNext() ? iter.getNext().key : null;
	    };
	    /** Inserts or updates an element */
	    SortedSet.prototype.add = function (elem) {
	        return this.copy(this.data.remove(elem).insert(elem, true));
	    };
	    /** Deletes an element */
	    SortedSet.prototype.delete = function (elem) {
	        if (!this.has(elem))
	            return this;
	        return this.copy(this.data.remove(elem));
	    };
	    SortedSet.prototype.isEmpty = function () {
	        return this.data.isEmpty();
	    };
	    SortedSet.prototype.unionWith = function (other) {
	        var result = this;
	        other.forEach(function (elem) {
	            result = result.add(elem);
	        });
	        return result;
	    };
	    SortedSet.prototype.isEqual = function (other) {
	        if (!(other instanceof SortedSet))
	            return false;
	        if (this.size !== other.size)
	            return false;
	        var thisIt = this.data.getIterator();
	        var otherIt = other.data.getIterator();
	        while (thisIt.hasNext()) {
	            var thisElem = thisIt.getNext().key;
	            var otherElem = otherIt.getNext().key;
	            if (this.comparator(thisElem, otherElem) !== 0)
	                return false;
	        }
	        return true;
	    };
	    SortedSet.prototype.toString = function () {
	        var result = [];
	        this.forEach(function (elem) { return result.push(elem); });
	        return 'SortedSet(' + result.toString() + ')';
	    };
	    SortedSet.prototype.copy = function (data) {
	        var result = new SortedSet(this.comparator);
	        result.data = data;
	        return result;
	    };
	    return SortedSet;
	}());
	exports.SortedSet = SortedSet;
	
	//# sourceMappingURL=sorted_set.js.map


/***/ }),
/* 77 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	'use strict';
	Object.defineProperty(exports, "__esModule", { value: true });
	var CODES = {
	    AVAILABLE_IN_WINDOW: 'only-available-in-window',
	    AVAILABLE_IN_SW: 'only-available-in-sw',
	    SHOULD_BE_INHERITED: 'should-be-overriden',
	    BAD_SENDER_ID: 'bad-sender-id',
	    INCORRECT_GCM_SENDER_ID: 'incorrect-gcm-sender-id',
	    PERMISSION_DEFAULT: 'permission-default',
	    PERMISSION_BLOCKED: 'permission-blocked',
	    UNSUPPORTED_BROWSER: 'unsupported-browser',
	    NOTIFICATIONS_BLOCKED: 'notifications-blocked',
	    FAILED_DEFAULT_REGISTRATION: 'failed-serviceworker-registration',
	    SW_REGISTRATION_EXPECTED: 'sw-registration-expected',
	    GET_SUBSCRIPTION_FAILED: 'get-subscription-failed',
	    INVALID_SAVED_TOKEN: 'invalid-saved-token',
	    SW_REG_REDUNDANT: 'sw-reg-redundant',
	    TOKEN_SUBSCRIBE_FAILED: 'token-subscribe-failed',
	    TOKEN_SUBSCRIBE_NO_TOKEN: 'token-subscribe-no-token',
	    TOKEN_SUBSCRIBE_NO_PUSH_SET: 'token-subscribe-no-push-set',
	    USE_SW_BEFORE_GET_TOKEN: 'use-sw-before-get-token',
	    INVALID_DELETE_TOKEN: 'invalid-delete-token',
	    DELETE_TOKEN_NOT_FOUND: 'delete-token-not-found',
	    DELETE_SCOPE_NOT_FOUND: 'delete-scope-not-found',
	    BG_HANDLER_FUNCTION_EXPECTED: 'bg-handler-function-expected',
	    NO_WINDOW_CLIENT_TO_MSG: 'no-window-client-to-msg',
	    UNABLE_TO_RESUBSCRIBE: 'unable-to-resubscribe',
	    NO_FCM_TOKEN_FOR_RESUBSCRIBE: 'no-fcm-token-for-resubscribe',
	    FAILED_TO_DELETE_TOKEN: 'failed-to-delete-token',
	    NO_SW_IN_REG: 'no-sw-in-reg',
	    BAD_SCOPE: 'bad-scope',
	    BAD_VAPID_KEY: 'bad-vapid-key',
	    BAD_SUBSCRIPTION: 'bad-subscription',
	    BAD_TOKEN: 'bad-token',
	    BAD_PUSH_SET: 'bad-push-set',
	    FAILED_DELETE_VAPID_KEY: 'failed-delete-vapid-key'
	};
	var ERROR_MAP = (_a = {},
	    _a[CODES.AVAILABLE_IN_WINDOW] = 'This method is available in a Window context.',
	    _a[CODES.AVAILABLE_IN_SW] = 'This method is available in a service worker ' + 'context.',
	    _a[CODES.SHOULD_BE_INHERITED] = 'This method should be overriden by ' + 'extended classes.',
	    _a[CODES.BAD_SENDER_ID] = "Please ensure that 'messagingSenderId' is set " +
	        'correctly in the options passed into firebase.initializeApp().',
	    _a[CODES.PERMISSION_DEFAULT] = 'The required permissions were not granted and ' + 'dismissed instead.',
	    _a[CODES.PERMISSION_BLOCKED] = 'The required permissions were not granted and ' + 'blocked instead.',
	    _a[CODES.UNSUPPORTED_BROWSER] = "This browser doesn't support the API's " +
	        'required to use the firebase SDK.',
	    _a[CODES.NOTIFICATIONS_BLOCKED] = 'Notifications have been blocked.',
	    _a[CODES.FAILED_DEFAULT_REGISTRATION] = 'We are unable to register the ' +
	        'default service worker. {$browserErrorMessage}',
	    _a[CODES.SW_REGISTRATION_EXPECTED] = 'A service worker registration was the ' + 'expected input.',
	    _a[CODES.GET_SUBSCRIPTION_FAILED] = 'There was an error when trying to get ' +
	        'any existing Push Subscriptions.',
	    _a[CODES.INVALID_SAVED_TOKEN] = 'Unable to access details of the saved token.',
	    _a[CODES.SW_REG_REDUNDANT] = 'The service worker being used for push was made ' + 'redundant.',
	    _a[CODES.TOKEN_SUBSCRIBE_FAILED] = 'A problem occured while subscribing the ' + 'user to FCM: {$message}',
	    _a[CODES.TOKEN_SUBSCRIBE_NO_TOKEN] = 'FCM returned no token when subscribing ' + 'the user to push.',
	    _a[CODES.TOKEN_SUBSCRIBE_NO_PUSH_SET] = 'FCM returned an invalid response ' + 'when getting an FCM token.',
	    _a[CODES.USE_SW_BEFORE_GET_TOKEN] = 'You must call useServiceWorker() before ' +
	        'calling getToken() to ensure your service worker is used.',
	    _a[CODES.INVALID_DELETE_TOKEN] = 'You must pass a valid token into ' +
	        'deleteToken(), i.e. the token from getToken().',
	    _a[CODES.DELETE_TOKEN_NOT_FOUND] = 'The deletion attempt for token could not ' +
	        'be performed as the token was not found.',
	    _a[CODES.DELETE_SCOPE_NOT_FOUND] = 'The deletion attempt for service worker ' +
	        'scope could not be performed as the scope was not found.',
	    _a[CODES.BG_HANDLER_FUNCTION_EXPECTED] = 'The input to ' + 'setBackgroundMessageHandler() must be a function.',
	    _a[CODES.NO_WINDOW_CLIENT_TO_MSG] = 'An attempt was made to message a ' + 'non-existant window client.',
	    _a[CODES.UNABLE_TO_RESUBSCRIBE] = 'There was an error while re-subscribing ' +
	        'the FCM token for push messaging. Will have to resubscribe the ' +
	        'user on next visit. {$message}',
	    _a[CODES.NO_FCM_TOKEN_FOR_RESUBSCRIBE] = 'Could not find an FCM token ' +
	        'and as a result, unable to resubscribe. Will have to resubscribe the ' +
	        'user on next visit.',
	    _a[CODES.FAILED_TO_DELETE_TOKEN] = 'Unable to delete the currently saved token.',
	    _a[CODES.NO_SW_IN_REG] = 'Even though the service worker registration was ' +
	        'successful, there was a problem accessing the service worker itself.',
	    _a[CODES.INCORRECT_GCM_SENDER_ID] = "Please change your web app manifest's " +
	        "'gcm_sender_id' value to '103953800507' to use Firebase messaging.",
	    _a[CODES.BAD_SCOPE] = 'The service worker scope must be a string with at ' +
	        'least one character.',
	    _a[CODES.BAD_VAPID_KEY] = 'The public VAPID key must be a string with at ' + 'least one character.',
	    _a[CODES.BAD_SUBSCRIPTION] = 'The subscription must be a valid ' + 'PushSubscription.',
	    _a[CODES.BAD_TOKEN] = 'The FCM Token used for storage / lookup was not ' +
	        'a valid token string.',
	    _a[CODES.BAD_PUSH_SET] = 'The FCM push set used for storage / lookup was not ' +
	        'not a valid push set string.',
	    _a[CODES.FAILED_DELETE_VAPID_KEY] = 'The VAPID key could not be deleted.',
	    _a);
	exports.default = {
	    codes: CODES,
	    map: ERROR_MAP
	};
	var _a;
	
	//# sourceMappingURL=errors.js.map


/***/ }),
/* 78 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * @fileoverview Constants used in the Firebase Storage library.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Domain and scheme for API calls.
	 */
	exports.domainBase = 'https://firebasestorage.googleapis.com';
	/**
	 * Domain and scheme for object downloads.
	 */
	exports.downloadBase = 'https://firebasestorage.googleapis.com';
	/**
	 * Base URL for non-upload calls to the API.
	 */
	exports.apiBaseUrl = '/v0';
	/**
	 * Base URL for upload calls to the API.
	 */
	exports.apiUploadBaseUrl = '/v0';
	function setDomainBase(domainBase) {
	    domainBase = domainBase;
	}
	exports.setDomainBase = setDomainBase;
	exports.configOption = 'storageBucket';
	/**
	 * 1 minute
	 */
	exports.shortMaxOperationRetryTime = 1 * 60 * 1000;
	/**
	 * 2 minutes
	 */
	exports.defaultMaxOperationRetryTime = 2 * 60 * 1000;
	/**
	 * 10 minutes
	 */
	exports.defaultMaxUploadRetryTime = 10 * 60 * 100;
	/**
	 * This is the value of Number.MIN_SAFE_INTEGER, which is not well supported
	 * enough for us to use it directly.
	 */
	exports.minSafeInteger = -9007199254740991;
	
	//# sourceMappingURL=constants.js.map


/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * @fileoverview Functionality related to the parsing/composition of bucket/
	 * object location.
	 */
	var errorsExports = __webpack_require__(30);
	/**
	 * @struct
	 */
	var Location = /** @class */ (function () {
	    function Location(bucket, path) {
	        this.bucket = bucket;
	        this.path_ = path;
	    }
	    Object.defineProperty(Location.prototype, "path", {
	        get: function () {
	            return this.path_;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Location.prototype.fullServerUrl = function () {
	        var encode = encodeURIComponent;
	        return '/b/' + encode(this.bucket) + '/o/' + encode(this.path);
	    };
	    Location.prototype.bucketOnlyServerUrl = function () {
	        var encode = encodeURIComponent;
	        return '/b/' + encode(this.bucket) + '/o';
	    };
	    Location.makeFromBucketSpec = function (bucketString) {
	        var bucketLocation;
	        try {
	            bucketLocation = Location.makeFromUrl(bucketString);
	        }
	        catch (e) {
	            // Not valid URL, use as-is. This lets you put bare bucket names in
	            // config.
	            return new Location(bucketString, '');
	        }
	        if (bucketLocation.path === '') {
	            return bucketLocation;
	        }
	        else {
	            throw errorsExports.invalidDefaultBucket(bucketString);
	        }
	    };
	    Location.makeFromUrl = function (url) {
	        var location = null;
	        var bucketDomain = '([A-Za-z0-9.\\-]+)';
	        function gsModify(loc) {
	            if (loc.path.charAt(loc.path.length - 1) === '/') {
	                loc.path_ = loc.path_.slice(0, -1);
	            }
	        }
	        var gsPath = '(/(.*))?$';
	        var path = '(/([^?#]*).*)?$';
	        var gsRegex = new RegExp('^gs://' + bucketDomain + gsPath, 'i');
	        var gsIndices = { bucket: 1, path: 3 };
	        function httpModify(loc) {
	            loc.path_ = decodeURIComponent(loc.path);
	        }
	        var version = 'v[A-Za-z0-9_]+';
	        var httpRegex = new RegExp('^https?://firebasestorage\\.googleapis\\.com/' +
	            version +
	            '/b/' +
	            bucketDomain +
	            '/o' +
	            path, 'i');
	        var httpIndices = { bucket: 1, path: 3 };
	        var groups = [
	            { regex: gsRegex, indices: gsIndices, postModify: gsModify },
	            { regex: httpRegex, indices: httpIndices, postModify: httpModify }
	        ];
	        for (var i = 0; i < groups.length; i++) {
	            var group = groups[i];
	            var captures = group.regex.exec(url);
	            if (captures) {
	                var bucketValue = captures[group.indices.bucket];
	                var pathValue = captures[group.indices.path];
	                if (!pathValue) {
	                    pathValue = '';
	                }
	                location = new Location(bucketValue, pathValue);
	                group.postModify(location);
	                break;
	            }
	        }
	        if (location == null) {
	            throw errorsExports.invalidUrl(url);
	        }
	        return location;
	    };
	    return Location;
	}());
	exports.Location = Location;
	
	//# sourceMappingURL=location.js.map


/***/ }),
/* 80 */
/***/ (function(module, exports) {

	// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	var global = module.exports = typeof window != 'undefined' && window.Math == Math
	  ? window : typeof self != 'undefined' && self.Math == Math ? self
	  // eslint-disable-next-line no-new-func
	  : Function('return this')();
	if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 81 */
/***/ (function(module, exports) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	// css base code, injected by the css-loader
	module.exports = function() {
		var list = [];
	
		// return the list of modules as css string
		list.toString = function toString() {
			var result = [];
			for(var i = 0; i < this.length; i++) {
				var item = this[i];
				if(item[2]) {
					result.push("@media " + item[2] + "{" + item[1] + "}");
				} else {
					result.push(item[1]);
				}
			}
			return result.join("");
		};
	
		// import a list of modules into the list
		list.i = function(modules, mediaQuery) {
			if(typeof modules === "string")
				modules = [[null, modules, ""]];
			var alreadyImportedModules = {};
			for(var i = 0; i < this.length; i++) {
				var id = this[i][0];
				if(typeof id === "number")
					alreadyImportedModules[id] = true;
			}
			for(i = 0; i < modules.length; i++) {
				var item = modules[i];
				// skip already imported module
				// this implementation is not 100% perfect for weird media query combinations
				//  when a module is imported multiple times with different media queries.
				//  I hope this will never occur (Hey this way we have smaller bundles)
				if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
					if(mediaQuery && !item[2]) {
						item[2] = mediaQuery;
					} else if(mediaQuery) {
						item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
					}
					list.push(item);
				}
			}
		};
		return list;
	};


/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var emptyObject = {};
	
	if (false) {
	  Object.freeze(emptyObject);
	}
	
	module.exports = emptyObject;

/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(7);
	
	var EventPluginRegistry = __webpack_require__(119);
	var ReactEventEmitterMixin = __webpack_require__(445);
	var ViewportMetrics = __webpack_require__(207);
	
	var getVendorPrefixedEventName = __webpack_require__(477);
	var isEventSupported = __webpack_require__(130);
	
	/**
	 * Summary of `ReactBrowserEventEmitter` event handling:
	 *
	 *  - Top-level delegation is used to trap most native browser events. This
	 *    may only occur in the main thread and is the responsibility of
	 *    ReactEventListener, which is injected and can therefore support pluggable
	 *    event sources. This is the only work that occurs in the main thread.
	 *
	 *  - We normalize and de-duplicate events to account for browser quirks. This
	 *    may be done in the worker thread.
	 *
	 *  - Forward these native events (with the associated top-level type used to
	 *    trap it) to `EventPluginHub`, which in turn will ask plugins if they want
	 *    to extract any synthetic events.
	 *
	 *  - The `EventPluginHub` will then process each event by annotating them with
	 *    "dispatches", a sequence of listeners and IDs that care about that event.
	 *
	 *  - The `EventPluginHub` then dispatches the events.
	 *
	 * Overview of React and the event system:
	 *
	 * +------------+    .
	 * |    DOM     |    .
	 * +------------+    .
	 *       |           .
	 *       v           .
	 * +------------+    .
	 * | ReactEvent |    .
	 * |  Listener  |    .
	 * +------------+    .                         +-----------+
	 *       |           .               +--------+|SimpleEvent|
	 *       |           .               |         |Plugin     |
	 * +-----|------+    .               v         +-----------+
	 * |     |      |    .    +--------------+                    +------------+
	 * |     +-----------.--->|EventPluginHub|                    |    Event   |
	 * |            |    .    |              |     +-----------+  | Propagators|
	 * | ReactEvent |    .    |              |     |TapEvent   |  |------------|
	 * |  Emitter   |    .    |              |<---+|Plugin     |  |other plugin|
	 * |            |    .    |              |     +-----------+  |  utilities |
	 * |     +-----------.--->|              |                    +------------+
	 * |     |      |    .    +--------------+
	 * +-----|------+    .                ^        +-----------+
	 *       |           .                |        |Enter/Leave|
	 *       +           .                +-------+|Plugin     |
	 * +-------------+   .                         +-----------+
	 * | application |   .
	 * |-------------|   .
	 * |             |   .
	 * |             |   .
	 * +-------------+   .
	 *                   .
	 *    React Core     .  General Purpose Event Plugin System
	 */
	
	var hasEventPageXY;
	var alreadyListeningTo = {};
	var isMonitoringScrollValue = false;
	var reactTopListenersCounter = 0;
	
	// For events like 'submit' which don't consistently bubble (which we trap at a
	// lower node than `document`), binding at `document` would cause duplicate
	// events so we don't include them here
	var topEventMapping = {
	  topAbort: 'abort',
	  topAnimationEnd: getVendorPrefixedEventName('animationend') || 'animationend',
	  topAnimationIteration: getVendorPrefixedEventName('animationiteration') || 'animationiteration',
	  topAnimationStart: getVendorPrefixedEventName('animationstart') || 'animationstart',
	  topBlur: 'blur',
	  topCanPlay: 'canplay',
	  topCanPlayThrough: 'canplaythrough',
	  topChange: 'change',
	  topClick: 'click',
	  topCompositionEnd: 'compositionend',
	  topCompositionStart: 'compositionstart',
	  topCompositionUpdate: 'compositionupdate',
	  topContextMenu: 'contextmenu',
	  topCopy: 'copy',
	  topCut: 'cut',
	  topDoubleClick: 'dblclick',
	  topDrag: 'drag',
	  topDragEnd: 'dragend',
	  topDragEnter: 'dragenter',
	  topDragExit: 'dragexit',
	  topDragLeave: 'dragleave',
	  topDragOver: 'dragover',
	  topDragStart: 'dragstart',
	  topDrop: 'drop',
	  topDurationChange: 'durationchange',
	  topEmptied: 'emptied',
	  topEncrypted: 'encrypted',
	  topEnded: 'ended',
	  topError: 'error',
	  topFocus: 'focus',
	  topInput: 'input',
	  topKeyDown: 'keydown',
	  topKeyPress: 'keypress',
	  topKeyUp: 'keyup',
	  topLoadedData: 'loadeddata',
	  topLoadedMetadata: 'loadedmetadata',
	  topLoadStart: 'loadstart',
	  topMouseDown: 'mousedown',
	  topMouseMove: 'mousemove',
	  topMouseOut: 'mouseout',
	  topMouseOver: 'mouseover',
	  topMouseUp: 'mouseup',
	  topPaste: 'paste',
	  topPause: 'pause',
	  topPlay: 'play',
	  topPlaying: 'playing',
	  topProgress: 'progress',
	  topRateChange: 'ratechange',
	  topScroll: 'scroll',
	  topSeeked: 'seeked',
	  topSeeking: 'seeking',
	  topSelectionChange: 'selectionchange',
	  topStalled: 'stalled',
	  topSuspend: 'suspend',
	  topTextInput: 'textInput',
	  topTimeUpdate: 'timeupdate',
	  topTouchCancel: 'touchcancel',
	  topTouchEnd: 'touchend',
	  topTouchMove: 'touchmove',
	  topTouchStart: 'touchstart',
	  topTransitionEnd: getVendorPrefixedEventName('transitionend') || 'transitionend',
	  topVolumeChange: 'volumechange',
	  topWaiting: 'waiting',
	  topWheel: 'wheel'
	};
	
	/**
	 * To ensure no conflicts with other potential React instances on the page
	 */
	var topListenersIDKey = '_reactListenersID' + String(Math.random()).slice(2);
	
	function getListeningForDocument(mountAt) {
	  // In IE8, `mountAt` is a host object and doesn't have `hasOwnProperty`
	  // directly.
	  if (!Object.prototype.hasOwnProperty.call(mountAt, topListenersIDKey)) {
	    mountAt[topListenersIDKey] = reactTopListenersCounter++;
	    alreadyListeningTo[mountAt[topListenersIDKey]] = {};
	  }
	  return alreadyListeningTo[mountAt[topListenersIDKey]];
	}
	
	/**
	 * `ReactBrowserEventEmitter` is used to attach top-level event listeners. For
	 * example:
	 *
	 *   EventPluginHub.putListener('myID', 'onClick', myFunction);
	 *
	 * This would allocate a "registration" of `('onClick', myFunction)` on 'myID'.
	 *
	 * @internal
	 */
	var ReactBrowserEventEmitter = _assign({}, ReactEventEmitterMixin, {
	  /**
	   * Injectable event backend
	   */
	  ReactEventListener: null,
	
	  injection: {
	    /**
	     * @param {object} ReactEventListener
	     */
	    injectReactEventListener: function (ReactEventListener) {
	      ReactEventListener.setHandleTopLevel(ReactBrowserEventEmitter.handleTopLevel);
	      ReactBrowserEventEmitter.ReactEventListener = ReactEventListener;
	    }
	  },
	
	  /**
	   * Sets whether or not any created callbacks should be enabled.
	   *
	   * @param {boolean} enabled True if callbacks should be enabled.
	   */
	  setEnabled: function (enabled) {
	    if (ReactBrowserEventEmitter.ReactEventListener) {
	      ReactBrowserEventEmitter.ReactEventListener.setEnabled(enabled);
	    }
	  },
	
	  /**
	   * @return {boolean} True if callbacks are enabled.
	   */
	  isEnabled: function () {
	    return !!(ReactBrowserEventEmitter.ReactEventListener && ReactBrowserEventEmitter.ReactEventListener.isEnabled());
	  },
	
	  /**
	   * We listen for bubbled touch events on the document object.
	   *
	   * Firefox v8.01 (and possibly others) exhibited strange behavior when
	   * mounting `onmousemove` events at some node that was not the document
	   * element. The symptoms were that if your mouse is not moving over something
	   * contained within that mount point (for example on the background) the
	   * top-level listeners for `onmousemove` won't be called. However, if you
	   * register the `mousemove` on the document object, then it will of course
	   * catch all `mousemove`s. This along with iOS quirks, justifies restricting
	   * top-level listeners to the document object only, at least for these
	   * movement types of events and possibly all events.
	   *
	   * @see http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
	   *
	   * Also, `keyup`/`keypress`/`keydown` do not bubble to the window on IE, but
	   * they bubble to document.
	   *
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @param {object} contentDocumentHandle Document which owns the container
	   */
	  listenTo: function (registrationName, contentDocumentHandle) {
	    var mountAt = contentDocumentHandle;
	    var isListening = getListeningForDocument(mountAt);
	    var dependencies = EventPluginRegistry.registrationNameDependencies[registrationName];
	
	    for (var i = 0; i < dependencies.length; i++) {
	      var dependency = dependencies[i];
	      if (!(isListening.hasOwnProperty(dependency) && isListening[dependency])) {
	        if (dependency === 'topWheel') {
	          if (isEventSupported('wheel')) {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'wheel', mountAt);
	          } else if (isEventSupported('mousewheel')) {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'mousewheel', mountAt);
	          } else {
	            // Firefox needs to capture a different mouse scroll event.
	            // @see http://www.quirksmode.org/dom/events/tests/scroll.html
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'DOMMouseScroll', mountAt);
	          }
	        } else if (dependency === 'topScroll') {
	          if (isEventSupported('scroll', true)) {
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topScroll', 'scroll', mountAt);
	          } else {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topScroll', 'scroll', ReactBrowserEventEmitter.ReactEventListener.WINDOW_HANDLE);
	          }
	        } else if (dependency === 'topFocus' || dependency === 'topBlur') {
	          if (isEventSupported('focus', true)) {
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topFocus', 'focus', mountAt);
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topBlur', 'blur', mountAt);
	          } else if (isEventSupported('focusin')) {
	            // IE has `focusin` and `focusout` events which bubble.
	            // @see http://www.quirksmode.org/blog/archives/2008/04/delegating_the.html
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topFocus', 'focusin', mountAt);
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topBlur', 'focusout', mountAt);
	          }
	
	          // to make sure blur and focus event listeners are only attached once
	          isListening.topBlur = true;
	          isListening.topFocus = true;
	        } else if (topEventMapping.hasOwnProperty(dependency)) {
	          ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(dependency, topEventMapping[dependency], mountAt);
	        }
	
	        isListening[dependency] = true;
	      }
	    }
	  },
	
	  trapBubbledEvent: function (topLevelType, handlerBaseName, handle) {
	    return ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelType, handlerBaseName, handle);
	  },
	
	  trapCapturedEvent: function (topLevelType, handlerBaseName, handle) {
	    return ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(topLevelType, handlerBaseName, handle);
	  },
	
	  /**
	   * Protect against document.createEvent() returning null
	   * Some popup blocker extensions appear to do this:
	   * https://github.com/facebook/react/issues/6887
	   */
	  supportsEventPageXY: function () {
	    if (!document.createEvent) {
	      return false;
	    }
	    var ev = document.createEvent('MouseEvent');
	    return ev != null && 'pageX' in ev;
	  },
	
	  /**
	   * Listens to window scroll and resize events. We cache scroll values so that
	   * application code can access them without triggering reflows.
	   *
	   * ViewportMetrics is only used by SyntheticMouse/TouchEvent and only when
	   * pageX/pageY isn't supported (legacy browsers).
	   *
	   * NOTE: Scroll events do not bubble.
	   *
	   * @see http://www.quirksmode.org/dom/events/scroll.html
	   */
	  ensureScrollValueMonitoring: function () {
	    if (hasEventPageXY === undefined) {
	      hasEventPageXY = ReactBrowserEventEmitter.supportsEventPageXY();
	    }
	    if (!hasEventPageXY && !isMonitoringScrollValue) {
	      var refresh = ViewportMetrics.refreshScrollValues;
	      ReactBrowserEventEmitter.ReactEventListener.monitorScrollValue(refresh);
	      isMonitoringScrollValue = true;
	    }
	  }
	});
	
	module.exports = ReactBrowserEventEmitter;

/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(62);
	var ViewportMetrics = __webpack_require__(207);
	
	var getEventModifierState = __webpack_require__(128);
	
	/**
	 * @interface MouseEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var MouseEventInterface = {
	  screenX: null,
	  screenY: null,
	  clientX: null,
	  clientY: null,
	  ctrlKey: null,
	  shiftKey: null,
	  altKey: null,
	  metaKey: null,
	  getModifierState: getEventModifierState,
	  button: function (event) {
	    // Webkit, Firefox, IE9+
	    // which:  1 2 3
	    // button: 0 1 2 (standard)
	    var button = event.button;
	    if ('which' in event) {
	      return button;
	    }
	    // IE<9
	    // which:  undefined
	    // button: 0 0 0
	    // button: 1 4 2 (onmouseup)
	    return button === 2 ? 2 : button === 4 ? 1 : 0;
	  },
	  buttons: null,
	  relatedTarget: function (event) {
	    return event.relatedTarget || (event.fromElement === event.srcElement ? event.toElement : event.fromElement);
	  },
	  // "Proprietary" Interface.
	  pageX: function (event) {
	    return 'pageX' in event ? event.pageX : event.clientX + ViewportMetrics.currentScrollLeft;
	  },
	  pageY: function (event) {
	    return 'pageY' in event ? event.pageY : event.clientY + ViewportMetrics.currentScrollTop;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticMouseEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticMouseEvent, MouseEventInterface);
	
	module.exports = SyntheticMouseEvent;

/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(6);
	
	var invariant = __webpack_require__(3);
	
	var OBSERVED_ERROR = {};
	
	/**
	 * `Transaction` creates a black box that is able to wrap any method such that
	 * certain invariants are maintained before and after the method is invoked
	 * (Even if an exception is thrown while invoking the wrapped method). Whoever
	 * instantiates a transaction can provide enforcers of the invariants at
	 * creation time. The `Transaction` class itself will supply one additional
	 * automatic invariant for you - the invariant that any transaction instance
	 * should not be run while it is already being run. You would typically create a
	 * single instance of a `Transaction` for reuse multiple times, that potentially
	 * is used to wrap several different methods. Wrappers are extremely simple -
	 * they only require implementing two methods.
	 *
	 * <pre>
	 *                       wrappers (injected at creation time)
	 *                                      +        +
	 *                                      |        |
	 *                    +-----------------|--------|--------------+
	 *                    |                 v        |              |
	 *                    |      +---------------+   |              |
	 *                    |   +--|    wrapper1   |---|----+         |
	 *                    |   |  +---------------+   v    |         |
	 *                    |   |          +-------------+  |         |
	 *                    |   |     +----|   wrapper2  |--------+   |
	 *                    |   |     |    +-------------+  |     |   |
	 *                    |   |     |                     |     |   |
	 *                    |   v     v                     v     v   | wrapper
	 *                    | +---+ +---+   +---------+   +---+ +---+ | invariants
	 * perform(anyMethod) | |   | |   |   |         |   |   | |   | | maintained
	 * +----------------->|-|---|-|---|-->|anyMethod|---|---|-|---|-|-------->
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | +---+ +---+   +---------+   +---+ +---+ |
	 *                    |  initialize                    close    |
	 *                    +-----------------------------------------+
	 * </pre>
	 *
	 * Use cases:
	 * - Preserving the input selection ranges before/after reconciliation.
	 *   Restoring selection even in the event of an unexpected error.
	 * - Deactivating events while rearranging the DOM, preventing blurs/focuses,
	 *   while guaranteeing that afterwards, the event system is reactivated.
	 * - Flushing a queue of collected DOM mutations to the main UI thread after a
	 *   reconciliation takes place in a worker thread.
	 * - Invoking any collected `componentDidUpdate` callbacks after rendering new
	 *   content.
	 * - (Future use case): Wrapping particular flushes of the `ReactWorker` queue
	 *   to preserve the `scrollTop` (an automatic scroll aware DOM).
	 * - (Future use case): Layout calculations before and after DOM updates.
	 *
	 * Transactional plugin API:
	 * - A module that has an `initialize` method that returns any precomputation.
	 * - and a `close` method that accepts the precomputation. `close` is invoked
	 *   when the wrapped process is completed, or has failed.
	 *
	 * @param {Array<TransactionalWrapper>} transactionWrapper Wrapper modules
	 * that implement `initialize` and `close`.
	 * @return {Transaction} Single transaction for reuse in thread.
	 *
	 * @class Transaction
	 */
	var TransactionImpl = {
	  /**
	   * Sets up this instance so that it is prepared for collecting metrics. Does
	   * so such that this setup method may be used on an instance that is already
	   * initialized, in a way that does not consume additional memory upon reuse.
	   * That can be useful if you decide to make your subclass of this mixin a
	   * "PooledClass".
	   */
	  reinitializeTransaction: function () {
	    this.transactionWrappers = this.getTransactionWrappers();
	    if (this.wrapperInitData) {
	      this.wrapperInitData.length = 0;
	    } else {
	      this.wrapperInitData = [];
	    }
	    this._isInTransaction = false;
	  },
	
	  _isInTransaction: false,
	
	  /**
	   * @abstract
	   * @return {Array<TransactionWrapper>} Array of transaction wrappers.
	   */
	  getTransactionWrappers: null,
	
	  isInTransaction: function () {
	    return !!this._isInTransaction;
	  },
	
	  /* eslint-disable space-before-function-paren */
	
	  /**
	   * Executes the function within a safety window. Use this for the top level
	   * methods that result in large amounts of computation/mutations that would
	   * need to be safety checked. The optional arguments helps prevent the need
	   * to bind in many cases.
	   *
	   * @param {function} method Member of scope to call.
	   * @param {Object} scope Scope to invoke from.
	   * @param {Object?=} a Argument to pass to the method.
	   * @param {Object?=} b Argument to pass to the method.
	   * @param {Object?=} c Argument to pass to the method.
	   * @param {Object?=} d Argument to pass to the method.
	   * @param {Object?=} e Argument to pass to the method.
	   * @param {Object?=} f Argument to pass to the method.
	   *
	   * @return {*} Return value from `method`.
	   */
	  perform: function (method, scope, a, b, c, d, e, f) {
	    /* eslint-enable space-before-function-paren */
	    !!this.isInTransaction() ?  false ? invariant(false, 'Transaction.perform(...): Cannot initialize a transaction when there is already an outstanding transaction.') : _prodInvariant('27') : void 0;
	    var errorThrown;
	    var ret;
	    try {
	      this._isInTransaction = true;
	      // Catching errors makes debugging more difficult, so we start with
	      // errorThrown set to true before setting it to false after calling
	      // close -- if it's still set to true in the finally block, it means
	      // one of these calls threw.
	      errorThrown = true;
	      this.initializeAll(0);
	      ret = method.call(scope, a, b, c, d, e, f);
	      errorThrown = false;
	    } finally {
	      try {
	        if (errorThrown) {
	          // If `method` throws, prefer to show that stack trace over any thrown
	          // by invoking `closeAll`.
	          try {
	            this.closeAll(0);
	          } catch (err) {}
	        } else {
	          // Since `method` didn't throw, we don't want to silence the exception
	          // here.
	          this.closeAll(0);
	        }
	      } finally {
	        this._isInTransaction = false;
	      }
	    }
	    return ret;
	  },
	
	  initializeAll: function (startIndex) {
	    var transactionWrappers = this.transactionWrappers;
	    for (var i = startIndex; i < transactionWrappers.length; i++) {
	      var wrapper = transactionWrappers[i];
	      try {
	        // Catching errors makes debugging more difficult, so we start with the
	        // OBSERVED_ERROR state before overwriting it with the real return value
	        // of initialize -- if it's still set to OBSERVED_ERROR in the finally
	        // block, it means wrapper.initialize threw.
	        this.wrapperInitData[i] = OBSERVED_ERROR;
	        this.wrapperInitData[i] = wrapper.initialize ? wrapper.initialize.call(this) : null;
	      } finally {
	        if (this.wrapperInitData[i] === OBSERVED_ERROR) {
	          // The initializer for wrapper i threw an error; initialize the
	          // remaining wrappers but silence any exceptions from them to ensure
	          // that the first error is the one to bubble up.
	          try {
	            this.initializeAll(i + 1);
	          } catch (err) {}
	        }
	      }
	    }
	  },
	
	  /**
	   * Invokes each of `this.transactionWrappers.close[i]` functions, passing into
	   * them the respective return values of `this.transactionWrappers.init[i]`
	   * (`close`rs that correspond to initializers that failed will not be
	   * invoked).
	   */
	  closeAll: function (startIndex) {
	    !this.isInTransaction() ?  false ? invariant(false, 'Transaction.closeAll(): Cannot close transaction when none are open.') : _prodInvariant('28') : void 0;
	    var transactionWrappers = this.transactionWrappers;
	    for (var i = startIndex; i < transactionWrappers.length; i++) {
	      var wrapper = transactionWrappers[i];
	      var initData = this.wrapperInitData[i];
	      var errorThrown;
	      try {
	        // Catching errors makes debugging more difficult, so we start with
	        // errorThrown set to true before setting it to false after calling
	        // close -- if it's still set to true in the finally block, it means
	        // wrapper.close threw.
	        errorThrown = true;
	        if (initData !== OBSERVED_ERROR && wrapper.close) {
	          wrapper.close.call(this, initData);
	        }
	        errorThrown = false;
	      } finally {
	        if (errorThrown) {
	          // The closer for wrapper i threw an error; close the remaining
	          // wrappers but silence any exceptions from them to ensure that the
	          // first error is the one to bubble up.
	          try {
	            this.closeAll(i + 1);
	          } catch (e) {}
	        }
	      }
	    }
	    this.wrapperInitData.length = 0;
	  }
	};
	
	module.exports = TransactionImpl;

/***/ }),
/* 86 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2016-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * Based on the escape-html library, which is used under the MIT License below:
	 *
	 * Copyright (c) 2012-2013 TJ Holowaychuk
	 * Copyright (c) 2015 Andreas Lubbe
	 * Copyright (c) 2015 Tiancheng "Timothy" Gu
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining
	 * a copy of this software and associated documentation files (the
	 * 'Software'), to deal in the Software without restriction, including
	 * without limitation the rights to use, copy, modify, merge, publish,
	 * distribute, sublicense, and/or sell copies of the Software, and to
	 * permit persons to whom the Software is furnished to do so, subject to
	 * the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be
	 * included in all copies or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND,
	 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
	 * IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
	 * CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
	 * TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
	 * SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
	 *
	 */
	
	'use strict';
	
	// code copied and modified from escape-html
	/**
	 * Module variables.
	 * @private
	 */
	
	var matchHtmlRegExp = /["'&<>]/;
	
	/**
	 * Escape special characters in the given string of html.
	 *
	 * @param  {string} string The string to escape for inserting into HTML
	 * @return {string}
	 * @public
	 */
	
	function escapeHtml(string) {
	  var str = '' + string;
	  var match = matchHtmlRegExp.exec(str);
	
	  if (!match) {
	    return str;
	  }
	
	  var escape;
	  var html = '';
	  var index = 0;
	  var lastIndex = 0;
	
	  for (index = match.index; index < str.length; index++) {
	    switch (str.charCodeAt(index)) {
	      case 34:
	        // "
	        escape = '&quot;';
	        break;
	      case 38:
	        // &
	        escape = '&amp;';
	        break;
	      case 39:
	        // '
	        escape = '&#x27;'; // modified from escape-html; used to be '&#39'
	        break;
	      case 60:
	        // <
	        escape = '&lt;';
	        break;
	      case 62:
	        // >
	        escape = '&gt;';
	        break;
	      default:
	        continue;
	    }
	
	    if (lastIndex !== index) {
	      html += str.substring(lastIndex, index);
	    }
	
	    lastIndex = index + 1;
	    html += escape;
	  }
	
	  return lastIndex !== index ? html + str.substring(lastIndex, index) : html;
	}
	// end code copied and modified from escape-html
	
	/**
	 * Escapes text to prevent scripting attacks.
	 *
	 * @param {*} text Text value to escape.
	 * @return {string} An escaped string.
	 */
	function escapeTextContentForBrowser(text) {
	  if (typeof text === 'boolean' || typeof text === 'number') {
	    // this shortcircuit helps perf for types that we know will never have
	    // special characters, especially given that this function is used often
	    // for numeric dom ids.
	    return '' + text;
	  }
	  return escapeHtml(text);
	}
	
	module.exports = escapeTextContentForBrowser;

/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(16);
	var DOMNamespaces = __webpack_require__(118);
	
	var WHITESPACE_TEST = /^[ \r\n\t\f]/;
	var NONVISIBLE_TEST = /<(!--|link|noscript|meta|script|style)[ \r\n\t\f\/>]/;
	
	var createMicrosoftUnsafeLocalFunction = __webpack_require__(126);
	
	// SVG temp container for IE lacking innerHTML
	var reusableSVGContainer;
	
	/**
	 * Set the innerHTML property of a node, ensuring that whitespace is preserved
	 * even in IE8.
	 *
	 * @param {DOMElement} node
	 * @param {string} html
	 * @internal
	 */
	var setInnerHTML = createMicrosoftUnsafeLocalFunction(function (node, html) {
	  // IE does not have innerHTML for SVG nodes, so instead we inject the
	  // new markup in a temp node and then move the child nodes across into
	  // the target node
	  if (node.namespaceURI === DOMNamespaces.svg && !('innerHTML' in node)) {
	    reusableSVGContainer = reusableSVGContainer || document.createElement('div');
	    reusableSVGContainer.innerHTML = '<svg>' + html + '</svg>';
	    var svgNode = reusableSVGContainer.firstChild;
	    while (svgNode.firstChild) {
	      node.appendChild(svgNode.firstChild);
	    }
	  } else {
	    node.innerHTML = html;
	  }
	});
	
	if (ExecutionEnvironment.canUseDOM) {
	  // IE8: When updating a just created node with innerHTML only leading
	  // whitespace is removed. When updating an existing node with innerHTML
	  // whitespace in root TextNodes is also collapsed.
	  // @see quirksmode.org/bugreports/archives/2004/11/innerhtml_and_t.html
	
	  // Feature detection; only IE8 is known to behave improperly like this.
	  var testElement = document.createElement('div');
	  testElement.innerHTML = ' ';
	  if (testElement.innerHTML === '') {
	    setInnerHTML = function (node, html) {
	      // Magic theory: IE8 supposedly differentiates between added and updated
	      // nodes when processing innerHTML, innerHTML on updated nodes suffers
	      // from worse whitespace behavior. Re-adding a node like this triggers
	      // the initial and more favorable whitespace behavior.
	      // TODO: What to do on a detached node?
	      if (node.parentNode) {
	        node.parentNode.replaceChild(node, node);
	      }
	
	      // We also implement a workaround for non-visible tags disappearing into
	      // thin air on IE8, this only happens if there is no visible text
	      // in-front of the non-visible tags. Piggyback on the whitespace fix
	      // and simply check if any non-visible tags appear in the source.
	      if (WHITESPACE_TEST.test(html) || html[0] === '<' && NONVISIBLE_TEST.test(html)) {
	        // Recover leading whitespace by temporarily prepending any character.
	        // \uFEFF has the potential advantage of being zero-width/invisible.
	        // UglifyJS drops U+FEFF chars when parsing, so use String.fromCharCode
	        // in hopes that this is preserved even if "\uFEFF" is transformed to
	        // the actual Unicode character (by Babel, for example).
	        // https://github.com/mishoo/UglifyJS2/blob/v2.4.20/lib/parse.js#L216
	        node.innerHTML = String.fromCharCode(0xfeff) + html;
	
	        // deleteData leaves an empty `TextNode` which offsets the index of all
	        // children. Definitely want to avoid this.
	        var textNode = node.firstChild;
	        if (textNode.data.length === 1) {
	          node.removeChild(textNode);
	        } else {
	          textNode.deleteData(0, 1);
	        }
	      } else {
	        node.innerHTML = html;
	      }
	    };
	  }
	  testElement = null;
	}
	
	module.exports = setInnerHTML;

/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	var stylesInDom = {},
		memoize = function(fn) {
			var memo;
			return function () {
				if (typeof memo === "undefined") memo = fn.apply(this, arguments);
				return memo;
			};
		},
		isOldIE = memoize(function() {
			return /msie [6-9]\b/.test(self.navigator.userAgent.toLowerCase());
		}),
		getHeadElement = memoize(function () {
			return document.head || document.getElementsByTagName("head")[0];
		}),
		singletonElement = null,
		singletonCounter = 0,
		styleElementsInsertedAtTop = [];
	
	module.exports = function(list, options) {
		if(true) {
			if(typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
		}
	
		options = options || {};
		// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
		// tags it will allow on a page
		if (typeof options.singleton === "undefined") options.singleton = isOldIE();
	
		// By default, add <style> tags to the bottom of <head>.
		if (typeof options.insertAt === "undefined") options.insertAt = "bottom";
	
		var styles = listToStyles(list);
		addStylesToDom(styles, options);
	
		return function update(newList) {
			var mayRemove = [];
			for(var i = 0; i < styles.length; i++) {
				var item = styles[i];
				var domStyle = stylesInDom[item.id];
				domStyle.refs--;
				mayRemove.push(domStyle);
			}
			if(newList) {
				var newStyles = listToStyles(newList);
				addStylesToDom(newStyles, options);
			}
			for(var i = 0; i < mayRemove.length; i++) {
				var domStyle = mayRemove[i];
				if(domStyle.refs === 0) {
					for(var j = 0; j < domStyle.parts.length; j++)
						domStyle.parts[j]();
					delete stylesInDom[domStyle.id];
				}
			}
		};
	}
	
	function addStylesToDom(styles, options) {
		for(var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];
			if(domStyle) {
				domStyle.refs++;
				for(var j = 0; j < domStyle.parts.length; j++) {
					domStyle.parts[j](item.parts[j]);
				}
				for(; j < item.parts.length; j++) {
					domStyle.parts.push(addStyle(item.parts[j], options));
				}
			} else {
				var parts = [];
				for(var j = 0; j < item.parts.length; j++) {
					parts.push(addStyle(item.parts[j], options));
				}
				stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
			}
		}
	}
	
	function listToStyles(list) {
		var styles = [];
		var newStyles = {};
		for(var i = 0; i < list.length; i++) {
			var item = list[i];
			var id = item[0];
			var css = item[1];
			var media = item[2];
			var sourceMap = item[3];
			var part = {css: css, media: media, sourceMap: sourceMap};
			if(!newStyles[id])
				styles.push(newStyles[id] = {id: id, parts: [part]});
			else
				newStyles[id].parts.push(part);
		}
		return styles;
	}
	
	function insertStyleElement(options, styleElement) {
		var head = getHeadElement();
		var lastStyleElementInsertedAtTop = styleElementsInsertedAtTop[styleElementsInsertedAtTop.length - 1];
		if (options.insertAt === "top") {
			if(!lastStyleElementInsertedAtTop) {
				head.insertBefore(styleElement, head.firstChild);
			} else if(lastStyleElementInsertedAtTop.nextSibling) {
				head.insertBefore(styleElement, lastStyleElementInsertedAtTop.nextSibling);
			} else {
				head.appendChild(styleElement);
			}
			styleElementsInsertedAtTop.push(styleElement);
		} else if (options.insertAt === "bottom") {
			head.appendChild(styleElement);
		} else {
			throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");
		}
	}
	
	function removeStyleElement(styleElement) {
		styleElement.parentNode.removeChild(styleElement);
		var idx = styleElementsInsertedAtTop.indexOf(styleElement);
		if(idx >= 0) {
			styleElementsInsertedAtTop.splice(idx, 1);
		}
	}
	
	function createStyleElement(options) {
		var styleElement = document.createElement("style");
		styleElement.type = "text/css";
		insertStyleElement(options, styleElement);
		return styleElement;
	}
	
	function createLinkElement(options) {
		var linkElement = document.createElement("link");
		linkElement.rel = "stylesheet";
		insertStyleElement(options, linkElement);
		return linkElement;
	}
	
	function addStyle(obj, options) {
		var styleElement, update, remove;
	
		if (options.singleton) {
			var styleIndex = singletonCounter++;
			styleElement = singletonElement || (singletonElement = createStyleElement(options));
			update = applyToSingletonTag.bind(null, styleElement, styleIndex, false);
			remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true);
		} else if(obj.sourceMap &&
			typeof URL === "function" &&
			typeof URL.createObjectURL === "function" &&
			typeof URL.revokeObjectURL === "function" &&
			typeof Blob === "function" &&
			typeof btoa === "function") {
			styleElement = createLinkElement(options);
			update = updateLink.bind(null, styleElement);
			remove = function() {
				removeStyleElement(styleElement);
				if(styleElement.href)
					URL.revokeObjectURL(styleElement.href);
			};
		} else {
			styleElement = createStyleElement(options);
			update = applyToTag.bind(null, styleElement);
			remove = function() {
				removeStyleElement(styleElement);
			};
		}
	
		update(obj);
	
		return function updateStyle(newObj) {
			if(newObj) {
				if(newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap)
					return;
				update(obj = newObj);
			} else {
				remove();
			}
		};
	}
	
	var replaceText = (function () {
		var textStore = [];
	
		return function (index, replacement) {
			textStore[index] = replacement;
			return textStore.filter(Boolean).join('\n');
		};
	})();
	
	function applyToSingletonTag(styleElement, index, remove, obj) {
		var css = remove ? "" : obj.css;
	
		if (styleElement.styleSheet) {
			styleElement.styleSheet.cssText = replaceText(index, css);
		} else {
			var cssNode = document.createTextNode(css);
			var childNodes = styleElement.childNodes;
			if (childNodes[index]) styleElement.removeChild(childNodes[index]);
			if (childNodes.length) {
				styleElement.insertBefore(cssNode, childNodes[index]);
			} else {
				styleElement.appendChild(cssNode);
			}
		}
	}
	
	function applyToTag(styleElement, obj) {
		var css = obj.css;
		var media = obj.media;
	
		if(media) {
			styleElement.setAttribute("media", media)
		}
	
		if(styleElement.styleSheet) {
			styleElement.styleSheet.cssText = css;
		} else {
			while(styleElement.firstChild) {
				styleElement.removeChild(styleElement.firstChild);
			}
			styleElement.appendChild(document.createTextNode(css));
		}
	}
	
	function updateLink(linkElement, obj) {
		var css = obj.css;
		var sourceMap = obj.sourceMap;
	
		if(sourceMap) {
			// http://stackoverflow.com/a/26603875
			css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
		}
	
		var blob = new Blob([css], { type: "text/css" });
	
		var oldSrc = linkElement.href;
	
		linkElement.href = URL.createObjectURL(blob);
	
		if(oldSrc)
			URL.revokeObjectURL(oldSrc);
	}


/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var util_1 = __webpack_require__(1);
	var validation_1 = __webpack_require__(34);
	var Path_1 = __webpack_require__(8);
	var PriorityIndex_1 = __webpack_require__(15);
	/**
	 * Class representing a firebase data snapshot.  It wraps a SnapshotNode and
	 * surfaces the public methods (val, forEach, etc.) we want to expose.
	 */
	var DataSnapshot = /** @class */ (function () {
	    /**
	     * @param {!Node} node_ A SnapshotNode to wrap.
	     * @param {!Reference} ref_ The ref of the location this snapshot came from.
	     * @param {!Index} index_ The iteration order for this snapshot
	     */
	    function DataSnapshot(node_, ref_, index_) {
	        this.node_ = node_;
	        this.ref_ = ref_;
	        this.index_ = index_;
	    }
	    /**
	     * Retrieves the snapshot contents as JSON.  Returns null if the snapshot is
	     * empty.
	     *
	     * @return {*} JSON representation of the DataSnapshot contents, or null if empty.
	     */
	    DataSnapshot.prototype.val = function () {
	        util_1.validateArgCount('DataSnapshot.val', 0, 0, arguments.length);
	        return this.node_.val();
	    };
	    /**
	     * Returns the snapshot contents as JSON, including priorities of node.  Suitable for exporting
	     * the entire node contents.
	     * @return {*} JSON representation of the DataSnapshot contents, or null if empty.
	     */
	    DataSnapshot.prototype.exportVal = function () {
	        util_1.validateArgCount('DataSnapshot.exportVal', 0, 0, arguments.length);
	        return this.node_.val(true);
	    };
	    // Do not create public documentation. This is intended to make JSON serialization work but is otherwise unnecessary
	    // for end-users
	    DataSnapshot.prototype.toJSON = function () {
	        // Optional spacer argument is unnecessary because we're depending on recursion rather than stringifying the content
	        util_1.validateArgCount('DataSnapshot.toJSON', 0, 1, arguments.length);
	        return this.exportVal();
	    };
	    /**
	     * Returns whether the snapshot contains a non-null value.
	     *
	     * @return {boolean} Whether the snapshot contains a non-null value, or is empty.
	     */
	    DataSnapshot.prototype.exists = function () {
	        util_1.validateArgCount('DataSnapshot.exists', 0, 0, arguments.length);
	        return !this.node_.isEmpty();
	    };
	    /**
	     * Returns a DataSnapshot of the specified child node's contents.
	     *
	     * @param {!string} childPathString Path to a child.
	     * @return {!DataSnapshot} DataSnapshot for child node.
	     */
	    DataSnapshot.prototype.child = function (childPathString) {
	        util_1.validateArgCount('DataSnapshot.child', 0, 1, arguments.length);
	        // Ensure the childPath is a string (can be a number)
	        childPathString = String(childPathString);
	        validation_1.validatePathString('DataSnapshot.child', 1, childPathString, false);
	        var childPath = new Path_1.Path(childPathString);
	        var childRef = this.ref_.child(childPath);
	        return new DataSnapshot(this.node_.getChild(childPath), childRef, PriorityIndex_1.PRIORITY_INDEX);
	    };
	    /**
	     * Returns whether the snapshot contains a child at the specified path.
	     *
	     * @param {!string} childPathString Path to a child.
	     * @return {boolean} Whether the child exists.
	     */
	    DataSnapshot.prototype.hasChild = function (childPathString) {
	        util_1.validateArgCount('DataSnapshot.hasChild', 1, 1, arguments.length);
	        validation_1.validatePathString('DataSnapshot.hasChild', 1, childPathString, false);
	        var childPath = new Path_1.Path(childPathString);
	        return !this.node_.getChild(childPath).isEmpty();
	    };
	    /**
	     * Returns the priority of the object, or null if no priority was set.
	     *
	     * @return {string|number|null} The priority.
	     */
	    DataSnapshot.prototype.getPriority = function () {
	        util_1.validateArgCount('DataSnapshot.getPriority', 0, 0, arguments.length);
	        // typecast here because we never return deferred values or internal priorities (MAX_PRIORITY)
	        return this.node_.getPriority().val();
	    };
	    /**
	     * Iterates through child nodes and calls the specified action for each one.
	     *
	     * @param {function(!DataSnapshot)} action Callback function to be called
	     * for each child.
	     * @return {boolean} True if forEach was canceled by action returning true for
	     * one of the child nodes.
	     */
	    DataSnapshot.prototype.forEach = function (action) {
	        var _this = this;
	        util_1.validateArgCount('DataSnapshot.forEach', 1, 1, arguments.length);
	        util_1.validateCallback('DataSnapshot.forEach', 1, action, false);
	        if (this.node_.isLeafNode())
	            return false;
	        var childrenNode = this.node_;
	        // Sanitize the return value to a boolean. ChildrenNode.forEachChild has a weird return type...
	        return !!childrenNode.forEachChild(this.index_, function (key, node) {
	            return action(new DataSnapshot(node, _this.ref_.child(key), PriorityIndex_1.PRIORITY_INDEX));
	        });
	    };
	    /**
	     * Returns whether this DataSnapshot has children.
	     * @return {boolean} True if the DataSnapshot contains 1 or more child nodes.
	     */
	    DataSnapshot.prototype.hasChildren = function () {
	        util_1.validateArgCount('DataSnapshot.hasChildren', 0, 0, arguments.length);
	        if (this.node_.isLeafNode())
	            return false;
	        else
	            return !this.node_.isEmpty();
	    };
	    Object.defineProperty(DataSnapshot.prototype, "key", {
	        get: function () {
	            return this.ref_.getKey();
	        },
	        enumerable: true,
	        configurable: true
	    });
	    /**
	     * Returns the number of children for this DataSnapshot.
	     * @return {number} The number of children that this DataSnapshot contains.
	     */
	    DataSnapshot.prototype.numChildren = function () {
	        util_1.validateArgCount('DataSnapshot.numChildren', 0, 0, arguments.length);
	        return this.node_.numChildren();
	    };
	    /**
	     * @return {Reference} The Firebase reference for the location this snapshot's data came from.
	     */
	    DataSnapshot.prototype.getRef = function () {
	        util_1.validateArgCount('DataSnapshot.ref', 0, 0, arguments.length);
	        return this.ref_;
	    };
	    Object.defineProperty(DataSnapshot.prototype, "ref", {
	        get: function () {
	            return this.getRef();
	        },
	        enumerable: true,
	        configurable: true
	    });
	    return DataSnapshot;
	}());
	exports.DataSnapshot = DataSnapshot;
	
	//# sourceMappingURL=DataSnapshot.js.map


/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var onDisconnect_1 = __webpack_require__(135);
	var TransactionResult_1 = __webpack_require__(225);
	var util_1 = __webpack_require__(4);
	var NextPushId_1 = __webpack_require__(242);
	var Query_1 = __webpack_require__(134);
	var Repo_1 = __webpack_require__(65);
	var Path_1 = __webpack_require__(8);
	var QueryParams_1 = __webpack_require__(252);
	var validation_1 = __webpack_require__(34);
	var util_2 = __webpack_require__(1);
	var util_3 = __webpack_require__(1);
	var SyncPoint_1 = __webpack_require__(140);
	var Reference = /** @class */ (function (_super) {
	    __extends(Reference, _super);
	    /**
	     * Call options:
	     *   new Reference(Repo, Path) or
	     *   new Reference(url: string, string|RepoManager)
	     *
	     * Externally - this is the firebase.database.Reference type.
	     *
	     * @param {!Repo} repo
	     * @param {(!Path)} path
	     * @extends {Query}
	     */
	    function Reference(repo, path) {
	        var _this = this;
	        if (!(repo instanceof Repo_1.Repo)) {
	            throw new Error('new Reference() no longer supported - use app.database().');
	        }
	        // call Query's constructor, passing in the repo and path.
	        _this = _super.call(this, repo, path, QueryParams_1.QueryParams.DEFAULT, false) || this;
	        return _this;
	    }
	    /** @return {?string} */
	    Reference.prototype.getKey = function () {
	        util_2.validateArgCount('Reference.key', 0, 0, arguments.length);
	        if (this.path.isEmpty())
	            return null;
	        else
	            return this.path.getBack();
	    };
	    /**
	     * @param {!(string|Path)} pathString
	     * @return {!Reference}
	     */
	    Reference.prototype.child = function (pathString) {
	        util_2.validateArgCount('Reference.child', 1, 1, arguments.length);
	        if (typeof pathString === 'number') {
	            pathString = String(pathString);
	        }
	        else if (!(pathString instanceof Path_1.Path)) {
	            if (this.path.getFront() === null)
	                validation_1.validateRootPathString('Reference.child', 1, pathString, false);
	            else
	                validation_1.validatePathString('Reference.child', 1, pathString, false);
	        }
	        return new Reference(this.repo, this.path.child(pathString));
	    };
	    /** @return {?Reference} */
	    Reference.prototype.getParent = function () {
	        util_2.validateArgCount('Reference.parent', 0, 0, arguments.length);
	        var parentPath = this.path.parent();
	        return parentPath === null ? null : new Reference(this.repo, parentPath);
	    };
	    /** @return {!Reference} */
	    Reference.prototype.getRoot = function () {
	        util_2.validateArgCount('Reference.root', 0, 0, arguments.length);
	        var ref = this;
	        while (ref.getParent() !== null) {
	            ref = ref.getParent();
	        }
	        return ref;
	    };
	    /** @return {!Database} */
	    Reference.prototype.databaseProp = function () {
	        return this.repo.database;
	    };
	    /**
	     * @param {*} newVal
	     * @param {function(?Error)=} onComplete
	     * @return {!Promise}
	     */
	    Reference.prototype.set = function (newVal, onComplete) {
	        util_2.validateArgCount('Reference.set', 1, 2, arguments.length);
	        validation_1.validateWritablePath('Reference.set', this.path);
	        validation_1.validateFirebaseDataArg('Reference.set', 1, newVal, this.path, false);
	        util_2.validateCallback('Reference.set', 2, onComplete, true);
	        var deferred = new util_3.Deferred();
	        this.repo.setWithPriority(this.path, newVal, 
	        /*priority=*/ null, deferred.wrapCallback(onComplete));
	        return deferred.promise;
	    };
	    /**
	     * @param {!Object} objectToMerge
	     * @param {function(?Error)=} onComplete
	     * @return {!Promise}
	     */
	    Reference.prototype.update = function (objectToMerge, onComplete) {
	        util_2.validateArgCount('Reference.update', 1, 2, arguments.length);
	        validation_1.validateWritablePath('Reference.update', this.path);
	        if (Array.isArray(objectToMerge)) {
	            var newObjectToMerge = {};
	            for (var i = 0; i < objectToMerge.length; ++i) {
	                newObjectToMerge['' + i] = objectToMerge[i];
	            }
	            objectToMerge = newObjectToMerge;
	            util_1.warn('Passing an Array to Firebase.update() is deprecated. ' +
	                'Use set() if you want to overwrite the existing data, or ' +
	                'an Object with integer keys if you really do want to ' +
	                'only update some of the children.');
	        }
	        validation_1.validateFirebaseMergeDataArg('Reference.update', 1, objectToMerge, this.path, false);
	        util_2.validateCallback('Reference.update', 2, onComplete, true);
	        var deferred = new util_3.Deferred();
	        this.repo.update(this.path, objectToMerge, deferred.wrapCallback(onComplete));
	        return deferred.promise;
	    };
	    /**
	     * @param {*} newVal
	     * @param {string|number|null} newPriority
	     * @param {function(?Error)=} onComplete
	     * @return {!Promise}
	     */
	    Reference.prototype.setWithPriority = function (newVal, newPriority, onComplete) {
	        util_2.validateArgCount('Reference.setWithPriority', 2, 3, arguments.length);
	        validation_1.validateWritablePath('Reference.setWithPriority', this.path);
	        validation_1.validateFirebaseDataArg('Reference.setWithPriority', 1, newVal, this.path, false);
	        validation_1.validatePriority('Reference.setWithPriority', 2, newPriority, false);
	        util_2.validateCallback('Reference.setWithPriority', 3, onComplete, true);
	        if (this.getKey() === '.length' || this.getKey() === '.keys')
	            throw 'Reference.setWithPriority failed: ' +
	                this.getKey() +
	                ' is a read-only object.';
	        var deferred = new util_3.Deferred();
	        this.repo.setWithPriority(this.path, newVal, newPriority, deferred.wrapCallback(onComplete));
	        return deferred.promise;
	    };
	    /**
	     * @param {function(?Error)=} onComplete
	     * @return {!Promise}
	     */
	    Reference.prototype.remove = function (onComplete) {
	        util_2.validateArgCount('Reference.remove', 0, 1, arguments.length);
	        validation_1.validateWritablePath('Reference.remove', this.path);
	        util_2.validateCallback('Reference.remove', 1, onComplete, true);
	        return this.set(null, onComplete);
	    };
	    /**
	     * @param {function(*):*} transactionUpdate
	     * @param {(function(?Error, boolean, ?DataSnapshot))=} onComplete
	     * @param {boolean=} applyLocally
	     * @return {!Promise}
	     */
	    Reference.prototype.transaction = function (transactionUpdate, onComplete, applyLocally) {
	        util_2.validateArgCount('Reference.transaction', 1, 3, arguments.length);
	        validation_1.validateWritablePath('Reference.transaction', this.path);
	        util_2.validateCallback('Reference.transaction', 1, transactionUpdate, false);
	        util_2.validateCallback('Reference.transaction', 2, onComplete, true);
	        // NOTE: applyLocally is an internal-only option for now.  We need to decide if we want to keep it and how
	        // to expose it.
	        validation_1.validateBoolean('Reference.transaction', 3, applyLocally, true);
	        if (this.getKey() === '.length' || this.getKey() === '.keys')
	            throw 'Reference.transaction failed: ' +
	                this.getKey() +
	                ' is a read-only object.';
	        if (applyLocally === undefined)
	            applyLocally = true;
	        var deferred = new util_3.Deferred();
	        if (typeof onComplete === 'function') {
	            deferred.promise.catch(function () { });
	        }
	        var promiseComplete = function (error, committed, snapshot) {
	            if (error) {
	                deferred.reject(error);
	            }
	            else {
	                deferred.resolve(new TransactionResult_1.TransactionResult(committed, snapshot));
	            }
	            if (typeof onComplete === 'function') {
	                onComplete(error, committed, snapshot);
	            }
	        };
	        this.repo.startTransaction(this.path, transactionUpdate, promiseComplete, applyLocally);
	        return deferred.promise;
	    };
	    /**
	     * @param {string|number|null} priority
	     * @param {function(?Error)=} onComplete
	     * @return {!Promise}
	     */
	    Reference.prototype.setPriority = function (priority, onComplete) {
	        util_2.validateArgCount('Reference.setPriority', 1, 2, arguments.length);
	        validation_1.validateWritablePath('Reference.setPriority', this.path);
	        validation_1.validatePriority('Reference.setPriority', 1, priority, false);
	        util_2.validateCallback('Reference.setPriority', 2, onComplete, true);
	        var deferred = new util_3.Deferred();
	        this.repo.setWithPriority(this.path.child('.priority'), priority, null, deferred.wrapCallback(onComplete));
	        return deferred.promise;
	    };
	    /**
	     * @param {*=} value
	     * @param {function(?Error)=} onComplete
	     * @return {!Reference}
	     */
	    Reference.prototype.push = function (value, onComplete) {
	        util_2.validateArgCount('Reference.push', 0, 2, arguments.length);
	        validation_1.validateWritablePath('Reference.push', this.path);
	        validation_1.validateFirebaseDataArg('Reference.push', 1, value, this.path, true);
	        util_2.validateCallback('Reference.push', 2, onComplete, true);
	        var now = this.repo.serverTime();
	        var name = NextPushId_1.nextPushId(now);
	        // push() returns a ThennableReference whose promise is fulfilled with a regular Reference.
	        // We use child() to create handles to two different references. The first is turned into a
	        // ThennableReference below by adding then() and catch() methods and is used as the
	        // return value of push(). The second remains a regular Reference and is used as the fulfilled
	        // value of the first ThennableReference.
	        var thennablePushRef = this.child(name);
	        var pushRef = this.child(name);
	        var promise;
	        if (value != null) {
	            promise = thennablePushRef.set(value, onComplete).then(function () { return pushRef; });
	        }
	        else {
	            promise = Promise.resolve(pushRef);
	        }
	        thennablePushRef.then = promise.then.bind(promise);
	        thennablePushRef.catch = promise.then.bind(promise, undefined);
	        if (typeof onComplete === 'function') {
	            promise.catch(function () { });
	        }
	        return thennablePushRef;
	    };
	    /**
	     * @return {!OnDisconnect}
	     */
	    Reference.prototype.onDisconnect = function () {
	        validation_1.validateWritablePath('Reference.onDisconnect', this.path);
	        return new onDisconnect_1.OnDisconnect(this.repo, this.path);
	    };
	    Object.defineProperty(Reference.prototype, "database", {
	        get: function () {
	            return this.databaseProp();
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(Reference.prototype, "key", {
	        get: function () {
	            return this.getKey();
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(Reference.prototype, "parent", {
	        get: function () {
	            return this.getParent();
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(Reference.prototype, "root", {
	        get: function () {
	            return this.getRoot();
	        },
	        enumerable: true,
	        configurable: true
	    });
	    return Reference;
	}(Query_1.Query));
	exports.Reference = Reference;
	/**
	 * Define reference constructor in various modules
	 *
	 * We are doing this here to avoid several circular
	 * dependency issues
	 */
	Query_1.Query.__referenceConstructor = Reference;
	SyncPoint_1.SyncPoint.__referenceConstructor = Reference;
	
	//# sourceMappingURL=Reference.js.map


/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var util_1 = __webpack_require__(1);
	var Repo_1 = __webpack_require__(65);
	var util_2 = __webpack_require__(4);
	var parser_1 = __webpack_require__(152);
	var validation_1 = __webpack_require__(34);
	__webpack_require__(231);
	/** @const {string} */
	var DATABASE_URL_OPTION = 'databaseURL';
	var _staticInstance;
	/**
	 * Creates and caches Repo instances.
	 */
	var RepoManager = /** @class */ (function () {
	    function RepoManager() {
	        /**
	         * @private {!Object.<string, Object<string, !fb.core.Repo>>}
	         */
	        this.repos_ = {};
	        /**
	         * If true, new Repos will be created to use ReadonlyRestClient (for testing purposes).
	         * @private {boolean}
	         */
	        this.useRestClient_ = false;
	    }
	    RepoManager.getInstance = function () {
	        if (!_staticInstance) {
	            _staticInstance = new RepoManager();
	        }
	        return _staticInstance;
	    };
	    // TODO(koss): Remove these functions unless used in tests?
	    RepoManager.prototype.interrupt = function () {
	        for (var appName in this.repos_) {
	            for (var dbUrl in this.repos_[appName]) {
	                this.repos_[appName][dbUrl].interrupt();
	            }
	        }
	    };
	    RepoManager.prototype.resume = function () {
	        for (var appName in this.repos_) {
	            for (var dbUrl in this.repos_[appName]) {
	                this.repos_[appName][dbUrl].resume();
	            }
	        }
	    };
	    /**
	     * This function should only ever be called to CREATE a new database instance.
	     *
	     * @param {!FirebaseApp} app
	     * @return {!Database}
	     */
	    RepoManager.prototype.databaseFromApp = function (app, url) {
	        var dbUrl = url || app.options[DATABASE_URL_OPTION];
	        if (dbUrl === undefined) {
	            util_2.fatal("Can't determine Firebase Database URL.  Be sure to include " +
	                DATABASE_URL_OPTION +
	                ' option when calling firebase.initializeApp().');
	        }
	        var parsedUrl = parser_1.parseRepoInfo(dbUrl);
	        var repoInfo = parsedUrl.repoInfo;
	        validation_1.validateUrl('Invalid Firebase Database URL', 1, parsedUrl);
	        if (!parsedUrl.path.isEmpty()) {
	            util_2.fatal('Database URL must point to the root of a Firebase Database ' +
	                '(not including a child path).');
	        }
	        var repo = this.createRepo(repoInfo, app);
	        return repo.database;
	    };
	    /**
	     * Remove the repo and make sure it is disconnected.
	     *
	     * @param {!Repo} repo
	     */
	    RepoManager.prototype.deleteRepo = function (repo) {
	        var appRepos = util_1.safeGet(this.repos_, repo.app.name);
	        // This should never happen...
	        if (!appRepos || util_1.safeGet(appRepos, repo.repoInfo_.toURLString()) !== repo) {
	            util_2.fatal("Database " + repo.app.name + "(" + repo.repoInfo_ + ") has already been deleted.");
	        }
	        repo.interrupt();
	        delete appRepos[repo.repoInfo_.toURLString()];
	    };
	    /**
	     * Ensures a repo doesn't already exist and then creates one using the
	     * provided app.
	     *
	     * @param {!RepoInfo} repoInfo The metadata about the Repo
	     * @param {!FirebaseApp} app
	     * @return {!Repo} The Repo object for the specified server / repoName.
	     */
	    RepoManager.prototype.createRepo = function (repoInfo, app) {
	        var appRepos = util_1.safeGet(this.repos_, app.name);
	        if (!appRepos) {
	            appRepos = {};
	            this.repos_[app.name] = appRepos;
	        }
	        var repo = util_1.safeGet(appRepos, repoInfo.toURLString());
	        if (repo) {
	            util_2.fatal('Database initialized multiple times. Please make sure the format of the database URL matches with each database() call.');
	        }
	        repo = new Repo_1.Repo(repoInfo, this.useRestClient_, app);
	        appRepos[repoInfo.toURLString()] = repo;
	        return repo;
	    };
	    /**
	     * Forces us to use ReadonlyRestClient instead of PersistentConnection for new Repos.
	     * @param {boolean} forceRestClient
	     */
	    RepoManager.prototype.forceRestClient = function (forceRestClient) {
	        this.useRestClient_ = forceRestClient;
	    };
	    return RepoManager;
	}());
	exports.RepoManager = RepoManager;
	
	//# sourceMappingURL=RepoManager.js.map


/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var StatsCollection_1 = __webpack_require__(238);
	var StatsManager = /** @class */ (function () {
	    function StatsManager() {
	    }
	    StatsManager.getCollection = function (repoInfo) {
	        var hashString = repoInfo.toString();
	        if (!this.collections_[hashString]) {
	            this.collections_[hashString] = new StatsCollection_1.StatsCollection();
	        }
	        return this.collections_[hashString];
	    };
	    StatsManager.getOrCreateReporter = function (repoInfo, creatorFunction) {
	        var hashString = repoInfo.toString();
	        if (!this.reporters_[hashString]) {
	            this.reporters_[hashString] = creatorFunction();
	        }
	        return this.reporters_[hashString];
	    };
	    StatsManager.collections_ = {};
	    StatsManager.reporters_ = {};
	    return StatsManager;
	}());
	exports.StatsManager = StatsManager;
	
	//# sourceMappingURL=StatsManager.js.map


/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var SortedMap_1 = __webpack_require__(69);
	var Path_1 = __webpack_require__(8);
	var util_1 = __webpack_require__(4);
	var util_2 = __webpack_require__(1);
	var emptyChildrenSingleton;
	/**
	 * Singleton empty children collection.
	 *
	 * @const
	 * @type {!SortedMap.<string, !ImmutableTree.<?>>}
	 */
	var EmptyChildren = function () {
	    if (!emptyChildrenSingleton) {
	        emptyChildrenSingleton = new SortedMap_1.SortedMap(util_1.stringCompare);
	    }
	    return emptyChildrenSingleton;
	};
	/**
	 * A tree with immutable elements.
	 */
	var ImmutableTree = /** @class */ (function () {
	    /**
	     * @template T
	     * @param {?T} value
	     * @param {SortedMap.<string, !ImmutableTree.<T>>=} children
	     */
	    function ImmutableTree(value, children) {
	        if (children === void 0) { children = EmptyChildren(); }
	        this.value = value;
	        this.children = children;
	    }
	    /**
	     * @template T
	     * @param {!Object.<string, !T>} obj
	     * @return {!ImmutableTree.<!T>}
	     */
	    ImmutableTree.fromObject = function (obj) {
	        var tree = ImmutableTree.Empty;
	        util_2.forEach(obj, function (childPath, childSnap) {
	            tree = tree.set(new Path_1.Path(childPath), childSnap);
	        });
	        return tree;
	    };
	    /**
	     * True if the value is empty and there are no children
	     * @return {boolean}
	     */
	    ImmutableTree.prototype.isEmpty = function () {
	        return this.value === null && this.children.isEmpty();
	    };
	    /**
	     * Given a path and predicate, return the first node and the path to that node
	     * where the predicate returns true.
	     *
	     * TODO Do a perf test -- If we're creating a bunch of {path: value:} objects
	     * on the way back out, it may be better to pass down a pathSoFar obj.
	     *
	     * @param {!Path} relativePath The remainder of the path
	     * @param {function(T):boolean} predicate The predicate to satisfy to return a
	     *   node
	     * @return {?{path:!Path, value:!T}}
	     */
	    ImmutableTree.prototype.findRootMostMatchingPathAndValue = function (relativePath, predicate) {
	        if (this.value != null && predicate(this.value)) {
	            return { path: Path_1.Path.Empty, value: this.value };
	        }
	        else {
	            if (relativePath.isEmpty()) {
	                return null;
	            }
	            else {
	                var front = relativePath.getFront();
	                var child = this.children.get(front);
	                if (child !== null) {
	                    var childExistingPathAndValue = child.findRootMostMatchingPathAndValue(relativePath.popFront(), predicate);
	                    if (childExistingPathAndValue != null) {
	                        var fullPath = new Path_1.Path(front).child(childExistingPathAndValue.path);
	                        return { path: fullPath, value: childExistingPathAndValue.value };
	                    }
	                    else {
	                        return null;
	                    }
	                }
	                else {
	                    return null;
	                }
	            }
	        }
	    };
	    /**
	     * Find, if it exists, the shortest subpath of the given path that points a defined
	     * value in the tree
	     * @param {!Path} relativePath
	     * @return {?{path: !Path, value: !T}}
	     */
	    ImmutableTree.prototype.findRootMostValueAndPath = function (relativePath) {
	        return this.findRootMostMatchingPathAndValue(relativePath, function () { return true; });
	    };
	    /**
	     * @param {!Path} relativePath
	     * @return {!ImmutableTree.<T>} The subtree at the given path
	     */
	    ImmutableTree.prototype.subtree = function (relativePath) {
	        if (relativePath.isEmpty()) {
	            return this;
	        }
	        else {
	            var front = relativePath.getFront();
	            var childTree = this.children.get(front);
	            if (childTree !== null) {
	                return childTree.subtree(relativePath.popFront());
	            }
	            else {
	                return ImmutableTree.Empty;
	            }
	        }
	    };
	    /**
	     * Sets a value at the specified path.
	     *
	     * @param {!Path} relativePath Path to set value at.
	     * @param {?T} toSet Value to set.
	     * @return {!ImmutableTree.<T>} Resulting tree.
	     */
	    ImmutableTree.prototype.set = function (relativePath, toSet) {
	        if (relativePath.isEmpty()) {
	            return new ImmutableTree(toSet, this.children);
	        }
	        else {
	            var front = relativePath.getFront();
	            var child = this.children.get(front) || ImmutableTree.Empty;
	            var newChild = child.set(relativePath.popFront(), toSet);
	            var newChildren = this.children.insert(front, newChild);
	            return new ImmutableTree(this.value, newChildren);
	        }
	    };
	    /**
	     * Removes the value at the specified path.
	     *
	     * @param {!Path} relativePath Path to value to remove.
	     * @return {!ImmutableTree.<T>} Resulting tree.
	     */
	    ImmutableTree.prototype.remove = function (relativePath) {
	        if (relativePath.isEmpty()) {
	            if (this.children.isEmpty()) {
	                return ImmutableTree.Empty;
	            }
	            else {
	                return new ImmutableTree(null, this.children);
	            }
	        }
	        else {
	            var front = relativePath.getFront();
	            var child = this.children.get(front);
	            if (child) {
	                var newChild = child.remove(relativePath.popFront());
	                var newChildren = void 0;
	                if (newChild.isEmpty()) {
	                    newChildren = this.children.remove(front);
	                }
	                else {
	                    newChildren = this.children.insert(front, newChild);
	                }
	                if (this.value === null && newChildren.isEmpty()) {
	                    return ImmutableTree.Empty;
	                }
	                else {
	                    return new ImmutableTree(this.value, newChildren);
	                }
	            }
	            else {
	                return this;
	            }
	        }
	    };
	    /**
	     * Gets a value from the tree.
	     *
	     * @param {!Path} relativePath Path to get value for.
	     * @return {?T} Value at path, or null.
	     */
	    ImmutableTree.prototype.get = function (relativePath) {
	        if (relativePath.isEmpty()) {
	            return this.value;
	        }
	        else {
	            var front = relativePath.getFront();
	            var child = this.children.get(front);
	            if (child) {
	                return child.get(relativePath.popFront());
	            }
	            else {
	                return null;
	            }
	        }
	    };
	    /**
	     * Replace the subtree at the specified path with the given new tree.
	     *
	     * @param {!Path} relativePath Path to replace subtree for.
	     * @param {!ImmutableTree} newTree New tree.
	     * @return {!ImmutableTree} Resulting tree.
	     */
	    ImmutableTree.prototype.setTree = function (relativePath, newTree) {
	        if (relativePath.isEmpty()) {
	            return newTree;
	        }
	        else {
	            var front = relativePath.getFront();
	            var child = this.children.get(front) || ImmutableTree.Empty;
	            var newChild = child.setTree(relativePath.popFront(), newTree);
	            var newChildren = void 0;
	            if (newChild.isEmpty()) {
	                newChildren = this.children.remove(front);
	            }
	            else {
	                newChildren = this.children.insert(front, newChild);
	            }
	            return new ImmutableTree(this.value, newChildren);
	        }
	    };
	    /**
	     * Performs a depth first fold on this tree. Transforms a tree into a single
	     * value, given a function that operates on the path to a node, an optional
	     * current value, and a map of child names to folded subtrees
	     * @template V
	     * @param {function(Path, ?T, Object.<string, V>):V} fn
	     * @return {V}
	     */
	    ImmutableTree.prototype.fold = function (fn) {
	        return this.fold_(Path_1.Path.Empty, fn);
	    };
	    /**
	     * Recursive helper for public-facing fold() method
	     * @template V
	     * @param {!Path} pathSoFar
	     * @param {function(Path, ?T, Object.<string, V>):V} fn
	     * @return {V}
	     * @private
	     */
	    ImmutableTree.prototype.fold_ = function (pathSoFar, fn) {
	        var accum = {};
	        this.children.inorderTraversal(function (childKey, childTree) {
	            accum[childKey] = childTree.fold_(pathSoFar.child(childKey), fn);
	        });
	        return fn(pathSoFar, this.value, accum);
	    };
	    /**
	     * Find the first matching value on the given path. Return the result of applying f to it.
	     * @template V
	     * @param {!Path} path
	     * @param {!function(!Path, !T):?V} f
	     * @return {?V}
	     */
	    ImmutableTree.prototype.findOnPath = function (path, f) {
	        return this.findOnPath_(path, Path_1.Path.Empty, f);
	    };
	    ImmutableTree.prototype.findOnPath_ = function (pathToFollow, pathSoFar, f) {
	        var result = this.value ? f(pathSoFar, this.value) : false;
	        if (result) {
	            return result;
	        }
	        else {
	            if (pathToFollow.isEmpty()) {
	                return null;
	            }
	            else {
	                var front = pathToFollow.getFront();
	                var nextChild = this.children.get(front);
	                if (nextChild) {
	                    return nextChild.findOnPath_(pathToFollow.popFront(), pathSoFar.child(front), f);
	                }
	                else {
	                    return null;
	                }
	            }
	        }
	    };
	    /**
	     *
	     * @param {!Path} path
	     * @param {!function(!Path, !T)} f
	     * @returns {!ImmutableTree.<T>}
	     */
	    ImmutableTree.prototype.foreachOnPath = function (path, f) {
	        return this.foreachOnPath_(path, Path_1.Path.Empty, f);
	    };
	    ImmutableTree.prototype.foreachOnPath_ = function (pathToFollow, currentRelativePath, f) {
	        if (pathToFollow.isEmpty()) {
	            return this;
	        }
	        else {
	            if (this.value) {
	                f(currentRelativePath, this.value);
	            }
	            var front = pathToFollow.getFront();
	            var nextChild = this.children.get(front);
	            if (nextChild) {
	                return nextChild.foreachOnPath_(pathToFollow.popFront(), currentRelativePath.child(front), f);
	            }
	            else {
	                return ImmutableTree.Empty;
	            }
	        }
	    };
	    /**
	     * Calls the given function for each node in the tree that has a value.
	     *
	     * @param {function(!Path, !T)} f A function to be called with
	     *   the path from the root of the tree to a node, and the value at that node.
	     *   Called in depth-first order.
	     */
	    ImmutableTree.prototype.foreach = function (f) {
	        this.foreach_(Path_1.Path.Empty, f);
	    };
	    ImmutableTree.prototype.foreach_ = function (currentRelativePath, f) {
	        this.children.inorderTraversal(function (childName, childTree) {
	            childTree.foreach_(currentRelativePath.child(childName), f);
	        });
	        if (this.value) {
	            f(currentRelativePath, this.value);
	        }
	    };
	    /**
	     *
	     * @param {function(string, !T)} f
	     */
	    ImmutableTree.prototype.foreachChild = function (f) {
	        this.children.inorderTraversal(function (childName, childTree) {
	            if (childTree.value) {
	                f(childName, childTree.value);
	            }
	        });
	    };
	    ImmutableTree.Empty = new ImmutableTree(null);
	    return ImmutableTree;
	}());
	exports.ImmutableTree = ImmutableTree;
	
	//# sourceMappingURL=ImmutableTree.js.map


/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var util_1 = __webpack_require__(1);
	var Change_1 = __webpack_require__(39);
	var ChildrenNode_1 = __webpack_require__(17);
	var PriorityIndex_1 = __webpack_require__(15);
	/**
	 * Doesn't really filter nodes but applies an index to the node and keeps track of any changes
	 *
	 * @constructor
	 * @implements {NodeFilter}
	 * @param {!Index} index
	 */
	var IndexedFilter = /** @class */ (function () {
	    function IndexedFilter(index_) {
	        this.index_ = index_;
	    }
	    IndexedFilter.prototype.updateChild = function (snap, key, newChild, affectedPath, source, optChangeAccumulator) {
	        util_1.assert(snap.isIndexed(this.index_), 'A node must be indexed if only a child is updated');
	        var oldChild = snap.getImmediateChild(key);
	        // Check if anything actually changed.
	        if (oldChild.getChild(affectedPath).equals(newChild.getChild(affectedPath))) {
	            // There's an edge case where a child can enter or leave the view because affectedPath was set to null.
	            // In this case, affectedPath will appear null in both the old and new snapshots.  So we need
	            // to avoid treating these cases as "nothing changed."
	            if (oldChild.isEmpty() == newChild.isEmpty()) {
	                // Nothing changed.
	                // This assert should be valid, but it's expensive (can dominate perf testing) so don't actually do it.
	                //assert(oldChild.equals(newChild), 'Old and new snapshots should be equal.');
	                return snap;
	            }
	        }
	        if (optChangeAccumulator != null) {
	            if (newChild.isEmpty()) {
	                if (snap.hasChild(key)) {
	                    optChangeAccumulator.trackChildChange(Change_1.Change.childRemovedChange(key, oldChild));
	                }
	                else {
	                    util_1.assert(snap.isLeafNode(), 'A child remove without an old child only makes sense on a leaf node');
	                }
	            }
	            else if (oldChild.isEmpty()) {
	                optChangeAccumulator.trackChildChange(Change_1.Change.childAddedChange(key, newChild));
	            }
	            else {
	                optChangeAccumulator.trackChildChange(Change_1.Change.childChangedChange(key, newChild, oldChild));
	            }
	        }
	        if (snap.isLeafNode() && newChild.isEmpty()) {
	            return snap;
	        }
	        else {
	            // Make sure the node is indexed
	            return snap.updateImmediateChild(key, newChild).withIndex(this.index_);
	        }
	    };
	    /**
	     * @inheritDoc
	     */
	    IndexedFilter.prototype.updateFullNode = function (oldSnap, newSnap, optChangeAccumulator) {
	        if (optChangeAccumulator != null) {
	            if (!oldSnap.isLeafNode()) {
	                oldSnap.forEachChild(PriorityIndex_1.PRIORITY_INDEX, function (key, childNode) {
	                    if (!newSnap.hasChild(key)) {
	                        optChangeAccumulator.trackChildChange(Change_1.Change.childRemovedChange(key, childNode));
	                    }
	                });
	            }
	            if (!newSnap.isLeafNode()) {
	                newSnap.forEachChild(PriorityIndex_1.PRIORITY_INDEX, function (key, childNode) {
	                    if (oldSnap.hasChild(key)) {
	                        var oldChild = oldSnap.getImmediateChild(key);
	                        if (!oldChild.equals(childNode)) {
	                            optChangeAccumulator.trackChildChange(Change_1.Change.childChangedChange(key, childNode, oldChild));
	                        }
	                    }
	                    else {
	                        optChangeAccumulator.trackChildChange(Change_1.Change.childAddedChange(key, childNode));
	                    }
	                });
	            }
	        }
	        return newSnap.withIndex(this.index_);
	    };
	    /**
	     * @inheritDoc
	     */
	    IndexedFilter.prototype.updatePriority = function (oldSnap, newPriority) {
	        if (oldSnap.isEmpty()) {
	            return ChildrenNode_1.ChildrenNode.EMPTY_NODE;
	        }
	        else {
	            return oldSnap.updatePriority(newPriority);
	        }
	    };
	    /**
	     * @inheritDoc
	     */
	    IndexedFilter.prototype.filtersNodes = function () {
	        return false;
	    };
	    /**
	     * @inheritDoc
	     */
	    IndexedFilter.prototype.getIndexedFilter = function () {
	        return this;
	    };
	    /**
	     * @inheritDoc
	     */
	    IndexedFilter.prototype.getIndex = function () {
	        return this.index_;
	    };
	    return IndexedFilter;
	}());
	exports.IndexedFilter = IndexedFilter;
	
	//# sourceMappingURL=IndexedFilter.js.map


/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var platform_1 = __webpack_require__(29);
	var api_1 = __webpack_require__(103);
	var error_1 = __webpack_require__(10);
	var input_validation_1 = __webpack_require__(54);
	var misc_1 = __webpack_require__(14);
	/** Helper function to assert Uint8Array is available at runtime. */
	function assertUint8ArrayAvailable() {
	    if (typeof Uint8Array === 'undefined') {
	        throw new error_1.FirestoreError(error_1.Code.UNIMPLEMENTED, 'Uint8Arrays are not available in this environment.');
	    }
	}
	/** Helper function to assert Base64 functions are available at runtime. */
	function assertBase64Available() {
	    if (!platform_1.PlatformSupport.getPlatform().base64Available) {
	        throw new error_1.FirestoreError(error_1.Code.UNIMPLEMENTED, 'Blobs are unavailable in Firestore in this environment.');
	    }
	}
	/**
	 * Immutable class holding a blob (binary data).
	 * This class is directly exposed in the public API.
	 *
	 * Note that while you can't hide the constructor in JavaScript code, we are
	 * using the hack above to make sure no-one outside this module can call it.
	 */
	var Blob = /** @class */ (function () {
	    function Blob(binaryString) {
	        assertBase64Available();
	        this._binaryString = binaryString;
	    }
	    Blob.fromBase64String = function (base64) {
	        input_validation_1.validateExactNumberOfArgs('Blob.fromBase64String', arguments, 1);
	        input_validation_1.validateArgType('Blob.fromBase64String', 'string', 1, base64);
	        assertBase64Available();
	        try {
	            var binaryString = platform_1.PlatformSupport.getPlatform().atob(base64);
	            return new Blob(binaryString);
	        }
	        catch (e) {
	            throw new error_1.FirestoreError(error_1.Code.INVALID_ARGUMENT, 'Failed to construct Blob from Base64 string: ' + e);
	        }
	    };
	    Blob.fromUint8Array = function (array) {
	        input_validation_1.validateExactNumberOfArgs('Blob.fromUint8Array', arguments, 1);
	        assertUint8ArrayAvailable();
	        if (!(array instanceof Uint8Array)) {
	            throw input_validation_1.invalidClassError('Blob.fromUint8Array', 'Uint8Array', 1, array);
	        }
	        // We can't call array.map directly because it expects the return type to
	        // be a Uint8Array, whereas we can convert it to a regular array by invoking
	        // map on the Array prototype.
	        var binaryString = Array.prototype.map
	            .call(array, function (char) {
	            return String.fromCharCode(char);
	        })
	            .join('');
	        return new Blob(binaryString);
	    };
	    Blob.prototype.toBase64 = function () {
	        input_validation_1.validateExactNumberOfArgs('Blob.toBase64', arguments, 0);
	        assertBase64Available();
	        return platform_1.PlatformSupport.getPlatform().btoa(this._binaryString);
	    };
	    Blob.prototype.toUint8Array = function () {
	        input_validation_1.validateExactNumberOfArgs('Blob.toUint8Array', arguments, 0);
	        assertUint8ArrayAvailable();
	        var buffer = new Uint8Array(this._binaryString.length);
	        for (var i = 0; i < this._binaryString.length; i++) {
	            buffer[i] = this._binaryString.charCodeAt(i);
	        }
	        return buffer;
	    };
	    Blob.prototype.toString = function () {
	        return 'Blob(base64: ' + this.toBase64() + ')';
	    };
	    Blob.prototype.isEqual = function (other) {
	        return this._binaryString === other._binaryString;
	    };
	    /**
	     * Actually private to JS consumers of our API, so this function is prefixed
	     * with an underscore.
	     */
	    Blob.prototype._compareTo = function (other) {
	        return misc_1.primitiveComparator(this._binaryString, other._binaryString);
	    };
	    return Blob;
	}());
	exports.Blob = Blob;
	// Public instance that disallows construction at runtime. This constructor is
	// used when exporting Blob on firebase.firestore.Blob and will be called Blob
	// publicly. Internally we still use Blob which has a type checked private
	// constructor. Note that Blob and PublicBlob can be used interchangeably in
	// instanceof checks.
	// For our internal TypeScript code PublicBlob doesn't exist as a type, and so
	// we need to use Blob as type and export it too.
	// tslint:disable-next-line:variable-name We're treating this as a class name.
	exports.PublicBlob = api_1.makeConstructorPrivate(Blob, 'Use Blob.fromUint8Array() or Blob.fromBase64String() instead.');
	
	//# sourceMappingURL=blob.js.map


/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var path_1 = __webpack_require__(35);
	var error_1 = __webpack_require__(10);
	var input_validation_1 = __webpack_require__(54);
	// The objects that are a part of this API are exposed to third-parties as
	// compiled javascript so we want to flag our private members with a leading
	// underscore to discourage their use.
	// tslint:disable:strip-private-property-underscore
	/**
	 * A FieldPath refers to a field in a document. The path may consist of a single
	 * field name (referring to a top-level field in the document), or a list of
	 * field names (referring to a nested field in the document).
	 */
	var FieldPath = /** @class */ (function () {
	    /**
	     * Creates a FieldPath from the provided field names. If more than one field
	     * name is provided, the path will point to a nested field in a document.
	     *
	     * @param fieldNames A list of field names.
	     */
	    function FieldPath() {
	        var fieldNames = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            fieldNames[_i] = arguments[_i];
	        }
	        input_validation_1.validateNamedArrayAtLeastNumberOfElements('FieldPath', fieldNames, 'fieldNames', 1);
	        for (var i = 0; i < fieldNames.length; ++i) {
	            input_validation_1.validateArgType('FieldPath', 'string', i, fieldNames[i]);
	            if (fieldNames[i].length === 0) {
	                throw new error_1.FirestoreError(error_1.Code.INVALID_ARGUMENT, "Invalid field name at argument $(i + 1). " +
	                    'Field names must not be empty.');
	            }
	        }
	        this._internalPath = new path_1.FieldPath(fieldNames);
	    }
	    FieldPath.documentId = function () {
	        return FieldPath._DOCUMENT_ID;
	    };
	    FieldPath.prototype.isEqual = function (other) {
	        if (!(other instanceof FieldPath)) {
	            throw input_validation_1.invalidClassError('isEqual', 'FieldPath', 1, other);
	        }
	        return this._internalPath.isEqual(other._internalPath);
	    };
	    /**
	     * Internal Note: The backend doesn't technically support querying by
	     * document ID. Instead it queries by the entire document name (full path
	     * included), but in the cases we currently support documentId(), the net
	     * effect is the same.
	     */
	    FieldPath._DOCUMENT_ID = new FieldPath(path_1.FieldPath.keyField().canonicalString());
	    return FieldPath;
	}());
	exports.FieldPath = FieldPath;
	/**
	 * Matches any characters in a field path string that are reserved.
	 */
	var RESERVED = new RegExp('[~\\*/\\[\\]]');
	/**
	 * Parses a field path string into a FieldPath, treating dots as separators.
	 */
	function fromDotSeparatedString(path) {
	    var found = path.search(RESERVED);
	    if (found >= 0) {
	        throw new error_1.FirestoreError(error_1.Code.INVALID_ARGUMENT, "Invalid field path (" + path + "). Paths must not contain " +
	            "'~', '*', '/', '[', or ']'");
	    }
	    try {
	        return new (FieldPath.bind.apply(FieldPath, [void 0].concat(path.split('.'))))();
	    }
	    catch (e) {
	        throw new error_1.FirestoreError(error_1.Code.INVALID_ARGUMENT, "Invalid field path (" + path + "). Paths must not be empty, " +
	            "begin with '.', end with '.', or contain '..'");
	    }
	}
	exports.fromDotSeparatedString = fromDotSeparatedString;
	
	//# sourceMappingURL=field_path.js.map


/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var error_1 = __webpack_require__(10);
	var input_validation_1 = __webpack_require__(54);
	var misc_1 = __webpack_require__(14);
	/**
	 * Immutable class representing a geo point as latitude-longitude pair.
	 * This class is directly exposed in the public API, including its constructor.
	 */
	var GeoPoint = /** @class */ (function () {
	    function GeoPoint(latitude, longitude) {
	        input_validation_1.validateExactNumberOfArgs('GeoPoint', arguments, 2);
	        input_validation_1.validateArgType('GeoPoint', 'number', 1, latitude);
	        input_validation_1.validateArgType('GeoPoint', 'number', 2, longitude);
	        if (!isFinite(latitude) || latitude < -90 || latitude > 90) {
	            throw new error_1.FirestoreError(error_1.Code.INVALID_ARGUMENT, 'Latitude must be a number between -90 and 90, but was: ' + latitude);
	        }
	        if (!isFinite(longitude) || longitude < -180 || longitude > 180) {
	            throw new error_1.FirestoreError(error_1.Code.INVALID_ARGUMENT, 'Longitude must be a number between -180 and 180, but was: ' + longitude);
	        }
	        this._lat = latitude;
	        this._long = longitude;
	    }
	    Object.defineProperty(GeoPoint.prototype, "latitude", {
	        /**
	         * Returns the latitude of this geo point, a number between -90 and 90.
	         */
	        get: function () {
	            return this._lat;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(GeoPoint.prototype, "longitude", {
	        /**
	         * Returns the longitude of this geo point, a number between -180 and 180.
	         */
	        get: function () {
	            return this._long;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    GeoPoint.prototype.isEqual = function (other) {
	        return this._lat === other._lat && this._long === other._long;
	    };
	    /**
	     * Actually private to JS consumers of our API, so this function is prefixed
	     * with an underscore.
	     */
	    GeoPoint.prototype._compareTo = function (other) {
	        return (misc_1.primitiveComparator(this._lat, other._lat) ||
	            misc_1.primitiveComparator(this._long, other._long));
	    };
	    return GeoPoint;
	}());
	exports.GeoPoint = GeoPoint;
	
	//# sourceMappingURL=geo_point.js.map


/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var document_1 = __webpack_require__(21);
	var document_key_1 = __webpack_require__(12);
	var field_value_1 = __webpack_require__(42);
	var path_1 = __webpack_require__(35);
	var assert_1 = __webpack_require__(2);
	var error_1 = __webpack_require__(10);
	var types_1 = __webpack_require__(55);
	var Query = /** @class */ (function () {
	    function Query(path, explicitOrderBy, filters, limit, startAt, endAt) {
	        if (explicitOrderBy === void 0) { explicitOrderBy = []; }
	        if (filters === void 0) { filters = []; }
	        if (limit === void 0) { limit = null; }
	        if (startAt === void 0) { startAt = null; }
	        if (endAt === void 0) { endAt = null; }
	        this.path = path;
	        this.explicitOrderBy = explicitOrderBy;
	        this.filters = filters;
	        this.limit = limit;
	        this.startAt = startAt;
	        this.endAt = endAt;
	        this.memoizedCanonicalId = null;
	        this.memoizedOrderBy = null;
	        if (this.startAt) {
	            this.assertValidBound(this.startAt);
	        }
	        if (this.endAt) {
	            this.assertValidBound(this.endAt);
	        }
	    }
	    Query.atPath = function (path) {
	        return new Query(path);
	    };
	    Object.defineProperty(Query.prototype, "orderBy", {
	        get: function () {
	            if (this.memoizedOrderBy === null) {
	                var inequalityField = this.getInequalityFilterField();
	                var firstOrderByField = this.getFirstOrderByField();
	                if (inequalityField !== null && firstOrderByField === null) {
	                    // In order to implicitly add key ordering, we must also add the
	                    // inequality filter field for it to be a valid query.
	                    // Note that the default inequality field and key ordering is ascending.
	                    if (inequalityField.isKeyField()) {
	                        this.memoizedOrderBy = [KEY_ORDERING_ASC];
	                    }
	                    else {
	                        this.memoizedOrderBy = [
	                            new OrderBy(inequalityField),
	                            KEY_ORDERING_ASC
	                        ];
	                    }
	                }
	                else {
	                    assert_1.assert(inequalityField === null ||
	                        (firstOrderByField !== null &&
	                            inequalityField.isEqual(firstOrderByField)), 'First orderBy should match inequality field.');
	                    this.memoizedOrderBy = [];
	                    var foundKeyOrdering = false;
	                    for (var _i = 0, _a = this.explicitOrderBy; _i < _a.length; _i++) {
	                        var orderBy = _a[_i];
	                        this.memoizedOrderBy.push(orderBy);
	                        if (orderBy.field.isKeyField()) {
	                            foundKeyOrdering = true;
	                        }
	                    }
	                    if (!foundKeyOrdering) {
	                        // The order of the implicit key ordering always matches the last
	                        // explicit order by
	                        var lastDirection = this.explicitOrderBy.length > 0
	                            ? this.explicitOrderBy[this.explicitOrderBy.length - 1].dir
	                            : Direction.ASCENDING;
	                        this.memoizedOrderBy.push(lastDirection === Direction.ASCENDING
	                            ? KEY_ORDERING_ASC
	                            : KEY_ORDERING_DESC);
	                    }
	                }
	            }
	            return this.memoizedOrderBy;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Query.prototype.addFilter = function (filter) {
	        assert_1.assert(this.getInequalityFilterField() == null ||
	            !(filter instanceof RelationFilter) ||
	            !filter.isInequality() ||
	            filter.field.isEqual(this.getInequalityFilterField()), 'Query must only have one inequality field.');
	        assert_1.assert(!document_key_1.DocumentKey.isDocumentKey(this.path), 'No filtering allowed for document query');
	        var newFilters = this.filters.concat([filter]);
	        return new Query(this.path, this.explicitOrderBy.slice(), newFilters, this.limit, this.startAt, this.endAt);
	    };
	    Query.prototype.addOrderBy = function (orderBy) {
	        assert_1.assert(!document_key_1.DocumentKey.isDocumentKey(this.path), 'No ordering allowed for document query');
	        assert_1.assert(!this.startAt && !this.endAt, 'Bounds must be set after orderBy');
	        // TODO(dimond): validate that orderBy does not list the same key twice.
	        var newOrderBy = this.explicitOrderBy.concat([orderBy]);
	        return new Query(this.path, newOrderBy, this.filters.slice(), this.limit, this.startAt, this.endAt);
	    };
	    Query.prototype.withLimit = function (limit) {
	        return new Query(this.path, this.explicitOrderBy.slice(), this.filters.slice(), limit, this.startAt, this.endAt);
	    };
	    Query.prototype.withStartAt = function (bound) {
	        return new Query(this.path, this.explicitOrderBy.slice(), this.filters.slice(), this.limit, bound, this.endAt);
	    };
	    Query.prototype.withEndAt = function (bound) {
	        return new Query(this.path, this.explicitOrderBy.slice(), this.filters.slice(), this.limit, this.startAt, bound);
	    };
	    // TODO(b/29183165): This is used to get a unique string from a query to, for
	    // example, use as a dictionary key, but the implementation is subject to
	    // collisions. Make it collision-free.
	    Query.prototype.canonicalId = function () {
	        if (this.memoizedCanonicalId === null) {
	            var canonicalId = this.path.canonicalString();
	            canonicalId += '|f:';
	            for (var _i = 0, _a = this.filters; _i < _a.length; _i++) {
	                var filter = _a[_i];
	                canonicalId += filter.canonicalId();
	                canonicalId += ',';
	            }
	            canonicalId += '|ob:';
	            // TODO(dimond): make this collision resistant
	            for (var _b = 0, _c = this.orderBy; _b < _c.length; _b++) {
	                var orderBy = _c[_b];
	                canonicalId += orderBy.canonicalId();
	                canonicalId += ',';
	            }
	            if (!types_1.isNullOrUndefined(this.limit)) {
	                canonicalId += '|l:';
	                canonicalId += this.limit;
	            }
	            if (this.startAt) {
	                canonicalId += '|lb:';
	                canonicalId += this.startAt.canonicalId();
	            }
	            if (this.endAt) {
	                canonicalId += '|ub:';
	                canonicalId += this.endAt.canonicalId();
	            }
	            this.memoizedCanonicalId = canonicalId;
	        }
	        return this.memoizedCanonicalId;
	    };
	    Query.prototype.toString = function () {
	        var str = 'Query(' + this.path.canonicalString();
	        if (this.filters.length > 0) {
	            str += ", filters: [" + this.filters.join(', ') + "]";
	        }
	        if (!types_1.isNullOrUndefined(this.limit)) {
	            str += ', limit: ' + this.limit;
	        }
	        if (this.explicitOrderBy.length > 0) {
	            str += ", orderBy: [" + this.explicitOrderBy.join(', ') + "]";
	        }
	        if (this.startAt) {
	            str += ', startAt: ' + this.startAt.canonicalId();
	        }
	        if (this.endAt) {
	            str += ', endAt: ' + this.endAt.canonicalId();
	        }
	        return str + ')';
	    };
	    Query.prototype.isEqual = function (other) {
	        if (this.limit !== other.limit) {
	            return false;
	        }
	        if (this.orderBy.length !== other.orderBy.length) {
	            return false;
	        }
	        for (var i = 0; i < this.orderBy.length; i++) {
	            if (!this.orderBy[i].isEqual(other.orderBy[i])) {
	                return false;
	            }
	        }
	        if (this.filters.length !== other.filters.length) {
	            return false;
	        }
	        for (var i = 0; i < this.filters.length; i++) {
	            if (!this.filters[i].isEqual(other.filters[i])) {
	                return false;
	            }
	        }
	        if (!this.path.isEqual(other.path)) {
	            return false;
	        }
	        if (this.startAt !== null
	            ? !this.startAt.isEqual(other.startAt)
	            : other.startAt !== null) {
	            return false;
	        }
	        return this.endAt !== null
	            ? this.endAt.isEqual(other.endAt)
	            : other.endAt === null;
	    };
	    Query.prototype.docComparator = function (d1, d2) {
	        var comparedOnKeyField = false;
	        for (var _i = 0, _a = this.orderBy; _i < _a.length; _i++) {
	            var orderBy = _a[_i];
	            var comp = orderBy.compare(d1, d2);
	            if (comp !== 0)
	                return comp;
	            comparedOnKeyField = comparedOnKeyField || orderBy.field.isKeyField();
	        }
	        // Assert that we actually compared by key
	        assert_1.assert(comparedOnKeyField, "orderBy used that doesn't compare on key field");
	        return 0;
	    };
	    Query.prototype.matches = function (doc) {
	        return (this.matchesAncestor(doc) &&
	            this.matchesOrderBy(doc) &&
	            this.matchesFilters(doc) &&
	            this.matchesBounds(doc));
	    };
	    Query.prototype.hasLimit = function () {
	        return !types_1.isNullOrUndefined(this.limit);
	    };
	    Query.prototype.getFirstOrderByField = function () {
	        return this.explicitOrderBy.length > 0
	            ? this.explicitOrderBy[0].field
	            : null;
	    };
	    Query.prototype.getInequalityFilterField = function () {
	        for (var _i = 0, _a = this.filters; _i < _a.length; _i++) {
	            var filter = _a[_i];
	            if (filter instanceof RelationFilter && filter.isInequality()) {
	                return filter.field;
	            }
	        }
	        return null;
	    };
	    Query.prototype.isDocumentQuery = function () {
	        return document_key_1.DocumentKey.isDocumentKey(this.path) && this.filters.length === 0;
	    };
	    Query.prototype.matchesAncestor = function (doc) {
	        var docPath = doc.key.path;
	        if (document_key_1.DocumentKey.isDocumentKey(this.path)) {
	            // exact match for document queries
	            return this.path.isEqual(docPath);
	        }
	        else {
	            // shallow ancestor queries by default
	            return (this.path.isPrefixOf(docPath) && this.path.length === docPath.length - 1);
	        }
	    };
	    /**
	     * A document must have a value for every ordering clause in order to show up
	     * in the results.
	     */
	    Query.prototype.matchesOrderBy = function (doc) {
	        for (var _i = 0, _a = this.explicitOrderBy; _i < _a.length; _i++) {
	            var orderBy = _a[_i];
	            // order by key always matches
	            if (!orderBy.field.isKeyField() &&
	                doc.field(orderBy.field) === undefined) {
	                return false;
	            }
	        }
	        return true;
	    };
	    Query.prototype.matchesFilters = function (doc) {
	        for (var _i = 0, _a = this.filters; _i < _a.length; _i++) {
	            var filter = _a[_i];
	            if (!filter.matches(doc)) {
	                return false;
	            }
	        }
	        return true;
	    };
	    /**
	     * Makes sure a document is within the bounds, if provided.
	     */
	    Query.prototype.matchesBounds = function (doc) {
	        if (this.startAt && !this.startAt.sortsBeforeDocument(this.orderBy, doc)) {
	            return false;
	        }
	        if (this.endAt && this.endAt.sortsBeforeDocument(this.orderBy, doc)) {
	            return false;
	        }
	        return true;
	    };
	    Query.prototype.assertValidBound = function (bound) {
	        assert_1.assert(bound.position.length <= this.orderBy.length, 'Bound is longer than orderBy');
	    };
	    return Query;
	}());
	exports.Query = Query;
	var RelationOp = /** @class */ (function () {
	    function RelationOp(name) {
	        this.name = name;
	    }
	    RelationOp.fromString = function (op) {
	        switch (op) {
	            case '<':
	                return RelationOp.LESS_THAN;
	            case '<=':
	                return RelationOp.LESS_THAN_OR_EQUAL;
	            case '==':
	                return RelationOp.EQUAL;
	            case '>=':
	                return RelationOp.GREATER_THAN_OR_EQUAL;
	            case '>':
	                return RelationOp.GREATER_THAN;
	            default:
	                return assert_1.fail('Unknown relation: ' + op);
	        }
	    };
	    RelationOp.prototype.toString = function () {
	        return this.name;
	    };
	    RelationOp.prototype.isEqual = function (other) {
	        return this.name === other.name;
	    };
	    RelationOp.LESS_THAN = new RelationOp('<');
	    RelationOp.LESS_THAN_OR_EQUAL = new RelationOp('<=');
	    RelationOp.EQUAL = new RelationOp('==');
	    RelationOp.GREATER_THAN = new RelationOp('>');
	    RelationOp.GREATER_THAN_OR_EQUAL = new RelationOp('>=');
	    return RelationOp;
	}());
	exports.RelationOp = RelationOp;
	var RelationFilter = /** @class */ (function () {
	    function RelationFilter(field, op, value) {
	        this.field = field;
	        this.op = op;
	        this.value = value;
	    }
	    RelationFilter.prototype.matches = function (doc) {
	        if (this.field.isKeyField()) {
	            assert_1.assert(this.value instanceof field_value_1.RefValue, 'Comparing on key, but filter value not a RefValue');
	            var refValue = this.value;
	            var comparison = document_key_1.DocumentKey.comparator(doc.key, refValue.key);
	            return this.matchesComparison(comparison);
	        }
	        else {
	            var val = doc.field(this.field);
	            return val !== undefined && this.matchesValue(val);
	        }
	    };
	    RelationFilter.prototype.matchesValue = function (value) {
	        // Only compare types with matching backend order (such as double and int).
	        if (this.value.typeOrder !== value.typeOrder) {
	            return false;
	        }
	        return this.matchesComparison(value.compareTo(this.value));
	    };
	    RelationFilter.prototype.matchesComparison = function (comparison) {
	        switch (this.op) {
	            case RelationOp.LESS_THAN:
	                return comparison < 0;
	            case RelationOp.LESS_THAN_OR_EQUAL:
	                return comparison <= 0;
	            case RelationOp.EQUAL:
	                return comparison === 0;
	            case RelationOp.GREATER_THAN:
	                return comparison > 0;
	            case RelationOp.GREATER_THAN_OR_EQUAL:
	                return comparison >= 0;
	            default:
	                return assert_1.fail('Unknown relation op' + this.op);
	        }
	    };
	    RelationFilter.prototype.isInequality = function () {
	        return this.op !== RelationOp.EQUAL;
	    };
	    RelationFilter.prototype.canonicalId = function () {
	        // TODO(b/29183165): Technically, this won't be unique if two values have
	        // the same description, such as the int 3 and the string "3". So we should
	        // add the types in here somehow, too.
	        return (this.field.canonicalString() + this.op.toString() + this.value.toString());
	    };
	    RelationFilter.prototype.isEqual = function (other) {
	        if (other instanceof RelationFilter) {
	            return (this.op.isEqual(other.op) &&
	                this.field.isEqual(other.field) &&
	                this.value.isEqual(other.value));
	        }
	        else {
	            return false;
	        }
	    };
	    RelationFilter.prototype.toString = function () {
	        return this.field.canonicalString() + " " + this.op + " " + this.value.value();
	    };
	    return RelationFilter;
	}());
	exports.RelationFilter = RelationFilter;
	/**
	 * Filter that matches 'null' values.
	 */
	var NullFilter = /** @class */ (function () {
	    function NullFilter(field) {
	        this.field = field;
	    }
	    NullFilter.prototype.matches = function (doc) {
	        var val = doc.field(this.field);
	        return val !== undefined && val.value() === null;
	    };
	    NullFilter.prototype.canonicalId = function () {
	        return this.field.canonicalString() + ' IS null';
	    };
	    NullFilter.prototype.toString = function () {
	        return this.field.canonicalString() + " IS null";
	    };
	    NullFilter.prototype.isEqual = function (other) {
	        if (other instanceof NullFilter) {
	            return this.field.isEqual(other.field);
	        }
	        else {
	            return false;
	        }
	    };
	    return NullFilter;
	}());
	exports.NullFilter = NullFilter;
	/**
	 * Filter that matches 'NaN' values.
	 */
	var NanFilter = /** @class */ (function () {
	    function NanFilter(field) {
	        this.field = field;
	    }
	    NanFilter.prototype.matches = function (doc) {
	        var val = doc.field(this.field).value();
	        return typeof val === 'number' && isNaN(val);
	    };
	    NanFilter.prototype.canonicalId = function () {
	        return this.field.canonicalString() + ' IS NaN';
	    };
	    NanFilter.prototype.toString = function () {
	        return this.field.canonicalString() + " IS NaN";
	    };
	    NanFilter.prototype.isEqual = function (other) {
	        if (other instanceof NanFilter) {
	            return this.field.isEqual(other.field);
	        }
	        else {
	            return false;
	        }
	    };
	    return NanFilter;
	}());
	exports.NanFilter = NanFilter;
	/**
	 * Creates a filter based on the provided arguments.
	 */
	function fieldFilter(field, op, value) {
	    if (value.isEqual(field_value_1.NullValue.INSTANCE)) {
	        if (op !== RelationOp.EQUAL) {
	            throw new error_1.FirestoreError(error_1.Code.INVALID_ARGUMENT, 'Invalid query. You can only perform equals ' + 'comparisons on null.');
	        }
	        return new NullFilter(field);
	    }
	    else if (value.isEqual(field_value_1.DoubleValue.NAN)) {
	        if (op !== RelationOp.EQUAL) {
	            throw new error_1.FirestoreError(error_1.Code.INVALID_ARGUMENT, 'Invalid query. You can only perform equals ' + 'comparisons on NaN.');
	        }
	        return new NanFilter(field);
	    }
	    else {
	        return new RelationFilter(field, op, value);
	    }
	}
	exports.fieldFilter = fieldFilter;
	/**
	 * The direction of sorting in an order by.
	 */
	var Direction = /** @class */ (function () {
	    function Direction(name) {
	        this.name = name;
	    }
	    Direction.prototype.toString = function () {
	        return this.name;
	    };
	    Direction.ASCENDING = new Direction('asc');
	    Direction.DESCENDING = new Direction('desc');
	    return Direction;
	}());
	exports.Direction = Direction;
	/**
	 * Represents a bound of a query.
	 *
	 * The bound is specified with the given components representing a position and
	 * whether it's just before or just after the position (relative to whatever the
	 * query order is).
	 *
	 * The position represents a logical index position for a query. It's a prefix
	 * of values for the (potentially implicit) order by clauses of a query.
	 *
	 * Bound provides a function to determine whether a document comes before or
	 * after a bound. This is influenced by whether the position is just before or
	 * just after the provided values.
	 */
	var Bound = /** @class */ (function () {
	    function Bound(position, before) {
	        this.position = position;
	        this.before = before;
	    }
	    Bound.prototype.canonicalId = function () {
	        // TODO(b/29183165): Make this collision robust.
	        var canonicalId = this.before ? 'b:' : 'a:';
	        for (var _i = 0, _a = this.position; _i < _a.length; _i++) {
	            var component = _a[_i];
	            canonicalId += component.toString();
	        }
	        return canonicalId;
	    };
	    /**
	     * Returns true if a document sorts before a bound using the provided sort
	     * order.
	     */
	    Bound.prototype.sortsBeforeDocument = function (orderBy, doc) {
	        assert_1.assert(this.position.length <= orderBy.length, "Bound has more components than query's orderBy");
	        var comparison = 0;
	        for (var i = 0; i < this.position.length; i++) {
	            var orderByComponent = orderBy[i];
	            var component = this.position[i];
	            if (orderByComponent.field.isKeyField()) {
	                assert_1.assert(component instanceof field_value_1.RefValue, 'Bound has a non-key value where the key path is being used.');
	                comparison = document_key_1.DocumentKey.comparator(component.key, doc.key);
	            }
	            else {
	                var docValue = doc.field(orderByComponent.field);
	                assert_1.assert(docValue !== undefined, 'Field should exist since document matched the orderBy already.');
	                comparison = component.compareTo(docValue);
	            }
	            if (orderByComponent.dir === Direction.DESCENDING) {
	                comparison = comparison * -1;
	            }
	            if (comparison !== 0) {
	                break;
	            }
	        }
	        return this.before ? comparison <= 0 : comparison < 0;
	    };
	    Bound.prototype.isEqual = function (other) {
	        if (other === null) {
	            return false;
	        }
	        if (this.before !== other.before ||
	            this.position.length !== other.position.length) {
	            return false;
	        }
	        for (var i = 0; i < this.position.length; i++) {
	            var thisPosition = this.position[i];
	            var otherPosition = other.position[i];
	            return thisPosition.isEqual(otherPosition);
	        }
	        return true;
	    };
	    return Bound;
	}());
	exports.Bound = Bound;
	/**
	 * An ordering on a field, in some Direction. Direction defaults to ASCENDING.
	 */
	var OrderBy = /** @class */ (function () {
	    function OrderBy(field, dir) {
	        this.field = field;
	        if (dir === undefined) {
	            dir = Direction.ASCENDING;
	        }
	        this.dir = dir;
	        this.isKeyOrderBy = field.isKeyField();
	    }
	    OrderBy.prototype.compare = function (d1, d2) {
	        var comparison = this.isKeyOrderBy
	            ? document_1.Document.compareByKey(d1, d2)
	            : document_1.Document.compareByField(this.field, d1, d2);
	        switch (this.dir) {
	            case Direction.ASCENDING:
	                return comparison;
	            case Direction.DESCENDING:
	                return -1 * comparison;
	            default:
	                return assert_1.fail('Unknown direction: ' + this.dir);
	        }
	    };
	    OrderBy.prototype.canonicalId = function () {
	        // TODO(b/29183165): Make this collision robust.
	        return this.field.canonicalString() + this.dir.toString();
	    };
	    OrderBy.prototype.toString = function () {
	        return this.field.canonicalString() + " (" + this.dir + ")";
	    };
	    OrderBy.prototype.isEqual = function (other) {
	        return this.dir === other.dir && this.field.isEqual(other.field);
	    };
	    return OrderBy;
	}());
	exports.OrderBy = OrderBy;
	var KEY_ORDERING_ASC = new OrderBy(path_1.FieldPath.keyField(), Direction.ASCENDING);
	var KEY_ORDERING_DESC = new OrderBy(path_1.FieldPath.keyField(), Direction.DESCENDING);
	
	//# sourceMappingURL=query.js.map


/***/ }),
/* 99 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Describes the online state of the Firestore client. Note that this does not
	 * indicate whether or not the remote store is trying to connect or not. This is
	 * primarily used by the View / EventManager code to change their behavior while
	 * offline (e.g. get() calls shouldn't wait for data from the server and
	 * snapshot events should set metadata.isFromCache=true).
	 */
	var OnlineState;
	(function (OnlineState) {
	    /**
	     * The Firestore client is in an unknown online state. This means the client
	     * is either not actively trying to establish a connection or it is currently
	     * trying to establish a connection, but it has not succeeded or failed yet.
	     * Higher-level components should not operate in offline mode.
	     */
	    OnlineState[OnlineState["Unknown"] = 0] = "Unknown";
	    /**
	     * The client is connected and the connections are healthy. This state is
	     * reached after a successful connection and there has been at least one
	     * successful message received from the backends.
	     */
	    OnlineState[OnlineState["Healthy"] = 1] = "Healthy";
	    /**
	     * The client is either trying to establish a connection but failing, or it
	     * has been explicitly marked offline via a call to disableNetwork().
	     * Higher-level components should operate in offline mode.
	     */
	    OnlineState[OnlineState["Failed"] = 2] = "Failed";
	})(OnlineState = exports.OnlineState || (exports.OnlineState = {}));
	
	//# sourceMappingURL=types.js.map


/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var app_1 = __webpack_require__(26);
	/** The semver (www.semver.org) version of the SDK. */
	exports.SDK_VERSION = app_1.default.SDK_VERSION;
	
	//# sourceMappingURL=version.js.map


/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var path_1 = __webpack_require__(35);
	var assert_1 = __webpack_require__(2);
	var escapeChar = '\u0001';
	var encodedSeparatorChar = '\u0001';
	var encodedNul = '\u0010';
	var encodedEscape = '\u0011';
	/**
	 * Encodes a resource path into a IndexedDb-compatible string form.
	 */
	function encode(path) {
	    var result = '';
	    for (var i = 0; i < path.length; i++) {
	        if (result.length > 0) {
	            result = encodeSeparator(result);
	        }
	        result = encodeSegment(path.get(i), result);
	    }
	    return encodeSeparator(result);
	}
	exports.encode = encode;
	/** Encodes a single segment of a resource path into the given result */
	function encodeSegment(segment, resultBuf) {
	    var result = resultBuf;
	    var length = segment.length;
	    for (var i = 0; i < length; i++) {
	        var c = segment.charAt(i);
	        switch (c) {
	            case '\0':
	                result += escapeChar + encodedNul;
	                break;
	            case escapeChar:
	                result += escapeChar + encodedEscape;
	                break;
	            default:
	                result += c;
	        }
	    }
	    return result;
	}
	/** Encodes a path separator into the given result */
	function encodeSeparator(result) {
	    return result + escapeChar + encodedSeparatorChar;
	}
	/**
	 * Decodes the given IndexedDb-compatible string form of a resource path into
	 * a ResourcePath instance. Note that this method is not suitable for use with
	 * decoding resource names from the server; those are One Platform format
	 * strings.
	 */
	function decode(path) {
	    // Event the empty path must encode as a path of at least length 2. A path
	    // with exactly 2 must be the empty path.
	    var length = path.length;
	    assert_1.assert(length >= 2, 'Invalid path ' + path);
	    if (length === 2) {
	        assert_1.assert(path.charAt(0) === escapeChar && path.charAt(1) === encodedSeparatorChar, 'Non-empty path ' + path + ' had length 2');
	        return path_1.ResourcePath.EMPTY_PATH;
	    }
	    // Escape characters cannot exist past the second-to-last position in the
	    // source value.
	    var lastReasonableEscapeIndex = length - 2;
	    var segments = [];
	    var segmentBuilder = '';
	    for (var start = 0; start < length;) {
	        // The last two characters of a valid encoded path must be a separator, so
	        // there must be an end to this segment.
	        var end = path.indexOf(escapeChar, start);
	        if (end < 0 || end > lastReasonableEscapeIndex) {
	            assert_1.fail('Invalid encoded resource path: "' + path + '"');
	        }
	        var next = path.charAt(end + 1);
	        switch (next) {
	            case encodedSeparatorChar:
	                var currentPiece = path.substring(start, end);
	                var segment = void 0;
	                if (segmentBuilder.length === 0) {
	                    // Avoid copying for the common case of a segment that excludes \0
	                    // and \001
	                    segment = currentPiece;
	                }
	                else {
	                    segmentBuilder += currentPiece;
	                    segment = segmentBuilder;
	                    segmentBuilder = '';
	                }
	                segments.push(segment);
	                break;
	            case encodedNul:
	                segmentBuilder += path.substring(start, end);
	                segmentBuilder += '\0';
	                break;
	            case encodedEscape:
	                // The escape character can be used in the output to encode itself.
	                segmentBuilder += path.substring(start, end + 1);
	                break;
	            default:
	                assert_1.fail('Invalid encoded resource path: "' + path + '"');
	        }
	        start = end + 2;
	    }
	    return new path_1.ResourcePath(segments);
	}
	exports.decode = decode;
	/**
	 * Computes the prefix successor of the given path, computed by encode above.
	 * A prefix successor is the first key that cannot be prefixed by the given
	 * path. It's useful for defining the end of a prefix scan such that all keys
	 * in the scan have the same prefix.
	 *
	 * Note that this is not a general prefix successor implementation, which is
	 * tricky to get right with Strings, given that they encode down to UTF-8.
	 * Instead this relies on the fact that all paths encoded by this class are
	 * always terminated with a separator, and so a successor can always be
	 * cheaply computed by incrementing the last character of the path.
	 */
	function prefixSuccessor(path) {
	    var c = path.charCodeAt(path.length - 1);
	    // TODO(mcg): this really should be a general thing, but not worth it right
	    // now
	    assert_1.assert(c === 1, 'successor may only operate on paths generated by encode');
	    return path.substring(0, path.length - 1) + String.fromCharCode(c + 1);
	}
	exports.prefixSuccessor = prefixSuccessor;
	
	//# sourceMappingURL=encoded_resource_path.js.map


/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var assert_1 = __webpack_require__(2);
	var error_1 = __webpack_require__(10);
	var log = __webpack_require__(13);
	/**
	 * Error Codes describing the different ways GRPC can fail. These are copied
	 * directly from GRPC's sources here:
	 *
	 * https://github.com/grpc/grpc/blob/bceec94ea4fc5f0085d81235d8e1c06798dc341a/include/grpc%2B%2B/impl/codegen/status_code_enum.h
	 *
	 * Important! The names of these identifiers matter because the string forms
	 * are used for reverse lookups from the webchannel stream. Do NOT change the
	 * names of these identifiers.
	 */
	var RpcCode;
	(function (RpcCode) {
	    RpcCode[RpcCode["OK"] = 0] = "OK";
	    RpcCode[RpcCode["CANCELLED"] = 1] = "CANCELLED";
	    RpcCode[RpcCode["UNKNOWN"] = 2] = "UNKNOWN";
	    RpcCode[RpcCode["INVALID_ARGUMENT"] = 3] = "INVALID_ARGUMENT";
	    RpcCode[RpcCode["DEADLINE_EXCEEDED"] = 4] = "DEADLINE_EXCEEDED";
	    RpcCode[RpcCode["NOT_FOUND"] = 5] = "NOT_FOUND";
	    RpcCode[RpcCode["ALREADY_EXISTS"] = 6] = "ALREADY_EXISTS";
	    RpcCode[RpcCode["PERMISSION_DENIED"] = 7] = "PERMISSION_DENIED";
	    RpcCode[RpcCode["UNAUTHENTICATED"] = 16] = "UNAUTHENTICATED";
	    RpcCode[RpcCode["RESOURCE_EXHAUSTED"] = 8] = "RESOURCE_EXHAUSTED";
	    RpcCode[RpcCode["FAILED_PRECONDITION"] = 9] = "FAILED_PRECONDITION";
	    RpcCode[RpcCode["ABORTED"] = 10] = "ABORTED";
	    RpcCode[RpcCode["OUT_OF_RANGE"] = 11] = "OUT_OF_RANGE";
	    RpcCode[RpcCode["UNIMPLEMENTED"] = 12] = "UNIMPLEMENTED";
	    RpcCode[RpcCode["INTERNAL"] = 13] = "INTERNAL";
	    RpcCode[RpcCode["UNAVAILABLE"] = 14] = "UNAVAILABLE";
	    RpcCode[RpcCode["DATA_LOSS"] = 15] = "DATA_LOSS";
	})(RpcCode || (RpcCode = {}));
	function isPermanentError(code) {
	    switch (code) {
	        case error_1.Code.OK:
	            return assert_1.fail('Treated status OK as error');
	        case error_1.Code.CANCELLED:
	        case error_1.Code.UNKNOWN:
	        case error_1.Code.DEADLINE_EXCEEDED:
	        case error_1.Code.RESOURCE_EXHAUSTED:
	        case error_1.Code.INTERNAL:
	        case error_1.Code.UNAVAILABLE:
	        // Unauthenticated means something went wrong with our token and we need
	        // to retry with new credentials which will happen automatically.
	        // TODO(b/37325376): Give up after second unauthenticated error.
	        case error_1.Code.UNAUTHENTICATED:
	            return false;
	        case error_1.Code.INVALID_ARGUMENT:
	        case error_1.Code.NOT_FOUND:
	        case error_1.Code.ALREADY_EXISTS:
	        case error_1.Code.PERMISSION_DENIED:
	        case error_1.Code.FAILED_PRECONDITION:
	        // Aborted might be retried in some scenarios, but that is dependant on
	        // the context and should handled individually by the calling code.
	        // See https://cloud.google.com/apis/design/errors.
	        case error_1.Code.ABORTED:
	        case error_1.Code.OUT_OF_RANGE:
	        case error_1.Code.UNIMPLEMENTED:
	        case error_1.Code.DATA_LOSS:
	            return true;
	        default:
	            return assert_1.fail('Unknown status code: ' + code);
	    }
	}
	exports.isPermanentError = isPermanentError;
	/**
	 * Maps an error Code from a GRPC status identifier like 'NOT_FOUND'.
	 *
	 * @returns The Code equivalent to the given status string or undefined if
	 *     there is no match.
	 */
	function mapCodeFromRpcStatus(status) {
	    // tslint:disable-next-line:no-any lookup by string
	    var code = RpcCode[status];
	    if (code === undefined) {
	        return undefined;
	    }
	    return mapCodeFromRpcCode(code);
	}
	exports.mapCodeFromRpcStatus = mapCodeFromRpcStatus;
	/**
	 * Maps an error Code from GRPC status code number, like 0, 1, or 14. These
	 * are not the same as HTTP status codes.
	 *
	 * @returns The Code equivalent to the given GRPC status code. Fails if there
	 *     is no match.
	 */
	function mapCodeFromRpcCode(code) {
	    if (code === undefined) {
	        // This shouldn't normally happen, but in certain error cases (like trying
	        // to send invalid proto messages) we may get an error with no GRPC code.
	        log.error('GRPC error has no .code');
	        return error_1.Code.UNKNOWN;
	    }
	    switch (code) {
	        case RpcCode.OK:
	            return error_1.Code.OK;
	        case RpcCode.CANCELLED:
	            return error_1.Code.CANCELLED;
	        case RpcCode.UNKNOWN:
	            return error_1.Code.UNKNOWN;
	        case RpcCode.DEADLINE_EXCEEDED:
	            return error_1.Code.DEADLINE_EXCEEDED;
	        case RpcCode.RESOURCE_EXHAUSTED:
	            return error_1.Code.RESOURCE_EXHAUSTED;
	        case RpcCode.INTERNAL:
	            return error_1.Code.INTERNAL;
	        case RpcCode.UNAVAILABLE:
	            return error_1.Code.UNAVAILABLE;
	        case RpcCode.UNAUTHENTICATED:
	            return error_1.Code.UNAUTHENTICATED;
	        case RpcCode.INVALID_ARGUMENT:
	            return error_1.Code.INVALID_ARGUMENT;
	        case RpcCode.NOT_FOUND:
	            return error_1.Code.NOT_FOUND;
	        case RpcCode.ALREADY_EXISTS:
	            return error_1.Code.ALREADY_EXISTS;
	        case RpcCode.PERMISSION_DENIED:
	            return error_1.Code.PERMISSION_DENIED;
	        case RpcCode.FAILED_PRECONDITION:
	            return error_1.Code.FAILED_PRECONDITION;
	        case RpcCode.ABORTED:
	            return error_1.Code.ABORTED;
	        case RpcCode.OUT_OF_RANGE:
	            return error_1.Code.OUT_OF_RANGE;
	        case RpcCode.UNIMPLEMENTED:
	            return error_1.Code.UNIMPLEMENTED;
	        case RpcCode.DATA_LOSS:
	            return error_1.Code.DATA_LOSS;
	        default:
	            return assert_1.fail('Unknown status code: ' + code);
	    }
	}
	exports.mapCodeFromRpcCode = mapCodeFromRpcCode;
	/**
	 * Maps an RPC code from a Code. This is the reverse operation from
	 * mapCodeFromRpcCode and should really only be used in tests.
	 */
	function mapRpcCodeFromCode(code) {
	    if (code === undefined) {
	        return RpcCode.OK;
	    }
	    switch (code) {
	        case error_1.Code.OK:
	            return RpcCode.OK;
	        case error_1.Code.CANCELLED:
	            return RpcCode.CANCELLED;
	        case error_1.Code.UNKNOWN:
	            return RpcCode.UNKNOWN;
	        case error_1.Code.DEADLINE_EXCEEDED:
	            return RpcCode.DEADLINE_EXCEEDED;
	        case error_1.Code.RESOURCE_EXHAUSTED:
	            return RpcCode.RESOURCE_EXHAUSTED;
	        case error_1.Code.INTERNAL:
	            return RpcCode.INTERNAL;
	        case error_1.Code.UNAVAILABLE:
	            return RpcCode.UNAVAILABLE;
	        case error_1.Code.UNAUTHENTICATED:
	            return RpcCode.UNAUTHENTICATED;
	        case error_1.Code.INVALID_ARGUMENT:
	            return RpcCode.INVALID_ARGUMENT;
	        case error_1.Code.NOT_FOUND:
	            return RpcCode.NOT_FOUND;
	        case error_1.Code.ALREADY_EXISTS:
	            return RpcCode.ALREADY_EXISTS;
	        case error_1.Code.PERMISSION_DENIED:
	            return RpcCode.PERMISSION_DENIED;
	        case error_1.Code.FAILED_PRECONDITION:
	            return RpcCode.FAILED_PRECONDITION;
	        case error_1.Code.ABORTED:
	            return RpcCode.ABORTED;
	        case error_1.Code.OUT_OF_RANGE:
	            return RpcCode.OUT_OF_RANGE;
	        case error_1.Code.UNIMPLEMENTED:
	            return RpcCode.UNIMPLEMENTED;
	        case error_1.Code.DATA_LOSS:
	            return RpcCode.DATA_LOSS;
	        default:
	            return assert_1.fail('Unknown status code: ' + code);
	    }
	}
	exports.mapRpcCodeFromCode = mapRpcCodeFromCode;
	/**
	 * Converts an HTTP Status Code to the equivalent error code.
	 *
	 * @param status An HTTP Status Code, like 200, 404, 503, etc.
	 * @returns The equivalent Code. Unknown status codes are mapped to
	 *     Code.UNKNOWN.
	 */
	function mapCodeFromHttpStatus(status) {
	    // The canonical error codes for Google APIs [1] specify mapping onto HTTP
	    // status codes but the mapping is not bijective. In each case of ambiguity
	    // this function chooses a primary error.
	    //
	    // [1]
	    // https://github.com/googleapis/googleapis/blob/master/google/rpc/code.proto
	    switch (status) {
	        case 200:// OK
	            return error_1.Code.OK;
	        case 400:// Bad Request
	            return error_1.Code.INVALID_ARGUMENT;
	        // Other possibilities based on the forward mapping
	        // return Code.FAILED_PRECONDITION;
	        // return Code.OUT_OF_RANGE;
	        case 401:// Unauthorized
	            return error_1.Code.UNAUTHENTICATED;
	        case 403:// Forbidden
	            return error_1.Code.PERMISSION_DENIED;
	        case 404:// Not Found
	            return error_1.Code.NOT_FOUND;
	        case 409:// Conflict
	            return error_1.Code.ABORTED;
	        // Other possibilities:
	        // return Code.ALREADY_EXISTS;
	        case 416:// Range Not Satisfiable
	            return error_1.Code.OUT_OF_RANGE;
	        case 429:// Too Many Requests
	            return error_1.Code.RESOURCE_EXHAUSTED;
	        case 499:// Client Closed Request
	            return error_1.Code.CANCELLED;
	        case 500:// Internal Server Error
	            return error_1.Code.UNKNOWN;
	        // Other possibilities:
	        // return Code.INTERNAL;
	        // return Code.DATA_LOSS;
	        case 501:// Unimplemented
	            return error_1.Code.UNIMPLEMENTED;
	        case 503:// Service Unavailable
	            return error_1.Code.UNAVAILABLE;
	        case 504:// Gateway Timeout
	            return error_1.Code.DEADLINE_EXCEEDED;
	        default:
	            if (status >= 200 && status < 300)
	                return error_1.Code.OK;
	            if (status >= 400 && status < 500)
	                return error_1.Code.FAILED_PRECONDITION;
	            if (status >= 500 && status < 600)
	                return error_1.Code.INTERNAL;
	            return error_1.Code.UNKNOWN;
	    }
	}
	exports.mapCodeFromHttpStatus = mapCodeFromHttpStatus;
	
	//# sourceMappingURL=rpc_error.js.map


/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	// We are doing some heavy reflective stuff, lots of any casting necessary
	/* tslint:disable:no-any */
	var error_1 = __webpack_require__(10);
	/**
	 * Helper function to prevent instantiation through the constructor.
	 *
	 * This method creates a new constructor that throws when it's invoked.
	 * The prototype of that constructor is then set to the prototype of the hidden
	 * "class" to expose all the prototype methods and allow for instanceof
	 * checks.
	 *
	 * To also make all the static methods available, all properties of the
	 * original constructor are copied to the new constructor.
	 */
	function makeConstructorPrivate(cls, optionalMessage) {
	    function PublicConstructor() {
	        var error = 'This constructor is private.';
	        if (optionalMessage) {
	            error += ' ';
	            error += optionalMessage;
	        }
	        throw new error_1.FirestoreError(error_1.Code.INVALID_ARGUMENT, error);
	    }
	    // Make sure instanceof checks work and all methods are exposed on the public
	    // constructor
	    PublicConstructor.prototype = cls.prototype;
	    // Copy any static methods/members
	    for (var staticProperty in cls) {
	        if (cls.hasOwnProperty(staticProperty)) {
	            PublicConstructor[staticProperty] = cls[staticProperty];
	        }
	    }
	    return PublicConstructor;
	}
	exports.makeConstructorPrivate = makeConstructorPrivate;
	
	//# sourceMappingURL=api.js.map


/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var objUtil = __webpack_require__(27);
	/**
	 * A map implementation that uses objects as keys. Objects must implement the
	 * Equatable interface and must be immutable. Entries in the map are stored
	 * together with the key being produced from the mapKeyFn. This map
	 * automatically handles collisions of keys.
	 */
	var ObjectMap = /** @class */ (function () {
	    function ObjectMap(mapKeyFn) {
	        this.mapKeyFn = mapKeyFn;
	        /**
	         * The inner map for a key -> value pair. Due to the possibility of
	         * collisions we keep a list of entries that we do a linear search through
	         * to find an actual match. Note that collisions should be rare, so we still
	         * expect near constant time lookups in practice.
	         */
	        this.inner = {};
	    }
	    /** Get a value for this key, or undefined if it does not exist. */
	    ObjectMap.prototype.get = function (key) {
	        var id = this.mapKeyFn(key);
	        var matches = this.inner[id];
	        if (matches === undefined) {
	            return undefined;
	        }
	        for (var _i = 0, matches_1 = matches; _i < matches_1.length; _i++) {
	            var _a = matches_1[_i], otherKey = _a[0], value = _a[1];
	            if (otherKey.isEqual(key)) {
	                return value;
	            }
	        }
	        return undefined;
	    };
	    ObjectMap.prototype.has = function (key) {
	        return this.get(key) !== undefined;
	    };
	    /** Put this key and value in the map. */
	    ObjectMap.prototype.set = function (key, value) {
	        var id = this.mapKeyFn(key);
	        var matches = this.inner[id];
	        if (matches === undefined) {
	            this.inner[id] = [[key, value]];
	            return;
	        }
	        for (var i = 0; i < matches.length; i++) {
	            if (matches[i][0].isEqual(key)) {
	                matches[i] = [key, value];
	                return;
	            }
	        }
	        matches.push([key, value]);
	    };
	    /**
	     * Remove this key from the map. Returns a boolean if anything was deleted.
	     */
	    ObjectMap.prototype.delete = function (key) {
	        var id = this.mapKeyFn(key);
	        var matches = this.inner[id];
	        if (matches === undefined) {
	            return false;
	        }
	        for (var i = 0; i < matches.length; i++) {
	            if (matches[i][0].isEqual(key)) {
	                if (matches.length === 1) {
	                    delete this.inner[id];
	                }
	                else {
	                    matches.splice(i, 1);
	                }
	                return true;
	            }
	        }
	        return false;
	    };
	    ObjectMap.prototype.forEach = function (fn) {
	        objUtil.forEach(this.inner, function (_, entries) {
	            for (var _i = 0, entries_1 = entries; _i < entries_1.length; _i++) {
	                var _a = entries_1[_i], k = _a[0], v = _a[1];
	                fn(k, v);
	            }
	        });
	    };
	    ObjectMap.prototype.isEmpty = function () {
	        return objUtil.isEmpty(this.inner);
	    };
	    return ObjectMap;
	}());
	exports.ObjectMap = ObjectMap;
	
	//# sourceMappingURL=obj_map.js.map


/***/ }),
/* 105 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var Deferred = /** @class */ (function () {
	    function Deferred() {
	        var _this = this;
	        this.promise = new Promise(function (resolve, reject) {
	            _this.resolve = resolve;
	            _this.reject = reject;
	        });
	    }
	    return Deferred;
	}());
	exports.Deferred = Deferred;
	/**
	 * Takes an array of values and sequences them using the promise (or value)
	 * returned by the supplied callback. The callback for each item is called
	 * after the promise is resolved for the previous item.
	 * The function returns a promise which is resolved after the promise for
	 * the last item is resolved.
	 */
	function sequence(values, fn, initialValue) {
	    var result = Promise.resolve(initialValue);
	    values.forEach(function (value) {
	        result = result.then(function (lastResult) { return fn(value, lastResult); });
	    });
	    return result;
	}
	exports.sequence = sequence;
	
	//# sourceMappingURL=promise.js.map


/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var errorsExports = __webpack_require__(30);
	var MetadataUtils = __webpack_require__(108);
	var type = __webpack_require__(22);
	/**
	 * @param name Name of the function.
	 * @param specs Argument specs.
	 * @param passed The actual arguments passed to the function.
	 * @throws {fbs.Error} If the arguments are invalid.
	 */
	function validate(name, specs, passed) {
	    var minArgs = specs.length;
	    var maxArgs = specs.length;
	    for (var i = 0; i < specs.length; i++) {
	        if (specs[i].optional) {
	            minArgs = i;
	            break;
	        }
	    }
	    var validLength = minArgs <= passed.length && passed.length <= maxArgs;
	    if (!validLength) {
	        throw errorsExports.invalidArgumentCount(minArgs, maxArgs, name, passed.length);
	    }
	    for (var i = 0; i < passed.length; i++) {
	        try {
	            specs[i].validator(passed[i]);
	        }
	        catch (e) {
	            if (e instanceof Error) {
	                throw errorsExports.invalidArgument(i, name, e.message);
	            }
	            else {
	                throw errorsExports.invalidArgument(i, name, e);
	            }
	        }
	    }
	}
	exports.validate = validate;
	/**
	 * @struct
	 */
	var ArgSpec = /** @class */ (function () {
	    function ArgSpec(validator, opt_optional) {
	        var self = this;
	        this.validator = function (p) {
	            if (self.optional && !type.isJustDef(p)) {
	                return;
	            }
	            validator(p);
	        };
	        this.optional = !!opt_optional;
	    }
	    return ArgSpec;
	}());
	exports.ArgSpec = ArgSpec;
	function and_(v1, v2) {
	    return function (p) {
	        v1(p);
	        v2(p);
	    };
	}
	exports.and_ = and_;
	function stringSpec(opt_validator, opt_optional) {
	    function stringValidator(p) {
	        if (!type.isString(p)) {
	            throw 'Expected string.';
	        }
	    }
	    var validator;
	    if (opt_validator) {
	        validator = and_(stringValidator, opt_validator);
	    }
	    else {
	        validator = stringValidator;
	    }
	    return new ArgSpec(validator, opt_optional);
	}
	exports.stringSpec = stringSpec;
	function uploadDataSpec() {
	    function validator(p) {
	        var valid = p instanceof Uint8Array ||
	            p instanceof ArrayBuffer ||
	            (type.isNativeBlobDefined() && p instanceof Blob);
	        if (!valid) {
	            throw 'Expected Blob or File.';
	        }
	    }
	    return new ArgSpec(validator);
	}
	exports.uploadDataSpec = uploadDataSpec;
	function metadataSpec(opt_optional) {
	    return new ArgSpec(MetadataUtils.metadataValidator, opt_optional);
	}
	exports.metadataSpec = metadataSpec;
	function nonNegativeNumberSpec() {
	    function validator(p) {
	        var valid = type.isNumber(p) && p >= 0;
	        if (!valid) {
	            throw 'Expected a number 0 or greater.';
	        }
	    }
	    return new ArgSpec(validator);
	}
	exports.nonNegativeNumberSpec = nonNegativeNumberSpec;
	function looseObjectSpec(opt_validator, opt_optional) {
	    function validator(p) {
	        var isLooseObject = p === null || (type.isDef(p) && p instanceof Object);
	        if (!isLooseObject) {
	            throw 'Expected an Object.';
	        }
	        if (opt_validator !== undefined && opt_validator !== null) {
	            opt_validator(p);
	        }
	    }
	    return new ArgSpec(validator, opt_optional);
	}
	exports.looseObjectSpec = looseObjectSpec;
	function nullFunctionSpec(opt_optional) {
	    function validator(p) {
	        var valid = p === null || type.isFunction(p);
	        if (!valid) {
	            throw 'Expected a Function.';
	        }
	    }
	    return new ArgSpec(validator, opt_optional);
	}
	exports.nullFunctionSpec = nullFunctionSpec;
	
	//# sourceMappingURL=args.js.map


/***/ }),
/* 107 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Returns true if the object is contained in the array (compared with ===).
	 * @template T
	 */
	function contains(array, elem) {
	    return array.indexOf(elem) !== -1;
	}
	exports.contains = contains;
	/**
	 * Returns a shallow copy of the array or array-like object (e.g. arguments).
	 * @template T
	 */
	function clone(arraylike) {
	    return Array.prototype.slice.call(arraylike);
	}
	exports.clone = clone;
	/**
	 * Removes the given element from the given array, if it is contained.
	 * Directly modifies the passed-in array.
	 * @template T
	 */
	function remove(array, elem) {
	    var i = array.indexOf(elem);
	    if (i !== -1) {
	        array.splice(i, 1);
	    }
	}
	exports.remove = remove;
	
	//# sourceMappingURL=array.js.map


/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var json = __webpack_require__(311);
	var location_1 = __webpack_require__(79);
	var path = __webpack_require__(170);
	var type = __webpack_require__(22);
	var UrlUtils = __webpack_require__(109);
	function noXform_(metadata, value) {
	    return value;
	}
	exports.noXform_ = noXform_;
	/**
	 * @struct
	 */
	var Mapping = /** @class */ (function () {
	    function Mapping(server, opt_local, opt_writable, opt_xform) {
	        this.server = server;
	        this.local = opt_local || server;
	        this.writable = !!opt_writable;
	        this.xform = opt_xform || noXform_;
	    }
	    return Mapping;
	}());
	exports.Mapping = Mapping;
	var mappings_ = null;
	function xformPath(fullPath) {
	    var valid = type.isString(fullPath);
	    if (!valid || fullPath.length < 2) {
	        return fullPath;
	    }
	    else {
	        fullPath = fullPath;
	        return path.lastComponent(fullPath);
	    }
	}
	exports.xformPath = xformPath;
	function getMappings() {
	    if (mappings_) {
	        return mappings_;
	    }
	    var mappings = [];
	    mappings.push(new Mapping('bucket'));
	    mappings.push(new Mapping('generation'));
	    mappings.push(new Mapping('metageneration'));
	    mappings.push(new Mapping('name', 'fullPath', true));
	    function mappingsXformPath(metadata, fullPath) {
	        return xformPath(fullPath);
	    }
	    var nameMapping = new Mapping('name');
	    nameMapping.xform = mappingsXformPath;
	    mappings.push(nameMapping);
	    /**
	     * Coerces the second param to a number, if it is defined.
	     */
	    function xformSize(metadata, size) {
	        if (type.isDef(size)) {
	            return +size;
	        }
	        else {
	            return size;
	        }
	    }
	    var sizeMapping = new Mapping('size');
	    sizeMapping.xform = xformSize;
	    mappings.push(sizeMapping);
	    mappings.push(new Mapping('timeCreated'));
	    mappings.push(new Mapping('updated'));
	    mappings.push(new Mapping('md5Hash', null, true));
	    mappings.push(new Mapping('cacheControl', null, true));
	    mappings.push(new Mapping('contentDisposition', null, true));
	    mappings.push(new Mapping('contentEncoding', null, true));
	    mappings.push(new Mapping('contentLanguage', null, true));
	    mappings.push(new Mapping('contentType', null, true));
	    mappings.push(new Mapping('metadata', 'customMetadata', true));
	    /**
	     * Transforms a comma-separated string of tokens into a list of download
	     * URLs.
	     */
	    function xformTokens(metadata, tokens) {
	        var valid = type.isString(tokens) && tokens.length > 0;
	        if (!valid) {
	            // This can happen if objects are uploaded through GCS and retrieved
	            // through list, so we don't want to throw an Error.
	            return [];
	        }
	        var encode = encodeURIComponent;
	        var tokensList = tokens.split(',');
	        var urls = tokensList.map(function (token) {
	            var bucket = metadata['bucket'];
	            var path = metadata['fullPath'];
	            var urlPart = '/b/' + encode(bucket) + '/o/' + encode(path);
	            var base = UrlUtils.makeDownloadUrl(urlPart);
	            var queryString = UrlUtils.makeQueryString({
	                alt: 'media',
	                token: token
	            });
	            return base + queryString;
	        });
	        return urls;
	    }
	    mappings.push(new Mapping('downloadTokens', 'downloadURLs', false, xformTokens));
	    mappings_ = mappings;
	    return mappings_;
	}
	exports.getMappings = getMappings;
	function addRef(metadata, authWrapper) {
	    function generateRef() {
	        var bucket = metadata['bucket'];
	        var path = metadata['fullPath'];
	        var loc = new location_1.Location(bucket, path);
	        return authWrapper.makeStorageReference(loc);
	    }
	    Object.defineProperty(metadata, 'ref', { get: generateRef });
	}
	exports.addRef = addRef;
	function fromResource(authWrapper, resource, mappings) {
	    var metadata = {};
	    metadata['type'] = 'file';
	    var len = mappings.length;
	    for (var i = 0; i < len; i++) {
	        var mapping = mappings[i];
	        metadata[mapping.local] = mapping.xform(metadata, resource[mapping.server]);
	    }
	    addRef(metadata, authWrapper);
	    return metadata;
	}
	exports.fromResource = fromResource;
	function fromResourceString(authWrapper, resourceString, mappings) {
	    var obj = json.jsonObjectOrNull(resourceString);
	    if (obj === null) {
	        return null;
	    }
	    var resource = obj;
	    return fromResource(authWrapper, resource, mappings);
	}
	exports.fromResourceString = fromResourceString;
	function toResourceString(metadata, mappings) {
	    var resource = {};
	    var len = mappings.length;
	    for (var i = 0; i < len; i++) {
	        var mapping = mappings[i];
	        if (mapping.writable) {
	            resource[mapping.server] = metadata[mapping.local];
	        }
	    }
	    return JSON.stringify(resource);
	}
	exports.toResourceString = toResourceString;
	function metadataValidator(p) {
	    var validType = p && type.isObject(p);
	    if (!validType) {
	        throw 'Expected Metadata object.';
	    }
	    for (var key in p) {
	        var val = p[key];
	        if (key === 'customMetadata') {
	            if (!type.isObject(val)) {
	                throw 'Expected object for \'customMetadata\' mapping.';
	            }
	        }
	        else {
	            if (type.isNonNullObject(val)) {
	                throw "Mapping for '" + key + "' cannot be an object.";
	            }
	        }
	    }
	}
	exports.metadataValidator = metadataValidator;
	
	//# sourceMappingURL=metadata.js.map


/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * @fileoverview Functions to create and manipulate URLs for the server API.
	 */
	var constants = __webpack_require__(78);
	var object = __webpack_require__(43);
	function makeNormalUrl(urlPart) {
	    return constants.domainBase + constants.apiBaseUrl + urlPart;
	}
	exports.makeNormalUrl = makeNormalUrl;
	function makeDownloadUrl(urlPart) {
	    return constants.downloadBase + constants.apiBaseUrl + urlPart;
	}
	exports.makeDownloadUrl = makeDownloadUrl;
	function makeUploadUrl(urlPart) {
	    return constants.domainBase + constants.apiUploadBaseUrl + urlPart;
	}
	exports.makeUploadUrl = makeUploadUrl;
	function makeQueryString(params) {
	    var encode = encodeURIComponent;
	    var queryPart = '?';
	    object.forEach(params, function (key, val) {
	        var nextPart = encode(key) + '=' + encode(val);
	        queryPart = queryPart + nextPart + '&';
	    });
	    // Chop off the extra '&' or '?' on the end
	    queryPart = queryPart.slice(0, -1);
	    return queryPart;
	}
	exports.makeQueryString = makeQueryString;
	
	//# sourceMappingURL=url.js.map


/***/ }),
/* 110 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * @fileoverview Firebase constants.  Some of these (@defines) can be overridden at compile-time.
	 */
	exports.CONSTANTS = {
	    /**
	     * @define {boolean} Whether this is the client Node.js SDK.
	     */
	    NODE_CLIENT: false,
	    /**
	     * @define {boolean} Whether this is the Admin Node.js SDK.
	     */
	    NODE_ADMIN: false,
	    /**
	     * Firebase SDK Version
	     */
	    SDK_VERSION: '${JSCORE_VERSION}'
	};
	
	//# sourceMappingURL=constants.js.map


/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	var utils = __webpack_require__(23);
	var normalizeHeaderName = __webpack_require__(348);
	
	var DEFAULT_CONTENT_TYPE = {
	  'Content-Type': 'application/x-www-form-urlencoded'
	};
	
	function setContentTypeIfUnset(headers, value) {
	  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
	    headers['Content-Type'] = value;
	  }
	}
	
	function getDefaultAdapter() {
	  var adapter;
	  if (typeof XMLHttpRequest !== 'undefined') {
	    // For browsers use XHR adapter
	    adapter = __webpack_require__(178);
	  } else if (typeof process !== 'undefined') {
	    // For node use HTTP adapter
	    adapter = __webpack_require__(178);
	  }
	  return adapter;
	}
	
	var defaults = {
	  adapter: getDefaultAdapter(),
	
	  transformRequest: [function transformRequest(data, headers) {
	    normalizeHeaderName(headers, 'Content-Type');
	    if (utils.isFormData(data) ||
	      utils.isArrayBuffer(data) ||
	      utils.isBuffer(data) ||
	      utils.isStream(data) ||
	      utils.isFile(data) ||
	      utils.isBlob(data)
	    ) {
	      return data;
	    }
	    if (utils.isArrayBufferView(data)) {
	      return data.buffer;
	    }
	    if (utils.isURLSearchParams(data)) {
	      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
	      return data.toString();
	    }
	    if (utils.isObject(data)) {
	      setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
	      return JSON.stringify(data);
	    }
	    return data;
	  }],
	
	  transformResponse: [function transformResponse(data) {
	    /*eslint no-param-reassign:0*/
	    if (typeof data === 'string') {
	      try {
	        data = JSON.parse(data);
	      } catch (e) { /* Ignore */ }
	    }
	    return data;
	  }],
	
	  timeout: 0,
	
	  xsrfCookieName: 'XSRF-TOKEN',
	  xsrfHeaderName: 'X-XSRF-TOKEN',
	
	  maxContentLength: -1,
	
	  validateStatus: function validateStatus(status) {
	    return status >= 200 && status < 300;
	  }
	};
	
	defaults.headers = {
	  common: {
	    'Accept': 'application/json, text/plain, */*'
	  }
	};
	
	utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
	  defaults.headers[method] = {};
	});
	
	utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
	  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
	});
	
	module.exports = defaults;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(58)))

/***/ }),
/* 112 */
/***/ (function(module, exports) {

	var core = module.exports = { version: '2.5.3' };
	if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

	// Thank's IE8 for his funny defineProperty
	module.exports = !__webpack_require__(114)(function () {
	  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ }),
/* 114 */
/***/ (function(module, exports) {

	module.exports = function (exec) {
	  try {
	    return !!exec();
	  } catch (e) {
	    return true;
	  }
	};


/***/ }),
/* 115 */
/***/ (function(module, exports) {

	module.exports = function (it) {
	  return typeof it === 'object' ? it !== null : typeof it === 'function';
	};


/***/ }),
/* 116 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 * 
	 */
	
	/*eslint-disable no-self-compare */
	
	'use strict';
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	/**
	 * inlined Object.is polyfill to avoid requiring consumers ship their own
	 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	 */
	function is(x, y) {
	  // SameValue algorithm
	  if (x === y) {
	    // Steps 1-5, 7-10
	    // Steps 6.b-6.e: +0 != -0
	    // Added the nonzero y check to make Flow happy, but it is redundant
	    return x !== 0 || y !== 0 || 1 / x === 1 / y;
	  } else {
	    // Step 6.a: NaN == NaN
	    return x !== x && y !== y;
	  }
	}
	
	/**
	 * Performs equality by iterating through keys on an object and returning false
	 * when any key has values which are not strictly equal between the arguments.
	 * Returns true when the values of all keys are strictly equal.
	 */
	function shallowEqual(objA, objB) {
	  if (is(objA, objB)) {
	    return true;
	  }
	
	  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  // Test for A's keys different from B.
	  for (var i = 0; i < keysA.length; i++) {
	    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	module.exports = shallowEqual;

/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMLazyTree = __webpack_require__(44);
	var Danger = __webpack_require__(422);
	var ReactDOMComponentTree = __webpack_require__(9);
	var ReactInstrumentation = __webpack_require__(25);
	
	var createMicrosoftUnsafeLocalFunction = __webpack_require__(126);
	var setInnerHTML = __webpack_require__(87);
	var setTextContent = __webpack_require__(215);
	
	function getNodeAfter(parentNode, node) {
	  // Special case for text components, which return [open, close] comments
	  // from getHostNode.
	  if (Array.isArray(node)) {
	    node = node[1];
	  }
	  return node ? node.nextSibling : parentNode.firstChild;
	}
	
	/**
	 * Inserts `childNode` as a child of `parentNode` at the `index`.
	 *
	 * @param {DOMElement} parentNode Parent node in which to insert.
	 * @param {DOMElement} childNode Child node to insert.
	 * @param {number} index Index at which to insert the child.
	 * @internal
	 */
	var insertChildAt = createMicrosoftUnsafeLocalFunction(function (parentNode, childNode, referenceNode) {
	  // We rely exclusively on `insertBefore(node, null)` instead of also using
	  // `appendChild(node)`. (Using `undefined` is not allowed by all browsers so
	  // we are careful to use `null`.)
	  parentNode.insertBefore(childNode, referenceNode);
	});
	
	function insertLazyTreeChildAt(parentNode, childTree, referenceNode) {
	  DOMLazyTree.insertTreeBefore(parentNode, childTree, referenceNode);
	}
	
	function moveChild(parentNode, childNode, referenceNode) {
	  if (Array.isArray(childNode)) {
	    moveDelimitedText(parentNode, childNode[0], childNode[1], referenceNode);
	  } else {
	    insertChildAt(parentNode, childNode, referenceNode);
	  }
	}
	
	function removeChild(parentNode, childNode) {
	  if (Array.isArray(childNode)) {
	    var closingComment = childNode[1];
	    childNode = childNode[0];
	    removeDelimitedText(parentNode, childNode, closingComment);
	    parentNode.removeChild(closingComment);
	  }
	  parentNode.removeChild(childNode);
	}
	
	function moveDelimitedText(parentNode, openingComment, closingComment, referenceNode) {
	  var node = openingComment;
	  while (true) {
	    var nextNode = node.nextSibling;
	    insertChildAt(parentNode, node, referenceNode);
	    if (node === closingComment) {
	      break;
	    }
	    node = nextNode;
	  }
	}
	
	function removeDelimitedText(parentNode, startNode, closingComment) {
	  while (true) {
	    var node = startNode.nextSibling;
	    if (node === closingComment) {
	      // The closing comment is removed by ReactMultiChild.
	      break;
	    } else {
	      parentNode.removeChild(node);
	    }
	  }
	}
	
	function replaceDelimitedText(openingComment, closingComment, stringText) {
	  var parentNode = openingComment.parentNode;
	  var nodeAfterComment = openingComment.nextSibling;
	  if (nodeAfterComment === closingComment) {
	    // There are no text nodes between the opening and closing comments; insert
	    // a new one if stringText isn't empty.
	    if (stringText) {
	      insertChildAt(parentNode, document.createTextNode(stringText), nodeAfterComment);
	    }
	  } else {
	    if (stringText) {
	      // Set the text content of the first node after the opening comment, and
	      // remove all following nodes up until the closing comment.
	      setTextContent(nodeAfterComment, stringText);
	      removeDelimitedText(parentNode, nodeAfterComment, closingComment);
	    } else {
	      removeDelimitedText(parentNode, openingComment, closingComment);
	    }
	  }
	
	  if (false) {
	    ReactInstrumentation.debugTool.onHostOperation({
	      instanceID: ReactDOMComponentTree.getInstanceFromNode(openingComment)._debugID,
	      type: 'replace text',
	      payload: stringText
	    });
	  }
	}
	
	var dangerouslyReplaceNodeWithMarkup = Danger.dangerouslyReplaceNodeWithMarkup;
	if (false) {
	  dangerouslyReplaceNodeWithMarkup = function (oldChild, markup, prevInstance) {
	    Danger.dangerouslyReplaceNodeWithMarkup(oldChild, markup);
	    if (prevInstance._debugID !== 0) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: prevInstance._debugID,
	        type: 'replace with',
	        payload: markup.toString()
	      });
	    } else {
	      var nextInstance = ReactDOMComponentTree.getInstanceFromNode(markup.node);
	      if (nextInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onHostOperation({
	          instanceID: nextInstance._debugID,
	          type: 'mount',
	          payload: markup.toString()
	        });
	      }
	    }
	  };
	}
	
	/**
	 * Operations for updating with DOM children.
	 */
	var DOMChildrenOperations = {
	  dangerouslyReplaceNodeWithMarkup: dangerouslyReplaceNodeWithMarkup,
	
	  replaceDelimitedText: replaceDelimitedText,
	
	  /**
	   * Updates a component's children by processing a series of updates. The
	   * update configurations are each expected to have a `parentNode` property.
	   *
	   * @param {array<object>} updates List of update configurations.
	   * @internal
	   */
	  processUpdates: function (parentNode, updates) {
	    if (false) {
	      var parentNodeDebugID = ReactDOMComponentTree.getInstanceFromNode(parentNode)._debugID;
	    }
	
	    for (var k = 0; k < updates.length; k++) {
	      var update = updates[k];
	      switch (update.type) {
	        case 'INSERT_MARKUP':
	          insertLazyTreeChildAt(parentNode, update.content, getNodeAfter(parentNode, update.afterNode));
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'insert child',
	              payload: {
	                toIndex: update.toIndex,
	                content: update.content.toString()
	              }
	            });
	          }
	          break;
	        case 'MOVE_EXISTING':
	          moveChild(parentNode, update.fromNode, getNodeAfter(parentNode, update.afterNode));
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'move child',
	              payload: { fromIndex: update.fromIndex, toIndex: update.toIndex }
	            });
	          }
	          break;
	        case 'SET_MARKUP':
	          setInnerHTML(parentNode, update.content);
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'replace children',
	              payload: update.content.toString()
	            });
	          }
	          break;
	        case 'TEXT_CONTENT':
	          setTextContent(parentNode, update.content);
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'replace text',
	              payload: update.content.toString()
	            });
	          }
	          break;
	        case 'REMOVE_NODE':
	          removeChild(parentNode, update.fromNode);
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'remove child',
	              payload: { fromIndex: update.fromIndex }
	            });
	          }
	          break;
	      }
	    }
	  }
	};
	
	module.exports = DOMChildrenOperations;

/***/ }),
/* 118 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMNamespaces = {
	  html: 'http://www.w3.org/1999/xhtml',
	  mathml: 'http://www.w3.org/1998/Math/MathML',
	  svg: 'http://www.w3.org/2000/svg'
	};
	
	module.exports = DOMNamespaces;

/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(6);
	
	var invariant = __webpack_require__(3);
	
	/**
	 * Injectable ordering of event plugins.
	 */
	var eventPluginOrder = null;
	
	/**
	 * Injectable mapping from names to event plugin modules.
	 */
	var namesToPlugins = {};
	
	/**
	 * Recomputes the plugin list using the injected plugins and plugin ordering.
	 *
	 * @private
	 */
	function recomputePluginOrdering() {
	  if (!eventPluginOrder) {
	    // Wait until an `eventPluginOrder` is injected.
	    return;
	  }
	  for (var pluginName in namesToPlugins) {
	    var pluginModule = namesToPlugins[pluginName];
	    var pluginIndex = eventPluginOrder.indexOf(pluginName);
	    !(pluginIndex > -1) ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugins that do not exist in the plugin ordering, `%s`.', pluginName) : _prodInvariant('96', pluginName) : void 0;
	    if (EventPluginRegistry.plugins[pluginIndex]) {
	      continue;
	    }
	    !pluginModule.extractEvents ?  false ? invariant(false, 'EventPluginRegistry: Event plugins must implement an `extractEvents` method, but `%s` does not.', pluginName) : _prodInvariant('97', pluginName) : void 0;
	    EventPluginRegistry.plugins[pluginIndex] = pluginModule;
	    var publishedEvents = pluginModule.eventTypes;
	    for (var eventName in publishedEvents) {
	      !publishEventForPlugin(publishedEvents[eventName], pluginModule, eventName) ?  false ? invariant(false, 'EventPluginRegistry: Failed to publish event `%s` for plugin `%s`.', eventName, pluginName) : _prodInvariant('98', eventName, pluginName) : void 0;
	    }
	  }
	}
	
	/**
	 * Publishes an event so that it can be dispatched by the supplied plugin.
	 *
	 * @param {object} dispatchConfig Dispatch configuration for the event.
	 * @param {object} PluginModule Plugin publishing the event.
	 * @return {boolean} True if the event was successfully published.
	 * @private
	 */
	function publishEventForPlugin(dispatchConfig, pluginModule, eventName) {
	  !!EventPluginRegistry.eventNameDispatchConfigs.hasOwnProperty(eventName) ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same event name, `%s`.', eventName) : _prodInvariant('99', eventName) : void 0;
	  EventPluginRegistry.eventNameDispatchConfigs[eventName] = dispatchConfig;
	
	  var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;
	  if (phasedRegistrationNames) {
	    for (var phaseName in phasedRegistrationNames) {
	      if (phasedRegistrationNames.hasOwnProperty(phaseName)) {
	        var phasedRegistrationName = phasedRegistrationNames[phaseName];
	        publishRegistrationName(phasedRegistrationName, pluginModule, eventName);
	      }
	    }
	    return true;
	  } else if (dispatchConfig.registrationName) {
	    publishRegistrationName(dispatchConfig.registrationName, pluginModule, eventName);
	    return true;
	  }
	  return false;
	}
	
	/**
	 * Publishes a registration name that is used to identify dispatched events and
	 * can be used with `EventPluginHub.putListener` to register listeners.
	 *
	 * @param {string} registrationName Registration name to add.
	 * @param {object} PluginModule Plugin publishing the event.
	 * @private
	 */
	function publishRegistrationName(registrationName, pluginModule, eventName) {
	  !!EventPluginRegistry.registrationNameModules[registrationName] ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same registration name, `%s`.', registrationName) : _prodInvariant('100', registrationName) : void 0;
	  EventPluginRegistry.registrationNameModules[registrationName] = pluginModule;
	  EventPluginRegistry.registrationNameDependencies[registrationName] = pluginModule.eventTypes[eventName].dependencies;
	
	  if (false) {
	    var lowerCasedName = registrationName.toLowerCase();
	    EventPluginRegistry.possibleRegistrationNames[lowerCasedName] = registrationName;
	
	    if (registrationName === 'onDoubleClick') {
	      EventPluginRegistry.possibleRegistrationNames.ondblclick = registrationName;
	    }
	  }
	}
	
	/**
	 * Registers plugins so that they can extract and dispatch events.
	 *
	 * @see {EventPluginHub}
	 */
	var EventPluginRegistry = {
	  /**
	   * Ordered list of injected plugins.
	   */
	  plugins: [],
	
	  /**
	   * Mapping from event name to dispatch config
	   */
	  eventNameDispatchConfigs: {},
	
	  /**
	   * Mapping from registration name to plugin module
	   */
	  registrationNameModules: {},
	
	  /**
	   * Mapping from registration name to event name
	   */
	  registrationNameDependencies: {},
	
	  /**
	   * Mapping from lowercase registration names to the properly cased version,
	   * used to warn in the case of missing event handlers. Available
	   * only in __DEV__.
	   * @type {Object}
	   */
	  possibleRegistrationNames:  false ? {} : null,
	  // Trust the developer to only use possibleRegistrationNames in __DEV__
	
	  /**
	   * Injects an ordering of plugins (by plugin name). This allows the ordering
	   * to be decoupled from injection of the actual plugins so that ordering is
	   * always deterministic regardless of packaging, on-the-fly injection, etc.
	   *
	   * @param {array} InjectedEventPluginOrder
	   * @internal
	   * @see {EventPluginHub.injection.injectEventPluginOrder}
	   */
	  injectEventPluginOrder: function (injectedEventPluginOrder) {
	    !!eventPluginOrder ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugin ordering more than once. You are likely trying to load more than one copy of React.') : _prodInvariant('101') : void 0;
	    // Clone the ordering so it cannot be dynamically mutated.
	    eventPluginOrder = Array.prototype.slice.call(injectedEventPluginOrder);
	    recomputePluginOrdering();
	  },
	
	  /**
	   * Injects plugins to be used by `EventPluginHub`. The plugin names must be
	   * in the ordering injected by `injectEventPluginOrder`.
	   *
	   * Plugins can be injected as part of page initialization or on-the-fly.
	   *
	   * @param {object} injectedNamesToPlugins Map from names to plugin modules.
	   * @internal
	   * @see {EventPluginHub.injection.injectEventPluginsByName}
	   */
	  injectEventPluginsByName: function (injectedNamesToPlugins) {
	    var isOrderingDirty = false;
	    for (var pluginName in injectedNamesToPlugins) {
	      if (!injectedNamesToPlugins.hasOwnProperty(pluginName)) {
	        continue;
	      }
	      var pluginModule = injectedNamesToPlugins[pluginName];
	      if (!namesToPlugins.hasOwnProperty(pluginName) || namesToPlugins[pluginName] !== pluginModule) {
	        !!namesToPlugins[pluginName] ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject two different event plugins using the same name, `%s`.', pluginName) : _prodInvariant('102', pluginName) : void 0;
	        namesToPlugins[pluginName] = pluginModule;
	        isOrderingDirty = true;
	      }
	    }
	    if (isOrderingDirty) {
	      recomputePluginOrdering();
	    }
	  },
	
	  /**
	   * Looks up the plugin for the supplied event.
	   *
	   * @param {object} event A synthetic event.
	   * @return {?object} The plugin that created the supplied event.
	   * @internal
	   */
	  getPluginModuleForEvent: function (event) {
	    var dispatchConfig = event.dispatchConfig;
	    if (dispatchConfig.registrationName) {
	      return EventPluginRegistry.registrationNameModules[dispatchConfig.registrationName] || null;
	    }
	    if (dispatchConfig.phasedRegistrationNames !== undefined) {
	      // pulling phasedRegistrationNames out of dispatchConfig helps Flow see
	      // that it is not undefined.
	      var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;
	
	      for (var phase in phasedRegistrationNames) {
	        if (!phasedRegistrationNames.hasOwnProperty(phase)) {
	          continue;
	        }
	        var pluginModule = EventPluginRegistry.registrationNameModules[phasedRegistrationNames[phase]];
	        if (pluginModule) {
	          return pluginModule;
	        }
	      }
	    }
	    return null;
	  },
	
	  /**
	   * Exposed for unit testing.
	   * @private
	   */
	  _resetEventPlugins: function () {
	    eventPluginOrder = null;
	    for (var pluginName in namesToPlugins) {
	      if (namesToPlugins.hasOwnProperty(pluginName)) {
	        delete namesToPlugins[pluginName];
	      }
	    }
	    EventPluginRegistry.plugins.length = 0;
	
	    var eventNameDispatchConfigs = EventPluginRegistry.eventNameDispatchConfigs;
	    for (var eventName in eventNameDispatchConfigs) {
	      if (eventNameDispatchConfigs.hasOwnProperty(eventName)) {
	        delete eventNameDispatchConfigs[eventName];
	      }
	    }
	
	    var registrationNameModules = EventPluginRegistry.registrationNameModules;
	    for (var registrationName in registrationNameModules) {
	      if (registrationNameModules.hasOwnProperty(registrationName)) {
	        delete registrationNameModules[registrationName];
	      }
	    }
	
	    if (false) {
	      var possibleRegistrationNames = EventPluginRegistry.possibleRegistrationNames;
	      for (var lowerCasedName in possibleRegistrationNames) {
	        if (possibleRegistrationNames.hasOwnProperty(lowerCasedName)) {
	          delete possibleRegistrationNames[lowerCasedName];
	        }
	      }
	    }
	  }
	};
	
	module.exports = EventPluginRegistry;

/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(6);
	
	var ReactErrorUtils = __webpack_require__(124);
	
	var invariant = __webpack_require__(3);
	var warning = __webpack_require__(5);
	
	/**
	 * Injected dependencies:
	 */
	
	/**
	 * - `ComponentTree`: [required] Module that can convert between React instances
	 *   and actual node references.
	 */
	var ComponentTree;
	var TreeTraversal;
	var injection = {
	  injectComponentTree: function (Injected) {
	    ComponentTree = Injected;
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(Injected && Injected.getNodeFromInstance && Injected.getInstanceFromNode, 'EventPluginUtils.injection.injectComponentTree(...): Injected ' + 'module is missing getNodeFromInstance or getInstanceFromNode.') : void 0;
	    }
	  },
	  injectTreeTraversal: function (Injected) {
	    TreeTraversal = Injected;
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(Injected && Injected.isAncestor && Injected.getLowestCommonAncestor, 'EventPluginUtils.injection.injectTreeTraversal(...): Injected ' + 'module is missing isAncestor or getLowestCommonAncestor.') : void 0;
	    }
	  }
	};
	
	function isEndish(topLevelType) {
	  return topLevelType === 'topMouseUp' || topLevelType === 'topTouchEnd' || topLevelType === 'topTouchCancel';
	}
	
	function isMoveish(topLevelType) {
	  return topLevelType === 'topMouseMove' || topLevelType === 'topTouchMove';
	}
	function isStartish(topLevelType) {
	  return topLevelType === 'topMouseDown' || topLevelType === 'topTouchStart';
	}
	
	var validateEventDispatches;
	if (false) {
	  validateEventDispatches = function (event) {
	    var dispatchListeners = event._dispatchListeners;
	    var dispatchInstances = event._dispatchInstances;
	
	    var listenersIsArr = Array.isArray(dispatchListeners);
	    var listenersLen = listenersIsArr ? dispatchListeners.length : dispatchListeners ? 1 : 0;
	
	    var instancesIsArr = Array.isArray(dispatchInstances);
	    var instancesLen = instancesIsArr ? dispatchInstances.length : dispatchInstances ? 1 : 0;
	
	    process.env.NODE_ENV !== 'production' ? warning(instancesIsArr === listenersIsArr && instancesLen === listenersLen, 'EventPluginUtils: Invalid `event`.') : void 0;
	  };
	}
	
	/**
	 * Dispatch the event to the listener.
	 * @param {SyntheticEvent} event SyntheticEvent to handle
	 * @param {boolean} simulated If the event is simulated (changes exn behavior)
	 * @param {function} listener Application-level callback
	 * @param {*} inst Internal component instance
	 */
	function executeDispatch(event, simulated, listener, inst) {
	  var type = event.type || 'unknown-event';
	  event.currentTarget = EventPluginUtils.getNodeFromInstance(inst);
	  if (simulated) {
	    ReactErrorUtils.invokeGuardedCallbackWithCatch(type, listener, event);
	  } else {
	    ReactErrorUtils.invokeGuardedCallback(type, listener, event);
	  }
	  event.currentTarget = null;
	}
	
	/**
	 * Standard/simple iteration through an event's collected dispatches.
	 */
	function executeDispatchesInOrder(event, simulated) {
	  var dispatchListeners = event._dispatchListeners;
	  var dispatchInstances = event._dispatchInstances;
	  if (false) {
	    validateEventDispatches(event);
	  }
	  if (Array.isArray(dispatchListeners)) {
	    for (var i = 0; i < dispatchListeners.length; i++) {
	      if (event.isPropagationStopped()) {
	        break;
	      }
	      // Listeners and Instances are two parallel arrays that are always in sync.
	      executeDispatch(event, simulated, dispatchListeners[i], dispatchInstances[i]);
	    }
	  } else if (dispatchListeners) {
	    executeDispatch(event, simulated, dispatchListeners, dispatchInstances);
	  }
	  event._dispatchListeners = null;
	  event._dispatchInstances = null;
	}
	
	/**
	 * Standard/simple iteration through an event's collected dispatches, but stops
	 * at the first dispatch execution returning true, and returns that id.
	 *
	 * @return {?string} id of the first dispatch execution who's listener returns
	 * true, or null if no listener returned true.
	 */
	function executeDispatchesInOrderStopAtTrueImpl(event) {
	  var dispatchListeners = event._dispatchListeners;
	  var dispatchInstances = event._dispatchInstances;
	  if (false) {
	    validateEventDispatches(event);
	  }
	  if (Array.isArray(dispatchListeners)) {
	    for (var i = 0; i < dispatchListeners.length; i++) {
	      if (event.isPropagationStopped()) {
	        break;
	      }
	      // Listeners and Instances are two parallel arrays that are always in sync.
	      if (dispatchListeners[i](event, dispatchInstances[i])) {
	        return dispatchInstances[i];
	      }
	    }
	  } else if (dispatchListeners) {
	    if (dispatchListeners(event, dispatchInstances)) {
	      return dispatchInstances;
	    }
	  }
	  return null;
	}
	
	/**
	 * @see executeDispatchesInOrderStopAtTrueImpl
	 */
	function executeDispatchesInOrderStopAtTrue(event) {
	  var ret = executeDispatchesInOrderStopAtTrueImpl(event);
	  event._dispatchInstances = null;
	  event._dispatchListeners = null;
	  return ret;
	}
	
	/**
	 * Execution of a "direct" dispatch - there must be at most one dispatch
	 * accumulated on the event or it is considered an error. It doesn't really make
	 * sense for an event with multiple dispatches (bubbled) to keep track of the
	 * return values at each dispatch execution, but it does tend to make sense when
	 * dealing with "direct" dispatches.
	 *
	 * @return {*} The return value of executing the single dispatch.
	 */
	function executeDirectDispatch(event) {
	  if (false) {
	    validateEventDispatches(event);
	  }
	  var dispatchListener = event._dispatchListeners;
	  var dispatchInstance = event._dispatchInstances;
	  !!Array.isArray(dispatchListener) ?  false ? invariant(false, 'executeDirectDispatch(...): Invalid `event`.') : _prodInvariant('103') : void 0;
	  event.currentTarget = dispatchListener ? EventPluginUtils.getNodeFromInstance(dispatchInstance) : null;
	  var res = dispatchListener ? dispatchListener(event) : null;
	  event.currentTarget = null;
	  event._dispatchListeners = null;
	  event._dispatchInstances = null;
	  return res;
	}
	
	/**
	 * @param {SyntheticEvent} event
	 * @return {boolean} True iff number of dispatches accumulated is greater than 0.
	 */
	function hasDispatches(event) {
	  return !!event._dispatchListeners;
	}
	
	/**
	 * General utilities that are useful in creating custom Event Plugins.
	 */
	var EventPluginUtils = {
	  isEndish: isEndish,
	  isMoveish: isMoveish,
	  isStartish: isStartish,
	
	  executeDirectDispatch: executeDirectDispatch,
	  executeDispatchesInOrder: executeDispatchesInOrder,
	  executeDispatchesInOrderStopAtTrue: executeDispatchesInOrderStopAtTrue,
	  hasDispatches: hasDispatches,
	
	  getInstanceFromNode: function (node) {
	    return ComponentTree.getInstanceFromNode(node);
	  },
	  getNodeFromInstance: function (node) {
	    return ComponentTree.getNodeFromInstance(node);
	  },
	  isAncestor: function (a, b) {
	    return TreeTraversal.isAncestor(a, b);
	  },
	  getLowestCommonAncestor: function (a, b) {
	    return TreeTraversal.getLowestCommonAncestor(a, b);
	  },
	  getParentInstance: function (inst) {
	    return TreeTraversal.getParentInstance(inst);
	  },
	  traverseTwoPhase: function (target, fn, arg) {
	    return TreeTraversal.traverseTwoPhase(target, fn, arg);
	  },
	  traverseEnterLeave: function (from, to, fn, argFrom, argTo) {
	    return TreeTraversal.traverseEnterLeave(from, to, fn, argFrom, argTo);
	  },
	
	  injection: injection
	};
	
	module.exports = EventPluginUtils;

/***/ }),
/* 121 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * Escape and wrap key so it is safe to use as a reactid
	 *
	 * @param {string} key to be escaped.
	 * @return {string} the escaped key.
	 */
	
	function escape(key) {
	  var escapeRegex = /[=:]/g;
	  var escaperLookup = {
	    '=': '=0',
	    ':': '=2'
	  };
	  var escapedString = ('' + key).replace(escapeRegex, function (match) {
	    return escaperLookup[match];
	  });
	
	  return '$' + escapedString;
	}
	
	/**
	 * Unescape and unwrap key for human-readable display
	 *
	 * @param {string} key to unescape.
	 * @return {string} the unescaped key.
	 */
	function unescape(key) {
	  var unescapeRegex = /(=0|=2)/g;
	  var unescaperLookup = {
	    '=0': '=',
	    '=2': ':'
	  };
	  var keySubstring = key[0] === '.' && key[1] === '$' ? key.substring(2) : key.substring(1);
	
	  return ('' + keySubstring).replace(unescapeRegex, function (match) {
	    return unescaperLookup[match];
	  });
	}
	
	var KeyEscapeUtils = {
	  escape: escape,
	  unescape: unescape
	};
	
	module.exports = KeyEscapeUtils;

/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(6);
	
	var ReactPropTypesSecret = __webpack_require__(451);
	var propTypesFactory = __webpack_require__(195);
	
	var React = __webpack_require__(47);
	var PropTypes = propTypesFactory(React.isValidElement);
	
	var invariant = __webpack_require__(3);
	var warning = __webpack_require__(5);
	
	var hasReadOnlyValue = {
	  button: true,
	  checkbox: true,
	  image: true,
	  hidden: true,
	  radio: true,
	  reset: true,
	  submit: true
	};
	
	function _assertSingleLink(inputProps) {
	  !(inputProps.checkedLink == null || inputProps.valueLink == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a valueLink. If you want to use checkedLink, you probably don\'t want to use valueLink and vice versa.') : _prodInvariant('87') : void 0;
	}
	function _assertValueLink(inputProps) {
	  _assertSingleLink(inputProps);
	  !(inputProps.value == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a valueLink and a value or onChange event. If you want to use value or onChange, you probably don\'t want to use valueLink.') : _prodInvariant('88') : void 0;
	}
	
	function _assertCheckedLink(inputProps) {
	  _assertSingleLink(inputProps);
	  !(inputProps.checked == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a checked property or onChange event. If you want to use checked or onChange, you probably don\'t want to use checkedLink') : _prodInvariant('89') : void 0;
	}
	
	var propTypes = {
	  value: function (props, propName, componentName) {
	    if (!props[propName] || hasReadOnlyValue[props.type] || props.onChange || props.readOnly || props.disabled) {
	      return null;
	    }
	    return new Error('You provided a `value` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultValue`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
	  },
	  checked: function (props, propName, componentName) {
	    if (!props[propName] || props.onChange || props.readOnly || props.disabled) {
	      return null;
	    }
	    return new Error('You provided a `checked` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultChecked`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
	  },
	  onChange: PropTypes.func
	};
	
	var loggedTypeFailures = {};
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	/**
	 * Provide a linked `value` attribute for controlled forms. You should not use
	 * this outside of the ReactDOM controlled form components.
	 */
	var LinkedValueUtils = {
	  checkPropTypes: function (tagName, props, owner) {
	    for (var propName in propTypes) {
	      if (propTypes.hasOwnProperty(propName)) {
	        var error = propTypes[propName](props, propName, tagName, 'prop', null, ReactPropTypesSecret);
	      }
	      if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	        // Only monitor this failure once because there tends to be a lot of the
	        // same error.
	        loggedTypeFailures[error.message] = true;
	
	        var addendum = getDeclarationErrorAddendum(owner);
	         false ? warning(false, 'Failed form propType: %s%s', error.message, addendum) : void 0;
	      }
	    }
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @return {*} current value of the input either from value prop or link.
	   */
	  getValue: function (inputProps) {
	    if (inputProps.valueLink) {
	      _assertValueLink(inputProps);
	      return inputProps.valueLink.value;
	    }
	    return inputProps.value;
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @return {*} current checked status of the input either from checked prop
	   *             or link.
	   */
	  getChecked: function (inputProps) {
	    if (inputProps.checkedLink) {
	      _assertCheckedLink(inputProps);
	      return inputProps.checkedLink.value;
	    }
	    return inputProps.checked;
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @param {SyntheticEvent} event change event to handle
	   */
	  executeOnChange: function (inputProps, event) {
	    if (inputProps.valueLink) {
	      _assertValueLink(inputProps);
	      return inputProps.valueLink.requestChange(event.target.value);
	    } else if (inputProps.checkedLink) {
	      _assertCheckedLink(inputProps);
	      return inputProps.checkedLink.requestChange(event.target.checked);
	    } else if (inputProps.onChange) {
	      return inputProps.onChange.call(undefined, event);
	    }
	  }
	};
	
	module.exports = LinkedValueUtils;

/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(6);
	
	var invariant = __webpack_require__(3);
	
	var injected = false;
	
	var ReactComponentEnvironment = {
	  /**
	   * Optionally injectable hook for swapping out mount images in the middle of
	   * the tree.
	   */
	  replaceNodeWithMarkup: null,
	
	  /**
	   * Optionally injectable hook for processing a queue of child updates. Will
	   * later move into MultiChildComponents.
	   */
	  processChildrenUpdates: null,
	
	  injection: {
	    injectEnvironment: function (environment) {
	      !!injected ?  false ? invariant(false, 'ReactCompositeComponent: injectEnvironment() can only be called once.') : _prodInvariant('104') : void 0;
	      ReactComponentEnvironment.replaceNodeWithMarkup = environment.replaceNodeWithMarkup;
	      ReactComponentEnvironment.processChildrenUpdates = environment.processChildrenUpdates;
	      injected = true;
	    }
	  }
	};
	
	module.exports = ReactComponentEnvironment;

/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var caughtError = null;
	
	/**
	 * Call a function while guarding against errors that happens within it.
	 *
	 * @param {String} name of the guard to use for logging or debugging
	 * @param {Function} func The function to invoke
	 * @param {*} a First argument
	 * @param {*} b Second argument
	 */
	function invokeGuardedCallback(name, func, a) {
	  try {
	    func(a);
	  } catch (x) {
	    if (caughtError === null) {
	      caughtError = x;
	    }
	  }
	}
	
	var ReactErrorUtils = {
	  invokeGuardedCallback: invokeGuardedCallback,
	
	  /**
	   * Invoked by ReactTestUtils.Simulate so that any errors thrown by the event
	   * handler are sure to be rethrown by rethrowCaughtError.
	   */
	  invokeGuardedCallbackWithCatch: invokeGuardedCallback,
	
	  /**
	   * During execution of guarded functions we will capture the first error which
	   * we will rethrow to be handled by the top level error handler.
	   */
	  rethrowCaughtError: function () {
	    if (caughtError) {
	      var error = caughtError;
	      caughtError = null;
	      throw error;
	    }
	  }
	};
	
	if (false) {
	  /**
	   * To help development we can get better devtools integration by simulating a
	   * real browser event.
	   */
	  if (typeof window !== 'undefined' && typeof window.dispatchEvent === 'function' && typeof document !== 'undefined' && typeof document.createEvent === 'function') {
	    var fakeNode = document.createElement('react');
	    ReactErrorUtils.invokeGuardedCallback = function (name, func, a) {
	      var boundFunc = function () {
	        func(a);
	      };
	      var evtType = 'react-' + name;
	      fakeNode.addEventListener(evtType, boundFunc, false);
	      var evt = document.createEvent('Event');
	      evt.initEvent(evtType, false, false);
	      fakeNode.dispatchEvent(evt);
	      fakeNode.removeEventListener(evtType, boundFunc, false);
	    };
	  }
	}
	
	module.exports = ReactErrorUtils;

/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(6);
	
	var ReactCurrentOwner = __webpack_require__(32);
	var ReactInstanceMap = __webpack_require__(61);
	var ReactInstrumentation = __webpack_require__(25);
	var ReactUpdates = __webpack_require__(28);
	
	var invariant = __webpack_require__(3);
	var warning = __webpack_require__(5);
	
	function enqueueUpdate(internalInstance) {
	  ReactUpdates.enqueueUpdate(internalInstance);
	}
	
	function formatUnexpectedArgument(arg) {
	  var type = typeof arg;
	  if (type !== 'object') {
	    return type;
	  }
	  var displayName = arg.constructor && arg.constructor.name || type;
	  var keys = Object.keys(arg);
	  if (keys.length > 0 && keys.length < 20) {
	    return displayName + ' (keys: ' + keys.join(', ') + ')';
	  }
	  return displayName;
	}
	
	function getInternalInstanceReadyForUpdate(publicInstance, callerName) {
	  var internalInstance = ReactInstanceMap.get(publicInstance);
	  if (!internalInstance) {
	    if (false) {
	      var ctor = publicInstance.constructor;
	      // Only warn when we have a callerName. Otherwise we should be silent.
	      // We're probably calling from enqueueCallback. We don't want to warn
	      // there because we already warned for the corresponding lifecycle method.
	      process.env.NODE_ENV !== 'production' ? warning(!callerName, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, ctor && (ctor.displayName || ctor.name) || 'ReactClass') : void 0;
	    }
	    return null;
	  }
	
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(ReactCurrentOwner.current == null, '%s(...): Cannot update during an existing state transition (such as ' + "within `render` or another component's constructor). Render methods " + 'should be a pure function of props and state; constructor ' + 'side-effects are an anti-pattern, but can be moved to ' + '`componentWillMount`.', callerName) : void 0;
	  }
	
	  return internalInstance;
	}
	
	/**
	 * ReactUpdateQueue allows for state updates to be scheduled into a later
	 * reconciliation step.
	 */
	var ReactUpdateQueue = {
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function (publicInstance) {
	    if (false) {
	      var owner = ReactCurrentOwner.current;
	      if (owner !== null) {
	        process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing isMounted inside its render() function. ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : void 0;
	        owner._warnedAboutRefsInRender = true;
	      }
	    }
	    var internalInstance = ReactInstanceMap.get(publicInstance);
	    if (internalInstance) {
	      // During componentWillMount and render this will still be null but after
	      // that will always render to something. At least for now. So we can use
	      // this hack.
	      return !!internalInstance._renderedComponent;
	    } else {
	      return false;
	    }
	  },
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @param {string} callerName Name of the calling function in the public API.
	   * @internal
	   */
	  enqueueCallback: function (publicInstance, callback, callerName) {
	    ReactUpdateQueue.validateCallback(callback, callerName);
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance);
	
	    // Previously we would throw an error if we didn't have an internal
	    // instance. Since we want to make it a no-op instead, we mirror the same
	    // behavior we have in other enqueue* methods.
	    // We also need to ignore callbacks in componentWillMount. See
	    // enqueueUpdates.
	    if (!internalInstance) {
	      return null;
	    }
	
	    if (internalInstance._pendingCallbacks) {
	      internalInstance._pendingCallbacks.push(callback);
	    } else {
	      internalInstance._pendingCallbacks = [callback];
	    }
	    // TODO: The callback here is ignored when setState is called from
	    // componentWillMount. Either fix it or disallow doing so completely in
	    // favor of getInitialState. Alternatively, we can disallow
	    // componentWillMount during server-side rendering.
	    enqueueUpdate(internalInstance);
	  },
	
	  enqueueCallbackInternal: function (internalInstance, callback) {
	    if (internalInstance._pendingCallbacks) {
	      internalInstance._pendingCallbacks.push(callback);
	    } else {
	      internalInstance._pendingCallbacks = [callback];
	    }
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	  enqueueForceUpdate: function (publicInstance) {
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'forceUpdate');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    internalInstance._pendingForceUpdate = true;
	
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} completeState Next state.
	   * @internal
	   */
	  enqueueReplaceState: function (publicInstance, completeState, callback) {
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'replaceState');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    internalInstance._pendingStateQueue = [completeState];
	    internalInstance._pendingReplaceState = true;
	
	    // Future-proof 15.5
	    if (callback !== undefined && callback !== null) {
	      ReactUpdateQueue.validateCallback(callback, 'replaceState');
	      if (internalInstance._pendingCallbacks) {
	        internalInstance._pendingCallbacks.push(callback);
	      } else {
	        internalInstance._pendingCallbacks = [callback];
	      }
	    }
	
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} partialState Next partial state to be merged with state.
	   * @internal
	   */
	  enqueueSetState: function (publicInstance, partialState) {
	    if (false) {
	      ReactInstrumentation.debugTool.onSetState();
	      process.env.NODE_ENV !== 'production' ? warning(partialState != null, 'setState(...): You passed an undefined or null state object; ' + 'instead, use forceUpdate().') : void 0;
	    }
	
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'setState');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    var queue = internalInstance._pendingStateQueue || (internalInstance._pendingStateQueue = []);
	    queue.push(partialState);
	
	    enqueueUpdate(internalInstance);
	  },
	
	  enqueueElementInternal: function (internalInstance, nextElement, nextContext) {
	    internalInstance._pendingElement = nextElement;
	    // TODO: introduce _pendingContext instead of setting it directly.
	    internalInstance._context = nextContext;
	    enqueueUpdate(internalInstance);
	  },
	
	  validateCallback: function (callback, callerName) {
	    !(!callback || typeof callback === 'function') ?  false ? invariant(false, '%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.', callerName, formatUnexpectedArgument(callback)) : _prodInvariant('122', callerName, formatUnexpectedArgument(callback)) : void 0;
	  }
	};
	
	module.exports = ReactUpdateQueue;

/***/ }),
/* 126 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	/* globals MSApp */
	
	'use strict';
	
	/**
	 * Create a function which has 'unsafe' privileges (required by windows8 apps)
	 */
	
	var createMicrosoftUnsafeLocalFunction = function (func) {
	  if (typeof MSApp !== 'undefined' && MSApp.execUnsafeLocalFunction) {
	    return function (arg0, arg1, arg2, arg3) {
	      MSApp.execUnsafeLocalFunction(function () {
	        return func(arg0, arg1, arg2, arg3);
	      });
	    };
	  } else {
	    return func;
	  }
	};
	
	module.exports = createMicrosoftUnsafeLocalFunction;

/***/ }),
/* 127 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * `charCode` represents the actual "character code" and is safe to use with
	 * `String.fromCharCode`. As such, only keys that correspond to printable
	 * characters produce a valid `charCode`, the only exception to this is Enter.
	 * The Tab-key is considered non-printable and does not have a `charCode`,
	 * presumably because it does not produce a tab-character in browsers.
	 *
	 * @param {object} nativeEvent Native browser event.
	 * @return {number} Normalized `charCode` property.
	 */
	
	function getEventCharCode(nativeEvent) {
	  var charCode;
	  var keyCode = nativeEvent.keyCode;
	
	  if ('charCode' in nativeEvent) {
	    charCode = nativeEvent.charCode;
	
	    // FF does not set `charCode` for the Enter-key, check against `keyCode`.
	    if (charCode === 0 && keyCode === 13) {
	      charCode = 13;
	    }
	  } else {
	    // IE8 does not implement `charCode`, but `keyCode` has the correct value.
	    charCode = keyCode;
	  }
	
	  // Some non-printable keys are reported in `charCode`/`keyCode`, discard them.
	  // Must not discard the (non-)printable Enter-key.
	  if (charCode >= 32 || charCode === 13) {
	    return charCode;
	  }
	
	  return 0;
	}
	
	module.exports = getEventCharCode;

/***/ }),
/* 128 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Translation from modifier key to the associated property in the event.
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/#keys-Modifiers
	 */
	
	var modifierKeyToProp = {
	  Alt: 'altKey',
	  Control: 'ctrlKey',
	  Meta: 'metaKey',
	  Shift: 'shiftKey'
	};
	
	// IE8 does not implement getModifierState so we simply map it to the only
	// modifier keys exposed by the event itself, does not support Lock-keys.
	// Currently, all major browsers except Chrome seems to support Lock-keys.
	function modifierStateGetter(keyArg) {
	  var syntheticEvent = this;
	  var nativeEvent = syntheticEvent.nativeEvent;
	  if (nativeEvent.getModifierState) {
	    return nativeEvent.getModifierState(keyArg);
	  }
	  var keyProp = modifierKeyToProp[keyArg];
	  return keyProp ? !!nativeEvent[keyProp] : false;
	}
	
	function getEventModifierState(nativeEvent) {
	  return modifierStateGetter;
	}
	
	module.exports = getEventModifierState;

/***/ }),
/* 129 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Gets the target node from a native browser event by accounting for
	 * inconsistencies in browser DOM APIs.
	 *
	 * @param {object} nativeEvent Native browser event.
	 * @return {DOMEventTarget} Target node.
	 */
	
	function getEventTarget(nativeEvent) {
	  var target = nativeEvent.target || nativeEvent.srcElement || window;
	
	  // Normalize SVG <use> element events #4963
	  if (target.correspondingUseElement) {
	    target = target.correspondingUseElement;
	  }
	
	  // Safari may fire events on text nodes (Node.TEXT_NODE is 3).
	  // @see http://www.quirksmode.org/js/events_properties.html
	  return target.nodeType === 3 ? target.parentNode : target;
	}
	
	module.exports = getEventTarget;

/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(16);
	
	var useHasFeature;
	if (ExecutionEnvironment.canUseDOM) {
	  useHasFeature = document.implementation && document.implementation.hasFeature &&
	  // always returns true in newer browsers as per the standard.
	  // @see http://dom.spec.whatwg.org/#dom-domimplementation-hasfeature
	  document.implementation.hasFeature('', '') !== true;
	}
	
	/**
	 * Checks if an event is supported in the current execution environment.
	 *
	 * NOTE: This will not work correctly for non-generic events such as `change`,
	 * `reset`, `load`, `error`, and `select`.
	 *
	 * Borrows from Modernizr.
	 *
	 * @param {string} eventNameSuffix Event name, e.g. "click".
	 * @param {?boolean} capture Check if the capture phase is supported.
	 * @return {boolean} True if the event is supported.
	 * @internal
	 * @license Modernizr 3.0.0pre (Custom Build) | MIT
	 */
	function isEventSupported(eventNameSuffix, capture) {
	  if (!ExecutionEnvironment.canUseDOM || capture && !('addEventListener' in document)) {
	    return false;
	  }
	
	  var eventName = 'on' + eventNameSuffix;
	  var isSupported = eventName in document;
	
	  if (!isSupported) {
	    var element = document.createElement('div');
	    element.setAttribute(eventName, 'return;');
	    isSupported = typeof element[eventName] === 'function';
	  }
	
	  if (!isSupported && useHasFeature && eventNameSuffix === 'wheel') {
	    // This is the only way to test support for the `wheel` event in IE9+.
	    isSupported = document.implementation.hasFeature('Events.wheel', '3.0');
	  }
	
	  return isSupported;
	}
	
	module.exports = isEventSupported;

/***/ }),
/* 131 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Given a `prevElement` and `nextElement`, determines if the existing
	 * instance should be updated as opposed to being destroyed or replaced by a new
	 * instance. Both arguments are elements. This ensures that this logic can
	 * operate on stateless trees without any backing instance.
	 *
	 * @param {?object} prevElement
	 * @param {?object} nextElement
	 * @return {boolean} True if the existing instance should be updated.
	 * @protected
	 */
	
	function shouldUpdateReactComponent(prevElement, nextElement) {
	  var prevEmpty = prevElement === null || prevElement === false;
	  var nextEmpty = nextElement === null || nextElement === false;
	  if (prevEmpty || nextEmpty) {
	    return prevEmpty === nextEmpty;
	  }
	
	  var prevType = typeof prevElement;
	  var nextType = typeof nextElement;
	  if (prevType === 'string' || prevType === 'number') {
	    return nextType === 'string' || nextType === 'number';
	  } else {
	    return nextType === 'object' && prevElement.type === nextElement.type && prevElement.key === nextElement.key;
	  }
	}
	
	module.exports = shouldUpdateReactComponent;

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(7);
	
	var emptyFunction = __webpack_require__(24);
	var warning = __webpack_require__(5);
	
	var validateDOMNesting = emptyFunction;
	
	if (false) {
	  // This validation code was written based on the HTML5 parsing spec:
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
	  //
	  // Note: this does not catch all invalid nesting, nor does it try to (as it's
	  // not clear what practical benefit doing so provides); instead, we warn only
	  // for cases where the parser will give a parse tree differing from what React
	  // intended. For example, <b><div></div></b> is invalid but we don't warn
	  // because it still parses correctly; we do warn for other cases like nested
	  // <p> tags where the beginning of the second element implicitly closes the
	  // first, causing a confusing mess.
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#special
	  var specialTags = ['address', 'applet', 'area', 'article', 'aside', 'base', 'basefont', 'bgsound', 'blockquote', 'body', 'br', 'button', 'caption', 'center', 'col', 'colgroup', 'dd', 'details', 'dir', 'div', 'dl', 'dt', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'frame', 'frameset', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'iframe', 'img', 'input', 'isindex', 'li', 'link', 'listing', 'main', 'marquee', 'menu', 'menuitem', 'meta', 'nav', 'noembed', 'noframes', 'noscript', 'object', 'ol', 'p', 'param', 'plaintext', 'pre', 'script', 'section', 'select', 'source', 'style', 'summary', 'table', 'tbody', 'td', 'template', 'textarea', 'tfoot', 'th', 'thead', 'title', 'tr', 'track', 'ul', 'wbr', 'xmp'];
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
	  var inScopeTags = ['applet', 'caption', 'html', 'table', 'td', 'th', 'marquee', 'object', 'template',
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#html-integration-point
	  // TODO: Distinguish by namespace here -- for <title>, including it here
	  // errs on the side of fewer warnings
	  'foreignObject', 'desc', 'title'];
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-button-scope
	  var buttonScopeTags = inScopeTags.concat(['button']);
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#generate-implied-end-tags
	  var impliedEndTags = ['dd', 'dt', 'li', 'option', 'optgroup', 'p', 'rp', 'rt'];
	
	  var emptyAncestorInfo = {
	    current: null,
	
	    formTag: null,
	    aTagInScope: null,
	    buttonTagInScope: null,
	    nobrTagInScope: null,
	    pTagInButtonScope: null,
	
	    listItemTagAutoclosing: null,
	    dlItemTagAutoclosing: null
	  };
	
	  var updatedAncestorInfo = function (oldInfo, tag, instance) {
	    var ancestorInfo = _assign({}, oldInfo || emptyAncestorInfo);
	    var info = { tag: tag, instance: instance };
	
	    if (inScopeTags.indexOf(tag) !== -1) {
	      ancestorInfo.aTagInScope = null;
	      ancestorInfo.buttonTagInScope = null;
	      ancestorInfo.nobrTagInScope = null;
	    }
	    if (buttonScopeTags.indexOf(tag) !== -1) {
	      ancestorInfo.pTagInButtonScope = null;
	    }
	
	    // See rules for 'li', 'dd', 'dt' start tags in
	    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
	    if (specialTags.indexOf(tag) !== -1 && tag !== 'address' && tag !== 'div' && tag !== 'p') {
	      ancestorInfo.listItemTagAutoclosing = null;
	      ancestorInfo.dlItemTagAutoclosing = null;
	    }
	
	    ancestorInfo.current = info;
	
	    if (tag === 'form') {
	      ancestorInfo.formTag = info;
	    }
	    if (tag === 'a') {
	      ancestorInfo.aTagInScope = info;
	    }
	    if (tag === 'button') {
	      ancestorInfo.buttonTagInScope = info;
	    }
	    if (tag === 'nobr') {
	      ancestorInfo.nobrTagInScope = info;
	    }
	    if (tag === 'p') {
	      ancestorInfo.pTagInButtonScope = info;
	    }
	    if (tag === 'li') {
	      ancestorInfo.listItemTagAutoclosing = info;
	    }
	    if (tag === 'dd' || tag === 'dt') {
	      ancestorInfo.dlItemTagAutoclosing = info;
	    }
	
	    return ancestorInfo;
	  };
	
	  /**
	   * Returns whether
	   */
	  var isTagValidWithParent = function (tag, parentTag) {
	    // First, let's check if we're in an unusual parsing mode...
	    switch (parentTag) {
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inselect
	      case 'select':
	        return tag === 'option' || tag === 'optgroup' || tag === '#text';
	      case 'optgroup':
	        return tag === 'option' || tag === '#text';
	      // Strictly speaking, seeing an <option> doesn't mean we're in a <select>
	      // but
	      case 'option':
	        return tag === '#text';
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intd
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incaption
	      // No special behavior since these rules fall back to "in body" mode for
	      // all except special table nodes which cause bad parsing behavior anyway.
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intr
	      case 'tr':
	        return tag === 'th' || tag === 'td' || tag === 'style' || tag === 'script' || tag === 'template';
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intbody
	      case 'tbody':
	      case 'thead':
	      case 'tfoot':
	        return tag === 'tr' || tag === 'style' || tag === 'script' || tag === 'template';
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incolgroup
	      case 'colgroup':
	        return tag === 'col' || tag === 'template';
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intable
	      case 'table':
	        return tag === 'caption' || tag === 'colgroup' || tag === 'tbody' || tag === 'tfoot' || tag === 'thead' || tag === 'style' || tag === 'script' || tag === 'template';
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inhead
	      case 'head':
	        return tag === 'base' || tag === 'basefont' || tag === 'bgsound' || tag === 'link' || tag === 'meta' || tag === 'title' || tag === 'noscript' || tag === 'noframes' || tag === 'style' || tag === 'script' || tag === 'template';
	      // https://html.spec.whatwg.org/multipage/semantics.html#the-html-element
	      case 'html':
	        return tag === 'head' || tag === 'body';
	      case '#document':
	        return tag === 'html';
	    }
	
	    // Probably in the "in body" parsing mode, so we outlaw only tag combos
	    // where the parsing rules cause implicit opens or closes to be added.
	    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
	    switch (tag) {
	      case 'h1':
	      case 'h2':
	      case 'h3':
	      case 'h4':
	      case 'h5':
	      case 'h6':
	        return parentTag !== 'h1' && parentTag !== 'h2' && parentTag !== 'h3' && parentTag !== 'h4' && parentTag !== 'h5' && parentTag !== 'h6';
	
	      case 'rp':
	      case 'rt':
	        return impliedEndTags.indexOf(parentTag) === -1;
	
	      case 'body':
	      case 'caption':
	      case 'col':
	      case 'colgroup':
	      case 'frame':
	      case 'head':
	      case 'html':
	      case 'tbody':
	      case 'td':
	      case 'tfoot':
	      case 'th':
	      case 'thead':
	      case 'tr':
	        // These tags are only valid with a few parents that have special child
	        // parsing rules -- if we're down here, then none of those matched and
	        // so we allow it only if we don't know what the parent is, as all other
	        // cases are invalid.
	        return parentTag == null;
	    }
	
	    return true;
	  };
	
	  /**
	   * Returns whether
	   */
	  var findInvalidAncestorForTag = function (tag, ancestorInfo) {
	    switch (tag) {
	      case 'address':
	      case 'article':
	      case 'aside':
	      case 'blockquote':
	      case 'center':
	      case 'details':
	      case 'dialog':
	      case 'dir':
	      case 'div':
	      case 'dl':
	      case 'fieldset':
	      case 'figcaption':
	      case 'figure':
	      case 'footer':
	      case 'header':
	      case 'hgroup':
	      case 'main':
	      case 'menu':
	      case 'nav':
	      case 'ol':
	      case 'p':
	      case 'section':
	      case 'summary':
	      case 'ul':
	      case 'pre':
	      case 'listing':
	      case 'table':
	      case 'hr':
	      case 'xmp':
	      case 'h1':
	      case 'h2':
	      case 'h3':
	      case 'h4':
	      case 'h5':
	      case 'h6':
	        return ancestorInfo.pTagInButtonScope;
	
	      case 'form':
	        return ancestorInfo.formTag || ancestorInfo.pTagInButtonScope;
	
	      case 'li':
	        return ancestorInfo.listItemTagAutoclosing;
	
	      case 'dd':
	      case 'dt':
	        return ancestorInfo.dlItemTagAutoclosing;
	
	      case 'button':
	        return ancestorInfo.buttonTagInScope;
	
	      case 'a':
	        // Spec says something about storing a list of markers, but it sounds
	        // equivalent to this check.
	        return ancestorInfo.aTagInScope;
	
	      case 'nobr':
	        return ancestorInfo.nobrTagInScope;
	    }
	
	    return null;
	  };
	
	  /**
	   * Given a ReactCompositeComponent instance, return a list of its recursive
	   * owners, starting at the root and ending with the instance itself.
	   */
	  var findOwnerStack = function (instance) {
	    if (!instance) {
	      return [];
	    }
	
	    var stack = [];
	    do {
	      stack.push(instance);
	    } while (instance = instance._currentElement._owner);
	    stack.reverse();
	    return stack;
	  };
	
	  var didWarn = {};
	
	  validateDOMNesting = function (childTag, childText, childInstance, ancestorInfo) {
	    ancestorInfo = ancestorInfo || emptyAncestorInfo;
	    var parentInfo = ancestorInfo.current;
	    var parentTag = parentInfo && parentInfo.tag;
	
	    if (childText != null) {
	      process.env.NODE_ENV !== 'production' ? warning(childTag == null, 'validateDOMNesting: when childText is passed, childTag should be null') : void 0;
	      childTag = '#text';
	    }
	
	    var invalidParent = isTagValidWithParent(childTag, parentTag) ? null : parentInfo;
	    var invalidAncestor = invalidParent ? null : findInvalidAncestorForTag(childTag, ancestorInfo);
	    var problematic = invalidParent || invalidAncestor;
	
	    if (problematic) {
	      var ancestorTag = problematic.tag;
	      var ancestorInstance = problematic.instance;
	
	      var childOwner = childInstance && childInstance._currentElement._owner;
	      var ancestorOwner = ancestorInstance && ancestorInstance._currentElement._owner;
	
	      var childOwners = findOwnerStack(childOwner);
	      var ancestorOwners = findOwnerStack(ancestorOwner);
	
	      var minStackLen = Math.min(childOwners.length, ancestorOwners.length);
	      var i;
	
	      var deepestCommon = -1;
	      for (i = 0; i < minStackLen; i++) {
	        if (childOwners[i] === ancestorOwners[i]) {
	          deepestCommon = i;
	        } else {
	          break;
	        }
	      }
	
	      var UNKNOWN = '(unknown)';
	      var childOwnerNames = childOwners.slice(deepestCommon + 1).map(function (inst) {
	        return inst.getName() || UNKNOWN;
	      });
	      var ancestorOwnerNames = ancestorOwners.slice(deepestCommon + 1).map(function (inst) {
	        return inst.getName() || UNKNOWN;
	      });
	      var ownerInfo = [].concat(
	      // If the parent and child instances have a common owner ancestor, start
	      // with that -- otherwise we just start with the parent's owners.
	      deepestCommon !== -1 ? childOwners[deepestCommon].getName() || UNKNOWN : [], ancestorOwnerNames, ancestorTag,
	      // If we're warning about an invalid (non-parent) ancestry, add '...'
	      invalidAncestor ? ['...'] : [], childOwnerNames, childTag).join(' > ');
	
	      var warnKey = !!invalidParent + '|' + childTag + '|' + ancestorTag + '|' + ownerInfo;
	      if (didWarn[warnKey]) {
	        return;
	      }
	      didWarn[warnKey] = true;
	
	      var tagDisplayName = childTag;
	      var whitespaceInfo = '';
	      if (childTag === '#text') {
	        if (/\S/.test(childText)) {
	          tagDisplayName = 'Text nodes';
	        } else {
	          tagDisplayName = 'Whitespace text nodes';
	          whitespaceInfo = " Make sure you don't have any extra whitespace between tags on " + 'each line of your source code.';
	        }
	      } else {
	        tagDisplayName = '<' + childTag + '>';
	      }
	
	      if (invalidParent) {
	        var info = '';
	        if (ancestorTag === 'table' && childTag === 'tr') {
	          info += ' Add a <tbody> to your code to match the DOM tree generated by ' + 'the browser.';
	        }
	        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): %s cannot appear as a child of <%s>.%s ' + 'See %s.%s', tagDisplayName, ancestorTag, whitespaceInfo, ownerInfo, info) : void 0;
	      } else {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): %s cannot appear as a descendant of ' + '<%s>. See %s.', tagDisplayName, ancestorTag, ownerInfo) : void 0;
	      }
	    }
	  };
	
	  validateDOMNesting.updatedAncestorInfo = updatedAncestorInfo;
	
	  // For testing
	  validateDOMNesting.isTagValidInContext = function (tag, ancestorInfo) {
	    ancestorInfo = ancestorInfo || emptyAncestorInfo;
	    var parentInfo = ancestorInfo.current;
	    var parentTag = parentInfo && parentInfo.tag;
	    return isTagValidWithParent(tag, parentTag) && !findInvalidAncestorForTag(tag, ancestorInfo);
	  };
	}
	
	module.exports = validateDOMNesting;

/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var util_1 = __webpack_require__(4);
	var parser_1 = __webpack_require__(152);
	var Path_1 = __webpack_require__(8);
	var Reference_1 = __webpack_require__(90);
	var Repo_1 = __webpack_require__(65);
	var RepoManager_1 = __webpack_require__(91);
	var util_2 = __webpack_require__(1);
	var validation_1 = __webpack_require__(34);
	/**
	 * Class representing a firebase database.
	 * @implements {FirebaseService}
	 */
	var Database = /** @class */ (function () {
	    /**
	     * The constructor should not be called by users of our public API.
	     * @param {!Repo} repo_
	     */
	    function Database(repo_) {
	        this.repo_ = repo_;
	        if (!(repo_ instanceof Repo_1.Repo)) {
	            util_1.fatal("Don't call new Database() directly - please use firebase.database().");
	        }
	        /** @type {Reference} */
	        this.root_ = new Reference_1.Reference(repo_, Path_1.Path.Empty);
	        this.INTERNAL = new DatabaseInternals(this);
	    }
	    Object.defineProperty(Database.prototype, "app", {
	        get: function () {
	            return this.repo_.app;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    /**
	     * Returns a reference to the root or the path specified in opt_pathString.
	     * @param {string=} pathString
	     * @return {!Reference} Firebase reference.
	     */
	    Database.prototype.ref = function (pathString) {
	        this.checkDeleted_('ref');
	        util_2.validateArgCount('database.ref', 0, 1, arguments.length);
	        return pathString !== undefined ? this.root_.child(pathString) : this.root_;
	    };
	    /**
	     * Returns a reference to the root or the path specified in url.
	     * We throw a exception if the url is not in the same domain as the
	     * current repo.
	     * @param {string} url
	     * @return {!Reference} Firebase reference.
	     */
	    Database.prototype.refFromURL = function (url) {
	        /** @const {string} */
	        var apiName = 'database.refFromURL';
	        this.checkDeleted_(apiName);
	        util_2.validateArgCount(apiName, 1, 1, arguments.length);
	        var parsedURL = parser_1.parseRepoInfo(url);
	        validation_1.validateUrl(apiName, 1, parsedURL);
	        var repoInfo = parsedURL.repoInfo;
	        if (repoInfo.host !== this.repo_.repoInfo_.host) {
	            util_1.fatal(apiName +
	                ': Host name does not match the current database: ' +
	                '(found ' +
	                repoInfo.host +
	                ' but expected ' +
	                this.repo_.repoInfo_.host +
	                ')');
	        }
	        return this.ref(parsedURL.path.toString());
	    };
	    /**
	     * @param {string} apiName
	     */
	    Database.prototype.checkDeleted_ = function (apiName) {
	        if (this.repo_ === null) {
	            util_1.fatal('Cannot call ' + apiName + ' on a deleted database.');
	        }
	    };
	    // Make individual repo go offline.
	    Database.prototype.goOffline = function () {
	        util_2.validateArgCount('database.goOffline', 0, 0, arguments.length);
	        this.checkDeleted_('goOffline');
	        this.repo_.interrupt();
	    };
	    Database.prototype.goOnline = function () {
	        util_2.validateArgCount('database.goOnline', 0, 0, arguments.length);
	        this.checkDeleted_('goOnline');
	        this.repo_.resume();
	    };
	    Database.ServerValue = {
	        TIMESTAMP: {
	            '.sv': 'timestamp'
	        }
	    };
	    return Database;
	}());
	exports.Database = Database;
	var DatabaseInternals = /** @class */ (function () {
	    /** @param {!Database} database */
	    function DatabaseInternals(database) {
	        this.database = database;
	    }
	    /** @return {Promise<void>} */
	    DatabaseInternals.prototype.delete = function () {
	        this.database.checkDeleted_('delete');
	        RepoManager_1.RepoManager.getInstance().deleteRepo(this.database.repo_);
	        this.database.repo_ = null;
	        this.database.root_ = null;
	        this.database.INTERNAL = null;
	        this.database = null;
	        return Promise.resolve();
	    };
	    return DatabaseInternals;
	}());
	exports.DatabaseInternals = DatabaseInternals;
	
	//# sourceMappingURL=Database.js.map


/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var util_1 = __webpack_require__(1);
	var KeyIndex_1 = __webpack_require__(49);
	var PriorityIndex_1 = __webpack_require__(15);
	var ValueIndex_1 = __webpack_require__(146);
	var PathIndex_1 = __webpack_require__(145);
	var util_2 = __webpack_require__(4);
	var Path_1 = __webpack_require__(8);
	var validation_1 = __webpack_require__(34);
	var util_3 = __webpack_require__(1);
	var EventRegistration_1 = __webpack_require__(251);
	var util_4 = __webpack_require__(1);
	var __referenceConstructor;
	/**
	 * A Query represents a filter to be applied to a firebase location.  This object purely represents the
	 * query expression (and exposes our public API to build the query).  The actual query logic is in ViewBase.js.
	 *
	 * Since every Firebase reference is a query, Firebase inherits from this object.
	 */
	var Query = /** @class */ (function () {
	    function Query(repo, path, queryParams_, orderByCalled_) {
	        this.repo = repo;
	        this.path = path;
	        this.queryParams_ = queryParams_;
	        this.orderByCalled_ = orderByCalled_;
	    }
	    Object.defineProperty(Query, "__referenceConstructor", {
	        get: function () {
	            util_1.assert(__referenceConstructor, 'Reference.ts has not been loaded');
	            return __referenceConstructor;
	        },
	        set: function (val) {
	            __referenceConstructor = val;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    /**
	     * Validates start/end values for queries.
	     * @param {!QueryParams} params
	     * @private
	     */
	    Query.validateQueryEndpoints_ = function (params) {
	        var startNode = null;
	        var endNode = null;
	        if (params.hasStart()) {
	            startNode = params.getIndexStartValue();
	        }
	        if (params.hasEnd()) {
	            endNode = params.getIndexEndValue();
	        }
	        if (params.getIndex() === KeyIndex_1.KEY_INDEX) {
	            var tooManyArgsError = 'Query: When ordering by key, you may only pass one argument to ' +
	                'startAt(), endAt(), or equalTo().';
	            var wrongArgTypeError = 'Query: When ordering by key, the argument passed to startAt(), endAt(),' +
	                'or equalTo() must be a string.';
	            if (params.hasStart()) {
	                var startName = params.getIndexStartName();
	                if (startName != util_2.MIN_NAME) {
	                    throw new Error(tooManyArgsError);
	                }
	                else if (typeof startNode !== 'string') {
	                    throw new Error(wrongArgTypeError);
	                }
	            }
	            if (params.hasEnd()) {
	                var endName = params.getIndexEndName();
	                if (endName != util_2.MAX_NAME) {
	                    throw new Error(tooManyArgsError);
	                }
	                else if (typeof endNode !== 'string') {
	                    throw new Error(wrongArgTypeError);
	                }
	            }
	        }
	        else if (params.getIndex() === PriorityIndex_1.PRIORITY_INDEX) {
	            if ((startNode != null && !validation_1.isValidPriority(startNode)) ||
	                (endNode != null && !validation_1.isValidPriority(endNode))) {
	                throw new Error('Query: When ordering by priority, the first argument passed to startAt(), ' +
	                    'endAt(), or equalTo() must be a valid priority value (null, a number, or a string).');
	            }
	        }
	        else {
	            util_1.assert(params.getIndex() instanceof PathIndex_1.PathIndex ||
	                params.getIndex() === ValueIndex_1.VALUE_INDEX, 'unknown index type.');
	            if ((startNode != null && typeof startNode === 'object') ||
	                (endNode != null && typeof endNode === 'object')) {
	                throw new Error('Query: First argument passed to startAt(), endAt(), or equalTo() cannot be ' +
	                    'an object.');
	            }
	        }
	    };
	    /**
	     * Validates that limit* has been called with the correct combination of parameters
	     * @param {!QueryParams} params
	     * @private
	     */
	    Query.validateLimit_ = function (params) {
	        if (params.hasStart() &&
	            params.hasEnd() &&
	            params.hasLimit() &&
	            !params.hasAnchoredLimit()) {
	            throw new Error("Query: Can't combine startAt(), endAt(), and limit(). Use limitToFirst() or limitToLast() instead.");
	        }
	    };
	    /**
	     * Validates that no other order by call has been made
	     * @param {!string} fnName
	     * @private
	     */
	    Query.prototype.validateNoPreviousOrderByCall_ = function (fnName) {
	        if (this.orderByCalled_ === true) {
	            throw new Error(fnName + ": You can't combine multiple orderBy calls.");
	        }
	    };
	    /**
	     * @return {!QueryParams}
	     */
	    Query.prototype.getQueryParams = function () {
	        return this.queryParams_;
	    };
	    /**
	     * @return {!Reference}
	     */
	    Query.prototype.getRef = function () {
	        util_3.validateArgCount('Query.ref', 0, 0, arguments.length);
	        // This is a slight hack. We cannot goog.require('fb.api.Firebase'), since Firebase requires fb.api.Query.
	        // However, we will always export 'Firebase' to the global namespace, so it's guaranteed to exist by the time this
	        // method gets called.
	        return new Query.__referenceConstructor(this.repo, this.path);
	    };
	    /**
	     * @param {!string} eventType
	     * @param {!function(DataSnapshot, string=)} callback
	     * @param {(function(Error)|Object)=} cancelCallbackOrContext
	     * @param {Object=} context
	     * @return {!function(DataSnapshot, string=)}
	     */
	    Query.prototype.on = function (eventType, callback, cancelCallbackOrContext, context) {
	        util_3.validateArgCount('Query.on', 2, 4, arguments.length);
	        validation_1.validateEventType('Query.on', 1, eventType, false);
	        util_3.validateCallback('Query.on', 2, callback, false);
	        var ret = Query.getCancelAndContextArgs_('Query.on', cancelCallbackOrContext, context);
	        if (eventType === 'value') {
	            this.onValueEvent(callback, ret.cancel, ret.context);
	        }
	        else {
	            var callbacks = {};
	            callbacks[eventType] = callback;
	            this.onChildEvent(callbacks, ret.cancel, ret.context);
	        }
	        return callback;
	    };
	    /**
	     * @param {!function(!DataSnapshot)} callback
	     * @param {?function(Error)} cancelCallback
	     * @param {?Object} context
	     * @protected
	     */
	    Query.prototype.onValueEvent = function (callback, cancelCallback, context) {
	        var container = new EventRegistration_1.ValueEventRegistration(callback, cancelCallback || null, context || null);
	        this.repo.addEventCallbackForQuery(this, container);
	    };
	    /**
	     * @param {!Object.<string, !function(!DataSnapshot, ?string)>} callbacks
	     * @param {?function(Error)} cancelCallback
	     * @param {?Object} context
	     * @protected
	     */
	    Query.prototype.onChildEvent = function (callbacks, cancelCallback, context) {
	        var container = new EventRegistration_1.ChildEventRegistration(callbacks, cancelCallback, context);
	        this.repo.addEventCallbackForQuery(this, container);
	    };
	    /**
	     * @param {string=} eventType
	     * @param {(function(!DataSnapshot, ?string=))=} callback
	     * @param {Object=} context
	     */
	    Query.prototype.off = function (eventType, callback, context) {
	        util_3.validateArgCount('Query.off', 0, 3, arguments.length);
	        validation_1.validateEventType('Query.off', 1, eventType, true);
	        util_3.validateCallback('Query.off', 2, callback, true);
	        util_3.validateContextObject('Query.off', 3, context, true);
	        var container = null;
	        var callbacks = null;
	        if (eventType === 'value') {
	            var valueCallback = callback || null;
	            container = new EventRegistration_1.ValueEventRegistration(valueCallback, null, context || null);
	        }
	        else if (eventType) {
	            if (callback) {
	                callbacks = {};
	                callbacks[eventType] = callback;
	            }
	            container = new EventRegistration_1.ChildEventRegistration(callbacks, null, context || null);
	        }
	        this.repo.removeEventCallbackForQuery(this, container);
	    };
	    /**
	     * Attaches a listener, waits for the first event, and then removes the listener
	     * @param {!string} eventType
	     * @param {!function(!DataSnapshot, string=)} userCallback
	     * @param cancelOrContext
	     * @param context
	     * @return {!firebase.Promise}
	     */
	    Query.prototype.once = function (eventType, userCallback, cancelOrContext, context) {
	        var _this = this;
	        util_3.validateArgCount('Query.once', 1, 4, arguments.length);
	        validation_1.validateEventType('Query.once', 1, eventType, false);
	        util_3.validateCallback('Query.once', 2, userCallback, true);
	        var ret = Query.getCancelAndContextArgs_('Query.once', cancelOrContext, context);
	        // TODO: Implement this more efficiently (in particular, use 'get' wire protocol for 'value' event)
	        // TODO: consider actually wiring the callbacks into the promise. We cannot do this without a breaking change
	        // because the API currently expects callbacks will be called synchronously if the data is cached, but this is
	        // against the Promise specification.
	        var firstCall = true;
	        var deferred = new util_4.Deferred();
	        // A dummy error handler in case a user wasn't expecting promises
	        deferred.promise.catch(function () { });
	        var onceCallback = function (snapshot) {
	            // NOTE: Even though we unsubscribe, we may get called multiple times if a single action (e.g. set() with JSON)
	            // triggers multiple events (e.g. child_added or child_changed).
	            if (firstCall) {
	                firstCall = false;
	                _this.off(eventType, onceCallback);
	                if (userCallback) {
	                    userCallback.bind(ret.context)(snapshot);
	                }
	                deferred.resolve(snapshot);
	            }
	        };
	        this.on(eventType, onceCallback, 
	        /*cancel=*/ function (err) {
	            _this.off(eventType, onceCallback);
	            if (ret.cancel)
	                ret.cancel.bind(ret.context)(err);
	            deferred.reject(err);
	        });
	        return deferred.promise;
	    };
	    /**
	     * Set a limit and anchor it to the start of the window.
	     * @param {!number} limit
	     * @return {!Query}
	     */
	    Query.prototype.limitToFirst = function (limit) {
	        util_3.validateArgCount('Query.limitToFirst', 1, 1, arguments.length);
	        if (typeof limit !== 'number' ||
	            Math.floor(limit) !== limit ||
	            limit <= 0) {
	            throw new Error('Query.limitToFirst: First argument must be a positive integer.');
	        }
	        if (this.queryParams_.hasLimit()) {
	            throw new Error('Query.limitToFirst: Limit was already set (by another call to limit, ' +
	                'limitToFirst, or limitToLast).');
	        }
	        return new Query(this.repo, this.path, this.queryParams_.limitToFirst(limit), this.orderByCalled_);
	    };
	    /**
	     * Set a limit and anchor it to the end of the window.
	     * @param {!number} limit
	     * @return {!Query}
	     */
	    Query.prototype.limitToLast = function (limit) {
	        util_3.validateArgCount('Query.limitToLast', 1, 1, arguments.length);
	        if (typeof limit !== 'number' ||
	            Math.floor(limit) !== limit ||
	            limit <= 0) {
	            throw new Error('Query.limitToLast: First argument must be a positive integer.');
	        }
	        if (this.queryParams_.hasLimit()) {
	            throw new Error('Query.limitToLast: Limit was already set (by another call to limit, ' +
	                'limitToFirst, or limitToLast).');
	        }
	        return new Query(this.repo, this.path, this.queryParams_.limitToLast(limit), this.orderByCalled_);
	    };
	    /**
	     * Given a child path, return a new query ordered by the specified grandchild path.
	     * @param {!string} path
	     * @return {!Query}
	     */
	    Query.prototype.orderByChild = function (path) {
	        util_3.validateArgCount('Query.orderByChild', 1, 1, arguments.length);
	        if (path === '$key') {
	            throw new Error('Query.orderByChild: "$key" is invalid.  Use Query.orderByKey() instead.');
	        }
	        else if (path === '$priority') {
	            throw new Error('Query.orderByChild: "$priority" is invalid.  Use Query.orderByPriority() instead.');
	        }
	        else if (path === '$value') {
	            throw new Error('Query.orderByChild: "$value" is invalid.  Use Query.orderByValue() instead.');
	        }
	        validation_1.validatePathString('Query.orderByChild', 1, path, false);
	        this.validateNoPreviousOrderByCall_('Query.orderByChild');
	        var parsedPath = new Path_1.Path(path);
	        if (parsedPath.isEmpty()) {
	            throw new Error('Query.orderByChild: cannot pass in empty path.  Use Query.orderByValue() instead.');
	        }
	        var index = new PathIndex_1.PathIndex(parsedPath);
	        var newParams = this.queryParams_.orderBy(index);
	        Query.validateQueryEndpoints_(newParams);
	        return new Query(this.repo, this.path, newParams, /*orderByCalled=*/ true);
	    };
	    /**
	     * Return a new query ordered by the KeyIndex
	     * @return {!Query}
	     */
	    Query.prototype.orderByKey = function () {
	        util_3.validateArgCount('Query.orderByKey', 0, 0, arguments.length);
	        this.validateNoPreviousOrderByCall_('Query.orderByKey');
	        var newParams = this.queryParams_.orderBy(KeyIndex_1.KEY_INDEX);
	        Query.validateQueryEndpoints_(newParams);
	        return new Query(this.repo, this.path, newParams, /*orderByCalled=*/ true);
	    };
	    /**
	     * Return a new query ordered by the PriorityIndex
	     * @return {!Query}
	     */
	    Query.prototype.orderByPriority = function () {
	        util_3.validateArgCount('Query.orderByPriority', 0, 0, arguments.length);
	        this.validateNoPreviousOrderByCall_('Query.orderByPriority');
	        var newParams = this.queryParams_.orderBy(PriorityIndex_1.PRIORITY_INDEX);
	        Query.validateQueryEndpoints_(newParams);
	        return new Query(this.repo, this.path, newParams, /*orderByCalled=*/ true);
	    };
	    /**
	     * Return a new query ordered by the ValueIndex
	     * @return {!Query}
	     */
	    Query.prototype.orderByValue = function () {
	        util_3.validateArgCount('Query.orderByValue', 0, 0, arguments.length);
	        this.validateNoPreviousOrderByCall_('Query.orderByValue');
	        var newParams = this.queryParams_.orderBy(ValueIndex_1.VALUE_INDEX);
	        Query.validateQueryEndpoints_(newParams);
	        return new Query(this.repo, this.path, newParams, /*orderByCalled=*/ true);
	    };
	    /**
	     * @param {number|string|boolean|null} value
	     * @param {?string=} name
	     * @return {!Query}
	     */
	    Query.prototype.startAt = function (value, name) {
	        if (value === void 0) { value = null; }
	        util_3.validateArgCount('Query.startAt', 0, 2, arguments.length);
	        validation_1.validateFirebaseDataArg('Query.startAt', 1, value, this.path, true);
	        validation_1.validateKey('Query.startAt', 2, name, true);
	        var newParams = this.queryParams_.startAt(value, name);
	        Query.validateLimit_(newParams);
	        Query.validateQueryEndpoints_(newParams);
	        if (this.queryParams_.hasStart()) {
	            throw new Error('Query.startAt: Starting point was already set (by another call to startAt ' +
	                'or equalTo).');
	        }
	        // Calling with no params tells us to start at the beginning.
	        if (value === undefined) {
	            value = null;
	            name = null;
	        }
	        return new Query(this.repo, this.path, newParams, this.orderByCalled_);
	    };
	    /**
	     * @param {number|string|boolean|null} value
	     * @param {?string=} name
	     * @return {!Query}
	     */
	    Query.prototype.endAt = function (value, name) {
	        if (value === void 0) { value = null; }
	        util_3.validateArgCount('Query.endAt', 0, 2, arguments.length);
	        validation_1.validateFirebaseDataArg('Query.endAt', 1, value, this.path, true);
	        validation_1.validateKey('Query.endAt', 2, name, true);
	        var newParams = this.queryParams_.endAt(value, name);
	        Query.validateLimit_(newParams);
	        Query.validateQueryEndpoints_(newParams);
	        if (this.queryParams_.hasEnd()) {
	            throw new Error('Query.endAt: Ending point was already set (by another call to endAt or ' +
	                'equalTo).');
	        }
	        return new Query(this.repo, this.path, newParams, this.orderByCalled_);
	    };
	    /**
	     * Load the selection of children with exactly the specified value, and, optionally,
	     * the specified name.
	     * @param {number|string|boolean|null} value
	     * @param {string=} name
	     * @return {!Query}
	     */
	    Query.prototype.equalTo = function (value, name) {
	        util_3.validateArgCount('Query.equalTo', 1, 2, arguments.length);
	        validation_1.validateFirebaseDataArg('Query.equalTo', 1, value, this.path, false);
	        validation_1.validateKey('Query.equalTo', 2, name, true);
	        if (this.queryParams_.hasStart()) {
	            throw new Error('Query.equalTo: Starting point was already set (by another call to startAt or ' +
	                'equalTo).');
	        }
	        if (this.queryParams_.hasEnd()) {
	            throw new Error('Query.equalTo: Ending point was already set (by another call to endAt or ' +
	                'equalTo).');
	        }
	        return this.startAt(value, name).endAt(value, name);
	    };
	    /**
	     * @return {!string} URL for this location.
	     */
	    Query.prototype.toString = function () {
	        util_3.validateArgCount('Query.toString', 0, 0, arguments.length);
	        return this.repo.toString() + this.path.toUrlEncodedString();
	    };
	    // Do not create public documentation. This is intended to make JSON serialization work but is otherwise unnecessary
	    // for end-users.
	    Query.prototype.toJSON = function () {
	        // An optional spacer argument is unnecessary for a string.
	        util_3.validateArgCount('Query.toJSON', 0, 1, arguments.length);
	        return this.toString();
	    };
	    /**
	     * An object representation of the query parameters used by this Query.
	     * @return {!Object}
	     */
	    Query.prototype.queryObject = function () {
	        return this.queryParams_.getQueryObject();
	    };
	    /**
	     * @return {!string}
	     */
	    Query.prototype.queryIdentifier = function () {
	        var obj = this.queryObject();
	        var id = util_2.ObjectToUniqueKey(obj);
	        return id === '{}' ? 'default' : id;
	    };
	    /**
	     * Return true if this query and the provided query are equivalent; otherwise, return false.
	     * @param {Query} other
	     * @return {boolean}
	     */
	    Query.prototype.isEqual = function (other) {
	        util_3.validateArgCount('Query.isEqual', 1, 1, arguments.length);
	        if (!(other instanceof Query)) {
	            var error = 'Query.isEqual failed: First argument must be an instance of firebase.database.Query.';
	            throw new Error(error);
	        }
	        var sameRepo = this.repo === other.repo;
	        var samePath = this.path.equals(other.path);
	        var sameQueryIdentifier = this.queryIdentifier() === other.queryIdentifier();
	        return sameRepo && samePath && sameQueryIdentifier;
	    };
	    /**
	     * Helper used by .on and .once to extract the context and or cancel arguments.
	     * @param {!string} fnName The function name (on or once)
	     * @param {(function(Error)|Object)=} cancelOrContext
	     * @param {Object=} context
	     * @return {{cancel: ?function(Error), context: ?Object}}
	     * @private
	     */
	    Query.getCancelAndContextArgs_ = function (fnName, cancelOrContext, context) {
	        var ret = { cancel: null, context: null };
	        if (cancelOrContext && context) {
	            ret.cancel = cancelOrContext;
	            util_3.validateCallback(fnName, 3, ret.cancel, true);
	            ret.context = context;
	            util_3.validateContextObject(fnName, 4, ret.context, true);
	        }
	        else if (cancelOrContext) {
	            // we have either a cancel callback or a context.
	            if (typeof cancelOrContext === 'object' && cancelOrContext !== null) {
	                // it's a context!
	                ret.context = cancelOrContext;
	            }
	            else if (typeof cancelOrContext === 'function') {
	                ret.cancel = cancelOrContext;
	            }
	            else {
	                throw new Error(util_3.errorPrefix(fnName, 3, true) +
	                    ' must either be a cancel callback or a context object.');
	            }
	        }
	        return ret;
	    };
	    Object.defineProperty(Query.prototype, "ref", {
	        get: function () {
	            return this.getRef();
	        },
	        enumerable: true,
	        configurable: true
	    });
	    return Query;
	}());
	exports.Query = Query;
	
	//# sourceMappingURL=Query.js.map


/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var util_1 = __webpack_require__(1);
	var validation_1 = __webpack_require__(34);
	var util_2 = __webpack_require__(4);
	var util_3 = __webpack_require__(1);
	/**
	 * @constructor
	 */
	var OnDisconnect = /** @class */ (function () {
	    /**
	     * @param {!Repo} repo_
	     * @param {!Path} path_
	     */
	    function OnDisconnect(repo_, path_) {
	        this.repo_ = repo_;
	        this.path_ = path_;
	    }
	    /**
	     * @param {function(?Error)=} onComplete
	     * @return {!firebase.Promise}
	     */
	    OnDisconnect.prototype.cancel = function (onComplete) {
	        util_1.validateArgCount('OnDisconnect.cancel', 0, 1, arguments.length);
	        util_1.validateCallback('OnDisconnect.cancel', 1, onComplete, true);
	        var deferred = new util_3.Deferred();
	        this.repo_.onDisconnectCancel(this.path_, deferred.wrapCallback(onComplete));
	        return deferred.promise;
	    };
	    /**
	     * @param {function(?Error)=} onComplete
	     * @return {!firebase.Promise}
	     */
	    OnDisconnect.prototype.remove = function (onComplete) {
	        util_1.validateArgCount('OnDisconnect.remove', 0, 1, arguments.length);
	        validation_1.validateWritablePath('OnDisconnect.remove', this.path_);
	        util_1.validateCallback('OnDisconnect.remove', 1, onComplete, true);
	        var deferred = new util_3.Deferred();
	        this.repo_.onDisconnectSet(this.path_, null, deferred.wrapCallback(onComplete));
	        return deferred.promise;
	    };
	    /**
	     * @param {*} value
	     * @param {function(?Error)=} onComplete
	     * @return {!firebase.Promise}
	     */
	    OnDisconnect.prototype.set = function (value, onComplete) {
	        util_1.validateArgCount('OnDisconnect.set', 1, 2, arguments.length);
	        validation_1.validateWritablePath('OnDisconnect.set', this.path_);
	        validation_1.validateFirebaseDataArg('OnDisconnect.set', 1, value, this.path_, false);
	        util_1.validateCallback('OnDisconnect.set', 2, onComplete, true);
	        var deferred = new util_3.Deferred();
	        this.repo_.onDisconnectSet(this.path_, value, deferred.wrapCallback(onComplete));
	        return deferred.promise;
	    };
	    /**
	     * @param {*} value
	     * @param {number|string|null} priority
	     * @param {function(?Error)=} onComplete
	     * @return {!firebase.Promise}
	     */
	    OnDisconnect.prototype.setWithPriority = function (value, priority, onComplete) {
	        util_1.validateArgCount('OnDisconnect.setWithPriority', 2, 3, arguments.length);
	        validation_1.validateWritablePath('OnDisconnect.setWithPriority', this.path_);
	        validation_1.validateFirebaseDataArg('OnDisconnect.setWithPriority', 1, value, this.path_, false);
	        validation_1.validatePriority('OnDisconnect.setWithPriority', 2, priority, false);
	        util_1.validateCallback('OnDisconnect.setWithPriority', 3, onComplete, true);
	        var deferred = new util_3.Deferred();
	        this.repo_.onDisconnectSetWithPriority(this.path_, value, priority, deferred.wrapCallback(onComplete));
	        return deferred.promise;
	    };
	    /**
	     * @param {!Object} objectToMerge
	     * @param {function(?Error)=} onComplete
	     * @return {!firebase.Promise}
	     */
	    OnDisconnect.prototype.update = function (objectToMerge, onComplete) {
	        util_1.validateArgCount('OnDisconnect.update', 1, 2, arguments.length);
	        validation_1.validateWritablePath('OnDisconnect.update', this.path_);
	        if (Array.isArray(objectToMerge)) {
	            var newObjectToMerge = {};
	            for (var i = 0; i < objectToMerge.length; ++i) {
	                newObjectToMerge['' + i] = objectToMerge[i];
	            }
	            objectToMerge = newObjectToMerge;
	            util_2.warn('Passing an Array to firebase.database.onDisconnect().update() is deprecated. Use set() if you want to overwrite the ' +
	                'existing data, or an Object with integer keys if you really do want to only update some of the children.');
	        }
	        validation_1.validateFirebaseMergeDataArg('OnDisconnect.update', 1, objectToMerge, this.path_, false);
	        util_1.validateCallback('OnDisconnect.update', 2, onComplete, true);
	        var deferred = new util_3.Deferred();
	        this.repo_.onDisconnectUpdate(this.path_, objectToMerge, deferred.wrapCallback(onComplete));
	        return deferred.promise;
	    };
	    return OnDisconnect;
	}());
	exports.OnDisconnect = OnDisconnect;
	
	//# sourceMappingURL=onDisconnect.js.map


/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var app_1 = __webpack_require__(26);
	var util_1 = __webpack_require__(1);
	var util_2 = __webpack_require__(1);
	var util_3 = __webpack_require__(1);
	var util_4 = __webpack_require__(4);
	var Path_1 = __webpack_require__(8);
	var VisibilityMonitor_1 = __webpack_require__(245);
	var OnlineMonitor_1 = __webpack_require__(243);
	var util_5 = __webpack_require__(1);
	var Connection_1 = __webpack_require__(156);
	var util_6 = __webpack_require__(1);
	var util_7 = __webpack_require__(1);
	var ServerActions_1 = __webpack_require__(138);
	var RECONNECT_MIN_DELAY = 1000;
	var RECONNECT_MAX_DELAY_DEFAULT = 60 * 5 * 1000; // 5 minutes in milliseconds (Case: 1858)
	var RECONNECT_MAX_DELAY_FOR_ADMINS = 30 * 1000; // 30 seconds for admin clients (likely to be a backend server)
	var RECONNECT_DELAY_MULTIPLIER = 1.3;
	var RECONNECT_DELAY_RESET_TIMEOUT = 30000; // Reset delay back to MIN_DELAY after being connected for 30sec.
	var SERVER_KILL_INTERRUPT_REASON = 'server_kill';
	// If auth fails repeatedly, we'll assume something is wrong and log a warning / back off.
	var INVALID_AUTH_TOKEN_THRESHOLD = 3;
	/**
	 * Firebase connection.  Abstracts wire protocol and handles reconnecting.
	 *
	 * NOTE: All JSON objects sent to the realtime connection must have property names enclosed
	 * in quotes to make sure the closure compiler does not minify them.
	 */
	var PersistentConnection = /** @class */ (function (_super) {
	    __extends(PersistentConnection, _super);
	    /**
	     * @implements {ServerActions}
	     * @param {!RepoInfo} repoInfo_ Data about the namespace we are connecting to
	     * @param {function(string, *, boolean, ?number)} onDataUpdate_ A callback for new data from the server
	     * @param onConnectStatus_
	     * @param onServerInfoUpdate_
	     * @param authTokenProvider_
	     * @param authOverride_
	     */
	    function PersistentConnection(repoInfo_, onDataUpdate_, onConnectStatus_, onServerInfoUpdate_, authTokenProvider_, authOverride_) {
	        var _this = _super.call(this) || this;
	        _this.repoInfo_ = repoInfo_;
	        _this.onDataUpdate_ = onDataUpdate_;
	        _this.onConnectStatus_ = onConnectStatus_;
	        _this.onServerInfoUpdate_ = onServerInfoUpdate_;
	        _this.authTokenProvider_ = authTokenProvider_;
	        _this.authOverride_ = authOverride_;
	        // Used for diagnostic logging.
	        _this.id = PersistentConnection.nextPersistentConnectionId_++;
	        _this.log_ = util_4.logWrapper('p:' + _this.id + ':');
	        /** @private {Object} */
	        _this.interruptReasons_ = {};
	        _this.listens_ = {};
	        _this.outstandingPuts_ = [];
	        _this.outstandingPutCount_ = 0;
	        _this.onDisconnectRequestQueue_ = [];
	        _this.connected_ = false;
	        _this.reconnectDelay_ = RECONNECT_MIN_DELAY;
	        _this.maxReconnectDelay_ = RECONNECT_MAX_DELAY_DEFAULT;
	        _this.securityDebugCallback_ = null;
	        _this.lastSessionId = null;
	        /** @private {number|null} */
	        _this.establishConnectionTimer_ = null;
	        /** @private {boolean} */
	        _this.visible_ = false;
	        // Before we get connected, we keep a queue of pending messages to send.
	        _this.requestCBHash_ = {};
	        _this.requestNumber_ = 0;
	        /** @private {?{
	         *   sendRequest(Object),
	         *   close()
	         * }} */
	        _this.realtime_ = null;
	        /** @private {string|null} */
	        _this.authToken_ = null;
	        _this.forceTokenRefresh_ = false;
	        _this.invalidAuthTokenCount_ = 0;
	        _this.firstConnection_ = true;
	        _this.lastConnectionAttemptTime_ = null;
	        _this.lastConnectionEstablishedTime_ = null;
	        if (authOverride_ && !util_7.isNodeSdk()) {
	            throw new Error('Auth override specified in options, but not supported on non Node.js platforms');
	        }
	        _this.scheduleConnect_(0);
	        VisibilityMonitor_1.VisibilityMonitor.getInstance().on('visible', _this.onVisible_, _this);
	        if (repoInfo_.host.indexOf('fblocal') === -1) {
	            OnlineMonitor_1.OnlineMonitor.getInstance().on('online', _this.onOnline_, _this);
	        }
	        return _this;
	    }
	    /**
	     * @param {!string} action
	     * @param {*} body
	     * @param {function(*)=} onResponse
	     * @protected
	     */
	    PersistentConnection.prototype.sendRequest = function (action, body, onResponse) {
	        var curReqNum = ++this.requestNumber_;
	        var msg = { r: curReqNum, a: action, b: body };
	        this.log_(util_2.stringify(msg));
	        util_3.assert(this.connected_, "sendRequest call when we're not connected not allowed.");
	        this.realtime_.sendRequest(msg);
	        if (onResponse) {
	            this.requestCBHash_[curReqNum] = onResponse;
	        }
	    };
	    /**
	     * @inheritDoc
	     */
	    PersistentConnection.prototype.listen = function (query, currentHashFn, tag, onComplete) {
	        var queryId = query.queryIdentifier();
	        var pathString = query.path.toString();
	        this.log_('Listen called for ' + pathString + ' ' + queryId);
	        this.listens_[pathString] = this.listens_[pathString] || {};
	        util_3.assert(query.getQueryParams().isDefault() ||
	            !query.getQueryParams().loadsAllData(), 'listen() called for non-default but complete query');
	        util_3.assert(!this.listens_[pathString][queryId], 'listen() called twice for same path/queryId.');
	        var listenSpec = {
	            onComplete: onComplete,
	            hashFn: currentHashFn,
	            query: query,
	            tag: tag
	        };
	        this.listens_[pathString][queryId] = listenSpec;
	        if (this.connected_) {
	            this.sendListen_(listenSpec);
	        }
	    };
	    /**
	     * @param {!{onComplete(),
	     *           hashFn():!string,
	     *           query: !Query,
	     *           tag: ?number}} listenSpec
	     * @private
	     */
	    PersistentConnection.prototype.sendListen_ = function (listenSpec) {
	        var _this = this;
	        var query = listenSpec.query;
	        var pathString = query.path.toString();
	        var queryId = query.queryIdentifier();
	        this.log_('Listen on ' + pathString + ' for ' + queryId);
	        var req = { /*path*/ p: pathString };
	        var action = 'q';
	        // Only bother to send query if it's non-default.
	        if (listenSpec.tag) {
	            req['q'] = query.queryObject();
	            req['t'] = listenSpec.tag;
	        }
	        req['h'] = listenSpec.hashFn();
	        this.sendRequest(action, req, function (message) {
	            var payload = message['d'];
	            var status = message['s'];
	            // print warnings in any case...
	            PersistentConnection.warnOnListenWarnings_(payload, query);
	            var currentListenSpec = _this.listens_[pathString] && _this.listens_[pathString][queryId];
	            // only trigger actions if the listen hasn't been removed and readded
	            if (currentListenSpec === listenSpec) {
	                _this.log_('listen response', message);
	                if (status !== 'ok') {
	                    _this.removeListen_(pathString, queryId);
	                }
	                if (listenSpec.onComplete) {
	                    listenSpec.onComplete(status, payload);
	                }
	            }
	        });
	    };
	    /**
	     * @param {*} payload
	     * @param {!Query} query
	     * @private
	     */
	    PersistentConnection.warnOnListenWarnings_ = function (payload, query) {
	        if (payload && typeof payload === 'object' && util_1.contains(payload, 'w')) {
	            var warnings = util_1.safeGet(payload, 'w');
	            if (Array.isArray(warnings) && ~warnings.indexOf('no_index')) {
	                var indexSpec = '".indexOn": "' +
	                    query
	                        .getQueryParams()
	                        .getIndex()
	                        .toString() +
	                    '"';
	                var indexPath = query.path.toString();
	                util_4.warn("Using an unspecified index. Your data will be downloaded and " +
	                    ("filtered on the client. Consider adding " + indexSpec + " at ") +
	                    (indexPath + " to your security rules for better performance."));
	            }
	        }
	    };
	    /**
	     * @inheritDoc
	     */
	    PersistentConnection.prototype.refreshAuthToken = function (token) {
	        this.authToken_ = token;
	        this.log_('Auth token refreshed');
	        if (this.authToken_) {
	            this.tryAuth();
	        }
	        else {
	            //If we're connected we want to let the server know to unauthenticate us. If we're not connected, simply delete
	            //the credential so we dont become authenticated next time we connect.
	            if (this.connected_) {
	                this.sendRequest('unauth', {}, function () { });
	            }
	        }
	        this.reduceReconnectDelayIfAdminCredential_(token);
	    };
	    /**
	     * @param {!string} credential
	     * @private
	     */
	    PersistentConnection.prototype.reduceReconnectDelayIfAdminCredential_ = function (credential) {
	        // NOTE: This isn't intended to be bulletproof (a malicious developer can always just modify the client).
	        // Additionally, we don't bother resetting the max delay back to the default if auth fails / expires.
	        var isFirebaseSecret = credential && credential.length === 40;
	        if (isFirebaseSecret || util_5.isAdmin(credential)) {
	            this.log_('Admin auth credential detected.  Reducing max reconnect time.');
	            this.maxReconnectDelay_ = RECONNECT_MAX_DELAY_FOR_ADMINS;
	        }
	    };
	    /**
	     * Attempts to authenticate with the given credentials. If the authentication attempt fails, it's triggered like
	     * a auth revoked (the connection is closed).
	     */
	    PersistentConnection.prototype.tryAuth = function () {
	        var _this = this;
	        if (this.connected_ && this.authToken_) {
	            var token_1 = this.authToken_;
	            var authMethod = util_5.isValidFormat(token_1) ? 'auth' : 'gauth';
	            var requestData = { cred: token_1 };
	            if (this.authOverride_ === null) {
	                requestData['noauth'] = true;
	            }
	            else if (typeof this.authOverride_ === 'object') {
	                requestData['authvar'] = this.authOverride_;
	            }
	            this.sendRequest(authMethod, requestData, function (res) {
	                var status = res['s'];
	                var data = res['d'] || 'error';
	                if (_this.authToken_ === token_1) {
	                    if (status === 'ok') {
	                        _this.invalidAuthTokenCount_ = 0;
	                    }
	                    else {
	                        // Triggers reconnect and force refresh for auth token
	                        _this.onAuthRevoked_(status, data);
	                    }
	                }
	            });
	        }
	    };
	    /**
	     * @inheritDoc
	     */
	    PersistentConnection.prototype.unlisten = function (query, tag) {
	        var pathString = query.path.toString();
	        var queryId = query.queryIdentifier();
	        this.log_('Unlisten called for ' + pathString + ' ' + queryId);
	        util_3.assert(query.getQueryParams().isDefault() ||
	            !query.getQueryParams().loadsAllData(), 'unlisten() called for non-default but complete query');
	        var listen = this.removeListen_(pathString, queryId);
	        if (listen && this.connected_) {
	            this.sendUnlisten_(pathString, queryId, query.queryObject(), tag);
	        }
	    };
	    PersistentConnection.prototype.sendUnlisten_ = function (pathString, queryId, queryObj, tag) {
	        this.log_('Unlisten on ' + pathString + ' for ' + queryId);
	        var req = { /*path*/ p: pathString };
	        var action = 'n';
	        // Only bother sending queryId if it's non-default.
	        if (tag) {
	            req['q'] = queryObj;
	            req['t'] = tag;
	        }
	        this.sendRequest(action, req);
	    };
	    /**
	     * @inheritDoc
	     */
	    PersistentConnection.prototype.onDisconnectPut = function (pathString, data, onComplete) {
	        if (this.connected_) {
	            this.sendOnDisconnect_('o', pathString, data, onComplete);
	        }
	        else {
	            this.onDisconnectRequestQueue_.push({
	                pathString: pathString,
	                action: 'o',
	                data: data,
	                onComplete: onComplete
	            });
	        }
	    };
	    /**
	     * @inheritDoc
	     */
	    PersistentConnection.prototype.onDisconnectMerge = function (pathString, data, onComplete) {
	        if (this.connected_) {
	            this.sendOnDisconnect_('om', pathString, data, onComplete);
	        }
	        else {
	            this.onDisconnectRequestQueue_.push({
	                pathString: pathString,
	                action: 'om',
	                data: data,
	                onComplete: onComplete
	            });
	        }
	    };
	    /**
	     * @inheritDoc
	     */
	    PersistentConnection.prototype.onDisconnectCancel = function (pathString, onComplete) {
	        if (this.connected_) {
	            this.sendOnDisconnect_('oc', pathString, null, onComplete);
	        }
	        else {
	            this.onDisconnectRequestQueue_.push({
	                pathString: pathString,
	                action: 'oc',
	                data: null,
	                onComplete: onComplete
	            });
	        }
	    };
	    PersistentConnection.prototype.sendOnDisconnect_ = function (action, pathString, data, onComplete) {
	        var request = { /*path*/ p: pathString, /*data*/ d: data };
	        this.log_('onDisconnect ' + action, request);
	        this.sendRequest(action, request, function (response) {
	            if (onComplete) {
	                setTimeout(function () {
	                    onComplete(response['s'], response['d']);
	                }, Math.floor(0));
	            }
	        });
	    };
	    /**
	     * @inheritDoc
	     */
	    PersistentConnection.prototype.put = function (pathString, data, onComplete, hash) {
	        this.putInternal('p', pathString, data, onComplete, hash);
	    };
	    /**
	     * @inheritDoc
	     */
	    PersistentConnection.prototype.merge = function (pathString, data, onComplete, hash) {
	        this.putInternal('m', pathString, data, onComplete, hash);
	    };
	    PersistentConnection.prototype.putInternal = function (action, pathString, data, onComplete, hash) {
	        var request = {
	            /*path*/ p: pathString,
	            /*data*/ d: data
	        };
	        if (hash !== undefined)
	            request['h'] = hash;
	        // TODO: Only keep track of the most recent put for a given path?
	        this.outstandingPuts_.push({
	            action: action,
	            request: request,
	            onComplete: onComplete
	        });
	        this.outstandingPutCount_++;
	        var index = this.outstandingPuts_.length - 1;
	        if (this.connected_) {
	            this.sendPut_(index);
	        }
	        else {
	            this.log_('Buffering put: ' + pathString);
	        }
	    };
	    PersistentConnection.prototype.sendPut_ = function (index) {
	        var _this = this;
	        var action = this.outstandingPuts_[index].action;
	        var request = this.outstandingPuts_[index].request;
	        var onComplete = this.outstandingPuts_[index].onComplete;
	        this.outstandingPuts_[index].queued = this.connected_;
	        this.sendRequest(action, request, function (message) {
	            _this.log_(action + ' response', message);
	            delete _this.outstandingPuts_[index];
	            _this.outstandingPutCount_--;
	            // Clean up array occasionally.
	            if (_this.outstandingPutCount_ === 0) {
	                _this.outstandingPuts_ = [];
	            }
	            if (onComplete)
	                onComplete(message['s'], message['d']);
	        });
	    };
	    /**
	     * @inheritDoc
	     */
	    PersistentConnection.prototype.reportStats = function (stats) {
	        var _this = this;
	        // If we're not connected, we just drop the stats.
	        if (this.connected_) {
	            var request = { /*counters*/ c: stats };
	            this.log_('reportStats', request);
	            this.sendRequest(/*stats*/ 's', request, function (result) {
	                var status = result['s'];
	                if (status !== 'ok') {
	                    var errorReason = result['d'];
	                    _this.log_('reportStats', 'Error sending stats: ' + errorReason);
	                }
	            });
	        }
	    };
	    /**
	     * @param {*} message
	     * @private
	     */
	    PersistentConnection.prototype.onDataMessage_ = function (message) {
	        if ('r' in message) {
	            // this is a response
	            this.log_('from server: ' + util_2.stringify(message));
	            var reqNum = message['r'];
	            var onResponse = this.requestCBHash_[reqNum];
	            if (onResponse) {
	                delete this.requestCBHash_[reqNum];
	                onResponse(message['b']);
	            }
	        }
	        else if ('error' in message) {
	            throw 'A server-side error has occurred: ' + message['error'];
	        }
	        else if ('a' in message) {
	            // a and b are action and body, respectively
	            this.onDataPush_(message['a'], message['b']);
	        }
	    };
	    PersistentConnection.prototype.onDataPush_ = function (action, body) {
	        this.log_('handleServerMessage', action, body);
	        if (action === 'd')
	            this.onDataUpdate_(body['p'], body['d'], 
	            /*isMerge*/ false, body['t']);
	        else if (action === 'm')
	            this.onDataUpdate_(body['p'], body['d'], 
	            /*isMerge=*/ true, body['t']);
	        else if (action === 'c')
	            this.onListenRevoked_(body['p'], body['q']);
	        else if (action === 'ac')
	            this.onAuthRevoked_(body['s'], body['d']);
	        else if (action === 'sd')
	            this.onSecurityDebugPacket_(body);
	        else
	            util_4.error('Unrecognized action received from server: ' +
	                util_2.stringify(action) +
	                '\nAre you using the latest client?');
	    };
	    PersistentConnection.prototype.onReady_ = function (timestamp, sessionId) {
	        this.log_('connection ready');
	        this.connected_ = true;
	        this.lastConnectionEstablishedTime_ = new Date().getTime();
	        this.handleTimestamp_(timestamp);
	        this.lastSessionId = sessionId;
	        if (this.firstConnection_) {
	            this.sendConnectStats_();
	        }
	        this.restoreState_();
	        this.firstConnection_ = false;
	        this.onConnectStatus_(true);
	    };
	    PersistentConnection.prototype.scheduleConnect_ = function (timeout) {
	        var _this = this;
	        util_3.assert(!this.realtime_, "Scheduling a connect when we're already connected/ing?");
	        if (this.establishConnectionTimer_) {
	            clearTimeout(this.establishConnectionTimer_);
	        }
	        // NOTE: Even when timeout is 0, it's important to do a setTimeout to work around an infuriating "Security Error" in
	        // Firefox when trying to write to our long-polling iframe in some scenarios (e.g. Forge or our unit tests).
	        this.establishConnectionTimer_ = setTimeout(function () {
	            _this.establishConnectionTimer_ = null;
	            _this.establishConnection_();
	        }, Math.floor(timeout));
	    };
	    /**
	     * @param {boolean} visible
	     * @private
	     */
	    PersistentConnection.prototype.onVisible_ = function (visible) {
	        // NOTE: Tabbing away and back to a window will defeat our reconnect backoff, but I think that's fine.
	        if (visible &&
	            !this.visible_ &&
	            this.reconnectDelay_ === this.maxReconnectDelay_) {
	            this.log_('Window became visible.  Reducing delay.');
	            this.reconnectDelay_ = RECONNECT_MIN_DELAY;
	            if (!this.realtime_) {
	                this.scheduleConnect_(0);
	            }
	        }
	        this.visible_ = visible;
	    };
	    PersistentConnection.prototype.onOnline_ = function (online) {
	        if (online) {
	            this.log_('Browser went online.');
	            this.reconnectDelay_ = RECONNECT_MIN_DELAY;
	            if (!this.realtime_) {
	                this.scheduleConnect_(0);
	            }
	        }
	        else {
	            this.log_('Browser went offline.  Killing connection.');
	            if (this.realtime_) {
	                this.realtime_.close();
	            }
	        }
	    };
	    PersistentConnection.prototype.onRealtimeDisconnect_ = function () {
	        this.log_('data client disconnected');
	        this.connected_ = false;
	        this.realtime_ = null;
	        // Since we don't know if our sent transactions succeeded or not, we need to cancel them.
	        this.cancelSentTransactions_();
	        // Clear out the pending requests.
	        this.requestCBHash_ = {};
	        if (this.shouldReconnect_()) {
	            if (!this.visible_) {
	                this.log_("Window isn't visible.  Delaying reconnect.");
	                this.reconnectDelay_ = this.maxReconnectDelay_;
	                this.lastConnectionAttemptTime_ = new Date().getTime();
	            }
	            else if (this.lastConnectionEstablishedTime_) {
	                // If we've been connected long enough, reset reconnect delay to minimum.
	                var timeSinceLastConnectSucceeded = new Date().getTime() - this.lastConnectionEstablishedTime_;
	                if (timeSinceLastConnectSucceeded > RECONNECT_DELAY_RESET_TIMEOUT)
	                    this.reconnectDelay_ = RECONNECT_MIN_DELAY;
	                this.lastConnectionEstablishedTime_ = null;
	            }
	            var timeSinceLastConnectAttempt = new Date().getTime() - this.lastConnectionAttemptTime_;
	            var reconnectDelay = Math.max(0, this.reconnectDelay_ - timeSinceLastConnectAttempt);
	            reconnectDelay = Math.random() * reconnectDelay;
	            this.log_('Trying to reconnect in ' + reconnectDelay + 'ms');
	            this.scheduleConnect_(reconnectDelay);
	            // Adjust reconnect delay for next time.
	            this.reconnectDelay_ = Math.min(this.maxReconnectDelay_, this.reconnectDelay_ * RECONNECT_DELAY_MULTIPLIER);
	        }
	        this.onConnectStatus_(false);
	    };
	    PersistentConnection.prototype.establishConnection_ = function () {
	        if (this.shouldReconnect_()) {
	            this.log_('Making a connection attempt');
	            this.lastConnectionAttemptTime_ = new Date().getTime();
	            this.lastConnectionEstablishedTime_ = null;
	            var onDataMessage_1 = this.onDataMessage_.bind(this);
	            var onReady_1 = this.onReady_.bind(this);
	            var onDisconnect_1 = this.onRealtimeDisconnect_.bind(this);
	            var connId_1 = this.id + ':' + PersistentConnection.nextConnectionId_++;
	            var self_1 = this;
	            var lastSessionId_1 = this.lastSessionId;
	            var canceled_1 = false;
	            var connection_1 = null;
	            var closeFn_1 = function () {
	                if (connection_1) {
	                    connection_1.close();
	                }
	                else {
	                    canceled_1 = true;
	                    onDisconnect_1();
	                }
	            };
	            var sendRequestFn = function (msg) {
	                util_3.assert(connection_1, "sendRequest call when we're not connected not allowed.");
	                connection_1.sendRequest(msg);
	            };
	            this.realtime_ = {
	                close: closeFn_1,
	                sendRequest: sendRequestFn
	            };
	            var forceRefresh = this.forceTokenRefresh_;
	            this.forceTokenRefresh_ = false;
	            // First fetch auth token, and establish connection after fetching the token was successful
	            this.authTokenProvider_
	                .getToken(forceRefresh)
	                .then(function (result) {
	                if (!canceled_1) {
	                    util_4.log('getToken() completed. Creating connection.');
	                    self_1.authToken_ = result && result.accessToken;
	                    connection_1 = new Connection_1.Connection(connId_1, self_1.repoInfo_, onDataMessage_1, onReady_1, onDisconnect_1, 
	                    /* onKill= */ function (reason) {
	                        util_4.warn(reason + ' (' + self_1.repoInfo_.toString() + ')');
	                        self_1.interrupt(SERVER_KILL_INTERRUPT_REASON);
	                    }, lastSessionId_1);
	                }
	                else {
	                    util_4.log('getToken() completed but was canceled');
	                }
	            })
	                .then(null, function (error) {
	                self_1.log_('Failed to get token: ' + error);
	                if (!canceled_1) {
	                    if (util_6.CONSTANTS.NODE_ADMIN) {
	                        // This may be a critical error for the Admin Node.js SDK, so log a warning.
	                        // But getToken() may also just have temporarily failed, so we still want to
	                        // continue retrying.
	                        util_4.warn(error);
	                    }
	                    closeFn_1();
	                }
	            });
	        }
	    };
	    /**
	     * @param {string} reason
	     */
	    PersistentConnection.prototype.interrupt = function (reason) {
	        util_4.log('Interrupting connection for reason: ' + reason);
	        this.interruptReasons_[reason] = true;
	        if (this.realtime_) {
	            this.realtime_.close();
	        }
	        else {
	            if (this.establishConnectionTimer_) {
	                clearTimeout(this.establishConnectionTimer_);
	                this.establishConnectionTimer_ = null;
	            }
	            if (this.connected_) {
	                this.onRealtimeDisconnect_();
	            }
	        }
	    };
	    /**
	     * @param {string} reason
	     */
	    PersistentConnection.prototype.resume = function (reason) {
	        util_4.log('Resuming connection for reason: ' + reason);
	        delete this.interruptReasons_[reason];
	        if (util_1.isEmpty(this.interruptReasons_)) {
	            this.reconnectDelay_ = RECONNECT_MIN_DELAY;
	            if (!this.realtime_) {
	                this.scheduleConnect_(0);
	            }
	        }
	    };
	    PersistentConnection.prototype.handleTimestamp_ = function (timestamp) {
	        var delta = timestamp - new Date().getTime();
	        this.onServerInfoUpdate_({ serverTimeOffset: delta });
	    };
	    PersistentConnection.prototype.cancelSentTransactions_ = function () {
	        for (var i = 0; i < this.outstandingPuts_.length; i++) {
	            var put = this.outstandingPuts_[i];
	            if (put && /*hash*/ 'h' in put.request && put.queued) {
	                if (put.onComplete)
	                    put.onComplete('disconnect');
	                delete this.outstandingPuts_[i];
	                this.outstandingPutCount_--;
	            }
	        }
	        // Clean up array occasionally.
	        if (this.outstandingPutCount_ === 0)
	            this.outstandingPuts_ = [];
	    };
	    /**
	     * @param {!string} pathString
	     * @param {Array.<*>=} query
	     * @private
	     */
	    PersistentConnection.prototype.onListenRevoked_ = function (pathString, query) {
	        // Remove the listen and manufacture a "permission_denied" error for the failed listen.
	        var queryId;
	        if (!query) {
	            queryId = 'default';
	        }
	        else {
	            queryId = query.map(function (q) { return util_4.ObjectToUniqueKey(q); }).join('$');
	        }
	        var listen = this.removeListen_(pathString, queryId);
	        if (listen && listen.onComplete)
	            listen.onComplete('permission_denied');
	    };
	    /**
	     * @param {!string} pathString
	     * @param {!string} queryId
	     * @return {{queries:Array.<Query>, onComplete:function(string)}}
	     * @private
	     */
	    PersistentConnection.prototype.removeListen_ = function (pathString, queryId) {
	        var normalizedPathString = new Path_1.Path(pathString).toString(); // normalize path.
	        var listen;
	        if (this.listens_[normalizedPathString] !== undefined) {
	            listen = this.listens_[normalizedPathString][queryId];
	            delete this.listens_[normalizedPathString][queryId];
	            if (util_1.getCount(this.listens_[normalizedPathString]) === 0) {
	                delete this.listens_[normalizedPathString];
	            }
	        }
	        else {
	            // all listens for this path has already been removed
	            listen = undefined;
	        }
	        return listen;
	    };
	    PersistentConnection.prototype.onAuthRevoked_ = function (statusCode, explanation) {
	        util_4.log('Auth token revoked: ' + statusCode + '/' + explanation);
	        this.authToken_ = null;
	        this.forceTokenRefresh_ = true;
	        this.realtime_.close();
	        if (statusCode === 'invalid_token' || statusCode === 'permission_denied') {
	            // We'll wait a couple times before logging the warning / increasing the
	            // retry period since oauth tokens will report as "invalid" if they're
	            // just expired. Plus there may be transient issues that resolve themselves.
	            this.invalidAuthTokenCount_++;
	            if (this.invalidAuthTokenCount_ >= INVALID_AUTH_TOKEN_THRESHOLD) {
	                // Set a long reconnect delay because recovery is unlikely
	                this.reconnectDelay_ = RECONNECT_MAX_DELAY_FOR_ADMINS;
	                // Notify the auth token provider that the token is invalid, which will log
	                // a warning
	                this.authTokenProvider_.notifyForInvalidToken();
	            }
	        }
	    };
	    PersistentConnection.prototype.onSecurityDebugPacket_ = function (body) {
	        if (this.securityDebugCallback_) {
	            this.securityDebugCallback_(body);
	        }
	        else {
	            if ('msg' in body && typeof console !== 'undefined') {
	                console.log('FIREBASE: ' + body['msg'].replace('\n', '\nFIREBASE: '));
	            }
	        }
	    };
	    PersistentConnection.prototype.restoreState_ = function () {
	        var _this = this;
	        //Re-authenticate ourselves if we have a credential stored.
	        this.tryAuth();
	        // Puts depend on having received the corresponding data update from the server before they complete, so we must
	        // make sure to send listens before puts.
	        util_1.forEach(this.listens_, function (pathString, queries) {
	            util_1.forEach(queries, function (key, listenSpec) {
	                _this.sendListen_(listenSpec);
	            });
	        });
	        for (var i = 0; i < this.outstandingPuts_.length; i++) {
	            if (this.outstandingPuts_[i])
	                this.sendPut_(i);
	        }
	        while (this.onDisconnectRequestQueue_.length) {
	            var request = this.onDisconnectRequestQueue_.shift();
	            this.sendOnDisconnect_(request.action, request.pathString, request.data, request.onComplete);
	        }
	    };
	    /**
	     * Sends client stats for first connection
	     * @private
	     */
	    PersistentConnection.prototype.sendConnectStats_ = function () {
	        var stats = {};
	        var clientName = 'js';
	        if (util_6.CONSTANTS.NODE_ADMIN) {
	            clientName = 'admin_node';
	        }
	        else if (util_6.CONSTANTS.NODE_CLIENT) {
	            clientName = 'node';
	        }
	        stats['sdk.' + clientName + '.' + app_1.default.SDK_VERSION.replace(/\./g, '-')] = 1;
	        if (util_7.isMobileCordova()) {
	            stats['framework.cordova'] = 1;
	        }
	        else if (util_7.isReactNative()) {
	            stats['framework.reactnative'] = 1;
	        }
	        this.reportStats(stats);
	    };
	    /**
	     * @return {boolean}
	     * @private
	     */
	    PersistentConnection.prototype.shouldReconnect_ = function () {
	        var online = OnlineMonitor_1.OnlineMonitor.getInstance().currentlyOnline();
	        return util_1.isEmpty(this.interruptReasons_) && online;
	    };
	    /**
	     * @private
	     */
	    PersistentConnection.nextPersistentConnectionId_ = 0;
	    /**
	     * Counter for number of connections created. Mainly used for tagging in the logs
	     * @type {number}
	     * @private
	     */
	    PersistentConnection.nextConnectionId_ = 0;
	    return PersistentConnection;
	}(ServerActions_1.ServerActions));
	exports.PersistentConnection = PersistentConnection;
	
	//# sourceMappingURL=PersistentConnection.js.map


/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var util_1 = __webpack_require__(1);
	var util_2 = __webpack_require__(1);
	var storage_1 = __webpack_require__(68);
	var Constants_1 = __webpack_require__(71);
	/**
	 * A class that holds metadata about a Repo object
	 *
	 * @constructor
	 */
	var RepoInfo = /** @class */ (function () {
	    /**
	     * @param {string} host Hostname portion of the url for the repo
	     * @param {boolean} secure Whether or not this repo is accessed over ssl
	     * @param {string} namespace The namespace represented by the repo
	     * @param {boolean} webSocketOnly Whether to prefer websockets over all other transports (used by Nest).
	     * @param {string=} persistenceKey Override the default session persistence storage key
	     */
	    function RepoInfo(host, secure, namespace, webSocketOnly, persistenceKey) {
	        if (persistenceKey === void 0) { persistenceKey = ''; }
	        this.secure = secure;
	        this.namespace = namespace;
	        this.webSocketOnly = webSocketOnly;
	        this.persistenceKey = persistenceKey;
	        this.host = host.toLowerCase();
	        this.domain = this.host.substr(this.host.indexOf('.') + 1);
	        this.internalHost = storage_1.PersistentStorage.get('host:' + host) || this.host;
	    }
	    RepoInfo.prototype.needsQueryParam = function () {
	        return this.host !== this.internalHost;
	    };
	    RepoInfo.prototype.isCacheableHost = function () {
	        return this.internalHost.substr(0, 2) === 's-';
	    };
	    RepoInfo.prototype.isDemoHost = function () {
	        return this.domain === 'firebaseio-demo.com';
	    };
	    RepoInfo.prototype.isCustomHost = function () {
	        return (this.domain !== 'firebaseio.com' && this.domain !== 'firebaseio-demo.com');
	    };
	    RepoInfo.prototype.updateHost = function (newHost) {
	        if (newHost !== this.internalHost) {
	            this.internalHost = newHost;
	            if (this.isCacheableHost()) {
	                storage_1.PersistentStorage.set('host:' + this.host, this.internalHost);
	            }
	        }
	    };
	    /**
	     * Returns the websocket URL for this repo
	     * @param {string} type of connection
	     * @param {Object} params list
	     * @return {string} The URL for this repo
	     */
	    RepoInfo.prototype.connectionURL = function (type, params) {
	        util_1.assert(typeof type === 'string', 'typeof type must == string');
	        util_1.assert(typeof params === 'object', 'typeof params must == object');
	        var connURL;
	        if (type === Constants_1.WEBSOCKET) {
	            connURL =
	                (this.secure ? 'wss://' : 'ws://') + this.internalHost + '/.ws?';
	        }
	        else if (type === Constants_1.LONG_POLLING) {
	            connURL =
	                (this.secure ? 'https://' : 'http://') + this.internalHost + '/.lp?';
	        }
	        else {
	            throw new Error('Unknown connection type: ' + type);
	        }
	        if (this.needsQueryParam()) {
	            params['ns'] = this.namespace;
	        }
	        var pairs = [];
	        util_2.forEach(params, function (key, value) {
	            pairs.push(key + '=' + value);
	        });
	        return connURL + pairs.join('&');
	    };
	    /** @return {string} */
	    RepoInfo.prototype.toString = function () {
	        var str = this.toURLString();
	        if (this.persistenceKey) {
	            str += '<' + this.persistenceKey + '>';
	        }
	        return str;
	    };
	    /** @return {string} */
	    RepoInfo.prototype.toURLString = function () {
	        return (this.secure ? 'https://' : 'http://') + this.host;
	    };
	    return RepoInfo;
	}());
	exports.RepoInfo = RepoInfo;
	
	//# sourceMappingURL=RepoInfo.js.map


/***/ }),
/* 138 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Interface defining the set of actions that can be performed against the Firebase server
	 * (basically corresponds to our wire protocol).
	 *
	 * @interface
	 */
	var ServerActions = /** @class */ (function () {
	    function ServerActions() {
	    }
	    /**
	     * @param {string} pathString
	     * @param {*} data
	     * @param {function(string, string)=} onComplete
	     * @param {string=} hash
	     */
	    ServerActions.prototype.put = function (pathString, data, onComplete, hash) { };
	    /**
	     * @param {string} pathString
	     * @param {*} data
	     * @param {function(string, ?string)} onComplete
	     * @param {string=} hash
	     */
	    ServerActions.prototype.merge = function (pathString, data, onComplete, hash) { };
	    /**
	     * Refreshes the auth token for the current connection.
	     * @param {string} token The authentication token
	     */
	    ServerActions.prototype.refreshAuthToken = function (token) { };
	    /**
	     * @param {string} pathString
	     * @param {*} data
	     * @param {function(string, string)=} onComplete
	     */
	    ServerActions.prototype.onDisconnectPut = function (pathString, data, onComplete) { };
	    /**
	     * @param {string} pathString
	     * @param {*} data
	     * @param {function(string, string)=} onComplete
	     */
	    ServerActions.prototype.onDisconnectMerge = function (pathString, data, onComplete) { };
	    /**
	     * @param {string} pathString
	     * @param {function(string, string)=} onComplete
	     */
	    ServerActions.prototype.onDisconnectCancel = function (pathString, onComplete) { };
	    /**
	     * @param {Object.<string, *>} stats
	     */
	    ServerActions.prototype.reportStats = function (stats) { };
	    return ServerActions;
	}());
	exports.ServerActions = ServerActions;
	
	//# sourceMappingURL=ServerActions.js.map


/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var Path_1 = __webpack_require__(8);
	var PriorityIndex_1 = __webpack_require__(15);
	var CountedSet_1 = __webpack_require__(149);
	/**
	 * Helper class to store a sparse set of snapshots.
	 *
	 * @constructor
	 */
	var SparseSnapshotTree = /** @class */ (function () {
	    function SparseSnapshotTree() {
	        /**
	         * @private
	         * @type {Node}
	         */
	        this.value_ = null;
	        /**
	         * @private
	         * @type {CountedSet}
	         */
	        this.children_ = null;
	    }
	    /**
	     * Gets the node stored at the given path if one exists.
	     *
	     * @param {!Path} path Path to look up snapshot for.
	     * @return {?Node} The retrieved node, or null.
	     */
	    SparseSnapshotTree.prototype.find = function (path) {
	        if (this.value_ != null) {
	            return this.value_.getChild(path);
	        }
	        else if (!path.isEmpty() && this.children_ != null) {
	            var childKey = path.getFront();
	            path = path.popFront();
	            if (this.children_.contains(childKey)) {
	                var childTree = this.children_.get(childKey);
	                return childTree.find(path);
	            }
	            else {
	                return null;
	            }
	        }
	        else {
	            return null;
	        }
	    };
	    /**
	     * Stores the given node at the specified path. If there is already a node
	     * at a shallower path, it merges the new data into that snapshot node.
	     *
	     * @param {!Path} path Path to look up snapshot for.
	     * @param {!Node} data The new data, or null.
	     */
	    SparseSnapshotTree.prototype.remember = function (path, data) {
	        if (path.isEmpty()) {
	            this.value_ = data;
	            this.children_ = null;
	        }
	        else if (this.value_ !== null) {
	            this.value_ = this.value_.updateChild(path, data);
	        }
	        else {
	            if (this.children_ == null) {
	                this.children_ = new CountedSet_1.CountedSet();
	            }
	            var childKey = path.getFront();
	            if (!this.children_.contains(childKey)) {
	                this.children_.add(childKey, new SparseSnapshotTree());
	            }
	            var child = this.children_.get(childKey);
	            path = path.popFront();
	            child.remember(path, data);
	        }
	    };
	    /**
	     * Purge the data at path from the cache.
	     *
	     * @param {!Path} path Path to look up snapshot for.
	     * @return {boolean} True if this node should now be removed.
	     */
	    SparseSnapshotTree.prototype.forget = function (path) {
	        if (path.isEmpty()) {
	            this.value_ = null;
	            this.children_ = null;
	            return true;
	        }
	        else {
	            if (this.value_ !== null) {
	                if (this.value_.isLeafNode()) {
	                    // We're trying to forget a node that doesn't exist
	                    return false;
	                }
	                else {
	                    var value = this.value_;
	                    this.value_ = null;
	                    var self_1 = this;
	                    value.forEachChild(PriorityIndex_1.PRIORITY_INDEX, function (key, tree) {
	                        self_1.remember(new Path_1.Path(key), tree);
	                    });
	                    return this.forget(path);
	                }
	            }
	            else if (this.children_ !== null) {
	                var childKey = path.getFront();
	                path = path.popFront();
	                if (this.children_.contains(childKey)) {
	                    var safeToRemove = this.children_.get(childKey).forget(path);
	                    if (safeToRemove) {
	                        this.children_.remove(childKey);
	                    }
	                }
	                if (this.children_.isEmpty()) {
	                    this.children_ = null;
	                    return true;
	                }
	                else {
	                    return false;
	                }
	            }
	            else {
	                return true;
	            }
	        }
	    };
	    /**
	     * Recursively iterates through all of the stored tree and calls the
	     * callback on each one.
	     *
	     * @param {!Path} prefixPath Path to look up node for.
	     * @param {!Function} func The function to invoke for each tree.
	     */
	    SparseSnapshotTree.prototype.forEachTree = function (prefixPath, func) {
	        if (this.value_ !== null) {
	            func(prefixPath, this.value_);
	        }
	        else {
	            this.forEachChild(function (key, tree) {
	                var path = new Path_1.Path(prefixPath.toString() + '/' + key);
	                tree.forEachTree(path, func);
	            });
	        }
	    };
	    /**
	     * Iterates through each immediate child and triggers the callback.
	     *
	     * @param {!Function} func The function to invoke for each child.
	     */
	    SparseSnapshotTree.prototype.forEachChild = function (func) {
	        if (this.children_ !== null) {
	            this.children_.each(function (key, tree) {
	                func(key, tree);
	            });
	        }
	    };
	    return SparseSnapshotTree;
	}());
	exports.SparseSnapshotTree = SparseSnapshotTree;
	
	//# sourceMappingURL=SparseSnapshotTree.js.map


/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var CacheNode_1 = __webpack_require__(70);
	var ChildrenNode_1 = __webpack_require__(17);
	var util_1 = __webpack_require__(1);
	var util_2 = __webpack_require__(1);
	var ViewCache_1 = __webpack_require__(153);
	var View_1 = __webpack_require__(253);
	var __referenceConstructor;
	/**
	 * SyncPoint represents a single location in a SyncTree with 1 or more event registrations, meaning we need to
	 * maintain 1 or more Views at this location to cache server data and raise appropriate events for server changes
	 * and user writes (set, transaction, update).
	 *
	 * It's responsible for:
	 *  - Maintaining the set of 1 or more views necessary at this location (a SyncPoint with 0 views should be removed).
	 *  - Proxying user / server operations to the views as appropriate (i.e. applyServerOverwrite,
	 *    applyUserOverwrite, etc.)
	 */
	var SyncPoint = /** @class */ (function () {
	    function SyncPoint() {
	        /**
	         * The Views being tracked at this location in the tree, stored as a map where the key is a
	         * queryId and the value is the View for that query.
	         *
	         * NOTE: This list will be quite small (usually 1, but perhaps 2 or 3; any more is an odd use case).
	         *
	         * @type {!Object.<!string, !View>}
	         * @private
	         */
	        this.views_ = {};
	    }
	    Object.defineProperty(SyncPoint, "__referenceConstructor", {
	        get: function () {
	            util_1.assert(__referenceConstructor, 'Reference.ts has not been loaded');
	            return __referenceConstructor;
	        },
	        set: function (val) {
	            util_1.assert(!__referenceConstructor, '__referenceConstructor has already been defined');
	            __referenceConstructor = val;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    /**
	     * @return {boolean}
	     */
	    SyncPoint.prototype.isEmpty = function () {
	        return util_2.isEmpty(this.views_);
	    };
	    /**
	     *
	     * @param {!Operation} operation
	     * @param {!WriteTreeRef} writesCache
	     * @param {?Node} optCompleteServerCache
	     * @return {!Array.<!Event>}
	     */
	    SyncPoint.prototype.applyOperation = function (operation, writesCache, optCompleteServerCache) {
	        var queryId = operation.source.queryId;
	        if (queryId !== null) {
	            var view = util_2.safeGet(this.views_, queryId);
	            util_1.assert(view != null, 'SyncTree gave us an op for an invalid query.');
	            return view.applyOperation(operation, writesCache, optCompleteServerCache);
	        }
	        else {
	            var events_1 = [];
	            util_2.forEach(this.views_, function (key, view) {
	                events_1 = events_1.concat(view.applyOperation(operation, writesCache, optCompleteServerCache));
	            });
	            return events_1;
	        }
	    };
	    /**
	     * Add an event callback for the specified query.
	     *
	     * @param {!Query} query
	     * @param {!EventRegistration} eventRegistration
	     * @param {!WriteTreeRef} writesCache
	     * @param {?Node} serverCache Complete server cache, if we have it.
	     * @param {boolean} serverCacheComplete
	     * @return {!Array.<!Event>} Events to raise.
	     */
	    SyncPoint.prototype.addEventRegistration = function (query, eventRegistration, writesCache, serverCache, serverCacheComplete) {
	        var queryId = query.queryIdentifier();
	        var view = util_2.safeGet(this.views_, queryId);
	        if (!view) {
	            // TODO: make writesCache take flag for complete server node
	            var eventCache = writesCache.calcCompleteEventCache(serverCacheComplete ? serverCache : null);
	            var eventCacheComplete = false;
	            if (eventCache) {
	                eventCacheComplete = true;
	            }
	            else if (serverCache instanceof ChildrenNode_1.ChildrenNode) {
	                eventCache = writesCache.calcCompleteEventChildren(serverCache);
	                eventCacheComplete = false;
	            }
	            else {
	                eventCache = ChildrenNode_1.ChildrenNode.EMPTY_NODE;
	                eventCacheComplete = false;
	            }
	            var viewCache = new ViewCache_1.ViewCache(new CacheNode_1.CacheNode(
	            /** @type {!Node} */ (eventCache), eventCacheComplete, false), new CacheNode_1.CacheNode(
	            /** @type {!Node} */ (serverCache), serverCacheComplete, false));
	            view = new View_1.View(query, viewCache);
	            this.views_[queryId] = view;
	        }
	        // This is guaranteed to exist now, we just created anything that was missing
	        view.addEventRegistration(eventRegistration);
	        return view.getInitialEvents(eventRegistration);
	    };
	    /**
	     * Remove event callback(s).  Return cancelEvents if a cancelError is specified.
	     *
	     * If query is the default query, we'll check all views for the specified eventRegistration.
	     * If eventRegistration is null, we'll remove all callbacks for the specified view(s).
	     *
	     * @param {!Query} query
	     * @param {?EventRegistration} eventRegistration If null, remove all callbacks.
	     * @param {Error=} cancelError If a cancelError is provided, appropriate cancel events will be returned.
	     * @return {{removed:!Array.<!Query>, events:!Array.<!Event>}} removed queries and any cancel events
	     */
	    SyncPoint.prototype.removeEventRegistration = function (query, eventRegistration, cancelError) {
	        var queryId = query.queryIdentifier();
	        var removed = [];
	        var cancelEvents = [];
	        var hadCompleteView = this.hasCompleteView();
	        if (queryId === 'default') {
	            // When you do ref.off(...), we search all views for the registration to remove.
	            var self_1 = this;
	            util_2.forEach(this.views_, function (viewQueryId, view) {
	                cancelEvents = cancelEvents.concat(view.removeEventRegistration(eventRegistration, cancelError));
	                if (view.isEmpty()) {
	                    delete self_1.views_[viewQueryId];
	                    // We'll deal with complete views later.
	                    if (!view
	                        .getQuery()
	                        .getQueryParams()
	                        .loadsAllData()) {
	                        removed.push(view.getQuery());
	                    }
	                }
	            });
	        }
	        else {
	            // remove the callback from the specific view.
	            var view = util_2.safeGet(this.views_, queryId);
	            if (view) {
	                cancelEvents = cancelEvents.concat(view.removeEventRegistration(eventRegistration, cancelError));
	                if (view.isEmpty()) {
	                    delete this.views_[queryId];
	                    // We'll deal with complete views later.
	                    if (!view
	                        .getQuery()
	                        .getQueryParams()
	                        .loadsAllData()) {
	                        removed.push(view.getQuery());
	                    }
	                }
	            }
	        }
	        if (hadCompleteView && !this.hasCompleteView()) {
	            // We removed our last complete view.
	            removed.push(new SyncPoint.__referenceConstructor(query.repo, query.path));
	        }
	        return { removed: removed, events: cancelEvents };
	    };
	    /**
	     * @return {!Array.<!View>}
	     */
	    SyncPoint.prototype.getQueryViews = function () {
	        var _this = this;
	        var values = Object.keys(this.views_).map(function (key) { return _this.views_[key]; });
	        return values.filter(function (view) {
	            return !view
	                .getQuery()
	                .getQueryParams()
	                .loadsAllData();
	        });
	    };
	    /**
	     *
	     * @param {!Path} path The path to the desired complete snapshot
	     * @return {?Node} A complete cache, if it exists
	     */
	    SyncPoint.prototype.getCompleteServerCache = function (path) {
	        var serverCache = null;
	        util_2.forEach(this.views_, function (key, view) {
	            serverCache = serverCache || view.getCompleteServerCache(path);
	        });
	        return serverCache;
	    };
	    /**
	     * @param {!Query} query
	     * @return {?View}
	     */
	    SyncPoint.prototype.viewForQuery = function (query) {
	        var params = query.getQueryParams();
	        if (params.loadsAllData()) {
	            return this.getCompleteView();
	        }
	        else {
	            var queryId = query.queryIdentifier();
	            return util_2.safeGet(this.views_, queryId);
	        }
	    };
	    /**
	     * @param {!Query} query
	     * @return {boolean}
	     */
	    SyncPoint.prototype.viewExistsForQuery = function (query) {
	        return this.viewForQuery(query) != null;
	    };
	    /**
	     * @return {boolean}
	     */
	    SyncPoint.prototype.hasCompleteView = function () {
	        return this.getCompleteView() != null;
	    };
	    /**
	     * @return {?View}
	     */
	    SyncPoint.prototype.getCompleteView = function () {
	        var completeView = util_2.findValue(this.views_, function (view) {
	            return view
	                .getQuery()
	                .getQueryParams()
	                .loadsAllData();
	        });
	        return completeView || null;
	    };
	    return SyncPoint;
	}());
	exports.SyncPoint = SyncPoint;
	
	//# sourceMappingURL=SyncPoint.js.map


/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var Operation_1 = __webpack_require__(33);
	var Path_1 = __webpack_require__(8);
	/**
	 * @param {!OperationSource} source
	 * @param {!Path} path
	 * @param {!Node} snap
	 * @constructor
	 * @implements {Operation}
	 */
	var Overwrite = /** @class */ (function () {
	    function Overwrite(source, path, snap) {
	        this.source = source;
	        this.path = path;
	        this.snap = snap;
	        /** @inheritDoc */
	        this.type = Operation_1.OperationType.OVERWRITE;
	    }
	    Overwrite.prototype.operationForChild = function (childName) {
	        if (this.path.isEmpty()) {
	            return new Overwrite(this.source, Path_1.Path.Empty, this.snap.getImmediateChild(childName));
	        }
	        else {
	            return new Overwrite(this.source, this.path.popFront(), this.snap);
	        }
	    };
	    return Overwrite;
	}());
	exports.Overwrite = Overwrite;
	
	//# sourceMappingURL=Overwrite.js.map


/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var util_1 = __webpack_require__(1);
	var childSet_1 = __webpack_require__(143);
	var util_2 = __webpack_require__(1);
	var Node_1 = __webpack_require__(19);
	var PriorityIndex_1 = __webpack_require__(15);
	var KeyIndex_1 = __webpack_require__(49);
	var _defaultIndexMap;
	var fallbackObject = {};
	/**
	 *
	 * @param {Object.<string, FallbackType|SortedMap.<NamedNode, Node>>} indexes
	 * @param {Object.<string, Index>} indexSet
	 * @constructor
	 */
	var IndexMap = /** @class */ (function () {
	    function IndexMap(indexes_, indexSet_) {
	        this.indexes_ = indexes_;
	        this.indexSet_ = indexSet_;
	    }
	    Object.defineProperty(IndexMap, "Default", {
	        /**
	         * The default IndexMap for nodes without a priority
	         * @type {!IndexMap}
	         * @const
	         */
	        get: function () {
	            util_1.assert(fallbackObject && PriorityIndex_1.PRIORITY_INDEX, 'ChildrenNode.ts has not been loaded');
	            _defaultIndexMap =
	                _defaultIndexMap ||
	                    new IndexMap({ '.priority': fallbackObject }, { '.priority': PriorityIndex_1.PRIORITY_INDEX });
	            return _defaultIndexMap;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    /**
	     *
	     * @param {!string} indexKey
	     * @return {?SortedMap.<NamedNode, Node>}
	     */
	    IndexMap.prototype.get = function (indexKey) {
	        var sortedMap = util_2.safeGet(this.indexes_, indexKey);
	        if (!sortedMap)
	            throw new Error('No index defined for ' + indexKey);
	        if (sortedMap === fallbackObject) {
	            // The index exists, but it falls back to just name comparison. Return null so that the calling code uses the
	            // regular child map
	            return null;
	        }
	        else {
	            return sortedMap;
	        }
	    };
	    /**
	     * @param {!Index} indexDefinition
	     * @return {boolean}
	     */
	    IndexMap.prototype.hasIndex = function (indexDefinition) {
	        return util_2.contains(this.indexSet_, indexDefinition.toString());
	    };
	    /**
	     * @param {!Index} indexDefinition
	     * @param {!SortedMap.<string, !Node>} existingChildren
	     * @return {!IndexMap}
	     */
	    IndexMap.prototype.addIndex = function (indexDefinition, existingChildren) {
	        util_1.assert(indexDefinition !== KeyIndex_1.KEY_INDEX, "KeyIndex always exists and isn't meant to be added to the IndexMap.");
	        var childList = [];
	        var sawIndexedValue = false;
	        var iter = existingChildren.getIterator(Node_1.NamedNode.Wrap);
	        var next = iter.getNext();
	        while (next) {
	            sawIndexedValue =
	                sawIndexedValue || indexDefinition.isDefinedOn(next.node);
	            childList.push(next);
	            next = iter.getNext();
	        }
	        var newIndex;
	        if (sawIndexedValue) {
	            newIndex = childSet_1.buildChildSet(childList, indexDefinition.getCompare());
	        }
	        else {
	            newIndex = fallbackObject;
	        }
	        var indexName = indexDefinition.toString();
	        var newIndexSet = util_2.clone(this.indexSet_);
	        newIndexSet[indexName] = indexDefinition;
	        var newIndexes = util_2.clone(this.indexes_);
	        newIndexes[indexName] = newIndex;
	        return new IndexMap(newIndexes, newIndexSet);
	    };
	    /**
	     * Ensure that this node is properly tracked in any indexes that we're maintaining
	     * @param {!NamedNode} namedNode
	     * @param {!SortedMap.<string, !Node>} existingChildren
	     * @return {!IndexMap}
	     */
	    IndexMap.prototype.addToIndexes = function (namedNode, existingChildren) {
	        var _this = this;
	        var newIndexes = util_2.map(this.indexes_, function (indexedChildren, indexName) {
	            var index = util_2.safeGet(_this.indexSet_, indexName);
	            util_1.assert(index, 'Missing index implementation for ' + indexName);
	            if (indexedChildren === fallbackObject) {
	                // Check to see if we need to index everything
	                if (index.isDefinedOn(namedNode.node)) {
	                    // We need to build this index
	                    var childList = [];
	                    var iter = existingChildren.getIterator(Node_1.NamedNode.Wrap);
	                    var next = iter.getNext();
	                    while (next) {
	                        if (next.name != namedNode.name) {
	                            childList.push(next);
	                        }
	                        next = iter.getNext();
	                    }
	                    childList.push(namedNode);
	                    return childSet_1.buildChildSet(childList, index.getCompare());
	                }
	                else {
	                    // No change, this remains a fallback
	                    return fallbackObject;
	                }
	            }
	            else {
	                var existingSnap = existingChildren.get(namedNode.name);
	                var newChildren = indexedChildren;
	                if (existingSnap) {
	                    newChildren = newChildren.remove(new Node_1.NamedNode(namedNode.name, existingSnap));
	                }
	                return newChildren.insert(namedNode, namedNode.node);
	            }
	        });
	        return new IndexMap(newIndexes, this.indexSet_);
	    };
	    /**
	     * Create a new IndexMap instance with the given value removed
	     * @param {!NamedNode} namedNode
	     * @param {!SortedMap.<string, !Node>} existingChildren
	     * @return {!IndexMap}
	     */
	    IndexMap.prototype.removeFromIndexes = function (namedNode, existingChildren) {
	        var newIndexes = util_2.map(this.indexes_, function (indexedChildren) {
	            if (indexedChildren === fallbackObject) {
	                // This is the fallback. Just return it, nothing to do in this case
	                return indexedChildren;
	            }
	            else {
	                var existingSnap = existingChildren.get(namedNode.name);
	                if (existingSnap) {
	                    return indexedChildren.remove(new Node_1.NamedNode(namedNode.name, existingSnap));
	                }
	                else {
	                    // No record of this child
	                    return indexedChildren;
	                }
	            }
	        });
	        return new IndexMap(newIndexes, this.indexSet_);
	    };
	    return IndexMap;
	}());
	exports.IndexMap = IndexMap;
	
	//# sourceMappingURL=IndexMap.js.map


/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var SortedMap_1 = __webpack_require__(69);
	var SortedMap_2 = __webpack_require__(69);
	var LOG_2 = Math.log(2);
	/**
	 * @constructor
	 */
	var Base12Num = /** @class */ (function () {
	    /**
	     * @param {number} length
	     */
	    function Base12Num(length) {
	        var logBase2 = function (num) {
	            return parseInt((Math.log(num) / LOG_2), 10);
	        };
	        var bitMask = function (bits) { return parseInt(Array(bits + 1).join('1'), 2); };
	        this.count = logBase2(length + 1);
	        this.current_ = this.count - 1;
	        var mask = bitMask(this.count);
	        this.bits_ = (length + 1) & mask;
	    }
	    /**
	     * @return {boolean}
	     */
	    Base12Num.prototype.nextBitIsOne = function () {
	        //noinspection JSBitwiseOperatorUsage
	        var result = !(this.bits_ & (0x1 << this.current_));
	        this.current_--;
	        return result;
	    };
	    return Base12Num;
	}());
	/**
	 * Takes a list of child nodes and constructs a SortedSet using the given comparison
	 * function
	 *
	 * Uses the algorithm described in the paper linked here:
	 * http://citeseerx.ist.psu.edu/viewdoc/summary?doi=10.1.1.46.1458
	 *
	 * @template K, V
	 * @param {Array.<!NamedNode>} childList Unsorted list of children
	 * @param {function(!NamedNode, !NamedNode):number} cmp The comparison method to be used
	 * @param {(function(NamedNode):K)=} keyFn An optional function to extract K from a node wrapper, if K's
	 *                                                        type is not NamedNode
	 * @param {(function(K, K):number)=} mapSortFn An optional override for comparator used by the generated sorted map
	 * @return {SortedMap.<K, V>}
	 */
	exports.buildChildSet = function (childList, cmp, keyFn, mapSortFn) {
	    childList.sort(cmp);
	    var buildBalancedTree = function (low, high) {
	        var length = high - low;
	        var namedNode;
	        var key;
	        if (length == 0) {
	            return null;
	        }
	        else if (length == 1) {
	            namedNode = childList[low];
	            key = keyFn ? keyFn(namedNode) : namedNode;
	            return new SortedMap_1.LLRBNode(key, namedNode.node, SortedMap_1.LLRBNode.BLACK, null, null);
	        }
	        else {
	            var middle = parseInt((length / 2), 10) + low;
	            var left = buildBalancedTree(low, middle);
	            var right = buildBalancedTree(middle + 1, high);
	            namedNode = childList[middle];
	            key = keyFn ? keyFn(namedNode) : namedNode;
	            return new SortedMap_1.LLRBNode(key, namedNode.node, SortedMap_1.LLRBNode.BLACK, left, right);
	        }
	    };
	    var buildFrom12Array = function (base12) {
	        var node = null;
	        var root = null;
	        var index = childList.length;
	        var buildPennant = function (chunkSize, color) {
	            var low = index - chunkSize;
	            var high = index;
	            index -= chunkSize;
	            var childTree = buildBalancedTree(low + 1, high);
	            var namedNode = childList[low];
	            var key = keyFn ? keyFn(namedNode) : namedNode;
	            attachPennant(new SortedMap_1.LLRBNode(key, namedNode.node, color, null, childTree));
	        };
	        var attachPennant = function (pennant) {
	            if (node) {
	                node.left = pennant;
	                node = pennant;
	            }
	            else {
	                root = pennant;
	                node = pennant;
	            }
	        };
	        for (var i = 0; i < base12.count; ++i) {
	            var isOne = base12.nextBitIsOne();
	            // The number of nodes taken in each slice is 2^(arr.length - (i + 1))
	            var chunkSize = Math.pow(2, base12.count - (i + 1));
	            if (isOne) {
	                buildPennant(chunkSize, SortedMap_1.LLRBNode.BLACK);
	            }
	            else {
	                // current == 2
	                buildPennant(chunkSize, SortedMap_1.LLRBNode.BLACK);
	                buildPennant(chunkSize, SortedMap_1.LLRBNode.RED);
	            }
	        }
	        return root;
	    };
	    var base12 = new Base12Num(childList.length);
	    var root = buildFrom12Array(base12);
	    return new SortedMap_2.SortedMap(mapSortFn || cmp, root);
	};
	
	//# sourceMappingURL=childSet.js.map


/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var util_1 = __webpack_require__(4);
	function NAME_ONLY_COMPARATOR(left, right) {
	    return util_1.nameCompare(left.name, right.name);
	}
	exports.NAME_ONLY_COMPARATOR = NAME_ONLY_COMPARATOR;
	function NAME_COMPARATOR(left, right) {
	    return util_1.nameCompare(left, right);
	}
	exports.NAME_COMPARATOR = NAME_COMPARATOR;
	
	//# sourceMappingURL=comparators.js.map


/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var util_1 = __webpack_require__(1);
	var util_2 = __webpack_require__(4);
	var Index_1 = __webpack_require__(67);
	var ChildrenNode_1 = __webpack_require__(17);
	var Node_1 = __webpack_require__(19);
	var nodeFromJSON_1 = __webpack_require__(50);
	/**
	 * @param {!Path} indexPath
	 * @constructor
	 * @extends {Index}
	 */
	var PathIndex = /** @class */ (function (_super) {
	    __extends(PathIndex, _super);
	    function PathIndex(indexPath_) {
	        var _this = _super.call(this) || this;
	        _this.indexPath_ = indexPath_;
	        util_1.assert(!indexPath_.isEmpty() && indexPath_.getFront() !== '.priority', "Can't create PathIndex with empty path or .priority key");
	        return _this;
	    }
	    /**
	     * @param {!Node} snap
	     * @return {!Node}
	     * @protected
	     */
	    PathIndex.prototype.extractChild = function (snap) {
	        return snap.getChild(this.indexPath_);
	    };
	    /**
	     * @inheritDoc
	     */
	    PathIndex.prototype.isDefinedOn = function (node) {
	        return !node.getChild(this.indexPath_).isEmpty();
	    };
	    /**
	     * @inheritDoc
	     */
	    PathIndex.prototype.compare = function (a, b) {
	        var aChild = this.extractChild(a.node);
	        var bChild = this.extractChild(b.node);
	        var indexCmp = aChild.compareTo(bChild);
	        if (indexCmp === 0) {
	            return util_2.nameCompare(a.name, b.name);
	        }
	        else {
	            return indexCmp;
	        }
	    };
	    /**
	     * @inheritDoc
	     */
	    PathIndex.prototype.makePost = function (indexValue, name) {
	        var valueNode = nodeFromJSON_1.nodeFromJSON(indexValue);
	        var node = ChildrenNode_1.ChildrenNode.EMPTY_NODE.updateChild(this.indexPath_, valueNode);
	        return new Node_1.NamedNode(name, node);
	    };
	    /**
	     * @inheritDoc
	     */
	    PathIndex.prototype.maxPost = function () {
	        var node = ChildrenNode_1.ChildrenNode.EMPTY_NODE.updateChild(this.indexPath_, ChildrenNode_1.MAX_NODE);
	        return new Node_1.NamedNode(util_2.MAX_NAME, node);
	    };
	    /**
	     * @inheritDoc
	     */
	    PathIndex.prototype.toString = function () {
	        return this.indexPath_.slice().join('/');
	    };
	    return PathIndex;
	}(Index_1.Index));
	exports.PathIndex = PathIndex;
	
	//# sourceMappingURL=PathIndex.js.map


/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var Index_1 = __webpack_require__(67);
	var Node_1 = __webpack_require__(19);
	var util_1 = __webpack_require__(4);
	var nodeFromJSON_1 = __webpack_require__(50);
	/**
	 * @constructor
	 * @extends {Index}
	 * @private
	 */
	var ValueIndex = /** @class */ (function (_super) {
	    __extends(ValueIndex, _super);
	    function ValueIndex() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    /**
	     * @inheritDoc
	     */
	    ValueIndex.prototype.compare = function (a, b) {
	        var indexCmp = a.node.compareTo(b.node);
	        if (indexCmp === 0) {
	            return util_1.nameCompare(a.name, b.name);
	        }
	        else {
	            return indexCmp;
	        }
	    };
	    /**
	     * @inheritDoc
	     */
	    ValueIndex.prototype.isDefinedOn = function (node) {
	        return true;
	    };
	    /**
	     * @inheritDoc
	     */
	    ValueIndex.prototype.indexedValueChanged = function (oldNode, newNode) {
	        return !oldNode.equals(newNode);
	    };
	    /**
	     * @inheritDoc
	     */
	    ValueIndex.prototype.minPost = function () {
	        return Node_1.NamedNode.MIN;
	    };
	    /**
	     * @inheritDoc
	     */
	    ValueIndex.prototype.maxPost = function () {
	        return Node_1.NamedNode.MAX;
	    };
	    /**
	     * @param {*} indexValue
	     * @param {string} name
	     * @return {!NamedNode}
	     */
	    ValueIndex.prototype.makePost = function (indexValue, name) {
	        var valueNode = nodeFromJSON_1.nodeFromJSON(indexValue);
	        return new Node_1.NamedNode(name, valueNode);
	    };
	    /**
	     * @return {!string} String representation for inclusion in a query spec
	     */
	    ValueIndex.prototype.toString = function () {
	        return '.value';
	    };
	    return ValueIndex;
	}(Index_1.Index));
	exports.ValueIndex = ValueIndex;
	exports.VALUE_INDEX = new ValueIndex();
	
	//# sourceMappingURL=ValueIndex.js.map


/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var util_1 = __webpack_require__(1);
	var util_2 = __webpack_require__(4);
	var util_3 = __webpack_require__(1);
	var MAX_NODE;
	function setMaxNode(val) {
	    MAX_NODE = val;
	}
	exports.setMaxNode = setMaxNode;
	/**
	 * @param {(!string|!number)} priority
	 * @return {!string}
	 */
	exports.priorityHashText = function (priority) {
	    if (typeof priority === 'number')
	        return 'number:' + util_2.doubleToIEEE754String(priority);
	    else
	        return 'string:' + priority;
	};
	/**
	 * Validates that a priority snapshot Node is valid.
	 *
	 * @param {!Node} priorityNode
	 */
	exports.validatePriorityNode = function (priorityNode) {
	    if (priorityNode.isLeafNode()) {
	        var val = priorityNode.val();
	        util_1.assert(typeof val === 'string' ||
	            typeof val === 'number' ||
	            (typeof val === 'object' && util_3.contains(val, '.sv')), 'Priority must be a string or number.');
	    }
	    else {
	        util_1.assert(priorityNode === MAX_NODE || priorityNode.isEmpty(), 'priority of unexpected type.');
	    }
	    // Don't call getPriority() on MAX_NODE to avoid hitting assertion.
	    util_1.assert(priorityNode === MAX_NODE || priorityNode.getPriority().isEmpty(), "Priority nodes can't have a priority of their own.");
	};
	
	//# sourceMappingURL=snap.js.map


/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var util_1 = __webpack_require__(1);
	/**
	 * Returns the delta from the previous call to get stats.
	 *
	 * @param collection_ The collection to "listen" to.
	 * @constructor
	 */
	var StatsListener = /** @class */ (function () {
	    function StatsListener(collection_) {
	        this.collection_ = collection_;
	        this.last_ = null;
	    }
	    StatsListener.prototype.get = function () {
	        var newStats = this.collection_.get();
	        var delta = util_1.clone(newStats);
	        if (this.last_) {
	            util_1.forEach(this.last_, function (stat, value) {
	                delta[stat] = delta[stat] - value;
	            });
	        }
	        this.last_ = newStats;
	        return delta;
	    };
	    return StatsListener;
	}());
	exports.StatsListener = StatsListener;
	
	//# sourceMappingURL=StatsListener.js.map


/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var util_1 = __webpack_require__(1);
	/**
	 * Implements a set with a count of elements.
	 *
	 * @template K, V
	 */
	var CountedSet = /** @class */ (function () {
	    function CountedSet() {
	        this.set = {};
	    }
	    /**
	     * @param {!K} item
	     * @param {V} val
	     */
	    CountedSet.prototype.add = function (item, val) {
	        this.set[item] = val !== null ? val : true;
	    };
	    /**
	     * @param {!K} key
	     * @return {boolean}
	     */
	    CountedSet.prototype.contains = function (key) {
	        return util_1.contains(this.set, key);
	    };
	    /**
	     * @param {!K} item
	     * @return {V}
	     */
	    CountedSet.prototype.get = function (item) {
	        return this.contains(item) ? this.set[item] : undefined;
	    };
	    /**
	     * @param {!K} item
	     */
	    CountedSet.prototype.remove = function (item) {
	        delete this.set[item];
	    };
	    /**
	     * Deletes everything in the set
	     */
	    CountedSet.prototype.clear = function () {
	        this.set = {};
	    };
	    /**
	     * True if there's nothing in the set
	     * @return {boolean}
	     */
	    CountedSet.prototype.isEmpty = function () {
	        return util_1.isEmpty(this.set);
	    };
	    /**
	     * @return {number} The number of items in the set
	     */
	    CountedSet.prototype.count = function () {
	        return util_1.getCount(this.set);
	    };
	    /**
	     * Run a function on each k,v pair in the set
	     * @param {function(K, V)} fn
	     */
	    CountedSet.prototype.each = function (fn) {
	        util_1.forEach(this.set, function (k, v) { return fn(k, v); });
	    };
	    /**
	     * Mostly for debugging
	     * @return {Array.<K>} The keys present in this CountedSet
	     */
	    CountedSet.prototype.keys = function () {
	        var keys = [];
	        util_1.forEach(this.set, function (k) {
	            keys.push(k);
	        });
	        return keys;
	    };
	    return CountedSet;
	}());
	exports.CountedSet = CountedSet;
	
	//# sourceMappingURL=CountedSet.js.map


/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var util_1 = __webpack_require__(1);
	/**
	 * Base class to be used if you want to emit events. Call the constructor with
	 * the set of allowed event names.
	 */
	var EventEmitter = /** @class */ (function () {
	    /**
	     * @param {!Array.<string>} allowedEvents_
	     */
	    function EventEmitter(allowedEvents_) {
	        this.allowedEvents_ = allowedEvents_;
	        this.listeners_ = {};
	        util_1.assert(Array.isArray(allowedEvents_) && allowedEvents_.length > 0, 'Requires a non-empty array');
	    }
	    /**
	     * To be called by derived classes to trigger events.
	     * @param {!string} eventType
	     * @param {...*} var_args
	     */
	    EventEmitter.prototype.trigger = function (eventType) {
	        var var_args = [];
	        for (var _i = 1; _i < arguments.length; _i++) {
	            var_args[_i - 1] = arguments[_i];
	        }
	        if (Array.isArray(this.listeners_[eventType])) {
	            // Clone the list, since callbacks could add/remove listeners.
	            var listeners = this.listeners_[eventType].slice();
	            for (var i = 0; i < listeners.length; i++) {
	                listeners[i].callback.apply(listeners[i].context, var_args);
	            }
	        }
	    };
	    EventEmitter.prototype.on = function (eventType, callback, context) {
	        this.validateEventType_(eventType);
	        this.listeners_[eventType] = this.listeners_[eventType] || [];
	        this.listeners_[eventType].push({ callback: callback, context: context });
	        var eventData = this.getInitialEvent(eventType);
	        if (eventData) {
	            callback.apply(context, eventData);
	        }
	    };
	    EventEmitter.prototype.off = function (eventType, callback, context) {
	        this.validateEventType_(eventType);
	        var listeners = this.listeners_[eventType] || [];
	        for (var i = 0; i < listeners.length; i++) {
	            if (listeners[i].callback === callback &&
	                (!context || context === listeners[i].context)) {
	                listeners.splice(i, 1);
	                return;
	            }
	        }
	    };
	    EventEmitter.prototype.validateEventType_ = function (eventType) {
	        util_1.assert(this.allowedEvents_.find(function (et) {
	            return et === eventType;
	        }), 'Unknown event: ' + eventType);
	    };
	    return EventEmitter;
	}());
	exports.EventEmitter = EventEmitter;
	
	//# sourceMappingURL=EventEmitter.js.map


/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var util_1 = __webpack_require__(1);
	var Path_1 = __webpack_require__(8);
	var SparseSnapshotTree_1 = __webpack_require__(139);
	var LeafNode_1 = __webpack_require__(66);
	var nodeFromJSON_1 = __webpack_require__(50);
	var PriorityIndex_1 = __webpack_require__(15);
	/**
	 * Generate placeholders for deferred values.
	 * @param {?Object} values
	 * @return {!Object}
	 */
	exports.generateWithValues = function (values) {
	    values = values || {};
	    values['timestamp'] = values['timestamp'] || new Date().getTime();
	    return values;
	};
	/**
	 * Value to use when firing local events. When writing server values, fire
	 * local events with an approximate value, otherwise return value as-is.
	 * @param {(Object|string|number|boolean)} value
	 * @param {!Object} serverValues
	 * @return {!(string|number|boolean)}
	 */
	exports.resolveDeferredValue = function (value, serverValues) {
	    if (!value || typeof value !== 'object') {
	        return value;
	    }
	    else {
	        util_1.assert('.sv' in value, 'Unexpected leaf node or priority contents');
	        return serverValues[value['.sv']];
	    }
	};
	/**
	 * Recursively replace all deferred values and priorities in the tree with the
	 * specified generated replacement values.
	 * @param {!SparseSnapshotTree} tree
	 * @param {!Object} serverValues
	 * @return {!SparseSnapshotTree}
	 */
	exports.resolveDeferredValueTree = function (tree, serverValues) {
	    var resolvedTree = new SparseSnapshotTree_1.SparseSnapshotTree();
	    tree.forEachTree(new Path_1.Path(''), function (path, node) {
	        resolvedTree.remember(path, exports.resolveDeferredValueSnapshot(node, serverValues));
	    });
	    return resolvedTree;
	};
	/**
	 * Recursively replace all deferred values and priorities in the node with the
	 * specified generated replacement values.  If there are no server values in the node,
	 * it'll be returned as-is.
	 * @param {!Node} node
	 * @param {!Object} serverValues
	 * @return {!Node}
	 */
	exports.resolveDeferredValueSnapshot = function (node, serverValues) {
	    var rawPri = node.getPriority().val();
	    var priority = exports.resolveDeferredValue(rawPri, serverValues);
	    var newNode;
	    if (node.isLeafNode()) {
	        var leafNode = node;
	        var value = exports.resolveDeferredValue(leafNode.getValue(), serverValues);
	        if (value !== leafNode.getValue() ||
	            priority !== leafNode.getPriority().val()) {
	            return new LeafNode_1.LeafNode(value, nodeFromJSON_1.nodeFromJSON(priority));
	        }
	        else {
	            return node;
	        }
	    }
	    else {
	        var childrenNode = node;
	        newNode = childrenNode;
	        if (priority !== childrenNode.getPriority().val()) {
	            newNode = newNode.updatePriority(new LeafNode_1.LeafNode(priority));
	        }
	        childrenNode.forEachChild(PriorityIndex_1.PRIORITY_INDEX, function (childName, childNode) {
	            var newChildNode = exports.resolveDeferredValueSnapshot(childNode, serverValues);
	            if (newChildNode !== childNode) {
	                newNode = newNode.updateImmediateChild(childName, newChildNode);
	            }
	        });
	        return newNode;
	    }
	};
	
	//# sourceMappingURL=ServerValues.js.map


/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var Path_1 = __webpack_require__(8);
	var RepoInfo_1 = __webpack_require__(137);
	var util_1 = __webpack_require__(4);
	/**
	 * @param {!string} pathString
	 * @return {string}
	 */
	function decodePath(pathString) {
	    var pathStringDecoded = '';
	    var pieces = pathString.split('/');
	    for (var i = 0; i < pieces.length; i++) {
	        if (pieces[i].length > 0) {
	            var piece = pieces[i];
	            try {
	                piece = decodeURIComponent(piece.replace(/\+/g, ' '));
	            }
	            catch (e) { }
	            pathStringDecoded += '/' + piece;
	        }
	    }
	    return pathStringDecoded;
	}
	/**
	 *
	 * @param {!string} dataURL
	 * @return {{repoInfo: !RepoInfo, path: !Path}}
	 */
	exports.parseRepoInfo = function (dataURL) {
	    var parsedUrl = exports.parseURL(dataURL), namespace = parsedUrl.subdomain;
	    if (parsedUrl.domain === 'firebase') {
	        util_1.fatal(parsedUrl.host +
	            ' is no longer supported. ' +
	            'Please use <YOUR FIREBASE>.firebaseio.com instead');
	    }
	    // Catch common error of uninitialized namespace value.
	    if ((!namespace || namespace == 'undefined') &&
	        parsedUrl.domain !== 'localhost') {
	        util_1.fatal('Cannot parse Firebase url. Please use https://<YOUR FIREBASE>.firebaseio.com');
	    }
	    if (!parsedUrl.secure) {
	        util_1.warnIfPageIsSecure();
	    }
	    var webSocketOnly = parsedUrl.scheme === 'ws' || parsedUrl.scheme === 'wss';
	    return {
	        repoInfo: new RepoInfo_1.RepoInfo(parsedUrl.host, parsedUrl.secure, namespace, webSocketOnly),
	        path: new Path_1.Path(parsedUrl.pathString)
	    };
	};
	/**
	 *
	 * @param {!string} dataURL
	 * @return {{host: string, port: number, domain: string, subdomain: string, secure: boolean, scheme: string, pathString: string}}
	 */
	exports.parseURL = function (dataURL) {
	    // Default to empty strings in the event of a malformed string.
	    var host = '', domain = '', subdomain = '', pathString = '';
	    // Always default to SSL, unless otherwise specified.
	    var secure = true, scheme = 'https', port = 443;
	    // Don't do any validation here. The caller is responsible for validating the result of parsing.
	    if (typeof dataURL === 'string') {
	        // Parse scheme.
	        var colonInd = dataURL.indexOf('//');
	        if (colonInd >= 0) {
	            scheme = dataURL.substring(0, colonInd - 1);
	            dataURL = dataURL.substring(colonInd + 2);
	        }
	        // Parse host and path.
	        var slashInd = dataURL.indexOf('/');
	        if (slashInd === -1) {
	            slashInd = dataURL.length;
	        }
	        host = dataURL.substring(0, slashInd);
	        pathString = decodePath(dataURL.substring(slashInd));
	        // If we have a port, use scheme for determining if it's secure.
	        colonInd = host.indexOf(':');
	        if (colonInd >= 0) {
	            secure = scheme === 'https' || scheme === 'wss';
	            port = parseInt(host.substring(colonInd + 1), 10);
	        }
	        else {
	            colonInd = dataURL.length;
	        }
	        var parts = host.split('.');
	        if (parts.length === 3) {
	            // Normalize namespaces to lowercase to share storage / connection.
	            domain = parts[1];
	            subdomain = parts[0].toLowerCase();
	        }
	        else if (parts.length === 2) {
	            domain = parts[0];
	        }
	        else if (parts[0].slice(0, colonInd).toLowerCase() === 'localhost') {
	            domain = 'localhost';
	        }
	    }
	    return {
	        host: host,
	        port: port,
	        domain: domain,
	        subdomain: subdomain,
	        secure: secure,
	        scheme: scheme,
	        pathString: pathString
	    };
	};
	
	//# sourceMappingURL=parser.js.map


/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var ChildrenNode_1 = __webpack_require__(17);
	var CacheNode_1 = __webpack_require__(70);
	/**
	 * Stores the data we have cached for a view.
	 *
	 * serverSnap is the cached server data, eventSnap is the cached event data (server data plus any local writes).
	 *
	 * @constructor
	 */
	var ViewCache = /** @class */ (function () {
	    /**
	     *
	     * @param {!CacheNode} eventCache_
	     * @param {!CacheNode} serverCache_
	     */
	    function ViewCache(eventCache_, serverCache_) {
	        this.eventCache_ = eventCache_;
	        this.serverCache_ = serverCache_;
	    }
	    /**
	     * @param {!Node} eventSnap
	     * @param {boolean} complete
	     * @param {boolean} filtered
	     * @return {!ViewCache}
	     */
	    ViewCache.prototype.updateEventSnap = function (eventSnap, complete, filtered) {
	        return new ViewCache(new CacheNode_1.CacheNode(eventSnap, complete, filtered), this.serverCache_);
	    };
	    /**
	     * @param {!Node} serverSnap
	     * @param {boolean} complete
	     * @param {boolean} filtered
	     * @return {!ViewCache}
	     */
	    ViewCache.prototype.updateServerSnap = function (serverSnap, complete, filtered) {
	        return new ViewCache(this.eventCache_, new CacheNode_1.CacheNode(serverSnap, complete, filtered));
	    };
	    /**
	     * @return {!CacheNode}
	     */
	    ViewCache.prototype.getEventCache = function () {
	        return this.eventCache_;
	    };
	    /**
	     * @return {?Node}
	     */
	    ViewCache.prototype.getCompleteEventSnap = function () {
	        return this.eventCache_.isFullyInitialized()
	            ? this.eventCache_.getNode()
	            : null;
	    };
	    /**
	     * @return {!CacheNode}
	     */
	    ViewCache.prototype.getServerCache = function () {
	        return this.serverCache_;
	    };
	    /**
	     * @return {?Node}
	     */
	    ViewCache.prototype.getCompleteServerSnap = function () {
	        return this.serverCache_.isFullyInitialized()
	            ? this.serverCache_.getNode()
	            : null;
	    };
	    /**
	     * @const
	     * @type {ViewCache}
	     */
	    ViewCache.Empty = new ViewCache(new CacheNode_1.CacheNode(ChildrenNode_1.ChildrenNode.EMPTY_NODE, 
	    /*fullyInitialized=*/ false, 
	    /*filtered=*/ false), new CacheNode_1.CacheNode(ChildrenNode_1.ChildrenNode.EMPTY_NODE, 
	    /*fullyInitialized=*/ false, 
	    /*filtered=*/ false));
	    return ViewCache;
	}());
	exports.ViewCache = ViewCache;
	
	//# sourceMappingURL=ViewCache.js.map


/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var IndexedFilter_1 = __webpack_require__(94);
	var PriorityIndex_1 = __webpack_require__(15);
	var Node_1 = __webpack_require__(19);
	var ChildrenNode_1 = __webpack_require__(17);
	/**
	 * Filters nodes by range and uses an IndexFilter to track any changes after filtering the node
	 *
	 * @constructor
	 * @implements {NodeFilter}
	 */
	var RangedFilter = /** @class */ (function () {
	    /**
	     * @param {!QueryParams} params
	     */
	    function RangedFilter(params) {
	        this.indexedFilter_ = new IndexedFilter_1.IndexedFilter(params.getIndex());
	        this.index_ = params.getIndex();
	        this.startPost_ = RangedFilter.getStartPost_(params);
	        this.endPost_ = RangedFilter.getEndPost_(params);
	    }
	    /**
	     * @return {!NamedNode}
	     */
	    RangedFilter.prototype.getStartPost = function () {
	        return this.startPost_;
	    };
	    /**
	     * @return {!NamedNode}
	     */
	    RangedFilter.prototype.getEndPost = function () {
	        return this.endPost_;
	    };
	    /**
	     * @param {!NamedNode} node
	     * @return {boolean}
	     */
	    RangedFilter.prototype.matches = function (node) {
	        return (this.index_.compare(this.getStartPost(), node) <= 0 &&
	            this.index_.compare(node, this.getEndPost()) <= 0);
	    };
	    /**
	     * @inheritDoc
	     */
	    RangedFilter.prototype.updateChild = function (snap, key, newChild, affectedPath, source, optChangeAccumulator) {
	        if (!this.matches(new Node_1.NamedNode(key, newChild))) {
	            newChild = ChildrenNode_1.ChildrenNode.EMPTY_NODE;
	        }
	        return this.indexedFilter_.updateChild(snap, key, newChild, affectedPath, source, optChangeAccumulator);
	    };
	    /**
	     * @inheritDoc
	     */
	    RangedFilter.prototype.updateFullNode = function (oldSnap, newSnap, optChangeAccumulator) {
	        if (newSnap.isLeafNode()) {
	            // Make sure we have a children node with the correct index, not a leaf node;
	            newSnap = ChildrenNode_1.ChildrenNode.EMPTY_NODE;
	        }
	        var filtered = newSnap.withIndex(this.index_);
	        // Don't support priorities on queries
	        filtered = filtered.updatePriority(ChildrenNode_1.ChildrenNode.EMPTY_NODE);
	        var self = this;
	        newSnap.forEachChild(PriorityIndex_1.PRIORITY_INDEX, function (key, childNode) {
	            if (!self.matches(new Node_1.NamedNode(key, childNode))) {
	                filtered = filtered.updateImmediateChild(key, ChildrenNode_1.ChildrenNode.EMPTY_NODE);
	            }
	        });
	        return this.indexedFilter_.updateFullNode(oldSnap, filtered, optChangeAccumulator);
	    };
	    /**
	     * @inheritDoc
	     */
	    RangedFilter.prototype.updatePriority = function (oldSnap, newPriority) {
	        // Don't support priorities on queries
	        return oldSnap;
	    };
	    /**
	     * @inheritDoc
	     */
	    RangedFilter.prototype.filtersNodes = function () {
	        return true;
	    };
	    /**
	     * @inheritDoc
	     */
	    RangedFilter.prototype.getIndexedFilter = function () {
	        return this.indexedFilter_;
	    };
	    /**
	     * @inheritDoc
	     */
	    RangedFilter.prototype.getIndex = function () {
	        return this.index_;
	    };
	    /**
	     * @param {!QueryParams} params
	     * @return {!NamedNode}
	     * @private
	     */
	    RangedFilter.getStartPost_ = function (params) {
	        if (params.hasStart()) {
	            var startName = params.getIndexStartName();
	            return params.getIndex().makePost(params.getIndexStartValue(), startName);
	        }
	        else {
	            return params.getIndex().minPost();
	        }
	    };
	    /**
	     * @param {!QueryParams} params
	     * @return {!NamedNode}
	     * @private
	     */
	    RangedFilter.getEndPost_ = function (params) {
	        if (params.hasEnd()) {
	            var endName = params.getIndexEndName();
	            return params.getIndex().makePost(params.getIndexEndValue(), endName);
	        }
	        else {
	            return params.getIndex().maxPost();
	        }
	    };
	    return RangedFilter;
	}());
	exports.RangedFilter = RangedFilter;
	
	//# sourceMappingURL=RangedFilter.js.map


/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var util_1 = __webpack_require__(4);
	var CountedSet_1 = __webpack_require__(149);
	var StatsManager_1 = __webpack_require__(92);
	var PacketReceiver_1 = __webpack_require__(257);
	var Constants_1 = __webpack_require__(71);
	var util_2 = __webpack_require__(1);
	var util_3 = __webpack_require__(1);
	// URL query parameters associated with longpolling
	exports.FIREBASE_LONGPOLL_START_PARAM = 'start';
	exports.FIREBASE_LONGPOLL_CLOSE_COMMAND = 'close';
	exports.FIREBASE_LONGPOLL_COMMAND_CB_NAME = 'pLPCommand';
	exports.FIREBASE_LONGPOLL_DATA_CB_NAME = 'pRTLPCB';
	exports.FIREBASE_LONGPOLL_ID_PARAM = 'id';
	exports.FIREBASE_LONGPOLL_PW_PARAM = 'pw';
	exports.FIREBASE_LONGPOLL_SERIAL_PARAM = 'ser';
	exports.FIREBASE_LONGPOLL_CALLBACK_ID_PARAM = 'cb';
	exports.FIREBASE_LONGPOLL_SEGMENT_NUM_PARAM = 'seg';
	exports.FIREBASE_LONGPOLL_SEGMENTS_IN_PACKET = 'ts';
	exports.FIREBASE_LONGPOLL_DATA_PARAM = 'd';
	exports.FIREBASE_LONGPOLL_DISCONN_FRAME_PARAM = 'disconn';
	exports.FIREBASE_LONGPOLL_DISCONN_FRAME_REQUEST_PARAM = 'dframe';
	//Data size constants.
	//TODO: Perf: the maximum length actually differs from browser to browser.
	// We should check what browser we're on and set accordingly.
	var MAX_URL_DATA_SIZE = 1870;
	var SEG_HEADER_SIZE = 30; //ie: &seg=8299234&ts=982389123&d=
	var MAX_PAYLOAD_SIZE = MAX_URL_DATA_SIZE - SEG_HEADER_SIZE;
	/**
	 * Keepalive period
	 * send a fresh request at minimum every 25 seconds. Opera has a maximum request
	 * length of 30 seconds that we can't exceed.
	 * @const
	 * @type {number}
	 */
	var KEEPALIVE_REQUEST_INTERVAL = 25000;
	/**
	 * How long to wait before aborting a long-polling connection attempt.
	 * @const
	 * @type {number}
	 */
	var LP_CONNECT_TIMEOUT = 30000;
	/**
	 * This class manages a single long-polling connection.
	 *
	 * @constructor
	 * @implements {Transport}
	 */
	var BrowserPollConnection = /** @class */ (function () {
	    /**
	     * @param {string} connId An identifier for this connection, used for logging
	     * @param {RepoInfo} repoInfo The info for the endpoint to send data to.
	     * @param {string=} transportSessionId Optional transportSessionid if we are reconnecting for an existing
	     *                                         transport session
	     * @param {string=}  lastSessionId Optional lastSessionId if the PersistentConnection has already created a
	     *                                     connection previously
	     */
	    function BrowserPollConnection(connId, repoInfo, transportSessionId, lastSessionId) {
	        this.connId = connId;
	        this.repoInfo = repoInfo;
	        this.transportSessionId = transportSessionId;
	        this.lastSessionId = lastSessionId;
	        this.bytesSent = 0;
	        this.bytesReceived = 0;
	        this.everConnected_ = false;
	        this.log_ = util_1.logWrapper(connId);
	        this.stats_ = StatsManager_1.StatsManager.getCollection(repoInfo);
	        this.urlFn = function (params) {
	            return repoInfo.connectionURL(Constants_1.LONG_POLLING, params);
	        };
	    }
	    /**
	     *
	     * @param {function(Object)} onMessage Callback when messages arrive
	     * @param {function()} onDisconnect Callback with connection lost.
	     */
	    BrowserPollConnection.prototype.open = function (onMessage, onDisconnect) {
	        var _this = this;
	        this.curSegmentNum = 0;
	        this.onDisconnect_ = onDisconnect;
	        this.myPacketOrderer = new PacketReceiver_1.PacketReceiver(onMessage);
	        this.isClosed_ = false;
	        this.connectTimeoutTimer_ = setTimeout(function () {
	            _this.log_('Timed out trying to connect.');
	            // Make sure we clear the host cache
	            _this.onClosed_();
	            _this.connectTimeoutTimer_ = null;
	        }, Math.floor(LP_CONNECT_TIMEOUT));
	        // Ensure we delay the creation of the iframe until the DOM is loaded.
	        util_1.executeWhenDOMReady(function () {
	            if (_this.isClosed_)
	                return;
	            //Set up a callback that gets triggered once a connection is set up.
	            _this.scriptTagHolder = new FirebaseIFrameScriptHolder(function () {
	                var args = [];
	                for (var _i = 0; _i < arguments.length; _i++) {
	                    args[_i] = arguments[_i];
	                }
	                var command = args[0], arg1 = args[1], arg2 = args[2], arg3 = args[3], arg4 = args[4];
	                _this.incrementIncomingBytes_(args);
	                if (!_this.scriptTagHolder)
	                    return; // we closed the connection.
	                if (_this.connectTimeoutTimer_) {
	                    clearTimeout(_this.connectTimeoutTimer_);
	                    _this.connectTimeoutTimer_ = null;
	                }
	                _this.everConnected_ = true;
	                if (command == exports.FIREBASE_LONGPOLL_START_PARAM) {
	                    _this.id = arg1;
	                    _this.password = arg2;
	                }
	                else if (command === exports.FIREBASE_LONGPOLL_CLOSE_COMMAND) {
	                    // Don't clear the host cache. We got a response from the server, so we know it's reachable
	                    if (arg1) {
	                        // We aren't expecting any more data (other than what the server's already in the process of sending us
	                        // through our already open polls), so don't send any more.
	                        _this.scriptTagHolder.sendNewPolls = false;
	                        // arg1 in this case is the last response number sent by the server. We should try to receive
	                        // all of the responses up to this one before closing
	                        _this.myPacketOrderer.closeAfter(arg1, function () {
	                            _this.onClosed_();
	                        });
	                    }
	                    else {
	                        _this.onClosed_();
	                    }
	                }
	                else {
	                    throw new Error('Unrecognized command received: ' + command);
	                }
	            }, function () {
	                var args = [];
	                for (var _i = 0; _i < arguments.length; _i++) {
	                    args[_i] = arguments[_i];
	                }
	                var pN = args[0], data = args[1];
	                _this.incrementIncomingBytes_(args);
	                _this.myPacketOrderer.handleResponse(pN, data);
	            }, function () {
	                _this.onClosed_();
	            }, _this.urlFn);
	            //Send the initial request to connect. The serial number is simply to keep the browser from pulling previous results
	            //from cache.
	            var urlParams = {};
	            urlParams[exports.FIREBASE_LONGPOLL_START_PARAM] = 't';
	            urlParams[exports.FIREBASE_LONGPOLL_SERIAL_PARAM] = Math.floor(Math.random() * 100000000);
	            if (_this.scriptTagHolder.uniqueCallbackIdentifier)
	                urlParams[exports.FIREBASE_LONGPOLL_CALLBACK_ID_PARAM] = _this.scriptTagHolder.uniqueCallbackIdentifier;
	            urlParams[Constants_1.VERSION_PARAM] = Constants_1.PROTOCOL_VERSION;
	            if (_this.transportSessionId) {
	                urlParams[Constants_1.TRANSPORT_SESSION_PARAM] = _this.transportSessionId;
	            }
	            if (_this.lastSessionId) {
	                urlParams[Constants_1.LAST_SESSION_PARAM] = _this.lastSessionId;
	            }
	            if (!util_3.isNodeSdk() &&
	                typeof location !== 'undefined' &&
	                location.href &&
	                location.href.indexOf(Constants_1.FORGE_DOMAIN) !== -1) {
	                urlParams[Constants_1.REFERER_PARAM] = Constants_1.FORGE_REF;
	            }
	            var connectURL = _this.urlFn(urlParams);
	            _this.log_('Connecting via long-poll to ' + connectURL);
	            _this.scriptTagHolder.addTag(connectURL, function () {
	                /* do nothing */
	            });
	        });
	    };
	    /**
	     * Call this when a handshake has completed successfully and we want to consider the connection established
	     */
	    BrowserPollConnection.prototype.start = function () {
	        this.scriptTagHolder.startLongPoll(this.id, this.password);
	        this.addDisconnectPingFrame(this.id, this.password);
	    };
	    /**
	     * Forces long polling to be considered as a potential transport
	     */
	    BrowserPollConnection.forceAllow = function () {
	        BrowserPollConnection.forceAllow_ = true;
	    };
	    /**
	     * Forces longpolling to not be considered as a potential transport
	     */
	    BrowserPollConnection.forceDisallow = function () {
	        BrowserPollConnection.forceDisallow_ = true;
	    };
	    // Static method, use string literal so it can be accessed in a generic way
	    BrowserPollConnection.isAvailable = function () {
	        // NOTE: In React-Native there's normally no 'document', but if you debug a React-Native app in
	        // the Chrome debugger, 'document' is defined, but document.createElement is null (2015/06/08).
	        return (BrowserPollConnection.forceAllow_ ||
	            (!BrowserPollConnection.forceDisallow_ &&
	                typeof document !== 'undefined' &&
	                document.createElement != null &&
	                !util_1.isChromeExtensionContentScript() &&
	                !util_1.isWindowsStoreApp() &&
	                !util_3.isNodeSdk()));
	    };
	    /**
	     * No-op for polling
	     */
	    BrowserPollConnection.prototype.markConnectionHealthy = function () { };
	    /**
	     * Stops polling and cleans up the iframe
	     * @private
	     */
	    BrowserPollConnection.prototype.shutdown_ = function () {
	        this.isClosed_ = true;
	        if (this.scriptTagHolder) {
	            this.scriptTagHolder.close();
	            this.scriptTagHolder = null;
	        }
	        //remove the disconnect frame, which will trigger an XHR call to the server to tell it we're leaving.
	        if (this.myDisconnFrame) {
	            document.body.removeChild(this.myDisconnFrame);
	            this.myDisconnFrame = null;
	        }
	        if (this.connectTimeoutTimer_) {
	            clearTimeout(this.connectTimeoutTimer_);
	            this.connectTimeoutTimer_ = null;
	        }
	    };
	    /**
	     * Triggered when this transport is closed
	     * @private
	     */
	    BrowserPollConnection.prototype.onClosed_ = function () {
	        if (!this.isClosed_) {
	            this.log_('Longpoll is closing itself');
	            this.shutdown_();
	            if (this.onDisconnect_) {
	                this.onDisconnect_(this.everConnected_);
	                this.onDisconnect_ = null;
	            }
	        }
	    };
	    /**
	     * External-facing close handler. RealTime has requested we shut down. Kill our connection and tell the server
	     * that we've left.
	     */
	    BrowserPollConnection.prototype.close = function () {
	        if (!this.isClosed_) {
	            this.log_('Longpoll is being closed.');
	            this.shutdown_();
	        }
	    };
	    /**
	     * Send the JSON object down to the server. It will need to be stringified, base64 encoded, and then
	     * broken into chunks (since URLs have a small maximum length).
	     * @param {!Object} data The JSON data to transmit.
	     */
	    BrowserPollConnection.prototype.send = function (data) {
	        var dataStr = util_2.stringify(data);
	        this.bytesSent += dataStr.length;
	        this.stats_.incrementCounter('bytes_sent', dataStr.length);
	        //first, lets get the base64-encoded data
	        var base64data = util_2.base64Encode(dataStr);
	        //We can only fit a certain amount in each URL, so we need to split this request
	        //up into multiple pieces if it doesn't fit in one request.
	        var dataSegs = util_1.splitStringBySize(base64data, MAX_PAYLOAD_SIZE);
	        //Enqueue each segment for transmission. We assign each chunk a sequential ID and a total number
	        //of segments so that we can reassemble the packet on the server.
	        for (var i = 0; i < dataSegs.length; i++) {
	            this.scriptTagHolder.enqueueSegment(this.curSegmentNum, dataSegs.length, dataSegs[i]);
	            this.curSegmentNum++;
	        }
	    };
	    /**
	     * This is how we notify the server that we're leaving.
	     * We aren't able to send requests with DHTML on a window close event, but we can
	     * trigger XHR requests in some browsers (everything but Opera basically).
	     * @param {!string} id
	     * @param {!string} pw
	     */
	    BrowserPollConnection.prototype.addDisconnectPingFrame = function (id, pw) {
	        if (util_3.isNodeSdk())
	            return;
	        this.myDisconnFrame = document.createElement('iframe');
	        var urlParams = {};
	        urlParams[exports.FIREBASE_LONGPOLL_DISCONN_FRAME_REQUEST_PARAM] = 't';
	        urlParams[exports.FIREBASE_LONGPOLL_ID_PARAM] = id;
	        urlParams[exports.FIREBASE_LONGPOLL_PW_PARAM] = pw;
	        this.myDisconnFrame.src = this.urlFn(urlParams);
	        this.myDisconnFrame.style.display = 'none';
	        document.body.appendChild(this.myDisconnFrame);
	    };
	    /**
	     * Used to track the bytes received by this client
	     * @param {*} args
	     * @private
	     */
	    BrowserPollConnection.prototype.incrementIncomingBytes_ = function (args) {
	        // TODO: This is an annoying perf hit just to track the number of incoming bytes.  Maybe it should be opt-in.
	        var bytesReceived = util_2.stringify(args).length;
	        this.bytesReceived += bytesReceived;
	        this.stats_.incrementCounter('bytes_received', bytesReceived);
	    };
	    return BrowserPollConnection;
	}());
	exports.BrowserPollConnection = BrowserPollConnection;
	/*********************************************************************************************
	 * A wrapper around an iframe that is used as a long-polling script holder.
	 * @constructor
	 *********************************************************************************************/
	var FirebaseIFrameScriptHolder = /** @class */ (function () {
	    /**
	     * @param commandCB - The callback to be called when control commands are recevied from the server.
	     * @param onMessageCB - The callback to be triggered when responses arrive from the server.
	     * @param onDisconnect - The callback to be triggered when this tag holder is closed
	     * @param urlFn - A function that provides the URL of the endpoint to send data to.
	     */
	    function FirebaseIFrameScriptHolder(commandCB, onMessageCB, onDisconnect, urlFn) {
	        this.onDisconnect = onDisconnect;
	        this.urlFn = urlFn;
	        //We maintain a count of all of the outstanding requests, because if we have too many active at once it can cause
	        //problems in some browsers.
	        /**
	         * @type {CountedSet.<number, number>}
	         */
	        this.outstandingRequests = new CountedSet_1.CountedSet();
	        //A queue of the pending segments waiting for transmission to the server.
	        this.pendingSegs = [];
	        //A serial number. We use this for two things:
	        // 1) A way to ensure the browser doesn't cache responses to polls
	        // 2) A way to make the server aware when long-polls arrive in a different order than we started them. The
	        //    server needs to release both polls in this case or it will cause problems in Opera since Opera can only execute
	        //    JSONP code in the order it was added to the iframe.
	        this.currentSerial = Math.floor(Math.random() * 100000000);
	        // This gets set to false when we're "closing down" the connection (e.g. we're switching transports but there's still
	        // incoming data from the server that we're waiting for).
	        this.sendNewPolls = true;
	        if (!util_3.isNodeSdk()) {
	            //Each script holder registers a couple of uniquely named callbacks with the window. These are called from the
	            //iframes where we put the long-polling script tags. We have two callbacks:
	            //   1) Command Callback - Triggered for control issues, like starting a connection.
	            //   2) Message Callback - Triggered when new data arrives.
	            this.uniqueCallbackIdentifier = util_1.LUIDGenerator();
	            window[exports.FIREBASE_LONGPOLL_COMMAND_CB_NAME + this.uniqueCallbackIdentifier] = commandCB;
	            window[exports.FIREBASE_LONGPOLL_DATA_CB_NAME + this.uniqueCallbackIdentifier] = onMessageCB;
	            //Create an iframe for us to add script tags to.
	            this.myIFrame = FirebaseIFrameScriptHolder.createIFrame_();
	            // Set the iframe's contents.
	            var script = '';
	            // if we set a javascript url, it's IE and we need to set the document domain. The javascript url is sufficient
	            // for ie9, but ie8 needs to do it again in the document itself.
	            if (this.myIFrame.src &&
	                this.myIFrame.src.substr(0, 'javascript:'.length) === 'javascript:') {
	                var currentDomain = document.domain;
	                script = '<script>document.domain="' + currentDomain + '";</script>';
	            }
	            var iframeContents = '<html><body>' + script + '</body></html>';
	            try {
	                this.myIFrame.doc.open();
	                this.myIFrame.doc.write(iframeContents);
	                this.myIFrame.doc.close();
	            }
	            catch (e) {
	                util_1.log('frame writing exception');
	                if (e.stack) {
	                    util_1.log(e.stack);
	                }
	                util_1.log(e);
	            }
	        }
	        else {
	            this.commandCB = commandCB;
	            this.onMessageCB = onMessageCB;
	        }
	    }
	    /**
	     * Each browser has its own funny way to handle iframes. Here we mush them all together into one object that I can
	     * actually use.
	     * @private
	     * @return {Element}
	     */
	    FirebaseIFrameScriptHolder.createIFrame_ = function () {
	        var iframe = document.createElement('iframe');
	        iframe.style.display = 'none';
	        // This is necessary in order to initialize the document inside the iframe
	        if (document.body) {
	            document.body.appendChild(iframe);
	            try {
	                // If document.domain has been modified in IE, this will throw an error, and we need to set the
	                // domain of the iframe's document manually. We can do this via a javascript: url as the src attribute
	                // Also note that we must do this *after* the iframe has been appended to the page. Otherwise it doesn't work.
	                var a = iframe.contentWindow.document;
	                if (!a) {
	                    // Apologies for the log-spam, I need to do something to keep closure from optimizing out the assignment above.
	                    util_1.log('No IE domain setting required');
	                }
	            }
	            catch (e) {
	                var domain = document.domain;
	                iframe.src =
	                    "javascript:void((function(){document.open();document.domain='" +
	                        domain +
	                        "';document.close();})())";
	            }
	        }
	        else {
	            // LongPollConnection attempts to delay initialization until the document is ready, so hopefully this
	            // never gets hit.
	            throw 'Document body has not initialized. Wait to initialize Firebase until after the document is ready.';
	        }
	        // Get the document of the iframe in a browser-specific way.
	        if (iframe.contentDocument) {
	            iframe.doc = iframe.contentDocument; // Firefox, Opera, Safari
	        }
	        else if (iframe.contentWindow) {
	            iframe.doc = iframe.contentWindow.document; // Internet Explorer
	        }
	        else if (iframe.document) {
	            iframe.doc = iframe.document; //others?
	        }
	        return iframe;
	    };
	    /**
	     * Cancel all outstanding queries and remove the frame.
	     */
	    FirebaseIFrameScriptHolder.prototype.close = function () {
	        var _this = this;
	        //Mark this iframe as dead, so no new requests are sent.
	        this.alive = false;
	        if (this.myIFrame) {
	            //We have to actually remove all of the html inside this iframe before removing it from the
	            //window, or IE will continue loading and executing the script tags we've already added, which
	            //can lead to some errors being thrown. Setting innerHTML seems to be the easiest way to do this.
	            this.myIFrame.doc.body.innerHTML = '';
	            setTimeout(function () {
	                if (_this.myIFrame !== null) {
	                    document.body.removeChild(_this.myIFrame);
	                    _this.myIFrame = null;
	                }
	            }, Math.floor(0));
	        }
	        if (util_3.isNodeSdk() && this.myID) {
	            var urlParams = {};
	            urlParams[exports.FIREBASE_LONGPOLL_DISCONN_FRAME_PARAM] = 't';
	            urlParams[exports.FIREBASE_LONGPOLL_ID_PARAM] = this.myID;
	            urlParams[exports.FIREBASE_LONGPOLL_PW_PARAM] = this.myPW;
	            var theURL = this.urlFn(urlParams);
	            FirebaseIFrameScriptHolder.nodeRestRequest(theURL);
	        }
	        // Protect from being called recursively.
	        var onDisconnect = this.onDisconnect;
	        if (onDisconnect) {
	            this.onDisconnect = null;
	            onDisconnect();
	        }
	    };
	    /**
	     * Actually start the long-polling session by adding the first script tag(s) to the iframe.
	     * @param {!string} id - The ID of this connection
	     * @param {!string} pw - The password for this connection
	     */
	    FirebaseIFrameScriptHolder.prototype.startLongPoll = function (id, pw) {
	        this.myID = id;
	        this.myPW = pw;
	        this.alive = true;
	        //send the initial request. If there are requests queued, make sure that we transmit as many as we are currently able to.
	        while (this.newRequest_()) { }
	    };
	    /**
	     * This is called any time someone might want a script tag to be added. It adds a script tag when there aren't
	     * too many outstanding requests and we are still alive.
	     *
	     * If there are outstanding packet segments to send, it sends one. If there aren't, it sends a long-poll anyways if
	     * needed.
	     */
	    FirebaseIFrameScriptHolder.prototype.newRequest_ = function () {
	        // We keep one outstanding request open all the time to receive data, but if we need to send data
	        // (pendingSegs.length > 0) then we create a new request to send the data.  The server will automatically
	        // close the old request.
	        if (this.alive &&
	            this.sendNewPolls &&
	            this.outstandingRequests.count() < (this.pendingSegs.length > 0 ? 2 : 1)) {
	            //construct our url
	            this.currentSerial++;
	            var urlParams = {};
	            urlParams[exports.FIREBASE_LONGPOLL_ID_PARAM] = this.myID;
	            urlParams[exports.FIREBASE_LONGPOLL_PW_PARAM] = this.myPW;
	            urlParams[exports.FIREBASE_LONGPOLL_SERIAL_PARAM] = this.currentSerial;
	            var theURL = this.urlFn(urlParams);
	            //Now add as much data as we can.
	            var curDataString = '';
	            var i = 0;
	            while (this.pendingSegs.length > 0) {
	                //first, lets see if the next segment will fit.
	                var nextSeg = this.pendingSegs[0];
	                if (nextSeg.d.length + SEG_HEADER_SIZE + curDataString.length <=
	                    MAX_URL_DATA_SIZE) {
	                    //great, the segment will fit. Lets append it.
	                    var theSeg = this.pendingSegs.shift();
	                    curDataString =
	                        curDataString +
	                            '&' +
	                            exports.FIREBASE_LONGPOLL_SEGMENT_NUM_PARAM +
	                            i +
	                            '=' +
	                            theSeg.seg +
	                            '&' +
	                            exports.FIREBASE_LONGPOLL_SEGMENTS_IN_PACKET +
	                            i +
	                            '=' +
	                            theSeg.ts +
	                            '&' +
	                            exports.FIREBASE_LONGPOLL_DATA_PARAM +
	                            i +
	                            '=' +
	                            theSeg.d;
	                    i++;
	                }
	                else {
	                    break;
	                }
	            }
	            theURL = theURL + curDataString;
	            this.addLongPollTag_(theURL, this.currentSerial);
	            return true;
	        }
	        else {
	            return false;
	        }
	    };
	    /**
	     * Queue a packet for transmission to the server.
	     * @param segnum - A sequential id for this packet segment used for reassembly
	     * @param totalsegs - The total number of segments in this packet
	     * @param data - The data for this segment.
	     */
	    FirebaseIFrameScriptHolder.prototype.enqueueSegment = function (segnum, totalsegs, data) {
	        //add this to the queue of segments to send.
	        this.pendingSegs.push({ seg: segnum, ts: totalsegs, d: data });
	        //send the data immediately if there isn't already data being transmitted, unless
	        //startLongPoll hasn't been called yet.
	        if (this.alive) {
	            this.newRequest_();
	        }
	    };
	    /**
	     * Add a script tag for a regular long-poll request.
	     * @param {!string} url - The URL of the script tag.
	     * @param {!number} serial - The serial number of the request.
	     * @private
	     */
	    FirebaseIFrameScriptHolder.prototype.addLongPollTag_ = function (url, serial) {
	        var _this = this;
	        //remember that we sent this request.
	        this.outstandingRequests.add(serial, 1);
	        var doNewRequest = function () {
	            _this.outstandingRequests.remove(serial);
	            _this.newRequest_();
	        };
	        // If this request doesn't return on its own accord (by the server sending us some data), we'll
	        // create a new one after the KEEPALIVE interval to make sure we always keep a fresh request open.
	        var keepaliveTimeout = setTimeout(doNewRequest, Math.floor(KEEPALIVE_REQUEST_INTERVAL));
	        var readyStateCB = function () {
	            // Request completed.  Cancel the keepalive.
	            clearTimeout(keepaliveTimeout);
	            // Trigger a new request so we can continue receiving data.
	            doNewRequest();
	        };
	        this.addTag(url, readyStateCB);
	    };
	    /**
	     * Add an arbitrary script tag to the iframe.
	     * @param {!string} url - The URL for the script tag source.
	     * @param {!function()} loadCB - A callback to be triggered once the script has loaded.
	     */
	    FirebaseIFrameScriptHolder.prototype.addTag = function (url, loadCB) {
	        var _this = this;
	        if (util_3.isNodeSdk()) {
	            this.doNodeLongPoll(url, loadCB);
	        }
	        else {
	            setTimeout(function () {
	                try {
	                    // if we're already closed, don't add this poll
	                    if (!_this.sendNewPolls)
	                        return;
	                    var newScript_1 = _this.myIFrame.doc.createElement('script');
	                    newScript_1.type = 'text/javascript';
	                    newScript_1.async = true;
	                    newScript_1.src = url;
	                    newScript_1.onload = newScript_1.onreadystatechange = function () {
	                        var rstate = newScript_1.readyState;
	                        if (!rstate || rstate === 'loaded' || rstate === 'complete') {
	                            newScript_1.onload = newScript_1.onreadystatechange = null;
	                            if (newScript_1.parentNode) {
	                                newScript_1.parentNode.removeChild(newScript_1);
	                            }
	                            loadCB();
	                        }
	                    };
	                    newScript_1.onerror = function () {
	                        util_1.log('Long-poll script failed to load: ' + url);
	                        _this.sendNewPolls = false;
	                        _this.close();
	                    };
	                    _this.myIFrame.doc.body.appendChild(newScript_1);
	                }
	                catch (e) {
	                    // TODO: we should make this error visible somehow
	                }
	            }, Math.floor(1));
	        }
	    };
	    return FirebaseIFrameScriptHolder;
	}());
	exports.FirebaseIFrameScriptHolder = FirebaseIFrameScriptHolder;
	
	//# sourceMappingURL=BrowserPollConnection.js.map


/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var util_1 = __webpack_require__(4);
	var storage_1 = __webpack_require__(68);
	var Constants_1 = __webpack_require__(71);
	var TransportManager_1 = __webpack_require__(256);
	// Abort upgrade attempt if it takes longer than 60s.
	var UPGRADE_TIMEOUT = 60000;
	// For some transports (WebSockets), we need to "validate" the transport by exchanging a few requests and responses.
	// If we haven't sent enough requests within 5s, we'll start sending noop ping requests.
	var DELAY_BEFORE_SENDING_EXTRA_REQUESTS = 5000;
	// If the initial data sent triggers a lot of bandwidth (i.e. it's a large put or a listen for a large amount of data)
	// then we may not be able to exchange our ping/pong requests within the healthy timeout.  So if we reach the timeout
	// but we've sent/received enough bytes, we don't cancel the connection.
	var BYTES_SENT_HEALTHY_OVERRIDE = 10 * 1024;
	var BYTES_RECEIVED_HEALTHY_OVERRIDE = 100 * 1024;
	var MESSAGE_TYPE = 't';
	var MESSAGE_DATA = 'd';
	var CONTROL_SHUTDOWN = 's';
	var CONTROL_RESET = 'r';
	var CONTROL_ERROR = 'e';
	var CONTROL_PONG = 'o';
	var SWITCH_ACK = 'a';
	var END_TRANSMISSION = 'n';
	var PING = 'p';
	var SERVER_HELLO = 'h';
	/**
	 * Creates a new real-time connection to the server using whichever method works
	 * best in the current browser.
	 *
	 * @constructor
	 */
	var Connection = /** @class */ (function () {
	    /**
	     * @param {!string} id - an id for this connection
	     * @param {!RepoInfo} repoInfo_ - the info for the endpoint to connect to
	     * @param {function(Object)} onMessage_ - the callback to be triggered when a server-push message arrives
	     * @param {function(number, string)} onReady_ - the callback to be triggered when this connection is ready to send messages.
	     * @param {function()} onDisconnect_ - the callback to be triggered when a connection was lost
	     * @param {function(string)} onKill_ - the callback to be triggered when this connection has permanently shut down.
	     * @param {string=} lastSessionId - last session id in persistent connection. is used to clean up old session in real-time server
	     */
	    function Connection(id, repoInfo_, onMessage_, onReady_, onDisconnect_, onKill_, lastSessionId) {
	        this.id = id;
	        this.repoInfo_ = repoInfo_;
	        this.onMessage_ = onMessage_;
	        this.onReady_ = onReady_;
	        this.onDisconnect_ = onDisconnect_;
	        this.onKill_ = onKill_;
	        this.lastSessionId = lastSessionId;
	        this.connectionCount = 0;
	        this.pendingDataMessages = [];
	        this.state_ = 0 /* CONNECTING */;
	        this.log_ = util_1.logWrapper('c:' + this.id + ':');
	        this.transportManager_ = new TransportManager_1.TransportManager(repoInfo_);
	        this.log_('Connection created');
	        this.start_();
	    }
	    /**
	     * Starts a connection attempt
	     * @private
	     */
	    Connection.prototype.start_ = function () {
	        var _this = this;
	        var conn = this.transportManager_.initialTransport();
	        this.conn_ = new conn(this.nextTransportId_(), this.repoInfo_, undefined, this.lastSessionId);
	        // For certain transports (WebSockets), we need to send and receive several messages back and forth before we
	        // can consider the transport healthy.
	        this.primaryResponsesRequired_ = conn['responsesRequiredToBeHealthy'] || 0;
	        var onMessageReceived = this.connReceiver_(this.conn_);
	        var onConnectionLost = this.disconnReceiver_(this.conn_);
	        this.tx_ = this.conn_;
	        this.rx_ = this.conn_;
	        this.secondaryConn_ = null;
	        this.isHealthy_ = false;
	        /*
	         * Firefox doesn't like when code from one iframe tries to create another iframe by way of the parent frame.
	         * This can occur in the case of a redirect, i.e. we guessed wrong on what server to connect to and received a reset.
	         * Somehow, setTimeout seems to make this ok. That doesn't make sense from a security perspective, since you should
	         * still have the context of your originating frame.
	         */
	        setTimeout(function () {
	            // this.conn_ gets set to null in some of the tests. Check to make sure it still exists before using it
	            _this.conn_ && _this.conn_.open(onMessageReceived, onConnectionLost);
	        }, Math.floor(0));
	        var healthyTimeout_ms = conn['healthyTimeout'] || 0;
	        if (healthyTimeout_ms > 0) {
	            this.healthyTimeout_ = util_1.setTimeoutNonBlocking(function () {
	                _this.healthyTimeout_ = null;
	                if (!_this.isHealthy_) {
	                    if (_this.conn_ &&
	                        _this.conn_.bytesReceived > BYTES_RECEIVED_HEALTHY_OVERRIDE) {
	                        _this.log_('Connection exceeded healthy timeout but has received ' +
	                            _this.conn_.bytesReceived +
	                            ' bytes.  Marking connection healthy.');
	                        _this.isHealthy_ = true;
	                        _this.conn_.markConnectionHealthy();
	                    }
	                    else if (_this.conn_ &&
	                        _this.conn_.bytesSent > BYTES_SENT_HEALTHY_OVERRIDE) {
	                        _this.log_('Connection exceeded healthy timeout but has sent ' +
	                            _this.conn_.bytesSent +
	                            ' bytes.  Leaving connection alive.');
	                        // NOTE: We don't want to mark it healthy, since we have no guarantee that the bytes have made it to
	                        // the server.
	                    }
	                    else {
	                        _this.log_('Closing unhealthy connection after timeout.');
	                        _this.close();
	                    }
	                }
	            }, Math.floor(healthyTimeout_ms));
	        }
	    };
	    /**
	     * @return {!string}
	     * @private
	     */
	    Connection.prototype.nextTransportId_ = function () {
	        return 'c:' + this.id + ':' + this.connectionCount++;
	    };
	    Connection.prototype.disconnReceiver_ = function (conn) {
	        var _this = this;
	        return function (everConnected) {
	            if (conn === _this.conn_) {
	                _this.onConnectionLost_(everConnected);
	            }
	            else if (conn === _this.secondaryConn_) {
	                _this.log_('Secondary connection lost.');
	                _this.onSecondaryConnectionLost_();
	            }
	            else {
	                _this.log_('closing an old connection');
	            }
	        };
	    };
	    Connection.prototype.connReceiver_ = function (conn) {
	        var _this = this;
	        return function (message) {
	            if (_this.state_ != 2 /* DISCONNECTED */) {
	                if (conn === _this.rx_) {
	                    _this.onPrimaryMessageReceived_(message);
	                }
	                else if (conn === _this.secondaryConn_) {
	                    _this.onSecondaryMessageReceived_(message);
	                }
	                else {
	                    _this.log_('message on old connection');
	                }
	            }
	        };
	    };
	    /**
	     *
	     * @param {Object} dataMsg An arbitrary data message to be sent to the server
	     */
	    Connection.prototype.sendRequest = function (dataMsg) {
	        // wrap in a data message envelope and send it on
	        var msg = { t: 'd', d: dataMsg };
	        this.sendData_(msg);
	    };
	    Connection.prototype.tryCleanupConnection = function () {
	        if (this.tx_ === this.secondaryConn_ && this.rx_ === this.secondaryConn_) {
	            this.log_('cleaning up and promoting a connection: ' + this.secondaryConn_.connId);
	            this.conn_ = this.secondaryConn_;
	            this.secondaryConn_ = null;
	            // the server will shutdown the old connection
	        }
	    };
	    Connection.prototype.onSecondaryControl_ = function (controlData) {
	        if (MESSAGE_TYPE in controlData) {
	            var cmd = controlData[MESSAGE_TYPE];
	            if (cmd === SWITCH_ACK) {
	                this.upgradeIfSecondaryHealthy_();
	            }
	            else if (cmd === CONTROL_RESET) {
	                // Most likely the session wasn't valid. Abandon the switch attempt
	                this.log_('Got a reset on secondary, closing it');
	                this.secondaryConn_.close();
	                // If we were already using this connection for something, than we need to fully close
	                if (this.tx_ === this.secondaryConn_ ||
	                    this.rx_ === this.secondaryConn_) {
	                    this.close();
	                }
	            }
	            else if (cmd === CONTROL_PONG) {
	                this.log_('got pong on secondary.');
	                this.secondaryResponsesRequired_--;
	                this.upgradeIfSecondaryHealthy_();
	            }
	        }
	    };
	    Connection.prototype.onSecondaryMessageReceived_ = function (parsedData) {
	        var layer = util_1.requireKey('t', parsedData);
	        var data = util_1.requireKey('d', parsedData);
	        if (layer == 'c') {
	            this.onSecondaryControl_(data);
	        }
	        else if (layer == 'd') {
	            // got a data message, but we're still second connection. Need to buffer it up
	            this.pendingDataMessages.push(data);
	        }
	        else {
	            throw new Error('Unknown protocol layer: ' + layer);
	        }
	    };
	    Connection.prototype.upgradeIfSecondaryHealthy_ = function () {
	        if (this.secondaryResponsesRequired_ <= 0) {
	            this.log_('Secondary connection is healthy.');
	            this.isHealthy_ = true;
	            this.secondaryConn_.markConnectionHealthy();
	            this.proceedWithUpgrade_();
	        }
	        else {
	            // Send a ping to make sure the connection is healthy.
	            this.log_('sending ping on secondary.');
	            this.secondaryConn_.send({ t: 'c', d: { t: PING, d: {} } });
	        }
	    };
	    Connection.prototype.proceedWithUpgrade_ = function () {
	        // tell this connection to consider itself open
	        this.secondaryConn_.start();
	        // send ack
	        this.log_('sending client ack on secondary');
	        this.secondaryConn_.send({ t: 'c', d: { t: SWITCH_ACK, d: {} } });
	        // send end packet on primary transport, switch to sending on this one
	        // can receive on this one, buffer responses until end received on primary transport
	        this.log_('Ending transmission on primary');
	        this.conn_.send({ t: 'c', d: { t: END_TRANSMISSION, d: {} } });
	        this.tx_ = this.secondaryConn_;
	        this.tryCleanupConnection();
	    };
	    Connection.prototype.onPrimaryMessageReceived_ = function (parsedData) {
	        // Must refer to parsedData properties in quotes, so closure doesn't touch them.
	        var layer = util_1.requireKey('t', parsedData);
	        var data = util_1.requireKey('d', parsedData);
	        if (layer == 'c') {
	            this.onControl_(data);
	        }
	        else if (layer == 'd') {
	            this.onDataMessage_(data);
	        }
	    };
	    Connection.prototype.onDataMessage_ = function (message) {
	        this.onPrimaryResponse_();
	        // We don't do anything with data messages, just kick them up a level
	        this.onMessage_(message);
	    };
	    Connection.prototype.onPrimaryResponse_ = function () {
	        if (!this.isHealthy_) {
	            this.primaryResponsesRequired_--;
	            if (this.primaryResponsesRequired_ <= 0) {
	                this.log_('Primary connection is healthy.');
	                this.isHealthy_ = true;
	                this.conn_.markConnectionHealthy();
	            }
	        }
	    };
	    Connection.prototype.onControl_ = function (controlData) {
	        var cmd = util_1.requireKey(MESSAGE_TYPE, controlData);
	        if (MESSAGE_DATA in controlData) {
	            var payload = controlData[MESSAGE_DATA];
	            if (cmd === SERVER_HELLO) {
	                this.onHandshake_(payload);
	            }
	            else if (cmd === END_TRANSMISSION) {
	                this.log_('recvd end transmission on primary');
	                this.rx_ = this.secondaryConn_;
	                for (var i = 0; i < this.pendingDataMessages.length; ++i) {
	                    this.onDataMessage_(this.pendingDataMessages[i]);
	                }
	                this.pendingDataMessages = [];
	                this.tryCleanupConnection();
	            }
	            else if (cmd === CONTROL_SHUTDOWN) {
	                // This was previously the 'onKill' callback passed to the lower-level connection
	                // payload in this case is the reason for the shutdown. Generally a human-readable error
	                this.onConnectionShutdown_(payload);
	            }
	            else if (cmd === CONTROL_RESET) {
	                // payload in this case is the host we should contact
	                this.onReset_(payload);
	            }
	            else if (cmd === CONTROL_ERROR) {
	                util_1.error('Server Error: ' + payload);
	            }
	            else if (cmd === CONTROL_PONG) {
	                this.log_('got pong on primary.');
	                this.onPrimaryResponse_();
	                this.sendPingOnPrimaryIfNecessary_();
	            }
	            else {
	                util_1.error('Unknown control packet command: ' + cmd);
	            }
	        }
	    };
	    /**
	     *
	     * @param {Object} handshake The handshake data returned from the server
	     * @private
	     */
	    Connection.prototype.onHandshake_ = function (handshake) {
	        var timestamp = handshake.ts;
	        var version = handshake.v;
	        var host = handshake.h;
	        this.sessionId = handshake.s;
	        this.repoInfo_.updateHost(host);
	        // if we've already closed the connection, then don't bother trying to progress further
	        if (this.state_ == 0 /* CONNECTING */) {
	            this.conn_.start();
	            this.onConnectionEstablished_(this.conn_, timestamp);
	            if (Constants_1.PROTOCOL_VERSION !== version) {
	                util_1.warn('Protocol version mismatch detected');
	            }
	            // TODO: do we want to upgrade? when? maybe a delay?
	            this.tryStartUpgrade_();
	        }
	    };
	    Connection.prototype.tryStartUpgrade_ = function () {
	        var conn = this.transportManager_.upgradeTransport();
	        if (conn) {
	            this.startUpgrade_(conn);
	        }
	    };
	    Connection.prototype.startUpgrade_ = function (conn) {
	        var _this = this;
	        this.secondaryConn_ = new conn(this.nextTransportId_(), this.repoInfo_, this.sessionId);
	        // For certain transports (WebSockets), we need to send and receive several messages back and forth before we
	        // can consider the transport healthy.
	        this.secondaryResponsesRequired_ =
	            conn['responsesRequiredToBeHealthy'] || 0;
	        var onMessage = this.connReceiver_(this.secondaryConn_);
	        var onDisconnect = this.disconnReceiver_(this.secondaryConn_);
	        this.secondaryConn_.open(onMessage, onDisconnect);
	        // If we haven't successfully upgraded after UPGRADE_TIMEOUT, give up and kill the secondary.
	        util_1.setTimeoutNonBlocking(function () {
	            if (_this.secondaryConn_) {
	                _this.log_('Timed out trying to upgrade.');
	                _this.secondaryConn_.close();
	            }
	        }, Math.floor(UPGRADE_TIMEOUT));
	    };
	    Connection.prototype.onReset_ = function (host) {
	        this.log_('Reset packet received.  New host: ' + host);
	        this.repoInfo_.updateHost(host);
	        // TODO: if we're already "connected", we need to trigger a disconnect at the next layer up.
	        // We don't currently support resets after the connection has already been established
	        if (this.state_ === 1 /* CONNECTED */) {
	            this.close();
	        }
	        else {
	            // Close whatever connections we have open and start again.
	            this.closeConnections_();
	            this.start_();
	        }
	    };
	    Connection.prototype.onConnectionEstablished_ = function (conn, timestamp) {
	        var _this = this;
	        this.log_('Realtime connection established.');
	        this.conn_ = conn;
	        this.state_ = 1 /* CONNECTED */;
	        if (this.onReady_) {
	            this.onReady_(timestamp, this.sessionId);
	            this.onReady_ = null;
	        }
	        // If after 5 seconds we haven't sent enough requests to the server to get the connection healthy,
	        // send some pings.
	        if (this.primaryResponsesRequired_ === 0) {
	            this.log_('Primary connection is healthy.');
	            this.isHealthy_ = true;
	        }
	        else {
	            util_1.setTimeoutNonBlocking(function () {
	                _this.sendPingOnPrimaryIfNecessary_();
	            }, Math.floor(DELAY_BEFORE_SENDING_EXTRA_REQUESTS));
	        }
	    };
	    Connection.prototype.sendPingOnPrimaryIfNecessary_ = function () {
	        // If the connection isn't considered healthy yet, we'll send a noop ping packet request.
	        if (!this.isHealthy_ && this.state_ === 1 /* CONNECTED */) {
	            this.log_('sending ping on primary.');
	            this.sendData_({ t: 'c', d: { t: PING, d: {} } });
	        }
	    };
	    Connection.prototype.onSecondaryConnectionLost_ = function () {
	        var conn = this.secondaryConn_;
	        this.secondaryConn_ = null;
	        if (this.tx_ === conn || this.rx_ === conn) {
	            // we are relying on this connection already in some capacity. Therefore, a failure is real
	            this.close();
	        }
	    };
	    /**
	     *
	     * @param {boolean} everConnected Whether or not the connection ever reached a server. Used to determine if
	     * we should flush the host cache
	     * @private
	     */
	    Connection.prototype.onConnectionLost_ = function (everConnected) {
	        this.conn_ = null;
	        // NOTE: IF you're seeing a Firefox error for this line, I think it might be because it's getting
	        // called on window close and RealtimeState.CONNECTING is no longer defined.  Just a guess.
	        if (!everConnected && this.state_ === 0 /* CONNECTING */) {
	            this.log_('Realtime connection failed.');
	            // Since we failed to connect at all, clear any cached entry for this namespace in case the machine went away
	            if (this.repoInfo_.isCacheableHost()) {
	                storage_1.PersistentStorage.remove('host:' + this.repoInfo_.host);
	                // reset the internal host to what we would show the user, i.e. <ns>.firebaseio.com
	                this.repoInfo_.internalHost = this.repoInfo_.host;
	            }
	        }
	        else if (this.state_ === 1 /* CONNECTED */) {
	            this.log_('Realtime connection lost.');
	        }
	        this.close();
	    };
	    /**
	     *
	     * @param {string} reason
	     * @private
	     */
	    Connection.prototype.onConnectionShutdown_ = function (reason) {
	        this.log_('Connection shutdown command received. Shutting down...');
	        if (this.onKill_) {
	            this.onKill_(reason);
	            this.onKill_ = null;
	        }
	        // We intentionally don't want to fire onDisconnect (kill is a different case),
	        // so clear the callback.
	        this.onDisconnect_ = null;
	        this.close();
	    };
	    Connection.prototype.sendData_ = function (data) {
	        if (this.state_ !== 1 /* CONNECTED */) {
	            throw 'Connection is not connected';
	        }
	        else {
	            this.tx_.send(data);
	        }
	    };
	    /**
	     * Cleans up this connection, calling the appropriate callbacks
	     */
	    Connection.prototype.close = function () {
	        if (this.state_ !== 2 /* DISCONNECTED */) {
	            this.log_('Closing realtime connection.');
	            this.state_ = 2 /* DISCONNECTED */;
	            this.closeConnections_();
	            if (this.onDisconnect_) {
	                this.onDisconnect_();
	                this.onDisconnect_ = null;
	            }
	        }
	    };
	    /**
	     *
	     * @private
	     */
	    Connection.prototype.closeConnections_ = function () {
	        this.log_('Shutting down all connections');
	        if (this.conn_) {
	            this.conn_.close();
	            this.conn_ = null;
	        }
	        if (this.secondaryConn_) {
	            this.secondaryConn_.close();
	            this.secondaryConn_ = null;
	        }
	        if (this.healthyTimeout_) {
	            clearTimeout(this.healthyTimeout_);
	            this.healthyTimeout_ = null;
	        }
	    };
	    return Connection;
	}());
	exports.Connection = Connection;
	
	//# sourceMappingURL=Connection.js.map


/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var app_1 = __webpack_require__(26);
	var util_1 = __webpack_require__(1);
	var util_2 = __webpack_require__(4);
	var StatsManager_1 = __webpack_require__(92);
	var Constants_1 = __webpack_require__(71);
	var util_3 = __webpack_require__(1);
	var storage_1 = __webpack_require__(68);
	var util_4 = __webpack_require__(1);
	var util_5 = __webpack_require__(1);
	var WEBSOCKET_MAX_FRAME_SIZE = 16384;
	var WEBSOCKET_KEEPALIVE_INTERVAL = 45000;
	var WebSocketImpl = null;
	if (typeof MozWebSocket !== 'undefined') {
	    WebSocketImpl = MozWebSocket;
	}
	else if (typeof WebSocket !== 'undefined') {
	    WebSocketImpl = WebSocket;
	}
	function setWebSocketImpl(impl) {
	    WebSocketImpl = impl;
	}
	exports.setWebSocketImpl = setWebSocketImpl;
	/**
	 * Create a new websocket connection with the given callbacks.
	 * @constructor
	 * @implements {Transport}
	 */
	var WebSocketConnection = /** @class */ (function () {
	    /**
	     * @param {string} connId identifier for this transport
	     * @param {RepoInfo} repoInfo The info for the websocket endpoint.
	     * @param {string=} transportSessionId Optional transportSessionId if this is connecting to an existing transport
	     *                                         session
	     * @param {string=} lastSessionId Optional lastSessionId if there was a previous connection
	     */
	    function WebSocketConnection(connId, repoInfo, transportSessionId, lastSessionId) {
	        this.connId = connId;
	        this.keepaliveTimer = null;
	        this.frames = null;
	        this.totalFrames = 0;
	        this.bytesSent = 0;
	        this.bytesReceived = 0;
	        this.log_ = util_2.logWrapper(this.connId);
	        this.stats_ = StatsManager_1.StatsManager.getCollection(repoInfo);
	        this.connURL = WebSocketConnection.connectionURL_(repoInfo, transportSessionId, lastSessionId);
	    }
	    /**
	     * @param {RepoInfo} repoInfo The info for the websocket endpoint.
	     * @param {string=} transportSessionId Optional transportSessionId if this is connecting to an existing transport
	     *                                         session
	     * @param {string=} lastSessionId Optional lastSessionId if there was a previous connection
	     * @return {string} connection url
	     * @private
	     */
	    WebSocketConnection.connectionURL_ = function (repoInfo, transportSessionId, lastSessionId) {
	        var urlParams = {};
	        urlParams[Constants_1.VERSION_PARAM] = Constants_1.PROTOCOL_VERSION;
	        if (!util_5.isNodeSdk() &&
	            typeof location !== 'undefined' &&
	            location.href &&
	            location.href.indexOf(Constants_1.FORGE_DOMAIN) !== -1) {
	            urlParams[Constants_1.REFERER_PARAM] = Constants_1.FORGE_REF;
	        }
	        if (transportSessionId) {
	            urlParams[Constants_1.TRANSPORT_SESSION_PARAM] = transportSessionId;
	        }
	        if (lastSessionId) {
	            urlParams[Constants_1.LAST_SESSION_PARAM] = lastSessionId;
	        }
	        return repoInfo.connectionURL(Constants_1.WEBSOCKET, urlParams);
	    };
	    /**
	     *
	     * @param onMessage Callback when messages arrive
	     * @param onDisconnect Callback with connection lost.
	     */
	    WebSocketConnection.prototype.open = function (onMessage, onDisconnect) {
	        var _this = this;
	        this.onDisconnect = onDisconnect;
	        this.onMessage = onMessage;
	        this.log_('Websocket connecting to ' + this.connURL);
	        this.everConnected_ = false;
	        // Assume failure until proven otherwise.
	        storage_1.PersistentStorage.set('previous_websocket_failure', true);
	        try {
	            if (util_5.isNodeSdk()) {
	                var device = util_3.CONSTANTS.NODE_ADMIN ? 'AdminNode' : 'Node';
	                // UA Format: Firebase/<wire_protocol>/<sdk_version>/<platform>/<device>
	                var options = {
	                    headers: {
	                        'User-Agent': "Firebase/" + Constants_1.PROTOCOL_VERSION + "/" + app_1.default.SDK_VERSION + "/" + process.platform + "/" + device
	                    }
	                };
	                // Plumb appropriate http_proxy environment variable into faye-websocket if it exists.
	                var env = process['env'];
	                var proxy = this.connURL.indexOf('wss://') == 0
	                    ? env['HTTPS_PROXY'] || env['https_proxy']
	                    : env['HTTP_PROXY'] || env['http_proxy'];
	                if (proxy) {
	                    options['proxy'] = { origin: proxy };
	                }
	                this.mySock = new WebSocketImpl(this.connURL, [], options);
	            }
	            else {
	                this.mySock = new WebSocketImpl(this.connURL);
	            }
	        }
	        catch (e) {
	            this.log_('Error instantiating WebSocket.');
	            var error = e.message || e.data;
	            if (error) {
	                this.log_(error);
	            }
	            this.onClosed_();
	            return;
	        }
	        this.mySock.onopen = function () {
	            _this.log_('Websocket connected.');
	            _this.everConnected_ = true;
	        };
	        this.mySock.onclose = function () {
	            _this.log_('Websocket connection was disconnected.');
	            _this.mySock = null;
	            _this.onClosed_();
	        };
	        this.mySock.onmessage = function (m) {
	            _this.handleIncomingFrame(m);
	        };
	        this.mySock.onerror = function (e) {
	            _this.log_('WebSocket error.  Closing connection.');
	            var error = e.message || e.data;
	            if (error) {
	                _this.log_(error);
	            }
	            _this.onClosed_();
	        };
	    };
	    /**
	     * No-op for websockets, we don't need to do anything once the connection is confirmed as open
	     */
	    WebSocketConnection.prototype.start = function () { };
	    WebSocketConnection.forceDisallow = function () {
	        WebSocketConnection.forceDisallow_ = true;
	    };
	    WebSocketConnection.isAvailable = function () {
	        var isOldAndroid = false;
	        if (typeof navigator !== 'undefined' && navigator.userAgent) {
	            var oldAndroidRegex = /Android ([0-9]{0,}\.[0-9]{0,})/;
	            var oldAndroidMatch = navigator.userAgent.match(oldAndroidRegex);
	            if (oldAndroidMatch && oldAndroidMatch.length > 1) {
	                if (parseFloat(oldAndroidMatch[1]) < 4.4) {
	                    isOldAndroid = true;
	                }
	            }
	        }
	        return (!isOldAndroid &&
	            WebSocketImpl !== null &&
	            !WebSocketConnection.forceDisallow_);
	    };
	    /**
	     * Returns true if we previously failed to connect with this transport.
	     * @return {boolean}
	     */
	    WebSocketConnection.previouslyFailed = function () {
	        // If our persistent storage is actually only in-memory storage,
	        // we default to assuming that it previously failed to be safe.
	        return (storage_1.PersistentStorage.isInMemoryStorage ||
	            storage_1.PersistentStorage.get('previous_websocket_failure') === true);
	    };
	    WebSocketConnection.prototype.markConnectionHealthy = function () {
	        storage_1.PersistentStorage.remove('previous_websocket_failure');
	    };
	    WebSocketConnection.prototype.appendFrame_ = function (data) {
	        this.frames.push(data);
	        if (this.frames.length == this.totalFrames) {
	            var fullMess = this.frames.join('');
	            this.frames = null;
	            var jsonMess = util_4.jsonEval(fullMess);
	            //handle the message
	            this.onMessage(jsonMess);
	        }
	    };
	    /**
	     * @param {number} frameCount The number of frames we are expecting from the server
	     * @private
	     */
	    WebSocketConnection.prototype.handleNewFrameCount_ = function (frameCount) {
	        this.totalFrames = frameCount;
	        this.frames = [];
	    };
	    /**
	     * Attempts to parse a frame count out of some text. If it can't, assumes a value of 1
	     * @param {!String} data
	     * @return {?String} Any remaining data to be process, or null if there is none
	     * @private
	     */
	    WebSocketConnection.prototype.extractFrameCount_ = function (data) {
	        util_1.assert(this.frames === null, 'We already have a frame buffer');
	        // TODO: The server is only supposed to send up to 9999 frames (i.e. length <= 4), but that isn't being enforced
	        // currently.  So allowing larger frame counts (length <= 6).  See https://app.asana.com/0/search/8688598998380/8237608042508
	        if (data.length <= 6) {
	            var frameCount = Number(data);
	            if (!isNaN(frameCount)) {
	                this.handleNewFrameCount_(frameCount);
	                return null;
	            }
	        }
	        this.handleNewFrameCount_(1);
	        return data;
	    };
	    /**
	     * Process a websocket frame that has arrived from the server.
	     * @param mess The frame data
	     */
	    WebSocketConnection.prototype.handleIncomingFrame = function (mess) {
	        if (this.mySock === null)
	            return; // Chrome apparently delivers incoming packets even after we .close() the connection sometimes.
	        var data = mess['data'];
	        this.bytesReceived += data.length;
	        this.stats_.incrementCounter('bytes_received', data.length);
	        this.resetKeepAlive();
	        if (this.frames !== null) {
	            // we're buffering
	            this.appendFrame_(data);
	        }
	        else {
	            // try to parse out a frame count, otherwise, assume 1 and process it
	            var remainingData = this.extractFrameCount_(data);
	            if (remainingData !== null) {
	                this.appendFrame_(remainingData);
	            }
	        }
	    };
	    /**
	     * Send a message to the server
	     * @param {Object} data The JSON object to transmit
	     */
	    WebSocketConnection.prototype.send = function (data) {
	        this.resetKeepAlive();
	        var dataStr = util_4.stringify(data);
	        this.bytesSent += dataStr.length;
	        this.stats_.incrementCounter('bytes_sent', dataStr.length);
	        //We can only fit a certain amount in each websocket frame, so we need to split this request
	        //up into multiple pieces if it doesn't fit in one request.
	        var dataSegs = util_2.splitStringBySize(dataStr, WEBSOCKET_MAX_FRAME_SIZE);
	        //Send the length header
	        if (dataSegs.length > 1) {
	            this.sendString_(String(dataSegs.length));
	        }
	        //Send the actual data in segments.
	        for (var i = 0; i < dataSegs.length; i++) {
	            this.sendString_(dataSegs[i]);
	        }
	    };
	    WebSocketConnection.prototype.shutdown_ = function () {
	        this.isClosed_ = true;
	        if (this.keepaliveTimer) {
	            clearInterval(this.keepaliveTimer);
	            this.keepaliveTimer = null;
	        }
	        if (this.mySock) {
	            this.mySock.close();
	            this.mySock = null;
	        }
	    };
	    WebSocketConnection.prototype.onClosed_ = function () {
	        if (!this.isClosed_) {
	            this.log_('WebSocket is closing itself');
	            this.shutdown_();
	            // since this is an internal close, trigger the close listener
	            if (this.onDisconnect) {
	                this.onDisconnect(this.everConnected_);
	                this.onDisconnect = null;
	            }
	        }
	    };
	    /**
	     * External-facing close handler.
	     * Close the websocket and kill the connection.
	     */
	    WebSocketConnection.prototype.close = function () {
	        if (!this.isClosed_) {
	            this.log_('WebSocket is being closed');
	            this.shutdown_();
	        }
	    };
	    /**
	     * Kill the current keepalive timer and start a new one, to ensure that it always fires N seconds after
	     * the last activity.
	     */
	    WebSocketConnection.prototype.resetKeepAlive = function () {
	        var _this = this;
	        clearInterval(this.keepaliveTimer);
	        this.keepaliveTimer = setInterval(function () {
	            //If there has been no websocket activity for a while, send a no-op
	            if (_this.mySock) {
	                _this.sendString_('0');
	            }
	            _this.resetKeepAlive();
	        }, Math.floor(WEBSOCKET_KEEPALIVE_INTERVAL));
	    };
	    /**
	     * Send a string over the websocket.
	     *
	     * @param {string} str String to send.
	     * @private
	     */
	    WebSocketConnection.prototype.sendString_ = function (str) {
	        // Firefox seems to sometimes throw exceptions (NS_ERROR_UNEXPECTED) from websocket .send()
	        // calls for some unknown reason.  We treat these as an error and disconnect.
	        // See https://app.asana.com/0/58926111402292/68021340250410
	        try {
	            this.mySock.send(str);
	        }
	        catch (e) {
	            this.log_('Exception thrown from WebSocket.send():', e.message || e.data, 'Closing connection.');
	            setTimeout(this.onClosed_.bind(this), 0);
	        }
	    };
	    /**
	     * Number of response before we consider the connection "healthy."
	     * @type {number}
	     */
	    WebSocketConnection.responsesRequiredToBeHealthy = 2;
	    /**
	     * Time to wait for the connection te become healthy before giving up.
	     * @type {number}
	     */
	    WebSocketConnection.healthyTimeout = 30000;
	    return WebSocketConnection;
	}());
	exports.WebSocketConnection = WebSocketConnection;
	
	//# sourceMappingURL=WebSocketConnection.js.map
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(58)))

/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var api_1 = __webpack_require__(103);
	/**
	 * An opaque base class for FieldValue sentinel objects in our public API,
	 * with public static methods for creating said sentinel objects.
	 */
	// tslint:disable-next-line:class-as-namespace  We use this as a base class.
	var FieldValueImpl = /** @class */ (function () {
	    function FieldValueImpl() {
	    }
	    FieldValueImpl.delete = function () {
	        return DeleteFieldValueImpl.instance;
	    };
	    FieldValueImpl.serverTimestamp = function () {
	        return ServerTimestampFieldValueImpl.instance;
	    };
	    FieldValueImpl.prototype.isEqual = function (other) {
	        return this === other;
	    };
	    return FieldValueImpl;
	}());
	exports.FieldValueImpl = FieldValueImpl;
	var DeleteFieldValueImpl = /** @class */ (function (_super) {
	    __extends(DeleteFieldValueImpl, _super);
	    function DeleteFieldValueImpl() {
	        return _super.call(this) || this;
	    }
	    /** Singleton instance. */
	    DeleteFieldValueImpl.instance = new DeleteFieldValueImpl();
	    return DeleteFieldValueImpl;
	}(FieldValueImpl));
	exports.DeleteFieldValueImpl = DeleteFieldValueImpl;
	var ServerTimestampFieldValueImpl = /** @class */ (function (_super) {
	    __extends(ServerTimestampFieldValueImpl, _super);
	    function ServerTimestampFieldValueImpl() {
	        return _super.call(this) || this;
	    }
	    /** Singleton instance. */
	    ServerTimestampFieldValueImpl.instance = new ServerTimestampFieldValueImpl();
	    return ServerTimestampFieldValueImpl;
	}(FieldValueImpl));
	exports.ServerTimestampFieldValueImpl = ServerTimestampFieldValueImpl;
	// Public instance that disallows construction at runtime. This constructor is
	// used when exporting FieldValueImpl on firebase.firestore.FieldValue and will
	// be called FieldValue publicly. Internally we still use FieldValueImpl which
	// has a type-checked private constructor. Note that FieldValueImpl and
	// PublicFieldValue can be used interchangeably in instanceof checks.
	// For our internal TypeScript code PublicFieldValue doesn't exist as a type,
	// and so we need to use FieldValueImpl as type and export it too.
	// tslint:disable-next-line:variable-name  We treat this as a class name.
	exports.PublicFieldValue = api_1.makeConstructorPrivate(FieldValueImpl, 'Use FieldValue.<field>() instead.');
	
	//# sourceMappingURL=field_value.js.map


/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var misc_1 = __webpack_require__(14);
	var DatabaseInfo = /** @class */ (function () {
	    /**
	     * Constructs a DatabaseInfo using the provided host, databaseId and
	     * persistenceKey.
	     *
	     * @param databaseId The database to use.
	     * @param persistenceKey A unique identifier for this Firestore's local
	     * storage (used in conjunction with the databaseId).
	     * @param host The Firestore backend host to connect to.
	     * @param ssl Whether to use SSL when connecting.
	     */
	    function DatabaseInfo(databaseId, persistenceKey, host, ssl) {
	        this.databaseId = databaseId;
	        this.persistenceKey = persistenceKey;
	        this.host = host;
	        this.ssl = ssl;
	    }
	    return DatabaseInfo;
	}());
	exports.DatabaseInfo = DatabaseInfo;
	/** The default database name for a project. */
	var DEFAULT_DATABASE_NAME = '(default)';
	/** Represents the database ID a Firestore client is associated with. */
	var DatabaseId = /** @class */ (function () {
	    function DatabaseId(projectId, database) {
	        this.projectId = projectId;
	        this.database = database ? database : DEFAULT_DATABASE_NAME;
	    }
	    Object.defineProperty(DatabaseId.prototype, "isDefaultDatabase", {
	        get: function () {
	            return this.database === DEFAULT_DATABASE_NAME;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    DatabaseId.prototype.isEqual = function (other) {
	        return (other instanceof DatabaseId &&
	            other.projectId === this.projectId &&
	            other.database === this.database);
	    };
	    DatabaseId.prototype.compareTo = function (other) {
	        return (misc_1.primitiveComparator(this.projectId, other.projectId) ||
	            misc_1.primitiveComparator(this.database, other.database));
	    };
	    return DatabaseId;
	}());
	exports.DatabaseId = DatabaseId;
	
	//# sourceMappingURL=database_info.js.map


/***/ }),
/* 160 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var RESERVED_BITS = 1;
	var GeneratorIds;
	(function (GeneratorIds) {
	    GeneratorIds[GeneratorIds["LocalStore"] = 0] = "LocalStore";
	    GeneratorIds[GeneratorIds["SyncEngine"] = 1] = "SyncEngine";
	})(GeneratorIds || (GeneratorIds = {}));
	/**
	 * TargetIdGenerator generates monotonically increasing integer IDs. There are
	 * separate generators for different scopes. While these generators will operate
	 * independently of each other, they are scoped, such that no two generators
	 * will ever produce the same ID. This is useful, because sometimes the backend
	 * may group IDs from separate parts of the client into the same ID space.
	 */
	var TargetIdGenerator = /** @class */ (function () {
	    function TargetIdGenerator(generatorId, initAfter) {
	        if (initAfter === void 0) { initAfter = 0; }
	        this.generatorId = generatorId;
	        // Replace the generator part of initAfter with this generator's ID.
	        var afterWithoutGenerator = (initAfter >> RESERVED_BITS) << RESERVED_BITS;
	        var afterGenerator = initAfter - afterWithoutGenerator;
	        if (afterGenerator >= generatorId) {
	            // For example, if:
	            //   this.generatorId = 0b0000
	            //   after = 0b1011
	            //   afterGenerator = 0b0001
	            // Then:
	            //   previous = 0b1010
	            //   next = 0b1100
	            this.previousId = afterWithoutGenerator | this.generatorId;
	        }
	        else {
	            // For example, if:
	            //   this.generatorId = 0b0001
	            //   after = 0b1010
	            //   afterGenerator = 0b0000
	            // Then:
	            //   previous = 0b1001
	            //   next = 0b1011
	            this.previousId =
	                (afterWithoutGenerator | this.generatorId) - (1 << RESERVED_BITS);
	        }
	    }
	    TargetIdGenerator.prototype.next = function () {
	        this.previousId += 1 << RESERVED_BITS;
	        return this.previousId;
	    };
	    TargetIdGenerator.forLocalStore = function (initAfter) {
	        if (initAfter === void 0) { initAfter = 0; }
	        return new TargetIdGenerator(GeneratorIds.LocalStore, initAfter);
	    };
	    TargetIdGenerator.forSyncEngine = function () {
	        return new TargetIdGenerator(GeneratorIds.SyncEngine);
	    };
	    return TargetIdGenerator;
	}());
	exports.TargetIdGenerator = TargetIdGenerator;
	
	//# sourceMappingURL=target_id_generator.js.map


/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var collections_1 = __webpack_require__(11);
	var persistence_promise_1 = __webpack_require__(18);
	/**
	 * A garbage collector implementation that eagerly collects documents as soon as
	 * they're no longer referenced in any of its registered GarbageSources.
	 *
	 * This implementation keeps track of a set of keys that are potentially garbage
	 * without keeping an exact reference count. During collectGarbage, the
	 * collector verifies that all potential garbage keys actually have no
	 * references by consulting its list of garbage sources.
	 */
	var EagerGarbageCollector = /** @class */ (function () {
	    function EagerGarbageCollector() {
	        this.isEager = true;
	        /**
	         * The garbage collectible sources to double-check during garbage collection.
	         */
	        this.sources = [];
	        /**
	         * A set of potentially garbage keys.
	         * PORTING NOTE: This would be a mutable set if Javascript had one.
	         */
	        this.potentialGarbage = collections_1.documentKeySet();
	    }
	    EagerGarbageCollector.prototype.addGarbageSource = function (garbageSource) {
	        this.sources.push(garbageSource);
	        garbageSource.setGarbageCollector(this);
	    };
	    EagerGarbageCollector.prototype.removeGarbageSource = function (garbageSource) {
	        this.sources.splice(this.sources.indexOf(garbageSource), 1);
	        garbageSource.setGarbageCollector(null);
	    };
	    EagerGarbageCollector.prototype.addPotentialGarbageKey = function (key) {
	        this.potentialGarbage = this.potentialGarbage.add(key);
	    };
	    EagerGarbageCollector.prototype.collectGarbage = function (txn) {
	        var _this = this;
	        var promises = [];
	        var garbageKeys = collections_1.documentKeySet();
	        this.potentialGarbage.forEach(function (key) {
	            var hasRefsPromise = _this.documentHasAnyReferences(txn, key);
	            promises.push(hasRefsPromise.next(function (hasRefs) {
	                // If there are no references, get the key.
	                if (!hasRefs) {
	                    garbageKeys = garbageKeys.add(key);
	                }
	                return persistence_promise_1.PersistencePromise.resolve();
	            }));
	        });
	        // Clear locally retained potential keys and returned confirmed garbage.
	        this.potentialGarbage = collections_1.documentKeySet();
	        return persistence_promise_1.PersistencePromise.waitFor(promises).next(function () { return garbageKeys; });
	    };
	    EagerGarbageCollector.prototype.documentHasAnyReferences = function (txn, key) {
	        var initial = persistence_promise_1.PersistencePromise.resolve(false);
	        return this.sources
	            .map(function (source) { return function () { return source.containsKey(txn, key); }; })
	            .reduce(function (promise, nextPromise) {
	            return promise.next(function (result) {
	                if (result) {
	                    return persistence_promise_1.PersistencePromise.resolve(true);
	                }
	                else {
	                    return nextPromise();
	                }
	            });
	        }, initial);
	    };
	    return EagerGarbageCollector;
	}());
	exports.EagerGarbageCollector = EagerGarbageCollector;
	
	//# sourceMappingURL=eager_garbage_collector.js.map


/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var sorted_map_1 = __webpack_require__(36);
	var collections_1 = __webpack_require__(11);
	var document_key_1 = __webpack_require__(12);
	/**
	 * DocumentSet is an immutable (copy-on-write) collection that holds documents
	 * in order specified by the provided comparator. We always add a document key
	 * comparator on top of what is provided to guarantee document equality based on
	 * the key.
	 */
	var DocumentSet = /** @class */ (function () {
	    /** The default ordering is by key if the comparator is omitted */
	    function DocumentSet(comp) {
	        // We are adding document key comparator to the end as it's the only
	        // guaranteed unique property of a document.
	        if (comp) {
	            this.comparator = function (d1, d2) {
	                return comp(d1, d2) || document_key_1.DocumentKey.comparator(d1.key, d2.key);
	            };
	        }
	        else {
	            this.comparator = function (d1, d2) {
	                return document_key_1.DocumentKey.comparator(d1.key, d2.key);
	            };
	        }
	        this.keyedMap = collections_1.documentMap();
	        this.sortedSet = new sorted_map_1.SortedMap(this.comparator);
	    }
	    /**
	     * Returns an empty copy of the existing DocumentSet, using the same
	     * comparator.
	     */
	    DocumentSet.emptySet = function (oldSet) {
	        return new DocumentSet(oldSet.comparator);
	    };
	    DocumentSet.prototype.has = function (key) {
	        return this.keyedMap.get(key) != null;
	    };
	    DocumentSet.prototype.get = function (key) {
	        return this.keyedMap.get(key);
	    };
	    DocumentSet.prototype.first = function () {
	        return this.sortedSet.minKey();
	    };
	    DocumentSet.prototype.last = function () {
	        return this.sortedSet.maxKey();
	    };
	    DocumentSet.prototype.isEmpty = function () {
	        return this.sortedSet.isEmpty();
	    };
	    /**
	     * Returns the index of the provided key in the document set, or -1 if the
	     * document key is not present in the set;
	     */
	    DocumentSet.prototype.indexOf = function (key) {
	        var doc = this.keyedMap.get(key);
	        return doc ? this.sortedSet.indexOf(doc) : -1;
	    };
	    Object.defineProperty(DocumentSet.prototype, "size", {
	        get: function () {
	            return this.sortedSet.size;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    /** Iterates documents in order defined by "comparator" */
	    DocumentSet.prototype.forEach = function (cb) {
	        this.sortedSet.inorderTraversal(function (k, v) {
	            cb(k);
	            return false;
	        });
	    };
	    /** Inserts or updates a document with the same key */
	    DocumentSet.prototype.add = function (doc) {
	        // First remove the element if we have it.
	        var set = this.delete(doc.key);
	        return set.copy(set.keyedMap.insert(doc.key, doc), set.sortedSet.insert(doc, null));
	    };
	    /** Deletes a document with a given key */
	    DocumentSet.prototype.delete = function (key) {
	        var doc = this.get(key);
	        if (!doc) {
	            return this;
	        }
	        return this.copy(this.keyedMap.remove(key), this.sortedSet.remove(doc));
	    };
	    DocumentSet.prototype.isEqual = function (other) {
	        if (!(other instanceof DocumentSet))
	            return false;
	        if (this.size !== other.size)
	            return false;
	        var thisIt = this.sortedSet.getIterator();
	        var otherIt = other.sortedSet.getIterator();
	        while (thisIt.hasNext()) {
	            var thisDoc = thisIt.getNext().key;
	            var otherDoc = otherIt.getNext().key;
	            if (!thisDoc.isEqual(otherDoc))
	                return false;
	        }
	        return true;
	    };
	    DocumentSet.prototype.toString = function () {
	        var docStrings = [];
	        this.forEach(function (doc) {
	            docStrings.push(doc.toString());
	        });
	        if (docStrings.length === 0) {
	            return 'DocumentSet ()';
	        }
	        else {
	            return 'DocumentSet (\n  ' + docStrings.join('  \n') + '\n)';
	        }
	    };
	    DocumentSet.prototype.copy = function (keyedMap, sortedSet) {
	        var newSet = new DocumentSet();
	        newSet.comparator = this.comparator;
	        newSet.keyedMap = keyedMap;
	        newSet.sortedSet = sortedSet;
	        return newSet;
	    };
	    return DocumentSet;
	}());
	exports.DocumentSet = DocumentSet;
	
	//# sourceMappingURL=document_set.js.map


/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var blob_1 = __webpack_require__(95);
	var geo_point_1 = __webpack_require__(97);
	var database_info_1 = __webpack_require__(159);
	var query_1 = __webpack_require__(98);
	var snapshot_version_1 = __webpack_require__(20);
	var timestamp_1 = __webpack_require__(40);
	var query_data_1 = __webpack_require__(51);
	var document_1 = __webpack_require__(21);
	var document_key_1 = __webpack_require__(12);
	var fieldValue = __webpack_require__(42);
	var mutation_1 = __webpack_require__(75);
	var path_1 = __webpack_require__(35);
	var assert_1 = __webpack_require__(2);
	var error_1 = __webpack_require__(10);
	var obj = __webpack_require__(27);
	var typeUtils = __webpack_require__(55);
	var existence_filter_1 = __webpack_require__(289);
	var rpc_error_1 = __webpack_require__(102);
	var watch_change_1 = __webpack_require__(164);
	var DIRECTIONS = (function () {
	    var dirs = {};
	    dirs[query_1.Direction.ASCENDING.name] = 'ASCENDING';
	    dirs[query_1.Direction.DESCENDING.name] = 'DESCENDING';
	    return dirs;
	})();
	var OPERATORS = (function () {
	    var ops = {};
	    ops[query_1.RelationOp.LESS_THAN.name] = 'LESS_THAN';
	    ops[query_1.RelationOp.LESS_THAN_OR_EQUAL.name] = 'LESS_THAN_OR_EQUAL';
	    ops[query_1.RelationOp.GREATER_THAN.name] = 'GREATER_THAN';
	    ops[query_1.RelationOp.GREATER_THAN_OR_EQUAL.name] = 'GREATER_THAN_OR_EQUAL';
	    ops[query_1.RelationOp.EQUAL.name] = 'EQUAL';
	    return ops;
	})();
	function assertPresent(value, description) {
	    assert_1.assert(!typeUtils.isNullOrUndefined(value), description + ' is missing');
	}
	function parseInt64(value) {
	    // TODO(bjornick): Handle int64 greater than 53 bits.
	    if (typeof value === 'number') {
	        return value;
	    }
	    else if (typeof value === 'string') {
	        return Number(value);
	    }
	    else {
	        return assert_1.fail("can't parse " + value);
	    }
	}
	/**
	 * Generates JsonObject values for the Datastore API suitable for sending to
	 * either GRPC stub methods or via the JSON/HTTP REST API.
	 * TODO(klimt): We can remove the databaseId argument if we keep the full
	 * resource name in documents.
	 */
	var JsonProtoSerializer = /** @class */ (function () {
	    function JsonProtoSerializer(databaseId, options) {
	        this.databaseId = databaseId;
	        this.options = options;
	    }
	    JsonProtoSerializer.prototype.emptyByteString = function () {
	        if (this.options.useProto3Json) {
	            return '';
	        }
	        else {
	            return new Uint8Array(0);
	        }
	    };
	    JsonProtoSerializer.prototype.unsafeCastProtoByteString = function (byteString) {
	        // byteStrings can be either string or UInt8Array, but the typings say
	        // it's always a string. Cast as string to avoid type check failing
	        return byteString;
	    };
	    JsonProtoSerializer.prototype.fromRpcStatus = function (status) {
	        var code = status.code === undefined
	            ? error_1.Code.UNKNOWN
	            : rpc_error_1.mapCodeFromRpcCode(status.code);
	        return new error_1.FirestoreError(code, status.message || '');
	    };
	    /**
	     * Returns a value for a number (or undefined) that's appropriate to put into
	     * a google.protobuf.Int32Value proto.
	     * DO NOT USE THIS FOR ANYTHING ELSE.
	     * This method cheats. It's typed as returning "number" because that's what
	     * our generated proto interfaces say Int32Value must be. But GRPC actually
	     * expects a { value: <number> } struct.
	     */
	    JsonProtoSerializer.prototype.toInt32Value = function (val) {
	        if (!typeUtils.isNullOrUndefined(val)) {
	            // tslint:disable-next-line:no-any We need to match generated Proto types.
	            return { value: val };
	        }
	        else {
	            return undefined;
	        }
	    };
	    /**
	     * Returns a number (or null) from a google.protobuf.Int32Value proto.
	     * DO NOT USE THIS FOR ANYTHING ELSE.
	     * This method cheats. It's typed as accepting "number" because that's what
	     * our generated proto interfaces say Int32Value must be, but it actually
	     * accepts { value: number } to match our serialization in toInt32Value().
	     */
	    JsonProtoSerializer.prototype.fromInt32Value = function (val) {
	        var result;
	        if (typeof val === 'object') {
	            // tslint:disable-next-line:no-any We need to match generated Proto types.
	            result = val.value;
	        }
	        else {
	            // We accept raw numbers (without the {value: ... } wrapper) for
	            // compatibility with legacy persisted data.
	            result = val;
	        }
	        return typeUtils.isNullOrUndefined(result) ? null : result;
	    };
	    /**
	     * Returns a value for a Date that's appropriate to put into a proto.
	     * DO NOT USE THIS FOR ANYTHING ELSE.
	     * This method cheats. It's typed as returning "string" because that's what
	     * our generated proto interfaces say dates must be. But it's easier and safer
	     * to actually return a Timestamp proto.
	     */
	    JsonProtoSerializer.prototype.toTimestamp = function (timestamp) {
	        return {
	            seconds: timestamp.seconds,
	            nanos: timestamp.nanos
	            // tslint:disable-next-line:no-any
	        };
	    };
	    JsonProtoSerializer.prototype.fromTimestamp = function (date) {
	        // The json interface (for the browser) will return an iso timestamp string,
	        // while the proto js library (for node) will return a
	        // google.protobuf.Timestamp instance.
	        if (typeof date === 'string') {
	            // TODO(b/37282237): Use strings for Proto3 timestamps
	            // assert(this.options.useProto3Json,
	            //   'The timestamp string format requires Proto3.');
	            return timestamp_1.Timestamp.fromISOString(date);
	        }
	        else {
	            assert_1.assert(!!date, 'Cannot deserialize null or undefined timestamp.');
	            // TODO(b/37282237): Use strings for Proto3 timestamps
	            // assert(!this.options.useProto3Json,
	            //   'The timestamp instance format requires Proto JS.');
	            var seconds = parseInt64(date.seconds || '0');
	            var nanos = date.nanos || 0;
	            return new timestamp_1.Timestamp(seconds, nanos);
	        }
	    };
	    /**
	     * Returns a value for bytes that's appropriate to put in a proto.
	     * DO NOT USE THIS FOR ANYTHING ELSE.
	     * This method cheats. It's typed as returning "string" because that's what
	     * our generated proto interfaces say bytes must be. But it should return
	     * an Uint8Array in Node.
	     */
	    JsonProtoSerializer.prototype.toBytes = function (bytes) {
	        if (this.options.useProto3Json) {
	            return bytes.toBase64();
	        }
	        else {
	            // The typings say it's a string, but it needs to be a Uint8Array in Node.
	            return this.unsafeCastProtoByteString(bytes.toUint8Array());
	        }
	    };
	    /**
	     * Parse the blob from the protos into the internal Blob class. Note that the
	     * typings assume all blobs are strings, but they are actually Uint8Arrays
	     * on Node.
	     */
	    JsonProtoSerializer.prototype.fromBlob = function (blob) {
	        if (typeof blob === 'string') {
	            assert_1.assert(this.options.useProto3Json, 'Expected bytes to be passed in as Uint8Array, but got a string instead.');
	            return blob_1.Blob.fromBase64String(blob);
	        }
	        else {
	            assert_1.assert(!this.options.useProto3Json, 'Expected bytes to be passed in as string, but got something else instead.');
	            return blob_1.Blob.fromUint8Array(blob);
	        }
	    };
	    JsonProtoSerializer.prototype.toVersion = function (version) {
	        return this.toTimestamp(version.toTimestamp());
	    };
	    JsonProtoSerializer.prototype.fromVersion = function (version) {
	        assert_1.assert(!!version, "Trying to deserialize version that isn't set");
	        return snapshot_version_1.SnapshotVersion.fromTimestamp(this.fromTimestamp(version));
	    };
	    JsonProtoSerializer.prototype.toResourceName = function (databaseId, path) {
	        return this.fullyQualifiedPrefixPath(databaseId)
	            .child('documents')
	            .child(path)
	            .canonicalString();
	    };
	    JsonProtoSerializer.prototype.fromResourceName = function (name) {
	        var resource = path_1.ResourcePath.fromString(name);
	        assert_1.assert(this.isValidResourceName(resource), 'Tried to deserialize invalid key ' + resource.toString());
	        return resource;
	    };
	    JsonProtoSerializer.prototype.toName = function (key) {
	        return this.toResourceName(this.databaseId, key.path);
	    };
	    JsonProtoSerializer.prototype.fromName = function (name) {
	        var resource = this.fromResourceName(name);
	        assert_1.assert(resource.get(1) === this.databaseId.projectId, 'Tried to deserialize key from different project: ' +
	            resource.get(1) +
	            ' vs ' +
	            this.databaseId.projectId);
	        assert_1.assert((!resource.get(3) && !this.databaseId.database) ||
	            resource.get(3) === this.databaseId.database, 'Tried to deserialize key from different database: ' +
	            resource.get(3) +
	            ' vs ' +
	            this.databaseId.database);
	        return new document_key_1.DocumentKey(this.extractLocalPathFromResourceName(resource));
	    };
	    JsonProtoSerializer.prototype.toQueryPath = function (path) {
	        if (path.length === 0) {
	            // If the path is empty, the backend requires we leave off the /documents
	            // at the end.
	            return this.encodedDatabaseId;
	        }
	        return this.toResourceName(this.databaseId, path);
	    };
	    JsonProtoSerializer.prototype.fromQueryPath = function (name) {
	        var resourceName = this.fromResourceName(name);
	        if (resourceName.length === 4) {
	            return path_1.ResourcePath.EMPTY_PATH;
	        }
	        return this.extractLocalPathFromResourceName(resourceName);
	    };
	    Object.defineProperty(JsonProtoSerializer.prototype, "encodedDatabaseId", {
	        get: function () {
	            var path = new path_1.ResourcePath([
	                'projects',
	                this.databaseId.projectId,
	                'databases',
	                this.databaseId.database
	            ]);
	            return path.canonicalString();
	        },
	        enumerable: true,
	        configurable: true
	    });
	    JsonProtoSerializer.prototype.fullyQualifiedPrefixPath = function (databaseId) {
	        return new path_1.ResourcePath([
	            'projects',
	            databaseId.projectId,
	            'databases',
	            databaseId.database
	        ]);
	    };
	    JsonProtoSerializer.prototype.extractLocalPathFromResourceName = function (resourceName) {
	        assert_1.assert(resourceName.length > 4 && resourceName.get(4) === 'documents', 'tried to deserialize invalid key ' + resourceName.toString());
	        return resourceName.popFirst(5);
	    };
	    JsonProtoSerializer.prototype.isValidResourceName = function (path) {
	        // Resource names have at least 4 components (project ID, database ID)
	        return (path.length >= 4 &&
	            path.get(0) === 'projects' &&
	            path.get(2) === 'databases');
	    };
	    JsonProtoSerializer.prototype.toValue = function (val) {
	        if (val instanceof fieldValue.NullValue) {
	            return { nullValue: 'NULL_VALUE' };
	        }
	        else if (val instanceof fieldValue.BooleanValue) {
	            return { booleanValue: val.value() };
	        }
	        else if (val instanceof fieldValue.IntegerValue) {
	            return { integerValue: '' + val.value() };
	        }
	        else if (val instanceof fieldValue.DoubleValue) {
	            var doubleValue = val.value();
	            if (this.options.useProto3Json) {
	                // Proto 3 let's us encode NaN and Infinity as string values as
	                // expected by the backend. This is currently not checked by our unit
	                // tests because they rely on protobuf.js.
	                if (isNaN(doubleValue)) {
	                    return { doubleValue: 'NaN' };
	                }
	                else if (doubleValue === Infinity) {
	                    return { doubleValue: 'Infinity' };
	                }
	                else if (doubleValue === -Infinity) {
	                    return { doubleValue: '-Infinity' };
	                }
	            }
	            return { doubleValue: val.value() };
	        }
	        else if (val instanceof fieldValue.StringValue) {
	            return { stringValue: val.value() };
	        }
	        else if (val instanceof fieldValue.ObjectValue) {
	            return { mapValue: this.toMapValue(val) };
	        }
	        else if (val instanceof fieldValue.ArrayValue) {
	            return { arrayValue: this.toArrayValue(val) };
	        }
	        else if (val instanceof fieldValue.TimestampValue) {
	            return {
	                timestampValue: this.toTimestamp(val.internalValue)
	            };
	        }
	        else if (val instanceof fieldValue.GeoPointValue) {
	            return {
	                geoPointValue: {
	                    latitude: val.value().latitude,
	                    longitude: val.value().longitude
	                }
	            };
	        }
	        else if (val instanceof fieldValue.BlobValue) {
	            return {
	                bytesValue: this.toBytes(val.value())
	            };
	        }
	        else if (val instanceof fieldValue.RefValue) {
	            return {
	                referenceValue: this.toResourceName(val.databaseId, val.key.path)
	            };
	        }
	        else {
	            return assert_1.fail('Unknown FieldValue ' + JSON.stringify(val));
	        }
	    };
	    JsonProtoSerializer.prototype.fromValue = function (obj) {
	        var _this = this;
	        // tslint:disable-next-line:no-any
	        var type = obj['value_type'];
	        if (hasTag(obj, type, 'nullValue')) {
	            return fieldValue.NullValue.INSTANCE;
	        }
	        else if (hasTag(obj, type, 'booleanValue')) {
	            return fieldValue.BooleanValue.of(obj.booleanValue);
	        }
	        else if (hasTag(obj, type, 'integerValue')) {
	            return new fieldValue.IntegerValue(parseInt64(obj.integerValue));
	        }
	        else if (hasTag(obj, type, 'doubleValue')) {
	            if (this.options.useProto3Json) {
	                // Proto 3 uses the string values 'NaN' and 'Infinity'.
	                if (obj.doubleValue === 'NaN') {
	                    return fieldValue.DoubleValue.NAN;
	                }
	                else if (obj.doubleValue === 'Infinity') {
	                    return fieldValue.DoubleValue.POSITIVE_INFINITY;
	                }
	                else if (obj.doubleValue === '-Infinity') {
	                    return fieldValue.DoubleValue.NEGATIVE_INFINITY;
	                }
	            }
	            return new fieldValue.DoubleValue(obj.doubleValue);
	        }
	        else if (hasTag(obj, type, 'stringValue')) {
	            return new fieldValue.StringValue(obj.stringValue);
	        }
	        else if (hasTag(obj, type, 'mapValue')) {
	            return this.fromFields(obj.mapValue.fields || {});
	        }
	        else if (hasTag(obj, type, 'arrayValue')) {
	            // "values" is not present if the array is empty
	            assertPresent(obj.arrayValue, 'arrayValue');
	            var values = obj.arrayValue.values || [];
	            return new fieldValue.ArrayValue(values.map(function (v) { return _this.fromValue(v); }));
	        }
	        else if (hasTag(obj, type, 'timestampValue')) {
	            assertPresent(obj.timestampValue, 'timestampValue');
	            return new fieldValue.TimestampValue(this.fromTimestamp(obj.timestampValue));
	        }
	        else if (hasTag(obj, type, 'geoPointValue')) {
	            assertPresent(obj.geoPointValue, 'geoPointValue');
	            var latitude = obj.geoPointValue.latitude || 0;
	            var longitude = obj.geoPointValue.longitude || 0;
	            return new fieldValue.GeoPointValue(new geo_point_1.GeoPoint(latitude, longitude));
	        }
	        else if (hasTag(obj, type, 'bytesValue')) {
	            assertPresent(obj.bytesValue, 'bytesValue');
	            var blob = this.fromBlob(obj.bytesValue);
	            return new fieldValue.BlobValue(blob);
	        }
	        else if (hasTag(obj, type, 'referenceValue')) {
	            assertPresent(obj.referenceValue, 'referenceValue');
	            var resourceName = this.fromResourceName(obj.referenceValue);
	            var dbId = new database_info_1.DatabaseId(resourceName.get(1), resourceName.get(3));
	            var key = new document_key_1.DocumentKey(this.extractLocalPathFromResourceName(resourceName));
	            return new fieldValue.RefValue(dbId, key);
	        }
	        else {
	            return assert_1.fail('Unknown Value proto ' + JSON.stringify(obj));
	        }
	    };
	    /** Creates an api.Document from key and fields (but no create/update time) */
	    JsonProtoSerializer.prototype.toMutationDocument = function (key, fields) {
	        return {
	            name: this.toName(key),
	            fields: this.toFields(fields)
	        };
	    };
	    JsonProtoSerializer.prototype.toDocument = function (document) {
	        assert_1.assert(!document.hasLocalMutations, "Can't serialize documents with mutations.");
	        return {
	            name: this.toName(document.key),
	            fields: this.toFields(document.data),
	            updateTime: this.toTimestamp(document.version.toTimestamp())
	        };
	    };
	    JsonProtoSerializer.prototype.fromDocument = function (document) {
	        return new document_1.Document(this.fromName(document.name), this.fromVersion(document.updateTime), this.fromFields(document.fields || {}), { hasLocalMutations: false });
	    };
	    JsonProtoSerializer.prototype.toFields = function (fields) {
	        var _this = this;
	        var result = {};
	        fields.forEach(function (key, value) {
	            result[key] = _this.toValue(value);
	        });
	        return result;
	    };
	    JsonProtoSerializer.prototype.fromFields = function (object) {
	        var _this = this;
	        // Proto map<string, Value> gets mapped to Object, so cast it.
	        var map = object;
	        var result = fieldValue.ObjectValue.EMPTY;
	        obj.forEach(map, function (key, value) {
	            result = result.set(new path_1.FieldPath([key]), _this.fromValue(value));
	        });
	        return result;
	    };
	    JsonProtoSerializer.prototype.toMapValue = function (map) {
	        return {
	            fields: this.toFields(map)
	        };
	    };
	    JsonProtoSerializer.prototype.toArrayValue = function (array) {
	        var _this = this;
	        var result = [];
	        array.forEach(function (value) {
	            result.push(_this.toValue(value));
	        });
	        return { values: result };
	    };
	    JsonProtoSerializer.prototype.fromFound = function (doc) {
	        assert_1.assert(!!doc.found, 'Tried to deserialize a found document from a missing document.');
	        assertPresent(doc.found.name, 'doc.found.name');
	        assertPresent(doc.found.updateTime, 'doc.found.updateTime');
	        var key = this.fromName(doc.found.name);
	        var version = this.fromVersion(doc.found.updateTime);
	        var fields = this.fromFields(doc.found.fields || {});
	        return new document_1.Document(key, version, fields, { hasLocalMutations: false });
	    };
	    JsonProtoSerializer.prototype.fromMissing = function (result) {
	        assert_1.assert(!!result.missing, 'Tried to deserialize a missing document from a found document.');
	        assert_1.assert(!!result.readTime, 'Tried to deserialize a missing document without a read time.');
	        var key = this.fromName(result.missing);
	        var version = this.fromVersion(result.readTime);
	        return new document_1.NoDocument(key, version);
	    };
	    JsonProtoSerializer.prototype.fromMaybeDocument = function (result) {
	        // tslint:disable-next-line:no-any
	        var type = result['result'];
	        if (hasTag(result, type, 'found')) {
	            return this.fromFound(result);
	        }
	        else if (hasTag(result, type, 'missing')) {
	            return this.fromMissing(result);
	        }
	        return assert_1.fail('invalid batch get response: ' + JSON.stringify(result));
	    };
	    JsonProtoSerializer.prototype.toWatchTargetChangeState = function (state) {
	        switch (state) {
	            case watch_change_1.WatchTargetChangeState.Added:
	                return 'ADD';
	            case watch_change_1.WatchTargetChangeState.Current:
	                return 'CURRENT';
	            case watch_change_1.WatchTargetChangeState.NoChange:
	                return 'NO_CHANGE';
	            case watch_change_1.WatchTargetChangeState.Removed:
	                return 'REMOVE';
	            case watch_change_1.WatchTargetChangeState.Reset:
	                return 'RESET';
	            default:
	                return assert_1.fail('Unknown WatchTargetChangeState: ' + state);
	        }
	    };
	    JsonProtoSerializer.prototype.toTestWatchChange = function (watchChange) {
	        if (watchChange instanceof watch_change_1.ExistenceFilterChange) {
	            return {
	                filter: {
	                    count: watchChange.existenceFilter.count,
	                    targetId: watchChange.targetId
	                }
	            };
	        }
	        if (watchChange instanceof watch_change_1.DocumentWatchChange) {
	            if (watchChange.newDoc instanceof document_1.Document) {
	                var doc = watchChange.newDoc;
	                return {
	                    documentChange: {
	                        document: {
	                            name: this.toName(doc.key),
	                            fields: this.toFields(doc.data),
	                            updateTime: this.toVersion(doc.version)
	                        },
	                        targetIds: watchChange.updatedTargetIds,
	                        removedTargetIds: watchChange.removedTargetIds
	                    }
	                };
	            }
	            else if (watchChange.newDoc instanceof document_1.NoDocument) {
	                var doc = watchChange.newDoc;
	                return {
	                    documentDelete: {
	                        document: this.toName(doc.key),
	                        readTime: this.toVersion(doc.version),
	                        removedTargetIds: watchChange.removedTargetIds
	                    }
	                };
	            }
	            else if (watchChange.newDoc === null) {
	                return {
	                    documentRemove: {
	                        document: this.toName(watchChange.key),
	                        removedTargetIds: watchChange.removedTargetIds
	                    }
	                };
	            }
	        }
	        if (watchChange instanceof watch_change_1.WatchTargetChange) {
	            var cause = undefined;
	            if (watchChange.cause) {
	                cause = {
	                    code: rpc_error_1.mapRpcCodeFromCode(watchChange.cause.code),
	                    message: watchChange.cause.message
	                };
	            }
	            return {
	                targetChange: {
	                    targetChangeType: this.toWatchTargetChangeState(watchChange.state),
	                    targetIds: watchChange.targetIds,
	                    resumeToken: this.unsafeCastProtoByteString(watchChange.resumeToken),
	                    cause: cause
	                }
	            };
	        }
	        return assert_1.fail('Unrecognized watch change: ' + JSON.stringify(watchChange));
	    };
	    JsonProtoSerializer.prototype.fromWatchChange = function (change) {
	        // tslint:disable-next-line:no-any
	        var type = change['response_type'];
	        var watchChange;
	        if (hasTag(change, type, 'targetChange')) {
	            assertPresent(change.targetChange, 'targetChange');
	            // proto3 default value is unset in JSON (undefined), so use 'NO_CHANGE'
	            // if unset
	            var state = this.fromWatchTargetChangeState(change.targetChange.targetChangeType || 'NO_CHANGE');
	            var targetIds = change.targetChange.targetIds || [];
	            var resumeToken = change.targetChange.resumeToken || this.emptyByteString();
	            var causeProto = change.targetChange.cause;
	            var cause = causeProto && this.fromRpcStatus(causeProto);
	            watchChange = new watch_change_1.WatchTargetChange(state, targetIds, resumeToken, cause || null);
	        }
	        else if (hasTag(change, type, 'documentChange')) {
	            assertPresent(change.documentChange, 'documentChange');
	            assertPresent(change.documentChange.document, 'documentChange.name');
	            assertPresent(change.documentChange.document.name, 'documentChange.document.name');
	            assertPresent(change.documentChange.document.updateTime, 'documentChange.document.updateTime');
	            var entityChange = change.documentChange;
	            var key = this.fromName(entityChange.document.name);
	            var version = this.fromVersion(entityChange.document.updateTime);
	            var fields = this.fromFields(entityChange.document.fields || {});
	            var doc = new document_1.Document(key, version, fields, {
	                hasLocalMutations: false
	            });
	            var updatedTargetIds = entityChange.targetIds || [];
	            var removedTargetIds = entityChange.removedTargetIds || [];
	            watchChange = new watch_change_1.DocumentWatchChange(updatedTargetIds, removedTargetIds, doc.key, doc);
	        }
	        else if (hasTag(change, type, 'documentDelete')) {
	            assertPresent(change.documentDelete, 'documentDelete');
	            assertPresent(change.documentDelete.document, 'documentDelete.document');
	            var docDelete = change.documentDelete;
	            var key = this.fromName(docDelete.document);
	            var version = docDelete.readTime
	                ? this.fromVersion(docDelete.readTime)
	                : snapshot_version_1.SnapshotVersion.forDeletedDoc();
	            var doc = new document_1.NoDocument(key, version);
	            var removedTargetIds = docDelete.removedTargetIds || [];
	            watchChange = new watch_change_1.DocumentWatchChange([], removedTargetIds, doc.key, doc);
	        }
	        else if (hasTag(change, type, 'documentRemove')) {
	            assertPresent(change.documentRemove, 'documentRemove');
	            assertPresent(change.documentRemove.document, 'documentRemove');
	            var docRemove = change.documentRemove;
	            var key = this.fromName(docRemove.document);
	            var removedTargetIds = docRemove.removedTargetIds || [];
	            watchChange = new watch_change_1.DocumentWatchChange([], removedTargetIds, key, null);
	        }
	        else if (hasTag(change, type, 'filter')) {
	            // TODO(dimond): implement existence filter parsing with strategy.
	            assertPresent(change.filter, 'filter');
	            assertPresent(change.filter.targetId, 'filter.targetId');
	            var filter = change.filter;
	            var count = filter.count || 0;
	            var existenceFilter = new existence_filter_1.ExistenceFilter(count);
	            var targetId = filter.targetId;
	            watchChange = new watch_change_1.ExistenceFilterChange(targetId, existenceFilter);
	        }
	        else {
	            return assert_1.fail('Unknown change type ' + JSON.stringify(change));
	        }
	        return watchChange;
	    };
	    JsonProtoSerializer.prototype.fromWatchTargetChangeState = function (state) {
	        if (state === 'NO_CHANGE') {
	            return watch_change_1.WatchTargetChangeState.NoChange;
	        }
	        else if (state === 'ADD') {
	            return watch_change_1.WatchTargetChangeState.Added;
	        }
	        else if (state === 'REMOVE') {
	            return watch_change_1.WatchTargetChangeState.Removed;
	        }
	        else if (state === 'CURRENT') {
	            return watch_change_1.WatchTargetChangeState.Current;
	        }
	        else if (state === 'RESET') {
	            return watch_change_1.WatchTargetChangeState.Reset;
	        }
	        else {
	            return assert_1.fail('Got unexpected TargetChange.state: ' + state);
	        }
	    };
	    JsonProtoSerializer.prototype.versionFromListenResponse = function (change) {
	        // We have only reached a consistent snapshot for the entire stream if there
	        // is a read_time set and it applies to all targets (i.e. the list of
	        // targets is empty). The backend is guaranteed to send such responses.
	        // tslint:disable-next-line:no-any
	        var type = change['response_type'];
	        if (!hasTag(change, type, 'targetChange')) {
	            return snapshot_version_1.SnapshotVersion.MIN;
	        }
	        var targetChange = change.targetChange;
	        if (targetChange.targetIds && targetChange.targetIds.length) {
	            return snapshot_version_1.SnapshotVersion.MIN;
	        }
	        if (!targetChange.readTime) {
	            return snapshot_version_1.SnapshotVersion.MIN;
	        }
	        return this.fromVersion(targetChange.readTime);
	    };
	    JsonProtoSerializer.prototype.toMutation = function (mutation) {
	        var _this = this;
	        var result;
	        if (mutation instanceof mutation_1.SetMutation) {
	            result = {
	                update: this.toMutationDocument(mutation.key, mutation.value)
	            };
	        }
	        else if (mutation instanceof mutation_1.DeleteMutation) {
	            result = { delete: this.toName(mutation.key) };
	        }
	        else if (mutation instanceof mutation_1.PatchMutation) {
	            result = {
	                update: this.toMutationDocument(mutation.key, mutation.data),
	                updateMask: this.toDocumentMask(mutation.fieldMask)
	            };
	        }
	        else if (mutation instanceof mutation_1.TransformMutation) {
	            result = {
	                transform: {
	                    document: this.toName(mutation.key),
	                    fieldTransforms: mutation.fieldTransforms.map(function (transform) {
	                        return _this.toFieldTransform(transform);
	                    })
	                }
	            };
	        }
	        else {
	            return assert_1.fail('Unknown mutation type ' + mutation.type);
	        }
	        if (!mutation.precondition.isNone) {
	            result.currentDocument = this.toPrecondition(mutation.precondition);
	        }
	        return result;
	    };
	    JsonProtoSerializer.prototype.fromMutation = function (proto) {
	        var _this = this;
	        var precondition = proto.currentDocument
	            ? this.fromPrecondition(proto.currentDocument)
	            : mutation_1.Precondition.NONE;
	        if (proto.update) {
	            assertPresent(proto.update.name, 'name');
	            var key = this.fromName(proto.update.name);
	            var value = this.fromFields(proto.update.fields || {});
	            if (proto.updateMask) {
	                var fieldMask = this.fromDocumentMask(proto.updateMask);
	                return new mutation_1.PatchMutation(key, value, fieldMask, precondition);
	            }
	            else {
	                return new mutation_1.SetMutation(key, value, precondition);
	            }
	        }
	        else if (proto.delete) {
	            var key = this.fromName(proto.delete);
	            return new mutation_1.DeleteMutation(key, precondition);
	        }
	        else if (proto.transform) {
	            var key = this.fromName(proto.transform.document);
	            var fieldTransforms = proto.transform.fieldTransforms.map(function (transform) {
	                return _this.fromFieldTransform(transform);
	            });
	            assert_1.assert(precondition.exists === true, 'Transforms only support precondition "exists == true"');
	            return new mutation_1.TransformMutation(key, fieldTransforms);
	        }
	        else {
	            return assert_1.fail('unknown mutation proto: ' + JSON.stringify(proto));
	        }
	    };
	    JsonProtoSerializer.prototype.toPrecondition = function (precondition) {
	        assert_1.assert(!precondition.isNone, "Can't serialize an empty precondition");
	        if (precondition.updateTime !== undefined) {
	            return {
	                updateTime: this.toVersion(precondition.updateTime)
	            };
	        }
	        else if (precondition.exists !== undefined) {
	            return { exists: precondition.exists };
	        }
	        else {
	            return assert_1.fail('Unknown precondition');
	        }
	    };
	    JsonProtoSerializer.prototype.fromPrecondition = function (precondition) {
	        if (precondition.updateTime !== undefined) {
	            return mutation_1.Precondition.updateTime(this.fromVersion(precondition.updateTime));
	        }
	        else if (precondition.exists !== undefined) {
	            return mutation_1.Precondition.exists(precondition.exists);
	        }
	        else {
	            return mutation_1.Precondition.NONE;
	        }
	    };
	    JsonProtoSerializer.prototype.fromWriteResult = function (proto) {
	        var _this = this;
	        // NOTE: Deletes don't have an updateTime.
	        var version = proto.updateTime
	            ? this.fromVersion(proto.updateTime)
	            : null;
	        var transformResults = null;
	        if (proto.transformResults && proto.transformResults.length > 0) {
	            transformResults = proto.transformResults.map(function (result) {
	                return _this.fromValue(result);
	            });
	        }
	        return new mutation_1.MutationResult(version, transformResults);
	    };
	    JsonProtoSerializer.prototype.fromWriteResults = function (protos) {
	        var _this = this;
	        return (protos || []).map(function (proto) { return _this.fromWriteResult(proto); });
	    };
	    JsonProtoSerializer.prototype.toFieldTransform = function (fieldTransform) {
	        assert_1.assert(fieldTransform.transform instanceof mutation_1.ServerTimestampTransform, 'Unknown transform: ' + fieldTransform.transform);
	        return {
	            fieldPath: fieldTransform.field.canonicalString(),
	            setToServerValue: 'REQUEST_TIME'
	        };
	    };
	    JsonProtoSerializer.prototype.fromFieldTransform = function (proto) {
	        assert_1.assert(proto.setToServerValue === 'REQUEST_TIME', 'Unknown transform proto: ' + JSON.stringify(proto));
	        var fieldPath = path_1.FieldPath.fromServerFormat(proto.fieldPath);
	        return new mutation_1.FieldTransform(fieldPath, mutation_1.ServerTimestampTransform.instance);
	    };
	    JsonProtoSerializer.prototype.toDocumentsTarget = function (query) {
	        return { documents: [this.toQueryPath(query.path)] };
	    };
	    JsonProtoSerializer.prototype.fromDocumentsTarget = function (documentsTarget) {
	        var count = documentsTarget.documents.length;
	        assert_1.assert(count === 1, 'DocumentsTarget contained other than 1 document: ' + count);
	        var name = documentsTarget.documents[0];
	        return query_1.Query.atPath(this.fromQueryPath(name));
	    };
	    JsonProtoSerializer.prototype.toQueryTarget = function (query) {
	        // Dissect the path into parent, collectionId, and optional key filter.
	        var result = { structuredQuery: {} };
	        if (query.path.isEmpty()) {
	            result.parent = this.toQueryPath(path_1.ResourcePath.EMPTY_PATH);
	        }
	        else {
	            var path = query.path;
	            assert_1.assert(path.length % 2 !== 0, 'Document queries with filters are not supported.');
	            result.parent = this.toQueryPath(path.popLast());
	            result.structuredQuery.from = [{ collectionId: path.lastSegment() }];
	        }
	        var where = this.toFilter(query.filters);
	        if (where) {
	            result.structuredQuery.where = where;
	        }
	        var orderBy = this.toOrder(query.orderBy);
	        if (orderBy) {
	            result.structuredQuery.orderBy = orderBy;
	        }
	        var limit = this.toInt32Value(query.limit);
	        if (limit !== undefined) {
	            result.structuredQuery.limit = limit;
	        }
	        if (query.startAt) {
	            result.structuredQuery.startAt = this.toCursor(query.startAt);
	        }
	        if (query.endAt) {
	            result.structuredQuery.endAt = this.toCursor(query.endAt);
	        }
	        return result;
	    };
	    JsonProtoSerializer.prototype.fromQueryTarget = function (target) {
	        var path = this.fromQueryPath(target.parent);
	        var query = target.structuredQuery;
	        var fromCount = query.from ? query.from.length : 0;
	        if (fromCount > 0) {
	            assert_1.assert(fromCount === 1, 'StructuredQuery.from with more than one collection is not supported.');
	            var from = query.from[0];
	            path = path.child(from.collectionId);
	        }
	        var filterBy = [];
	        if (query.where) {
	            filterBy = this.fromFilter(query.where);
	        }
	        var orderBy = [];
	        if (query.orderBy) {
	            orderBy = this.fromOrder(query.orderBy);
	        }
	        var limit = null;
	        if (query.limit) {
	            limit = this.fromInt32Value(query.limit);
	        }
	        var startAt = null;
	        if (query.startAt) {
	            startAt = this.fromCursor(query.startAt);
	        }
	        var endAt = null;
	        if (query.endAt) {
	            endAt = this.fromCursor(query.endAt);
	        }
	        return new query_1.Query(path, orderBy, filterBy, limit, startAt, endAt);
	    };
	    JsonProtoSerializer.prototype.toListenRequestLabels = function (queryData) {
	        var value = this.toLabel(queryData.purpose);
	        if (value == null) {
	            return null;
	        }
	        else {
	            return {
	                'goog-listen-tags': value
	            };
	        }
	    };
	    JsonProtoSerializer.prototype.toLabel = function (purpose) {
	        switch (purpose) {
	            case query_data_1.QueryPurpose.Listen:
	                return null;
	            case query_data_1.QueryPurpose.ExistenceFilterMismatch:
	                return 'existence-filter-mismatch';
	            case query_data_1.QueryPurpose.LimboResolution:
	                return 'limbo-document';
	            default:
	                return assert_1.fail('Unrecognized query purpose: ' + purpose);
	        }
	    };
	    JsonProtoSerializer.prototype.toTarget = function (queryData) {
	        var result;
	        var query = queryData.query;
	        if (query.isDocumentQuery()) {
	            result = { documents: this.toDocumentsTarget(query) };
	        }
	        else {
	            result = { query: this.toQueryTarget(query) };
	        }
	        result.targetId = queryData.targetId;
	        if (queryData.resumeToken.length > 0) {
	            result.resumeToken = this.unsafeCastProtoByteString(queryData.resumeToken);
	        }
	        return result;
	    };
	    JsonProtoSerializer.prototype.toFilter = function (filters) {
	        var _this = this;
	        if (filters.length === 0)
	            return;
	        var protos = filters.map(function (filter) {
	            return filter instanceof query_1.RelationFilter
	                ? _this.toRelationFilter(filter)
	                : _this.toUnaryFilter(filter);
	        });
	        if (protos.length === 1) {
	            return protos[0];
	        }
	        return { compositeFilter: { op: 'AND', filters: protos } };
	    };
	    JsonProtoSerializer.prototype.fromFilter = function (filter) {
	        var _this = this;
	        if (!filter) {
	            return [];
	        }
	        else if (filter.unaryFilter !== undefined) {
	            return [this.fromUnaryFilter(filter)];
	        }
	        else if (filter.fieldFilter !== undefined) {
	            return [this.fromRelationFilter(filter)];
	        }
	        else if (filter.compositeFilter !== undefined) {
	            return filter.compositeFilter.filters
	                .map(function (f) { return _this.fromFilter(f); })
	                .reduce(function (accum, current) { return accum.concat(current); });
	        }
	        else {
	            return assert_1.fail('Unknown filter: ' + JSON.stringify(filter));
	        }
	    };
	    JsonProtoSerializer.prototype.toOrder = function (orderBys) {
	        var _this = this;
	        if (orderBys.length === 0)
	            return;
	        return orderBys.map(function (order) { return _this.toPropertyOrder(order); });
	    };
	    JsonProtoSerializer.prototype.fromOrder = function (orderBys) {
	        var _this = this;
	        return orderBys.map(function (order) { return _this.fromPropertyOrder(order); });
	    };
	    JsonProtoSerializer.prototype.toCursor = function (cursor) {
	        var _this = this;
	        return {
	            before: cursor.before,
	            values: cursor.position.map(function (component) { return _this.toValue(component); })
	        };
	    };
	    JsonProtoSerializer.prototype.fromCursor = function (cursor) {
	        var _this = this;
	        var before = !!cursor.before;
	        var position = cursor.values.map(function (component) { return _this.fromValue(component); });
	        return new query_1.Bound(position, before);
	    };
	    // visible for testing
	    JsonProtoSerializer.prototype.toDirection = function (dir) {
	        return DIRECTIONS[dir.name];
	    };
	    // visible for testing
	    JsonProtoSerializer.prototype.fromDirection = function (dir) {
	        switch (dir) {
	            case 'ASCENDING':
	                return query_1.Direction.ASCENDING;
	            case 'DESCENDING':
	                return query_1.Direction.DESCENDING;
	            default:
	                return undefined;
	        }
	    };
	    // visible for testing
	    JsonProtoSerializer.prototype.toOperatorName = function (op) {
	        return OPERATORS[op.name];
	    };
	    JsonProtoSerializer.prototype.fromOperatorName = function (op) {
	        switch (op) {
	            case 'EQUAL':
	                return query_1.RelationOp.EQUAL;
	            case 'GREATER_THAN':
	                return query_1.RelationOp.GREATER_THAN;
	            case 'GREATER_THAN_OR_EQUAL':
	                return query_1.RelationOp.GREATER_THAN_OR_EQUAL;
	            case 'LESS_THAN':
	                return query_1.RelationOp.LESS_THAN;
	            case 'LESS_THAN_OR_EQUAL':
	                return query_1.RelationOp.LESS_THAN_OR_EQUAL;
	            case 'OPERATOR_UNSPECIFIED':
	                return assert_1.fail('Unspecified relation');
	            default:
	                return assert_1.fail('Unknown relation');
	        }
	    };
	    JsonProtoSerializer.prototype.toFieldPathReference = function (path) {
	        return { fieldPath: path.canonicalString() };
	    };
	    JsonProtoSerializer.prototype.fromFieldPathReference = function (fieldReference) {
	        return path_1.FieldPath.fromServerFormat(fieldReference.fieldPath);
	    };
	    // visible for testing
	    JsonProtoSerializer.prototype.toPropertyOrder = function (orderBy) {
	        return {
	            field: this.toFieldPathReference(orderBy.field),
	            direction: this.toDirection(orderBy.dir)
	        };
	    };
	    JsonProtoSerializer.prototype.fromPropertyOrder = function (orderBy) {
	        return new query_1.OrderBy(this.fromFieldPathReference(orderBy.field), this.fromDirection(orderBy.direction));
	    };
	    // visible for testing
	    JsonProtoSerializer.prototype.toRelationFilter = function (filter) {
	        if (filter instanceof query_1.RelationFilter) {
	            return {
	                fieldFilter: {
	                    field: this.toFieldPathReference(filter.field),
	                    op: this.toOperatorName(filter.op),
	                    value: this.toValue(filter.value)
	                }
	            };
	        }
	        else {
	            return assert_1.fail('Unrecognized filter: ' + JSON.stringify(filter));
	        }
	    };
	    JsonProtoSerializer.prototype.fromRelationFilter = function (filter) {
	        return new query_1.RelationFilter(this.fromFieldPathReference(filter.fieldFilter.field), this.fromOperatorName(filter.fieldFilter.op), this.fromValue(filter.fieldFilter.value));
	    };
	    // visible for testing
	    JsonProtoSerializer.prototype.toUnaryFilter = function (filter) {
	        if (filter instanceof query_1.NanFilter) {
	            return {
	                unaryFilter: {
	                    field: this.toFieldPathReference(filter.field),
	                    op: 'IS_NAN'
	                }
	            };
	        }
	        else if (filter instanceof query_1.NullFilter) {
	            return {
	                unaryFilter: {
	                    field: this.toFieldPathReference(filter.field),
	                    op: 'IS_NULL'
	                }
	            };
	        }
	        else {
	            return assert_1.fail('Unrecognized filter: ' + JSON.stringify(filter));
	        }
	    };
	    JsonProtoSerializer.prototype.fromUnaryFilter = function (filter) {
	        switch (filter.unaryFilter.op) {
	            case 'IS_NAN':
	                var nanField = this.fromFieldPathReference(filter.unaryFilter.field);
	                return new query_1.NanFilter(nanField);
	            case 'IS_NULL':
	                var nullField = this.fromFieldPathReference(filter.unaryFilter.field);
	                return new query_1.NullFilter(nullField);
	            case 'OPERATOR_UNSPECIFIED':
	                return assert_1.fail('Unspecified filter');
	            default:
	                return assert_1.fail('Unknown filter');
	        }
	    };
	    JsonProtoSerializer.prototype.toDocumentMask = function (fieldMask) {
	        return {
	            fieldPaths: fieldMask.fields.map(function (field) { return field.canonicalString(); })
	        };
	    };
	    JsonProtoSerializer.prototype.fromDocumentMask = function (proto) {
	        var paths = proto.fieldPaths || [];
	        var fields = paths.map(function (path) { return path_1.FieldPath.fromServerFormat(path); });
	        return new mutation_1.FieldMask(fields);
	    };
	    return JsonProtoSerializer;
	}());
	exports.JsonProtoSerializer = JsonProtoSerializer;
	/**
	 * Checks for a specific oneof tag in a protocol buffer message.
	 *
	 * This intentionally accommodates two distinct cases:
	 *
	 * 1) Messages containing a type tag: these are the format produced by GRPC in
	 * return values. These may contain default-value mappings for all tags in the
	 * oneof but the type tag specifies which one was actually set.
	 *
	 * 2) Messages that don't contain a type tag: these are the format required by
	 * GRPC as inputs. If we emitted objects with type tags, ProtoBuf.js would
	 * choke claiming that the tags aren't fields in the Message.
	 *
	 * Allowing both formats here makes the serializer able to consume the outputs
	 * it produces: for all messages it supports, fromX(toX(value)) == value.
	 *
	 * Note that case 2 suffers from ambiguity: if multiple tags are present
	 * without a type tag then the callers are structured in such a way that the
	 * first invocation will win. Since we only parse in this mode when parsing
	 * the output of a serialize method this works, but it's not a general
	 * solution.
	 *
	 * Unfortunately there is no general solution here because proto3 makes it
	 * impossible to distinguish unset from explicitly set fields: both have the
	 * default value for the type. Without the type tag but multiple value tags
	 * it's possible to have default values for each tag in the oneof and not be
	 * able to know which was actually in effect.
	 */
	function hasTag(obj, type, tag) {
	    return type === tag || (!type && tag in obj);
	}
	
	//# sourceMappingURL=serializer.js.map


/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var collections_1 = __webpack_require__(11);
	var platform_1 = __webpack_require__(29);
	var assert_1 = __webpack_require__(2);
	var objUtils = __webpack_require__(27);
	var remote_event_1 = __webpack_require__(53);
	/**
	 * Represents a changed document and a list of target ids to which this change
	 * applies.
	 *
	 * If document has been deleted NoDocument will be provided.
	 */
	var DocumentWatchChange = /** @class */ (function () {
	    function DocumentWatchChange(
	        /** The new document applies to all of these targets. */
	        updatedTargetIds, 
	        /** The new document is removed from all of these targets. */
	        removedTargetIds, 
	        /** The key of the document for this change. */
	        key, 
	        /**
	         * The new document or NoDocument if it was deleted. Is null if the
	         * document went out of view without the server sending a new document.
	         */
	        newDoc) {
	        this.updatedTargetIds = updatedTargetIds;
	        this.removedTargetIds = removedTargetIds;
	        this.key = key;
	        this.newDoc = newDoc;
	    }
	    return DocumentWatchChange;
	}());
	exports.DocumentWatchChange = DocumentWatchChange;
	var ExistenceFilterChange = /** @class */ (function () {
	    function ExistenceFilterChange(targetId, existenceFilter) {
	        this.targetId = targetId;
	        this.existenceFilter = existenceFilter;
	    }
	    return ExistenceFilterChange;
	}());
	exports.ExistenceFilterChange = ExistenceFilterChange;
	var WatchTargetChangeState;
	(function (WatchTargetChangeState) {
	    WatchTargetChangeState[WatchTargetChangeState["NoChange"] = 0] = "NoChange";
	    WatchTargetChangeState[WatchTargetChangeState["Added"] = 1] = "Added";
	    WatchTargetChangeState[WatchTargetChangeState["Removed"] = 2] = "Removed";
	    WatchTargetChangeState[WatchTargetChangeState["Current"] = 3] = "Current";
	    WatchTargetChangeState[WatchTargetChangeState["Reset"] = 4] = "Reset";
	})(WatchTargetChangeState = exports.WatchTargetChangeState || (exports.WatchTargetChangeState = {}));
	var WatchTargetChange = /** @class */ (function () {
	    function WatchTargetChange(
	        /** What kind of change occurred to the watch target. */
	        state, 
	        /** The target IDs that were added/removed/set. */
	        targetIds, 
	        /**
	         * An opaque, server-assigned token that allows watching a query to be
	         * resumed after disconnecting without retransmitting all the data that
	         * matches the query. The resume token essentially identifies a point in
	         * time from which the server should resume sending results.
	         */
	        resumeToken, 
	        /** An RPC error indicating why the watch failed. */
	        cause) {
	        if (resumeToken === void 0) { resumeToken = platform_1.emptyByteString(); }
	        if (cause === void 0) { cause = null; }
	        this.state = state;
	        this.targetIds = targetIds;
	        this.resumeToken = resumeToken;
	        this.cause = cause;
	    }
	    return WatchTargetChange;
	}());
	exports.WatchTargetChange = WatchTargetChange;
	/**
	 * A helper class to accumulate watch changes into a RemoteEvent and other
	 * target information.
	 */
	var WatchChangeAggregator = /** @class */ (function () {
	    function WatchChangeAggregator(snapshotVersion, listenTargets, pendingTargetResponses) {
	        this.snapshotVersion = snapshotVersion;
	        this.listenTargets = listenTargets;
	        /** The existence filter - if any - for the given target IDs. */
	        this.existenceFilters = {};
	        /** Keeps track of the current target mappings */
	        this.targetChanges = {};
	        /** Keeps track of document to update */
	        this.documentUpdates = collections_1.maybeDocumentMap();
	        /** Whether this aggregator was frozen and can no longer be modified */
	        this.frozen = false;
	        this.pendingTargetResponses = objUtils.shallowCopy(pendingTargetResponses);
	    }
	    /** Aggregates a watch change into the current state */
	    WatchChangeAggregator.prototype.add = function (watchChange) {
	        assert_1.assert(!this.frozen, 'Trying to modify frozen WatchChangeAggregator.');
	        if (watchChange instanceof DocumentWatchChange) {
	            this.addDocumentChange(watchChange);
	        }
	        else if (watchChange instanceof WatchTargetChange) {
	            this.addTargetChange(watchChange);
	        }
	        else if (watchChange instanceof ExistenceFilterChange) {
	            this.addExistenceFilterChange(watchChange);
	        }
	        else {
	            assert_1.fail('Unknown watch change: ' + watchChange);
	        }
	    };
	    /** Aggregates all provided watch changes to the current state in order */
	    WatchChangeAggregator.prototype.addChanges = function (watchChanges) {
	        var _this = this;
	        assert_1.assert(!this.frozen, 'Trying to modify frozen WatchChangeAggregator.');
	        watchChanges.forEach(function (change) { return _this.add(change); });
	    };
	    /**
	     * Converts the current state into a remote event with the snapshot version
	     * provided via the constructor.
	     */
	    WatchChangeAggregator.prototype.createRemoteEvent = function () {
	        var _this = this;
	        var targetChanges = this.targetChanges;
	        // Remove all the non-active targets from the remote event.
	        objUtils.forEachNumber(this.targetChanges, function (targetId) {
	            if (!_this.isActiveTarget(targetId)) {
	                delete targetChanges[targetId];
	            }
	        });
	        // Mark this aggregator as frozen so no further modifications are made
	        this.frozen = true;
	        return new remote_event_1.RemoteEvent(this.snapshotVersion, targetChanges, this.documentUpdates);
	    };
	    WatchChangeAggregator.prototype.ensureTargetChange = function (targetId) {
	        var change = this.targetChanges[targetId];
	        if (!change) {
	            // Create an UpdateMapping by default, since resets are always explicit.
	            change = {
	                currentStatusUpdate: remote_event_1.CurrentStatusUpdate.None,
	                snapshotVersion: this.snapshotVersion,
	                mapping: new remote_event_1.UpdateMapping(),
	                resumeToken: platform_1.emptyByteString()
	            };
	            this.targetChanges[targetId] = change;
	        }
	        return change;
	    };
	    /**
	     * We need to wait for watch to ack targets before we process those events,
	     * so to know if a target is active, there must be no pending acks we're
	     * waiting for and it must be in the current list of targets that the client
	     * cares about.
	     *
	     * This method is visible for testing.
	     */
	    WatchChangeAggregator.prototype.isActiveTarget = function (targetId) {
	        return (!objUtils.contains(this.pendingTargetResponses, targetId) &&
	            objUtils.contains(this.listenTargets, targetId));
	    };
	    WatchChangeAggregator.prototype.addDocumentChange = function (docChange) {
	        var relevant = false;
	        for (var _i = 0, _a = docChange.updatedTargetIds; _i < _a.length; _i++) {
	            var targetId = _a[_i];
	            if (this.isActiveTarget(targetId)) {
	                var change = this.ensureTargetChange(targetId);
	                change.mapping.add(docChange.key);
	                relevant = true;
	            }
	        }
	        for (var _b = 0, _c = docChange.removedTargetIds; _b < _c.length; _b++) {
	            var targetId = _c[_b];
	            if (this.isActiveTarget(targetId)) {
	                var change = this.ensureTargetChange(targetId);
	                change.mapping.delete(docChange.key);
	                relevant = true;
	            }
	        }
	        // Only update the document if there is a new document to replace to an
	        // active target that is being listened to, this might be just a target
	        // update instead.
	        if (docChange.newDoc && relevant) {
	            this.documentUpdates = this.documentUpdates.insert(docChange.key, docChange.newDoc);
	        }
	    };
	    WatchChangeAggregator.prototype.addTargetChange = function (targetChange) {
	        var _this = this;
	        targetChange.targetIds.forEach(function (targetId) {
	            var change = _this.ensureTargetChange(targetId);
	            switch (targetChange.state) {
	                case WatchTargetChangeState.NoChange:
	                    if (_this.isActiveTarget(targetId)) {
	                        // Creating the change above satisfies the semantics of no-change.
	                        applyResumeToken(change, targetChange.resumeToken);
	                    }
	                    break;
	                case WatchTargetChangeState.Added:
	                    // We need to decrement the number of pending acks needed from watch
	                    // for this targetId.
	                    _this.recordTargetResponse(targetId);
	                    if (!objUtils.contains(_this.pendingTargetResponses, targetId)) {
	                        // We have a freshly added target, so we need to reset any state
	                        // that we had previously This can happen e.g. when remove and add
	                        // back a target for existence filter mismatches.
	                        change.mapping = new remote_event_1.UpdateMapping();
	                        change.currentStatusUpdate = remote_event_1.CurrentStatusUpdate.None;
	                        delete _this.existenceFilters[targetId];
	                    }
	                    applyResumeToken(change, targetChange.resumeToken);
	                    break;
	                case WatchTargetChangeState.Removed:
	                    // We need to keep track of removed targets to we can
	                    // post-filter and remove any target changes.
	                    // We need to decrement the number of pending acks needed from watch
	                    // for this targetId.
	                    _this.recordTargetResponse(targetId);
	                    assert_1.assert(!targetChange.cause, 'WatchChangeAggregator does not handle errored targets');
	                    break;
	                case WatchTargetChangeState.Current:
	                    if (_this.isActiveTarget(targetId)) {
	                        change.currentStatusUpdate = remote_event_1.CurrentStatusUpdate.MarkCurrent;
	                        applyResumeToken(change, targetChange.resumeToken);
	                    }
	                    break;
	                case WatchTargetChangeState.Reset:
	                    if (_this.isActiveTarget(targetId)) {
	                        // Overwrite any existing target mapping with a reset
	                        // mapping. Every subsequent update will modify the reset
	                        // mapping, not an update mapping.
	                        change.mapping = new remote_event_1.ResetMapping();
	                        applyResumeToken(change, targetChange.resumeToken);
	                    }
	                    break;
	                default:
	                    assert_1.fail('Unknown target watch change state: ' + targetChange.state);
	            }
	        });
	    };
	    /**
	     * Record that we get a watch target add/remove by decrementing the number of
	     * pending target responses that we have.
	     */
	    WatchChangeAggregator.prototype.recordTargetResponse = function (targetId) {
	        var newCount = (this.pendingTargetResponses[targetId] || 0) - 1;
	        if (newCount === 0) {
	            delete this.pendingTargetResponses[targetId];
	        }
	        else {
	            this.pendingTargetResponses[targetId] = newCount;
	        }
	    };
	    WatchChangeAggregator.prototype.addExistenceFilterChange = function (change) {
	        if (this.isActiveTarget(change.targetId)) {
	            this.existenceFilters[change.targetId] = change.existenceFilter;
	        }
	    };
	    return WatchChangeAggregator;
	}());
	exports.WatchChangeAggregator = WatchChangeAggregator;
	/**
	 * Applies the resume token to the TargetChange, but only when it has a new
	 * value. null and empty resumeTokens are discarded.
	 */
	function applyResumeToken(change, resumeToken) {
	    if (resumeToken.length > 0) {
	        change.resumeToken = resumeToken;
	    }
	}
	
	//# sourceMappingURL=watch_change.js.map


/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	'use strict';
	Object.defineProperty(exports, "__esModule", { value: true });
	var util_1 = __webpack_require__(1);
	var errors_1 = __webpack_require__(77);
	var token_manager_1 = __webpack_require__(300);
	var notification_permission_1 = __webpack_require__(167);
	var SENDER_ID_OPTION_NAME = 'messagingSenderId';
	var ControllerInterface = /** @class */ (function () {
	    /**
	     * An interface of the Messaging Service API
	     * @param {!firebase.app.App} app
	     */
	    function ControllerInterface(app) {
	        var _this = this;
	        this.errorFactory_ = new util_1.ErrorFactory('messaging', 'Messaging', errors_1.default.map);
	        if (!app.options[SENDER_ID_OPTION_NAME] ||
	            typeof app.options[SENDER_ID_OPTION_NAME] !== 'string') {
	            throw this.errorFactory_.create(errors_1.default.codes.BAD_SENDER_ID);
	        }
	        this.messagingSenderId_ = app.options[SENDER_ID_OPTION_NAME];
	        this.tokenManager_ = new token_manager_1.default();
	        this.app = app;
	        this.INTERNAL = {};
	        this.INTERNAL.delete = function () { return _this.delete; };
	    }
	    /**
	     * @export
	     * @return {Promise<string> | Promise<null>} Returns a promise that
	     * resolves to an FCM token.
	     */
	    ControllerInterface.prototype.getToken = function () {
	        var _this = this;
	        // Check with permissions
	        var currentPermission = this.getNotificationPermission_();
	        if (currentPermission !== notification_permission_1.default.granted) {
	            if (currentPermission === notification_permission_1.default.denied) {
	                return Promise.reject(this.errorFactory_.create(errors_1.default.codes.NOTIFICATIONS_BLOCKED));
	            }
	            // We must wait for permission to be granted
	            return Promise.resolve(null);
	        }
	        return this.getSWRegistration_().then(function (registration) {
	            return _this.tokenManager_
	                .getSavedToken(_this.messagingSenderId_, registration)
	                .then(function (token) {
	                if (token) {
	                    return token;
	                }
	                return _this.tokenManager_.createToken(_this.messagingSenderId_, registration);
	            });
	        });
	    };
	    /**
	     * This method deletes tokens that the token manager looks after and then
	     * unregisters the push subscription if it exists.
	     * @export
	     * @param {string} token
	     * @return {Promise<void>}
	     */
	    ControllerInterface.prototype.deleteToken = function (token) {
	        var _this = this;
	        return this.tokenManager_.deleteToken(token).then(function () {
	            return _this.getSWRegistration_()
	                .then(function (registration) {
	                if (registration) {
	                    return registration.pushManager.getSubscription();
	                }
	            })
	                .then(function (subscription) {
	                if (subscription) {
	                    return subscription.unsubscribe();
	                }
	            });
	        });
	    };
	    ControllerInterface.prototype.getSWRegistration_ = function () {
	        throw this.errorFactory_.create(errors_1.default.codes.SHOULD_BE_INHERITED);
	    };
	    //
	    // The following methods should only be available in the window.
	    //
	    ControllerInterface.prototype.requestPermission = function () {
	        throw this.errorFactory_.create(errors_1.default.codes.AVAILABLE_IN_WINDOW);
	    };
	    /**
	     * @export
	     * @param {!ServiceWorkerRegistration} registration
	     */
	    ControllerInterface.prototype.useServiceWorker = function (registration) {
	        throw this.errorFactory_.create(errors_1.default.codes.AVAILABLE_IN_WINDOW);
	    };
	    /**
	     * @export
	     * @param {!firebase.Observer|function(*)} nextOrObserver
	     * @param {function(!Error)=} optError
	     * @param {function()=} optCompleted
	     * @return {!function()}
	     */
	    ControllerInterface.prototype.onMessage = function (nextOrObserver, optError, optCompleted) {
	        throw this.errorFactory_.create(errors_1.default.codes.AVAILABLE_IN_WINDOW);
	    };
	    /**
	     * @export
	     * @param {!firebase.Observer|function()} nextOrObserver An observer object
	     * or a function triggered on token refresh.
	     * @param {function(!Error)=} optError Optional A function
	     * triggered on token refresh error.
	     * @param {function()=} optCompleted Optional function triggered when the
	     * observer is removed.
	     * @return {!function()} The unsubscribe function for the observer.
	     */
	    ControllerInterface.prototype.onTokenRefresh = function (nextOrObserver, optError, optCompleted) {
	        throw this.errorFactory_.create(errors_1.default.codes.AVAILABLE_IN_WINDOW);
	    };
	    //
	    // The following methods are used by the service worker only.
	    //
	    /**
	     * @export
	     * @param {function(Object)} callback
	     */
	    ControllerInterface.prototype.setBackgroundMessageHandler = function (callback) {
	        throw this.errorFactory_.create(errors_1.default.codes.AVAILABLE_IN_SW);
	    };
	    //
	    // The following methods are used by the service themselves and not exposed
	    // publicly or not expected to be used by developers.
	    //
	    /**
	     * This method is required to adhere to the Firebase interface.
	     * It closes any currently open indexdb database connections.
	     */
	    ControllerInterface.prototype.delete = function () {
	        return this.tokenManager_.closeDatabase();
	    };
	    /**
	     * Returns the current Notification Permission state.
	     * @private
	     * @return {string} The currenct permission state.
	     */
	    ControllerInterface.prototype.getNotificationPermission_ = function () {
	        return Notification.permission;
	    };
	    /**
	     * @protected
	     * @returns {TokenManager}
	     */
	    ControllerInterface.prototype.getTokenManager = function () {
	        return this.tokenManager_;
	    };
	    return ControllerInterface;
	}());
	exports.default = ControllerInterface;
	
	//# sourceMappingURL=controller-interface.js.map


/***/ }),
/* 166 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	'use strict';
	Object.defineProperty(exports, "__esModule", { value: true });
	var FCM_APPLICATION_SERVER_KEY = [
	    0x04,
	    0x33,
	    0x94,
	    0xf7,
	    0xdf,
	    0xa1,
	    0xeb,
	    0xb1,
	    0xdc,
	    0x03,
	    0xa2,
	    0x5e,
	    0x15,
	    0x71,
	    0xdb,
	    0x48,
	    0xd3,
	    0x2e,
	    0xed,
	    0xed,
	    0xb2,
	    0x34,
	    0xdb,
	    0xb7,
	    0x47,
	    0x3a,
	    0x0c,
	    0x8f,
	    0xc4,
	    0xcc,
	    0xe1,
	    0x6f,
	    0x3c,
	    0x8c,
	    0x84,
	    0xdf,
	    0xab,
	    0xb6,
	    0x66,
	    0x3e,
	    0xf2,
	    0x0c,
	    0xd4,
	    0x8b,
	    0xfe,
	    0xe3,
	    0xf9,
	    0x76,
	    0x2f,
	    0x14,
	    0x1c,
	    0x63,
	    0x08,
	    0x6a,
	    0x6f,
	    0x2d,
	    0xb1,
	    0x1a,
	    0x95,
	    0xb0,
	    0xce,
	    0x37,
	    0xc0,
	    0x9c,
	    0x6e
	];
	var SUBSCRIPTION_DETAILS = {
	    userVisibleOnly: true,
	    applicationServerKey: new Uint8Array(FCM_APPLICATION_SERVER_KEY)
	};
	exports.default = {
	    ENDPOINT: 'https://fcm.googleapis.com',
	    APPLICATION_SERVER_KEY: FCM_APPLICATION_SERVER_KEY,
	    SUBSCRIPTION_OPTIONS: SUBSCRIPTION_DETAILS
	};
	
	//# sourceMappingURL=fcm-details.js.map


/***/ }),
/* 167 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	'use strict';
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = {
	    granted: 'granted',
	    default: 'default',
	    denied: 'denied'
	};
	
	//# sourceMappingURL=notification-permission.js.map


/***/ }),
/* 168 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	'use strict';
	Object.defineProperty(exports, "__esModule", { value: true });
	// These fields are strings to prevent closure from thinking goog.getMsg
	// should be used to initialise the values
	var PARAMS = {
	    TYPE_OF_MSG: 'firebase-messaging-msg-type',
	    DATA: 'firebase-messaging-msg-data'
	};
	// This value isn't using the TYPE_OF_MSG short hand as closure
	// expects the variable to be defined via goog.getMsg
	var msgType = {
	    PUSH_MSG_RECEIVED: 'push-msg-received',
	    NOTIFICATION_CLICKED: 'notification-clicked'
	};
	var createNewMsg = function (msgType, msgData) {
	    var message = (_a = {},
	        _a[PARAMS.TYPE_OF_MSG] = msgType,
	        _a[PARAMS.DATA] = msgData,
	        _a);
	    return message;
	    var _a;
	};
	exports.default = {
	    PARAMS: PARAMS,
	    TYPES_OF_MSG: msgType,
	    createNewMsg: createNewMsg
	};
	
	//# sourceMappingURL=worker-page-message.js.map


/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * @file Provides a Blob-like wrapper for various binary types (including the
	 * native Blob type). This makes it possible to upload types like ArrayBuffers,
	 * making uploads possible in environments without the native Blob type.
	 */
	var fs = __webpack_require__(310);
	var string = __webpack_require__(56);
	var string_1 = __webpack_require__(56);
	var type = __webpack_require__(22);
	/**
	 * @param opt_elideCopy If true, doesn't copy mutable input data
	 *     (e.g. Uint8Arrays). Pass true only if you know the objects will not be
	 *     modified after this blob's construction.
	 */
	var FbsBlob = /** @class */ (function () {
	    function FbsBlob(data, opt_elideCopy) {
	        var size = 0;
	        var blobType = '';
	        if (type.isNativeBlob(data)) {
	            this.data_ = data;
	            size = data.size;
	            blobType = data.type;
	        }
	        else if (data instanceof ArrayBuffer) {
	            if (opt_elideCopy) {
	                this.data_ = new Uint8Array(data);
	            }
	            else {
	                this.data_ = new Uint8Array(data.byteLength);
	                this.data_.set(new Uint8Array(data));
	            }
	            size = this.data_.length;
	        }
	        else if (data instanceof Uint8Array) {
	            if (opt_elideCopy) {
	                this.data_ = data;
	            }
	            else {
	                this.data_ = new Uint8Array(data.length);
	                this.data_.set(data);
	            }
	            size = data.length;
	        }
	        this.size_ = size;
	        this.type_ = blobType;
	    }
	    FbsBlob.prototype.size = function () {
	        return this.size_;
	    };
	    FbsBlob.prototype.type = function () {
	        return this.type_;
	    };
	    FbsBlob.prototype.slice = function (startByte, endByte) {
	        if (type.isNativeBlob(this.data_)) {
	            var realBlob = this.data_;
	            var sliced = fs.sliceBlob(realBlob, startByte, endByte);
	            if (sliced === null) {
	                return null;
	            }
	            return new FbsBlob(sliced);
	        }
	        else {
	            var slice = new Uint8Array(this.data_.buffer, startByte, endByte - startByte);
	            return new FbsBlob(slice, true);
	        }
	    };
	    FbsBlob.getBlob = function () {
	        var var_args = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            var_args[_i] = arguments[_i];
	        }
	        if (type.isNativeBlobDefined()) {
	            var blobby = var_args.map(function (val) {
	                if (val instanceof FbsBlob) {
	                    return val.data_;
	                }
	                else {
	                    return val;
	                }
	            });
	            return new FbsBlob(fs.getBlob.apply(null, blobby));
	        }
	        else {
	            var uint8Arrays = var_args.map(function (val) {
	                if (type.isString(val)) {
	                    return string.dataFromString(string_1.StringFormat.RAW, val).data;
	                }
	                else {
	                    // Blobs don't exist, so this has to be a Uint8Array.
	                    return val.data_;
	                }
	            });
	            var finalLength_1 = 0;
	            uint8Arrays.forEach(function (array) {
	                finalLength_1 += array.byteLength;
	            });
	            var merged_1 = new Uint8Array(finalLength_1);
	            var index_1 = 0;
	            uint8Arrays.forEach(function (array) {
	                for (var i = 0; i < array.length; i++) {
	                    merged_1[index_1++] = array[i];
	                }
	            });
	            return new FbsBlob(merged_1, true);
	        }
	    };
	    FbsBlob.prototype.uploadData = function () {
	        return this.data_;
	    };
	    return FbsBlob;
	}());
	exports.FbsBlob = FbsBlob;
	
	//# sourceMappingURL=blob.js.map


/***/ }),
/* 170 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * @fileoverview Contains helper methods for manipulating paths.
	 */
	/**
	 * @return Null if the path is already at the root.
	 */
	function parent(path) {
	    if (path.length == 0) {
	        return null;
	    }
	    var index = path.lastIndexOf('/');
	    if (index === -1) {
	        return '';
	    }
	    var newPath = path.slice(0, index);
	    return newPath;
	}
	exports.parent = parent;
	function child(path, childPath) {
	    var canonicalChildPath = childPath
	        .split('/')
	        .filter(function (component) {
	        return component.length > 0;
	    })
	        .join('/');
	    if (path.length === 0) {
	        return canonicalChildPath;
	    }
	    else {
	        return path + '/' + canonicalChildPath;
	    }
	}
	exports.child = child;
	/**
	 * Returns the last component of a path.
	 * '/foo/bar' -> 'bar'
	 * '/foo/bar/baz/' -> 'baz/'
	 * '/a' -> 'a'
	 */
	function lastComponent(path) {
	    var index = path.lastIndexOf('/', path.length - 2);
	    if (index === -1) {
	        return path;
	    }
	    else {
	        return path.slice(index + 1);
	    }
	}
	exports.lastComponent = lastComponent;
	
	//# sourceMappingURL=path.js.map


/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var array = __webpack_require__(107);
	var blob_1 = __webpack_require__(169);
	var errorsExports = __webpack_require__(30);
	var MetadataUtils = __webpack_require__(108);
	var object = __webpack_require__(43);
	var requestinfo_1 = __webpack_require__(314);
	var type = __webpack_require__(22);
	var UrlUtils = __webpack_require__(109);
	/**
	 * Throws the UNKNOWN FirebaseStorageError if cndn is false.
	 */
	function handlerCheck(cndn) {
	    if (!cndn) {
	        throw errorsExports.unknown();
	    }
	}
	exports.handlerCheck = handlerCheck;
	function metadataHandler(authWrapper, mappings) {
	    function handler(xhr, text) {
	        var metadata = MetadataUtils.fromResourceString(authWrapper, text, mappings);
	        handlerCheck(metadata !== null);
	        return metadata;
	    }
	    return handler;
	}
	exports.metadataHandler = metadataHandler;
	function sharedErrorHandler(location) {
	    function errorHandler(xhr, err) {
	        var newErr;
	        if (xhr.getStatus() === 401) {
	            newErr = errorsExports.unauthenticated();
	        }
	        else {
	            if (xhr.getStatus() === 402) {
	                newErr = errorsExports.quotaExceeded(location.bucket);
	            }
	            else {
	                if (xhr.getStatus() === 403) {
	                    newErr = errorsExports.unauthorized(location.path);
	                }
	                else {
	                    newErr = err;
	                }
	            }
	        }
	        newErr.setServerResponseProp(err.serverResponseProp());
	        return newErr;
	    }
	    return errorHandler;
	}
	exports.sharedErrorHandler = sharedErrorHandler;
	function objectErrorHandler(location) {
	    var shared = sharedErrorHandler(location);
	    function errorHandler(xhr, err) {
	        var newErr = shared(xhr, err);
	        if (xhr.getStatus() === 404) {
	            newErr = errorsExports.objectNotFound(location.path);
	        }
	        newErr.setServerResponseProp(err.serverResponseProp());
	        return newErr;
	    }
	    return errorHandler;
	}
	exports.objectErrorHandler = objectErrorHandler;
	function getMetadata(authWrapper, location, mappings) {
	    var urlPart = location.fullServerUrl();
	    var url = UrlUtils.makeNormalUrl(urlPart);
	    var method = 'GET';
	    var timeout = authWrapper.maxOperationRetryTime();
	    var requestInfo = new requestinfo_1.RequestInfo(url, method, metadataHandler(authWrapper, mappings), timeout);
	    requestInfo.errorHandler = objectErrorHandler(location);
	    return requestInfo;
	}
	exports.getMetadata = getMetadata;
	function updateMetadata(authWrapper, location, metadata, mappings) {
	    var urlPart = location.fullServerUrl();
	    var url = UrlUtils.makeNormalUrl(urlPart);
	    var method = 'PATCH';
	    var body = MetadataUtils.toResourceString(metadata, mappings);
	    var headers = { 'Content-Type': 'application/json; charset=utf-8' };
	    var timeout = authWrapper.maxOperationRetryTime();
	    var requestInfo = new requestinfo_1.RequestInfo(url, method, metadataHandler(authWrapper, mappings), timeout);
	    requestInfo.headers = headers;
	    requestInfo.body = body;
	    requestInfo.errorHandler = objectErrorHandler(location);
	    return requestInfo;
	}
	exports.updateMetadata = updateMetadata;
	function deleteObject(authWrapper, location) {
	    var urlPart = location.fullServerUrl();
	    var url = UrlUtils.makeNormalUrl(urlPart);
	    var method = 'DELETE';
	    var timeout = authWrapper.maxOperationRetryTime();
	    function handler(xhr, text) { }
	    var requestInfo = new requestinfo_1.RequestInfo(url, method, handler, timeout);
	    requestInfo.successCodes = [200, 204];
	    requestInfo.errorHandler = objectErrorHandler(location);
	    return requestInfo;
	}
	exports.deleteObject = deleteObject;
	function determineContentType_(metadata, blob) {
	    return ((metadata && metadata['contentType']) ||
	        (blob && blob.type()) ||
	        'application/octet-stream');
	}
	exports.determineContentType_ = determineContentType_;
	function metadataForUpload_(location, blob, opt_metadata) {
	    var metadata = object.clone(opt_metadata);
	    metadata['fullPath'] = location.path;
	    metadata['size'] = blob.size();
	    if (!metadata['contentType']) {
	        metadata['contentType'] = determineContentType_(null, blob);
	    }
	    return metadata;
	}
	exports.metadataForUpload_ = metadataForUpload_;
	function multipartUpload(authWrapper, location, mappings, blob, opt_metadata) {
	    var urlPart = location.bucketOnlyServerUrl();
	    var headers = {
	        'X-Goog-Upload-Protocol': 'multipart'
	    };
	    function genBoundary() {
	        var str = '';
	        for (var i = 0; i < 2; i++) {
	            str =
	                str +
	                    Math.random()
	                        .toString()
	                        .slice(2);
	        }
	        return str;
	    }
	    var boundary = genBoundary();
	    headers['Content-Type'] = 'multipart/related; boundary=' + boundary;
	    var metadata = metadataForUpload_(location, blob, opt_metadata);
	    var metadataString = MetadataUtils.toResourceString(metadata, mappings);
	    var preBlobPart = '--' +
	        boundary +
	        '\r\n' +
	        'Content-Type: application/json; charset=utf-8\r\n\r\n' +
	        metadataString +
	        '\r\n--' +
	        boundary +
	        '\r\n' +
	        'Content-Type: ' +
	        metadata['contentType'] +
	        '\r\n\r\n';
	    var postBlobPart = '\r\n--' + boundary + '--';
	    var body = blob_1.FbsBlob.getBlob(preBlobPart, blob, postBlobPart);
	    if (body === null) {
	        throw errorsExports.cannotSliceBlob();
	    }
	    var urlParams = { name: metadata['fullPath'] };
	    var url = UrlUtils.makeUploadUrl(urlPart);
	    var method = 'POST';
	    var timeout = authWrapper.maxUploadRetryTime();
	    var requestInfo = new requestinfo_1.RequestInfo(url, method, metadataHandler(authWrapper, mappings), timeout);
	    requestInfo.urlParams = urlParams;
	    requestInfo.headers = headers;
	    requestInfo.body = body.uploadData();
	    requestInfo.errorHandler = sharedErrorHandler(location);
	    return requestInfo;
	}
	exports.multipartUpload = multipartUpload;
	/**
	 * @param current The number of bytes that have been uploaded so far.
	 * @param total The total number of bytes in the upload.
	 * @param opt_finalized True if the server has finished the upload.
	 * @param opt_metadata The upload metadata, should
	 *     only be passed if opt_finalized is true.
	 * @struct
	 */
	var ResumableUploadStatus = /** @class */ (function () {
	    function ResumableUploadStatus(current, total, finalized, metadata) {
	        this.current = current;
	        this.total = total;
	        this.finalized = !!finalized;
	        this.metadata = metadata || null;
	    }
	    return ResumableUploadStatus;
	}());
	exports.ResumableUploadStatus = ResumableUploadStatus;
	function checkResumeHeader_(xhr, opt_allowed) {
	    var status;
	    try {
	        status = xhr.getResponseHeader('X-Goog-Upload-Status');
	    }
	    catch (e) {
	        handlerCheck(false);
	    }
	    var allowed = opt_allowed || ['active'];
	    handlerCheck(array.contains(allowed, status));
	    return status;
	}
	exports.checkResumeHeader_ = checkResumeHeader_;
	function createResumableUpload(authWrapper, location, mappings, blob, opt_metadata) {
	    var urlPart = location.bucketOnlyServerUrl();
	    var metadata = metadataForUpload_(location, blob, opt_metadata);
	    var urlParams = { name: metadata['fullPath'] };
	    var url = UrlUtils.makeUploadUrl(urlPart);
	    var method = 'POST';
	    var headers = {
	        'X-Goog-Upload-Protocol': 'resumable',
	        'X-Goog-Upload-Command': 'start',
	        'X-Goog-Upload-Header-Content-Length': blob.size(),
	        'X-Goog-Upload-Header-Content-Type': metadata['contentType'],
	        'Content-Type': 'application/json; charset=utf-8'
	    };
	    var body = MetadataUtils.toResourceString(metadata, mappings);
	    var timeout = authWrapper.maxUploadRetryTime();
	    function handler(xhr, text) {
	        checkResumeHeader_(xhr);
	        var url;
	        try {
	            url = xhr.getResponseHeader('X-Goog-Upload-URL');
	        }
	        catch (e) {
	            handlerCheck(false);
	        }
	        handlerCheck(type.isString(url));
	        return url;
	    }
	    var requestInfo = new requestinfo_1.RequestInfo(url, method, handler, timeout);
	    requestInfo.urlParams = urlParams;
	    requestInfo.headers = headers;
	    requestInfo.body = body;
	    requestInfo.errorHandler = sharedErrorHandler(location);
	    return requestInfo;
	}
	exports.createResumableUpload = createResumableUpload;
	/**
	 * @param url From a call to fbs.requests.createResumableUpload.
	 */
	function getResumableUploadStatus(authWrapper, location, url, blob) {
	    var headers = { 'X-Goog-Upload-Command': 'query' };
	    function handler(xhr, text) {
	        var status = checkResumeHeader_(xhr, ['active', 'final']);
	        var sizeString;
	        try {
	            sizeString = xhr.getResponseHeader('X-Goog-Upload-Size-Received');
	        }
	        catch (e) {
	            handlerCheck(false);
	        }
	        var size = parseInt(sizeString, 10);
	        handlerCheck(!isNaN(size));
	        return new ResumableUploadStatus(size, blob.size(), status === 'final');
	    }
	    var method = 'POST';
	    var timeout = authWrapper.maxUploadRetryTime();
	    var requestInfo = new requestinfo_1.RequestInfo(url, method, handler, timeout);
	    requestInfo.headers = headers;
	    requestInfo.errorHandler = sharedErrorHandler(location);
	    return requestInfo;
	}
	exports.getResumableUploadStatus = getResumableUploadStatus;
	/**
	 * Any uploads via the resumable upload API must transfer a number of bytes
	 * that is a multiple of this number.
	 */
	exports.resumableUploadChunkSize = 256 * 1024;
	/**
	 * @param url From a call to fbs.requests.createResumableUpload.
	 * @param chunkSize Number of bytes to upload.
	 * @param opt_status The previous status.
	 *     If not passed or null, we start from the beginning.
	 * @throws fbs.Error If the upload is already complete, the passed in status
	 *     has a final size inconsistent with the blob, or the blob cannot be sliced
	 *     for upload.
	 */
	function continueResumableUpload(location, authWrapper, url, blob, chunkSize, mappings, opt_status, opt_progressCallback) {
	    // TODO(andysoto): standardize on internal asserts
	    // assert(!(opt_status && opt_status.finalized));
	    var status = new ResumableUploadStatus(0, 0);
	    if (opt_status) {
	        status.current = opt_status.current;
	        status.total = opt_status.total;
	    }
	    else {
	        status.current = 0;
	        status.total = blob.size();
	    }
	    if (blob.size() !== status.total) {
	        throw errorsExports.serverFileWrongSize();
	    }
	    var bytesLeft = status.total - status.current;
	    var bytesToUpload = bytesLeft;
	    if (chunkSize > 0) {
	        bytesToUpload = Math.min(bytesToUpload, chunkSize);
	    }
	    var startByte = status.current;
	    var endByte = startByte + bytesToUpload;
	    var uploadCommand = bytesToUpload === bytesLeft ? 'upload, finalize' : 'upload';
	    var headers = {
	        'X-Goog-Upload-Command': uploadCommand,
	        'X-Goog-Upload-Offset': status.current
	    };
	    var body = blob.slice(startByte, endByte);
	    if (body === null) {
	        throw errorsExports.cannotSliceBlob();
	    }
	    function handler(xhr, text) {
	        // TODO(andysoto): Verify the MD5 of each uploaded range:
	        // the 'x-range-md5' header comes back with status code 308 responses.
	        // We'll only be able to bail out though, because you can't re-upload a
	        // range that you previously uploaded.
	        var uploadStatus = checkResumeHeader_(xhr, ['active', 'final']);
	        var newCurrent = status.current + bytesToUpload;
	        var size = blob.size();
	        var metadata;
	        if (uploadStatus === 'final') {
	            metadata = metadataHandler(authWrapper, mappings)(xhr, text);
	        }
	        else {
	            metadata = null;
	        }
	        return new ResumableUploadStatus(newCurrent, size, uploadStatus === 'final', metadata);
	    }
	    var method = 'POST';
	    var timeout = authWrapper.maxUploadRetryTime();
	    var requestInfo = new requestinfo_1.RequestInfo(url, method, handler, timeout);
	    requestInfo.headers = headers;
	    requestInfo.body = body.uploadData();
	    requestInfo.progressCallback = opt_progressCallback || null;
	    requestInfo.errorHandler = sharedErrorHandler(location);
	    return requestInfo;
	}
	exports.continueResumableUpload = continueResumableUpload;
	
	//# sourceMappingURL=requests.js.map


/***/ }),
/* 172 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * @enum{number}
	 */
	var ErrorCode;
	(function (ErrorCode) {
	    ErrorCode[ErrorCode["NO_ERROR"] = 0] = "NO_ERROR";
	    ErrorCode[ErrorCode["NETWORK_ERROR"] = 1] = "NETWORK_ERROR";
	    ErrorCode[ErrorCode["ABORT"] = 2] = "ABORT";
	})(ErrorCode = exports.ErrorCode || (exports.ErrorCode = {}));
	
	//# sourceMappingURL=xhrio.js.map


/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * @fileoverview Defines the Firebase Storage Reference class.
	 */
	var args = __webpack_require__(106);
	var blob_1 = __webpack_require__(169);
	var errorsExports = __webpack_require__(30);
	var location_1 = __webpack_require__(79);
	var metadata = __webpack_require__(108);
	var object = __webpack_require__(43);
	var path = __webpack_require__(170);
	var requests = __webpack_require__(171);
	var fbsString = __webpack_require__(56);
	var string_1 = __webpack_require__(56);
	var type = __webpack_require__(22);
	var task_1 = __webpack_require__(319);
	/**
	 * Provides methods to interact with a bucket in the Firebase Storage service.
	 * @param location An fbs.location, or the URL at
	 *     which to base this object, in one of the following forms:
	 *         gs://<bucket>/<object-path>
	 *         http[s]://firebasestorage.googleapis.com/
	 *                     <api-version>/b/<bucket>/o/<object-path>
	 *     Any query or fragment strings will be ignored in the http[s]
	 *     format. If no value is passed, the storage object will use a URL based on
	 *     the project ID of the base firebase.App instance.
	 */
	var Reference = /** @class */ (function () {
	    function Reference(authWrapper, location) {
	        this.authWrapper = authWrapper;
	        if (location instanceof location_1.Location) {
	            this.location = location;
	        }
	        else {
	            this.location = location_1.Location.makeFromUrl(location);
	        }
	    }
	    /**
	     * @return The URL for the bucket and path this object references,
	     *     in the form gs://<bucket>/<object-path>
	     * @override
	     */
	    Reference.prototype.toString = function () {
	        args.validate('toString', [], arguments);
	        return 'gs://' + this.location.bucket + '/' + this.location.path;
	    };
	    Reference.prototype.newRef = function (authWrapper, location) {
	        return new Reference(authWrapper, location);
	    };
	    Reference.prototype.mappings = function () {
	        return metadata.getMappings();
	    };
	    /**
	     * @return A reference to the object obtained by
	     *     appending childPath, removing any duplicate, beginning, or trailing
	     *     slashes.
	     */
	    Reference.prototype.child = function (childPath) {
	        args.validate('child', [args.stringSpec()], arguments);
	        var newPath = path.child(this.location.path, childPath);
	        var location = new location_1.Location(this.location.bucket, newPath);
	        return this.newRef(this.authWrapper, location);
	    };
	    Object.defineProperty(Reference.prototype, "parent", {
	        /**
	         * @return A reference to the parent of the
	         *     current object, or null if the current object is the root.
	         */
	        get: function () {
	            var newPath = path.parent(this.location.path);
	            if (newPath === null) {
	                return null;
	            }
	            var location = new location_1.Location(this.location.bucket, newPath);
	            return this.newRef(this.authWrapper, location);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(Reference.prototype, "root", {
	        /**
	         * @return An reference to the root of this
	         *     object's bucket.
	         */
	        get: function () {
	            var location = new location_1.Location(this.location.bucket, '');
	            return this.newRef(this.authWrapper, location);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(Reference.prototype, "bucket", {
	        get: function () {
	            return this.location.bucket;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(Reference.prototype, "fullPath", {
	        get: function () {
	            return this.location.path;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(Reference.prototype, "name", {
	        get: function () {
	            return path.lastComponent(this.location.path);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(Reference.prototype, "storage", {
	        get: function () {
	            return this.authWrapper.service();
	        },
	        enumerable: true,
	        configurable: true
	    });
	    /**
	     * Uploads a blob to this object's location.
	     * @param data The blob to upload.
	     * @return An UploadTask that lets you control and
	     *     observe the upload.
	     */
	    Reference.prototype.put = function (data, metadata) {
	        if (metadata === void 0) { metadata = null; }
	        args.validate('put', [args.uploadDataSpec(), args.metadataSpec(true)], arguments);
	        this.throwIfRoot_('put');
	        return new task_1.UploadTask(this, this.authWrapper, this.location, this.mappings(), new blob_1.FbsBlob(data), metadata);
	    };
	    /**
	     * Uploads a string to this object's location.
	     * @param string The string to upload.
	     * @param opt_format The format of the string to upload.
	     * @return An UploadTask that lets you control and
	     *     observe the upload.
	     */
	    Reference.prototype.putString = function (string, format, opt_metadata) {
	        if (format === void 0) { format = string_1.StringFormat.RAW; }
	        args.validate('putString', [
	            args.stringSpec(),
	            args.stringSpec(fbsString.formatValidator, true),
	            args.metadataSpec(true)
	        ], arguments);
	        this.throwIfRoot_('putString');
	        var data = fbsString.dataFromString(format, string);
	        var metadata = object.clone(opt_metadata);
	        if (!type.isDef(metadata['contentType']) && type.isDef(data.contentType)) {
	            metadata['contentType'] = data.contentType;
	        }
	        return new task_1.UploadTask(this, this.authWrapper, this.location, this.mappings(), new blob_1.FbsBlob(data.data, true), metadata);
	    };
	    /**
	     * Deletes the object at this location.
	     * @return A promise that resolves if the deletion succeeds.
	     */
	    Reference.prototype.delete = function () {
	        args.validate('delete', [], arguments);
	        this.throwIfRoot_('delete');
	        var self = this;
	        return this.authWrapper.getAuthToken().then(function (authToken) {
	            var requestInfo = requests.deleteObject(self.authWrapper, self.location);
	            return self.authWrapper.makeRequest(requestInfo, authToken).getPromise();
	        });
	    };
	    /**
	     *     A promise that resolves with the metadata for this object. If this
	     *     object doesn't exist or metadata cannot be retreived, the promise is
	     *     rejected.
	     */
	    Reference.prototype.getMetadata = function () {
	        args.validate('getMetadata', [], arguments);
	        this.throwIfRoot_('getMetadata');
	        var self = this;
	        return this.authWrapper.getAuthToken().then(function (authToken) {
	            var requestInfo = requests.getMetadata(self.authWrapper, self.location, self.mappings());
	            return self.authWrapper.makeRequest(requestInfo, authToken).getPromise();
	        });
	    };
	    /**
	     * Updates the metadata for this object.
	     * @param metadata The new metadata for the object.
	     *     Only values that have been explicitly set will be changed. Explicitly
	     *     setting a value to null will remove the metadata.
	     * @return A promise that resolves
	     *     with the new metadata for this object.
	     *     @see firebaseStorage.Reference.prototype.getMetadata
	     */
	    Reference.prototype.updateMetadata = function (metadata) {
	        args.validate('updateMetadata', [args.metadataSpec()], arguments);
	        this.throwIfRoot_('updateMetadata');
	        var self = this;
	        return this.authWrapper.getAuthToken().then(function (authToken) {
	            var requestInfo = requests.updateMetadata(self.authWrapper, self.location, metadata, self.mappings());
	            return self.authWrapper.makeRequest(requestInfo, authToken).getPromise();
	        });
	    };
	    /**
	     * @return A promise that resolves with the download
	     *     URL for this object.
	     */
	    Reference.prototype.getDownloadURL = function () {
	        args.validate('getDownloadURL', [], arguments);
	        this.throwIfRoot_('getDownloadURL');
	        return this.getMetadata().then(function (metadata) {
	            var url = metadata['downloadURLs'][0];
	            if (type.isDef(url)) {
	                return url;
	            }
	            else {
	                throw errorsExports.noDownloadURL();
	            }
	        });
	    };
	    Reference.prototype.throwIfRoot_ = function (name) {
	        if (this.location.path === '') {
	            throw errorsExports.invalidRootOperation(name);
	        }
	    };
	    return Reference;
	}());
	exports.Reference = Reference;
	
	//# sourceMappingURL=reference.js.map


/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var constants_1 = __webpack_require__(110);
	/**
	 * Throws an error if the provided assertion is falsy
	 * @param {*} assertion The assertion to be tested for falsiness
	 * @param {!string} message The message to display if the check fails
	 */
	exports.assert = function (assertion, message) {
	    if (!assertion) {
	        throw exports.assertionError(message);
	    }
	};
	/**
	 * Returns an Error object suitable for throwing.
	 * @param {string} message
	 * @return {!Error}
	 */
	exports.assertionError = function (message) {
	    return new Error('Firebase Database (' +
	        constants_1.CONSTANTS.SDK_VERSION +
	        ') INTERNAL ASSERT FAILED: ' +
	        message);
	};
	
	//# sourceMappingURL=assert.js.map


/***/ }),
/* 175 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var stringToByteArray = function (str) {
	    // TODO(user): Use native implementations if/when available
	    var out = [], p = 0;
	    for (var i = 0; i < str.length; i++) {
	        var c = str.charCodeAt(i);
	        if (c < 128) {
	            out[p++] = c;
	        }
	        else if (c < 2048) {
	            out[p++] = (c >> 6) | 192;
	            out[p++] = (c & 63) | 128;
	        }
	        else if ((c & 0xfc00) == 0xd800 &&
	            i + 1 < str.length &&
	            (str.charCodeAt(i + 1) & 0xfc00) == 0xdc00) {
	            // Surrogate Pair
	            c = 0x10000 + ((c & 0x03ff) << 10) + (str.charCodeAt(++i) & 0x03ff);
	            out[p++] = (c >> 18) | 240;
	            out[p++] = ((c >> 12) & 63) | 128;
	            out[p++] = ((c >> 6) & 63) | 128;
	            out[p++] = (c & 63) | 128;
	        }
	        else {
	            out[p++] = (c >> 12) | 224;
	            out[p++] = ((c >> 6) & 63) | 128;
	            out[p++] = (c & 63) | 128;
	        }
	    }
	    return out;
	};
	/**
	 * Turns an array of numbers into the string given by the concatenation of the
	 * characters to which the numbers correspond.
	 * @param {Array<number>} bytes Array of numbers representing characters.
	 * @return {string} Stringification of the array.
	 */
	var byteArrayToString = function (bytes) {
	    // TODO(user): Use native implementations if/when available
	    var out = [], pos = 0, c = 0;
	    while (pos < bytes.length) {
	        var c1 = bytes[pos++];
	        if (c1 < 128) {
	            out[c++] = String.fromCharCode(c1);
	        }
	        else if (c1 > 191 && c1 < 224) {
	            var c2 = bytes[pos++];
	            out[c++] = String.fromCharCode(((c1 & 31) << 6) | (c2 & 63));
	        }
	        else if (c1 > 239 && c1 < 365) {
	            // Surrogate Pair
	            var c2 = bytes[pos++];
	            var c3 = bytes[pos++];
	            var c4 = bytes[pos++];
	            var u = (((c1 & 7) << 18) | ((c2 & 63) << 12) | ((c3 & 63) << 6) | (c4 & 63)) -
	                0x10000;
	            out[c++] = String.fromCharCode(0xd800 + (u >> 10));
	            out[c++] = String.fromCharCode(0xdc00 + (u & 1023));
	        }
	        else {
	            var c2 = bytes[pos++];
	            var c3 = bytes[pos++];
	            out[c++] = String.fromCharCode(((c1 & 15) << 12) | ((c2 & 63) << 6) | (c3 & 63));
	        }
	    }
	    return out.join('');
	};
	// Static lookup maps, lazily populated by init_()
	exports.base64 = {
	    /**
	     * Maps bytes to characters.
	     * @type {Object}
	     * @private
	     */
	    byteToCharMap_: null,
	    /**
	     * Maps characters to bytes.
	     * @type {Object}
	     * @private
	     */
	    charToByteMap_: null,
	    /**
	     * Maps bytes to websafe characters.
	     * @type {Object}
	     * @private
	     */
	    byteToCharMapWebSafe_: null,
	    /**
	     * Maps websafe characters to bytes.
	     * @type {Object}
	     * @private
	     */
	    charToByteMapWebSafe_: null,
	    /**
	     * Our default alphabet, shared between
	     * ENCODED_VALS and ENCODED_VALS_WEBSAFE
	     * @type {string}
	     */
	    ENCODED_VALS_BASE: 'ABCDEFGHIJKLMNOPQRSTUVWXYZ' + 'abcdefghijklmnopqrstuvwxyz' + '0123456789',
	    /**
	     * Our default alphabet. Value 64 (=) is special; it means "nothing."
	     * @type {string}
	     */
	    get ENCODED_VALS() {
	        return this.ENCODED_VALS_BASE + '+/=';
	    },
	    /**
	     * Our websafe alphabet.
	     * @type {string}
	     */
	    get ENCODED_VALS_WEBSAFE() {
	        return this.ENCODED_VALS_BASE + '-_.';
	    },
	    /**
	     * Whether this browser supports the atob and btoa functions. This extension
	     * started at Mozilla but is now implemented by many browsers. We use the
	     * ASSUME_* variables to avoid pulling in the full useragent detection library
	     * but still allowing the standard per-browser compilations.
	     *
	     * @type {boolean}
	     */
	    HAS_NATIVE_SUPPORT: typeof atob === 'function',
	    /**
	     * Base64-encode an array of bytes.
	     *
	     * @param {Array<number>|Uint8Array} input An array of bytes (numbers with
	     *     value in [0, 255]) to encode.
	     * @param {boolean=} opt_webSafe Boolean indicating we should use the
	     *     alternative alphabet.
	     * @return {string} The base64 encoded string.
	     */
	    encodeByteArray: function (input, opt_webSafe) {
	        if (!Array.isArray(input)) {
	            throw Error('encodeByteArray takes an array as a parameter');
	        }
	        this.init_();
	        var byteToCharMap = opt_webSafe
	            ? this.byteToCharMapWebSafe_
	            : this.byteToCharMap_;
	        var output = [];
	        for (var i = 0; i < input.length; i += 3) {
	            var byte1 = input[i];
	            var haveByte2 = i + 1 < input.length;
	            var byte2 = haveByte2 ? input[i + 1] : 0;
	            var haveByte3 = i + 2 < input.length;
	            var byte3 = haveByte3 ? input[i + 2] : 0;
	            var outByte1 = byte1 >> 2;
	            var outByte2 = ((byte1 & 0x03) << 4) | (byte2 >> 4);
	            var outByte3 = ((byte2 & 0x0f) << 2) | (byte3 >> 6);
	            var outByte4 = byte3 & 0x3f;
	            if (!haveByte3) {
	                outByte4 = 64;
	                if (!haveByte2) {
	                    outByte3 = 64;
	                }
	            }
	            output.push(byteToCharMap[outByte1], byteToCharMap[outByte2], byteToCharMap[outByte3], byteToCharMap[outByte4]);
	        }
	        return output.join('');
	    },
	    /**
	     * Base64-encode a string.
	     *
	     * @param {string} input A string to encode.
	     * @param {boolean=} opt_webSafe If true, we should use the
	     *     alternative alphabet.
	     * @return {string} The base64 encoded string.
	     */
	    encodeString: function (input, opt_webSafe) {
	        // Shortcut for Mozilla browsers that implement
	        // a native base64 encoder in the form of "btoa/atob"
	        if (this.HAS_NATIVE_SUPPORT && !opt_webSafe) {
	            return btoa(input);
	        }
	        return this.encodeByteArray(stringToByteArray(input), opt_webSafe);
	    },
	    /**
	     * Base64-decode a string.
	     *
	     * @param {string} input to decode.
	     * @param {boolean=} opt_webSafe True if we should use the
	     *     alternative alphabet.
	     * @return {string} string representing the decoded value.
	     */
	    decodeString: function (input, opt_webSafe) {
	        // Shortcut for Mozilla browsers that implement
	        // a native base64 encoder in the form of "btoa/atob"
	        if (this.HAS_NATIVE_SUPPORT && !opt_webSafe) {
	            return atob(input);
	        }
	        return byteArrayToString(this.decodeStringToByteArray(input, opt_webSafe));
	    },
	    /**
	     * Base64-decode a string.
	     *
	     * In base-64 decoding, groups of four characters are converted into three
	     * bytes.  If the encoder did not apply padding, the input length may not
	     * be a multiple of 4.
	     *
	     * In this case, the last group will have fewer than 4 characters, and
	     * padding will be inferred.  If the group has one or two characters, it decodes
	     * to one byte.  If the group has three characters, it decodes to two bytes.
	     *
	     * @param {string} input Input to decode.
	     * @param {boolean=} opt_webSafe True if we should use the web-safe alphabet.
	     * @return {!Array<number>} bytes representing the decoded value.
	     */
	    decodeStringToByteArray: function (input, opt_webSafe) {
	        this.init_();
	        var charToByteMap = opt_webSafe
	            ? this.charToByteMapWebSafe_
	            : this.charToByteMap_;
	        var output = [];
	        for (var i = 0; i < input.length;) {
	            var byte1 = charToByteMap[input.charAt(i++)];
	            var haveByte2 = i < input.length;
	            var byte2 = haveByte2 ? charToByteMap[input.charAt(i)] : 0;
	            ++i;
	            var haveByte3 = i < input.length;
	            var byte3 = haveByte3 ? charToByteMap[input.charAt(i)] : 64;
	            ++i;
	            var haveByte4 = i < input.length;
	            var byte4 = haveByte4 ? charToByteMap[input.charAt(i)] : 64;
	            ++i;
	            if (byte1 == null || byte2 == null || byte3 == null || byte4 == null) {
	                throw Error();
	            }
	            var outByte1 = (byte1 << 2) | (byte2 >> 4);
	            output.push(outByte1);
	            if (byte3 != 64) {
	                var outByte2 = ((byte2 << 4) & 0xf0) | (byte3 >> 2);
	                output.push(outByte2);
	                if (byte4 != 64) {
	                    var outByte3 = ((byte3 << 6) & 0xc0) | byte4;
	                    output.push(outByte3);
	                }
	            }
	        }
	        return output;
	    },
	    /**
	     * Lazy static initialization function. Called before
	     * accessing any of the static map variables.
	     * @private
	     */
	    init_: function () {
	        if (!this.byteToCharMap_) {
	            this.byteToCharMap_ = {};
	            this.charToByteMap_ = {};
	            this.byteToCharMapWebSafe_ = {};
	            this.charToByteMapWebSafe_ = {};
	            // We want quick mappings back and forth, so we precompute two maps.
	            for (var i = 0; i < this.ENCODED_VALS.length; i++) {
	                this.byteToCharMap_[i] = this.ENCODED_VALS.charAt(i);
	                this.charToByteMap_[this.byteToCharMap_[i]] = i;
	                this.byteToCharMapWebSafe_[i] = this.ENCODED_VALS_WEBSAFE.charAt(i);
	                this.charToByteMapWebSafe_[this.byteToCharMapWebSafe_[i]] = i;
	                // Be forgiving when decoding and correctly decode both encodings.
	                if (i >= this.ENCODED_VALS_BASE.length) {
	                    this.charToByteMap_[this.ENCODED_VALS_WEBSAFE.charAt(i)] = i;
	                    this.charToByteMapWebSafe_[this.ENCODED_VALS.charAt(i)] = i;
	                }
	            }
	        }
	    }
	};
	/**
	 * URL-safe base64 encoding
	 * @param {!string} str
	 * @return {!string}
	 */
	exports.base64Encode = function (str) {
	    var utf8Bytes = stringToByteArray(str);
	    return exports.base64.encodeByteArray(utf8Bytes, true);
	};
	/**
	 * URL-safe base64 decoding
	 *
	 * NOTE: DO NOT use the global atob() function - it does NOT support the
	 * base64Url variant encoding.
	 *
	 * @param {string} str To be decoded
	 * @return {?string} Decoded result, if possible
	 */
	exports.base64Decode = function (str) {
	    try {
	        return exports.base64.decodeString(str, true);
	    }
	    catch (e) {
	        console.error('base64Decode failed: ', e);
	    }
	    return null;
	};
	
	//# sourceMappingURL=crypt.js.map


/***/ }),
/* 176 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Evaluates a JSON string into a javascript object.
	 *
	 * @param {string} str A string containing JSON.
	 * @return {*} The javascript object representing the specified JSON.
	 */
	function jsonEval(str) {
	    return JSON.parse(str);
	}
	exports.jsonEval = jsonEval;
	/**
	 * Returns JSON representing a javascript object.
	 * @param {*} data Javascript object to be stringified.
	 * @return {string} The JSON contents of the object.
	 */
	function stringify(data) {
	    return JSON.stringify(data);
	}
	exports.stringify = stringify;
	
	//# sourceMappingURL=json.js.map


/***/ }),
/* 177 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	// See http://www.devthought.com/2012/01/18/an-object-is-not-a-hash/
	exports.contains = function (obj, key) {
	    return Object.prototype.hasOwnProperty.call(obj, key);
	};
	exports.safeGet = function (obj, key) {
	    if (Object.prototype.hasOwnProperty.call(obj, key))
	        return obj[key];
	    // else return undefined.
	};
	/**
	 * Enumerates the keys/values in an object, excluding keys defined on the prototype.
	 *
	 * @param {?Object.<K,V>} obj Object to enumerate.
	 * @param {!function(K, V)} fn Function to call for each key and value.
	 * @template K,V
	 */
	exports.forEach = function (obj, fn) {
	    for (var key in obj) {
	        if (Object.prototype.hasOwnProperty.call(obj, key)) {
	            fn(key, obj[key]);
	        }
	    }
	};
	/**
	 * Copies all the (own) properties from one object to another.
	 * @param {!Object} objTo
	 * @param {!Object} objFrom
	 * @return {!Object} objTo
	 */
	exports.extend = function (objTo, objFrom) {
	    exports.forEach(objFrom, function (key, value) {
	        objTo[key] = value;
	    });
	    return objTo;
	};
	/**
	 * Returns a clone of the specified object.
	 * @param {!Object} obj
	 * @return {!Object} cloned obj.
	 */
	exports.clone = function (obj) {
	    return exports.extend({}, obj);
	};
	/**
	 * Returns true if obj has typeof "object" and is not null.  Unlike goog.isObject(), does not return true
	 * for functions.
	 *
	 * @param obj {*} A potential object.
	 * @returns {boolean} True if it's an object.
	 */
	exports.isNonNullObject = function (obj) {
	    return typeof obj === 'object' && obj !== null;
	};
	exports.isEmpty = function (obj) {
	    for (var key in obj) {
	        return false;
	    }
	    return true;
	};
	exports.getCount = function (obj) {
	    var rv = 0;
	    for (var key in obj) {
	        rv++;
	    }
	    return rv;
	};
	exports.map = function (obj, f, opt_obj) {
	    var res = {};
	    for (var key in obj) {
	        res[key] = f.call(opt_obj, obj[key], key, obj);
	    }
	    return res;
	};
	exports.findKey = function (obj, fn, opt_this) {
	    for (var key in obj) {
	        if (fn.call(opt_this, obj[key], key, obj)) {
	            return key;
	        }
	    }
	    return undefined;
	};
	exports.findValue = function (obj, fn, opt_this) {
	    var key = exports.findKey(obj, fn, opt_this);
	    return key && obj[key];
	};
	exports.getAnyKey = function (obj) {
	    for (var key in obj) {
	        return key;
	    }
	};
	exports.getValues = function (obj) {
	    var res = [];
	    var i = 0;
	    for (var key in obj) {
	        res[i++] = obj[key];
	    }
	    return res;
	};
	/**
	 * Tests whether every key/value pair in an object pass the test implemented
	 * by the provided function
	 *
	 * @param {?Object.<K,V>} obj Object to test.
	 * @param {!function(K, V)} fn Function to call for each key and value.
	 * @template K,V
	 */
	exports.every = function (obj, fn) {
	    for (var key in obj) {
	        if (Object.prototype.hasOwnProperty.call(obj, key)) {
	            if (!fn(key, obj[key])) {
	                return false;
	            }
	        }
	    }
	    return true;
	};
	
	//# sourceMappingURL=obj.js.map


/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(23);
	var settle = __webpack_require__(340);
	var buildURL = __webpack_require__(343);
	var parseHeaders = __webpack_require__(349);
	var isURLSameOrigin = __webpack_require__(347);
	var createError = __webpack_require__(181);
	var btoa = (typeof window !== 'undefined' && window.btoa && window.btoa.bind(window)) || __webpack_require__(342);
	
	module.exports = function xhrAdapter(config) {
	  return new Promise(function dispatchXhrRequest(resolve, reject) {
	    var requestData = config.data;
	    var requestHeaders = config.headers;
	
	    if (utils.isFormData(requestData)) {
	      delete requestHeaders['Content-Type']; // Let the browser set it
	    }
	
	    var request = new XMLHttpRequest();
	    var loadEvent = 'onreadystatechange';
	    var xDomain = false;
	
	    // For IE 8/9 CORS support
	    // Only supports POST and GET calls and doesn't returns the response headers.
	    // DON'T do this for testing b/c XMLHttpRequest is mocked, not XDomainRequest.
	    if (("production") !== 'test' &&
	        typeof window !== 'undefined' &&
	        window.XDomainRequest && !('withCredentials' in request) &&
	        !isURLSameOrigin(config.url)) {
	      request = new window.XDomainRequest();
	      loadEvent = 'onload';
	      xDomain = true;
	      request.onprogress = function handleProgress() {};
	      request.ontimeout = function handleTimeout() {};
	    }
	
	    // HTTP basic authentication
	    if (config.auth) {
	      var username = config.auth.username || '';
	      var password = config.auth.password || '';
	      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
	    }
	
	    request.open(config.method.toUpperCase(), buildURL(config.url, config.params, config.paramsSerializer), true);
	
	    // Set the request timeout in MS
	    request.timeout = config.timeout;
	
	    // Listen for ready state
	    request[loadEvent] = function handleLoad() {
	      if (!request || (request.readyState !== 4 && !xDomain)) {
	        return;
	      }
	
	      // The request errored out and we didn't get a response, this will be
	      // handled by onerror instead
	      // With one exception: request that using file: protocol, most browsers
	      // will return status as 0 even though it's a successful request
	      if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
	        return;
	      }
	
	      // Prepare the response
	      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
	      var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
	      var response = {
	        data: responseData,
	        // IE sends 1223 instead of 204 (https://github.com/axios/axios/issues/201)
	        status: request.status === 1223 ? 204 : request.status,
	        statusText: request.status === 1223 ? 'No Content' : request.statusText,
	        headers: responseHeaders,
	        config: config,
	        request: request
	      };
	
	      settle(resolve, reject, response);
	
	      // Clean up request
	      request = null;
	    };
	
	    // Handle low level network errors
	    request.onerror = function handleError() {
	      // Real errors are hidden from us by the browser
	      // onerror should only fire if it's a network error
	      reject(createError('Network Error', config, null, request));
	
	      // Clean up request
	      request = null;
	    };
	
	    // Handle timeout
	    request.ontimeout = function handleTimeout() {
	      reject(createError('timeout of ' + config.timeout + 'ms exceeded', config, 'ECONNABORTED',
	        request));
	
	      // Clean up request
	      request = null;
	    };
	
	    // Add xsrf header
	    // This is only done if running in a standard browser environment.
	    // Specifically not if we're in a web worker, or react-native.
	    if (utils.isStandardBrowserEnv()) {
	      var cookies = __webpack_require__(345);
	
	      // Add xsrf header
	      var xsrfValue = (config.withCredentials || isURLSameOrigin(config.url)) && config.xsrfCookieName ?
	          cookies.read(config.xsrfCookieName) :
	          undefined;
	
	      if (xsrfValue) {
	        requestHeaders[config.xsrfHeaderName] = xsrfValue;
	      }
	    }
	
	    // Add headers to the request
	    if ('setRequestHeader' in request) {
	      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
	        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
	          // Remove Content-Type if data is undefined
	          delete requestHeaders[key];
	        } else {
	          // Otherwise add header to the request
	          request.setRequestHeader(key, val);
	        }
	      });
	    }
	
	    // Add withCredentials to request if needed
	    if (config.withCredentials) {
	      request.withCredentials = true;
	    }
	
	    // Add responseType to request if needed
	    if (config.responseType) {
	      try {
	        request.responseType = config.responseType;
	      } catch (e) {
	        // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
	        // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
	        if (config.responseType !== 'json') {
	          throw e;
	        }
	      }
	    }
	
	    // Handle progress if needed
	    if (typeof config.onDownloadProgress === 'function') {
	      request.addEventListener('progress', config.onDownloadProgress);
	    }
	
	    // Not all browsers support upload events
	    if (typeof config.onUploadProgress === 'function' && request.upload) {
	      request.upload.addEventListener('progress', config.onUploadProgress);
	    }
	
	    if (config.cancelToken) {
	      // Handle cancellation
	      config.cancelToken.promise.then(function onCanceled(cancel) {
	        if (!request) {
	          return;
	        }
	
	        request.abort();
	        reject(cancel);
	        // Clean up request
	        request = null;
	      });
	    }
	
	    if (requestData === undefined) {
	      requestData = null;
	    }
	
	    // Send the request
	    request.send(requestData);
	  });
	};


/***/ }),
/* 179 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * A `Cancel` is an object that is thrown when an operation is canceled.
	 *
	 * @class
	 * @param {string=} message The message.
	 */
	function Cancel(message) {
	  this.message = message;
	}
	
	Cancel.prototype.toString = function toString() {
	  return 'Cancel' + (this.message ? ': ' + this.message : '');
	};
	
	Cancel.prototype.__CANCEL__ = true;
	
	module.exports = Cancel;


/***/ }),
/* 180 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function isCancel(value) {
	  return !!(value && value.__CANCEL__);
	};


/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var enhanceError = __webpack_require__(339);
	
	/**
	 * Create an Error with the specified message, config, error code, request and response.
	 *
	 * @param {string} message The error message.
	 * @param {Object} config The config.
	 * @param {string} [code] The error code (for example, 'ECONNABORTED').
	 * @param {Object} [request] The request.
	 * @param {Object} [response] The response.
	 * @returns {Error} The created error.
	 */
	module.exports = function createError(message, config, code, request, response) {
	  var error = new Error(message);
	  return enhanceError(error, config, code, request, response);
	};


/***/ }),
/* 182 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function bind(fn, thisArg) {
	  return function wrap() {
	    var args = new Array(arguments.length);
	    for (var i = 0; i < args.length; i++) {
	      args[i] = arguments[i];
	    }
	    return fn.apply(thisArg, args);
	  };
	};


/***/ }),
/* 183 */
/***/ (function(module, exports) {

	// 7.2.1 RequireObjectCoercible(argument)
	module.exports = function (it) {
	  if (it == undefined) throw TypeError("Can't call method on  " + it);
	  return it;
	};


/***/ }),
/* 184 */
/***/ (function(module, exports) {

	var hasOwnProperty = {}.hasOwnProperty;
	module.exports = function (it, key) {
	  return hasOwnProperty.call(it, key);
	};


/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(366);
	var createDesc = __webpack_require__(371);
	module.exports = __webpack_require__(113) ? function (object, key, value) {
	  return dP.f(object, key, createDesc(1, value));
	} : function (object, key, value) {
	  object[key] = value;
	  return object;
	};


/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

	// fallback for non-array-like ES3 and non-enumerable old V8 strings
	var cof = __webpack_require__(359);
	// eslint-disable-next-line no-prototype-builtins
	module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
	  return cof(it) == 'String' ? it.split('') : Object(it);
	};


/***/ }),
/* 187 */
/***/ (function(module, exports) {

	// 7.1.4 ToInteger
	var ceil = Math.ceil;
	var floor = Math.floor;
	module.exports = function (it) {
	  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
	};


/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

	// to indexed object, toObject with fallback for non-array-like ES3 strings
	var IObject = __webpack_require__(186);
	var defined = __webpack_require__(183);
	module.exports = function (it) {
	  return IObject(defined(it));
	};


/***/ }),
/* 189 */
/***/ (function(module, exports) {

	var id = 0;
	var px = Math.random();
	module.exports = function (key) {
	  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
	};


/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var emptyFunction = __webpack_require__(24);
	
	/**
	 * Upstream version of event listener. Does not take into account specific
	 * nature of platform.
	 */
	var EventListener = {
	  /**
	   * Listen to DOM events during the bubble phase.
	   *
	   * @param {DOMEventTarget} target DOM element to register listener on.
	   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
	   * @param {function} callback Callback function.
	   * @return {object} Object with a `remove` method.
	   */
	  listen: function listen(target, eventType, callback) {
	    if (target.addEventListener) {
	      target.addEventListener(eventType, callback, false);
	      return {
	        remove: function remove() {
	          target.removeEventListener(eventType, callback, false);
	        }
	      };
	    } else if (target.attachEvent) {
	      target.attachEvent('on' + eventType, callback);
	      return {
	        remove: function remove() {
	          target.detachEvent('on' + eventType, callback);
	        }
	      };
	    }
	  },
	
	  /**
	   * Listen to DOM events during the capture phase.
	   *
	   * @param {DOMEventTarget} target DOM element to register listener on.
	   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
	   * @param {function} callback Callback function.
	   * @return {object} Object with a `remove` method.
	   */
	  capture: function capture(target, eventType, callback) {
	    if (target.addEventListener) {
	      target.addEventListener(eventType, callback, true);
	      return {
	        remove: function remove() {
	          target.removeEventListener(eventType, callback, true);
	        }
	      };
	    } else {
	      if (false) {
	        console.error('Attempted to listen to events during the capture phase on a ' + 'browser that does not support the capture phase. Your application ' + 'will not receive some events.');
	      }
	      return {
	        remove: emptyFunction
	      };
	    }
	  },
	
	  registerDefault: function registerDefault() {}
	};
	
	module.exports = EventListener;

/***/ }),
/* 191 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * @param {DOMElement} node input/textarea to focus
	 */
	
	function focusNode(node) {
	  // IE8 can throw "Can't move focus to the control because it is invisible,
	  // not enabled, or of a type that does not accept the focus." for all kinds of
	  // reasons that are too expensive and fragile to test.
	  try {
	    node.focus();
	  } catch (e) {}
	}
	
	module.exports = focusNode;

/***/ }),
/* 192 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	/* eslint-disable fb-www/typeof-undefined */
	
	/**
	 * Same as document.activeElement but wraps in a try-catch block. In IE it is
	 * not safe to call document.activeElement if there is nothing focused.
	 *
	 * The activeElement will be null only if the document or document body is not
	 * yet defined.
	 *
	 * @param {?DOMDocument} doc Defaults to current document.
	 * @return {?DOMElement}
	 */
	function getActiveElement(doc) /*?DOMElement*/{
	  doc = doc || (typeof document !== 'undefined' ? document : undefined);
	  if (typeof doc === 'undefined') {
	    return null;
	  }
	  try {
	    return doc.activeElement || doc.body;
	  } catch (e) {
	    return doc.body;
	  }
	}
	
	module.exports = getActiveElement;

/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "b9c2730e240eb05558a45eafae0ae64c.svg";

/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	var firebase = __webpack_require__(405);
	__webpack_require__(406);
	__webpack_require__(407);
	__webpack_require__(409);
	__webpack_require__(410);
	
	module.exports = firebase;


/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	// React 15.5 references this module, and assumes PropTypes are still callable in production.
	// Therefore we re-export development-only version with all the PropTypes checks here.
	// However if one is migrating to the `prop-types` npm library, they will go through the
	// `index.js` entry point, and it will branch depending on the environment.
	var factory = __webpack_require__(414);
	module.exports = function(isValidElement) {
	  // It is still allowed in 15.5.
	  var throwOnDirectAccess = false;
	  return factory(isValidElement, throwOnDirectAccess);
	};


/***/ }),
/* 196 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * CSS properties which accept numbers but are not in units of "px".
	 */
	
	var isUnitlessNumber = {
	  animationIterationCount: true,
	  borderImageOutset: true,
	  borderImageSlice: true,
	  borderImageWidth: true,
	  boxFlex: true,
	  boxFlexGroup: true,
	  boxOrdinalGroup: true,
	  columnCount: true,
	  columns: true,
	  flex: true,
	  flexGrow: true,
	  flexPositive: true,
	  flexShrink: true,
	  flexNegative: true,
	  flexOrder: true,
	  gridRow: true,
	  gridRowEnd: true,
	  gridRowSpan: true,
	  gridRowStart: true,
	  gridColumn: true,
	  gridColumnEnd: true,
	  gridColumnSpan: true,
	  gridColumnStart: true,
	  fontWeight: true,
	  lineClamp: true,
	  lineHeight: true,
	  opacity: true,
	  order: true,
	  orphans: true,
	  tabSize: true,
	  widows: true,
	  zIndex: true,
	  zoom: true,
	
	  // SVG-related properties
	  fillOpacity: true,
	  floodOpacity: true,
	  stopOpacity: true,
	  strokeDasharray: true,
	  strokeDashoffset: true,
	  strokeMiterlimit: true,
	  strokeOpacity: true,
	  strokeWidth: true
	};
	
	/**
	 * @param {string} prefix vendor-specific prefix, eg: Webkit
	 * @param {string} key style name, eg: transitionDuration
	 * @return {string} style name prefixed with `prefix`, properly camelCased, eg:
	 * WebkitTransitionDuration
	 */
	function prefixKey(prefix, key) {
	  return prefix + key.charAt(0).toUpperCase() + key.substring(1);
	}
	
	/**
	 * Support style names that may come passed in prefixed by adding permutations
	 * of vendor prefixes.
	 */
	var prefixes = ['Webkit', 'ms', 'Moz', 'O'];
	
	// Using Object.keys here, or else the vanilla for-in loop makes IE8 go into an
	// infinite loop, because it iterates over the newly added props too.
	Object.keys(isUnitlessNumber).forEach(function (prop) {
	  prefixes.forEach(function (prefix) {
	    isUnitlessNumber[prefixKey(prefix, prop)] = isUnitlessNumber[prop];
	  });
	});
	
	/**
	 * Most style properties can be unset by doing .style[prop] = '' but IE8
	 * doesn't like doing that with shorthand properties so for the properties that
	 * IE8 breaks on, which are listed here, we instead unset each of the
	 * individual properties. See http://bugs.jquery.com/ticket/12385.
	 * The 4-value 'clock' properties like margin, padding, border-width seem to
	 * behave without any problems. Curiously, list-style works too without any
	 * special prodding.
	 */
	var shorthandPropertyExpansions = {
	  background: {
	    backgroundAttachment: true,
	    backgroundColor: true,
	    backgroundImage: true,
	    backgroundPositionX: true,
	    backgroundPositionY: true,
	    backgroundRepeat: true
	  },
	  backgroundPosition: {
	    backgroundPositionX: true,
	    backgroundPositionY: true
	  },
	  border: {
	    borderWidth: true,
	    borderStyle: true,
	    borderColor: true
	  },
	  borderBottom: {
	    borderBottomWidth: true,
	    borderBottomStyle: true,
	    borderBottomColor: true
	  },
	  borderLeft: {
	    borderLeftWidth: true,
	    borderLeftStyle: true,
	    borderLeftColor: true
	  },
	  borderRight: {
	    borderRightWidth: true,
	    borderRightStyle: true,
	    borderRightColor: true
	  },
	  borderTop: {
	    borderTopWidth: true,
	    borderTopStyle: true,
	    borderTopColor: true
	  },
	  font: {
	    fontStyle: true,
	    fontVariant: true,
	    fontWeight: true,
	    fontSize: true,
	    lineHeight: true,
	    fontFamily: true
	  },
	  outline: {
	    outlineWidth: true,
	    outlineStyle: true,
	    outlineColor: true
	  }
	};
	
	var CSSProperty = {
	  isUnitlessNumber: isUnitlessNumber,
	  shorthandPropertyExpansions: shorthandPropertyExpansions
	};
	
	module.exports = CSSProperty;

/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(6);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var PooledClass = __webpack_require__(38);
	
	var invariant = __webpack_require__(3);
	
	/**
	 * A specialized pseudo-event module to help keep track of components waiting to
	 * be notified when their DOM representations are available for use.
	 *
	 * This implements `PooledClass`, so you should never need to instantiate this.
	 * Instead, use `CallbackQueue.getPooled()`.
	 *
	 * @class ReactMountReady
	 * @implements PooledClass
	 * @internal
	 */
	
	var CallbackQueue = function () {
	  function CallbackQueue(arg) {
	    _classCallCheck(this, CallbackQueue);
	
	    this._callbacks = null;
	    this._contexts = null;
	    this._arg = arg;
	  }
	
	  /**
	   * Enqueues a callback to be invoked when `notifyAll` is invoked.
	   *
	   * @param {function} callback Invoked when `notifyAll` is invoked.
	   * @param {?object} context Context to call `callback` with.
	   * @internal
	   */
	
	
	  CallbackQueue.prototype.enqueue = function enqueue(callback, context) {
	    this._callbacks = this._callbacks || [];
	    this._callbacks.push(callback);
	    this._contexts = this._contexts || [];
	    this._contexts.push(context);
	  };
	
	  /**
	   * Invokes all enqueued callbacks and clears the queue. This is invoked after
	   * the DOM representation of a component has been created or updated.
	   *
	   * @internal
	   */
	
	
	  CallbackQueue.prototype.notifyAll = function notifyAll() {
	    var callbacks = this._callbacks;
	    var contexts = this._contexts;
	    var arg = this._arg;
	    if (callbacks && contexts) {
	      !(callbacks.length === contexts.length) ?  false ? invariant(false, 'Mismatched list of contexts in callback queue') : _prodInvariant('24') : void 0;
	      this._callbacks = null;
	      this._contexts = null;
	      for (var i = 0; i < callbacks.length; i++) {
	        callbacks[i].call(contexts[i], arg);
	      }
	      callbacks.length = 0;
	      contexts.length = 0;
	    }
	  };
	
	  CallbackQueue.prototype.checkpoint = function checkpoint() {
	    return this._callbacks ? this._callbacks.length : 0;
	  };
	
	  CallbackQueue.prototype.rollback = function rollback(len) {
	    if (this._callbacks && this._contexts) {
	      this._callbacks.length = len;
	      this._contexts.length = len;
	    }
	  };
	
	  /**
	   * Resets the internal queue.
	   *
	   * @internal
	   */
	
	
	  CallbackQueue.prototype.reset = function reset() {
	    this._callbacks = null;
	    this._contexts = null;
	  };
	
	  /**
	   * `PooledClass` looks for this.
	   */
	
	
	  CallbackQueue.prototype.destructor = function destructor() {
	    this.reset();
	  };
	
	  return CallbackQueue;
	}();
	
	module.exports = PooledClass.addPoolingTo(CallbackQueue);

/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(45);
	var ReactDOMComponentTree = __webpack_require__(9);
	var ReactInstrumentation = __webpack_require__(25);
	
	var quoteAttributeValueForBrowser = __webpack_require__(478);
	var warning = __webpack_require__(5);
	
	var VALID_ATTRIBUTE_NAME_REGEX = new RegExp('^[' + DOMProperty.ATTRIBUTE_NAME_START_CHAR + '][' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$');
	var illegalAttributeNameCache = {};
	var validatedAttributeNameCache = {};
	
	function isAttributeNameSafe(attributeName) {
	  if (validatedAttributeNameCache.hasOwnProperty(attributeName)) {
	    return true;
	  }
	  if (illegalAttributeNameCache.hasOwnProperty(attributeName)) {
	    return false;
	  }
	  if (VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) {
	    validatedAttributeNameCache[attributeName] = true;
	    return true;
	  }
	  illegalAttributeNameCache[attributeName] = true;
	   false ? warning(false, 'Invalid attribute name: `%s`', attributeName) : void 0;
	  return false;
	}
	
	function shouldIgnoreValue(propertyInfo, value) {
	  return value == null || propertyInfo.hasBooleanValue && !value || propertyInfo.hasNumericValue && isNaN(value) || propertyInfo.hasPositiveNumericValue && value < 1 || propertyInfo.hasOverloadedBooleanValue && value === false;
	}
	
	/**
	 * Operations for dealing with DOM properties.
	 */
	var DOMPropertyOperations = {
	  /**
	   * Creates markup for the ID property.
	   *
	   * @param {string} id Unescaped ID.
	   * @return {string} Markup string.
	   */
	  createMarkupForID: function (id) {
	    return DOMProperty.ID_ATTRIBUTE_NAME + '=' + quoteAttributeValueForBrowser(id);
	  },
	
	  setAttributeForID: function (node, id) {
	    node.setAttribute(DOMProperty.ID_ATTRIBUTE_NAME, id);
	  },
	
	  createMarkupForRoot: function () {
	    return DOMProperty.ROOT_ATTRIBUTE_NAME + '=""';
	  },
	
	  setAttributeForRoot: function (node) {
	    node.setAttribute(DOMProperty.ROOT_ATTRIBUTE_NAME, '');
	  },
	
	  /**
	   * Creates markup for a property.
	   *
	   * @param {string} name
	   * @param {*} value
	   * @return {?string} Markup string, or null if the property was invalid.
	   */
	  createMarkupForProperty: function (name, value) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      if (shouldIgnoreValue(propertyInfo, value)) {
	        return '';
	      }
	      var attributeName = propertyInfo.attributeName;
	      if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
	        return attributeName + '=""';
	      }
	      return attributeName + '=' + quoteAttributeValueForBrowser(value);
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      if (value == null) {
	        return '';
	      }
	      return name + '=' + quoteAttributeValueForBrowser(value);
	    }
	    return null;
	  },
	
	  /**
	   * Creates markup for a custom property.
	   *
	   * @param {string} name
	   * @param {*} value
	   * @return {string} Markup string, or empty string if the property was invalid.
	   */
	  createMarkupForCustomAttribute: function (name, value) {
	    if (!isAttributeNameSafe(name) || value == null) {
	      return '';
	    }
	    return name + '=' + quoteAttributeValueForBrowser(value);
	  },
	
	  /**
	   * Sets the value for a property on a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   * @param {*} value
	   */
	  setValueForProperty: function (node, name, value) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      var mutationMethod = propertyInfo.mutationMethod;
	      if (mutationMethod) {
	        mutationMethod(node, value);
	      } else if (shouldIgnoreValue(propertyInfo, value)) {
	        this.deleteValueForProperty(node, name);
	        return;
	      } else if (propertyInfo.mustUseProperty) {
	        // Contrary to `setAttribute`, object properties are properly
	        // `toString`ed by IE8/9.
	        node[propertyInfo.propertyName] = value;
	      } else {
	        var attributeName = propertyInfo.attributeName;
	        var namespace = propertyInfo.attributeNamespace;
	        // `setAttribute` with objects becomes only `[object]` in IE8/9,
	        // ('' + value) makes it output the correct toString()-value.
	        if (namespace) {
	          node.setAttributeNS(namespace, attributeName, '' + value);
	        } else if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
	          node.setAttribute(attributeName, '');
	        } else {
	          node.setAttribute(attributeName, '' + value);
	        }
	      }
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      DOMPropertyOperations.setValueForAttribute(node, name, value);
	      return;
	    }
	
	    if (false) {
	      var payload = {};
	      payload[name] = value;
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'update attribute',
	        payload: payload
	      });
	    }
	  },
	
	  setValueForAttribute: function (node, name, value) {
	    if (!isAttributeNameSafe(name)) {
	      return;
	    }
	    if (value == null) {
	      node.removeAttribute(name);
	    } else {
	      node.setAttribute(name, '' + value);
	    }
	
	    if (false) {
	      var payload = {};
	      payload[name] = value;
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'update attribute',
	        payload: payload
	      });
	    }
	  },
	
	  /**
	   * Deletes an attributes from a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   */
	  deleteValueForAttribute: function (node, name) {
	    node.removeAttribute(name);
	    if (false) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'remove attribute',
	        payload: name
	      });
	    }
	  },
	
	  /**
	   * Deletes the value for a property on a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   */
	  deleteValueForProperty: function (node, name) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      var mutationMethod = propertyInfo.mutationMethod;
	      if (mutationMethod) {
	        mutationMethod(node, undefined);
	      } else if (propertyInfo.mustUseProperty) {
	        var propName = propertyInfo.propertyName;
	        if (propertyInfo.hasBooleanValue) {
	          node[propName] = false;
	        } else {
	          node[propName] = '';
	        }
	      } else {
	        node.removeAttribute(propertyInfo.attributeName);
	      }
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      node.removeAttribute(name);
	    }
	
	    if (false) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'remove attribute',
	        payload: name
	      });
	    }
	  }
	};
	
	module.exports = DOMPropertyOperations;

/***/ }),
/* 199 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactDOMComponentFlags = {
	  hasCachedChildNodes: 1 << 0
	};
	
	module.exports = ReactDOMComponentFlags;

/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(7);
	
	var LinkedValueUtils = __webpack_require__(122);
	var ReactDOMComponentTree = __webpack_require__(9);
	var ReactUpdates = __webpack_require__(28);
	
	var warning = __webpack_require__(5);
	
	var didWarnValueLink = false;
	var didWarnValueDefaultValue = false;
	
	function updateOptionsIfPendingUpdateAndMounted() {
	  if (this._rootNodeID && this._wrapperState.pendingUpdate) {
	    this._wrapperState.pendingUpdate = false;
	
	    var props = this._currentElement.props;
	    var value = LinkedValueUtils.getValue(props);
	
	    if (value != null) {
	      updateOptions(this, Boolean(props.multiple), value);
	    }
	  }
	}
	
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	var valuePropNames = ['value', 'defaultValue'];
	
	/**
	 * Validation function for `value` and `defaultValue`.
	 * @private
	 */
	function checkSelectPropTypes(inst, props) {
	  var owner = inst._currentElement._owner;
	  LinkedValueUtils.checkPropTypes('select', props, owner);
	
	  if (props.valueLink !== undefined && !didWarnValueLink) {
	     false ? warning(false, '`valueLink` prop on `select` is deprecated; set `value` and `onChange` instead.') : void 0;
	    didWarnValueLink = true;
	  }
	
	  for (var i = 0; i < valuePropNames.length; i++) {
	    var propName = valuePropNames[i];
	    if (props[propName] == null) {
	      continue;
	    }
	    var isArray = Array.isArray(props[propName]);
	    if (props.multiple && !isArray) {
	       false ? warning(false, 'The `%s` prop supplied to <select> must be an array if ' + '`multiple` is true.%s', propName, getDeclarationErrorAddendum(owner)) : void 0;
	    } else if (!props.multiple && isArray) {
	       false ? warning(false, 'The `%s` prop supplied to <select> must be a scalar ' + 'value if `multiple` is false.%s', propName, getDeclarationErrorAddendum(owner)) : void 0;
	    }
	  }
	}
	
	/**
	 * @param {ReactDOMComponent} inst
	 * @param {boolean} multiple
	 * @param {*} propValue A stringable (with `multiple`, a list of stringables).
	 * @private
	 */
	function updateOptions(inst, multiple, propValue) {
	  var selectedValue, i;
	  var options = ReactDOMComponentTree.getNodeFromInstance(inst).options;
	
	  if (multiple) {
	    selectedValue = {};
	    for (i = 0; i < propValue.length; i++) {
	      selectedValue['' + propValue[i]] = true;
	    }
	    for (i = 0; i < options.length; i++) {
	      var selected = selectedValue.hasOwnProperty(options[i].value);
	      if (options[i].selected !== selected) {
	        options[i].selected = selected;
	      }
	    }
	  } else {
	    // Do not set `select.value` as exact behavior isn't consistent across all
	    // browsers for all cases.
	    selectedValue = '' + propValue;
	    for (i = 0; i < options.length; i++) {
	      if (options[i].value === selectedValue) {
	        options[i].selected = true;
	        return;
	      }
	    }
	    if (options.length) {
	      options[0].selected = true;
	    }
	  }
	}
	
	/**
	 * Implements a <select> host component that allows optionally setting the
	 * props `value` and `defaultValue`. If `multiple` is false, the prop must be a
	 * stringable. If `multiple` is true, the prop must be an array of stringables.
	 *
	 * If `value` is not supplied (or null/undefined), user actions that change the
	 * selected option will trigger updates to the rendered options.
	 *
	 * If it is supplied (and not null/undefined), the rendered options will not
	 * update in response to user actions. Instead, the `value` prop must change in
	 * order for the rendered options to update.
	 *
	 * If `defaultValue` is provided, any options with the supplied values will be
	 * selected.
	 */
	var ReactDOMSelect = {
	  getHostProps: function (inst, props) {
	    return _assign({}, props, {
	      onChange: inst._wrapperState.onChange,
	      value: undefined
	    });
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      checkSelectPropTypes(inst, props);
	    }
	
	    var value = LinkedValueUtils.getValue(props);
	    inst._wrapperState = {
	      pendingUpdate: false,
	      initialValue: value != null ? value : props.defaultValue,
	      listeners: null,
	      onChange: _handleChange.bind(inst),
	      wasMultiple: Boolean(props.multiple)
	    };
	
	    if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
	       false ? warning(false, 'Select elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled select ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
	      didWarnValueDefaultValue = true;
	    }
	  },
	
	  getSelectValueContext: function (inst) {
	    // ReactDOMOption looks at this initial value so the initial generated
	    // markup has correct `selected` attributes
	    return inst._wrapperState.initialValue;
	  },
	
	  postUpdateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    // After the initial mount, we control selected-ness manually so don't pass
	    // this value down
	    inst._wrapperState.initialValue = undefined;
	
	    var wasMultiple = inst._wrapperState.wasMultiple;
	    inst._wrapperState.wasMultiple = Boolean(props.multiple);
	
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      inst._wrapperState.pendingUpdate = false;
	      updateOptions(inst, Boolean(props.multiple), value);
	    } else if (wasMultiple !== Boolean(props.multiple)) {
	      // For simplicity, reapply `defaultValue` if `multiple` is toggled.
	      if (props.defaultValue != null) {
	        updateOptions(inst, Boolean(props.multiple), props.defaultValue);
	      } else {
	        // Revert the select back to its default unselected state.
	        updateOptions(inst, Boolean(props.multiple), props.multiple ? [] : '');
	      }
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	
	  if (this._rootNodeID) {
	    this._wrapperState.pendingUpdate = true;
	  }
	  ReactUpdates.asap(updateOptionsIfPendingUpdateAndMounted, this);
	  return returnValue;
	}
	
	module.exports = ReactDOMSelect;

/***/ }),
/* 201 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var emptyComponentFactory;
	
	var ReactEmptyComponentInjection = {
	  injectEmptyComponentFactory: function (factory) {
	    emptyComponentFactory = factory;
	  }
	};
	
	var ReactEmptyComponent = {
	  create: function (instantiate) {
	    return emptyComponentFactory(instantiate);
	  }
	};
	
	ReactEmptyComponent.injection = ReactEmptyComponentInjection;
	
	module.exports = ReactEmptyComponent;

/***/ }),
/* 202 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var ReactFeatureFlags = {
	  // When true, call console.time() before and .timeEnd() after each top-level
	  // render (both initial renders and updates). Useful when looking at prod-mode
	  // timeline profiles in Chrome, for example.
	  logTopLevelRenders: false
	};
	
	module.exports = ReactFeatureFlags;

/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(6);
	
	var invariant = __webpack_require__(3);
	
	var genericComponentClass = null;
	var textComponentClass = null;
	
	var ReactHostComponentInjection = {
	  // This accepts a class that receives the tag string. This is a catch all
	  // that can render any kind of tag.
	  injectGenericComponentClass: function (componentClass) {
	    genericComponentClass = componentClass;
	  },
	  // This accepts a text component class that takes the text string to be
	  // rendered as props.
	  injectTextComponentClass: function (componentClass) {
	    textComponentClass = componentClass;
	  }
	};
	
	/**
	 * Get a host internal component class for a specific tag.
	 *
	 * @param {ReactElement} element The element to create.
	 * @return {function} The internal class constructor function.
	 */
	function createInternalComponent(element) {
	  !genericComponentClass ?  false ? invariant(false, 'There is no registered component for the tag %s', element.type) : _prodInvariant('111', element.type) : void 0;
	  return new genericComponentClass(element);
	}
	
	/**
	 * @param {ReactText} text
	 * @return {ReactComponent}
	 */
	function createInstanceForText(text) {
	  return new textComponentClass(text);
	}
	
	/**
	 * @param {ReactComponent} component
	 * @return {boolean}
	 */
	function isTextComponent(component) {
	  return component instanceof textComponentClass;
	}
	
	var ReactHostComponent = {
	  createInternalComponent: createInternalComponent,
	  createInstanceForText: createInstanceForText,
	  isTextComponent: isTextComponent,
	  injection: ReactHostComponentInjection
	};
	
	module.exports = ReactHostComponent;

/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactDOMSelection = __webpack_require__(438);
	
	var containsNode = __webpack_require__(387);
	var focusNode = __webpack_require__(191);
	var getActiveElement = __webpack_require__(192);
	
	function isInDocument(node) {
	  return containsNode(document.documentElement, node);
	}
	
	/**
	 * @ReactInputSelection: React input selection module. Based on Selection.js,
	 * but modified to be suitable for react and has a couple of bug fixes (doesn't
	 * assume buttons have range selections allowed).
	 * Input selection module for React.
	 */
	var ReactInputSelection = {
	  hasSelectionCapabilities: function (elem) {
	    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
	    return nodeName && (nodeName === 'input' && elem.type === 'text' || nodeName === 'textarea' || elem.contentEditable === 'true');
	  },
	
	  getSelectionInformation: function () {
	    var focusedElem = getActiveElement();
	    return {
	      focusedElem: focusedElem,
	      selectionRange: ReactInputSelection.hasSelectionCapabilities(focusedElem) ? ReactInputSelection.getSelection(focusedElem) : null
	    };
	  },
	
	  /**
	   * @restoreSelection: If any selection information was potentially lost,
	   * restore it. This is useful when performing operations that could remove dom
	   * nodes and place them back in, resulting in focus being lost.
	   */
	  restoreSelection: function (priorSelectionInformation) {
	    var curFocusedElem = getActiveElement();
	    var priorFocusedElem = priorSelectionInformation.focusedElem;
	    var priorSelectionRange = priorSelectionInformation.selectionRange;
	    if (curFocusedElem !== priorFocusedElem && isInDocument(priorFocusedElem)) {
	      if (ReactInputSelection.hasSelectionCapabilities(priorFocusedElem)) {
	        ReactInputSelection.setSelection(priorFocusedElem, priorSelectionRange);
	      }
	      focusNode(priorFocusedElem);
	    }
	  },
	
	  /**
	   * @getSelection: Gets the selection bounds of a focused textarea, input or
	   * contentEditable node.
	   * -@input: Look up selection bounds of this input
	   * -@return {start: selectionStart, end: selectionEnd}
	   */
	  getSelection: function (input) {
	    var selection;
	
	    if ('selectionStart' in input) {
	      // Modern browser with input or textarea.
	      selection = {
	        start: input.selectionStart,
	        end: input.selectionEnd
	      };
	    } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === 'input') {
	      // IE8 input.
	      var range = document.selection.createRange();
	      // There can only be one selection per document in IE, so it must
	      // be in our element.
	      if (range.parentElement() === input) {
	        selection = {
	          start: -range.moveStart('character', -input.value.length),
	          end: -range.moveEnd('character', -input.value.length)
	        };
	      }
	    } else {
	      // Content editable or old IE textarea.
	      selection = ReactDOMSelection.getOffsets(input);
	    }
	
	    return selection || { start: 0, end: 0 };
	  },
	
	  /**
	   * @setSelection: Sets the selection bounds of a textarea or input and focuses
	   * the input.
	   * -@input     Set selection bounds of this input or textarea
	   * -@offsets   Object of same form that is returned from get*
	   */
	  setSelection: function (input, offsets) {
	    var start = offsets.start;
	    var end = offsets.end;
	    if (end === undefined) {
	      end = start;
	    }
	
	    if ('selectionStart' in input) {
	      input.selectionStart = start;
	      input.selectionEnd = Math.min(end, input.value.length);
	    } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === 'input') {
	      var range = input.createTextRange();
	      range.collapse(true);
	      range.moveStart('character', start);
	      range.moveEnd('character', end - start);
	      range.select();
	    } else {
	      ReactDOMSelection.setOffsets(input, offsets);
	    }
	  }
	};
	
	module.exports = ReactInputSelection;

/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(6);
	
	var DOMLazyTree = __webpack_require__(44);
	var DOMProperty = __webpack_require__(45);
	var React = __webpack_require__(47);
	var ReactBrowserEventEmitter = __webpack_require__(83);
	var ReactCurrentOwner = __webpack_require__(32);
	var ReactDOMComponentTree = __webpack_require__(9);
	var ReactDOMContainerInfo = __webpack_require__(432);
	var ReactDOMFeatureFlags = __webpack_require__(434);
	var ReactFeatureFlags = __webpack_require__(202);
	var ReactInstanceMap = __webpack_require__(61);
	var ReactInstrumentation = __webpack_require__(25);
	var ReactMarkupChecksum = __webpack_require__(448);
	var ReactReconciler = __webpack_require__(46);
	var ReactUpdateQueue = __webpack_require__(125);
	var ReactUpdates = __webpack_require__(28);
	
	var emptyObject = __webpack_require__(82);
	var instantiateReactComponent = __webpack_require__(213);
	var invariant = __webpack_require__(3);
	var setInnerHTML = __webpack_require__(87);
	var shouldUpdateReactComponent = __webpack_require__(131);
	var warning = __webpack_require__(5);
	
	var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
	var ROOT_ATTR_NAME = DOMProperty.ROOT_ATTRIBUTE_NAME;
	
	var ELEMENT_NODE_TYPE = 1;
	var DOC_NODE_TYPE = 9;
	var DOCUMENT_FRAGMENT_NODE_TYPE = 11;
	
	var instancesByReactRootID = {};
	
	/**
	 * Finds the index of the first character
	 * that's not common between the two given strings.
	 *
	 * @return {number} the index of the character where the strings diverge
	 */
	function firstDifferenceIndex(string1, string2) {
	  var minLen = Math.min(string1.length, string2.length);
	  for (var i = 0; i < minLen; i++) {
	    if (string1.charAt(i) !== string2.charAt(i)) {
	      return i;
	    }
	  }
	  return string1.length === string2.length ? -1 : minLen;
	}
	
	/**
	 * @param {DOMElement|DOMDocument} container DOM element that may contain
	 * a React component
	 * @return {?*} DOM element that may have the reactRoot ID, or null.
	 */
	function getReactRootElementInContainer(container) {
	  if (!container) {
	    return null;
	  }
	
	  if (container.nodeType === DOC_NODE_TYPE) {
	    return container.documentElement;
	  } else {
	    return container.firstChild;
	  }
	}
	
	function internalGetID(node) {
	  // If node is something like a window, document, or text node, none of
	  // which support attributes or a .getAttribute method, gracefully return
	  // the empty string, as if the attribute were missing.
	  return node.getAttribute && node.getAttribute(ATTR_NAME) || '';
	}
	
	/**
	 * Mounts this component and inserts it into the DOM.
	 *
	 * @param {ReactComponent} componentInstance The instance to mount.
	 * @param {DOMElement} container DOM element to mount into.
	 * @param {ReactReconcileTransaction} transaction
	 * @param {boolean} shouldReuseMarkup If true, do not insert markup
	 */
	function mountComponentIntoNode(wrapperInstance, container, transaction, shouldReuseMarkup, context) {
	  var markerName;
	  if (ReactFeatureFlags.logTopLevelRenders) {
	    var wrappedElement = wrapperInstance._currentElement.props.child;
	    var type = wrappedElement.type;
	    markerName = 'React mount: ' + (typeof type === 'string' ? type : type.displayName || type.name);
	    console.time(markerName);
	  }
	
	  var markup = ReactReconciler.mountComponent(wrapperInstance, transaction, null, ReactDOMContainerInfo(wrapperInstance, container), context, 0 /* parentDebugID */
	  );
	
	  if (markerName) {
	    console.timeEnd(markerName);
	  }
	
	  wrapperInstance._renderedComponent._topLevelWrapper = wrapperInstance;
	  ReactMount._mountImageIntoNode(markup, container, wrapperInstance, shouldReuseMarkup, transaction);
	}
	
	/**
	 * Batched mount.
	 *
	 * @param {ReactComponent} componentInstance The instance to mount.
	 * @param {DOMElement} container DOM element to mount into.
	 * @param {boolean} shouldReuseMarkup If true, do not insert markup
	 */
	function batchedMountComponentIntoNode(componentInstance, container, shouldReuseMarkup, context) {
	  var transaction = ReactUpdates.ReactReconcileTransaction.getPooled(
	  /* useCreateElement */
	  !shouldReuseMarkup && ReactDOMFeatureFlags.useCreateElement);
	  transaction.perform(mountComponentIntoNode, null, componentInstance, container, transaction, shouldReuseMarkup, context);
	  ReactUpdates.ReactReconcileTransaction.release(transaction);
	}
	
	/**
	 * Unmounts a component and removes it from the DOM.
	 *
	 * @param {ReactComponent} instance React component instance.
	 * @param {DOMElement} container DOM element to unmount from.
	 * @final
	 * @internal
	 * @see {ReactMount.unmountComponentAtNode}
	 */
	function unmountComponentFromNode(instance, container, safely) {
	  if (false) {
	    ReactInstrumentation.debugTool.onBeginFlush();
	  }
	  ReactReconciler.unmountComponent(instance, safely);
	  if (false) {
	    ReactInstrumentation.debugTool.onEndFlush();
	  }
	
	  if (container.nodeType === DOC_NODE_TYPE) {
	    container = container.documentElement;
	  }
	
	  // http://jsperf.com/emptying-a-node
	  while (container.lastChild) {
	    container.removeChild(container.lastChild);
	  }
	}
	
	/**
	 * True if the supplied DOM node has a direct React-rendered child that is
	 * not a React root element. Useful for warning in `render`,
	 * `unmountComponentAtNode`, etc.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM element contains a direct child that was
	 * rendered by React but is not a root element.
	 * @internal
	 */
	function hasNonRootReactChild(container) {
	  var rootEl = getReactRootElementInContainer(container);
	  if (rootEl) {
	    var inst = ReactDOMComponentTree.getInstanceFromNode(rootEl);
	    return !!(inst && inst._hostParent);
	  }
	}
	
	/**
	 * True if the supplied DOM node is a React DOM element and
	 * it has been rendered by another copy of React.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM has been rendered by another copy of React
	 * @internal
	 */
	function nodeIsRenderedByOtherInstance(container) {
	  var rootEl = getReactRootElementInContainer(container);
	  return !!(rootEl && isReactNode(rootEl) && !ReactDOMComponentTree.getInstanceFromNode(rootEl));
	}
	
	/**
	 * True if the supplied DOM node is a valid node element.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM is a valid DOM node.
	 * @internal
	 */
	function isValidContainer(node) {
	  return !!(node && (node.nodeType === ELEMENT_NODE_TYPE || node.nodeType === DOC_NODE_TYPE || node.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE));
	}
	
	/**
	 * True if the supplied DOM node is a valid React node element.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM is a valid React DOM node.
	 * @internal
	 */
	function isReactNode(node) {
	  return isValidContainer(node) && (node.hasAttribute(ROOT_ATTR_NAME) || node.hasAttribute(ATTR_NAME));
	}
	
	function getHostRootInstanceInContainer(container) {
	  var rootEl = getReactRootElementInContainer(container);
	  var prevHostInstance = rootEl && ReactDOMComponentTree.getInstanceFromNode(rootEl);
	  return prevHostInstance && !prevHostInstance._hostParent ? prevHostInstance : null;
	}
	
	function getTopLevelWrapperInContainer(container) {
	  var root = getHostRootInstanceInContainer(container);
	  return root ? root._hostContainerInfo._topLevelWrapper : null;
	}
	
	/**
	 * Temporary (?) hack so that we can store all top-level pending updates on
	 * composites instead of having to worry about different types of components
	 * here.
	 */
	var topLevelRootCounter = 1;
	var TopLevelWrapper = function () {
	  this.rootID = topLevelRootCounter++;
	};
	TopLevelWrapper.prototype.isReactComponent = {};
	if (false) {
	  TopLevelWrapper.displayName = 'TopLevelWrapper';
	}
	TopLevelWrapper.prototype.render = function () {
	  return this.props.child;
	};
	TopLevelWrapper.isReactTopLevelWrapper = true;
	
	/**
	 * Mounting is the process of initializing a React component by creating its
	 * representative DOM elements and inserting them into a supplied `container`.
	 * Any prior content inside `container` is destroyed in the process.
	 *
	 *   ReactMount.render(
	 *     component,
	 *     document.getElementById('container')
	 *   );
	 *
	 *   <div id="container">                   <-- Supplied `container`.
	 *     <div data-reactid=".3">              <-- Rendered reactRoot of React
	 *       // ...                                 component.
	 *     </div>
	 *   </div>
	 *
	 * Inside of `container`, the first element rendered is the "reactRoot".
	 */
	var ReactMount = {
	  TopLevelWrapper: TopLevelWrapper,
	
	  /**
	   * Used by devtools. The keys are not important.
	   */
	  _instancesByReactRootID: instancesByReactRootID,
	
	  /**
	   * This is a hook provided to support rendering React components while
	   * ensuring that the apparent scroll position of its `container` does not
	   * change.
	   *
	   * @param {DOMElement} container The `container` being rendered into.
	   * @param {function} renderCallback This must be called once to do the render.
	   */
	  scrollMonitor: function (container, renderCallback) {
	    renderCallback();
	  },
	
	  /**
	   * Take a component that's already mounted into the DOM and replace its props
	   * @param {ReactComponent} prevComponent component instance already in the DOM
	   * @param {ReactElement} nextElement component instance to render
	   * @param {DOMElement} container container to render into
	   * @param {?function} callback function triggered on completion
	   */
	  _updateRootComponent: function (prevComponent, nextElement, nextContext, container, callback) {
	    ReactMount.scrollMonitor(container, function () {
	      ReactUpdateQueue.enqueueElementInternal(prevComponent, nextElement, nextContext);
	      if (callback) {
	        ReactUpdateQueue.enqueueCallbackInternal(prevComponent, callback);
	      }
	    });
	
	    return prevComponent;
	  },
	
	  /**
	   * Render a new component into the DOM. Hooked by hooks!
	   *
	   * @param {ReactElement} nextElement element to render
	   * @param {DOMElement} container container to render into
	   * @param {boolean} shouldReuseMarkup if we should skip the markup insertion
	   * @return {ReactComponent} nextComponent
	   */
	  _renderNewRootComponent: function (nextElement, container, shouldReuseMarkup, context) {
	    // Various parts of our code (such as ReactCompositeComponent's
	    // _renderValidatedComponent) assume that calls to render aren't nested;
	    // verify that that's the case.
	     false ? warning(ReactCurrentOwner.current == null, '_renderNewRootComponent(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from ' + 'render is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : void 0;
	
	    !isValidContainer(container) ?  false ? invariant(false, '_registerComponent(...): Target container is not a DOM element.') : _prodInvariant('37') : void 0;
	
	    ReactBrowserEventEmitter.ensureScrollValueMonitoring();
	    var componentInstance = instantiateReactComponent(nextElement, false);
	
	    // The initial render is synchronous but any updates that happen during
	    // rendering, in componentWillMount or componentDidMount, will be batched
	    // according to the current batching strategy.
	
	    ReactUpdates.batchedUpdates(batchedMountComponentIntoNode, componentInstance, container, shouldReuseMarkup, context);
	
	    var wrapperID = componentInstance._instance.rootID;
	    instancesByReactRootID[wrapperID] = componentInstance;
	
	    return componentInstance;
	  },
	
	  /**
	   * Renders a React component into the DOM in the supplied `container`.
	   *
	   * If the React component was previously rendered into `container`, this will
	   * perform an update on it and only mutate the DOM as necessary to reflect the
	   * latest React component.
	   *
	   * @param {ReactComponent} parentComponent The conceptual parent of this render tree.
	   * @param {ReactElement} nextElement Component element to render.
	   * @param {DOMElement} container DOM element to render into.
	   * @param {?function} callback function triggered on completion
	   * @return {ReactComponent} Component instance rendered in `container`.
	   */
	  renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
	    !(parentComponent != null && ReactInstanceMap.has(parentComponent)) ?  false ? invariant(false, 'parentComponent must be a valid React Component') : _prodInvariant('38') : void 0;
	    return ReactMount._renderSubtreeIntoContainer(parentComponent, nextElement, container, callback);
	  },
	
	  _renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
	    ReactUpdateQueue.validateCallback(callback, 'ReactDOM.render');
	    !React.isValidElement(nextElement) ?  false ? invariant(false, 'ReactDOM.render(): Invalid component element.%s', typeof nextElement === 'string' ? " Instead of passing a string like 'div', pass " + "React.createElement('div') or <div />." : typeof nextElement === 'function' ? ' Instead of passing a class like Foo, pass ' + 'React.createElement(Foo) or <Foo />.' : // Check if it quacks like an element
	    nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : _prodInvariant('39', typeof nextElement === 'string' ? " Instead of passing a string like 'div', pass " + "React.createElement('div') or <div />." : typeof nextElement === 'function' ? ' Instead of passing a class like Foo, pass ' + 'React.createElement(Foo) or <Foo />.' : nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : void 0;
	
	     false ? warning(!container || !container.tagName || container.tagName.toUpperCase() !== 'BODY', 'render(): Rendering components directly into document.body is ' + 'discouraged, since its children are often manipulated by third-party ' + 'scripts and browser extensions. This may lead to subtle ' + 'reconciliation issues. Try rendering into a container element created ' + 'for your app.') : void 0;
	
	    var nextWrappedElement = React.createElement(TopLevelWrapper, {
	      child: nextElement
	    });
	
	    var nextContext;
	    if (parentComponent) {
	      var parentInst = ReactInstanceMap.get(parentComponent);
	      nextContext = parentInst._processChildContext(parentInst._context);
	    } else {
	      nextContext = emptyObject;
	    }
	
	    var prevComponent = getTopLevelWrapperInContainer(container);
	
	    if (prevComponent) {
	      var prevWrappedElement = prevComponent._currentElement;
	      var prevElement = prevWrappedElement.props.child;
	      if (shouldUpdateReactComponent(prevElement, nextElement)) {
	        var publicInst = prevComponent._renderedComponent.getPublicInstance();
	        var updatedCallback = callback && function () {
	          callback.call(publicInst);
	        };
	        ReactMount._updateRootComponent(prevComponent, nextWrappedElement, nextContext, container, updatedCallback);
	        return publicInst;
	      } else {
	        ReactMount.unmountComponentAtNode(container);
	      }
	    }
	
	    var reactRootElement = getReactRootElementInContainer(container);
	    var containerHasReactMarkup = reactRootElement && !!internalGetID(reactRootElement);
	    var containerHasNonRootReactChild = hasNonRootReactChild(container);
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, 'render(...): Replacing React-rendered children with a new root ' + 'component. If you intended to update the children of this node, ' + 'you should instead have the existing children update their state ' + 'and render the new components instead of calling ReactDOM.render.') : void 0;
	
	      if (!containerHasReactMarkup || reactRootElement.nextSibling) {
	        var rootElementSibling = reactRootElement;
	        while (rootElementSibling) {
	          if (internalGetID(rootElementSibling)) {
	            process.env.NODE_ENV !== 'production' ? warning(false, 'render(): Target node has markup rendered by React, but there ' + 'are unrelated nodes as well. This is most commonly caused by ' + 'white-space inserted around server-rendered markup.') : void 0;
	            break;
	          }
	          rootElementSibling = rootElementSibling.nextSibling;
	        }
	      }
	    }
	
	    var shouldReuseMarkup = containerHasReactMarkup && !prevComponent && !containerHasNonRootReactChild;
	    var component = ReactMount._renderNewRootComponent(nextWrappedElement, container, shouldReuseMarkup, nextContext)._renderedComponent.getPublicInstance();
	    if (callback) {
	      callback.call(component);
	    }
	    return component;
	  },
	
	  /**
	   * Renders a React component into the DOM in the supplied `container`.
	   * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.render
	   *
	   * If the React component was previously rendered into `container`, this will
	   * perform an update on it and only mutate the DOM as necessary to reflect the
	   * latest React component.
	   *
	   * @param {ReactElement} nextElement Component element to render.
	   * @param {DOMElement} container DOM element to render into.
	   * @param {?function} callback function triggered on completion
	   * @return {ReactComponent} Component instance rendered in `container`.
	   */
	  render: function (nextElement, container, callback) {
	    return ReactMount._renderSubtreeIntoContainer(null, nextElement, container, callback);
	  },
	
	  /**
	   * Unmounts and destroys the React component rendered in the `container`.
	   * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.unmountcomponentatnode
	   *
	   * @param {DOMElement} container DOM element containing a React component.
	   * @return {boolean} True if a component was found in and unmounted from
	   *                   `container`
	   */
	  unmountComponentAtNode: function (container) {
	    // Various parts of our code (such as ReactCompositeComponent's
	    // _renderValidatedComponent) assume that calls to render aren't nested;
	    // verify that that's the case. (Strictly speaking, unmounting won't cause a
	    // render but we still don't expect to be in a render call here.)
	     false ? warning(ReactCurrentOwner.current == null, 'unmountComponentAtNode(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from render ' + 'is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : void 0;
	
	    !isValidContainer(container) ?  false ? invariant(false, 'unmountComponentAtNode(...): Target container is not a DOM element.') : _prodInvariant('40') : void 0;
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(!nodeIsRenderedByOtherInstance(container), "unmountComponentAtNode(): The node you're attempting to unmount " + 'was rendered by another copy of React.') : void 0;
	    }
	
	    var prevComponent = getTopLevelWrapperInContainer(container);
	    if (!prevComponent) {
	      // Check if the node being unmounted was rendered by React, but isn't a
	      // root node.
	      var containerHasNonRootReactChild = hasNonRootReactChild(container);
	
	      // Check if the container itself is a React root node.
	      var isContainerReactRoot = container.nodeType === 1 && container.hasAttribute(ROOT_ATTR_NAME);
	
	      if (false) {
	        process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, "unmountComponentAtNode(): The node you're attempting to unmount " + 'was rendered by React and is not a top-level container. %s', isContainerReactRoot ? 'You may have accidentally passed in a React root node instead ' + 'of its container.' : 'Instead, have the parent component update its state and ' + 'rerender in order to remove this component.') : void 0;
	      }
	
	      return false;
	    }
	    delete instancesByReactRootID[prevComponent._instance.rootID];
	    ReactUpdates.batchedUpdates(unmountComponentFromNode, prevComponent, container, false);
	    return true;
	  },
	
	  _mountImageIntoNode: function (markup, container, instance, shouldReuseMarkup, transaction) {
	    !isValidContainer(container) ?  false ? invariant(false, 'mountComponentIntoNode(...): Target container is not valid.') : _prodInvariant('41') : void 0;
	
	    if (shouldReuseMarkup) {
	      var rootElement = getReactRootElementInContainer(container);
	      if (ReactMarkupChecksum.canReuseMarkup(markup, rootElement)) {
	        ReactDOMComponentTree.precacheNode(instance, rootElement);
	        return;
	      } else {
	        var checksum = rootElement.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	        rootElement.removeAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	
	        var rootMarkup = rootElement.outerHTML;
	        rootElement.setAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME, checksum);
	
	        var normalizedMarkup = markup;
	        if (false) {
	          // because rootMarkup is retrieved from the DOM, various normalizations
	          // will have occurred which will not be present in `markup`. Here,
	          // insert markup into a <div> or <iframe> depending on the container
	          // type to perform the same normalizations before comparing.
	          var normalizer;
	          if (container.nodeType === ELEMENT_NODE_TYPE) {
	            normalizer = document.createElement('div');
	            normalizer.innerHTML = markup;
	            normalizedMarkup = normalizer.innerHTML;
	          } else {
	            normalizer = document.createElement('iframe');
	            document.body.appendChild(normalizer);
	            normalizer.contentDocument.write(markup);
	            normalizedMarkup = normalizer.contentDocument.documentElement.outerHTML;
	            document.body.removeChild(normalizer);
	          }
	        }
	
	        var diffIndex = firstDifferenceIndex(normalizedMarkup, rootMarkup);
	        var difference = ' (client) ' + normalizedMarkup.substring(diffIndex - 20, diffIndex + 20) + '\n (server) ' + rootMarkup.substring(diffIndex - 20, diffIndex + 20);
	
	        !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document using server rendering but the checksum was invalid. This usually means you rendered a different component type or props on the client from the one on the server, or your render() methods are impure. React cannot handle this case due to cross-browser quirks by rendering at the document root. You should look for environment dependent code in your components and ensure the props are the same client and server side:\n%s', difference) : _prodInvariant('42', difference) : void 0;
	
	        if (false) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'React attempted to reuse markup in a container but the ' + 'checksum was invalid. This generally means that you are ' + 'using server rendering and the markup generated on the ' + 'server was not what the client was expecting. React injected ' + 'new markup to compensate which works but you have lost many ' + 'of the benefits of server rendering. Instead, figure out ' + 'why the markup being generated is different on the client ' + 'or server:\n%s', difference) : void 0;
	        }
	      }
	    }
	
	    !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document but you didn\'t use server rendering. We can\'t do this without using server rendering due to cross-browser quirks. See ReactDOMServer.renderToString() for server rendering.') : _prodInvariant('43') : void 0;
	
	    if (transaction.useCreateElement) {
	      while (container.lastChild) {
	        container.removeChild(container.lastChild);
	      }
	      DOMLazyTree.insertTreeBefore(container, markup, null);
	    } else {
	      setInnerHTML(container, markup);
	      ReactDOMComponentTree.precacheNode(instance, container.firstChild);
	    }
	
	    if (false) {
	      var hostNode = ReactDOMComponentTree.getInstanceFromNode(container.firstChild);
	      if (hostNode._debugID !== 0) {
	        ReactInstrumentation.debugTool.onHostOperation({
	          instanceID: hostNode._debugID,
	          type: 'mount',
	          payload: markup.toString()
	        });
	      }
	    }
	  }
	};
	
	module.exports = ReactMount;

/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(6);
	
	var React = __webpack_require__(47);
	
	var invariant = __webpack_require__(3);
	
	var ReactNodeTypes = {
	  HOST: 0,
	  COMPOSITE: 1,
	  EMPTY: 2,
	
	  getType: function (node) {
	    if (node === null || node === false) {
	      return ReactNodeTypes.EMPTY;
	    } else if (React.isValidElement(node)) {
	      if (typeof node.type === 'function') {
	        return ReactNodeTypes.COMPOSITE;
	      } else {
	        return ReactNodeTypes.HOST;
	      }
	    }
	     true ?  false ? invariant(false, 'Unexpected node: %s', node) : _prodInvariant('26', node) : void 0;
	  }
	};
	
	module.exports = ReactNodeTypes;

/***/ }),
/* 207 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ViewportMetrics = {
	  currentScrollLeft: 0,
	
	  currentScrollTop: 0,
	
	  refreshScrollValues: function (scrollPosition) {
	    ViewportMetrics.currentScrollLeft = scrollPosition.x;
	    ViewportMetrics.currentScrollTop = scrollPosition.y;
	  }
	};
	
	module.exports = ViewportMetrics;

/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(6);
	
	var invariant = __webpack_require__(3);
	
	/**
	 * Accumulates items that must not be null or undefined into the first one. This
	 * is used to conserve memory by avoiding array allocations, and thus sacrifices
	 * API cleanness. Since `current` can be null before being passed in and not
	 * null after this function, make sure to assign it back to `current`:
	 *
	 * `a = accumulateInto(a, b);`
	 *
	 * This API should be sparingly used. Try `accumulate` for something cleaner.
	 *
	 * @return {*|array<*>} An accumulation of items.
	 */
	
	function accumulateInto(current, next) {
	  !(next != null) ?  false ? invariant(false, 'accumulateInto(...): Accumulated items must not be null or undefined.') : _prodInvariant('30') : void 0;
	
	  if (current == null) {
	    return next;
	  }
	
	  // Both are not empty. Warning: Never call x.concat(y) when you are not
	  // certain that x is an Array (x could be a string with concat method).
	  if (Array.isArray(current)) {
	    if (Array.isArray(next)) {
	      current.push.apply(current, next);
	      return current;
	    }
	    current.push(next);
	    return current;
	  }
	
	  if (Array.isArray(next)) {
	    // A bit too dangerous to mutate `next`.
	    return [current].concat(next);
	  }
	
	  return [current, next];
	}
	
	module.exports = accumulateInto;

/***/ }),
/* 209 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * @param {array} arr an "accumulation" of items which is either an Array or
	 * a single item. Useful when paired with the `accumulate` module. This is a
	 * simple utility that allows us to reason about a collection of items, but
	 * handling the case when there is exactly one item (and we do not need to
	 * allocate an array).
	 */
	
	function forEachAccumulated(arr, cb, scope) {
	  if (Array.isArray(arr)) {
	    arr.forEach(cb, scope);
	  } else if (arr) {
	    cb.call(scope, arr);
	  }
	}
	
	module.exports = forEachAccumulated;

/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactNodeTypes = __webpack_require__(206);
	
	function getHostComponentFromComposite(inst) {
	  var type;
	
	  while ((type = inst._renderedNodeType) === ReactNodeTypes.COMPOSITE) {
	    inst = inst._renderedComponent;
	  }
	
	  if (type === ReactNodeTypes.HOST) {
	    return inst._renderedComponent;
	  } else if (type === ReactNodeTypes.EMPTY) {
	    return null;
	  }
	}
	
	module.exports = getHostComponentFromComposite;

/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(16);
	
	var contentKey = null;
	
	/**
	 * Gets the key used to access text content on a DOM node.
	 *
	 * @return {?string} Key used to access text content.
	 * @internal
	 */
	function getTextContentAccessor() {
	  if (!contentKey && ExecutionEnvironment.canUseDOM) {
	    // Prefer textContent to innerText because many browsers support both but
	    // SVG <text> elements don't support innerText even when <div> does.
	    contentKey = 'textContent' in document.documentElement ? 'textContent' : 'innerText';
	  }
	  return contentKey;
	}
	
	module.exports = getTextContentAccessor;

/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactDOMComponentTree = __webpack_require__(9);
	
	function isCheckable(elem) {
	  var type = elem.type;
	  var nodeName = elem.nodeName;
	  return nodeName && nodeName.toLowerCase() === 'input' && (type === 'checkbox' || type === 'radio');
	}
	
	function getTracker(inst) {
	  return inst._wrapperState.valueTracker;
	}
	
	function attachTracker(inst, tracker) {
	  inst._wrapperState.valueTracker = tracker;
	}
	
	function detachTracker(inst) {
	  inst._wrapperState.valueTracker = null;
	}
	
	function getValueFromNode(node) {
	  var value;
	  if (node) {
	    value = isCheckable(node) ? '' + node.checked : node.value;
	  }
	  return value;
	}
	
	var inputValueTracking = {
	  // exposed for testing
	  _getTrackerFromNode: function (node) {
	    return getTracker(ReactDOMComponentTree.getInstanceFromNode(node));
	  },
	
	
	  track: function (inst) {
	    if (getTracker(inst)) {
	      return;
	    }
	
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var valueField = isCheckable(node) ? 'checked' : 'value';
	    var descriptor = Object.getOwnPropertyDescriptor(node.constructor.prototype, valueField);
	
	    var currentValue = '' + node[valueField];
	
	    // if someone has already defined a value or Safari, then bail
	    // and don't track value will cause over reporting of changes,
	    // but it's better then a hard failure
	    // (needed for certain tests that spyOn input values and Safari)
	    if (node.hasOwnProperty(valueField) || typeof descriptor.get !== 'function' || typeof descriptor.set !== 'function') {
	      return;
	    }
	
	    Object.defineProperty(node, valueField, {
	      enumerable: descriptor.enumerable,
	      configurable: true,
	      get: function () {
	        return descriptor.get.call(this);
	      },
	      set: function (value) {
	        currentValue = '' + value;
	        descriptor.set.call(this, value);
	      }
	    });
	
	    attachTracker(inst, {
	      getValue: function () {
	        return currentValue;
	      },
	      setValue: function (value) {
	        currentValue = '' + value;
	      },
	      stopTracking: function () {
	        detachTracker(inst);
	        delete node[valueField];
	      }
	    });
	  },
	
	  updateValueIfChanged: function (inst) {
	    if (!inst) {
	      return false;
	    }
	    var tracker = getTracker(inst);
	
	    if (!tracker) {
	      inputValueTracking.track(inst);
	      return true;
	    }
	
	    var lastValue = tracker.getValue();
	    var nextValue = getValueFromNode(ReactDOMComponentTree.getNodeFromInstance(inst));
	
	    if (nextValue !== lastValue) {
	      tracker.setValue(nextValue);
	      return true;
	    }
	
	    return false;
	  },
	  stopTracking: function (inst) {
	    var tracker = getTracker(inst);
	    if (tracker) {
	      tracker.stopTracking();
	    }
	  }
	};
	
	module.exports = inputValueTracking;

/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(6),
	    _assign = __webpack_require__(7);
	
	var ReactCompositeComponent = __webpack_require__(429);
	var ReactEmptyComponent = __webpack_require__(201);
	var ReactHostComponent = __webpack_require__(203);
	
	var getNextDebugID = __webpack_require__(488);
	var invariant = __webpack_require__(3);
	var warning = __webpack_require__(5);
	
	// To avoid a cyclic dependency, we create the final class in this module
	var ReactCompositeComponentWrapper = function (element) {
	  this.construct(element);
	};
	
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	/**
	 * Check if the type reference is a known internal type. I.e. not a user
	 * provided composite type.
	 *
	 * @param {function} type
	 * @return {boolean} Returns true if this is a valid internal type.
	 */
	function isInternalComponentType(type) {
	  return typeof type === 'function' && typeof type.prototype !== 'undefined' && typeof type.prototype.mountComponent === 'function' && typeof type.prototype.receiveComponent === 'function';
	}
	
	/**
	 * Given a ReactNode, create an instance that will actually be mounted.
	 *
	 * @param {ReactNode} node
	 * @param {boolean} shouldHaveDebugID
	 * @return {object} A new instance of the element's constructor.
	 * @protected
	 */
	function instantiateReactComponent(node, shouldHaveDebugID) {
	  var instance;
	
	  if (node === null || node === false) {
	    instance = ReactEmptyComponent.create(instantiateReactComponent);
	  } else if (typeof node === 'object') {
	    var element = node;
	    var type = element.type;
	    if (typeof type !== 'function' && typeof type !== 'string') {
	      var info = '';
	      if (false) {
	        if (type === undefined || typeof type === 'object' && type !== null && Object.keys(type).length === 0) {
	          info += ' You likely forgot to export your component from the file ' + "it's defined in.";
	        }
	      }
	      info += getDeclarationErrorAddendum(element._owner);
	       true ?  false ? invariant(false, 'Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s', type == null ? type : typeof type, info) : _prodInvariant('130', type == null ? type : typeof type, info) : void 0;
	    }
	
	    // Special case string values
	    if (typeof element.type === 'string') {
	      instance = ReactHostComponent.createInternalComponent(element);
	    } else if (isInternalComponentType(element.type)) {
	      // This is temporarily available for custom components that are not string
	      // representations. I.e. ART. Once those are updated to use the string
	      // representation, we can drop this code path.
	      instance = new element.type(element);
	
	      // We renamed this. Allow the old name for compat. :(
	      if (!instance.getHostNode) {
	        instance.getHostNode = instance.getNativeNode;
	      }
	    } else {
	      instance = new ReactCompositeComponentWrapper(element);
	    }
	  } else if (typeof node === 'string' || typeof node === 'number') {
	    instance = ReactHostComponent.createInstanceForText(node);
	  } else {
	     true ?  false ? invariant(false, 'Encountered invalid React node of type %s', typeof node) : _prodInvariant('131', typeof node) : void 0;
	  }
	
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(typeof instance.mountComponent === 'function' && typeof instance.receiveComponent === 'function' && typeof instance.getHostNode === 'function' && typeof instance.unmountComponent === 'function', 'Only React Components can be mounted.') : void 0;
	  }
	
	  // These two fields are used by the DOM and ART diffing algorithms
	  // respectively. Instead of using expandos on components, we should be
	  // storing the state needed by the diffing algorithms elsewhere.
	  instance._mountIndex = 0;
	  instance._mountImage = null;
	
	  if (false) {
	    instance._debugID = shouldHaveDebugID ? getNextDebugID() : 0;
	  }
	
	  // Internal instances should fully constructed at this point, so they should
	  // not get any new fields added to them at this point.
	  if (false) {
	    if (Object.preventExtensions) {
	      Object.preventExtensions(instance);
	    }
	  }
	
	  return instance;
	}
	
	_assign(ReactCompositeComponentWrapper.prototype, ReactCompositeComponent, {
	  _instantiateReactComponent: instantiateReactComponent
	});
	
	module.exports = instantiateReactComponent;

/***/ }),
/* 214 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * @see http://www.whatwg.org/specs/web-apps/current-work/multipage/the-input-element.html#input-type-attr-summary
	 */
	
	var supportedInputTypes = {
	  color: true,
	  date: true,
	  datetime: true,
	  'datetime-local': true,
	  email: true,
	  month: true,
	  number: true,
	  password: true,
	  range: true,
	  search: true,
	  tel: true,
	  text: true,
	  time: true,
	  url: true,
	  week: true
	};
	
	function isTextInputElement(elem) {
	  var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
	
	  if (nodeName === 'input') {
	    return !!supportedInputTypes[elem.type];
	  }
	
	  if (nodeName === 'textarea') {
	    return true;
	  }
	
	  return false;
	}
	
	module.exports = isTextInputElement;

/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(16);
	var escapeTextContentForBrowser = __webpack_require__(86);
	var setInnerHTML = __webpack_require__(87);
	
	/**
	 * Set the textContent property of a node, ensuring that whitespace is preserved
	 * even in IE8. innerText is a poor substitute for textContent and, among many
	 * issues, inserts <br> instead of the literal newline chars. innerHTML behaves
	 * as it should.
	 *
	 * @param {DOMElement} node
	 * @param {string} text
	 * @internal
	 */
	var setTextContent = function (node, text) {
	  if (text) {
	    var firstChild = node.firstChild;
	
	    if (firstChild && firstChild === node.lastChild && firstChild.nodeType === 3) {
	      firstChild.nodeValue = text;
	      return;
	    }
	  }
	  node.textContent = text;
	};
	
	if (ExecutionEnvironment.canUseDOM) {
	  if (!('textContent' in document.documentElement)) {
	    setTextContent = function (node, text) {
	      if (node.nodeType === 3) {
	        node.nodeValue = text;
	        return;
	      }
	      setInnerHTML(node, escapeTextContentForBrowser(text));
	    };
	  }
	}
	
	module.exports = setTextContent;

/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(6);
	
	var ReactCurrentOwner = __webpack_require__(32);
	var REACT_ELEMENT_TYPE = __webpack_require__(444);
	
	var getIteratorFn = __webpack_require__(475);
	var invariant = __webpack_require__(3);
	var KeyEscapeUtils = __webpack_require__(121);
	var warning = __webpack_require__(5);
	
	var SEPARATOR = '.';
	var SUBSEPARATOR = ':';
	
	/**
	 * This is inlined from ReactElement since this file is shared between
	 * isomorphic and renderers. We could extract this to a
	 *
	 */
	
	/**
	 * TODO: Test that a single child and an array with one item have the same key
	 * pattern.
	 */
	
	var didWarnAboutMaps = false;
	
	/**
	 * Generate a key string that identifies a component within a set.
	 *
	 * @param {*} component A component that could contain a manual key.
	 * @param {number} index Index that is used if a manual key is not provided.
	 * @return {string}
	 */
	function getComponentKey(component, index) {
	  // Do some typechecking here since we call this blindly. We want to ensure
	  // that we don't block potential future ES APIs.
	  if (component && typeof component === 'object' && component.key != null) {
	    // Explicit key
	    return KeyEscapeUtils.escape(component.key);
	  }
	  // Implicit key determined by the index in the set
	  return index.toString(36);
	}
	
	/**
	 * @param {?*} children Children tree container.
	 * @param {!string} nameSoFar Name of the key path so far.
	 * @param {!function} callback Callback to invoke with each child found.
	 * @param {?*} traverseContext Used to pass information throughout the traversal
	 * process.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
	  var type = typeof children;
	
	  if (type === 'undefined' || type === 'boolean') {
	    // All of the above are perceived as null.
	    children = null;
	  }
	
	  if (children === null || type === 'string' || type === 'number' ||
	  // The following is inlined from ReactElement. This means we can optimize
	  // some checks. React Fiber also inlines this logic for similar purposes.
	  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
	    callback(traverseContext, children,
	    // If it's the only child, treat the name as if it was wrapped in an array
	    // so that it's consistent if the number of children grows.
	    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
	    return 1;
	  }
	
	  var child;
	  var nextName;
	  var subtreeCount = 0; // Count of children found in the current subtree.
	  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;
	
	  if (Array.isArray(children)) {
	    for (var i = 0; i < children.length; i++) {
	      child = children[i];
	      nextName = nextNamePrefix + getComponentKey(child, i);
	      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	    }
	  } else {
	    var iteratorFn = getIteratorFn(children);
	    if (iteratorFn) {
	      var iterator = iteratorFn.call(children);
	      var step;
	      if (iteratorFn !== children.entries) {
	        var ii = 0;
	        while (!(step = iterator.next()).done) {
	          child = step.value;
	          nextName = nextNamePrefix + getComponentKey(child, ii++);
	          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	        }
	      } else {
	        if (false) {
	          var mapsAsChildrenAddendum = '';
	          if (ReactCurrentOwner.current) {
	            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
	            if (mapsAsChildrenOwnerName) {
	              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
	            }
	          }
	          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
	          didWarnAboutMaps = true;
	        }
	        // Iterator will provide entry [k,v] tuples rather than values.
	        while (!(step = iterator.next()).done) {
	          var entry = step.value;
	          if (entry) {
	            child = entry[1];
	            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
	            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	          }
	        }
	      }
	    } else if (type === 'object') {
	      var addendum = '';
	      if (false) {
	        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
	        if (children._isReactElement) {
	          addendum = " It looks like you're using an element created by a different " + 'version of React. Make sure to use only one copy of React.';
	        }
	        if (ReactCurrentOwner.current) {
	          var name = ReactCurrentOwner.current.getName();
	          if (name) {
	            addendum += ' Check the render method of `' + name + '`.';
	          }
	        }
	      }
	      var childrenString = String(children);
	       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
	    }
	  }
	
	  return subtreeCount;
	}
	
	/**
	 * Traverses children that are typically specified as `props.children`, but
	 * might also be specified through attributes:
	 *
	 * - `traverseAllChildren(this.props.children, ...)`
	 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
	 *
	 * The `traverseContext` is an optional argument that is passed through the
	 * entire traversal. It can be used to store accumulations or anything else that
	 * the callback might find relevant.
	 *
	 * @param {?*} children Children tree object.
	 * @param {!function} callback To invoke upon traversing each child.
	 * @param {?*} traverseContext Context for traversal.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildren(children, callback, traverseContext) {
	  if (children == null) {
	    return 0;
	  }
	
	  return traverseAllChildrenImpl(children, '', callback, traverseContext);
	}
	
	module.exports = traverseAllChildren;

/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(63),
	    _assign = __webpack_require__(7);
	
	var ReactNoopUpdateQueue = __webpack_require__(220);
	
	var canDefineProperty = __webpack_require__(221);
	var emptyObject = __webpack_require__(82);
	var invariant = __webpack_require__(3);
	var lowPriorityWarning = __webpack_require__(489);
	
	/**
	 * Base class helpers for the updating state of a component.
	 */
	function ReactComponent(props, context, updater) {
	  this.props = props;
	  this.context = context;
	  this.refs = emptyObject;
	  // We initialize the default updater but the real one gets injected by the
	  // renderer.
	  this.updater = updater || ReactNoopUpdateQueue;
	}
	
	ReactComponent.prototype.isReactComponent = {};
	
	/**
	 * Sets a subset of the state. Always use this to mutate
	 * state. You should treat `this.state` as immutable.
	 *
	 * There is no guarantee that `this.state` will be immediately updated, so
	 * accessing `this.state` after calling this method may return the old value.
	 *
	 * There is no guarantee that calls to `setState` will run synchronously,
	 * as they may eventually be batched together.  You can provide an optional
	 * callback that will be executed when the call to setState is actually
	 * completed.
	 *
	 * When a function is provided to setState, it will be called at some point in
	 * the future (not synchronously). It will be called with the up to date
	 * component arguments (state, props, context). These values can be different
	 * from this.* because your function may be called after receiveProps but before
	 * shouldComponentUpdate, and this new state, props, and context will not yet be
	 * assigned to this.
	 *
	 * @param {object|function} partialState Next partial state or function to
	 *        produce next partial state to be merged with current state.
	 * @param {?function} callback Called after state is updated.
	 * @final
	 * @protected
	 */
	ReactComponent.prototype.setState = function (partialState, callback) {
	  !(typeof partialState === 'object' || typeof partialState === 'function' || partialState == null) ?  false ? invariant(false, 'setState(...): takes an object of state variables to update or a function which returns an object of state variables.') : _prodInvariant('85') : void 0;
	  this.updater.enqueueSetState(this, partialState);
	  if (callback) {
	    this.updater.enqueueCallback(this, callback, 'setState');
	  }
	};
	
	/**
	 * Forces an update. This should only be invoked when it is known with
	 * certainty that we are **not** in a DOM transaction.
	 *
	 * You may want to call this when you know that some deeper aspect of the
	 * component's state has changed but `setState` was not called.
	 *
	 * This will not invoke `shouldComponentUpdate`, but it will invoke
	 * `componentWillUpdate` and `componentDidUpdate`.
	 *
	 * @param {?function} callback Called after update is complete.
	 * @final
	 * @protected
	 */
	ReactComponent.prototype.forceUpdate = function (callback) {
	  this.updater.enqueueForceUpdate(this);
	  if (callback) {
	    this.updater.enqueueCallback(this, callback, 'forceUpdate');
	  }
	};
	
	/**
	 * Deprecated APIs. These APIs used to exist on classic React classes but since
	 * we would like to deprecate them, we're not going to move them over to this
	 * modern base class. Instead, we define a getter that warns if it's accessed.
	 */
	if (false) {
	  var deprecatedAPIs = {
	    isMounted: ['isMounted', 'Instead, make sure to clean up subscriptions and pending requests in ' + 'componentWillUnmount to prevent memory leaks.'],
	    replaceState: ['replaceState', 'Refactor your code to use setState instead (see ' + 'https://github.com/facebook/react/issues/3236).']
	  };
	  var defineDeprecationWarning = function (methodName, info) {
	    if (canDefineProperty) {
	      Object.defineProperty(ReactComponent.prototype, methodName, {
	        get: function () {
	          lowPriorityWarning(false, '%s(...) is deprecated in plain JavaScript React classes. %s', info[0], info[1]);
	          return undefined;
	        }
	      });
	    }
	  };
	  for (var fnName in deprecatedAPIs) {
	    if (deprecatedAPIs.hasOwnProperty(fnName)) {
	      defineDeprecationWarning(fnName, deprecatedAPIs[fnName]);
	    }
	  }
	}
	
	/**
	 * Base class helpers for the updating state of a component.
	 */
	function ReactPureComponent(props, context, updater) {
	  // Duplicated from ReactComponent.
	  this.props = props;
	  this.context = context;
	  this.refs = emptyObject;
	  // We initialize the default updater but the real one gets injected by the
	  // renderer.
	  this.updater = updater || ReactNoopUpdateQueue;
	}
	
	function ComponentDummy() {}
	ComponentDummy.prototype = ReactComponent.prototype;
	ReactPureComponent.prototype = new ComponentDummy();
	ReactPureComponent.prototype.constructor = ReactPureComponent;
	// Avoid an extra prototype jump for these methods.
	_assign(ReactPureComponent.prototype, ReactComponent.prototype);
	ReactPureComponent.prototype.isPureReactComponent = true;
	
	module.exports = {
	  Component: ReactComponent,
	  PureComponent: ReactPureComponent
	};

/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2016-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(63);
	
	var ReactCurrentOwner = __webpack_require__(32);
	
	var invariant = __webpack_require__(3);
	var warning = __webpack_require__(5);
	
	function isNative(fn) {
	  // Based on isNative() from Lodash
	  var funcToString = Function.prototype.toString;
	  var hasOwnProperty = Object.prototype.hasOwnProperty;
	  var reIsNative = RegExp('^' + funcToString
	  // Take an example native function source for comparison
	  .call(hasOwnProperty
	  // Strip regex characters so we can use it for regex
	  ).replace(/[\\^$.*+?()[\]{}|]/g, '\\$&'
	  // Remove hasOwnProperty from the template to make it generic
	  ).replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
	  try {
	    var source = funcToString.call(fn);
	    return reIsNative.test(source);
	  } catch (err) {
	    return false;
	  }
	}
	
	var canUseCollections =
	// Array.from
	typeof Array.from === 'function' &&
	// Map
	typeof Map === 'function' && isNative(Map) &&
	// Map.prototype.keys
	Map.prototype != null && typeof Map.prototype.keys === 'function' && isNative(Map.prototype.keys) &&
	// Set
	typeof Set === 'function' && isNative(Set) &&
	// Set.prototype.keys
	Set.prototype != null && typeof Set.prototype.keys === 'function' && isNative(Set.prototype.keys);
	
	var setItem;
	var getItem;
	var removeItem;
	var getItemIDs;
	var addRoot;
	var removeRoot;
	var getRootIDs;
	
	if (canUseCollections) {
	  var itemMap = new Map();
	  var rootIDSet = new Set();
	
	  setItem = function (id, item) {
	    itemMap.set(id, item);
	  };
	  getItem = function (id) {
	    return itemMap.get(id);
	  };
	  removeItem = function (id) {
	    itemMap['delete'](id);
	  };
	  getItemIDs = function () {
	    return Array.from(itemMap.keys());
	  };
	
	  addRoot = function (id) {
	    rootIDSet.add(id);
	  };
	  removeRoot = function (id) {
	    rootIDSet['delete'](id);
	  };
	  getRootIDs = function () {
	    return Array.from(rootIDSet.keys());
	  };
	} else {
	  var itemByKey = {};
	  var rootByKey = {};
	
	  // Use non-numeric keys to prevent V8 performance issues:
	  // https://github.com/facebook/react/pull/7232
	  var getKeyFromID = function (id) {
	    return '.' + id;
	  };
	  var getIDFromKey = function (key) {
	    return parseInt(key.substr(1), 10);
	  };
	
	  setItem = function (id, item) {
	    var key = getKeyFromID(id);
	    itemByKey[key] = item;
	  };
	  getItem = function (id) {
	    var key = getKeyFromID(id);
	    return itemByKey[key];
	  };
	  removeItem = function (id) {
	    var key = getKeyFromID(id);
	    delete itemByKey[key];
	  };
	  getItemIDs = function () {
	    return Object.keys(itemByKey).map(getIDFromKey);
	  };
	
	  addRoot = function (id) {
	    var key = getKeyFromID(id);
	    rootByKey[key] = true;
	  };
	  removeRoot = function (id) {
	    var key = getKeyFromID(id);
	    delete rootByKey[key];
	  };
	  getRootIDs = function () {
	    return Object.keys(rootByKey).map(getIDFromKey);
	  };
	}
	
	var unmountedIDs = [];
	
	function purgeDeep(id) {
	  var item = getItem(id);
	  if (item) {
	    var childIDs = item.childIDs;
	
	    removeItem(id);
	    childIDs.forEach(purgeDeep);
	  }
	}
	
	function describeComponentFrame(name, source, ownerName) {
	  return '\n    in ' + (name || 'Unknown') + (source ? ' (at ' + source.fileName.replace(/^.*[\\\/]/, '') + ':' + source.lineNumber + ')' : ownerName ? ' (created by ' + ownerName + ')' : '');
	}
	
	function getDisplayName(element) {
	  if (element == null) {
	    return '#empty';
	  } else if (typeof element === 'string' || typeof element === 'number') {
	    return '#text';
	  } else if (typeof element.type === 'string') {
	    return element.type;
	  } else {
	    return element.type.displayName || element.type.name || 'Unknown';
	  }
	}
	
	function describeID(id) {
	  var name = ReactComponentTreeHook.getDisplayName(id);
	  var element = ReactComponentTreeHook.getElement(id);
	  var ownerID = ReactComponentTreeHook.getOwnerID(id);
	  var ownerName;
	  if (ownerID) {
	    ownerName = ReactComponentTreeHook.getDisplayName(ownerID);
	  }
	   false ? warning(element, 'ReactComponentTreeHook: Missing React element for debugID %s when ' + 'building stack', id) : void 0;
	  return describeComponentFrame(name, element && element._source, ownerName);
	}
	
	var ReactComponentTreeHook = {
	  onSetChildren: function (id, nextChildIDs) {
	    var item = getItem(id);
	    !item ?  false ? invariant(false, 'Item must have been set') : _prodInvariant('144') : void 0;
	    item.childIDs = nextChildIDs;
	
	    for (var i = 0; i < nextChildIDs.length; i++) {
	      var nextChildID = nextChildIDs[i];
	      var nextChild = getItem(nextChildID);
	      !nextChild ?  false ? invariant(false, 'Expected hook events to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('140') : void 0;
	      !(nextChild.childIDs != null || typeof nextChild.element !== 'object' || nextChild.element == null) ?  false ? invariant(false, 'Expected onSetChildren() to fire for a container child before its parent includes it in onSetChildren().') : _prodInvariant('141') : void 0;
	      !nextChild.isMounted ?  false ? invariant(false, 'Expected onMountComponent() to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('71') : void 0;
	      if (nextChild.parentID == null) {
	        nextChild.parentID = id;
	        // TODO: This shouldn't be necessary but mounting a new root during in
	        // componentWillMount currently causes not-yet-mounted components to
	        // be purged from our tree data so their parent id is missing.
	      }
	      !(nextChild.parentID === id) ?  false ? invariant(false, 'Expected onBeforeMountComponent() parent and onSetChildren() to be consistent (%s has parents %s and %s).', nextChildID, nextChild.parentID, id) : _prodInvariant('142', nextChildID, nextChild.parentID, id) : void 0;
	    }
	  },
	  onBeforeMountComponent: function (id, element, parentID) {
	    var item = {
	      element: element,
	      parentID: parentID,
	      text: null,
	      childIDs: [],
	      isMounted: false,
	      updateCount: 0
	    };
	    setItem(id, item);
	  },
	  onBeforeUpdateComponent: function (id, element) {
	    var item = getItem(id);
	    if (!item || !item.isMounted) {
	      // We may end up here as a result of setState() in componentWillUnmount().
	      // In this case, ignore the element.
	      return;
	    }
	    item.element = element;
	  },
	  onMountComponent: function (id) {
	    var item = getItem(id);
	    !item ?  false ? invariant(false, 'Item must have been set') : _prodInvariant('144') : void 0;
	    item.isMounted = true;
	    var isRoot = item.parentID === 0;
	    if (isRoot) {
	      addRoot(id);
	    }
	  },
	  onUpdateComponent: function (id) {
	    var item = getItem(id);
	    if (!item || !item.isMounted) {
	      // We may end up here as a result of setState() in componentWillUnmount().
	      // In this case, ignore the element.
	      return;
	    }
	    item.updateCount++;
	  },
	  onUnmountComponent: function (id) {
	    var item = getItem(id);
	    if (item) {
	      // We need to check if it exists.
	      // `item` might not exist if it is inside an error boundary, and a sibling
	      // error boundary child threw while mounting. Then this instance never
	      // got a chance to mount, but it still gets an unmounting event during
	      // the error boundary cleanup.
	      item.isMounted = false;
	      var isRoot = item.parentID === 0;
	      if (isRoot) {
	        removeRoot(id);
	      }
	    }
	    unmountedIDs.push(id);
	  },
	  purgeUnmountedComponents: function () {
	    if (ReactComponentTreeHook._preventPurging) {
	      // Should only be used for testing.
	      return;
	    }
	
	    for (var i = 0; i < unmountedIDs.length; i++) {
	      var id = unmountedIDs[i];
	      purgeDeep(id);
	    }
	    unmountedIDs.length = 0;
	  },
	  isMounted: function (id) {
	    var item = getItem(id);
	    return item ? item.isMounted : false;
	  },
	  getCurrentStackAddendum: function (topElement) {
	    var info = '';
	    if (topElement) {
	      var name = getDisplayName(topElement);
	      var owner = topElement._owner;
	      info += describeComponentFrame(name, topElement._source, owner && owner.getName());
	    }
	
	    var currentOwner = ReactCurrentOwner.current;
	    var id = currentOwner && currentOwner._debugID;
	
	    info += ReactComponentTreeHook.getStackAddendumByID(id);
	    return info;
	  },
	  getStackAddendumByID: function (id) {
	    var info = '';
	    while (id) {
	      info += describeID(id);
	      id = ReactComponentTreeHook.getParentID(id);
	    }
	    return info;
	  },
	  getChildIDs: function (id) {
	    var item = getItem(id);
	    return item ? item.childIDs : [];
	  },
	  getDisplayName: function (id) {
	    var element = ReactComponentTreeHook.getElement(id);
	    if (!element) {
	      return null;
	    }
	    return getDisplayName(element);
	  },
	  getElement: function (id) {
	    var item = getItem(id);
	    return item ? item.element : null;
	  },
	  getOwnerID: function (id) {
	    var element = ReactComponentTreeHook.getElement(id);
	    if (!element || !element._owner) {
	      return null;
	    }
	    return element._owner._debugID;
	  },
	  getParentID: function (id) {
	    var item = getItem(id);
	    return item ? item.parentID : null;
	  },
	  getSource: function (id) {
	    var item = getItem(id);
	    var element = item ? item.element : null;
	    var source = element != null ? element._source : null;
	    return source;
	  },
	  getText: function (id) {
	    var element = ReactComponentTreeHook.getElement(id);
	    if (typeof element === 'string') {
	      return element;
	    } else if (typeof element === 'number') {
	      return '' + element;
	    } else {
	      return null;
	    }
	  },
	  getUpdateCount: function (id) {
	    var item = getItem(id);
	    return item ? item.updateCount : 0;
	  },
	
	
	  getRootIDs: getRootIDs,
	  getRegisteredIDs: getItemIDs,
	
	  pushNonStandardWarningStack: function (isCreatingElement, currentSource) {
	    if (typeof console.reactStack !== 'function') {
	      return;
	    }
	
	    var stack = [];
	    var currentOwner = ReactCurrentOwner.current;
	    var id = currentOwner && currentOwner._debugID;
	
	    try {
	      if (isCreatingElement) {
	        stack.push({
	          name: id ? ReactComponentTreeHook.getDisplayName(id) : null,
	          fileName: currentSource ? currentSource.fileName : null,
	          lineNumber: currentSource ? currentSource.lineNumber : null
	        });
	      }
	
	      while (id) {
	        var element = ReactComponentTreeHook.getElement(id);
	        var parentID = ReactComponentTreeHook.getParentID(id);
	        var ownerID = ReactComponentTreeHook.getOwnerID(id);
	        var ownerName = ownerID ? ReactComponentTreeHook.getDisplayName(ownerID) : null;
	        var source = element && element._source;
	        stack.push({
	          name: ownerName,
	          fileName: source ? source.fileName : null,
	          lineNumber: source ? source.lineNumber : null
	        });
	        id = parentID;
	      }
	    } catch (err) {
	      // Internal state is messed up.
	      // Stop building the stack (it's just a nice to have).
	    }
	
	    console.reactStack(stack);
	  },
	  popNonStandardWarningStack: function () {
	    if (typeof console.reactStackEnd !== 'function') {
	      return;
	    }
	    console.reactStackEnd();
	  }
	};
	
	module.exports = ReactComponentTreeHook;

/***/ }),
/* 219 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	// The Symbol used to tag the ReactElement type. If there is no native Symbol
	// nor polyfill, then a plain number is used for performance.
	
	var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 0xeac7;
	
	module.exports = REACT_ELEMENT_TYPE;

/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var warning = __webpack_require__(5);
	
	function warnNoop(publicInstance, callerName) {
	  if (false) {
	    var constructor = publicInstance.constructor;
	    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
	  }
	}
	
	/**
	 * This is the abstract API for an update queue.
	 */
	var ReactNoopUpdateQueue = {
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function (publicInstance) {
	    return false;
	  },
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @internal
	   */
	  enqueueCallback: function (publicInstance, callback) {},
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	  enqueueForceUpdate: function (publicInstance) {
	    warnNoop(publicInstance, 'forceUpdate');
	  },
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} completeState Next state.
	   * @internal
	   */
	  enqueueReplaceState: function (publicInstance, completeState) {
	    warnNoop(publicInstance, 'replaceState');
	  },
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} partialState Next partial state to be merged with state.
	   * @internal
	   */
	  enqueueSetState: function (publicInstance, partialState) {
	    warnNoop(publicInstance, 'setState');
	  }
	};
	
	module.exports = ReactNoopUpdateQueue;

/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var canDefineProperty = false;
	if (false) {
	  try {
	    // $FlowFixMe https://github.com/facebook/flow/issues/285
	    Object.defineProperty({}, 'x', { get: function () {} });
	    canDefineProperty = true;
	  } catch (x) {
	    // IE will fail on defineProperty
	  }
	}
	
	module.exports = canDefineProperty;

/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var util_1 = __webpack_require__(1);
	var contains = function (obj, key) {
	    return Object.prototype.hasOwnProperty.call(obj, key);
	};
	var DEFAULT_ENTRY_NAME = '[DEFAULT]';
	// An array to capture listeners before the true auth functions
	// exist
	var tokenListeners = [];
	/**
	 * Global context object for a collection of services using
	 * a shared authentication state.
	 */
	var FirebaseAppImpl = /** @class */ (function () {
	    function FirebaseAppImpl(options, name, firebase_) {
	        this.firebase_ = firebase_;
	        this.isDeleted_ = false;
	        this.services_ = {};
	        this.name_ = name;
	        this.options_ = util_1.deepCopy(options);
	        this.INTERNAL = {
	            getUid: function () { return null; },
	            getToken: function () { return Promise.resolve(null); },
	            addAuthTokenListener: function (callback) {
	                tokenListeners.push(callback);
	                // Make sure callback is called, asynchronously, in the absence of the auth module
	                setTimeout(function () { return callback(null); }, 0);
	            },
	            removeAuthTokenListener: function (callback) {
	                tokenListeners = tokenListeners.filter(function (listener) { return listener !== callback; });
	            }
	        };
	    }
	    Object.defineProperty(FirebaseAppImpl.prototype, "name", {
	        get: function () {
	            this.checkDestroyed_();
	            return this.name_;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(FirebaseAppImpl.prototype, "options", {
	        get: function () {
	            this.checkDestroyed_();
	            return this.options_;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    FirebaseAppImpl.prototype.delete = function () {
	        var _this = this;
	        return new Promise(function (resolve) {
	            _this.checkDestroyed_();
	            resolve();
	        })
	            .then(function () {
	            _this.firebase_.INTERNAL.removeApp(_this.name_);
	            var services = [];
	            Object.keys(_this.services_).forEach(function (serviceKey) {
	                Object.keys(_this.services_[serviceKey]).forEach(function (instanceKey) {
	                    services.push(_this.services_[serviceKey][instanceKey]);
	                });
	            });
	            return Promise.all(services.map(function (service) {
	                return service.INTERNAL.delete();
	            }));
	        })
	            .then(function () {
	            _this.isDeleted_ = true;
	            _this.services_ = {};
	        });
	    };
	    /**
	     * Return a service instance associated with this app (creating it
	     * on demand), identified by the passed instanceIdentifier.
	     *
	     * NOTE: Currently storage is the only one that is leveraging this
	     * functionality. They invoke it by calling:
	     *
	     * ```javascript
	     * firebase.app().storage('STORAGE BUCKET ID')
	     * ```
	     *
	     * The service name is passed to this already
	     * @internal
	     */
	    FirebaseAppImpl.prototype._getService = function (name, instanceIdentifier) {
	        if (instanceIdentifier === void 0) { instanceIdentifier = DEFAULT_ENTRY_NAME; }
	        this.checkDestroyed_();
	        if (!this.services_[name]) {
	            this.services_[name] = {};
	        }
	        if (!this.services_[name][instanceIdentifier]) {
	            /**
	             * If a custom instance has been defined (i.e. not '[DEFAULT]')
	             * then we will pass that instance on, otherwise we pass `null`
	             */
	            var instanceSpecifier = instanceIdentifier !== DEFAULT_ENTRY_NAME
	                ? instanceIdentifier
	                : undefined;
	            var service = this.firebase_.INTERNAL.factories[name](this, this.extendApp.bind(this), instanceSpecifier);
	            this.services_[name][instanceIdentifier] = service;
	        }
	        return this.services_[name][instanceIdentifier];
	    };
	    /**
	     * Callback function used to extend an App instance at the time
	     * of service instance creation.
	     */
	    FirebaseAppImpl.prototype.extendApp = function (props) {
	        var _this = this;
	        // Copy the object onto the FirebaseAppImpl prototype
	        util_1.deepExtend(this, props);
	        /**
	         * If the app has overwritten the addAuthTokenListener stub, forward
	         * the active token listeners on to the true fxn.
	         *
	         * TODO: This function is required due to our current module
	         * structure. Once we are able to rely strictly upon a single module
	         * implementation, this code should be refactored and Auth should
	         * provide these stubs and the upgrade logic
	         */
	        if (props.INTERNAL && props.INTERNAL.addAuthTokenListener) {
	            tokenListeners.forEach(function (listener) {
	                _this.INTERNAL.addAuthTokenListener(listener);
	            });
	            tokenListeners = [];
	        }
	    };
	    /**
	     * This function will throw an Error if the App has already been deleted -
	     * use before performing API actions on the App.
	     */
	    FirebaseAppImpl.prototype.checkDestroyed_ = function () {
	        if (this.isDeleted_) {
	            error('app-deleted', { name: this.name_ });
	        }
	    };
	    return FirebaseAppImpl;
	}());
	// Prevent dead-code elimination of these methods w/o invalid property
	// copying.
	(FirebaseAppImpl.prototype.name && FirebaseAppImpl.prototype.options) ||
	    FirebaseAppImpl.prototype.delete ||
	    console.log('dc');
	/**
	 * Return a firebase namespace object.
	 *
	 * In production, this will be called exactly once and the result
	 * assigned to the 'firebase' global.  It may be called multiple times
	 * in unit tests.
	 */
	function createFirebaseNamespace() {
	    var apps_ = {};
	    var factories = {};
	    var appHooks = {};
	    // A namespace is a plain JavaScript Object.
	    var namespace = {
	        // Hack to prevent Babel from modifying the object returned
	        // as the firebase namespace.
	        __esModule: true,
	        initializeApp: initializeApp,
	        app: app,
	        apps: null,
	        Promise: Promise,
	        SDK_VERSION: '4.9.1',
	        INTERNAL: {
	            registerService: registerService,
	            createFirebaseNamespace: createFirebaseNamespace,
	            extendNamespace: extendNamespace,
	            createSubscribe: util_1.createSubscribe,
	            ErrorFactory: util_1.ErrorFactory,
	            removeApp: removeApp,
	            factories: factories,
	            useAsService: useAsService,
	            Promise: Promise,
	            deepExtend: util_1.deepExtend
	        }
	    };
	    // Inject a circular default export to allow Babel users who were previously
	    // using:
	    //
	    //   import firebase from 'firebase';
	    //   which becomes: var firebase = require('firebase').default;
	    //
	    // instead of
	    //
	    //   import * as firebase from 'firebase';
	    //   which becomes: var firebase = require('firebase');
	    util_1.patchProperty(namespace, 'default', namespace);
	    // firebase.apps is a read-only getter.
	    Object.defineProperty(namespace, 'apps', {
	        get: getApps
	    });
	    /**
	     * Called by App.delete() - but before any services associated with the App
	     * are deleted.
	     */
	    function removeApp(name) {
	        var app = apps_[name];
	        callAppHooks(app, 'delete');
	        delete apps_[name];
	    }
	    /**
	     * Get the App object for a given name (or DEFAULT).
	     */
	    function app(name) {
	        name = name || DEFAULT_ENTRY_NAME;
	        if (!contains(apps_, name)) {
	            error('no-app', { name: name });
	        }
	        return apps_[name];
	    }
	    util_1.patchProperty(app, 'App', FirebaseAppImpl);
	    /**
	     * Create a new App instance (name must be unique).
	     */
	    function initializeApp(options, name) {
	        if (name === undefined) {
	            name = DEFAULT_ENTRY_NAME;
	        }
	        else {
	            if (typeof name !== 'string' || name === '') {
	                error('bad-app-name', { name: name + '' });
	            }
	        }
	        if (contains(apps_, name)) {
	            error('duplicate-app', { name: name });
	        }
	        var app = new FirebaseAppImpl(options, name, namespace);
	        apps_[name] = app;
	        callAppHooks(app, 'create');
	        return app;
	    }
	    /*
	     * Return an array of all the non-deleted FirebaseApps.
	     */
	    function getApps() {
	        // Make a copy so caller cannot mutate the apps list.
	        return Object.keys(apps_).map(function (name) { return apps_[name]; });
	    }
	    /*
	     * Register a Firebase Service.
	     *
	     * firebase.INTERNAL.registerService()
	     *
	     * TODO: Implement serviceProperties.
	     */
	    function registerService(name, createService, serviceProperties, appHook, allowMultipleInstances) {
	        // Cannot re-register a service that already exists
	        if (factories[name]) {
	            error('duplicate-service', { name: name });
	        }
	        // Capture the service factory for later service instantiation
	        factories[name] = createService;
	        // Capture the appHook, if passed
	        if (appHook) {
	            appHooks[name] = appHook;
	            // Run the **new** app hook on all existing apps
	            getApps().forEach(function (app) {
	                appHook('create', app);
	            });
	        }
	        // The Service namespace is an accessor function ...
	        var serviceNamespace = function (appArg) {
	            if (appArg === void 0) { appArg = app(); }
	            if (typeof appArg[name] !== 'function') {
	                // Invalid argument.
	                // This happens in the following case: firebase.storage('gs:/')
	                error('invalid-app-argument', { name: name });
	            }
	            // Forward service instance lookup to the FirebaseApp.
	            return appArg[name]();
	        };
	        // ... and a container for service-level properties.
	        if (serviceProperties !== undefined) {
	            util_1.deepExtend(serviceNamespace, serviceProperties);
	        }
	        // Monkey-patch the serviceNamespace onto the firebase namespace
	        namespace[name] = serviceNamespace;
	        // Patch the FirebaseAppImpl prototype
	        FirebaseAppImpl.prototype[name] = function () {
	            var args = [];
	            for (var _i = 0; _i < arguments.length; _i++) {
	                args[_i] = arguments[_i];
	            }
	            var serviceFxn = this._getService.bind(this, name);
	            return serviceFxn.apply(this, allowMultipleInstances ? args : []);
	        };
	        return serviceNamespace;
	    }
	    /**
	     * Patch the top-level firebase namespace with additional properties.
	     *
	     * firebase.INTERNAL.extendNamespace()
	     */
	    function extendNamespace(props) {
	        util_1.deepExtend(namespace, props);
	    }
	    function callAppHooks(app, eventName) {
	        Object.keys(factories).forEach(function (serviceName) {
	            // Ignore virtual services
	            var factoryName = useAsService(app, serviceName);
	            if (factoryName === null) {
	                return;
	            }
	            if (appHooks[factoryName]) {
	                appHooks[factoryName](eventName, app);
	            }
	        });
	    }
	    // Map the requested service to a registered service name
	    // (used to map auth to serverAuth service when needed).
	    function useAsService(app, name) {
	        if (name === 'serverAuth') {
	            return null;
	        }
	        var useService = name;
	        var options = app.options;
	        return useService;
	    }
	    return namespace;
	}
	exports.createFirebaseNamespace = createFirebaseNamespace;
	function error(code, args) {
	    throw appErrors.create(code, args);
	}
	// TypeScript does not support non-string indexes!
	// let errors: {[code: AppError: string} = {
	var errors = {
	    'no-app': "No Firebase App '{$name}' has been created - " +
	        'call Firebase App.initializeApp()',
	    'bad-app-name': "Illegal App name: '{$name}",
	    'duplicate-app': "Firebase App named '{$name}' already exists",
	    'app-deleted': "Firebase App named '{$name}' already deleted",
	    'duplicate-service': "Firebase service named '{$name}' already registered",
	    'sa-not-supported': 'Initializing the Firebase SDK with a service ' +
	        'account is only allowed in a Node.js environment. On client ' +
	        'devices, you should instead initialize the SDK with an api key and ' +
	        'auth domain',
	    'invalid-app-argument': 'firebase.{$name}() takes either no argument or a ' +
	        'Firebase App instance.'
	};
	var appErrors = new util_1.ErrorFactory('app', 'Firebase', errors);
	
	
	//# sourceMappingURL=firebaseApp.js.map


/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {(function() {
	  var firebase = __webpack_require__(26).default;
	  var h,aa=aa||{},k=this;function m(a){return"string"==typeof a}function ba(a){return"boolean"==typeof a}function ca(){}
	function da(a){var b=typeof a;if("object"==b)if(a){if(a instanceof Array)return"array";if(a instanceof Object)return b;var c=Object.prototype.toString.call(a);if("[object Window]"==c)return"object";if("[object Array]"==c||"number"==typeof a.length&&"undefined"!=typeof a.splice&&"undefined"!=typeof a.propertyIsEnumerable&&!a.propertyIsEnumerable("splice"))return"array";if("[object Function]"==c||"undefined"!=typeof a.call&&"undefined"!=typeof a.propertyIsEnumerable&&!a.propertyIsEnumerable("call"))return"function"}else return"null";
	else if("function"==b&&"undefined"==typeof a.call)return"object";return b}function ea(a){return null===a}function fa(a){return"array"==da(a)}function ha(a){var b=da(a);return"array"==b||"object"==b&&"number"==typeof a.length}function p(a){return"function"==da(a)}function q(a){var b=typeof a;return"object"==b&&null!=a||"function"==b}var ia="closure_uid_"+(1E9*Math.random()>>>0),ja=0;function ka(a,b,c){return a.call.apply(a.bind,arguments)}
	function la(a,b,c){if(!a)throw Error();if(2<arguments.length){var d=Array.prototype.slice.call(arguments,2);return function(){var c=Array.prototype.slice.call(arguments);Array.prototype.unshift.apply(c,d);return a.apply(b,c)}}return function(){return a.apply(b,arguments)}}function r(a,b,c){Function.prototype.bind&&-1!=Function.prototype.bind.toString().indexOf("native code")?r=ka:r=la;return r.apply(null,arguments)}
	function ma(a,b){var c=Array.prototype.slice.call(arguments,1);return function(){var b=c.slice();b.push.apply(b,arguments);return a.apply(this,b)}}var na=Date.now||function(){return+new Date};function t(a,b){function c(){}c.prototype=b.prototype;a.ib=b.prototype;a.prototype=new c;a.prototype.constructor=a;a.Rc=function(a,c,f){for(var d=Array(arguments.length-2),e=2;e<arguments.length;e++)d[e-2]=arguments[e];return b.prototype[c].apply(a,d)}};function u(a){if(Error.captureStackTrace)Error.captureStackTrace(this,u);else{var b=Error().stack;b&&(this.stack=b)}a&&(this.message=String(a))}t(u,Error);u.prototype.name="CustomError";function oa(a,b){for(var c=a.split("%s"),d="",e=Array.prototype.slice.call(arguments,1);e.length&&1<c.length;)d+=c.shift()+e.shift();return d+c.join("%s")}var pa=String.prototype.trim?function(a){return a.trim()}:function(a){return a.replace(/^[\s\xa0]+|[\s\xa0]+$/g,"")};
	function qa(a){if(!ra.test(a))return a;-1!=a.indexOf("&")&&(a=a.replace(sa,"&amp;"));-1!=a.indexOf("<")&&(a=a.replace(ta,"&lt;"));-1!=a.indexOf(">")&&(a=a.replace(ua,"&gt;"));-1!=a.indexOf('"')&&(a=a.replace(va,"&quot;"));-1!=a.indexOf("'")&&(a=a.replace(wa,"&#39;"));-1!=a.indexOf("\x00")&&(a=a.replace(xa,"&#0;"));return a}var sa=/&/g,ta=/</g,ua=/>/g,va=/"/g,wa=/'/g,xa=/\x00/g,ra=/[\x00&<>"']/;function v(a,b){return-1!=a.indexOf(b)}function ya(a,b){return a<b?-1:a>b?1:0};function za(a,b){b.unshift(a);u.call(this,oa.apply(null,b));b.shift()}t(za,u);za.prototype.name="AssertionError";function Aa(a,b){throw new za("Failure"+(a?": "+a:""),Array.prototype.slice.call(arguments,1));};var Ba=Array.prototype.indexOf?function(a,b,c){return Array.prototype.indexOf.call(a,b,c)}:function(a,b,c){c=null==c?0:0>c?Math.max(0,a.length+c):c;if(m(a))return m(b)&&1==b.length?a.indexOf(b,c):-1;for(;c<a.length;c++)if(c in a&&a[c]===b)return c;return-1},w=Array.prototype.forEach?function(a,b,c){Array.prototype.forEach.call(a,b,c)}:function(a,b,c){for(var d=a.length,e=m(a)?a.split(""):a,f=0;f<d;f++)f in e&&b.call(c,e[f],f,a)};
	function Ca(a,b){var c=a.length,d=m(a)?a.split(""):a;for(--c;0<=c;--c)c in d&&b.call(void 0,d[c],c,a)}var Da=Array.prototype.map?function(a,b,c){return Array.prototype.map.call(a,b,c)}:function(a,b,c){for(var d=a.length,e=Array(d),f=m(a)?a.split(""):a,g=0;g<d;g++)g in f&&(e[g]=b.call(c,f[g],g,a));return e},Ea=Array.prototype.some?function(a,b,c){return Array.prototype.some.call(a,b,c)}:function(a,b,c){for(var d=a.length,e=m(a)?a.split(""):a,f=0;f<d;f++)if(f in e&&b.call(c,e[f],f,a))return!0;return!1};
	function Fa(a){a:{var b=Ga;for(var c=a.length,d=m(a)?a.split(""):a,e=0;e<c;e++)if(e in d&&b.call(void 0,d[e],e,a)){b=e;break a}b=-1}return 0>b?null:m(a)?a.charAt(b):a[b]}function Ha(a,b){return 0<=Ba(a,b)}function Ia(a,b){b=Ba(a,b);var c;(c=0<=b)&&Array.prototype.splice.call(a,b,1);return c}function Ja(a,b){var c=0;Ca(a,function(d,e){b.call(void 0,d,e,a)&&1==Array.prototype.splice.call(a,e,1).length&&c++})}function Ka(a){return Array.prototype.concat.apply([],arguments)}
	function La(a){var b=a.length;if(0<b){for(var c=Array(b),d=0;d<b;d++)c[d]=a[d];return c}return[]};var Ma;a:{var Na=k.navigator;if(Na){var Oa=Na.userAgent;if(Oa){Ma=Oa;break a}}Ma=""}function x(a){return v(Ma,a)};function Pa(a,b){for(var c in a)b.call(void 0,a[c],c,a)}function Qa(a){var b=[],c=0,d;for(d in a)b[c++]=a[d];return b}function Ra(a){var b=[],c=0,d;for(d in a)b[c++]=d;return b}function Sa(a){for(var b in a)return!1;return!0}function Ta(a,b){for(var c in a)if(!(c in b)||a[c]!==b[c])return!1;for(c in b)if(!(c in a))return!1;return!0}function Ua(a){var b={},c;for(c in a)b[c]=a[c];return b}var Va="constructor hasOwnProperty isPrototypeOf propertyIsEnumerable toLocaleString toString valueOf".split(" ");
	function Wa(a,b){for(var c,d,e=1;e<arguments.length;e++){d=arguments[e];for(c in d)a[c]=d[c];for(var f=0;f<Va.length;f++)c=Va[f],Object.prototype.hasOwnProperty.call(d,c)&&(a[c]=d[c])}};function Xa(a){Xa[" "](a);return a}Xa[" "]=ca;function Ya(a,b){var c=Za;return Object.prototype.hasOwnProperty.call(c,a)?c[a]:c[a]=b(a)};var $a=x("Opera"),y=x("Trident")||x("MSIE"),ab=x("Edge"),bb=ab||y,cb=x("Gecko")&&!(v(Ma.toLowerCase(),"webkit")&&!x("Edge"))&&!(x("Trident")||x("MSIE"))&&!x("Edge"),db=v(Ma.toLowerCase(),"webkit")&&!x("Edge");function eb(){var a=k.document;return a?a.documentMode:void 0}var fb;
	a:{var gb="",hb=function(){var a=Ma;if(cb)return/rv\:([^\);]+)(\)|;)/.exec(a);if(ab)return/Edge\/([\d\.]+)/.exec(a);if(y)return/\b(?:MSIE|rv)[: ]([^\);]+)(\)|;)/.exec(a);if(db)return/WebKit\/(\S+)/.exec(a);if($a)return/(?:Version)[ \/]?(\S+)/.exec(a)}();hb&&(gb=hb?hb[1]:"");if(y){var ib=eb();if(null!=ib&&ib>parseFloat(gb)){fb=String(ib);break a}}fb=gb}var Za={};
	function jb(a){return Ya(a,function(){for(var b=0,c=pa(String(fb)).split("."),d=pa(String(a)).split("."),e=Math.max(c.length,d.length),f=0;0==b&&f<e;f++){var g=c[f]||"",l=d[f]||"";do{g=/(\d*)(\D*)(.*)/.exec(g)||["","","",""];l=/(\d*)(\D*)(.*)/.exec(l)||["","","",""];if(0==g[0].length&&0==l[0].length)break;b=ya(0==g[1].length?0:parseInt(g[1],10),0==l[1].length?0:parseInt(l[1],10))||ya(0==g[2].length,0==l[2].length)||ya(g[2],l[2]);g=g[3];l=l[3]}while(0==b)}return 0<=b})}var kb;var lb=k.document;
	kb=lb&&y?eb()||("CSS1Compat"==lb.compatMode?parseInt(fb,10):5):void 0;function mb(a){a.prototype.then=a.prototype.then;a.prototype.$goog_Thenable=!0}function nb(a){if(!a)return!1;try{return!!a.$goog_Thenable}catch(b){return!1}};function ob(a,b,c){this.f=c;this.c=a;this.g=b;this.b=0;this.a=null}ob.prototype.get=function(){if(0<this.b){this.b--;var a=this.a;this.a=a.next;a.next=null}else a=this.c();return a};function pb(a,b){a.g(b);a.b<a.f&&(a.b++,b.next=a.a,a.a=b)};var rb=new ob(function(){return new qb},function(a){a.reset()},100);function sb(){var a=tb,b=null;a.a&&(b=a.a,a.a=a.a.next,a.a||(a.b=null),b.next=null);return b}function qb(){this.next=this.b=this.a=null}qb.prototype.set=function(a,b){this.a=a;this.b=b;this.next=null};qb.prototype.reset=function(){this.next=this.b=this.a=null};function ub(a){k.setTimeout(function(){throw a;},0)}var wb;
	function xb(){var a=k.MessageChannel;"undefined"===typeof a&&"undefined"!==typeof window&&window.postMessage&&window.addEventListener&&!x("Presto")&&(a=function(){var a=document.createElement("IFRAME");a.style.display="none";a.src="";document.documentElement.appendChild(a);var b=a.contentWindow;a=b.document;a.open();a.write("");a.close();var c="callImmediate"+Math.random(),d="file:"==b.location.protocol?"*":b.location.protocol+"//"+b.location.host;a=r(function(a){if(("*"==d||a.origin==d)&&a.data==
	c)this.port1.onmessage()},this);b.addEventListener("message",a,!1);this.port1={};this.port2={postMessage:function(){b.postMessage(c,d)}}});if("undefined"!==typeof a&&!x("Trident")&&!x("MSIE")){var b=new a,c={},d=c;b.port1.onmessage=function(){if(void 0!==c.next){c=c.next;var a=c.pb;c.pb=null;a()}};return function(a){d.next={pb:a};d=d.next;b.port2.postMessage(0)}}return"undefined"!==typeof document&&"onreadystatechange"in document.createElement("SCRIPT")?function(a){var b=document.createElement("SCRIPT");
	b.onreadystatechange=function(){b.onreadystatechange=null;b.parentNode.removeChild(b);b=null;a();a=null};document.documentElement.appendChild(b)}:function(a){k.setTimeout(a,0)}};function yb(a,b){zb||Ab();Bb||(zb(),Bb=!0);var c=tb,d=rb.get();d.set(a,b);c.b?c.b.next=d:c.a=d;c.b=d}var zb;function Ab(){if(-1!=String(k.Promise).indexOf("[native code]")){var a=k.Promise.resolve(void 0);zb=function(){a.then(Cb)}}else zb=function(){var a=Cb;!p(k.setImmediate)||k.Window&&k.Window.prototype&&!x("Edge")&&k.Window.prototype.setImmediate==k.setImmediate?(wb||(wb=xb()),wb(a)):k.setImmediate(a)}}var Bb=!1,tb=new function(){this.b=this.a=null};
	function Cb(){for(var a;a=sb();){try{a.a.call(a.b)}catch(b){ub(b)}pb(rb,a)}Bb=!1};function z(a,b){this.a=Db;this.i=void 0;this.f=this.b=this.c=null;this.g=this.h=!1;if(a!=ca)try{var c=this;a.call(b,function(a){Eb(c,Fb,a)},function(a){if(!(a instanceof Gb))try{if(a instanceof Error)throw a;throw Error("Promise rejected.");}catch(e){}Eb(c,Hb,a)})}catch(d){Eb(this,Hb,d)}}var Db=0,Fb=2,Hb=3;function Ib(){this.next=this.f=this.b=this.g=this.a=null;this.c=!1}Ib.prototype.reset=function(){this.f=this.b=this.g=this.a=null;this.c=!1};
	var Jb=new ob(function(){return new Ib},function(a){a.reset()},100);function Kb(a,b,c){var d=Jb.get();d.g=a;d.b=b;d.f=c;return d}function A(a){if(a instanceof z)return a;var b=new z(ca);Eb(b,Fb,a);return b}function B(a){return new z(function(b,c){c(a)})}function Lb(a,b,c){Mb(a,b,c,null)||yb(ma(b,a))}function Nb(a){return new z(function(b,c){var d=a.length,e=[];if(d)for(var f=function(a,c){d--;e[a]=c;0==d&&b(e)},g=function(a){c(a)},l=0,n;l<a.length;l++)n=a[l],Lb(n,ma(f,l),g);else b(e)})}
	function Ob(a){return new z(function(b){var c=a.length,d=[];if(c)for(var e=function(a,e,f){c--;d[a]=e?{Ub:!0,value:f}:{Ub:!1,reason:f};0==c&&b(d)},f=0,g;f<a.length;f++)g=a[f],Lb(g,ma(e,f,!0),ma(e,f,!1));else b(d)})}z.prototype.then=function(a,b,c){return Pb(this,p(a)?a:null,p(b)?b:null,c)};mb(z);function Qb(a,b){b=Kb(b,b,void 0);b.c=!0;Rb(a,b);return a}h=z.prototype;h.s=function(a,b){return Pb(this,null,a,b)};h.cancel=function(a){this.a==Db&&yb(function(){var b=new Gb(a);Sb(this,b)},this)};
	function Sb(a,b){if(a.a==Db)if(a.c){var c=a.c;if(c.b){for(var d=0,e=null,f=null,g=c.b;g&&(g.c||(d++,g.a==a&&(e=g),!(e&&1<d)));g=g.next)e||(f=g);e&&(c.a==Db&&1==d?Sb(c,b):(f?(d=f,d.next==c.f&&(c.f=d),d.next=d.next.next):Tb(c),Ub(c,e,Hb,b)))}a.c=null}else Eb(a,Hb,b)}function Rb(a,b){a.b||a.a!=Fb&&a.a!=Hb||Vb(a);a.f?a.f.next=b:a.b=b;a.f=b}
	function Pb(a,b,c,d){var e=Kb(null,null,null);e.a=new z(function(a,g){e.g=b?function(c){try{var e=b.call(d,c);a(e)}catch(D){g(D)}}:a;e.b=c?function(b){try{var e=c.call(d,b);void 0===e&&b instanceof Gb?g(b):a(e)}catch(D){g(D)}}:g});e.a.c=a;Rb(a,e);return e.a}h.Ac=function(a){this.a=Db;Eb(this,Fb,a)};h.Bc=function(a){this.a=Db;Eb(this,Hb,a)};
	function Eb(a,b,c){a.a==Db&&(a===c&&(b=Hb,c=new TypeError("Promise cannot resolve to itself")),a.a=1,Mb(c,a.Ac,a.Bc,a)||(a.i=c,a.a=b,a.c=null,Vb(a),b!=Hb||c instanceof Gb||Wb(a,c)))}function Mb(a,b,c,d){if(a instanceof z)return Rb(a,Kb(b||ca,c||null,d)),!0;if(nb(a))return a.then(b,c,d),!0;if(q(a))try{var e=a.then;if(p(e))return Xb(a,e,b,c,d),!0}catch(f){return c.call(d,f),!0}return!1}
	function Xb(a,b,c,d,e){function f(a){l||(l=!0,d.call(e,a))}function g(a){l||(l=!0,c.call(e,a))}var l=!1;try{b.call(a,g,f)}catch(n){f(n)}}function Vb(a){a.h||(a.h=!0,yb(a.Qb,a))}function Tb(a){var b=null;a.b&&(b=a.b,a.b=b.next,b.next=null);a.b||(a.f=null);return b}h.Qb=function(){for(var a;a=Tb(this);)Ub(this,a,this.a,this.i);this.h=!1};
	function Ub(a,b,c,d){if(c==Hb&&b.b&&!b.c)for(;a&&a.g;a=a.c)a.g=!1;if(b.a)b.a.c=null,Yb(b,c,d);else try{b.c?b.g.call(b.f):Yb(b,c,d)}catch(e){Zb.call(null,e)}pb(Jb,b)}function Yb(a,b,c){b==Fb?a.g.call(a.f,c):a.b&&a.b.call(a.f,c)}function Wb(a,b){a.g=!0;yb(function(){a.g&&Zb.call(null,b)})}var Zb=ub;function Gb(a){u.call(this,a)}t(Gb,u);Gb.prototype.name="cancel";var $b=!y||9<=Number(kb);function ac(){this.a="";this.b=bc}ac.prototype.la=!0;ac.prototype.ja=function(){return this.a};ac.prototype.toString=function(){return"Const{"+this.a+"}"};function cc(a){if(a instanceof ac&&a.constructor===ac&&a.b===bc)return a.a;Aa("expected object of type Const, got '"+a+"'");return"type_error:Const"}var bc={};function dc(a){var b=new ac;b.a=a;return b}dc("");function ec(){this.a="";this.b=fc}ec.prototype.la=!0;ec.prototype.ja=function(){return this.a};ec.prototype.toString=function(){return"TrustedResourceUrl{"+this.a+"}"};function gc(a){if(a instanceof ec&&a.constructor===ec&&a.b===fc)return a.a;Aa("expected object of type TrustedResourceUrl, got '"+a+"' of type "+da(a));return"type_error:TrustedResourceUrl"}function hc(a,b){a=ic(a,b);b=new ec;b.a=a;return b}
	function ic(a,b){var c=cc(a);if(!jc.test(c))throw Error("Invalid TrustedResourceUrl format: "+c);return c.replace(kc,function(a,e){if(!Object.prototype.hasOwnProperty.call(b,e))throw Error('Found marker, "'+e+'", in format string, "'+c+'", but no valid label mapping found in args: '+JSON.stringify(b));a=b[e];return a instanceof ac?cc(a):encodeURIComponent(String(a))})}var kc=/%{(\w+)}/g,jc=/^(?:https:)?\/\/[0-9a-z.:[\]-]+\/|^\/[^\/\\]|^about:blank(#|$)/i,fc={};function lc(){this.a="";this.b=mc}lc.prototype.la=!0;lc.prototype.ja=function(){return this.a};lc.prototype.toString=function(){return"SafeUrl{"+this.a+"}"};function nc(a){if(a instanceof lc&&a.constructor===lc&&a.b===mc)return a.a;Aa("expected object of type SafeUrl, got '"+a+"' of type "+da(a));return"type_error:SafeUrl"}var oc=/^(?:(?:https?|mailto|ftp):|[^:/?#]*(?:[/?#]|$))/i;
	function pc(a){if(a instanceof lc)return a;a=a.la?a.ja():String(a);oc.test(a)||(a="about:invalid#zClosurez");return qc(a)}var mc={};function qc(a){var b=new lc;b.a=a;return b}qc("about:blank");function rc(){this.a="";this.b=sc}rc.prototype.la=!0;rc.prototype.ja=function(){return this.a};rc.prototype.toString=function(){return"SafeHtml{"+this.a+"}"};function uc(a){if(a instanceof rc&&a.constructor===rc&&a.b===sc)return a.a;Aa("expected object of type SafeHtml, got '"+a+"' of type "+da(a));return"type_error:SafeHtml"}var sc={};function vc(a){var b=new rc;b.a=a;return b}vc("<!DOCTYPE html>");vc("");vc("<br>");function wc(a){var b=document;return m(a)?b.getElementById(a):a}function xc(a,b){Pa(b,function(b,d){b&&b.la&&(b=b.ja());"style"==d?a.style.cssText=b:"class"==d?a.className=b:"for"==d?a.htmlFor=b:yc.hasOwnProperty(d)?a.setAttribute(yc[d],b):0==d.lastIndexOf("aria-",0)||0==d.lastIndexOf("data-",0)?a.setAttribute(d,b):a[d]=b})}
	var yc={cellpadding:"cellPadding",cellspacing:"cellSpacing",colspan:"colSpan",frameborder:"frameBorder",height:"height",maxlength:"maxLength",nonce:"nonce",role:"role",rowspan:"rowSpan",type:"type",usemap:"useMap",valign:"vAlign",width:"width"};
	function zc(a,b,c){var d=arguments,e=document,f=String(d[0]),g=d[1];if(!$b&&g&&(g.name||g.type)){f=["<",f];g.name&&f.push(' name="',qa(g.name),'"');if(g.type){f.push(' type="',qa(g.type),'"');var l={};Wa(l,g);delete l.type;g=l}f.push(">");f=f.join("")}f=e.createElement(f);g&&(m(g)?f.className=g:fa(g)?f.className=g.join(" "):xc(f,g));2<d.length&&Ac(e,f,d);return f}
	function Ac(a,b,c){function d(c){c&&b.appendChild(m(c)?a.createTextNode(c):c)}for(var e=2;e<c.length;e++){var f=c[e];!ha(f)||q(f)&&0<f.nodeType?d(f):w(Bc(f)?La(f):f,d)}}function Bc(a){if(a&&"number"==typeof a.length){if(q(a))return"function"==typeof a.item||"string"==typeof a.item;if(p(a))return"function"==typeof a.item}return!1};function Cc(a){var b=[];Dc(new Ec,a,b);return b.join("")}function Ec(){}
	function Dc(a,b,c){if(null==b)c.push("null");else{if("object"==typeof b){if(fa(b)){var d=b;b=d.length;c.push("[");for(var e="",f=0;f<b;f++)c.push(e),Dc(a,d[f],c),e=",";c.push("]");return}if(b instanceof String||b instanceof Number||b instanceof Boolean)b=b.valueOf();else{c.push("{");e="";for(d in b)Object.prototype.hasOwnProperty.call(b,d)&&(f=b[d],"function"!=typeof f&&(c.push(e),Fc(d,c),c.push(":"),Dc(a,f,c),e=","));c.push("}");return}}switch(typeof b){case "string":Fc(b,c);break;case "number":c.push(isFinite(b)&&
	!isNaN(b)?String(b):"null");break;case "boolean":c.push(String(b));break;case "function":c.push("null");break;default:throw Error("Unknown type: "+typeof b);}}}var Gc={'"':'\\"',"\\":"\\\\","/":"\\/","\b":"\\b","\f":"\\f","\n":"\\n","\r":"\\r","\t":"\\t","\x0B":"\\u000b"},Hc=/\uffff/.test("\uffff")?/[\\\"\x00-\x1f\x7f-\uffff]/g:/[\\\"\x00-\x1f\x7f-\xff]/g;
	function Fc(a,b){b.push('"',a.replace(Hc,function(a){var b=Gc[a];b||(b="\\u"+(a.charCodeAt(0)|65536).toString(16).substr(1),Gc[a]=b);return b}),'"')};function Ic(){0!=Jc&&(Kc[this[ia]||(this[ia]=++ja)]=this);this.oa=this.oa;this.Fa=this.Fa}var Jc=0,Kc={};Ic.prototype.oa=!1;function Lc(a){a.oa||(a.oa=!0,a.ta(),0!=Jc&&(a=a[ia]||(a[ia]=++ja),delete Kc[a]))}Ic.prototype.ta=function(){if(this.Fa)for(;this.Fa.length;)this.Fa.shift()()};var Mc=Object.freeze||function(a){return a};var Nc=!y||9<=Number(kb),Oc=y&&!jb("9"),Pc=function(){if(!k.addEventListener||!Object.defineProperty)return!1;var a=!1,b=Object.defineProperty({},"passive",{get:function(){a=!0}});k.addEventListener("test",ca,b);k.removeEventListener("test",ca,b);return a}();function C(a,b){this.type=a;this.b=this.target=b;this.Bb=!0}C.prototype.c=function(){this.Bb=!1};function Qc(a,b){C.call(this,a?a.type:"");this.relatedTarget=this.b=this.target=null;this.button=this.screenY=this.screenX=this.clientY=this.clientX=0;this.key="";this.metaKey=this.shiftKey=this.altKey=this.ctrlKey=!1;this.pointerId=0;this.pointerType="";this.a=null;if(a){var c=this.type=a.type,d=a.changedTouches?a.changedTouches[0]:null;this.target=a.target||a.srcElement;this.b=b;if(b=a.relatedTarget){if(cb){a:{try{Xa(b.nodeName);var e=!0;break a}catch(f){}e=!1}e||(b=null)}}else"mouseover"==c?b=
	a.fromElement:"mouseout"==c&&(b=a.toElement);this.relatedTarget=b;null===d?(this.clientX=void 0!==a.clientX?a.clientX:a.pageX,this.clientY=void 0!==a.clientY?a.clientY:a.pageY,this.screenX=a.screenX||0,this.screenY=a.screenY||0):(this.clientX=void 0!==d.clientX?d.clientX:d.pageX,this.clientY=void 0!==d.clientY?d.clientY:d.pageY,this.screenX=d.screenX||0,this.screenY=d.screenY||0);this.button=a.button;this.key=a.key||"";this.ctrlKey=a.ctrlKey;this.altKey=a.altKey;this.shiftKey=a.shiftKey;this.metaKey=
	a.metaKey;this.pointerId=a.pointerId||0;this.pointerType=m(a.pointerType)?a.pointerType:Rc[a.pointerType]||"";this.a=a;a.defaultPrevented&&this.c()}}t(Qc,C);var Rc=Mc({2:"touch",3:"pen",4:"mouse"});Qc.prototype.c=function(){Qc.ib.c.call(this);var a=this.a;if(a.preventDefault)a.preventDefault();else if(a.returnValue=!1,Oc)try{if(a.ctrlKey||112<=a.keyCode&&123>=a.keyCode)a.keyCode=-1}catch(b){}};Qc.prototype.g=function(){return this.a};var Sc="closure_listenable_"+(1E6*Math.random()|0),Tc=0;function Uc(a,b,c,d,e){this.listener=a;this.a=null;this.src=b;this.type=c;this.capture=!!d;this.La=e;this.key=++Tc;this.ma=this.Ha=!1}function Vc(a){a.ma=!0;a.listener=null;a.a=null;a.src=null;a.La=null};function Wc(a){this.src=a;this.a={};this.b=0}function Xc(a,b,c,d,e,f){var g=b.toString();b=a.a[g];b||(b=a.a[g]=[],a.b++);var l=Yc(b,c,e,f);-1<l?(a=b[l],d||(a.Ha=!1)):(a=new Uc(c,a.src,g,!!e,f),a.Ha=d,b.push(a));return a}function Zc(a,b){var c=b.type;c in a.a&&Ia(a.a[c],b)&&(Vc(b),0==a.a[c].length&&(delete a.a[c],a.b--))}function Yc(a,b,c,d){for(var e=0;e<a.length;++e){var f=a[e];if(!f.ma&&f.listener==b&&f.capture==!!c&&f.La==d)return e}return-1};var $c="closure_lm_"+(1E6*Math.random()|0),ad={},bd=0;function cd(a,b,c,d,e){if(d&&d.once)dd(a,b,c,d,e);else if(fa(b))for(var f=0;f<b.length;f++)cd(a,b[f],c,d,e);else c=ed(c),a&&a[Sc]?fd(a,b,c,q(d)?!!d.capture:!!d,e):gd(a,b,c,!1,d,e)}
	function gd(a,b,c,d,e,f){if(!b)throw Error("Invalid event type");var g=q(e)?!!e.capture:!!e,l=hd(a);l||(a[$c]=l=new Wc(a));c=Xc(l,b,c,d,g,f);if(!c.a){d=id();c.a=d;d.src=a;d.listener=c;if(a.addEventListener)Pc||(e=g),void 0===e&&(e=!1),a.addEventListener(b.toString(),d,e);else if(a.attachEvent)a.attachEvent(jd(b.toString()),d);else throw Error("addEventListener and attachEvent are unavailable.");bd++}}
	function id(){var a=kd,b=Nc?function(c){return a.call(b.src,b.listener,c)}:function(c){c=a.call(b.src,b.listener,c);if(!c)return c};return b}function dd(a,b,c,d,e){if(fa(b))for(var f=0;f<b.length;f++)dd(a,b[f],c,d,e);else c=ed(c),a&&a[Sc]?ld(a,b,c,q(d)?!!d.capture:!!d,e):gd(a,b,c,!0,d,e)}
	function E(a,b,c,d,e){if(fa(b))for(var f=0;f<b.length;f++)E(a,b[f],c,d,e);else(d=q(d)?!!d.capture:!!d,c=ed(c),a&&a[Sc])?(a=a.u,b=String(b).toString(),b in a.a&&(f=a.a[b],c=Yc(f,c,d,e),-1<c&&(Vc(f[c]),Array.prototype.splice.call(f,c,1),0==f.length&&(delete a.a[b],a.b--)))):a&&(a=hd(a))&&(b=a.a[b.toString()],a=-1,b&&(a=Yc(b,c,d,e)),(c=-1<a?b[a]:null)&&md(c))}
	function md(a){if("number"!=typeof a&&a&&!a.ma){var b=a.src;if(b&&b[Sc])Zc(b.u,a);else{var c=a.type,d=a.a;b.removeEventListener?b.removeEventListener(c,d,a.capture):b.detachEvent&&b.detachEvent(jd(c),d);bd--;(c=hd(b))?(Zc(c,a),0==c.b&&(c.src=null,b[$c]=null)):Vc(a)}}}function jd(a){return a in ad?ad[a]:ad[a]="on"+a}function nd(a,b,c,d){var e=!0;if(a=hd(a))if(b=a.a[b.toString()])for(b=b.concat(),a=0;a<b.length;a++){var f=b[a];f&&f.capture==c&&!f.ma&&(f=od(f,d),e=e&&!1!==f)}return e}
	function od(a,b){var c=a.listener,d=a.La||a.src;a.Ha&&md(a);return c.call(d,b)}
	function kd(a,b){if(a.ma)return!0;if(!Nc){if(!b)a:{b=["window","event"];for(var c=k,d=0;d<b.length;d++)if(c=c[b[d]],null==c){b=null;break a}b=c}d=b;b=new Qc(d,this);c=!0;if(!(0>d.keyCode||void 0!=d.returnValue)){a:{var e=!1;if(0==d.keyCode)try{d.keyCode=-1;break a}catch(g){e=!0}if(e||void 0==d.returnValue)d.returnValue=!0}d=[];for(e=b.b;e;e=e.parentNode)d.push(e);a=a.type;for(e=d.length-1;0<=e;e--){b.b=d[e];var f=nd(d[e],a,!0,b);c=c&&f}for(e=0;e<d.length;e++)b.b=d[e],f=nd(d[e],a,!1,b),c=c&&f}return c}return od(a,
	new Qc(b,this))}function hd(a){a=a[$c];return a instanceof Wc?a:null}var pd="__closure_events_fn_"+(1E9*Math.random()>>>0);function ed(a){if(p(a))return a;a[pd]||(a[pd]=function(b){return a.handleEvent(b)});return a[pd]};function F(){Ic.call(this);this.u=new Wc(this);this.Ib=this;this.Ra=null}t(F,Ic);F.prototype[Sc]=!0;F.prototype.removeEventListener=function(a,b,c,d){E(this,a,b,c,d)};
	function G(a,b){var c,d=a.Ra;if(d)for(c=[];d;d=d.Ra)c.push(d);a=a.Ib;d=b.type||b;if(m(b))b=new C(b,a);else if(b instanceof C)b.target=b.target||a;else{var e=b;b=new C(d,a);Wa(b,e)}e=!0;if(c)for(var f=c.length-1;0<=f;f--){var g=b.b=c[f];e=qd(g,d,!0,b)&&e}g=b.b=a;e=qd(g,d,!0,b)&&e;e=qd(g,d,!1,b)&&e;if(c)for(f=0;f<c.length;f++)g=b.b=c[f],e=qd(g,d,!1,b)&&e}
	F.prototype.ta=function(){F.ib.ta.call(this);if(this.u){var a=this.u,b=0,c;for(c in a.a){for(var d=a.a[c],e=0;e<d.length;e++)++b,Vc(d[e]);delete a.a[c];a.b--}}this.Ra=null};function fd(a,b,c,d,e){Xc(a.u,String(b),c,!1,d,e)}function ld(a,b,c,d,e){Xc(a.u,String(b),c,!0,d,e)}function qd(a,b,c,d){b=a.u.a[String(b)];if(!b)return!0;b=b.concat();for(var e=!0,f=0;f<b.length;++f){var g=b[f];if(g&&!g.ma&&g.capture==c){var l=g.listener,n=g.La||g.src;g.Ha&&Zc(a.u,g);e=!1!==l.call(n,d)&&e}}return e&&0!=d.Bb};function rd(a,b,c){if(p(a))c&&(a=r(a,c));else if(a&&"function"==typeof a.handleEvent)a=r(a.handleEvent,a);else throw Error("Invalid listener argument");return 2147483647<Number(b)?-1:k.setTimeout(a,b||0)}function sd(a){var b=null;return(new z(function(c,d){b=rd(function(){c(void 0)},a);-1==b&&d(Error("Failed to schedule timer."))})).s(function(a){k.clearTimeout(b);throw a;})};function td(a,b,c,d,e){this.reset(a,b,c,d,e)}td.prototype.a=null;var ud=0;td.prototype.reset=function(a,b,c,d,e){"number"==typeof e||ud++;d||na();this.b=b;delete this.a};function vd(a){this.f=a;this.b=this.c=this.a=null}function wd(a,b){this.name=a;this.value=b}wd.prototype.toString=function(){return this.name};var xd=new wd("SEVERE",1E3),yd=new wd("CONFIG",700),zd=new wd("FINE",500);function Ad(a){if(a.c)return a.c;if(a.a)return Ad(a.a);Aa("Root logger has no level set.");return null}
	vd.prototype.log=function(a,b,c){if(a.value>=Ad(this).value)for(p(b)&&(b=b()),a=new td(a,String(b),this.f),c&&(a.a=c),c="log:"+a.b,(a=k.console)&&a.timeStamp&&a.timeStamp(c),(a=k.msWriteProfilerMark)&&a(c),c=this;c;)c=c.a};var Bd={},Cd=null;function Dd(a){Cd||(Cd=new vd(""),Bd[""]=Cd,Cd.c=yd);var b;if(!(b=Bd[a])){b=new vd(a);var c=a.lastIndexOf("."),d=a.substr(c+1);c=Dd(a.substr(0,c));c.b||(c.b={});c.b[d]=b;b.a=c;Bd[a]=b}return b};function Ed(a,b){this.b={};this.a=[];this.c=0;var c=arguments.length;if(1<c){if(c%2)throw Error("Uneven number of arguments");for(var d=0;d<c;d+=2)this.set(arguments[d],arguments[d+1])}else if(a){a instanceof Ed?(c=a.S(),d=a.P()):(c=Ra(a),d=Qa(a));for(var e=0;e<c.length;e++)this.set(c[e],d[e])}}h=Ed.prototype;h.P=function(){Fd(this);for(var a=[],b=0;b<this.a.length;b++)a.push(this.b[this.a[b]]);return a};h.S=function(){Fd(this);return this.a.concat()};
	h.clear=function(){this.b={};this.c=this.a.length=0};function Fd(a){if(a.c!=a.a.length){for(var b=0,c=0;b<a.a.length;){var d=a.a[b];Gd(a.b,d)&&(a.a[c++]=d);b++}a.a.length=c}if(a.c!=a.a.length){var e={};for(c=b=0;b<a.a.length;)d=a.a[b],Gd(e,d)||(a.a[c++]=d,e[d]=1),b++;a.a.length=c}}h.get=function(a,b){return Gd(this.b,a)?this.b[a]:b};h.set=function(a,b){Gd(this.b,a)||(this.c++,this.a.push(a));this.b[a]=b};
	h.forEach=function(a,b){for(var c=this.S(),d=0;d<c.length;d++){var e=c[d],f=this.get(e);a.call(b,f,e,this)}};function Gd(a,b){return Object.prototype.hasOwnProperty.call(a,b)};function H(a,b){a&&a.log(zd,b,void 0)};function Id(a){return Da(a,function(a){a=a.toString(16);return 1<a.length?a:"0"+a}).join("")};var Jd=null,Kd=null;function Ld(a){var b="";Md(a,function(a){b+=String.fromCharCode(a)});return b}function Md(a,b){function c(b){for(;d<a.length;){var c=a.charAt(d++),e=Kd[c];if(null!=e)return e;if(!/^[\s\xa0]*$/.test(c))throw Error("Unknown base64 encoding at char: "+c);}return b}Nd();for(var d=0;;){var e=c(-1),f=c(0),g=c(64),l=c(64);if(64===l&&-1===e)break;b(e<<2|f>>4);64!=g&&(b(f<<4&240|g>>2),64!=l&&b(g<<6&192|l))}}
	function Nd(){if(!Jd){Jd={};Kd={};for(var a=0;65>a;a++)Jd[a]="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=".charAt(a),Kd[Jd[a]]=a,62<=a&&(Kd["ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_.".charAt(a)]=a)}};/*
	 Portions of this code are from MochiKit, received by
	 The Closure Authors under the MIT license. All other code is Copyright
	 2005-2009 The Closure Authors. All Rights Reserved.
	*/
	function Od(a,b){this.g=[];this.v=a;this.o=b||null;this.f=this.a=!1;this.c=void 0;this.u=this.w=this.i=!1;this.h=0;this.b=null;this.l=0}Od.prototype.cancel=function(a){if(this.a)this.c instanceof Od&&this.c.cancel();else{if(this.b){var b=this.b;delete this.b;a?b.cancel(a):(b.l--,0>=b.l&&b.cancel())}this.v?this.v.call(this.o,this):this.u=!0;this.a||(a=new Pd,Qd(this),Rd(this,!1,a))}};Od.prototype.m=function(a,b){this.i=!1;Rd(this,a,b)};function Rd(a,b,c){a.a=!0;a.c=c;a.f=!b;Sd(a)}
	function Qd(a){if(a.a){if(!a.u)throw new Td;a.u=!1}}Od.prototype.A=function(a){Qd(this);Rd(this,!0,a)};function Ud(a,b){Vd(a,null,b,void 0)}function Vd(a,b,c,d){a.g.push([b,c,d]);a.a&&Sd(a)}Od.prototype.then=function(a,b,c){var d,e,f=new z(function(a,b){d=a;e=b});Vd(this,d,function(a){a instanceof Pd?f.cancel():e(a)});return f.then(a,b,c)};mb(Od);function Wd(a){return Ea(a.g,function(a){return p(a[1])})}
	function Sd(a){if(a.h&&a.a&&Wd(a)){var b=a.h,c=Xd[b];c&&(k.clearTimeout(c.a),delete Xd[b]);a.h=0}a.b&&(a.b.l--,delete a.b);b=a.c;for(var d=c=!1;a.g.length&&!a.i;){var e=a.g.shift(),f=e[0],g=e[1];e=e[2];if(f=a.f?g:f)try{var l=f.call(e||a.o,b);void 0!==l&&(a.f=a.f&&(l==b||l instanceof Error),a.c=b=l);if(nb(b)||"function"===typeof k.Promise&&b instanceof k.Promise)d=!0,a.i=!0}catch(n){b=n,a.f=!0,Wd(a)||(c=!0)}}a.c=b;d&&(l=r(a.m,a,!0),d=r(a.m,a,!1),b instanceof Od?(Vd(b,l,d),b.w=!0):b.then(l,d));c&&(b=
	new Yd(b),Xd[b.a]=b,a.h=b.a)}function Td(){u.call(this)}t(Td,u);Td.prototype.message="Deferred has already fired";Td.prototype.name="AlreadyCalledError";function Pd(){u.call(this)}t(Pd,u);Pd.prototype.message="Deferred was canceled";Pd.prototype.name="CanceledError";function Yd(a){this.a=k.setTimeout(r(this.c,this),0);this.b=a}Yd.prototype.c=function(){delete Xd[this.a];throw this.b;};var Xd={};function Zd(){this.b=-1};function $d(a,b){this.b=-1;this.b=ae;this.f=k.Uint8Array?new Uint8Array(this.b):Array(this.b);this.g=this.c=0;this.a=[];this.i=a;this.h=b;this.l=k.Int32Array?new Int32Array(64):Array(64);be||(k.Int32Array?be=new Int32Array(ce):be=ce);this.reset()}var be;t($d,Zd);for(var ae=64,de=ae-1,ee=[],fe=0;fe<de;fe++)ee[fe]=0;var ge=Ka(128,ee);$d.prototype.reset=function(){this.g=this.c=0;this.a=k.Int32Array?new Int32Array(this.h):La(this.h)};
	function he(a){for(var b=a.f,c=a.l,d=0,e=0;e<b.length;)c[d++]=b[e]<<24|b[e+1]<<16|b[e+2]<<8|b[e+3],e=4*d;for(b=16;64>b;b++){e=c[b-15]|0;d=c[b-2]|0;var f=(c[b-16]|0)+((e>>>7|e<<25)^(e>>>18|e<<14)^e>>>3)|0,g=(c[b-7]|0)+((d>>>17|d<<15)^(d>>>19|d<<13)^d>>>10)|0;c[b]=f+g|0}d=a.a[0]|0;e=a.a[1]|0;var l=a.a[2]|0,n=a.a[3]|0,D=a.a[4]|0,vb=a.a[5]|0,tc=a.a[6]|0;f=a.a[7]|0;for(b=0;64>b;b++){var Hd=((d>>>2|d<<30)^(d>>>13|d<<19)^(d>>>22|d<<10))+(d&e^d&l^e&l)|0;g=D&vb^~D&tc;f=f+((D>>>6|D<<26)^(D>>>11|D<<21)^(D>>>
	25|D<<7))|0;g=g+(be[b]|0)|0;g=f+(g+(c[b]|0)|0)|0;f=tc;tc=vb;vb=D;D=n+g|0;n=l;l=e;e=d;d=g+Hd|0}a.a[0]=a.a[0]+d|0;a.a[1]=a.a[1]+e|0;a.a[2]=a.a[2]+l|0;a.a[3]=a.a[3]+n|0;a.a[4]=a.a[4]+D|0;a.a[5]=a.a[5]+vb|0;a.a[6]=a.a[6]+tc|0;a.a[7]=a.a[7]+f|0}
	function ie(a,b,c){void 0===c&&(c=b.length);var d=0,e=a.c;if(m(b))for(;d<c;)a.f[e++]=b.charCodeAt(d++),e==a.b&&(he(a),e=0);else if(ha(b))for(;d<c;){var f=b[d++];if(!("number"==typeof f&&0<=f&&255>=f&&f==(f|0)))throw Error("message must be a byte array");a.f[e++]=f;e==a.b&&(he(a),e=0)}else throw Error("message must be string or array");a.c=e;a.g+=c}
	var ce=[1116352408,1899447441,3049323471,3921009573,961987163,1508970993,2453635748,2870763221,3624381080,310598401,607225278,1426881987,1925078388,2162078206,2614888103,3248222580,3835390401,4022224774,264347078,604807628,770255983,1249150122,1555081692,1996064986,2554220882,2821834349,2952996808,3210313671,3336571891,3584528711,113926993,338241895,666307205,773529912,1294757372,1396182291,1695183700,1986661051,2177026350,2456956037,2730485921,2820302411,3259730800,3345764771,3516065817,3600352804,
	4094571909,275423344,430227734,506948616,659060556,883997877,958139571,1322822218,1537002063,1747873779,1955562222,2024104815,2227730452,2361852424,2428436474,2756734187,3204031479,3329325298];function je(){$d.call(this,8,ke)}t(je,$d);var ke=[1779033703,3144134277,1013904242,2773480762,1359893119,2600822924,528734635,1541459225];function le(a){if(a.P&&"function"==typeof a.P)return a.P();if(m(a))return a.split("");if(ha(a)){for(var b=[],c=a.length,d=0;d<c;d++)b.push(a[d]);return b}return Qa(a)}function me(a){if(a.S&&"function"==typeof a.S)return a.S();if(!a.P||"function"!=typeof a.P){if(ha(a)||m(a)){var b=[];a=a.length;for(var c=0;c<a;c++)b.push(c);return b}return Ra(a)}}
	function ne(a,b){if(a.forEach&&"function"==typeof a.forEach)a.forEach(b,void 0);else if(ha(a)||m(a))w(a,b,void 0);else for(var c=me(a),d=le(a),e=d.length,f=0;f<e;f++)b.call(void 0,d[f],c&&c[f],a)};var oe=/^(?:([^:/?#.]+):)?(?:\/\/(?:([^/?#]*)@)?([^/#?]*?)(?::([0-9]+))?(?=[/#?]|$))?([^?#]+)?(?:\?([^#]*))?(?:#([\s\S]*))?$/;function pe(a,b){if(a){a=a.split("&");for(var c=0;c<a.length;c++){var d=a[c].indexOf("="),e=null;if(0<=d){var f=a[c].substring(0,d);e=a[c].substring(d+1)}else f=a[c];b(f,e?decodeURIComponent(e.replace(/\+/g," ")):"")}}};function qe(a,b){this.b=this.l=this.c="";this.i=null;this.h=this.g="";this.f=!1;if(a instanceof qe){this.f=void 0!==b?b:a.f;re(this,a.c);this.l=a.l;this.b=a.b;se(this,a.i);this.g=a.g;b=a.a;var c=new te;c.c=b.c;b.a&&(c.a=new Ed(b.a),c.b=b.b);ue(this,c);this.h=a.h}else a&&(c=String(a).match(oe))?(this.f=!!b,re(this,c[1]||"",!0),this.l=ve(c[2]||""),this.b=ve(c[3]||"",!0),se(this,c[4]),this.g=ve(c[5]||"",!0),ue(this,c[6]||"",!0),this.h=ve(c[7]||"")):(this.f=!!b,this.a=new te(null,0,this.f))}
	qe.prototype.toString=function(){var a=[],b=this.c;b&&a.push(we(b,xe,!0),":");var c=this.b;if(c||"file"==b)a.push("//"),(b=this.l)&&a.push(we(b,xe,!0),"@"),a.push(encodeURIComponent(String(c)).replace(/%25([0-9a-fA-F]{2})/g,"%$1")),c=this.i,null!=c&&a.push(":",String(c));if(c=this.g)this.b&&"/"!=c.charAt(0)&&a.push("/"),a.push(we(c,"/"==c.charAt(0)?ye:ze,!0));(c=this.a.toString())&&a.push("?",c);(c=this.h)&&a.push("#",we(c,Ae));return a.join("")};
	function re(a,b,c){a.c=c?ve(b,!0):b;a.c&&(a.c=a.c.replace(/:$/,""))}function se(a,b){if(b){b=Number(b);if(isNaN(b)||0>b)throw Error("Bad port number "+b);a.i=b}else a.i=null}function ue(a,b,c){b instanceof te?(a.a=b,Be(a.a,a.f)):(c||(b=we(b,Ce)),a.a=new te(b,0,a.f))}function I(a,b,c){a.a.set(b,c)}function De(a,b){return a.a.get(b)}function Ee(a){return a instanceof qe?new qe(a):new qe(a,void 0)}function Fe(a,b){var c=new qe(null,void 0);re(c,"https");a&&(c.b=a);b&&(c.g=b);return c}
	function ve(a,b){return a?b?decodeURI(a.replace(/%25/g,"%2525")):decodeURIComponent(a):""}function we(a,b,c){return m(a)?(a=encodeURI(a).replace(b,Ge),c&&(a=a.replace(/%25([0-9a-fA-F]{2})/g,"%$1")),a):null}function Ge(a){a=a.charCodeAt(0);return"%"+(a>>4&15).toString(16)+(a&15).toString(16)}var xe=/[#\/\?@]/g,ze=/[\#\?:]/g,ye=/[\#\?]/g,Ce=/[\#\?@]/g,Ae=/#/g;function te(a,b,c){this.b=this.a=null;this.c=a||null;this.f=!!c}
	function He(a){a.a||(a.a=new Ed,a.b=0,a.c&&pe(a.c,function(b,c){Ie(a,decodeURIComponent(b.replace(/\+/g," ")),c)}))}function Je(a){var b=me(a);if("undefined"==typeof b)throw Error("Keys are undefined");var c=new te(null,0,void 0);a=le(a);for(var d=0;d<b.length;d++){var e=b[d],f=a[d];fa(f)?Ke(c,e,f):Ie(c,e,f)}return c}function Ie(a,b,c){He(a);a.c=null;b=Le(a,b);var d=a.a.get(b);d||a.a.set(b,d=[]);d.push(c);a.b+=1}
	function Me(a,b){He(a);b=Le(a,b);Gd(a.a.b,b)&&(a.c=null,a.b-=a.a.get(b).length,a=a.a,Gd(a.b,b)&&(delete a.b[b],a.c--,a.a.length>2*a.c&&Fd(a)))}h=te.prototype;h.clear=function(){this.a=this.c=null;this.b=0};function Ne(a,b){He(a);b=Le(a,b);return Gd(a.a.b,b)}h.forEach=function(a,b){He(this);this.a.forEach(function(c,d){w(c,function(c){a.call(b,c,d,this)},this)},this)};h.S=function(){He(this);for(var a=this.a.P(),b=this.a.S(),c=[],d=0;d<b.length;d++)for(var e=a[d],f=0;f<e.length;f++)c.push(b[d]);return c};
	h.P=function(a){He(this);var b=[];if(m(a))Ne(this,a)&&(b=Ka(b,this.a.get(Le(this,a))));else{a=this.a.P();for(var c=0;c<a.length;c++)b=Ka(b,a[c])}return b};h.set=function(a,b){He(this);this.c=null;a=Le(this,a);Ne(this,a)&&(this.b-=this.a.get(a).length);this.a.set(a,[b]);this.b+=1;return this};h.get=function(a,b){a=a?this.P(a):[];return 0<a.length?String(a[0]):b};function Ke(a,b,c){Me(a,b);0<c.length&&(a.c=null,a.a.set(Le(a,b),La(c)),a.b+=c.length)}
	h.toString=function(){if(this.c)return this.c;if(!this.a)return"";for(var a=[],b=this.a.S(),c=0;c<b.length;c++){var d=b[c],e=encodeURIComponent(String(d));d=this.P(d);for(var f=0;f<d.length;f++){var g=e;""!==d[f]&&(g+="="+encodeURIComponent(String(d[f])));a.push(g)}}return this.c=a.join("&")};function Le(a,b){b=String(b);a.f&&(b=b.toLowerCase());return b}function Be(a,b){b&&!a.f&&(He(a),a.c=null,a.a.forEach(function(a,b){var c=b.toLowerCase();b!=c&&(Me(this,b),Ke(this,c,a))},a));a.f=b};function Oe(){}Oe.prototype.c=null;function Pe(a){return a.c||(a.c=a.b())};var Qe;function Re(){}t(Re,Oe);Re.prototype.a=function(){var a=Se(this);return a?new ActiveXObject(a):new XMLHttpRequest};Re.prototype.b=function(){var a={};Se(this)&&(a[0]=!0,a[1]=!0);return a};
	function Se(a){if(!a.f&&"undefined"==typeof XMLHttpRequest&&"undefined"!=typeof ActiveXObject){for(var b=["MSXML2.XMLHTTP.6.0","MSXML2.XMLHTTP.3.0","MSXML2.XMLHTTP","Microsoft.XMLHTTP"],c=0;c<b.length;c++){var d=b[c];try{return new ActiveXObject(d),a.f=d}catch(e){}}throw Error("Could not create ActiveXObject. ActiveX might be disabled, or MSXML might not be installed");}return a.f}Qe=new Re;function Te(a){F.call(this);this.headers=new Ed;this.w=a||null;this.b=!1;this.v=this.a=null;this.g=this.I=this.i="";this.c=this.G=this.h=this.A=!1;this.f=0;this.m=null;this.l=Ue;this.o=this.N=!1}t(Te,F);var Ue="",Ve=Te.prototype,We=Dd("goog.net.XhrIo");Ve.J=We;var Xe=/^https?$/i,Ye=["POST","PUT"];
	function Ze(a,b,c,d,e){if(a.a)throw Error("[goog.net.XhrIo] Object is active with another request="+a.i+"; newUri="+b);c=c?c.toUpperCase():"GET";a.i=b;a.g="";a.I=c;a.A=!1;a.b=!0;a.a=a.w?a.w.a():Qe.a();a.v=a.w?Pe(a.w):Pe(Qe);a.a.onreadystatechange=r(a.Ab,a);try{H(a.J,$e(a,"Opening Xhr")),a.G=!0,a.a.open(c,String(b),!0),a.G=!1}catch(g){H(a.J,$e(a,"Error opening Xhr: "+g.message));af(a,g);return}b=d||"";var f=new Ed(a.headers);e&&ne(e,function(a,b){f.set(b,a)});e=Fa(f.S());d=k.FormData&&b instanceof
	k.FormData;!Ha(Ye,c)||e||d||f.set("Content-Type","application/x-www-form-urlencoded;charset=utf-8");f.forEach(function(a,b){this.a.setRequestHeader(b,a)},a);a.l&&(a.a.responseType=a.l);"withCredentials"in a.a&&a.a.withCredentials!==a.N&&(a.a.withCredentials=a.N);try{bf(a),0<a.f&&(a.o=cf(a.a),H(a.J,$e(a,"Will abort after "+a.f+"ms if incomplete, xhr2 "+a.o)),a.o?(a.a.timeout=a.f,a.a.ontimeout=r(a.Ea,a)):a.m=rd(a.Ea,a.f,a)),H(a.J,$e(a,"Sending request")),a.h=!0,a.a.send(b),a.h=!1}catch(g){H(a.J,$e(a,
	"Send error: "+g.message)),af(a,g)}}function cf(a){return y&&jb(9)&&"number"==typeof a.timeout&&void 0!==a.ontimeout}function Ga(a){return"content-type"==a.toLowerCase()}h=Te.prototype;h.Ea=function(){"undefined"!=typeof aa&&this.a&&(this.g="Timed out after "+this.f+"ms, aborting",H(this.J,$e(this,this.g)),G(this,"timeout"),this.abort(8))};function af(a,b){a.b=!1;a.a&&(a.c=!0,a.a.abort(),a.c=!1);a.g=b;df(a);ef(a)}function df(a){a.A||(a.A=!0,G(a,"complete"),G(a,"error"))}
	h.abort=function(){this.a&&this.b&&(H(this.J,$e(this,"Aborting")),this.b=!1,this.c=!0,this.a.abort(),this.c=!1,G(this,"complete"),G(this,"abort"),ef(this))};h.ta=function(){this.a&&(this.b&&(this.b=!1,this.c=!0,this.a.abort(),this.c=!1),ef(this,!0));Te.ib.ta.call(this)};h.Ab=function(){this.oa||(this.G||this.h||this.c?ff(this):this.jc())};h.jc=function(){ff(this)};
	function ff(a){if(a.b&&"undefined"!=typeof aa)if(a.v[1]&&4==gf(a)&&2==hf(a))H(a.J,$e(a,"Local request error detected and ignored"));else if(a.h&&4==gf(a))rd(a.Ab,0,a);else if(G(a,"readystatechange"),4==gf(a)){H(a.J,$e(a,"Request complete"));a.b=!1;try{var b=hf(a);a:switch(b){case 200:case 201:case 202:case 204:case 206:case 304:case 1223:var c=!0;break a;default:c=!1}var d;if(!(d=c)){var e;if(e=0===b){var f=String(a.i).match(oe)[1]||null;if(!f&&k.self&&k.self.location){var g=k.self.location.protocol;
	f=g.substr(0,g.length-1)}e=!Xe.test(f?f.toLowerCase():"")}d=e}if(d)G(a,"complete"),G(a,"success");else{try{var l=2<gf(a)?a.a.statusText:""}catch(n){H(a.J,"Can not get status: "+n.message),l=""}a.g=l+" ["+hf(a)+"]";df(a)}}finally{ef(a)}}}function ef(a,b){if(a.a){bf(a);var c=a.a,d=a.v[0]?ca:null;a.a=null;a.v=null;b||G(a,"ready");try{c.onreadystatechange=d}catch(e){(a=a.J)&&a.log(xd,"Problem encountered resetting onreadystatechange: "+e.message,void 0)}}}
	function bf(a){a.a&&a.o&&(a.a.ontimeout=null);"number"==typeof a.m&&(k.clearTimeout(a.m),a.m=null)}function gf(a){return a.a?a.a.readyState:0}function hf(a){try{return 2<gf(a)?a.a.status:-1}catch(b){return-1}}function jf(a){try{return a.a?a.a.responseText:""}catch(b){return H(a.J,"Can not get responseText: "+b.message),""}}
	h.getResponse=function(){try{if(!this.a)return null;if("response"in this.a)return this.a.response;switch(this.l){case Ue:case "text":return this.a.responseText;case "arraybuffer":if("mozResponseArrayBuffer"in this.a)return this.a.mozResponseArrayBuffer}var a=this.J;a&&a.log(xd,"Response type "+this.l+" is not supported on this browser",void 0);return null}catch(b){return H(this.J,"Can not get response: "+b.message),null}};function $e(a,b){return b+" ["+a.I+" "+a.i+" "+hf(a)+"]"};var kf=/^[+a-zA-Z0-9_.!#$%&'*\/=?^`{|}~-]+@([a-zA-Z0-9-]+\.)+[a-zA-Z0-9]{2,63}$/;function lf(a){var b={},c=b.document||document,d=gc(a),e=document.createElement("SCRIPT"),f={Cb:e,Ea:void 0},g=new Od(mf,f),l=null,n=null!=b.timeout?b.timeout:5E3;0<n&&(l=window.setTimeout(function(){nf(e,!0);var a=new of(pf,"Timeout reached for loading script "+d);Qd(g);Rd(g,!1,a)},n),f.Ea=l);e.onload=e.onreadystatechange=function(){e.readyState&&"loaded"!=e.readyState&&"complete"!=e.readyState||(nf(e,b.Sc||!1,l),g.A(null))};e.onerror=function(){nf(e,!0,l);var a=new of(qf,"Error while loading script "+
	d);Qd(g);Rd(g,!1,a)};f=b.attributes||{};Wa(f,{type:"text/javascript",charset:"UTF-8"});xc(e,f);e.src=gc(a);rf(c).appendChild(e);return g}function rf(a){var b;return(b=(a||document).getElementsByTagName("HEAD"))&&0!=b.length?b[0]:a.documentElement}function mf(){if(this&&this.Cb){var a=this.Cb;a&&"SCRIPT"==a.tagName&&nf(a,!0,this.Ea)}}
	function nf(a,b,c){null!=c&&k.clearTimeout(c);a.onload=ca;a.onerror=ca;a.onreadystatechange=ca;b&&window.setTimeout(function(){a&&a.parentNode&&a.parentNode.removeChild(a)},0)}var qf=0,pf=1;function of(a,b){var c="Jsloader error (code #"+a+")";b&&(c+=": "+b);u.call(this,c);this.code=a}t(of,u);function sf(){}t(sf,Oe);sf.prototype.a=function(){var a=new XMLHttpRequest;if("withCredentials"in a)return a;if("undefined"!=typeof XDomainRequest)return new tf;throw Error("Unsupported browser");};sf.prototype.b=function(){return{}};
	function tf(){this.a=new XDomainRequest;this.readyState=0;this.onreadystatechange=null;this.responseText="";this.status=-1;this.statusText=this.responseXML=null;this.a.onload=r(this.Wb,this);this.a.onerror=r(this.xb,this);this.a.onprogress=r(this.Xb,this);this.a.ontimeout=r(this.Yb,this)}h=tf.prototype;h.open=function(a,b,c){if(null!=c&&!c)throw Error("Only async requests are supported.");this.a.open(a,b)};
	h.send=function(a){if(a)if("string"==typeof a)this.a.send(a);else throw Error("Only string data is supported");else this.a.send()};h.abort=function(){this.a.abort()};h.setRequestHeader=function(){};h.getResponseHeader=function(a){return"content-type"==a.toLowerCase()?this.a.contentType:""};h.Wb=function(){this.status=200;this.responseText=this.a.responseText;uf(this,4)};h.xb=function(){this.status=500;this.responseText="";uf(this,4)};h.Yb=function(){this.xb()};
	h.Xb=function(){this.status=200;uf(this,1)};function uf(a,b){a.readyState=b;if(a.onreadystatechange)a.onreadystatechange()}h.getAllResponseHeaders=function(){return"content-type: "+this.a.contentType};function vf(){var a=J();return y&&!!kb&&11==kb||/Edge\/\d+/.test(a)}function wf(){return k.window&&k.window.location.href||""}function xf(a,b){b=b||k.window;var c="about:blank";a&&(c=nc(pc(a)));b.location.href=c}function yf(a,b){var c=[],d;for(d in a)d in b?typeof a[d]!=typeof b[d]?c.push(d):fa(a[d])?Ta(a[d],b[d])||c.push(d):"object"==typeof a[d]&&null!=a[d]&&null!=b[d]?0<yf(a[d],b[d]).length&&c.push(d):a[d]!==b[d]&&c.push(d):c.push(d);for(d in b)d in a||c.push(d);return c}
	function zf(){var a=J();a=Af(a)!=Bf?null:(a=a.match(/\sChrome\/(\d+)/i))&&2==a.length?parseInt(a[1],10):null;return a&&30>a?!1:!y||!kb||9<kb}function Cf(a){a=(a||J()).toLowerCase();return a.match(/android/)||a.match(/webos/)||a.match(/iphone|ipad|ipod/)||a.match(/blackberry/)||a.match(/windows phone/)||a.match(/iemobile/)?!0:!1}function Df(a){a=a||k.window;try{a.close()}catch(b){}}
	function Ef(a,b,c){var d=Math.floor(1E9*Math.random()).toString();b=b||500;c=c||600;var e=(window.screen.availHeight-c)/2,f=(window.screen.availWidth-b)/2;b={width:b,height:c,top:0<e?e:0,left:0<f?f:0,location:!0,resizable:!0,statusbar:!0,toolbar:!1};c=J().toLowerCase();d&&(b.target=d,v(c,"crios/")&&(b.target="_blank"));Af(J())==Ff&&(a=a||"http://localhost",b.scrollbars=!0);c=a||"";(d=b)||(d={});a=window;b=c instanceof lc?c:pc("undefined"!=typeof c.href?c.href:String(c));c=d.target||c.target;e=[];
	for(g in d)switch(g){case "width":case "height":case "top":case "left":e.push(g+"="+d[g]);break;case "target":case "noreferrer":break;default:e.push(g+"="+(d[g]?1:0))}var g=e.join(",");(x("iPhone")&&!x("iPod")&&!x("iPad")||x("iPad")||x("iPod"))&&a.navigator&&a.navigator.standalone&&c&&"_self"!=c?(g=a.document.createElement("A"),b instanceof lc||b instanceof lc||(b=b.la?b.ja():String(b),oc.test(b)||(b="about:invalid#zClosurez"),b=qc(b)),g.href=nc(b),g.setAttribute("target",c),d.noreferrer&&g.setAttribute("rel",
	"noreferrer"),d=document.createEvent("MouseEvent"),d.initMouseEvent("click",!0,!0,a,1),g.dispatchEvent(d),g={}):d.noreferrer?(g=a.open("",c,g),a=nc(b),g&&(bb&&v(a,";")&&(a="'"+a.replace(/'/g,"%27")+"'"),g.opener=null,dc("b/12014412, meta tag with sanitized URL"),a='<META HTTP-EQUIV="refresh" content="0; url='+qa(a)+'">',a=vc(a),g.document.write(uc(a)),g.document.close())):g=a.open(nc(b),c,g);if(g)try{g.focus()}catch(l){}return g}
	function Gf(a){return new z(function(b){function c(){sd(2E3).then(function(){if(!a||a.closed)b();else return c()})}return c()})}var Hf=/^\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}$/;function If(){var a=null;return(new z(function(b){"complete"==k.document.readyState?b():(a=function(){b()},dd(window,"load",a))})).s(function(b){E(window,"load",a);throw b;})}
	function Jf(){return Kf(void 0)?If().then(function(){return new z(function(a,b){var c=k.document,d=setTimeout(function(){b(Error("Cordova framework is not ready."))},1E3);c.addEventListener("deviceready",function(){clearTimeout(d);a()},!1)})}):B(Error("Cordova must run in an Android or iOS file scheme."))}function Kf(a){a=a||J();return!("file:"!==Lf()||!a.toLowerCase().match(/iphone|ipad|ipod|android/))}function Mf(){var a=k.window;try{return!(!a||a==a.top)}catch(b){return!1}}
	function K(){return firebase.INTERNAL.hasOwnProperty("reactNative")?"ReactNative":firebase.INTERNAL.hasOwnProperty("node")?"Node":"Browser"}function Nf(){var a=K();return"ReactNative"===a||"Node"===a}var Ff="Firefox",Bf="Chrome";
	function Af(a){var b=a.toLowerCase();if(v(b,"opera/")||v(b,"opr/")||v(b,"opios/"))return"Opera";if(v(b,"iemobile"))return"IEMobile";if(v(b,"msie")||v(b,"trident/"))return"IE";if(v(b,"edge/"))return"Edge";if(v(b,"firefox/"))return Ff;if(v(b,"silk/"))return"Silk";if(v(b,"blackberry"))return"Blackberry";if(v(b,"webos"))return"Webos";if(!v(b,"safari/")||v(b,"chrome/")||v(b,"crios/")||v(b,"android"))if(!v(b,"chrome/")&&!v(b,"crios/")||v(b,"edge/")){if(v(b,"android"))return"Android";if((a=a.match(/([a-zA-Z\d\.]+)\/[a-zA-Z\d\.]*$/))&&
	2==a.length)return a[1]}else return Bf;else return"Safari";return"Other"}var Of={Gc:"FirebaseCore-web",Ic:"FirebaseUI-web"};function Pf(a,b){b=b||[];var c=[],d={},e;for(e in Of)d[Of[e]]=!0;for(e=0;e<b.length;e++)"undefined"!==typeof d[b[e]]&&(delete d[b[e]],c.push(b[e]));c.sort();b=c;b.length||(b=["FirebaseCore-web"]);c=K();d="";"Browser"===c?d=Af(J()):d=c;return d+"/JsCore/"+a+"/"+b.join(",")}function J(){return k.navigator&&k.navigator.userAgent||""}
	function L(a,b){a=a.split(".");b=b||k;for(var c=0;c<a.length&&"object"==typeof b&&null!=b;c++)b=b[a[c]];c!=a.length&&(b=void 0);return b}function Qf(){try{var a=k.localStorage,b=Rf();if(a)return a.setItem(b,"1"),a.removeItem(b),vf()?!!k.indexedDB:!0}catch(c){}return!1}function Sf(){return(Tf()||"chrome-extension:"===Lf()||Kf())&&!Nf()&&Qf()}function Tf(){return"http:"===Lf()||"https:"===Lf()}function Lf(){return k.location&&k.location.protocol||null}
	function Uf(a){a=a||J();return Cf(a)||Af(a)==Ff?!1:!0}function Vf(a){return"undefined"===typeof a?null:Cc(a)}function Wf(a){var b={},c;for(c in a)a.hasOwnProperty(c)&&null!==a[c]&&void 0!==a[c]&&(b[c]=a[c]);return b}function Xf(a){if(null!==a)return JSON.parse(a)}function Rf(a){return a?a:""+Math.floor(1E9*Math.random()).toString()}function Yf(a){a=a||J();return"Safari"==Af(a)||a.toLowerCase().match(/iphone|ipad|ipod/)?!1:!0}
	function Zf(){var a=k.___jsl;if(a&&a.H)for(var b in a.H)if(a.H[b].r=a.H[b].r||[],a.H[b].L=a.H[b].L||[],a.H[b].r=a.H[b].L.concat(),a.CP)for(var c=0;c<a.CP.length;c++)a.CP[c]=null}function $f(){var a=k.navigator;return a&&"boolean"===typeof a.onLine&&(Tf()||"chrome-extension:"===Lf()||"undefined"!==typeof a.connection)?a.onLine:!0}function ag(a,b,c,d){if(a>b)throw Error("Short delay should be less than long delay!");this.c=a;this.b=b;a=c||J();d=d||K();this.a=Cf(a)||"ReactNative"===d}
	ag.prototype.get=function(){return this.a?this.b:this.c};function bg(){var a=k.document;return a&&"undefined"!==typeof a.visibilityState?"visible"==a.visibilityState:!0}function cg(){var a=k.document,b=null;return bg()||!a?A():(new z(function(c){b=function(){bg()&&(a.removeEventListener("visibilitychange",b,!1),c())};a.addEventListener("visibilitychange",b,!1)})).s(function(c){a.removeEventListener("visibilitychange",b,!1);throw c;})}
	function dg(a){try{var b=new Date(parseInt(a,10));if(!isNaN(b.getTime())&&!/[^0-9]/.test(a))return b.toUTCString()}catch(c){}return null};var eg={};var fg;try{var gg={};Object.defineProperty(gg,"abcd",{configurable:!0,enumerable:!0,value:1});Object.defineProperty(gg,"abcd",{configurable:!0,enumerable:!0,value:2});fg=2==gg.abcd}catch(a){fg=!1}function M(a,b,c){fg?Object.defineProperty(a,b,{configurable:!0,enumerable:!0,value:c}):a[b]=c}function hg(a,b){if(b)for(var c in b)b.hasOwnProperty(c)&&M(a,c,b[c])}function ig(a){var b={};hg(b,a);return b}function jg(a){var b={},c;for(c in a)a.hasOwnProperty(c)&&(b[c]=a[c]);return b}
	function kg(a,b){if(!b||!b.length)return!0;if(!a)return!1;for(var c=0;c<b.length;c++){var d=a[b[c]];if(void 0===d||null===d||""===d)return!1}return!0}function lg(a){var b=a;if("object"==typeof a&&null!=a){b="length"in a?[]:{};for(var c in a)M(b,c,lg(a[c]))}return b};function mg(a){var b={},c=a[ng],d=a[og];a=a[pg];if(!c||!a)throw Error("Invalid provider user info!");b[qg]=d||null;b[rg]=c;M(this,sg,a);M(this,tg,lg(b))}var ng="email",og="newEmail",pg="requestType",rg="email",qg="fromEmail",tg="data",sg="operation";function N(a,b){this.code=ug+a;this.message=b||vg[a]||""}t(N,Error);N.prototype.B=function(){return{code:this.code,message:this.message}};N.prototype.toJSON=function(){return this.B()};function wg(a){var b=a&&a.code;return b?new N(b.substring(ug.length),a.message):null}
	var ug="auth/",vg={"argument-error":"","app-not-authorized":"This app, identified by the domain where it's hosted, is not authorized to use Firebase Authentication with the provided API key. Review your key configuration in the Google API console.","app-not-installed":"The requested mobile application corresponding to the identifier (Android package name or iOS bundle ID) provided is not installed on this device.","captcha-check-failed":"The reCAPTCHA response token provided is either invalid, expired, already used or the domain associated with it does not match the list of whitelisted domains.",
	"code-expired":"The SMS code has expired. Please re-send the verification code to try again.","cordova-not-ready":"Cordova framework is not ready.","cors-unsupported":"This browser is not supported.","credential-already-in-use":"This credential is already associated with a different user account.","custom-token-mismatch":"The custom token corresponds to a different audience.","requires-recent-login":"This operation is sensitive and requires recent authentication. Log in again before retrying this request.",
	"dynamic-link-not-activated":"Please activate Dynamic Links in the Firebase Console and agree to the terms and conditions.","email-already-in-use":"The email address is already in use by another account.","expired-action-code":"The action code has expired. ","cancelled-popup-request":"This operation has been cancelled due to another conflicting popup being opened.","internal-error":"An internal error has occurred.","invalid-app-credential":"The phone verification request contains an invalid application verifier. The reCAPTCHA token response is either invalid or expired.",
	"invalid-app-id":"The mobile app identifier is not registed for the current project.","invalid-user-token":"The user's credential is no longer valid. The user must sign in again.","invalid-auth-event":"An internal error has occurred.","invalid-verification-code":"The SMS verification code used to create the phone auth credential is invalid. Please resend the verification code sms and be sure use the verification code provided by the user.","invalid-continue-uri":"The continue URL provided in the request is invalid.",
	"invalid-cordova-configuration":"The following Cordova plugins must be installed to enable OAuth sign-in: cordova-plugin-buildinfo, cordova-universal-links-plugin, cordova-plugin-browsertab, cordova-plugin-inappbrowser and cordova-plugin-customurlscheme.","invalid-custom-token":"The custom token format is incorrect. Please check the documentation.","invalid-email":"The email address is badly formatted.","invalid-api-key":"Your API key is invalid, please check you have copied it correctly.","invalid-cert-hash":"The SHA-1 certificate hash provided is invalid.",
	"invalid-credential":"The supplied auth credential is malformed or has expired.","invalid-persistence-type":"The specified persistence type is invalid. It can only be local, session or none.","invalid-message-payload":"The email template corresponding to this action contains invalid characters in its message. Please fix by going to the Auth email templates section in the Firebase Console.","invalid-oauth-provider":"EmailAuthProvider is not supported for this operation. This operation only supports OAuth providers.",
	"invalid-oauth-client-id":"The OAuth client ID provided is either invalid or does not match the specified API key.","unauthorized-domain":"This domain is not authorized for OAuth operations for your Firebase project. Edit the list of authorized domains from the Firebase console.","invalid-action-code":"The action code is invalid. This can happen if the code is malformed, expired, or has already been used.","wrong-password":"The password is invalid or the user does not have a password.","invalid-phone-number":"The format of the phone number provided is incorrect. Please enter the phone number in a format that can be parsed into E.164 format. E.164 phone numbers are written in the format [+][country code][subscriber number including area code].",
	"invalid-recipient-email":"The email corresponding to this action failed to send as the provided recipient email address is invalid.","invalid-sender":"The email template corresponding to this action contains an invalid sender email or name. Please fix by going to the Auth email templates section in the Firebase Console.","invalid-verification-id":"The verification ID used to create the phone auth credential is invalid.","missing-android-pkg-name":"An Android Package Name must be provided if the Android App is required to be installed.",
	"auth-domain-config-required":"Be sure to include authDomain when calling firebase.initializeApp(), by following the instructions in the Firebase console.","missing-app-credential":"The phone verification request is missing an application verifier assertion. A reCAPTCHA response token needs to be provided.","missing-verification-code":"The phone auth credential was created with an empty SMS verification code.","missing-continue-uri":"A continue URL must be provided in the request.","missing-iframe-start":"An internal error has occurred.",
	"missing-ios-bundle-id":"An iOS Bundle ID must be provided if an App Store ID is provided.","missing-phone-number":"To send verification codes, provide a phone number for the recipient.","missing-verification-id":"The phone auth credential was created with an empty verification ID.","app-deleted":"This instance of FirebaseApp has been deleted.","account-exists-with-different-credential":"An account already exists with the same email address but different sign-in credentials. Sign in using a provider associated with this email address.",
	"network-request-failed":"A network error (such as timeout, interrupted connection or unreachable host) has occurred.","no-auth-event":"An internal error has occurred.","no-such-provider":"User was not linked to an account with the given provider.","operation-not-allowed":"The given sign-in provider is disabled for this Firebase project. Enable it in the Firebase console, under the sign-in method tab of the Auth section.","operation-not-supported-in-this-environment":'This operation is not supported in the environment this application is running on. "location.protocol" must be http, https or chrome-extension and web storage must be enabled.',
	"popup-blocked":"Unable to establish a connection with the popup. It may have been blocked by the browser.","popup-closed-by-user":"The popup has been closed by the user before finalizing the operation.","provider-already-linked":"User can only be linked to one identity for the given provider.","quota-exceeded":"The project's quota for this operation has been exceeded.","redirect-cancelled-by-user":"The redirect operation has been cancelled by the user before finalizing.","redirect-operation-pending":"A redirect sign-in operation is already pending.",
	timeout:"The operation has timed out.","user-token-expired":"The user's credential is no longer valid. The user must sign in again.","too-many-requests":"We have blocked all requests from this device due to unusual activity. Try again later.","unauthorized-continue-uri":"The domain of the continue URL is not whitelisted.  Please whitelist the domain in the Firebase console.","unsupported-persistence-type":"The current environment does not support the specified persistence type.","user-cancelled":"User did not grant your application the permissions it requested.",
	"user-not-found":"There is no user record corresponding to this identifier. The user may have been deleted.","user-disabled":"The user account has been disabled by an administrator.","user-mismatch":"The supplied credentials do not correspond to the previously signed in user.","user-signed-out":"","weak-password":"The password must be 6 characters long or more.","web-storage-unsupported":"This browser is not supported or 3rd party cookies and data may be disabled."};function xg(a){var b=a[yg];if("undefined"===typeof b)throw new N("missing-continue-uri");if("string"!==typeof b||"string"===typeof b&&!b.length)throw new N("invalid-continue-uri");this.h=b;this.c=this.a=null;this.g=!1;var c=a[zg];if(c&&"object"===typeof c){b=c[Ag];var d=c[Bg];c=c[Cg];if("string"===typeof b&&b.length){this.a=b;if("undefined"!==typeof d&&"boolean"!==typeof d)throw new N("argument-error",Bg+" property must be a boolean when specified.");this.g=!!d;if("undefined"!==typeof c&&("string"!==
	typeof c||"string"===typeof c&&!c.length))throw new N("argument-error",Cg+" property must be a non empty string when specified.");this.c=c||null}else{if("undefined"!==typeof b)throw new N("argument-error",Ag+" property must be a non empty string when specified.");if("undefined"!==typeof d||"undefined"!==typeof c)throw new N("missing-android-pkg-name");}}else if("undefined"!==typeof c)throw new N("argument-error",zg+" property must be a non null object when specified.");this.b=null;if((b=a[Dg])&&"object"===
	typeof b)if(b=b[Eg],"string"===typeof b&&b.length)this.b=b;else{if("undefined"!==typeof b)throw new N("argument-error",Eg+" property must be a non empty string when specified.");}else if("undefined"!==typeof b)throw new N("argument-error",Dg+" property must be a non null object when specified.");a=a[Fg];if("undefined"!==typeof a&&"boolean"!==typeof a)throw new N("argument-error",Fg+" property must be a boolean when specified.");if((this.f=!!a)&&!this.b&&!this.a)throw new N("argument-error",Fg+" property can't be true when no mobile application is provided.");
	}var zg="android",Fg="handleCodeInApp",Dg="iOS",yg="url",Bg="installApp",Cg="minimumVersion",Ag="packageName",Eg="bundleId";function Gg(a){var b={};b.continueUrl=a.h;b.canHandleCodeInApp=a.f;if(b.androidPackageName=a.a)b.androidMinimumVersion=a.c,b.androidInstallApp=a.g;b.iOSBundleId=a.b;for(var c in b)null===b[c]&&delete b[c];return b};function Hg(a){this.b=a.sub;na();this.a=a.provider_id||a.firebase&&a.firebase.sign_in_provider||null}function Ig(a){a=a.split(".");if(3!=a.length)return null;a=a[1];for(var b=(4-a.length%4)%4,c=0;c<b;c++)a+=".";try{var d=JSON.parse(Ld(a));if(d.sub&&d.iss&&d.aud&&d.exp)return new Hg(d)}catch(e){}return null};var Jg="oauth_consumer_key oauth_nonce oauth_signature oauth_signature_method oauth_timestamp oauth_token oauth_version".split(" "),Kg=["client_id","response_type","scope","redirect_uri","state"],Lg={Hc:{Ma:"locale",za:500,ya:600,Na:"facebook.com",$a:Kg},Jc:{Ma:null,za:500,ya:620,Na:"github.com",$a:Kg},Kc:{Ma:"hl",za:515,ya:680,Na:"google.com",$a:Kg},Qc:{Ma:"lang",za:485,ya:705,Na:"twitter.com",$a:Jg}};function Mg(a){for(var b in Lg)if(Lg[b].Na==a)return Lg[b];return null};function Ng(a){var b={};b["facebook.com"]=Og;b["google.com"]=Pg;b["github.com"]=Qg;b["twitter.com"]=Rg;var c=a&&a[Sg];try{if(c)return b[c]?new b[c](a):new Tg(a);if("undefined"!==typeof a[Ug])return new Vg(a)}catch(d){}return null}var Ug="idToken",Sg="providerId";
	function Vg(a){var b=a[Sg];if(!b&&a[Ug]){var c=Ig(a[Ug]);c&&c.a&&(b=c.a)}if(!b)throw Error("Invalid additional user info!");if("anonymous"==b||"custom"==b)b=null;c=!1;"undefined"!==typeof a.isNewUser?c=!!a.isNewUser:"identitytoolkit#SignupNewUserResponse"===a.kind&&(c=!0);M(this,"providerId",b);M(this,"isNewUser",c)}function Tg(a){Vg.call(this,a);a=Xf(a.rawUserInfo||"{}");M(this,"profile",lg(a||{}))}t(Tg,Vg);
	function Og(a){Tg.call(this,a);if("facebook.com"!=this.providerId)throw Error("Invalid provider ID!");}t(Og,Tg);function Qg(a){Tg.call(this,a);if("github.com"!=this.providerId)throw Error("Invalid provider ID!");M(this,"username",this.profile&&this.profile.login||null)}t(Qg,Tg);function Pg(a){Tg.call(this,a);if("google.com"!=this.providerId)throw Error("Invalid provider ID!");}t(Pg,Tg);
	function Rg(a){Tg.call(this,a);if("twitter.com"!=this.providerId)throw Error("Invalid provider ID!");M(this,"username",a.screenName||null)}t(Rg,Tg);function Wg(a,b){return a.then(function(a){if(a[O]){var c=Ig(a[O]);if(!c||b!=c.b)throw new N("user-mismatch");return a}throw new N("user-mismatch");}).s(function(a){throw a&&a.code&&a.code==ug+"user-not-found"?new N("user-mismatch"):a;})}
	function Xg(a,b){if(b.idToken||b.accessToken)b.idToken&&M(this,"idToken",b.idToken),b.accessToken&&M(this,"accessToken",b.accessToken);else if(b.oauthToken&&b.oauthTokenSecret)M(this,"accessToken",b.oauthToken),M(this,"secret",b.oauthTokenSecret);else throw new N("internal-error","failed to construct a credential");M(this,"providerId",a)}Xg.prototype.wa=function(a){return Yg(a,Zg(this))};Xg.prototype.b=function(a,b){var c=Zg(this);c.idToken=b;return $g(a,c)};
	Xg.prototype.c=function(a,b){var c=Zg(this);return Wg(ah(a,c),b)};function Zg(a){var b={};a.idToken&&(b.id_token=a.idToken);a.accessToken&&(b.access_token=a.accessToken);a.secret&&(b.oauth_token_secret=a.secret);b.providerId=a.providerId;return{postBody:Je(b).toString(),requestUri:"http://localhost"}}
	Xg.prototype.B=function(){var a={providerId:this.providerId};this.idToken&&(a.oauthIdToken=this.idToken);this.accessToken&&(a.oauthAccessToken=this.accessToken);this.secret&&(a.oauthTokenSecret=this.secret);return a};function bh(a,b){this.rc=b||[];hg(this,{providerId:a,isOAuthProvider:!0});this.rb={};this.Wa=(Mg(a)||{}).Ma||null;this.Ua=null}bh.prototype.Ba=function(a){this.rb=Ua(a);return this};function P(a){bh.call(this,a,Kg);this.a=[]}t(P,bh);
	P.prototype.sa=function(a){Ha(this.a,a)||this.a.push(a);return this};P.prototype.wb=function(){return La(this.a)};P.prototype.credential=function(a,b){if(!a&&!b)throw new N("argument-error","credential failed: must provide the ID token and/or the access token.");return new Xg(this.providerId,{idToken:a||null,accessToken:b||null})};function ch(){P.call(this,"facebook.com")}t(ch,P);M(ch,"PROVIDER_ID","facebook.com");
	function dh(a){if(!a)throw new N("argument-error","credential failed: expected 1 argument (the OAuth access token).");var b=a;q(a)&&(b=a.accessToken);return(new ch).credential(null,b)}function eh(){P.call(this,"github.com")}t(eh,P);M(eh,"PROVIDER_ID","github.com");function fh(a){if(!a)throw new N("argument-error","credential failed: expected 1 argument (the OAuth access token).");var b=a;q(a)&&(b=a.accessToken);return(new eh).credential(null,b)}
	function gh(){P.call(this,"google.com");this.sa("profile")}t(gh,P);M(gh,"PROVIDER_ID","google.com");function hh(a,b){var c=a;q(a)&&(c=a.idToken,b=a.accessToken);return(new gh).credential(c,b)}function ih(){bh.call(this,"twitter.com",Jg)}t(ih,bh);M(ih,"PROVIDER_ID","twitter.com");
	function jh(a,b){var c=a;q(c)||(c={oauthToken:a,oauthTokenSecret:b});if(!c.oauthToken||!c.oauthTokenSecret)throw new N("argument-error","credential failed: expected 2 arguments (the OAuth access token and secret).");return new Xg("twitter.com",c)}function kh(a,b){this.a=a;this.f=b;M(this,"providerId","password")}kh.prototype.wa=function(a){return Q(a,lh,{email:this.a,password:this.f})};kh.prototype.b=function(a,b){return Q(a,mh,{idToken:b,email:this.a,password:this.f})};
	kh.prototype.c=function(a,b){return Wg(this.wa(a),b)};kh.prototype.B=function(){return{email:this.a,password:this.f}};function nh(){hg(this,{providerId:"password",isOAuthProvider:!1})}hg(nh,{PROVIDER_ID:"password"});function oh(a){if(!(a.Pa&&a.Oa||a.Da&&a.Y))throw new N("internal-error");this.a=a;M(this,"providerId","phone")}oh.prototype.wa=function(a){return a.Qa(ph(this))};oh.prototype.b=function(a,b){var c=ph(this);c.idToken=b;return Q(a,qh,c)};
	oh.prototype.c=function(a,b){var c=ph(this);c.operation="REAUTH";a=Q(a,rh,c);return Wg(a,b)};oh.prototype.B=function(){var a={providerId:"phone"};this.a.Pa&&(a.verificationId=this.a.Pa);this.a.Oa&&(a.verificationCode=this.a.Oa);this.a.Da&&(a.temporaryProof=this.a.Da);this.a.Y&&(a.phoneNumber=this.a.Y);return a};function ph(a){return a.a.Da&&a.a.Y?{temporaryProof:a.a.Da,phoneNumber:a.a.Y}:{sessionInfo:a.a.Pa,code:a.a.Oa}}
	function sh(a){try{this.a=a||firebase.auth()}catch(b){throw new N("argument-error","Either an instance of firebase.auth.Auth must be passed as an argument to the firebase.auth.PhoneAuthProvider constructor, or the default firebase App instance must be initialized via firebase.initializeApp().");}hg(this,{providerId:"phone",isOAuthProvider:!1})}
	sh.prototype.Qa=function(a,b){var c=this.a.c;return A(b.verify()).then(function(d){if(!m(d))throw new N("argument-error","An implementation of firebase.auth.ApplicationVerifier.prototype.verify() must return a firebase.Promise that resolves with a string.");switch(b.type){case "recaptcha":return th(c,{phoneNumber:a,recaptchaToken:d}).then(function(a){"function"===typeof b.reset&&b.reset();return a},function(a){"function"===typeof b.reset&&b.reset();throw a;});default:throw new N("argument-error",
	'Only firebase.auth.ApplicationVerifiers with type="recaptcha" are currently supported.');}})};function uh(a,b){if(!a)throw new N("missing-verification-id");if(!b)throw new N("missing-verification-code");return new oh({Pa:a,Oa:b})}hg(sh,{PROVIDER_ID:"phone"});
	function vh(a){if(a.temporaryProof&&a.phoneNumber)return new oh({Da:a.temporaryProof,Y:a.phoneNumber});var b=a&&a.providerId;if(!b||"password"===b)return null;var c=a&&a.oauthAccessToken,d=a&&a.oauthTokenSecret;a=a&&a.oauthIdToken;try{switch(b){case "google.com":return hh(a,c);case "facebook.com":return dh(c);case "github.com":return fh(c);case "twitter.com":return jh(c,d);default:return(new P(b)).credential(a,c)}}catch(e){return null}}
	function wh(a){if(!a.isOAuthProvider)throw new N("invalid-oauth-provider");};function xh(a,b,c,d,e){this.b=a;this.c=b||null;this.f=c||null;this.g=d||null;this.a=e||null;if(this.f||this.a){if(this.f&&this.a)throw new N("invalid-auth-event");if(this.f&&!this.g)throw new N("invalid-auth-event");}else throw new N("invalid-auth-event");}xh.prototype.B=function(){return{type:this.b,eventId:this.c,urlResponse:this.f,sessionId:this.g,error:this.a&&this.a.B()}};function yh(a){a=a||{};return a.type?new xh(a.type,a.eventId,a.urlResponse,a.sessionId,a.error&&wg(a.error)):null};function zh(){this.b=null;this.a=[]}var Ah=null;zh.prototype.subscribe=function(a){var b=this;this.a.push(a);this.b||(this.b=function(a){for(var c=0;c<b.a.length;c++)b.a[c](a)},a=L("universalLinks.subscribe",k),"function"===typeof a&&a(null,this.b))};zh.prototype.unsubscribe=function(a){Ja(this.a,function(b){return b==a})};function Bh(a){var b="unauthorized-domain",c=void 0,d=Ee(a);a=d.b;d=d.c;"chrome-extension"==d?c=oa("This chrome extension ID (chrome-extension://%s) is not authorized to run this operation. Add it to the OAuth redirect domains list in the Firebase console -> Auth section -> Sign in method tab.",a):"http"==d||"https"==d?c=oa("This domain (%s) is not authorized to run this operation. Add it to the OAuth redirect domains list in the Firebase console -> Auth section -> Sign in method tab.",a):b="operation-not-supported-in-this-environment";
	N.call(this,b,c)}t(Bh,N);function Ch(a,b,c){N.call(this,a,c);a=b||{};a.sb&&M(this,"email",a.sb);a.Y&&M(this,"phoneNumber",a.Y);a.credential&&M(this,"credential",a.credential)}t(Ch,N);Ch.prototype.B=function(){var a={code:this.code,message:this.message};this.email&&(a.email=this.email);this.phoneNumber&&(a.phoneNumber=this.phoneNumber);var b=this.credential&&this.credential.B();b&&Wa(a,b);return a};Ch.prototype.toJSON=function(){return this.B()};
	function Dh(a){if(a.code){var b=a.code||"";0==b.indexOf(ug)&&(b=b.substring(ug.length));var c={credential:vh(a)};if(a.email)c.sb=a.email;else if(a.phoneNumber)c.Y=a.phoneNumber;else return new N(b,a.message||void 0);return new Ch(b,c,a.message)}return null};function Eh(a){this.f=a}t(Eh,Oe);Eh.prototype.a=function(){return new this.f};Eh.prototype.b=function(){return{}};
	function Fh(a,b,c){var d="Node"==K();d=k.XMLHttpRequest||d&&firebase.INTERNAL.node&&firebase.INTERNAL.node.XMLHttpRequest;if(!d)throw new N("internal-error","The XMLHttpRequest compatibility library was not found.");this.b=a;a=b||{};this.i=a.secureTokenEndpoint||"https://securetoken.googleapis.com/v1/token";this.l=a.secureTokenTimeout||Gh;this.c=Ua(a.secureTokenHeaders||Hh);this.g=a.firebaseEndpoint||"https://www.googleapis.com/identitytoolkit/v3/relyingparty/";this.h=a.firebaseTimeout||Ih;this.a=
	Ua(a.firebaseHeaders||Jh);c&&(this.a["X-Client-Version"]=c,this.c["X-Client-Version"]=c);this.f=new sf;this.o=new Eh(d)}var Kh,O="idToken",Gh=new ag(3E4,6E4),Hh={"Content-Type":"application/x-www-form-urlencoded"},Ih=new ag(3E4,6E4),Jh={"Content-Type":"application/json"};function Lh(a,b){b?a.a["X-Firebase-Locale"]=b:delete a.a["X-Firebase-Locale"]}function Mh(a,b){b?(a.a["X-Client-Version"]=b,a.c["X-Client-Version"]=b):(delete a.a["X-Client-Version"],delete a.c["X-Client-Version"])}
	function Nh(a,b,c,d,e,f,g){$f()?(zf()?a=r(a.m,a):(Kh||(Kh=new z(function(a,b){Oh(a,b)})),a=r(a.u,a)),a(b,c,d,e,f,g)):c&&c(null)}
	Fh.prototype.m=function(a,b,c,d,e,f){var g="Node"==K(),l=Nf()?g?new Te(this.o):new Te:new Te(this.f);if(f){l.f=Math.max(0,f);var n=setTimeout(function(){G(l,"timeout")},f)}fd(l,"complete",function(){n&&clearTimeout(n);var a=null;try{a=JSON.parse(jf(this))||null}catch(vb){a=null}b&&b(a)});ld(l,"ready",function(){n&&clearTimeout(n);Lc(this)});ld(l,"timeout",function(){n&&clearTimeout(n);Lc(this);b&&b(null)});Ze(l,a,c,d,e)};
	var Ph=dc("https://apis.google.com/js/client.js?onload=%{onload}"),Qh="__fcb"+Math.floor(1E6*Math.random()).toString();function Oh(a,b){if(((window.gapi||{}).client||{}).request)a();else{k[Qh]=function(){((window.gapi||{}).client||{}).request?a():b(Error("CORS_UNSUPPORTED"))};var c=hc(Ph,{onload:Qh});Ud(lf(c),function(){b(Error("CORS_UNSUPPORTED"))})}}
	Fh.prototype.u=function(a,b,c,d,e){var f=this;Kh.then(function(){window.gapi.client.setApiKey(f.b);var g=window.gapi.auth.getToken();window.gapi.auth.setToken(null);window.gapi.client.request({path:a,method:c,body:d,headers:e,authType:"none",callback:function(a){window.gapi.auth.setToken(g);b&&b(a)}})}).s(function(a){b&&b({error:{message:a&&a.message||"CORS_UNSUPPORTED"}})})};
	function Rh(a,b){return new z(function(c,d){"refresh_token"==b.grant_type&&b.refresh_token||"authorization_code"==b.grant_type&&b.code?Nh(a,a.i+"?key="+encodeURIComponent(a.b),function(a){a?a.error?d(Sh(a)):a.access_token&&a.refresh_token?c(a):d(new N("internal-error")):d(new N("network-request-failed"))},"POST",Je(b).toString(),a.c,a.l.get()):d(new N("internal-error"))})}
	function Th(a,b,c,d,e,f){var g=Ee(a.g+b);I(g,"key",a.b);f&&I(g,"cb",na().toString());var l="GET"==c;if(l)for(var n in d)d.hasOwnProperty(n)&&I(g,n,d[n]);return new z(function(b,f){Nh(a,g.toString(),function(a){a?a.error?f(Sh(a,e||{})):b(a):f(new N("network-request-failed"))},c,l?void 0:Cc(Wf(d)),a.a,a.h.get())})}function Uh(a){if(!kf.test(a.email))throw new N("invalid-email");}function Vh(a){"email"in a&&Uh(a)}
	function Wh(a,b){return Q(a,Xh,{identifier:b,continueUri:Tf()?wf():"http://localhost"}).then(function(a){return a.allProviders||[]})}function Yh(a){return Q(a,Zh,{}).then(function(a){return a.authorizedDomains||[]})}function $h(a){if(!a[O])throw new N("internal-error");}
	function ai(a){if(a.phoneNumber||a.temporaryProof){if(!a.phoneNumber||!a.temporaryProof)throw new N("internal-error");}else{if(!a.sessionInfo)throw new N("missing-verification-id");if(!a.code)throw new N("missing-verification-code");}}Fh.prototype.gb=function(){return Q(this,bi,{})};Fh.prototype.kb=function(a,b){return Q(this,ci,{idToken:a,email:b})};Fh.prototype.lb=function(a,b){return Q(this,mh,{idToken:a,password:b})};var di={displayName:"DISPLAY_NAME",photoUrl:"PHOTO_URL"};h=Fh.prototype;
	h.mb=function(a,b){var c={idToken:a},d=[];Pa(di,function(a,f){var e=b[f];null===e?d.push(a):f in b&&(c[f]=e)});d.length&&(c.deleteAttribute=d);return Q(this,ci,c)};h.cb=function(a,b){a={requestType:"PASSWORD_RESET",email:a};Wa(a,b);return Q(this,ei,a)};h.bb=function(a,b){a={requestType:"VERIFY_EMAIL",idToken:a};Wa(a,b);return Q(this,fi,a)};function th(a,b){return Q(a,gi,b)}h.Qa=function(a){return Q(this,hi,a)};function ii(a,b,c){return Q(a,ji,{idToken:b,deleteProvider:c})}
	function ki(a){if(!a.requestUri||!a.sessionId&&!a.postBody)throw new N("internal-error");}function li(a){var b=null;a.needConfirmation?(a.code="account-exists-with-different-credential",b=Dh(a)):"FEDERATED_USER_ID_ALREADY_LINKED"==a.errorMessage?(a.code="credential-already-in-use",b=Dh(a)):"EMAIL_EXISTS"==a.errorMessage?(a.code="email-already-in-use",b=Dh(a)):a.errorMessage&&(b=mi(a.errorMessage));if(b)throw b;if(!a[O])throw new N("internal-error");}
	function Yg(a,b){b.returnIdpCredential=!0;return Q(a,ni,b)}function $g(a,b){b.returnIdpCredential=!0;return Q(a,oi,b)}function ah(a,b){b.returnIdpCredential=!0;b.autoCreate=!1;return Q(a,pi,b)}function qi(a){if(!a.oobCode)throw new N("invalid-action-code");}h.Ta=function(a,b){return Q(this,ri,{oobCode:a,newPassword:b})};h.Ia=function(a){return Q(this,si,{oobCode:a})};h.Sa=function(a){return Q(this,ti,{oobCode:a})};
	var ti={endpoint:"setAccountInfo",D:qi,ga:"email"},si={endpoint:"resetPassword",D:qi,O:function(a){if(!a.email||!a.requestType)throw new N("internal-error");}},ui={endpoint:"signupNewUser",D:function(a){Uh(a);if(!a.password)throw new N("weak-password");},O:$h,T:!0},Xh={endpoint:"createAuthUri"},vi={endpoint:"deleteAccount",ea:["idToken"]},ji={endpoint:"setAccountInfo",ea:["idToken","deleteProvider"],D:function(a){if(!fa(a.deleteProvider))throw new N("internal-error");}},wi={endpoint:"getAccountInfo"},
	fi={endpoint:"getOobConfirmationCode",ea:["idToken","requestType"],D:function(a){if("VERIFY_EMAIL"!=a.requestType)throw new N("internal-error");},ga:"email"},ei={endpoint:"getOobConfirmationCode",ea:["requestType"],D:function(a){if("PASSWORD_RESET"!=a.requestType)throw new N("internal-error");Uh(a)},ga:"email"},Zh={nb:!0,endpoint:"getProjectConfig",zb:"GET"},xi={nb:!0,endpoint:"getRecaptchaParam",zb:"GET",O:function(a){if(!a.recaptchaSiteKey)throw new N("internal-error");}},ri={endpoint:"resetPassword",
	D:qi,ga:"email"},gi={endpoint:"sendVerificationCode",ea:["phoneNumber","recaptchaToken"],ga:"sessionInfo"},ci={endpoint:"setAccountInfo",ea:["idToken"],D:Vh,T:!0},mh={endpoint:"setAccountInfo",ea:["idToken"],D:function(a){Vh(a);if(!a.password)throw new N("weak-password");},O:$h,T:!0},bi={endpoint:"signupNewUser",O:$h,T:!0},ni={endpoint:"verifyAssertion",D:ki,O:li,T:!0},pi={endpoint:"verifyAssertion",D:ki,O:function(a){if(a.errorMessage&&"USER_NOT_FOUND"==a.errorMessage)throw new N("user-not-found");
	if(a.errorMessage)throw mi(a.errorMessage);if(!a[O])throw new N("internal-error");},T:!0},oi={endpoint:"verifyAssertion",D:function(a){ki(a);if(!a.idToken)throw new N("internal-error");},O:li,T:!0},yi={endpoint:"verifyCustomToken",D:function(a){if(!a.token)throw new N("invalid-custom-token");},O:$h,T:!0},lh={endpoint:"verifyPassword",D:function(a){Uh(a);if(!a.password)throw new N("wrong-password");},O:$h,T:!0},hi={endpoint:"verifyPhoneNumber",D:ai,O:$h},qh={endpoint:"verifyPhoneNumber",D:function(a){if(!a.idToken)throw new N("internal-error");
	ai(a)},O:function(a){if(a.temporaryProof)throw a.code="credential-already-in-use",Dh(a);$h(a)}},rh={Pb:{USER_NOT_FOUND:"user-not-found"},endpoint:"verifyPhoneNumber",D:ai,O:$h};
	function Q(a,b,c){if(!kg(c,b.ea))return B(new N("internal-error"));var d=b.zb||"POST",e;return A(c).then(b.D).then(function(){b.T&&(c.returnSecureToken=!0);return Th(a,b.endpoint,d,c,b.Pb,b.nb||!1)}).then(function(a){return e=a}).then(b.O).then(function(){if(!b.ga)return e;if(!(b.ga in e))throw new N("internal-error");return e[b.ga]})}function mi(a){return Sh({error:{errors:[{message:a}],code:400,message:a}})}
	function Sh(a,b){var c=(a.error&&a.error.errors&&a.error.errors[0]||{}).reason||"";var d={keyInvalid:"invalid-api-key",ipRefererBlocked:"app-not-authorized"};if(c=d[c]?new N(d[c]):null)return c;c=a.error&&a.error.message||"";d={INVALID_CUSTOM_TOKEN:"invalid-custom-token",CREDENTIAL_MISMATCH:"custom-token-mismatch",MISSING_CUSTOM_TOKEN:"internal-error",INVALID_IDENTIFIER:"invalid-email",MISSING_CONTINUE_URI:"internal-error",INVALID_EMAIL:"invalid-email",INVALID_PASSWORD:"wrong-password",USER_DISABLED:"user-disabled",
	MISSING_PASSWORD:"internal-error",EMAIL_EXISTS:"email-already-in-use",PASSWORD_LOGIN_DISABLED:"operation-not-allowed",INVALID_IDP_RESPONSE:"invalid-credential",FEDERATED_USER_ID_ALREADY_LINKED:"credential-already-in-use",INVALID_MESSAGE_PAYLOAD:"invalid-message-payload",INVALID_RECIPIENT_EMAIL:"invalid-recipient-email",INVALID_SENDER:"invalid-sender",EMAIL_NOT_FOUND:"user-not-found",EXPIRED_OOB_CODE:"expired-action-code",INVALID_OOB_CODE:"invalid-action-code",MISSING_OOB_CODE:"internal-error",CREDENTIAL_TOO_OLD_LOGIN_AGAIN:"requires-recent-login",
	INVALID_ID_TOKEN:"invalid-user-token",TOKEN_EXPIRED:"user-token-expired",USER_NOT_FOUND:"user-token-expired",CORS_UNSUPPORTED:"cors-unsupported",DYNAMIC_LINK_NOT_ACTIVATED:"dynamic-link-not-activated",INVALID_APP_ID:"invalid-app-id",TOO_MANY_ATTEMPTS_TRY_LATER:"too-many-requests",WEAK_PASSWORD:"weak-password",OPERATION_NOT_ALLOWED:"operation-not-allowed",USER_CANCELLED:"user-cancelled",CAPTCHA_CHECK_FAILED:"captcha-check-failed",INVALID_APP_CREDENTIAL:"invalid-app-credential",INVALID_CODE:"invalid-verification-code",
	INVALID_PHONE_NUMBER:"invalid-phone-number",INVALID_SESSION_INFO:"invalid-verification-id",INVALID_TEMPORARY_PROOF:"invalid-credential",MISSING_APP_CREDENTIAL:"missing-app-credential",MISSING_CODE:"missing-verification-code",MISSING_PHONE_NUMBER:"missing-phone-number",MISSING_SESSION_INFO:"missing-verification-id",QUOTA_EXCEEDED:"quota-exceeded",SESSION_EXPIRED:"code-expired",INVALID_CONTINUE_URI:"invalid-continue-uri",MISSING_ANDROID_PACKAGE_NAME:"missing-android-pkg-name",MISSING_IOS_BUNDLE_ID:"missing-ios-bundle-id",
	UNAUTHORIZED_DOMAIN:"unauthorized-continue-uri",INVALID_OAUTH_CLIENT_ID:"invalid-oauth-client-id",INVALID_CERT_HASH:"invalid-cert-hash"};Wa(d,b||{});b=(b=c.match(/^[^\s]+\s*:\s*(.*)$/))&&1<b.length?b[1]:void 0;for(var e in d)if(0===c.indexOf(e))return new N(d[e],b);!b&&a&&(b=Vf(a));return new N("internal-error",b)};var zi={Mc:{Va:"https://www.googleapis.com/identitytoolkit/v3/relyingparty/",ab:"https://securetoken.googleapis.com/v1/token",id:"p"},Oc:{Va:"https://staging-www.sandbox.googleapis.com/identitytoolkit/v3/relyingparty/",ab:"https://staging-securetoken.sandbox.googleapis.com/v1/token",id:"s"},Pc:{Va:"https://www-googleapis-test.sandbox.google.com/identitytoolkit/v3/relyingparty/",ab:"https://test-securetoken.sandbox.googleapis.com/v1/token",id:"t"}};
	function Ai(a){for(var b in zi)if(zi[b].id===a)return a=zi[b],{firebaseEndpoint:a.Va,secureTokenEndpoint:a.ab};return null}var Bi;Bi=Ai("__EID__")?"__EID__":void 0;function Ci(a){this.b=a;this.a=null;this.Ya=Di(this)}
	function Di(a){return Ei().then(function(){return new z(function(b,c){L("gapi.iframes.getContext")().open({where:document.body,url:a.b,messageHandlersFilter:L("gapi.iframes.CROSS_ORIGIN_IFRAMES_FILTER"),attributes:{style:{position:"absolute",top:"-100px",width:"1px",height:"1px"}},dontclear:!0},function(d){function e(){clearTimeout(f);b()}a.a=d;a.a.restyle({setHideOnLeave:!1});var f=setTimeout(function(){c(Error("Network Error"))},Fi.get());d.ping(e).then(e,function(){c(Error("Network Error"))})})})})}
	function Gi(a,b){return a.Ya.then(function(){return new z(function(c){a.a.send(b.type,b,c,L("gapi.iframes.CROSS_ORIGIN_IFRAMES_FILTER"))})})}function Hi(a,b){a.Ya.then(function(){a.a.register("authEvent",b,L("gapi.iframes.CROSS_ORIGIN_IFRAMES_FILTER"))})}var Ii=dc("https://apis.google.com/js/api.js?onload=%{onload}"),Ji=new ag(3E4,6E4),Fi=new ag(5E3,15E3),Ki=null;
	function Ei(){return Ki?Ki:Ki=(new z(function(a,b){if($f()){var c=function(){Zf();L("gapi.load")("gapi.iframes",{callback:a,ontimeout:function(){Zf();b(Error("Network Error"))},timeout:Ji.get()})};if(L("gapi.iframes.Iframe"))a();else if(L("gapi.load"))c();else{var d="__iframefcb"+Math.floor(1E6*Math.random()).toString();k[d]=function(){L("gapi.load")?c():b(Error("Network Error"))};d=hc(Ii,{onload:d});A(lf(d)).s(function(){b(Error("Network Error"))})}}else b(Error("Network Error"))})).s(function(a){Ki=
	null;throw a;})};function Li(a,b,c){this.i=a;this.g=b;this.h=c;this.f=null;this.a=Fe(this.i,"/__/auth/iframe");I(this.a,"apiKey",this.g);I(this.a,"appName",this.h);this.b=null;this.c=[]}Li.prototype.toString=function(){this.f?I(this.a,"v",this.f):Me(this.a.a,"v");this.b?I(this.a,"eid",this.b):Me(this.a.a,"eid");this.c.length?I(this.a,"fw",this.c.join(",")):Me(this.a.a,"fw");return this.a.toString()};function Mi(a,b,c,d,e){this.m=a;this.u=b;this.c=c;this.l=d;this.i=this.g=this.h=null;this.a=e;this.f=null}
	Mi.prototype.toString=function(){var a=Fe(this.m,"/__/auth/handler");I(a,"apiKey",this.u);I(a,"appName",this.c);I(a,"authType",this.l);if(this.a.isOAuthProvider){var b=this.a;try{var c=firebase.app(this.c).auth().$()}catch(l){c=null}b.Ua=c;I(a,"providerId",this.a.providerId);b=this.a;c=Wf(b.rb);for(var d in c)c[d]=c[d].toString();d=b.rc;c=Ua(c);for(var e=0;e<d.length;e++){var f=d[e];f in c&&delete c[f]}b.Wa&&b.Ua&&!c[b.Wa]&&(c[b.Wa]=b.Ua);Sa(c)||I(a,"customParameters",Vf(c))}"function"===typeof this.a.wb&&
	(b=this.a.wb(),b.length&&I(a,"scopes",b.join(",")));this.h?I(a,"redirectUrl",this.h):Me(a.a,"redirectUrl");this.g?I(a,"eventId",this.g):Me(a.a,"eventId");this.i?I(a,"v",this.i):Me(a.a,"v");if(this.b)for(var g in this.b)this.b.hasOwnProperty(g)&&!De(a,g)&&I(a,g,this.b[g]);this.f?I(a,"eid",this.f):Me(a.a,"eid");g=Ni(this.c);g.length&&I(a,"fw",g.join(","));return a.toString()};function Ni(a){try{return firebase.app(a).auth().Ka()}catch(b){return[]}}
	function Oi(a,b,c,d,e){this.u=a;this.f=b;this.b=c;this.c=d||null;this.h=e||null;this.m=this.o=this.v=null;this.g=[];this.l=this.a=null}
	function Pi(a){var b=wf();return Yh(a).then(function(a){a:{var c=Ee(b),e=c.c;c=c.b;for(var f=0;f<a.length;f++){var g=a[f];var l=c;var n=e;0==g.indexOf("chrome-extension://")?l=Ee(g).b==l&&"chrome-extension"==n:"http"!=n&&"https"!=n?l=!1:Hf.test(g)?l=l==g:(g=g.split(".").join("\\."),l=(new RegExp("^(.+\\."+g+"|"+g+")$","i")).test(l));if(l){a=!0;break a}}a=!1}if(!a)throw new Bh(wf());})}
	function Qi(a){if(a.l)return a.l;a.l=If().then(function(){if(!a.o){var b=a.c,c=a.h,d=Ni(a.b),e=new Li(a.u,a.f,a.b);e.f=b;e.b=c;e.c=La(d||[]);a.o=e.toString()}a.i=new Ci(a.o);Ri(a)});return a.l}h=Oi.prototype;h.Ca=function(a,b,c){var d=new N("popup-closed-by-user"),e=new N("web-storage-unsupported"),f=this,g=!1;return this.ba().then(function(){Si(f).then(function(c){c||(a&&Df(a),b(e),g=!0)})}).s(function(){}).then(function(){if(!g)return Gf(a)}).then(function(){if(!g)return sd(c).then(function(){b(d)})})};
	h.Db=function(){var a=J();return!Uf(a)&&!Yf(a)};h.yb=function(){return!1};
	h.vb=function(a,b,c,d,e,f,g){if(!a)return B(new N("popup-blocked"));if(g&&!Uf())return this.ba().s(function(b){Df(a);e(b)}),d(),A();this.a||(this.a=Pi(Ti(this)));var l=this;return this.a.then(function(){var b=l.ba().s(function(b){Df(a);e(b);throw b;});d();return b}).then(function(){wh(c);if(!g){var d=Ui(l.u,l.f,l.b,b,c,null,f,l.c,void 0,l.h);xf(d,a)}}).s(function(a){"auth/network-request-failed"==a.code&&(l.a=null);throw a;})};
	function Ti(a){a.m||(a.v=a.c?Pf(a.c,Ni(a.b)):null,a.m=new Fh(a.f,Ai(a.h),a.v));return a.m}h.Aa=function(a,b,c){this.a||(this.a=Pi(Ti(this)));var d=this;return this.a.then(function(){wh(b);var e=Ui(d.u,d.f,d.b,a,b,wf(),c,d.c,void 0,d.h);xf(e)}).s(function(a){"auth/network-request-failed"==a.code&&(d.a=null);throw a;})};h.ba=function(){var a=this;return Qi(this).then(function(){return a.i.Ya}).s(function(){a.a=null;throw new N("network-request-failed");})};h.Hb=function(){return!0};
	function Ui(a,b,c,d,e,f,g,l,n,D){a=new Mi(a,b,c,d,e);a.h=f;a.g=g;a.i=l;a.b=Ua(n||null);a.f=D;return a.toString()}function Ri(a){if(!a.i)throw Error("IfcHandler must be initialized!");Hi(a.i,function(b){var c={};if(b&&b.authEvent){var d=!1;b=yh(b.authEvent);for(c=0;c<a.g.length;c++)d=a.g[c](b)||d;c={};c.status=d?"ACK":"ERROR";return A(c)}c.status="ERROR";return A(c)})}
	function Si(a){var b={type:"webStorageSupport"};return Qi(a).then(function(){return Gi(a.i,b)}).then(function(a){if(a&&a.length&&"undefined"!==typeof a[0].webStorageSupport)return a[0].webStorageSupport;throw Error();})}h.ua=function(a){this.g.push(a)};h.Ja=function(a){Ja(this.g,function(b){return b==a})};function Vi(a){this.a=a||firebase.INTERNAL.reactNative&&firebase.INTERNAL.reactNative.AsyncStorage;if(!this.a)throw new N("internal-error","The React Native compatibility library was not found.");}h=Vi.prototype;h.get=function(a){return A(this.a.getItem(a)).then(function(a){return a&&Xf(a)})};h.set=function(a,b){return A(this.a.setItem(a,Vf(b)))};h.X=function(a){return A(this.a.removeItem(a))};h.ia=function(){};h.da=function(){};function Wi(){this.a={}}h=Wi.prototype;h.get=function(a){return A(this.a[a])};h.set=function(a,b){this.a[a]=b;return A()};h.X=function(a){delete this.a[a];return A()};h.ia=function(){};h.da=function(){};function Xi(a,b,c,d,e,f){try{var g=!!k.indexedDB}catch(l){g=!1}if(!g)throw new N("web-storage-unsupported");this.u=a;this.h=b;this.g=c;this.l=d;this.m=e;this.f={};this.c=[];this.a=0;this.o=f||k.indexedDB}var Yi;function Zi(a){return new z(function(b,c){var d=a.o.open(a.u,a.m);d.onerror=function(a){c(Error(a.target.errorCode))};d.onupgradeneeded=function(b){b=b.target.result;try{b.createObjectStore(a.h,{keyPath:a.g})}catch(f){c(f)}};d.onsuccess=function(a){b(a.target.result)}})}
	function $i(a){a.i||(a.i=Zi(a));return a.i}function aj(a,b){return b.objectStore(a.h)}function bj(a,b,c){return b.transaction([a.h],c?"readwrite":"readonly")}function cj(a){return new z(function(b,c){a.onsuccess=function(a){a&&a.target?b(a.target.result):b()};a.onerror=function(a){c(Error(a.target.errorCode))}})}h=Xi.prototype;
	h.set=function(a,b){var c=!1,d,e=this;return Qb($i(this).then(function(b){d=b;b=aj(e,bj(e,d,!0));return cj(b.get(a))}).then(function(f){var g=aj(e,bj(e,d,!0));if(f)return f.value=b,cj(g.put(f));e.a++;c=!0;f={};f[e.g]=a;f[e.l]=b;return cj(g.add(f))}).then(function(){e.f[a]=b}),function(){c&&e.a--})};h.get=function(a){var b=this;return $i(this).then(function(c){return cj(aj(b,bj(b,c,!1)).get(a))}).then(function(a){return a&&a.value})};
	h.X=function(a){var b=!1,c=this;return Qb($i(this).then(function(d){b=!0;c.a++;return cj(aj(c,bj(c,d,!0))["delete"](a))}).then(function(){delete c.f[a]}),function(){b&&c.a--})};
	h.zc=function(){var a=this;return $i(this).then(function(b){var c=aj(a,bj(a,b,!1));return c.getAll?cj(c.getAll()):new z(function(a,b){var d=[],e=c.openCursor();e.onsuccess=function(b){(b=b.target.result)?(d.push(b.value),b["continue"]()):a(d)};e.onerror=function(a){b(Error(a.target.errorCode))}})}).then(function(b){var c={},d=[];if(0==a.a){for(d=0;d<b.length;d++)c[b[d][a.g]]=b[d][a.l];d=yf(a.f,c);a.f=c}return d})};h.ia=function(a){0==this.c.length&&dj(this);this.c.push(a)};
	h.da=function(a){Ja(this.c,function(b){return b==a});0==this.c.length&&this.b&&this.b.cancel("STOP_EVENT")};function dj(a){function b(){a.b=sd(800).then(r(a.zc,a)).then(function(b){0<b.length&&w(a.c,function(a){a(b)})}).then(b).s(function(a){"STOP_EVENT"!=a.message&&b()});return a.b}a.b&&a.b.cancel("STOP_EVENT");b()};function ej(){if(!fj()){if("Node"==K())throw new N("internal-error","The LocalStorage compatibility library was not found.");throw new N("web-storage-unsupported");}this.a=gj()||firebase.INTERNAL.node.localStorage}function gj(){try{var a=k.localStorage,b=Rf();a&&(a.setItem(b,"1"),a.removeItem(b));return a}catch(c){return null}}
	function fj(){var a="Node"==K();a=gj()||a&&firebase.INTERNAL.node&&firebase.INTERNAL.node.localStorage;if(!a)return!1;try{return a.setItem("__sak","1"),a.removeItem("__sak"),!0}catch(b){return!1}}h=ej.prototype;h.get=function(a){var b=this;return A().then(function(){var c=b.a.getItem(a);return Xf(c)})};h.set=function(a,b){var c=this;return A().then(function(){var d=Vf(b);null===d?c.X(a):c.a.setItem(a,d)})};h.X=function(a){var b=this;return A().then(function(){b.a.removeItem(a)})};
	h.ia=function(a){k.window&&cd(k.window,"storage",a)};h.da=function(a){k.window&&E(k.window,"storage",a)};function hj(){}h=hj.prototype;h.get=function(){return A(null)};h.set=function(){return A()};h.X=function(){return A()};h.ia=function(){};h.da=function(){};function ij(){if(!jj()){if("Node"==K())throw new N("internal-error","The SessionStorage compatibility library was not found.");throw new N("web-storage-unsupported");}this.a=kj()||firebase.INTERNAL.node.sessionStorage}function kj(){try{var a=k.sessionStorage,b=Rf();a&&(a.setItem(b,"1"),a.removeItem(b));return a}catch(c){return null}}
	function jj(){var a="Node"==K();a=kj()||a&&firebase.INTERNAL.node&&firebase.INTERNAL.node.sessionStorage;if(!a)return!1;try{return a.setItem("__sak","1"),a.removeItem("__sak"),!0}catch(b){return!1}}h=ij.prototype;h.get=function(a){var b=this;return A().then(function(){var c=b.a.getItem(a);return Xf(c)})};h.set=function(a,b){var c=this;return A().then(function(){var d=Vf(b);null===d?c.X(a):c.a.setItem(a,d)})};h.X=function(a){var b=this;return A().then(function(){b.a.removeItem(a)})};h.ia=function(){};
	h.da=function(){};function lj(){var a={};a.Browser=mj;a.Node=nj;a.ReactNative=oj;this.a=a[K()]}var pj,mj={C:ej,jb:ij},nj={C:ej,jb:ij},oj={C:Vi,jb:hj};var qj={Lc:"local",NONE:"none",Nc:"session"};function rj(a){var b=new N("invalid-persistence-type"),c=new N("unsupported-persistence-type");a:{for(d in qj)if(qj[d]==a){var d=!0;break a}d=!1}if(!d||"string"!==typeof a)throw b;switch(K()){case "ReactNative":if("session"===a)throw c;break;case "Node":if("none"!==a)throw c;break;default:if(!Qf()&&"none"!==a)throw c;}}
	function sj(a,b,c,d,e){this.i=a;this.g=b;this.A=c;this.u=d;this.v=e;this.a={};pj||(pj=new lj);a=pj;try{if(vf()){Yi||(Yi=new Xi("firebaseLocalStorageDb","firebaseLocalStorage","fbase_key","value",1));var f=Yi}else f=new a.a.C;this.l=f}catch(g){this.l=new Wi,this.u=!0}try{this.o=new a.a.jb}catch(g){this.o=new Wi}this.w=new Wi;this.h=r(this.m,this);this.b={}}var tj;function uj(){tj||(tj=new sj("firebase",":",!Yf(J())&&Mf()?!0:!1,Uf(),Qf()));return tj}
	function vj(a,b){switch(b){case "session":return a.o;case "none":return a.w;default:return a.l}}function wj(a,b,c){return a.i+a.g+b.name+(c?a.g+c:"")}sj.prototype.get=function(a,b){return vj(this,a.C).get(wj(this,a,b))};function xj(a,b,c){c=wj(a,b,c);"local"==b.C&&(a.b[c]=null);return vj(a,b.C).X(c)}sj.prototype.set=function(a,b,c){var d=wj(this,a,c),e=this,f=vj(this,a.C);return f.set(d,b).then(function(){return f.get(d)}).then(function(b){"local"==a.C&&(e.b[d]=b)})};
	function yj(a,b,c,d){b=wj(a,b,c);a.v&&(a.b[b]=k.localStorage.getItem(b));Sa(a.a)&&(vj(a,"local").ia(a.h),a.u||vf()||!a.v||zj(a));a.a[b]||(a.a[b]=[]);a.a[b].push(d)}function Aj(a,b,c){b=wj(a,Bj("local"),b);a.a[b]&&(Ja(a.a[b],function(a){return a==c}),0==a.a[b].length&&delete a.a[b]);Sa(a.a)&&Cj(a)}
	function zj(a){Dj(a);a.f=setInterval(function(){for(var b in a.a){var c=k.localStorage.getItem(b),d=a.b[b];c!=d&&(a.b[b]=c,c=new Qc({type:"storage",key:b,target:window,oldValue:d,newValue:c,a:!0}),a.m(c))}},1E3)}function Dj(a){a.f&&(clearInterval(a.f),a.f=null)}function Cj(a){vj(a,"local").da(a.h);Dj(a)}
	sj.prototype.m=function(a){if(a&&a.g){var b=a.a.key;if(null==b)for(var c in this.a){var d=this.b[c];"undefined"===typeof d&&(d=null);var e=k.localStorage.getItem(c);e!==d&&(this.b[c]=e,this.c(c))}else if(0==b.indexOf(this.i+this.g)&&this.a[b]){"undefined"!==typeof a.a.a?vj(this,"local").da(this.h):Dj(this);if(this.A)if(c=k.localStorage.getItem(b),d=a.a.newValue,d!==c)null!==d?k.localStorage.setItem(b,d):k.localStorage.removeItem(b);else if(this.b[b]===d&&"undefined"===typeof a.a.a)return;var f=this;
	c=function(){if("undefined"!==typeof a.a.a||f.b[b]!==k.localStorage.getItem(b))f.b[b]=k.localStorage.getItem(b),f.c(b)};y&&kb&&10==kb&&k.localStorage.getItem(b)!==a.a.newValue&&a.a.newValue!==a.a.oldValue?setTimeout(c,10):c()}}else w(a,r(this.c,this))};sj.prototype.c=function(a){this.a[a]&&w(this.a[a],function(a){a()})};function Ej(a){this.a=a;this.b=uj()}var Fj={name:"authEvent",C:"local"};function Gj(a){return a.b.get(Fj,a.a).then(function(a){return yh(a)})};function Hj(){this.a=uj()};function Ij(a,b,c,d,e,f,g){this.u=a;this.i=b;this.l=c;this.m=d||null;this.o=g||null;this.h=b+":"+c;this.A=new Hj;this.g=new Ej(this.h);this.f=null;this.b=[];this.v=e||500;this.w=f||2E3;this.a=this.c=null}function Jj(a){return new N("invalid-cordova-configuration",a)}h=Ij.prototype;
	h.ba=function(){return this.xa?this.xa:this.xa=Jf().then(function(){if("function"!==typeof L("universalLinks.subscribe",k))throw Jj("cordova-universal-links-plugin is not installed");if("undefined"===typeof L("BuildInfo.packageName",k))throw Jj("cordova-plugin-buildinfo is not installed");if("function"!==typeof L("cordova.plugins.browsertab.openUrl",k))throw Jj("cordova-plugin-browsertab is not installed");if("function"!==typeof L("cordova.InAppBrowser.open",k))throw Jj("cordova-plugin-inappbrowser is not installed");
	},function(){throw new N("cordova-not-ready");})};function Kj(){for(var a=20,b=[];0<a;)b.push("1234567890abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ".charAt(Math.floor(62*Math.random()))),a--;return b.join("")}function Lj(a){var b=new je;ie(b,a);a=[];var c=8*b.g;56>b.c?ie(b,ge,56-b.c):ie(b,ge,b.b-(b.c-56));for(var d=63;56<=d;d--)b.f[d]=c&255,c/=256;he(b);for(d=c=0;d<b.i;d++)for(var e=24;0<=e;e-=8)a[c++]=b.a[d]>>e&255;return Id(a)}
	h.Ca=function(a,b){b(new N("operation-not-supported-in-this-environment"));return A()};h.vb=function(){return B(new N("operation-not-supported-in-this-environment"))};h.Hb=function(){return!1};h.Db=function(){return!0};h.yb=function(){return!0};
	h.Aa=function(a,b,c){if(this.c)return B(new N("redirect-operation-pending"));var d=this,e=k.document,f=null,g=null,l=null,n=null;return this.c=Qb(A().then(function(){wh(b);return Mj(d)}).then(function(){return Nj(d,a,b,c)}).then(function(){return(new z(function(a,b){g=function(){var b=L("cordova.plugins.browsertab.close",k);a();"function"===typeof b&&b();d.a&&"function"===typeof d.a.close&&(d.a.close(),d.a=null);return!1};d.ua(g);l=function(){f||(f=sd(d.w).then(function(){b(new N("redirect-cancelled-by-user"))}))};
	n=function(){bg()&&l()};e.addEventListener("resume",l,!1);J().toLowerCase().match(/android/)||e.addEventListener("visibilitychange",n,!1)})).s(function(a){return Oj(d).then(function(){throw a;})})}),function(){l&&e.removeEventListener("resume",l,!1);n&&e.removeEventListener("visibilitychange",n,!1);f&&f.cancel();g&&d.Ja(g);d.c=null})};
	function Nj(a,b,c,d){var e=Kj(),f=new xh(b,d,null,e,new N("no-auth-event")),g=L("BuildInfo.packageName",k);if("string"!==typeof g)throw new N("invalid-cordova-configuration");var l=L("BuildInfo.displayName",k),n={};if(J().toLowerCase().match(/iphone|ipad|ipod/))n.ibi=g;else if(J().toLowerCase().match(/android/))n.apn=g;else return B(new N("operation-not-supported-in-this-environment"));l&&(n.appDisplayName=l);e=Lj(e);n.sessionId=e;var D=Ui(a.u,a.i,a.l,b,c,null,d,a.m,n,a.o);return a.ba().then(function(){var b=
	a.h;return a.A.a.set(Fj,f.B(),b)}).then(function(){var b=L("cordova.plugins.browsertab.isAvailable",k);if("function"!==typeof b)throw new N("invalid-cordova-configuration");var c=null;b(function(b){if(b){c=L("cordova.plugins.browsertab.openUrl",k);if("function"!==typeof c)throw new N("invalid-cordova-configuration");c(D)}else{c=L("cordova.InAppBrowser.open",k);if("function"!==typeof c)throw new N("invalid-cordova-configuration");b=J();b=!(!b.match(/(iPad|iPhone|iPod).*OS 7_\d/i)&&!b.match(/(iPad|iPhone|iPod).*OS 8_\d/i));
	a.a=c(D,b?"_blank":"_system","location=yes")}})})}function Pj(a,b){for(var c=0;c<a.b.length;c++)try{a.b[c](b)}catch(d){}}function Mj(a){a.f||(a.f=a.ba().then(function(){return new z(function(b){function c(d){b(d);a.Ja(c);return!1}a.ua(c);Qj(a)})}));return a.f}function Oj(a){var b=null;return Gj(a.g).then(function(c){b=c;c=a.g;return xj(c.b,Fj,c.a)}).then(function(){return b})}
	function Qj(a){function b(b){d=!0;e&&e.cancel();Oj(a).then(function(d){var e=c;if(d&&b&&b.url){e=null;var f=b.url;var g=Ee(f),l=De(g,"link"),Hd=De(Ee(l),"link");g=De(g,"deep_link_id");f=De(Ee(g),"link")||g||Hd||l||f;-1!=f.indexOf("/__/auth/callback")&&(e=Ee(f),e=Xf(De(e,"firebaseError")||null),e=(e="object"===typeof e?wg(e):null)?new xh(d.b,d.c,null,null,e):new xh(d.b,d.c,f,d.g));e=e||c}Pj(a,e)})}var c=new xh("unknown",null,null,null,new N("no-auth-event")),d=!1,e=sd(a.v).then(function(){return Oj(a).then(function(){d||
	Pj(a,c)})}),f=k.handleOpenURL;k.handleOpenURL=function(a){0==a.toLowerCase().indexOf(L("BuildInfo.packageName",k).toLowerCase()+"://")&&b({url:a});if("function"===typeof f)try{f(a)}catch(l){console.error(l)}};Ah||(Ah=new zh);Ah.subscribe(b)}h.ua=function(a){this.b.push(a);Mj(this).s(function(b){"auth/invalid-cordova-configuration"===b.code&&(b=new xh("unknown",null,null,null,new N("no-auth-event")),a(b))})};h.Ja=function(a){Ja(this.b,function(b){return b==a})};function Rj(a){this.a=a;this.b=uj()}var Sj={name:"pendingRedirect",C:"session"};function Tj(a){return a.b.set(Sj,"pending",a.a)}function Uj(a){return xj(a.b,Sj,a.a)}function Vj(a){return a.b.get(Sj,a.a).then(function(a){return"pending"==a})};function Wj(a,b,c){this.v=a;this.l=b;this.u=c;this.h=[];this.f=!1;this.i=r(this.m,this);this.c=new Xj;this.o=new Yj;this.g=new Rj(this.l+":"+this.u);this.b={};this.b.unknown=this.c;this.b.signInViaRedirect=this.c;this.b.linkViaRedirect=this.c;this.b.reauthViaRedirect=this.c;this.b.signInViaPopup=this.o;this.b.linkViaPopup=this.o;this.b.reauthViaPopup=this.o;this.a=Zj(this.v,this.l,this.u,Bi)}
	function Zj(a,b,c,d){var e=firebase.SDK_VERSION||null;return Kf()?new Ij(a,b,c,e,void 0,void 0,d):new Oi(a,b,c,e,d)}Wj.prototype.reset=function(){this.f=!1;this.a.Ja(this.i);this.a=Zj(this.v,this.l,this.u)};function ak(a){a.f||(a.f=!0,a.a.ua(a.i));var b=a.a;return a.a.ba().s(function(c){a.a==b&&a.reset();throw c;})}function bk(a){a.a.Db()&&ak(a).s(function(b){var c=new xh("unknown",null,null,null,new N("operation-not-supported-in-this-environment"));ck(b)&&a.m(c)});a.a.yb()||dk(a.c)}
	Wj.prototype.subscribe=function(a){Ha(this.h,a)||this.h.push(a);if(!this.f){var b=this;Vj(this.g).then(function(a){a?Uj(b.g).then(function(){ak(b).s(function(a){var c=new xh("unknown",null,null,null,new N("operation-not-supported-in-this-environment"));ck(a)&&b.m(c)})}):bk(b)}).s(function(){bk(b)})}};Wj.prototype.unsubscribe=function(a){Ja(this.h,function(b){return b==a})};
	Wj.prototype.m=function(a){if(!a)throw new N("invalid-auth-event");for(var b=!1,c=0;c<this.h.length;c++){var d=this.h[c];if(d.ob(a.b,a.c)){(b=this.b[a.b])&&b.h(a,d);b=!0;break}}dk(this.c);return b};var ek=new ag(2E3,1E4),fk=new ag(3E4,6E4);Wj.prototype.aa=function(){return this.c.aa()};function gk(a,b,c,d,e,f){return a.a.vb(b,c,d,function(){a.f||(a.f=!0,a.a.ua(a.i))},function(){a.reset()},e,f)}function ck(a){return a&&"auth/cordova-not-ready"==a.code?!0:!1}
	Wj.prototype.Aa=function(a,b,c){var d=this,e;return Tj(this.g).then(function(){return d.a.Aa(a,b,c).s(function(a){if(ck(a))throw new N("operation-not-supported-in-this-environment");e=a;return Uj(d.g).then(function(){throw e;})}).then(function(){return d.a.Hb()?new z(function(){}):Uj(d.g).then(function(){return d.aa()}).then(function(){}).s(function(){})})})};Wj.prototype.Ca=function(a,b,c,d){return this.a.Ca(c,function(c){a.fa(b,null,c,d)},ek.get())};var hk={};
	function ik(a,b,c){var d=b+":"+c;hk[d]||(hk[d]=new Wj(a,b,c));return hk[d]}function Xj(){this.b=null;this.f=[];this.c=[];this.a=null;this.g=!1}Xj.prototype.reset=function(){this.b=null;this.a&&(this.a.cancel(),this.a=null)};
	Xj.prototype.h=function(a,b){if(!a)return B(new N("invalid-auth-event"));this.reset();this.g=!0;var c=a.b,d=a.c,e=a.a&&"auth/web-storage-unsupported"==a.a.code,f=a.a&&"auth/operation-not-supported-in-this-environment"==a.a.code;"unknown"!=c||e||f?a.a?(jk(this,!0,null,a.a),a=A()):a=b.va(c,d)?kk(this,a,b):B(new N("invalid-auth-event")):(jk(this,!1,null,null),a=A());return a};function dk(a){a.g||(a.g=!0,jk(a,!1,null,null))}
	function kk(a,b,c){c=c.va(b.b,b.c);var d=b.f,e=b.g,f=!!b.b.match(/Redirect$/);return c(d,e).then(function(b){jk(a,f,b,null)}).s(function(b){jk(a,f,null,b)})}function lk(a,b){a.b=function(){return B(b)};if(a.c.length)for(var c=0;c<a.c.length;c++)a.c[c](b)}function mk(a,b){a.b=function(){return A(b)};if(a.f.length)for(var c=0;c<a.f.length;c++)a.f[c](b)}function jk(a,b,c,d){b?d?lk(a,d):mk(a,c):mk(a,{user:null});a.f=[];a.c=[]}
	Xj.prototype.aa=function(){var a=this;return new z(function(b,c){a.b?a.b().then(b,c):(a.f.push(b),a.c.push(c),nk(a))})};function nk(a){var b=new N("timeout");a.a&&a.a.cancel();a.a=sd(fk.get()).then(function(){a.b||jk(a,!0,null,b)})}function Yj(){}Yj.prototype.h=function(a,b){if(!a)return B(new N("invalid-auth-event"));var c=a.b,d=a.c;a.a?(b.fa(a.b,null,a.a,a.c),a=A()):a=b.va(c,d)?ok(a,b):B(new N("invalid-auth-event"));return a};
	function ok(a,b){var c=a.c,d=a.b;return b.va(d,c)(a.f,a.g).then(function(a){b.fa(d,a,null,c)}).s(function(a){b.fa(d,null,a,c)})};function pk(a,b){this.a=b;M(this,"verificationId",a)}pk.prototype.confirm=function(a){a=uh(this.verificationId,a);return this.a(a)};function qk(a,b,c,d){return(new sh(a)).Qa(b,c).then(function(a){return new pk(a,d)})};function rk(a,b,c,d,e,f){this.h=a;this.i=b;this.g=c;this.c=d;this.f=e;this.l=!!f;this.b=null;this.a=this.c;if(this.f<this.c)throw Error("Proactive refresh lower bound greater than upper bound!");}rk.prototype.start=function(){this.a=this.c;sk(this,!0)};function tk(a,b){if(b)return a.a=a.c,a.g();b=a.a;a.a*=2;a.a>a.f&&(a.a=a.f);return b}
	function sk(a,b){uk(a);a.b=sd(tk(a,b)).then(function(){return a.l?A():cg()}).then(function(){return a.h()}).then(function(){sk(a,!0)}).s(function(b){a.i(b)&&sk(a,!1)})}function uk(a){a.b&&(a.b.cancel(),a.b=null)};function vk(a){this.f=a;this.b=this.a=null;this.c=0}vk.prototype.B=function(){return{apiKey:this.f.b,refreshToken:this.a,accessToken:this.b,expirationTime:this.c}};function wk(a,b){var c=b[O],d=b.refreshToken;b=xk(b.expiresIn);a.b=c;a.c=b;a.a=d}function xk(a){return na()+1E3*parseInt(a,10)}
	function yk(a,b){return Rh(a.f,b).then(function(b){a.b=b.access_token;a.c=xk(b.expires_in);a.a=b.refresh_token;return{accessToken:a.b,expirationTime:a.c,refreshToken:a.a}}).s(function(b){"auth/user-token-expired"==b.code&&(a.a=null);throw b;})}vk.prototype.getToken=function(a){a=!!a;return this.b&&!this.a?B(new N("user-token-expired")):a||!this.b||na()>this.c-3E4?this.a?yk(this,{grant_type:"refresh_token",refresh_token:this.a}):A(null):A({accessToken:this.b,expirationTime:this.c,refreshToken:this.a})};function zk(a,b){this.a=a||null;this.b=b||null;hg(this,{lastSignInTime:dg(b||null),creationTime:dg(a||null)})}function Ak(a){return new zk(a.a,a.b)}zk.prototype.B=function(){return{lastLoginAt:this.b,createdAt:this.a}};function Bk(a,b,c,d,e,f){hg(this,{uid:a,displayName:d||null,photoURL:e||null,email:c||null,phoneNumber:f||null,providerId:b})}function Ck(a,b){C.call(this,a);for(var c in b)this[c]=b[c]}t(Ck,C);
	function Dk(a,b,c){this.A=[];this.G=a.apiKey;this.o=a.appName;this.w=a.authDomain||null;a=firebase.SDK_VERSION?Pf(firebase.SDK_VERSION):null;this.c=new Fh(this.G,Ai(Bi),a);this.h=new vk(this.c);Ek(this,b[O]);wk(this.h,b);M(this,"refreshToken",this.h.a);Fk(this,c||{});F.call(this);this.I=!1;this.w&&Sf()&&(this.a=ik(this.w,this.G,this.o));this.N=[];this.i=null;this.l=Gk(this);this.U=r(this.Ga,this);var d=this;this.ha=null;this.ra=function(a){d.na(a.h)};this.W=null;this.R=[];this.qa=function(a){Hk(d,
	a.f)};this.V=null}t(Dk,F);Dk.prototype.na=function(a){this.ha=a;Lh(this.c,a)};Dk.prototype.$=function(){return this.ha};function Ik(a,b){a.W&&E(a.W,"languageCodeChanged",a.ra);(a.W=b)&&cd(b,"languageCodeChanged",a.ra)}function Hk(a,b){a.R=b;Mh(a.c,firebase.SDK_VERSION?Pf(firebase.SDK_VERSION,a.R):null)}Dk.prototype.Ka=function(){return La(this.R)};function Jk(a,b){a.V&&E(a.V,"frameworkChanged",a.qa);(a.V=b)&&cd(b,"frameworkChanged",a.qa)}Dk.prototype.Ga=function(){this.l.b&&(uk(this.l),this.l.start())};
	function Kk(a){try{return firebase.app(a.o).auth()}catch(b){throw new N("internal-error","No firebase.auth.Auth instance is available for the Firebase App '"+a.o+"'!");}}function Gk(a){return new rk(function(){return a.F(!0)},function(a){return a&&"auth/network-request-failed"==a.code?!0:!1},function(){var b=a.h.c-na()-3E5;return 0<b?b:0},3E4,96E4,!1)}function Lk(a){a.m||a.l.b||(a.l.start(),E(a,"tokenChanged",a.U),cd(a,"tokenChanged",a.U))}function Mk(a){E(a,"tokenChanged",a.U);uk(a.l)}
	function Ek(a,b){a.pa=b;M(a,"_lat",b)}function Nk(a,b){Ja(a.N,function(a){return a==b})}function Ok(a){for(var b=[],c=0;c<a.N.length;c++)b.push(a.N[c](a));return Ob(b).then(function(){return a})}function Pk(a){a.a&&!a.I&&(a.I=!0,a.a.subscribe(a))}
	function Fk(a,b){hg(a,{uid:b.uid,displayName:b.displayName||null,photoURL:b.photoURL||null,email:b.email||null,emailVerified:b.emailVerified||!1,phoneNumber:b.phoneNumber||null,isAnonymous:b.isAnonymous||!1,metadata:new zk(b.createdAt,b.lastLoginAt),providerData:[]})}M(Dk.prototype,"providerId","firebase");function Qk(){}function Rk(a){return A().then(function(){if(a.m)throw new N("app-deleted");})}function Sk(a){return Da(a.providerData,function(a){return a.providerId})}
	function Tk(a,b){b&&(Uk(a,b.providerId),a.providerData.push(b))}function Uk(a,b){Ja(a.providerData,function(a){return a.providerId==b})}function Vk(a,b,c){("uid"!=b||c)&&a.hasOwnProperty(b)&&M(a,b,c)}
	function Wk(a,b){a!=b&&(hg(a,{uid:b.uid,displayName:b.displayName,photoURL:b.photoURL,email:b.email,emailVerified:b.emailVerified,phoneNumber:b.phoneNumber,isAnonymous:b.isAnonymous,providerData:[]}),b.metadata?M(a,"metadata",Ak(b.metadata)):M(a,"metadata",new zk),w(b.providerData,function(b){Tk(a,b)}),a.h=b.h,M(a,"refreshToken",a.h.a))}h=Dk.prototype;h.reload=function(){var a=this;return R(this,Rk(this).then(function(){return Xk(a).then(function(){return Ok(a)}).then(Qk)}))};
	function Xk(a){return a.F().then(function(b){var c=a.isAnonymous;return Yk(a,b).then(function(){c||Vk(a,"isAnonymous",!1);return b})})}h.F=function(a){var b=this;return R(this,Rk(this).then(function(){return b.h.getToken(a)}).then(function(a){if(!a)throw new N("internal-error");a.accessToken!=b.pa&&(Ek(b,a.accessToken),G(b,new Ck("tokenChanged")));Vk(b,"refreshToken",a.refreshToken);return a.accessToken}))};
	h.getToken=function(a){eg["firebase.User.prototype.getToken is deprecated. Please use firebase.User.prototype.getIdToken instead."]||(eg["firebase.User.prototype.getToken is deprecated. Please use firebase.User.prototype.getIdToken instead."]=!0,"undefined"!==typeof console&&"function"===typeof console.warn&&console.warn("firebase.User.prototype.getToken is deprecated. Please use firebase.User.prototype.getIdToken instead."));return this.F(a)};
	function Zk(a,b){b[O]&&a.pa!=b[O]&&(wk(a.h,b),G(a,new Ck("tokenChanged")),Ek(a,b[O]),Vk(a,"refreshToken",a.h.a))}function Yk(a,b){return Q(a.c,wi,{idToken:b}).then(r(a.kc,a))}
	h.kc=function(a){a=a.users;if(!a||!a.length)throw new N("internal-error");a=a[0];Fk(this,{uid:a.localId,displayName:a.displayName,photoURL:a.photoUrl,email:a.email,emailVerified:!!a.emailVerified,phoneNumber:a.phoneNumber,lastLoginAt:a.lastLoginAt,createdAt:a.createdAt});for(var b=$k(a),c=0;c<b.length;c++)Tk(this,b[c]);Vk(this,"isAnonymous",!(this.email&&a.passwordHash)&&!(this.providerData&&this.providerData.length))};
	function $k(a){return(a=a.providerUserInfo)&&a.length?Da(a,function(a){return new Bk(a.rawId,a.providerId,a.email,a.displayName,a.photoUrl,a.phoneNumber)}):[]}h.Za=function(a){var b=this,c=null;return R(this,a.c(this.c,this.uid).then(function(a){Zk(b,a);c=al(b,a,"reauthenticate");b.i=null;return b.reload()}).then(function(){return c}),!0)};h.mc=function(a){return this.Za(a).then(function(){})};
	function bl(a,b){return Xk(a).then(function(){if(Ha(Sk(a),b))return Ok(a).then(function(){throw new N("provider-already-linked");})})}h.Xa=function(a){var b=this,c=null;return R(this,bl(this,a.providerId).then(function(){return b.F()}).then(function(c){return a.b(b.c,c)}).then(function(a){c=al(b,a,"link");return cl(b,a)}).then(function(){return c}))};h.cc=function(a){return this.Xa(a).then(function(a){return a.user})};
	h.dc=function(a,b){var c=this;return R(this,bl(this,"phone").then(function(){return qk(Kk(c),a,b,r(c.Xa,c))}))};h.nc=function(a,b){var c=this;return R(this,A().then(function(){return qk(Kk(c),a,b,r(c.Za,c))}),!0)};function al(a,b,c){var d=vh(b);b=Ng(b);return ig({user:a,credential:d,additionalUserInfo:b,operationType:c})}function cl(a,b){Zk(a,b);return a.reload().then(function(){return a})}
	h.kb=function(a){var b=this;return R(this,this.F().then(function(c){return b.c.kb(c,a)}).then(function(a){Zk(b,a);return b.reload()}))};h.Dc=function(a){var b=this;return R(this,this.F().then(function(c){return a.b(b.c,c)}).then(function(a){Zk(b,a);return b.reload()}))};h.lb=function(a){var b=this;return R(this,this.F().then(function(c){return b.c.lb(c,a)}).then(function(a){Zk(b,a);return b.reload()}))};
	h.mb=function(a){if(void 0===a.displayName&&void 0===a.photoURL)return Rk(this);var b=this;return R(this,this.F().then(function(c){return b.c.mb(c,{displayName:a.displayName,photoUrl:a.photoURL})}).then(function(a){Zk(b,a);Vk(b,"displayName",a.displayName||null);Vk(b,"photoURL",a.photoUrl||null);w(b.providerData,function(a){"password"===a.providerId&&(M(a,"displayName",b.displayName),M(a,"photoURL",b.photoURL))});return Ok(b)}).then(Qk))};
	h.Cc=function(a){var b=this;return R(this,Xk(this).then(function(c){return Ha(Sk(b),a)?ii(b.c,c,[a]).then(function(a){var c={};w(a.providerUserInfo||[],function(a){c[a.providerId]=!0});w(Sk(b),function(a){c[a]||Uk(b,a)});c[sh.PROVIDER_ID]||M(b,"phoneNumber",null);return Ok(b)}):Ok(b).then(function(){throw new N("no-such-provider");})}))};
	h.delete=function(){var a=this;return R(this,this.F().then(function(b){return Q(a.c,vi,{idToken:b})}).then(function(){G(a,new Ck("userDeleted"))})).then(function(){for(var b=0;b<a.A.length;b++)a.A[b].cancel("app-deleted");Ik(a,null);Jk(a,null);a.A=[];a.m=!0;Mk(a);M(a,"refreshToken",null);a.a&&a.a.unsubscribe(a)})};
	h.ob=function(a,b){return"linkViaPopup"==a&&(this.g||null)==b&&this.f||"reauthViaPopup"==a&&(this.g||null)==b&&this.f||"linkViaRedirect"==a&&(this.Z||null)==b||"reauthViaRedirect"==a&&(this.Z||null)==b?!0:!1};h.fa=function(a,b,c,d){"linkViaPopup"!=a&&"reauthViaPopup"!=a||d!=(this.g||null)||(c&&this.v?this.v(c):b&&!c&&this.f&&this.f(b),this.b&&(this.b.cancel(),this.b=null),delete this.f,delete this.v)};
	h.va=function(a,b){return"linkViaPopup"==a&&b==(this.g||null)?r(this.tb,this):"reauthViaPopup"==a&&b==(this.g||null)?r(this.ub,this):"linkViaRedirect"==a&&(this.Z||null)==b?r(this.tb,this):"reauthViaRedirect"==a&&(this.Z||null)==b?r(this.ub,this):null};h.ec=function(a){var b=this;return dl(this,"linkViaPopup",a,function(){return bl(b,a.providerId).then(function(){return Ok(b)})},!1)};h.oc=function(a){return dl(this,"reauthViaPopup",a,function(){return A()},!0)};
	function dl(a,b,c,d,e){if(!Sf())return B(new N("operation-not-supported-in-this-environment"));if(a.i&&!e)return B(a.i);var f=Mg(c.providerId),g=Rf(a.uid+":::"),l=null;(!Uf()||Mf())&&a.w&&c.isOAuthProvider&&(l=Ui(a.w,a.G,a.o,b,c,null,g,firebase.SDK_VERSION||null));var n=Ef(l,f&&f.za,f&&f.ya);d=d().then(function(){el(a);if(!e)return a.F().then(function(){})}).then(function(){return gk(a.a,n,b,c,g,!!l)}).then(function(){return new z(function(c,d){a.fa(b,null,new N("cancelled-popup-request"),a.g||null);
	a.f=c;a.v=d;a.g=g;a.b=a.a.Ca(a,b,n,g)})}).then(function(a){n&&Df(n);return a?ig(a):null}).s(function(a){n&&Df(n);throw a;});return R(a,d,e)}h.fc=function(a){var b=this;return fl(this,"linkViaRedirect",a,function(){return bl(b,a.providerId)},!1)};h.pc=function(a){return fl(this,"reauthViaRedirect",a,function(){return A()},!0)};
	function fl(a,b,c,d,e){if(!Sf())return B(new N("operation-not-supported-in-this-environment"));if(a.i&&!e)return B(a.i);var f=null,g=Rf(a.uid+":::");d=d().then(function(){el(a);if(!e)return a.F().then(function(){})}).then(function(){a.Z=g;return Ok(a)}).then(function(b){a.ca&&(b=a.ca,b=b.b.set(gl,a.B(),b.a));return b}).then(function(){return a.a.Aa(b,c,g)}).s(function(b){f=b;if(a.ca)return hl(a.ca);throw f;}).then(function(){if(f)throw f;});return R(a,d,e)}
	function el(a){if(!a.a||!a.I){if(a.a&&!a.I)throw new N("internal-error");throw new N("auth-domain-config-required");}}h.tb=function(a,b){var c=this;this.b&&(this.b.cancel(),this.b=null);var d=null,e=this.F().then(function(d){return $g(c.c,{requestUri:a,sessionId:b,idToken:d})}).then(function(a){d=al(c,a,"link");return cl(c,a)}).then(function(){return d});return R(this,e)};
	h.ub=function(a,b){var c=this;this.b&&(this.b.cancel(),this.b=null);var d=null,e=A().then(function(){return Wg(ah(c.c,{requestUri:a,sessionId:b}),c.uid)}).then(function(a){d=al(c,a,"reauthenticate");Zk(c,a);c.i=null;return c.reload()}).then(function(){return d});return R(this,e,!0)};h.bb=function(a){var b=this,c=null;return R(this,this.F().then(function(b){c=b;return"undefined"===typeof a||Sa(a)?{}:Gg(new xg(a))}).then(function(a){return b.c.bb(c,a)}).then(function(a){if(b.email!=a)return b.reload()}).then(function(){}))};
	function R(a,b,c){var d=il(a,b,c);a.A.push(d);Qb(d,function(){Ia(a.A,d)});return d}function il(a,b,c){return a.i&&!c?(b.cancel(),B(a.i)):b.s(function(b){!b||"auth/user-disabled"!=b.code&&"auth/user-token-expired"!=b.code||(a.i||G(a,new Ck("userInvalidated")),a.i=b);throw b;})}h.toJSON=function(){return this.B()};
	h.B=function(){var a={uid:this.uid,displayName:this.displayName,photoURL:this.photoURL,email:this.email,emailVerified:this.emailVerified,phoneNumber:this.phoneNumber,isAnonymous:this.isAnonymous,providerData:[],apiKey:this.G,appName:this.o,authDomain:this.w,stsTokenManager:this.h.B(),redirectEventId:this.Z||null};this.metadata&&Wa(a,this.metadata.B());w(this.providerData,function(b){a.providerData.push(jg(b))});return a};
	function jl(a){if(!a.apiKey)return null;var b={apiKey:a.apiKey,authDomain:a.authDomain,appName:a.appName},c={};if(a.stsTokenManager&&a.stsTokenManager.accessToken&&a.stsTokenManager.expirationTime)c[O]=a.stsTokenManager.accessToken,c.refreshToken=a.stsTokenManager.refreshToken||null,c.expiresIn=(a.stsTokenManager.expirationTime-na())/1E3;else return null;var d=new Dk(b,c,a);a.providerData&&w(a.providerData,function(a){a&&Tk(d,ig(a))});a.redirectEventId&&(d.Z=a.redirectEventId);return d}
	function kl(a,b,c,d){var e=new Dk(a,b);c&&(e.ca=c);d&&Hk(e,d);return e.reload().then(function(){return e})};function ll(a){this.a=a;this.b=uj()}var gl={name:"redirectUser",C:"session"};function hl(a){return xj(a.b,gl,a.a)}function ml(a,b){return a.b.get(gl,a.a).then(function(a){a&&b&&(a.authDomain=b);return jl(a||{})})};function nl(a,b){this.a=a;this.b=b||uj();this.c=null;this.f=ol(this);yj(this.b,Bj("local"),this.a,r(this.g,this))}nl.prototype.g=function(){var a=this,b=Bj("local");pl(this,function(){return A().then(function(){return a.c&&"local"!=a.c.C?a.b.get(b,a.a):null}).then(function(c){if(c)return ql(a,"local").then(function(){a.c=b})})})};function ql(a,b){var c=[],d;for(d in qj)qj[d]!==b&&c.push(xj(a.b,Bj(qj[d]),a.a));c.push(xj(a.b,rl,a.a));return Nb(c)}
	function ol(a){var b=Bj("local"),c=Bj("session"),d=Bj("none");return a.b.get(c,a.a).then(function(e){return e?c:a.b.get(d,a.a).then(function(c){return c?d:a.b.get(b,a.a).then(function(c){return c?b:a.b.get(rl,a.a).then(function(a){return a?Bj(a):b})})})}).then(function(b){a.c=b;return ql(a,b.C)}).s(function(){a.c||(a.c=b)})}var rl={name:"persistence",C:"session"};function Bj(a){return{name:"authUser",C:a}}
	nl.prototype.eb=function(a){var b=null,c=this;rj(a);return pl(this,function(){return a!=c.c.C?c.b.get(c.c,c.a).then(function(d){b=d;return ql(c,a)}).then(function(){c.c=Bj(a);if(b)return c.b.set(c.c,b,c.a)}):A()})};function sl(a){return pl(a,function(){return a.b.set(rl,a.c.C,a.a)})}function tl(a,b){return pl(a,function(){return a.b.set(a.c,b.B(),a.a)})}function ul(a){return pl(a,function(){return xj(a.b,a.c,a.a)})}
	function vl(a,b){return pl(a,function(){return a.b.get(a.c,a.a).then(function(a){a&&b&&(a.authDomain=b);return jl(a||{})})})}function pl(a,b){a.f=a.f.then(b,b);return a.f};function wl(a){this.l=!1;M(this,"app",a);if(S(this).options&&S(this).options.apiKey)a=firebase.SDK_VERSION?Pf(firebase.SDK_VERSION):null,this.c=new Fh(S(this).options&&S(this).options.apiKey,Ai(Bi),a);else throw new N("invalid-api-key");this.N=[];this.m=[];this.I=[];this.Kb=firebase.INTERNAL.createSubscribe(r(this.ac,this));this.R=void 0;this.Lb=firebase.INTERNAL.createSubscribe(r(this.bc,this));xl(this,null);this.h=new nl(S(this).options.apiKey+":"+S(this).name);this.G=new ll(S(this).options.apiKey+
	":"+S(this).name);this.U=T(this,yl(this));this.i=T(this,zl(this));this.W=!1;this.ha=r(this.yc,this);this.Ga=r(this.ka,this);this.pa=r(this.Tb,this);this.qa=r(this.Zb,this);this.ra=r(this.$b,this);Al(this);this.INTERNAL={};this.INTERNAL["delete"]=r(this.delete,this);this.INTERNAL.logFramework=r(this.gc,this);this.o=0;F.call(this);Bl(this);this.A=[]}t(wl,F);function Cl(a){C.call(this,"languageCodeChanged");this.h=a}t(Cl,C);function Dl(a){C.call(this,"frameworkChanged");this.f=a}t(Dl,C);h=wl.prototype;
	h.eb=function(a){a=this.h.eb(a);return T(this,a)};h.na=function(a){this.V===a||this.l||(this.V=a,Lh(this.c,this.V),G(this,new Cl(this.$())))};h.$=function(){return this.V};h.Ec=function(){var a=k.navigator;this.na(a?a.languages&&a.languages[0]||a.language||a.userLanguage||null:null)};h.gc=function(a){this.A.push(a);Mh(this.c,firebase.SDK_VERSION?Pf(firebase.SDK_VERSION,this.A):null);G(this,new Dl(this.A))};h.Ka=function(){return La(this.A)};
	function Bl(a){Object.defineProperty(a,"lc",{get:function(){return this.$()},set:function(a){this.na(a)},enumerable:!1});a.V=null}h.toJSON=function(){return{apiKey:S(this).options.apiKey,authDomain:S(this).options.authDomain,appName:S(this).name,currentUser:U(this)&&U(this).B()}};function El(a){return a.Jb||B(new N("auth-domain-config-required"))}
	function Al(a){var b=S(a).options.authDomain,c=S(a).options.apiKey;b&&Sf()&&(a.Jb=a.U.then(function(){if(!a.l){a.a=ik(b,c,S(a).name);a.a.subscribe(a);U(a)&&Pk(U(a));if(a.w){Pk(a.w);var d=a.w;d.na(a.$());Ik(d,a);d=a.w;Hk(d,a.A);Jk(d,a);a.w=null}return a.a}}))}h.ob=function(a,b){switch(a){case "unknown":case "signInViaRedirect":return!0;case "signInViaPopup":return this.g==b&&!!this.f;default:return!1}};
	h.fa=function(a,b,c,d){"signInViaPopup"==a&&this.g==d&&(c&&this.v?this.v(c):b&&!c&&this.f&&this.f(b),this.b&&(this.b.cancel(),this.b=null),delete this.f,delete this.v)};h.va=function(a,b){return"signInViaRedirect"==a||"signInViaPopup"==a&&this.g==b&&this.f?r(this.Sb,this):null};
	h.Sb=function(a,b){var c=this;a={requestUri:a,sessionId:b};this.b&&(this.b.cancel(),this.b=null);var d=null,e=null,f=Yg(c.c,a).then(function(a){d=vh(a);e=Ng(a);return a});a=c.U.then(function(){return f}).then(function(a){return Fl(c,a)}).then(function(){return ig({user:U(c),credential:d,additionalUserInfo:e,operationType:"signIn"})});return T(this,a)};
	h.wc=function(a){if(!Sf())return B(new N("operation-not-supported-in-this-environment"));var b=this,c=Mg(a.providerId),d=Rf(),e=null;(!Uf()||Mf())&&S(this).options.authDomain&&a.isOAuthProvider&&(e=Ui(S(this).options.authDomain,S(this).options.apiKey,S(this).name,"signInViaPopup",a,null,d,firebase.SDK_VERSION||null));var f=Ef(e,c&&c.za,c&&c.ya);c=El(this).then(function(b){return gk(b,f,"signInViaPopup",a,d,!!e)}).then(function(){return new z(function(a,c){b.fa("signInViaPopup",null,new N("cancelled-popup-request"),
	b.g);b.f=a;b.v=c;b.g=d;b.b=b.a.Ca(b,"signInViaPopup",f,d)})}).then(function(a){f&&Df(f);return a?ig(a):null}).s(function(a){f&&Df(f);throw a;});return T(this,c)};h.xc=function(a){if(!Sf())return B(new N("operation-not-supported-in-this-environment"));var b=this,c=El(this).then(function(){return sl(b.h)}).then(function(){return b.a.Aa("signInViaRedirect",a)});return T(this,c)};
	h.aa=function(){if(!Sf())return B(new N("operation-not-supported-in-this-environment"));var a=this,b=El(this).then(function(){return a.a.aa()}).then(function(a){return a?ig(a):null});return T(this,b)};function Fl(a,b){var c={};c.apiKey=S(a).options.apiKey;c.authDomain=S(a).options.authDomain;c.appName=S(a).name;return a.U.then(function(){return kl(c,b,a.G,a.Ka())}).then(function(b){if(U(a)&&b.uid==U(a).uid)return Wk(U(a),b),a.ka(b);xl(a,b);Pk(b);return a.ka(b)}).then(function(){Gl(a)})}
	function xl(a,b){U(a)&&(Nk(U(a),a.Ga),E(U(a),"tokenChanged",a.pa),E(U(a),"userDeleted",a.qa),E(U(a),"userInvalidated",a.ra),Mk(U(a)));b&&(b.N.push(a.Ga),cd(b,"tokenChanged",a.pa),cd(b,"userDeleted",a.qa),cd(b,"userInvalidated",a.ra),0<a.o&&Lk(b));M(a,"currentUser",b);b&&(b.na(a.$()),Ik(b,a),Hk(b,a.A),Jk(b,a))}h.hb=function(){var a=this,b=this.i.then(function(){if(!U(a))return A();xl(a,null);return ul(a.h).then(function(){Gl(a)})});return T(this,b)};
	function Hl(a){var b=ml(a.G,S(a).options.authDomain).then(function(b){if(a.w=b)b.ca=a.G;return hl(a.G)});return T(a,b)}function yl(a){var b=S(a).options.authDomain,c=Hl(a).then(function(){return vl(a.h,b)}).then(function(b){return b?(b.ca=a.G,a.w&&(a.w.Z||null)==(b.Z||null)?b:b.reload().then(function(){return tl(a.h,b).then(function(){return b})}).s(function(c){return"auth/network-request-failed"==c.code?b:ul(a.h)})):null}).then(function(b){xl(a,b||null)});return T(a,c)}
	function zl(a){return a.U.then(function(){return a.aa()}).s(function(){}).then(function(){if(!a.l)return a.ha()}).s(function(){}).then(function(){if(!a.l){a.W=!0;var b=a.h;yj(b.b,Bj("local"),b.a,a.ha)}})}
	h.yc=function(){var a=this;return vl(this.h,S(this).options.authDomain).then(function(b){if(!a.l){var c;if(c=U(a)&&b){c=U(a).uid;var d=b.uid;c=void 0===c||null===c||""===c||void 0===d||null===d||""===d?!1:c==d}if(c)return Wk(U(a),b),U(a).F();if(U(a)||b)xl(a,b),b&&(Pk(b),b.ca=a.G),a.a&&a.a.subscribe(a),Gl(a)}})};h.ka=function(a){return tl(this.h,a)};h.Tb=function(){Gl(this);this.ka(U(this))};h.Zb=function(){this.hb()};h.$b=function(){this.hb()};
	function Il(a,b){var c=null,d=null;return T(a,b.then(function(b){c=vh(b);d=Ng(b);return Fl(a,b)}).then(function(){return ig({user:U(a),credential:c,additionalUserInfo:d,operationType:"signIn"})}))}h.ac=function(a){var b=this;this.addAuthTokenListener(function(){a.next(U(b))})};h.bc=function(a){var b=this;Jl(this,function(){a.next(U(b))})};h.ic=function(a,b,c){var d=this;this.W&&firebase.Promise.resolve().then(function(){p(a)?a(U(d)):p(a.next)&&a.next(U(d))});return this.Kb(a,b,c)};
	h.hc=function(a,b,c){var d=this;this.W&&firebase.Promise.resolve().then(function(){d.R=d.getUid();p(a)?a(U(d)):p(a.next)&&a.next(U(d))});return this.Lb(a,b,c)};h.Vb=function(a){var b=this,c=this.i.then(function(){return U(b)?U(b).F(a).then(function(a){return{accessToken:a}}):null});return T(this,c)};h.tc=function(a){return this.Eb(a).then(function(a){return a.user})};
	h.Eb=function(a){var b=this;return this.i.then(function(){return Il(b,Q(b.c,yi,{token:a}))}).then(function(a){var c=a.user;Vk(c,"isAnonymous",!1);b.ka(c);return a})};h.Fb=function(a,b){var c=this;return this.i.then(function(){return Il(c,Q(c.c,lh,{email:a,password:b}))})};h.uc=function(a,b){return this.Fb(a,b).then(function(a){return a.user})};h.Ob=function(a,b){return this.qb(a,b).then(function(a){return a.user})};
	h.qb=function(a,b){var c=this;return this.i.then(function(){return Il(c,Q(c.c,ui,{email:a,password:b}))})};h.sc=function(a){return this.fb(a).then(function(a){return a.user})};h.fb=function(a){var b=this;return this.i.then(function(){return Il(b,a.wa(b.c))})};h.gb=function(){return this.Gb().then(function(a){return a.user})};
	h.Gb=function(){var a=this;return this.i.then(function(){var b=U(a);if(b&&b.isAnonymous){var c=ig({providerId:null,isNewUser:!1});return ig({user:b,credential:null,additionalUserInfo:c,operationType:"signIn"})}return Il(a,a.c.gb()).then(function(b){var c=b.user;Vk(c,"isAnonymous",!0);a.ka(c);return b})})};function S(a){return a.app}function U(a){return a.currentUser}h.getUid=function(){return U(this)&&U(this).uid||null};function Kl(a){return U(a)&&U(a)._lat||null}
	function Gl(a){if(a.W){for(var b=0;b<a.m.length;b++)if(a.m[b])a.m[b](Kl(a));if(a.R!==a.getUid()&&a.I.length)for(a.R=a.getUid(),b=0;b<a.I.length;b++)if(a.I[b])a.I[b](Kl(a))}}h.Mb=function(a){this.addAuthTokenListener(a);this.o++;0<this.o&&U(this)&&Lk(U(this))};h.qc=function(a){var b=this;w(this.m,function(c){c==a&&b.o--});0>this.o&&(this.o=0);0==this.o&&U(this)&&Mk(U(this));this.removeAuthTokenListener(a)};
	h.addAuthTokenListener=function(a){var b=this;this.m.push(a);T(this,this.i.then(function(){b.l||Ha(b.m,a)&&a(Kl(b))}))};h.removeAuthTokenListener=function(a){Ja(this.m,function(b){return b==a})};function Jl(a,b){a.I.push(b);T(a,a.i.then(function(){!a.l&&Ha(a.I,b)&&a.R!==a.getUid()&&(a.R=a.getUid(),b(Kl(a)))}))}h.delete=function(){this.l=!0;for(var a=0;a<this.N.length;a++)this.N[a].cancel("app-deleted");this.N=[];this.h&&(a=this.h,Aj(a.b,a.a,this.ha));this.a&&this.a.unsubscribe(this);return firebase.Promise.resolve()};
	function T(a,b){a.N.push(b);Qb(b,function(){Ia(a.N,b)});return b}h.Rb=function(a){return T(this,Wh(this.c,a))};h.Fc=function(a){return this.Ia(a).then(function(a){return a.data.email})};h.Ta=function(a,b){return T(this,this.c.Ta(a,b).then(function(){}))};h.Ia=function(a){return T(this,this.c.Ia(a).then(function(a){return new mg(a)}))};h.Sa=function(a){return T(this,this.c.Sa(a).then(function(){}))};
	h.cb=function(a,b){var c=this;return T(this,A().then(function(){return"undefined"===typeof b||Sa(b)?{}:Gg(new xg(b))}).then(function(b){return c.c.cb(a,b)}).then(function(){}))};h.vc=function(a,b){return T(this,qk(this,a,b,r(this.fb,this)))};function Ll(a,b,c,d){a:{c=Array.prototype.slice.call(c);var e=0;for(var f=!1,g=0;g<b.length;g++)if(b[g].optional)f=!0;else{if(f)throw new N("internal-error","Argument validator encountered a required argument after an optional argument.");e++}f=b.length;if(c.length<e||f<c.length)d="Expected "+(e==f?1==e?"1 argument":e+" arguments":e+"-"+f+" arguments")+" but got "+c.length+".";else{for(e=0;e<c.length;e++)if(f=b[e].optional&&void 0===c[e],!b[e].M(c[e])&&!f){b=b[e];if(0>e||e>=Ml.length)throw new N("internal-error",
	"Argument validator received an unsupported number of arguments.");c=Ml[e];d=(d?"":c+" argument ")+(b.name?'"'+b.name+'" ':"")+"must be "+b.K+".";break a}d=null}}if(d)throw new N("argument-error",a+" failed: "+d);}var Ml="First Second Third Fourth Fifth Sixth Seventh Eighth Ninth".split(" ");function V(a,b){return{name:a||"",K:"a valid string",optional:!!b,M:m}}function Nl(){return{name:"opt_forceRefresh",K:"a boolean",optional:!0,M:ba}}
	function W(a,b){return{name:a||"",K:"a valid object",optional:!!b,M:q}}function Ol(a,b){return{name:a||"",K:"a function",optional:!!b,M:p}}function Pl(a,b){return{name:a||"",K:"null",optional:!!b,M:ea}}function Ql(){return{name:"",K:"an HTML element",optional:!1,M:function(a){return!!(a&&a instanceof Element)}}}function Rl(){return{name:"auth",K:"an instance of Firebase Auth",optional:!0,M:function(a){return!!(a&&a instanceof wl)}}}
	function Sl(){return{name:"app",K:"an instance of Firebase App",optional:!0,M:function(a){return!!(a&&a instanceof firebase.app.App)}}}function Tl(a){return{name:a?a+"Credential":"credential",K:a?"a valid "+a+" credential":"a valid credential",optional:!1,M:function(b){if(!b)return!1;var c=!a||b.providerId===a;return!(!b.wa||!c)}}}
	function Ul(){return{name:"authProvider",K:"a valid Auth provider",optional:!1,M:function(a){return!!(a&&a.providerId&&a.hasOwnProperty&&a.hasOwnProperty("isOAuthProvider"))}}}function Vl(){return{name:"applicationVerifier",K:"an implementation of firebase.auth.ApplicationVerifier",optional:!1,M:function(a){return!!(a&&m(a.type)&&p(a.verify))}}}function X(a,b,c,d){return{name:c||"",K:a.K+" or "+b.K,optional:!!d,M:function(c){return a.M(c)||b.M(c)}}};function Wl(a,b,c,d,e,f){M(this,"type","recaptcha");this.b=this.c=null;this.m=!1;this.l=b;this.a=c||{theme:"light",type:"image"};this.g=[];if(this.a[Xl])throw new N("argument-error","sitekey should not be provided for reCAPTCHA as one is automatically provisioned for the current project.");this.h="invisible"===this.a[Yl];if(!wc(b)||!this.h&&wc(b).hasChildNodes())throw new N("argument-error","reCAPTCHA container is either not found or already contains inner elements!");this.u=new Fh(a,f||null,e||null);
	this.o=d||function(){return null};var g=this;this.i=[];var l=this.a[Zl];this.a[Zl]=function(a){$l(g,a);if("function"===typeof l)l(a);else if("string"===typeof l){var b=L(l,k);"function"===typeof b&&b(a)}};var n=this.a[am];this.a[am]=function(){$l(g,null);if("function"===typeof n)n();else if("string"===typeof n){var a=L(n,k);"function"===typeof a&&a()}}}var Zl="callback",am="expired-callback",Xl="sitekey",Yl="size";function $l(a,b){for(var c=0;c<a.i.length;c++)try{a.i[c](b)}catch(d){}}
	function bm(a,b){Ja(a.i,function(a){return a==b})}function cm(a,b){a.g.push(b);Qb(b,function(){Ia(a.g,b)});return b}h=Wl.prototype;
	h.xa=function(){var a=this;return this.c?this.c:this.c=cm(this,A().then(function(){if(Tf())return If();throw new N("operation-not-supported-in-this-environment","RecaptchaVerifier is only supported in a browser HTTP/HTTPS environment.");}).then(function(){return dm(em(),a.o())}).then(function(){return Q(a.u,xi,{})}).then(function(b){a.a[Xl]=b.recaptchaSiteKey}).s(function(b){a.c=null;throw b;}))};
	h.render=function(){fm(this);var a=this;return cm(this,this.xa().then(function(){if(null===a.b){var b=a.l;if(!a.h){var c=wc(b);b=zc("DIV");c.appendChild(b)}a.b=grecaptcha.render(b,a.a)}return a.b}))};h.verify=function(){fm(this);var a=this;return cm(this,this.render().then(function(b){return new z(function(c){var d=grecaptcha.getResponse(b);if(d)c(d);else{var e=function(b){b&&(bm(a,e),c(b))};a.i.push(e);a.h&&grecaptcha.execute(a.b)}})}))};h.reset=function(){fm(this);null!==this.b&&grecaptcha.reset(this.b)};
	function fm(a){if(a.m)throw new N("internal-error","RecaptchaVerifier instance has been destroyed.");}h.clear=function(){fm(this);this.m=!0;em().b--;for(var a=0;a<this.g.length;a++)this.g[a].cancel("RecaptchaVerifier instance has been destroyed.");if(!this.h){a=wc(this.l);for(var b;b=a.firstChild;)a.removeChild(b)}};var gm=dc("https://www.google.com/recaptcha/api.js?onload=%{onload}&render=explicit&hl=%{hl}");
	function hm(){this.b=k.grecaptcha?Infinity:0;this.c=null;this.a="__rcb"+Math.floor(1E6*Math.random()).toString()}
	function dm(a,b){return new z(function(c,d){if($f())if(!k.grecaptcha||b!==a.c&&!a.b){k[a.a]=function(){if(k.grecaptcha){a.c=b;var e=k.grecaptcha.render;k.grecaptcha.render=function(b,c){b=e(b,c);a.b++;return b};c()}else d(new N("internal-error"));delete k[a.a]};var e=hc(gm,{onload:a.a,hl:b||""});A(lf(e)).s(function(){d(new N("internal-error","Unable to load external reCAPTCHA dependencies!"))})}else c();else d(new N("network-request-failed"))})}var im=null;
	function em(){im||(im=new hm);return im}function jm(a,b,c){try{this.f=c||firebase.app()}catch(f){throw new N("argument-error","No firebase.app.App instance is currently initialized.");}if(this.f.options&&this.f.options.apiKey)c=this.f.options.apiKey;else throw new N("invalid-api-key");var d=this,e=null;try{e=this.f.auth().Ka()}catch(f){}e=firebase.SDK_VERSION?Pf(firebase.SDK_VERSION,e):null;Wl.call(this,c,a,b,function(){try{var a=d.f.auth().$()}catch(g){a=null}return a},e,Ai(Bi))}t(jm,Wl);function Y(a,b){for(var c in b){var d=b[c].name;a[d]=km(d,a[c],b[c].j)}}function Z(a,b,c,d){a[b]=km(b,c,d)}function km(a,b,c){function d(){var a=Array.prototype.slice.call(arguments);Ll(e,c,a);return b.apply(this,a)}if(!c)return b;var e=lm(a),f;for(f in b)d[f]=b[f];for(f in b.prototype)d.prototype[f]=b.prototype[f];return d}function lm(a){a=a.split(".");return a[a.length-1]};Y(wl.prototype,{Sa:{name:"applyActionCode",j:[V("code")]},Ia:{name:"checkActionCode",j:[V("code")]},Ta:{name:"confirmPasswordReset",j:[V("code"),V("newPassword")]},Ob:{name:"createUserWithEmailAndPassword",j:[V("email"),V("password")]},qb:{name:"createUserAndRetrieveDataWithEmailAndPassword",j:[V("email"),V("password")]},Rb:{name:"fetchProvidersForEmail",j:[V("email")]},aa:{name:"getRedirectResult",j:[]},hc:{name:"onAuthStateChanged",j:[X(W(),Ol(),"nextOrObserver"),Ol("opt_error",!0),Ol("opt_completed",
	!0)]},ic:{name:"onIdTokenChanged",j:[X(W(),Ol(),"nextOrObserver"),Ol("opt_error",!0),Ol("opt_completed",!0)]},cb:{name:"sendPasswordResetEmail",j:[V("email"),X(W("opt_actionCodeSettings",!0),Pl(null,!0),"opt_actionCodeSettings",!0)]},eb:{name:"setPersistence",j:[V("persistence")]},fb:{name:"signInAndRetrieveDataWithCredential",j:[Tl()]},gb:{name:"signInAnonymously",j:[]},Gb:{name:"signInAnonymouslyAndRetrieveData",j:[]},sc:{name:"signInWithCredential",j:[Tl()]},tc:{name:"signInWithCustomToken",j:[V("token")]},
	Eb:{name:"signInAndRetrieveDataWithCustomToken",j:[V("token")]},uc:{name:"signInWithEmailAndPassword",j:[V("email"),V("password")]},Fb:{name:"signInAndRetrieveDataWithEmailAndPassword",j:[V("email"),V("password")]},vc:{name:"signInWithPhoneNumber",j:[V("phoneNumber"),Vl()]},wc:{name:"signInWithPopup",j:[Ul()]},xc:{name:"signInWithRedirect",j:[Ul()]},hb:{name:"signOut",j:[]},toJSON:{name:"toJSON",j:[V(null,!0)]},Ec:{name:"useDeviceLanguage",j:[]},Fc:{name:"verifyPasswordResetCode",j:[V("code")]}});
	(function(a,b){for(var c in b){var d=b[c].name;if(d!==c){var e=b[c].Nb;Object.defineProperty(a,d,{get:function(){return this[c]},set:function(a){Ll(d,[e],[a],!0);this[c]=a},enumerable:!0})}}})(wl.prototype,{lc:{name:"languageCode",Nb:X(V(),Pl(),"languageCode")}});wl.Persistence=qj;wl.Persistence.LOCAL="local";wl.Persistence.SESSION="session";wl.Persistence.NONE="none";
	Y(Dk.prototype,{"delete":{name:"delete",j:[]},F:{name:"getIdToken",j:[Nl()]},getToken:{name:"getToken",j:[Nl()]},Xa:{name:"linkAndRetrieveDataWithCredential",j:[Tl()]},cc:{name:"linkWithCredential",j:[Tl()]},dc:{name:"linkWithPhoneNumber",j:[V("phoneNumber"),Vl()]},ec:{name:"linkWithPopup",j:[Ul()]},fc:{name:"linkWithRedirect",j:[Ul()]},Za:{name:"reauthenticateAndRetrieveDataWithCredential",j:[Tl()]},mc:{name:"reauthenticateWithCredential",j:[Tl()]},nc:{name:"reauthenticateWithPhoneNumber",j:[V("phoneNumber"),
	Vl()]},oc:{name:"reauthenticateWithPopup",j:[Ul()]},pc:{name:"reauthenticateWithRedirect",j:[Ul()]},reload:{name:"reload",j:[]},bb:{name:"sendEmailVerification",j:[X(W("opt_actionCodeSettings",!0),Pl(null,!0),"opt_actionCodeSettings",!0)]},toJSON:{name:"toJSON",j:[V(null,!0)]},Cc:{name:"unlink",j:[V("provider")]},kb:{name:"updateEmail",j:[V("email")]},lb:{name:"updatePassword",j:[V("password")]},Dc:{name:"updatePhoneNumber",j:[Tl("phone")]},mb:{name:"updateProfile",j:[W("profile")]}});
	Y(z.prototype,{s:{name:"catch"},then:{name:"then"}});Y(pk.prototype,{confirm:{name:"confirm",j:[V("verificationCode")]}});Z(nh,"credential",function(a,b){return new kh(a,b)},[V("email"),V("password")]);Y(ch.prototype,{sa:{name:"addScope",j:[V("scope")]},Ba:{name:"setCustomParameters",j:[W("customOAuthParameters")]}});Z(ch,"credential",dh,[X(V(),W(),"token")]);Y(eh.prototype,{sa:{name:"addScope",j:[V("scope")]},Ba:{name:"setCustomParameters",j:[W("customOAuthParameters")]}});
	Z(eh,"credential",fh,[X(V(),W(),"token")]);Y(gh.prototype,{sa:{name:"addScope",j:[V("scope")]},Ba:{name:"setCustomParameters",j:[W("customOAuthParameters")]}});Z(gh,"credential",hh,[X(V(),X(W(),Pl()),"idToken"),X(V(),Pl(),"accessToken",!0)]);Y(ih.prototype,{Ba:{name:"setCustomParameters",j:[W("customOAuthParameters")]}});Z(ih,"credential",jh,[X(V(),W(),"token"),V("secret",!0)]);
	Y(P.prototype,{sa:{name:"addScope",j:[V("scope")]},credential:{name:"credential",j:[X(V(),Pl(),"idToken",!0),X(V(),Pl(),"accessToken",!0)]},Ba:{name:"setCustomParameters",j:[W("customOAuthParameters")]}});Z(sh,"credential",uh,[V("verificationId"),V("verificationCode")]);Y(sh.prototype,{Qa:{name:"verifyPhoneNumber",j:[V("phoneNumber"),Vl()]}});Y(N.prototype,{toJSON:{name:"toJSON",j:[V(null,!0)]}});Y(Ch.prototype,{toJSON:{name:"toJSON",j:[V(null,!0)]}});
	Y(Bh.prototype,{toJSON:{name:"toJSON",j:[V(null,!0)]}});Y(jm.prototype,{clear:{name:"clear",j:[]},render:{name:"render",j:[]},verify:{name:"verify",j:[]}});
	(function(){if("undefined"!==typeof firebase&&firebase.INTERNAL&&firebase.INTERNAL.registerService){var a={Auth:wl,Error:N};Z(a,"EmailAuthProvider",nh,[]);Z(a,"FacebookAuthProvider",ch,[]);Z(a,"GithubAuthProvider",eh,[]);Z(a,"GoogleAuthProvider",gh,[]);Z(a,"TwitterAuthProvider",ih,[]);Z(a,"OAuthProvider",P,[V("providerId")]);Z(a,"PhoneAuthProvider",sh,[Rl()]);Z(a,"RecaptchaVerifier",jm,[X(V(),Ql(),"recaptchaContainer"),W("recaptchaParameters",!0),Sl()]);firebase.INTERNAL.registerService("auth",function(a,
	c){a=new wl(a);c({INTERNAL:{getUid:r(a.getUid,a),getToken:r(a.Vb,a),addAuthTokenListener:r(a.Mb,a),removeAuthTokenListener:r(a.qc,a)}});return a},a,function(a,c){if("create"===a)try{c.auth()}catch(d){}});firebase.INTERNAL.extendNamespace({User:Dk})}else throw Error("Cannot find the firebase namespace; be sure to include firebase-app.js before this library.");})();
	}).call(typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : typeof window !== 'undefined' ? window : {});
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var app_1 = __webpack_require__(26);
	var Database_1 = __webpack_require__(133);
	exports.Database = Database_1.Database;
	var Query_1 = __webpack_require__(134);
	exports.Query = Query_1.Query;
	var Reference_1 = __webpack_require__(90);
	exports.Reference = Reference_1.Reference;
	var util_1 = __webpack_require__(4);
	exports.enableLogging = util_1.enableLogging;
	var RepoManager_1 = __webpack_require__(91);
	var INTERNAL = __webpack_require__(226);
	var TEST_ACCESS = __webpack_require__(227);
	var util_2 = __webpack_require__(1);
	var ServerValue = Database_1.Database.ServerValue;
	exports.ServerValue = ServerValue;
	function registerDatabase(instance) {
	    // Register the Database Service with the 'firebase' namespace.
	    var namespace = instance.INTERNAL.registerService('database', function (app, unused, url) { return RepoManager_1.RepoManager.getInstance().databaseFromApp(app, url); }, 
	    // firebase.database namespace properties
	    {
	        Reference: Reference_1.Reference,
	        Query: Query_1.Query,
	        Database: Database_1.Database,
	        enableLogging: util_1.enableLogging,
	        INTERNAL: INTERNAL,
	        ServerValue: ServerValue,
	        TEST_ACCESS: TEST_ACCESS
	    }, null, true);
	    if (util_2.isNodeSdk()) {
	        module.exports = namespace;
	    }
	}
	exports.registerDatabase = registerDatabase;
	registerDatabase(app_1.default);
	var DataSnapshot_1 = __webpack_require__(89);
	exports.DataSnapshot = DataSnapshot_1.DataSnapshot;
	var onDisconnect_1 = __webpack_require__(135);
	exports.OnDisconnect = onDisconnect_1.OnDisconnect;
	
	//# sourceMappingURL=index.js.map


/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var util_1 = __webpack_require__(1);
	var TransactionResult = /** @class */ (function () {
	    /**
	     * A type for the resolve value of Firebase.transaction.
	     * @constructor
	     * @dict
	     * @param {boolean} committed
	     * @param {DataSnapshot} snapshot
	     */
	    function TransactionResult(committed, snapshot) {
	        this.committed = committed;
	        this.snapshot = snapshot;
	    }
	    // Do not create public documentation. This is intended to make JSON serialization work but is otherwise unnecessary
	    // for end-users
	    TransactionResult.prototype.toJSON = function () {
	        util_1.validateArgCount('TransactionResult.toJSON', 0, 1, arguments.length);
	        return { committed: this.committed, snapshot: this.snapshot.toJSON() };
	    };
	    return TransactionResult;
	}());
	exports.TransactionResult = TransactionResult;
	
	//# sourceMappingURL=TransactionResult.js.map


/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var WebSocketConnection_1 = __webpack_require__(157);
	var BrowserPollConnection_1 = __webpack_require__(155);
	/**
	 * INTERNAL methods for internal-use only (tests, etc.).
	 *
	 * Customers shouldn't use these or else should be aware that they could break at any time.
	 *
	 * @const
	 */
	exports.forceLongPolling = function () {
	    WebSocketConnection_1.WebSocketConnection.forceDisallow();
	    BrowserPollConnection_1.BrowserPollConnection.forceAllow();
	};
	exports.forceWebSockets = function () {
	    BrowserPollConnection_1.BrowserPollConnection.forceDisallow();
	};
	/* Used by App Manager */
	exports.isWebSocketsAvailable = function () {
	    return WebSocketConnection_1.WebSocketConnection['isAvailable']();
	};
	exports.setSecurityDebugCallback = function (ref, callback) {
	    ref.repo.persistentConnection_.securityDebugCallback_ = callback;
	};
	exports.stats = function (ref, showDelta) {
	    ref.repo.stats(showDelta);
	};
	exports.statsIncrementCounter = function (ref, metric) {
	    ref.repo.statsIncrementCounter(metric);
	};
	exports.dataUpdateCount = function (ref) {
	    return ref.repo.dataUpdateCount;
	};
	exports.interceptServerData = function (ref, callback) {
	    return ref.repo.interceptServerData_(callback);
	};
	
	//# sourceMappingURL=internal.js.map


/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var RepoInfo_1 = __webpack_require__(137);
	var PersistentConnection_1 = __webpack_require__(136);
	var RepoManager_1 = __webpack_require__(91);
	var Connection_1 = __webpack_require__(156);
	exports.DataConnection = PersistentConnection_1.PersistentConnection;
	/**
	 * @param {!string} pathString
	 * @param {function(*)} onComplete
	 */
	PersistentConnection_1.PersistentConnection.prototype.simpleListen = function (pathString, onComplete) {
	    this.sendRequest('q', { p: pathString }, onComplete);
	};
	/**
	 * @param {*} data
	 * @param {function(*)} onEcho
	 */
	PersistentConnection_1.PersistentConnection.prototype.echo = function (data, onEcho) {
	    this.sendRequest('echo', { d: data }, onEcho);
	};
	// RealTimeConnection properties that we use in tests.
	exports.RealTimeConnection = Connection_1.Connection;
	/**
	 * @param {function(): string} newHash
	 * @return {function()}
	 */
	exports.hijackHash = function (newHash) {
	    var oldPut = PersistentConnection_1.PersistentConnection.prototype.put;
	    PersistentConnection_1.PersistentConnection.prototype.put = function (pathString, data, opt_onComplete, opt_hash) {
	        if (opt_hash !== undefined) {
	            opt_hash = newHash();
	        }
	        oldPut.call(this, pathString, data, opt_onComplete, opt_hash);
	    };
	    return function () {
	        PersistentConnection_1.PersistentConnection.prototype.put = oldPut;
	    };
	};
	/**
	 * @type {function(new:RepoInfo, !string, boolean, !string, boolean): undefined}
	 */
	exports.ConnectionTarget = RepoInfo_1.RepoInfo;
	/**
	 * @param {!Query} query
	 * @return {!string}
	 */
	exports.queryIdentifier = function (query) {
	    return query.queryIdentifier();
	};
	/**
	 * @param {!Query} firebaseRef
	 * @return {!Object}
	 */
	exports.listens = function (firebaseRef) {
	    return firebaseRef.repo.persistentConnection_.listens_;
	};
	/**
	 * Forces the RepoManager to create Repos that use ReadonlyRestClient instead of PersistentConnection.
	 *
	 * @param {boolean} forceRestClient
	 */
	exports.forceRestClient = function (forceRestClient) {
	    RepoManager_1.RepoManager.getInstance().forceRestClient(forceRestClient);
	};
	
	//# sourceMappingURL=test_access.js.map


/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var util_1 = __webpack_require__(4);
	/**
	 * Abstraction around FirebaseApp's token fetching capabilities.
	 */
	var AuthTokenProvider = /** @class */ (function () {
	    /**
	     * @param {!FirebaseApp} app_
	     */
	    function AuthTokenProvider(app_) {
	        this.app_ = app_;
	    }
	    /**
	     * @param {boolean} forceRefresh
	     * @return {!Promise<FirebaseAuthTokenData>}
	     */
	    AuthTokenProvider.prototype.getToken = function (forceRefresh) {
	        return this.app_['INTERNAL']['getToken'](forceRefresh).then(null, 
	        // .catch
	        function (error) {
	            // TODO: Need to figure out all the cases this is raised and whether
	            // this makes sense.
	            if (error && error.code === 'auth/token-not-initialized') {
	                util_1.log('Got auth/token-not-initialized error.  Treating as null token.');
	                return null;
	            }
	            else {
	                return Promise.reject(error);
	            }
	        });
	    };
	    AuthTokenProvider.prototype.addTokenChangeListener = function (listener) {
	        // TODO: We might want to wrap the listener and call it with no args to
	        // avoid a leaky abstraction, but that makes removing the listener harder.
	        this.app_['INTERNAL']['addAuthTokenListener'](listener);
	    };
	    AuthTokenProvider.prototype.removeTokenChangeListener = function (listener) {
	        this.app_['INTERNAL']['removeAuthTokenListener'](listener);
	    };
	    AuthTokenProvider.prototype.notifyForInvalidToken = function () {
	        var errorMessage = 'Provided authentication credentials for the app named "' +
	            this.app_.name +
	            '" are invalid. This usually indicates your app was not ' +
	            'initialized correctly. ';
	        if ('credential' in this.app_.options) {
	            errorMessage +=
	                'Make sure the "credential" property provided to initializeApp() ' +
	                    'is authorized to access the specified "databaseURL" and is from the correct ' +
	                    'project.';
	        }
	        else if ('serviceAccount' in this.app_.options) {
	            errorMessage +=
	                'Make sure the "serviceAccount" property provided to initializeApp() ' +
	                    'is authorized to access the specified "databaseURL" and is from the correct ' +
	                    'project.';
	        }
	        else {
	            errorMessage +=
	                'Make sure the "apiKey" and "databaseURL" properties provided to ' +
	                    'initializeApp() match the values provided for your app at ' +
	                    'https://console.firebase.google.com/.';
	        }
	        util_1.warn(errorMessage);
	    };
	    return AuthTokenProvider;
	}());
	exports.AuthTokenProvider = AuthTokenProvider;
	
	//# sourceMappingURL=AuthTokenProvider.js.map


/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var ImmutableTree_1 = __webpack_require__(93);
	var Path_1 = __webpack_require__(8);
	var util_1 = __webpack_require__(1);
	var Node_1 = __webpack_require__(19);
	var PriorityIndex_1 = __webpack_require__(15);
	var util_2 = __webpack_require__(1);
	/**
	 * This class holds a collection of writes that can be applied to nodes in unison. It abstracts away the logic with
	 * dealing with priority writes and multiple nested writes. At any given path there is only allowed to be one write
	 * modifying that path. Any write to an existing path or shadowing an existing path will modify that existing write
	 * to reflect the write added.
	 *
	 * @constructor
	 * @param {!ImmutableTree.<!Node>} writeTree
	 */
	var CompoundWrite = /** @class */ (function () {
	    function CompoundWrite(writeTree_) {
	        this.writeTree_ = writeTree_;
	    }
	    /**
	     * @param {!Path} path
	     * @param {!Node} node
	     * @return {!CompoundWrite}
	     */
	    CompoundWrite.prototype.addWrite = function (path, node) {
	        if (path.isEmpty()) {
	            return new CompoundWrite(new ImmutableTree_1.ImmutableTree(node));
	        }
	        else {
	            var rootmost = this.writeTree_.findRootMostValueAndPath(path);
	            if (rootmost != null) {
	                var rootMostPath = rootmost.path;
	                var value = rootmost.value;
	                var relativePath = Path_1.Path.relativePath(rootMostPath, path);
	                value = value.updateChild(relativePath, node);
	                return new CompoundWrite(this.writeTree_.set(rootMostPath, value));
	            }
	            else {
	                var subtree = new ImmutableTree_1.ImmutableTree(node);
	                var newWriteTree = this.writeTree_.setTree(path, subtree);
	                return new CompoundWrite(newWriteTree);
	            }
	        }
	    };
	    /**
	     * @param {!Path} path
	     * @param {!Object.<string, !Node>} updates
	     * @return {!CompoundWrite}
	     */
	    CompoundWrite.prototype.addWrites = function (path, updates) {
	        var newWrite = this;
	        util_1.forEach(updates, function (childKey, node) {
	            newWrite = newWrite.addWrite(path.child(childKey), node);
	        });
	        return newWrite;
	    };
	    /**
	     * Will remove a write at the given path and deeper paths. This will <em>not</em> modify a write at a higher
	     * location, which must be removed by calling this method with that path.
	     *
	     * @param {!Path} path The path at which a write and all deeper writes should be removed
	     * @return {!CompoundWrite} The new CompoundWrite with the removed path
	     */
	    CompoundWrite.prototype.removeWrite = function (path) {
	        if (path.isEmpty()) {
	            return CompoundWrite.Empty;
	        }
	        else {
	            var newWriteTree = this.writeTree_.setTree(path, ImmutableTree_1.ImmutableTree.Empty);
	            return new CompoundWrite(newWriteTree);
	        }
	    };
	    /**
	     * Returns whether this CompoundWrite will fully overwrite a node at a given location and can therefore be
	     * considered "complete".
	     *
	     * @param {!Path} path The path to check for
	     * @return {boolean} Whether there is a complete write at that path
	     */
	    CompoundWrite.prototype.hasCompleteWrite = function (path) {
	        return this.getCompleteNode(path) != null;
	    };
	    /**
	     * Returns a node for a path if and only if the node is a "complete" overwrite at that path. This will not aggregate
	     * writes from deeper paths, but will return child nodes from a more shallow path.
	     *
	     * @param {!Path} path The path to get a complete write
	     * @return {?Node} The node if complete at that path, or null otherwise.
	     */
	    CompoundWrite.prototype.getCompleteNode = function (path) {
	        var rootmost = this.writeTree_.findRootMostValueAndPath(path);
	        if (rootmost != null) {
	            return this.writeTree_
	                .get(rootmost.path)
	                .getChild(Path_1.Path.relativePath(rootmost.path, path));
	        }
	        else {
	            return null;
	        }
	    };
	    /**
	     * Returns all children that are guaranteed to be a complete overwrite.
	     *
	     * @return {!Array.<NamedNode>} A list of all complete children.
	     */
	    CompoundWrite.prototype.getCompleteChildren = function () {
	        var children = [];
	        var node = this.writeTree_.value;
	        if (node != null) {
	            // If it's a leaf node, it has no children; so nothing to do.
	            if (!node.isLeafNode()) {
	                node.forEachChild(PriorityIndex_1.PRIORITY_INDEX, function (childName, childNode) {
	                    children.push(new Node_1.NamedNode(childName, childNode));
	                });
	            }
	        }
	        else {
	            this.writeTree_.children.inorderTraversal(function (childName, childTree) {
	                if (childTree.value != null) {
	                    children.push(new Node_1.NamedNode(childName, childTree.value));
	                }
	            });
	        }
	        return children;
	    };
	    /**
	     * @param {!Path} path
	     * @return {!CompoundWrite}
	     */
	    CompoundWrite.prototype.childCompoundWrite = function (path) {
	        if (path.isEmpty()) {
	            return this;
	        }
	        else {
	            var shadowingNode = this.getCompleteNode(path);
	            if (shadowingNode != null) {
	                return new CompoundWrite(new ImmutableTree_1.ImmutableTree(shadowingNode));
	            }
	            else {
	                return new CompoundWrite(this.writeTree_.subtree(path));
	            }
	        }
	    };
	    /**
	     * Returns true if this CompoundWrite is empty and therefore does not modify any nodes.
	     * @return {boolean} Whether this CompoundWrite is empty
	     */
	    CompoundWrite.prototype.isEmpty = function () {
	        return this.writeTree_.isEmpty();
	    };
	    /**
	     * Applies this CompoundWrite to a node. The node is returned with all writes from this CompoundWrite applied to the
	     * node
	     * @param {!Node} node The node to apply this CompoundWrite to
	     * @return {!Node} The node with all writes applied
	     */
	    CompoundWrite.prototype.apply = function (node) {
	        return CompoundWrite.applySubtreeWrite_(Path_1.Path.Empty, this.writeTree_, node);
	    };
	    /**
	     * @type {!CompoundWrite}
	     */
	    CompoundWrite.Empty = new CompoundWrite(new ImmutableTree_1.ImmutableTree(null));
	    /**
	     * @param {!Path} relativePath
	     * @param {!ImmutableTree.<!Node>} writeTree
	     * @param {!Node} node
	     * @return {!Node}
	     * @private
	     */
	    CompoundWrite.applySubtreeWrite_ = function (relativePath, writeTree, node) {
	        if (writeTree.value != null) {
	            // Since there a write is always a leaf, we're done here
	            return node.updateChild(relativePath, writeTree.value);
	        }
	        else {
	            var priorityWrite_1 = null;
	            writeTree.children.inorderTraversal(function (childKey, childTree) {
	                if (childKey === '.priority') {
	                    // Apply priorities at the end so we don't update priorities for either empty nodes or forget
	                    // to apply priorities to empty nodes that are later filled
	                    util_2.assert(childTree.value !== null, 'Priority writes must always be leaf nodes');
	                    priorityWrite_1 = childTree.value;
	                }
	                else {
	                    node = CompoundWrite.applySubtreeWrite_(relativePath.child(childKey), childTree, node);
	                }
	            });
	            // If there was a priority write, we only apply it if the node is not empty
	            if (!node.getChild(relativePath).isEmpty() && priorityWrite_1 !== null) {
	                node = node.updateChild(relativePath.child('.priority'), priorityWrite_1);
	            }
	            return node;
	        }
	    };
	    return CompoundWrite;
	}());
	exports.CompoundWrite = CompoundWrite;
	
	//# sourceMappingURL=CompoundWrite.js.map


/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var util_1 = __webpack_require__(1);
	var util_2 = __webpack_require__(4);
	var util_3 = __webpack_require__(1);
	var util_4 = __webpack_require__(1);
	var util_5 = __webpack_require__(1);
	var ServerActions_1 = __webpack_require__(138);
	/**
	 * An implementation of ServerActions that communicates with the server via REST requests.
	 * This is mostly useful for compatibility with crawlers, where we don't want to spin up a full
	 * persistent connection (using WebSockets or long-polling)
	 */
	var ReadonlyRestClient = /** @class */ (function (_super) {
	    __extends(ReadonlyRestClient, _super);
	    /**
	     * @param {!RepoInfo} repoInfo_ Data about the namespace we are connecting to
	     * @param {function(string, *, boolean, ?number)} onDataUpdate_ A callback for new data from the server
	     * @param {AuthTokenProvider} authTokenProvider_
	     * @implements {ServerActions}
	     */
	    function ReadonlyRestClient(repoInfo_, onDataUpdate_, authTokenProvider_) {
	        var _this = _super.call(this) || this;
	        _this.repoInfo_ = repoInfo_;
	        _this.onDataUpdate_ = onDataUpdate_;
	        _this.authTokenProvider_ = authTokenProvider_;
	        /** @private {function(...[*])} */
	        _this.log_ = util_2.logWrapper('p:rest:');
	        /**
	         * We don't actually need to track listens, except to prevent us calling an onComplete for a listen
	         * that's been removed. :-/
	         *
	         * @private {!Object.<string, !Object>}
	         */
	        _this.listens_ = {};
	        return _this;
	    }
	    ReadonlyRestClient.prototype.reportStats = function (stats) {
	        throw new Error('Method not implemented.');
	    };
	    /**
	     * @param {!Query} query
	     * @param {?number=} tag
	     * @return {string}
	     * @private
	     */
	    ReadonlyRestClient.getListenId_ = function (query, tag) {
	        if (tag !== undefined) {
	            return 'tag$' + tag;
	        }
	        else {
	            util_1.assert(query.getQueryParams().isDefault(), "should have a tag if it's not a default query.");
	            return query.path.toString();
	        }
	    };
	    /** @inheritDoc */
	    ReadonlyRestClient.prototype.listen = function (query, currentHashFn, tag, onComplete) {
	        var _this = this;
	        var pathString = query.path.toString();
	        this.log_('Listen called for ' + pathString + ' ' + query.queryIdentifier());
	        // Mark this listener so we can tell if it's removed.
	        var listenId = ReadonlyRestClient.getListenId_(query, tag);
	        var thisListen = {};
	        this.listens_[listenId] = thisListen;
	        var queryStringParamaters = query
	            .getQueryParams()
	            .toRestQueryStringParameters();
	        this.restRequest_(pathString + '.json', queryStringParamaters, function (error, result) {
	            var data = result;
	            if (error === 404) {
	                data = null;
	                error = null;
	            }
	            if (error === null) {
	                _this.onDataUpdate_(pathString, data, /*isMerge=*/ false, tag);
	            }
	            if (util_4.safeGet(_this.listens_, listenId) === thisListen) {
	                var status_1;
	                if (!error) {
	                    status_1 = 'ok';
	                }
	                else if (error == 401) {
	                    status_1 = 'permission_denied';
	                }
	                else {
	                    status_1 = 'rest_error:' + error;
	                }
	                onComplete(status_1, null);
	            }
	        });
	    };
	    /** @inheritDoc */
	    ReadonlyRestClient.prototype.unlisten = function (query, tag) {
	        var listenId = ReadonlyRestClient.getListenId_(query, tag);
	        delete this.listens_[listenId];
	    };
	    /** @inheritDoc */
	    ReadonlyRestClient.prototype.refreshAuthToken = function (token) {
	        // no-op since we just always call getToken.
	    };
	    /**
	     * Performs a REST request to the given path, with the provided query string parameters,
	     * and any auth credentials we have.
	     *
	     * @param {!string} pathString
	     * @param {!Object.<string, *>} queryStringParameters
	     * @param {?function(?number, *=)} callback
	     * @private
	     */
	    ReadonlyRestClient.prototype.restRequest_ = function (pathString, queryStringParameters, callback) {
	        var _this = this;
	        if (queryStringParameters === void 0) { queryStringParameters = {}; }
	        queryStringParameters['format'] = 'export';
	        this.authTokenProvider_
	            .getToken(/*forceRefresh=*/ false)
	            .then(function (authTokenData) {
	            var authToken = authTokenData && authTokenData.accessToken;
	            if (authToken) {
	                queryStringParameters['auth'] = authToken;
	            }
	            var url = (_this.repoInfo_.secure ? 'https://' : 'http://') +
	                _this.repoInfo_.host +
	                pathString +
	                '?' +
	                util_5.querystring(queryStringParameters);
	            _this.log_('Sending REST request for ' + url);
	            var xhr = new XMLHttpRequest();
	            xhr.onreadystatechange = function () {
	                if (callback && xhr.readyState === 4) {
	                    _this.log_('REST Response for ' + url + ' received. status:', xhr.status, 'response:', xhr.responseText);
	                    var res = null;
	                    if (xhr.status >= 200 && xhr.status < 300) {
	                        try {
	                            res = util_3.jsonEval(xhr.responseText);
	                        }
	                        catch (e) {
	                            util_2.warn('Failed to parse JSON response for ' +
	                                url +
	                                ': ' +
	                                xhr.responseText);
	                        }
	                        callback(null, res);
	                    }
	                    else {
	                        // 401 and 404 are expected.
	                        if (xhr.status !== 401 && xhr.status !== 404) {
	                            util_2.warn('Got unsuccessful REST response for ' +
	                                url +
	                                ' Status: ' +
	                                xhr.status);
	                        }
	                        callback(xhr.status);
	                    }
	                    callback = null;
	                }
	            };
	            xhr.open('GET', url, /*asynchronous=*/ true);
	            xhr.send();
	        });
	    };
	    return ReadonlyRestClient;
	}(ServerActions_1.ServerActions));
	exports.ReadonlyRestClient = ReadonlyRestClient;
	
	//# sourceMappingURL=ReadonlyRestClient.js.map


/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var util_1 = __webpack_require__(1);
	var Reference_1 = __webpack_require__(90);
	var DataSnapshot_1 = __webpack_require__(89);
	var Path_1 = __webpack_require__(8);
	var Tree_1 = __webpack_require__(244);
	var PriorityIndex_1 = __webpack_require__(15);
	var util_2 = __webpack_require__(4);
	var ServerValues_1 = __webpack_require__(151);
	var validation_1 = __webpack_require__(34);
	var util_3 = __webpack_require__(1);
	var nodeFromJSON_1 = __webpack_require__(50);
	var ChildrenNode_1 = __webpack_require__(17);
	var Repo_1 = __webpack_require__(65);
	// TODO: This is pretty messy.  Ideally, a lot of this would move into FirebaseData, or a transaction-specific
	// component used by FirebaseData, but it has ties to user callbacks (transaction update and onComplete) as well
	// as the realtime connection (to send transactions to the server).  So that all needs to be decoupled first.
	// For now it's part of Repo, but in its own file.
	/**
	 * @enum {number}
	 */
	var TransactionStatus;
	(function (TransactionStatus) {
	    // We've run the transaction and updated transactionResultData_ with the result, but it isn't currently sent to the
	    // server. A transaction will go from RUN -> SENT -> RUN if it comes back from the server as rejected due to
	    // mismatched hash.
	    TransactionStatus[TransactionStatus["RUN"] = 0] = "RUN";
	    // We've run the transaction and sent it to the server and it's currently outstanding (hasn't come back as accepted
	    // or rejected yet).
	    TransactionStatus[TransactionStatus["SENT"] = 1] = "SENT";
	    // Temporary state used to mark completed transactions (whether successful or aborted).  The transaction will be
	    // removed when we get a chance to prune completed ones.
	    TransactionStatus[TransactionStatus["COMPLETED"] = 2] = "COMPLETED";
	    // Used when an already-sent transaction needs to be aborted (e.g. due to a conflicting set() call that was made).
	    // If it comes back as unsuccessful, we'll abort it.
	    TransactionStatus[TransactionStatus["SENT_NEEDS_ABORT"] = 3] = "SENT_NEEDS_ABORT";
	    // Temporary state used to mark transactions that need to be aborted.
	    TransactionStatus[TransactionStatus["NEEDS_ABORT"] = 4] = "NEEDS_ABORT";
	})(TransactionStatus = exports.TransactionStatus || (exports.TransactionStatus = {}));
	/**
	 * If a transaction does not succeed after 25 retries, we abort it.  Among other things this ensure that if there's
	 * ever a bug causing a mismatch between client / server hashes for some data, we won't retry indefinitely.
	 * @type {number}
	 * @const
	 * @private
	 */
	Repo_1.Repo.MAX_TRANSACTION_RETRIES_ = 25;
	/**
	 * Setup the transaction data structures
	 * @private
	 */
	Repo_1.Repo.prototype.transactions_init_ = function () {
	    /**
	     * Stores queues of outstanding transactions for Firebase locations.
	     *
	     * @type {!Tree.<Array.<!Transaction>>}
	     * @private
	     */
	    this.transactionQueueTree_ = new Tree_1.Tree();
	};
	/**
	 * Creates a new transaction, adds it to the transactions we're tracking, and sends it to the server if possible.
	 *
	 * @param {!Path} path Path at which to do transaction.
	 * @param {function(*):*} transactionUpdate Update callback.
	 * @param {?function(?Error, boolean, ?DataSnapshot)} onComplete Completion callback.
	 * @param {boolean} applyLocally Whether or not to make intermediate results visible
	 */
	Repo_1.Repo.prototype.startTransaction = function (path, transactionUpdate, onComplete, applyLocally) {
	    this.log_('transaction on ' + path);
	    // Add a watch to make sure we get server updates.
	    var valueCallback = function () { };
	    var watchRef = new Reference_1.Reference(this, path);
	    watchRef.on('value', valueCallback);
	    var unwatcher = function () {
	        watchRef.off('value', valueCallback);
	    };
	    // Initialize transaction.
	    var transaction = {
	        path: path,
	        update: transactionUpdate,
	        onComplete: onComplete,
	        // One of TransactionStatus enums.
	        status: null,
	        // Used when combining transactions at different locations to figure out which one goes first.
	        order: util_2.LUIDGenerator(),
	        // Whether to raise local events for this transaction.
	        applyLocally: applyLocally,
	        // Count of how many times we've retried the transaction.
	        retryCount: 0,
	        // Function to call to clean up our .on() listener.
	        unwatcher: unwatcher,
	        // Stores why a transaction was aborted.
	        abortReason: null,
	        currentWriteId: null,
	        currentInputSnapshot: null,
	        currentOutputSnapshotRaw: null,
	        currentOutputSnapshotResolved: null
	    };
	    // Run transaction initially.
	    var currentState = this.getLatestState_(path);
	    transaction.currentInputSnapshot = currentState;
	    var newVal = transaction.update(currentState.val());
	    if (newVal === undefined) {
	        // Abort transaction.
	        transaction.unwatcher();
	        transaction.currentOutputSnapshotRaw = null;
	        transaction.currentOutputSnapshotResolved = null;
	        if (transaction.onComplete) {
	            // We just set the input snapshot, so this cast should be safe
	            var snapshot = new DataSnapshot_1.DataSnapshot(transaction.currentInputSnapshot, new Reference_1.Reference(this, transaction.path), PriorityIndex_1.PRIORITY_INDEX);
	            transaction.onComplete(null, false, snapshot);
	        }
	    }
	    else {
	        validation_1.validateFirebaseData('transaction failed: Data returned ', newVal, transaction.path);
	        // Mark as run and add to our queue.
	        transaction.status = TransactionStatus.RUN;
	        var queueNode = this.transactionQueueTree_.subTree(path);
	        var nodeQueue = queueNode.getValue() || [];
	        nodeQueue.push(transaction);
	        queueNode.setValue(nodeQueue);
	        // Update visibleData and raise events
	        // Note: We intentionally raise events after updating all of our transaction state, since the user could
	        // start new transactions from the event callbacks.
	        var priorityForNode = void 0;
	        if (typeof newVal === 'object' &&
	            newVal !== null &&
	            util_3.contains(newVal, '.priority')) {
	            priorityForNode = util_3.safeGet(newVal, '.priority');
	            util_1.assert(validation_1.isValidPriority(priorityForNode), 'Invalid priority returned by transaction. ' +
	                'Priority must be a valid string, finite number, server value, or null.');
	        }
	        else {
	            var currentNode = this.serverSyncTree_.calcCompleteEventCache(path) ||
	                ChildrenNode_1.ChildrenNode.EMPTY_NODE;
	            priorityForNode = currentNode.getPriority().val();
	        }
	        priorityForNode /** @type {null|number|string} */ = priorityForNode;
	        var serverValues = this.generateServerValues();
	        var newNodeUnresolved = nodeFromJSON_1.nodeFromJSON(newVal, priorityForNode);
	        var newNode = ServerValues_1.resolveDeferredValueSnapshot(newNodeUnresolved, serverValues);
	        transaction.currentOutputSnapshotRaw = newNodeUnresolved;
	        transaction.currentOutputSnapshotResolved = newNode;
	        transaction.currentWriteId = this.getNextWriteId_();
	        var events = this.serverSyncTree_.applyUserOverwrite(path, newNode, transaction.currentWriteId, transaction.applyLocally);
	        this.eventQueue_.raiseEventsForChangedPath(path, events);
	        this.sendReadyTransactions_();
	    }
	};
	/**
	 * @param {!Path} path
	 * @param {Array.<number>=} excludeSets A specific set to exclude
	 * @return {Node}
	 * @private
	 */
	Repo_1.Repo.prototype.getLatestState_ = function (path, excludeSets) {
	    return (this.serverSyncTree_.calcCompleteEventCache(path, excludeSets) ||
	        ChildrenNode_1.ChildrenNode.EMPTY_NODE);
	};
	/**
	 * Sends any already-run transactions that aren't waiting for outstanding transactions to
	 * complete.
	 *
	 * Externally it's called with no arguments, but it calls itself recursively with a particular
	 * transactionQueueTree node to recurse through the tree.
	 *
	 * @param {Tree.<Array.<Transaction>>=} node  transactionQueueTree node to start at.
	 * @private
	 */
	Repo_1.Repo.prototype.sendReadyTransactions_ = function (node) {
	    var _this = this;
	    if (node === void 0) { node = this.transactionQueueTree_; }
	    // Before recursing, make sure any completed transactions are removed.
	    if (!node) {
	        this.pruneCompletedTransactionsBelowNode_(node);
	    }
	    if (node.getValue() !== null) {
	        var queue = this.buildTransactionQueue_(node);
	        util_1.assert(queue.length > 0, 'Sending zero length transaction queue');
	        var allRun = queue.every(function (transaction) { return transaction.status === TransactionStatus.RUN; });
	        // If they're all run (and not sent), we can send them.  Else, we must wait.
	        if (allRun) {
	            this.sendTransactionQueue_(node.path(), queue);
	        }
	    }
	    else if (node.hasChildren()) {
	        node.forEachChild(function (childNode) {
	            _this.sendReadyTransactions_(childNode);
	        });
	    }
	};
	/**
	 * Given a list of run transactions, send them to the server and then handle the result (success or failure).
	 *
	 * @param {!Path} path The location of the queue.
	 * @param {!Array.<Transaction>} queue Queue of transactions under the specified location.
	 * @private
	 */
	Repo_1.Repo.prototype.sendTransactionQueue_ = function (path, queue) {
	    var _this = this;
	    // Mark transactions as sent and increment retry count!
	    var setsToIgnore = queue.map(function (txn) {
	        return txn.currentWriteId;
	    });
	    var latestState = this.getLatestState_(path, setsToIgnore);
	    var snapToSend = latestState;
	    var latestHash = latestState.hash();
	    for (var i = 0; i < queue.length; i++) {
	        var txn = queue[i];
	        util_1.assert(txn.status === TransactionStatus.RUN, 'tryToSendTransactionQueue_: items in queue should all be run.');
	        txn.status = TransactionStatus.SENT;
	        txn.retryCount++;
	        var relativePath = Path_1.Path.relativePath(path, txn.path);
	        // If we've gotten to this point, the output snapshot must be defined.
	        snapToSend = snapToSend.updateChild(relativePath /**@type {!Node} */, txn.currentOutputSnapshotRaw);
	    }
	    var dataToSend = snapToSend.val(true);
	    var pathToSend = path;
	    // Send the put.
	    this.server_.put(pathToSend.toString(), dataToSend, function (status) {
	        _this.log_('transaction put response', {
	            path: pathToSend.toString(),
	            status: status
	        });
	        var events = [];
	        if (status === 'ok') {
	            // Queue up the callbacks and fire them after cleaning up all of our transaction state, since
	            // the callback could trigger more transactions or sets.
	            var callbacks = [];
	            for (var i = 0; i < queue.length; i++) {
	                queue[i].status = TransactionStatus.COMPLETED;
	                events = events.concat(_this.serverSyncTree_.ackUserWrite(queue[i].currentWriteId));
	                if (queue[i].onComplete) {
	                    // We never unset the output snapshot, and given that this transaction is complete, it should be set
	                    var node = queue[i].currentOutputSnapshotResolved;
	                    var ref = new Reference_1.Reference(_this, queue[i].path);
	                    var snapshot = new DataSnapshot_1.DataSnapshot(node, ref, PriorityIndex_1.PRIORITY_INDEX);
	                    callbacks.push(queue[i].onComplete.bind(null, null, true, snapshot));
	                }
	                queue[i].unwatcher();
	            }
	            // Now remove the completed transactions.
	            _this.pruneCompletedTransactionsBelowNode_(_this.transactionQueueTree_.subTree(path));
	            // There may be pending transactions that we can now send.
	            _this.sendReadyTransactions_();
	            _this.eventQueue_.raiseEventsForChangedPath(path, events);
	            // Finally, trigger onComplete callbacks.
	            for (var i = 0; i < callbacks.length; i++) {
	                util_2.exceptionGuard(callbacks[i]);
	            }
	        }
	        else {
	            // transactions are no longer sent.  Update their status appropriately.
	            if (status === 'datastale') {
	                for (var i = 0; i < queue.length; i++) {
	                    if (queue[i].status === TransactionStatus.SENT_NEEDS_ABORT)
	                        queue[i].status = TransactionStatus.NEEDS_ABORT;
	                    else
	                        queue[i].status = TransactionStatus.RUN;
	                }
	            }
	            else {
	                util_2.warn('transaction at ' + pathToSend.toString() + ' failed: ' + status);
	                for (var i = 0; i < queue.length; i++) {
	                    queue[i].status = TransactionStatus.NEEDS_ABORT;
	                    queue[i].abortReason = status;
	                }
	            }
	            _this.rerunTransactions_(path);
	        }
	    }, latestHash);
	};
	/**
	 * Finds all transactions dependent on the data at changedPath and reruns them.
	 *
	 * Should be called any time cached data changes.
	 *
	 * Return the highest path that was affected by rerunning transactions.  This is the path at which events need to
	 * be raised for.
	 *
	 * @param {!Path} changedPath The path in mergedData that changed.
	 * @return {!Path} The rootmost path that was affected by rerunning transactions.
	 * @private
	 */
	Repo_1.Repo.prototype.rerunTransactions_ = function (changedPath) {
	    var rootMostTransactionNode = this.getAncestorTransactionNode_(changedPath);
	    var path = rootMostTransactionNode.path();
	    var queue = this.buildTransactionQueue_(rootMostTransactionNode);
	    this.rerunTransactionQueue_(queue, path);
	    return path;
	};
	/**
	 * Does all the work of rerunning transactions (as well as cleans up aborted transactions and whatnot).
	 *
	 * @param {Array.<Transaction>} queue The queue of transactions to run.
	 * @param {!Path} path The path the queue is for.
	 * @private
	 */
	Repo_1.Repo.prototype.rerunTransactionQueue_ = function (queue, path) {
	    if (queue.length === 0) {
	        return; // Nothing to do!
	    }
	    // Queue up the callbacks and fire them after cleaning up all of our transaction state, since
	    // the callback could trigger more transactions or sets.
	    var callbacks = [];
	    var events = [];
	    // Ignore all of the sets we're going to re-run.
	    var txnsToRerun = queue.filter(function (q) {
	        return q.status === TransactionStatus.RUN;
	    });
	    var setsToIgnore = txnsToRerun.map(function (q) {
	        return q.currentWriteId;
	    });
	    for (var i = 0; i < queue.length; i++) {
	        var transaction = queue[i];
	        var relativePath = Path_1.Path.relativePath(path, transaction.path);
	        var abortTransaction = false, abortReason = void 0;
	        util_1.assert(relativePath !== null, 'rerunTransactionsUnderNode_: relativePath should not be null.');
	        if (transaction.status === TransactionStatus.NEEDS_ABORT) {
	            abortTransaction = true;
	            abortReason = transaction.abortReason;
	            events = events.concat(this.serverSyncTree_.ackUserWrite(transaction.currentWriteId, true));
	        }
	        else if (transaction.status === TransactionStatus.RUN) {
	            if (transaction.retryCount >= Repo_1.Repo.MAX_TRANSACTION_RETRIES_) {
	                abortTransaction = true;
	                abortReason = 'maxretry';
	                events = events.concat(this.serverSyncTree_.ackUserWrite(transaction.currentWriteId, true));
	            }
	            else {
	                // This code reruns a transaction
	                var currentNode = this.getLatestState_(transaction.path, setsToIgnore);
	                transaction.currentInputSnapshot = currentNode;
	                var newData = queue[i].update(currentNode.val());
	                if (newData !== undefined) {
	                    validation_1.validateFirebaseData('transaction failed: Data returned ', newData, transaction.path);
	                    var newDataNode = nodeFromJSON_1.nodeFromJSON(newData);
	                    var hasExplicitPriority = typeof newData === 'object' &&
	                        newData != null &&
	                        util_3.contains(newData, '.priority');
	                    if (!hasExplicitPriority) {
	                        // Keep the old priority if there wasn't a priority explicitly specified.
	                        newDataNode = newDataNode.updatePriority(currentNode.getPriority());
	                    }
	                    var oldWriteId = transaction.currentWriteId;
	                    var serverValues = this.generateServerValues();
	                    var newNodeResolved = ServerValues_1.resolveDeferredValueSnapshot(newDataNode, serverValues);
	                    transaction.currentOutputSnapshotRaw = newDataNode;
	                    transaction.currentOutputSnapshotResolved = newNodeResolved;
	                    transaction.currentWriteId = this.getNextWriteId_();
	                    // Mutates setsToIgnore in place
	                    setsToIgnore.splice(setsToIgnore.indexOf(oldWriteId), 1);
	                    events = events.concat(this.serverSyncTree_.applyUserOverwrite(transaction.path, newNodeResolved, transaction.currentWriteId, transaction.applyLocally));
	                    events = events.concat(this.serverSyncTree_.ackUserWrite(oldWriteId, true));
	                }
	                else {
	                    abortTransaction = true;
	                    abortReason = 'nodata';
	                    events = events.concat(this.serverSyncTree_.ackUserWrite(transaction.currentWriteId, true));
	                }
	            }
	        }
	        this.eventQueue_.raiseEventsForChangedPath(path, events);
	        events = [];
	        if (abortTransaction) {
	            // Abort.
	            queue[i].status = TransactionStatus.COMPLETED;
	            // Removing a listener can trigger pruning which can muck with mergedData/visibleData (as it prunes data).
	            // So defer the unwatcher until we're done.
	            (function (unwatcher) {
	                setTimeout(unwatcher, Math.floor(0));
	            })(queue[i].unwatcher);
	            if (queue[i].onComplete) {
	                if (abortReason === 'nodata') {
	                    var ref = new Reference_1.Reference(this, queue[i].path);
	                    // We set this field immediately, so it's safe to cast to an actual snapshot
	                    var lastInput /** @type {!Node} */ = queue[i].currentInputSnapshot;
	                    var snapshot = new DataSnapshot_1.DataSnapshot(lastInput, ref, PriorityIndex_1.PRIORITY_INDEX);
	                    callbacks.push(queue[i].onComplete.bind(null, null, false, snapshot));
	                }
	                else {
	                    callbacks.push(queue[i].onComplete.bind(null, new Error(abortReason), false, null));
	                }
	            }
	        }
	    }
	    // Clean up completed transactions.
	    this.pruneCompletedTransactionsBelowNode_(this.transactionQueueTree_);
	    // Now fire callbacks, now that we're in a good, known state.
	    for (var i = 0; i < callbacks.length; i++) {
	        util_2.exceptionGuard(callbacks[i]);
	    }
	    // Try to send the transaction result to the server.
	    this.sendReadyTransactions_();
	};
	/**
	 * Returns the rootmost ancestor node of the specified path that has a pending transaction on it, or just returns
	 * the node for the given path if there are no pending transactions on any ancestor.
	 *
	 * @param {!Path} path The location to start at.
	 * @return {!Tree.<Array.<!Transaction>>} The rootmost node with a transaction.
	 * @private
	 */
	Repo_1.Repo.prototype.getAncestorTransactionNode_ = function (path) {
	    var front;
	    // Start at the root and walk deeper into the tree towards path until we find a node with pending transactions.
	    var transactionNode = this.transactionQueueTree_;
	    while ((front = path.getFront()) !== null &&
	        transactionNode.getValue() === null) {
	        transactionNode = transactionNode.subTree(front);
	        path = path.popFront();
	    }
	    return transactionNode;
	};
	/**
	 * Builds the queue of all transactions at or below the specified transactionNode.
	 *
	 * @param {!Tree.<Array.<Transaction>>} transactionNode
	 * @return {Array.<Transaction>} The generated queue.
	 * @private
	 */
	Repo_1.Repo.prototype.buildTransactionQueue_ = function (transactionNode) {
	    // Walk any child transaction queues and aggregate them into a single queue.
	    var transactionQueue = [];
	    this.aggregateTransactionQueuesForNode_(transactionNode, transactionQueue);
	    // Sort them by the order the transactions were created.
	    transactionQueue.sort(function (a, b) {
	        return a.order - b.order;
	    });
	    return transactionQueue;
	};
	/**
	 * @param {!Tree.<Array.<Transaction>>} node
	 * @param {Array.<Transaction>} queue
	 * @private
	 */
	Repo_1.Repo.prototype.aggregateTransactionQueuesForNode_ = function (node, queue) {
	    var _this = this;
	    var nodeQueue = node.getValue();
	    if (nodeQueue !== null) {
	        for (var i = 0; i < nodeQueue.length; i++) {
	            queue.push(nodeQueue[i]);
	        }
	    }
	    node.forEachChild(function (child) {
	        _this.aggregateTransactionQueuesForNode_(child, queue);
	    });
	};
	/**
	 * Remove COMPLETED transactions at or below this node in the transactionQueueTree_.
	 *
	 * @param {!Tree.<Array.<!Transaction>>} node
	 * @private
	 */
	Repo_1.Repo.prototype.pruneCompletedTransactionsBelowNode_ = function (node) {
	    var _this = this;
	    var queue = node.getValue();
	    if (queue) {
	        var to = 0;
	        for (var from = 0; from < queue.length; from++) {
	            if (queue[from].status !== TransactionStatus.COMPLETED) {
	                queue[to] = queue[from];
	                to++;
	            }
	        }
	        queue.length = to;
	        node.setValue(queue.length > 0 ? queue : null);
	    }
	    node.forEachChild(function (childNode) {
	        _this.pruneCompletedTransactionsBelowNode_(childNode);
	    });
	};
	/**
	 * Aborts all transactions on ancestors or descendants of the specified path.  Called when doing a set() or update()
	 * since we consider them incompatible with transactions.
	 *
	 * @param {!Path} path Path for which we want to abort related transactions.
	 * @return {!Path}
	 * @private
	 */
	Repo_1.Repo.prototype.abortTransactions_ = function (path) {
	    var _this = this;
	    var affectedPath = this.getAncestorTransactionNode_(path).path();
	    var transactionNode = this.transactionQueueTree_.subTree(path);
	    transactionNode.forEachAncestor(function (node) {
	        _this.abortTransactionsOnNode_(node);
	    });
	    this.abortTransactionsOnNode_(transactionNode);
	    transactionNode.forEachDescendant(function (node) {
	        _this.abortTransactionsOnNode_(node);
	    });
	    return affectedPath;
	};
	/**
	 * Abort transactions stored in this transaction queue node.
	 *
	 * @param {!Tree.<Array.<Transaction>>} node Node to abort transactions for.
	 * @private
	 */
	Repo_1.Repo.prototype.abortTransactionsOnNode_ = function (node) {
	    var queue = node.getValue();
	    if (queue !== null) {
	        // Queue up the callbacks and fire them after cleaning up all of our transaction state, since
	        // the callback could trigger more transactions or sets.
	        var callbacks = [];
	        // Go through queue.  Any already-sent transactions must be marked for abort, while the unsent ones
	        // can be immediately aborted and removed.
	        var events = [];
	        var lastSent = -1;
	        for (var i = 0; i < queue.length; i++) {
	            if (queue[i].status === TransactionStatus.SENT_NEEDS_ABORT) {
	                // Already marked.  No action needed.
	            }
	            else if (queue[i].status === TransactionStatus.SENT) {
	                util_1.assert(lastSent === i - 1, 'All SENT items should be at beginning of queue.');
	                lastSent = i;
	                // Mark transaction for abort when it comes back.
	                queue[i].status = TransactionStatus.SENT_NEEDS_ABORT;
	                queue[i].abortReason = 'set';
	            }
	            else {
	                util_1.assert(queue[i].status === TransactionStatus.RUN, 'Unexpected transaction status in abort');
	                // We can abort it immediately.
	                queue[i].unwatcher();
	                events = events.concat(this.serverSyncTree_.ackUserWrite(queue[i].currentWriteId, true));
	                if (queue[i].onComplete) {
	                    var snapshot = null;
	                    callbacks.push(queue[i].onComplete.bind(null, new Error('set'), false, snapshot));
	                }
	            }
	        }
	        if (lastSent === -1) {
	            // We're not waiting for any sent transactions.  We can clear the queue.
	            node.setValue(null);
	        }
	        else {
	            // Remove the transactions we aborted.
	            queue.length = lastSent + 1;
	        }
	        // Now fire the callbacks.
	        this.eventQueue_.raiseEventsForChangedPath(node.path(), events);
	        for (var i = 0; i < callbacks.length; i++) {
	            util_2.exceptionGuard(callbacks[i]);
	        }
	    }
	};
	
	//# sourceMappingURL=Repo_transaction.js.map


/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var ChildrenNode_1 = __webpack_require__(17);
	/**
	 * Mutable object which basically just stores a reference to the "latest" immutable snapshot.
	 *
	 * @constructor
	 */
	var SnapshotHolder = /** @class */ (function () {
	    function SnapshotHolder() {
	        this.rootNode_ = ChildrenNode_1.ChildrenNode.EMPTY_NODE;
	    }
	    SnapshotHolder.prototype.getNode = function (path) {
	        return this.rootNode_.getChild(path);
	    };
	    SnapshotHolder.prototype.updateSnapshot = function (path, newSnapshotNode) {
	        this.rootNode_ = this.rootNode_.updateChild(path, newSnapshotNode);
	    };
	    return SnapshotHolder;
	}());
	exports.SnapshotHolder = SnapshotHolder;
	
	//# sourceMappingURL=SnapshotHolder.js.map


/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var util_1 = __webpack_require__(1);
	var util_2 = __webpack_require__(4);
	var AckUserWrite_1 = __webpack_require__(235);
	var ChildrenNode_1 = __webpack_require__(17);
	var util_3 = __webpack_require__(1);
	var ImmutableTree_1 = __webpack_require__(93);
	var ListenComplete_1 = __webpack_require__(236);
	var Merge_1 = __webpack_require__(237);
	var Operation_1 = __webpack_require__(33);
	var Overwrite_1 = __webpack_require__(141);
	var Path_1 = __webpack_require__(8);
	var SyncPoint_1 = __webpack_require__(140);
	var WriteTree_1 = __webpack_require__(234);
	/**
	 * SyncTree is the central class for managing event callback registration, data caching, views
	 * (query processing), and event generation.  There are typically two SyncTree instances for
	 * each Repo, one for the normal Firebase data, and one for the .info data.
	 *
	 * It has a number of responsibilities, including:
	 *  - Tracking all user event callbacks (registered via addEventRegistration() and removeEventRegistration()).
	 *  - Applying and caching data changes for user set(), transaction(), and update() calls
	 *    (applyUserOverwrite(), applyUserMerge()).
	 *  - Applying and caching data changes for server data changes (applyServerOverwrite(),
	 *    applyServerMerge()).
	 *  - Generating user-facing events for server and user changes (all of the apply* methods
	 *    return the set of events that need to be raised as a result).
	 *  - Maintaining the appropriate set of server listens to ensure we are always subscribed
	 *    to the correct set of paths and queries to satisfy the current set of user event
	 *    callbacks (listens are started/stopped using the provided listenProvider).
	 *
	 * NOTE: Although SyncTree tracks event callbacks and calculates events to raise, the actual
	 * events are returned to the caller rather than raised synchronously.
	 *
	 * @constructor
	 */
	var SyncTree = /** @class */ (function () {
	    /**
	     * @param {!ListenProvider} listenProvider_ Used by SyncTree to start / stop listening
	     *   to server data.
	     */
	    function SyncTree(listenProvider_) {
	        this.listenProvider_ = listenProvider_;
	        /**
	         * Tree of SyncPoints.  There's a SyncPoint at any location that has 1 or more views.
	         * @type {!ImmutableTree.<!SyncPoint>}
	         * @private
	         */
	        this.syncPointTree_ = ImmutableTree_1.ImmutableTree.Empty;
	        /**
	         * A tree of all pending user writes (user-initiated set()'s, transaction()'s, update()'s, etc.).
	         * @type {!WriteTree}
	         * @private
	         */
	        this.pendingWriteTree_ = new WriteTree_1.WriteTree();
	        this.tagToQueryMap_ = {};
	        this.queryToTagMap_ = {};
	    }
	    /**
	     * Apply the data changes for a user-generated set() or transaction() call.
	     *
	     * @param {!Path} path
	     * @param {!Node} newData
	     * @param {number} writeId
	     * @param {boolean=} visible
	     * @return {!Array.<!Event>} Events to raise.
	     */
	    SyncTree.prototype.applyUserOverwrite = function (path, newData, writeId, visible) {
	        // Record pending write.
	        this.pendingWriteTree_.addOverwrite(path, newData, writeId, visible);
	        if (!visible) {
	            return [];
	        }
	        else {
	            return this.applyOperationToSyncPoints_(new Overwrite_1.Overwrite(Operation_1.OperationSource.User, path, newData));
	        }
	    };
	    /**
	     * Apply the data from a user-generated update() call
	     *
	     * @param {!Path} path
	     * @param {!Object.<string, !Node>} changedChildren
	     * @param {!number} writeId
	     * @return {!Array.<!Event>} Events to raise.
	     */
	    SyncTree.prototype.applyUserMerge = function (path, changedChildren, writeId) {
	        // Record pending merge.
	        this.pendingWriteTree_.addMerge(path, changedChildren, writeId);
	        var changeTree = ImmutableTree_1.ImmutableTree.fromObject(changedChildren);
	        return this.applyOperationToSyncPoints_(new Merge_1.Merge(Operation_1.OperationSource.User, path, changeTree));
	    };
	    /**
	     * Acknowledge a pending user write that was previously registered with applyUserOverwrite() or applyUserMerge().
	     *
	     * @param {!number} writeId
	     * @param {boolean=} revert True if the given write failed and needs to be reverted
	     * @return {!Array.<!Event>} Events to raise.
	     */
	    SyncTree.prototype.ackUserWrite = function (writeId, revert) {
	        if (revert === void 0) { revert = false; }
	        var write = this.pendingWriteTree_.getWrite(writeId);
	        var needToReevaluate = this.pendingWriteTree_.removeWrite(writeId);
	        if (!needToReevaluate) {
	            return [];
	        }
	        else {
	            var affectedTree_1 = ImmutableTree_1.ImmutableTree.Empty;
	            if (write.snap != null) {
	                // overwrite
	                affectedTree_1 = affectedTree_1.set(Path_1.Path.Empty, true);
	            }
	            else {
	                util_3.forEach(write.children, function (pathString, node) {
	                    affectedTree_1 = affectedTree_1.set(new Path_1.Path(pathString), node);
	                });
	            }
	            return this.applyOperationToSyncPoints_(new AckUserWrite_1.AckUserWrite(write.path, affectedTree_1, revert));
	        }
	    };
	    /**
	     * Apply new server data for the specified path..
	     *
	     * @param {!Path} path
	     * @param {!Node} newData
	     * @return {!Array.<!Event>} Events to raise.
	     */
	    SyncTree.prototype.applyServerOverwrite = function (path, newData) {
	        return this.applyOperationToSyncPoints_(new Overwrite_1.Overwrite(Operation_1.OperationSource.Server, path, newData));
	    };
	    /**
	     * Apply new server data to be merged in at the specified path.
	     *
	     * @param {!Path} path
	     * @param {!Object.<string, !Node>} changedChildren
	     * @return {!Array.<!Event>} Events to raise.
	     */
	    SyncTree.prototype.applyServerMerge = function (path, changedChildren) {
	        var changeTree = ImmutableTree_1.ImmutableTree.fromObject(changedChildren);
	        return this.applyOperationToSyncPoints_(new Merge_1.Merge(Operation_1.OperationSource.Server, path, changeTree));
	    };
	    /**
	     * Apply a listen complete for a query
	     *
	     * @param {!Path} path
	     * @return {!Array.<!Event>} Events to raise.
	     */
	    SyncTree.prototype.applyListenComplete = function (path) {
	        return this.applyOperationToSyncPoints_(new ListenComplete_1.ListenComplete(Operation_1.OperationSource.Server, path));
	    };
	    /**
	     * Apply new server data for the specified tagged query.
	     *
	     * @param {!Path} path
	     * @param {!Node} snap
	     * @param {!number} tag
	     * @return {!Array.<!Event>} Events to raise.
	     */
	    SyncTree.prototype.applyTaggedQueryOverwrite = function (path, snap, tag) {
	        var queryKey = this.queryKeyForTag_(tag);
	        if (queryKey != null) {
	            var r = SyncTree.parseQueryKey_(queryKey);
	            var queryPath = r.path, queryId = r.queryId;
	            var relativePath = Path_1.Path.relativePath(queryPath, path);
	            var op = new Overwrite_1.Overwrite(Operation_1.OperationSource.forServerTaggedQuery(queryId), relativePath, snap);
	            return this.applyTaggedOperation_(queryPath, op);
	        }
	        else {
	            // Query must have been removed already
	            return [];
	        }
	    };
	    /**
	     * Apply server data to be merged in for the specified tagged query.
	     *
	     * @param {!Path} path
	     * @param {!Object.<string, !Node>} changedChildren
	     * @param {!number} tag
	     * @return {!Array.<!Event>} Events to raise.
	     */
	    SyncTree.prototype.applyTaggedQueryMerge = function (path, changedChildren, tag) {
	        var queryKey = this.queryKeyForTag_(tag);
	        if (queryKey) {
	            var r = SyncTree.parseQueryKey_(queryKey);
	            var queryPath = r.path, queryId = r.queryId;
	            var relativePath = Path_1.Path.relativePath(queryPath, path);
	            var changeTree = ImmutableTree_1.ImmutableTree.fromObject(changedChildren);
	            var op = new Merge_1.Merge(Operation_1.OperationSource.forServerTaggedQuery(queryId), relativePath, changeTree);
	            return this.applyTaggedOperation_(queryPath, op);
	        }
	        else {
	            // We've already removed the query. No big deal, ignore the update
	            return [];
	        }
	    };
	    /**
	     * Apply a listen complete for a tagged query
	     *
	     * @param {!Path} path
	     * @param {!number} tag
	     * @return {!Array.<!Event>} Events to raise.
	     */
	    SyncTree.prototype.applyTaggedListenComplete = function (path, tag) {
	        var queryKey = this.queryKeyForTag_(tag);
	        if (queryKey) {
	            var r = SyncTree.parseQueryKey_(queryKey);
	            var queryPath = r.path, queryId = r.queryId;
	            var relativePath = Path_1.Path.relativePath(queryPath, path);
	            var op = new ListenComplete_1.ListenComplete(Operation_1.OperationSource.forServerTaggedQuery(queryId), relativePath);
	            return this.applyTaggedOperation_(queryPath, op);
	        }
	        else {
	            // We've already removed the query. No big deal, ignore the update
	            return [];
	        }
	    };
	    /**
	     * Add an event callback for the specified query.
	     *
	     * @param {!Query} query
	     * @param {!EventRegistration} eventRegistration
	     * @return {!Array.<!Event>} Events to raise.
	     */
	    SyncTree.prototype.addEventRegistration = function (query, eventRegistration) {
	        var path = query.path;
	        var serverCache = null;
	        var foundAncestorDefaultView = false;
	        // Any covering writes will necessarily be at the root, so really all we need to find is the server cache.
	        // Consider optimizing this once there's a better understanding of what actual behavior will be.
	        this.syncPointTree_.foreachOnPath(path, function (pathToSyncPoint, sp) {
	            var relativePath = Path_1.Path.relativePath(pathToSyncPoint, path);
	            serverCache = serverCache || sp.getCompleteServerCache(relativePath);
	            foundAncestorDefaultView =
	                foundAncestorDefaultView || sp.hasCompleteView();
	        });
	        var syncPoint = this.syncPointTree_.get(path);
	        if (!syncPoint) {
	            syncPoint = new SyncPoint_1.SyncPoint();
	            this.syncPointTree_ = this.syncPointTree_.set(path, syncPoint);
	        }
	        else {
	            foundAncestorDefaultView =
	                foundAncestorDefaultView || syncPoint.hasCompleteView();
	            serverCache = serverCache || syncPoint.getCompleteServerCache(Path_1.Path.Empty);
	        }
	        var serverCacheComplete;
	        if (serverCache != null) {
	            serverCacheComplete = true;
	        }
	        else {
	            serverCacheComplete = false;
	            serverCache = ChildrenNode_1.ChildrenNode.EMPTY_NODE;
	            var subtree = this.syncPointTree_.subtree(path);
	            subtree.foreachChild(function (childName, childSyncPoint) {
	                var completeCache = childSyncPoint.getCompleteServerCache(Path_1.Path.Empty);
	                if (completeCache) {
	                    serverCache = serverCache.updateImmediateChild(childName, completeCache);
	                }
	            });
	        }
	        var viewAlreadyExists = syncPoint.viewExistsForQuery(query);
	        if (!viewAlreadyExists && !query.getQueryParams().loadsAllData()) {
	            // We need to track a tag for this query
	            var queryKey = SyncTree.makeQueryKey_(query);
	            util_1.assert(!(queryKey in this.queryToTagMap_), 'View does not exist, but we have a tag');
	            var tag = SyncTree.getNextQueryTag_();
	            this.queryToTagMap_[queryKey] = tag;
	            // Coerce to string to avoid sparse arrays.
	            this.tagToQueryMap_['_' + tag] = queryKey;
	        }
	        var writesCache = this.pendingWriteTree_.childWrites(path);
	        var events = syncPoint.addEventRegistration(query, eventRegistration, writesCache, serverCache, serverCacheComplete);
	        if (!viewAlreadyExists && !foundAncestorDefaultView) {
	            var view /** @type !View */ = syncPoint.viewForQuery(query);
	            events = events.concat(this.setupListener_(query, view));
	        }
	        return events;
	    };
	    /**
	     * Remove event callback(s).
	     *
	     * If query is the default query, we'll check all queries for the specified eventRegistration.
	     * If eventRegistration is null, we'll remove all callbacks for the specified query/queries.
	     *
	     * @param {!Query} query
	     * @param {?EventRegistration} eventRegistration If null, all callbacks are removed.
	     * @param {Error=} cancelError If a cancelError is provided, appropriate cancel events will be returned.
	     * @return {!Array.<!Event>} Cancel events, if cancelError was provided.
	     */
	    SyncTree.prototype.removeEventRegistration = function (query, eventRegistration, cancelError) {
	        var _this = this;
	        // Find the syncPoint first. Then deal with whether or not it has matching listeners
	        var path = query.path;
	        var maybeSyncPoint = this.syncPointTree_.get(path);
	        var cancelEvents = [];
	        // A removal on a default query affects all queries at that location. A removal on an indexed query, even one without
	        // other query constraints, does *not* affect all queries at that location. So this check must be for 'default', and
	        // not loadsAllData().
	        if (maybeSyncPoint &&
	            (query.queryIdentifier() === 'default' ||
	                maybeSyncPoint.viewExistsForQuery(query))) {
	            /**
	             * @type {{removed: !Array.<!Query>, events: !Array.<!Event>}}
	             */
	            var removedAndEvents = maybeSyncPoint.removeEventRegistration(query, eventRegistration, cancelError);
	            if (maybeSyncPoint.isEmpty()) {
	                this.syncPointTree_ = this.syncPointTree_.remove(path);
	            }
	            var removed = removedAndEvents.removed;
	            cancelEvents = removedAndEvents.events;
	            // We may have just removed one of many listeners and can short-circuit this whole process
	            // We may also not have removed a default listener, in which case all of the descendant listeners should already be
	            // properly set up.
	            //
	            // Since indexed queries can shadow if they don't have other query constraints, check for loadsAllData(), instead of
	            // queryId === 'default'
	            var removingDefault = -1 !==
	                removed.findIndex(function (query) {
	                    return query.getQueryParams().loadsAllData();
	                });
	            var covered = this.syncPointTree_.findOnPath(path, function (relativePath, parentSyncPoint) {
	                return parentSyncPoint.hasCompleteView();
	            });
	            if (removingDefault && !covered) {
	                var subtree = this.syncPointTree_.subtree(path);
	                // There are potentially child listeners. Determine what if any listens we need to send before executing the
	                // removal
	                if (!subtree.isEmpty()) {
	                    // We need to fold over our subtree and collect the listeners to send
	                    var newViews = this.collectDistinctViewsForSubTree_(subtree);
	                    // Ok, we've collected all the listens we need. Set them up.
	                    for (var i = 0; i < newViews.length; ++i) {
	                        var view = newViews[i], newQuery = view.getQuery();
	                        var listener = this.createListenerForView_(view);
	                        this.listenProvider_.startListening(SyncTree.queryForListening_(newQuery), this.tagForQuery_(newQuery), listener.hashFn, listener.onComplete);
	                    }
	                }
	                else {
	                    // There's nothing below us, so nothing we need to start listening on
	                }
	            }
	            // If we removed anything and we're not covered by a higher up listen, we need to stop listening on this query
	            // The above block has us covered in terms of making sure we're set up on listens lower in the tree.
	            // Also, note that if we have a cancelError, it's already been removed at the provider level.
	            if (!covered && removed.length > 0 && !cancelError) {
	                // If we removed a default, then we weren't listening on any of the other queries here. Just cancel the one
	                // default. Otherwise, we need to iterate through and cancel each individual query
	                if (removingDefault) {
	                    // We don't tag default listeners
	                    var defaultTag = null;
	                    this.listenProvider_.stopListening(SyncTree.queryForListening_(query), defaultTag);
	                }
	                else {
	                    removed.forEach(function (queryToRemove) {
	                        var tagToRemove = _this.queryToTagMap_[SyncTree.makeQueryKey_(queryToRemove)];
	                        _this.listenProvider_.stopListening(SyncTree.queryForListening_(queryToRemove), tagToRemove);
	                    });
	                }
	            }
	            // Now, clear all of the tags we're tracking for the removed listens
	            this.removeTags_(removed);
	        }
	        else {
	            // No-op, this listener must've been already removed
	        }
	        return cancelEvents;
	    };
	    /**
	     * Returns a complete cache, if we have one, of the data at a particular path. The location must have a listener above
	     * it, but as this is only used by transaction code, that should always be the case anyways.
	     *
	     * Note: this method will *include* hidden writes from transaction with applyLocally set to false.
	     * @param {!Path} path The path to the data we want
	     * @param {Array.<number>=} writeIdsToExclude A specific set to be excluded
	     * @return {?Node}
	     */
	    SyncTree.prototype.calcCompleteEventCache = function (path, writeIdsToExclude) {
	        var includeHiddenSets = true;
	        var writeTree = this.pendingWriteTree_;
	        var serverCache = this.syncPointTree_.findOnPath(path, function (pathSoFar, syncPoint) {
	            var relativePath = Path_1.Path.relativePath(pathSoFar, path);
	            var serverCache = syncPoint.getCompleteServerCache(relativePath);
	            if (serverCache) {
	                return serverCache;
	            }
	        });
	        return writeTree.calcCompleteEventCache(path, serverCache, writeIdsToExclude, includeHiddenSets);
	    };
	    /**
	     * This collapses multiple unfiltered views into a single view, since we only need a single
	     * listener for them.
	     *
	     * @param {!ImmutableTree.<!SyncPoint>} subtree
	     * @return {!Array.<!View>}
	     * @private
	     */
	    SyncTree.prototype.collectDistinctViewsForSubTree_ = function (subtree) {
	        return subtree.fold(function (relativePath, maybeChildSyncPoint, childMap) {
	            if (maybeChildSyncPoint && maybeChildSyncPoint.hasCompleteView()) {
	                var completeView = maybeChildSyncPoint.getCompleteView();
	                return [completeView];
	            }
	            else {
	                // No complete view here, flatten any deeper listens into an array
	                var views_1 = [];
	                if (maybeChildSyncPoint) {
	                    views_1 = maybeChildSyncPoint.getQueryViews();
	                }
	                util_3.forEach(childMap, function (key, childViews) {
	                    views_1 = views_1.concat(childViews);
	                });
	                return views_1;
	            }
	        });
	    };
	    /**
	     * @param {!Array.<!Query>} queries
	     * @private
	     */
	    SyncTree.prototype.removeTags_ = function (queries) {
	        for (var j = 0; j < queries.length; ++j) {
	            var removedQuery = queries[j];
	            if (!removedQuery.getQueryParams().loadsAllData()) {
	                // We should have a tag for this
	                var removedQueryKey = SyncTree.makeQueryKey_(removedQuery);
	                var removedQueryTag = this.queryToTagMap_[removedQueryKey];
	                delete this.queryToTagMap_[removedQueryKey];
	                delete this.tagToQueryMap_['_' + removedQueryTag];
	            }
	        }
	    };
	    /**
	     * Normalizes a query to a query we send the server for listening
	     * @param {!Query} query
	     * @return {!Query} The normalized query
	     * @private
	     */
	    SyncTree.queryForListening_ = function (query) {
	        if (query.getQueryParams().loadsAllData() &&
	            !query.getQueryParams().isDefault()) {
	            // We treat queries that load all data as default queries
	            // Cast is necessary because ref() technically returns Firebase which is actually fb.api.Firebase which inherits
	            // from Query
	            return /** @type {!Query} */ query.getRef();
	        }
	        else {
	            return query;
	        }
	    };
	    /**
	     * For a given new listen, manage the de-duplication of outstanding subscriptions.
	     *
	     * @param {!Query} query
	     * @param {!View} view
	     * @return {!Array.<!Event>} This method can return events to support synchronous data sources
	     * @private
	     */
	    SyncTree.prototype.setupListener_ = function (query, view) {
	        var path = query.path;
	        var tag = this.tagForQuery_(query);
	        var listener = this.createListenerForView_(view);
	        var events = this.listenProvider_.startListening(SyncTree.queryForListening_(query), tag, listener.hashFn, listener.onComplete);
	        var subtree = this.syncPointTree_.subtree(path);
	        // The root of this subtree has our query. We're here because we definitely need to send a listen for that, but we
	        // may need to shadow other listens as well.
	        if (tag) {
	            util_1.assert(!subtree.value.hasCompleteView(), "If we're adding a query, it shouldn't be shadowed");
	        }
	        else {
	            // Shadow everything at or below this location, this is a default listener.
	            var queriesToStop = subtree.fold(function (relativePath, maybeChildSyncPoint, childMap) {
	                if (!relativePath.isEmpty() &&
	                    maybeChildSyncPoint &&
	                    maybeChildSyncPoint.hasCompleteView()) {
	                    return [maybeChildSyncPoint.getCompleteView().getQuery()];
	                }
	                else {
	                    // No default listener here, flatten any deeper queries into an array
	                    var queries_1 = [];
	                    if (maybeChildSyncPoint) {
	                        queries_1 = queries_1.concat(maybeChildSyncPoint.getQueryViews().map(function (view) { return view.getQuery(); }));
	                    }
	                    util_3.forEach(childMap, function (key, childQueries) {
	                        queries_1 = queries_1.concat(childQueries);
	                    });
	                    return queries_1;
	                }
	            });
	            for (var i = 0; i < queriesToStop.length; ++i) {
	                var queryToStop = queriesToStop[i];
	                this.listenProvider_.stopListening(SyncTree.queryForListening_(queryToStop), this.tagForQuery_(queryToStop));
	            }
	        }
	        return events;
	    };
	    /**
	     *
	     * @param {!View} view
	     * @return {{hashFn: function(), onComplete: function(!string, *)}}
	     * @private
	     */
	    SyncTree.prototype.createListenerForView_ = function (view) {
	        var _this = this;
	        var query = view.getQuery();
	        var tag = this.tagForQuery_(query);
	        return {
	            hashFn: function () {
	                var cache = view.getServerCache() || ChildrenNode_1.ChildrenNode.EMPTY_NODE;
	                return cache.hash();
	            },
	            onComplete: function (status) {
	                if (status === 'ok') {
	                    if (tag) {
	                        return _this.applyTaggedListenComplete(query.path, tag);
	                    }
	                    else {
	                        return _this.applyListenComplete(query.path);
	                    }
	                }
	                else {
	                    // If a listen failed, kill all of the listeners here, not just the one that triggered the error.
	                    // Note that this may need to be scoped to just this listener if we change permissions on filtered children
	                    var error = util_2.errorForServerCode(status, query);
	                    return _this.removeEventRegistration(query, 
	                    /*eventRegistration*/ null, error);
	                }
	            }
	        };
	    };
	    /**
	     * Given a query, computes a "queryKey" suitable for use in our queryToTagMap_.
	     * @private
	     * @param {!Query} query
	     * @return {string}
	     */
	    SyncTree.makeQueryKey_ = function (query) {
	        return query.path.toString() + '$' + query.queryIdentifier();
	    };
	    /**
	     * Given a queryKey (created by makeQueryKey), parse it back into a path and queryId.
	     * @private
	     * @param {!string} queryKey
	     * @return {{queryId: !string, path: !Path}}
	     */
	    SyncTree.parseQueryKey_ = function (queryKey) {
	        var splitIndex = queryKey.indexOf('$');
	        util_1.assert(splitIndex !== -1 && splitIndex < queryKey.length - 1, 'Bad queryKey.');
	        return {
	            queryId: queryKey.substr(splitIndex + 1),
	            path: new Path_1.Path(queryKey.substr(0, splitIndex))
	        };
	    };
	    /**
	     * Return the query associated with the given tag, if we have one
	     * @param {!number} tag
	     * @return {?string}
	     * @private
	     */
	    SyncTree.prototype.queryKeyForTag_ = function (tag) {
	        return this.tagToQueryMap_['_' + tag];
	    };
	    /**
	     * Return the tag associated with the given query.
	     * @param {!Query} query
	     * @return {?number}
	     * @private
	     */
	    SyncTree.prototype.tagForQuery_ = function (query) {
	        var queryKey = SyncTree.makeQueryKey_(query);
	        return util_3.safeGet(this.queryToTagMap_, queryKey);
	    };
	    /**
	     * Static accessor for query tags.
	     * @return {number}
	     * @private
	     */
	    SyncTree.getNextQueryTag_ = function () {
	        return SyncTree.nextQueryTag_++;
	    };
	    /**
	     * A helper method to apply tagged operations
	     *
	     * @param {!Path} queryPath
	     * @param {!Operation} operation
	     * @return {!Array.<!Event>}
	     * @private
	     */
	    SyncTree.prototype.applyTaggedOperation_ = function (queryPath, operation) {
	        var syncPoint = this.syncPointTree_.get(queryPath);
	        util_1.assert(syncPoint, "Missing sync point for query tag that we're tracking");
	        var writesCache = this.pendingWriteTree_.childWrites(queryPath);
	        return syncPoint.applyOperation(operation, writesCache, 
	        /*serverCache=*/ null);
	    };
	    /**
	     * A helper method that visits all descendant and ancestor SyncPoints, applying the operation.
	     *
	     * NOTES:
	     * - Descendant SyncPoints will be visited first (since we raise events depth-first).
	  
	     * - We call applyOperation() on each SyncPoint passing three things:
	     *   1. A version of the Operation that has been made relative to the SyncPoint location.
	     *   2. A WriteTreeRef of any writes we have cached at the SyncPoint location.
	     *   3. A snapshot Node with cached server data, if we have it.
	  
	     * - We concatenate all of the events returned by each SyncPoint and return the result.
	     *
	     * @param {!Operation} operation
	     * @return {!Array.<!Event>}
	     * @private
	     */
	    SyncTree.prototype.applyOperationToSyncPoints_ = function (operation) {
	        return this.applyOperationHelper_(operation, this.syncPointTree_, 
	        /*serverCache=*/ null, this.pendingWriteTree_.childWrites(Path_1.Path.Empty));
	    };
	    /**
	     * Recursive helper for applyOperationToSyncPoints_
	     *
	     * @private
	     * @param {!Operation} operation
	     * @param {ImmutableTree.<!SyncPoint>} syncPointTree
	     * @param {?Node} serverCache
	     * @param {!WriteTreeRef} writesCache
	     * @return {!Array.<!Event>}
	     */
	    SyncTree.prototype.applyOperationHelper_ = function (operation, syncPointTree, serverCache, writesCache) {
	        if (operation.path.isEmpty()) {
	            return this.applyOperationDescendantsHelper_(operation, syncPointTree, serverCache, writesCache);
	        }
	        else {
	            var syncPoint = syncPointTree.get(Path_1.Path.Empty);
	            // If we don't have cached server data, see if we can get it from this SyncPoint.
	            if (serverCache == null && syncPoint != null) {
	                serverCache = syncPoint.getCompleteServerCache(Path_1.Path.Empty);
	            }
	            var events = [];
	            var childName = operation.path.getFront();
	            var childOperation = operation.operationForChild(childName);
	            var childTree = syncPointTree.children.get(childName);
	            if (childTree && childOperation) {
	                var childServerCache = serverCache
	                    ? serverCache.getImmediateChild(childName)
	                    : null;
	                var childWritesCache = writesCache.child(childName);
	                events = events.concat(this.applyOperationHelper_(childOperation, childTree, childServerCache, childWritesCache));
	            }
	            if (syncPoint) {
	                events = events.concat(syncPoint.applyOperation(operation, writesCache, serverCache));
	            }
	            return events;
	        }
	    };
	    /**
	     * Recursive helper for applyOperationToSyncPoints_
	     *
	     * @private
	     * @param {!Operation} operation
	     * @param {ImmutableTree.<!SyncPoint>} syncPointTree
	     * @param {?Node} serverCache
	     * @param {!WriteTreeRef} writesCache
	     * @return {!Array.<!Event>}
	     */
	    SyncTree.prototype.applyOperationDescendantsHelper_ = function (operation, syncPointTree, serverCache, writesCache) {
	        var _this = this;
	        var syncPoint = syncPointTree.get(Path_1.Path.Empty);
	        // If we don't have cached server data, see if we can get it from this SyncPoint.
	        if (serverCache == null && syncPoint != null) {
	            serverCache = syncPoint.getCompleteServerCache(Path_1.Path.Empty);
	        }
	        var events = [];
	        syncPointTree.children.inorderTraversal(function (childName, childTree) {
	            var childServerCache = serverCache
	                ? serverCache.getImmediateChild(childName)
	                : null;
	            var childWritesCache = writesCache.child(childName);
	            var childOperation = operation.operationForChild(childName);
	            if (childOperation) {
	                events = events.concat(_this.applyOperationDescendantsHelper_(childOperation, childTree, childServerCache, childWritesCache));
	            }
	        });
	        if (syncPoint) {
	            events = events.concat(syncPoint.applyOperation(operation, writesCache, serverCache));
	        }
	        return events;
	    };
	    /**
	     * Static tracker for next query tag.
	     * @type {number}
	     * @private
	     */
	    SyncTree.nextQueryTag_ = 1;
	    return SyncTree;
	}());
	exports.SyncTree = SyncTree;
	
	//# sourceMappingURL=SyncTree.js.map


/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var util_1 = __webpack_require__(1);
	var util_2 = __webpack_require__(1);
	var Path_1 = __webpack_require__(8);
	var CompoundWrite_1 = __webpack_require__(229);
	var PriorityIndex_1 = __webpack_require__(15);
	var ChildrenNode_1 = __webpack_require__(17);
	/**
	 * WriteTree tracks all pending user-initiated writes and has methods to calculate the result of merging them
	 * with underlying server data (to create "event cache" data).  Pending writes are added with addOverwrite()
	 * and addMerge(), and removed with removeWrite().
	 *
	 * @constructor
	 */
	var WriteTree = /** @class */ (function () {
	    function WriteTree() {
	        /**
	         * A tree tracking the result of applying all visible writes.  This does not include transactions with
	         * applyLocally=false or writes that are completely shadowed by other writes.
	         *
	         * @type {!CompoundWrite}
	         * @private
	         */
	        this.visibleWrites_ = CompoundWrite_1.CompoundWrite.Empty;
	        /**
	         * A list of all pending writes, regardless of visibility and shadowed-ness.  Used to calculate arbitrary
	         * sets of the changed data, such as hidden writes (from transactions) or changes with certain writes excluded (also
	         * used by transactions).
	         *
	         * @type {!Array.<!WriteRecord>}
	         * @private
	         */
	        this.allWrites_ = [];
	        this.lastWriteId_ = -1;
	    }
	    /**
	     * Create a new WriteTreeRef for the given path. For use with a new sync point at the given path.
	     *
	     * @param {!Path} path
	     * @return {!WriteTreeRef}
	     */
	    WriteTree.prototype.childWrites = function (path) {
	        return new WriteTreeRef(path, this);
	    };
	    /**
	     * Record a new overwrite from user code.
	     *
	     * @param {!Path} path
	     * @param {!Node} snap
	     * @param {!number} writeId
	     * @param {boolean=} visible This is set to false by some transactions. It should be excluded from event caches
	     */
	    WriteTree.prototype.addOverwrite = function (path, snap, writeId, visible) {
	        util_2.assert(writeId > this.lastWriteId_, 'Stacking an older write on top of newer ones');
	        if (visible === undefined) {
	            visible = true;
	        }
	        this.allWrites_.push({
	            path: path,
	            snap: snap,
	            writeId: writeId,
	            visible: visible
	        });
	        if (visible) {
	            this.visibleWrites_ = this.visibleWrites_.addWrite(path, snap);
	        }
	        this.lastWriteId_ = writeId;
	    };
	    /**
	     * Record a new merge from user code.
	     *
	     * @param {!Path} path
	     * @param {!Object.<string, !Node>} changedChildren
	     * @param {!number} writeId
	     */
	    WriteTree.prototype.addMerge = function (path, changedChildren, writeId) {
	        util_2.assert(writeId > this.lastWriteId_, 'Stacking an older merge on top of newer ones');
	        this.allWrites_.push({
	            path: path,
	            children: changedChildren,
	            writeId: writeId,
	            visible: true
	        });
	        this.visibleWrites_ = this.visibleWrites_.addWrites(path, changedChildren);
	        this.lastWriteId_ = writeId;
	    };
	    /**
	     * @param {!number} writeId
	     * @return {?WriteRecord}
	     */
	    WriteTree.prototype.getWrite = function (writeId) {
	        for (var i = 0; i < this.allWrites_.length; i++) {
	            var record = this.allWrites_[i];
	            if (record.writeId === writeId) {
	                return record;
	            }
	        }
	        return null;
	    };
	    /**
	     * Remove a write (either an overwrite or merge) that has been successfully acknowledge by the server. Recalculates
	     * the tree if necessary.  We return true if it may have been visible, meaning views need to reevaluate.
	     *
	     * @param {!number} writeId
	     * @return {boolean} true if the write may have been visible (meaning we'll need to reevaluate / raise
	     * events as a result).
	     */
	    WriteTree.prototype.removeWrite = function (writeId) {
	        // Note: disabling this check. It could be a transaction that preempted another transaction, and thus was applied
	        // out of order.
	        //const validClear = revert || this.allWrites_.length === 0 || writeId <= this.allWrites_[0].writeId;
	        //assert(validClear, "Either we don't have this write, or it's the first one in the queue");
	        var _this = this;
	        var idx = this.allWrites_.findIndex(function (s) {
	            return s.writeId === writeId;
	        });
	        util_2.assert(idx >= 0, 'removeWrite called with nonexistent writeId.');
	        var writeToRemove = this.allWrites_[idx];
	        this.allWrites_.splice(idx, 1);
	        var removedWriteWasVisible = writeToRemove.visible;
	        var removedWriteOverlapsWithOtherWrites = false;
	        var i = this.allWrites_.length - 1;
	        while (removedWriteWasVisible && i >= 0) {
	            var currentWrite = this.allWrites_[i];
	            if (currentWrite.visible) {
	                if (i >= idx &&
	                    this.recordContainsPath_(currentWrite, writeToRemove.path)) {
	                    // The removed write was completely shadowed by a subsequent write.
	                    removedWriteWasVisible = false;
	                }
	                else if (writeToRemove.path.contains(currentWrite.path)) {
	                    // Either we're covering some writes or they're covering part of us (depending on which came first).
	                    removedWriteOverlapsWithOtherWrites = true;
	                }
	            }
	            i--;
	        }
	        if (!removedWriteWasVisible) {
	            return false;
	        }
	        else if (removedWriteOverlapsWithOtherWrites) {
	            // There's some shadowing going on. Just rebuild the visible writes from scratch.
	            this.resetTree_();
	            return true;
	        }
	        else {
	            // There's no shadowing.  We can safely just remove the write(s) from visibleWrites.
	            if (writeToRemove.snap) {
	                this.visibleWrites_ = this.visibleWrites_.removeWrite(writeToRemove.path);
	            }
	            else {
	                var children = writeToRemove.children;
	                util_1.forEach(children, function (childName) {
	                    _this.visibleWrites_ = _this.visibleWrites_.removeWrite(writeToRemove.path.child(childName));
	                });
	            }
	            return true;
	        }
	    };
	    /**
	     * Return a complete snapshot for the given path if there's visible write data at that path, else null.
	     * No server data is considered.
	     *
	     * @param {!Path} path
	     * @return {?Node}
	     */
	    WriteTree.prototype.getCompleteWriteData = function (path) {
	        return this.visibleWrites_.getCompleteNode(path);
	    };
	    /**
	     * Given optional, underlying server data, and an optional set of constraints (exclude some sets, include hidden
	     * writes), attempt to calculate a complete snapshot for the given path
	     *
	     * @param {!Path} treePath
	     * @param {?Node} completeServerCache
	     * @param {Array.<number>=} writeIdsToExclude An optional set to be excluded
	     * @param {boolean=} includeHiddenWrites Defaults to false, whether or not to layer on writes with visible set to false
	     * @return {?Node}
	     */
	    WriteTree.prototype.calcCompleteEventCache = function (treePath, completeServerCache, writeIdsToExclude, includeHiddenWrites) {
	        if (!writeIdsToExclude && !includeHiddenWrites) {
	            var shadowingNode = this.visibleWrites_.getCompleteNode(treePath);
	            if (shadowingNode != null) {
	                return shadowingNode;
	            }
	            else {
	                var subMerge = this.visibleWrites_.childCompoundWrite(treePath);
	                if (subMerge.isEmpty()) {
	                    return completeServerCache;
	                }
	                else if (completeServerCache == null &&
	                    !subMerge.hasCompleteWrite(Path_1.Path.Empty)) {
	                    // We wouldn't have a complete snapshot, since there's no underlying data and no complete shadow
	                    return null;
	                }
	                else {
	                    var layeredCache = completeServerCache || ChildrenNode_1.ChildrenNode.EMPTY_NODE;
	                    return subMerge.apply(layeredCache);
	                }
	            }
	        }
	        else {
	            var merge = this.visibleWrites_.childCompoundWrite(treePath);
	            if (!includeHiddenWrites && merge.isEmpty()) {
	                return completeServerCache;
	            }
	            else {
	                // If the server cache is null, and we don't have a complete cache, we need to return null
	                if (!includeHiddenWrites &&
	                    completeServerCache == null &&
	                    !merge.hasCompleteWrite(Path_1.Path.Empty)) {
	                    return null;
	                }
	                else {
	                    var filter = function (write) {
	                        return ((write.visible || includeHiddenWrites) &&
	                            (!writeIdsToExclude ||
	                                !~writeIdsToExclude.indexOf(write.writeId)) &&
	                            (write.path.contains(treePath) || treePath.contains(write.path)));
	                    };
	                    var mergeAtPath = WriteTree.layerTree_(this.allWrites_, filter, treePath);
	                    var layeredCache = completeServerCache || ChildrenNode_1.ChildrenNode.EMPTY_NODE;
	                    return mergeAtPath.apply(layeredCache);
	                }
	            }
	        }
	    };
	    /**
	     * With optional, underlying server data, attempt to return a children node of children that we have complete data for.
	     * Used when creating new views, to pre-fill their complete event children snapshot.
	     *
	     * @param {!Path} treePath
	     * @param {?ChildrenNode} completeServerChildren
	     * @return {!ChildrenNode}
	     */
	    WriteTree.prototype.calcCompleteEventChildren = function (treePath, completeServerChildren) {
	        var completeChildren = ChildrenNode_1.ChildrenNode.EMPTY_NODE;
	        var topLevelSet = this.visibleWrites_.getCompleteNode(treePath);
	        if (topLevelSet) {
	            if (!topLevelSet.isLeafNode()) {
	                // we're shadowing everything. Return the children.
	                topLevelSet.forEachChild(PriorityIndex_1.PRIORITY_INDEX, function (childName, childSnap) {
	                    completeChildren = completeChildren.updateImmediateChild(childName, childSnap);
	                });
	            }
	            return completeChildren;
	        }
	        else if (completeServerChildren) {
	            // Layer any children we have on top of this
	            // We know we don't have a top-level set, so just enumerate existing children
	            var merge_1 = this.visibleWrites_.childCompoundWrite(treePath);
	            completeServerChildren.forEachChild(PriorityIndex_1.PRIORITY_INDEX, function (childName, childNode) {
	                var node = merge_1
	                    .childCompoundWrite(new Path_1.Path(childName))
	                    .apply(childNode);
	                completeChildren = completeChildren.updateImmediateChild(childName, node);
	            });
	            // Add any complete children we have from the set
	            merge_1.getCompleteChildren().forEach(function (namedNode) {
	                completeChildren = completeChildren.updateImmediateChild(namedNode.name, namedNode.node);
	            });
	            return completeChildren;
	        }
	        else {
	            // We don't have anything to layer on top of. Layer on any children we have
	            // Note that we can return an empty snap if we have a defined delete
	            var merge = this.visibleWrites_.childCompoundWrite(treePath);
	            merge.getCompleteChildren().forEach(function (namedNode) {
	                completeChildren = completeChildren.updateImmediateChild(namedNode.name, namedNode.node);
	            });
	            return completeChildren;
	        }
	    };
	    /**
	     * Given that the underlying server data has updated, determine what, if anything, needs to be
	     * applied to the event cache.
	     *
	     * Possibilities:
	     *
	     * 1. No writes are shadowing. Events should be raised, the snap to be applied comes from the server data
	     *
	     * 2. Some write is completely shadowing. No events to be raised
	     *
	     * 3. Is partially shadowed. Events
	     *
	     * Either existingEventSnap or existingServerSnap must exist
	     *
	     * @param {!Path} treePath
	     * @param {!Path} childPath
	     * @param {?Node} existingEventSnap
	     * @param {?Node} existingServerSnap
	     * @return {?Node}
	     */
	    WriteTree.prototype.calcEventCacheAfterServerOverwrite = function (treePath, childPath, existingEventSnap, existingServerSnap) {
	        util_2.assert(existingEventSnap || existingServerSnap, 'Either existingEventSnap or existingServerSnap must exist');
	        var path = treePath.child(childPath);
	        if (this.visibleWrites_.hasCompleteWrite(path)) {
	            // At this point we can probably guarantee that we're in case 2, meaning no events
	            // May need to check visibility while doing the findRootMostValueAndPath call
	            return null;
	        }
	        else {
	            // No complete shadowing. We're either partially shadowing or not shadowing at all.
	            var childMerge = this.visibleWrites_.childCompoundWrite(path);
	            if (childMerge.isEmpty()) {
	                // We're not shadowing at all. Case 1
	                return existingServerSnap.getChild(childPath);
	            }
	            else {
	                // This could be more efficient if the serverNode + updates doesn't change the eventSnap
	                // However this is tricky to find out, since user updates don't necessary change the server
	                // snap, e.g. priority updates on empty nodes, or deep deletes. Another special case is if the server
	                // adds nodes, but doesn't change any existing writes. It is therefore not enough to
	                // only check if the updates change the serverNode.
	                // Maybe check if the merge tree contains these special cases and only do a full overwrite in that case?
	                return childMerge.apply(existingServerSnap.getChild(childPath));
	            }
	        }
	    };
	    /**
	     * Returns a complete child for a given server snap after applying all user writes or null if there is no
	     * complete child for this ChildKey.
	     *
	     * @param {!Path} treePath
	     * @param {!string} childKey
	     * @param {!CacheNode} existingServerSnap
	     * @return {?Node}
	     */
	    WriteTree.prototype.calcCompleteChild = function (treePath, childKey, existingServerSnap) {
	        var path = treePath.child(childKey);
	        var shadowingNode = this.visibleWrites_.getCompleteNode(path);
	        if (shadowingNode != null) {
	            return shadowingNode;
	        }
	        else {
	            if (existingServerSnap.isCompleteForChild(childKey)) {
	                var childMerge = this.visibleWrites_.childCompoundWrite(path);
	                return childMerge.apply(existingServerSnap.getNode().getImmediateChild(childKey));
	            }
	            else {
	                return null;
	            }
	        }
	    };
	    /**
	     * Returns a node if there is a complete overwrite for this path. More specifically, if there is a write at
	     * a higher path, this will return the child of that write relative to the write and this path.
	     * Returns null if there is no write at this path.
	     *
	     * @param {!Path} path
	     * @return {?Node}
	     */
	    WriteTree.prototype.shadowingWrite = function (path) {
	        return this.visibleWrites_.getCompleteNode(path);
	    };
	    /**
	     * This method is used when processing child remove events on a query. If we can, we pull in children that were outside
	     * the window, but may now be in the window.
	     *
	     * @param {!Path} treePath
	     * @param {?Node} completeServerData
	     * @param {!NamedNode} startPost
	     * @param {!number} count
	     * @param {boolean} reverse
	     * @param {!Index} index
	     * @return {!Array.<!NamedNode>}
	     */
	    WriteTree.prototype.calcIndexedSlice = function (treePath, completeServerData, startPost, count, reverse, index) {
	        var toIterate;
	        var merge = this.visibleWrites_.childCompoundWrite(treePath);
	        var shadowingNode = merge.getCompleteNode(Path_1.Path.Empty);
	        if (shadowingNode != null) {
	            toIterate = shadowingNode;
	        }
	        else if (completeServerData != null) {
	            toIterate = merge.apply(completeServerData);
	        }
	        else {
	            // no children to iterate on
	            return [];
	        }
	        toIterate = toIterate.withIndex(index);
	        if (!toIterate.isEmpty() && !toIterate.isLeafNode()) {
	            var nodes = [];
	            var cmp = index.getCompare();
	            var iter = reverse
	                ? toIterate.getReverseIteratorFrom(startPost, index)
	                : toIterate.getIteratorFrom(startPost, index);
	            var next = iter.getNext();
	            while (next && nodes.length < count) {
	                if (cmp(next, startPost) !== 0) {
	                    nodes.push(next);
	                }
	                next = iter.getNext();
	            }
	            return nodes;
	        }
	        else {
	            return [];
	        }
	    };
	    /**
	     * @param {!WriteRecord} writeRecord
	     * @param {!Path} path
	     * @return {boolean}
	     * @private
	     */
	    WriteTree.prototype.recordContainsPath_ = function (writeRecord, path) {
	        if (writeRecord.snap) {
	            return writeRecord.path.contains(path);
	        }
	        else {
	            // findKey can return undefined, so use !! to coerce to boolean
	            return !!util_1.findKey(writeRecord.children, function (childSnap, childName) {
	                return writeRecord.path.child(childName).contains(path);
	            });
	        }
	    };
	    /**
	     * Re-layer the writes and merges into a tree so we can efficiently calculate event snapshots
	     * @private
	     */
	    WriteTree.prototype.resetTree_ = function () {
	        this.visibleWrites_ = WriteTree.layerTree_(this.allWrites_, WriteTree.DefaultFilter_, Path_1.Path.Empty);
	        if (this.allWrites_.length > 0) {
	            this.lastWriteId_ = this.allWrites_[this.allWrites_.length - 1].writeId;
	        }
	        else {
	            this.lastWriteId_ = -1;
	        }
	    };
	    /**
	     * The default filter used when constructing the tree. Keep everything that's visible.
	     *
	     * @param {!WriteRecord} write
	     * @return {boolean}
	     * @private
	     */
	    WriteTree.DefaultFilter_ = function (write) {
	        return write.visible;
	    };
	    /**
	     * Static method. Given an array of WriteRecords, a filter for which ones to include, and a path, construct the tree of
	     * event data at that path.
	     *
	     * @param {!Array.<!WriteRecord>} writes
	     * @param {!function(!WriteRecord):boolean} filter
	     * @param {!Path} treeRoot
	     * @return {!CompoundWrite}
	     * @private
	     */
	    WriteTree.layerTree_ = function (writes, filter, treeRoot) {
	        var compoundWrite = CompoundWrite_1.CompoundWrite.Empty;
	        for (var i = 0; i < writes.length; ++i) {
	            var write = writes[i];
	            // Theory, a later set will either:
	            // a) abort a relevant transaction, so no need to worry about excluding it from calculating that transaction
	            // b) not be relevant to a transaction (separate branch), so again will not affect the data for that transaction
	            if (filter(write)) {
	                var writePath = write.path;
	                var relativePath = void 0;
	                if (write.snap) {
	                    if (treeRoot.contains(writePath)) {
	                        relativePath = Path_1.Path.relativePath(treeRoot, writePath);
	                        compoundWrite = compoundWrite.addWrite(relativePath, write.snap);
	                    }
	                    else if (writePath.contains(treeRoot)) {
	                        relativePath = Path_1.Path.relativePath(writePath, treeRoot);
	                        compoundWrite = compoundWrite.addWrite(Path_1.Path.Empty, write.snap.getChild(relativePath));
	                    }
	                    else {
	                        // There is no overlap between root path and write path, ignore write
	                    }
	                }
	                else if (write.children) {
	                    if (treeRoot.contains(writePath)) {
	                        relativePath = Path_1.Path.relativePath(treeRoot, writePath);
	                        compoundWrite = compoundWrite.addWrites(relativePath, write.children);
	                    }
	                    else if (writePath.contains(treeRoot)) {
	                        relativePath = Path_1.Path.relativePath(writePath, treeRoot);
	                        if (relativePath.isEmpty()) {
	                            compoundWrite = compoundWrite.addWrites(Path_1.Path.Empty, write.children);
	                        }
	                        else {
	                            var child = util_1.safeGet(write.children, relativePath.getFront());
	                            if (child) {
	                                // There exists a child in this node that matches the root path
	                                var deepNode = child.getChild(relativePath.popFront());
	                                compoundWrite = compoundWrite.addWrite(Path_1.Path.Empty, deepNode);
	                            }
	                        }
	                    }
	                    else {
	                        // There is no overlap between root path and write path, ignore write
	                    }
	                }
	                else {
	                    throw util_2.assertionError('WriteRecord should have .snap or .children');
	                }
	            }
	        }
	        return compoundWrite;
	    };
	    return WriteTree;
	}());
	exports.WriteTree = WriteTree;
	/**
	 * A WriteTreeRef wraps a WriteTree and a path, for convenient access to a particular subtree.  All of the methods
	 * just proxy to the underlying WriteTree.
	 *
	 * @constructor
	 */
	var WriteTreeRef = /** @class */ (function () {
	    /**
	     * @param {!Path} path
	     * @param {!WriteTree} writeTree
	     */
	    function WriteTreeRef(path, writeTree) {
	        this.treePath_ = path;
	        this.writeTree_ = writeTree;
	    }
	    /**
	     * If possible, returns a complete event cache, using the underlying server data if possible. In addition, can be used
	     * to get a cache that includes hidden writes, and excludes arbitrary writes. Note that customizing the returned node
	     * can lead to a more expensive calculation.
	     *
	     * @param {?Node} completeServerCache
	     * @param {Array.<number>=} writeIdsToExclude Optional writes to exclude.
	     * @param {boolean=} includeHiddenWrites Defaults to false, whether or not to layer on writes with visible set to false
	     * @return {?Node}
	     */
	    WriteTreeRef.prototype.calcCompleteEventCache = function (completeServerCache, writeIdsToExclude, includeHiddenWrites) {
	        return this.writeTree_.calcCompleteEventCache(this.treePath_, completeServerCache, writeIdsToExclude, includeHiddenWrites);
	    };
	    /**
	     * If possible, returns a children node containing all of the complete children we have data for. The returned data is a
	     * mix of the given server data and write data.
	     *
	     * @param {?ChildrenNode} completeServerChildren
	     * @return {!ChildrenNode}
	     */
	    WriteTreeRef.prototype.calcCompleteEventChildren = function (completeServerChildren) {
	        return this.writeTree_.calcCompleteEventChildren(this.treePath_, completeServerChildren);
	    };
	    /**
	     * Given that either the underlying server data has updated or the outstanding writes have updated, determine what,
	     * if anything, needs to be applied to the event cache.
	     *
	     * Possibilities:
	     *
	     * 1. No writes are shadowing. Events should be raised, the snap to be applied comes from the server data
	     *
	     * 2. Some write is completely shadowing. No events to be raised
	     *
	     * 3. Is partially shadowed. Events should be raised
	     *
	     * Either existingEventSnap or existingServerSnap must exist, this is validated via an assert
	     *
	     * @param {!Path} path
	     * @param {?Node} existingEventSnap
	     * @param {?Node} existingServerSnap
	     * @return {?Node}
	     */
	    WriteTreeRef.prototype.calcEventCacheAfterServerOverwrite = function (path, existingEventSnap, existingServerSnap) {
	        return this.writeTree_.calcEventCacheAfterServerOverwrite(this.treePath_, path, existingEventSnap, existingServerSnap);
	    };
	    /**
	     * Returns a node if there is a complete overwrite for this path. More specifically, if there is a write at
	     * a higher path, this will return the child of that write relative to the write and this path.
	     * Returns null if there is no write at this path.
	     *
	     * @param {!Path} path
	     * @return {?Node}
	     */
	    WriteTreeRef.prototype.shadowingWrite = function (path) {
	        return this.writeTree_.shadowingWrite(this.treePath_.child(path));
	    };
	    /**
	     * This method is used when processing child remove events on a query. If we can, we pull in children that were outside
	     * the window, but may now be in the window
	     *
	     * @param {?Node} completeServerData
	     * @param {!NamedNode} startPost
	     * @param {!number} count
	     * @param {boolean} reverse
	     * @param {!Index} index
	     * @return {!Array.<!NamedNode>}
	     */
	    WriteTreeRef.prototype.calcIndexedSlice = function (completeServerData, startPost, count, reverse, index) {
	        return this.writeTree_.calcIndexedSlice(this.treePath_, completeServerData, startPost, count, reverse, index);
	    };
	    /**
	     * Returns a complete child for a given server snap after applying all user writes or null if there is no
	     * complete child for this ChildKey.
	     *
	     * @param {!string} childKey
	     * @param {!CacheNode} existingServerCache
	     * @return {?Node}
	     */
	    WriteTreeRef.prototype.calcCompleteChild = function (childKey, existingServerCache) {
	        return this.writeTree_.calcCompleteChild(this.treePath_, childKey, existingServerCache);
	    };
	    /**
	     * Return a WriteTreeRef for a child.
	     *
	     * @param {string} childName
	     * @return {!WriteTreeRef}
	     */
	    WriteTreeRef.prototype.child = function (childName) {
	        return new WriteTreeRef(this.treePath_.child(childName), this.writeTree_);
	    };
	    return WriteTreeRef;
	}());
	exports.WriteTreeRef = WriteTreeRef;
	
	//# sourceMappingURL=WriteTree.js.map


/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var util_1 = __webpack_require__(1);
	var Path_1 = __webpack_require__(8);
	var Operation_1 = __webpack_require__(33);
	var AckUserWrite = /** @class */ (function () {
	    /**
	     *
	     * @param {!Path} path
	     * @param {!ImmutableTree<!boolean>} affectedTree A tree containing true for each affected path. Affected paths can't overlap.
	     * @param {!boolean} revert
	     */
	    function AckUserWrite(
	        /**@inheritDoc */ path, 
	        /**@inheritDoc */ affectedTree, 
	        /**@inheritDoc */ revert) {
	        this.path = path;
	        this.affectedTree = affectedTree;
	        this.revert = revert;
	        /** @inheritDoc */
	        this.type = Operation_1.OperationType.ACK_USER_WRITE;
	        /** @inheritDoc */
	        this.source = Operation_1.OperationSource.User;
	    }
	    /**
	     * @inheritDoc
	     */
	    AckUserWrite.prototype.operationForChild = function (childName) {
	        if (!this.path.isEmpty()) {
	            util_1.assert(this.path.getFront() === childName, 'operationForChild called for unrelated child.');
	            return new AckUserWrite(this.path.popFront(), this.affectedTree, this.revert);
	        }
	        else if (this.affectedTree.value != null) {
	            util_1.assert(this.affectedTree.children.isEmpty(), 'affectedTree should not have overlapping affected paths.');
	            // All child locations are affected as well; just return same operation.
	            return this;
	        }
	        else {
	            var childTree = this.affectedTree.subtree(new Path_1.Path(childName));
	            return new AckUserWrite(Path_1.Path.Empty, childTree, this.revert);
	        }
	    };
	    return AckUserWrite;
	}());
	exports.AckUserWrite = AckUserWrite;
	
	//# sourceMappingURL=AckUserWrite.js.map


/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var Path_1 = __webpack_require__(8);
	var Operation_1 = __webpack_require__(33);
	/**
	 * @param {!OperationSource} source
	 * @param {!Path} path
	 * @constructor
	 * @implements {Operation}
	 */
	var ListenComplete = /** @class */ (function () {
	    function ListenComplete(source, path) {
	        this.source = source;
	        this.path = path;
	        /** @inheritDoc */
	        this.type = Operation_1.OperationType.LISTEN_COMPLETE;
	    }
	    ListenComplete.prototype.operationForChild = function (childName) {
	        if (this.path.isEmpty()) {
	            return new ListenComplete(this.source, Path_1.Path.Empty);
	        }
	        else {
	            return new ListenComplete(this.source, this.path.popFront());
	        }
	    };
	    return ListenComplete;
	}());
	exports.ListenComplete = ListenComplete;
	
	//# sourceMappingURL=ListenComplete.js.map


/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var Operation_1 = __webpack_require__(33);
	var Overwrite_1 = __webpack_require__(141);
	var Path_1 = __webpack_require__(8);
	var util_1 = __webpack_require__(1);
	/**
	 * @param {!OperationSource} source
	 * @param {!Path} path
	 * @param {!ImmutableTree.<!Node>} children
	 * @constructor
	 * @implements {Operation}
	 */
	var Merge = /** @class */ (function () {
	    function Merge(
	        /**@inheritDoc */ source, 
	        /**@inheritDoc */ path, 
	        /**@inheritDoc */ children) {
	        this.source = source;
	        this.path = path;
	        this.children = children;
	        /** @inheritDoc */
	        this.type = Operation_1.OperationType.MERGE;
	    }
	    /**
	     * @inheritDoc
	     */
	    Merge.prototype.operationForChild = function (childName) {
	        if (this.path.isEmpty()) {
	            var childTree = this.children.subtree(new Path_1.Path(childName));
	            if (childTree.isEmpty()) {
	                // This child is unaffected
	                return null;
	            }
	            else if (childTree.value) {
	                // We have a snapshot for the child in question.  This becomes an overwrite of the child.
	                return new Overwrite_1.Overwrite(this.source, Path_1.Path.Empty, childTree.value);
	            }
	            else {
	                // This is a merge at a deeper level
	                return new Merge(this.source, Path_1.Path.Empty, childTree);
	            }
	        }
	        else {
	            util_1.assert(this.path.getFront() === childName, "Can't get a merge for a child not on the path of the operation");
	            return new Merge(this.source, this.path.popFront(), this.children);
	        }
	    };
	    /**
	     * @inheritDoc
	     */
	    Merge.prototype.toString = function () {
	        return ('Operation(' +
	            this.path +
	            ': ' +
	            this.source.toString() +
	            ' merge: ' +
	            this.children.toString() +
	            ')');
	    };
	    return Merge;
	}());
	exports.Merge = Merge;
	
	//# sourceMappingURL=Merge.js.map


/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var util_1 = __webpack_require__(1);
	var util_2 = __webpack_require__(1);
	/**
	 * Tracks a collection of stats.
	 *
	 * @constructor
	 */
	var StatsCollection = /** @class */ (function () {
	    function StatsCollection() {
	        this.counters_ = {};
	    }
	    StatsCollection.prototype.incrementCounter = function (name, amount) {
	        if (amount === void 0) { amount = 1; }
	        if (!util_2.contains(this.counters_, name))
	            this.counters_[name] = 0;
	        this.counters_[name] += amount;
	    };
	    StatsCollection.prototype.get = function () {
	        return util_1.deepCopy(this.counters_);
	    };
	    return StatsCollection;
	}());
	exports.StatsCollection = StatsCollection;
	
	//# sourceMappingURL=StatsCollection.js.map


/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var util_1 = __webpack_require__(1);
	var util_2 = __webpack_require__(4);
	var StatsListener_1 = __webpack_require__(148);
	// Assuming some apps may have a short amount of time on page, and a bulk of firebase operations probably
	// happen on page load, we try to report our first set of stats pretty quickly, but we wait at least 10
	// seconds to try to ensure the Firebase connection is established / settled.
	var FIRST_STATS_MIN_TIME = 10 * 1000;
	var FIRST_STATS_MAX_TIME = 30 * 1000;
	// We'll continue to report stats on average every 5 minutes.
	var REPORT_STATS_INTERVAL = 5 * 60 * 1000;
	/**
	 * @constructor
	 */
	var StatsReporter = /** @class */ (function () {
	    /**
	     * @param collection
	     * @param server_
	     */
	    function StatsReporter(collection, server_) {
	        this.server_ = server_;
	        this.statsToReport_ = {};
	        this.statsListener_ = new StatsListener_1.StatsListener(collection);
	        var timeout = FIRST_STATS_MIN_TIME +
	            (FIRST_STATS_MAX_TIME - FIRST_STATS_MIN_TIME) * Math.random();
	        util_2.setTimeoutNonBlocking(this.reportStats_.bind(this), Math.floor(timeout));
	    }
	    StatsReporter.prototype.includeStat = function (stat) {
	        this.statsToReport_[stat] = true;
	    };
	    StatsReporter.prototype.reportStats_ = function () {
	        var _this = this;
	        var stats = this.statsListener_.get();
	        var reportedStats = {};
	        var haveStatsToReport = false;
	        util_1.forEach(stats, function (stat, value) {
	            if (value > 0 && util_1.contains(_this.statsToReport_, stat)) {
	                reportedStats[stat] = value;
	                haveStatsToReport = true;
	            }
	        });
	        if (haveStatsToReport) {
	            this.server_.reportStats(reportedStats);
	        }
	        // queue our next run.
	        util_2.setTimeoutNonBlocking(this.reportStats_.bind(this), Math.floor(Math.random() * 2 * REPORT_STATS_INTERVAL));
	    };
	    return StatsReporter;
	}());
	exports.StatsReporter = StatsReporter;
	
	//# sourceMappingURL=StatsReporter.js.map


/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var util_1 = __webpack_require__(1);
	/**
	 * Wraps a DOM Storage object and:
	 * - automatically encode objects as JSON strings before storing them to allow us to store arbitrary types.
	 * - prefixes names with "firebase:" to avoid collisions with app data.
	 *
	 * We automatically (see storage.js) create two such wrappers, one for sessionStorage,
	 * and one for localStorage.
	 *
	 * @constructor
	 */
	var DOMStorageWrapper = /** @class */ (function () {
	    /**
	     * @param {Storage} domStorage_ The underlying storage object (e.g. localStorage or sessionStorage)
	     */
	    function DOMStorageWrapper(domStorage_) {
	        this.domStorage_ = domStorage_;
	        // Use a prefix to avoid collisions with other stuff saved by the app.
	        this.prefix_ = 'firebase:';
	    }
	    /**
	     * @param {string} key The key to save the value under
	     * @param {?Object} value The value being stored, or null to remove the key.
	     */
	    DOMStorageWrapper.prototype.set = function (key, value) {
	        if (value == null) {
	            this.domStorage_.removeItem(this.prefixedName_(key));
	        }
	        else {
	            this.domStorage_.setItem(this.prefixedName_(key), util_1.stringify(value));
	        }
	    };
	    /**
	     * @param {string} key
	     * @return {*} The value that was stored under this key, or null
	     */
	    DOMStorageWrapper.prototype.get = function (key) {
	        var storedVal = this.domStorage_.getItem(this.prefixedName_(key));
	        if (storedVal == null) {
	            return null;
	        }
	        else {
	            return util_1.jsonEval(storedVal);
	        }
	    };
	    /**
	     * @param {string} key
	     */
	    DOMStorageWrapper.prototype.remove = function (key) {
	        this.domStorage_.removeItem(this.prefixedName_(key));
	    };
	    /**
	     * @param {string} name
	     * @return {string}
	     */
	    DOMStorageWrapper.prototype.prefixedName_ = function (name) {
	        return this.prefix_ + name;
	    };
	    DOMStorageWrapper.prototype.toString = function () {
	        return this.domStorage_.toString();
	    };
	    return DOMStorageWrapper;
	}());
	exports.DOMStorageWrapper = DOMStorageWrapper;
	
	//# sourceMappingURL=DOMStorageWrapper.js.map


/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var util_1 = __webpack_require__(1);
	/**
	 * An in-memory storage implementation that matches the API of DOMStorageWrapper
	 * (TODO: create interface for both to implement).
	 *
	 * @constructor
	 */
	var MemoryStorage = /** @class */ (function () {
	    function MemoryStorage() {
	        this.cache_ = {};
	        this.isInMemoryStorage = true;
	    }
	    MemoryStorage.prototype.set = function (key, value) {
	        if (value == null) {
	            delete this.cache_[key];
	        }
	        else {
	            this.cache_[key] = value;
	        }
	    };
	    MemoryStorage.prototype.get = function (key) {
	        if (util_1.contains(this.cache_, key)) {
	            return this.cache_[key];
	        }
	        return null;
	    };
	    MemoryStorage.prototype.remove = function (key) {
	        delete this.cache_[key];
	    };
	    return MemoryStorage;
	}());
	exports.MemoryStorage = MemoryStorage;
	
	//# sourceMappingURL=MemoryStorage.js.map


/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var util_1 = __webpack_require__(1);
	/**
	 * Fancy ID generator that creates 20-character string identifiers with the
	 * following properties:
	 *
	 * 1. They're based on timestamp so that they sort *after* any existing ids.
	 * 2. They contain 72-bits of random data after the timestamp so that IDs won't
	 *    collide with other clients' IDs.
	 * 3. They sort *lexicographically* (so the timestamp is converted to characters
	 *    that will sort properly).
	 * 4. They're monotonically increasing. Even if you generate more than one in
	 *    the same timestamp, the latter ones will sort after the former ones. We do
	 *    this by using the previous random bits but "incrementing" them by 1 (only
	 *    in the case of a timestamp collision).
	 */
	exports.nextPushId = (function () {
	    // Modeled after base64 web-safe chars, but ordered by ASCII.
	    var PUSH_CHARS = '-0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ_abcdefghijklmnopqrstuvwxyz';
	    // Timestamp of last push, used to prevent local collisions if you push twice
	    // in one ms.
	    var lastPushTime = 0;
	    // We generate 72-bits of randomness which get turned into 12 characters and
	    // appended to the timestamp to prevent collisions with other clients. We
	    // store the last characters we generated because in the event of a collision,
	    // we'll use those same characters except "incremented" by one.
	    var lastRandChars = [];
	    return function (now) {
	        var duplicateTime = now === lastPushTime;
	        lastPushTime = now;
	        var i;
	        var timeStampChars = new Array(8);
	        for (i = 7; i >= 0; i--) {
	            timeStampChars[i] = PUSH_CHARS.charAt(now % 64);
	            // NOTE: Can't use << here because javascript will convert to int and lose
	            // the upper bits.
	            now = Math.floor(now / 64);
	        }
	        util_1.assert(now === 0, 'Cannot push at time == 0');
	        var id = timeStampChars.join('');
	        if (!duplicateTime) {
	            for (i = 0; i < 12; i++) {
	                lastRandChars[i] = Math.floor(Math.random() * 64);
	            }
	        }
	        else {
	            // If the timestamp hasn't changed since last push, use the same random
	            // number, except incremented by 1.
	            for (i = 11; i >= 0 && lastRandChars[i] === 63; i--) {
	                lastRandChars[i] = 0;
	            }
	            lastRandChars[i]++;
	        }
	        for (i = 0; i < 12; i++) {
	            id += PUSH_CHARS.charAt(lastRandChars[i]);
	        }
	        util_1.assert(id.length === 20, 'nextPushId: Length should be 20.');
	        return id;
	    };
	})();
	
	//# sourceMappingURL=NextPushId.js.map


/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var util_1 = __webpack_require__(1);
	var EventEmitter_1 = __webpack_require__(150);
	var util_2 = __webpack_require__(1);
	/**
	 * Monitors online state (as reported by window.online/offline events).
	 *
	 * The expectation is that this could have many false positives (thinks we are online
	 * when we're not), but no false negatives.  So we can safely use it to determine when
	 * we definitely cannot reach the internet.
	 *
	 * @extends {EventEmitter}
	 */
	var OnlineMonitor = /** @class */ (function (_super) {
	    __extends(OnlineMonitor, _super);
	    function OnlineMonitor() {
	        var _this = _super.call(this, ['online']) || this;
	        _this.online_ = true;
	        // We've had repeated complaints that Cordova apps can get stuck "offline", e.g.
	        // https://forum.ionicframework.com/t/firebase-connection-is-lost-and-never-come-back/43810
	        // It would seem that the 'online' event does not always fire consistently. So we disable it
	        // for Cordova.
	        if (typeof window !== 'undefined' &&
	            typeof window.addEventListener !== 'undefined' &&
	            !util_2.isMobileCordova()) {
	            window.addEventListener('online', function () {
	                if (!_this.online_) {
	                    _this.online_ = true;
	                    _this.trigger('online', true);
	                }
	            }, false);
	            window.addEventListener('offline', function () {
	                if (_this.online_) {
	                    _this.online_ = false;
	                    _this.trigger('online', false);
	                }
	            }, false);
	        }
	        return _this;
	    }
	    OnlineMonitor.getInstance = function () {
	        return new OnlineMonitor();
	    };
	    /**
	     * @param {!string} eventType
	     * @return {Array.<boolean>}
	     */
	    OnlineMonitor.prototype.getInitialEvent = function (eventType) {
	        util_1.assert(eventType === 'online', 'Unknown event type: ' + eventType);
	        return [this.online_];
	    };
	    /**
	     * @return {boolean}
	     */
	    OnlineMonitor.prototype.currentlyOnline = function () {
	        return this.online_;
	    };
	    return OnlineMonitor;
	}(EventEmitter_1.EventEmitter));
	exports.OnlineMonitor = OnlineMonitor;
	
	//# sourceMappingURL=OnlineMonitor.js.map


/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var util_1 = __webpack_require__(1);
	var Path_1 = __webpack_require__(8);
	var util_2 = __webpack_require__(1);
	/**
	 * Node in a Tree.
	 */
	var TreeNode = /** @class */ (function () {
	    function TreeNode() {
	        // TODO: Consider making accessors that create children and value lazily or
	        // separate Internal / Leaf 'types'.
	        this.children = {};
	        this.childCount = 0;
	        this.value = null;
	    }
	    return TreeNode;
	}());
	exports.TreeNode = TreeNode;
	/**
	 * A light-weight tree, traversable by path.  Nodes can have both values and children.
	 * Nodes are not enumerated (by forEachChild) unless they have a value or non-empty
	 * children.
	 */
	var Tree = /** @class */ (function () {
	    /**
	     * @template T
	     * @param {string=} name_ Optional name of the node.
	     * @param {Tree=} parent_ Optional parent node.
	     * @param {TreeNode=} node_ Optional node to wrap.
	     */
	    function Tree(name_, parent_, node_) {
	        if (name_ === void 0) { name_ = ''; }
	        if (parent_ === void 0) { parent_ = null; }
	        if (node_ === void 0) { node_ = new TreeNode(); }
	        this.name_ = name_;
	        this.parent_ = parent_;
	        this.node_ = node_;
	    }
	    /**
	     * Returns a sub-Tree for the given path.
	     *
	     * @param {!(string|Path)} pathObj Path to look up.
	     * @return {!Tree.<T>} Tree for path.
	     */
	    Tree.prototype.subTree = function (pathObj) {
	        // TODO: Require pathObj to be Path?
	        var path = pathObj instanceof Path_1.Path ? pathObj : new Path_1.Path(pathObj);
	        var child = this, next;
	        while ((next = path.getFront()) !== null) {
	            var childNode = util_2.safeGet(child.node_.children, next) || new TreeNode();
	            child = new Tree(next, child, childNode);
	            path = path.popFront();
	        }
	        return child;
	    };
	    /**
	     * Returns the data associated with this tree node.
	     *
	     * @return {?T} The data or null if no data exists.
	     */
	    Tree.prototype.getValue = function () {
	        return this.node_.value;
	    };
	    /**
	     * Sets data to this tree node.
	     *
	     * @param {!T} value Value to set.
	     */
	    Tree.prototype.setValue = function (value) {
	        util_1.assert(typeof value !== 'undefined', 'Cannot set value to undefined');
	        this.node_.value = value;
	        this.updateParents_();
	    };
	    /**
	     * Clears the contents of the tree node (its value and all children).
	     */
	    Tree.prototype.clear = function () {
	        this.node_.value = null;
	        this.node_.children = {};
	        this.node_.childCount = 0;
	        this.updateParents_();
	    };
	    /**
	     * @return {boolean} Whether the tree has any children.
	     */
	    Tree.prototype.hasChildren = function () {
	        return this.node_.childCount > 0;
	    };
	    /**
	     * @return {boolean} Whether the tree is empty (no value or children).
	     */
	    Tree.prototype.isEmpty = function () {
	        return this.getValue() === null && !this.hasChildren();
	    };
	    /**
	     * Calls action for each child of this tree node.
	     *
	     * @param {function(!Tree.<T>)} action Action to be called for each child.
	     */
	    Tree.prototype.forEachChild = function (action) {
	        var _this = this;
	        util_2.forEach(this.node_.children, function (child, childTree) {
	            action(new Tree(child, _this, childTree));
	        });
	    };
	    /**
	     * Does a depth-first traversal of this node's descendants, calling action for each one.
	     *
	     * @param {function(!Tree.<T>)} action Action to be called for each child.
	     * @param {boolean=} includeSelf Whether to call action on this node as well. Defaults to
	     *   false.
	     * @param {boolean=} childrenFirst Whether to call action on children before calling it on
	     *   parent.
	     */
	    Tree.prototype.forEachDescendant = function (action, includeSelf, childrenFirst) {
	        if (includeSelf && !childrenFirst)
	            action(this);
	        this.forEachChild(function (child) {
	            child.forEachDescendant(action, /*includeSelf=*/ true, childrenFirst);
	        });
	        if (includeSelf && childrenFirst)
	            action(this);
	    };
	    /**
	     * Calls action on each ancestor node.
	     *
	     * @param {function(!Tree.<T>)} action Action to be called on each parent; return
	     *   true to abort.
	     * @param {boolean=} includeSelf Whether to call action on this node as well.
	     * @return {boolean} true if the action callback returned true.
	     */
	    Tree.prototype.forEachAncestor = function (action, includeSelf) {
	        var node = includeSelf ? this : this.parent();
	        while (node !== null) {
	            if (action(node)) {
	                return true;
	            }
	            node = node.parent();
	        }
	        return false;
	    };
	    /**
	     * Does a depth-first traversal of this node's descendants.  When a descendant with a value
	     * is found, action is called on it and traversal does not continue inside the node.
	     * Action is *not* called on this node.
	     *
	     * @param {function(!Tree.<T>)} action Action to be called for each child.
	     */
	    Tree.prototype.forEachImmediateDescendantWithValue = function (action) {
	        this.forEachChild(function (child) {
	            if (child.getValue() !== null)
	                action(child);
	            else
	                child.forEachImmediateDescendantWithValue(action);
	        });
	    };
	    /**
	     * @return {!Path} The path of this tree node, as a Path.
	     */
	    Tree.prototype.path = function () {
	        return new Path_1.Path(this.parent_ === null
	            ? this.name_
	            : this.parent_.path() + '/' + this.name_);
	    };
	    /**
	     * @return {string} The name of the tree node.
	     */
	    Tree.prototype.name = function () {
	        return this.name_;
	    };
	    /**
	     * @return {?Tree} The parent tree node, or null if this is the root of the tree.
	     */
	    Tree.prototype.parent = function () {
	        return this.parent_;
	    };
	    /**
	     * Adds or removes this child from its parent based on whether it's empty or not.
	     *
	     * @private
	     */
	    Tree.prototype.updateParents_ = function () {
	        if (this.parent_ !== null)
	            this.parent_.updateChild_(this.name_, this);
	    };
	    /**
	     * Adds or removes the passed child to this tree node, depending on whether it's empty.
	     *
	     * @param {string} childName The name of the child to update.
	     * @param {!Tree.<T>} child The child to update.
	     * @private
	     */
	    Tree.prototype.updateChild_ = function (childName, child) {
	        var childEmpty = child.isEmpty();
	        var childExists = util_2.contains(this.node_.children, childName);
	        if (childEmpty && childExists) {
	            delete this.node_.children[childName];
	            this.node_.childCount--;
	            this.updateParents_();
	        }
	        else if (!childEmpty && !childExists) {
	            this.node_.children[childName] = child.node_;
	            this.node_.childCount++;
	            this.updateParents_();
	        }
	    };
	    return Tree;
	}());
	exports.Tree = Tree;
	
	//# sourceMappingURL=Tree.js.map


/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var EventEmitter_1 = __webpack_require__(150);
	var util_1 = __webpack_require__(1);
	/**
	 * @extends {EventEmitter}
	 */
	var VisibilityMonitor = /** @class */ (function (_super) {
	    __extends(VisibilityMonitor, _super);
	    function VisibilityMonitor() {
	        var _this = _super.call(this, ['visible']) || this;
	        var hidden;
	        var visibilityChange;
	        if (typeof document !== 'undefined' &&
	            typeof document.addEventListener !== 'undefined') {
	            if (typeof document['hidden'] !== 'undefined') {
	                // Opera 12.10 and Firefox 18 and later support
	                visibilityChange = 'visibilitychange';
	                hidden = 'hidden';
	            }
	            else if (typeof document['mozHidden'] !== 'undefined') {
	                visibilityChange = 'mozvisibilitychange';
	                hidden = 'mozHidden';
	            }
	            else if (typeof document['msHidden'] !== 'undefined') {
	                visibilityChange = 'msvisibilitychange';
	                hidden = 'msHidden';
	            }
	            else if (typeof document['webkitHidden'] !== 'undefined') {
	                visibilityChange = 'webkitvisibilitychange';
	                hidden = 'webkitHidden';
	            }
	        }
	        // Initially, we always assume we are visible. This ensures that in browsers
	        // without page visibility support or in cases where we are never visible
	        // (e.g. chrome extension), we act as if we are visible, i.e. don't delay
	        // reconnects
	        _this.visible_ = true;
	        if (visibilityChange) {
	            document.addEventListener(visibilityChange, function () {
	                var visible = !document[hidden];
	                if (visible !== _this.visible_) {
	                    _this.visible_ = visible;
	                    _this.trigger('visible', visible);
	                }
	            }, false);
	        }
	        return _this;
	    }
	    VisibilityMonitor.getInstance = function () {
	        return new VisibilityMonitor();
	    };
	    /**
	     * @param {!string} eventType
	     * @return {Array.<boolean>}
	     */
	    VisibilityMonitor.prototype.getInitialEvent = function (eventType) {
	        util_1.assert(eventType === 'visible', 'Unknown event type: ' + eventType);
	        return [this.visible_];
	    };
	    return VisibilityMonitor;
	}(EventEmitter_1.EventEmitter));
	exports.VisibilityMonitor = VisibilityMonitor;
	
	//# sourceMappingURL=VisibilityMonitor.js.map


/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var util_1 = __webpack_require__(1);
	var Change_1 = __webpack_require__(39);
	var util_2 = __webpack_require__(1);
	/**
	 * @constructor
	 */
	var ChildChangeAccumulator = /** @class */ (function () {
	    function ChildChangeAccumulator() {
	        this.changeMap_ = {};
	    }
	    /**
	     * @param {!Change} change
	     */
	    ChildChangeAccumulator.prototype.trackChildChange = function (change) {
	        var type = change.type;
	        var childKey /** @type {!string} */ = change.childName;
	        util_2.assert(type == Change_1.Change.CHILD_ADDED ||
	            type == Change_1.Change.CHILD_CHANGED ||
	            type == Change_1.Change.CHILD_REMOVED, 'Only child changes supported for tracking');
	        util_2.assert(childKey !== '.priority', 'Only non-priority child changes can be tracked.');
	        var oldChange = util_1.safeGet(this.changeMap_, childKey);
	        if (oldChange) {
	            var oldType = oldChange.type;
	            if (type == Change_1.Change.CHILD_ADDED && oldType == Change_1.Change.CHILD_REMOVED) {
	                this.changeMap_[childKey] = Change_1.Change.childChangedChange(childKey, change.snapshotNode, oldChange.snapshotNode);
	            }
	            else if (type == Change_1.Change.CHILD_REMOVED &&
	                oldType == Change_1.Change.CHILD_ADDED) {
	                delete this.changeMap_[childKey];
	            }
	            else if (type == Change_1.Change.CHILD_REMOVED &&
	                oldType == Change_1.Change.CHILD_CHANGED) {
	                this.changeMap_[childKey] = Change_1.Change.childRemovedChange(childKey, oldChange.oldSnap);
	            }
	            else if (type == Change_1.Change.CHILD_CHANGED &&
	                oldType == Change_1.Change.CHILD_ADDED) {
	                this.changeMap_[childKey] = Change_1.Change.childAddedChange(childKey, change.snapshotNode);
	            }
	            else if (type == Change_1.Change.CHILD_CHANGED &&
	                oldType == Change_1.Change.CHILD_CHANGED) {
	                this.changeMap_[childKey] = Change_1.Change.childChangedChange(childKey, change.snapshotNode, oldChange.oldSnap);
	            }
	            else {
	                throw util_2.assertionError('Illegal combination of changes: ' +
	                    change +
	                    ' occurred after ' +
	                    oldChange);
	            }
	        }
	        else {
	            this.changeMap_[childKey] = change;
	        }
	    };
	    /**
	     * @return {!Array.<!Change>}
	     */
	    ChildChangeAccumulator.prototype.getChanges = function () {
	        return util_1.getValues(this.changeMap_);
	    };
	    return ChildChangeAccumulator;
	}());
	exports.ChildChangeAccumulator = ChildChangeAccumulator;
	
	//# sourceMappingURL=ChildChangeAccumulator.js.map


/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var CacheNode_1 = __webpack_require__(70);
	/**
	 * An implementation of CompleteChildSource that never returns any additional children
	 *
	 * @private
	 * @constructor
	 * @implements CompleteChildSource
	 */
	var NoCompleteChildSource_ = /** @class */ (function () {
	    function NoCompleteChildSource_() {
	    }
	    /**
	     * @inheritDoc
	     */
	    NoCompleteChildSource_.prototype.getCompleteChild = function (childKey) {
	        return null;
	    };
	    /**
	     * @inheritDoc
	     */
	    NoCompleteChildSource_.prototype.getChildAfterChild = function (index, child, reverse) {
	        return null;
	    };
	    return NoCompleteChildSource_;
	}());
	exports.NoCompleteChildSource_ = NoCompleteChildSource_;
	/**
	 * Singleton instance.
	 * @const
	 * @type {!CompleteChildSource}
	 */
	exports.NO_COMPLETE_CHILD_SOURCE = new NoCompleteChildSource_();
	/**
	 * An implementation of CompleteChildSource that uses a WriteTree in addition to any other server data or
	 * old event caches available to calculate complete children.
	 *
	 *
	 * @implements CompleteChildSource
	 */
	var WriteTreeCompleteChildSource = /** @class */ (function () {
	    /**
	     * @param {!WriteTreeRef} writes_
	     * @param {!ViewCache} viewCache_
	     * @param {?Node} optCompleteServerCache_
	     */
	    function WriteTreeCompleteChildSource(writes_, viewCache_, optCompleteServerCache_) {
	        if (optCompleteServerCache_ === void 0) { optCompleteServerCache_ = null; }
	        this.writes_ = writes_;
	        this.viewCache_ = viewCache_;
	        this.optCompleteServerCache_ = optCompleteServerCache_;
	    }
	    /**
	     * @inheritDoc
	     */
	    WriteTreeCompleteChildSource.prototype.getCompleteChild = function (childKey) {
	        var node = this.viewCache_.getEventCache();
	        if (node.isCompleteForChild(childKey)) {
	            return node.getNode().getImmediateChild(childKey);
	        }
	        else {
	            var serverNode = this.optCompleteServerCache_ != null
	                ? new CacheNode_1.CacheNode(this.optCompleteServerCache_, true, false)
	                : this.viewCache_.getServerCache();
	            return this.writes_.calcCompleteChild(childKey, serverNode);
	        }
	    };
	    /**
	     * @inheritDoc
	     */
	    WriteTreeCompleteChildSource.prototype.getChildAfterChild = function (index, child, reverse) {
	        var completeServerData = this.optCompleteServerCache_ != null
	            ? this.optCompleteServerCache_
	            : this.viewCache_.getCompleteServerSnap();
	        var nodes = this.writes_.calcIndexedSlice(completeServerData, child, 1, reverse, index);
	        if (nodes.length === 0) {
	            return null;
	        }
	        else {
	            return nodes[0];
	        }
	    };
	    return WriteTreeCompleteChildSource;
	}());
	exports.WriteTreeCompleteChildSource = WriteTreeCompleteChildSource;
	
	//# sourceMappingURL=CompleteChildSource.js.map


/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var util_1 = __webpack_require__(1);
	/**
	 * Encapsulates the data needed to raise an event
	 * @implements {Event}
	 */
	var DataEvent = /** @class */ (function () {
	    /**
	     * @param {!string} eventType One of: value, child_added, child_changed, child_moved, child_removed
	     * @param {!EventRegistration} eventRegistration The function to call to with the event data. User provided
	     * @param {!DataSnapshot} snapshot The data backing the event
	     * @param {?string=} prevName Optional, the name of the previous child for child_* events.
	     */
	    function DataEvent(eventType, eventRegistration, snapshot, prevName) {
	        this.eventType = eventType;
	        this.eventRegistration = eventRegistration;
	        this.snapshot = snapshot;
	        this.prevName = prevName;
	    }
	    /**
	     * @inheritDoc
	     */
	    DataEvent.prototype.getPath = function () {
	        var ref = this.snapshot.getRef();
	        if (this.eventType === 'value') {
	            return ref.path;
	        }
	        else {
	            return ref.getParent().path;
	        }
	    };
	    /**
	     * @inheritDoc
	     */
	    DataEvent.prototype.getEventType = function () {
	        return this.eventType;
	    };
	    /**
	     * @inheritDoc
	     */
	    DataEvent.prototype.getEventRunner = function () {
	        return this.eventRegistration.getEventRunner(this);
	    };
	    /**
	     * @inheritDoc
	     */
	    DataEvent.prototype.toString = function () {
	        return (this.getPath().toString() +
	            ':' +
	            this.eventType +
	            ':' +
	            util_1.stringify(this.snapshot.exportVal()));
	    };
	    return DataEvent;
	}());
	exports.DataEvent = DataEvent;
	var CancelEvent = /** @class */ (function () {
	    /**
	     * @param {EventRegistration} eventRegistration
	     * @param {Error} error
	     * @param {!Path} path
	     */
	    function CancelEvent(eventRegistration, error, path) {
	        this.eventRegistration = eventRegistration;
	        this.error = error;
	        this.path = path;
	    }
	    /**
	     * @inheritDoc
	     */
	    CancelEvent.prototype.getPath = function () {
	        return this.path;
	    };
	    /**
	     * @inheritDoc
	     */
	    CancelEvent.prototype.getEventType = function () {
	        return 'cancel';
	    };
	    /**
	     * @inheritDoc
	     */
	    CancelEvent.prototype.getEventRunner = function () {
	        return this.eventRegistration.getEventRunner(this);
	    };
	    /**
	     * @inheritDoc
	     */
	    CancelEvent.prototype.toString = function () {
	        return this.path.toString() + ':cancel';
	    };
	    return CancelEvent;
	}());
	exports.CancelEvent = CancelEvent;
	
	//# sourceMappingURL=Event.js.map


/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var Node_1 = __webpack_require__(19);
	var Change_1 = __webpack_require__(39);
	var util_1 = __webpack_require__(1);
	/**
	 * An EventGenerator is used to convert "raw" changes (Change) as computed by the
	 * CacheDiffer into actual events (Event) that can be raised.  See generateEventsForChanges()
	 * for details.
	 *
	 * @constructor
	 */
	var EventGenerator = /** @class */ (function () {
	    /**
	     *
	     * @param {!Query} query_
	     */
	    function EventGenerator(query_) {
	        this.query_ = query_;
	        /**
	         * @private
	         * @type {!Index}
	         */
	        this.index_ = this.query_.getQueryParams().getIndex();
	    }
	    /**
	     * Given a set of raw changes (no moved events and prevName not specified yet), and a set of
	     * EventRegistrations that should be notified of these changes, generate the actual events to be raised.
	     *
	     * Notes:
	     *  - child_moved events will be synthesized at this time for any child_changed events that affect
	     *    our index.
	     *  - prevName will be calculated based on the index ordering.
	     *
	     * @param {!Array.<!Change>} changes
	     * @param {!Node} eventCache
	     * @param {!Array.<!EventRegistration>} eventRegistrations
	     * @return {!Array.<!Event>}
	     */
	    EventGenerator.prototype.generateEventsForChanges = function (changes, eventCache, eventRegistrations) {
	        var _this = this;
	        var events = [];
	        var moves = [];
	        changes.forEach(function (change) {
	            if (change.type === Change_1.Change.CHILD_CHANGED &&
	                _this.index_.indexedValueChanged(change.oldSnap, change.snapshotNode)) {
	                moves.push(Change_1.Change.childMovedChange(change.childName, change.snapshotNode));
	            }
	        });
	        this.generateEventsForType_(events, Change_1.Change.CHILD_REMOVED, changes, eventRegistrations, eventCache);
	        this.generateEventsForType_(events, Change_1.Change.CHILD_ADDED, changes, eventRegistrations, eventCache);
	        this.generateEventsForType_(events, Change_1.Change.CHILD_MOVED, moves, eventRegistrations, eventCache);
	        this.generateEventsForType_(events, Change_1.Change.CHILD_CHANGED, changes, eventRegistrations, eventCache);
	        this.generateEventsForType_(events, Change_1.Change.VALUE, changes, eventRegistrations, eventCache);
	        return events;
	    };
	    /**
	     * Given changes of a single change type, generate the corresponding events.
	     *
	     * @param {!Array.<!Event>} events
	     * @param {!string} eventType
	     * @param {!Array.<!Change>} changes
	     * @param {!Array.<!EventRegistration>} registrations
	     * @param {!Node} eventCache
	     * @private
	     */
	    EventGenerator.prototype.generateEventsForType_ = function (events, eventType, changes, registrations, eventCache) {
	        var _this = this;
	        var filteredChanges = changes.filter(function (change) { return change.type === eventType; });
	        filteredChanges.sort(this.compareChanges_.bind(this));
	        filteredChanges.forEach(function (change) {
	            var materializedChange = _this.materializeSingleChange_(change, eventCache);
	            registrations.forEach(function (registration) {
	                if (registration.respondsTo(change.type)) {
	                    events.push(registration.createEvent(materializedChange, _this.query_));
	                }
	            });
	        });
	    };
	    /**
	     * @param {!Change} change
	     * @param {!Node} eventCache
	     * @return {!Change}
	     * @private
	     */
	    EventGenerator.prototype.materializeSingleChange_ = function (change, eventCache) {
	        if (change.type === 'value' || change.type === 'child_removed') {
	            return change;
	        }
	        else {
	            change.prevName = eventCache.getPredecessorChildName(
	            /** @type {!string} */
	            change.childName, change.snapshotNode, this.index_);
	            return change;
	        }
	    };
	    /**
	     * @param {!Change} a
	     * @param {!Change} b
	     * @return {number}
	     * @private
	     */
	    EventGenerator.prototype.compareChanges_ = function (a, b) {
	        if (a.childName == null || b.childName == null) {
	            throw util_1.assertionError('Should only compare child_ events.');
	        }
	        var aWrapped = new Node_1.NamedNode(a.childName, a.snapshotNode);
	        var bWrapped = new Node_1.NamedNode(b.childName, b.snapshotNode);
	        return this.index_.compare(aWrapped, bWrapped);
	    };
	    return EventGenerator;
	}());
	exports.EventGenerator = EventGenerator;
	
	//# sourceMappingURL=EventGenerator.js.map


/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var util_1 = __webpack_require__(4);
	/**
	 * The event queue serves a few purposes:
	 * 1. It ensures we maintain event order in the face of event callbacks doing operations that result in more
	 *    events being queued.
	 * 2. raiseQueuedEvents() handles being called reentrantly nicely.  That is, if in the course of raising events,
	 *    raiseQueuedEvents() is called again, the "inner" call will pick up raising events where the "outer" call
	 *    left off, ensuring that the events are still raised synchronously and in order.
	 * 3. You can use raiseEventsAtPath and raiseEventsForChangedPath to ensure only relevant previously-queued
	 *    events are raised synchronously.
	 *
	 * NOTE: This can all go away if/when we move to async events.
	 *
	 * @constructor
	 */
	var EventQueue = /** @class */ (function () {
	    function EventQueue() {
	        /**
	         * @private
	         * @type {!Array.<EventList>}
	         */
	        this.eventLists_ = [];
	        /**
	         * Tracks recursion depth of raiseQueuedEvents_, for debugging purposes.
	         * @private
	         * @type {!number}
	         */
	        this.recursionDepth_ = 0;
	    }
	    /**
	     * @param {!Array.<Event>} eventDataList The new events to queue.
	     */
	    EventQueue.prototype.queueEvents = function (eventDataList) {
	        // We group events by path, storing them in a single EventList, to make it easier to skip over them quickly.
	        var currList = null;
	        for (var i = 0; i < eventDataList.length; i++) {
	            var eventData = eventDataList[i];
	            var eventPath = eventData.getPath();
	            if (currList !== null && !eventPath.equals(currList.getPath())) {
	                this.eventLists_.push(currList);
	                currList = null;
	            }
	            if (currList === null) {
	                currList = new EventList(eventPath);
	            }
	            currList.add(eventData);
	        }
	        if (currList) {
	            this.eventLists_.push(currList);
	        }
	    };
	    /**
	     * Queues the specified events and synchronously raises all events (including previously queued ones)
	     * for the specified path.
	     *
	     * It is assumed that the new events are all for the specified path.
	     *
	     * @param {!Path} path The path to raise events for.
	     * @param {!Array.<Event>} eventDataList The new events to raise.
	     */
	    EventQueue.prototype.raiseEventsAtPath = function (path, eventDataList) {
	        this.queueEvents(eventDataList);
	        this.raiseQueuedEventsMatchingPredicate_(function (eventPath) {
	            return eventPath.equals(path);
	        });
	    };
	    /**
	     * Queues the specified events and synchronously raises all events (including previously queued ones) for
	     * locations related to the specified change path (i.e. all ancestors and descendants).
	     *
	     * It is assumed that the new events are all related (ancestor or descendant) to the specified path.
	     *
	     * @param {!Path} changedPath The path to raise events for.
	     * @param {!Array.<!Event>} eventDataList The events to raise
	     */
	    EventQueue.prototype.raiseEventsForChangedPath = function (changedPath, eventDataList) {
	        this.queueEvents(eventDataList);
	        this.raiseQueuedEventsMatchingPredicate_(function (eventPath) {
	            return eventPath.contains(changedPath) || changedPath.contains(eventPath);
	        });
	    };
	    /**
	     * @param {!function(!Path):boolean} predicate
	     * @private
	     */
	    EventQueue.prototype.raiseQueuedEventsMatchingPredicate_ = function (predicate) {
	        this.recursionDepth_++;
	        var sentAll = true;
	        for (var i = 0; i < this.eventLists_.length; i++) {
	            var eventList = this.eventLists_[i];
	            if (eventList) {
	                var eventPath = eventList.getPath();
	                if (predicate(eventPath)) {
	                    this.eventLists_[i].raise();
	                    this.eventLists_[i] = null;
	                }
	                else {
	                    sentAll = false;
	                }
	            }
	        }
	        if (sentAll) {
	            this.eventLists_ = [];
	        }
	        this.recursionDepth_--;
	    };
	    return EventQueue;
	}());
	exports.EventQueue = EventQueue;
	/**
	 * @param {!Path} path
	 * @constructor
	 */
	var EventList = /** @class */ (function () {
	    function EventList(path_) {
	        this.path_ = path_;
	        /**
	         * @type {!Array.<Event>}
	         * @private
	         */
	        this.events_ = [];
	    }
	    /**
	     * @param {!Event} eventData
	     */
	    EventList.prototype.add = function (eventData) {
	        this.events_.push(eventData);
	    };
	    /**
	     * Iterates through the list and raises each event
	     */
	    EventList.prototype.raise = function () {
	        for (var i = 0; i < this.events_.length; i++) {
	            var eventData = this.events_[i];
	            if (eventData !== null) {
	                this.events_[i] = null;
	                var eventFn = eventData.getEventRunner();
	                if (util_1.logger) {
	                    util_1.log('event: ' + eventData.toString());
	                }
	                util_1.exceptionGuard(eventFn);
	            }
	        }
	    };
	    /**
	     * @return {!Path}
	     */
	    EventList.prototype.getPath = function () {
	        return this.path_;
	    };
	    return EventList;
	}());
	exports.EventList = EventList;
	
	//# sourceMappingURL=EventQueue.js.map


/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var DataSnapshot_1 = __webpack_require__(89);
	var Event_1 = __webpack_require__(248);
	var util_1 = __webpack_require__(1);
	var util_2 = __webpack_require__(1);
	/**
	 * Represents registration for 'value' events.
	 */
	var ValueEventRegistration = /** @class */ (function () {
	    /**
	     * @param {?function(!DataSnapshot)} callback_
	     * @param {?function(Error)} cancelCallback_
	     * @param {?Object} context_
	     */
	    function ValueEventRegistration(callback_, cancelCallback_, context_) {
	        this.callback_ = callback_;
	        this.cancelCallback_ = cancelCallback_;
	        this.context_ = context_;
	    }
	    /**
	     * @inheritDoc
	     */
	    ValueEventRegistration.prototype.respondsTo = function (eventType) {
	        return eventType === 'value';
	    };
	    /**
	     * @inheritDoc
	     */
	    ValueEventRegistration.prototype.createEvent = function (change, query) {
	        var index = query.getQueryParams().getIndex();
	        return new Event_1.DataEvent('value', this, new DataSnapshot_1.DataSnapshot(change.snapshotNode, query.getRef(), index));
	    };
	    /**
	     * @inheritDoc
	     */
	    ValueEventRegistration.prototype.getEventRunner = function (eventData) {
	        var ctx = this.context_;
	        if (eventData.getEventType() === 'cancel') {
	            util_2.assert(this.cancelCallback_, 'Raising a cancel event on a listener with no cancel callback');
	            var cancelCB_1 = this.cancelCallback_;
	            return function () {
	                // We know that error exists, we checked above that this is a cancel event
	                cancelCB_1.call(ctx, eventData.error);
	            };
	        }
	        else {
	            var cb_1 = this.callback_;
	            return function () {
	                cb_1.call(ctx, eventData.snapshot);
	            };
	        }
	    };
	    /**
	     * @inheritDoc
	     */
	    ValueEventRegistration.prototype.createCancelEvent = function (error, path) {
	        if (this.cancelCallback_) {
	            return new Event_1.CancelEvent(this, error, path);
	        }
	        else {
	            return null;
	        }
	    };
	    /**
	     * @inheritDoc
	     */
	    ValueEventRegistration.prototype.matches = function (other) {
	        if (!(other instanceof ValueEventRegistration)) {
	            return false;
	        }
	        else if (!other.callback_ || !this.callback_) {
	            // If no callback specified, we consider it to match any callback.
	            return true;
	        }
	        else {
	            return (other.callback_ === this.callback_ && other.context_ === this.context_);
	        }
	    };
	    /**
	     * @inheritDoc
	     */
	    ValueEventRegistration.prototype.hasAnyCallback = function () {
	        return this.callback_ !== null;
	    };
	    return ValueEventRegistration;
	}());
	exports.ValueEventRegistration = ValueEventRegistration;
	/**
	 * Represents the registration of 1 or more child_xxx events.
	 *
	 * Currently, it is always exactly 1 child_xxx event, but the idea is we might let you
	 * register a group of callbacks together in the future.
	 *
	 * @constructor
	 * @implements {EventRegistration}
	 */
	var ChildEventRegistration = /** @class */ (function () {
	    /**
	     * @param {?Object.<string, function(!DataSnapshot, ?string=)>} callbacks_
	     * @param {?function(Error)} cancelCallback_
	     * @param {Object=} context_
	     */
	    function ChildEventRegistration(callbacks_, cancelCallback_, context_) {
	        this.callbacks_ = callbacks_;
	        this.cancelCallback_ = cancelCallback_;
	        this.context_ = context_;
	    }
	    /**
	     * @inheritDoc
	     */
	    ChildEventRegistration.prototype.respondsTo = function (eventType) {
	        var eventToCheck = eventType === 'children_added' ? 'child_added' : eventType;
	        eventToCheck =
	            eventToCheck === 'children_removed' ? 'child_removed' : eventToCheck;
	        return util_1.contains(this.callbacks_, eventToCheck);
	    };
	    /**
	     * @inheritDoc
	     */
	    ChildEventRegistration.prototype.createCancelEvent = function (error, path) {
	        if (this.cancelCallback_) {
	            return new Event_1.CancelEvent(this, error, path);
	        }
	        else {
	            return null;
	        }
	    };
	    /**
	     * @inheritDoc
	     */
	    ChildEventRegistration.prototype.createEvent = function (change, query) {
	        util_2.assert(change.childName != null, 'Child events should have a childName.');
	        var ref = query.getRef().child(/** @type {!string} */ (change.childName));
	        var index = query.getQueryParams().getIndex();
	        return new Event_1.DataEvent(change.type, this, new DataSnapshot_1.DataSnapshot(change.snapshotNode, ref, index), change.prevName);
	    };
	    /**
	     * @inheritDoc
	     */
	    ChildEventRegistration.prototype.getEventRunner = function (eventData) {
	        var ctx = this.context_;
	        if (eventData.getEventType() === 'cancel') {
	            util_2.assert(this.cancelCallback_, 'Raising a cancel event on a listener with no cancel callback');
	            var cancelCB_2 = this.cancelCallback_;
	            return function () {
	                // We know that error exists, we checked above that this is a cancel event
	                cancelCB_2.call(ctx, eventData.error);
	            };
	        }
	        else {
	            var cb_2 = this.callbacks_[eventData.eventType];
	            return function () {
	                cb_2.call(ctx, eventData.snapshot, eventData.prevName);
	            };
	        }
	    };
	    /**
	     * @inheritDoc
	     */
	    ChildEventRegistration.prototype.matches = function (other) {
	        if (other instanceof ChildEventRegistration) {
	            if (!this.callbacks_ || !other.callbacks_) {
	                return true;
	            }
	            else if (this.context_ === other.context_) {
	                var otherCount = util_1.getCount(other.callbacks_);
	                var thisCount = util_1.getCount(this.callbacks_);
	                if (otherCount === thisCount) {
	                    // If count is 1, do an exact match on eventType, if either is defined but null, it's a match.
	                    //  If event types don't match, not a match
	                    // If count is not 1, exact match across all
	                    if (otherCount === 1) {
	                        var otherKey /** @type {!string} */ = util_1.getAnyKey(other.callbacks_);
	                        var thisKey /** @type {!string} */ = util_1.getAnyKey(this.callbacks_);
	                        return (thisKey === otherKey &&
	                            (!other.callbacks_[otherKey] ||
	                                !this.callbacks_[thisKey] ||
	                                other.callbacks_[otherKey] === this.callbacks_[thisKey]));
	                    }
	                    else {
	                        // Exact match on each key.
	                        return util_1.every(this.callbacks_, function (eventType, cb) { return other.callbacks_[eventType] === cb; });
	                    }
	                }
	            }
	        }
	        return false;
	    };
	    /**
	     * @inheritDoc
	     */
	    ChildEventRegistration.prototype.hasAnyCallback = function () {
	        return this.callbacks_ !== null;
	    };
	    return ChildEventRegistration;
	}());
	exports.ChildEventRegistration = ChildEventRegistration;
	
	//# sourceMappingURL=EventRegistration.js.map


/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var util_1 = __webpack_require__(1);
	var util_2 = __webpack_require__(4);
	var KeyIndex_1 = __webpack_require__(49);
	var PriorityIndex_1 = __webpack_require__(15);
	var ValueIndex_1 = __webpack_require__(146);
	var PathIndex_1 = __webpack_require__(145);
	var IndexedFilter_1 = __webpack_require__(94);
	var LimitedFilter_1 = __webpack_require__(255);
	var RangedFilter_1 = __webpack_require__(154);
	var util_3 = __webpack_require__(1);
	/**
	 * This class is an immutable-from-the-public-api struct containing a set of query parameters defining a
	 * range to be returned for a particular location. It is assumed that validation of parameters is done at the
	 * user-facing API level, so it is not done here.
	 * @constructor
	 */
	var QueryParams = /** @class */ (function () {
	    function QueryParams() {
	        this.limitSet_ = false;
	        this.startSet_ = false;
	        this.startNameSet_ = false;
	        this.endSet_ = false;
	        this.endNameSet_ = false;
	        this.limit_ = 0;
	        this.viewFrom_ = '';
	        this.indexStartValue_ = null;
	        this.indexStartName_ = '';
	        this.indexEndValue_ = null;
	        this.indexEndName_ = '';
	        this.index_ = PriorityIndex_1.PRIORITY_INDEX;
	    }
	    /**
	     * @return {boolean}
	     */
	    QueryParams.prototype.hasStart = function () {
	        return this.startSet_;
	    };
	    /**
	     * @return {boolean} True if it would return from left.
	     */
	    QueryParams.prototype.isViewFromLeft = function () {
	        if (this.viewFrom_ === '') {
	            // limit(), rather than limitToFirst or limitToLast was called.
	            // This means that only one of startSet_ and endSet_ is true. Use them
	            // to calculate which side of the view to anchor to. If neither is set,
	            // anchor to the end.
	            return this.startSet_;
	        }
	        else {
	            return (this.viewFrom_ === QueryParams.WIRE_PROTOCOL_CONSTANTS_.VIEW_FROM_LEFT);
	        }
	    };
	    /**
	     * Only valid to call if hasStart() returns true
	     * @return {*}
	     */
	    QueryParams.prototype.getIndexStartValue = function () {
	        util_1.assert(this.startSet_, 'Only valid if start has been set');
	        return this.indexStartValue_;
	    };
	    /**
	     * Only valid to call if hasStart() returns true.
	     * Returns the starting key name for the range defined by these query parameters
	     * @return {!string}
	     */
	    QueryParams.prototype.getIndexStartName = function () {
	        util_1.assert(this.startSet_, 'Only valid if start has been set');
	        if (this.startNameSet_) {
	            return this.indexStartName_;
	        }
	        else {
	            return util_2.MIN_NAME;
	        }
	    };
	    /**
	     * @return {boolean}
	     */
	    QueryParams.prototype.hasEnd = function () {
	        return this.endSet_;
	    };
	    /**
	     * Only valid to call if hasEnd() returns true.
	     * @return {*}
	     */
	    QueryParams.prototype.getIndexEndValue = function () {
	        util_1.assert(this.endSet_, 'Only valid if end has been set');
	        return this.indexEndValue_;
	    };
	    /**
	     * Only valid to call if hasEnd() returns true.
	     * Returns the end key name for the range defined by these query parameters
	     * @return {!string}
	     */
	    QueryParams.prototype.getIndexEndName = function () {
	        util_1.assert(this.endSet_, 'Only valid if end has been set');
	        if (this.endNameSet_) {
	            return this.indexEndName_;
	        }
	        else {
	            return util_2.MAX_NAME;
	        }
	    };
	    /**
	     * @return {boolean}
	     */
	    QueryParams.prototype.hasLimit = function () {
	        return this.limitSet_;
	    };
	    /**
	     * @return {boolean} True if a limit has been set and it has been explicitly anchored
	     */
	    QueryParams.prototype.hasAnchoredLimit = function () {
	        return this.limitSet_ && this.viewFrom_ !== '';
	    };
	    /**
	     * Only valid to call if hasLimit() returns true
	     * @return {!number}
	     */
	    QueryParams.prototype.getLimit = function () {
	        util_1.assert(this.limitSet_, 'Only valid if limit has been set');
	        return this.limit_;
	    };
	    /**
	     * @return {!Index}
	     */
	    QueryParams.prototype.getIndex = function () {
	        return this.index_;
	    };
	    /**
	     * @return {!QueryParams}
	     * @private
	     */
	    QueryParams.prototype.copy_ = function () {
	        var copy = new QueryParams();
	        copy.limitSet_ = this.limitSet_;
	        copy.limit_ = this.limit_;
	        copy.startSet_ = this.startSet_;
	        copy.indexStartValue_ = this.indexStartValue_;
	        copy.startNameSet_ = this.startNameSet_;
	        copy.indexStartName_ = this.indexStartName_;
	        copy.endSet_ = this.endSet_;
	        copy.indexEndValue_ = this.indexEndValue_;
	        copy.endNameSet_ = this.endNameSet_;
	        copy.indexEndName_ = this.indexEndName_;
	        copy.index_ = this.index_;
	        copy.viewFrom_ = this.viewFrom_;
	        return copy;
	    };
	    /**
	     * @param {!number} newLimit
	     * @return {!QueryParams}
	     */
	    QueryParams.prototype.limit = function (newLimit) {
	        var newParams = this.copy_();
	        newParams.limitSet_ = true;
	        newParams.limit_ = newLimit;
	        newParams.viewFrom_ = '';
	        return newParams;
	    };
	    /**
	     * @param {!number} newLimit
	     * @return {!QueryParams}
	     */
	    QueryParams.prototype.limitToFirst = function (newLimit) {
	        var newParams = this.copy_();
	        newParams.limitSet_ = true;
	        newParams.limit_ = newLimit;
	        newParams.viewFrom_ = QueryParams.WIRE_PROTOCOL_CONSTANTS_.VIEW_FROM_LEFT;
	        return newParams;
	    };
	    /**
	     * @param {!number} newLimit
	     * @return {!QueryParams}
	     */
	    QueryParams.prototype.limitToLast = function (newLimit) {
	        var newParams = this.copy_();
	        newParams.limitSet_ = true;
	        newParams.limit_ = newLimit;
	        newParams.viewFrom_ = QueryParams.WIRE_PROTOCOL_CONSTANTS_.VIEW_FROM_RIGHT;
	        return newParams;
	    };
	    /**
	     * @param {*} indexValue
	     * @param {?string=} key
	     * @return {!QueryParams}
	     */
	    QueryParams.prototype.startAt = function (indexValue, key) {
	        var newParams = this.copy_();
	        newParams.startSet_ = true;
	        if (!(indexValue !== undefined)) {
	            indexValue = null;
	        }
	        newParams.indexStartValue_ = indexValue;
	        if (key != null) {
	            newParams.startNameSet_ = true;
	            newParams.indexStartName_ = key;
	        }
	        else {
	            newParams.startNameSet_ = false;
	            newParams.indexStartName_ = '';
	        }
	        return newParams;
	    };
	    /**
	     * @param {*} indexValue
	     * @param {?string=} key
	     * @return {!QueryParams}
	     */
	    QueryParams.prototype.endAt = function (indexValue, key) {
	        var newParams = this.copy_();
	        newParams.endSet_ = true;
	        if (!(indexValue !== undefined)) {
	            indexValue = null;
	        }
	        newParams.indexEndValue_ = indexValue;
	        if (key !== undefined) {
	            newParams.endNameSet_ = true;
	            newParams.indexEndName_ = key;
	        }
	        else {
	            newParams.endNameSet_ = false;
	            newParams.indexEndName_ = '';
	        }
	        return newParams;
	    };
	    /**
	     * @param {!Index} index
	     * @return {!QueryParams}
	     */
	    QueryParams.prototype.orderBy = function (index) {
	        var newParams = this.copy_();
	        newParams.index_ = index;
	        return newParams;
	    };
	    /**
	     * @return {!Object}
	     */
	    QueryParams.prototype.getQueryObject = function () {
	        var WIRE_PROTOCOL_CONSTANTS = QueryParams.WIRE_PROTOCOL_CONSTANTS_;
	        var obj = {};
	        if (this.startSet_) {
	            obj[WIRE_PROTOCOL_CONSTANTS.INDEX_START_VALUE] = this.indexStartValue_;
	            if (this.startNameSet_) {
	                obj[WIRE_PROTOCOL_CONSTANTS.INDEX_START_NAME] = this.indexStartName_;
	            }
	        }
	        if (this.endSet_) {
	            obj[WIRE_PROTOCOL_CONSTANTS.INDEX_END_VALUE] = this.indexEndValue_;
	            if (this.endNameSet_) {
	                obj[WIRE_PROTOCOL_CONSTANTS.INDEX_END_NAME] = this.indexEndName_;
	            }
	        }
	        if (this.limitSet_) {
	            obj[WIRE_PROTOCOL_CONSTANTS.LIMIT] = this.limit_;
	            var viewFrom = this.viewFrom_;
	            if (viewFrom === '') {
	                if (this.isViewFromLeft()) {
	                    viewFrom = WIRE_PROTOCOL_CONSTANTS.VIEW_FROM_LEFT;
	                }
	                else {
	                    viewFrom = WIRE_PROTOCOL_CONSTANTS.VIEW_FROM_RIGHT;
	                }
	            }
	            obj[WIRE_PROTOCOL_CONSTANTS.VIEW_FROM] = viewFrom;
	        }
	        // For now, priority index is the default, so we only specify if it's some other index
	        if (this.index_ !== PriorityIndex_1.PRIORITY_INDEX) {
	            obj[WIRE_PROTOCOL_CONSTANTS.INDEX] = this.index_.toString();
	        }
	        return obj;
	    };
	    /**
	     * @return {boolean}
	     */
	    QueryParams.prototype.loadsAllData = function () {
	        return !(this.startSet_ || this.endSet_ || this.limitSet_);
	    };
	    /**
	     * @return {boolean}
	     */
	    QueryParams.prototype.isDefault = function () {
	        return this.loadsAllData() && this.index_ == PriorityIndex_1.PRIORITY_INDEX;
	    };
	    /**
	     * @return {!NodeFilter}
	     */
	    QueryParams.prototype.getNodeFilter = function () {
	        if (this.loadsAllData()) {
	            return new IndexedFilter_1.IndexedFilter(this.getIndex());
	        }
	        else if (this.hasLimit()) {
	            return new LimitedFilter_1.LimitedFilter(this);
	        }
	        else {
	            return new RangedFilter_1.RangedFilter(this);
	        }
	    };
	    /**
	     * Returns a set of REST query string parameters representing this query.
	     *
	     * @return {!Object.<string,*>} query string parameters
	     */
	    QueryParams.prototype.toRestQueryStringParameters = function () {
	        var REST_CONSTANTS = QueryParams.REST_QUERY_CONSTANTS_;
	        var qs = {};
	        if (this.isDefault()) {
	            return qs;
	        }
	        var orderBy;
	        if (this.index_ === PriorityIndex_1.PRIORITY_INDEX) {
	            orderBy = REST_CONSTANTS.PRIORITY_INDEX;
	        }
	        else if (this.index_ === ValueIndex_1.VALUE_INDEX) {
	            orderBy = REST_CONSTANTS.VALUE_INDEX;
	        }
	        else if (this.index_ === KeyIndex_1.KEY_INDEX) {
	            orderBy = REST_CONSTANTS.KEY_INDEX;
	        }
	        else {
	            util_1.assert(this.index_ instanceof PathIndex_1.PathIndex, 'Unrecognized index type!');
	            orderBy = this.index_.toString();
	        }
	        qs[REST_CONSTANTS.ORDER_BY] = util_3.stringify(orderBy);
	        if (this.startSet_) {
	            qs[REST_CONSTANTS.START_AT] = util_3.stringify(this.indexStartValue_);
	            if (this.startNameSet_) {
	                qs[REST_CONSTANTS.START_AT] += ',' + util_3.stringify(this.indexStartName_);
	            }
	        }
	        if (this.endSet_) {
	            qs[REST_CONSTANTS.END_AT] = util_3.stringify(this.indexEndValue_);
	            if (this.endNameSet_) {
	                qs[REST_CONSTANTS.END_AT] += ',' + util_3.stringify(this.indexEndName_);
	            }
	        }
	        if (this.limitSet_) {
	            if (this.isViewFromLeft()) {
	                qs[REST_CONSTANTS.LIMIT_TO_FIRST] = this.limit_;
	            }
	            else {
	                qs[REST_CONSTANTS.LIMIT_TO_LAST] = this.limit_;
	            }
	        }
	        return qs;
	    };
	    /**
	     * Wire Protocol Constants
	     * @const
	     * @enum {string}
	     * @private
	     */
	    QueryParams.WIRE_PROTOCOL_CONSTANTS_ = {
	        INDEX_START_VALUE: 'sp',
	        INDEX_START_NAME: 'sn',
	        INDEX_END_VALUE: 'ep',
	        INDEX_END_NAME: 'en',
	        LIMIT: 'l',
	        VIEW_FROM: 'vf',
	        VIEW_FROM_LEFT: 'l',
	        VIEW_FROM_RIGHT: 'r',
	        INDEX: 'i'
	    };
	    /**
	     * REST Query Constants
	     * @const
	     * @enum {string}
	     * @private
	     */
	    QueryParams.REST_QUERY_CONSTANTS_ = {
	        ORDER_BY: 'orderBy',
	        PRIORITY_INDEX: '$priority',
	        VALUE_INDEX: '$value',
	        KEY_INDEX: '$key',
	        START_AT: 'startAt',
	        END_AT: 'endAt',
	        LIMIT_TO_FIRST: 'limitToFirst',
	        LIMIT_TO_LAST: 'limitToLast'
	    };
	    /**
	     * Default, empty query parameters
	     * @type {!QueryParams}
	     * @const
	     */
	    QueryParams.DEFAULT = new QueryParams();
	    return QueryParams;
	}());
	exports.QueryParams = QueryParams;
	
	//# sourceMappingURL=QueryParams.js.map


/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var IndexedFilter_1 = __webpack_require__(94);
	var ViewProcessor_1 = __webpack_require__(254);
	var ChildrenNode_1 = __webpack_require__(17);
	var CacheNode_1 = __webpack_require__(70);
	var ViewCache_1 = __webpack_require__(153);
	var EventGenerator_1 = __webpack_require__(249);
	var util_1 = __webpack_require__(1);
	var Operation_1 = __webpack_require__(33);
	var Change_1 = __webpack_require__(39);
	var PriorityIndex_1 = __webpack_require__(15);
	/**
	 * A view represents a specific location and query that has 1 or more event registrations.
	 *
	 * It does several things:
	 *  - Maintains the list of event registrations for this location/query.
	 *  - Maintains a cache of the data visible for this location/query.
	 *  - Applies new operations (via applyOperation), updates the cache, and based on the event
	 *    registrations returns the set of events to be raised.
	 * @constructor
	 */
	var View = /** @class */ (function () {
	    /**
	     *
	     * @param {!Query} query_
	     * @param {!ViewCache} initialViewCache
	     */
	    function View(query_, initialViewCache) {
	        this.query_ = query_;
	        this.eventRegistrations_ = [];
	        var params = this.query_.getQueryParams();
	        var indexFilter = new IndexedFilter_1.IndexedFilter(params.getIndex());
	        var filter = params.getNodeFilter();
	        /**
	         * @type {ViewProcessor}
	         * @private
	         */
	        this.processor_ = new ViewProcessor_1.ViewProcessor(filter);
	        var initialServerCache = initialViewCache.getServerCache();
	        var initialEventCache = initialViewCache.getEventCache();
	        // Don't filter server node with other filter than index, wait for tagged listen
	        var serverSnap = indexFilter.updateFullNode(ChildrenNode_1.ChildrenNode.EMPTY_NODE, initialServerCache.getNode(), null);
	        var eventSnap = filter.updateFullNode(ChildrenNode_1.ChildrenNode.EMPTY_NODE, initialEventCache.getNode(), null);
	        var newServerCache = new CacheNode_1.CacheNode(serverSnap, initialServerCache.isFullyInitialized(), indexFilter.filtersNodes());
	        var newEventCache = new CacheNode_1.CacheNode(eventSnap, initialEventCache.isFullyInitialized(), filter.filtersNodes());
	        /**
	         * @type {!ViewCache}
	         * @private
	         */
	        this.viewCache_ = new ViewCache_1.ViewCache(newEventCache, newServerCache);
	        /**
	         * @type {!EventGenerator}
	         * @private
	         */
	        this.eventGenerator_ = new EventGenerator_1.EventGenerator(this.query_);
	    }
	    /**
	     * @return {!Query}
	     */
	    View.prototype.getQuery = function () {
	        return this.query_;
	    };
	    /**
	     * @return {?Node}
	     */
	    View.prototype.getServerCache = function () {
	        return this.viewCache_.getServerCache().getNode();
	    };
	    /**
	     * @param {!Path} path
	     * @return {?Node}
	     */
	    View.prototype.getCompleteServerCache = function (path) {
	        var cache = this.viewCache_.getCompleteServerSnap();
	        if (cache) {
	            // If this isn't a "loadsAllData" view, then cache isn't actually a complete cache and
	            // we need to see if it contains the child we're interested in.
	            if (this.query_.getQueryParams().loadsAllData() ||
	                (!path.isEmpty() && !cache.getImmediateChild(path.getFront()).isEmpty())) {
	                return cache.getChild(path);
	            }
	        }
	        return null;
	    };
	    /**
	     * @return {boolean}
	     */
	    View.prototype.isEmpty = function () {
	        return this.eventRegistrations_.length === 0;
	    };
	    /**
	     * @param {!EventRegistration} eventRegistration
	     */
	    View.prototype.addEventRegistration = function (eventRegistration) {
	        this.eventRegistrations_.push(eventRegistration);
	    };
	    /**
	     * @param {?EventRegistration} eventRegistration If null, remove all callbacks.
	     * @param {Error=} cancelError If a cancelError is provided, appropriate cancel events will be returned.
	     * @return {!Array.<!Event>} Cancel events, if cancelError was provided.
	     */
	    View.prototype.removeEventRegistration = function (eventRegistration, cancelError) {
	        var cancelEvents = [];
	        if (cancelError) {
	            util_1.assert(eventRegistration == null, 'A cancel should cancel all event registrations.');
	            var path_1 = this.query_.path;
	            this.eventRegistrations_.forEach(function (registration) {
	                cancelError /** @type {!Error} */ = cancelError;
	                var maybeEvent = registration.createCancelEvent(cancelError, path_1);
	                if (maybeEvent) {
	                    cancelEvents.push(maybeEvent);
	                }
	            });
	        }
	        if (eventRegistration) {
	            var remaining = [];
	            for (var i = 0; i < this.eventRegistrations_.length; ++i) {
	                var existing = this.eventRegistrations_[i];
	                if (!existing.matches(eventRegistration)) {
	                    remaining.push(existing);
	                }
	                else if (eventRegistration.hasAnyCallback()) {
	                    // We're removing just this one
	                    remaining = remaining.concat(this.eventRegistrations_.slice(i + 1));
	                    break;
	                }
	            }
	            this.eventRegistrations_ = remaining;
	        }
	        else {
	            this.eventRegistrations_ = [];
	        }
	        return cancelEvents;
	    };
	    /**
	     * Applies the given Operation, updates our cache, and returns the appropriate events.
	     *
	     * @param {!Operation} operation
	     * @param {!WriteTreeRef} writesCache
	     * @param {?Node} completeServerCache
	     * @return {!Array.<!Event>}
	     */
	    View.prototype.applyOperation = function (operation, writesCache, completeServerCache) {
	        if (operation.type === Operation_1.OperationType.MERGE &&
	            operation.source.queryId !== null) {
	            util_1.assert(this.viewCache_.getCompleteServerSnap(), 'We should always have a full cache before handling merges');
	            util_1.assert(this.viewCache_.getCompleteEventSnap(), 'Missing event cache, even though we have a server cache');
	        }
	        var oldViewCache = this.viewCache_;
	        var result = this.processor_.applyOperation(oldViewCache, operation, writesCache, completeServerCache);
	        this.processor_.assertIndexed(result.viewCache);
	        util_1.assert(result.viewCache.getServerCache().isFullyInitialized() ||
	            !oldViewCache.getServerCache().isFullyInitialized(), 'Once a server snap is complete, it should never go back');
	        this.viewCache_ = result.viewCache;
	        return this.generateEventsForChanges_(result.changes, result.viewCache.getEventCache().getNode(), null);
	    };
	    /**
	     * @param {!EventRegistration} registration
	     * @return {!Array.<!Event>}
	     */
	    View.prototype.getInitialEvents = function (registration) {
	        var eventSnap = this.viewCache_.getEventCache();
	        var initialChanges = [];
	        if (!eventSnap.getNode().isLeafNode()) {
	            var eventNode = eventSnap.getNode();
	            eventNode.forEachChild(PriorityIndex_1.PRIORITY_INDEX, function (key, childNode) {
	                initialChanges.push(Change_1.Change.childAddedChange(key, childNode));
	            });
	        }
	        if (eventSnap.isFullyInitialized()) {
	            initialChanges.push(Change_1.Change.valueChange(eventSnap.getNode()));
	        }
	        return this.generateEventsForChanges_(initialChanges, eventSnap.getNode(), registration);
	    };
	    /**
	     * @private
	     * @param {!Array.<!Change>} changes
	     * @param {!Node} eventCache
	     * @param {EventRegistration=} eventRegistration
	     * @return {!Array.<!Event>}
	     */
	    View.prototype.generateEventsForChanges_ = function (changes, eventCache, eventRegistration) {
	        var registrations = eventRegistration
	            ? [eventRegistration]
	            : this.eventRegistrations_;
	        return this.eventGenerator_.generateEventsForChanges(changes, eventCache, registrations);
	    };
	    return View;
	}());
	exports.View = View;
	
	//# sourceMappingURL=View.js.map


/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var Operation_1 = __webpack_require__(33);
	var util_1 = __webpack_require__(1);
	var ChildChangeAccumulator_1 = __webpack_require__(246);
	var Change_1 = __webpack_require__(39);
	var ChildrenNode_1 = __webpack_require__(17);
	var KeyIndex_1 = __webpack_require__(49);
	var ImmutableTree_1 = __webpack_require__(93);
	var Path_1 = __webpack_require__(8);
	var CompleteChildSource_1 = __webpack_require__(247);
	/**
	 * @constructor
	 * @struct
	 */
	var ProcessorResult = /** @class */ (function () {
	    /**
	     * @param {!ViewCache} viewCache
	     * @param {!Array.<!Change>} changes
	     */
	    function ProcessorResult(viewCache, changes) {
	        this.viewCache = viewCache;
	        this.changes = changes;
	    }
	    return ProcessorResult;
	}());
	exports.ProcessorResult = ProcessorResult;
	/**
	 * @constructor
	 */
	var ViewProcessor = /** @class */ (function () {
	    /**
	     * @param {!NodeFilter} filter_
	     */
	    function ViewProcessor(filter_) {
	        this.filter_ = filter_;
	    }
	    /**
	     * @param {!ViewCache} viewCache
	     */
	    ViewProcessor.prototype.assertIndexed = function (viewCache) {
	        util_1.assert(viewCache
	            .getEventCache()
	            .getNode()
	            .isIndexed(this.filter_.getIndex()), 'Event snap not indexed');
	        util_1.assert(viewCache
	            .getServerCache()
	            .getNode()
	            .isIndexed(this.filter_.getIndex()), 'Server snap not indexed');
	    };
	    /**
	     * @param {!ViewCache} oldViewCache
	     * @param {!Operation} operation
	     * @param {!WriteTreeRef} writesCache
	     * @param {?Node} completeCache
	     * @return {!ProcessorResult}
	     */
	    ViewProcessor.prototype.applyOperation = function (oldViewCache, operation, writesCache, completeCache) {
	        var accumulator = new ChildChangeAccumulator_1.ChildChangeAccumulator();
	        var newViewCache, filterServerNode;
	        if (operation.type === Operation_1.OperationType.OVERWRITE) {
	            var overwrite = operation;
	            if (overwrite.source.fromUser) {
	                newViewCache = this.applyUserOverwrite_(oldViewCache, overwrite.path, overwrite.snap, writesCache, completeCache, accumulator);
	            }
	            else {
	                util_1.assert(overwrite.source.fromServer, 'Unknown source.');
	                // We filter the node if it's a tagged update or the node has been previously filtered  and the
	                // update is not at the root in which case it is ok (and necessary) to mark the node unfiltered
	                // again
	                filterServerNode =
	                    overwrite.source.tagged ||
	                        (oldViewCache.getServerCache().isFiltered() &&
	                            !overwrite.path.isEmpty());
	                newViewCache = this.applyServerOverwrite_(oldViewCache, overwrite.path, overwrite.snap, writesCache, completeCache, filterServerNode, accumulator);
	            }
	        }
	        else if (operation.type === Operation_1.OperationType.MERGE) {
	            var merge = operation;
	            if (merge.source.fromUser) {
	                newViewCache = this.applyUserMerge_(oldViewCache, merge.path, merge.children, writesCache, completeCache, accumulator);
	            }
	            else {
	                util_1.assert(merge.source.fromServer, 'Unknown source.');
	                // We filter the node if it's a tagged update or the node has been previously filtered
	                filterServerNode =
	                    merge.source.tagged || oldViewCache.getServerCache().isFiltered();
	                newViewCache = this.applyServerMerge_(oldViewCache, merge.path, merge.children, writesCache, completeCache, filterServerNode, accumulator);
	            }
	        }
	        else if (operation.type === Operation_1.OperationType.ACK_USER_WRITE) {
	            var ackUserWrite = operation;
	            if (!ackUserWrite.revert) {
	                newViewCache = this.ackUserWrite_(oldViewCache, ackUserWrite.path, ackUserWrite.affectedTree, writesCache, completeCache, accumulator);
	            }
	            else {
	                newViewCache = this.revertUserWrite_(oldViewCache, ackUserWrite.path, writesCache, completeCache, accumulator);
	            }
	        }
	        else if (operation.type === Operation_1.OperationType.LISTEN_COMPLETE) {
	            newViewCache = this.listenComplete_(oldViewCache, operation.path, writesCache, accumulator);
	        }
	        else {
	            throw util_1.assertionError('Unknown operation type: ' + operation.type);
	        }
	        var changes = accumulator.getChanges();
	        ViewProcessor.maybeAddValueEvent_(oldViewCache, newViewCache, changes);
	        return new ProcessorResult(newViewCache, changes);
	    };
	    /**
	     * @param {!ViewCache} oldViewCache
	     * @param {!ViewCache} newViewCache
	     * @param {!Array.<!Change>} accumulator
	     * @private
	     */
	    ViewProcessor.maybeAddValueEvent_ = function (oldViewCache, newViewCache, accumulator) {
	        var eventSnap = newViewCache.getEventCache();
	        if (eventSnap.isFullyInitialized()) {
	            var isLeafOrEmpty = eventSnap.getNode().isLeafNode() || eventSnap.getNode().isEmpty();
	            var oldCompleteSnap = oldViewCache.getCompleteEventSnap();
	            if (accumulator.length > 0 ||
	                !oldViewCache.getEventCache().isFullyInitialized() ||
	                (isLeafOrEmpty &&
	                    !eventSnap
	                        .getNode()
	                        .equals(/** @type {!Node} */ (oldCompleteSnap))) ||
	                !eventSnap
	                    .getNode()
	                    .getPriority()
	                    .equals(oldCompleteSnap.getPriority())) {
	                accumulator.push(Change_1.Change.valueChange(
	                /** @type {!Node} */ newViewCache.getCompleteEventSnap()));
	            }
	        }
	    };
	    /**
	     * @param {!ViewCache} viewCache
	     * @param {!Path} changePath
	     * @param {!WriteTreeRef} writesCache
	     * @param {!CompleteChildSource} source
	     * @param {!ChildChangeAccumulator} accumulator
	     * @return {!ViewCache}
	     * @private
	     */
	    ViewProcessor.prototype.generateEventCacheAfterServerEvent_ = function (viewCache, changePath, writesCache, source, accumulator) {
	        var oldEventSnap = viewCache.getEventCache();
	        if (writesCache.shadowingWrite(changePath) != null) {
	            // we have a shadowing write, ignore changes
	            return viewCache;
	        }
	        else {
	            var newEventCache = void 0, serverNode = void 0;
	            if (changePath.isEmpty()) {
	                // TODO: figure out how this plays with "sliding ack windows"
	                util_1.assert(viewCache.getServerCache().isFullyInitialized(), 'If change path is empty, we must have complete server data');
	                if (viewCache.getServerCache().isFiltered()) {
	                    // We need to special case this, because we need to only apply writes to complete children, or
	                    // we might end up raising events for incomplete children. If the server data is filtered deep
	                    // writes cannot be guaranteed to be complete
	                    var serverCache = viewCache.getCompleteServerSnap();
	                    var completeChildren = serverCache instanceof ChildrenNode_1.ChildrenNode
	                        ? serverCache
	                        : ChildrenNode_1.ChildrenNode.EMPTY_NODE;
	                    var completeEventChildren = writesCache.calcCompleteEventChildren(completeChildren);
	                    newEventCache = this.filter_.updateFullNode(viewCache.getEventCache().getNode(), completeEventChildren, accumulator);
	                }
	                else {
	                    var completeNode = writesCache.calcCompleteEventCache(viewCache.getCompleteServerSnap());
	                    newEventCache = this.filter_.updateFullNode(viewCache.getEventCache().getNode(), completeNode, accumulator);
	                }
	            }
	            else {
	                var childKey = changePath.getFront();
	                if (childKey == '.priority') {
	                    util_1.assert(changePath.getLength() == 1, "Can't have a priority with additional path components");
	                    var oldEventNode = oldEventSnap.getNode();
	                    serverNode = viewCache.getServerCache().getNode();
	                    // we might have overwrites for this priority
	                    var updatedPriority = writesCache.calcEventCacheAfterServerOverwrite(changePath, oldEventNode, serverNode);
	                    if (updatedPriority != null) {
	                        newEventCache = this.filter_.updatePriority(oldEventNode, updatedPriority);
	                    }
	                    else {
	                        // priority didn't change, keep old node
	                        newEventCache = oldEventSnap.getNode();
	                    }
	                }
	                else {
	                    var childChangePath = changePath.popFront();
	                    // update child
	                    var newEventChild = void 0;
	                    if (oldEventSnap.isCompleteForChild(childKey)) {
	                        serverNode = viewCache.getServerCache().getNode();
	                        var eventChildUpdate = writesCache.calcEventCacheAfterServerOverwrite(changePath, oldEventSnap.getNode(), serverNode);
	                        if (eventChildUpdate != null) {
	                            newEventChild = oldEventSnap
	                                .getNode()
	                                .getImmediateChild(childKey)
	                                .updateChild(childChangePath, eventChildUpdate);
	                        }
	                        else {
	                            // Nothing changed, just keep the old child
	                            newEventChild = oldEventSnap
	                                .getNode()
	                                .getImmediateChild(childKey);
	                        }
	                    }
	                    else {
	                        newEventChild = writesCache.calcCompleteChild(childKey, viewCache.getServerCache());
	                    }
	                    if (newEventChild != null) {
	                        newEventCache = this.filter_.updateChild(oldEventSnap.getNode(), childKey, newEventChild, childChangePath, source, accumulator);
	                    }
	                    else {
	                        // no complete child available or no change
	                        newEventCache = oldEventSnap.getNode();
	                    }
	                }
	            }
	            return viewCache.updateEventSnap(newEventCache, oldEventSnap.isFullyInitialized() || changePath.isEmpty(), this.filter_.filtersNodes());
	        }
	    };
	    /**
	     * @param {!ViewCache} oldViewCache
	     * @param {!Path} changePath
	     * @param {!Node} changedSnap
	     * @param {!WriteTreeRef} writesCache
	     * @param {?Node} completeCache
	     * @param {boolean} filterServerNode
	     * @param {!ChildChangeAccumulator} accumulator
	     * @return {!ViewCache}
	     * @private
	     */
	    ViewProcessor.prototype.applyServerOverwrite_ = function (oldViewCache, changePath, changedSnap, writesCache, completeCache, filterServerNode, accumulator) {
	        var oldServerSnap = oldViewCache.getServerCache();
	        var newServerCache;
	        var serverFilter = filterServerNode
	            ? this.filter_
	            : this.filter_.getIndexedFilter();
	        if (changePath.isEmpty()) {
	            newServerCache = serverFilter.updateFullNode(oldServerSnap.getNode(), changedSnap, null);
	        }
	        else if (serverFilter.filtersNodes() && !oldServerSnap.isFiltered()) {
	            // we want to filter the server node, but we didn't filter the server node yet, so simulate a full update
	            var newServerNode = oldServerSnap
	                .getNode()
	                .updateChild(changePath, changedSnap);
	            newServerCache = serverFilter.updateFullNode(oldServerSnap.getNode(), newServerNode, null);
	        }
	        else {
	            var childKey = changePath.getFront();
	            if (!oldServerSnap.isCompleteForPath(changePath) &&
	                changePath.getLength() > 1) {
	                // We don't update incomplete nodes with updates intended for other listeners
	                return oldViewCache;
	            }
	            var childChangePath = changePath.popFront();
	            var childNode = oldServerSnap.getNode().getImmediateChild(childKey);
	            var newChildNode = childNode.updateChild(childChangePath, changedSnap);
	            if (childKey == '.priority') {
	                newServerCache = serverFilter.updatePriority(oldServerSnap.getNode(), newChildNode);
	            }
	            else {
	                newServerCache = serverFilter.updateChild(oldServerSnap.getNode(), childKey, newChildNode, childChangePath, CompleteChildSource_1.NO_COMPLETE_CHILD_SOURCE, null);
	            }
	        }
	        var newViewCache = oldViewCache.updateServerSnap(newServerCache, oldServerSnap.isFullyInitialized() || changePath.isEmpty(), serverFilter.filtersNodes());
	        var source = new CompleteChildSource_1.WriteTreeCompleteChildSource(writesCache, newViewCache, completeCache);
	        return this.generateEventCacheAfterServerEvent_(newViewCache, changePath, writesCache, source, accumulator);
	    };
	    /**
	     * @param {!ViewCache} oldViewCache
	     * @param {!Path} changePath
	     * @param {!Node} changedSnap
	     * @param {!WriteTreeRef} writesCache
	     * @param {?Node} completeCache
	     * @param {!ChildChangeAccumulator} accumulator
	     * @return {!ViewCache}
	     * @private
	     */
	    ViewProcessor.prototype.applyUserOverwrite_ = function (oldViewCache, changePath, changedSnap, writesCache, completeCache, accumulator) {
	        var oldEventSnap = oldViewCache.getEventCache();
	        var newViewCache, newEventCache;
	        var source = new CompleteChildSource_1.WriteTreeCompleteChildSource(writesCache, oldViewCache, completeCache);
	        if (changePath.isEmpty()) {
	            newEventCache = this.filter_.updateFullNode(oldViewCache.getEventCache().getNode(), changedSnap, accumulator);
	            newViewCache = oldViewCache.updateEventSnap(newEventCache, true, this.filter_.filtersNodes());
	        }
	        else {
	            var childKey = changePath.getFront();
	            if (childKey === '.priority') {
	                newEventCache = this.filter_.updatePriority(oldViewCache.getEventCache().getNode(), changedSnap);
	                newViewCache = oldViewCache.updateEventSnap(newEventCache, oldEventSnap.isFullyInitialized(), oldEventSnap.isFiltered());
	            }
	            else {
	                var childChangePath = changePath.popFront();
	                var oldChild = oldEventSnap.getNode().getImmediateChild(childKey);
	                var newChild = void 0;
	                if (childChangePath.isEmpty()) {
	                    // Child overwrite, we can replace the child
	                    newChild = changedSnap;
	                }
	                else {
	                    var childNode = source.getCompleteChild(childKey);
	                    if (childNode != null) {
	                        if (childChangePath.getBack() === '.priority' &&
	                            childNode.getChild(childChangePath.parent()).isEmpty()) {
	                            // This is a priority update on an empty node. If this node exists on the server, the
	                            // server will send down the priority in the update, so ignore for now
	                            newChild = childNode;
	                        }
	                        else {
	                            newChild = childNode.updateChild(childChangePath, changedSnap);
	                        }
	                    }
	                    else {
	                        // There is no complete child node available
	                        newChild = ChildrenNode_1.ChildrenNode.EMPTY_NODE;
	                    }
	                }
	                if (!oldChild.equals(newChild)) {
	                    var newEventSnap = this.filter_.updateChild(oldEventSnap.getNode(), childKey, newChild, childChangePath, source, accumulator);
	                    newViewCache = oldViewCache.updateEventSnap(newEventSnap, oldEventSnap.isFullyInitialized(), this.filter_.filtersNodes());
	                }
	                else {
	                    newViewCache = oldViewCache;
	                }
	            }
	        }
	        return newViewCache;
	    };
	    /**
	     * @param {!ViewCache} viewCache
	     * @param {string} childKey
	     * @return {boolean}
	     * @private
	     */
	    ViewProcessor.cacheHasChild_ = function (viewCache, childKey) {
	        return viewCache.getEventCache().isCompleteForChild(childKey);
	    };
	    /**
	     * @param {!ViewCache} viewCache
	     * @param {!Path} path
	     * @param {ImmutableTree.<!Node>} changedChildren
	     * @param {!WriteTreeRef} writesCache
	     * @param {?Node} serverCache
	     * @param {!ChildChangeAccumulator} accumulator
	     * @return {!ViewCache}
	     * @private
	     */
	    ViewProcessor.prototype.applyUserMerge_ = function (viewCache, path, changedChildren, writesCache, serverCache, accumulator) {
	        var _this = this;
	        // HACK: In the case of a limit query, there may be some changes that bump things out of the
	        // window leaving room for new items.  It's important we process these changes first, so we
	        // iterate the changes twice, first processing any that affect items currently in view.
	        // TODO: I consider an item "in view" if cacheHasChild is true, which checks both the server
	        // and event snap.  I'm not sure if this will result in edge cases when a child is in one but
	        // not the other.
	        var curViewCache = viewCache;
	        changedChildren.foreach(function (relativePath, childNode) {
	            var writePath = path.child(relativePath);
	            if (ViewProcessor.cacheHasChild_(viewCache, writePath.getFront())) {
	                curViewCache = _this.applyUserOverwrite_(curViewCache, writePath, childNode, writesCache, serverCache, accumulator);
	            }
	        });
	        changedChildren.foreach(function (relativePath, childNode) {
	            var writePath = path.child(relativePath);
	            if (!ViewProcessor.cacheHasChild_(viewCache, writePath.getFront())) {
	                curViewCache = _this.applyUserOverwrite_(curViewCache, writePath, childNode, writesCache, serverCache, accumulator);
	            }
	        });
	        return curViewCache;
	    };
	    /**
	     * @param {!Node} node
	     * @param {ImmutableTree.<!Node>} merge
	     * @return {!Node}
	     * @private
	     */
	    ViewProcessor.prototype.applyMerge_ = function (node, merge) {
	        merge.foreach(function (relativePath, childNode) {
	            node = node.updateChild(relativePath, childNode);
	        });
	        return node;
	    };
	    /**
	     * @param {!ViewCache} viewCache
	     * @param {!Path} path
	     * @param {!ImmutableTree.<!Node>} changedChildren
	     * @param {!WriteTreeRef} writesCache
	     * @param {?Node} serverCache
	     * @param {boolean} filterServerNode
	     * @param {!ChildChangeAccumulator} accumulator
	     * @return {!ViewCache}
	     * @private
	     */
	    ViewProcessor.prototype.applyServerMerge_ = function (viewCache, path, changedChildren, writesCache, serverCache, filterServerNode, accumulator) {
	        var _this = this;
	        // If we don't have a cache yet, this merge was intended for a previously listen in the same location. Ignore it and
	        // wait for the complete data update coming soon.
	        if (viewCache
	            .getServerCache()
	            .getNode()
	            .isEmpty() &&
	            !viewCache.getServerCache().isFullyInitialized()) {
	            return viewCache;
	        }
	        // HACK: In the case of a limit query, there may be some changes that bump things out of the
	        // window leaving room for new items.  It's important we process these changes first, so we
	        // iterate the changes twice, first processing any that affect items currently in view.
	        // TODO: I consider an item "in view" if cacheHasChild is true, which checks both the server
	        // and event snap.  I'm not sure if this will result in edge cases when a child is in one but
	        // not the other.
	        var curViewCache = viewCache;
	        var viewMergeTree;
	        if (path.isEmpty()) {
	            viewMergeTree = changedChildren;
	        }
	        else {
	            viewMergeTree = ImmutableTree_1.ImmutableTree.Empty.setTree(path, changedChildren);
	        }
	        var serverNode = viewCache.getServerCache().getNode();
	        viewMergeTree.children.inorderTraversal(function (childKey, childTree) {
	            if (serverNode.hasChild(childKey)) {
	                var serverChild = viewCache
	                    .getServerCache()
	                    .getNode()
	                    .getImmediateChild(childKey);
	                var newChild = _this.applyMerge_(serverChild, childTree);
	                curViewCache = _this.applyServerOverwrite_(curViewCache, new Path_1.Path(childKey), newChild, writesCache, serverCache, filterServerNode, accumulator);
	            }
	        });
	        viewMergeTree.children.inorderTraversal(function (childKey, childMergeTree) {
	            var isUnknownDeepMerge = !viewCache.getServerCache().isCompleteForChild(childKey) &&
	                childMergeTree.value == null;
	            if (!serverNode.hasChild(childKey) && !isUnknownDeepMerge) {
	                var serverChild = viewCache
	                    .getServerCache()
	                    .getNode()
	                    .getImmediateChild(childKey);
	                var newChild = _this.applyMerge_(serverChild, childMergeTree);
	                curViewCache = _this.applyServerOverwrite_(curViewCache, new Path_1.Path(childKey), newChild, writesCache, serverCache, filterServerNode, accumulator);
	            }
	        });
	        return curViewCache;
	    };
	    /**
	     * @param {!ViewCache} viewCache
	     * @param {!Path} ackPath
	     * @param {!ImmutableTree<!boolean>} affectedTree
	     * @param {!WriteTreeRef} writesCache
	     * @param {?Node} completeCache
	     * @param {!ChildChangeAccumulator} accumulator
	     * @return {!ViewCache}
	     * @private
	     */
	    ViewProcessor.prototype.ackUserWrite_ = function (viewCache, ackPath, affectedTree, writesCache, completeCache, accumulator) {
	        if (writesCache.shadowingWrite(ackPath) != null) {
	            return viewCache;
	        }
	        // Only filter server node if it is currently filtered
	        var filterServerNode = viewCache.getServerCache().isFiltered();
	        // Essentially we'll just get our existing server cache for the affected paths and re-apply it as a server update
	        // now that it won't be shadowed.
	        var serverCache = viewCache.getServerCache();
	        if (affectedTree.value != null) {
	            // This is an overwrite.
	            if ((ackPath.isEmpty() && serverCache.isFullyInitialized()) ||
	                serverCache.isCompleteForPath(ackPath)) {
	                return this.applyServerOverwrite_(viewCache, ackPath, serverCache.getNode().getChild(ackPath), writesCache, completeCache, filterServerNode, accumulator);
	            }
	            else if (ackPath.isEmpty()) {
	                // This is a goofy edge case where we are acking data at this location but don't have full data.  We
	                // should just re-apply whatever we have in our cache as a merge.
	                var changedChildren_1 = ImmutableTree_1.ImmutableTree.Empty;
	                serverCache.getNode().forEachChild(KeyIndex_1.KEY_INDEX, function (name, node) {
	                    changedChildren_1 = changedChildren_1.set(new Path_1.Path(name), node);
	                });
	                return this.applyServerMerge_(viewCache, ackPath, changedChildren_1, writesCache, completeCache, filterServerNode, accumulator);
	            }
	            else {
	                return viewCache;
	            }
	        }
	        else {
	            // This is a merge.
	            var changedChildren_2 = ImmutableTree_1.ImmutableTree.Empty;
	            affectedTree.foreach(function (mergePath, value) {
	                var serverCachePath = ackPath.child(mergePath);
	                if (serverCache.isCompleteForPath(serverCachePath)) {
	                    changedChildren_2 = changedChildren_2.set(mergePath, serverCache.getNode().getChild(serverCachePath));
	                }
	            });
	            return this.applyServerMerge_(viewCache, ackPath, changedChildren_2, writesCache, completeCache, filterServerNode, accumulator);
	        }
	    };
	    /**
	     * @param {!ViewCache} viewCache
	     * @param {!Path} path
	     * @param {!WriteTreeRef} writesCache
	     * @param {!ChildChangeAccumulator} accumulator
	     * @return {!ViewCache}
	     * @private
	     */
	    ViewProcessor.prototype.listenComplete_ = function (viewCache, path, writesCache, accumulator) {
	        var oldServerNode = viewCache.getServerCache();
	        var newViewCache = viewCache.updateServerSnap(oldServerNode.getNode(), oldServerNode.isFullyInitialized() || path.isEmpty(), oldServerNode.isFiltered());
	        return this.generateEventCacheAfterServerEvent_(newViewCache, path, writesCache, CompleteChildSource_1.NO_COMPLETE_CHILD_SOURCE, accumulator);
	    };
	    /**
	     * @param {!ViewCache} viewCache
	     * @param {!Path} path
	     * @param {!WriteTreeRef} writesCache
	     * @param {?Node} completeServerCache
	     * @param {!ChildChangeAccumulator} accumulator
	     * @return {!ViewCache}
	     * @private
	     */
	    ViewProcessor.prototype.revertUserWrite_ = function (viewCache, path, writesCache, completeServerCache, accumulator) {
	        var complete;
	        if (writesCache.shadowingWrite(path) != null) {
	            return viewCache;
	        }
	        else {
	            var source = new CompleteChildSource_1.WriteTreeCompleteChildSource(writesCache, viewCache, completeServerCache);
	            var oldEventCache = viewCache.getEventCache().getNode();
	            var newEventCache = void 0;
	            if (path.isEmpty() || path.getFront() === '.priority') {
	                var newNode = void 0;
	                if (viewCache.getServerCache().isFullyInitialized()) {
	                    newNode = writesCache.calcCompleteEventCache(viewCache.getCompleteServerSnap());
	                }
	                else {
	                    var serverChildren = viewCache.getServerCache().getNode();
	                    util_1.assert(serverChildren instanceof ChildrenNode_1.ChildrenNode, 'serverChildren would be complete if leaf node');
	                    newNode = writesCache.calcCompleteEventChildren(serverChildren);
	                }
	                newNode = newNode;
	                newEventCache = this.filter_.updateFullNode(oldEventCache, newNode, accumulator);
	            }
	            else {
	                var childKey = path.getFront();
	                var newChild = writesCache.calcCompleteChild(childKey, viewCache.getServerCache());
	                if (newChild == null &&
	                    viewCache.getServerCache().isCompleteForChild(childKey)) {
	                    newChild = oldEventCache.getImmediateChild(childKey);
	                }
	                if (newChild != null) {
	                    newEventCache = this.filter_.updateChild(oldEventCache, childKey, newChild, path.popFront(), source, accumulator);
	                }
	                else if (viewCache
	                    .getEventCache()
	                    .getNode()
	                    .hasChild(childKey)) {
	                    // No complete child available, delete the existing one, if any
	                    newEventCache = this.filter_.updateChild(oldEventCache, childKey, ChildrenNode_1.ChildrenNode.EMPTY_NODE, path.popFront(), source, accumulator);
	                }
	                else {
	                    newEventCache = oldEventCache;
	                }
	                if (newEventCache.isEmpty() &&
	                    viewCache.getServerCache().isFullyInitialized()) {
	                    // We might have reverted all child writes. Maybe the old event was a leaf node
	                    complete = writesCache.calcCompleteEventCache(viewCache.getCompleteServerSnap());
	                    if (complete.isLeafNode()) {
	                        newEventCache = this.filter_.updateFullNode(newEventCache, complete, accumulator);
	                    }
	                }
	            }
	            complete =
	                viewCache.getServerCache().isFullyInitialized() ||
	                    writesCache.shadowingWrite(Path_1.Path.Empty) != null;
	            return viewCache.updateEventSnap(newEventCache, complete, this.filter_.filtersNodes());
	        }
	    };
	    return ViewProcessor;
	}());
	exports.ViewProcessor = ViewProcessor;
	
	//# sourceMappingURL=ViewProcessor.js.map


/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var RangedFilter_1 = __webpack_require__(154);
	var ChildrenNode_1 = __webpack_require__(17);
	var Node_1 = __webpack_require__(19);
	var util_1 = __webpack_require__(1);
	var Change_1 = __webpack_require__(39);
	/**
	 * Applies a limit and a range to a node and uses RangedFilter to do the heavy lifting where possible
	 *
	 * @constructor
	 * @implements {NodeFilter}
	 */
	var LimitedFilter = /** @class */ (function () {
	    /**
	     * @param {!QueryParams} params
	     */
	    function LimitedFilter(params) {
	        this.rangedFilter_ = new RangedFilter_1.RangedFilter(params);
	        this.index_ = params.getIndex();
	        this.limit_ = params.getLimit();
	        this.reverse_ = !params.isViewFromLeft();
	    }
	    /**
	     * @inheritDoc
	     */
	    LimitedFilter.prototype.updateChild = function (snap, key, newChild, affectedPath, source, optChangeAccumulator) {
	        if (!this.rangedFilter_.matches(new Node_1.NamedNode(key, newChild))) {
	            newChild = ChildrenNode_1.ChildrenNode.EMPTY_NODE;
	        }
	        if (snap.getImmediateChild(key).equals(newChild)) {
	            // No change
	            return snap;
	        }
	        else if (snap.numChildren() < this.limit_) {
	            return this.rangedFilter_
	                .getIndexedFilter()
	                .updateChild(snap, key, newChild, affectedPath, source, optChangeAccumulator);
	        }
	        else {
	            return this.fullLimitUpdateChild_(snap, key, newChild, source, optChangeAccumulator);
	        }
	    };
	    /**
	     * @inheritDoc
	     */
	    LimitedFilter.prototype.updateFullNode = function (oldSnap, newSnap, optChangeAccumulator) {
	        var filtered;
	        if (newSnap.isLeafNode() || newSnap.isEmpty()) {
	            // Make sure we have a children node with the correct index, not a leaf node;
	            filtered = ChildrenNode_1.ChildrenNode.EMPTY_NODE.withIndex(this.index_);
	        }
	        else {
	            if (this.limit_ * 2 < newSnap.numChildren() &&
	                newSnap.isIndexed(this.index_)) {
	                // Easier to build up a snapshot, since what we're given has more than twice the elements we want
	                filtered = ChildrenNode_1.ChildrenNode.EMPTY_NODE.withIndex(this.index_);
	                // anchor to the startPost, endPost, or last element as appropriate
	                var iterator = void 0;
	                if (this.reverse_) {
	                    iterator = newSnap.getReverseIteratorFrom(this.rangedFilter_.getEndPost(), this.index_);
	                }
	                else {
	                    iterator = newSnap.getIteratorFrom(this.rangedFilter_.getStartPost(), this.index_);
	                }
	                var count = 0;
	                while (iterator.hasNext() && count < this.limit_) {
	                    var next = iterator.getNext();
	                    var inRange = void 0;
	                    if (this.reverse_) {
	                        inRange =
	                            this.index_.compare(this.rangedFilter_.getStartPost(), next) <= 0;
	                    }
	                    else {
	                        inRange =
	                            this.index_.compare(next, this.rangedFilter_.getEndPost()) <= 0;
	                    }
	                    if (inRange) {
	                        filtered = filtered.updateImmediateChild(next.name, next.node);
	                        count++;
	                    }
	                    else {
	                        // if we have reached the end post, we cannot keep adding elemments
	                        break;
	                    }
	                }
	            }
	            else {
	                // The snap contains less than twice the limit. Faster to delete from the snap than build up a new one
	                filtered = newSnap.withIndex(this.index_);
	                // Don't support priorities on queries
	                filtered = filtered.updatePriority(ChildrenNode_1.ChildrenNode.EMPTY_NODE);
	                var startPost = void 0;
	                var endPost = void 0;
	                var cmp = void 0;
	                var iterator = void 0;
	                if (this.reverse_) {
	                    iterator = filtered.getReverseIterator(this.index_);
	                    startPost = this.rangedFilter_.getEndPost();
	                    endPost = this.rangedFilter_.getStartPost();
	                    var indexCompare_1 = this.index_.getCompare();
	                    cmp = function (a, b) { return indexCompare_1(b, a); };
	                }
	                else {
	                    iterator = filtered.getIterator(this.index_);
	                    startPost = this.rangedFilter_.getStartPost();
	                    endPost = this.rangedFilter_.getEndPost();
	                    cmp = this.index_.getCompare();
	                }
	                var count = 0;
	                var foundStartPost = false;
	                while (iterator.hasNext()) {
	                    var next = iterator.getNext();
	                    if (!foundStartPost && cmp(startPost, next) <= 0) {
	                        // start adding
	                        foundStartPost = true;
	                    }
	                    var inRange = foundStartPost && count < this.limit_ && cmp(next, endPost) <= 0;
	                    if (inRange) {
	                        count++;
	                    }
	                    else {
	                        filtered = filtered.updateImmediateChild(next.name, ChildrenNode_1.ChildrenNode.EMPTY_NODE);
	                    }
	                }
	            }
	        }
	        return this.rangedFilter_
	            .getIndexedFilter()
	            .updateFullNode(oldSnap, filtered, optChangeAccumulator);
	    };
	    /**
	     * @inheritDoc
	     */
	    LimitedFilter.prototype.updatePriority = function (oldSnap, newPriority) {
	        // Don't support priorities on queries
	        return oldSnap;
	    };
	    /**
	     * @inheritDoc
	     */
	    LimitedFilter.prototype.filtersNodes = function () {
	        return true;
	    };
	    /**
	     * @inheritDoc
	     */
	    LimitedFilter.prototype.getIndexedFilter = function () {
	        return this.rangedFilter_.getIndexedFilter();
	    };
	    /**
	     * @inheritDoc
	     */
	    LimitedFilter.prototype.getIndex = function () {
	        return this.index_;
	    };
	    /**
	     * @param {!Node} snap
	     * @param {string} childKey
	     * @param {!Node} childSnap
	     * @param {!CompleteChildSource} source
	     * @param {?ChildChangeAccumulator} changeAccumulator
	     * @return {!Node}
	     * @private
	     */
	    LimitedFilter.prototype.fullLimitUpdateChild_ = function (snap, childKey, childSnap, source, changeAccumulator) {
	        // TODO: rename all cache stuff etc to general snap terminology
	        var cmp;
	        if (this.reverse_) {
	            var indexCmp_1 = this.index_.getCompare();
	            cmp = function (a, b) { return indexCmp_1(b, a); };
	        }
	        else {
	            cmp = this.index_.getCompare();
	        }
	        var oldEventCache = snap;
	        util_1.assert(oldEventCache.numChildren() == this.limit_, '');
	        var newChildNamedNode = new Node_1.NamedNode(childKey, childSnap);
	        var windowBoundary = this.reverse_
	            ? oldEventCache.getFirstChild(this.index_)
	            : oldEventCache.getLastChild(this.index_);
	        var inRange = this.rangedFilter_.matches(newChildNamedNode);
	        if (oldEventCache.hasChild(childKey)) {
	            var oldChildSnap = oldEventCache.getImmediateChild(childKey);
	            var nextChild = source.getChildAfterChild(this.index_, windowBoundary, this.reverse_);
	            while (nextChild != null &&
	                (nextChild.name == childKey || oldEventCache.hasChild(nextChild.name))) {
	                // There is a weird edge case where a node is updated as part of a merge in the write tree, but hasn't
	                // been applied to the limited filter yet. Ignore this next child which will be updated later in
	                // the limited filter...
	                nextChild = source.getChildAfterChild(this.index_, nextChild, this.reverse_);
	            }
	            var compareNext = nextChild == null ? 1 : cmp(nextChild, newChildNamedNode);
	            var remainsInWindow = inRange && !childSnap.isEmpty() && compareNext >= 0;
	            if (remainsInWindow) {
	                if (changeAccumulator != null) {
	                    changeAccumulator.trackChildChange(Change_1.Change.childChangedChange(childKey, childSnap, oldChildSnap));
	                }
	                return oldEventCache.updateImmediateChild(childKey, childSnap);
	            }
	            else {
	                if (changeAccumulator != null) {
	                    changeAccumulator.trackChildChange(Change_1.Change.childRemovedChange(childKey, oldChildSnap));
	                }
	                var newEventCache = oldEventCache.updateImmediateChild(childKey, ChildrenNode_1.ChildrenNode.EMPTY_NODE);
	                var nextChildInRange = nextChild != null && this.rangedFilter_.matches(nextChild);
	                if (nextChildInRange) {
	                    if (changeAccumulator != null) {
	                        changeAccumulator.trackChildChange(Change_1.Change.childAddedChange(nextChild.name, nextChild.node));
	                    }
	                    return newEventCache.updateImmediateChild(nextChild.name, nextChild.node);
	                }
	                else {
	                    return newEventCache;
	                }
	            }
	        }
	        else if (childSnap.isEmpty()) {
	            // we're deleting a node, but it was not in the window, so ignore it
	            return snap;
	        }
	        else if (inRange) {
	            if (cmp(windowBoundary, newChildNamedNode) >= 0) {
	                if (changeAccumulator != null) {
	                    changeAccumulator.trackChildChange(Change_1.Change.childRemovedChange(windowBoundary.name, windowBoundary.node));
	                    changeAccumulator.trackChildChange(Change_1.Change.childAddedChange(childKey, childSnap));
	                }
	                return oldEventCache
	                    .updateImmediateChild(childKey, childSnap)
	                    .updateImmediateChild(windowBoundary.name, ChildrenNode_1.ChildrenNode.EMPTY_NODE);
	            }
	            else {
	                return snap;
	            }
	        }
	        else {
	            return snap;
	        }
	    };
	    return LimitedFilter;
	}());
	exports.LimitedFilter = LimitedFilter;
	
	//# sourceMappingURL=LimitedFilter.js.map


/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var BrowserPollConnection_1 = __webpack_require__(155);
	var WebSocketConnection_1 = __webpack_require__(157);
	var util_1 = __webpack_require__(4);
	/**
	 * Currently simplistic, this class manages what transport a Connection should use at various stages of its
	 * lifecycle.
	 *
	 * It starts with longpolling in a browser, and httppolling on node. It then upgrades to websockets if
	 * they are available.
	 * @constructor
	 */
	var TransportManager = /** @class */ (function () {
	    /**
	     * @param {!RepoInfo} repoInfo Metadata around the namespace we're connecting to
	     */
	    function TransportManager(repoInfo) {
	        this.initTransports_(repoInfo);
	    }
	    Object.defineProperty(TransportManager, "ALL_TRANSPORTS", {
	        /**
	         * @const
	         * @type {!Array.<function(new:Transport, string, RepoInfo, string=)>}
	         */
	        get: function () {
	            return [BrowserPollConnection_1.BrowserPollConnection, WebSocketConnection_1.WebSocketConnection];
	        },
	        enumerable: true,
	        configurable: true
	    });
	    /**
	     * @param {!RepoInfo} repoInfo
	     * @private
	     */
	    TransportManager.prototype.initTransports_ = function (repoInfo) {
	        var isWebSocketsAvailable = WebSocketConnection_1.WebSocketConnection && WebSocketConnection_1.WebSocketConnection['isAvailable']();
	        var isSkipPollConnection = isWebSocketsAvailable && !WebSocketConnection_1.WebSocketConnection.previouslyFailed();
	        if (repoInfo.webSocketOnly) {
	            if (!isWebSocketsAvailable)
	                util_1.warn("wss:// URL used, but browser isn't known to support websockets.  Trying anyway.");
	            isSkipPollConnection = true;
	        }
	        if (isSkipPollConnection) {
	            this.transports_ = [WebSocketConnection_1.WebSocketConnection];
	        }
	        else {
	            var transports_1 = (this.transports_ = []);
	            util_1.each(TransportManager.ALL_TRANSPORTS, function (i, transport) {
	                if (transport && transport['isAvailable']()) {
	                    transports_1.push(transport);
	                }
	            });
	        }
	    };
	    /**
	     * @return {function(new:Transport, !string, !RepoInfo, string=, string=)} The constructor for the
	     * initial transport to use
	     */
	    TransportManager.prototype.initialTransport = function () {
	        if (this.transports_.length > 0) {
	            return this.transports_[0];
	        }
	        else {
	            throw new Error('No transports available');
	        }
	    };
	    /**
	     * @return {?function(new:Transport, function(),function(), string=)} The constructor for the next
	     * transport, or null
	     */
	    TransportManager.prototype.upgradeTransport = function () {
	        if (this.transports_.length > 1) {
	            return this.transports_[1];
	        }
	        else {
	            return null;
	        }
	    };
	    return TransportManager;
	}());
	exports.TransportManager = TransportManager;
	
	//# sourceMappingURL=TransportManager.js.map


/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var util_1 = __webpack_require__(4);
	/**
	 * This class ensures the packets from the server arrive in order
	 * This class takes data from the server and ensures it gets passed into the callbacks in order.
	 * @constructor
	 */
	var PacketReceiver = /** @class */ (function () {
	    /**
	     * @param onMessage_
	     */
	    function PacketReceiver(onMessage_) {
	        this.onMessage_ = onMessage_;
	        this.pendingResponses = [];
	        this.currentResponseNum = 0;
	        this.closeAfterResponse = -1;
	        this.onClose = null;
	    }
	    PacketReceiver.prototype.closeAfter = function (responseNum, callback) {
	        this.closeAfterResponse = responseNum;
	        this.onClose = callback;
	        if (this.closeAfterResponse < this.currentResponseNum) {
	            this.onClose();
	            this.onClose = null;
	        }
	    };
	    /**
	     * Each message from the server comes with a response number, and an array of data. The responseNumber
	     * allows us to ensure that we process them in the right order, since we can't be guaranteed that all
	     * browsers will respond in the same order as the requests we sent
	     * @param {number} requestNum
	     * @param {Array} data
	     */
	    PacketReceiver.prototype.handleResponse = function (requestNum, data) {
	        var _this = this;
	        this.pendingResponses[requestNum] = data;
	        var _loop_1 = function () {
	            var toProcess = this_1.pendingResponses[this_1.currentResponseNum];
	            delete this_1.pendingResponses[this_1.currentResponseNum];
	            var _loop_2 = function (i) {
	                if (toProcess[i]) {
	                    util_1.exceptionGuard(function () {
	                        _this.onMessage_(toProcess[i]);
	                    });
	                }
	            };
	            for (var i = 0; i < toProcess.length; ++i) {
	                _loop_2(i);
	            }
	            if (this_1.currentResponseNum === this_1.closeAfterResponse) {
	                if (this_1.onClose) {
	                    this_1.onClose();
	                    this_1.onClose = null;
	                }
	                return "break";
	            }
	            this_1.currentResponseNum++;
	        };
	        var this_1 = this;
	        while (this.pendingResponses[this.currentResponseNum]) {
	            var state_1 = _loop_1();
	            if (state_1 === "break")
	                break;
	        }
	    };
	    return PacketReceiver;
	}());
	exports.PacketReceiver = PacketReceiver;
	
	//# sourceMappingURL=PacketReceiver.js.map


/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var app_1 = __webpack_require__(26);
	__webpack_require__(284);
	var config_1 = __webpack_require__(283);
	function registerFirestore(instance) {
	    config_1.configureForFirebase(instance);
	}
	exports.registerFirestore = registerFirestore;
	registerFirestore(app_1.default);
	
	//# sourceMappingURL=index.js.map


/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var user_1 = __webpack_require__(263);
	var assert_1 = __webpack_require__(2);
	var error_1 = __webpack_require__(10);
	var OAuthToken = /** @class */ (function () {
	    function OAuthToken(value, user) {
	        this.user = user;
	        this.type = 'OAuth';
	        this.authHeaders = { Authorization: "Bearer " + value };
	    }
	    return OAuthToken;
	}());
	exports.OAuthToken = OAuthToken;
	/** A CredentialsProvider that always yields an empty token. */
	var EmptyCredentialsProvider = /** @class */ (function () {
	    function EmptyCredentialsProvider() {
	        /**
	         * Stores the User listener registered with setUserChangeListener()
	         * This isn't actually necessary since the UID never changes, but we use this
	         * to verify the listen contract is adhered to in tests.
	         */
	        this.userListener = null;
	    }
	    EmptyCredentialsProvider.prototype.getToken = function (forceRefresh) {
	        return Promise.resolve(null);
	    };
	    EmptyCredentialsProvider.prototype.setUserChangeListener = function (listener) {
	        assert_1.assert(!this.userListener, 'Can only call setUserChangeListener() once.');
	        this.userListener = listener;
	        // Fire with initial user.
	        listener(user_1.User.UNAUTHENTICATED);
	    };
	    EmptyCredentialsProvider.prototype.removeUserChangeListener = function () {
	        assert_1.assert(this.userListener !== null, 'removeUserChangeListener() when no listener registered');
	        this.userListener = null;
	    };
	    return EmptyCredentialsProvider;
	}());
	exports.EmptyCredentialsProvider = EmptyCredentialsProvider;
	var FirebaseCredentialsProvider = /** @class */ (function () {
	    function FirebaseCredentialsProvider(app) {
	        var _this = this;
	        this.app = app;
	        /**
	         * The auth token listener registered with FirebaseApp, retained here so we
	         * can unregister it.
	         */
	        this.tokenListener = null;
	        /**
	         * Counter used to detect if the user changed while a getToken request was
	         * outstanding.
	         */
	        this.userCounter = 0;
	        /** The User listener registered with setUserChangeListener(). */
	        this.userListener = null;
	        // We listen for token changes but all we really care about is knowing when
	        // the uid may have changed.
	        this.tokenListener = function () {
	            var newUser = _this.getUser();
	            if (!_this.currentUser || !newUser.isEqual(_this.currentUser)) {
	                _this.currentUser = newUser;
	                _this.userCounter++;
	                if (_this.userListener) {
	                    _this.userListener(_this.currentUser);
	                }
	            }
	        };
	        this.userCounter = 0;
	        // Will fire at least once where we set this.currentUser
	        this.app.INTERNAL.addAuthTokenListener(this.tokenListener);
	    }
	    FirebaseCredentialsProvider.prototype.getToken = function (forceRefresh) {
	        var _this = this;
	        assert_1.assert(this.tokenListener != null, 'getToken cannot be called after listener removed.');
	        // Take note of the current value of the userCounter so that this method can
	        // fail (with an ABORTED error) if there is a user change while the request
	        // is outstanding.
	        var initialUserCounter = this.userCounter;
	        return this.app.INTERNAL.getToken(forceRefresh).then(function (tokenData) {
	            // Cancel the request since the user changed while the request was
	            // outstanding so the response is likely for a previous user (which
	            // user, we can't be sure).
	            if (_this.userCounter !== initialUserCounter) {
	                throw new error_1.FirestoreError(error_1.Code.ABORTED, 'getToken aborted due to uid change.');
	            }
	            else {
	                if (tokenData) {
	                    assert_1.assert(typeof tokenData.accessToken === 'string', 'Invalid tokenData returned from getToken():' + tokenData);
	                    return new OAuthToken(tokenData.accessToken, _this.currentUser);
	                }
	                else {
	                    return null;
	                }
	            }
	        });
	    };
	    FirebaseCredentialsProvider.prototype.setUserChangeListener = function (listener) {
	        assert_1.assert(!this.userListener, 'Can only call setUserChangeListener() once.');
	        this.userListener = listener;
	        // Fire the initial event, but only if we received the initial user
	        if (this.currentUser) {
	            listener(this.currentUser);
	        }
	    };
	    FirebaseCredentialsProvider.prototype.removeUserChangeListener = function () {
	        assert_1.assert(this.tokenListener != null, 'removeUserChangeListener() called twice');
	        assert_1.assert(this.userListener !== null, 'removeUserChangeListener() called when no listener registered');
	        this.app.INTERNAL.removeAuthTokenListener(this.tokenListener);
	        this.tokenListener = null;
	        this.userListener = null;
	    };
	    FirebaseCredentialsProvider.prototype.getUser = function () {
	        // TODO(mikelehen): Remove this check once we're shipping with firebase.js.
	        if (typeof this.app.INTERNAL.getUid !== 'function') {
	            assert_1.fail('This version of the Firestore SDK requires at least version' +
	                ' 3.7.0 of firebase.js.');
	        }
	        var currentUid = this.app.INTERNAL.getUid();
	        assert_1.assert(currentUid === null || typeof currentUid === 'string', 'Received invalid UID: ' + currentUid);
	        return new user_1.User(currentUid);
	    };
	    return FirebaseCredentialsProvider;
	}());
	exports.FirebaseCredentialsProvider = FirebaseCredentialsProvider;
	/*
	 * FirstPartyToken provides a fresh token each time its value
	 * is requested, because if the token is too old, requests will be rejected.
	 * TODO(b/33147818) this implementation violates the current assumption that
	 * tokens are immutable.  We need to either revisit this assumption or come
	 * up with some way for FPA to use the listen/unlisten interface.
	 */
	var FirstPartyToken = /** @class */ (function () {
	    function FirstPartyToken(gapi, sessionIndex) {
	        this.gapi = gapi;
	        this.sessionIndex = sessionIndex;
	        this.type = 'FirstParty';
	        this.user = user_1.User.FIRST_PARTY;
	        assert_1.assert(this.gapi &&
	            this.gapi['auth'] &&
	            this.gapi['auth']['getAuthHeaderValueForFirstParty'], 'unexpected gapi interface');
	    }
	    Object.defineProperty(FirstPartyToken.prototype, "authHeaders", {
	        get: function () {
	            return {
	                Authorization: this.gapi['auth']['getAuthHeaderValueForFirstParty']([]),
	                'X-Goog-AuthUser': this.sessionIndex
	            };
	        },
	        enumerable: true,
	        configurable: true
	    });
	    return FirstPartyToken;
	}());
	exports.FirstPartyToken = FirstPartyToken;
	/*
	 * Provides user credentials required for the Firestore JavaScript SDK
	 * to authenticate the user, using technique that is only available
	 * to applications hosted by Google.
	 */
	var FirstPartyCredentialsProvider = /** @class */ (function () {
	    function FirstPartyCredentialsProvider(gapi, sessionIndex) {
	        this.gapi = gapi;
	        this.sessionIndex = sessionIndex;
	        assert_1.assert(this.gapi &&
	            this.gapi['auth'] &&
	            this.gapi['auth']['getAuthHeaderValueForFirstParty'], 'unexpected gapi interface');
	    }
	    FirstPartyCredentialsProvider.prototype.getToken = function (forceRefresh) {
	        return Promise.resolve(new FirstPartyToken(this.gapi, this.sessionIndex));
	    };
	    // TODO(33108925): can someone switch users w/o a page refresh?
	    // TODO(33110621): need to understand token/session lifecycle
	    FirstPartyCredentialsProvider.prototype.setUserChangeListener = function (listener) {
	        // Fire with initial uid.
	        listener(user_1.User.FIRST_PARTY);
	    };
	    FirstPartyCredentialsProvider.prototype.removeUserChangeListener = function () { };
	    return FirstPartyCredentialsProvider;
	}());
	exports.FirstPartyCredentialsProvider = FirstPartyCredentialsProvider;
	/**
	 * Builds a CredentialsProvider depending on the type of
	 * the credentials passed in.
	 */
	function makeCredentialsProvider(credentials) {
	    if (!credentials) {
	        return new EmptyCredentialsProvider();
	    }
	    switch (credentials.type) {
	        case 'gapi':
	            return new FirstPartyCredentialsProvider(credentials.client, credentials.sessionIndex || '0');
	        case 'provider':
	            return credentials.client;
	        default:
	            throw new error_1.FirestoreError(error_1.Code.INVALID_ARGUMENT, 'makeCredentialsProvider failed due to invalid credential type');
	    }
	}
	exports.makeCredentialsProvider = makeCredentialsProvider;
	
	//# sourceMappingURL=credentials.js.map


/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var field_path_1 = __webpack_require__(96);
	var database_info_1 = __webpack_require__(159);
	var firestore_client_1 = __webpack_require__(265);
	var query_1 = __webpack_require__(98);
	var view_snapshot_1 = __webpack_require__(72);
	var document_1 = __webpack_require__(21);
	var document_key_1 = __webpack_require__(12);
	var field_value_1 = __webpack_require__(42);
	var mutation_1 = __webpack_require__(75);
	var path_1 = __webpack_require__(35);
	var platform_1 = __webpack_require__(29);
	var api_1 = __webpack_require__(103);
	var assert_1 = __webpack_require__(2);
	var async_observer_1 = __webpack_require__(293);
	var async_queue_1 = __webpack_require__(294);
	var error_1 = __webpack_require__(10);
	var input_validation_1 = __webpack_require__(54);
	var log = __webpack_require__(13);
	var log_1 = __webpack_require__(13);
	var misc_1 = __webpack_require__(14);
	var objUtils = __webpack_require__(27);
	var credentials_1 = __webpack_require__(259);
	var observer_1 = __webpack_require__(261);
	var user_data_converter_1 = __webpack_require__(262);
	// The objects that are a part of this API are exposed to third-parties as
	// compiled javascript so we want to flag our private members with a leading
	// underscore to discourage their use.
	// tslint:disable:strip-private-property-underscore
	var DEFAULT_HOST = 'firestore.googleapis.com';
	var DEFAULT_SSL = true;
	/**
	 * A concrete type describing all the values that can be applied via a
	 * user-supplied firestore.Settings object. This is a separate type so that
	 * defaults can be supplied and the value can be checked for equality.
	 */
	var FirestoreSettings = /** @class */ (function () {
	    function FirestoreSettings(settings) {
	        if (settings.host === undefined) {
	            if (settings.ssl !== undefined) {
	                throw new error_1.FirestoreError(error_1.Code.INVALID_ARGUMENT, "Can't provide ssl option if host option is not set");
	            }
	            this.host = DEFAULT_HOST;
	            this.ssl = DEFAULT_SSL;
	        }
	        else {
	            input_validation_1.validateNamedType('settings', 'string', 'host', settings.host);
	            this.host = settings.host;
	            input_validation_1.validateNamedOptionalType('settings', 'boolean', 'ssl', settings.ssl);
	            this.ssl = objUtils.defaulted(settings.ssl, DEFAULT_SSL);
	        }
	        input_validation_1.validateOptionNames('settings', settings, ['host', 'ssl', 'credentials']);
	        input_validation_1.validateNamedOptionalType('settings', 'object', 'credentials', settings.credentials);
	        this.credentials = settings.credentials;
	    }
	    FirestoreSettings.prototype.isEqual = function (other) {
	        return (this.host === other.host &&
	            this.ssl === other.ssl &&
	            this.credentials === other.credentials);
	    };
	    return FirestoreSettings;
	}());
	var FirestoreConfig = /** @class */ (function () {
	    function FirestoreConfig() {
	    }
	    return FirestoreConfig;
	}());
	/**
	 * The root reference to the database.
	 */
	var Firestore = /** @class */ (function () {
	    function Firestore(databaseIdOrApp) {
	        var _this = this;
	        // Public for use in tests.
	        // TODO(mikelehen): Use modularized initialization instead.
	        this._queue = new async_queue_1.AsyncQueue();
	        this.INTERNAL = {
	            delete: function () {
	                if (_this._firestoreClient) {
	                    return _this._firestoreClient.shutdown();
	                }
	                else {
	                    return Promise.resolve();
	                }
	            }
	        };
	        var config = new FirestoreConfig();
	        if (typeof databaseIdOrApp.options === 'object') {
	            // This is very likely a Firebase app object
	            // TODO(b/34177605): Can we somehow use instanceof?
	            var app = databaseIdOrApp;
	            config.firebaseApp = app;
	            config.databaseId = Firestore.databaseIdFromApp(app);
	            config.persistenceKey = config.firebaseApp.name;
	            config.credentials = new credentials_1.FirebaseCredentialsProvider(app);
	        }
	        else {
	            var external_1 = databaseIdOrApp;
	            if (!external_1.projectId) {
	                throw new error_1.FirestoreError(error_1.Code.INVALID_ARGUMENT, 'Must provide projectId');
	            }
	            config.databaseId = new database_info_1.DatabaseId(external_1.projectId, external_1.database);
	            // Use a default persistenceKey that lines up with FirebaseApp.
	            config.persistenceKey = '[DEFAULT]';
	            config.credentials = new credentials_1.EmptyCredentialsProvider();
	        }
	        config.settings = new FirestoreSettings({});
	        this._config = config;
	        this._databaseId = config.databaseId;
	    }
	    Firestore.prototype.settings = function (settingsLiteral) {
	        input_validation_1.validateExactNumberOfArgs('Firestore.settings', arguments, 1);
	        input_validation_1.validateArgType('Firestore.settings', 'object', 1, settingsLiteral);
	        if (objUtils.contains(settingsLiteral, 'persistence')) {
	            throw new error_1.FirestoreError(error_1.Code.INVALID_ARGUMENT, '"persistence" is now specified with a separate call to ' +
	                'firestore.enablePersistence().');
	        }
	        var newSettings = new FirestoreSettings(settingsLiteral);
	        if (this._firestoreClient && !this._config.settings.isEqual(newSettings)) {
	            throw new error_1.FirestoreError(error_1.Code.FAILED_PRECONDITION, 'Firestore has already been started and its settings can no longer ' +
	                'be changed. You can only call settings() before calling any other ' +
	                'methods on a Firestore object.');
	        }
	        this._config.settings = newSettings;
	        if (newSettings.credentials !== undefined) {
	            this._config.credentials = credentials_1.makeCredentialsProvider(newSettings.credentials);
	        }
	    };
	    Firestore.prototype.enableNetwork = function () {
	        this.ensureClientConfigured();
	        return this._firestoreClient.enableNetwork();
	    };
	    Firestore.prototype.disableNetwork = function () {
	        this.ensureClientConfigured();
	        return this._firestoreClient.disableNetwork();
	    };
	    Firestore.prototype.enablePersistence = function () {
	        if (this._firestoreClient) {
	            throw new error_1.FirestoreError(error_1.Code.FAILED_PRECONDITION, 'Firestore has already been started and persistence can no longer ' +
	                'be enabled. You can only call enablePersistence() before calling ' +
	                'any other methods on a Firestore object.');
	        }
	        return this.configureClient(/* persistence= */ true);
	    };
	    Firestore.prototype.ensureClientConfigured = function () {
	        if (!this._firestoreClient) {
	            this.configureClient(/* persistence= */ false);
	        }
	        return this._firestoreClient;
	    };
	    Firestore.prototype.configureClient = function (persistence) {
	        var _this = this;
	        assert_1.assert(!!this._config.settings.host, 'FirestoreSettings.host cannot be falsey');
	        assert_1.assert(!this._firestoreClient, 'configureClient() called multiple times');
	        var databaseInfo = new database_info_1.DatabaseInfo(this._config.databaseId, this._config.persistenceKey, this._config.settings.host, this._config.settings.ssl);
	        var preConverter = function (value) {
	            if (value instanceof DocumentReference) {
	                var thisDb = _this._config.databaseId;
	                var otherDb = value.firestore._config.databaseId;
	                if (!otherDb.isEqual(thisDb)) {
	                    throw new error_1.FirestoreError(error_1.Code.INVALID_ARGUMENT, 'Document reference is for database ' +
	                        (otherDb.projectId + "/" + otherDb.database + " but should be ") +
	                        ("for database " + thisDb.projectId + "/" + thisDb.database));
	                }
	                return new user_data_converter_1.DocumentKeyReference(_this._config.databaseId, value._key);
	            }
	            else {
	                return value;
	            }
	        };
	        this._dataConverter = new user_data_converter_1.UserDataConverter(preConverter);
	        this._firestoreClient = new firestore_client_1.FirestoreClient(platform_1.PlatformSupport.getPlatform(), databaseInfo, this._config.credentials, this._queue);
	        return this._firestoreClient.start(persistence);
	    };
	    Firestore.databaseIdFromApp = function (app) {
	        var options = app.options;
	        if (!objUtils.contains(options, 'projectId')) {
	            // TODO(b/62673263): We can safely remove the special handling of
	            // 'firestoreId' once alpha testers have upgraded.
	            if (objUtils.contains(options, 'firestoreId')) {
	                throw new error_1.FirestoreError(error_1.Code.INVALID_ARGUMENT, '"firestoreId" is now specified as "projectId" in ' +
	                    'firebase.initializeApp.');
	            }
	            throw new error_1.FirestoreError(error_1.Code.INVALID_ARGUMENT, '"projectId" not provided in firebase.initializeApp.');
	        }
	        if (objUtils.contains(options, 'firestoreOptions')) {
	            // TODO(b/62673263): We can safely remove the special handling of
	            // 'firestoreOptions' once alpha testers have upgraded.
	            throw new error_1.FirestoreError(error_1.Code.INVALID_ARGUMENT, '"firestoreOptions" values are now specified with ' +
	                'Firestore.settings()');
	        }
	        var projectId = options['projectId'];
	        if (!projectId || typeof projectId !== 'string') {
	            throw new error_1.FirestoreError(error_1.Code.INVALID_ARGUMENT, 'projectId must be a string in FirebaseApp.options');
	        }
	        return new database_info_1.DatabaseId(projectId);
	    };
	    Object.defineProperty(Firestore.prototype, "app", {
	        get: function () {
	            if (!this._config.firebaseApp) {
	                throw new error_1.FirestoreError(error_1.Code.FAILED_PRECONDITION, "Firestore was not initialized using the Firebase SDK. 'app' is " +
	                    'not available');
	            }
	            return this._config.firebaseApp;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Firestore.prototype.collection = function (pathString) {
	        input_validation_1.validateExactNumberOfArgs('Firestore.collection', arguments, 1);
	        input_validation_1.validateArgType('Firestore.collection', 'string', 1, pathString);
	        if (!pathString) {
	            throw new error_1.FirestoreError(error_1.Code.INVALID_ARGUMENT, 'Must provide a non-empty collection path to collection()');
	        }
	        this.ensureClientConfigured();
	        return new CollectionReference(path_1.ResourcePath.fromString(pathString), this);
	    };
	    Firestore.prototype.doc = function (pathString) {
	        input_validation_1.validateExactNumberOfArgs('Firestore.doc', arguments, 1);
	        input_validation_1.validateArgType('Firestore.doc', 'string', 1, pathString);
	        if (!pathString) {
	            throw new error_1.FirestoreError(error_1.Code.INVALID_ARGUMENT, 'Must provide a non-empty document path to doc()');
	        }
	        this.ensureClientConfigured();
	        return DocumentReference.forPath(path_1.ResourcePath.fromString(pathString), this);
	    };
	    Firestore.prototype.runTransaction = function (updateFunction) {
	        var _this = this;
	        input_validation_1.validateExactNumberOfArgs('Firestore.runTransaction', arguments, 1);
	        input_validation_1.validateArgType('Firestore.runTransaction', 'function', 1, updateFunction);
	        return this.ensureClientConfigured().transaction(function (transaction) {
	            return updateFunction(new Transaction(_this, transaction));
	        });
	    };
	    Firestore.prototype.batch = function () {
	        this.ensureClientConfigured();
	        return new WriteBatch(this);
	    };
	    Object.defineProperty(Firestore, "logLevel", {
	        get: function () {
	            switch (log.getLogLevel()) {
	                case log_1.LogLevel.DEBUG:
	                    return 'debug';
	                case log_1.LogLevel.ERROR:
	                    return 'error';
	                case log_1.LogLevel.SILENT:
	                    return 'silent';
	                default:
	                    return assert_1.fail('Unknown log level: ' + log.getLogLevel());
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Firestore.setLogLevel = function (level) {
	        input_validation_1.validateExactNumberOfArgs('Firestore.setLogLevel', arguments, 1);
	        input_validation_1.validateArgType('Firestore.setLogLevel', 'string', 1, level);
	        switch (level) {
	            case 'debug':
	                log.setLogLevel(log.LogLevel.DEBUG);
	                break;
	            case 'error':
	                log.setLogLevel(log.LogLevel.ERROR);
	                break;
	            case 'silent':
	                log.setLogLevel(log.LogLevel.SILENT);
	                break;
	            default:
	                throw new error_1.FirestoreError(error_1.Code.INVALID_ARGUMENT, 'Invalid log level: ' + level);
	        }
	    };
	    return Firestore;
	}());
	exports.Firestore = Firestore;
	/**
	 * A reference to a transaction.
	 */
	var Transaction = /** @class */ (function () {
	    function Transaction(_firestore, _transaction) {
	        this._firestore = _firestore;
	        this._transaction = _transaction;
	    }
	    Transaction.prototype.get = function (documentRef) {
	        var _this = this;
	        input_validation_1.validateExactNumberOfArgs('Transaction.get', arguments, 1);
	        var ref = validateReference('Transaction.get', documentRef, this._firestore);
	        return this._transaction
	            .lookup([ref._key])
	            .then(function (docs) {
	            if (!docs || docs.length !== 1) {
	                return assert_1.fail('Mismatch in docs returned from document lookup.');
	            }
	            var doc = docs[0];
	            if (doc instanceof document_1.NoDocument) {
	                return new DocumentSnapshot(_this._firestore, ref._key, null, false);
	            }
	            return new DocumentSnapshot(_this._firestore, ref._key, doc, false);
	        });
	    };
	    Transaction.prototype.set = function (documentRef, value, options) {
	        input_validation_1.validateBetweenNumberOfArgs('Transaction.set', arguments, 2, 3);
	        var ref = validateReference('Transaction.set', documentRef, this._firestore);
	        options = validateSetOptions('Transaction.set', options);
	        var parsed = options.merge
	            ? this._firestore._dataConverter.parseMergeData('Transaction.set', value)
	            : this._firestore._dataConverter.parseSetData('Transaction.set', value);
	        this._transaction.set(ref._key, parsed);
	        return this;
	    };
	    Transaction.prototype.update = function (documentRef, fieldOrUpdateData, value) {
	        var moreFieldsAndValues = [];
	        for (var _i = 3; _i < arguments.length; _i++) {
	            moreFieldsAndValues[_i - 3] = arguments[_i];
	        }
	        var ref;
	        var parsed;
	        if (typeof fieldOrUpdateData === 'string' ||
	            fieldOrUpdateData instanceof field_path_1.FieldPath) {
	            input_validation_1.validateAtLeastNumberOfArgs('Transaction.update', arguments, 3);
	            ref = validateReference('Transaction.update', documentRef, this._firestore);
	            parsed = this._firestore._dataConverter.parseUpdateVarargs('Transaction.update', fieldOrUpdateData, value, moreFieldsAndValues);
	        }
	        else {
	            input_validation_1.validateExactNumberOfArgs('Transaction.update', arguments, 2);
	            ref = validateReference('Transaction.update', documentRef, this._firestore);
	            parsed = this._firestore._dataConverter.parseUpdateData('Transaction.update', fieldOrUpdateData);
	        }
	        this._transaction.update(ref._key, parsed);
	        return this;
	    };
	    Transaction.prototype.delete = function (documentRef) {
	        input_validation_1.validateExactNumberOfArgs('Transaction.delete', arguments, 1);
	        var ref = validateReference('Transaction.delete', documentRef, this._firestore);
	        this._transaction.delete(ref._key);
	        return this;
	    };
	    return Transaction;
	}());
	exports.Transaction = Transaction;
	var WriteBatch = /** @class */ (function () {
	    function WriteBatch(_firestore) {
	        this._firestore = _firestore;
	        this._mutations = [];
	        this._committed = false;
	    }
	    WriteBatch.prototype.set = function (documentRef, value, options) {
	        input_validation_1.validateBetweenNumberOfArgs('WriteBatch.set', arguments, 2, 3);
	        this.verifyNotCommitted();
	        var ref = validateReference('WriteBatch.set', documentRef, this._firestore);
	        options = validateSetOptions('WriteBatch.set', options);
	        var parsed = options.merge
	            ? this._firestore._dataConverter.parseMergeData('WriteBatch.set', value)
	            : this._firestore._dataConverter.parseSetData('WriteBatch.set', value);
	        this._mutations = this._mutations.concat(parsed.toMutations(ref._key, mutation_1.Precondition.NONE));
	        return this;
	    };
	    WriteBatch.prototype.update = function (documentRef, fieldOrUpdateData, value) {
	        var moreFieldsAndValues = [];
	        for (var _i = 3; _i < arguments.length; _i++) {
	            moreFieldsAndValues[_i - 3] = arguments[_i];
	        }
	        this.verifyNotCommitted();
	        var ref;
	        var parsed;
	        if (typeof fieldOrUpdateData === 'string' ||
	            fieldOrUpdateData instanceof field_path_1.FieldPath) {
	            input_validation_1.validateAtLeastNumberOfArgs('WriteBatch.update', arguments, 3);
	            ref = validateReference('WriteBatch.update', documentRef, this._firestore);
	            parsed = this._firestore._dataConverter.parseUpdateVarargs('WriteBatch.update', fieldOrUpdateData, value, moreFieldsAndValues);
	        }
	        else {
	            input_validation_1.validateExactNumberOfArgs('WriteBatch.update', arguments, 2);
	            ref = validateReference('WriteBatch.update', documentRef, this._firestore);
	            parsed = this._firestore._dataConverter.parseUpdateData('WriteBatch.update', fieldOrUpdateData);
	        }
	        this._mutations = this._mutations.concat(parsed.toMutations(ref._key, mutation_1.Precondition.exists(true)));
	        return this;
	    };
	    WriteBatch.prototype.delete = function (documentRef) {
	        input_validation_1.validateExactNumberOfArgs('WriteBatch.delete', arguments, 1);
	        this.verifyNotCommitted();
	        var ref = validateReference('WriteBatch.delete', documentRef, this._firestore);
	        this._mutations = this._mutations.concat(new mutation_1.DeleteMutation(ref._key, mutation_1.Precondition.NONE));
	        return this;
	    };
	    WriteBatch.prototype.commit = function () {
	        this.verifyNotCommitted();
	        this._committed = true;
	        if (this._mutations.length > 0) {
	            return this._firestore.ensureClientConfigured().write(this._mutations);
	        }
	        else {
	            return Promise.resolve();
	        }
	    };
	    WriteBatch.prototype.verifyNotCommitted = function () {
	        if (this._committed) {
	            throw new error_1.FirestoreError(error_1.Code.FAILED_PRECONDITION, 'A write batch can no longer be used after commit() ' +
	                'has been called.');
	        }
	    };
	    return WriteBatch;
	}());
	exports.WriteBatch = WriteBatch;
	/**
	 * A reference to a particular document in a collection in the database.
	 */
	var DocumentReference = /** @class */ (function () {
	    function DocumentReference(_key, firestore) {
	        this._key = _key;
	        this.firestore = firestore;
	        this._firestoreClient = this.firestore.ensureClientConfigured();
	    }
	    DocumentReference.forPath = function (path, firestore) {
	        if (path.length % 2 !== 0) {
	            throw new error_1.FirestoreError(error_1.Code.INVALID_ARGUMENT, 'Invalid document reference. Document ' +
	                'references must have an even number of segments, but ' +
	                (path.canonicalString() + " has " + path.length));
	        }
	        return new DocumentReference(new document_key_1.DocumentKey(path), firestore);
	    };
	    Object.defineProperty(DocumentReference.prototype, "id", {
	        get: function () {
	            return this._key.path.lastSegment();
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(DocumentReference.prototype, "parent", {
	        get: function () {
	            return new CollectionReference(this._key.path.popLast(), this.firestore);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(DocumentReference.prototype, "path", {
	        get: function () {
	            return this._key.path.canonicalString();
	        },
	        enumerable: true,
	        configurable: true
	    });
	    DocumentReference.prototype.collection = function (pathString) {
	        input_validation_1.validateExactNumberOfArgs('DocumentReference.collection', arguments, 1);
	        input_validation_1.validateArgType('DocumentReference.collection', 'string', 1, pathString);
	        if (!pathString) {
	            throw new error_1.FirestoreError(error_1.Code.INVALID_ARGUMENT, 'Must provide a non-empty collection name to collection()');
	        }
	        var path = path_1.ResourcePath.fromString(pathString);
	        return new CollectionReference(this._key.path.child(path), this.firestore);
	    };
	    DocumentReference.prototype.isEqual = function (other) {
	        if (!(other instanceof DocumentReference)) {
	            throw input_validation_1.invalidClassError('isEqual', 'DocumentReference', 1, other);
	        }
	        return this.firestore === other.firestore && this._key.isEqual(other._key);
	    };
	    DocumentReference.prototype.set = function (value, options) {
	        input_validation_1.validateBetweenNumberOfArgs('DocumentReference.set', arguments, 1, 2);
	        options = validateSetOptions('DocumentReference.set', options);
	        var parsed = options.merge
	            ? this.firestore._dataConverter.parseMergeData('DocumentReference.set', value)
	            : this.firestore._dataConverter.parseSetData('DocumentReference.set', value);
	        return this._firestoreClient.write(parsed.toMutations(this._key, mutation_1.Precondition.NONE));
	    };
	    DocumentReference.prototype.update = function (fieldOrUpdateData, value) {
	        var moreFieldsAndValues = [];
	        for (var _i = 2; _i < arguments.length; _i++) {
	            moreFieldsAndValues[_i - 2] = arguments[_i];
	        }
	        var parsed;
	        if (typeof fieldOrUpdateData === 'string' ||
	            fieldOrUpdateData instanceof field_path_1.FieldPath) {
	            input_validation_1.validateAtLeastNumberOfArgs('DocumentReference.update', arguments, 2);
	            parsed = this.firestore._dataConverter.parseUpdateVarargs('DocumentReference.update', fieldOrUpdateData, value, moreFieldsAndValues);
	        }
	        else {
	            input_validation_1.validateExactNumberOfArgs('DocumentReference.update', arguments, 1);
	            parsed = this.firestore._dataConverter.parseUpdateData('DocumentReference.update', fieldOrUpdateData);
	        }
	        return this._firestoreClient.write(parsed.toMutations(this._key, mutation_1.Precondition.exists(true)));
	    };
	    DocumentReference.prototype.delete = function () {
	        input_validation_1.validateExactNumberOfArgs('DocumentReference.delete', arguments, 0);
	        return this._firestoreClient.write([
	            new mutation_1.DeleteMutation(this._key, mutation_1.Precondition.NONE)
	        ]);
	    };
	    DocumentReference.prototype.onSnapshot = function () {
	        var args = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            args[_i] = arguments[_i];
	        }
	        input_validation_1.validateBetweenNumberOfArgs('DocumentReference.onSnapshot', arguments, 1, 4);
	        var options = {
	            includeMetadataChanges: false
	        };
	        var observer;
	        var currArg = 0;
	        if (typeof args[currArg] === 'object' &&
	            !observer_1.isPartialObserver(args[currArg])) {
	            options = args[currArg];
	            input_validation_1.validateOptionNames('DocumentReference.onSnapshot', options, [
	                'includeMetadataChanges'
	            ]);
	            input_validation_1.validateNamedOptionalType('DocumentReference.onSnapshot', 'boolean', 'includeMetadataChanges', options.includeMetadataChanges);
	            currArg++;
	        }
	        var internalOptions = {
	            includeDocumentMetadataChanges: options.includeMetadataChanges,
	            includeQueryMetadataChanges: options.includeMetadataChanges
	        };
	        if (observer_1.isPartialObserver(args[currArg])) {
	            observer = args[currArg];
	        }
	        else {
	            input_validation_1.validateArgType('DocumentReference.onSnapshot', 'function', currArg, args[currArg]);
	            input_validation_1.validateOptionalArgType('DocumentReference.onSnapshot', 'function', currArg + 1, args[currArg + 1]);
	            input_validation_1.validateOptionalArgType('DocumentReference.onSnapshot', 'function', currArg + 2, args[currArg + 2]);
	            observer = {
	                next: args[currArg],
	                error: args[currArg + 1],
	                complete: args[currArg + 2]
	            };
	        }
	        return this.onSnapshotInternal(internalOptions, observer);
	    };
	    DocumentReference.prototype.onSnapshotInternal = function (options, observer) {
	        var _this = this;
	        var errHandler = function (err) {
	            console.error('Uncaught Error in onSnapshot:', err);
	        };
	        if (observer.error) {
	            errHandler = observer.error.bind(observer);
	        }
	        var asyncObserver = new async_observer_1.AsyncObserver({
	            next: function (snapshot) {
	                if (observer.next) {
	                    assert_1.assert(snapshot.docs.size <= 1, 'Too many documents returned on a document query');
	                    var doc = snapshot.docs.get(_this._key);
	                    observer.next(new DocumentSnapshot(_this.firestore, _this._key, doc, snapshot.fromCache));
	                }
	            },
	            error: errHandler
	        });
	        var internalListener = this._firestoreClient.listen(query_1.Query.atPath(this._key.path), asyncObserver, options);
	        return function () {
	            asyncObserver.mute();
	            _this._firestoreClient.unlisten(internalListener);
	        };
	    };
	    DocumentReference.prototype.get = function () {
	        var _this = this;
	        input_validation_1.validateExactNumberOfArgs('DocumentReference.get', arguments, 0);
	        return new Promise(function (resolve, reject) {
	            var unlisten = _this.onSnapshotInternal({
	                includeQueryMetadataChanges: true,
	                includeDocumentMetadataChanges: true,
	                waitForSyncWhenOnline: true
	            }, {
	                next: function (snap) {
	                    // Remove query first before passing event to user to avoid
	                    // user actions affecting the now stale query.
	                    unlisten();
	                    if (!snap.exists && snap.metadata.fromCache) {
	                        // TODO(dimond): If we're online and the document doesn't
	                        // exist then we resolve with a doc.exists set to false. If
	                        // we're offline however, we reject the Promise in this
	                        // case. Two options: 1) Cache the negative response from
	                        // the server so we can deliver that even when you're
	                        // offline 2) Actually reject the Promise in the online case
	                        // if the document doesn't exist.
	                        reject(new error_1.FirestoreError(error_1.Code.ABORTED, 'Failed to get document because the client is ' + 'offline.'));
	                    }
	                    else {
	                        resolve(snap);
	                    }
	                },
	                error: reject
	            });
	        });
	    };
	    return DocumentReference;
	}());
	exports.DocumentReference = DocumentReference;
	var SnapshotMetadata = /** @class */ (function () {
	    function SnapshotMetadata(hasPendingWrites, fromCache) {
	        this.hasPendingWrites = hasPendingWrites;
	        this.fromCache = fromCache;
	    }
	    SnapshotMetadata.prototype.isEqual = function (other) {
	        return (this.hasPendingWrites === other.hasPendingWrites &&
	            this.fromCache === other.fromCache);
	    };
	    return SnapshotMetadata;
	}());
	var DocumentSnapshot = /** @class */ (function () {
	    function DocumentSnapshot(_firestore, _key, _document, _fromCache) {
	        this._firestore = _firestore;
	        this._key = _key;
	        this._document = _document;
	        this._fromCache = _fromCache;
	    }
	    DocumentSnapshot.prototype.data = function (options) {
	        input_validation_1.validateBetweenNumberOfArgs('DocumentSnapshot.data', arguments, 0, 1);
	        options = validateSnapshotOptions('DocumentSnapshot.data', options);
	        return !this._document
	            ? undefined
	            : this.convertObject(this._document.data, field_value_1.FieldValueOptions.fromSnapshotOptions(options));
	    };
	    DocumentSnapshot.prototype.get = function (fieldPath, options) {
	        input_validation_1.validateBetweenNumberOfArgs('DocumentSnapshot.get', arguments, 1, 2);
	        options = validateSnapshotOptions('DocumentSnapshot.get', options);
	        if (this._document) {
	            var value = this._document.data.field(user_data_converter_1.fieldPathFromArgument('DocumentSnapshot.get', fieldPath));
	            if (value !== undefined) {
	                return this.convertValue(value, field_value_1.FieldValueOptions.fromSnapshotOptions(options));
	            }
	        }
	        return undefined;
	    };
	    Object.defineProperty(DocumentSnapshot.prototype, "id", {
	        get: function () {
	            return this._key.path.lastSegment();
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(DocumentSnapshot.prototype, "ref", {
	        get: function () {
	            return new DocumentReference(this._key, this._firestore);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(DocumentSnapshot.prototype, "exists", {
	        get: function () {
	            return this._document !== null;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(DocumentSnapshot.prototype, "metadata", {
	        get: function () {
	            return new SnapshotMetadata(this._document !== null && this._document.hasLocalMutations, this._fromCache);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    DocumentSnapshot.prototype.isEqual = function (other) {
	        if (!(other instanceof DocumentSnapshot)) {
	            throw input_validation_1.invalidClassError('isEqual', 'DocumentSnapshot', 1, other);
	        }
	        return (this._firestore === other._firestore &&
	            this._fromCache === other._fromCache &&
	            this._key.isEqual(other._key) &&
	            (this._document === null
	                ? other._document === null
	                : this._document.isEqual(other._document)));
	    };
	    DocumentSnapshot.prototype.convertObject = function (data, options) {
	        var _this = this;
	        var result = {};
	        data.forEach(function (key, value) {
	            result[key] = _this.convertValue(value, options);
	        });
	        return result;
	    };
	    DocumentSnapshot.prototype.convertValue = function (value, options) {
	        if (value instanceof field_value_1.ObjectValue) {
	            return this.convertObject(value, options);
	        }
	        else if (value instanceof field_value_1.ArrayValue) {
	            return this.convertArray(value, options);
	        }
	        else if (value instanceof field_value_1.RefValue) {
	            var key = value.value(options);
	            var database = this._firestore.ensureClientConfigured().databaseId();
	            if (!value.databaseId.isEqual(database)) {
	                // TODO(b/64130202): Somehow support foreign references.
	                log.error("Document " + this._key.path + " contains a document " +
	                    "reference within a different database (" +
	                    (value.databaseId.projectId + "/" + value.databaseId.database + ") which is not ") +
	                    "supported. It will be treated as a reference in the current " +
	                    ("database (" + database.projectId + "/" + database.database + ") ") +
	                    "instead.");
	            }
	            return new DocumentReference(key, this._firestore);
	        }
	        else {
	            return value.value(options);
	        }
	    };
	    DocumentSnapshot.prototype.convertArray = function (data, options) {
	        var _this = this;
	        return data.internalValue.map(function (value) {
	            return _this.convertValue(value, options);
	        });
	    };
	    return DocumentSnapshot;
	}());
	exports.DocumentSnapshot = DocumentSnapshot;
	var QueryDocumentSnapshot = /** @class */ (function (_super) {
	    __extends(QueryDocumentSnapshot, _super);
	    function QueryDocumentSnapshot(firestore, key, document, fromCache) {
	        return _super.call(this, firestore, key, document, fromCache) || this;
	    }
	    QueryDocumentSnapshot.prototype.data = function (options) {
	        var data = _super.prototype.data.call(this, options);
	        assert_1.assert(typeof data === 'object', 'Document in a QueryDocumentSnapshot should exist');
	        return data;
	    };
	    return QueryDocumentSnapshot;
	}(DocumentSnapshot));
	exports.QueryDocumentSnapshot = QueryDocumentSnapshot;
	var Query = /** @class */ (function () {
	    function Query(_query, firestore) {
	        this._query = _query;
	        this.firestore = firestore;
	    }
	    Query.prototype.where = function (field, opStr, value) {
	        input_validation_1.validateExactNumberOfArgs('Query.where', arguments, 3);
	        input_validation_1.validateArgType('Query.where', 'string', 2, opStr);
	        input_validation_1.validateDefined('Query.where', 3, value);
	        var fieldValue;
	        var fieldPath = user_data_converter_1.fieldPathFromArgument('Query.where', field);
	        if (fieldPath.isKeyField()) {
	            if (typeof value === 'string') {
	                if (value.indexOf('/') !== -1) {
	                    // TODO(dimond): Allow slashes once ancestor queries are supported
	                    throw new error_1.FirestoreError(error_1.Code.INVALID_ARGUMENT, 'Function Query.where() requires its third parameter to be a ' +
	                        'valid document ID if the first parameter is ' +
	                        'FieldPath.documentId(), but it contains a slash.');
	                }
	                if (value === '') {
	                    throw new error_1.FirestoreError(error_1.Code.INVALID_ARGUMENT, 'Function Query.where() requires its third parameter to be a ' +
	                        'valid document ID if the first parameter is ' +
	                        'FieldPath.documentId(), but it was an empty string.');
	                }
	                var path = this._query.path.child(new path_1.ResourcePath([value]));
	                assert_1.assert(path.length % 2 === 0, 'Path should be a document key');
	                fieldValue = new field_value_1.RefValue(this.firestore._databaseId, new document_key_1.DocumentKey(path));
	            }
	            else if (value instanceof DocumentReference) {
	                var ref = value;
	                fieldValue = new field_value_1.RefValue(this.firestore._databaseId, ref._key);
	            }
	            else {
	                throw new error_1.FirestoreError(error_1.Code.INVALID_ARGUMENT, "Function Query.where() requires its third parameter to be a " +
	                    "string or a DocumentReference if the first parameter is " +
	                    "FieldPath.documentId(), but it was: " +
	                    (input_validation_1.valueDescription(value) + "."));
	            }
	        }
	        else {
	            fieldValue = this.firestore._dataConverter.parseQueryValue('Query.where', value);
	        }
	        var filter = query_1.fieldFilter(fieldPath, query_1.RelationOp.fromString(opStr), fieldValue);
	        this.validateNewFilter(filter);
	        return new Query(this._query.addFilter(filter), this.firestore);
	    };
	    Query.prototype.orderBy = function (field, directionStr) {
	        input_validation_1.validateBetweenNumberOfArgs('Query.orderBy', arguments, 1, 2);
	        input_validation_1.validateOptionalArgType('Query.orderBy', 'string', 2, directionStr);
	        var direction;
	        if (directionStr === undefined || directionStr === 'asc') {
	            direction = query_1.Direction.ASCENDING;
	        }
	        else if (directionStr === 'desc') {
	            direction = query_1.Direction.DESCENDING;
	        }
	        else {
	            throw new error_1.FirestoreError(error_1.Code.INVALID_ARGUMENT, "Function Query.orderBy() has unknown direction '" + directionStr + "', " +
	                "expected 'asc' or 'desc'.");
	        }
	        if (this._query.startAt !== null) {
	            throw new error_1.FirestoreError(error_1.Code.INVALID_ARGUMENT, 'Invalid query. You must not call Query.startAt() or ' +
	                'Query.startAfter() before calling Query.orderBy().');
	        }
	        if (this._query.endAt !== null) {
	            throw new error_1.FirestoreError(error_1.Code.INVALID_ARGUMENT, 'Invalid query. You must not call Query.endAt() or ' +
	                'Query.endBefore() before calling Query.orderBy().');
	        }
	        var fieldPath = user_data_converter_1.fieldPathFromArgument('Query.orderBy', field);
	        var orderBy = new query_1.OrderBy(fieldPath, direction);
	        this.validateNewOrderBy(orderBy);
	        return new Query(this._query.addOrderBy(orderBy), this.firestore);
	    };
	    Query.prototype.limit = function (n) {
	        input_validation_1.validateExactNumberOfArgs('Query.limit', arguments, 1);
	        input_validation_1.validateArgType('Query.limit', 'number', 1, n);
	        if (n <= 0) {
	            throw new error_1.FirestoreError(error_1.Code.INVALID_ARGUMENT, "Invalid Query. Query limit (" + n + ") is invalid. Limit must be " +
	                'positive.');
	        }
	        return new Query(this._query.withLimit(n), this.firestore);
	    };
	    Query.prototype.startAt = function (docOrField) {
	        var fields = [];
	        for (var _i = 1; _i < arguments.length; _i++) {
	            fields[_i - 1] = arguments[_i];
	        }
	        input_validation_1.validateAtLeastNumberOfArgs('Query.startAt', arguments, 1);
	        var bound = this.boundFromDocOrFields('Query.startAt', docOrField, fields, 
	        /*before=*/ true);
	        return new Query(this._query.withStartAt(bound), this.firestore);
	    };
	    Query.prototype.startAfter = function (docOrField) {
	        var fields = [];
	        for (var _i = 1; _i < arguments.length; _i++) {
	            fields[_i - 1] = arguments[_i];
	        }
	        input_validation_1.validateAtLeastNumberOfArgs('Query.startAfter', arguments, 1);
	        var bound = this.boundFromDocOrFields('Query.startAfter', docOrField, fields, 
	        /*before=*/ false);
	        return new Query(this._query.withStartAt(bound), this.firestore);
	    };
	    Query.prototype.endBefore = function (docOrField) {
	        var fields = [];
	        for (var _i = 1; _i < arguments.length; _i++) {
	            fields[_i - 1] = arguments[_i];
	        }
	        input_validation_1.validateAtLeastNumberOfArgs('Query.endBefore', arguments, 1);
	        var bound = this.boundFromDocOrFields('Query.endBefore', docOrField, fields, 
	        /*before=*/ true);
	        return new Query(this._query.withEndAt(bound), this.firestore);
	    };
	    Query.prototype.endAt = function (docOrField) {
	        var fields = [];
	        for (var _i = 1; _i < arguments.length; _i++) {
	            fields[_i - 1] = arguments[_i];
	        }
	        input_validation_1.validateAtLeastNumberOfArgs('Query.endAt', arguments, 1);
	        var bound = this.boundFromDocOrFields('Query.endAt', docOrField, fields, 
	        /*before=*/ false);
	        return new Query(this._query.withEndAt(bound), this.firestore);
	    };
	    Query.prototype.isEqual = function (other) {
	        if (!(other instanceof Query)) {
	            throw input_validation_1.invalidClassError('isEqual', 'Query', 1, other);
	        }
	        return (this.firestore === other.firestore && this._query.isEqual(other._query));
	    };
	    /** Helper function to create a bound from a document or fields */
	    Query.prototype.boundFromDocOrFields = function (methodName, docOrField, fields, before) {
	        input_validation_1.validateDefined(methodName, 1, docOrField);
	        if (docOrField instanceof DocumentSnapshot) {
	            if (fields.length > 0) {
	                throw new error_1.FirestoreError(error_1.Code.INVALID_ARGUMENT, "Too many arguments provided to " + methodName + "().");
	            }
	            var snap = docOrField;
	            if (!snap.exists) {
	                throw new error_1.FirestoreError(error_1.Code.NOT_FOUND, "Can't use a DocumentSnapshot that doesn't exist for " +
	                    (methodName + "()."));
	            }
	            return this.boundFromDocument(methodName, snap._document, before);
	        }
	        else {
	            var allFields = [docOrField].concat(fields);
	            return this.boundFromFields(methodName, allFields, before);
	        }
	    };
	    /**
	     * Create a Bound from a query and a document.
	     *
	     * Note that the Bound will always include the key of the document
	     * and so only the provided document will compare equal to the returned
	     * position.
	     *
	     * Will throw if the document does not contain all fields of the order by
	     * of the query.
	     */
	    Query.prototype.boundFromDocument = function (methodName, doc, before) {
	        var components = [];
	        // Because people expect to continue/end a query at the exact document
	        // provided, we need to use the implicit sort order rather than the explicit
	        // sort order, because it's guaranteed to contain the document key. That way
	        // the position becomes unambiguous and the query continues/ends exactly at
	        // the provided document. Without the key (by using the explicit sort
	        // orders), multiple documents could match the position, yielding duplicate
	        // results.
	        for (var _i = 0, _a = this._query.orderBy; _i < _a.length; _i++) {
	            var orderBy = _a[_i];
	            if (orderBy.field.isKeyField()) {
	                components.push(new field_value_1.RefValue(this.firestore._databaseId, doc.key));
	            }
	            else {
	                var value = doc.field(orderBy.field);
	                if (value !== undefined) {
	                    components.push(value);
	                }
	                else {
	                    var field = orderBy.field.canonicalString();
	                    throw new error_1.FirestoreError(error_1.Code.INVALID_ARGUMENT, "Invalid query. You are trying to start or end a query using a " +
	                        ("document for which the field '" + field + "' (used as the ") +
	                        "orderBy) does not exist.");
	                }
	            }
	        }
	        return new query_1.Bound(components, before);
	    };
	    /**
	     * Converts a list of field values to a Bound for the given query.
	     */
	    Query.prototype.boundFromFields = function (methodName, values, before) {
	        // Use explicit order by's because it has to match the query the user made
	        var orderBy = this._query.explicitOrderBy;
	        if (values.length > orderBy.length) {
	            throw new error_1.FirestoreError(error_1.Code.INVALID_ARGUMENT, "Too many arguments provided to " + methodName + "(). " +
	                "The number of arguments must be less than or equal to the " +
	                "number of Query.orderBy() clauses");
	        }
	        var components = [];
	        for (var i = 0; i < values.length; i++) {
	            var rawValue = values[i];
	            var orderByComponent = orderBy[i];
	            if (orderByComponent.field.isKeyField()) {
	                if (typeof rawValue !== 'string') {
	                    throw new error_1.FirestoreError(error_1.Code.INVALID_ARGUMENT, "Invalid query. Expected a string for document ID in " +
	                        (methodName + "(), but got a " + typeof rawValue));
	                }
	                if (rawValue.indexOf('/') !== -1) {
	                    throw new error_1.FirestoreError(error_1.Code.INVALID_ARGUMENT, "Invalid query. Document ID '" + rawValue + "' contains a slash in " +
	                        (methodName + "()"));
	                }
	                var key = new document_key_1.DocumentKey(this._query.path.child(rawValue));
	                components.push(new field_value_1.RefValue(this.firestore._databaseId, key));
	            }
	            else {
	                var wrapped = this.firestore._dataConverter.parseQueryValue(methodName, rawValue);
	                components.push(wrapped);
	            }
	        }
	        return new query_1.Bound(components, before);
	    };
	    Query.prototype.onSnapshot = function () {
	        var args = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            args[_i] = arguments[_i];
	        }
	        input_validation_1.validateBetweenNumberOfArgs('Query.onSnapshot', arguments, 1, 4);
	        var options = {};
	        var observer;
	        var currArg = 0;
	        if (typeof args[currArg] === 'object' &&
	            !observer_1.isPartialObserver(args[currArg])) {
	            options = args[currArg];
	            input_validation_1.validateOptionNames('Query.onSnapshot', options, [
	                'includeQueryMetadataChanges',
	                'includeDocumentMetadataChanges'
	            ]);
	            input_validation_1.validateNamedOptionalType('Query.onSnapshot', 'boolean', 'includeDocumentMetadataChanges', options.includeDocumentMetadataChanges);
	            input_validation_1.validateNamedOptionalType('Query.onSnapshot', 'boolean', 'includeQueryMetadataChanges', options.includeQueryMetadataChanges);
	            currArg++;
	        }
	        if (observer_1.isPartialObserver(args[currArg])) {
	            observer = args[currArg];
	        }
	        else {
	            input_validation_1.validateArgType('Query.onSnapshot', 'function', currArg, args[currArg]);
	            input_validation_1.validateOptionalArgType('Query.onSnapshot', 'function', currArg + 1, args[currArg + 1]);
	            input_validation_1.validateOptionalArgType('Query.onSnapshot', 'function', currArg + 2, args[currArg + 2]);
	            observer = {
	                next: args[currArg],
	                error: args[currArg + 1],
	                complete: args[currArg + 2]
	            };
	        }
	        return this.onSnapshotInternal(options, observer);
	    };
	    Query.prototype.onSnapshotInternal = function (options, observer) {
	        var _this = this;
	        var errHandler = function (err) {
	            console.error('Uncaught Error in onSnapshot:', err);
	        };
	        if (observer.error) {
	            errHandler = observer.error.bind(observer);
	        }
	        var asyncObserver = new async_observer_1.AsyncObserver({
	            next: function (result) {
	                if (observer.next) {
	                    observer.next(new QuerySnapshot(_this.firestore, _this._query, result));
	                }
	            },
	            error: errHandler
	        });
	        var firestoreClient = this.firestore.ensureClientConfigured();
	        var internalListener = firestoreClient.listen(this._query, asyncObserver, options);
	        return function () {
	            asyncObserver.mute();
	            firestoreClient.unlisten(internalListener);
	        };
	    };
	    Query.prototype.get = function () {
	        var _this = this;
	        input_validation_1.validateExactNumberOfArgs('Query.get', arguments, 0);
	        return new Promise(function (resolve, reject) {
	            var unlisten = _this.onSnapshotInternal({
	                includeDocumentMetadataChanges: false,
	                includeQueryMetadataChanges: true,
	                waitForSyncWhenOnline: true
	            }, {
	                next: function (result) {
	                    // Remove query first before passing event to user to avoid
	                    // user actions affecting the now stale query.
	                    unlisten();
	                    resolve(result);
	                },
	                error: reject
	            });
	        });
	    };
	    Query.prototype.validateNewFilter = function (filter) {
	        if (filter instanceof query_1.RelationFilter && filter.isInequality()) {
	            var existingField = this._query.getInequalityFilterField();
	            if (existingField !== null && !existingField.isEqual(filter.field)) {
	                throw new error_1.FirestoreError(error_1.Code.INVALID_ARGUMENT, 'Invalid query. All where filters with an inequality' +
	                    ' (<, <=, >, or >=) must be on the same field. But you have' +
	                    (" inequality filters on '" + existingField.toString() + "'") +
	                    (" and '" + filter.field.toString() + "'"));
	            }
	            var firstOrderByField = this._query.getFirstOrderByField();
	            if (firstOrderByField !== null) {
	                this.validateOrderByAndInequalityMatch(filter.field, firstOrderByField);
	            }
	        }
	    };
	    Query.prototype.validateNewOrderBy = function (orderBy) {
	        if (this._query.getFirstOrderByField() === null) {
	            // This is the first order by. It must match any inequality.
	            var inequalityField = this._query.getInequalityFilterField();
	            if (inequalityField !== null) {
	                this.validateOrderByAndInequalityMatch(inequalityField, orderBy.field);
	            }
	        }
	    };
	    Query.prototype.validateOrderByAndInequalityMatch = function (inequality, orderBy) {
	        if (!orderBy.isEqual(inequality)) {
	            throw new error_1.FirestoreError(error_1.Code.INVALID_ARGUMENT, "Invalid query. You have a where filter with an inequality " +
	                ("(<, <=, >, or >=) on field '" + inequality.toString() + "' ") +
	                ("and so you must also use '" + inequality.toString() + "' ") +
	                "as your first Query.orderBy(), but your first Query.orderBy() " +
	                ("is on field '" + orderBy.toString() + "' instead."));
	        }
	    };
	    return Query;
	}());
	exports.Query = Query;
	var QuerySnapshot = /** @class */ (function () {
	    function QuerySnapshot(_firestore, _originalQuery, _snapshot) {
	        this._firestore = _firestore;
	        this._originalQuery = _originalQuery;
	        this._snapshot = _snapshot;
	        this._cachedChanges = null;
	        this.metadata = new SnapshotMetadata(_snapshot.hasPendingWrites, _snapshot.fromCache);
	    }
	    Object.defineProperty(QuerySnapshot.prototype, "docs", {
	        get: function () {
	            var result = [];
	            this.forEach(function (doc) { return result.push(doc); });
	            return result;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(QuerySnapshot.prototype, "empty", {
	        get: function () {
	            return this._snapshot.docs.isEmpty();
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(QuerySnapshot.prototype, "size", {
	        get: function () {
	            return this._snapshot.docs.size;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    QuerySnapshot.prototype.forEach = function (callback, thisArg) {
	        var _this = this;
	        input_validation_1.validateBetweenNumberOfArgs('QuerySnapshot.forEach', arguments, 1, 2);
	        input_validation_1.validateArgType('QuerySnapshot.forEach', 'function', 1, callback);
	        this._snapshot.docs.forEach(function (doc) {
	            callback.call(thisArg, _this.convertToDocumentImpl(doc));
	        });
	    };
	    Object.defineProperty(QuerySnapshot.prototype, "query", {
	        get: function () {
	            return new Query(this._originalQuery, this._firestore);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(QuerySnapshot.prototype, "docChanges", {
	        get: function () {
	            if (!this._cachedChanges) {
	                this._cachedChanges = changesFromSnapshot(this._firestore, this._snapshot);
	            }
	            return this._cachedChanges;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    /** Check the equality. The call can be very expensive. */
	    QuerySnapshot.prototype.isEqual = function (other) {
	        if (!(other instanceof QuerySnapshot)) {
	            throw input_validation_1.invalidClassError('isEqual', 'QuerySnapshot', 1, other);
	        }
	        return (this._firestore === other._firestore &&
	            this._originalQuery.isEqual(other._originalQuery) &&
	            this._snapshot.isEqual(other._snapshot));
	    };
	    QuerySnapshot.prototype.convertToDocumentImpl = function (doc) {
	        return new QueryDocumentSnapshot(this._firestore, doc.key, doc, this.metadata.fromCache);
	    };
	    return QuerySnapshot;
	}());
	exports.QuerySnapshot = QuerySnapshot;
	var CollectionReference = /** @class */ (function (_super) {
	    __extends(CollectionReference, _super);
	    function CollectionReference(path, firestore) {
	        var _this = _super.call(this, query_1.Query.atPath(path), firestore) || this;
	        if (path.length % 2 !== 1) {
	            throw new error_1.FirestoreError(error_1.Code.INVALID_ARGUMENT, 'Invalid collection reference. Collection ' +
	                'references must have an odd number of segments, but ' +
	                (path.canonicalString() + " has " + path.length));
	        }
	        return _this;
	    }
	    Object.defineProperty(CollectionReference.prototype, "id", {
	        get: function () {
	            return this._query.path.lastSegment();
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(CollectionReference.prototype, "parent", {
	        get: function () {
	            var parentPath = this._query.path.popLast();
	            if (parentPath.isEmpty()) {
	                return null;
	            }
	            else {
	                return new DocumentReference(new document_key_1.DocumentKey(parentPath), this.firestore);
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(CollectionReference.prototype, "path", {
	        get: function () {
	            return this._query.path.canonicalString();
	        },
	        enumerable: true,
	        configurable: true
	    });
	    CollectionReference.prototype.doc = function (pathString) {
	        input_validation_1.validateBetweenNumberOfArgs('CollectionReference.doc', arguments, 0, 1);
	        // We allow omission of 'pathString' but explicitly prohibit passing in both
	        // 'undefined' and 'null'.
	        if (arguments.length === 0) {
	            pathString = misc_1.AutoId.newId();
	        }
	        input_validation_1.validateArgType('CollectionReference.doc', 'string', 1, pathString);
	        if (pathString === '') {
	            throw new error_1.FirestoreError(error_1.Code.INVALID_ARGUMENT, 'Document path must be a non-empty string');
	        }
	        var path = path_1.ResourcePath.fromString(pathString);
	        return DocumentReference.forPath(this._query.path.child(path), this.firestore);
	    };
	    CollectionReference.prototype.add = function (value) {
	        input_validation_1.validateExactNumberOfArgs('CollectionReference.add', arguments, 1);
	        input_validation_1.validateArgType('CollectionReference.add', 'object', 1, value);
	        var docRef = this.doc();
	        return docRef.set(value).then(function () { return docRef; });
	    };
	    return CollectionReference;
	}(Query));
	exports.CollectionReference = CollectionReference;
	function validateSetOptions(methodName, options) {
	    if (options === undefined) {
	        return {
	            merge: false
	        };
	    }
	    input_validation_1.validateOptionNames(methodName, options, ['merge']);
	    input_validation_1.validateNamedOptionalType(methodName, 'boolean', 'merge', options.merge);
	    return options;
	}
	function validateSnapshotOptions(methodName, options) {
	    if (options === undefined) {
	        return {};
	    }
	    input_validation_1.validateOptionNames(methodName, options, ['serverTimestamps']);
	    input_validation_1.validateNamedOptionalPropertyEquals(methodName, 'options', 'serverTimestamps', options.serverTimestamps, ['estimate', 'previous', 'none']);
	    return options;
	}
	function validateReference(methodName, documentRef, firestore) {
	    if (!(documentRef instanceof DocumentReference)) {
	        throw input_validation_1.invalidClassError(methodName, 'DocumentReference', 1, documentRef);
	    }
	    else if (documentRef.firestore !== firestore) {
	        throw new error_1.FirestoreError(error_1.Code.INVALID_ARGUMENT, 'Provided document reference is from a different Firestore instance.');
	    }
	    else {
	        return documentRef;
	    }
	}
	/**
	 * Calculates the array of firestore.DocumentChange's for a given ViewSnapshot.
	 *
	 * Exported for testing.
	 */
	function changesFromSnapshot(firestore, snapshot) {
	    if (snapshot.oldDocs.isEmpty()) {
	        // Special case the first snapshot because index calculation is easy and
	        // fast
	        var lastDoc_1;
	        var index_1 = 0;
	        return snapshot.docChanges.map(function (change) {
	            var doc = new QueryDocumentSnapshot(firestore, change.doc.key, change.doc, snapshot.fromCache);
	            assert_1.assert(change.type === view_snapshot_1.ChangeType.Added, 'Invalid event type for first snapshot');
	            assert_1.assert(!lastDoc_1 || snapshot.query.docComparator(lastDoc_1, change.doc) < 0, 'Got added events in wrong order');
	            lastDoc_1 = change.doc;
	            return {
	                type: 'added',
	                doc: doc,
	                oldIndex: -1,
	                newIndex: index_1++
	            };
	        });
	    }
	    else {
	        // A DocumentSet that is updated incrementally as changes are applied to use
	        // to lookup the index of a document.
	        var indexTracker_1 = snapshot.oldDocs;
	        return snapshot.docChanges.map(function (change) {
	            var doc = new QueryDocumentSnapshot(firestore, change.doc.key, change.doc, snapshot.fromCache);
	            var oldIndex = -1;
	            var newIndex = -1;
	            if (change.type !== view_snapshot_1.ChangeType.Added) {
	                oldIndex = indexTracker_1.indexOf(change.doc.key);
	                assert_1.assert(oldIndex >= 0, 'Index for document not found');
	                indexTracker_1 = indexTracker_1.delete(change.doc.key);
	            }
	            if (change.type !== view_snapshot_1.ChangeType.Removed) {
	                indexTracker_1 = indexTracker_1.add(change.doc);
	                newIndex = indexTracker_1.indexOf(change.doc.key);
	            }
	            return { type: resultChangeType(change.type), doc: doc, oldIndex: oldIndex, newIndex: newIndex };
	        });
	    }
	}
	exports.changesFromSnapshot = changesFromSnapshot;
	function resultChangeType(type) {
	    switch (type) {
	        case view_snapshot_1.ChangeType.Added:
	            return 'added';
	        case view_snapshot_1.ChangeType.Modified:
	        case view_snapshot_1.ChangeType.Metadata:
	            return 'modified';
	        case view_snapshot_1.ChangeType.Removed:
	            return 'removed';
	        default:
	            return assert_1.fail('Unknown change type: ' + type);
	    }
	}
	// Export the classes with a private constructor (it will fail if invoked
	// at runtime). Note that this still allows instanceof checks.
	// We're treating the variables as class names, so disable checking for lower
	// case variable names.
	// tslint:disable:variable-name
	exports.PublicFirestore = api_1.makeConstructorPrivate(Firestore, 'Use firebase.firestore() instead.');
	exports.PublicTransaction = api_1.makeConstructorPrivate(Transaction, 'Use firebase.firestore().runTransaction() instead.');
	exports.PublicWriteBatch = api_1.makeConstructorPrivate(WriteBatch, 'Use firebase.firestore().batch() instead.');
	exports.PublicDocumentReference = api_1.makeConstructorPrivate(DocumentReference, 'Use firebase.firestore().doc() instead.');
	exports.PublicDocumentSnapshot = api_1.makeConstructorPrivate(DocumentSnapshot);
	exports.PublicQueryDocumentSnapshot = api_1.makeConstructorPrivate(QueryDocumentSnapshot);
	exports.PublicQuery = api_1.makeConstructorPrivate(Query);
	exports.PublicQuerySnapshot = api_1.makeConstructorPrivate(QuerySnapshot);
	exports.PublicCollectionReference = api_1.makeConstructorPrivate(CollectionReference, 'Use firebase.firestore().collection() instead.');
	// tslint:enable:variable-name
	
	//# sourceMappingURL=database.js.map


/***/ }),
/* 261 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	function isPartialObserver(obj) {
	    return implementsAnyMethods(obj, ['next', 'error', 'complete']);
	}
	exports.isPartialObserver = isPartialObserver;
	/**
	 * Returns true if obj is an object and contains at least one of the specified
	 * methods.
	 */
	function implementsAnyMethods(obj, methods) {
	    if (typeof obj !== 'object' || obj === null) {
	        return false;
	    }
	    var object = obj;
	    for (var _i = 0, methods_1 = methods; _i < methods_1.length; _i++) {
	        var method = methods_1[_i];
	        if (method in object && typeof object[method] === 'function') {
	            return true;
	        }
	    }
	    return false;
	}
	
	//# sourceMappingURL=observer.js.map


/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var timestamp_1 = __webpack_require__(40);
	var field_value_1 = __webpack_require__(42);
	var field_value_2 = __webpack_require__(42);
	var mutation_1 = __webpack_require__(75);
	var path_1 = __webpack_require__(35);
	var assert_1 = __webpack_require__(2);
	var error_1 = __webpack_require__(10);
	var input_validation_1 = __webpack_require__(54);
	var misc_1 = __webpack_require__(14);
	var objUtils = __webpack_require__(27);
	var sorted_map_1 = __webpack_require__(36);
	var typeUtils = __webpack_require__(55);
	var blob_1 = __webpack_require__(95);
	var field_path_1 = __webpack_require__(96);
	var field_value_3 = __webpack_require__(158);
	var geo_point_1 = __webpack_require__(97);
	var RESERVED_FIELD_REGEX = /^__.*__$/;
	/** The result of parsing document data (e.g. for a setData call). */
	var ParsedSetData = /** @class */ (function () {
	    function ParsedSetData(data, fieldMask, fieldTransforms) {
	        this.data = data;
	        this.fieldMask = fieldMask;
	        this.fieldTransforms = fieldTransforms;
	    }
	    ParsedSetData.prototype.toMutations = function (key, precondition) {
	        var mutations = [];
	        if (this.fieldMask !== null) {
	            mutations.push(new mutation_1.PatchMutation(key, this.data, this.fieldMask, precondition));
	        }
	        else {
	            mutations.push(new mutation_1.SetMutation(key, this.data, precondition));
	        }
	        if (this.fieldTransforms.length > 0) {
	            mutations.push(new mutation_1.TransformMutation(key, this.fieldTransforms));
	        }
	        return mutations;
	    };
	    return ParsedSetData;
	}());
	exports.ParsedSetData = ParsedSetData;
	/** The result of parsing "update" data (i.e. for an updateData call). */
	var ParsedUpdateData = /** @class */ (function () {
	    function ParsedUpdateData(data, fieldMask, fieldTransforms) {
	        this.data = data;
	        this.fieldMask = fieldMask;
	        this.fieldTransforms = fieldTransforms;
	    }
	    ParsedUpdateData.prototype.toMutations = function (key, precondition) {
	        var mutations = [
	            new mutation_1.PatchMutation(key, this.data, this.fieldMask, precondition)
	        ];
	        if (this.fieldTransforms.length > 0) {
	            mutations.push(new mutation_1.TransformMutation(key, this.fieldTransforms));
	        }
	        return mutations;
	    };
	    return ParsedUpdateData;
	}());
	exports.ParsedUpdateData = ParsedUpdateData;
	/*
	 * Represents what type of API method provided the data being parsed; useful
	 * for determining which error conditions apply during parsing and providing
	 * better error messages.
	 */
	var UserDataSource;
	(function (UserDataSource) {
	    UserDataSource[UserDataSource["Set"] = 0] = "Set";
	    UserDataSource[UserDataSource["Update"] = 1] = "Update";
	    UserDataSource[UserDataSource["MergeSet"] = 2] = "MergeSet";
	    UserDataSource[UserDataSource["QueryValue"] = 3] = "QueryValue"; // from a where clause or cursor bound
	})(UserDataSource || (UserDataSource = {}));
	function isWrite(dataSource) {
	    switch (dataSource) {
	        case UserDataSource.Set: // fall through
	        case UserDataSource.MergeSet: // fall through
	        case UserDataSource.Update:
	            return true;
	        case UserDataSource.QueryValue:
	            return false;
	        default:
	            throw assert_1.fail("Unexpected case for UserDataSource: " + dataSource);
	    }
	}
	/** A "context" object passed around while parsing user data. */
	var ParseContext = /** @class */ (function () {
	    /**
	     * Initializes a ParseContext with the given source and path.
	     *
	     * @param dataSource Indicates what kind of API method this data came from.
	     * @param methodName The name of the method the user called to create this
	     *     ParseContext.
	     * @param path A path within the object being parsed. This could be an empty
	     *     path (in which case the context represents the root of the data being
	     *     parsed), or a nonempty path (indicating the context represents a nested
	     *     location within the data).
	     * @param arrayElement Whether or not this context corresponds to an element
	     *     of an array.
	     * @param fieldTransforms A mutable list of field transforms encountered while
	     *     parsing the data.
	     * @param fieldMask A mutable list of field paths encountered while parsing
	     *     the data.
	     *
	     * TODO(b/34871131): We don't support array paths right now, so path can be
	     * null to indicate the context represents any location within an array (in
	     * which case certain features will not work and errors will be somewhat
	     * compromised).
	     */
	    function ParseContext(dataSource, methodName, path, arrayElement, fieldTransforms, fieldMask) {
	        this.dataSource = dataSource;
	        this.methodName = methodName;
	        this.path = path;
	        this.arrayElement = arrayElement;
	        // Minor hack: If fieldTransforms is undefined, we assume this is an
	        // external call and we need to validate the entire path.
	        if (fieldTransforms === undefined) {
	            this.validatePath();
	        }
	        this.arrayElement = arrayElement !== undefined ? arrayElement : false;
	        this.fieldTransforms = fieldTransforms || [];
	        this.fieldMask = fieldMask || [];
	    }
	    ParseContext.prototype.childContextForField = function (field) {
	        var childPath = this.path == null ? null : this.path.child(field);
	        var context = new ParseContext(this.dataSource, this.methodName, childPath, 
	        /*arrayElement=*/ false, this.fieldTransforms, this.fieldMask);
	        context.validatePathSegment(field);
	        return context;
	    };
	    ParseContext.prototype.childContextForFieldPath = function (field) {
	        var childPath = this.path == null ? null : this.path.child(field);
	        var context = new ParseContext(this.dataSource, this.methodName, childPath, 
	        /*arrayElement=*/ false, this.fieldTransforms, this.fieldMask);
	        context.validatePath();
	        return context;
	    };
	    ParseContext.prototype.childContextForArray = function (index) {
	        // TODO(b/34871131): We don't support array paths right now; so make path
	        // null.
	        return new ParseContext(this.dataSource, this.methodName, 
	        /*path=*/ null, 
	        /*arrayElement=*/ true, this.fieldTransforms, this.fieldMask);
	    };
	    ParseContext.prototype.createError = function (reason) {
	        var fieldDescription = this.path === null || this.path.isEmpty()
	            ? ''
	            : " (found in field " + this.path.toString() + ")";
	        return new error_1.FirestoreError(error_1.Code.INVALID_ARGUMENT, "Function " + this.methodName + "() called with invalid data. " +
	            reason +
	            fieldDescription);
	    };
	    ParseContext.prototype.validatePath = function () {
	        // TODO(b/34871131): Remove null check once we have proper paths for fields
	        // within arrays.
	        if (this.path === null) {
	            return;
	        }
	        for (var i = 0; i < this.path.length; i++) {
	            this.validatePathSegment(this.path.get(i));
	        }
	    };
	    ParseContext.prototype.validatePathSegment = function (segment) {
	        if (isWrite(this.dataSource) && RESERVED_FIELD_REGEX.test(segment)) {
	            throw this.createError('Document fields cannot begin and end with __');
	        }
	    };
	    ParseContext.prototype.isWrite = function () {
	        return (this.dataSource === UserDataSource.Set ||
	            this.dataSource === UserDataSource.Update);
	    };
	    return ParseContext;
	}());
	/**
	 * A placeholder object for DocumentReferences in this file, in order to
	 * avoid a circular dependency. See the comments for `DataPreConverter` for
	 * the full context.
	 */
	var DocumentKeyReference = /** @class */ (function () {
	    function DocumentKeyReference(databaseId, key) {
	        this.databaseId = databaseId;
	        this.key = key;
	    }
	    return DocumentKeyReference;
	}());
	exports.DocumentKeyReference = DocumentKeyReference;
	/**
	 * Helper for parsing raw user input (provided via the API) into internal model
	 * classes.
	 */
	var UserDataConverter = /** @class */ (function () {
	    function UserDataConverter(preConverter) {
	        this.preConverter = preConverter;
	    }
	    /** Parse document data from a non-merge set() call. */
	    UserDataConverter.prototype.parseSetData = function (methodName, input) {
	        var context = new ParseContext(UserDataSource.Set, methodName, path_1.FieldPath.EMPTY_PATH);
	        validatePlainObject('Data must be an object, but it was:', context, input);
	        var updateData = this.parseData(input, context);
	        return new ParsedSetData(updateData, 
	        /* fieldMask= */ null, context.fieldTransforms);
	    };
	    /** Parse document data from a set() call with '{merge:true}'. */
	    UserDataConverter.prototype.parseMergeData = function (methodName, input) {
	        var context = new ParseContext(UserDataSource.MergeSet, methodName, path_1.FieldPath.EMPTY_PATH);
	        validatePlainObject('Data must be an object, but it was:', context, input);
	        var updateData = this.parseData(input, context);
	        var fieldMask = new mutation_1.FieldMask(context.fieldMask);
	        return new ParsedSetData(updateData, fieldMask, context.fieldTransforms);
	    };
	    /** Parse update data from an update() call. */
	    UserDataConverter.prototype.parseUpdateData = function (methodName, input) {
	        var _this = this;
	        var context = new ParseContext(UserDataSource.Update, methodName, path_1.FieldPath.EMPTY_PATH);
	        validatePlainObject('Data must be an object, but it was:', context, input);
	        var fieldMaskPaths = [];
	        var updateData = field_value_1.ObjectValue.EMPTY;
	        objUtils.forEach(input, function (key, value) {
	            var path = fieldPathFromDotSeparatedString(methodName, key);
	            var childContext = context.childContextForFieldPath(path);
	            value = _this.runPreConverter(value, childContext);
	            if (value instanceof field_value_3.DeleteFieldValueImpl) {
	                // Add it to the field mask, but don't add anything to updateData.
	                fieldMaskPaths.push(path);
	            }
	            else {
	                var parsedValue = _this.parseData(value, childContext);
	                if (parsedValue != null) {
	                    fieldMaskPaths.push(path);
	                    updateData = updateData.set(path, parsedValue);
	                }
	            }
	        });
	        var mask = new mutation_1.FieldMask(fieldMaskPaths);
	        return new ParsedUpdateData(updateData, mask, context.fieldTransforms);
	    };
	    /** Parse update data from a list of field/value arguments. */
	    UserDataConverter.prototype.parseUpdateVarargs = function (methodName, field, value, moreFieldsAndValues) {
	        var context = new ParseContext(UserDataSource.Update, methodName, path_1.FieldPath.EMPTY_PATH);
	        var keys = [fieldPathFromArgument(methodName, field)];
	        var values = [value];
	        if (moreFieldsAndValues.length % 2 !== 0) {
	            throw new error_1.FirestoreError(error_1.Code.INVALID_ARGUMENT, "Function " + methodName + "() needs to be called with an even number " +
	                'of arguments that alternate between field names and values.');
	        }
	        for (var i = 0; i < moreFieldsAndValues.length; i += 2) {
	            keys.push(fieldPathFromArgument(methodName, moreFieldsAndValues[i]));
	            values.push(moreFieldsAndValues[i + 1]);
	        }
	        var fieldMaskPaths = [];
	        var updateData = field_value_1.ObjectValue.EMPTY;
	        for (var i = 0; i < keys.length; ++i) {
	            var path = keys[i];
	            var childContext = context.childContextForFieldPath(path);
	            var value_1 = this.runPreConverter(values[i], childContext);
	            if (value_1 instanceof field_value_3.DeleteFieldValueImpl) {
	                // Add it to the field mask, but don't add anything to updateData.
	                fieldMaskPaths.push(path);
	            }
	            else {
	                var parsedValue = this.parseData(value_1, childContext);
	                if (parsedValue != null) {
	                    fieldMaskPaths.push(path);
	                    updateData = updateData.set(path, parsedValue);
	                }
	            }
	        }
	        var mask = new mutation_1.FieldMask(fieldMaskPaths);
	        return new ParsedUpdateData(updateData, mask, context.fieldTransforms);
	    };
	    /**
	     * Parse a "query value" (e.g. value in a where filter or a value in a cursor
	     * bound).
	     */
	    UserDataConverter.prototype.parseQueryValue = function (methodName, input) {
	        var context = new ParseContext(UserDataSource.QueryValue, methodName, path_1.FieldPath.EMPTY_PATH);
	        var parsed = this.parseData(input, context);
	        assert_1.assert(parsed != null, 'Parsed data should not be null.');
	        assert_1.assert(context.fieldTransforms.length === 0, 'Field transforms should have been disallowed.');
	        return parsed;
	    };
	    /** Sends data through this.preConverter, handling any thrown errors. */
	    UserDataConverter.prototype.runPreConverter = function (input, context) {
	        try {
	            return this.preConverter(input);
	        }
	        catch (e) {
	            var message = errorMessage(e);
	            throw context.createError(message);
	        }
	    };
	    /**
	     * Internal helper for parsing user data.
	     *
	     * @param input Data to be parsed.
	     * @param context A context object representing the current path being parsed,
	     * the source of the data being parsed, etc.
	     * @return The parsed value, or null if the value was a FieldValue sentinel
	     * that should not be included in the resulting parsed data.
	     */
	    UserDataConverter.prototype.parseData = function (input, context) {
	        input = this.runPreConverter(input, context);
	        if (input instanceof Array) {
	            // TODO(b/34871131): Include the path containing the array in the error
	            // message.
	            if (context.arrayElement) {
	                throw context.createError('Nested arrays are not supported');
	            }
	            // If context.path is null we are already inside an array and we don't
	            // support field mask paths more granular than the top-level array.
	            if (context.path) {
	                context.fieldMask.push(context.path);
	            }
	            return this.parseArray(input, context);
	        }
	        else if (looksLikeJsonObject(input)) {
	            validatePlainObject('Unsupported field value:', context, input);
	            return this.parseObject(input, context);
	        }
	        else {
	            // If context.path is null, we are inside an array and we should have
	            // already added the root of the array to the field mask.
	            if (context.path) {
	                context.fieldMask.push(context.path);
	            }
	            return this.parseScalarValue(input, context);
	        }
	    };
	    UserDataConverter.prototype.parseArray = function (array, context) {
	        var result = [];
	        var entryIndex = 0;
	        for (var _i = 0, array_1 = array; _i < array_1.length; _i++) {
	            var entry = array_1[_i];
	            var parsedEntry = this.parseData(entry, context.childContextForArray(entryIndex));
	            if (parsedEntry == null) {
	                // Just include nulls in the array for fields being replaced with a
	                // sentinel.
	                parsedEntry = field_value_2.NullValue.INSTANCE;
	            }
	            result.push(parsedEntry);
	            entryIndex++;
	        }
	        return new field_value_2.ArrayValue(result);
	    };
	    UserDataConverter.prototype.parseObject = function (obj, context) {
	        var _this = this;
	        var result = new sorted_map_1.SortedMap(misc_1.primitiveComparator);
	        objUtils.forEach(obj, function (key, val) {
	            var parsedValue = _this.parseData(val, context.childContextForField(key));
	            if (parsedValue != null) {
	                result = result.insert(key, parsedValue);
	            }
	        });
	        return new field_value_1.ObjectValue(result);
	    };
	    /**
	     * Helper to parse a scalar value (i.e. not an Object or Array)
	     *
	     * @return The parsed value, or null if the value was a FieldValue sentinel
	     * that should not be included in the resulting parsed data.
	     */
	    UserDataConverter.prototype.parseScalarValue = function (value, context) {
	        if (value === null) {
	            return field_value_2.NullValue.INSTANCE;
	        }
	        else if (typeof value === 'number') {
	            if (typeUtils.isSafeInteger(value)) {
	                return new field_value_2.IntegerValue(value);
	            }
	            else {
	                return new field_value_2.DoubleValue(value);
	            }
	        }
	        else if (typeof value === 'boolean') {
	            return field_value_2.BooleanValue.of(value);
	        }
	        else if (typeof value === 'string') {
	            return new field_value_2.StringValue(value);
	        }
	        else if (value instanceof Date) {
	            return new field_value_2.TimestampValue(timestamp_1.Timestamp.fromDate(value));
	        }
	        else if (value instanceof geo_point_1.GeoPoint) {
	            return new field_value_2.GeoPointValue(value);
	        }
	        else if (value instanceof blob_1.Blob) {
	            return new field_value_2.BlobValue(value);
	        }
	        else if (value instanceof DocumentKeyReference) {
	            return new field_value_2.RefValue(value.databaseId, value.key);
	        }
	        else if (value instanceof field_value_3.FieldValueImpl) {
	            if (value instanceof field_value_3.DeleteFieldValueImpl) {
	                if (context.dataSource === UserDataSource.MergeSet) {
	                    return null;
	                }
	                else if (context.dataSource === UserDataSource.Update) {
	                    assert_1.assert(context.path == null || context.path.length > 0, 'FieldValue.delete() at the top level should have already' +
	                        ' been handled.');
	                    throw context.createError('FieldValue.delete() can only appear at the top level ' +
	                        'of your update data');
	                }
	                else {
	                    // We shouldn't encounter delete sentinels for queries or non-merge set() calls.
	                    throw context.createError('FieldValue.delete() can only be used with update() and set() with {merge:true}');
	                }
	            }
	            else if (value instanceof field_value_3.ServerTimestampFieldValueImpl) {
	                if (!isWrite(context.dataSource)) {
	                    throw context.createError('FieldValue.serverTimestamp() can only be used with set()' +
	                        ' and update()');
	                }
	                if (context.path === null) {
	                    throw context.createError('FieldValue.serverTimestamp() is not currently' +
	                        ' supported inside arrays');
	                }
	                context.fieldTransforms.push(new mutation_1.FieldTransform(context.path, mutation_1.ServerTimestampTransform.instance));
	                // Return null so this value is omitted from the parsed result.
	                return null;
	            }
	            else {
	                return assert_1.fail('Unknown FieldValue type: ' + value);
	            }
	        }
	        else {
	            throw context.createError("Unsupported field value: " + input_validation_1.valueDescription(value));
	        }
	    };
	    return UserDataConverter;
	}());
	exports.UserDataConverter = UserDataConverter;
	/**
	 * Checks whether an object looks like a JSON object that should be converted
	 * into a struct. Normal class/prototype instances are considered to look like
	 * JSON objects since they should be converted to a struct value. Arrays, Dates,
	 * GeoPoints, etc. are not considered to look like JSON objects since they map
	 * to specific FieldValue types other than ObjectValue.
	 */
	function looksLikeJsonObject(input) {
	    return (typeof input === 'object' &&
	        input !== null &&
	        !(input instanceof Array) &&
	        !(input instanceof Date) &&
	        !(input instanceof geo_point_1.GeoPoint) &&
	        !(input instanceof blob_1.Blob) &&
	        !(input instanceof DocumentKeyReference) &&
	        !(input instanceof field_value_3.FieldValueImpl));
	}
	function validatePlainObject(message, context, input) {
	    if (!looksLikeJsonObject(input) || !input_validation_1.isPlainObject(input)) {
	        var description = input_validation_1.valueDescription(input);
	        if (description === 'an object') {
	            // Massage the error if it was an object.
	            throw context.createError(message + ' a custom object');
	        }
	        else {
	            throw context.createError(message + ' ' + description);
	        }
	    }
	}
	/**
	 * Helper that calls fromDotSeparatedString() but wraps any error thrown.
	 */
	function fieldPathFromArgument(methodName, path) {
	    if (path instanceof field_path_1.FieldPath) {
	        return path._internalPath;
	    }
	    else if (typeof path === 'string') {
	        return fieldPathFromDotSeparatedString(methodName, path);
	    }
	    else {
	        var message = 'Field path arguments must be of type string or FieldPath.';
	        throw new error_1.FirestoreError(error_1.Code.INVALID_ARGUMENT, "Function " + methodName + "() called with invalid data. " + message);
	    }
	}
	exports.fieldPathFromArgument = fieldPathFromArgument;
	/**
	 * Wraps fromDotSeparatedString with an error message about the method that
	 * was thrown.
	 * @param methodName The publicly visible method name
	 * @param path The dot-separated string form of a field path which will be split
	 * on dots.
	 */
	function fieldPathFromDotSeparatedString(methodName, path) {
	    try {
	        return field_path_1.fromDotSeparatedString(path)._internalPath;
	    }
	    catch (e) {
	        var message = errorMessage(e);
	        throw new error_1.FirestoreError(error_1.Code.INVALID_ARGUMENT, "Function " + methodName + "() called with invalid data. " + message);
	    }
	}
	/**
	 * Extracts the message from a caught exception, which should be an Error object
	 * though JS doesn't guarantee that.
	 */
	function errorMessage(error) {
	    return error instanceof Error ? error.message : error.toString();
	}
	
	//# sourceMappingURL=user_data_converter.js.map


/***/ }),
/* 263 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Simple wrapper around a nullable UID. Mostly exists to make code more
	 * readable.
	 */
	var User = /** @class */ (function () {
	    function User(uid) {
	        this.uid = uid;
	    }
	    User.prototype.isUnauthenticated = function () {
	        return this.uid == null;
	    };
	    /**
	     * Returns a key representing this user, suitable for inclusion in a
	     * dictionary.
	     */
	    User.prototype.toKey = function () {
	        if (this.isUnauthenticated()) {
	            return 'anonymous-user';
	        }
	        else {
	            return 'uid:' + this.uid;
	        }
	    };
	    User.prototype.isEqual = function (otherUser) {
	        return otherUser.uid === this.uid;
	    };
	    /** A user with a null UID. */
	    User.UNAUTHENTICATED = new User(null);
	    // TODO(mikelehen): Look into getting a proper uid-equivalent for
	    // non-FirebaseAuth providers.
	    User.GOOGLE_CREDENTIALS = new User('google-credentials-uid');
	    User.FIRST_PARTY = new User('first-party-uid');
	    return User;
	}());
	exports.User = User;
	
	//# sourceMappingURL=user.js.map


/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var types_1 = __webpack_require__(99);
	var view_snapshot_1 = __webpack_require__(72);
	var document_set_1 = __webpack_require__(162);
	var assert_1 = __webpack_require__(2);
	var obj_map_1 = __webpack_require__(104);
	/**
	 * Holds the listeners and the last received ViewSnapshot for a query being
	 * tracked by EventManager.
	 */
	var QueryListenersInfo = /** @class */ (function () {
	    function QueryListenersInfo() {
	        this.listeners = [];
	    }
	    return QueryListenersInfo;
	}());
	/**
	 * EventManager is responsible for mapping queries to query event emitters.
	 * It handles "fan-out". -- Identical queries will re-use the same watch on the
	 * backend.
	 */
	var EventManager = /** @class */ (function () {
	    function EventManager(syncEngine) {
	        this.syncEngine = syncEngine;
	        this.queries = new obj_map_1.ObjectMap(function (q) {
	            return q.canonicalId();
	        });
	        this.onlineState = types_1.OnlineState.Unknown;
	        this.syncEngine.subscribe(this.onChange.bind(this), this.onError.bind(this));
	    }
	    EventManager.prototype.listen = function (listener) {
	        var query = listener.query;
	        var firstListen = false;
	        var queryInfo = this.queries.get(query);
	        if (!queryInfo) {
	            firstListen = true;
	            queryInfo = new QueryListenersInfo();
	            this.queries.set(query, queryInfo);
	        }
	        queryInfo.listeners.push(listener);
	        listener.applyOnlineStateChange(this.onlineState);
	        if (queryInfo.viewSnap)
	            listener.onViewSnapshot(queryInfo.viewSnap);
	        if (firstListen) {
	            return this.syncEngine.listen(query).then(function (targetId) {
	                queryInfo.targetId = targetId;
	                return targetId;
	            });
	        }
	        else {
	            return Promise.resolve(queryInfo.targetId);
	        }
	    };
	    EventManager.prototype.unlisten = function (listener) {
	        var query = listener.query;
	        var lastListen = false;
	        var queryInfo = this.queries.get(query);
	        if (queryInfo) {
	            var i = queryInfo.listeners.indexOf(listener);
	            if (i >= 0) {
	                queryInfo.listeners.splice(i, 1);
	                lastListen = queryInfo.listeners.length === 0;
	            }
	        }
	        if (lastListen) {
	            this.queries.delete(query);
	            return this.syncEngine.unlisten(query);
	        }
	        else {
	            return Promise.resolve();
	        }
	    };
	    EventManager.prototype.onChange = function (viewSnaps) {
	        for (var _i = 0, viewSnaps_1 = viewSnaps; _i < viewSnaps_1.length; _i++) {
	            var viewSnap = viewSnaps_1[_i];
	            var query = viewSnap.query;
	            var queryInfo = this.queries.get(query);
	            if (queryInfo) {
	                for (var _a = 0, _b = queryInfo.listeners; _a < _b.length; _a++) {
	                    var listener = _b[_a];
	                    listener.onViewSnapshot(viewSnap);
	                }
	                queryInfo.viewSnap = viewSnap;
	            }
	        }
	    };
	    EventManager.prototype.onError = function (query, error) {
	        var queryInfo = this.queries.get(query);
	        if (queryInfo) {
	            for (var _i = 0, _a = queryInfo.listeners; _i < _a.length; _i++) {
	                var listener = _a[_i];
	                listener.onError(error);
	            }
	        }
	        // Remove all listeners. NOTE: We don't need to call syncEngine.unlisten()
	        // after an error.
	        this.queries.delete(query);
	    };
	    EventManager.prototype.applyOnlineStateChange = function (onlineState) {
	        this.onlineState = onlineState;
	        this.queries.forEach(function (_, queryInfo) {
	            for (var _i = 0, _a = queryInfo.listeners; _i < _a.length; _i++) {
	                var listener = _a[_i];
	                listener.applyOnlineStateChange(onlineState);
	            }
	        });
	    };
	    return EventManager;
	}());
	exports.EventManager = EventManager;
	/**
	 * QueryListener takes a series of internal view snapshots and determines
	 * when to raise the event.
	 *
	 * It uses an Observer to dispatch events.
	 */
	var QueryListener = /** @class */ (function () {
	    function QueryListener(query, queryObserver, options) {
	        this.query = query;
	        this.queryObserver = queryObserver;
	        /**
	         * Initial snapshots (e.g. from cache) may not be propagated to the wrapped
	         * observer. This flag is set to true once we've actually raised an event.
	         */
	        this.raisedInitialEvent = false;
	        this.onlineState = types_1.OnlineState.Unknown;
	        this.options = options || {};
	    }
	    QueryListener.prototype.onViewSnapshot = function (snap) {
	        assert_1.assert(snap.docChanges.length > 0 || snap.syncStateChanged, 'We got a new snapshot with no changes?');
	        if (!this.options.includeDocumentMetadataChanges) {
	            // Remove the metadata only changes.
	            var docChanges = [];
	            for (var _i = 0, _a = snap.docChanges; _i < _a.length; _i++) {
	                var docChange = _a[_i];
	                if (docChange.type !== view_snapshot_1.ChangeType.Metadata) {
	                    docChanges.push(docChange);
	                }
	            }
	            snap = new view_snapshot_1.ViewSnapshot(snap.query, snap.docs, snap.oldDocs, docChanges, snap.fromCache, snap.hasPendingWrites, snap.syncStateChanged);
	        }
	        if (!this.raisedInitialEvent) {
	            if (this.shouldRaiseInitialEvent(snap, this.onlineState)) {
	                this.raiseInitialEvent(snap);
	            }
	        }
	        else if (this.shouldRaiseEvent(snap)) {
	            this.queryObserver.next(snap);
	        }
	        this.snap = snap;
	    };
	    QueryListener.prototype.onError = function (error) {
	        this.queryObserver.error(error);
	    };
	    QueryListener.prototype.applyOnlineStateChange = function (onlineState) {
	        this.onlineState = onlineState;
	        if (this.snap &&
	            !this.raisedInitialEvent &&
	            this.shouldRaiseInitialEvent(this.snap, onlineState)) {
	            this.raiseInitialEvent(this.snap);
	        }
	    };
	    QueryListener.prototype.shouldRaiseInitialEvent = function (snap, onlineState) {
	        assert_1.assert(!this.raisedInitialEvent, 'Determining whether to raise first event but already had first event');
	        // Always raise the first event when we're synced
	        if (!snap.fromCache) {
	            return true;
	        }
	        // NOTE: We consider OnlineState.Unknown as online (it should become Failed
	        // or Online if we wait long enough).
	        var maybeOnline = onlineState !== types_1.OnlineState.Failed;
	        // Don't raise the event if we're online, aren't synced yet (checked
	        // above) and are waiting for a sync.
	        if (this.options.waitForSyncWhenOnline && maybeOnline) {
	            assert_1.assert(snap.fromCache, 'Waiting for sync, but snapshot is not from cache');
	            return false;
	        }
	        // Raise data from cache if we have any documents or we are offline
	        return !snap.docs.isEmpty() || onlineState === types_1.OnlineState.Failed;
	    };
	    QueryListener.prototype.shouldRaiseEvent = function (snap) {
	        // We don't need to handle includeDocumentMetadataChanges here because
	        // the Metadata only changes have already been stripped out if needed.
	        // At this point the only changes we will see are the ones we should
	        // propagate.
	        if (snap.docChanges.length > 0) {
	            return true;
	        }
	        var hasPendingWritesChanged = this.snap && this.snap.hasPendingWrites !== snap.hasPendingWrites;
	        if (snap.syncStateChanged || hasPendingWritesChanged) {
	            return this.options.includeQueryMetadataChanges === true;
	        }
	        // Generally we should have hit one of the cases above, but it's possible
	        // to get here if there were only metadata docChanges and they got
	        // stripped out.
	        return false;
	    };
	    QueryListener.prototype.raiseInitialEvent = function (snap) {
	        assert_1.assert(!this.raisedInitialEvent, 'Trying to raise initial events for second time');
	        snap = new view_snapshot_1.ViewSnapshot(snap.query, snap.docs, document_set_1.DocumentSet.emptySet(snap.docs), QueryListener.getInitialViewChanges(snap), snap.fromCache, snap.hasPendingWrites, true);
	        this.raisedInitialEvent = true;
	        this.queryObserver.next(snap);
	    };
	    /** Returns changes as if all documents in the snap were added. */
	    QueryListener.getInitialViewChanges = function (snap) {
	        var result = [];
	        snap.docs.forEach(function (doc) {
	            result.push({ type: view_snapshot_1.ChangeType.Added, doc: doc });
	        });
	        return result;
	    };
	    return QueryListener;
	}());
	exports.QueryListener = QueryListener;
	
	//# sourceMappingURL=event_manager.js.map


/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var event_manager_1 = __webpack_require__(264);
	var sync_engine_1 = __webpack_require__(266);
	var eager_garbage_collector_1 = __webpack_require__(161);
	var indexeddb_persistence_1 = __webpack_require__(270);
	var local_store_1 = __webpack_require__(275);
	var memory_persistence_1 = __webpack_require__(278);
	var no_op_garbage_collector_1 = __webpack_require__(281);
	var datastore_1 = __webpack_require__(288);
	var remote_store_1 = __webpack_require__(291);
	var serializer_1 = __webpack_require__(163);
	var error_1 = __webpack_require__(10);
	var log_1 = __webpack_require__(13);
	var promise_1 = __webpack_require__(105);
	var LOG_TAG = 'FirestoreClient';
	/**
	 * FirestoreClient is a top-level class that constructs and owns all of the
	 * pieces of the client SDK architecture. It is responsible for creating the
	 * async queue that is shared by all of the other components in the system.
	 */
	var FirestoreClient = /** @class */ (function () {
	    function FirestoreClient(platform, databaseInfo, credentials, 
	        /**
	         * Asynchronous queue responsible for all of our internal processing. When
	         * we get incoming work from the user (via public API) or the network
	         * (incoming GRPC messages), we should always schedule onto this queue.
	         * This ensures all of our work is properly serialized (e.g. we don't
	         * start processing a new operation while the previous one is waiting for
	         * an async I/O to complete).
	         */
	        asyncQueue) {
	        this.platform = platform;
	        this.databaseInfo = databaseInfo;
	        this.credentials = credentials;
	        this.asyncQueue = asyncQueue;
	    }
	    /**
	     * Starts up the FirestoreClient, returning only whether or not enabling
	     * persistence succeeded.
	     *
	     * The intent here is to "do the right thing" as far as users are concerned.
	     * Namely, in cases where offline persistence is requested and possible,
	     * enable it, but otherwise fall back to persistence disabled. For the most
	     * part we expect this to succeed one way or the other so we don't expect our
	     * users to actually wait on the firestore.enablePersistence Promise since
	     * they generally won't care.
	     *
	     * Of course some users actually do care about whether or not persistence
	     * was successfully enabled, so the Promise returned from this method
	     * indicates this outcome.
	     *
	     * This presents a problem though: even before enablePersistence resolves or
	     * rejects, users may have made calls to e.g. firestore.collection() which
	     * means that the FirestoreClient in there will be available and will be
	     * enqueuing actions on the async queue.
	     *
	     * Meanwhile any failure of an operation on the async queue causes it to
	     * panic and reject any further work, on the premise that unhandled errors
	     * are fatal.
	     *
	     * Consequently the fallback is handled internally here in start, and if the
	     * fallback succeeds we signal success to the async queue even though the
	     * start() itself signals failure.
	     *
	     * @param usePersistence Whether or not to attempt to enable persistence.
	     * @returns A deferred result indicating the user-visible result of enabling
	     *     offline persistence. This method will reject this if IndexedDB fails to
	     *     start for any reason. If usePersistence is false this is
	     *     unconditionally resolved.
	     */
	    FirestoreClient.prototype.start = function (usePersistence) {
	        var _this = this;
	        // We defer our initialization until we get the current user from
	        // setUserChangeListener(). We block the async queue until we got the
	        // initial user and the initialization is completed. This will prevent
	        // any scheduled work from happening before initialization is completed.
	        //
	        // If initializationDone resolved then the FirestoreClient is in a usable
	        // state.
	        var initializationDone = new promise_1.Deferred();
	        // If usePersistence is true, certain classes of errors while starting are
	        // recoverable but only by falling back to persistence disabled.
	        //
	        // If there's an error in the first case but not in recovery we cannot
	        // reject the promise blocking the async queue because this will cause the
	        // async queue to panic.
	        var persistenceResult = new promise_1.Deferred();
	        var initialized = false;
	        this.credentials.setUserChangeListener(function (user) {
	            if (!initialized) {
	                initialized = true;
	                _this.initializePersistence(usePersistence, persistenceResult)
	                    .then(function () { return _this.initializeRest(user); })
	                    .then(initializationDone.resolve, initializationDone.reject);
	            }
	            else {
	                _this.asyncQueue.schedule(function () {
	                    return _this.handleUserChange(user);
	                });
	            }
	        });
	        // Block the async queue until initialization is done
	        this.asyncQueue.schedule(function () {
	            return initializationDone.promise;
	        });
	        // Return only the result of enabling persistence. Note that this does not
	        // need to await the completion of initializationDone because the result of
	        // this method should not reflect any other kind of failure to start.
	        return persistenceResult.promise;
	    };
	    /** Enables the network connection and requeues all pending operations. */
	    FirestoreClient.prototype.enableNetwork = function () {
	        var _this = this;
	        return this.asyncQueue.schedule(function () {
	            return _this.remoteStore.enableNetwork();
	        });
	    };
	    /**
	     * Initializes persistent storage, attempting to use IndexedDB if
	     * usePersistence is true or memory-only if false.
	     *
	     * If IndexedDB fails because it's already open in another tab or because the
	     * platform can't possibly support our implementation then this method rejects
	     * the persistenceResult and falls back on memory-only persistence.
	     *
	     * @param usePersistence indicates whether or not to use offline persistence
	     * @param persistenceResult A deferred result indicating the user-visible
	     *     result of enabling offline persistence. This method will reject this if
	     *     IndexedDB fails to start for any reason. If usePersistence is false
	     *     this is unconditionally resolved.
	     * @returns a Promise indicating whether or not initialization should
	     *     continue, i.e. that one of the persistence implementations actually
	     *     succeeded.
	     */
	    FirestoreClient.prototype.initializePersistence = function (usePersistence, persistenceResult) {
	        var _this = this;
	        if (usePersistence) {
	            return this.startIndexedDbPersistence()
	                .then(persistenceResult.resolve)
	                .catch(function (error) {
	                // Regardless of whether or not the retry succeeds, from an user
	                // perspective, offline persistence has failed.
	                persistenceResult.reject(error);
	                // An unknown failure on the first stage shuts everything down.
	                if (!_this.canFallback(error)) {
	                    return Promise.reject(error);
	                }
	                console.warn('Error enabling offline storage. Falling back to' +
	                    ' storage disabled: ' +
	                    error);
	                return _this.startMemoryPersistence();
	            });
	        }
	        else {
	            // When usePersistence == false, enabling offline persistence is defined
	            // to unconditionally succeed. This allows start() to have the same
	            // signature for both cases, despite the fact that the returned promise
	            // is only used in the enablePersistence call.
	            persistenceResult.resolve();
	            return this.startMemoryPersistence();
	        }
	    };
	    FirestoreClient.prototype.canFallback = function (error) {
	        return (error.code === error_1.Code.FAILED_PRECONDITION ||
	            error.code === error_1.Code.UNIMPLEMENTED);
	    };
	    /**
	     * Starts IndexedDB-based persistence.
	     *
	     * @returns A promise indicating success or failure.
	     */
	    FirestoreClient.prototype.startIndexedDbPersistence = function () {
	        // TODO(http://b/33384523): For now we just disable garbage collection
	        // when persistence is enabled.
	        this.garbageCollector = new no_op_garbage_collector_1.NoOpGarbageCollector();
	        var storagePrefix = indexeddb_persistence_1.IndexedDbPersistence.buildStoragePrefix(this.databaseInfo);
	        // Opt to use proto3 JSON in case the platform doesn't support Uint8Array.
	        var serializer = new serializer_1.JsonProtoSerializer(this.databaseInfo.databaseId, {
	            useProto3Json: true
	        });
	        this.persistence = new indexeddb_persistence_1.IndexedDbPersistence(storagePrefix, serializer);
	        return this.persistence.start();
	    };
	    /**
	     * Starts Memory-backed persistence. In practice this cannot fail.
	     *
	     * @returns A promise that will successfully resolve.
	     */
	    FirestoreClient.prototype.startMemoryPersistence = function () {
	        this.garbageCollector = new eager_garbage_collector_1.EagerGarbageCollector();
	        this.persistence = new memory_persistence_1.MemoryPersistence();
	        return this.persistence.start();
	    };
	    /**
	     * Initializes the rest of the FirestoreClient, assuming the initial user
	     * has been obtained from the credential provider and some persistence
	     * implementation is available in this.persistence.
	     */
	    FirestoreClient.prototype.initializeRest = function (user) {
	        var _this = this;
	        return this.platform
	            .loadConnection(this.databaseInfo)
	            .then(function (connection) {
	            _this.localStore = new local_store_1.LocalStore(_this.persistence, user, _this.garbageCollector);
	            var serializer = _this.platform.newSerializer(_this.databaseInfo.databaseId);
	            var datastore = new datastore_1.Datastore(_this.databaseInfo, _this.asyncQueue, connection, _this.credentials, serializer);
	            var onlineStateChangedHandler = function (onlineState) {
	                _this.syncEngine.applyOnlineStateChange(onlineState);
	                _this.eventMgr.applyOnlineStateChange(onlineState);
	            };
	            _this.remoteStore = new remote_store_1.RemoteStore(_this.localStore, datastore, onlineStateChangedHandler);
	            _this.syncEngine = new sync_engine_1.SyncEngine(_this.localStore, _this.remoteStore, user);
	            // Setup wiring between sync engine and remote store
	            _this.remoteStore.syncEngine = _this.syncEngine;
	            _this.eventMgr = new event_manager_1.EventManager(_this.syncEngine);
	            // NOTE: RemoteStore depends on LocalStore (for persisting stream
	            // tokens, refilling mutation queue, etc.) so must be started after
	            // LocalStore.
	            return _this.localStore.start();
	        })
	            .then(function () {
	            return _this.remoteStore.start();
	        });
	    };
	    FirestoreClient.prototype.handleUserChange = function (user) {
	        this.asyncQueue.verifyOperationInProgress();
	        log_1.debug(LOG_TAG, 'User Changed: ' + user.uid);
	        return this.syncEngine.handleUserChange(user);
	    };
	    /** Disables the network connection. Pending operations will not complete. */
	    FirestoreClient.prototype.disableNetwork = function () {
	        var _this = this;
	        return this.asyncQueue.schedule(function () {
	            return _this.remoteStore.disableNetwork();
	        });
	    };
	    FirestoreClient.prototype.shutdown = function () {
	        var _this = this;
	        return this.asyncQueue
	            .schedule(function () {
	            _this.credentials.removeUserChangeListener();
	            return _this.remoteStore.shutdown();
	        })
	            .then(function () {
	            // PORTING NOTE: LocalStore does not need an explicit shutdown on web.
	            return _this.persistence.shutdown();
	        });
	    };
	    FirestoreClient.prototype.listen = function (query, observer, options) {
	        var _this = this;
	        var listener = new event_manager_1.QueryListener(query, observer, options);
	        this.asyncQueue.schedule(function () {
	            return _this.eventMgr.listen(listener);
	        });
	        return listener;
	    };
	    FirestoreClient.prototype.unlisten = function (listener) {
	        var _this = this;
	        this.asyncQueue.schedule(function () {
	            return _this.eventMgr.unlisten(listener);
	        });
	    };
	    FirestoreClient.prototype.write = function (mutations) {
	        var _this = this;
	        var deferred = new promise_1.Deferred();
	        this.asyncQueue.schedule(function () { return _this.syncEngine.write(mutations, deferred); });
	        return deferred.promise;
	    };
	    FirestoreClient.prototype.databaseId = function () {
	        return this.databaseInfo.databaseId;
	    };
	    FirestoreClient.prototype.transaction = function (updateFunction) {
	        var _this = this;
	        // We have to wait for the async queue to be sure syncEngine is initialized.
	        return this.asyncQueue
	            .schedule(function () {
	            return Promise.resolve();
	        })
	            .then(function () {
	            return _this.syncEngine.runTransaction(updateFunction);
	        });
	    };
	    return FirestoreClient;
	}());
	exports.FirestoreClient = FirestoreClient;
	
	//# sourceMappingURL=firestore_client.js.map


/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var eager_garbage_collector_1 = __webpack_require__(161);
	var local_view_changes_1 = __webpack_require__(276);
	var query_data_1 = __webpack_require__(51);
	var reference_set_1 = __webpack_require__(73);
	var document_1 = __webpack_require__(21);
	var document_key_1 = __webpack_require__(12);
	var remote_event_1 = __webpack_require__(53);
	var assert_1 = __webpack_require__(2);
	var log = __webpack_require__(13);
	var misc_1 = __webpack_require__(14);
	var objUtils = __webpack_require__(27);
	var obj_map_1 = __webpack_require__(104);
	var sorted_map_1 = __webpack_require__(36);
	var types_1 = __webpack_require__(55);
	var query_1 = __webpack_require__(98);
	var snapshot_version_1 = __webpack_require__(20);
	var target_id_generator_1 = __webpack_require__(160);
	var view_1 = __webpack_require__(268);
	var LOG_TAG = 'SyncEngine';
	/**
	 * QueryView contains all of the data that SyncEngine needs to keep track of for
	 * a particular query.
	 */
	var QueryView = /** @class */ (function () {
	    function QueryView(
	        /**
	         * The query itself.
	         */
	        query, 
	        /**
	         * The target number created by the client that is used in the watch
	         * stream to identify this query.
	         */
	        targetId, 
	        /**
	         * An identifier from the datastore backend that indicates the last state
	         * of the results that was received. This can be used to indicate where
	         * to continue receiving new doc changes for the query.
	         */
	        resumeToken, 
	        /**
	         * The view is responsible for computing the final merged truth of what
	         * docs are in the query. It gets notified of local and remote changes,
	         * and applies the query filters and limits to determine the most correct
	         * possible results.
	         */
	        view) {
	        this.query = query;
	        this.targetId = targetId;
	        this.resumeToken = resumeToken;
	        this.view = view;
	    }
	    return QueryView;
	}());
	/**
	 * SyncEngine is the central controller in the client SDK architecture. It is
	 * the glue code between the EventManager, LocalStore, and RemoteStore. Some of
	 * SyncEngine's responsibilities include:
	 * 1. Coordinating client requests and remote events between the EventManager
	 *    and the local and remote data stores.
	 * 2. Managing a View object for each query, providing the unified view between
	 *    the local and remote data stores.
	 * 3. Notifying the RemoteStore when the LocalStore has new mutations in its
	 *    queue that need sending to the backend.
	 *
	 * The SyncEngine’s methods should only ever be called by methods running in the
	 * global async queue.
	 */
	var SyncEngine = /** @class */ (function () {
	    function SyncEngine(localStore, remoteStore, currentUser) {
	        this.localStore = localStore;
	        this.remoteStore = remoteStore;
	        this.currentUser = currentUser;
	        this.viewHandler = null;
	        this.errorHandler = null;
	        this.queryViewsByQuery = new obj_map_1.ObjectMap(function (q) {
	            return q.canonicalId();
	        });
	        this.queryViewsByTarget = {};
	        this.limboTargetsByKey = new sorted_map_1.SortedMap(document_key_1.DocumentKey.comparator);
	        this.limboKeysByTarget = {};
	        this.limboDocumentRefs = new reference_set_1.ReferenceSet();
	        this.limboCollector = new eager_garbage_collector_1.EagerGarbageCollector();
	        /** Stores user completion handlers, indexed by User and BatchId. */
	        this.mutationUserCallbacks = {};
	        this.targetIdGenerator = target_id_generator_1.TargetIdGenerator.forSyncEngine();
	    }
	    /** Subscribes view and error handler. Can be called only once. */
	    SyncEngine.prototype.subscribe = function (viewHandler, errorHandler) {
	        assert_1.assert(viewHandler !== null && errorHandler !== null, 'View and error handlers cannot be null');
	        assert_1.assert(this.viewHandler === null && this.errorHandler === null, 'SyncEngine already has a subscriber.');
	        this.viewHandler = viewHandler;
	        this.errorHandler = errorHandler;
	        this.limboCollector.addGarbageSource(this.limboDocumentRefs);
	    };
	    /**
	     * Initiates the new listen, resolves promise when listen enqueued to the
	     * server. All the subsequent view snapshots or errors are sent to the
	     * subscribed handlers. Returns the targetId of the query.
	     */
	    SyncEngine.prototype.listen = function (query) {
	        var _this = this;
	        this.assertSubscribed('listen()');
	        assert_1.assert(!this.queryViewsByQuery.has(query), 'We already listen to the query: ' + query);
	        return this.localStore.allocateQuery(query).then(function (queryData) {
	            return _this.localStore
	                .executeQuery(query)
	                .then(function (docs) {
	                return _this.localStore
	                    .remoteDocumentKeys(queryData.targetId)
	                    .then(function (remoteKeys) {
	                    var view = new view_1.View(query, remoteKeys);
	                    var viewDocChanges = view.computeDocChanges(docs);
	                    var viewChange = view.applyChanges(viewDocChanges);
	                    assert_1.assert(viewChange.limboChanges.length === 0, 'View returned limbo docs before target ack from the server.');
	                    assert_1.assert(!!viewChange.snapshot, 'applyChanges for new view should always return a snapshot');
	                    var data = new QueryView(query, queryData.targetId, queryData.resumeToken, view);
	                    _this.queryViewsByQuery.set(query, data);
	                    _this.queryViewsByTarget[queryData.targetId] = data;
	                    _this.viewHandler([viewChange.snapshot]);
	                    _this.remoteStore.listen(queryData);
	                });
	            })
	                .then(function () {
	                return queryData.targetId;
	            });
	        });
	    };
	    /** Stops listening to the query. */
	    SyncEngine.prototype.unlisten = function (query) {
	        var _this = this;
	        this.assertSubscribed('unlisten()');
	        var queryView = this.queryViewsByQuery.get(query);
	        assert_1.assert(!!queryView, 'Trying to unlisten on query not found:' + query);
	        return this.localStore.releaseQuery(query).then(function () {
	            _this.remoteStore.unlisten(queryView.targetId);
	            return _this.removeAndCleanupQuery(queryView).then(function () {
	                return _this.localStore.collectGarbage();
	            });
	        });
	    };
	    /**
	     * Initiates the write of local mutation batch which involves adding the
	     * writes to the mutation queue, notifying the remote store about new
	     * mutations and raising events for any changes this write caused.
	     *
	     * The promise returned by this call is resolved when the above steps
	     * have completed, *not* when the write was acked by the backend. The
	     * userCallback is resolved once the write was acked/rejected by the
	     * backend (or failed locally for any other reason).
	     */
	    SyncEngine.prototype.write = function (batch, userCallback) {
	        var _this = this;
	        this.assertSubscribed('write()');
	        return this.localStore
	            .localWrite(batch)
	            .then(function (result) {
	            _this.addMutationCallback(result.batchId, userCallback);
	            return _this.emitNewSnapsAndNotifyLocalStore(result.changes);
	        })
	            .then(function () {
	            return _this.remoteStore.fillWritePipeline();
	        });
	    };
	    // TODO(klimt): Wrap the given error in a standard Firestore error object.
	    SyncEngine.prototype.wrapUpdateFunctionError = function (error) {
	        return error;
	    };
	    /**
	     * Takes an updateFunction in which a set of reads and writes can be performed
	     * atomically. In the updateFunction, the client can read and write values
	     * using the supplied transaction object. After the updateFunction, all
	     * changes will be committed. If some other client has changed any of the data
	     * referenced, then the updateFunction will be called again. If the
	     * updateFunction still fails after the given number of retries, then the
	     * transaction will be rejection.
	     *
	     * The transaction object passed to the updateFunction contains methods for
	     * accessing documents and collections. Unlike other datastore access, data
	     * accessed with the transaction will not reflect local changes that have not
	     * been committed. For this reason, it is required that all reads are
	     * performed before any writes. Transactions must be performed while online.
	     *
	     * The promise returned is resolved when the transaction is fully committed.
	     */
	    SyncEngine.prototype.runTransaction = function (updateFunction, retries) {
	        var _this = this;
	        if (retries === void 0) { retries = 5; }
	        assert_1.assert(retries >= 0, 'Got negative number of retries for transaction.');
	        var transaction = this.remoteStore.createTransaction();
	        var wrappedUpdateFunction = function () {
	            try {
	                var userPromise = updateFunction(transaction);
	                if (types_1.isNullOrUndefined(userPromise) ||
	                    !userPromise.catch ||
	                    !userPromise.then) {
	                    return Promise.reject(Error('Transaction callback must return a Promise'));
	                }
	                return userPromise.catch(function (e) {
	                    return Promise.reject(_this.wrapUpdateFunctionError(e));
	                });
	            }
	            catch (e) {
	                return Promise.reject(_this.wrapUpdateFunctionError(e));
	            }
	        };
	        return wrappedUpdateFunction().then(function (result) {
	            return transaction
	                .commit()
	                .then(function () {
	                return result;
	            })
	                .catch(function (error) {
	                if (retries === 0) {
	                    return Promise.reject(error);
	                }
	                // TODO(klimt): Put in a retry delay?
	                return _this.runTransaction(updateFunction, retries - 1);
	            });
	        });
	    };
	    SyncEngine.prototype.applyRemoteEvent = function (remoteEvent) {
	        var _this = this;
	        this.assertSubscribed('applyRemoteEvent()');
	        // Make sure limbo documents are deleted if there were no results
	        objUtils.forEachNumber(remoteEvent.targetChanges, function (targetId, targetChange) {
	            var limboKey = _this.limboKeysByTarget[targetId];
	            if (limboKey &&
	                targetChange.currentStatusUpdate ===
	                    remote_event_1.CurrentStatusUpdate.MarkCurrent &&
	                !remoteEvent.documentUpdates.get(limboKey)) {
	                // When listening to a query the server responds with a snapshot
	                // containing documents matching the query and a current marker
	                // telling us we're now in sync. It's possible for these to arrive
	                // as separate remote events or as a single remote event.
	                // For a document query, there will be no documents sent in the
	                // response if the document doesn't exist.
	                //
	                // If the snapshot arrives separately from the current marker,
	                // we handle it normally and updateTrackedLimbos will resolve the
	                // limbo status of the document, removing it from limboDocumentRefs.
	                // This works because clients only initiate limbo resolution when
	                // a target is current and because all current targets are
	                // always at a consistent snapshot.
	                //
	                // However, if the document doesn't exist and the current marker
	                // arrives, the document is not present in the snapshot and our
	                // normal view handling would consider the document to remain in
	                // limbo indefinitely because there are no updates to the document.
	                // To avoid this, we specially handle this just this case here:
	                // synthesizing a delete.
	                //
	                // TODO(dimond): Ideally we would have an explicit lookup query
	                // instead resulting in an explicit delete message and we could
	                // remove this special logic.
	                remoteEvent.addDocumentUpdate(new document_1.NoDocument(limboKey, remoteEvent.snapshotVersion));
	            }
	        });
	        return this.localStore.applyRemoteEvent(remoteEvent).then(function (changes) {
	            return _this.emitNewSnapsAndNotifyLocalStore(changes, remoteEvent);
	        });
	    };
	    /**
	     * Applies an OnlineState change to the sync engine and notifies any views of
	     * the change.
	     */
	    SyncEngine.prototype.applyOnlineStateChange = function (onlineState) {
	        var newViewSnapshots = [];
	        this.queryViewsByQuery.forEach(function (query, queryView) {
	            var viewChange = queryView.view.applyOnlineStateChange(onlineState);
	            assert_1.assert(viewChange.limboChanges.length === 0, 'OnlineState should not affect limbo documents.');
	            if (viewChange.snapshot) {
	                newViewSnapshots.push(viewChange.snapshot);
	            }
	        });
	        this.viewHandler(newViewSnapshots);
	    };
	    SyncEngine.prototype.rejectListen = function (targetId, err) {
	        var _this = this;
	        this.assertSubscribed('rejectListens()');
	        var limboKey = this.limboKeysByTarget[targetId];
	        if (limboKey) {
	            // Since this query failed, we won't want to manually unlisten to it.
	            // So go ahead and remove it from bookkeeping.
	            this.limboTargetsByKey = this.limboTargetsByKey.remove(limboKey);
	            delete this.limboKeysByTarget[targetId];
	            // TODO(klimt): We really only should do the following on permission
	            // denied errors, but we don't have the cause code here.
	            // It's a limbo doc. Create a synthetic event saying it was deleted.
	            // This is kind of a hack. Ideally, we would have a method in the local
	            // store to purge a document. However, it would be tricky to keep all of
	            // the local store's invariants with another method.
	            var docMap = new sorted_map_1.SortedMap(document_key_1.DocumentKey.comparator);
	            docMap = docMap.insert(limboKey, new document_1.NoDocument(limboKey, snapshot_version_1.SnapshotVersion.forDeletedDoc()));
	            var event_1 = new remote_event_1.RemoteEvent(snapshot_version_1.SnapshotVersion.MIN, {}, docMap);
	            return this.applyRemoteEvent(event_1);
	        }
	        else {
	            var queryView_1 = this.queryViewsByTarget[targetId];
	            assert_1.assert(!!queryView_1, 'Unknown targetId: ' + targetId);
	            return this.localStore.releaseQuery(queryView_1.query).then(function () {
	                return _this.removeAndCleanupQuery(queryView_1).then(function () {
	                    _this.errorHandler(queryView_1.query, err);
	                });
	            });
	        }
	    };
	    SyncEngine.prototype.applySuccessfulWrite = function (mutationBatchResult) {
	        var _this = this;
	        this.assertSubscribed('applySuccessfulWrite()');
	        // The local store may or may not be able to apply the write result and
	        // raise events immediately (depending on whether the watcher is caught
	        // up), so we raise user callbacks first so that they consistently happen
	        // before listen events.
	        this.processUserCallback(mutationBatchResult.batch.batchId, 
	        /*error=*/ null);
	        return this.localStore
	            .acknowledgeBatch(mutationBatchResult)
	            .then(function (changes) {
	            return _this.emitNewSnapsAndNotifyLocalStore(changes);
	        });
	    };
	    SyncEngine.prototype.rejectFailedWrite = function (batchId, error) {
	        var _this = this;
	        this.assertSubscribed('rejectFailedWrite()');
	        // The local store may or may not be able to apply the write result and
	        // raise events immediately (depending on whether the watcher is caught up),
	        // so we raise user callbacks first so that they consistently happen before
	        // listen events.
	        this.processUserCallback(batchId, error);
	        return this.localStore.rejectBatch(batchId).then(function (changes) {
	            return _this.emitNewSnapsAndNotifyLocalStore(changes);
	        });
	    };
	    SyncEngine.prototype.addMutationCallback = function (batchId, callback) {
	        var newCallbacks = this.mutationUserCallbacks[this.currentUser.toKey()];
	        if (!newCallbacks) {
	            newCallbacks = new sorted_map_1.SortedMap(misc_1.primitiveComparator);
	        }
	        newCallbacks = newCallbacks.insert(batchId, callback);
	        this.mutationUserCallbacks[this.currentUser.toKey()] = newCallbacks;
	    };
	    /**
	     * Resolves or rejects the user callback for the given batch and then discards
	     * it.
	     */
	    SyncEngine.prototype.processUserCallback = function (batchId, error) {
	        var newCallbacks = this.mutationUserCallbacks[this.currentUser.toKey()];
	        // NOTE: Mutations restored from persistence won't have callbacks, so it's
	        // okay for there to be no callback for this ID.
	        if (newCallbacks) {
	            var callback = newCallbacks.get(batchId);
	            if (callback) {
	                assert_1.assert(batchId === newCallbacks.minKey(), 'Mutation callbacks processed out-of-order?');
	                if (error) {
	                    callback.reject(error);
	                }
	                else {
	                    callback.resolve();
	                }
	                newCallbacks = newCallbacks.remove(batchId);
	            }
	            this.mutationUserCallbacks[this.currentUser.toKey()] = newCallbacks;
	        }
	    };
	    SyncEngine.prototype.removeAndCleanupQuery = function (queryView) {
	        this.queryViewsByQuery.delete(queryView.query);
	        delete this.queryViewsByTarget[queryView.targetId];
	        this.limboDocumentRefs.removeReferencesForId(queryView.targetId);
	        return this.gcLimboDocuments();
	    };
	    SyncEngine.prototype.updateTrackedLimbos = function (targetId, limboChanges) {
	        for (var _i = 0, limboChanges_1 = limboChanges; _i < limboChanges_1.length; _i++) {
	            var limboChange = limboChanges_1[_i];
	            if (limboChange instanceof view_1.AddedLimboDocument) {
	                this.limboDocumentRefs.addReference(limboChange.key, targetId);
	                this.trackLimboChange(limboChange);
	            }
	            else if (limboChange instanceof view_1.RemovedLimboDocument) {
	                log.debug(LOG_TAG, 'Document no longer in limbo: ' + limboChange.key);
	                this.limboDocumentRefs.removeReference(limboChange.key, targetId);
	            }
	            else {
	                assert_1.fail('Unknown limbo change: ' + JSON.stringify(limboChange));
	            }
	        }
	        return this.gcLimboDocuments();
	    };
	    SyncEngine.prototype.trackLimboChange = function (limboChange) {
	        var key = limboChange.key;
	        if (!this.limboTargetsByKey.get(key)) {
	            log.debug(LOG_TAG, 'New document in limbo: ' + key);
	            var limboTargetId = this.targetIdGenerator.next();
	            var query = query_1.Query.atPath(key.path);
	            this.limboKeysByTarget[limboTargetId] = key;
	            this.remoteStore.listen(new query_data_1.QueryData(query, limboTargetId, query_data_1.QueryPurpose.Listen));
	            this.limboTargetsByKey = this.limboTargetsByKey.insert(key, limboTargetId);
	        }
	    };
	    SyncEngine.prototype.gcLimboDocuments = function () {
	        var _this = this;
	        // HACK: We can use a null transaction here, because we know that the
	        // reference set is entirely within memory and doesn't need a store engine.
	        return this.limboCollector
	            .collectGarbage(null)
	            .next(function (keys) {
	            keys.forEach(function (key) {
	                var limboTargetId = _this.limboTargetsByKey.get(key);
	                if (limboTargetId === null) {
	                    // This target already got removed, because the query failed.
	                    return;
	                }
	                _this.remoteStore.unlisten(limboTargetId);
	                _this.limboTargetsByKey = _this.limboTargetsByKey.remove(key);
	                delete _this.limboKeysByTarget[limboTargetId];
	            });
	        })
	            .toPromise();
	    };
	    // Visible for testing
	    SyncEngine.prototype.currentLimboDocs = function () {
	        return this.limboTargetsByKey;
	    };
	    SyncEngine.prototype.emitNewSnapsAndNotifyLocalStore = function (changes, remoteEvent) {
	        var _this = this;
	        var newSnaps = [];
	        var docChangesInAllViews = [];
	        var queriesProcessed = [];
	        this.queryViewsByQuery.forEach(function (_, queryView) {
	            queriesProcessed.push(Promise.resolve()
	                .then(function () {
	                var viewDocChanges = queryView.view.computeDocChanges(changes);
	                if (!viewDocChanges.needsRefill) {
	                    return viewDocChanges;
	                }
	                // The query has a limit and some docs were removed, so we need
	                // to re-run the query against the local store to make sure we
	                // didn't lose any good docs that had been past the limit.
	                return _this.localStore.executeQuery(queryView.query).then(function (docs) {
	                    return queryView.view.computeDocChanges(docs, viewDocChanges);
	                });
	            })
	                .then(function (viewDocChanges) {
	                var targetChange = remoteEvent && remoteEvent.targetChanges[queryView.targetId];
	                var viewChange = queryView.view.applyChanges(viewDocChanges, targetChange);
	                return _this.updateTrackedLimbos(queryView.targetId, viewChange.limboChanges).then(function () {
	                    if (viewChange.snapshot) {
	                        newSnaps.push(viewChange.snapshot);
	                        var docChanges = local_view_changes_1.LocalViewChanges.fromSnapshot(viewChange.snapshot);
	                        docChangesInAllViews.push(docChanges);
	                    }
	                });
	            }));
	        });
	        return Promise.all(queriesProcessed)
	            .then(function () {
	            _this.viewHandler(newSnaps);
	            return _this.localStore.notifyLocalViewChanges(docChangesInAllViews);
	        })
	            .then(function () {
	            return _this.localStore.collectGarbage();
	        });
	    };
	    SyncEngine.prototype.assertSubscribed = function (fnName) {
	        assert_1.assert(this.viewHandler !== null && this.errorHandler !== null, 'Trying to call ' + fnName + ' before calling subscribe().');
	    };
	    SyncEngine.prototype.handleUserChange = function (user) {
	        var _this = this;
	        this.currentUser = user;
	        return this.localStore
	            .handleUserChange(user)
	            .then(function (changes) {
	            return _this.emitNewSnapsAndNotifyLocalStore(changes);
	        })
	            .then(function () {
	            return _this.remoteStore.handleUserChange(user);
	        });
	    };
	    return SyncEngine;
	}());
	exports.SyncEngine = SyncEngine;
	
	//# sourceMappingURL=sync_engine.js.map


/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var snapshot_version_1 = __webpack_require__(20);
	var collections_1 = __webpack_require__(11);
	var document_1 = __webpack_require__(21);
	var mutation_1 = __webpack_require__(75);
	var error_1 = __webpack_require__(10);
	/**
	 * Internal transaction object responsible for accumulating the mutations to
	 * perform and the base versions for any documents read.
	 */
	var Transaction = /** @class */ (function () {
	    function Transaction(datastore) {
	        this.datastore = datastore;
	        // The version of each document that was read during this transaction.
	        this.readVersions = collections_1.documentVersionMap();
	        this.mutations = [];
	        this.committed = false;
	    }
	    Transaction.prototype.recordVersion = function (doc) {
	        var docVersion = doc.version;
	        if (doc instanceof document_1.NoDocument) {
	            // For deleted docs, we must use baseVersion 0 when we overwrite them.
	            docVersion = snapshot_version_1.SnapshotVersion.forDeletedDoc();
	        }
	        var existingVersion = this.readVersions.get(doc.key);
	        if (existingVersion !== null) {
	            if (!docVersion.isEqual(existingVersion)) {
	                // This transaction will fail no matter what.
	                throw new error_1.FirestoreError(error_1.Code.ABORTED, 'Document version changed between two reads.');
	            }
	        }
	        else {
	            this.readVersions = this.readVersions.insert(doc.key, docVersion);
	        }
	    };
	    Transaction.prototype.lookup = function (keys) {
	        var _this = this;
	        if (this.committed) {
	            return Promise.reject('Transaction has already completed.');
	        }
	        if (this.mutations.length > 0) {
	            return Promise.reject('Transactions lookups are invalid after writes.');
	        }
	        return this.datastore.lookup(keys).then(function (docs) {
	            docs.forEach(function (doc) { return _this.recordVersion(doc); });
	            return docs;
	        });
	    };
	    Transaction.prototype.write = function (mutations) {
	        if (this.committed) {
	            throw new error_1.FirestoreError(error_1.Code.FAILED_PRECONDITION, 'Transaction has already completed.');
	        }
	        this.mutations = this.mutations.concat(mutations);
	    };
	    /**
	     * Returns the version of this document when it was read in this transaction,
	     * as a precondition, or no precondition if it was not read.
	     */
	    Transaction.prototype.precondition = function (key) {
	        var version = this.readVersions.get(key);
	        if (version) {
	            return mutation_1.Precondition.updateTime(version);
	        }
	        else {
	            return mutation_1.Precondition.NONE;
	        }
	    };
	    /**
	     * Returns the precondition for a document if the operation is an update.
	     */
	    Transaction.prototype.preconditionForUpdate = function (key) {
	        var version = this.readVersions.get(key);
	        if (version && version.isEqual(snapshot_version_1.SnapshotVersion.forDeletedDoc())) {
	            // The document doesn't exist, so fail the transaction.
	            throw new error_1.FirestoreError(error_1.Code.FAILED_PRECONDITION, "Can't update a document that doesn't exist.");
	        }
	        else if (version) {
	            // Document exists, base precondition on document update time.
	            return mutation_1.Precondition.updateTime(version);
	        }
	        else {
	            // Document was not read, so we just use the preconditions for a blind
	            // update.
	            return mutation_1.Precondition.exists(true);
	        }
	    };
	    Transaction.prototype.set = function (key, data) {
	        this.write(data.toMutations(key, this.precondition(key)));
	    };
	    Transaction.prototype.update = function (key, data) {
	        this.write(data.toMutations(key, this.preconditionForUpdate(key)));
	    };
	    Transaction.prototype.delete = function (key) {
	        this.write([new mutation_1.DeleteMutation(key, this.precondition(key))]);
	        // Since the delete will be applied before all following writes, we need to
	        // ensure that the precondition for the next write will be exists: false.
	        this.readVersions = this.readVersions.insert(key, snapshot_version_1.SnapshotVersion.forDeletedDoc());
	    };
	    Transaction.prototype.commit = function () {
	        var _this = this;
	        var unwritten = this.readVersions;
	        // For each mutation, note that the doc was written.
	        this.mutations.forEach(function (mutation) {
	            unwritten = unwritten.remove(mutation.key);
	        });
	        if (!unwritten.isEmpty()) {
	            return Promise.reject(Error('Every document read in a transaction must also be written.'));
	        }
	        return this.datastore.commit(this.mutations).then(function () {
	            _this.committed = true;
	        });
	    };
	    return Transaction;
	}());
	exports.Transaction = Transaction;
	
	//# sourceMappingURL=transaction.js.map


/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var collections_1 = __webpack_require__(11);
	var document_1 = __webpack_require__(21);
	var document_set_1 = __webpack_require__(162);
	var remote_event_1 = __webpack_require__(53);
	var assert_1 = __webpack_require__(2);
	var types_1 = __webpack_require__(99);
	var view_snapshot_1 = __webpack_require__(72);
	var AddedLimboDocument = /** @class */ (function () {
	    function AddedLimboDocument(key) {
	        this.key = key;
	    }
	    return AddedLimboDocument;
	}());
	exports.AddedLimboDocument = AddedLimboDocument;
	var RemovedLimboDocument = /** @class */ (function () {
	    function RemovedLimboDocument(key) {
	        this.key = key;
	    }
	    return RemovedLimboDocument;
	}());
	exports.RemovedLimboDocument = RemovedLimboDocument;
	/**
	 * View is responsible for computing the final merged truth of what docs are in
	 * a query. It gets notified of local and remote changes to docs, and applies
	 * the query filters and limits to determine the most correct possible results.
	 */
	var View = /** @class */ (function () {
	    function View(query, 
	        /** Documents included in the remote target */
	        syncedDocuments) {
	        this.query = query;
	        this.syncedDocuments = syncedDocuments;
	        this.syncState = null;
	        /**
	         * A flag whether the view is current with the backend. A view is considered
	         * current after it has seen the current flag from the backend and did not
	         * lose consistency within the watch stream (e.g. because of an existence
	         * filter mismatch).
	         */
	        this.current = false;
	        /** Documents in the view but not in the remote target */
	        this.limboDocuments = collections_1.documentKeySet();
	        /** Document Keys that have local changes */
	        this.mutatedKeys = collections_1.documentKeySet();
	        this.documentSet = new document_set_1.DocumentSet(query.docComparator.bind(query));
	    }
	    /**
	     * Iterates over a set of doc changes, applies the query limit, and computes
	     * what the new results should be, what the changes were, and whether we may
	     * need to go back to the local cache for more results. Does not make any
	     * changes to the view.
	     * @param docChanges The doc changes to apply to this view.
	     * @param previousChanges If this is being called with a refill, then start
	     *        with this set of docs and changes instead of the current view.
	     * @return a new set of docs, changes, and refill flag.
	     */
	    View.prototype.computeDocChanges = function (docChanges, previousChanges) {
	        var _this = this;
	        var changeSet = previousChanges
	            ? previousChanges.changeSet
	            : new view_snapshot_1.DocumentChangeSet();
	        var oldDocumentSet = previousChanges
	            ? previousChanges.documentSet
	            : this.documentSet;
	        var newMutatedKeys = previousChanges
	            ? previousChanges.mutatedKeys
	            : this.mutatedKeys;
	        var newDocumentSet = oldDocumentSet;
	        var needsRefill = false;
	        // Track the last doc in a (full) limit. This is necessary, because some
	        // update (a delete, or an update moving a doc past the old limit) might
	        // mean there is some other document in the local cache that either should
	        // come (1) between the old last limit doc and the new last document, in the
	        // case of updates, or (2) after the new last document, in the case of
	        // deletes. So we keep this doc at the old limit to compare the updates to.
	        //
	        // Note that this should never get used in a refill (when previousChanges is
	        // set), because there will only be adds -- no deletes or updates.
	        var lastDocInLimit = this.query.hasLimit() && oldDocumentSet.size === this.query.limit
	            ? oldDocumentSet.last()
	            : null;
	        docChanges.inorderTraversal(function (key, newMaybeDoc) {
	            var oldDoc = oldDocumentSet.get(key);
	            var newDoc = newMaybeDoc instanceof document_1.Document ? newMaybeDoc : null;
	            if (newDoc) {
	                assert_1.assert(key.isEqual(newDoc.key), 'Mismatching keys found in document changes: ' +
	                    key +
	                    ' != ' +
	                    newDoc.key);
	                newDoc = _this.query.matches(newDoc) ? newDoc : null;
	            }
	            if (newDoc) {
	                newDocumentSet = newDocumentSet.add(newDoc);
	                if (newDoc.hasLocalMutations) {
	                    newMutatedKeys = newMutatedKeys.add(key);
	                }
	                else {
	                    newMutatedKeys = newMutatedKeys.delete(key);
	                }
	            }
	            else {
	                newDocumentSet = newDocumentSet.delete(key);
	                newMutatedKeys = newMutatedKeys.delete(key);
	            }
	            // Calculate change
	            if (oldDoc && newDoc) {
	                var docsEqual = oldDoc.data.isEqual(newDoc.data);
	                if (!docsEqual ||
	                    oldDoc.hasLocalMutations !== newDoc.hasLocalMutations) {
	                    // only report a change if document actually changed
	                    if (docsEqual) {
	                        changeSet.track({ type: view_snapshot_1.ChangeType.Metadata, doc: newDoc });
	                    }
	                    else {
	                        changeSet.track({ type: view_snapshot_1.ChangeType.Modified, doc: newDoc });
	                    }
	                    if (lastDocInLimit &&
	                        _this.query.docComparator(newDoc, lastDocInLimit) > 0) {
	                        // This doc moved from inside the limit to after the limit.
	                        // That means there may be some doc in the local cache that's
	                        // actually less than this one.
	                        needsRefill = true;
	                    }
	                }
	            }
	            else if (!oldDoc && newDoc) {
	                changeSet.track({ type: view_snapshot_1.ChangeType.Added, doc: newDoc });
	            }
	            else if (oldDoc && !newDoc) {
	                changeSet.track({ type: view_snapshot_1.ChangeType.Removed, doc: oldDoc });
	                if (lastDocInLimit) {
	                    // A doc was removed from a full limit query. We'll need to
	                    // requery from the local cache to see if we know about some other
	                    // doc that should be in the results.
	                    needsRefill = true;
	                }
	            }
	        });
	        if (this.query.hasLimit()) {
	            // TODO(klimt): Make DocumentSet size be constant time.
	            while (newDocumentSet.size > this.query.limit) {
	                var oldDoc = newDocumentSet.last();
	                newDocumentSet = newDocumentSet.delete(oldDoc.key);
	                changeSet.track({ type: view_snapshot_1.ChangeType.Removed, doc: oldDoc });
	            }
	        }
	        assert_1.assert(!needsRefill || !previousChanges, 'View was refilled using docs that themselves needed refilling.');
	        return {
	            documentSet: newDocumentSet,
	            changeSet: changeSet,
	            needsRefill: needsRefill,
	            mutatedKeys: newMutatedKeys
	        };
	    };
	    /**
	     * Updates the view with the given ViewDocumentChanges and updates limbo docs
	     * and sync state from the given (optional) target change.
	     * @param docChanges The set of changes to make to the view's docs.
	     * @param targetChange A target change to apply for computing limbo docs and
	     *        sync state.
	     * @return A new ViewChange with the given docs, changes, and sync state.
	     */
	    View.prototype.applyChanges = function (docChanges, targetChange) {
	        var _this = this;
	        assert_1.assert(!docChanges.needsRefill, 'Cannot apply changes that need a refill');
	        var oldDocs = this.documentSet;
	        this.documentSet = docChanges.documentSet;
	        this.mutatedKeys = docChanges.mutatedKeys;
	        // Sort changes based on type and query comparator
	        var changes = docChanges.changeSet.getChanges();
	        changes.sort(function (c1, c2) {
	            return (compareChangeType(c1.type, c2.type) ||
	                _this.query.docComparator(c1.doc, c2.doc));
	        });
	        this.applyTargetChange(targetChange);
	        var limboChanges = this.updateLimboDocuments();
	        var synced = this.limboDocuments.size === 0 && this.current;
	        var newSyncState = synced ? view_snapshot_1.SyncState.Synced : view_snapshot_1.SyncState.Local;
	        var syncStateChanged = newSyncState !== this.syncState;
	        this.syncState = newSyncState;
	        if (changes.length === 0 && !syncStateChanged) {
	            // no changes
	            return { limboChanges: limboChanges };
	        }
	        else {
	            var snap = new view_snapshot_1.ViewSnapshot(this.query, docChanges.documentSet, oldDocs, changes, newSyncState === view_snapshot_1.SyncState.Local, !docChanges.mutatedKeys.isEmpty(), syncStateChanged);
	            return {
	                snapshot: snap,
	                limboChanges: limboChanges
	            };
	        }
	    };
	    /**
	     * Applies an OnlineState change to the view, potentially generating a
	     * ViewChange if the view's syncState changes as a result.
	     */
	    View.prototype.applyOnlineStateChange = function (onlineState) {
	        if (this.current && onlineState === types_1.OnlineState.Failed) {
	            // If we're offline, set `current` to false and then call applyChanges()
	            // to refresh our syncState and generate a ViewChange as appropriate. We
	            // are guaranteed to get a new TargetChange that sets `current` back to
	            // true once the client is back online.
	            this.current = false;
	            return this.applyChanges({
	                documentSet: this.documentSet,
	                changeSet: new view_snapshot_1.DocumentChangeSet(),
	                mutatedKeys: this.mutatedKeys,
	                needsRefill: false
	            });
	        }
	        else {
	            // No effect, just return a no-op ViewChange.
	            return { limboChanges: [] };
	        }
	    };
	    /**
	     * Returns whether the doc for the given key should be in limbo.
	     */
	    View.prototype.shouldBeInLimbo = function (key) {
	        // If the remote end says it's part of this query, it's not in limbo.
	        if (this.syncedDocuments.has(key)) {
	            return false;
	        }
	        // The local store doesn't think it's a result, so it shouldn't be in limbo.
	        if (!this.documentSet.has(key)) {
	            return false;
	        }
	        // If there are local changes to the doc, they might explain why the server
	        // doesn't know that it's part of the query. So don't put it in limbo.
	        // TODO(klimt): Ideally, we would only consider changes that might actually
	        // affect this specific query.
	        if (this.documentSet.get(key).hasLocalMutations) {
	            return false;
	        }
	        // Everything else is in limbo.
	        return true;
	    };
	    /**
	     * Updates syncedDocuments, current, and limbo docs based on the given change.
	     * Returns the list of changes to which docs are in limbo.
	     */
	    View.prototype.applyTargetChange = function (targetChange) {
	        if (targetChange) {
	            var targetMapping = targetChange.mapping;
	            if (targetMapping instanceof remote_event_1.ResetMapping) {
	                this.syncedDocuments = targetMapping.documents;
	            }
	            else if (targetMapping instanceof remote_event_1.UpdateMapping) {
	                this.syncedDocuments = targetMapping.applyToKeySet(this.syncedDocuments);
	            }
	            switch (targetChange.currentStatusUpdate) {
	                case remote_event_1.CurrentStatusUpdate.MarkCurrent:
	                    this.current = true;
	                    break;
	                case remote_event_1.CurrentStatusUpdate.MarkNotCurrent:
	                    this.current = false;
	                    break;
	                case remote_event_1.CurrentStatusUpdate.None:
	                    break;
	                default:
	                    assert_1.fail('Unknown current status update: ' + targetChange.currentStatusUpdate);
	            }
	        }
	    };
	    View.prototype.updateLimboDocuments = function () {
	        var _this = this;
	        // We can only determine limbo documents when we're in-sync with the server.
	        if (!this.current) {
	            return [];
	        }
	        // TODO(klimt): Do this incrementally so that it's not quadratic when
	        // updating many documents.
	        var oldLimboDocuments = this.limboDocuments;
	        this.limboDocuments = collections_1.documentKeySet();
	        this.documentSet.forEach(function (doc) {
	            if (_this.shouldBeInLimbo(doc.key)) {
	                _this.limboDocuments = _this.limboDocuments.add(doc.key);
	            }
	        });
	        // Diff the new limbo docs with the old limbo docs.
	        var changes = [];
	        oldLimboDocuments.forEach(function (key) {
	            if (!_this.limboDocuments.has(key)) {
	                changes.push(new RemovedLimboDocument(key));
	            }
	        });
	        this.limboDocuments.forEach(function (key) {
	            if (!oldLimboDocuments.has(key)) {
	                changes.push(new AddedLimboDocument(key));
	            }
	        });
	        return changes;
	    };
	    return View;
	}());
	exports.View = View;
	function compareChangeType(c1, c2) {
	    var order = function (change) {
	        switch (change) {
	            case view_snapshot_1.ChangeType.Added:
	                return 1;
	            case view_snapshot_1.ChangeType.Modified:
	                return 2;
	            case view_snapshot_1.ChangeType.Metadata:
	                // A metadata change is converted to a modified change at the public
	                // api layer.  Since we sort by document key and then change type,
	                // metadata and modified changes must be sorted equivalently.
	                return 2;
	            case view_snapshot_1.ChangeType.Removed:
	                return 0;
	            default:
	                return assert_1.fail('Unknown ChangeType: ' + change);
	        }
	    };
	    return order(c1) - order(c2);
	}
	
	//# sourceMappingURL=view.js.map


/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var mutation_batch_1 = __webpack_require__(52);
	var assert_1 = __webpack_require__(2);
	var misc_1 = __webpack_require__(14);
	var sorted_set_1 = __webpack_require__(76);
	var EncodedResourcePath = __webpack_require__(101);
	var indexeddb_schema_1 = __webpack_require__(41);
	var persistence_promise_1 = __webpack_require__(18);
	var simple_db_1 = __webpack_require__(74);
	/** A mutation queue for a specific user, backed by IndexedDB. */
	var IndexedDbMutationQueue = /** @class */ (function () {
	    function IndexedDbMutationQueue(
	        /**
	         * The normalized userId (e.g. null UID => "" userId) used to store /
	         * retrieve mutations.
	         */
	        userId, serializer) {
	        this.userId = userId;
	        this.serializer = serializer;
	        this.garbageCollector = null;
	    }
	    /**
	     * Creates a new mutation queue for the given user.
	     * @param user The user for which to create a mutation queue.
	     * @param serializer The serializer to use when persisting to IndexedDb.
	     */
	    IndexedDbMutationQueue.forUser = function (user, serializer) {
	        // TODO(mcg): Figure out what constraints there are on userIDs
	        // In particular, are there any reserved characters? are empty ids allowed?
	        // For the moment store these together in the same mutations table assuming
	        // that empty userIDs aren't allowed.
	        assert_1.assert(user.uid !== '', 'UserID must not be an empty string.');
	        var userId = user.isUnauthenticated() ? '' : user.uid;
	        return new IndexedDbMutationQueue(userId, serializer);
	    };
	    IndexedDbMutationQueue.prototype.start = function (transaction) {
	        var _this = this;
	        return IndexedDbMutationQueue.loadNextBatchIdFromDb(transaction)
	            .next(function (nextBatchId) {
	            _this.nextBatchId = nextBatchId;
	            return mutationQueuesStore(transaction).get(_this.userId);
	        })
	            .next(function (metadata) {
	            if (!metadata) {
	                metadata = new indexeddb_schema_1.DbMutationQueue(_this.userId, mutation_batch_1.BATCHID_UNKNOWN, 
	                /*lastStreamToken=*/ '');
	            }
	            _this.metadata = metadata;
	            // On restart, nextBatchId may end up lower than
	            // lastAcknowledgedBatchId since it's computed from the queue
	            // contents, and there may be no mutations in the queue. In this
	            // case, we need to reset lastAcknowledgedBatchId (which is safe
	            // since the queue must be empty).
	            if (_this.metadata.lastAcknowledgedBatchId >= _this.nextBatchId) {
	                return _this.checkEmpty(transaction).next(function (empty) {
	                    assert_1.assert(empty, 'Reset nextBatchID is only possible when the queue is empty');
	                    _this.metadata.lastAcknowledgedBatchId = mutation_batch_1.BATCHID_UNKNOWN;
	                    return mutationQueuesStore(transaction).put(_this.metadata);
	                });
	            }
	            else {
	                return persistence_promise_1.PersistencePromise.resolve();
	            }
	        });
	    };
	    /**
	     * Returns one larger than the largest batch ID that has been stored. If there
	     * are no mutations returns 0. Note that batch IDs are global.
	     */
	    IndexedDbMutationQueue.loadNextBatchIdFromDb = function (txn) {
	        var maxBatchId = mutation_batch_1.BATCHID_UNKNOWN;
	        return mutationsStore(txn)
	            .iterate({ reverse: true }, function (key, batch, control) {
	            var userId = key[0], batchId = key[1];
	            if (batchId > maxBatchId) {
	                maxBatchId = batch.batchId;
	            }
	            if (userId === '') {
	                // We can't compute a predecessor for the empty string, since it
	                // is lexographically first. That also means that no other
	                // userIds can come before this one, so we can just exit early.
	                control.done();
	            }
	            else {
	                var nextUser = misc_1.immediatePredecessor(userId);
	                control.skip([nextUser]);
	            }
	        })
	            .next(function () { return maxBatchId + 1; });
	    };
	    IndexedDbMutationQueue.prototype.checkEmpty = function (transaction) {
	        var empty = true;
	        var range = IDBKeyRange.bound(this.keyForBatchId(Number.NEGATIVE_INFINITY), this.keyForBatchId(Number.POSITIVE_INFINITY));
	        return mutationsStore(transaction)
	            .iterate({ range: range }, function (key, value, control) {
	            empty = false;
	            control.done();
	        })
	            .next(function () { return empty; });
	    };
	    IndexedDbMutationQueue.prototype.getNextBatchId = function (transaction) {
	        return persistence_promise_1.PersistencePromise.resolve(this.nextBatchId);
	    };
	    IndexedDbMutationQueue.prototype.getHighestAcknowledgedBatchId = function (transaction) {
	        return persistence_promise_1.PersistencePromise.resolve(this.metadata.lastAcknowledgedBatchId);
	    };
	    IndexedDbMutationQueue.prototype.acknowledgeBatch = function (transaction, batch, streamToken) {
	        var batchId = batch.batchId;
	        assert_1.assert(batchId > this.metadata.lastAcknowledgedBatchId, 'Mutation batchIDs must be acknowledged in order');
	        this.metadata.lastAcknowledgedBatchId = batchId;
	        this.metadata.lastStreamToken = validateStreamToken(streamToken);
	        return mutationQueuesStore(transaction).put(this.metadata);
	    };
	    IndexedDbMutationQueue.prototype.getLastStreamToken = function (transaction) {
	        return persistence_promise_1.PersistencePromise.resolve(this.metadata.lastStreamToken);
	    };
	    IndexedDbMutationQueue.prototype.setLastStreamToken = function (transaction, streamToken) {
	        this.metadata.lastStreamToken = validateStreamToken(streamToken);
	        return mutationQueuesStore(transaction).put(this.metadata);
	    };
	    IndexedDbMutationQueue.prototype.addMutationBatch = function (transaction, localWriteTime, mutations) {
	        var _this = this;
	        var batchId = this.nextBatchId;
	        this.nextBatchId++;
	        var batch = new mutation_batch_1.MutationBatch(batchId, localWriteTime, mutations);
	        var dbBatch = this.serializer.toDbMutationBatch(this.userId, batch);
	        return mutationsStore(transaction)
	            .put(dbBatch)
	            .next(function () {
	            var promises = [];
	            for (var _i = 0, mutations_1 = mutations; _i < mutations_1.length; _i++) {
	                var mutation = mutations_1[_i];
	                var encodedPath = EncodedResourcePath.encode(mutation.key.path);
	                var indexKey = indexeddb_schema_1.DbDocumentMutation.key(_this.userId, mutation.key.path, batchId);
	                documentMutationsStore(transaction).put(indexKey, indexeddb_schema_1.DbDocumentMutation.PLACEHOLDER);
	            }
	            return persistence_promise_1.PersistencePromise.waitFor(promises);
	        })
	            .next(function () {
	            return batch;
	        });
	    };
	    IndexedDbMutationQueue.prototype.lookupMutationBatch = function (transaction, batchId) {
	        var _this = this;
	        return mutationsStore(transaction)
	            .get(this.keyForBatchId(batchId))
	            .next(function (dbBatch) {
	            return dbBatch ? _this.serializer.fromDbMutationBatch(dbBatch) : null;
	        });
	    };
	    IndexedDbMutationQueue.prototype.getNextMutationBatchAfterBatchId = function (transaction, batchId) {
	        var _this = this;
	        var range = IDBKeyRange.lowerBound(this.keyForBatchId(batchId + 1));
	        var foundBatch = null;
	        return mutationsStore(transaction)
	            .iterate({ range: range }, function (key, dbBatch, control) {
	            if (dbBatch.userId === _this.userId) {
	                assert_1.assert(dbBatch.batchId > batchId, 'Should have found mutation after ' + batchId);
	                foundBatch = _this.serializer.fromDbMutationBatch(dbBatch);
	            }
	            control.done();
	        })
	            .next(function () { return foundBatch; });
	    };
	    IndexedDbMutationQueue.prototype.getAllMutationBatches = function (transaction) {
	        var _this = this;
	        var range = IDBKeyRange.bound(this.keyForBatchId(mutation_batch_1.BATCHID_UNKNOWN), this.keyForBatchId(Number.POSITIVE_INFINITY));
	        return mutationsStore(transaction)
	            .loadAll(range)
	            .next(function (dbBatches) {
	            return dbBatches.map(function (dbBatch) { return _this.serializer.fromDbMutationBatch(dbBatch); });
	        });
	    };
	    IndexedDbMutationQueue.prototype.getAllMutationBatchesThroughBatchId = function (transaction, batchId) {
	        var _this = this;
	        var range = IDBKeyRange.bound(this.keyForBatchId(mutation_batch_1.BATCHID_UNKNOWN), this.keyForBatchId(batchId));
	        return mutationsStore(transaction)
	            .loadAll(range)
	            .next(function (dbBatches) {
	            return dbBatches.map(function (dbBatch) { return _this.serializer.fromDbMutationBatch(dbBatch); });
	        });
	    };
	    IndexedDbMutationQueue.prototype.getAllMutationBatchesAffectingDocumentKey = function (transaction, documentKey) {
	        var _this = this;
	        // Scan the document-mutation index starting with a prefix starting with
	        // the given documentKey.
	        var indexPrefix = indexeddb_schema_1.DbDocumentMutation.prefixForPath(this.userId, documentKey.path);
	        var indexStart = IDBKeyRange.lowerBound(indexPrefix);
	        var results = [];
	        return documentMutationsStore(transaction)
	            .iterate({ range: indexStart }, function (indexKey, _, control) {
	            var userID = indexKey[0], encodedPath = indexKey[1], batchID = indexKey[2];
	            // Only consider rows matching exactly the specific key of
	            // interest. Note that because we order by path first, and we
	            // order terminators before path separators, we'll encounter all
	            // the index rows for documentKey contiguously. In particular, all
	            // the rows for documentKey will occur before any rows for
	            // documents nested in a subcollection beneath documentKey so we
	            // can stop as soon as we hit any such row.
	            var path = EncodedResourcePath.decode(encodedPath);
	            if (userID !== _this.userId || !documentKey.path.isEqual(path)) {
	                control.done();
	                return;
	            }
	            var mutationKey = _this.keyForBatchId(batchID);
	            // Look up the mutation batch in the store.
	            // PORTING NOTE: because iteration is callback driven in the web,
	            // we just look up the key instead of keeping an open iterator
	            // like iOS.
	            return mutationsStore(transaction)
	                .get(mutationKey)
	                .next(function (dbBatch) {
	                if (dbBatch === null) {
	                    assert_1.fail('Dangling document-mutation reference found: ' +
	                        indexKey +
	                        ' which points to ' +
	                        mutationKey);
	                }
	                results.push(_this.serializer.fromDbMutationBatch(dbBatch));
	            });
	        })
	            .next(function () { return results; });
	    };
	    IndexedDbMutationQueue.prototype.getAllMutationBatchesAffectingQuery = function (transaction, query) {
	        var _this = this;
	        assert_1.assert(!query.isDocumentQuery(), "Document queries shouldn't go down this path");
	        var queryPath = query.path;
	        var immediateChildrenLength = queryPath.length + 1;
	        // TODO(mcg): Actually implement a single-collection query
	        //
	        // This is actually executing an ancestor query, traversing the whole
	        // subtree below the collection which can be horrifically inefficient for
	        // some structures. The right way to solve this is to implement the full
	        // value index, but that's not in the cards in the near future so this is
	        // the best we can do for the moment.
	        //
	        // Since we don't yet index the actual properties in the mutations, our
	        // current approach is to just return all mutation batches that affect
	        // documents in the collection being queried.
	        var indexPrefix = indexeddb_schema_1.DbDocumentMutation.prefixForPath(this.userId, queryPath);
	        var encodedQueryPath = indexPrefix[1];
	        var indexStart = IDBKeyRange.lowerBound(indexPrefix);
	        // Collect up unique batchIDs encountered during a scan of the index. Use a
	        // SortedSet to accumulate batch IDs so they can be traversed in order in a
	        // scan of the main table.
	        var uniqueBatchIDs = new sorted_set_1.SortedSet(misc_1.primitiveComparator);
	        return documentMutationsStore(transaction)
	            .iterate({ range: indexStart }, function (indexKey, _, control) {
	            var userID = indexKey[0], encodedPath = indexKey[1], batchID = indexKey[2];
	            var path = EncodedResourcePath.decode(encodedPath);
	            if (userID !== _this.userId || !queryPath.isPrefixOf(path)) {
	                control.done();
	                return;
	            }
	            // Rows with document keys more than one segment longer than the
	            // query path can't be matches. For example, a query on 'rooms'
	            // can't match the document /rooms/abc/messages/xyx.
	            // TODO(mcg): we'll need a different scanner when we implement
	            // ancestor queries.
	            if (path.length !== immediateChildrenLength) {
	                return;
	            }
	            uniqueBatchIDs = uniqueBatchIDs.add(batchID);
	        })
	            .next(function () {
	            var results = [];
	            var promises = [];
	            // TODO(rockwood): Implement this using iterate.
	            uniqueBatchIDs.forEach(function (batchID) {
	                var mutationKey = _this.keyForBatchId(batchID);
	                promises.push(mutationsStore(transaction)
	                    .get(mutationKey)
	                    .next(function (mutation) {
	                    if (mutation === null) {
	                        assert_1.fail('Dangling document-mutation reference found, ' +
	                            'which points to ' +
	                            mutationKey);
	                    }
	                    results.push(_this.serializer.fromDbMutationBatch(mutation));
	                }));
	            });
	            return persistence_promise_1.PersistencePromise.waitFor(promises).next(function () { return results; });
	        });
	    };
	    IndexedDbMutationQueue.prototype.removeMutationBatches = function (transaction, batches) {
	        var txn = mutationsStore(transaction);
	        var indexTxn = documentMutationsStore(transaction);
	        var promises = [];
	        var _loop_1 = function (batch) {
	            var range = IDBKeyRange.only(this_1.keyForBatchId(batch.batchId));
	            var numDeleted = 0;
	            var removePromise = txn.iterate({ range: range }, function (key, value, control) {
	                numDeleted++;
	                return control.delete();
	            });
	            promises.push(removePromise.next(function () {
	                assert_1.assert(numDeleted === 1, 'Dangling document-mutation reference found: Missing batch ' +
	                    batch.batchId);
	            }));
	            for (var _i = 0, _a = batch.mutations; _i < _a.length; _i++) {
	                var mutation = _a[_i];
	                var indexKey = indexeddb_schema_1.DbDocumentMutation.key(this_1.userId, mutation.key.path, batch.batchId);
	                promises.push(indexTxn.delete(indexKey));
	                if (this_1.garbageCollector !== null) {
	                    this_1.garbageCollector.addPotentialGarbageKey(mutation.key);
	                }
	            }
	        };
	        var this_1 = this;
	        for (var _i = 0, batches_1 = batches; _i < batches_1.length; _i++) {
	            var batch = batches_1[_i];
	            _loop_1(batch);
	        }
	        return persistence_promise_1.PersistencePromise.waitFor(promises);
	    };
	    IndexedDbMutationQueue.prototype.performConsistencyCheck = function (txn) {
	        var _this = this;
	        return this.checkEmpty(txn).next(function (empty) {
	            if (!empty) {
	                return persistence_promise_1.PersistencePromise.resolve();
	            }
	            // Verify that there are no entries in the documentMutations index if
	            // the queue is empty.
	            var startRange = IDBKeyRange.lowerBound(indexeddb_schema_1.DbDocumentMutation.prefixForUser(_this.userId));
	            var danglingMutationReferences = [];
	            return documentMutationsStore(txn)
	                .iterate({ range: startRange }, function (key, _, control) {
	                var userID = key[0];
	                if (userID !== _this.userId) {
	                    control.done();
	                    return;
	                }
	                else {
	                    var path = EncodedResourcePath.decode(key[1]);
	                    danglingMutationReferences.push(path);
	                }
	            })
	                .next(function () {
	                assert_1.assert(danglingMutationReferences.length === 0, 'Document leak -- detected dangling mutation references when queue is empty. Dangling keys: ' +
	                    danglingMutationReferences.map(function (p) { return p.canonicalString(); }));
	            });
	        });
	    };
	    IndexedDbMutationQueue.prototype.setGarbageCollector = function (gc) {
	        this.garbageCollector = gc;
	    };
	    IndexedDbMutationQueue.prototype.containsKey = function (txn, key) {
	        var _this = this;
	        var indexKey = indexeddb_schema_1.DbDocumentMutation.prefixForPath(this.userId, key.path);
	        var encodedPath = indexKey[1];
	        var startRange = IDBKeyRange.lowerBound(indexKey);
	        var containsKey = false;
	        return documentMutationsStore(txn)
	            .iterate({ range: startRange, keysOnly: true }, function (key, _, control) {
	            var userID = key[0], keyPath = key[1], batchID = key[2];
	            if (userID === _this.userId && keyPath === encodedPath) {
	                containsKey = true;
	            }
	            control.done();
	        })
	            .next(function () { return containsKey; });
	    };
	    /**
	     * Creates a [userId, batchId] key for use with the DbMutationQueue object
	     * store.
	     */
	    IndexedDbMutationQueue.prototype.keyForBatchId = function (batchId) {
	        return [this.userId, batchId];
	    };
	    return IndexedDbMutationQueue;
	}());
	exports.IndexedDbMutationQueue = IndexedDbMutationQueue;
	function validateStreamToken(token) {
	    assert_1.assert(typeof token === 'string', 'Persisting non-string stream token not supported.');
	    return token;
	}
	/**
	 * Helper to get a typed SimpleDbStore for the mutations object store.
	 */
	function mutationsStore(txn) {
	    return getStore(txn, indexeddb_schema_1.DbMutationBatch.store);
	}
	/**
	 * Helper to get a typed SimpleDbStore for the mutationQueues object store.
	 */
	function documentMutationsStore(txn) {
	    return getStore(txn, indexeddb_schema_1.DbDocumentMutation.store);
	}
	/**
	 * Helper to get a typed SimpleDbStore for the mutationQueues object store.
	 */
	function mutationQueuesStore(txn) {
	    return getStore(txn, indexeddb_schema_1.DbMutationQueue.store);
	}
	/**
	 * Helper to get a typed SimpleDbStore from a transaction.
	 */
	function getStore(txn, store) {
	    if (txn instanceof simple_db_1.SimpleDbTransaction) {
	        return txn.store(store);
	    }
	    else {
	        return assert_1.fail('Invalid transaction object provided!');
	    }
	}
	
	//# sourceMappingURL=indexeddb_mutation_queue.js.map


/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var assert_1 = __webpack_require__(2);
	var error_1 = __webpack_require__(10);
	var log = __webpack_require__(13);
	var misc_1 = __webpack_require__(14);
	var indexeddb_mutation_queue_1 = __webpack_require__(269);
	var indexeddb_query_cache_1 = __webpack_require__(271);
	var indexeddb_remote_document_cache_1 = __webpack_require__(272);
	var indexeddb_schema_1 = __webpack_require__(41);
	var indexeddb_schema_2 = __webpack_require__(41);
	var local_serializer_1 = __webpack_require__(274);
	var persistence_promise_1 = __webpack_require__(18);
	var simple_db_1 = __webpack_require__(74);
	var LOG_TAG = 'IndexedDbPersistence';
	/** If the owner lease is older than 5 seconds, try to take ownership. */
	var OWNER_LEASE_MAX_AGE_MS = 5000;
	/** Refresh the owner lease every 4 seconds while owner. */
	var OWNER_LEASE_REFRESH_INTERVAL_MS = 4000;
	/** LocalStorage location to indicate a zombied ownerId (see class comment). */
	var ZOMBIE_OWNER_LOCALSTORAGE_SUFFIX = 'zombiedOwnerId';
	/** Error when the owner lease cannot be acquired or is lost. */
	var EXISTING_OWNER_ERROR_MSG = 'There is another tab open with offline' +
	    ' persistence enabled. Only one such tab is allowed at a time. The' +
	    ' other tab must be closed or persistence must be disabled.';
	var UNSUPPORTED_PLATFORM_ERROR_MSG = 'This platform is either missing' +
	    ' IndexedDB or is known to have an incomplete implementation. Offline' +
	    ' persistence has been disabled.';
	/**
	 * An IndexedDB-backed instance of Persistence. Data is stored persistently
	 * across sessions.
	 *
	 * Currently the Firestore SDK only supports a single consumer of the database,
	 * but browsers obviously support multiple tabs. IndexedDbPersistence ensures a
	 * single consumer of the database via an "owner lease" stored in the database.
	 *
	 * On startup, IndexedDbPersistence assigns itself a random "ownerId" and writes
	 * it to a special "owner" object in the database (if no entry exists already or
	 * the current entry is expired). This owner lease is then verified inside every
	 * transaction to ensure the lease has not been lost.
	 *
	 * If a tab opts not to acquire the owner lease (because there's an existing
	 * non-expired owner) or loses the owner lease, IndexedDbPersistence enters a
	 * failed state and all subsequent operations will automatically fail.
	 *
	 * The current owner regularly refreshes the owner lease with new timestamps to
	 * prevent newly-opened tabs from taking over ownership.
	 *
	 * Additionally there is an optimization so that when a tab is closed, the owner
	 * lease is released immediately (this is especially important to make sure that
	 * a refreshed tab is able to immediately re-acquire the owner lease).
	 * Unfortunately, IndexedDB cannot be reliably used in window.unload since it is
	 * an asynchronous API. So in addition to attempting to give up the lease,
	 * the owner writes its ownerId to a "zombiedOwnerId" entry in LocalStorage
	 * which acts as an indicator that another tab should go ahead and take the
	 * owner lease immediately regardless of the current lease timestamp.
	 */
	var IndexedDbPersistence = /** @class */ (function () {
	    function IndexedDbPersistence(prefix, serializer) {
	        this.ownerId = this.generateOwnerId();
	        this.dbName = prefix + IndexedDbPersistence.MAIN_DATABASE;
	        this.serializer = new local_serializer_1.LocalSerializer(serializer);
	        this.localStoragePrefix = prefix;
	    }
	    IndexedDbPersistence.prototype.start = function () {
	        var _this = this;
	        if (!IndexedDbPersistence.isAvailable()) {
	            this.persistenceError = new error_1.FirestoreError(error_1.Code.UNIMPLEMENTED, UNSUPPORTED_PLATFORM_ERROR_MSG);
	            return Promise.reject(this.persistenceError);
	        }
	        assert_1.assert(!this.started, 'IndexedDbPersistence double-started!');
	        this.started = true;
	        return simple_db_1.SimpleDb.openOrCreate(this.dbName, indexeddb_schema_2.SCHEMA_VERSION, indexeddb_schema_2.createOrUpgradeDb)
	            .then(function (db) {
	            _this.simpleDb = db;
	        })
	            .then(function () { return _this.tryAcquireOwnerLease(); })
	            .then(function () {
	            _this.scheduleOwnerLeaseRefreshes();
	            _this.attachWindowUnloadHook();
	        });
	    };
	    IndexedDbPersistence.prototype.shutdown = function () {
	        var _this = this;
	        assert_1.assert(this.started, 'IndexedDbPersistence shutdown without start!');
	        this.started = false;
	        this.detachWindowUnloadHook();
	        this.stopOwnerLeaseRefreshes();
	        return this.releaseOwnerLease().then(function () {
	            _this.simpleDb.close();
	        });
	    };
	    IndexedDbPersistence.prototype.getMutationQueue = function (user) {
	        return indexeddb_mutation_queue_1.IndexedDbMutationQueue.forUser(user, this.serializer);
	    };
	    IndexedDbPersistence.prototype.getQueryCache = function () {
	        return new indexeddb_query_cache_1.IndexedDbQueryCache(this.serializer);
	    };
	    IndexedDbPersistence.prototype.getRemoteDocumentCache = function () {
	        return new indexeddb_remote_document_cache_1.IndexedDbRemoteDocumentCache(this.serializer);
	    };
	    IndexedDbPersistence.prototype.runTransaction = function (action, operation) {
	        var _this = this;
	        if (this.persistenceError) {
	            return Promise.reject(this.persistenceError);
	        }
	        log.debug(LOG_TAG, 'Starting transaction:', action);
	        // Do all transactions as readwrite against all object stores, since we
	        // are the only reader/writer.
	        return this.simpleDb.runTransaction('readwrite', indexeddb_schema_1.ALL_STORES, function (txn) {
	            // Verify that we still have the owner lease as part of every transaction.
	            return _this.ensureOwnerLease(txn).next(function () { return operation(txn); });
	        });
	    };
	    IndexedDbPersistence.isAvailable = function () {
	        return simple_db_1.SimpleDb.isAvailable();
	    };
	    /**
	     * Generates a string used as a prefix when storing data in IndexedDB and
	     * LocalStorage.
	     */
	    IndexedDbPersistence.buildStoragePrefix = function (databaseInfo) {
	        // Use two different prefix formats:
	        //
	        //   * firestore / persistenceKey / projectID . databaseID / ...
	        //   * firestore / persistenceKey / projectID / ...
	        //
	        // projectIDs are DNS-compatible names and cannot contain dots
	        // so there's no danger of collisions.
	        var database = databaseInfo.databaseId.projectId;
	        if (!databaseInfo.databaseId.isDefaultDatabase) {
	            database += '.' + databaseInfo.databaseId.database;
	        }
	        return 'firestore/' + databaseInfo.persistenceKey + '/' + database + '/';
	    };
	    /**
	     * Acquires the owner lease if there's no valid owner. Else returns a rejected
	     * promise.
	     */
	    IndexedDbPersistence.prototype.tryAcquireOwnerLease = function () {
	        var _this = this;
	        // NOTE: Don't use this.runTransaction, since it requires us to already
	        // have the lease.
	        return this.simpleDb.runTransaction('readwrite', [indexeddb_schema_1.DbOwner.store], function (txn) {
	            var store = txn.store(indexeddb_schema_1.DbOwner.store);
	            return store.get('owner').next(function (dbOwner) {
	                if (!_this.validOwner(dbOwner)) {
	                    var newDbOwner = new indexeddb_schema_1.DbOwner(_this.ownerId, Date.now());
	                    log.debug(LOG_TAG, 'No valid owner. Acquiring owner lease. Current owner:', dbOwner, 'New owner:', newDbOwner);
	                    return store.put('owner', newDbOwner);
	                }
	                else {
	                    log.debug(LOG_TAG, 'Valid owner already. Failing. Current owner:', dbOwner);
	                    _this.persistenceError = new error_1.FirestoreError(error_1.Code.FAILED_PRECONDITION, EXISTING_OWNER_ERROR_MSG);
	                    return persistence_promise_1.PersistencePromise.reject(_this.persistenceError);
	                }
	            });
	        });
	    };
	    /** Checks the owner lease and deletes it if we are the current owner. */
	    IndexedDbPersistence.prototype.releaseOwnerLease = function () {
	        var _this = this;
	        // NOTE: Don't use this.runTransaction, since it requires us to already
	        // have the lease.
	        return this.simpleDb.runTransaction('readwrite', [indexeddb_schema_1.DbOwner.store], function (txn) {
	            var store = txn.store(indexeddb_schema_1.DbOwner.store);
	            return store.get('owner').next(function (dbOwner) {
	                if (dbOwner !== null && dbOwner.ownerId === _this.ownerId) {
	                    log.debug(LOG_TAG, 'Releasing owner lease.');
	                    return store.delete('owner');
	                }
	                else {
	                    return persistence_promise_1.PersistencePromise.resolve();
	                }
	            });
	        });
	    };
	    /**
	     * Checks the owner lease and returns a rejected promise if we are not the
	     * current owner. This should be included in every transaction to guard
	     * against losing the owner lease.
	     */
	    IndexedDbPersistence.prototype.ensureOwnerLease = function (txn) {
	        var _this = this;
	        var store = txn.store(indexeddb_schema_1.DbOwner.store);
	        return store.get('owner').next(function (dbOwner) {
	            if (dbOwner === null || dbOwner.ownerId !== _this.ownerId) {
	                _this.persistenceError = new error_1.FirestoreError(error_1.Code.FAILED_PRECONDITION, EXISTING_OWNER_ERROR_MSG);
	                return persistence_promise_1.PersistencePromise.reject(_this.persistenceError);
	            }
	            else {
	                return persistence_promise_1.PersistencePromise.resolve();
	            }
	        });
	    };
	    /**
	     * Returns true if the provided owner exists, has a recent timestamp, and
	     * isn't zombied.
	     *
	     * NOTE: To determine if the owner is zombied, this method reads from
	     * LocalStorage which could be mildly expensive.
	     */
	    IndexedDbPersistence.prototype.validOwner = function (dbOwner) {
	        var now = Date.now();
	        var minAcceptable = now - OWNER_LEASE_MAX_AGE_MS;
	        var maxAcceptable = now;
	        if (dbOwner === null) {
	            return false; // no owner.
	        }
	        else if (dbOwner.leaseTimestampMs < minAcceptable) {
	            return false; // owner lease has expired.
	        }
	        else if (dbOwner.leaseTimestampMs > maxAcceptable) {
	            log.error('Persistence owner-lease is in the future. Discarding.', dbOwner);
	            return false;
	        }
	        else if (dbOwner.ownerId === this.getZombiedOwnerId()) {
	            return false; // owner's tab closed.
	        }
	        else {
	            return true;
	        }
	    };
	    /**
	     * Schedules a recurring timer to update the owner lease timestamp to prevent
	     * other tabs from taking the lease.
	     */
	    IndexedDbPersistence.prototype.scheduleOwnerLeaseRefreshes = function () {
	        var _this = this;
	        // NOTE: This doesn't need to be scheduled on the async queue and doing so
	        // would increase the chances of us not refreshing on time if the queue is
	        // backed up for some reason.
	        this.ownerLeaseRefreshHandle = setInterval(function () {
	            var txResult = _this.runTransaction('Refresh owner timestamp', function (txn) {
	                // NOTE: We don't need to validate the current owner contents, since
	                // runTransaction does that automatically.
	                var store = txn.store(indexeddb_schema_1.DbOwner.store);
	                return store.put('owner', new indexeddb_schema_1.DbOwner(_this.ownerId, Date.now()));
	            });
	            txResult.catch(function (reason) {
	                // Probably means we lost the lease. Report the error and stop trying to
	                // refresh the lease.
	                log.error(reason);
	                _this.stopOwnerLeaseRefreshes();
	            });
	        }, OWNER_LEASE_REFRESH_INTERVAL_MS);
	    };
	    IndexedDbPersistence.prototype.stopOwnerLeaseRefreshes = function () {
	        if (this.ownerLeaseRefreshHandle) {
	            clearInterval(this.ownerLeaseRefreshHandle);
	            this.ownerLeaseRefreshHandle = null;
	        }
	    };
	    /**
	     * Attaches a window.unload handler that will synchronously write our
	     * ownerId to a "zombie owner id" location in localstorage. This can be used
	     * by tabs trying to acquire the lease to determine that the lease should be
	     * acquired immediately even if the timestamp is recent. This is particularly
	     * important for the refresh case (so the tab correctly re-acquires the owner
	     * lease). LocalStorage is used for this rather than IndexedDb because it is
	     * a synchronous API and so can be used reliably from an unload handler.
	     */
	    IndexedDbPersistence.prototype.attachWindowUnloadHook = function () {
	        var _this = this;
	        this.windowUnloadHandler = function () {
	            // Record that we're zombied.
	            _this.setZombiedOwnerId(_this.ownerId);
	            // Attempt graceful shutdown (including releasing our owner lease), but
	            // there's no guarantee it will complete.
	            _this.shutdown();
	        };
	        window.addEventListener('unload', this.windowUnloadHandler);
	    };
	    IndexedDbPersistence.prototype.detachWindowUnloadHook = function () {
	        if (this.windowUnloadHandler) {
	            window.removeEventListener('unload', this.windowUnloadHandler);
	            this.windowUnloadHandler = null;
	        }
	    };
	    /**
	     * Returns any recorded "zombied owner" (i.e. a previous owner that became
	     * zombied due to their tab closing) from LocalStorage, or null if no such
	     * record exists.
	     */
	    IndexedDbPersistence.prototype.getZombiedOwnerId = function () {
	        try {
	            var zombiedOwnerId = window.localStorage.getItem(this.zombiedOwnerLocalStorageKey());
	            log.debug(LOG_TAG, 'Zombied ownerID from LocalStorage:', zombiedOwnerId);
	            return zombiedOwnerId;
	        }
	        catch (e) {
	            // Gracefully handle if LocalStorage isn't available / working.
	            log.error('Failed to get zombie owner id.', e);
	            return null;
	        }
	    };
	    /**
	     * Records a zombied owner (an owner that had its tab closed) in LocalStorage
	     * or, if passed null, deletes any recorded zombied owner.
	     */
	    IndexedDbPersistence.prototype.setZombiedOwnerId = function (zombieOwnerId) {
	        try {
	            if (zombieOwnerId === null) {
	                window.localStorage.removeItem(this.zombiedOwnerLocalStorageKey());
	            }
	            else {
	                window.localStorage.setItem(this.zombiedOwnerLocalStorageKey(), zombieOwnerId);
	            }
	        }
	        catch (e) {
	            // Gracefully handle if LocalStorage isn't available / working.
	            log.error('Failed to set zombie owner id.', e);
	        }
	    };
	    IndexedDbPersistence.prototype.zombiedOwnerLocalStorageKey = function () {
	        return this.localStoragePrefix + ZOMBIE_OWNER_LOCALSTORAGE_SUFFIX;
	    };
	    IndexedDbPersistence.prototype.generateOwnerId = function () {
	        // For convenience, just use an AutoId.
	        return misc_1.AutoId.newId();
	    };
	    /**
	     * The name of the main (and currently only) IndexedDB database. this name is
	     * appended to the prefix provided to the IndexedDbPersistence constructor.
	     */
	    IndexedDbPersistence.MAIN_DATABASE = 'main';
	    return IndexedDbPersistence;
	}());
	exports.IndexedDbPersistence = IndexedDbPersistence;
	
	//# sourceMappingURL=indexeddb_persistence.js.map


/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var snapshot_version_1 = __webpack_require__(20);
	var timestamp_1 = __webpack_require__(40);
	var collections_1 = __webpack_require__(11);
	var document_key_1 = __webpack_require__(12);
	var assert_1 = __webpack_require__(2);
	var misc_1 = __webpack_require__(14);
	var EncodedResourcePath = __webpack_require__(101);
	var indexeddb_schema_1 = __webpack_require__(41);
	var persistence_promise_1 = __webpack_require__(18);
	var simple_db_1 = __webpack_require__(74);
	var IndexedDbQueryCache = /** @class */ (function () {
	    function IndexedDbQueryCache(serializer) {
	        this.serializer = serializer;
	        /**
	         * The last received snapshot version. We store this seperately from the
	         * metadata to avoid the extra conversion to/from DbTimestamp.
	         */
	        this.lastRemoteSnapshotVersion = snapshot_version_1.SnapshotVersion.MIN;
	        /**
	         * A cached copy of the metadata for the query cache.
	         */
	        this.metadata = new indexeddb_schema_1.DbTargetGlobal(
	        /*highestTargetId=*/ 0, 
	        /*lastListenSequenceNumber=*/ 0, snapshot_version_1.SnapshotVersion.MIN.toTimestamp());
	        /** The garbage collector to notify about potential garbage keys. */
	        this.garbageCollector = null;
	    }
	    IndexedDbQueryCache.prototype.start = function (transaction) {
	        var _this = this;
	        return globalTargetStore(transaction)
	            .get(indexeddb_schema_1.DbTargetGlobal.key)
	            .next(function (metadata) {
	            if (metadata !== null) {
	                _this.metadata = metadata;
	                var lastSavedVersion = metadata.lastRemoteSnapshotVersion;
	                _this.lastRemoteSnapshotVersion = snapshot_version_1.SnapshotVersion.fromTimestamp(new timestamp_1.Timestamp(lastSavedVersion.seconds, lastSavedVersion.nanos));
	            }
	            return persistence_promise_1.PersistencePromise.resolve();
	        });
	    };
	    IndexedDbQueryCache.prototype.getHighestTargetId = function () {
	        return this.metadata.highestTargetId;
	    };
	    IndexedDbQueryCache.prototype.getLastRemoteSnapshotVersion = function () {
	        return this.lastRemoteSnapshotVersion;
	    };
	    IndexedDbQueryCache.prototype.setLastRemoteSnapshotVersion = function (transaction, snapshotVersion) {
	        this.lastRemoteSnapshotVersion = snapshotVersion;
	        this.metadata.lastRemoteSnapshotVersion = snapshotVersion.toTimestamp();
	        return globalTargetStore(transaction).put(indexeddb_schema_1.DbTargetGlobal.key, this.metadata);
	    };
	    IndexedDbQueryCache.prototype.addQueryData = function (transaction, queryData) {
	        var _this = this;
	        var targetId = queryData.targetId;
	        var addedQueryPromise = targetsStore(transaction).put(this.serializer.toDbTarget(queryData));
	        if (targetId > this.metadata.highestTargetId) {
	            this.metadata.highestTargetId = targetId;
	            return addedQueryPromise.next(function () {
	                return globalTargetStore(transaction).put(indexeddb_schema_1.DbTargetGlobal.key, _this.metadata);
	            });
	        }
	        else {
	            return addedQueryPromise;
	        }
	    };
	    IndexedDbQueryCache.prototype.removeQueryData = function (transaction, queryData) {
	        return this.removeMatchingKeysForTargetId(transaction, queryData.targetId).next(function () {
	            targetsStore(transaction).delete(queryData.targetId);
	        });
	    };
	    IndexedDbQueryCache.prototype.getQueryData = function (transaction, query) {
	        var _this = this;
	        // Iterating by the canonicalId may yield more than one result because
	        // canonicalId values are not required to be unique per target. This query
	        // depends on the queryTargets index to be efficent.
	        var canonicalId = query.canonicalId();
	        var range = IDBKeyRange.bound([canonicalId, Number.NEGATIVE_INFINITY], [canonicalId, Number.POSITIVE_INFINITY]);
	        var result = null;
	        return targetsStore(transaction)
	            .iterate({ range: range, index: indexeddb_schema_1.DbTarget.queryTargetsIndexName }, function (key, value, control) {
	            var found = _this.serializer.fromDbTarget(value);
	            // After finding a potential match, check that the query is
	            // actually equal to the requested query.
	            if (query.isEqual(found.query)) {
	                result = found;
	                control.done();
	            }
	        })
	            .next(function () { return result; });
	    };
	    IndexedDbQueryCache.prototype.addMatchingKeys = function (txn, keys, targetId) {
	        // PORTING NOTE: The reverse index (documentsTargets) is maintained by
	        // Indexeddb.
	        var promises = [];
	        var store = documentTargetStore(txn);
	        keys.forEach(function (key) {
	            var path = EncodedResourcePath.encode(key.path);
	            promises.push(store.put(new indexeddb_schema_1.DbTargetDocument(targetId, path)));
	        });
	        return persistence_promise_1.PersistencePromise.waitFor(promises);
	    };
	    IndexedDbQueryCache.prototype.removeMatchingKeys = function (txn, keys, targetId) {
	        var _this = this;
	        // PORTING NOTE: The reverse index (documentsTargets) is maintained by
	        // IndexedDb.
	        var promises = [];
	        var store = documentTargetStore(txn);
	        keys.forEach(function (key) {
	            var path = EncodedResourcePath.encode(key.path);
	            promises.push(store.delete([targetId, path]));
	            if (_this.garbageCollector !== null) {
	                _this.garbageCollector.addPotentialGarbageKey(key);
	            }
	        });
	        return persistence_promise_1.PersistencePromise.waitFor(promises);
	    };
	    IndexedDbQueryCache.prototype.removeMatchingKeysForTargetId = function (txn, targetId) {
	        var store = documentTargetStore(txn);
	        var range = IDBKeyRange.bound([targetId], [targetId + 1], 
	        /*lowerOpen=*/ false, 
	        /*upperOpen=*/ true);
	        return this.notifyGCForRemovedKeys(txn, range).next(function () {
	            return store.delete(range);
	        });
	    };
	    IndexedDbQueryCache.prototype.notifyGCForRemovedKeys = function (txn, range) {
	        var _this = this;
	        var store = documentTargetStore(txn);
	        if (this.garbageCollector !== null && this.garbageCollector.isEager) {
	            // In order to generate garbage events properly, we need to read these
	            // keys before deleting.
	            return store.iterate({ range: range, keysOnly: true }, function (key, _, control) {
	                var path = EncodedResourcePath.decode(key[1]);
	                var docKey = new document_key_1.DocumentKey(path);
	                // Paranoid assertion in case the the collector is set to null
	                // during the iteration.
	                assert_1.assert(_this.garbageCollector !== null, 'GarbageCollector for query cache set to null during key removal.');
	                _this.garbageCollector.addPotentialGarbageKey(docKey);
	            });
	        }
	        else {
	            return persistence_promise_1.PersistencePromise.resolve();
	        }
	    };
	    IndexedDbQueryCache.prototype.getMatchingKeysForTargetId = function (txn, targetId) {
	        var promises = [];
	        var range = IDBKeyRange.bound([targetId], [targetId + 1], 
	        /*lowerOpen=*/ false, 
	        /*upperOpen=*/ true);
	        var store = documentTargetStore(txn);
	        var result = collections_1.documentKeySet();
	        return store
	            .iterate({ range: range, keysOnly: true }, function (key, _, control) {
	            var path = EncodedResourcePath.decode(key[1]);
	            var docKey = new document_key_1.DocumentKey(path);
	            result = result.add(docKey);
	        })
	            .next(function () { return result; });
	    };
	    IndexedDbQueryCache.prototype.setGarbageCollector = function (gc) {
	        this.garbageCollector = gc;
	    };
	    IndexedDbQueryCache.prototype.containsKey = function (txn, key) {
	        assert_1.assert(txn !== null, 'Persistence Transaction cannot be null for query cache containsKey');
	        var path = EncodedResourcePath.encode(key.path);
	        var range = IDBKeyRange.bound([path], [misc_1.immediateSuccessor(path)], 
	        /*lowerOpen=*/ false, 
	        /*upperOpen=*/ true);
	        var count = 0;
	        return documentTargetStore(txn)
	            .iterate({
	            index: indexeddb_schema_1.DbTargetDocument.documentTargetsIndex,
	            keysOnly: true,
	            range: range
	        }, function (key, _, control) {
	            count++;
	            control.done();
	        })
	            .next(function () { return count > 0; });
	    };
	    return IndexedDbQueryCache;
	}());
	exports.IndexedDbQueryCache = IndexedDbQueryCache;
	/**
	 * Helper to get a typed SimpleDbStore for the queries object store.
	 */
	function targetsStore(txn) {
	    return getStore(txn, indexeddb_schema_1.DbTarget.store);
	}
	/**
	 * Helper to get a typed SimpleDbStore for the target globals object store.
	 */
	function globalTargetStore(txn) {
	    return getStore(txn, indexeddb_schema_1.DbTargetGlobal.store);
	}
	/**
	 * Helper to get a typed SimpleDbStore for the document target object store.
	 */
	function documentTargetStore(txn) {
	    return getStore(txn, indexeddb_schema_1.DbTargetDocument.store);
	}
	/**
	 * Helper to get a typed SimpleDbStore from a transaction.
	 */
	function getStore(txn, store) {
	    if (txn instanceof simple_db_1.SimpleDbTransaction) {
	        return txn.store(store);
	    }
	    else {
	        return assert_1.fail('Invalid transaction object provided!');
	    }
	}
	
	//# sourceMappingURL=indexeddb_query_cache.js.map


/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var collections_1 = __webpack_require__(11);
	var document_1 = __webpack_require__(21);
	var assert_1 = __webpack_require__(2);
	var indexeddb_schema_1 = __webpack_require__(41);
	var simple_db_1 = __webpack_require__(74);
	var IndexedDbRemoteDocumentCache = /** @class */ (function () {
	    function IndexedDbRemoteDocumentCache(serializer) {
	        this.serializer = serializer;
	    }
	    IndexedDbRemoteDocumentCache.prototype.addEntry = function (transaction, maybeDocument) {
	        return remoteDocumentsStore(transaction).put(dbKey(maybeDocument.key), this.serializer.toDbRemoteDocument(maybeDocument));
	    };
	    IndexedDbRemoteDocumentCache.prototype.removeEntry = function (transaction, documentKey) {
	        return remoteDocumentsStore(transaction).delete(dbKey(documentKey));
	    };
	    IndexedDbRemoteDocumentCache.prototype.getEntry = function (transaction, documentKey) {
	        var _this = this;
	        return remoteDocumentsStore(transaction)
	            .get(dbKey(documentKey))
	            .next(function (dbRemoteDoc) {
	            return dbRemoteDoc
	                ? _this.serializer.fromDbRemoteDocument(dbRemoteDoc)
	                : null;
	        });
	    };
	    IndexedDbRemoteDocumentCache.prototype.getDocumentsMatchingQuery = function (transaction, query) {
	        var _this = this;
	        var results = collections_1.documentMap();
	        // Documents are ordered by key, so we can use a prefix scan to narrow down
	        // the documents we need to match the query against.
	        var startKey = query.path.toArray();
	        var range = IDBKeyRange.lowerBound(startKey);
	        return remoteDocumentsStore(transaction)
	            .iterate({ range: range }, function (key, dbRemoteDoc, control) {
	            var maybeDoc = _this.serializer.fromDbRemoteDocument(dbRemoteDoc);
	            if (!query.path.isPrefixOf(maybeDoc.key.path)) {
	                control.done();
	            }
	            else if (maybeDoc instanceof document_1.Document && query.matches(maybeDoc)) {
	                results = results.insert(maybeDoc.key, maybeDoc);
	            }
	        })
	            .next(function () { return results; });
	    };
	    return IndexedDbRemoteDocumentCache;
	}());
	exports.IndexedDbRemoteDocumentCache = IndexedDbRemoteDocumentCache;
	/**
	 * Helper to get a typed SimpleDbStore for the remoteDocuments object store.
	 */
	function remoteDocumentsStore(txn) {
	    if (txn instanceof simple_db_1.SimpleDbTransaction) {
	        return txn.store(indexeddb_schema_1.DbRemoteDocument.store);
	    }
	    else {
	        return assert_1.fail('Invalid transaction object provided!');
	    }
	}
	function dbKey(docKey) {
	    return docKey.path.toArray();
	}
	
	//# sourceMappingURL=indexeddb_remote_document_cache.js.map


/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var snapshot_version_1 = __webpack_require__(20);
	var collections_1 = __webpack_require__(11);
	var document_1 = __webpack_require__(21);
	var document_key_1 = __webpack_require__(12);
	var assert_1 = __webpack_require__(2);
	var persistence_promise_1 = __webpack_require__(18);
	/**
	 * A readonly view of the local state of all documents we're tracking (i.e. we
	 * have a cached version in remoteDocumentCache or local mutations for the
	 * document). The view is computed by applying the mutations in the
	 * MutationQueue to the RemoteDocumentCache.
	 */
	var LocalDocumentsView = /** @class */ (function () {
	    function LocalDocumentsView(remoteDocumentCache, mutationQueue) {
	        this.remoteDocumentCache = remoteDocumentCache;
	        this.mutationQueue = mutationQueue;
	    }
	    /**
	     * Get the local view of the document identified by `key`.
	     *
	     * @return Local view of the document or null if we don't have any cached
	     * state for it.
	     */
	    LocalDocumentsView.prototype.getDocument = function (transaction, key) {
	        var _this = this;
	        return this.remoteDocumentCache
	            .getEntry(transaction, key)
	            .next(function (remoteDoc) {
	            return _this.computeLocalDocument(transaction, key, remoteDoc);
	        });
	    };
	    /**
	     * Gets the local view of the documents identified by `keys`.
	     *
	     * If we don't have cached state for a document in `keys`, a NoDocument will
	     * be stored for that key in the resulting set.
	     */
	    LocalDocumentsView.prototype.getDocuments = function (transaction, keys) {
	        var _this = this;
	        var promises = [];
	        var results = collections_1.maybeDocumentMap();
	        keys.forEach(function (key) {
	            promises.push(_this.getDocument(transaction, key).next(function (maybeDoc) {
	                // TODO(http://b/32275378): Don't conflate missing / deleted.
	                if (!maybeDoc) {
	                    maybeDoc = new document_1.NoDocument(key, snapshot_version_1.SnapshotVersion.forDeletedDoc());
	                }
	                results = results.insert(key, maybeDoc);
	            }));
	        });
	        return persistence_promise_1.PersistencePromise.waitFor(promises).next(function () { return results; });
	    };
	    /** Performs a query against the local view of all documents. */
	    LocalDocumentsView.prototype.getDocumentsMatchingQuery = function (transaction, query) {
	        if (document_key_1.DocumentKey.isDocumentKey(query.path)) {
	            return this.getDocumentsMatchingDocumentQuery(transaction, query.path);
	        }
	        else {
	            return this.getDocumentsMatchingCollectionQuery(transaction, query);
	        }
	    };
	    LocalDocumentsView.prototype.getDocumentsMatchingDocumentQuery = function (transaction, docPath) {
	        // Just do a simple document lookup.
	        return this.getDocument(transaction, new document_key_1.DocumentKey(docPath)).next(function (maybeDoc) {
	            var result = collections_1.documentMap();
	            if (maybeDoc instanceof document_1.Document) {
	                result = result.insert(maybeDoc.key, maybeDoc);
	            }
	            return result;
	        });
	    };
	    LocalDocumentsView.prototype.getDocumentsMatchingCollectionQuery = function (transaction, query) {
	        var _this = this;
	        // Query the remote documents and overlay mutations.
	        // TODO(mikelehen): There may be significant overlap between the mutations
	        // affecting these remote documents and the
	        // getAllMutationBatchesAffectingQuery() mutations. Consider optimizing.
	        var results;
	        return this.remoteDocumentCache
	            .getDocumentsMatchingQuery(transaction, query)
	            .next(function (queryResults) {
	            return _this.computeLocalDocuments(transaction, queryResults);
	        })
	            .next(function (promisedResults) {
	            results = promisedResults;
	            // Now use the mutation queue to discover any other documents that may
	            // match the query after applying mutations.
	            return _this.mutationQueue.getAllMutationBatchesAffectingQuery(transaction, query);
	        })
	            .next(function (matchingMutationBatches) {
	            var matchingKeys = collections_1.documentKeySet();
	            for (var _i = 0, matchingMutationBatches_1 = matchingMutationBatches; _i < matchingMutationBatches_1.length; _i++) {
	                var batch = matchingMutationBatches_1[_i];
	                for (var _a = 0, _b = batch.mutations; _a < _b.length; _a++) {
	                    var mutation = _b[_a];
	                    // TODO(mikelehen): PERF: Check if this mutation actually
	                    // affects the query to reduce work.
	                    if (!results.get(mutation.key)) {
	                        matchingKeys = matchingKeys.add(mutation.key);
	                    }
	                }
	            }
	            // Now add in the results for the matchingKeys.
	            var promises = [];
	            matchingKeys.forEach(function (key) {
	                promises.push(_this.getDocument(transaction, key).next(function (doc) {
	                    if (doc instanceof document_1.Document) {
	                        results = results.insert(doc.key, doc);
	                    }
	                }));
	            });
	            return persistence_promise_1.PersistencePromise.waitFor(promises);
	        })
	            .next(function () {
	            // Finally, filter out any documents that don't actually match
	            // the query.
	            results.forEach(function (key, doc) {
	                if (!query.matches(doc)) {
	                    results = results.remove(key);
	                }
	            });
	            return results;
	        });
	    };
	    /**
	     * Takes a remote document and applies local mutations to generate the local
	     * view of the document.
	     * @param transaction The transaction in which to perform any persistence
	     *     operations.
	     * @param documentKey The key of the document (necessary when remoteDocument
	     *     is null).
	     * @param document The base remote document to apply mutations to or null.
	     */
	    LocalDocumentsView.prototype.computeLocalDocument = function (transaction, documentKey, document) {
	        return this.mutationQueue
	            .getAllMutationBatchesAffectingDocumentKey(transaction, documentKey)
	            .next(function (batches) {
	            for (var _i = 0, batches_1 = batches; _i < batches_1.length; _i++) {
	                var batch = batches_1[_i];
	                document = batch.applyToLocalView(documentKey, document);
	            }
	            return document;
	        });
	    };
	    /**
	     * Takes a set of remote documents and applies local mutations to generate the
	     * local view of the documents.
	     * @param transaction The transaction in which to perform any persistence
	     *     operations.
	     * @param documents The base remote documents to apply mutations to.
	     * @return The local view of the documents.
	     */
	    LocalDocumentsView.prototype.computeLocalDocuments = function (transaction, documents) {
	        var _this = this;
	        var promises = [];
	        documents.forEach(function (key, doc) {
	            promises.push(_this.computeLocalDocument(transaction, key, doc).next(function (mutatedDoc) {
	                if (mutatedDoc instanceof document_1.Document) {
	                    documents = documents.insert(mutatedDoc.key, mutatedDoc);
	                }
	                else if (mutatedDoc instanceof document_1.NoDocument) {
	                    documents = documents.remove(mutatedDoc.key);
	                }
	                else {
	                    assert_1.fail('Unknown MaybeDocument: ' + mutatedDoc);
	                }
	            }));
	        });
	        return persistence_promise_1.PersistencePromise.waitFor(promises).next(function () { return documents; });
	    };
	    return LocalDocumentsView;
	}());
	exports.LocalDocumentsView = LocalDocumentsView;
	
	//# sourceMappingURL=local_documents_view.js.map


/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var snapshot_version_1 = __webpack_require__(20);
	var timestamp_1 = __webpack_require__(40);
	var document_1 = __webpack_require__(21);
	var document_key_1 = __webpack_require__(12);
	var mutation_batch_1 = __webpack_require__(52);
	var assert_1 = __webpack_require__(2);
	var indexeddb_schema_1 = __webpack_require__(41);
	var query_data_1 = __webpack_require__(51);
	/** Serializer for values stored in the LocalStore. */
	var LocalSerializer = /** @class */ (function () {
	    function LocalSerializer(remoteSerializer) {
	        this.remoteSerializer = remoteSerializer;
	    }
	    /** Decodes a remote document from storage locally to a Document. */
	    LocalSerializer.prototype.fromDbRemoteDocument = function (remoteDoc) {
	        if (remoteDoc.document) {
	            return this.remoteSerializer.fromDocument(remoteDoc.document);
	        }
	        else if (remoteDoc.noDocument) {
	            var key = document_key_1.DocumentKey.fromSegments(remoteDoc.noDocument.path);
	            var readTime = remoteDoc.noDocument.readTime;
	            var timestamp = new timestamp_1.Timestamp(readTime.seconds, readTime.nanos);
	            return new document_1.NoDocument(key, snapshot_version_1.SnapshotVersion.fromTimestamp(timestamp));
	        }
	        else {
	            return assert_1.fail('Unexpected DbRemoteDocument');
	        }
	    };
	    /** Encodes a document for storage locally. */
	    LocalSerializer.prototype.toDbRemoteDocument = function (maybeDoc) {
	        if (maybeDoc instanceof document_1.Document) {
	            var doc = this.remoteSerializer.toDocument(maybeDoc);
	            return new indexeddb_schema_1.DbRemoteDocument(null, doc);
	        }
	        else {
	            var path = maybeDoc.key.path.toArray();
	            var timestamp = maybeDoc.version.toTimestamp();
	            var readTime = new indexeddb_schema_1.DbTimestamp(timestamp.seconds, timestamp.nanos);
	            return new indexeddb_schema_1.DbRemoteDocument(new indexeddb_schema_1.DbNoDocument(path, readTime), null);
	        }
	    };
	    /** Encodes a batch of mutations into a DbMutationBatch for local storage. */
	    LocalSerializer.prototype.toDbMutationBatch = function (userId, batch) {
	        var _this = this;
	        var serializedMutations = batch.mutations.map(function (m) {
	            return _this.remoteSerializer.toMutation(m);
	        });
	        return new indexeddb_schema_1.DbMutationBatch(userId, batch.batchId, batch.localWriteTime.toEpochMilliseconds(), serializedMutations);
	    };
	    /** Decodes a DbMutationBatch into a MutationBatch */
	    LocalSerializer.prototype.fromDbMutationBatch = function (dbBatch) {
	        var _this = this;
	        var mutations = dbBatch.mutations.map(function (m) {
	            return _this.remoteSerializer.fromMutation(m);
	        });
	        var timestamp = timestamp_1.Timestamp.fromEpochMilliseconds(dbBatch.localWriteTimeMs);
	        return new mutation_batch_1.MutationBatch(dbBatch.batchId, timestamp, mutations);
	    };
	    /** Decodes a DbTarget into QueryData */
	    LocalSerializer.prototype.fromDbTarget = function (dbTarget) {
	        var readTime = new timestamp_1.Timestamp(dbTarget.readTime.seconds, dbTarget.readTime.nanos);
	        var version = snapshot_version_1.SnapshotVersion.fromTimestamp(readTime);
	        var query;
	        if (isDocumentQuery(dbTarget.query)) {
	            query = this.remoteSerializer.fromDocumentsTarget(dbTarget.query);
	        }
	        else {
	            query = this.remoteSerializer.fromQueryTarget(dbTarget.query);
	        }
	        return new query_data_1.QueryData(query, dbTarget.targetId, query_data_1.QueryPurpose.Listen, version, dbTarget.resumeToken);
	    };
	    /** Encodes QueryData into a DbTarget for storage locally. */
	    LocalSerializer.prototype.toDbTarget = function (queryData) {
	        assert_1.assert(query_data_1.QueryPurpose.Listen === queryData.purpose, 'Only queries with purpose ' +
	            query_data_1.QueryPurpose.Listen +
	            ' may be stored, got ' +
	            queryData.purpose);
	        var timestamp = queryData.snapshotVersion.toTimestamp();
	        var dbTimestamp = new indexeddb_schema_1.DbTimestamp(timestamp.seconds, timestamp.nanos);
	        var queryProto;
	        if (queryData.query.isDocumentQuery()) {
	            queryProto = this.remoteSerializer.toDocumentsTarget(queryData.query);
	        }
	        else {
	            queryProto = this.remoteSerializer.toQueryTarget(queryData.query);
	        }
	        assert_1.assert(typeof queryData.resumeToken === 'string', 'Persisting non-string resume token not supported.');
	        var resumeToken = queryData.resumeToken;
	        // lastListenSequenceNumber is always 0 until we do real GC.
	        return new indexeddb_schema_1.DbTarget(queryData.targetId, queryData.query.canonicalId(), dbTimestamp, resumeToken, 0, queryProto);
	    };
	    return LocalSerializer;
	}());
	exports.LocalSerializer = LocalSerializer;
	/**
	 * A helper function for figuring out what kind of query has been stored.
	 */
	function isDocumentQuery(dbQuery) {
	    return dbQuery.documents !== undefined;
	}
	
	//# sourceMappingURL=local_serializer.js.map


/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var snapshot_version_1 = __webpack_require__(20);
	var target_id_generator_1 = __webpack_require__(160);
	var timestamp_1 = __webpack_require__(40);
	var collections_1 = __webpack_require__(11);
	var mutation_batch_1 = __webpack_require__(52);
	var remote_event_1 = __webpack_require__(53);
	var assert_1 = __webpack_require__(2);
	var log = __webpack_require__(13);
	var objUtils = __webpack_require__(27);
	var local_documents_view_1 = __webpack_require__(273);
	var persistence_promise_1 = __webpack_require__(18);
	var query_data_1 = __webpack_require__(51);
	var reference_set_1 = __webpack_require__(73);
	var remote_document_change_buffer_1 = __webpack_require__(282);
	var LOG_TAG = 'LocalStore';
	/**
	 * Local storage in the Firestore client. Coordinates persistence components
	 * like the mutation queue and remote document cache to present a
	 * latency-compensated view of stored data.
	 *
	 * The LocalStore is responsible for accepting mutations from the Sync Engine.
	 * Writes from the client are put into a queue as provisional Mutations until
	 * they are processed by the RemoteStore and confirmed as having been written
	 * to the server.
	 *
	 * The local store provides the local version of documents that have been
	 * modified locally. It maintains the constraint:
	 *
	 *   LocalDocument = RemoteDocument + Active(LocalMutations)
	 *
	 * (Active mutations are those that are enqueued and have not been previously
	 * acknowledged or rejected).
	 *
	 * The RemoteDocument ("ground truth") state is provided via the
	 * applyChangeBatch method. It will be some version of a server-provided
	 * document OR will be a server-provided document PLUS acknowledged mutations:
	 *
	 *   RemoteDocument' = RemoteDocument + Acknowledged(LocalMutations)
	 *
	 * Note that this "dirty" version of a RemoteDocument will not be identical to a
	 * server base version, since it has LocalMutations added to it pending getting
	 * an authoritative copy from the server.
	 *
	 * Since LocalMutations can be rejected by the server, we have to be able to
	 * revert a LocalMutation that has already been applied to the LocalDocument
	 * (typically done by replaying all remaining LocalMutations to the
	 * RemoteDocument to re-apply).
	 *
	 * The LocalStore is responsible for the garbage collection of the documents it
	 * contains. For now, it every doc referenced by a view, the mutation queue, or
	 * the RemoteStore.
	 *
	 * It also maintains the persistence of mapping queries to resume tokens and
	 * target ids. It needs to know this data about queries to properly know what
	 * docs it would be allowed to garbage collect.
	 *
	 * The LocalStore must be able to efficiently execute queries against its local
	 * cache of the documents, to provide the initial set of results before any
	 * remote changes have been received.
	 *
	 * Note: In TypeScript, most methods return Promises since the implementation
	 * may rely on fetching data from IndexedDB which is async.
	 * These Promises will only be rejected on an I/O error or other internal
	 * (unexpected) failure (e.g. failed assert) and always represent an
	 * unrecoverable error (should be caught / reported by the async_queue).
	 */
	var LocalStore = /** @class */ (function () {
	    function LocalStore(
	        /** Manages our in-memory or durable persistence. */
	        persistence, initialUser, 
	        /**
	         * The garbage collector collects documents that should no longer be
	         * cached (e.g. if they are no longer retained by the above reference sets
	         * and the garbage collector is performing eager collection).
	         */
	        garbageCollector) {
	        this.persistence = persistence;
	        this.garbageCollector = garbageCollector;
	        /**
	         * The set of document references maintained by any local views.
	         */
	        this.localViewReferences = new reference_set_1.ReferenceSet();
	        /** Maps a targetID to data about its query. */
	        this.targetIds = {};
	        /** Used to generate targetIDs for queries tracked locally. */
	        this.targetIdGenerator = target_id_generator_1.TargetIdGenerator.forLocalStore();
	        /**
	         * A heldBatchResult is a mutation batch result (from a write acknowledgement)
	         * that arrived before the watch stream got notified of a snapshot that
	         * includes the write. So we "hold" it until the watch stream catches up. It
	         * ensures that the local write remains visible (latency compensation) and
	         * doesn't temporarily appear reverted because the watch stream is slower than
	         * the write stream and so wasn't reflecting it.
	         *
	         * NOTE: Eventually we want to move this functionality into the remote store.
	         */
	        this.heldBatchResults = [];
	        this.mutationQueue = persistence.getMutationQueue(initialUser);
	        this.remoteDocuments = persistence.getRemoteDocumentCache();
	        this.queryCache = persistence.getQueryCache();
	        this.localDocuments = new local_documents_view_1.LocalDocumentsView(this.remoteDocuments, this.mutationQueue);
	        this.garbageCollector.addGarbageSource(this.localViewReferences);
	        this.garbageCollector.addGarbageSource(this.queryCache);
	        this.garbageCollector.addGarbageSource(this.mutationQueue);
	    }
	    /** Performs any initial startup actions required by the local store. */
	    LocalStore.prototype.start = function () {
	        var _this = this;
	        return this.persistence.runTransaction('Start LocalStore', function (txn) {
	            return _this.startMutationQueue(txn).next(function () { return _this.startQueryCache(txn); });
	        });
	    };
	    /**
	     * Tells the LocalStore that the currently authenticated user has changed.
	     *
	     * In response the local store switches the mutation queue to the new user and
	     * returns any resulting document changes.
	     */
	    LocalStore.prototype.handleUserChange = function (user) {
	        var _this = this;
	        return this.persistence.runTransaction('Handle user change', function (txn) {
	            // Swap out the mutation queue, grabbing the pending mutation batches
	            // before and after.
	            var oldBatches;
	            return _this.mutationQueue
	                .getAllMutationBatches(txn)
	                .next(function (promisedOldBatches) {
	                oldBatches = promisedOldBatches;
	                _this.garbageCollector.removeGarbageSource(_this.mutationQueue);
	                _this.mutationQueue = _this.persistence.getMutationQueue(user);
	                _this.garbageCollector.addGarbageSource(_this.mutationQueue);
	                return _this.startMutationQueue(txn);
	            })
	                .next(function () {
	                // Recreate our LocalDocumentsView using the new
	                // MutationQueue.
	                _this.localDocuments = new local_documents_view_1.LocalDocumentsView(_this.remoteDocuments, _this.mutationQueue);
	                return _this.mutationQueue.getAllMutationBatches(txn);
	            })
	                .next(function (newBatches) {
	                // Union the old/new changed keys.
	                var changedKeys = collections_1.documentKeySet();
	                for (var _i = 0, _a = [oldBatches, newBatches]; _i < _a.length; _i++) {
	                    var batches = _a[_i];
	                    for (var _b = 0, batches_1 = batches; _b < batches_1.length; _b++) {
	                        var batch = batches_1[_b];
	                        for (var _c = 0, _d = batch.mutations; _c < _d.length; _c++) {
	                            var mutation = _d[_c];
	                            changedKeys = changedKeys.add(mutation.key);
	                        }
	                    }
	                }
	                // Return the set of all (potentially) changed documents as the
	                // result of the user change.
	                return _this.localDocuments.getDocuments(txn, changedKeys);
	            });
	        });
	    };
	    LocalStore.prototype.startQueryCache = function (txn) {
	        var _this = this;
	        return this.queryCache.start(txn).next(function () {
	            var targetId = _this.queryCache.getHighestTargetId();
	            _this.targetIdGenerator = target_id_generator_1.TargetIdGenerator.forLocalStore(targetId);
	        });
	    };
	    LocalStore.prototype.startMutationQueue = function (txn) {
	        var _this = this;
	        return this.mutationQueue
	            .start(txn)
	            .next(function () {
	            // If we have any leftover mutation batch results from a prior run,
	            // just drop them.
	            // TODO(http://b/33446471): We probably need to repopulate
	            // heldBatchResults or similar instead, but that is not
	            // straightforward since we're not persisting the write ack versions.
	            _this.heldBatchResults = [];
	            return _this.mutationQueue.getHighestAcknowledgedBatchId(txn);
	        })
	            .next(function (highestAck) {
	            // TODO(mikelehen): This is the only usage of
	            // getAllMutationBatchesThroughBatchId(). Consider removing it in
	            // favor of a getAcknowledgedBatches() method.
	            if (highestAck !== mutation_batch_1.BATCHID_UNKNOWN) {
	                return _this.mutationQueue.getAllMutationBatchesThroughBatchId(txn, highestAck);
	            }
	            else {
	                return persistence_promise_1.PersistencePromise.resolve([]);
	            }
	        })
	            .next(function (ackedBatches) {
	            if (ackedBatches.length > 0) {
	                return _this.mutationQueue.removeMutationBatches(txn, ackedBatches);
	            }
	            else {
	                return persistence_promise_1.PersistencePromise.resolve();
	            }
	        });
	    };
	    /* Accept locally generated Mutations and commit them to storage. */
	    LocalStore.prototype.localWrite = function (mutations) {
	        var _this = this;
	        return this.persistence.runTransaction('Locally write mutations', function (txn) {
	            var batch;
	            var localWriteTime = timestamp_1.Timestamp.now();
	            return _this.mutationQueue
	                .addMutationBatch(txn, localWriteTime, mutations)
	                .next(function (promisedBatch) {
	                batch = promisedBatch;
	                // TODO(koss): This is doing an N^2 update by replaying ALL the
	                // mutations on each document (instead of just the ones added) in
	                // this batch.
	                var keys = batch.keys();
	                return _this.localDocuments.getDocuments(txn, keys);
	            })
	                .next(function (changedDocuments) {
	                return { batchId: batch.batchId, changes: changedDocuments };
	            });
	        });
	    };
	    /**
	     * Acknowledge the given batch.
	     *
	     * On the happy path when a batch is acknowledged, the local store will
	     *
	     *  + remove the batch from the mutation queue;
	     *  + apply the changes to the remote document cache;
	     *  + recalculate the latency compensated view implied by those changes (there
	     *    may be mutations in the queue that affect the documents but haven't been
	     *    acknowledged yet); and
	     *  + give the changed documents back the sync engine
	     *
	     * @returns The resulting (modified) documents.
	     */
	    LocalStore.prototype.acknowledgeBatch = function (batchResult) {
	        var _this = this;
	        return this.persistence.runTransaction('Acknowledge batch', function (txn) {
	            var affected;
	            return _this.mutationQueue
	                .acknowledgeBatch(txn, batchResult.batch, batchResult.streamToken)
	                .next(function () {
	                if (_this.shouldHoldBatchResult(batchResult.commitVersion)) {
	                    _this.heldBatchResults.push(batchResult);
	                    affected = collections_1.documentKeySet();
	                    return persistence_promise_1.PersistencePromise.resolve();
	                }
	                else {
	                    var documentBuffer_1 = new remote_document_change_buffer_1.RemoteDocumentChangeBuffer(_this.remoteDocuments);
	                    return _this.releaseBatchResults(txn, [batchResult], documentBuffer_1).next(function (promisedAffectedKeys) {
	                        affected = promisedAffectedKeys;
	                        return documentBuffer_1.apply(txn);
	                    });
	                }
	            })
	                .next(function () {
	                return _this.mutationQueue.performConsistencyCheck(txn);
	            })
	                .next(function () {
	                return _this.localDocuments.getDocuments(txn, affected);
	            });
	        });
	    };
	    /**
	     * Remove mutations from the MutationQueue for the specified batch;
	     * LocalDocuments will be recalculated.
	     *
	     * @returns The resulting modified documents.
	     */
	    LocalStore.prototype.rejectBatch = function (batchId) {
	        var _this = this;
	        return this.persistence.runTransaction('Reject batch', function (txn) {
	            var toReject;
	            var affectedKeys;
	            return _this.mutationQueue
	                .lookupMutationBatch(txn, batchId)
	                .next(function (promisedToReject) {
	                assert_1.assert(promisedToReject != null, 'Attempt to reject nonexistent batch!');
	                toReject = promisedToReject;
	                return _this.mutationQueue
	                    .getHighestAcknowledgedBatchId(txn)
	                    .next(function (lastAcked) {
	                    assert_1.assert(batchId > lastAcked, "Acknowledged batches can't be rejected.");
	                    return toReject;
	                });
	            })
	                .next(function () {
	                return _this.removeMutationBatch(txn, toReject);
	            })
	                .next(function (promisedAffectedKeys) {
	                affectedKeys = promisedAffectedKeys;
	                return _this.mutationQueue.performConsistencyCheck(txn);
	            })
	                .next(function () {
	                return _this.localDocuments.getDocuments(txn, affectedKeys);
	            });
	        });
	    };
	    /** Returns the last recorded stream token for the current user. */
	    LocalStore.prototype.getLastStreamToken = function () {
	        var _this = this;
	        return this.persistence.runTransaction('Get last stream token', function (txn) {
	            return _this.mutationQueue.getLastStreamToken(txn);
	        });
	    };
	    /**
	     * Sets the stream token for the current user without acknowledging any
	     * mutation batch. This is usually only useful after a stream handshake or in
	     * response to an error that requires clearing the stream token.
	     */
	    LocalStore.prototype.setLastStreamToken = function (streamToken) {
	        var _this = this;
	        return this.persistence.runTransaction('Set last stream token', function (txn) {
	            return _this.mutationQueue.setLastStreamToken(txn, streamToken);
	        });
	    };
	    /**
	     * Returns the last consistent snapshot processed (used by the RemoteStore to
	     * determine whether to buffer incoming snapshots from the backend).
	     */
	    LocalStore.prototype.getLastRemoteSnapshotVersion = function () {
	        return this.queryCache.getLastRemoteSnapshotVersion();
	    };
	    /**
	     * Update the "ground-state" (remote) documents. We assume that the remote
	     * event reflects any write batches that have been acknowledged or rejected
	     * (i.e. we do not re-apply local mutations to updates from this event).
	     *
	     * LocalDocuments are re-calculated if there are remaining mutations in the
	     * queue.
	     */
	    LocalStore.prototype.applyRemoteEvent = function (remoteEvent) {
	        var _this = this;
	        var documentBuffer = new remote_document_change_buffer_1.RemoteDocumentChangeBuffer(this.remoteDocuments);
	        return this.persistence.runTransaction('Apply remote event', function (txn) {
	            var promises = [];
	            objUtils.forEachNumber(remoteEvent.targetChanges, function (targetId, change) {
	                // Do not ref/unref unassigned targetIds - it may lead to leaks.
	                var queryData = _this.targetIds[targetId];
	                if (!queryData)
	                    return;
	                var mapping = change.mapping;
	                if (mapping) {
	                    // First make sure that all references are deleted
	                    if (mapping instanceof remote_event_1.ResetMapping) {
	                        promises.push(_this.queryCache
	                            .removeMatchingKeysForTargetId(txn, targetId)
	                            .next(function () {
	                            return _this.queryCache.addMatchingKeys(txn, mapping.documents, targetId);
	                        }));
	                    }
	                    else if (mapping instanceof remote_event_1.UpdateMapping) {
	                        promises.push(_this.queryCache
	                            .removeMatchingKeys(txn, mapping.removedDocuments, targetId)
	                            .next(function () {
	                            return _this.queryCache.addMatchingKeys(txn, mapping.addedDocuments, targetId);
	                        }));
	                    }
	                    else {
	                        return assert_1.fail('Unknown mapping type: ' + JSON.stringify(mapping));
	                    }
	                }
	                // Update the resume token if the change includes one. Don't clear
	                // any preexisting value.
	                var resumeToken = change.resumeToken;
	                if (resumeToken.length > 0) {
	                    queryData = queryData.update({
	                        resumeToken: resumeToken,
	                        snapshotVersion: change.snapshotVersion
	                    });
	                    _this.targetIds[targetId] = queryData;
	                    promises.push(_this.queryCache.addQueryData(txn, queryData));
	                }
	            });
	            var changedDocKeys = collections_1.documentKeySet();
	            remoteEvent.documentUpdates.forEach(function (key, doc) {
	                changedDocKeys = changedDocKeys.add(key);
	                promises.push(documentBuffer.getEntry(txn, key).next(function (existingDoc) {
	                    // Make sure we don't apply an old document version to the remote
	                    // cache, though we make an exception for SnapshotVersion.MIN which
	                    // can happen for manufactured events (e.g. in the case of a limbo
	                    // document resolution failing).
	                    if (existingDoc == null ||
	                        doc.version.isEqual(snapshot_version_1.SnapshotVersion.MIN) ||
	                        doc.version.compareTo(existingDoc.version) >= 0) {
	                        documentBuffer.addEntry(doc);
	                    }
	                    else {
	                        log.debug(LOG_TAG, 'Ignoring outdated watch update for ', key, '. Current version:', existingDoc.version, ' Watch version:', doc.version);
	                    }
	                    // The document might be garbage because it was unreferenced by
	                    // everything. Make sure to mark it as garbage if it is...
	                    _this.garbageCollector.addPotentialGarbageKey(key);
	                }));
	            });
	            // HACK: The only reason we allow a null snapshot version is so that we
	            // can synthesize remote events when we get permission denied errors while
	            // trying to resolve the state of a locally cached document that is in
	            // limbo.
	            var lastRemoteVersion = _this.queryCache.getLastRemoteSnapshotVersion();
	            var remoteVersion = remoteEvent.snapshotVersion;
	            if (!remoteVersion.isEqual(snapshot_version_1.SnapshotVersion.MIN)) {
	                assert_1.assert(remoteVersion.compareTo(lastRemoteVersion) >= 0, 'Watch stream reverted to previous snapshot?? ' +
	                    remoteVersion +
	                    ' < ' +
	                    lastRemoteVersion);
	                promises.push(_this.queryCache.setLastRemoteSnapshotVersion(txn, remoteVersion));
	            }
	            var releasedWriteKeys;
	            return persistence_promise_1.PersistencePromise.waitFor(promises)
	                .next(function () { return _this.releaseHeldBatchResults(txn, documentBuffer); })
	                .next(function (promisedReleasedWriteKeys) {
	                releasedWriteKeys = promisedReleasedWriteKeys;
	                return documentBuffer.apply(txn);
	            })
	                .next(function () {
	                return _this.localDocuments.getDocuments(txn, changedDocKeys.unionWith(releasedWriteKeys));
	            });
	        });
	    };
	    /**
	     * Notify local store of the changed views to locally pin documents.
	     */
	    LocalStore.prototype.notifyLocalViewChanges = function (viewChanges) {
	        var _this = this;
	        return this.persistence.runTransaction('Notify local view changes', function (txn) {
	            var promises = [];
	            var _loop_1 = function (view) {
	                promises.push(_this.queryCache
	                    .getQueryData(txn, view.query)
	                    .next(function (queryData) {
	                    assert_1.assert(queryData !== null, 'Local view changes contain unallocated query.');
	                    var targetId = queryData.targetId;
	                    _this.localViewReferences.addReferences(view.addedKeys, targetId);
	                    _this.localViewReferences.removeReferences(view.removedKeys, targetId);
	                }));
	            };
	            for (var _i = 0, viewChanges_1 = viewChanges; _i < viewChanges_1.length; _i++) {
	                var view = viewChanges_1[_i];
	                _loop_1(view);
	            }
	            return persistence_promise_1.PersistencePromise.waitFor(promises);
	        });
	    };
	    /**
	     * Gets the mutation batch after the passed in batchId in the mutation queue
	     * or null if empty.
	     * @param afterBatchId If provided, the batch to search after.
	     * @returns The next mutation or null if there wasn't one.
	     */
	    LocalStore.prototype.nextMutationBatch = function (afterBatchId) {
	        var _this = this;
	        return this.persistence.runTransaction('Get next mutation batch', function (txn) {
	            if (afterBatchId === undefined) {
	                afterBatchId = mutation_batch_1.BATCHID_UNKNOWN;
	            }
	            return _this.mutationQueue.getNextMutationBatchAfterBatchId(txn, afterBatchId);
	        });
	    };
	    /**
	     * Read the current value of a Document with a given key or null if not
	     * found - used for testing.
	     */
	    LocalStore.prototype.readDocument = function (key) {
	        var _this = this;
	        return this.persistence.runTransaction('read document', function (txn) {
	            return _this.localDocuments.getDocument(txn, key);
	        });
	    };
	    /**
	     * Assigns the given query an internal ID so that its results can be pinned so
	     * they don't get GC'd. A query must be allocated in the local store before
	     * the store can be used to manage its view.
	     */
	    LocalStore.prototype.allocateQuery = function (query) {
	        var _this = this;
	        return this.persistence.runTransaction('Allocate query', function (txn) {
	            var queryData;
	            return _this.queryCache
	                .getQueryData(txn, query)
	                .next(function (cached) {
	                if (cached) {
	                    // This query has been listened to previously, so reuse the
	                    // previous targetID.
	                    // TODO(mcg): freshen last accessed date?
	                    queryData = cached;
	                    return persistence_promise_1.PersistencePromise.resolve();
	                }
	                else {
	                    var targetId = _this.targetIdGenerator.next();
	                    queryData = new query_data_1.QueryData(query, targetId, query_data_1.QueryPurpose.Listen);
	                    return _this.queryCache.addQueryData(txn, queryData);
	                }
	            })
	                .next(function () {
	                assert_1.assert(!_this.targetIds[queryData.targetId], 'Tried to allocate an already allocated query: ' + query);
	                _this.targetIds[queryData.targetId] = queryData;
	                return queryData;
	            });
	        });
	    };
	    /** Unpin all the documents associated with the given query. */
	    LocalStore.prototype.releaseQuery = function (query) {
	        var _this = this;
	        return this.persistence.runTransaction('Release query', function (txn) {
	            return _this.queryCache
	                .getQueryData(txn, query)
	                .next(function (queryData) {
	                assert_1.assert(queryData != null, 'Tried to release nonexistent query: ' + query);
	                _this.localViewReferences.removeReferencesForId(queryData.targetId);
	                delete _this.targetIds[queryData.targetId];
	                if (_this.garbageCollector.isEager) {
	                    return _this.queryCache.removeQueryData(txn, queryData);
	                }
	                else {
	                    return persistence_promise_1.PersistencePromise.resolve();
	                }
	            })
	                .next(function () {
	                // If this was the last watch target, then we won't get any more
	                // watch snapshots, so we should release any held batch results.
	                if (objUtils.isEmpty(_this.targetIds)) {
	                    var documentBuffer_2 = new remote_document_change_buffer_1.RemoteDocumentChangeBuffer(_this.remoteDocuments);
	                    return _this.releaseHeldBatchResults(txn, documentBuffer_2).next(function () {
	                        documentBuffer_2.apply(txn);
	                    });
	                }
	                else {
	                    return persistence_promise_1.PersistencePromise.resolve();
	                }
	            });
	        });
	    };
	    /**
	     * Runs the specified query against all the documents in the local store and
	     * returns the results.
	     */
	    LocalStore.prototype.executeQuery = function (query) {
	        var _this = this;
	        return this.persistence.runTransaction('Execute query', function (txn) {
	            return _this.localDocuments.getDocumentsMatchingQuery(txn, query);
	        });
	    };
	    /**
	     * Returns the keys of the documents that are associated with the given
	     * target id in the remote table.
	     */
	    LocalStore.prototype.remoteDocumentKeys = function (targetId) {
	        var _this = this;
	        return this.persistence.runTransaction('Remote document keys', function (txn) {
	            return _this.queryCache.getMatchingKeysForTargetId(txn, targetId);
	        });
	    };
	    /**
	     * Collect garbage if necessary.
	     * Should be called periodically by Sync Engine to recover resources. The
	     * implementation must guarantee that GC won't happen in other places than
	     * this method call.
	     */
	    LocalStore.prototype.collectGarbage = function () {
	        var _this = this;
	        // Call collectGarbage regardless of whether isGCEnabled so the referenceSet
	        // doesn't continue to accumulate the garbage keys.
	        return this.persistence.runTransaction('Garbage collection', function (txn) {
	            return _this.garbageCollector.collectGarbage(txn).next(function (garbage) {
	                var promises = [];
	                garbage.forEach(function (key) {
	                    promises.push(_this.remoteDocuments.removeEntry(txn, key));
	                });
	                return persistence_promise_1.PersistencePromise.waitFor(promises);
	            });
	        });
	    };
	    LocalStore.prototype.releaseHeldBatchResults = function (txn, documentBuffer) {
	        var toRelease = [];
	        for (var _i = 0, _a = this.heldBatchResults; _i < _a.length; _i++) {
	            var batchResult = _a[_i];
	            if (!this.isRemoteUpToVersion(batchResult.commitVersion)) {
	                break;
	            }
	            toRelease.push(batchResult);
	        }
	        if (toRelease.length === 0) {
	            return persistence_promise_1.PersistencePromise.resolve(collections_1.documentKeySet());
	        }
	        else {
	            this.heldBatchResults.splice(0, toRelease.length);
	            return this.releaseBatchResults(txn, toRelease, documentBuffer);
	        }
	    };
	    LocalStore.prototype.isRemoteUpToVersion = function (version) {
	        // If there are no watch targets, then we won't get remote snapshots, and
	        // we are always "up-to-date."
	        var lastRemoteVersion = this.queryCache.getLastRemoteSnapshotVersion();
	        return (version.compareTo(lastRemoteVersion) <= 0 ||
	            objUtils.isEmpty(this.targetIds));
	    };
	    LocalStore.prototype.shouldHoldBatchResult = function (version) {
	        // Check if watcher isn't up to date or prior results are already held.
	        return (!this.isRemoteUpToVersion(version) || this.heldBatchResults.length > 0);
	    };
	    LocalStore.prototype.releaseBatchResults = function (txn, batchResults, documentBuffer) {
	        var _this = this;
	        var promiseChain = persistence_promise_1.PersistencePromise.resolve();
	        var _loop_2 = function (batchResult) {
	            promiseChain = promiseChain.next(function () {
	                return _this.applyWriteToRemoteDocuments(txn, batchResult, documentBuffer);
	            });
	        };
	        for (var _i = 0, batchResults_1 = batchResults; _i < batchResults_1.length; _i++) {
	            var batchResult = batchResults_1[_i];
	            _loop_2(batchResult);
	        }
	        return promiseChain.next(function () {
	            return _this.removeMutationBatches(txn, batchResults.map(function (result) { return result.batch; }));
	        });
	    };
	    LocalStore.prototype.removeMutationBatch = function (txn, batch) {
	        return this.removeMutationBatches(txn, [batch]);
	    };
	    /** Removes all the mutation batches named in the given array. */
	    LocalStore.prototype.removeMutationBatches = function (txn, batches) {
	        var affectedDocs = collections_1.documentKeySet();
	        for (var _i = 0, batches_2 = batches; _i < batches_2.length; _i++) {
	            var batch = batches_2[_i];
	            for (var _a = 0, _b = batch.mutations; _a < _b.length; _a++) {
	                var mutation = _b[_a];
	                var key = mutation.key;
	                affectedDocs = affectedDocs.add(key);
	            }
	        }
	        return this.mutationQueue
	            .removeMutationBatches(txn, batches)
	            .next(function () { return affectedDocs; });
	    };
	    LocalStore.prototype.applyWriteToRemoteDocuments = function (txn, batchResult, documentBuffer) {
	        var batch = batchResult.batch;
	        var docKeys = batch.keys();
	        var promiseChain = persistence_promise_1.PersistencePromise.resolve();
	        docKeys.forEach(function (docKey) {
	            promiseChain = promiseChain
	                .next(function () {
	                return documentBuffer.getEntry(txn, docKey);
	            })
	                .next(function (remoteDoc) {
	                var doc = remoteDoc;
	                var ackVersion = batchResult.docVersions.get(docKey);
	                assert_1.assert(ackVersion !== null, 'ackVersions should contain every doc in the write.');
	                if (!doc || doc.version.compareTo(ackVersion) < 0) {
	                    doc = batch.applyToRemoteDocument(docKey, doc, batchResult);
	                    if (!doc) {
	                        assert_1.assert(!remoteDoc, 'Mutation batch ' +
	                            batch +
	                            ' applied to document ' +
	                            remoteDoc +
	                            ' resulted in null');
	                    }
	                    else {
	                        documentBuffer.addEntry(doc);
	                    }
	                }
	            });
	        });
	        return promiseChain;
	    };
	    return LocalStore;
	}());
	exports.LocalStore = LocalStore;
	
	//# sourceMappingURL=local_store.js.map


/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var view_snapshot_1 = __webpack_require__(72);
	var collections_1 = __webpack_require__(11);
	/**
	 * A set of changes to what documents are currently in view and out of view for
	 * a given query. These changes are sent to the LocalStore by the View (via
	 * the SyncEngine) and are used to pin / unpin documents as appropriate.
	 */
	var LocalViewChanges = /** @class */ (function () {
	    function LocalViewChanges(query, addedKeys, removedKeys) {
	        this.query = query;
	        this.addedKeys = addedKeys;
	        this.removedKeys = removedKeys;
	    }
	    LocalViewChanges.fromSnapshot = function (viewSnapshot) {
	        var addedKeys = collections_1.documentKeySet();
	        var removedKeys = collections_1.documentKeySet();
	        for (var _i = 0, _a = viewSnapshot.docChanges; _i < _a.length; _i++) {
	            var docChange = _a[_i];
	            switch (docChange.type) {
	                case view_snapshot_1.ChangeType.Added:
	                    addedKeys = addedKeys.add(docChange.doc.key);
	                    break;
	                case view_snapshot_1.ChangeType.Removed:
	                    removedKeys = removedKeys.add(docChange.doc.key);
	                    break;
	                default:
	            }
	        }
	        return new LocalViewChanges(viewSnapshot.query, addedKeys, removedKeys);
	    };
	    return LocalViewChanges;
	}());
	exports.LocalViewChanges = LocalViewChanges;
	
	//# sourceMappingURL=local_view_changes.js.map


/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var document_key_1 = __webpack_require__(12);
	var mutation_batch_1 = __webpack_require__(52);
	var platform_1 = __webpack_require__(29);
	var assert_1 = __webpack_require__(2);
	var misc_1 = __webpack_require__(14);
	var sorted_set_1 = __webpack_require__(76);
	var persistence_promise_1 = __webpack_require__(18);
	var reference_set_1 = __webpack_require__(73);
	var MemoryMutationQueue = /** @class */ (function () {
	    function MemoryMutationQueue() {
	        /**
	         * The set of all mutations that have been sent but not yet been applied to
	         * the backend.
	         */
	        this.mutationQueue = [];
	        /** Next value to use when assigning sequential IDs to each mutation batch. */
	        this.nextBatchId = 1;
	        /** The highest acknowledged mutation in the queue. */
	        this.highestAcknowledgedBatchId = mutation_batch_1.BATCHID_UNKNOWN;
	        /** The last received stream token from the server, used to acknowledge which
	         * responses the client has processed. Stream tokens are opaque checkpoint
	         * markers whose only real value is their inclusion in the next request.
	         */
	        this.lastStreamToken = platform_1.emptyByteString();
	        /** The garbage collector to notify about potential garbage keys. */
	        this.garbageCollector = null;
	        /** An ordered mapping between documents and the mutations batch IDs. */
	        this.batchesByDocumentKey = new sorted_set_1.SortedSet(reference_set_1.DocReference.compareByKey);
	    }
	    MemoryMutationQueue.prototype.start = function (transaction) {
	        // NOTE: The queue may be shutdown / started multiple times, since we
	        // maintain the queue for the duration of the app session in case a user
	        // logs out / back in. To behave like the LevelDB-backed MutationQueue (and
	        // accommodate tests that expect as much), we reset nextBatchId and
	        // highestAcknowledgedBatchId if the queue is empty.
	        if (this.mutationQueue.length === 0) {
	            this.nextBatchId = 1;
	            this.highestAcknowledgedBatchId = mutation_batch_1.BATCHID_UNKNOWN;
	        }
	        assert_1.assert(this.highestAcknowledgedBatchId < this.nextBatchId, 'highestAcknowledgedBatchId must be less than the nextBatchId');
	        return persistence_promise_1.PersistencePromise.resolve();
	    };
	    MemoryMutationQueue.prototype.checkEmpty = function (transaction) {
	        return persistence_promise_1.PersistencePromise.resolve(this.mutationQueue.length === 0);
	    };
	    MemoryMutationQueue.prototype.getNextBatchId = function (transaction) {
	        return persistence_promise_1.PersistencePromise.resolve(this.nextBatchId);
	    };
	    MemoryMutationQueue.prototype.getHighestAcknowledgedBatchId = function (transaction) {
	        return persistence_promise_1.PersistencePromise.resolve(this.highestAcknowledgedBatchId);
	    };
	    MemoryMutationQueue.prototype.acknowledgeBatch = function (transaction, batch, streamToken) {
	        var batchId = batch.batchId;
	        assert_1.assert(batchId > this.highestAcknowledgedBatchId, 'Mutation batchIDs must be acknowledged in order');
	        var batchIndex = this.indexOfExistingBatchId(batchId, 'acknowledged');
	        // Verify that the batch in the queue is the one to be acknowledged.
	        var check = this.mutationQueue[batchIndex];
	        assert_1.assert(batchId === check.batchId, 'Queue ordering failure: expected batch ' +
	            batchId +
	            ', got batch ' +
	            check.batchId);
	        assert_1.assert(!check.isTombstone(), "Can't acknowledge a previously removed batch");
	        this.highestAcknowledgedBatchId = batchId;
	        this.lastStreamToken = streamToken;
	        return persistence_promise_1.PersistencePromise.resolve();
	    };
	    MemoryMutationQueue.prototype.getLastStreamToken = function (transaction) {
	        return persistence_promise_1.PersistencePromise.resolve(this.lastStreamToken);
	    };
	    MemoryMutationQueue.prototype.setLastStreamToken = function (transaction, streamToken) {
	        this.lastStreamToken = streamToken;
	        return persistence_promise_1.PersistencePromise.resolve();
	    };
	    MemoryMutationQueue.prototype.addMutationBatch = function (transaction, localWriteTime, mutations) {
	        assert_1.assert(mutations.length !== 0, 'Mutation batches should not be empty');
	        var batchId = this.nextBatchId;
	        this.nextBatchId++;
	        if (this.mutationQueue.length > 0) {
	            var prior = this.mutationQueue[this.mutationQueue.length - 1];
	            assert_1.assert(prior.batchId < batchId, 'Mutation batchIDs must be monotonically increasing order');
	        }
	        var batch = new mutation_batch_1.MutationBatch(batchId, localWriteTime, mutations);
	        this.mutationQueue.push(batch);
	        // Track references by document key.
	        for (var _i = 0, mutations_1 = mutations; _i < mutations_1.length; _i++) {
	            var mutation = mutations_1[_i];
	            this.batchesByDocumentKey = this.batchesByDocumentKey.add(new reference_set_1.DocReference(mutation.key, batchId));
	        }
	        return persistence_promise_1.PersistencePromise.resolve(batch);
	    };
	    MemoryMutationQueue.prototype.lookupMutationBatch = function (transaction, batchId) {
	        return persistence_promise_1.PersistencePromise.resolve(this.findMutationBatch(batchId));
	    };
	    MemoryMutationQueue.prototype.getNextMutationBatchAfterBatchId = function (transaction, batchId) {
	        var size = this.mutationQueue.length;
	        // All batches with batchId <= this.highestAcknowledgedBatchId have been
	        // acknowledged so the first unacknowledged batch after batchID will have a
	        // batchID larger than both of these values.
	        batchId = Math.max(batchId + 1, this.highestAcknowledgedBatchId);
	        // The requested batchId may still be out of range so normalize it to the
	        // start of the queue.
	        var rawIndex = this.indexOfBatchId(batchId);
	        var index = rawIndex < 0 ? 0 : rawIndex;
	        // Finally return the first non-tombstone batch.
	        for (; index < size; index++) {
	            var batch = this.mutationQueue[index];
	            if (!batch.isTombstone()) {
	                return persistence_promise_1.PersistencePromise.resolve(batch);
	            }
	        }
	        return persistence_promise_1.PersistencePromise.resolve(null);
	    };
	    MemoryMutationQueue.prototype.getAllMutationBatches = function (transaction) {
	        return persistence_promise_1.PersistencePromise.resolve(this.getAllLiveMutationBatchesBeforeIndex(this.mutationQueue.length));
	    };
	    MemoryMutationQueue.prototype.getAllMutationBatchesThroughBatchId = function (transaction, batchId) {
	        var count = this.mutationQueue.length;
	        var endIndex = this.indexOfBatchId(batchId);
	        if (endIndex < 0) {
	            endIndex = 0;
	        }
	        else if (endIndex >= count) {
	            endIndex = count;
	        }
	        else {
	            // The endIndex is in the queue so increment to pull everything in the
	            // queue including it.
	            endIndex++;
	        }
	        return persistence_promise_1.PersistencePromise.resolve(this.getAllLiveMutationBatchesBeforeIndex(endIndex));
	    };
	    MemoryMutationQueue.prototype.getAllMutationBatchesAffectingDocumentKey = function (transaction, documentKey) {
	        var _this = this;
	        var start = new reference_set_1.DocReference(documentKey, 0);
	        var end = new reference_set_1.DocReference(documentKey, Number.POSITIVE_INFINITY);
	        var result = [];
	        this.batchesByDocumentKey.forEachInRange([start, end], function (ref) {
	            assert_1.assert(documentKey.isEqual(ref.key), "Should only iterate over a single key's batches");
	            var batch = _this.findMutationBatch(ref.targetOrBatchId);
	            assert_1.assert(batch !== null, 'Batches in the index must exist in the main table');
	            result.push(batch);
	        });
	        return persistence_promise_1.PersistencePromise.resolve(result);
	    };
	    MemoryMutationQueue.prototype.getAllMutationBatchesAffectingQuery = function (transaction, query) {
	        var _this = this;
	        // Use the query path as a prefix for testing if a document matches the
	        // query.
	        var prefix = query.path;
	        var immediateChildrenPathLength = prefix.length + 1;
	        // Construct a document reference for actually scanning the index. Unlike
	        // the prefix the document key in this reference must have an even number of
	        // segments. The empty segment can be used a suffix of the query path
	        // because it precedes all other segments in an ordered traversal.
	        var startPath = prefix;
	        if (!document_key_1.DocumentKey.isDocumentKey(startPath)) {
	            startPath = startPath.child('');
	        }
	        var start = new reference_set_1.DocReference(new document_key_1.DocumentKey(startPath), 0);
	        // Find unique batchIDs referenced by all documents potentially matching the
	        // query.
	        var uniqueBatchIDs = new sorted_set_1.SortedSet(misc_1.primitiveComparator);
	        this.batchesByDocumentKey.forEachWhile(function (ref) {
	            var rowKeyPath = ref.key.path;
	            if (!prefix.isPrefixOf(rowKeyPath)) {
	                return false;
	            }
	            else {
	                // Rows with document keys more than one segment longer than the query
	                // path can't be matches. For example, a query on 'rooms' can't match
	                // the document /rooms/abc/messages/xyx.
	                // TODO(mcg): we'll need a different scanner when we implement
	                // ancestor queries.
	                if (rowKeyPath.length === immediateChildrenPathLength) {
	                    uniqueBatchIDs = uniqueBatchIDs.add(ref.targetOrBatchId);
	                }
	                return true;
	            }
	        }, start);
	        // Construct an array of matching batches, sorted by batchID to ensure that
	        // multiple mutations affecting the same document key are applied in order.
	        var result = [];
	        uniqueBatchIDs.forEach(function (batchId) {
	            var batch = _this.findMutationBatch(batchId);
	            if (batch !== null) {
	                result.push(batch);
	            }
	        });
	        return persistence_promise_1.PersistencePromise.resolve(result);
	    };
	    MemoryMutationQueue.prototype.removeMutationBatches = function (transaction, batches) {
	        var batchCount = batches.length;
	        assert_1.assert(batchCount > 0, 'Should not remove mutations when none exist.');
	        var firstBatchId = batches[0].batchId;
	        var queueCount = this.mutationQueue.length;
	        // Find the position of the first batch for removal. This need not be the
	        // first entry in the queue.
	        var startIndex = this.indexOfExistingBatchId(firstBatchId, 'removed');
	        assert_1.assert(this.mutationQueue[startIndex].batchId === firstBatchId, 'Removed batches must exist in the queue');
	        // Check that removed batches are contiguous (while excluding tombstones).
	        var batchIndex = 1;
	        var queueIndex = startIndex + 1;
	        while (batchIndex < batchCount && queueIndex < queueCount) {
	            var batch = this.mutationQueue[queueIndex];
	            if (batch.isTombstone()) {
	                queueIndex++;
	                continue;
	            }
	            assert_1.assert(batch.batchId === batches[batchIndex].batchId, 'Removed batches must be contiguous in the queue');
	            batchIndex++;
	            queueIndex++;
	        }
	        // Only actually remove batches if removing at the front of the queue.
	        // Previously rejected batches may have left tombstones in the queue, so
	        // expand the removal range to include any tombstones.
	        if (startIndex === 0) {
	            for (; queueIndex < queueCount; queueIndex++) {
	                var batch = this.mutationQueue[queueIndex];
	                if (!batch.isTombstone()) {
	                    break;
	                }
	            }
	            var length_1 = queueIndex - startIndex;
	            this.mutationQueue.splice(startIndex, length_1);
	        }
	        else {
	            // Mark the tombstones
	            for (var i = startIndex; i < queueIndex; i++) {
	                this.mutationQueue[i] = this.mutationQueue[i].toTombstone();
	            }
	        }
	        var references = this.batchesByDocumentKey;
	        for (var _i = 0, batches_1 = batches; _i < batches_1.length; _i++) {
	            var batch = batches_1[_i];
	            var batchId = batch.batchId;
	            for (var _a = 0, _b = batch.mutations; _a < _b.length; _a++) {
	                var mutation = _b[_a];
	                var key = mutation.key;
	                if (this.garbageCollector !== null) {
	                    this.garbageCollector.addPotentialGarbageKey(key);
	                }
	                var ref = new reference_set_1.DocReference(key, batchId);
	                references = references.delete(ref);
	            }
	        }
	        this.batchesByDocumentKey = references;
	        return persistence_promise_1.PersistencePromise.resolve();
	    };
	    MemoryMutationQueue.prototype.setGarbageCollector = function (garbageCollector) {
	        this.garbageCollector = garbageCollector;
	    };
	    MemoryMutationQueue.prototype.containsKey = function (txn, key) {
	        var ref = new reference_set_1.DocReference(key, 0);
	        var firstRef = this.batchesByDocumentKey.firstAfterOrEqual(ref);
	        return persistence_promise_1.PersistencePromise.resolve(key.isEqual(firstRef && firstRef.key));
	    };
	    MemoryMutationQueue.prototype.performConsistencyCheck = function (txn) {
	        if (this.mutationQueue.length === 0) {
	            assert_1.assert(this.batchesByDocumentKey.isEmpty(), 'Document leak -- detected dangling mutation references when queue is empty.');
	        }
	        return persistence_promise_1.PersistencePromise.resolve();
	    };
	    /**
	     * A private helper that collects all the mutations batches in the queue up to
	     * but not including the given endIndex. All tombstones in the queue are
	     * excluded.
	     */
	    MemoryMutationQueue.prototype.getAllLiveMutationBatchesBeforeIndex = function (endIndex) {
	        var result = [];
	        for (var i = 0; i < endIndex; i++) {
	            var batch = this.mutationQueue[i];
	            if (!batch.isTombstone()) {
	                result.push(batch);
	            }
	        }
	        return result;
	    };
	    /**
	     * Finds the index of the given batchId in the mutation queue and asserts that
	     * the resulting index is within the bounds of the queue.
	     *
	     * @param batchId The batchId to search for
	     * @param action A description of what the caller is doing, phrased in passive
	     * form (e.g. "acknowledged" in a routine that acknowledges batches).
	     */
	    MemoryMutationQueue.prototype.indexOfExistingBatchId = function (batchId, action) {
	        var index = this.indexOfBatchId(batchId);
	        assert_1.assert(index >= 0 && index < this.mutationQueue.length, 'Batches must exist to be ' + action);
	        return index;
	    };
	    /**
	     * Finds the index of the given batchId in the mutation queue. This operation
	     * is O(1).
	     *
	     * @return The computed index of the batch with the given batchId, based on
	     * the state of the queue. Note this index can be negative if the requested
	     * batchId has already been remvoed from the queue or past the end of the
	     * queue if the batchId is larger than the last added batch.
	     */
	    MemoryMutationQueue.prototype.indexOfBatchId = function (batchId) {
	        if (this.mutationQueue.length === 0) {
	            // As an index this is past the end of the queue
	            return 0;
	        }
	        // Examine the front of the queue to figure out the difference between the
	        // batchId and indexes in the array. Note that since the queue is ordered
	        // by batchId, if the first batch has a larger batchId then the requested
	        // batchId doesn't exist in the queue.
	        var firstBatchId = this.mutationQueue[0].batchId;
	        return batchId - firstBatchId;
	    };
	    /**
	     * A version of lookupMutationBatch that doesn't return a promise, this makes
	     * other functions that uses this code easier to read and more efficent.
	     */
	    MemoryMutationQueue.prototype.findMutationBatch = function (batchId) {
	        var index = this.indexOfBatchId(batchId);
	        if (index < 0 || index >= this.mutationQueue.length) {
	            return null;
	        }
	        var batch = this.mutationQueue[index];
	        assert_1.assert(batch.batchId === batchId, 'If found batch must match');
	        return batch.isTombstone() ? null : batch;
	    };
	    return MemoryMutationQueue;
	}());
	exports.MemoryMutationQueue = MemoryMutationQueue;
	
	//# sourceMappingURL=memory_mutation_queue.js.map


/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var assert_1 = __webpack_require__(2);
	var log_1 = __webpack_require__(13);
	var memory_mutation_queue_1 = __webpack_require__(277);
	var memory_query_cache_1 = __webpack_require__(279);
	var memory_remote_document_cache_1 = __webpack_require__(280);
	var LOG_TAG = 'MemoryPersistence';
	/**
	 * A memory-backed instance of Persistence. Data is stored only in RAM and
	 * not persisted across sessions.
	 */
	var MemoryPersistence = /** @class */ (function () {
	    function MemoryPersistence() {
	        /**
	         * Note that these are retained here to make it easier to write tests
	         * affecting both the in-memory and IndexedDB-backed persistence layers. Tests
	         * can create a new LocalStore wrapping this Persistence instance and this
	         * will make the in-memory persistence layer behave as if it were actually
	         * persisting values.
	         */
	        this.mutationQueues = {};
	        this.remoteDocumentCache = new memory_remote_document_cache_1.MemoryRemoteDocumentCache();
	        this.queryCache = new memory_query_cache_1.MemoryQueryCache();
	        this.started = false;
	    }
	    MemoryPersistence.prototype.start = function () {
	        assert_1.assert(!this.started, 'MemoryPersistence double-started!');
	        this.started = true;
	        // No durable state to read on startup.
	        return Promise.resolve();
	    };
	    MemoryPersistence.prototype.shutdown = function () {
	        // No durable state to ensure is closed on shutdown.
	        assert_1.assert(this.started, 'MemoryPersistence shutdown without start!');
	        this.started = false;
	        return Promise.resolve();
	    };
	    MemoryPersistence.prototype.getMutationQueue = function (user) {
	        var queue = this.mutationQueues[user.toKey()];
	        if (!queue) {
	            queue = new memory_mutation_queue_1.MemoryMutationQueue();
	            this.mutationQueues[user.toKey()] = queue;
	        }
	        return queue;
	    };
	    MemoryPersistence.prototype.getQueryCache = function () {
	        return this.queryCache;
	    };
	    MemoryPersistence.prototype.getRemoteDocumentCache = function () {
	        return this.remoteDocumentCache;
	    };
	    MemoryPersistence.prototype.runTransaction = function (action, operation) {
	        log_1.debug(LOG_TAG, 'Starting transaction:', action);
	        return operation(new MemoryPersistenceTransaction()).toPromise();
	    };
	    return MemoryPersistence;
	}());
	exports.MemoryPersistence = MemoryPersistence;
	/** Dummy class since memory persistence doesn't actually use transactions. */
	var MemoryPersistenceTransaction = /** @class */ (function () {
	    function MemoryPersistenceTransaction() {
	    }
	    return MemoryPersistenceTransaction;
	}());
	
	//# sourceMappingURL=memory_persistence.js.map


/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var snapshot_version_1 = __webpack_require__(20);
	var obj_map_1 = __webpack_require__(104);
	var persistence_promise_1 = __webpack_require__(18);
	var reference_set_1 = __webpack_require__(73);
	var MemoryQueryCache = /** @class */ (function () {
	    function MemoryQueryCache() {
	        /**
	         * Maps a query to the data about that query
	         */
	        this.queries = new obj_map_1.ObjectMap(function (q) { return q.canonicalId(); });
	        /** The last received snapshot version. */
	        this.lastRemoteSnapshotVersion = snapshot_version_1.SnapshotVersion.MIN;
	        /** The highest numbered target ID encountered. */
	        this.highestTargetId = 0;
	        /**
	         * A ordered bidirectional mapping between documents and the remote target
	         * IDs.
	         */
	        this.references = new reference_set_1.ReferenceSet();
	    }
	    MemoryQueryCache.prototype.start = function (transaction) {
	        // Nothing to do.
	        return persistence_promise_1.PersistencePromise.resolve();
	    };
	    MemoryQueryCache.prototype.getLastRemoteSnapshotVersion = function () {
	        return this.lastRemoteSnapshotVersion;
	    };
	    MemoryQueryCache.prototype.getHighestTargetId = function () {
	        return this.highestTargetId;
	    };
	    MemoryQueryCache.prototype.setLastRemoteSnapshotVersion = function (transaction, snapshotVersion) {
	        this.lastRemoteSnapshotVersion = snapshotVersion;
	        return persistence_promise_1.PersistencePromise.resolve();
	    };
	    MemoryQueryCache.prototype.addQueryData = function (transaction, queryData) {
	        this.queries.set(queryData.query, queryData);
	        var targetId = queryData.targetId;
	        if (targetId > this.highestTargetId) {
	            this.highestTargetId = targetId;
	        }
	        return persistence_promise_1.PersistencePromise.resolve();
	    };
	    MemoryQueryCache.prototype.removeQueryData = function (transaction, queryData) {
	        this.queries.delete(queryData.query);
	        this.references.removeReferencesForId(queryData.targetId);
	        return persistence_promise_1.PersistencePromise.resolve();
	    };
	    MemoryQueryCache.prototype.getQueryData = function (transaction, query) {
	        var queryData = this.queries.get(query) || null;
	        return persistence_promise_1.PersistencePromise.resolve(queryData);
	    };
	    MemoryQueryCache.prototype.addMatchingKeys = function (txn, keys, targetId) {
	        this.references.addReferences(keys, targetId);
	        return persistence_promise_1.PersistencePromise.resolve();
	    };
	    MemoryQueryCache.prototype.removeMatchingKeys = function (txn, keys, targetId) {
	        this.references.removeReferences(keys, targetId);
	        return persistence_promise_1.PersistencePromise.resolve();
	    };
	    MemoryQueryCache.prototype.removeMatchingKeysForTargetId = function (txn, targetId) {
	        this.references.removeReferencesForId(targetId);
	        return persistence_promise_1.PersistencePromise.resolve();
	    };
	    MemoryQueryCache.prototype.getMatchingKeysForTargetId = function (txn, targetId) {
	        var matchingKeys = this.references.referencesForId(targetId);
	        return persistence_promise_1.PersistencePromise.resolve(matchingKeys);
	    };
	    MemoryQueryCache.prototype.setGarbageCollector = function (gc) {
	        this.references.setGarbageCollector(gc);
	    };
	    MemoryQueryCache.prototype.containsKey = function (txn, key) {
	        return this.references.containsKey(txn, key);
	    };
	    return MemoryQueryCache;
	}());
	exports.MemoryQueryCache = MemoryQueryCache;
	
	//# sourceMappingURL=memory_query_cache.js.map


/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var collections_1 = __webpack_require__(11);
	var document_1 = __webpack_require__(21);
	var document_key_1 = __webpack_require__(12);
	var persistence_promise_1 = __webpack_require__(18);
	var MemoryRemoteDocumentCache = /** @class */ (function () {
	    function MemoryRemoteDocumentCache() {
	        this.docs = collections_1.maybeDocumentMap();
	    }
	    MemoryRemoteDocumentCache.prototype.addEntry = function (transaction, maybeDocument) {
	        this.docs = this.docs.insert(maybeDocument.key, maybeDocument);
	        return persistence_promise_1.PersistencePromise.resolve();
	    };
	    MemoryRemoteDocumentCache.prototype.removeEntry = function (transaction, documentKey) {
	        this.docs = this.docs.remove(documentKey);
	        return persistence_promise_1.PersistencePromise.resolve();
	    };
	    MemoryRemoteDocumentCache.prototype.getEntry = function (transaction, documentKey) {
	        return persistence_promise_1.PersistencePromise.resolve(this.docs.get(documentKey));
	    };
	    MemoryRemoteDocumentCache.prototype.getDocumentsMatchingQuery = function (transaction, query) {
	        var results = collections_1.documentMap();
	        // Documents are ordered by key, so we can use a prefix scan to narrow down
	        // the documents we need to match the query against.
	        var prefix = new document_key_1.DocumentKey(query.path.child(''));
	        var iterator = this.docs.getIteratorFrom(prefix);
	        while (iterator.hasNext()) {
	            var _a = iterator.getNext(), key = _a.key, maybeDoc = _a.value;
	            if (!query.path.isPrefixOf(key.path)) {
	                break;
	            }
	            if (maybeDoc instanceof document_1.Document && query.matches(maybeDoc)) {
	                results = results.insert(maybeDoc.key, maybeDoc);
	            }
	        }
	        return persistence_promise_1.PersistencePromise.resolve(results);
	    };
	    return MemoryRemoteDocumentCache;
	}());
	exports.MemoryRemoteDocumentCache = MemoryRemoteDocumentCache;
	
	//# sourceMappingURL=memory_remote_document_cache.js.map


/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var collections_1 = __webpack_require__(11);
	var persistence_promise_1 = __webpack_require__(18);
	/**
	 * A garbage collector implementation that does absolutely nothing. It ignores
	 * all addGarbageSource and addPotentialGarbageKey messages and and never
	 * produces any garbage.
	 */
	var NoOpGarbageCollector = /** @class */ (function () {
	    function NoOpGarbageCollector() {
	        this.isEager = false;
	    }
	    NoOpGarbageCollector.prototype.addGarbageSource = function (garbageSource) {
	        // Not tracking garbage so don't track sources.
	    };
	    NoOpGarbageCollector.prototype.removeGarbageSource = function (garbageSource) {
	        // Not tracking garbage so don't track sources.
	    };
	    NoOpGarbageCollector.prototype.addPotentialGarbageKey = function (key) {
	        // Not tracking garbage so ignore.
	    };
	    NoOpGarbageCollector.prototype.collectGarbage = function (txn) {
	        return persistence_promise_1.PersistencePromise.resolve(collections_1.documentKeySet());
	    };
	    return NoOpGarbageCollector;
	}());
	exports.NoOpGarbageCollector = NoOpGarbageCollector;
	
	//# sourceMappingURL=no_op_garbage_collector.js.map


/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var collections_1 = __webpack_require__(11);
	var assert_1 = __webpack_require__(2);
	var persistence_promise_1 = __webpack_require__(18);
	/**
	 * An in-memory buffer of entries to be written to a RemoteDocumentCache.
	 * It can be used to batch up a set of changes to be written to the cache, but
	 * additionally supports reading entries back with the `getEntry()` method,
	 * falling back to the underlying RemoteDocumentCache if no entry is
	 * buffered.
	 *
	 * NOTE: This class was introduced in iOS to work around a limitation in
	 * LevelDB. Given IndexedDb has full transaction support with
	 * read-your-own-writes capability, this class is not technically needed, but
	 * has been preserved as a convenience and to aid portability.
	 */
	var RemoteDocumentChangeBuffer = /** @class */ (function () {
	    function RemoteDocumentChangeBuffer(remoteDocumentCache) {
	        this.remoteDocumentCache = remoteDocumentCache;
	        this.changes = collections_1.maybeDocumentMap();
	    }
	    /** Buffers a `RemoteDocumentCache.addEntry()` call. */
	    RemoteDocumentChangeBuffer.prototype.addEntry = function (maybeDocument) {
	        var changes = this.assertChanges();
	        this.changes = changes.insert(maybeDocument.key, maybeDocument);
	    };
	    // NOTE: removeEntry() is not presently necessary and so is omitted.
	    /**
	     * Looks up an entry in the cache. The buffered changes will first be checked,
	     * and if no buffered change applies, this will forward to
	     * `RemoteDocumentCache.getEntry()`.
	     *
	     * @param transaction The transaction in which to perform any persistence
	     *     operations.
	     * @param documentKey The key of the entry to look up.
	     * @return The cached Document or NoDocument entry, or null if we have nothing
	     * cached.
	     */
	    RemoteDocumentChangeBuffer.prototype.getEntry = function (transaction, documentKey) {
	        var changes = this.assertChanges();
	        var bufferedEntry = changes.get(documentKey);
	        if (bufferedEntry) {
	            return persistence_promise_1.PersistencePromise.resolve(bufferedEntry);
	        }
	        else {
	            return this.remoteDocumentCache.getEntry(transaction, documentKey);
	        }
	    };
	    /**
	     * Applies buffered changes to the underlying RemoteDocumentCache, using
	     * the provided transaction.
	     */
	    RemoteDocumentChangeBuffer.prototype.apply = function (transaction) {
	        var _this = this;
	        var changes = this.assertChanges();
	        var promises = [];
	        changes.forEach(function (key, maybeDoc) {
	            promises.push(_this.remoteDocumentCache.addEntry(transaction, maybeDoc));
	        });
	        // We should not be used to buffer any more changes.
	        this.changes = null;
	        return persistence_promise_1.PersistencePromise.waitFor(promises);
	    };
	    /** Helper to assert this.changes is not null and return it. */
	    RemoteDocumentChangeBuffer.prototype.assertChanges = function () {
	        assert_1.assert(this.changes !== null, 'Changes have already been applied.');
	        return this.changes;
	    };
	    return RemoteDocumentChangeBuffer;
	}());
	exports.RemoteDocumentChangeBuffer = RemoteDocumentChangeBuffer;
	
	//# sourceMappingURL=remote_document_change_buffer.js.map


/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var blob_1 = __webpack_require__(95);
	var database_1 = __webpack_require__(260);
	var field_path_1 = __webpack_require__(96);
	var field_value_1 = __webpack_require__(158);
	var geo_point_1 = __webpack_require__(97);
	var obj_1 = __webpack_require__(27);
	var firestoreNamespace = {
	    Firestore: database_1.PublicFirestore,
	    GeoPoint: geo_point_1.GeoPoint,
	    Blob: blob_1.PublicBlob,
	    Transaction: database_1.PublicTransaction,
	    WriteBatch: database_1.PublicWriteBatch,
	    DocumentReference: database_1.PublicDocumentReference,
	    DocumentSnapshot: database_1.PublicDocumentSnapshot,
	    Query: database_1.PublicQuery,
	    QueryDocumentSnapshot: database_1.PublicQueryDocumentSnapshot,
	    QuerySnapshot: database_1.PublicQuerySnapshot,
	    CollectionReference: database_1.PublicCollectionReference,
	    FieldPath: field_path_1.FieldPath,
	    FieldValue: field_value_1.PublicFieldValue,
	    setLogLevel: database_1.Firestore.setLogLevel
	};
	/**
	 * Configures Firestore as part of the Firebase SDK by calling registerService.
	 */
	function configureForFirebase(firebase) {
	    firebase.INTERNAL.registerService('firestore', function (app) { return new database_1.Firestore(app); }, obj_1.shallowCopy(firestoreNamespace));
	}
	exports.configureForFirebase = configureForFirebase;
	/**
	 * Exports the Firestore namespace into the provided `exportObject` object under
	 * the key 'firestore'. This is used for wrapped binary that exposes Firestore
	 * as a goog module.
	 */
	function configureForStandalone(exportObject) {
	    var copiedNamespace = obj_1.shallowCopy(firestoreNamespace);
	    // Unlike the use with Firebase, the standalone allows the use of the
	    // constructor, so export it's internal class
	    copiedNamespace['Firestore'] = database_1.Firestore;
	    exportObject['firestore'] = copiedNamespace;
	}
	exports.configureForStandalone = configureForStandalone;
	
	//# sourceMappingURL=config.js.map


/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var platform_1 = __webpack_require__(29);
	var browser_platform_1 = __webpack_require__(285);
	/**
	 * This code needs to run before Firestore is used. This can be achieved in
	 * several ways:
	 *   1) Through the JSCompiler compiling this code and then (automatically)
	 *      executing it before exporting the Firestore symbols.
	 *   2) Through importing this module first in a Firestore main module
	 */
	platform_1.PlatformSupport.setPlatform(new browser_platform_1.BrowserPlatform());
	
	//# sourceMappingURL=browser_init.js.map


/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var serializer_1 = __webpack_require__(163);
	var webchannel_connection_1 = __webpack_require__(286);
	var BrowserPlatform = /** @class */ (function () {
	    function BrowserPlatform() {
	        this.emptyByteString = '';
	        this.base64Available = typeof atob !== 'undefined';
	    }
	    BrowserPlatform.prototype.loadConnection = function (databaseInfo) {
	        return Promise.resolve(new webchannel_connection_1.WebChannelConnection(databaseInfo));
	    };
	    BrowserPlatform.prototype.newSerializer = function (databaseId) {
	        return new serializer_1.JsonProtoSerializer(databaseId, { useProto3Json: true });
	    };
	    BrowserPlatform.prototype.formatJSON = function (value) {
	        return JSON.stringify(value);
	    };
	    BrowserPlatform.prototype.atob = function (encoded) {
	        return atob(encoded);
	    };
	    BrowserPlatform.prototype.btoa = function (raw) {
	        return btoa(raw);
	    };
	    return BrowserPlatform;
	}());
	exports.BrowserPlatform = BrowserPlatform;
	
	//# sourceMappingURL=browser_platform.js.map


/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var webchannel_wrapper_1 = __webpack_require__(332);
	var version_1 = __webpack_require__(100);
	var rpc_error_1 = __webpack_require__(102);
	var stream_bridge_1 = __webpack_require__(292);
	var assert_1 = __webpack_require__(2);
	var error_1 = __webpack_require__(10);
	var log = __webpack_require__(13);
	var LOG_TAG = 'Connection';
	var RPC_STREAM_SERVICE = 'google.firestore.v1beta1.Firestore';
	var RPC_URL_VERSION = 'v1beta1';
	/** Maps RPC names to the corresponding REST endpoint name. */
	var RPC_NAME_REST_MAPPING = {
	    BatchGetDocuments: 'batchGet',
	    Commit: 'commit'
	};
	// TODO(b/38203344): The SDK_VERSION is set independently from Firebase because
	// we are doing out-of-band releases. Once we release as part of Firebase, we
	// should use the Firebase version instead.
	var X_GOOG_API_CLIENT_VALUE = 'gl-js/ fire/' + version_1.SDK_VERSION;
	var XHR_TIMEOUT_SECS = 15;
	var WebChannelConnection = /** @class */ (function () {
	    function WebChannelConnection(info) {
	        this.databaseId = info.databaseId;
	        this.pool = new webchannel_wrapper_1.XhrIoPool();
	        var proto = info.ssl ? 'https' : 'http';
	        this.baseUrl = proto + '://' + info.host;
	    }
	    /**
	     * Modifies the headers for a request, adding any authorization token if
	     * present and any additional headers for the request.
	     */
	    WebChannelConnection.prototype.modifyHeadersForRequest = function (headers, token) {
	        if (token) {
	            for (var header in token.authHeaders) {
	                if (token.authHeaders.hasOwnProperty(header)) {
	                    headers[header] = token.authHeaders[header];
	                }
	            }
	        }
	        headers['X-Goog-Api-Client'] = X_GOOG_API_CLIENT_VALUE;
	        // This header is used to improve routing and project isolation by the
	        // backend.
	        headers['google-cloud-resource-prefix'] =
	            "projects/" + this.databaseId.projectId + "/" +
	                ("databases/" + this.databaseId.database);
	    };
	    WebChannelConnection.prototype.invokeRPC = function (rpcName, request, token) {
	        var _this = this;
	        var url = this.makeUrl(rpcName);
	        return new Promise(function (resolve, reject) {
	            // tslint:disable-next-line:no-any XhrIoPool doesn't have TS typings.
	            _this.pool.getObject(function (xhr) {
	                xhr.listenOnce(webchannel_wrapper_1.EventType.COMPLETE, function () {
	                    try {
	                        switch (xhr.getLastErrorCode()) {
	                            case webchannel_wrapper_1.ErrorCode.NO_ERROR:
	                                var json = xhr.getResponseJson();
	                                log.debug(LOG_TAG, 'XHR received:', JSON.stringify(json));
	                                resolve(json);
	                                break;
	                            case webchannel_wrapper_1.ErrorCode.TIMEOUT:
	                                log.debug(LOG_TAG, 'RPC "' + rpcName + '" timed out');
	                                reject(new error_1.FirestoreError(error_1.Code.DEADLINE_EXCEEDED, 'Request time out'));
	                                break;
	                            case webchannel_wrapper_1.ErrorCode.HTTP_ERROR:
	                                var status_1 = xhr.getStatus();
	                                log.debug(LOG_TAG, 'RPC "' + rpcName + '" failed with status:', status_1, 'response text:', xhr.getResponseText());
	                                if (status_1 > 0) {
	                                    reject(new error_1.FirestoreError(rpc_error_1.mapCodeFromHttpStatus(status_1), 'Server responded with status ' + xhr.getStatusText()));
	                                }
	                                else {
	                                    // If we received an HTTP_ERROR but there's no status code,
	                                    // it's most probably a connection issue
	                                    log.debug(LOG_TAG, 'RPC "' + rpcName + '" failed');
	                                    reject(new error_1.FirestoreError(error_1.Code.UNAVAILABLE, 'Connection failed.'));
	                                }
	                                break;
	                            default:
	                                assert_1.fail('RPC "' +
	                                    rpcName +
	                                    '" failed with unanticipated ' +
	                                    'webchannel error ' +
	                                    xhr.getLastErrorCode() +
	                                    ': ' +
	                                    xhr.getLastError() +
	                                    ', giving up.');
	                        }
	                    }
	                    finally {
	                        log.debug(LOG_TAG, 'RPC "' + rpcName + '" completed.');
	                        _this.pool.releaseObject(xhr);
	                    }
	                });
	                var requestString = JSON.stringify(request);
	                log.debug(LOG_TAG, 'XHR sending: ', url + ' ' + requestString);
	                // Content-Type: text/plain will avoid preflight requests which might
	                // mess with CORS and redirects by proxies. If we add custom headers
	                // we will need to change this code to potentially use the
	                // $httpOverwrite parameter supported by ESF to avoid
	                // triggering preflight requests.
	                var headers = { 'Content-Type': 'text/plain' };
	                _this.modifyHeadersForRequest(headers, token);
	                xhr.send(url, 'POST', requestString, headers, XHR_TIMEOUT_SECS);
	            });
	        });
	    };
	    WebChannelConnection.prototype.invokeStreamingRPC = function (rpcName, request, token) {
	        // The REST API automatically aggregates all of the streamed results, so we
	        // can just use the normal invoke() method.
	        return this.invokeRPC(rpcName, request, token);
	    };
	    WebChannelConnection.prototype.openStream = function (rpcName, token) {
	        var urlParts = [
	            this.baseUrl,
	            '/',
	            RPC_STREAM_SERVICE,
	            '/',
	            rpcName,
	            '/channel'
	        ];
	        var webchannelTransport = webchannel_wrapper_1.createWebChannelTransport();
	        var request = {
	            // Background channel test avoids the initial two test calls and decreases
	            // initial cold start time.
	            // TODO(dimond): wenboz@ mentioned this might affect use with proxies and
	            // we should monitor closely for any reports.
	            backgroundChannelTest: true,
	            // Required for backend stickiness, routing behavior is based on this
	            // parameter.
	            httpSessionIdParam: 'gsessionid',
	            initMessageHeaders: {},
	            // Send our custom headers as a '$httpHeaders=' url param to avoid CORS
	            // preflight round-trip. This is formally defined here:
	            // https://github.com/google/closure-library/blob/b0e1815b13fb92a46d7c9b3c30de5d6a396a3245/closure/goog/net/rpc/httpcors.js#L40
	            httpHeadersOverwriteParam: '$httpHeaders',
	            sendRawJson: true,
	            supportsCrossDomainXhr: true
	        };
	        this.modifyHeadersForRequest(request.initMessageHeaders, token);
	        var url = urlParts.join('');
	        log.debug(LOG_TAG, 'Creating WebChannel: ' + url + ' ' + request);
	        // tslint:disable-next-line:no-any Because listen isn't defined on it.
	        var channel = webchannelTransport.createWebChannel(url, request);
	        // WebChannel supports sending the first message with the handshake - saving
	        // a network round trip. However, it will have to call send in the same
	        // JS event loop as open. In order to enforce this, we delay actually
	        // opening the WebChannel until send is called. Whether we have called
	        // open is tracked with this variable.
	        var opened = false;
	        // A flag to determine whether the stream was closed (by us or through an
	        // error/close event) to avoid delivering multiple close events or sending
	        // on a closed stream
	        var closed = false;
	        var streamBridge = new stream_bridge_1.StreamBridge({
	            sendFn: function (msg) {
	                if (!closed) {
	                    if (!opened) {
	                        log.debug(LOG_TAG, 'Opening WebChannel transport.');
	                        channel.open();
	                        opened = true;
	                    }
	                    log.debug(LOG_TAG, 'WebChannel sending:', msg);
	                    channel.send(msg);
	                }
	                else {
	                    log.debug(LOG_TAG, 'Not sending because WebChannel is closed:', msg);
	                }
	            },
	            closeFn: function () { return channel.close(); }
	        });
	        // Closure events are guarded and exceptions are swallowed, so catch any
	        // exception and rethrow using a setTimeout so they become visible again.
	        // Note that eventually this function could go away if we are confident
	        // enough the code is exception free.
	        var unguardedEventListen = function (type, fn) {
	            // TODO(dimond): closure typing seems broken because WebChannel does
	            // not implement goog.events.Listenable
	            channel.listen(type, function (param) {
	                try {
	                    fn(param);
	                }
	                catch (e) {
	                    setTimeout(function () {
	                        throw e;
	                    }, 0);
	                }
	            });
	        };
	        unguardedEventListen(webchannel_wrapper_1.WebChannel.EventType.OPEN, function () {
	            if (!closed) {
	                log.debug(LOG_TAG, 'WebChannel transport opened.');
	            }
	        });
	        unguardedEventListen(webchannel_wrapper_1.WebChannel.EventType.CLOSE, function () {
	            if (!closed) {
	                closed = true;
	                log.debug(LOG_TAG, 'WebChannel transport closed');
	                streamBridge.callOnClose();
	            }
	        });
	        unguardedEventListen(webchannel_wrapper_1.WebChannel.EventType.ERROR, function (err) {
	            if (!closed) {
	                closed = true;
	                log.debug(LOG_TAG, 'WebChannel transport errored:', err);
	                streamBridge.callOnClose(new error_1.FirestoreError(error_1.Code.UNAVAILABLE, 'The operation could not be completed'));
	            }
	        });
	        unguardedEventListen(webchannel_wrapper_1.WebChannel.EventType.MESSAGE, function (msg) {
	            if (!closed) {
	                var msgData = msg.data[0];
	                assert_1.assert(!!msgData, 'Got a webchannel message without data.');
	                // TODO(b/35143891): There is a bug in One Platform that caused errors
	                // (and only errors) to be wrapped in an extra array. To be forward
	                // compatible with the bug we need to check either condition. The latter
	                // can be removed once the fix has been rolled out.
	                var error = 
	                // tslint:disable-next-line:no-any msgData.error is not typed.
	                msgData.error || (msgData[0] && msgData[0].error);
	                if (error) {
	                    log.debug(LOG_TAG, 'WebChannel received error:', error);
	                    // error.status will be a string like 'OK' or 'NOT_FOUND'.
	                    var status_2 = error.status;
	                    var code = rpc_error_1.mapCodeFromRpcStatus(status_2);
	                    var message = error.message;
	                    if (code === undefined) {
	                        code = error_1.Code.INTERNAL;
	                        message =
	                            'Unknown error status: ' +
	                                status_2 +
	                                ' with message ' +
	                                error.message;
	                    }
	                    // Mark closed so no further events are propagated
	                    closed = true;
	                    streamBridge.callOnClose(new error_1.FirestoreError(code, message));
	                    channel.close();
	                }
	                else {
	                    log.debug(LOG_TAG, 'WebChannel received:', msgData);
	                    streamBridge.callOnMessage(msgData);
	                }
	            }
	        });
	        setTimeout(function () {
	            // Technically we could/should wait for the WebChannel opened event,
	            // but because we want to send the first message with the WebChannel
	            // handshake we pretend the channel opened here (asynchronously), and
	            // then delay the actual open until the first message is sent.
	            streamBridge.callOnOpen();
	        }, 0);
	        return streamBridge;
	    };
	    // visible for testing
	    WebChannelConnection.prototype.makeUrl = function (rpcName) {
	        var urlRpcName = RPC_NAME_REST_MAPPING[rpcName];
	        assert_1.assert(urlRpcName !== undefined, 'Unknown REST mapping for: ' + rpcName);
	        var url = [this.baseUrl, '/', RPC_URL_VERSION];
	        url.push('/projects/');
	        url.push(this.databaseId.projectId);
	        url.push('/databases/');
	        url.push(this.databaseId.database);
	        url.push('/documents');
	        url.push(':');
	        url.push(urlRpcName);
	        return url.join('');
	    };
	    return WebChannelConnection;
	}());
	exports.WebChannelConnection = WebChannelConnection;
	
	//# sourceMappingURL=webchannel_connection.js.map


/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var log = __webpack_require__(13);
	var promise_1 = __webpack_require__(105);
	var LOG_TAG = 'ExponentialBackoff';
	/**
	 * A helper for running delayed tasks following an exponential backoff curve
	 * between attempts.
	 *
	 * Each delay is made up of a "base" delay which follows the exponential
	 * backoff curve, and a +/- 50% "jitter" that is calculated and added to the
	 * base delay. This prevents clients from accidentally synchronizing their
	 * delays causing spikes of load to the backend.
	 */
	var ExponentialBackoff = /** @class */ (function () {
	    function ExponentialBackoff(
	        /**
	         * The initial delay (used as the base delay on the first retry attempt).
	         * Note that jitter will still be applied, so the actual delay could be as
	         * little as 0.5*initialDelayMs.
	         */
	        initialDelayMs, 
	        /**
	         * The multiplier to use to determine the extended base delay after each
	         * attempt.
	         */
	        backoffFactor, 
	        /**
	         * The maximum base delay after which no further backoff is performed.
	         * Note that jitter will still be applied, so the actual delay could be as
	         * much as 1.5*maxDelayMs.
	         */
	        maxDelayMs) {
	        this.initialDelayMs = initialDelayMs;
	        this.backoffFactor = backoffFactor;
	        this.maxDelayMs = maxDelayMs;
	        this.reset();
	    }
	    /**
	     * Resets the backoff delay.
	     *
	     * The very next backoffAndWait() will have no delay. If it is called again
	     * (i.e. due to an error), initialDelayMs (plus jitter) will be used, and
	     * subsequent ones will increase according to the backoffFactor.
	     */
	    ExponentialBackoff.prototype.reset = function () {
	        this.currentBaseMs = 0;
	    };
	    /**
	     * Resets the backoff delay to the maximum delay (e.g. for use after a
	     * RESOURCE_EXHAUSTED error).
	     */
	    ExponentialBackoff.prototype.resetToMax = function () {
	        this.currentBaseMs = this.maxDelayMs;
	    };
	    /**
	     * Returns a promise that resolves after currentDelayMs, and increases the
	     * delay for any subsequent attempts.
	     */
	    ExponentialBackoff.prototype.backoffAndWait = function () {
	        var def = new promise_1.Deferred();
	        // First schedule using the current base (which may be 0 and should be
	        // honored as such).
	        var delayWithJitterMs = this.currentBaseMs + this.jitterDelayMs();
	        if (this.currentBaseMs > 0) {
	            log.debug(LOG_TAG, "Backing off for " + delayWithJitterMs + " ms " +
	                ("(base delay: " + this.currentBaseMs + " ms)"));
	        }
	        setTimeout(function () {
	            def.resolve();
	        }, delayWithJitterMs);
	        // Apply backoff factor to determine next delay and ensure it is within
	        // bounds.
	        this.currentBaseMs *= this.backoffFactor;
	        if (this.currentBaseMs < this.initialDelayMs) {
	            this.currentBaseMs = this.initialDelayMs;
	        }
	        if (this.currentBaseMs > this.maxDelayMs) {
	            this.currentBaseMs = this.maxDelayMs;
	        }
	        return def.promise;
	    };
	    /** Returns a random value in the range [-currentBaseMs/2, currentBaseMs/2] */
	    ExponentialBackoff.prototype.jitterDelayMs = function () {
	        return (Math.random() - 0.5) * this.currentBaseMs;
	    };
	    return ExponentialBackoff;
	}());
	exports.ExponentialBackoff = ExponentialBackoff;
	
	//# sourceMappingURL=backoff.js.map


/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var collections_1 = __webpack_require__(11);
	var assert_1 = __webpack_require__(2);
	var persistent_stream_1 = __webpack_require__(290);
	/**
	 * Datastore is a wrapper around the external Google Cloud Datastore grpc API,
	 * which provides an interface that is more convenient for the rest of the
	 * client SDK architecture to consume.
	 */
	var Datastore = /** @class */ (function () {
	    function Datastore(databaseInfo, queue, connection, credentials, serializer, initialBackoffDelay) {
	        this.databaseInfo = databaseInfo;
	        this.queue = queue;
	        this.connection = connection;
	        this.credentials = credentials;
	        this.serializer = serializer;
	        this.initialBackoffDelay = initialBackoffDelay;
	    }
	    Datastore.prototype.newPersistentWriteStream = function () {
	        return new persistent_stream_1.PersistentWriteStream(this.databaseInfo, this.queue, this.connection, this.credentials, this.serializer, this.initialBackoffDelay);
	    };
	    Datastore.prototype.newPersistentWatchStream = function () {
	        return new persistent_stream_1.PersistentListenStream(this.databaseInfo, this.queue, this.connection, this.credentials, this.serializer, this.initialBackoffDelay);
	    };
	    Datastore.prototype.commit = function (mutations) {
	        var _this = this;
	        var params = {
	            database: this.serializer.encodedDatabaseId,
	            writes: mutations.map(function (m) { return _this.serializer.toMutation(m); })
	        };
	        return this.invokeRPC('Commit', params).then(function (response) {
	            return _this.serializer.fromWriteResults(response.writeResults);
	        });
	    };
	    Datastore.prototype.lookup = function (keys) {
	        var _this = this;
	        var params = {
	            database: this.serializer.encodedDatabaseId,
	            documents: keys.map(function (k) { return _this.serializer.toName(k); })
	        };
	        return this.invokeStreamingRPC('BatchGetDocuments', params).then(function (response) {
	            var docs = collections_1.maybeDocumentMap();
	            response.forEach(function (proto) {
	                var doc = _this.serializer.fromMaybeDocument(proto);
	                docs = docs.insert(doc.key, doc);
	            });
	            var result = [];
	            keys.forEach(function (key) {
	                var doc = docs.get(key);
	                assert_1.assert(!!doc, 'Missing entity in write response for ' + key);
	                result.push(doc);
	            });
	            return result;
	        });
	    };
	    /** Gets an auth token and invokes the provided RPC. */
	    Datastore.prototype.invokeRPC = function (rpcName, request) {
	        var _this = this;
	        // TODO(mikelehen): Retry (with backoff) on token failures?
	        return this.credentials.getToken(/*forceRefresh=*/ false).then(function (token) {
	            return _this.connection.invokeRPC(rpcName, request, token);
	        });
	    };
	    /** Gets an auth token and invokes the provided RPC with streamed results. */
	    Datastore.prototype.invokeStreamingRPC = function (rpcName, request) {
	        var _this = this;
	        // TODO(mikelehen): Retry (with backoff) on token failures?
	        return this.credentials.getToken(/*forceRefresh=*/ false).then(function (token) {
	            return _this.connection.invokeStreamingRPC(rpcName, request, token);
	        });
	    };
	    return Datastore;
	}());
	exports.Datastore = Datastore;
	
	//# sourceMappingURL=datastore.js.map


/***/ }),
/* 289 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var ExistenceFilter = /** @class */ (function () {
	    // TODO(b/33078163): just use simplest form of existence filter for now
	    function ExistenceFilter(count) {
	        this.count = count;
	    }
	    ExistenceFilter.prototype.isEqual = function (other) {
	        return other && other.count === this.count;
	    };
	    return ExistenceFilter;
	}());
	exports.ExistenceFilter = ExistenceFilter;
	
	//# sourceMappingURL=existence_filter.js.map


/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var assert_1 = __webpack_require__(2);
	var error_1 = __webpack_require__(10);
	var log = __webpack_require__(13);
	var backoff_1 = __webpack_require__(287);
	var types_1 = __webpack_require__(55);
	var LOG_TAG = 'PersistentStream';
	var PersistentStreamState;
	(function (PersistentStreamState) {
	    /**
	     * The streaming RPC is not running and there's no error condition.
	     * Calling `start` will start the stream immediately without backoff.
	     * While in this state isStarted will return false.
	     */
	    PersistentStreamState[PersistentStreamState["Initial"] = 0] = "Initial";
	    /**
	     * The stream is starting, and is waiting for an auth token to attach to
	     * the initial request. While in this state, isStarted will return
	     * true but isOpen will return false.
	     */
	    PersistentStreamState[PersistentStreamState["Auth"] = 1] = "Auth";
	    /**
	     * The streaming RPC is up and running. Requests and responses can flow
	     * freely. Both isStarted and isOpen will return true.
	     */
	    PersistentStreamState[PersistentStreamState["Open"] = 2] = "Open";
	    /**
	     * The stream encountered an error. The next start attempt will back off.
	     * While in this state isStarted() will return false.
	     *
	     */
	    PersistentStreamState[PersistentStreamState["Error"] = 3] = "Error";
	    /**
	     * An in-between state after an error where the stream is waiting before
	     * re-starting. After
	     * waiting is complete, the stream will try to open. While in this
	     * state isStarted() will return YES but isOpen will return false.
	     */
	    PersistentStreamState[PersistentStreamState["Backoff"] = 4] = "Backoff";
	    /**
	     * The stream has been explicitly stopped; no further events will be emitted.
	     */
	    PersistentStreamState[PersistentStreamState["Stopped"] = 5] = "Stopped";
	})(PersistentStreamState || (PersistentStreamState = {}));
	/**
	 * Initial backoff time in milliseconds after an error.
	 * Set to 1s according to https://cloud.google.com/apis/design/errors.
	 */
	var BACKOFF_INITIAL_DELAY_MS = 1000;
	/** Maximum backoff time in milliseconds */
	var BACKOFF_MAX_DELAY_MS = 60 * 1000;
	var BACKOFF_FACTOR = 1.5;
	/** The time a stream stays open after it is marked idle. */
	var IDLE_TIMEOUT_MS = 60 * 1000;
	/**
	 * A PersistentStream is an abstract base class that represents a streaming RPC
	 * to the Firestore backend. It's built on top of the connections own support
	 * for streaming RPCs, and adds several critical features for our clients:
	 *
	 *   - Exponential backoff on failure
	 *   - Authentication via CredentialsProvider
	 *   - Dispatching all callbacks into the shared worker queue
	 *
	 * Subclasses of PersistentStream implement serialization of models to and
	 * from the JSON representation of the protocol buffers for a specific
	 * streaming RPC.
	 *
	 * ## Starting and Stopping
	 *
	 * Streaming RPCs are stateful and need to be `start`ed before messages can
	 * be sent and received. The PersistentStream will call the onOpen function
	 * of the listener once the stream is ready to accept requests.
	 *
	 * Should a `start` fail, PersistentStream will call the registered
	 * onClose with a FirestoreError indicating what went wrong.
	 *
	 * A PersistentStream can be started and stopped repeatedly.
	 *
	 * Generic types:
	 *  SendType: The type of the outgoing message of the underlying
	 *    connection stream
	 *  ReceiveType: The type of the incoming message of the underlying
	 *    connection stream
	 *  ListenerType: The type of the listener that will be used for callbacks
	 */
	var PersistentStream = /** @class */ (function () {
	    function PersistentStream(queue, connection, credentialsProvider, 
	        // Used for faster retries in testing
	        initialBackoffDelay) {
	        this.queue = queue;
	        this.connection = connection;
	        this.credentialsProvider = credentialsProvider;
	        this.idle = false;
	        this.stream = null;
	        this.listener = null;
	        this.backoff = new backoff_1.ExponentialBackoff(initialBackoffDelay ? initialBackoffDelay : BACKOFF_INITIAL_DELAY_MS, BACKOFF_FACTOR, BACKOFF_MAX_DELAY_MS);
	        this.state = PersistentStreamState.Initial;
	    }
	    /**
	     * Returns true if `start` has been called and no error has occurred. True
	     * indicates the stream is open or in the process of opening (which
	     * encompasses respecting backoff, getting auth tokens, and starting the
	     * actual RPC). Use `isOpen` to determine if the stream is open and ready for
	     * outbound requests.
	     */
	    PersistentStream.prototype.isStarted = function () {
	        return (this.state === PersistentStreamState.Backoff ||
	            this.state === PersistentStreamState.Auth ||
	            this.state === PersistentStreamState.Open);
	    };
	    /**
	     * Returns true if the underlying RPC is open (the openHandler has been
	     * called) and the stream is ready for outbound requests.
	     */
	    PersistentStream.prototype.isOpen = function () {
	        return this.state === PersistentStreamState.Open;
	    };
	    /**
	     * Starts the RPC. Only allowed if isStarted returns false. The stream is
	     * not immediately ready for use: onOpen will be invoked when the RPC is ready
	     * for outbound requests, at which point isOpen will return true.
	     *
	     *  When start returns, isStarted will return true.
	     */
	    PersistentStream.prototype.start = function (listener) {
	        if (this.state === PersistentStreamState.Error) {
	            this.performBackoff(listener);
	            return;
	        }
	        assert_1.assert(this.state === PersistentStreamState.Initial, 'Already started');
	        this.listener = listener;
	        this.auth();
	    };
	    /**
	     * Stops the RPC. This call is idempotent and allowed regardless of the
	     * current isStarted state.
	     *
	     * When stop returns, isStarted and isOpen will both return false.
	     */
	    PersistentStream.prototype.stop = function () {
	        if (this.isStarted()) {
	            this.close(PersistentStreamState.Stopped);
	        }
	    };
	    /**
	     * After an error the stream will usually back off on the next attempt to
	     * start it. If the error warrants an immediate restart of the stream, the
	     * sender can use this to indicate that the receiver should not back off.
	     *
	     * Each error will call the onClose function. That function can decide to
	     * inhibit backoff if required.
	     */
	    PersistentStream.prototype.inhibitBackoff = function () {
	        assert_1.assert(!this.isStarted(), 'Can only inhibit backoff in a stopped state');
	        this.state = PersistentStreamState.Initial;
	        this.backoff.reset();
	    };
	    /**
	     * Initializes the idle timer. If no write takes place within one minute, the
	     * WebChannel stream will be closed.
	     */
	    PersistentStream.prototype.markIdle = function () {
	        var _this = this;
	        this.idle = true;
	        this.queue
	            .schedule(function () {
	            return _this.handleIdleCloseTimer();
	        }, IDLE_TIMEOUT_MS)
	            .catch(function (err) {
	            // When the AsyncQueue gets drained during testing, pending Promises
	            // (including these idle checks) will get rejected. We special-case
	            // these cancelled idle checks to make sure that these specific Promise
	            // rejections are not considered unhandled.
	            assert_1.assert(err.code === error_1.Code.CANCELLED, "Received unexpected error in idle timeout closure. Expected CANCELLED, but was: " + err);
	        });
	    };
	    /** Sends a message to the underlying stream. */
	    PersistentStream.prototype.sendRequest = function (msg) {
	        this.cancelIdleCheck();
	        this.stream.send(msg);
	    };
	    /** Called by the idle timer when the stream should close due to inactivity. */
	    PersistentStream.prototype.handleIdleCloseTimer = function () {
	        if (this.isOpen() && this.idle) {
	            // When timing out an idle stream there's no reason to force the stream into backoff when
	            // it restarts so set the stream state to Initial instead of Error.
	            return this.close(PersistentStreamState.Initial);
	        }
	        return Promise.resolve();
	    };
	    /** Marks the stream as active again. */
	    PersistentStream.prototype.cancelIdleCheck = function () {
	        this.idle = false;
	    };
	    /**
	     * Closes the stream and cleans up as necessary:
	     *
	     * * closes the underlying GRPC stream;
	     * * calls the onClose handler with the given 'error';
	     * * sets internal stream state to 'finalState';
	     * * adjusts the backoff timer based on the error
	     *
	     * A new stream can be opened by calling `start` unless `finalState` is set to
	     * `PersistentStreamState.Stopped`.
	     *
	     * @param finalState the intended state of the stream after closing.
	     * @param error the error the connection was closed with.
	     */
	    PersistentStream.prototype.close = function (finalState, error) {
	        assert_1.assert(finalState === PersistentStreamState.Error || types_1.isNullOrUndefined(error), "Can't provide an error when not in an error state.");
	        this.cancelIdleCheck();
	        if (finalState !== PersistentStreamState.Error) {
	            // If this is an intentional close ensure we don't delay our next connection attempt.
	            this.backoff.reset();
	        }
	        else if (error && error.code === error_1.Code.RESOURCE_EXHAUSTED) {
	            // Log the error. (Probably either 'quota exceeded' or 'max queue length reached'.)
	            log.error(error.toString());
	            log.error('Using maximum backoff delay to prevent overloading the backend.');
	            this.backoff.resetToMax();
	        }
	        // Clean up the underlying stream because we are no longer interested in events.
	        if (this.stream !== null) {
	            this.tearDown();
	            this.stream.close();
	            this.stream = null;
	        }
	        // This state must be assigned before calling onClose() to allow the callback to
	        // inhibit backoff or otherwise manipulate the state in its non-started state.
	        this.state = finalState;
	        var listener = this.listener;
	        // Clear the listener to avoid bleeding of events from the underlying streams.
	        this.listener = null;
	        // If the caller explicitly requested a stream stop, don't notify them of a closing stream (it
	        // could trigger undesirable recovery logic, etc.).
	        if (finalState !== PersistentStreamState.Stopped) {
	            return listener.onClose(error);
	        }
	        else {
	            return Promise.resolve();
	        }
	    };
	    /**
	     * Can be overridden to perform additional cleanup before the stream is closed.
	     * Calling super.tearDown() is not required.
	     */
	    PersistentStream.prototype.tearDown = function () { };
	    PersistentStream.prototype.auth = function () {
	        var _this = this;
	        assert_1.assert(this.state === PersistentStreamState.Initial, 'Must be in initial state to auth');
	        this.state = PersistentStreamState.Auth;
	        this.credentialsProvider.getToken(/*forceRefresh=*/ false).then(function (token) {
	            // Normally we'd have to schedule the callback on the AsyncQueue.
	            // However, the following calls are safe to be called outside the
	            // AsyncQueue since they don't chain asynchronous calls
	            _this.startStream(token);
	        }, function (error) {
	            _this.queue.schedule(function () {
	                if (_this.state !== PersistentStreamState.Stopped) {
	                    // Stream can be stopped while waiting for authorization.
	                    var rpcError = new error_1.FirestoreError(error_1.Code.UNKNOWN, 'Fetching auth token failed: ' + error.message);
	                    return _this.handleStreamClose(rpcError);
	                }
	                else {
	                    return Promise.resolve();
	                }
	            });
	        });
	    };
	    PersistentStream.prototype.startStream = function (token) {
	        var _this = this;
	        if (this.state === PersistentStreamState.Stopped) {
	            // Stream can be stopped while waiting for authorization.
	            return;
	        }
	        assert_1.assert(this.state === PersistentStreamState.Auth, 'Trying to start stream in a non-auth state');
	        // Helper function to dispatch to AsyncQueue and make sure that any
	        // close will seem instantaneous and events are prevented from being
	        // raised after the close call
	        var dispatchIfStillActive = function (stream, fn) {
	            _this.queue.schedule(function () {
	                // Only raise events if the stream instance has not changed
	                if (_this.stream === stream) {
	                    return fn();
	                }
	                else {
	                    return Promise.resolve();
	                }
	            });
	        };
	        // Only start stream if listener has not changed
	        if (this.listener !== null) {
	            var currentStream_1 = this.startRpc(token);
	            this.stream = currentStream_1;
	            this.stream.onOpen(function () {
	                dispatchIfStillActive(currentStream_1, function () {
	                    assert_1.assert(_this.state === PersistentStreamState.Auth, 'Expected stream to be in state auth, but was ' + _this.state);
	                    _this.state = PersistentStreamState.Open;
	                    return _this.listener.onOpen();
	                });
	            });
	            this.stream.onClose(function (error) {
	                dispatchIfStillActive(currentStream_1, function () {
	                    return _this.handleStreamClose(error);
	                });
	            });
	            this.stream.onMessage(function (msg) {
	                dispatchIfStillActive(currentStream_1, function () {
	                    return _this.onMessage(msg);
	                });
	            });
	        }
	    };
	    PersistentStream.prototype.performBackoff = function (listener) {
	        var _this = this;
	        assert_1.assert(this.state === PersistentStreamState.Error, 'Should only perform backoff in an error case');
	        this.state = PersistentStreamState.Backoff;
	        this.backoff.backoffAndWait().then(function () {
	            // Backoff does not run on the AsyncQueue, so we need to reschedule to
	            // make sure the queue blocks
	            _this.queue.schedule(function () {
	                if (_this.state === PersistentStreamState.Stopped) {
	                    // Stream can be stopped while waiting for backoff to complete.
	                    return Promise.resolve();
	                }
	                _this.state = PersistentStreamState.Initial;
	                _this.start(listener);
	                assert_1.assert(_this.isStarted(), 'PersistentStream should have started');
	                return Promise.resolve();
	            });
	        });
	    };
	    PersistentStream.prototype.handleStreamClose = function (error) {
	        assert_1.assert(this.isStarted(), "Can't handle server close on non-started stream");
	        log.debug(LOG_TAG, "close with error: " + error);
	        this.stream = null;
	        // In theory the stream could close cleanly, however, in our current model
	        // we never expect this to happen because if we stop a stream ourselves,
	        // this callback will never be called. To prevent cases where we retry
	        // without a backoff accidentally, we set the stream to error in all cases.
	        return this.close(PersistentStreamState.Error, error);
	    };
	    return PersistentStream;
	}());
	exports.PersistentStream = PersistentStream;
	/**
	 * A PersistentStream that implements the Listen RPC.
	 *
	 * Once the Listen stream has called the openHandler, any number of listen and
	 * unlisten calls calls can be sent to control what changes will be sent from
	 * the server for ListenResponses.
	 */
	var PersistentListenStream = /** @class */ (function (_super) {
	    __extends(PersistentListenStream, _super);
	    function PersistentListenStream(databaseInfo, queue, connection, credentials, serializer, initialBackoffDelay) {
	        var _this = _super.call(this, queue, connection, credentials, initialBackoffDelay) || this;
	        _this.databaseInfo = databaseInfo;
	        _this.serializer = serializer;
	        return _this;
	    }
	    PersistentListenStream.prototype.startRpc = function (token) {
	        return this.connection.openStream('Listen', token);
	    };
	    PersistentListenStream.prototype.onMessage = function (watchChangeProto) {
	        // A successful response means the stream is healthy
	        this.backoff.reset();
	        var watchChange = this.serializer.fromWatchChange(watchChangeProto);
	        var snapshot = this.serializer.versionFromListenResponse(watchChangeProto);
	        return this.listener.onWatchChange(watchChange, snapshot);
	    };
	    /**
	     * Registers interest in the results of the given query. If the query
	     * includes a resumeToken it will be included in the request. Results that
	     * affect the query will be streamed back as WatchChange messages that
	     * reference the targetId.
	     */
	    PersistentListenStream.prototype.watch = function (queryData) {
	        var request = {};
	        request.database = this.serializer.encodedDatabaseId;
	        request.addTarget = this.serializer.toTarget(queryData);
	        var labels = this.serializer.toListenRequestLabels(queryData);
	        if (labels) {
	            request.labels = labels;
	        }
	        this.sendRequest(request);
	    };
	    /**
	     * Unregisters interest in the results of the query associated with the
	     * given targetId.
	     */
	    PersistentListenStream.prototype.unwatch = function (targetId) {
	        var request = {};
	        request.database = this.serializer.encodedDatabaseId;
	        request.removeTarget = targetId;
	        this.sendRequest(request);
	    };
	    return PersistentListenStream;
	}(PersistentStream));
	exports.PersistentListenStream = PersistentListenStream;
	/**
	 * A Stream that implements the Write RPC.
	 *
	 * The Write RPC requires the caller to maintain special streamToken
	 * state in between calls, to help the server understand which responses the
	 * client has processed by the time the next request is made. Every response
	 * will contain a streamToken; this value must be passed to the next
	 * request.
	 *
	 * After calling start() on this stream, the next request must be a handshake,
	 * containing whatever streamToken is on hand. Once a response to this
	 * request is received, all pending mutations may be submitted. When
	 * submitting multiple batches of mutations at the same time, it's
	 * okay to use the same streamToken for the calls to writeMutations.
	 *
	 * TODO(b/33271235): Use proto types
	 */
	var PersistentWriteStream = /** @class */ (function (_super) {
	    __extends(PersistentWriteStream, _super);
	    function PersistentWriteStream(databaseInfo, queue, connection, credentials, serializer, initialBackoffDelay) {
	        var _this = _super.call(this, queue, connection, credentials, initialBackoffDelay) || this;
	        _this.databaseInfo = databaseInfo;
	        _this.serializer = serializer;
	        _this.handshakeComplete_ = false;
	        return _this;
	    }
	    Object.defineProperty(PersistentWriteStream.prototype, "handshakeComplete", {
	        /**
	         * Tracks whether or not a handshake has been successfully exchanged and
	         * the stream is ready to accept mutations.
	         */
	        get: function () {
	            return this.handshakeComplete_;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    // Override of PersistentStream.start
	    PersistentWriteStream.prototype.start = function (listener) {
	        this.handshakeComplete_ = false;
	        _super.prototype.start.call(this, listener);
	    };
	    PersistentWriteStream.prototype.tearDown = function () {
	        if (this.handshakeComplete_) {
	            this.writeMutations([]);
	        }
	    };
	    PersistentWriteStream.prototype.startRpc = function (token) {
	        return this.connection.openStream('Write', token);
	    };
	    PersistentWriteStream.prototype.onMessage = function (responseProto) {
	        // Always capture the last stream token.
	        assert_1.assert(!!responseProto.streamToken, 'Got a write response without a stream token');
	        this.lastStreamToken = responseProto.streamToken;
	        if (!this.handshakeComplete_) {
	            // The first response is always the handshake response
	            assert_1.assert(!responseProto.writeResults || responseProto.writeResults.length === 0, 'Got mutation results for handshake');
	            this.handshakeComplete_ = true;
	            return this.listener.onHandshakeComplete();
	        }
	        else {
	            // A successful first write response means the stream is healthy,
	            // Note, that we could consider a successful handshake healthy, however,
	            // the write itself might be causing an error we want to back off from.
	            this.backoff.reset();
	            var results = this.serializer.fromWriteResults(responseProto.writeResults);
	            var commitVersion = this.serializer.fromVersion(responseProto.commitTime);
	            return this.listener.onMutationResult(commitVersion, results);
	        }
	    };
	    /**
	     * Sends an initial streamToken to the server, performing the handshake
	     * required to make the StreamingWrite RPC work. Subsequent
	     * calls should wait until onHandshakeComplete was called.
	     */
	    PersistentWriteStream.prototype.writeHandshake = function () {
	        assert_1.assert(this.isOpen(), 'Writing handshake requires an opened stream');
	        assert_1.assert(!this.handshakeComplete_, 'Handshake already completed');
	        // TODO(dimond): Support stream resumption. We intentionally do not set the
	        // stream token on the handshake, ignoring any stream token we might have.
	        var request = {};
	        request.database = this.serializer.encodedDatabaseId;
	        this.sendRequest(request);
	    };
	    /** Sends a group of mutations to the Firestore backend to apply. */
	    PersistentWriteStream.prototype.writeMutations = function (mutations) {
	        var _this = this;
	        assert_1.assert(this.isOpen(), 'Writing mutations requires an opened stream');
	        assert_1.assert(this.handshakeComplete_, 'Handshake must be complete before writing mutations');
	        assert_1.assert(this.lastStreamToken.length > 0, 'Trying to write mutation without a token');
	        var request = {
	            // Protos are typed with string, but we support UInt8Array on Node
	            // tslint:disable-next-line:no-any
	            streamToken: this.lastStreamToken,
	            writes: mutations.map(function (mutation) { return _this.serializer.toMutation(mutation); })
	        };
	        this.sendRequest(request);
	    };
	    return PersistentWriteStream;
	}(PersistentStream));
	exports.PersistentWriteStream = PersistentWriteStream;
	
	//# sourceMappingURL=persistent_stream.js.map


/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var snapshot_version_1 = __webpack_require__(20);
	var transaction_1 = __webpack_require__(267);
	var types_1 = __webpack_require__(99);
	var query_data_1 = __webpack_require__(51);
	var document_1 = __webpack_require__(21);
	var document_key_1 = __webpack_require__(12);
	var mutation_batch_1 = __webpack_require__(52);
	var platform_1 = __webpack_require__(29);
	var assert_1 = __webpack_require__(2);
	var error_1 = __webpack_require__(10);
	var log = __webpack_require__(13);
	var objUtils = __webpack_require__(27);
	var remote_event_1 = __webpack_require__(53);
	var rpc_error_1 = __webpack_require__(102);
	var watch_change_1 = __webpack_require__(164);
	var LOG_TAG = 'RemoteStore';
	// TODO(b/35853402): Negotiate this with the stream.
	var MAX_PENDING_WRITES = 10;
	// The RemoteStore notifies an onlineStateHandler with OnlineState.Failed if we
	// fail to connect to the backend. This subsequently triggers get() requests to
	// fail or use cached data, etc. Unfortunately, our connections have
	// historically been subject to various transient failures. So we wait for
	// multiple failures before notifying the onlineStateHandler.
	var ONLINE_ATTEMPTS_BEFORE_FAILURE = 2;
	/**
	 * RemoteStore - An interface to remotely stored data, basically providing a
	 * wrapper around the Datastore that is more reliable for the rest of the
	 * system.
	 *
	 * RemoteStore is responsible for maintaining the connection to the server.
	 * - maintaining a list of active listens.
	 * - reconnecting when the connection is dropped.
	 * - resuming all the active listens on reconnect.
	 *
	 * RemoteStore handles all incoming events from the Datastore.
	 * - listening to the watch stream and repackaging the events as RemoteEvents
	 * - notifying SyncEngine of any changes to the active listens.
	 *
	 * RemoteStore takes writes from other components and handles them reliably.
	 * - pulling pending mutations from LocalStore and sending them to Datastore.
	 * - retrying mutations that failed because of network problems.
	 * - acking mutations to the SyncEngine once they are accepted or rejected.
	 */
	var RemoteStore = /** @class */ (function () {
	    function RemoteStore(
	        /**
	         * The local store, used to fill the write pipeline with outbound
	         * mutations and resolve existence filter mismatches.
	         */
	        localStore, 
	        /** The client-side proxy for interacting with the backend. */
	        datastore, onlineStateHandler) {
	        this.localStore = localStore;
	        this.datastore = datastore;
	        this.onlineStateHandler = onlineStateHandler;
	        this.pendingWrites = [];
	        this.lastBatchSeen = mutation_batch_1.BATCHID_UNKNOWN;
	        /**
	         * A mapping of watched targets that the client cares about tracking and the
	         * user has explicitly called a 'listen' for this target.
	         *
	         * These targets may or may not have been sent to or acknowledged by the
	         * server. On re-establishing the listen stream, these targets should be sent
	         * to the server. The targets removed with unlistens are removed eagerly
	         * without waiting for confirmation from the listen stream.
	         */
	        this.listenTargets = {};
	        /**
	         * A mapping of targetId to pending acks needed.
	         *
	         * If a targetId is present in this map, then we're waiting for watch to
	         * acknowledge a removal or addition of the target. If a target is not in this
	         * mapping, and it's in the listenTargets map, then we consider the target to
	         * be active.
	         *
	         * We increment the count here every time we issue a request over the stream
	         * to watch or unwatch. We then decrement the count every time we get a target
	         * added or target removed message from the server. Once the count is equal to
	         * 0 we know that the client and server are in the same state (once this state
	         * is reached the targetId is removed from the map to free the memory).
	         */
	        this.pendingTargetResponses = {};
	        this.accumulatedWatchChanges = [];
	        this.watchStream = null;
	        this.writeStream = null;
	        /**
	         * The online state of the watch stream. The state is set to healthy if and
	         * only if there are messages received by the backend.
	         */
	        this.watchStreamOnlineState = types_1.OnlineState.Unknown;
	        /** A count of consecutive failures to open the stream. */
	        this.watchStreamFailures = 0;
	        /** Whether the client should fire offline warning. */
	        this.shouldWarnOffline = true;
	    }
	    /**
	     * Starts up the remote store, creating streams, restoring state from
	     * LocalStore, etc.
	     */
	    RemoteStore.prototype.start = function () {
	        return this.enableNetwork();
	    };
	    /**
	     * Updates our OnlineState to the new state, updating local state
	     * and notifying the onlineStateHandler as appropriate. Idempotent.
	     */
	    RemoteStore.prototype.updateOnlineState = function (newState) {
	        if (newState !== this.watchStreamOnlineState) {
	            if (newState === types_1.OnlineState.Healthy) {
	                // We've connected to watch at least once. Don't warn the developer about
	                // being offline going forward.
	                this.shouldWarnOffline = false;
	            }
	            else if (newState === types_1.OnlineState.Unknown) {
	                // The state is set to unknown when a healthy stream is closed (e.g. due to
	                // a token timeout) or when we have no active listens and therefore there's
	                // no need to start the stream. Assuming there is (possibly in the future)
	                // an active listen, then we will eventually move to state Online or Failed,
	                // but we always want to make at least ONLINE_ATTEMPTS_BEFORE_FAILURE
	                // attempts before failing, so we reset the count here.
	                this.watchStreamFailures = 0;
	            }
	            this.watchStreamOnlineState = newState;
	            this.onlineStateHandler(newState);
	        }
	    };
	    /**
	     * Updates our OnlineState as appropriate after the watch stream reports a
	     * failure. The first failure moves us to the 'Unknown' state. We then may
	     * allow multiple failures (based on ONLINE_ATTEMPTS_BEFORE_FAILURE) before we
	     * actually transition to OnlineState.Failed.
	     */
	    RemoteStore.prototype.updateOnlineStateAfterFailure = function () {
	        if (this.watchStreamOnlineState === types_1.OnlineState.Healthy) {
	            this.updateOnlineState(types_1.OnlineState.Unknown);
	        }
	        else {
	            this.watchStreamFailures++;
	            if (this.watchStreamFailures >= ONLINE_ATTEMPTS_BEFORE_FAILURE) {
	                if (this.shouldWarnOffline) {
	                    log.error('Could not reach Firestore backend.');
	                    this.shouldWarnOffline = false;
	                }
	                this.updateOnlineState(types_1.OnlineState.Failed);
	            }
	        }
	    };
	    RemoteStore.prototype.isNetworkEnabled = function () {
	        assert_1.assert((this.watchStream == null) === (this.writeStream == null), 'WatchStream and WriteStream should both be null or non-null');
	        return this.watchStream != null;
	    };
	    /** Re-enables the network. Idempotent. */
	    RemoteStore.prototype.enableNetwork = function () {
	        var _this = this;
	        if (this.isNetworkEnabled()) {
	            return Promise.resolve();
	        }
	        // Create new streams (but note they're not started yet).
	        this.watchStream = this.datastore.newPersistentWatchStream();
	        this.writeStream = this.datastore.newPersistentWriteStream();
	        // Load any saved stream token from persistent storage
	        return this.localStore.getLastStreamToken().then(function (token) {
	            _this.writeStream.lastStreamToken = token;
	            if (_this.shouldStartWatchStream()) {
	                _this.startWatchStream();
	            }
	            _this.updateOnlineState(types_1.OnlineState.Unknown);
	            return _this.fillWritePipeline(); // This may start the writeStream.
	        });
	    };
	    /**
	     * Temporarily disables the network. The network can be re-enabled using
	     * enableNetwork().
	     */
	    RemoteStore.prototype.disableNetwork = function () {
	        this.disableNetworkInternal();
	        // Set the OnlineState to failed so get()'s return from cache, etc.
	        this.updateOnlineState(types_1.OnlineState.Failed);
	        return Promise.resolve();
	    };
	    /**
	     * Disables the network, if it is currently enabled.
	     */
	    RemoteStore.prototype.disableNetworkInternal = function () {
	        if (this.isNetworkEnabled()) {
	            // NOTE: We're guaranteed not to get any further events from these streams (not even a close
	            // event).
	            this.watchStream.stop();
	            this.writeStream.stop();
	            this.cleanUpWatchStreamState();
	            this.cleanUpWriteStreamState();
	            this.writeStream = null;
	            this.watchStream = null;
	        }
	    };
	    RemoteStore.prototype.shutdown = function () {
	        log.debug(LOG_TAG, 'RemoteStore shutting down.');
	        this.disableNetworkInternal();
	        // Set the OnlineState to Unknown (rather than Failed) to avoid potentially
	        // triggering spurious listener events with cached data, etc.
	        this.updateOnlineState(types_1.OnlineState.Unknown);
	        return Promise.resolve();
	    };
	    /** Starts new listen for the given query. Uses resume token if provided */
	    RemoteStore.prototype.listen = function (queryData) {
	        assert_1.assert(!objUtils.contains(this.listenTargets, queryData.targetId), 'listen called with duplicate targetId!');
	        // Mark this as something the client is currently listening for.
	        this.listenTargets[queryData.targetId] = queryData;
	        if (this.shouldStartWatchStream()) {
	            // The listen will be sent in onWatchStreamOpen
	            this.startWatchStream();
	        }
	        else if (this.isNetworkEnabled() && this.watchStream.isOpen()) {
	            this.sendWatchRequest(queryData);
	        }
	    };
	    /** Removes the listen from server */
	    RemoteStore.prototype.unlisten = function (targetId) {
	        assert_1.assert(objUtils.contains(this.listenTargets, targetId), 'unlisten called without assigned target ID!');
	        var queryData = this.listenTargets[targetId];
	        delete this.listenTargets[targetId];
	        if (this.isNetworkEnabled() && this.watchStream.isOpen()) {
	            this.sendUnwatchRequest(targetId);
	            if (objUtils.isEmpty(this.listenTargets)) {
	                this.watchStream.markIdle();
	            }
	        }
	    };
	    /**
	     * We need to increment the the expected number of pending responses we're due
	     * from watch so we wait for the ack to process any messages from this target.
	     */
	    RemoteStore.prototype.sendWatchRequest = function (queryData) {
	        this.recordPendingTargetRequest(queryData.targetId);
	        this.watchStream.watch(queryData);
	    };
	    /**
	     * We need to increment the expected number of pending responses we're due
	     * from watch so we wait for the removal on the server before we process any
	     * messages from this target.
	     */
	    RemoteStore.prototype.sendUnwatchRequest = function (targetId) {
	        this.recordPendingTargetRequest(targetId);
	        this.watchStream.unwatch(targetId);
	    };
	    /**
	     * Increment the mapping of how many acks are needed from watch before we can
	     * consider the server to be 'in-sync' with the client's active targets.
	     */
	    RemoteStore.prototype.recordPendingTargetRequest = function (targetId) {
	        // For each request we get we need to record we need a response for it.
	        this.pendingTargetResponses[targetId] =
	            (this.pendingTargetResponses[targetId] || 0) + 1;
	    };
	    RemoteStore.prototype.startWatchStream = function () {
	        assert_1.assert(this.shouldStartWatchStream(), 'startWriteStream() called when shouldStartWatchStream() is false.');
	        this.watchStream.start({
	            onOpen: this.onWatchStreamOpen.bind(this),
	            onClose: this.onWatchStreamClose.bind(this),
	            onWatchChange: this.onWatchStreamChange.bind(this)
	        });
	    };
	    /**
	     * Returns whether the watch stream should be started because there are
	     * active targets trying to be listened too
	     */
	    RemoteStore.prototype.shouldStartWatchStream = function () {
	        return (this.isNetworkEnabled() &&
	            !this.watchStream.isStarted() &&
	            !objUtils.isEmpty(this.listenTargets));
	    };
	    RemoteStore.prototype.cleanUpWatchStreamState = function () {
	        // If the connection is closed then we'll never get a snapshot version for
	        // the accumulated changes and so we'll never be able to complete the batch.
	        // When we start up again the server is going to resend these changes
	        // anyway, so just toss the accumulated state.
	        this.accumulatedWatchChanges = [];
	        this.pendingTargetResponses = {};
	    };
	    RemoteStore.prototype.onWatchStreamOpen = function () {
	        var _this = this;
	        // TODO(b/35852690): close the stream again (with some timeout?) if no watch
	        // targets are active
	        objUtils.forEachNumber(this.listenTargets, function (targetId, queryData) {
	            _this.sendWatchRequest(queryData);
	        });
	        return Promise.resolve();
	    };
	    RemoteStore.prototype.onWatchStreamClose = function (error) {
	        assert_1.assert(this.isNetworkEnabled(), 'onWatchStreamClose() should only be called when the network is enabled');
	        this.cleanUpWatchStreamState();
	        // If there was an error, retry the connection.
	        if (this.shouldStartWatchStream()) {
	            this.updateOnlineStateAfterFailure();
	            this.startWatchStream();
	        }
	        else {
	            // No need to restart watch stream because there are no active targets.
	            // The online state is set to unknown because there is no active attempt
	            // at establishing a connection
	            this.updateOnlineState(types_1.OnlineState.Unknown);
	        }
	        return Promise.resolve();
	    };
	    RemoteStore.prototype.onWatchStreamChange = function (watchChange, snapshotVersion) {
	        // Mark the connection as healthy because we got a message from the server
	        this.updateOnlineState(types_1.OnlineState.Healthy);
	        if (watchChange instanceof watch_change_1.WatchTargetChange &&
	            watchChange.state === watch_change_1.WatchTargetChangeState.Removed &&
	            watchChange.cause) {
	            // There was an error on a target, don't wait for a consistent snapshot
	            // to raise events
	            return this.handleTargetError(watchChange);
	        }
	        // Accumulate watch changes but don't process them if there's no
	        // snapshotVersion or it's older than a previous snapshot we've processed
	        // (can happen after we resume a target using a resume token).
	        this.accumulatedWatchChanges.push(watchChange);
	        if (!snapshotVersion.isEqual(snapshot_version_1.SnapshotVersion.MIN) &&
	            snapshotVersion.compareTo(this.localStore.getLastRemoteSnapshotVersion()) >= 0) {
	            var changes = this.accumulatedWatchChanges;
	            this.accumulatedWatchChanges = [];
	            return this.handleWatchChangeBatch(snapshotVersion, changes);
	        }
	        else {
	            return Promise.resolve();
	        }
	    };
	    /**
	     * Takes a batch of changes from the Datastore, repackages them as a
	     * RemoteEvent, and passes that on to the listener, which is typically the
	     * SyncEngine.
	     */
	    RemoteStore.prototype.handleWatchChangeBatch = function (snapshotVersion, changes) {
	        var _this = this;
	        var aggregator = new watch_change_1.WatchChangeAggregator(snapshotVersion, this.listenTargets, this.pendingTargetResponses);
	        aggregator.addChanges(changes);
	        var remoteEvent = aggregator.createRemoteEvent();
	        // Get the new response counts from the aggregator
	        this.pendingTargetResponses = aggregator.pendingTargetResponses;
	        var promises = [];
	        // Handle existence filters and existence filter mismatches.
	        objUtils.forEachNumber(aggregator.existenceFilters, function (targetId, filter) {
	            var queryData = _this.listenTargets[targetId];
	            if (!queryData) {
	                // A watched target might have been removed already.
	                return;
	            }
	            var query = queryData.query;
	            if (query.isDocumentQuery()) {
	                if (filter.count === 0) {
	                    // The existence filter told us the document does not exist.
	                    // We need to deduce that this document does not exist and apply
	                    // a deleted document to our updates. Without applying a deleted
	                    // document there might be another query that will raise this
	                    // document as part of a snapshot until it is resolved,
	                    // essentially exposing inconsistency between queries.
	                    var key = new document_key_1.DocumentKey(query.path);
	                    var deletedDoc = new document_1.NoDocument(key, snapshotVersion);
	                    remoteEvent.addDocumentUpdate(deletedDoc);
	                }
	                else {
	                    assert_1.assert(filter.count === 1, 'Single document existence filter with count: ' + filter.count);
	                }
	            }
	            else {
	                // Not a document query.
	                var promise = _this.localStore
	                    .remoteDocumentKeys(targetId)
	                    .then(function (trackedRemote) {
	                    if (remoteEvent.targetChanges[targetId]) {
	                        var mapping = remoteEvent.targetChanges[targetId].mapping;
	                        if (mapping !== null) {
	                            if (mapping instanceof remote_event_1.UpdateMapping) {
	                                trackedRemote = mapping.applyToKeySet(trackedRemote);
	                            }
	                            else {
	                                assert_1.assert(mapping instanceof remote_event_1.ResetMapping, 'Expected either reset or update mapping but got something else: ' +
	                                    mapping);
	                                trackedRemote = mapping.documents;
	                            }
	                        }
	                    }
	                    if (trackedRemote.size !== filter.count) {
	                        // Existence filter mismatch, resetting mapping.
	                        // Make sure the mismatch is exposed in the remote event.
	                        remoteEvent.handleExistenceFilterMismatch(targetId);
	                        // Clear the resume token for the query, since we're in a
	                        // known mismatch state.
	                        var newQueryData = new query_data_1.QueryData(query, targetId, queryData.purpose);
	                        _this.listenTargets[targetId] = newQueryData;
	                        // Cause a hard reset by unwatching and rewatching
	                        // immediately, but deliberately don't send a resume token
	                        // so that we get a full update.
	                        // Make sure we expect that this acks are going to happen.
	                        _this.sendUnwatchRequest(targetId);
	                        // Mark the query we send as being on behalf of an existence
	                        // filter mismatch, but don't actually retain that in
	                        // listenTargets. This ensures that we flag the first
	                        // re-listen this way without impacting future listens of
	                        // this target (that might happen e.g. on reconnect).
	                        var requestQueryData = new query_data_1.QueryData(query, targetId, query_data_1.QueryPurpose.ExistenceFilterMismatch);
	                        _this.sendWatchRequest(requestQueryData);
	                    }
	                });
	                promises.push(promise);
	            }
	        });
	        return Promise.all(promises).then(function () {
	            // Update in-memory resume tokens. LocalStore will update the
	            // persistent view of these when applying the completed RemoteEvent.
	            objUtils.forEachNumber(remoteEvent.targetChanges, function (targetId, change) {
	                if (change.resumeToken.length > 0) {
	                    var queryData = _this.listenTargets[targetId];
	                    // A watched target might have been removed already.
	                    if (queryData) {
	                        _this.listenTargets[targetId] = queryData.update({
	                            resumeToken: change.resumeToken,
	                            snapshotVersion: change.snapshotVersion
	                        });
	                    }
	                }
	            });
	            // Finally handle remote event
	            return _this.syncEngine.applyRemoteEvent(remoteEvent);
	        });
	    };
	    /** Handles an error on a target */
	    RemoteStore.prototype.handleTargetError = function (watchChange) {
	        var _this = this;
	        assert_1.assert(!!watchChange.cause, 'Handling target error without a cause');
	        var error = watchChange.cause;
	        var promiseChain = Promise.resolve();
	        watchChange.targetIds.forEach(function (targetId) {
	            promiseChain = promiseChain.then(function () {
	                if (objUtils.contains(_this.listenTargets, targetId)) {
	                    delete _this.listenTargets[targetId];
	                    return _this.syncEngine.rejectListen(targetId, error);
	                }
	                else {
	                    // A watched target might have been removed already.
	                    return Promise.resolve();
	                }
	            });
	        });
	        return promiseChain;
	    };
	    RemoteStore.prototype.cleanUpWriteStreamState = function () {
	        this.lastBatchSeen = mutation_batch_1.BATCHID_UNKNOWN;
	        log.debug(LOG_TAG, 'Stopping write stream with ' +
	            this.pendingWrites.length +
	            ' pending writes');
	        this.pendingWrites = [];
	    };
	    /**
	     * Notifies that there are new mutations to process in the queue. This is
	     * typically called by SyncEngine after it has sent mutations to LocalStore.
	     */
	    RemoteStore.prototype.fillWritePipeline = function () {
	        var _this = this;
	        if (!this.canWriteMutations()) {
	            return Promise.resolve();
	        }
	        else {
	            return this.localStore
	                .nextMutationBatch(this.lastBatchSeen)
	                .then(function (batch) {
	                if (batch === null) {
	                    if (_this.pendingWrites.length === 0) {
	                        _this.writeStream.markIdle();
	                    }
	                    return Promise.resolve();
	                }
	                else {
	                    _this.commit(batch);
	                    return _this.fillWritePipeline();
	                }
	            });
	        }
	    };
	    /**
	     * Returns true if the backend can accept additional write requests.
	     *
	     * When sending mutations to the write stream (e.g. in fillWritePipeline),
	     * call this method first to check if more mutations can be sent.
	     *
	     * Currently the only thing that can prevent the backend from accepting
	     * write requests is if there are too many requests already outstanding. As
	     * writes complete the backend will be able to accept more.
	     */
	    RemoteStore.prototype.canWriteMutations = function () {
	        return (this.isNetworkEnabled() && this.pendingWrites.length < MAX_PENDING_WRITES);
	    };
	    // For testing
	    RemoteStore.prototype.outstandingWrites = function () {
	        return this.pendingWrites.length;
	    };
	    /**
	     * Given mutations to commit, actually commits them to the Datastore. Note
	     * that this does *not* return a Promise specifically because the AsyncQueue
	     * should not block operations for this.
	     */
	    RemoteStore.prototype.commit = function (batch) {
	        assert_1.assert(this.canWriteMutations(), "commit called when batches can't be written");
	        this.lastBatchSeen = batch.batchId;
	        this.pendingWrites.push(batch);
	        if (this.shouldStartWriteStream()) {
	            this.startWriteStream();
	        }
	        else if (this.isNetworkEnabled() && this.writeStream.handshakeComplete) {
	            this.writeStream.writeMutations(batch.mutations);
	        }
	    };
	    RemoteStore.prototype.shouldStartWriteStream = function () {
	        return (this.isNetworkEnabled() &&
	            !this.writeStream.isStarted() &&
	            this.pendingWrites.length > 0);
	    };
	    RemoteStore.prototype.startWriteStream = function () {
	        assert_1.assert(this.shouldStartWriteStream(), 'startWriteStream() called when shouldStartWriteStream() is false.');
	        this.writeStream.start({
	            onOpen: this.onWriteStreamOpen.bind(this),
	            onClose: this.onWriteStreamClose.bind(this),
	            onHandshakeComplete: this.onWriteHandshakeComplete.bind(this),
	            onMutationResult: this.onMutationResult.bind(this)
	        });
	    };
	    RemoteStore.prototype.onWriteStreamOpen = function () {
	        this.writeStream.writeHandshake();
	        return Promise.resolve();
	    };
	    RemoteStore.prototype.onWriteHandshakeComplete = function () {
	        var _this = this;
	        // Record the stream token.
	        return this.localStore
	            .setLastStreamToken(this.writeStream.lastStreamToken)
	            .then(function () {
	            // Drain any pending writes.
	            //
	            // Note that at this point pendingWrites contains mutations that
	            // have already been accepted by fillWritePipeline/commitBatch. If
	            // the pipeline is full, canWriteMutations will be false, despite
	            // the fact that we actually need to send mutations over.
	            //
	            // This also means that this method indirectly respects the limits
	            // imposed by canWriteMutations since writes can't be added to the
	            // pendingWrites array when canWriteMutations is false. If the
	            // limits imposed by canWriteMutations actually protect us from
	            // DOSing ourselves then those limits won't be exceeded here and
	            // we'll continue to make progress.
	            for (var _i = 0, _a = _this.pendingWrites; _i < _a.length; _i++) {
	                var batch = _a[_i];
	                _this.writeStream.writeMutations(batch.mutations);
	            }
	        });
	    };
	    RemoteStore.prototype.onMutationResult = function (commitVersion, results) {
	        var _this = this;
	        // This is a response to a write containing mutations and should be
	        // correlated to the first pending write.
	        assert_1.assert(this.pendingWrites.length > 0, 'Got result for empty pending writes');
	        var batch = this.pendingWrites.shift();
	        var success = mutation_batch_1.MutationBatchResult.from(batch, commitVersion, results, this.writeStream.lastStreamToken);
	        return this.syncEngine.applySuccessfulWrite(success).then(function () {
	            // It's possible that with the completion of this mutation another
	            // slot has freed up.
	            return _this.fillWritePipeline();
	        });
	    };
	    RemoteStore.prototype.onWriteStreamClose = function (error) {
	        var _this = this;
	        assert_1.assert(this.isNetworkEnabled(), 'onWriteStreamClose() should only be called when the network is enabled');
	        // If the write stream closed due to an error, invoke the error callbacks if
	        // there are pending writes.
	        if (error && this.pendingWrites.length > 0) {
	            assert_1.assert(!!error, 'We have pending writes, but the write stream closed without an error');
	            // A promise that is resolved after we processed the error
	            var errorHandling = void 0;
	            if (this.writeStream.handshakeComplete) {
	                // This error affects the actual write.
	                errorHandling = this.handleWriteError(error);
	            }
	            else {
	                // If there was an error before the handshake has finished, it's
	                // possible that the server is unable to process the stream token
	                // we're sending. (Perhaps it's too old?)
	                errorHandling = this.handleHandshakeError(error);
	            }
	            return errorHandling.then(function () {
	                // The write stream might have been started by refilling the write
	                // pipeline for failed writes
	                if (_this.shouldStartWriteStream()) {
	                    _this.startWriteStream();
	                }
	            });
	        }
	        else {
	            // No pending writes, nothing to do
	            return Promise.resolve();
	        }
	    };
	    RemoteStore.prototype.handleHandshakeError = function (error) {
	        // Reset the token if it's a permanent error or the error code is
	        // ABORTED, signaling the write stream is no longer valid.
	        if (rpc_error_1.isPermanentError(error.code) || error.code === error_1.Code.ABORTED) {
	            log.debug(LOG_TAG, 'RemoteStore error before completed handshake; resetting stream token: ', this.writeStream.lastStreamToken);
	            this.writeStream.lastStreamToken = platform_1.emptyByteString();
	            return this.localStore.setLastStreamToken(platform_1.emptyByteString());
	        }
	        else {
	            // Some other error, don't reset stream token. Our stream logic will
	            // just retry with exponential backoff.
	            return Promise.resolve();
	        }
	    };
	    RemoteStore.prototype.handleWriteError = function (error) {
	        var _this = this;
	        if (rpc_error_1.isPermanentError(error.code)) {
	            // This was a permanent error, the request itself was the problem
	            // so it's not going to succeed if we resend it.
	            var batch = this.pendingWrites.shift();
	            // In this case it's also unlikely that the server itself is melting
	            // down -- this was just a bad request so inhibit backoff on the next
	            // restart.
	            this.writeStream.inhibitBackoff();
	            return this.syncEngine
	                .rejectFailedWrite(batch.batchId, error)
	                .then(function () {
	                // It's possible that with the completion of this mutation
	                // another slot has freed up.
	                return _this.fillWritePipeline();
	            });
	        }
	        else {
	            // Transient error, just let the retry logic kick in.
	            return Promise.resolve();
	        }
	    };
	    RemoteStore.prototype.createTransaction = function () {
	        return new transaction_1.Transaction(this.datastore);
	    };
	    RemoteStore.prototype.handleUserChange = function (user) {
	        log.debug(LOG_TAG, 'RemoteStore changing users: uid=', user.uid);
	        // If the network has been explicitly disabled, make sure we don't
	        // accidentally re-enable it.
	        if (this.isNetworkEnabled()) {
	            // Tear down and re-create our network streams. This will ensure we get a fresh auth token
	            // for the new user and re-fill the write pipeline with new mutations from the LocalStore
	            // (since mutations are per-user).
	            this.disableNetworkInternal();
	            this.updateOnlineState(types_1.OnlineState.Unknown);
	            return this.enableNetwork();
	        }
	    };
	    return RemoteStore;
	}());
	exports.RemoteStore = RemoteStore;
	
	//# sourceMappingURL=remote_store.js.map


/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var assert_1 = __webpack_require__(2);
	/**
	 * Provides a simple helper class that implements the Stream interface to
	 * bridge to other implementations that are streams but do not implement the
	 * interface. The stream callbacks are invoked with the callOn... methods.
	 */
	var StreamBridge = /** @class */ (function () {
	    function StreamBridge(args) {
	        this.sendFn = args.sendFn;
	        this.closeFn = args.closeFn;
	    }
	    StreamBridge.prototype.onOpen = function (callback) {
	        assert_1.assert(!this.wrappedOnOpen, 'Called onOpen on stream twice!');
	        this.wrappedOnOpen = callback;
	    };
	    StreamBridge.prototype.onClose = function (callback) {
	        assert_1.assert(!this.wrappedOnClose, 'Called onClose on stream twice!');
	        this.wrappedOnClose = callback;
	    };
	    StreamBridge.prototype.onMessage = function (callback) {
	        assert_1.assert(!this.wrappedOnMessage, 'Called onMessage on stream twice!');
	        this.wrappedOnMessage = callback;
	    };
	    StreamBridge.prototype.close = function () {
	        this.closeFn();
	    };
	    StreamBridge.prototype.send = function (msg) {
	        this.sendFn(msg);
	    };
	    StreamBridge.prototype.callOnOpen = function () {
	        assert_1.assert(this.wrappedOnOpen !== undefined, 'Cannot call onOpen because no callback was set');
	        this.wrappedOnOpen();
	    };
	    StreamBridge.prototype.callOnClose = function (err) {
	        assert_1.assert(this.wrappedOnClose !== undefined, 'Cannot call onClose because no callback was set');
	        this.wrappedOnClose(err);
	    };
	    StreamBridge.prototype.callOnMessage = function (msg) {
	        assert_1.assert(this.wrappedOnMessage !== undefined, 'Cannot call onMessage because no callback was set');
	        this.wrappedOnMessage(msg);
	    };
	    return StreamBridge;
	}());
	exports.StreamBridge = StreamBridge;
	
	//# sourceMappingURL=stream_bridge.js.map


/***/ }),
/* 293 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	/*
	 * A wrapper implementation of Observer<T> that will dispatch events
	 * asynchronously. To allow immediate silencing, a mute call is added which
	 * causes events scheduled to no longer be raised.
	 */
	var AsyncObserver = /** @class */ (function () {
	    function AsyncObserver(observer) {
	        this.observer = observer;
	        /**
	         * When set to true, will not raise future events. Necessary to deal with
	         * async detachment of listener.
	         */
	        this.muted = false;
	    }
	    AsyncObserver.prototype.next = function (value) {
	        this.scheduleEvent(this.observer.next, value);
	    };
	    AsyncObserver.prototype.error = function (error) {
	        this.scheduleEvent(this.observer.error, error);
	    };
	    AsyncObserver.prototype.mute = function () {
	        this.muted = true;
	    };
	    AsyncObserver.prototype.scheduleEvent = function (eventHandler, event) {
	        var _this = this;
	        if (!this.muted) {
	            setTimeout(function () {
	                if (!_this.muted) {
	                    eventHandler(event);
	                }
	            }, 0);
	        }
	    };
	    return AsyncObserver;
	}());
	exports.AsyncObserver = AsyncObserver;
	
	//# sourceMappingURL=async_observer.js.map


/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var assert_1 = __webpack_require__(2);
	var log = __webpack_require__(13);
	var promise_1 = __webpack_require__(105);
	var error_1 = __webpack_require__(10);
	var AsyncQueue = /** @class */ (function () {
	    function AsyncQueue() {
	        // The last promise in the queue.
	        this.tail = Promise.resolve();
	        // A list with timeout handles and their respective deferred promises.
	        // Contains an entry for each operation that is queued to run in the future
	        // (i.e. it has a delay that has not yet elapsed). Prior to cleanup, this list
	        // may also contain entries that have already been run (in which case `handle` is
	        // null).
	        this.delayedOperations = [];
	        // The number of operations that are queued to be run in the future (i.e. they
	        // have a delay that has not yet elapsed). Unlike `delayedOperations`, this
	        // is guaranteed to only contain operations that have not yet been run.
	        //
	        // Visible for testing.
	        this.delayedOperationsCount = 0;
	        // Flag set while there's an outstanding AsyncQueue operation, used for
	        // assertion sanity-checks.
	        this.operationInProgress = false;
	    }
	    /**
	     * Adds a new operation to the queue. Returns a promise that will be resolved
	     * when the promise returned by the new operation is (with its value).
	     *
	     * Can optionally specify a delay (in milliseconds) to wait before queuing the
	     * operation.
	     */
	    AsyncQueue.prototype.schedule = function (op, delay) {
	        var _this = this;
	        if (this.failure) {
	            assert_1.fail('AsyncQueue is already failed: ' +
	                (this.failure.stack || this.failure.message));
	        }
	        if ((delay || 0) > 0) {
	            this.delayedOperationsCount++;
	            var delayedOp_1 = {
	                handle: null,
	                op: op,
	                deferred: new promise_1.Deferred()
	            };
	            delayedOp_1.handle = setTimeout(function () {
	                _this.scheduleInternal(function () {
	                    return delayedOp_1.op().then(function (result) {
	                        delayedOp_1.deferred.resolve(result);
	                    });
	                });
	                delayedOp_1.handle = null;
	                _this.delayedOperationsCount--;
	                if (_this.delayedOperationsCount === 0) {
	                    _this.delayedOperations = [];
	                }
	            }, delay);
	            this.delayedOperations.push(delayedOp_1);
	            return delayedOp_1.deferred.promise;
	        }
	        else {
	            return this.scheduleInternal(op);
	        }
	    };
	    AsyncQueue.prototype.scheduleInternal = function (op) {
	        var _this = this;
	        this.tail = this.tail.then(function () {
	            _this.operationInProgress = true;
	            return op()
	                .catch(function (error) {
	                _this.failure = error;
	                _this.operationInProgress = false;
	                var message = error.stack || error.message || '';
	                log.error('INTERNAL UNHANDLED ERROR: ', message);
	                // Escape the promise chain and throw the error globally so that
	                // e.g. any global crash reporting library detects and reports it.
	                // (but not for simulated errors in our tests since this breaks mocha)
	                if (message.indexOf('Firestore Test Simulated Error') < 0) {
	                    setTimeout(function () {
	                        throw error;
	                    }, 0);
	                }
	                // Re-throw the error so that this.tail becomes a rejected Promise and
	                // all further attempts to chain (via .then) will just short-circuit
	                // and return the rejected Promise.
	                throw error;
	            })
	                .then(function () {
	                _this.operationInProgress = false;
	            });
	        });
	        return this.tail;
	    };
	    /**
	     * Verifies there's an operation currently in-progress on the AsyncQueue.
	     * Unfortunately we can't verify that the running code is in the promise chain
	     * of that operation, so this isn't a foolproof check, but it should be enough
	     * to catch some bugs.
	     */
	    AsyncQueue.prototype.verifyOperationInProgress = function () {
	        assert_1.assert(this.operationInProgress, 'verifyOpInProgress() called when no op in progress on this queue.');
	    };
	    /**
	     * Waits until all currently scheduled tasks are finished executing. Tasks
	     * scheduled with a delay can be rejected or queued for immediate execution.
	     */
	    AsyncQueue.prototype.drain = function (executeDelayedTasks) {
	        var _this = this;
	        this.delayedOperations.forEach(function (entry) {
	            if (entry.handle) {
	                clearTimeout(entry.handle);
	                if (executeDelayedTasks) {
	                    _this.scheduleInternal(entry.op).then(entry.deferred.resolve, entry.deferred.reject);
	                }
	                else {
	                    entry.deferred.reject(new error_1.FirestoreError(error_1.Code.CANCELLED, 'Operation cancelled by shutdown'));
	                }
	            }
	        });
	        this.delayedOperations = [];
	        this.delayedOperationsCount = 0;
	        return this.schedule(function () { return Promise.resolve(); });
	    };
	    return AsyncQueue;
	}());
	exports.AsyncQueue = AsyncQueue;
	
	//# sourceMappingURL=async_queue.js.map


/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	'use strict';
	Object.defineProperty(exports, "__esModule", { value: true });
	var window_controller_1 = __webpack_require__(297);
	var sw_controller_1 = __webpack_require__(296);
	var app_1 = __webpack_require__(26);
	function registerMessaging(instance) {
	    var messagingName = 'messaging';
	    var factoryMethod = function (app) {
	        if (self && 'ServiceWorkerGlobalScope' in self) {
	            return new sw_controller_1.default(app);
	        }
	        // Assume we are in the window context.
	        return new window_controller_1.default(app);
	    };
	    var namespaceExports = {
	        // no-inline
	        Messaging: window_controller_1.default
	    };
	    instance.INTERNAL.registerService(messagingName, factoryMethod, namespaceExports);
	}
	exports.registerMessaging = registerMessaging;
	registerMessaging(app_1.firebase);
	
	//# sourceMappingURL=index.js.map


/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	'use strict';
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var controller_interface_1 = __webpack_require__(165);
	var errors_1 = __webpack_require__(77);
	var worker_page_message_1 = __webpack_require__(168);
	var fcm_details_1 = __webpack_require__(166);
	var FCM_MSG = 'FCM_MSG';
	var SWController = /** @class */ (function (_super) {
	    __extends(SWController, _super);
	    function SWController(app) {
	        var _this = _super.call(this, app) || this;
	        self.addEventListener('push', function (e) { return _this.onPush_(e); }, false);
	        self.addEventListener('pushsubscriptionchange', function (e) { return _this.onSubChange_(e); }, false);
	        self.addEventListener('notificationclick', function (e) { return _this.onNotificationClick_(e); }, false);
	        /**
	         * @private
	         * @type {function(Object)|null}
	         */
	        _this.bgMessageHandler_ = null;
	        return _this;
	    }
	    /**
	     * A handler for push events that shows notifications based on the content of
	     * the payload.
	     *
	     * The payload must be a JSON-encoded Object with a `notification` key. The
	     * value of the `notification` property will be used as the NotificationOptions
	     * object passed to showNotification. Additionally, the `title` property of the
	     * notification object will be used as the title.
	     *
	     * If there is no notification data in the payload then no notification will be
	     * shown.
	     * @private
	     */
	    SWController.prototype.onPush_ = function (event) {
	        var _this = this;
	        var msgPayload;
	        try {
	            msgPayload = event.data.json();
	        }
	        catch (err) {
	            // Not JSON so not an FCM message
	            return;
	        }
	        var handleMsgPromise = this.hasVisibleClients_().then(function (hasVisibleClients) {
	            if (hasVisibleClients) {
	                // Do not need to show a notification.
	                if (msgPayload.notification || _this.bgMessageHandler_) {
	                    // Send to page
	                    return _this.sendMessageToWindowClients_(msgPayload);
	                }
	                return;
	            }
	            var notificationDetails = _this.getNotificationData_(msgPayload);
	            if (notificationDetails) {
	                var notificationTitle = notificationDetails.title || '';
	                return self.registration.showNotification(notificationTitle, notificationDetails);
	            }
	            else if (_this.bgMessageHandler_) {
	                return _this.bgMessageHandler_(msgPayload);
	            }
	        });
	        event.waitUntil(handleMsgPromise);
	    };
	    /**
	     * @private
	     */
	    SWController.prototype.onSubChange_ = function (event) {
	        var _this = this;
	        var promiseChain = this.getToken().then(function (token) {
	            if (!token) {
	                // We can't resubscribe if we don't have an FCM token for this scope.
	                throw _this.errorFactory_.create(errors_1.default.codes.NO_FCM_TOKEN_FOR_RESUBSCRIBE);
	            }
	            var tokenDetails = null;
	            var tokenManager = _this.getTokenManager();
	            return tokenManager
	                .getTokenDetailsFromToken(token)
	                .then(function (details) {
	                tokenDetails = details;
	                if (!tokenDetails) {
	                    throw _this.errorFactory_.create(errors_1.default.codes.INVALID_SAVED_TOKEN);
	                }
	                // Attempt to get a new subscription
	                return self.registration.pushManager.subscribe(fcm_details_1.default.SUBSCRIPTION_OPTIONS);
	            })
	                .then(function (newSubscription) {
	                // Send new subscription to FCM.
	                return tokenManager.subscribeToFCM(tokenDetails.fcmSenderId, newSubscription, tokenDetails.fcmPushSet);
	            })
	                .catch(function (err) {
	                // The best thing we can do is log this to the terminal so
	                // developers might notice the error.
	                return tokenManager.deleteToken(tokenDetails.fcmToken).then(function () {
	                    throw _this.errorFactory_.create(errors_1.default.codes.UNABLE_TO_RESUBSCRIBE, {
	                        message: err
	                    });
	                });
	            });
	        });
	        event.waitUntil(promiseChain);
	    };
	    /**
	     * @private
	     */
	    SWController.prototype.onNotificationClick_ = function (event) {
	        var _this = this;
	        if (!(event.notification &&
	            event.notification.data &&
	            event.notification.data[FCM_MSG])) {
	            // Not an FCM notification, do nothing.
	            return;
	        }
	        // Prevent other listeners from receiving the event
	        event.stopImmediatePropagation();
	        event.notification.close();
	        var msgPayload = event.notification.data[FCM_MSG];
	        var clickAction = msgPayload['notification']['click_action'];
	        if (!clickAction) {
	            // Nothing to do.
	            return;
	        }
	        var promiseChain = this.getWindowClient_(clickAction)
	            .then(function (windowClient) {
	            if (!windowClient) {
	                // Unable to find window client so need to open one.
	                return self.clients.openWindow(clickAction);
	            }
	            return windowClient;
	        })
	            .then(function (windowClient) {
	            if (!windowClient) {
	                // Window Client will not be returned if it's for a third party origin.
	                return;
	            }
	            // Delete notification data from payload before sending to the page.
	            var notificationData = msgPayload['notification'];
	            delete msgPayload['notification'];
	            var internalMsg = worker_page_message_1.default.createNewMsg(worker_page_message_1.default.TYPES_OF_MSG.NOTIFICATION_CLICKED, msgPayload);
	            // Attempt to send a message to the client to handle the data
	            // Is affected by: https://github.com/slightlyoff/ServiceWorker/issues/728
	            return _this.attemptToMessageClient_(windowClient, internalMsg);
	        });
	        event.waitUntil(promiseChain);
	    };
	    /**
	     * @private
	     * @param {Object} msgPayload
	     * @return {NotificationOptions|undefined}
	     */
	    SWController.prototype.getNotificationData_ = function (msgPayload) {
	        if (!msgPayload) {
	            return;
	        }
	        if (typeof msgPayload.notification !== 'object') {
	            return;
	        }
	        var notificationInformation = Object.assign({}, msgPayload.notification);
	        // Put the message payload under FCM_MSG name so we can identify the
	        // notification as being an FCM notification vs a notification from
	        // somewhere else (i.e. normal web push or developer generated
	        // notification).
	        notificationInformation['data'] = (_a = {},
	            _a[FCM_MSG] = msgPayload,
	            _a);
	        return notificationInformation;
	        var _a;
	    };
	    /**
	     * Calling setBackgroundMessageHandler will opt in to some specific
	     * behaviours.
	     * 1.) If a notification doesn't need to be shown due to a window already
	     * being visible, then push messages will be sent to the page.
	     * 2.) If a notification needs to be shown, and the message contains no
	     * notification data this method will be called
	     * and the promise it returns will be passed to event.waitUntil.
	     * If you do not set this callback then all push messages will let and the
	     * developer can handle them in a their own 'push' event callback
	     * @export
	     * @param {function(Object)} callback The callback to be called when a push
	     * message is received and a notification must be shown. The callback will
	     * be given the data from the push message.
	     */
	    SWController.prototype.setBackgroundMessageHandler = function (callback) {
	        if (callback && typeof callback !== 'function') {
	            throw this.errorFactory_.create(errors_1.default.codes.BG_HANDLER_FUNCTION_EXPECTED);
	        }
	        this.bgMessageHandler_ = callback;
	    };
	    /**
	     * @private
	     * @param {string} url The URL to look for when focusing a client.
	     * @return {Object} Returns an existing window client or a newly opened
	     * WindowClient.
	     */
	    SWController.prototype.getWindowClient_ = function (url) {
	        // Use URL to normalize the URL when comparing to windowClients.
	        // This at least handles whether to include trailing slashes or not
	        var parsedURL = new URL(url).href;
	        return self.clients
	            .matchAll({
	            type: 'window',
	            includeUncontrolled: true
	        })
	            .then(function (clientList) {
	            var suitableClient = null;
	            for (var i = 0; i < clientList.length; i++) {
	                var parsedClientUrl = new URL(clientList[i].url).href;
	                if (parsedClientUrl === parsedURL) {
	                    suitableClient = clientList[i];
	                    break;
	                }
	            }
	            if (suitableClient) {
	                suitableClient.focus();
	                return suitableClient;
	            }
	        });
	    };
	    /**
	     * This message will attempt to send the message to a window client.
	     * @private
	     * @param {Object} client The WindowClient to send the message to.
	     * @param {Object} message The message to send to the client.
	     * @returns {Promise} Returns a promise that resolves after sending the
	     * message. This does not guarantee that the message was successfully
	     * received.
	     */
	    SWController.prototype.attemptToMessageClient_ = function (client, message) {
	        var _this = this;
	        return new Promise(function (resolve, reject) {
	            if (!client) {
	                return reject(_this.errorFactory_.create(errors_1.default.codes.NO_WINDOW_CLIENT_TO_MSG));
	            }
	            client.postMessage(message);
	            resolve();
	        });
	    };
	    /**
	     * @private
	     * @returns {Promise<boolean>} If there is currently a visible WindowClient,
	     * this method will resolve to true, otherwise false.
	     */
	    SWController.prototype.hasVisibleClients_ = function () {
	        return self.clients
	            .matchAll({
	            type: 'window',
	            includeUncontrolled: true
	        })
	            .then(function (clientList) {
	            return clientList.some(function (client) { return client.visibilityState === 'visible'; });
	        });
	    };
	    /**
	     * @private
	     * @param {Object} msgPayload The data from the push event that should be sent
	     * to all available pages.
	     * @returns {Promise} Returns a promise that resolves once the message
	     * has been sent to all WindowClients.
	     */
	    SWController.prototype.sendMessageToWindowClients_ = function (msgPayload) {
	        var _this = this;
	        return self.clients
	            .matchAll({
	            type: 'window',
	            includeUncontrolled: true
	        })
	            .then(function (clientList) {
	            var internalMsg = worker_page_message_1.default.createNewMsg(worker_page_message_1.default.TYPES_OF_MSG.PUSH_MSG_RECEIVED, msgPayload);
	            return Promise.all(clientList.map(function (client) {
	                return _this.attemptToMessageClient_(client, internalMsg);
	            }));
	        });
	    };
	    /**
	     * This will register the default service worker and return the registration.
	     * @private
	     * @return {Promise<!ServiceWorkerRegistration>} The service worker
	     * registration to be used for the push service.
	     */
	    SWController.prototype.getSWRegistration_ = function () {
	        return Promise.resolve(self.registration);
	    };
	    return SWController;
	}(controller_interface_1.default));
	exports.default = SWController;
	
	//# sourceMappingURL=sw-controller.js.map


/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	'use strict';
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var controller_interface_1 = __webpack_require__(165);
	var errors_1 = __webpack_require__(77);
	var worker_page_message_1 = __webpack_require__(168);
	var default_sw_1 = __webpack_require__(299);
	var notification_permission_1 = __webpack_require__(167);
	var util_1 = __webpack_require__(1);
	var WindowController = /** @class */ (function (_super) {
	    __extends(WindowController, _super);
	    /**
	     * A service that provides a MessagingService instance.
	     * @param {!firebase.app.App} app
	     */
	    function WindowController(app) {
	        var _this = _super.call(this, app) || this;
	        _this.messageObserver_ = null;
	        _this.onMessage_ = util_1.createSubscribe(function (observer) {
	            _this.messageObserver_ = observer;
	        });
	        _this.tokenRefreshObserver_ = null;
	        _this.onTokenRefresh_ = util_1.createSubscribe(function (observer) {
	            _this.tokenRefreshObserver_ = observer;
	        });
	        _this.setupSWMessageListener_();
	        return _this;
	    }
	    /**
	     * This method returns an FCM token if it can be generated.
	     * The return promise will reject if the browser doesn't support
	     * FCM, if permission is denied for notifications or it's not
	     * possible to generate a token.
	     * @export
	     * @return {Promise<string> | Promise<null>} Returns a promise the
	     * resolves to an FCM token or null if permission isn't granted.
	     */
	    WindowController.prototype.getToken = function () {
	        var _this = this;
	        // Check that the required API's are available
	        if (!this.isSupported_()) {
	            return Promise.reject(this.errorFactory_.create(errors_1.default.codes.UNSUPPORTED_BROWSER));
	        }
	        return this.manifestCheck_().then(function () {
	            return _super.prototype.getToken.call(_this);
	        });
	    };
	    /**
	     * The method checks that a manifest is defined and has the correct GCM
	     * sender ID.
	     * @private
	     * @return {Promise} Returns a promise that resolves if the manifest matches
	     * our required sender ID
	     */
	    WindowController.prototype.manifestCheck_ = function () {
	        var _this = this;
	        if (this.manifestCheckPromise_) {
	            return this.manifestCheckPromise_;
	        }
	        var manifestTag = document.querySelector('link[rel="manifest"]');
	        if (!manifestTag) {
	            this.manifestCheckPromise_ = Promise.resolve();
	        }
	        else {
	            this.manifestCheckPromise_ = fetch(manifestTag.href)
	                .then(function (response) {
	                return response.json();
	            })
	                .catch(function () {
	                // If the download or parsing fails allow check.
	                // We only want to error if we KNOW that the gcm_sender_id is incorrect.
	                return Promise.resolve();
	            })
	                .then(function (manifestContent) {
	                if (!manifestContent) {
	                    return;
	                }
	                if (!manifestContent['gcm_sender_id']) {
	                    return;
	                }
	                if (manifestContent['gcm_sender_id'] !== '103953800507') {
	                    throw _this.errorFactory_.create(errors_1.default.codes.INCORRECT_GCM_SENDER_ID);
	                }
	            });
	        }
	        return this.manifestCheckPromise_;
	    };
	    /**
	     * Request permission if it is not currently granted
	     * @export
	     * @returns {Promise} Resolves if the permission was granted, otherwise
	     * rejects
	     */
	    WindowController.prototype.requestPermission = function () {
	        var _this = this;
	        if (Notification.permission === notification_permission_1.default.granted) {
	            return Promise.resolve();
	        }
	        return new Promise(function (resolve, reject) {
	            var managePermissionResult = function (result) {
	                if (result === notification_permission_1.default.granted) {
	                    return resolve();
	                }
	                else if (result === notification_permission_1.default.denied) {
	                    return reject(_this.errorFactory_.create(errors_1.default.codes.PERMISSION_BLOCKED));
	                }
	                else {
	                    return reject(_this.errorFactory_.create(errors_1.default.codes.PERMISSION_DEFAULT));
	                }
	            };
	            // The Notification.requestPermission API was changed to
	            // return a promise so now have to handle both in case
	            // browsers stop support callbacks for promised version
	            var permissionPromise = Notification.requestPermission(function (result) {
	                if (permissionPromise) {
	                    // Let the promise manage this
	                    return;
	                }
	                managePermissionResult(result);
	            });
	            if (permissionPromise) {
	                // Prefer the promise version as it's the future API.
	                permissionPromise.then(managePermissionResult);
	            }
	        });
	    };
	    /**
	     * This method allows a developer to override the default service worker and
	     * instead use a custom service worker.
	     * @export
	     * @param {!ServiceWorkerRegistration} registration The service worker
	     * registration that should be used to receive the push messages.
	     */
	    WindowController.prototype.useServiceWorker = function (registration) {
	        if (!(registration instanceof ServiceWorkerRegistration)) {
	            throw this.errorFactory_.create(errors_1.default.codes.SW_REGISTRATION_EXPECTED);
	        }
	        if (typeof this.registrationToUse_ !== 'undefined') {
	            throw this.errorFactory_.create(errors_1.default.codes.USE_SW_BEFORE_GET_TOKEN);
	        }
	        this.registrationToUse_ = registration;
	    };
	    /**
	     * @export
	     * @param {!firebase.Observer|function(*)} nextOrObserver An observer object
	     * or a function triggered on message.
	     * @param {function(!Error)=} optError Optional A function triggered on
	     * message error.
	     * @param {function()=} optCompleted Optional function triggered when the
	     * observer is removed.
	     * @return {!function()} The unsubscribe function for the observer.
	     */
	    WindowController.prototype.onMessage = function (nextOrObserver, optError, optCompleted) {
	        return this.onMessage_(nextOrObserver, optError, optCompleted);
	    };
	    /**
	     * @export
	     * @param {!firebase.Observer|function()} nextOrObserver An observer object
	     * or a function triggered on token refresh.
	     * @param {function(!Error)=} optError Optional A function
	     * triggered on token refresh error.
	     * @param {function()=} optCompleted Optional function triggered when the
	     * observer is removed.
	     * @return {!function()} The unsubscribe function for the observer.
	     */
	    WindowController.prototype.onTokenRefresh = function (nextOrObserver, optError, optCompleted) {
	        return this.onTokenRefresh_(nextOrObserver, optError, optCompleted);
	    };
	    /**
	     * Given a registration, wait for the service worker it relates to
	     * become activer
	     * @private
	     * @param  {ServiceWorkerRegistration} registration Registration to wait
	     * for service worker to become active
	     * @return {Promise<!ServiceWorkerRegistration>} Wait for service worker
	     * registration to become active
	     */
	    WindowController.prototype.waitForRegistrationToActivate_ = function (registration) {
	        var _this = this;
	        var serviceWorker = registration.installing || registration.waiting || registration.active;
	        return new Promise(function (resolve, reject) {
	            if (!serviceWorker) {
	                // This is a rare scenario but has occured in firefox
	                reject(_this.errorFactory_.create(errors_1.default.codes.NO_SW_IN_REG));
	                return;
	            }
	            // Because the Promise function is called on next tick there is a
	            // small chance that the worker became active or redundant already.
	            if (serviceWorker.state === 'activated') {
	                resolve(registration);
	                return;
	            }
	            if (serviceWorker.state === 'redundant') {
	                reject(_this.errorFactory_.create(errors_1.default.codes.SW_REG_REDUNDANT));
	                return;
	            }
	            var stateChangeListener = function () {
	                if (serviceWorker.state === 'activated') {
	                    resolve(registration);
	                }
	                else if (serviceWorker.state === 'redundant') {
	                    reject(_this.errorFactory_.create(errors_1.default.codes.SW_REG_REDUNDANT));
	                }
	                else {
	                    // Return early and wait to next state change
	                    return;
	                }
	                serviceWorker.removeEventListener('statechange', stateChangeListener);
	            };
	            serviceWorker.addEventListener('statechange', stateChangeListener);
	        });
	    };
	    /**
	     * This will regiater the default service worker and return the registration
	     * @private
	     * @return {Promise<!ServiceWorkerRegistration>} The service worker
	     * registration to be used for the push service.
	     */
	    WindowController.prototype.getSWRegistration_ = function () {
	        var _this = this;
	        if (this.registrationToUse_) {
	            return this.waitForRegistrationToActivate_(this.registrationToUse_);
	        }
	        // Make the registration null so we know useServiceWorker will not
	        // use a new service worker as registrationToUse_ is no longer undefined
	        this.registrationToUse_ = null;
	        return navigator.serviceWorker
	            .register(default_sw_1.default.path, {
	            scope: default_sw_1.default.scope
	        })
	            .catch(function (err) {
	            throw _this.errorFactory_.create(errors_1.default.codes.FAILED_DEFAULT_REGISTRATION, {
	                browserErrorMessage: err.message
	            });
	        })
	            .then(function (registration) {
	            return _this.waitForRegistrationToActivate_(registration).then(function () {
	                _this.registrationToUse_ = registration;
	                // We update after activation due to an issue with Firefox v49 where
	                // a race condition occassionally causes the service work to not
	                // install
	                registration.update();
	                return registration;
	            });
	        });
	    };
	    /**
	     * This method will set up a message listener to handle
	     * events from the service worker that should trigger
	     * events in the page.
	     *
	     * @private
	     */
	    WindowController.prototype.setupSWMessageListener_ = function () {
	        var _this = this;
	        if (!('serviceWorker' in navigator)) {
	            return;
	        }
	        navigator.serviceWorker.addEventListener('message', function (event) {
	            if (!event.data || !event.data[worker_page_message_1.default.PARAMS.TYPE_OF_MSG]) {
	                // Not a message from FCM
	                return;
	            }
	            var workerPageMessage = event.data;
	            switch (workerPageMessage[worker_page_message_1.default.PARAMS.TYPE_OF_MSG]) {
	                case worker_page_message_1.default.TYPES_OF_MSG.PUSH_MSG_RECEIVED:
	                case worker_page_message_1.default.TYPES_OF_MSG.NOTIFICATION_CLICKED:
	                    var pushMessage = workerPageMessage[worker_page_message_1.default.PARAMS.DATA];
	                    _this.messageObserver_.next(pushMessage);
	                    break;
	                default:
	                    // Noop.
	                    break;
	            }
	        }, false);
	    };
	    /**
	     * Checks to see if the required API's are valid or not.
	     * @private
	     * @return {boolean} Returns true if the desired APIs are available.
	     */
	    WindowController.prototype.isSupported_ = function () {
	        return ('serviceWorker' in navigator &&
	            'PushManager' in window &&
	            'Notification' in window &&
	            'fetch' in window &&
	            ServiceWorkerRegistration.prototype.hasOwnProperty('showNotification') &&
	            PushSubscription.prototype.hasOwnProperty('getKey'));
	    };
	    return WindowController;
	}(controller_interface_1.default));
	exports.default = WindowController;
	
	//# sourceMappingURL=window-controller.js.map


/***/ }),
/* 298 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	function toBase64(arrayBuffer) {
	    var uint8Version = new Uint8Array(arrayBuffer);
	    return window.btoa(String.fromCharCode.apply(null, uint8Version));
	}
	exports.default = function (arrayBuffer) {
	    var base64String = toBase64(arrayBuffer);
	    return base64String
	        .replace(/=/g, '')
	        .replace(/\+/g, '-')
	        .replace(/\//g, '_');
	};
	
	//# sourceMappingURL=array-buffer-to-base64.js.map


/***/ }),
/* 299 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	'use strict';
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = {
	    path: '/firebase-messaging-sw.js',
	    scope: '/firebase-cloud-messaging-push-scope'
	};
	
	//# sourceMappingURL=default-sw.js.map


/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	'use strict';
	Object.defineProperty(exports, "__esModule", { value: true });
	var util_1 = __webpack_require__(1);
	var errors_1 = __webpack_require__(77);
	var array_buffer_to_base64_1 = __webpack_require__(298);
	var fcm_details_1 = __webpack_require__(166);
	var FCM_TOKEN_OBJ_STORE = 'fcm_token_object_Store';
	var FCM_TOKEN_DETAILS_DB_VERSION = 1;
	var TokenManager = /** @class */ (function () {
	    function TokenManager() {
	        this.errorFactory_ = new util_1.ErrorFactory('messaging', 'Messaging', errors_1.default.map);
	        this.openDbPromise_ = null;
	    }
	    /**
	     * Get the indexedDB as a promsie.
	     * @private
	     * @return {Promise<IDBDatabase>} The IndexedDB database
	     */
	    TokenManager.prototype.openDatabase_ = function () {
	        if (this.openDbPromise_) {
	            return this.openDbPromise_;
	        }
	        this.openDbPromise_ = new Promise(function (resolve, reject) {
	            var request = indexedDB.open(TokenManager.DB_NAME, FCM_TOKEN_DETAILS_DB_VERSION);
	            request.onerror = function (event) {
	                reject(event.target.error);
	            };
	            request.onsuccess = function (event) {
	                resolve(event.target.result);
	            };
	            request.onupgradeneeded = function (event) {
	                var db = event.target.result;
	                var objectStore = db.createObjectStore(FCM_TOKEN_OBJ_STORE, {
	                    keyPath: 'swScope'
	                });
	                // Make sure the sender ID can be searched
	                objectStore.createIndex('fcmSenderId', 'fcmSenderId', {
	                    unique: false
	                });
	                objectStore.createIndex('fcmToken', 'fcmToken', {
	                    unique: true
	                });
	            };
	        });
	        return this.openDbPromise_;
	    };
	    /**
	     * Close the currently open database.
	     * @return {Promise<?>} Returns the result of the promise chain.
	     */
	    TokenManager.prototype.closeDatabase = function () {
	        var _this = this;
	        if (this.openDbPromise_) {
	            return this.openDbPromise_.then(function (db) {
	                db.close();
	                _this.openDbPromise_ = null;
	            });
	        }
	        return Promise.resolve();
	    };
	    /**
	     * Given a token, this method will look up the details in indexedDB.
	     * @public
	     * @param {string} fcmToken
	     * @return {Promise<Object>} The details associated with that token.
	     */
	    TokenManager.prototype.getTokenDetailsFromToken = function (fcmToken) {
	        return this.openDatabase_().then(function (db) {
	            return new Promise(function (resolve, reject) {
	                var transaction = db.transaction([FCM_TOKEN_OBJ_STORE]);
	                var objectStore = transaction.objectStore(FCM_TOKEN_OBJ_STORE);
	                var index = objectStore.index('fcmToken');
	                var request = index.get(fcmToken);
	                request.onerror = function (event) {
	                    reject(event.target.error);
	                };
	                request.onsuccess = function (event) {
	                    resolve(event.target.result);
	                };
	            });
	        });
	    };
	    TokenManager.prototype.getTokenDetailsFromSWScope_ = function (swScope) {
	        return this.openDatabase_().then(function (db) {
	            return new Promise(function (resolve, reject) {
	                var transaction = db.transaction([FCM_TOKEN_OBJ_STORE]);
	                var objectStore = transaction.objectStore(FCM_TOKEN_OBJ_STORE);
	                var scopeRequest = objectStore.get(swScope);
	                scopeRequest.onerror = function (event) {
	                    reject(event.target.error);
	                };
	                scopeRequest.onsuccess = function (event) {
	                    resolve(event.target.result);
	                };
	            });
	        });
	    };
	    TokenManager.prototype.getAllTokenDetailsForSenderId_ = function (senderId) {
	        return this.openDatabase_().then(function (db) {
	            return new Promise(function (resolve, reject) {
	                var transaction = db.transaction([FCM_TOKEN_OBJ_STORE]);
	                var objectStore = transaction.objectStore(FCM_TOKEN_OBJ_STORE);
	                var senderIdTokens = [];
	                var cursorRequest = objectStore.openCursor();
	                cursorRequest.onerror = function (event) {
	                    reject(event.target.error);
	                };
	                cursorRequest.onsuccess = function (event) {
	                    var cursor = event.target.result;
	                    if (cursor) {
	                        if (cursor.value['fcmSenderId'] === senderId) {
	                            senderIdTokens.push(cursor.value);
	                        }
	                        cursor.continue();
	                    }
	                    else {
	                        resolve(senderIdTokens);
	                    }
	                };
	            });
	        });
	    };
	    /**
	     * Given a PushSubscription and messagingSenderId, get an FCM token.
	     * @public
	     * @param  {string} senderId The 'messagingSenderId' to tie the token to.
	     * @param  {PushSubscription} subscription The PushSusbcription to "federate".
	     * @param  {string=} pushSet If defined this will swap the subscription for
	     * matching FCM token.
	     * @return {Promise<!Object>} Returns the FCM token to be used in place
	     * of the PushSubscription.
	     */
	    TokenManager.prototype.subscribeToFCM = function (senderId, subscription, pushSet) {
	        var _this = this;
	        var p256dh = array_buffer_to_base64_1.default(subscription['getKey']('p256dh'));
	        var auth = array_buffer_to_base64_1.default(subscription['getKey']('auth'));
	        var fcmSubscribeBody = "authorized_entity=" + senderId + "&" +
	            ("endpoint=" + subscription.endpoint + "&") +
	            ("encryption_key=" + p256dh + "&") +
	            ("encryption_auth=" + auth);
	        if (pushSet) {
	            fcmSubscribeBody += "&pushSet=" + pushSet;
	        }
	        var headers = new Headers();
	        headers.append('Content-Type', 'application/x-www-form-urlencoded');
	        var subscribeOptions = {
	            method: 'POST',
	            headers: headers,
	            body: fcmSubscribeBody
	        };
	        return fetch(fcm_details_1.default.ENDPOINT + '/fcm/connect/subscribe', subscribeOptions)
	            .then(function (response) { return response.json(); })
	            .then(function (response) {
	            var fcmTokenResponse = response;
	            if (fcmTokenResponse['error']) {
	                var message = fcmTokenResponse['error']['message'];
	                throw _this.errorFactory_.create(errors_1.default.codes.TOKEN_SUBSCRIBE_FAILED, {
	                    message: message
	                });
	            }
	            if (!fcmTokenResponse['token']) {
	                throw _this.errorFactory_.create(errors_1.default.codes.TOKEN_SUBSCRIBE_NO_TOKEN);
	            }
	            if (!fcmTokenResponse['pushSet']) {
	                throw _this.errorFactory_.create(errors_1.default.codes.TOKEN_SUBSCRIBE_NO_PUSH_SET);
	            }
	            return {
	                token: fcmTokenResponse['token'],
	                pushSet: fcmTokenResponse['pushSet']
	            };
	        });
	    };
	    /**
	     * Checks the that fields in the PushSubscription are equivalent to the
	     * details stores in the masterTokenDetails.
	     * @private
	     * @param  {PushSubscription} subscription The push subscription we expect
	     * the master token to match.
	     * @param  {Object}  masterTokenDetails The saved details we wish to compare
	     * with the PushSubscription
	     * @return {boolean} true if the subscription and token details are
	     * equivalent.
	     */
	    TokenManager.prototype.isSameSubscription_ = function (subscription, masterTokenDetails) {
	        // getKey() isn't defined in the PushSubscription externs file, hence
	        // subscription['getKey']('<key name>').
	        return (subscription.endpoint === masterTokenDetails['endpoint'] &&
	            array_buffer_to_base64_1.default(subscription['getKey']('auth')) ===
	                masterTokenDetails['auth'] &&
	            array_buffer_to_base64_1.default(subscription['getKey']('p256dh')) ===
	                masterTokenDetails['p256dh']);
	    };
	    /**
	     * Save the details for the fcm token for re-use at a later date.
	     * @private
	     * @param  {string} senderId The 'messagingSenderId' used for this project
	     * @param  {ServiceWorkerRegistration} swRegistration The service worker
	     * used to subscribe the user for web push
	     * @param  {PushSubscription} subscription The push subscription passed to
	     * FCM for the current token.
	     * @param  {string} fcmToken The FCM token currently used on this
	     * device.
	     * @param  {string} fcmPushSet The FCM push tied to the fcm token.
	     * @return {Promise<void>}
	     */
	    TokenManager.prototype.saveTokenDetails_ = function (senderId, swRegistration, subscription, fcmToken, fcmPushSet) {
	        var details = {
	            swScope: swRegistration.scope,
	            endpoint: subscription.endpoint,
	            auth: array_buffer_to_base64_1.default(subscription['getKey']('auth')),
	            p256dh: array_buffer_to_base64_1.default(subscription['getKey']('p256dh')),
	            fcmToken: fcmToken,
	            fcmPushSet: fcmPushSet,
	            fcmSenderId: senderId
	        };
	        return this.openDatabase_().then(function (db) {
	            return new Promise(function (resolve, reject) {
	                var transaction = db.transaction([FCM_TOKEN_OBJ_STORE], 'readwrite');
	                var objectStore = transaction.objectStore(FCM_TOKEN_OBJ_STORE);
	                var request = objectStore.put(details);
	                request.onerror = function (event) {
	                    reject(event.target.error);
	                };
	                request.onsuccess = function (event) {
	                    resolve();
	                };
	            });
	        });
	    };
	    /**
	     * Returns the saved FCM Token if one is available and still valid,
	     * otherwise `null` is returned.
	     * @param {string} senderId This should be the sender ID associated with the
	     * FCM Token being retrieved.
	     * @param {ServiceWorkerRegistration} swRegistration Registration to be used
	     * to subscribe the user to push.
	     * @return {Promise<string> | Promise} Returns the saved FCM Token if
	     * avilable and valid.
	     * @export
	     */
	    TokenManager.prototype.getSavedToken = function (senderId, swRegistration) {
	        var _this = this;
	        if (!(swRegistration instanceof ServiceWorkerRegistration)) {
	            return Promise.reject(this.errorFactory_.create(errors_1.default.codes.SW_REGISTRATION_EXPECTED));
	        }
	        if (typeof senderId !== 'string' || senderId.length === 0) {
	            return Promise.reject(this.errorFactory_.create(errors_1.default.codes.BAD_SENDER_ID));
	        }
	        return this.getAllTokenDetailsForSenderId_(senderId)
	            .then(function (allTokenDetails) {
	            if (allTokenDetails.length === 0) {
	                return;
	            }
	            var index = allTokenDetails.findIndex(function (tokenDetails) {
	                return (swRegistration.scope === tokenDetails['swScope'] &&
	                    senderId === tokenDetails['fcmSenderId']);
	            });
	            if (index === -1) {
	                return;
	            }
	            return allTokenDetails[index];
	        })
	            .then(function (tokenDetails) {
	            if (!tokenDetails) {
	                return;
	            }
	            return swRegistration.pushManager
	                .getSubscription()
	                .catch(function (err) {
	                throw _this.errorFactory_.create(errors_1.default.codes.GET_SUBSCRIPTION_FAILED);
	            })
	                .then(function (subscription) {
	                if (subscription &&
	                    _this.isSameSubscription_(subscription, tokenDetails)) {
	                    return tokenDetails['fcmToken'];
	                }
	            });
	        });
	    };
	    /**
	     * Creates a new FCM token.
	     */
	    TokenManager.prototype.createToken = function (senderId, swRegistration) {
	        var _this = this;
	        if (typeof senderId !== 'string' || senderId.length === 0) {
	            return Promise.reject(this.errorFactory_.create(errors_1.default.codes.BAD_SENDER_ID));
	        }
	        if (!(swRegistration instanceof ServiceWorkerRegistration)) {
	            return Promise.reject(this.errorFactory_.create(errors_1.default.codes.SW_REGISTRATION_EXPECTED));
	        }
	        // Check for existing subscription first
	        var subscription;
	        var fcmTokenDetails;
	        return swRegistration.pushManager
	            .getSubscription()
	            .then(function (subscription) {
	            if (subscription) {
	                return subscription;
	            }
	            return swRegistration.pushManager.subscribe(fcm_details_1.default.SUBSCRIPTION_OPTIONS);
	        })
	            .then(function (sub) {
	            subscription = sub;
	            return _this.subscribeToFCM(senderId, subscription);
	        })
	            .then(function (tokenDetails) {
	            fcmTokenDetails = tokenDetails;
	            return _this.saveTokenDetails_(senderId, swRegistration, subscription, fcmTokenDetails['token'], fcmTokenDetails['pushSet']);
	        })
	            .then(function () { return fcmTokenDetails['token']; });
	    };
	    /**
	     * This method deletes details of the current FCM token.
	     * It's returning a promise in case we need to move to an async
	     * method for deleting at a later date.
	     * @param {string} token Token to be deleted
	     * @return {Promise<Object>} Resolves once the FCM token details have been
	     * deleted and returns the deleted details.
	     */
	    TokenManager.prototype.deleteToken = function (token) {
	        var _this = this;
	        if (typeof token !== 'string' || token.length === 0) {
	            return Promise.reject(this.errorFactory_.create(errors_1.default.codes.INVALID_DELETE_TOKEN));
	        }
	        return this.getTokenDetailsFromToken(token).then(function (details) {
	            if (!details) {
	                throw _this.errorFactory_.create(errors_1.default.codes.DELETE_TOKEN_NOT_FOUND);
	            }
	            return _this.openDatabase_().then(function (db) {
	                return new Promise(function (resolve, reject) {
	                    var transaction = db.transaction([FCM_TOKEN_OBJ_STORE], 'readwrite');
	                    var objectStore = transaction.objectStore(FCM_TOKEN_OBJ_STORE);
	                    var request = objectStore.delete(details['swScope']);
	                    request.onerror = function (event) {
	                        reject(event.target.error);
	                    };
	                    request.onsuccess = function (event) {
	                        if (event.target.result === 0) {
	                            reject(_this.errorFactory_.create(errors_1.default.codes.FAILED_TO_DELETE_TOKEN));
	                            return;
	                        }
	                        resolve(details);
	                    };
	                });
	            });
	        });
	    };
	    return TokenManager;
	}());
	exports.default = TokenManager;
	
	//# sourceMappingURL=token-manager.js.map


/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	__webpack_require__(302);
	__webpack_require__(303);
	__webpack_require__(304);
	
	//# sourceMappingURL=index.js.map


/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var __global = (function () {
	    if (typeof global !== 'undefined') {
	        return global;
	    }
	    if (typeof window !== 'undefined') {
	        return window;
	    }
	    if (typeof self !== 'undefined') {
	        return self;
	    }
	    throw new Error('unable to locate global object');
	})();
	// Polyfill Promise
	if (typeof Promise === 'undefined') {
	    // HACK: TS throws an error if I attempt to use 'dot-notation'
	    __global['Promise'] = Promise = __webpack_require__(412);
	}
	
	//# sourceMappingURL=promise.js.map
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 303 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * This is the Array.prototype.find polyfill from MDN
	 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/find
	 * https://tc39.github.io/ecma262/#sec-array.prototype.find
	 */
	if (!Array.prototype.find) {
	    Object.defineProperty(Array.prototype, 'find', {
	        value: function (predicate) {
	            // 1. Let O be ? ToObject(this value).
	            if (this == null) {
	                throw new TypeError('"this" is null or not defined');
	            }
	            var o = Object(this);
	            // 2. Let len be ? ToLength(? Get(O, "length")).
	            var len = o.length >>> 0;
	            // 3. If IsCallable(predicate) is false, throw a TypeError exception.
	            if (typeof predicate !== 'function') {
	                throw new TypeError('predicate must be a function');
	            }
	            // 4. If thisArg was supplied, let T be thisArg; else let T be undefined.
	            var thisArg = arguments[1];
	            // 5. Let k be 0.
	            var k = 0;
	            // 6. Repeat, while k < len
	            while (k < len) {
	                // a. Let Pk be ! ToString(k).
	                // b. Let kValue be ? Get(O, Pk).
	                // c. Let testResult be ToBoolean(? Call(predicate, T, « kValue, k, O »)).
	                // d. If testResult is true, return kValue.
	                var kValue = o[k];
	                if (predicate.call(thisArg, kValue, k, o)) {
	                    return kValue;
	                }
	                // e. Increase k by 1.
	                k++;
	            }
	            // 7. Return undefined.
	            return undefined;
	        }
	    });
	}
	
	//# sourceMappingURL=find.js.map


/***/ }),
/* 304 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * This is the Array.prototype.findIndex polyfill from MDN
	 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/findIndex
	 * https://tc39.github.io/ecma262/#sec-array.prototype.findIndex
	 */
	if (!Array.prototype.findIndex) {
	    Object.defineProperty(Array.prototype, 'findIndex', {
	        value: function (predicate) {
	            // 1. Let O be ? ToObject(this value).
	            if (this == null) {
	                throw new TypeError('"this" is null or not defined');
	            }
	            var o = Object(this);
	            // 2. Let len be ? ToLength(? Get(O, "length")).
	            var len = o.length >>> 0;
	            // 3. If IsCallable(predicate) is false, throw a TypeError exception.
	            if (typeof predicate !== 'function') {
	                throw new TypeError('predicate must be a function');
	            }
	            // 4. If thisArg was supplied, let T be thisArg; else let T be undefined.
	            var thisArg = arguments[1];
	            // 5. Let k be 0.
	            var k = 0;
	            // 6. Repeat, while k < len
	            while (k < len) {
	                // a. Let Pk be ! ToString(k).
	                // b. Let kValue be ? Get(O, Pk).
	                // c. Let testResult be ToBoolean(? Call(predicate, T, « kValue, k, O »)).
	                // d. If testResult is true, return k.
	                var kValue = o[k];
	                if (predicate.call(thisArg, kValue, k, o)) {
	                    return k;
	                }
	                // e. Increase k by 1.
	                k++;
	            }
	            // 7. Return -1.
	            return -1;
	        }
	    });
	}
	
	//# sourceMappingURL=findIndex.js.map


/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var app_1 = __webpack_require__(26);
	var string_1 = __webpack_require__(56);
	var taskenums_1 = __webpack_require__(57);
	var taskenums_2 = __webpack_require__(57);
	var xhriopool_1 = __webpack_require__(317);
	var reference_1 = __webpack_require__(173);
	var service_1 = __webpack_require__(318);
	/**
	 * Type constant for Firebase Storage.
	 */
	var STORAGE_TYPE = 'storage';
	function factory(app, unused, opt_url) {
	    return new service_1.Service(app, new xhriopool_1.XhrIoPool(), opt_url);
	}
	function registerStorage(instance) {
	    var namespaceExports = {
	        // no-inline
	        TaskState: taskenums_2.TaskState,
	        TaskEvent: taskenums_1.TaskEvent,
	        StringFormat: string_1.StringFormat,
	        Storage: service_1.Service,
	        Reference: reference_1.Reference
	    };
	    instance.INTERNAL.registerService(STORAGE_TYPE, factory, namespaceExports, undefined, 
	    // Allow multiple storage instances per app.
	    true);
	}
	exports.registerStorage = registerStorage;
	registerStorage(app_1.default);
	
	//# sourceMappingURL=index.js.map


/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * @fileoverview Method for invoking a callback asynchronously.
	 */
	var promiseimpl = __webpack_require__(37);
	/**
	 * Returns a function that invokes f with its arguments asynchronously as a
	 * microtask, i.e. as soon as possible after the current script returns back
	 * into browser code.
	 */
	function async(f) {
	    return function () {
	        var argsToForward = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            argsToForward[_i] = arguments[_i];
	        }
	        promiseimpl.resolve(true).then(function () {
	            f.apply(null, argsToForward);
	        });
	    };
	}
	exports.async = async;
	
	//# sourceMappingURL=async.js.map


/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var constants = __webpack_require__(78);
	var errorsExports = __webpack_require__(30);
	var failrequest_1 = __webpack_require__(309);
	var location_1 = __webpack_require__(79);
	var promiseimpl = __webpack_require__(37);
	var requestmap_1 = __webpack_require__(315);
	var type = __webpack_require__(22);
	/**
	 * @param app If null, getAuthToken always resolves with null.
	 * @param service The storage service associated with this auth wrapper.
	 *     Untyped to avoid circular type dependencies.
	 * @struct
	 */
	var AuthWrapper = /** @class */ (function () {
	    function AuthWrapper(app, maker, requestMaker, service, pool) {
	        this.bucket_ = null;
	        this.deleted_ = false;
	        this.app_ = app;
	        if (this.app_ !== null) {
	            var options = this.app_.options;
	            if (type.isDef(options)) {
	                this.bucket_ = AuthWrapper.extractBucket_(options);
	            }
	        }
	        this.storageRefMaker_ = maker;
	        this.requestMaker_ = requestMaker;
	        this.pool_ = pool;
	        this.service_ = service;
	        this.maxOperationRetryTime_ = constants.defaultMaxOperationRetryTime;
	        this.maxUploadRetryTime_ = constants.defaultMaxUploadRetryTime;
	        this.requestMap_ = new requestmap_1.RequestMap();
	    }
	    AuthWrapper.extractBucket_ = function (config) {
	        var bucketString = config[constants.configOption] || null;
	        if (bucketString == null) {
	            return null;
	        }
	        var loc = location_1.Location.makeFromBucketSpec(bucketString);
	        return loc.bucket;
	    };
	    AuthWrapper.prototype.getAuthToken = function () {
	        // TODO(andysoto): remove ifDef checks after firebase-app implements stubs
	        // (b/28673818).
	        if (this.app_ !== null &&
	            type.isDef(this.app_.INTERNAL) &&
	            type.isDef(this.app_.INTERNAL.getToken)) {
	            return this.app_.INTERNAL.getToken().then(function (response) {
	                if (response !== null) {
	                    return response.accessToken;
	                }
	                else {
	                    return null;
	                }
	            }, function (_error) {
	                return null;
	            });
	        }
	        else {
	            return promiseimpl.resolve(null);
	        }
	    };
	    AuthWrapper.prototype.bucket = function () {
	        if (this.deleted_) {
	            throw errorsExports.appDeleted();
	        }
	        else {
	            return this.bucket_;
	        }
	    };
	    /**
	     * The service associated with this auth wrapper. Untyped to avoid circular
	     * type dependencies.
	     */
	    AuthWrapper.prototype.service = function () {
	        return this.service_;
	    };
	    /**
	     * Returns a new firebaseStorage.Reference object referencing this AuthWrapper
	     * at the given Location.
	     * @param loc The Location.
	     * @return Actually a firebaseStorage.Reference, typing not allowed
	     *     because of circular dependency problems.
	     */
	    AuthWrapper.prototype.makeStorageReference = function (loc) {
	        return this.storageRefMaker_(this, loc);
	    };
	    AuthWrapper.prototype.makeRequest = function (requestInfo, authToken) {
	        if (!this.deleted_) {
	            var request = this.requestMaker_(requestInfo, authToken, this.pool_);
	            this.requestMap_.addRequest(request);
	            return request;
	        }
	        else {
	            return new failrequest_1.FailRequest(errorsExports.appDeleted());
	        }
	    };
	    /**
	     * Stop running requests and prevent more from being created.
	     */
	    AuthWrapper.prototype.deleteApp = function () {
	        this.deleted_ = true;
	        this.app_ = null;
	        this.requestMap_.clear();
	    };
	    AuthWrapper.prototype.maxUploadRetryTime = function () {
	        return this.maxUploadRetryTime_;
	    };
	    AuthWrapper.prototype.setMaxUploadRetryTime = function (time) {
	        this.maxUploadRetryTime_ = time;
	    };
	    AuthWrapper.prototype.maxOperationRetryTime = function () {
	        return this.maxOperationRetryTime_;
	    };
	    AuthWrapper.prototype.setMaxOperationRetryTime = function (time) {
	        this.maxOperationRetryTime_ = time;
	    };
	    return AuthWrapper;
	}());
	exports.AuthWrapper = AuthWrapper;
	
	//# sourceMappingURL=authwrapper.js.map


/***/ }),
/* 308 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * @param f May be invoked
	 *     before the function returns.
	 * @param callback Get all the arguments passed to the function
	 *     passed to f, including the initial boolean.
	 */
	function start(f, callback, timeout) {
	    // TODO(andysoto): make this code cleaner (probably refactor into an actual
	    // type instead of a bunch of functions with state shared in the closure)
	    var waitSeconds = 1;
	    // Would type this as "number" but that doesn't work for Node so ¯\_(ツ)_/¯
	    var timeoutId = null;
	    var hitTimeout = false;
	    var cancelState = 0;
	    function canceled() {
	        return cancelState === 2;
	    }
	    var triggeredCallback = false;
	    function triggerCallback() {
	        if (!triggeredCallback) {
	            triggeredCallback = true;
	            callback.apply(null, arguments);
	        }
	    }
	    function callWithDelay(millis) {
	        timeoutId = setTimeout(function () {
	            timeoutId = null;
	            f(handler, canceled());
	        }, millis);
	    }
	    function handler(success) {
	        var var_args = [];
	        for (var _i = 1; _i < arguments.length; _i++) {
	            var_args[_i - 1] = arguments[_i];
	        }
	        if (triggeredCallback) {
	            return;
	        }
	        if (success) {
	            triggerCallback.apply(null, arguments);
	            return;
	        }
	        var mustStop = canceled() || hitTimeout;
	        if (mustStop) {
	            triggerCallback.apply(null, arguments);
	            return;
	        }
	        if (waitSeconds < 64) {
	            /* TODO(andysoto): don't back off so quickly if we know we're offline. */
	            waitSeconds *= 2;
	        }
	        var waitMillis;
	        if (cancelState === 1) {
	            cancelState = 2;
	            waitMillis = 0;
	        }
	        else {
	            waitMillis = (waitSeconds + Math.random()) * 1000;
	        }
	        callWithDelay(waitMillis);
	    }
	    var stopped = false;
	    function stop(wasTimeout) {
	        if (stopped) {
	            return;
	        }
	        stopped = true;
	        if (triggeredCallback) {
	            return;
	        }
	        if (timeoutId !== null) {
	            if (!wasTimeout) {
	                cancelState = 2;
	            }
	            clearTimeout(timeoutId);
	            callWithDelay(0);
	        }
	        else {
	            if (!wasTimeout) {
	                cancelState = 1;
	            }
	        }
	    }
	    callWithDelay(0);
	    setTimeout(function () {
	        hitTimeout = true;
	        stop(true);
	    }, timeout);
	    return stop;
	}
	exports.start = start;
	/**
	 * Stops the retry loop from repeating.
	 * If the function is currently "in between" retries, it is invoked immediately
	 * with the second parameter as "true". Otherwise, it will be invoked once more
	 * after the current invocation finishes iff the current invocation would have
	 * triggered another retry.
	 */
	function stop(id) {
	    id(false);
	}
	exports.stop = stop;
	
	//# sourceMappingURL=backoff.js.map


/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var promiseimpl = __webpack_require__(37);
	/**
	 * A request whose promise always fails.
	 * @struct
	 * @template T
	 */
	var FailRequest = /** @class */ (function () {
	    function FailRequest(error) {
	        this.promise_ = promiseimpl.reject(error);
	    }
	    /** @inheritDoc */
	    FailRequest.prototype.getPromise = function () {
	        return this.promise_;
	    };
	    /** @inheritDoc */
	    FailRequest.prototype.cancel = function (appDelete) {
	        if (appDelete === void 0) { appDelete = false; }
	    };
	    return FailRequest;
	}());
	exports.FailRequest = FailRequest;
	
	//# sourceMappingURL=failrequest.js.map


/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var type = __webpack_require__(22);
	function getBlobBuilder() {
	    if (typeof BlobBuilder !== 'undefined') {
	        return BlobBuilder;
	    }
	    else if (typeof WebKitBlobBuilder !== 'undefined') {
	        return WebKitBlobBuilder;
	    }
	    else {
	        return undefined;
	    }
	}
	/**
	 * Concatenates one or more values together and converts them to a Blob.
	 *
	 * @param var_args The values that will make up the resulting blob.
	 * @return The blob.
	 */
	function getBlob() {
	    var var_args = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        var_args[_i] = arguments[_i];
	    }
	    var BlobBuilder = getBlobBuilder();
	    if (BlobBuilder !== undefined) {
	        var bb = new BlobBuilder();
	        for (var i = 0; i < var_args.length; i++) {
	            bb.append(var_args[i]);
	        }
	        return bb.getBlob();
	    }
	    else {
	        if (type.isNativeBlobDefined()) {
	            return new Blob(var_args);
	        }
	        else {
	            throw Error("This browser doesn't seem to support creating Blobs");
	        }
	    }
	}
	exports.getBlob = getBlob;
	/**
	 * Slices the blob. The returned blob contains data from the start byte
	 * (inclusive) till the end byte (exclusive). Negative indices cannot be used.
	 *
	 * @param blob The blob to be sliced.
	 * @param start Index of the starting byte.
	 * @param end Index of the ending byte.
	 * @return The blob slice or null if not supported.
	 */
	function sliceBlob(blob, start, end) {
	    if (blob.webkitSlice) {
	        return blob.webkitSlice(start, end);
	    }
	    else if (blob.mozSlice) {
	        return blob.mozSlice(start, end);
	    }
	    else if (blob.slice) {
	        return blob.slice(start, end);
	    }
	    return null;
	}
	exports.sliceBlob = sliceBlob;
	
	//# sourceMappingURL=fs.js.map


/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var type = __webpack_require__(22);
	/**
	 * Returns the Object resulting from parsing the given JSON, or null if the
	 * given string does not represent a JSON object.
	 */
	function jsonObjectOrNull(s) {
	    var obj;
	    try {
	        obj = JSON.parse(s);
	    }
	    catch (e) {
	        return null;
	    }
	    if (type.isNonArrayObject(obj)) {
	        return obj;
	    }
	    else {
	        return null;
	    }
	}
	exports.jsonObjectOrNull = jsonObjectOrNull;
	
	//# sourceMappingURL=json.js.map


/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var type = __webpack_require__(22);
	/**
	 * @struct
	 */
	var Observer = /** @class */ (function () {
	    function Observer(nextOrObserver, opt_error, opt_complete) {
	        var asFunctions = type.isFunction(nextOrObserver) ||
	            type.isDef(opt_error) ||
	            type.isDef(opt_complete);
	        if (asFunctions) {
	            this.next = nextOrObserver;
	            this.error = opt_error || null;
	            this.complete = opt_complete || null;
	        }
	        else {
	            var observer = nextOrObserver;
	            this.next = observer.next || null;
	            this.error = observer.error || null;
	            this.complete = observer.complete || null;
	        }
	    }
	    return Observer;
	}());
	exports.Observer = Observer;
	
	//# sourceMappingURL=observer.js.map


/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * @fileoverview Defines methods used to actually send HTTP requests from
	 * abstract representations.
	 */
	var app_1 = __webpack_require__(26);
	var array = __webpack_require__(107);
	var backoff = __webpack_require__(308);
	var errorsExports = __webpack_require__(30);
	var object = __webpack_require__(43);
	var promiseimpl = __webpack_require__(37);
	var type = __webpack_require__(22);
	var UrlUtils = __webpack_require__(109);
	var XhrIoExports = __webpack_require__(172);
	/**
	 * @struct
	 * @template T
	 */
	var NetworkRequest = /** @class */ (function () {
	    function NetworkRequest(url, method, headers, body, successCodes, additionalRetryCodes, callback, errorCallback, timeout, progressCallback, pool) {
	        this.pendingXhr_ = null;
	        this.backoffId_ = null;
	        this.resolve_ = null;
	        this.reject_ = null;
	        this.canceled_ = false;
	        this.appDelete_ = false;
	        this.url_ = url;
	        this.method_ = method;
	        this.headers_ = headers;
	        this.body_ = body;
	        this.successCodes_ = successCodes.slice();
	        this.additionalRetryCodes_ = additionalRetryCodes.slice();
	        this.callback_ = callback;
	        this.errorCallback_ = errorCallback;
	        this.progressCallback_ = progressCallback;
	        this.timeout_ = timeout;
	        this.pool_ = pool;
	        var self = this;
	        this.promise_ = promiseimpl.make(function (resolve, reject) {
	            self.resolve_ = resolve;
	            self.reject_ = reject;
	            self.start_();
	        });
	    }
	    /**
	     * Actually starts the retry loop.
	     */
	    NetworkRequest.prototype.start_ = function () {
	        var self = this;
	        function doTheRequest(backoffCallback, canceled) {
	            if (canceled) {
	                backoffCallback(false, new RequestEndStatus(false, null, true));
	                return;
	            }
	            var xhr = self.pool_.createXhrIo();
	            self.pendingXhr_ = xhr;
	            function progressListener(progressEvent) {
	                var loaded = progressEvent.loaded;
	                var total = progressEvent.lengthComputable ? progressEvent.total : -1;
	                if (self.progressCallback_ !== null) {
	                    self.progressCallback_(loaded, total);
	                }
	            }
	            if (self.progressCallback_ !== null) {
	                xhr.addUploadProgressListener(progressListener);
	            }
	            xhr
	                .send(self.url_, self.method_, self.body_, self.headers_)
	                .then(function (xhr) {
	                if (self.progressCallback_ !== null) {
	                    xhr.removeUploadProgressListener(progressListener);
	                }
	                self.pendingXhr_ = null;
	                xhr = xhr;
	                var hitServer = xhr.getErrorCode() === XhrIoExports.ErrorCode.NO_ERROR;
	                var status = xhr.getStatus();
	                if (!hitServer || self.isRetryStatusCode_(status)) {
	                    var wasCanceled = xhr.getErrorCode() === XhrIoExports.ErrorCode.ABORT;
	                    backoffCallback(false, new RequestEndStatus(false, null, wasCanceled));
	                    return;
	                }
	                var successCode = array.contains(self.successCodes_, status);
	                backoffCallback(true, new RequestEndStatus(successCode, xhr));
	            });
	        }
	        /**
	         * @param requestWentThrough True if the request eventually went
	         *     through, false if it hit the retry limit or was canceled.
	         */
	        function backoffDone(requestWentThrough, status) {
	            var resolve = self.resolve_;
	            var reject = self.reject_;
	            var xhr = status.xhr;
	            if (status.wasSuccessCode) {
	                try {
	                    var result = self.callback_(xhr, xhr.getResponseText());
	                    if (type.isJustDef(result)) {
	                        resolve(result);
	                    }
	                    else {
	                        resolve();
	                    }
	                }
	                catch (e) {
	                    reject(e);
	                }
	            }
	            else {
	                if (xhr !== null) {
	                    var err = errorsExports.unknown();
	                    err.setServerResponseProp(xhr.getResponseText());
	                    if (self.errorCallback_) {
	                        reject(self.errorCallback_(xhr, err));
	                    }
	                    else {
	                        reject(err);
	                    }
	                }
	                else {
	                    if (status.canceled) {
	                        var err = self.appDelete_
	                            ? errorsExports.appDeleted()
	                            : errorsExports.canceled();
	                        reject(err);
	                    }
	                    else {
	                        var err = errorsExports.retryLimitExceeded();
	                        reject(err);
	                    }
	                }
	            }
	        }
	        if (this.canceled_) {
	            backoffDone(false, new RequestEndStatus(false, null, true));
	        }
	        else {
	            this.backoffId_ = backoff.start(doTheRequest, backoffDone, this.timeout_);
	        }
	    };
	    /** @inheritDoc */
	    NetworkRequest.prototype.getPromise = function () {
	        return this.promise_;
	    };
	    /** @inheritDoc */
	    NetworkRequest.prototype.cancel = function (appDelete) {
	        this.canceled_ = true;
	        this.appDelete_ = appDelete || false;
	        if (this.backoffId_ !== null) {
	            backoff.stop(this.backoffId_);
	        }
	        if (this.pendingXhr_ !== null) {
	            this.pendingXhr_.abort();
	        }
	    };
	    NetworkRequest.prototype.isRetryStatusCode_ = function (status) {
	        // The codes for which to retry came from this page:
	        // https://cloud.google.com/storage/docs/exponential-backoff
	        var isFiveHundredCode = status >= 500 && status < 600;
	        var extraRetryCodes = [
	            // Request Timeout: web server didn't receive full request in time.
	            408,
	            // Too Many Requests: you're getting rate-limited, basically.
	            429
	        ];
	        var isExtraRetryCode = array.contains(extraRetryCodes, status);
	        var isRequestSpecificRetryCode = array.contains(this.additionalRetryCodes_, status);
	        return isFiveHundredCode || isExtraRetryCode || isRequestSpecificRetryCode;
	    };
	    return NetworkRequest;
	}());
	/**
	 * A collection of information about the result of a network request.
	 * @param opt_canceled Defaults to false.
	 * @struct
	 */
	var RequestEndStatus = /** @class */ (function () {
	    function RequestEndStatus(wasSuccessCode, xhr, opt_canceled) {
	        this.wasSuccessCode = wasSuccessCode;
	        this.xhr = xhr;
	        this.canceled = !!opt_canceled;
	    }
	    return RequestEndStatus;
	}());
	exports.RequestEndStatus = RequestEndStatus;
	function addAuthHeader_(headers, authToken) {
	    if (authToken !== null && authToken.length > 0) {
	        headers['Authorization'] = 'Firebase ' + authToken;
	    }
	}
	exports.addAuthHeader_ = addAuthHeader_;
	function addVersionHeader_(headers) {
	    var number = typeof app_1.default !== 'undefined' ? app_1.default.SDK_VERSION : 'AppManager';
	    headers['X-Firebase-Storage-Version'] = 'webjs/' + number;
	}
	exports.addVersionHeader_ = addVersionHeader_;
	/**
	 * @template T
	 */
	function makeRequest(requestInfo, authToken, pool) {
	    var queryPart = UrlUtils.makeQueryString(requestInfo.urlParams);
	    var url = requestInfo.url + queryPart;
	    var headers = object.clone(requestInfo.headers);
	    addAuthHeader_(headers, authToken);
	    addVersionHeader_(headers);
	    return new NetworkRequest(url, requestInfo.method, headers, requestInfo.body, requestInfo.successCodes, requestInfo.additionalRetryCodes, requestInfo.handler, requestInfo.errorHandler, requestInfo.timeout, requestInfo.progressCallback, pool);
	}
	exports.makeRequest = makeRequest;
	
	//# sourceMappingURL=request.js.map


/***/ }),
/* 314 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var RequestInfo = /** @class */ (function () {
	    function RequestInfo(url, method, 
	        /**
	         * Returns the value with which to resolve the request's promise. Only called
	         * if the request is successful. Throw from this function to reject the
	         * returned Request's promise with the thrown error.
	         * Note: The XhrIo passed to this function may be reused after this callback
	         * returns. Do not keep a reference to it in any way.
	         */
	        handler, timeout) {
	        this.url = url;
	        this.method = method;
	        this.handler = handler;
	        this.timeout = timeout;
	        this.urlParams = {};
	        this.headers = {};
	        this.body = null;
	        this.errorHandler = null;
	        /**
	         * Called with the current number of bytes uploaded and total size (-1 if not
	         * computable) of the request body (i.e. used to report upload progress).
	         */
	        this.progressCallback = null;
	        this.successCodes = [200];
	        this.additionalRetryCodes = [];
	    }
	    return RequestInfo;
	}());
	exports.RequestInfo = RequestInfo;
	
	//# sourceMappingURL=requestinfo.js.map


/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var object = __webpack_require__(43);
	var constants = __webpack_require__(78);
	/**
	 * @struct
	 */
	var RequestMap = /** @class */ (function () {
	    function RequestMap() {
	        this.map_ = {};
	        this.id_ = constants.minSafeInteger;
	    }
	    /**
	     * Registers the given request with this map.
	     * The request is unregistered when it completes.
	     * @param r The request to register.
	     */
	    RequestMap.prototype.addRequest = function (r) {
	        var id = this.id_;
	        this.id_++;
	        this.map_[id] = r;
	        var self = this;
	        function unmap() {
	            delete self.map_[id];
	        }
	        r.getPromise().then(unmap, unmap);
	    };
	    /**
	     * Cancels all registered requests.
	     */
	    RequestMap.prototype.clear = function () {
	        object.forEach(this.map_, function (key, val) {
	            if (val) {
	                val.cancel(true);
	            }
	        });
	        this.map_ = {};
	    };
	    return RequestMap;
	}());
	exports.RequestMap = RequestMap;
	
	//# sourceMappingURL=requestmap.js.map


/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var errorsExports = __webpack_require__(30);
	var object = __webpack_require__(43);
	var promiseimpl = __webpack_require__(37);
	var type = __webpack_require__(22);
	var XhrIoExports = __webpack_require__(172);
	/**
	 * We use this instead of goog.net.XhrIo because goog.net.XhrIo is hyuuuuge and
	 * doesn't work in React Native on Android.
	 */
	var NetworkXhrIo = /** @class */ (function () {
	    function NetworkXhrIo() {
	        var _this = this;
	        this.sent_ = false;
	        this.xhr_ = new XMLHttpRequest();
	        this.errorCode_ = XhrIoExports.ErrorCode.NO_ERROR;
	        this.sendPromise_ = promiseimpl.make(function (resolve, reject) {
	            _this.xhr_.addEventListener('abort', function (event) {
	                _this.errorCode_ = XhrIoExports.ErrorCode.ABORT;
	                resolve(_this);
	            });
	            _this.xhr_.addEventListener('error', function (event) {
	                _this.errorCode_ = XhrIoExports.ErrorCode.NETWORK_ERROR;
	                resolve(_this);
	            });
	            _this.xhr_.addEventListener('load', function (event) {
	                resolve(_this);
	            });
	        });
	    }
	    /**
	     * @override
	     */
	    NetworkXhrIo.prototype.send = function (url, method, opt_body, opt_headers) {
	        var _this = this;
	        if (this.sent_) {
	            throw errorsExports.internalError('cannot .send() more than once');
	        }
	        this.sent_ = true;
	        this.xhr_.open(method, url, true);
	        if (type.isDef(opt_headers)) {
	            var headers = opt_headers;
	            object.forEach(headers, function (key, val) {
	                _this.xhr_.setRequestHeader(key, val.toString());
	            });
	        }
	        if (type.isDef(opt_body)) {
	            this.xhr_.send(opt_body);
	        }
	        else {
	            this.xhr_.send();
	        }
	        return this.sendPromise_;
	    };
	    /**
	     * @override
	     */
	    NetworkXhrIo.prototype.getErrorCode = function () {
	        if (!this.sent_) {
	            throw errorsExports.internalError('cannot .getErrorCode() before sending');
	        }
	        return this.errorCode_;
	    };
	    /**
	     * @override
	     */
	    NetworkXhrIo.prototype.getStatus = function () {
	        if (!this.sent_) {
	            throw errorsExports.internalError('cannot .getStatus() before sending');
	        }
	        try {
	            return this.xhr_.status;
	        }
	        catch (e) {
	            return -1;
	        }
	    };
	    /**
	     * @override
	     */
	    NetworkXhrIo.prototype.getResponseText = function () {
	        if (!this.sent_) {
	            throw errorsExports.internalError('cannot .getResponseText() before sending');
	        }
	        return this.xhr_.responseText;
	    };
	    /**
	     * Aborts the request.
	     * @override
	     */
	    NetworkXhrIo.prototype.abort = function () {
	        this.xhr_.abort();
	    };
	    /**
	     * @override
	     */
	    NetworkXhrIo.prototype.getResponseHeader = function (header) {
	        return this.xhr_.getResponseHeader(header);
	    };
	    /**
	     * @override
	     */
	    NetworkXhrIo.prototype.addUploadProgressListener = function (listener) {
	        if (type.isDef(this.xhr_.upload)) {
	            this.xhr_.upload.addEventListener('progress', listener);
	        }
	    };
	    /**
	     * @override
	     */
	    NetworkXhrIo.prototype.removeUploadProgressListener = function (listener) {
	        if (type.isDef(this.xhr_.upload)) {
	            this.xhr_.upload.removeEventListener('progress', listener);
	        }
	    };
	    return NetworkXhrIo;
	}());
	exports.NetworkXhrIo = NetworkXhrIo;
	
	//# sourceMappingURL=xhrio_network.js.map


/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var xhrio_network_1 = __webpack_require__(316);
	/**
	 * Factory-like class for creating XhrIo instances.
	 */
	var XhrIoPool = /** @class */ (function () {
	    function XhrIoPool() {
	    }
	    XhrIoPool.prototype.createXhrIo = function () {
	        return new xhrio_network_1.NetworkXhrIo();
	    };
	    return XhrIoPool;
	}());
	exports.XhrIoPool = XhrIoPool;
	
	//# sourceMappingURL=xhriopool.js.map


/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var args = __webpack_require__(106);
	var authwrapper_1 = __webpack_require__(307);
	var location_1 = __webpack_require__(79);
	var fbsPromiseImpl = __webpack_require__(37);
	var RequestExports = __webpack_require__(313);
	var reference_1 = __webpack_require__(173);
	/**
	 * A service that provides firebaseStorage.Reference instances.
	 * @param opt_url gs:// url to a custom Storage Bucket
	 *
	 * @struct
	 */
	var Service = /** @class */ (function () {
	    function Service(app, pool, url) {
	        this.bucket_ = null;
	        function maker(authWrapper, loc) {
	            return new reference_1.Reference(authWrapper, loc);
	        }
	        this.authWrapper_ = new authwrapper_1.AuthWrapper(app, maker, RequestExports.makeRequest, this, pool);
	        this.app_ = app;
	        if (url != null) {
	            this.bucket_ = location_1.Location.makeFromBucketSpec(url);
	        }
	        else {
	            var authWrapperBucket = this.authWrapper_.bucket();
	            if (authWrapperBucket != null) {
	                this.bucket_ = new location_1.Location(authWrapperBucket, '');
	            }
	        }
	        this.internals_ = new ServiceInternals(this);
	    }
	    /**
	     * Returns a firebaseStorage.Reference for the given path in the default
	     * bucket.
	     */
	    Service.prototype.ref = function (path) {
	        function validator(path) {
	            if (/^[A-Za-z]+:\/\//.test(path)) {
	                throw 'Expected child path but got a URL, use refFromURL instead.';
	            }
	        }
	        args.validate('ref', [args.stringSpec(validator, true)], arguments);
	        if (this.bucket_ == null) {
	            throw new Error('No Storage Bucket defined in Firebase Options.');
	        }
	        var ref = new reference_1.Reference(this.authWrapper_, this.bucket_);
	        if (path != null) {
	            return ref.child(path);
	        }
	        else {
	            return ref;
	        }
	    };
	    /**
	     * Returns a firebaseStorage.Reference object for the given absolute URL,
	     * which must be a gs:// or http[s]:// URL.
	     */
	    Service.prototype.refFromURL = function (url) {
	        function validator(p) {
	            if (!/^[A-Za-z]+:\/\//.test(p)) {
	                throw 'Expected full URL but got a child path, use ref instead.';
	            }
	            try {
	                location_1.Location.makeFromUrl(p);
	            }
	            catch (e) {
	                throw 'Expected valid full URL but got an invalid one.';
	            }
	        }
	        args.validate('refFromURL', [args.stringSpec(validator, false)], arguments);
	        return new reference_1.Reference(this.authWrapper_, url);
	    };
	    Object.defineProperty(Service.prototype, "maxUploadRetryTime", {
	        get: function () {
	            return this.authWrapper_.maxUploadRetryTime();
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Service.prototype.setMaxUploadRetryTime = function (time) {
	        args.validate('setMaxUploadRetryTime', [args.nonNegativeNumberSpec()], arguments);
	        this.authWrapper_.setMaxUploadRetryTime(time);
	    };
	    Object.defineProperty(Service.prototype, "maxOperationRetryTime", {
	        get: function () {
	            return this.authWrapper_.maxOperationRetryTime();
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Service.prototype.setMaxOperationRetryTime = function (time) {
	        args.validate('setMaxOperationRetryTime', [args.nonNegativeNumberSpec()], arguments);
	        this.authWrapper_.setMaxOperationRetryTime(time);
	    };
	    Object.defineProperty(Service.prototype, "app", {
	        get: function () {
	            return this.app_;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(Service.prototype, "INTERNAL", {
	        get: function () {
	            return this.internals_;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    return Service;
	}());
	exports.Service = Service;
	/**
	 * @struct
	 */
	var ServiceInternals = /** @class */ (function () {
	    function ServiceInternals(service) {
	        this.service_ = service;
	    }
	    /**
	     * Called when the associated app is deleted.
	     * @see {!fbs.AuthWrapper.prototype.deleteApp}
	     */
	    ServiceInternals.prototype.delete = function () {
	        this.service_.authWrapper_.deleteApp();
	        return fbsPromiseImpl.resolve(undefined);
	    };
	    return ServiceInternals;
	}());
	exports.ServiceInternals = ServiceInternals;
	
	//# sourceMappingURL=service.js.map


/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * @fileoverview Defines types for interacting with blob transfer tasks.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var taskenums_1 = __webpack_require__(57);
	var observer_1 = __webpack_require__(312);
	var taskenums_2 = __webpack_require__(57);
	var tasksnapshot_1 = __webpack_require__(320);
	var fbsArgs = __webpack_require__(106);
	var fbsArray = __webpack_require__(107);
	var async_1 = __webpack_require__(306);
	var errors = __webpack_require__(30);
	var fbsPromiseimpl = __webpack_require__(37);
	var fbsRequests = __webpack_require__(171);
	var fbsTaskEnums = __webpack_require__(57);
	var typeUtils = __webpack_require__(22);
	/**
	 * Represents a blob being uploaded. Can be used to pause/resume/cancel the
	 * upload and manage callbacks for various events.
	 */
	var UploadTask = /** @class */ (function () {
	    /**
	     * @param ref The firebaseStorage.Reference object this task came
	     *     from, untyped to avoid cyclic dependencies.
	     * @param blob The blob to upload.
	     */
	    function UploadTask(ref, authWrapper, location, mappings, blob, metadata) {
	        if (metadata === void 0) { metadata = null; }
	        var _this = this;
	        this.transferred_ = 0;
	        this.needToFetchStatus_ = false;
	        this.needToFetchMetadata_ = false;
	        this.observers_ = [];
	        this.error_ = null;
	        this.uploadUrl_ = null;
	        this.request_ = null;
	        this.chunkMultiplier_ = 1;
	        this.resolve_ = null;
	        this.reject_ = null;
	        this.ref_ = ref;
	        this.authWrapper_ = authWrapper;
	        this.location_ = location;
	        this.blob_ = blob;
	        this.metadata_ = metadata;
	        this.mappings_ = mappings;
	        this.resumable_ = this.shouldDoResumable_(this.blob_);
	        this.state_ = taskenums_1.InternalTaskState.RUNNING;
	        this.errorHandler_ = function (error) {
	            _this.request_ = null;
	            _this.chunkMultiplier_ = 1;
	            if (error.codeEquals(errors.Code.CANCELED)) {
	                _this.needToFetchStatus_ = true;
	                _this.completeTransitions_();
	            }
	            else {
	                _this.error_ = error;
	                _this.transition_(taskenums_1.InternalTaskState.ERROR);
	            }
	        };
	        this.metadataErrorHandler_ = function (error) {
	            _this.request_ = null;
	            if (error.codeEquals(errors.Code.CANCELED)) {
	                _this.completeTransitions_();
	            }
	            else {
	                _this.error_ = error;
	                _this.transition_(taskenums_1.InternalTaskState.ERROR);
	            }
	        };
	        this.promise_ = fbsPromiseimpl.make(function (resolve, reject) {
	            _this.resolve_ = resolve;
	            _this.reject_ = reject;
	            _this.start_();
	        });
	        // Prevent uncaught rejections on the internal promise from bubbling out
	        // to the top level with a dummy handler.
	        this.promise_.then(null, function () { });
	    }
	    UploadTask.prototype.makeProgressCallback_ = function () {
	        var _this = this;
	        var sizeBefore = this.transferred_;
	        return function (loaded, total) {
	            _this.updateProgress_(sizeBefore + loaded);
	        };
	    };
	    UploadTask.prototype.shouldDoResumable_ = function (blob) {
	        return blob.size() > 256 * 1024;
	    };
	    UploadTask.prototype.start_ = function () {
	        if (this.state_ !== taskenums_1.InternalTaskState.RUNNING) {
	            // This can happen if someone pauses us in a resume callback, for example.
	            return;
	        }
	        if (this.request_ !== null) {
	            return;
	        }
	        if (this.resumable_) {
	            if (this.uploadUrl_ === null) {
	                this.createResumable_();
	            }
	            else {
	                if (this.needToFetchStatus_) {
	                    this.fetchStatus_();
	                }
	                else {
	                    if (this.needToFetchMetadata_) {
	                        // Happens if we miss the metadata on upload completion.
	                        this.fetchMetadata_();
	                    }
	                    else {
	                        this.continueUpload_();
	                    }
	                }
	            }
	        }
	        else {
	            this.oneShotUpload_();
	        }
	    };
	    UploadTask.prototype.resolveToken_ = function (callback) {
	        var _this = this;
	        this.authWrapper_.getAuthToken().then(function (authToken) {
	            switch (_this.state_) {
	                case taskenums_1.InternalTaskState.RUNNING:
	                    callback(authToken);
	                    break;
	                case taskenums_1.InternalTaskState.CANCELING:
	                    _this.transition_(taskenums_1.InternalTaskState.CANCELED);
	                    break;
	                case taskenums_1.InternalTaskState.PAUSING:
	                    _this.transition_(taskenums_1.InternalTaskState.PAUSED);
	                    break;
	                default:
	            }
	        });
	    };
	    // TODO(andysoto): assert false
	    UploadTask.prototype.createResumable_ = function () {
	        var _this = this;
	        this.resolveToken_(function (authToken) {
	            var requestInfo = fbsRequests.createResumableUpload(_this.authWrapper_, _this.location_, _this.mappings_, _this.blob_, _this.metadata_);
	            var createRequest = _this.authWrapper_.makeRequest(requestInfo, authToken);
	            _this.request_ = createRequest;
	            createRequest.getPromise().then(function (url) {
	                _this.request_ = null;
	                _this.uploadUrl_ = url;
	                _this.needToFetchStatus_ = false;
	                _this.completeTransitions_();
	            }, _this.errorHandler_);
	        });
	    };
	    UploadTask.prototype.fetchStatus_ = function () {
	        var _this = this;
	        // TODO(andysoto): assert(this.uploadUrl_ !== null);
	        var url = this.uploadUrl_;
	        this.resolveToken_(function (authToken) {
	            var requestInfo = fbsRequests.getResumableUploadStatus(_this.authWrapper_, _this.location_, url, _this.blob_);
	            var statusRequest = _this.authWrapper_.makeRequest(requestInfo, authToken);
	            _this.request_ = statusRequest;
	            statusRequest.getPromise().then(function (status) {
	                status = status;
	                _this.request_ = null;
	                _this.updateProgress_(status.current);
	                _this.needToFetchStatus_ = false;
	                if (status.finalized) {
	                    _this.needToFetchMetadata_ = true;
	                }
	                _this.completeTransitions_();
	            }, _this.errorHandler_);
	        });
	    };
	    UploadTask.prototype.continueUpload_ = function () {
	        var _this = this;
	        var chunkSize = fbsRequests.resumableUploadChunkSize * this.chunkMultiplier_;
	        var status = new fbsRequests.ResumableUploadStatus(this.transferred_, this.blob_.size());
	        // TODO(andysoto): assert(this.uploadUrl_ !== null);
	        var url = this.uploadUrl_;
	        this.resolveToken_(function (authToken) {
	            var requestInfo;
	            try {
	                requestInfo = fbsRequests.continueResumableUpload(_this.location_, _this.authWrapper_, url, _this.blob_, chunkSize, _this.mappings_, status, _this.makeProgressCallback_());
	            }
	            catch (e) {
	                _this.error_ = e;
	                _this.transition_(taskenums_1.InternalTaskState.ERROR);
	                return;
	            }
	            var uploadRequest = _this.authWrapper_.makeRequest(requestInfo, authToken);
	            _this.request_ = uploadRequest;
	            uploadRequest
	                .getPromise()
	                .then(function (newStatus) {
	                _this.increaseMultiplier_();
	                _this.request_ = null;
	                _this.updateProgress_(newStatus.current);
	                if (newStatus.finalized) {
	                    _this.metadata_ = newStatus.metadata;
	                    _this.transition_(taskenums_1.InternalTaskState.SUCCESS);
	                }
	                else {
	                    _this.completeTransitions_();
	                }
	            }, _this.errorHandler_);
	        });
	    };
	    UploadTask.prototype.increaseMultiplier_ = function () {
	        var currentSize = fbsRequests.resumableUploadChunkSize * this.chunkMultiplier_;
	        // Max chunk size is 32M.
	        if (currentSize < 32 * 1024 * 1024) {
	            this.chunkMultiplier_ *= 2;
	        }
	    };
	    UploadTask.prototype.fetchMetadata_ = function () {
	        var _this = this;
	        this.resolveToken_(function (authToken) {
	            var requestInfo = fbsRequests.getMetadata(_this.authWrapper_, _this.location_, _this.mappings_);
	            var metadataRequest = _this.authWrapper_.makeRequest(requestInfo, authToken);
	            _this.request_ = metadataRequest;
	            metadataRequest.getPromise().then(function (metadata) {
	                _this.request_ = null;
	                _this.metadata_ = metadata;
	                _this.transition_(taskenums_1.InternalTaskState.SUCCESS);
	            }, _this.metadataErrorHandler_);
	        });
	    };
	    UploadTask.prototype.oneShotUpload_ = function () {
	        var _this = this;
	        this.resolveToken_(function (authToken) {
	            var requestInfo = fbsRequests.multipartUpload(_this.authWrapper_, _this.location_, _this.mappings_, _this.blob_, _this.metadata_);
	            var multipartRequest = _this.authWrapper_.makeRequest(requestInfo, authToken);
	            _this.request_ = multipartRequest;
	            multipartRequest.getPromise().then(function (metadata) {
	                _this.request_ = null;
	                _this.metadata_ = metadata;
	                _this.updateProgress_(_this.blob_.size());
	                _this.transition_(taskenums_1.InternalTaskState.SUCCESS);
	            }, _this.errorHandler_);
	        });
	    };
	    UploadTask.prototype.updateProgress_ = function (transferred) {
	        var old = this.transferred_;
	        this.transferred_ = transferred;
	        // A progress update can make the "transferred" value smaller (e.g. a
	        // partial upload not completed by server, after which the "transferred"
	        // value may reset to the value at the beginning of the request).
	        if (this.transferred_ !== old) {
	            this.notifyObservers_();
	        }
	    };
	    UploadTask.prototype.transition_ = function (state) {
	        if (this.state_ === state) {
	            return;
	        }
	        switch (state) {
	            case taskenums_1.InternalTaskState.CANCELING:
	                // TODO(andysoto):
	                // assert(this.state_ === InternalTaskState.RUNNING ||
	                //        this.state_ === InternalTaskState.PAUSING);
	                this.state_ = state;
	                if (this.request_ !== null) {
	                    this.request_.cancel();
	                }
	                break;
	            case taskenums_1.InternalTaskState.PAUSING:
	                // TODO(andysoto):
	                // assert(this.state_ === InternalTaskState.RUNNING);
	                this.state_ = state;
	                if (this.request_ !== null) {
	                    this.request_.cancel();
	                }
	                break;
	            case taskenums_1.InternalTaskState.RUNNING:
	                // TODO(andysoto):
	                // assert(this.state_ === InternalTaskState.PAUSED ||
	                //        this.state_ === InternalTaskState.PAUSING);
	                var wasPaused = this.state_ === taskenums_1.InternalTaskState.PAUSED;
	                this.state_ = state;
	                if (wasPaused) {
	                    this.notifyObservers_();
	                    this.start_();
	                }
	                break;
	            case taskenums_1.InternalTaskState.PAUSED:
	                // TODO(andysoto):
	                // assert(this.state_ === InternalTaskState.PAUSING);
	                this.state_ = state;
	                this.notifyObservers_();
	                break;
	            case taskenums_1.InternalTaskState.CANCELED:
	                // TODO(andysoto):
	                // assert(this.state_ === InternalTaskState.PAUSED ||
	                //        this.state_ === InternalTaskState.CANCELING);
	                this.error_ = errors.canceled();
	                this.state_ = state;
	                this.notifyObservers_();
	                break;
	            case taskenums_1.InternalTaskState.ERROR:
	                // TODO(andysoto):
	                // assert(this.state_ === InternalTaskState.RUNNING ||
	                //        this.state_ === InternalTaskState.PAUSING ||
	                //        this.state_ === InternalTaskState.CANCELING);
	                this.state_ = state;
	                this.notifyObservers_();
	                break;
	            case taskenums_1.InternalTaskState.SUCCESS:
	                // TODO(andysoto):
	                // assert(this.state_ === InternalTaskState.RUNNING ||
	                //        this.state_ === InternalTaskState.PAUSING ||
	                //        this.state_ === InternalTaskState.CANCELING);
	                this.state_ = state;
	                this.notifyObservers_();
	                break;
	        }
	    };
	    UploadTask.prototype.completeTransitions_ = function () {
	        switch (this.state_) {
	            case taskenums_1.InternalTaskState.PAUSING:
	                this.transition_(taskenums_1.InternalTaskState.PAUSED);
	                break;
	            case taskenums_1.InternalTaskState.CANCELING:
	                this.transition_(taskenums_1.InternalTaskState.CANCELED);
	                break;
	            case taskenums_1.InternalTaskState.RUNNING:
	                this.start_();
	                break;
	            default:
	                // TODO(andysoto): assert(false);
	                break;
	        }
	    };
	    Object.defineProperty(UploadTask.prototype, "snapshot", {
	        get: function () {
	            var externalState = fbsTaskEnums.taskStateFromInternalTaskState(this.state_);
	            return new tasksnapshot_1.UploadTaskSnapshot(this.transferred_, this.blob_.size(), externalState, this.metadata_, this, this.ref_);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    /**
	     * Adds a callback for an event.
	     * @param type The type of event to listen for.
	     */
	    UploadTask.prototype.on = function (type, nextOrObserver, error, completed) {
	        if (nextOrObserver === void 0) { nextOrObserver = undefined; }
	        if (error === void 0) { error = undefined; }
	        if (completed === void 0) { completed = undefined; }
	        function typeValidator(_p) {
	            if (type !== taskenums_2.TaskEvent.STATE_CHANGED) {
	                throw "Expected one of the event types: [" + taskenums_2.TaskEvent.STATE_CHANGED + "].";
	            }
	        }
	        var nextOrObserverMessage = 'Expected a function or an Object with one of ' +
	            '`next`, `error`, `complete` properties.';
	        var nextValidator = fbsArgs.nullFunctionSpec(true).validator;
	        var observerValidator = fbsArgs.looseObjectSpec(null, true).validator;
	        function nextOrObserverValidator(p) {
	            try {
	                nextValidator(p);
	                return;
	            }
	            catch (e) { }
	            try {
	                observerValidator(p);
	                var anyDefined = typeUtils.isJustDef(p['next']) ||
	                    typeUtils.isJustDef(p['error']) ||
	                    typeUtils.isJustDef(p['complete']);
	                if (!anyDefined) {
	                    throw '';
	                }
	                return;
	            }
	            catch (e) {
	                throw nextOrObserverMessage;
	            }
	        }
	        var specs = [
	            fbsArgs.stringSpec(typeValidator),
	            fbsArgs.looseObjectSpec(nextOrObserverValidator, true),
	            fbsArgs.nullFunctionSpec(true),
	            fbsArgs.nullFunctionSpec(true)
	        ];
	        fbsArgs.validate('on', specs, arguments);
	        var self = this;
	        function makeBinder(specs) {
	            function binder(nextOrObserver, error, opt_complete) {
	                if (specs !== null) {
	                    fbsArgs.validate('on', specs, arguments);
	                }
	                var observer = new observer_1.Observer(nextOrObserver, error, completed);
	                self.addObserver_(observer);
	                return function () {
	                    self.removeObserver_(observer);
	                };
	            }
	            return binder;
	        }
	        function binderNextOrObserverValidator(p) {
	            if (p === null) {
	                throw nextOrObserverMessage;
	            }
	            nextOrObserverValidator(p);
	        }
	        var binderSpecs = [
	            fbsArgs.looseObjectSpec(binderNextOrObserverValidator),
	            fbsArgs.nullFunctionSpec(true),
	            fbsArgs.nullFunctionSpec(true)
	        ];
	        var typeOnly = !(typeUtils.isJustDef(nextOrObserver) ||
	            typeUtils.isJustDef(error) ||
	            typeUtils.isJustDef(completed));
	        if (typeOnly) {
	            return makeBinder(binderSpecs);
	        }
	        else {
	            return makeBinder(null)(nextOrObserver, error, completed);
	        }
	    };
	    /**
	     * This object behaves like a Promise, and resolves with its snapshot data
	     * when the upload completes.
	     * @param onFulfilled The fulfillment callback. Promise chaining works as normal.
	     * @param onRejected The rejection callback.
	     */
	    UploadTask.prototype.then = function (onFulfilled, onRejected) {
	        // These casts are needed so that TypeScript can infer the types of the
	        // resulting Promise.
	        return this.promise_.then(onFulfilled, onRejected);
	    };
	    /**
	     * Equivalent to calling `then(null, onRejected)`.
	     */
	    UploadTask.prototype.catch = function (onRejected) {
	        return this.then(null, onRejected);
	    };
	    /**
	     * Adds the given observer.
	     */
	    UploadTask.prototype.addObserver_ = function (observer) {
	        this.observers_.push(observer);
	        this.notifyObserver_(observer);
	    };
	    /**
	     * Removes the given observer.
	     */
	    UploadTask.prototype.removeObserver_ = function (observer) {
	        fbsArray.remove(this.observers_, observer);
	    };
	    UploadTask.prototype.notifyObservers_ = function () {
	        var _this = this;
	        this.finishPromise_();
	        var observers = fbsArray.clone(this.observers_);
	        observers.forEach(function (observer) {
	            _this.notifyObserver_(observer);
	        });
	    };
	    UploadTask.prototype.finishPromise_ = function () {
	        if (this.resolve_ !== null) {
	            var triggered = true;
	            switch (fbsTaskEnums.taskStateFromInternalTaskState(this.state_)) {
	                case taskenums_2.TaskState.SUCCESS:
	                    async_1.async(this.resolve_.bind(null, this.snapshot))();
	                    break;
	                case taskenums_2.TaskState.CANCELED:
	                case taskenums_2.TaskState.ERROR:
	                    var toCall = this.reject_;
	                    async_1.async(toCall.bind(null, this.error_))();
	                    break;
	                default:
	                    triggered = false;
	                    break;
	            }
	            if (triggered) {
	                this.resolve_ = null;
	                this.reject_ = null;
	            }
	        }
	    };
	    UploadTask.prototype.notifyObserver_ = function (observer) {
	        var externalState = fbsTaskEnums.taskStateFromInternalTaskState(this.state_);
	        switch (externalState) {
	            case taskenums_2.TaskState.RUNNING:
	            case taskenums_2.TaskState.PAUSED:
	                if (observer.next !== null) {
	                    async_1.async(observer.next.bind(observer, this.snapshot))();
	                }
	                break;
	            case taskenums_2.TaskState.SUCCESS:
	                if (observer.complete !== null) {
	                    async_1.async(observer.complete.bind(observer))();
	                }
	                break;
	            case taskenums_2.TaskState.CANCELED:
	            case taskenums_2.TaskState.ERROR:
	                if (observer.error !== null) {
	                    async_1.async(observer.error.bind(observer, this.error_))();
	                }
	                break;
	            default:
	                // TODO(andysoto): assert(false);
	                if (observer.error !== null) {
	                    async_1.async(observer.error.bind(observer, this.error_))();
	                }
	        }
	    };
	    /**
	     * Resumes a paused task. Has no effect on a currently running or failed task.
	     * @return True if the operation took effect, false if ignored.
	     */
	    UploadTask.prototype.resume = function () {
	        fbsArgs.validate('resume', [], arguments);
	        var valid = this.state_ === taskenums_1.InternalTaskState.PAUSED ||
	            this.state_ === taskenums_1.InternalTaskState.PAUSING;
	        if (valid) {
	            this.transition_(taskenums_1.InternalTaskState.RUNNING);
	        }
	        return valid;
	    };
	    /**
	     * Pauses a currently running task. Has no effect on a paused or failed task.
	     * @return True if the operation took effect, false if ignored.
	     */
	    UploadTask.prototype.pause = function () {
	        fbsArgs.validate('pause', [], arguments);
	        var valid = this.state_ === taskenums_1.InternalTaskState.RUNNING;
	        if (valid) {
	            this.transition_(taskenums_1.InternalTaskState.PAUSING);
	        }
	        return valid;
	    };
	    /**
	     * Cancels a currently running or paused task. Has no effect on a complete or
	     * failed task.
	     * @return True if the operation took effect, false if ignored.
	     */
	    UploadTask.prototype.cancel = function () {
	        fbsArgs.validate('cancel', [], arguments);
	        var valid = this.state_ === taskenums_1.InternalTaskState.RUNNING ||
	            this.state_ === taskenums_1.InternalTaskState.PAUSING;
	        if (valid) {
	            this.transition_(taskenums_1.InternalTaskState.CANCELING);
	        }
	        return valid;
	    };
	    return UploadTask;
	}());
	exports.UploadTask = UploadTask;
	
	//# sourceMappingURL=task.js.map


/***/ }),
/* 320 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var UploadTaskSnapshot = /** @class */ (function () {
	    function UploadTaskSnapshot(bytesTransferred, totalBytes, state, metadata, task, ref) {
	        this.bytesTransferred = bytesTransferred;
	        this.totalBytes = totalBytes;
	        this.state = state;
	        this.metadata = metadata;
	        this.task = task;
	        this.ref = ref;
	    }
	    Object.defineProperty(UploadTaskSnapshot.prototype, "downloadURL", {
	        get: function () {
	            if (this.metadata !== null) {
	                var urls = this.metadata['downloadURLs'];
	                if (urls != null && urls[0] != null) {
	                    return urls[0];
	                }
	                else {
	                    return null;
	                }
	            }
	            else {
	                return null;
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    return UploadTaskSnapshot;
	}());
	exports.UploadTaskSnapshot = UploadTaskSnapshot;
	
	//# sourceMappingURL=tasksnapshot.js.map


/***/ }),
/* 321 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Do a deep-copy of basic JavaScript Objects or Arrays.
	 */
	function deepCopy(value) {
	    return deepExtend(undefined, value);
	}
	exports.deepCopy = deepCopy;
	/**
	 * Copy properties from source to target (recursively allows extension
	 * of Objects and Arrays).  Scalar values in the target are over-written.
	 * If target is undefined, an object of the appropriate type will be created
	 * (and returned).
	 *
	 * We recursively copy all child properties of plain Objects in the source- so
	 * that namespace- like dictionaries are merged.
	 *
	 * Note that the target can be a function, in which case the properties in
	 * the source Object are copied onto it as static properties of the Function.
	 */
	function deepExtend(target, source) {
	    if (!(source instanceof Object)) {
	        return source;
	    }
	    switch (source.constructor) {
	        case Date:
	            // Treat Dates like scalars; if the target date object had any child
	            // properties - they will be lost!
	            var dateValue = source;
	            return new Date(dateValue.getTime());
	        case Object:
	            if (target === undefined) {
	                target = {};
	            }
	            break;
	        case Array:
	            // Always copy the array source and overwrite the target.
	            target = [];
	            break;
	        default:
	            // Not a plain Object - treat it as a scalar.
	            return source;
	    }
	    for (var prop in source) {
	        if (!source.hasOwnProperty(prop)) {
	            continue;
	        }
	        target[prop] = deepExtend(target[prop], source[prop]);
	    }
	    return target;
	}
	exports.deepExtend = deepExtend;
	// TODO: Really needed (for JSCompiler type checking)?
	function patchProperty(obj, prop, value) {
	    obj[prop] = value;
	}
	exports.patchProperty = patchProperty;
	
	//# sourceMappingURL=deepCopy.js.map


/***/ }),
/* 322 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var Deferred = /** @class */ (function () {
	    function Deferred() {
	        var _this = this;
	        this.promise = new Promise(function (resolve, reject) {
	            _this.resolve = resolve;
	            _this.reject = reject;
	        });
	    }
	    /**
	     * Our API internals are not promiseified and cannot because our callback APIs have subtle expectations around
	     * invoking promises inline, which Promises are forbidden to do. This method accepts an optional node-style callback
	     * and returns a node-style callback which will resolve or reject the Deferred's promise.
	     * @param {((?function(?(Error)): (?|undefined))| (?function(?(Error),?=): (?|undefined)))=} callback
	     * @return {!function(?(Error), ?=)}
	     */
	    Deferred.prototype.wrapCallback = function (callback) {
	        var _this = this;
	        return function (error, value) {
	            if (error) {
	                _this.reject(error);
	            }
	            else {
	                _this.resolve(value);
	            }
	            if (typeof callback === 'function') {
	                // Attaching noop handler just in case developer wasn't expecting
	                // promises
	                _this.promise.catch(function () { });
	                // Some of our callbacks don't expect a value and our own tests
	                // assert that the parameter length is 1
	                if (callback.length === 1) {
	                    callback(error);
	                }
	                else {
	                    callback(error, value);
	                }
	            }
	        };
	    };
	    return Deferred;
	}());
	exports.Deferred = Deferred;
	
	//# sourceMappingURL=deferred.js.map


/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var constants_1 = __webpack_require__(110);
	/**
	 * Returns navigator.userAgent string or '' if it's not defined.
	 * @return {string} user agent string
	 */
	exports.getUA = function () {
	    if (typeof navigator !== 'undefined' &&
	        typeof navigator['userAgent'] === 'string') {
	        return navigator['userAgent'];
	    }
	    else {
	        return '';
	    }
	};
	/**
	 * Detect Cordova / PhoneGap / Ionic frameworks on a mobile device.
	 *
	 * Deliberately does not rely on checking `file://` URLs (as this fails PhoneGap in the Ripple emulator) nor
	 * Cordova `onDeviceReady`, which would normally wait for a callback.
	 *
	 * @return {boolean} isMobileCordova
	 */
	exports.isMobileCordova = function () {
	    return (typeof window !== 'undefined' &&
	        !!(window['cordova'] || window['phonegap'] || window['PhoneGap']) &&
	        /ios|iphone|ipod|ipad|android|blackberry|iemobile/i.test(exports.getUA()));
	};
	/**
	 * Detect React Native.
	 *
	 * @return {boolean} True if ReactNative environment is detected.
	 */
	exports.isReactNative = function () {
	    return (typeof navigator === 'object' && navigator['product'] === 'ReactNative');
	};
	/**
	 * Detect Node.js.
	 *
	 * @return {boolean} True if Node.js environment is detected.
	 */
	exports.isNodeSdk = function () {
	    return constants_1.CONSTANTS.NODE_CLIENT === true || constants_1.CONSTANTS.NODE_ADMIN === true;
	};
	
	//# sourceMappingURL=environment.js.map


/***/ }),
/* 324 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var ERROR_NAME = 'FirebaseError';
	var captureStackTrace = Error
	    .captureStackTrace;
	// Export for faking in tests
	function patchCapture(captureFake) {
	    var result = captureStackTrace;
	    captureStackTrace = captureFake;
	    return result;
	}
	exports.patchCapture = patchCapture;
	var FirebaseError = /** @class */ (function () {
	    function FirebaseError(code, message) {
	        this.code = code;
	        this.message = message;
	        var stack;
	        // We want the stack value, if implemented by Error
	        if (captureStackTrace) {
	            // Patches this.stack, omitted calls above ErrorFactory#create
	            captureStackTrace(this, ErrorFactory.prototype.create);
	        }
	        else {
	            var err_1 = Error.apply(this, arguments);
	            this.name = ERROR_NAME;
	            // Make non-enumerable getter for the property.
	            Object.defineProperty(this, 'stack', {
	                get: function () {
	                    return err_1.stack;
	                }
	            });
	        }
	    }
	    return FirebaseError;
	}());
	exports.FirebaseError = FirebaseError;
	// Back-door inheritance
	FirebaseError.prototype = Object.create(Error.prototype);
	FirebaseError.prototype.constructor = FirebaseError;
	FirebaseError.prototype.name = ERROR_NAME;
	var ErrorFactory = /** @class */ (function () {
	    function ErrorFactory(service, serviceName, errors) {
	        this.service = service;
	        this.serviceName = serviceName;
	        this.errors = errors;
	        // Matches {$name}, by default.
	        this.pattern = /\{\$([^}]+)}/g;
	        // empty
	    }
	    ErrorFactory.prototype.create = function (code, data) {
	        if (data === undefined) {
	            data = {};
	        }
	        var template = this.errors[code];
	        var fullCode = this.service + '/' + code;
	        var message;
	        if (template === undefined) {
	            message = 'Error';
	        }
	        else {
	            message = template.replace(this.pattern, function (match, key) {
	                var value = data[key];
	                return value !== undefined ? value.toString() : '<' + key + '?>';
	            });
	        }
	        // Service: Error message (service/code).
	        message = this.serviceName + ': ' + message + ' (' + fullCode + ').';
	        var err = new FirebaseError(fullCode, message);
	        // Populate the Error object with message parts for programmatic
	        // accesses (e.g., e.file).
	        for (var prop in data) {
	            if (!data.hasOwnProperty(prop) || prop.slice(-1) === '_') {
	                continue;
	            }
	            err[prop] = data[prop];
	        }
	        return err;
	    };
	    return ErrorFactory;
	}());
	exports.ErrorFactory = ErrorFactory;
	
	//# sourceMappingURL=errors.js.map


/***/ }),
/* 325 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	// Copyright 2011 The Closure Library Authors. All Rights Reserved.
	//
	// Licensed under the Apache License, Version 2.0 (the "License");
	// you may not use this file except in compliance with the License.
	// You may obtain a copy of the License at
	//
	//      http://www.apache.org/licenses/LICENSE-2.0
	//
	// Unless required by applicable law or agreed to in writing, software
	// distributed under the License is distributed on an "AS-IS" BASIS,
	// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	// See the License for the specific language governing permissions and
	// limitations under the License.
	/**
	 * @fileoverview Abstract cryptographic hash interface.
	 *
	 * See Sha1 and Md5 for sample implementations.
	 *
	 */
	/**
	 * Create a cryptographic hash instance.
	 *
	 * @constructor
	 * @struct
	 */
	var Hash = /** @class */ (function () {
	    function Hash() {
	        /**
	         * The block size for the hasher.
	         * @type {number}
	         */
	        this.blockSize = -1;
	    }
	    return Hash;
	}());
	exports.Hash = Hash;
	
	//# sourceMappingURL=hash.js.map


/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var crypt_1 = __webpack_require__(175);
	var json_1 = __webpack_require__(176);
	/**
	 * Decodes a Firebase auth. token into constituent parts.
	 *
	 * Notes:
	 * - May return with invalid / incomplete claims if there's no native base64 decoding support.
	 * - Doesn't check if the token is actually valid.
	 *
	 * @param {?string} token
	 * @return {{header: *, claims: *, data: *, signature: string}}
	 */
	exports.decode = function (token) {
	    var header = {}, claims = {}, data = {}, signature = '';
	    try {
	        var parts = token.split('.');
	        header = json_1.jsonEval(crypt_1.base64Decode(parts[0]) || '');
	        claims = json_1.jsonEval(crypt_1.base64Decode(parts[1]) || '');
	        signature = parts[2];
	        data = claims['d'] || {};
	        delete claims['d'];
	    }
	    catch (e) { }
	    return {
	        header: header,
	        claims: claims,
	        data: data,
	        signature: signature
	    };
	};
	/**
	 * Decodes a Firebase auth. token and checks the validity of its time-based claims. Will return true if the
	 * token is within the time window authorized by the 'nbf' (not-before) and 'iat' (issued-at) claims.
	 *
	 * Notes:
	 * - May return a false negative if there's no native base64 decoding support.
	 * - Doesn't check if the token is actually valid.
	 *
	 * @param {?string} token
	 * @return {boolean}
	 */
	exports.isValidTimestamp = function (token) {
	    var claims = exports.decode(token).claims, now = Math.floor(new Date().getTime() / 1000), validSince, validUntil;
	    if (typeof claims === 'object') {
	        if (claims.hasOwnProperty('nbf')) {
	            validSince = claims['nbf'];
	        }
	        else if (claims.hasOwnProperty('iat')) {
	            validSince = claims['iat'];
	        }
	        if (claims.hasOwnProperty('exp')) {
	            validUntil = claims['exp'];
	        }
	        else {
	            // token will expire after 24h by default
	            validUntil = validSince + 86400;
	        }
	    }
	    return (now && validSince && validUntil && now >= validSince && now <= validUntil);
	};
	/**
	 * Decodes a Firebase auth. token and returns its issued at time if valid, null otherwise.
	 *
	 * Notes:
	 * - May return null if there's no native base64 decoding support.
	 * - Doesn't check if the token is actually valid.
	 *
	 * @param {?string} token
	 * @return {?number}
	 */
	exports.issuedAtTime = function (token) {
	    var claims = exports.decode(token).claims;
	    if (typeof claims === 'object' && claims.hasOwnProperty('iat')) {
	        return claims['iat'];
	    }
	    return null;
	};
	/**
	 * Decodes a Firebase auth. token and checks the validity of its format. Expects a valid issued-at time and non-empty
	 * signature.
	 *
	 * Notes:
	 * - May return a false negative if there's no native base64 decoding support.
	 * - Doesn't check if the token is actually valid.
	 *
	 * @param {?string} token
	 * @return {boolean}
	 */
	exports.isValidFormat = function (token) {
	    var decoded = exports.decode(token), claims = decoded.claims;
	    return (!!decoded.signature &&
	        !!claims &&
	        typeof claims === 'object' &&
	        claims.hasOwnProperty('iat'));
	};
	/**
	 * Attempts to peer into an auth token and determine if it's an admin auth token by looking at the claims portion.
	 *
	 * Notes:
	 * - May return a false negative if there's no native base64 decoding support.
	 * - Doesn't check if the token is actually valid.
	 *
	 * @param {?string} token
	 * @return {boolean}
	 */
	exports.isAdmin = function (token) {
	    var claims = exports.decode(token).claims;
	    return typeof claims === 'object' && claims['admin'] === true;
	};
	
	//# sourceMappingURL=jwt.js.map


/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var obj_1 = __webpack_require__(177);
	/**
	 * Returns a querystring-formatted string (e.g. &arg=val&arg2=val2) from a params
	 * object (e.g. {arg: 'val', arg2: 'val2'})
	 * Note: You must prepend it with ? when adding it to a URL.
	 *
	 * @param {!Object} querystringParams
	 * @return {string}
	 */
	exports.querystring = function (querystringParams) {
	    var params = [];
	    obj_1.forEach(querystringParams, function (key, value) {
	        if (Array.isArray(value)) {
	            value.forEach(function (arrayVal) {
	                params.push(encodeURIComponent(key) + '=' + encodeURIComponent(arrayVal));
	            });
	        }
	        else {
	            params.push(encodeURIComponent(key) + '=' + encodeURIComponent(value));
	        }
	    });
	    return params.length ? '&' + params.join('&') : '';
	};
	/**
	 * Decodes a querystring (e.g. ?arg=val&arg2=val2) into a params object (e.g. {arg: 'val', arg2: 'val2'})
	 *
	 * @param {string} querystring
	 * @return {!Object}
	 */
	exports.querystringDecode = function (querystring) {
	    var obj = {};
	    var tokens = querystring.replace(/^\?/, '').split('&');
	    tokens.forEach(function (token) {
	        if (token) {
	            var key = token.split('=');
	            obj[key[0]] = key[1];
	        }
	    });
	    return obj;
	};
	
	//# sourceMappingURL=query.js.map


/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var hash_1 = __webpack_require__(325);
	/**
	 * @fileoverview SHA-1 cryptographic hash.
	 * Variable names follow the notation in FIPS PUB 180-3:
	 * http://csrc.nist.gov/publications/fips/fips180-3/fips180-3_final.pdf.
	 *
	 * Usage:
	 *   var sha1 = new sha1();
	 *   sha1.update(bytes);
	 *   var hash = sha1.digest();
	 *
	 * Performance:
	 *   Chrome 23:   ~400 Mbit/s
	 *   Firefox 16:  ~250 Mbit/s
	 *
	 */
	/**
	 * SHA-1 cryptographic hash constructor.
	 *
	 * The properties declared here are discussed in the above algorithm document.
	 * @constructor
	 * @extends {Hash}
	 * @final
	 * @struct
	 */
	var Sha1 = /** @class */ (function (_super) {
	    __extends(Sha1, _super);
	    function Sha1() {
	        var _this = _super.call(this) || this;
	        /**
	         * Holds the previous values of accumulated variables a-e in the compress_
	         * function.
	         * @type {!Array<number>}
	         * @private
	         */
	        _this.chain_ = [];
	        /**
	         * A buffer holding the partially computed hash result.
	         * @type {!Array<number>}
	         * @private
	         */
	        _this.buf_ = [];
	        /**
	         * An array of 80 bytes, each a part of the message to be hashed.  Referred to
	         * as the message schedule in the docs.
	         * @type {!Array<number>}
	         * @private
	         */
	        _this.W_ = [];
	        /**
	         * Contains data needed to pad messages less than 64 bytes.
	         * @type {!Array<number>}
	         * @private
	         */
	        _this.pad_ = [];
	        /**
	         * @private {number}
	         */
	        _this.inbuf_ = 0;
	        /**
	         * @private {number}
	         */
	        _this.total_ = 0;
	        _this.blockSize = 512 / 8;
	        _this.pad_[0] = 128;
	        for (var i = 1; i < _this.blockSize; ++i) {
	            _this.pad_[i] = 0;
	        }
	        _this.reset();
	        return _this;
	    }
	    Sha1.prototype.reset = function () {
	        this.chain_[0] = 0x67452301;
	        this.chain_[1] = 0xefcdab89;
	        this.chain_[2] = 0x98badcfe;
	        this.chain_[3] = 0x10325476;
	        this.chain_[4] = 0xc3d2e1f0;
	        this.inbuf_ = 0;
	        this.total_ = 0;
	    };
	    /**
	     * Internal compress helper function.
	     * @param {!Array<number>|!Uint8Array|string} buf Block to compress.
	     * @param {number=} opt_offset Offset of the block in the buffer.
	     * @private
	     */
	    Sha1.prototype.compress_ = function (buf, opt_offset) {
	        if (!opt_offset) {
	            opt_offset = 0;
	        }
	        var W = this.W_;
	        // get 16 big endian words
	        if (typeof buf === 'string') {
	            for (var i = 0; i < 16; i++) {
	                // TODO(user): [bug 8140122] Recent versions of Safari for Mac OS and iOS
	                // have a bug that turns the post-increment ++ operator into pre-increment
	                // during JIT compilation.  We have code that depends heavily on SHA-1 for
	                // correctness and which is affected by this bug, so I've removed all uses
	                // of post-increment ++ in which the result value is used.  We can revert
	                // this change once the Safari bug
	                // (https://bugs.webkit.org/show_bug.cgi?id=109036) has been fixed and
	                // most clients have been updated.
	                W[i] =
	                    (buf.charCodeAt(opt_offset) << 24) |
	                        (buf.charCodeAt(opt_offset + 1) << 16) |
	                        (buf.charCodeAt(opt_offset + 2) << 8) |
	                        buf.charCodeAt(opt_offset + 3);
	                opt_offset += 4;
	            }
	        }
	        else {
	            for (var i = 0; i < 16; i++) {
	                W[i] =
	                    (buf[opt_offset] << 24) |
	                        (buf[opt_offset + 1] << 16) |
	                        (buf[opt_offset + 2] << 8) |
	                        buf[opt_offset + 3];
	                opt_offset += 4;
	            }
	        }
	        // expand to 80 words
	        for (var i = 16; i < 80; i++) {
	            var t = W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16];
	            W[i] = ((t << 1) | (t >>> 31)) & 0xffffffff;
	        }
	        var a = this.chain_[0];
	        var b = this.chain_[1];
	        var c = this.chain_[2];
	        var d = this.chain_[3];
	        var e = this.chain_[4];
	        var f, k;
	        // TODO(user): Try to unroll this loop to speed up the computation.
	        for (var i = 0; i < 80; i++) {
	            if (i < 40) {
	                if (i < 20) {
	                    f = d ^ (b & (c ^ d));
	                    k = 0x5a827999;
	                }
	                else {
	                    f = b ^ c ^ d;
	                    k = 0x6ed9eba1;
	                }
	            }
	            else {
	                if (i < 60) {
	                    f = (b & c) | (d & (b | c));
	                    k = 0x8f1bbcdc;
	                }
	                else {
	                    f = b ^ c ^ d;
	                    k = 0xca62c1d6;
	                }
	            }
	            var t = (((a << 5) | (a >>> 27)) + f + e + k + W[i]) & 0xffffffff;
	            e = d;
	            d = c;
	            c = ((b << 30) | (b >>> 2)) & 0xffffffff;
	            b = a;
	            a = t;
	        }
	        this.chain_[0] = (this.chain_[0] + a) & 0xffffffff;
	        this.chain_[1] = (this.chain_[1] + b) & 0xffffffff;
	        this.chain_[2] = (this.chain_[2] + c) & 0xffffffff;
	        this.chain_[3] = (this.chain_[3] + d) & 0xffffffff;
	        this.chain_[4] = (this.chain_[4] + e) & 0xffffffff;
	    };
	    Sha1.prototype.update = function (bytes, opt_length) {
	        // TODO(johnlenz): tighten the function signature and remove this check
	        if (bytes == null) {
	            return;
	        }
	        if (opt_length === undefined) {
	            opt_length = bytes.length;
	        }
	        var lengthMinusBlock = opt_length - this.blockSize;
	        var n = 0;
	        // Using local instead of member variables gives ~5% speedup on Firefox 16.
	        var buf = this.buf_;
	        var inbuf = this.inbuf_;
	        // The outer while loop should execute at most twice.
	        while (n < opt_length) {
	            // When we have no data in the block to top up, we can directly process the
	            // input buffer (assuming it contains sufficient data). This gives ~25%
	            // speedup on Chrome 23 and ~15% speedup on Firefox 16, but requires that
	            // the data is provided in large chunks (or in multiples of 64 bytes).
	            if (inbuf == 0) {
	                while (n <= lengthMinusBlock) {
	                    this.compress_(bytes, n);
	                    n += this.blockSize;
	                }
	            }
	            if (typeof bytes === 'string') {
	                while (n < opt_length) {
	                    buf[inbuf] = bytes.charCodeAt(n);
	                    ++inbuf;
	                    ++n;
	                    if (inbuf == this.blockSize) {
	                        this.compress_(buf);
	                        inbuf = 0;
	                        // Jump to the outer loop so we use the full-block optimization.
	                        break;
	                    }
	                }
	            }
	            else {
	                while (n < opt_length) {
	                    buf[inbuf] = bytes[n];
	                    ++inbuf;
	                    ++n;
	                    if (inbuf == this.blockSize) {
	                        this.compress_(buf);
	                        inbuf = 0;
	                        // Jump to the outer loop so we use the full-block optimization.
	                        break;
	                    }
	                }
	            }
	        }
	        this.inbuf_ = inbuf;
	        this.total_ += opt_length;
	    };
	    /** @override */
	    Sha1.prototype.digest = function () {
	        var digest = [];
	        var totalBits = this.total_ * 8;
	        // Add pad 0x80 0x00*.
	        if (this.inbuf_ < 56) {
	            this.update(this.pad_, 56 - this.inbuf_);
	        }
	        else {
	            this.update(this.pad_, this.blockSize - (this.inbuf_ - 56));
	        }
	        // Add # bits.
	        for (var i = this.blockSize - 1; i >= 56; i--) {
	            this.buf_[i] = totalBits & 255;
	            totalBits /= 256; // Don't use bit-shifting here!
	        }
	        this.compress_(this.buf_);
	        var n = 0;
	        for (var i = 0; i < 5; i++) {
	            for (var j = 24; j >= 0; j -= 8) {
	                digest[n] = (this.chain_[i] >> j) & 255;
	                ++n;
	            }
	        }
	        return digest;
	    };
	    return Sha1;
	}(hash_1.Hash));
	exports.Sha1 = Sha1;
	
	//# sourceMappingURL=sha1.js.map


/***/ }),
/* 329 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Helper to make a Subscribe function (just like Promise helps make a
	 * Thenable).
	 *
	 * @param executor Function which can make calls to a single Observer
	 *     as a proxy.
	 * @param onNoObservers Callback when count of Observers goes to zero.
	 */
	function createSubscribe(executor, onNoObservers) {
	    var proxy = new ObserverProxy(executor, onNoObservers);
	    return proxy.subscribe.bind(proxy);
	}
	exports.createSubscribe = createSubscribe;
	/**
	 * Implement fan-out for any number of Observers attached via a subscribe
	 * function.
	 */
	var ObserverProxy = /** @class */ (function () {
	    /**
	     * @param executor Function which can make calls to a single Observer
	     *     as a proxy.
	     * @param onNoObservers Callback when count of Observers goes to zero.
	     */
	    function ObserverProxy(executor, onNoObservers) {
	        var _this = this;
	        this.observers = [];
	        this.unsubscribes = [];
	        this.observerCount = 0;
	        // Micro-task scheduling by calling task.then().
	        this.task = Promise.resolve();
	        this.finalized = false;
	        this.onNoObservers = onNoObservers;
	        // Call the executor asynchronously so subscribers that are called
	        // synchronously after the creation of the subscribe function
	        // can still receive the very first value generated in the executor.
	        this.task
	            .then(function () {
	            executor(_this);
	        })
	            .catch(function (e) {
	            _this.error(e);
	        });
	    }
	    ObserverProxy.prototype.next = function (value) {
	        this.forEachObserver(function (observer) {
	            observer.next(value);
	        });
	    };
	    ObserverProxy.prototype.error = function (error) {
	        this.forEachObserver(function (observer) {
	            observer.error(error);
	        });
	        this.close(error);
	    };
	    ObserverProxy.prototype.complete = function () {
	        this.forEachObserver(function (observer) {
	            observer.complete();
	        });
	        this.close();
	    };
	    /**
	     * Subscribe function that can be used to add an Observer to the fan-out list.
	     *
	     * - We require that no event is sent to a subscriber sychronously to their
	     *   call to subscribe().
	     */
	    ObserverProxy.prototype.subscribe = function (nextOrObserver, error, complete) {
	        var _this = this;
	        var observer;
	        if (nextOrObserver === undefined &&
	            error === undefined &&
	            complete === undefined) {
	            throw new Error('Missing Observer.');
	        }
	        // Assemble an Observer object when passed as callback functions.
	        if (implementsAnyMethods(nextOrObserver, ['next', 'error', 'complete'])) {
	            observer = nextOrObserver;
	        }
	        else {
	            observer = {
	                next: nextOrObserver,
	                error: error,
	                complete: complete
	            };
	        }
	        if (observer.next === undefined) {
	            observer.next = noop;
	        }
	        if (observer.error === undefined) {
	            observer.error = noop;
	        }
	        if (observer.complete === undefined) {
	            observer.complete = noop;
	        }
	        var unsub = this.unsubscribeOne.bind(this, this.observers.length);
	        // Attempt to subscribe to a terminated Observable - we
	        // just respond to the Observer with the final error or complete
	        // event.
	        if (this.finalized) {
	            this.task.then(function () {
	                try {
	                    if (_this.finalError) {
	                        observer.error(_this.finalError);
	                    }
	                    else {
	                        observer.complete();
	                    }
	                }
	                catch (e) {
	                    // nothing
	                }
	                return;
	            });
	        }
	        this.observers.push(observer);
	        return unsub;
	    };
	    // Unsubscribe is synchronous - we guarantee that no events are sent to
	    // any unsubscribed Observer.
	    ObserverProxy.prototype.unsubscribeOne = function (i) {
	        if (this.observers === undefined || this.observers[i] === undefined) {
	            return;
	        }
	        delete this.observers[i];
	        this.observerCount -= 1;
	        if (this.observerCount === 0 && this.onNoObservers !== undefined) {
	            this.onNoObservers(this);
	        }
	    };
	    ObserverProxy.prototype.forEachObserver = function (fn) {
	        if (this.finalized) {
	            // Already closed by previous event....just eat the additional values.
	            return;
	        }
	        // Since sendOne calls asynchronously - there is no chance that
	        // this.observers will become undefined.
	        for (var i = 0; i < this.observers.length; i++) {
	            this.sendOne(i, fn);
	        }
	    };
	    // Call the Observer via one of it's callback function. We are careful to
	    // confirm that the observe has not been unsubscribed since this asynchronous
	    // function had been queued.
	    ObserverProxy.prototype.sendOne = function (i, fn) {
	        var _this = this;
	        // Execute the callback asynchronously
	        this.task.then(function () {
	            if (_this.observers !== undefined && _this.observers[i] !== undefined) {
	                try {
	                    fn(_this.observers[i]);
	                }
	                catch (e) {
	                    // Ignore exceptions raised in Observers or missing methods of an
	                    // Observer.
	                    // Log error to console. b/31404806
	                    if (typeof console !== 'undefined' && console.error) {
	                        console.error(e);
	                    }
	                }
	            }
	        });
	    };
	    ObserverProxy.prototype.close = function (err) {
	        var _this = this;
	        if (this.finalized) {
	            return;
	        }
	        this.finalized = true;
	        if (err !== undefined) {
	            this.finalError = err;
	        }
	        // Proxy is no longer needed - garbage collect references
	        this.task.then(function () {
	            _this.observers = undefined;
	            _this.onNoObservers = undefined;
	        });
	    };
	    return ObserverProxy;
	}());
	/** Turn synchronous function into one called asynchronously. */
	function async(fn, onError) {
	    return function () {
	        var args = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            args[_i] = arguments[_i];
	        }
	        Promise.resolve(true)
	            .then(function () {
	            fn.apply(void 0, args);
	        })
	            .catch(function (error) {
	            if (onError) {
	                onError(error);
	            }
	        });
	    };
	}
	exports.async = async;
	/**
	 * Return true if the object passed in implements any of the named methods.
	 */
	function implementsAnyMethods(obj, methods) {
	    if (typeof obj !== 'object' || obj === null) {
	        return false;
	    }
	    for (var _i = 0, methods_1 = methods; _i < methods_1.length; _i++) {
	        var method = methods_1[_i];
	        if (method in obj && typeof obj[method] === 'function') {
	            return true;
	        }
	    }
	    return false;
	}
	function noop() {
	    // do nothing
	}
	
	//# sourceMappingURL=subscribe.js.map


/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var assert_1 = __webpack_require__(174);
	// Code originally came from goog.crypt.stringToUtf8ByteArray, but for some reason they
	// automatically replaced '\r\n' with '\n', and they didn't handle surrogate pairs,
	// so it's been modified.
	// Note that not all Unicode characters appear as single characters in JavaScript strings.
	// fromCharCode returns the UTF-16 encoding of a character - so some Unicode characters
	// use 2 characters in Javascript.  All 4-byte UTF-8 characters begin with a first
	// character in the range 0xD800 - 0xDBFF (the first character of a so-called surrogate
	// pair).
	// See http://www.ecma-international.org/ecma-262/5.1/#sec-15.1.3
	/**
	 * @param {string} str
	 * @return {Array}
	 */
	exports.stringToByteArray = function (str) {
	    var out = [], p = 0;
	    for (var i = 0; i < str.length; i++) {
	        var c = str.charCodeAt(i);
	        // Is this the lead surrogate in a surrogate pair?
	        if (c >= 0xd800 && c <= 0xdbff) {
	            var high = c - 0xd800; // the high 10 bits.
	            i++;
	            assert_1.assert(i < str.length, 'Surrogate pair missing trail surrogate.');
	            var low = str.charCodeAt(i) - 0xdc00; // the low 10 bits.
	            c = 0x10000 + (high << 10) + low;
	        }
	        if (c < 128) {
	            out[p++] = c;
	        }
	        else if (c < 2048) {
	            out[p++] = (c >> 6) | 192;
	            out[p++] = (c & 63) | 128;
	        }
	        else if (c < 65536) {
	            out[p++] = (c >> 12) | 224;
	            out[p++] = ((c >> 6) & 63) | 128;
	            out[p++] = (c & 63) | 128;
	        }
	        else {
	            out[p++] = (c >> 18) | 240;
	            out[p++] = ((c >> 12) & 63) | 128;
	            out[p++] = ((c >> 6) & 63) | 128;
	            out[p++] = (c & 63) | 128;
	        }
	    }
	    return out;
	};
	/**
	 * Calculate length without actually converting; useful for doing cheaper validation.
	 * @param {string} str
	 * @return {number}
	 */
	exports.stringLength = function (str) {
	    var p = 0;
	    for (var i = 0; i < str.length; i++) {
	        var c = str.charCodeAt(i);
	        if (c < 128) {
	            p++;
	        }
	        else if (c < 2048) {
	            p += 2;
	        }
	        else if (c >= 0xd800 && c <= 0xdbff) {
	            // Lead surrogate of a surrogate pair.  The pair together will take 4 bytes to represent.
	            p += 4;
	            i++; // skip trail surrogate.
	        }
	        else {
	            p += 3;
	        }
	    }
	    return p;
	};
	
	//# sourceMappingURL=utf8.js.map


/***/ }),
/* 331 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Check to make sure the appropriate number of arguments are provided for a public function.
	 * Throws an error if it fails.
	 *
	 * @param {!string} fnName The function name
	 * @param {!number} minCount The minimum number of arguments to allow for the function call
	 * @param {!number} maxCount The maximum number of argument to allow for the function call
	 * @param {!number} argCount The actual number of arguments provided.
	 */
	exports.validateArgCount = function (fnName, minCount, maxCount, argCount) {
	    var argError;
	    if (argCount < minCount) {
	        argError = 'at least ' + minCount;
	    }
	    else if (argCount > maxCount) {
	        argError = maxCount === 0 ? 'none' : 'no more than ' + maxCount;
	    }
	    if (argError) {
	        var error = fnName +
	            ' failed: Was called with ' +
	            argCount +
	            (argCount === 1 ? ' argument.' : ' arguments.') +
	            ' Expects ' +
	            argError +
	            '.';
	        throw new Error(error);
	    }
	};
	/**
	 * Generates a string to prefix an error message about failed argument validation
	 *
	 * @param {!string} fnName The function name
	 * @param {!number} argumentNumber The index of the argument
	 * @param {boolean} optional Whether or not the argument is optional
	 * @return {!string} The prefix to add to the error thrown for validation.
	 */
	function errorPrefix(fnName, argumentNumber, optional) {
	    var argName = '';
	    switch (argumentNumber) {
	        case 1:
	            argName = optional ? 'first' : 'First';
	            break;
	        case 2:
	            argName = optional ? 'second' : 'Second';
	            break;
	        case 3:
	            argName = optional ? 'third' : 'Third';
	            break;
	        case 4:
	            argName = optional ? 'fourth' : 'Fourth';
	            break;
	        default:
	            throw new Error('errorPrefix called with argumentNumber > 4.  Need to update it?');
	    }
	    var error = fnName + ' failed: ';
	    error += argName + ' argument ';
	    return error;
	}
	exports.errorPrefix = errorPrefix;
	/**
	 * @param {!string} fnName
	 * @param {!number} argumentNumber
	 * @param {!string} namespace
	 * @param {boolean} optional
	 */
	function validateNamespace(fnName, argumentNumber, namespace, optional) {
	    if (optional && !namespace)
	        return;
	    if (typeof namespace !== 'string') {
	        //TODO: I should do more validation here. We only allow certain chars in namespaces.
	        throw new Error(errorPrefix(fnName, argumentNumber, optional) +
	            'must be a valid firebase namespace.');
	    }
	}
	exports.validateNamespace = validateNamespace;
	function validateCallback(fnName, argumentNumber, callback, optional) {
	    if (optional && !callback)
	        return;
	    if (typeof callback !== 'function')
	        throw new Error(errorPrefix(fnName, argumentNumber, optional) +
	            'must be a valid function.');
	}
	exports.validateCallback = validateCallback;
	function validateContextObject(fnName, argumentNumber, context, optional) {
	    if (optional && !context)
	        return;
	    if (typeof context !== 'object' || context === null)
	        throw new Error(errorPrefix(fnName, argumentNumber, optional) +
	            'must be a valid context object.');
	}
	exports.validateContextObject = validateContextObject;
	
	//# sourceMappingURL=validation.js.map


/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {(function() {var g,goog=goog||{},k=this;function l(a){return"string"==typeof a}function aa(){}
	function ba(a){var b=typeof a;if("object"==b)if(a){if(a instanceof Array)return"array";if(a instanceof Object)return b;var c=Object.prototype.toString.call(a);if("[object Window]"==c)return"object";if("[object Array]"==c||"number"==typeof a.length&&"undefined"!=typeof a.splice&&"undefined"!=typeof a.propertyIsEnumerable&&!a.propertyIsEnumerable("splice"))return"array";if("[object Function]"==c||"undefined"!=typeof a.call&&"undefined"!=typeof a.propertyIsEnumerable&&!a.propertyIsEnumerable("call"))return"function"}else return"null";
	else if("function"==b&&"undefined"==typeof a.call)return"object";return b}function n(a){return"array"==ba(a)}function ca(a){var b=ba(a);return"array"==b||"object"==b&&"number"==typeof a.length}function da(a){return"function"==ba(a)}function p(a){var b=typeof a;return"object"==b&&null!=a||"function"==b}var q="closure_uid_"+(1E9*Math.random()>>>0),ea=0;function fa(a,b,c){return a.call.apply(a.bind,arguments)}
	function ha(a,b,c){if(!a)throw Error();if(2<arguments.length){var d=Array.prototype.slice.call(arguments,2);return function(){var c=Array.prototype.slice.call(arguments);Array.prototype.unshift.apply(c,d);return a.apply(b,c)}}return function(){return a.apply(b,arguments)}}function r(a,b,c){Function.prototype.bind&&-1!=Function.prototype.bind.toString().indexOf("native code")?r=fa:r=ha;return r.apply(null,arguments)}
	function ia(a,b){var c=Array.prototype.slice.call(arguments,1);return function(){var b=c.slice();b.push.apply(b,arguments);return a.apply(this,b)}}var t=Date.now||function(){return+new Date};function u(a,b){function c(){}c.prototype=b.prototype;a.H=b.prototype;a.prototype=new c;a.prototype.constructor=a;a.Cb=function(a,c,f){for(var d=Array(arguments.length-2),e=2;e<arguments.length;e++)d[e-2]=arguments[e];return b.prototype[c].apply(a,d)}};function ja(a){if(Error.captureStackTrace)Error.captureStackTrace(this,ja);else{var b=Error().stack;b&&(this.stack=b)}a&&(this.message=String(a))}u(ja,Error);ja.prototype.name="CustomError";function ka(a,b){for(var c=a.split("%s"),d="",e=Array.prototype.slice.call(arguments,1);e.length&&1<c.length;)d+=c.shift()+e.shift();return d+c.join("%s")}var la=String.prototype.trim?function(a){return a.trim()}:function(a){return a.replace(/^[\s\xa0]+|[\s\xa0]+$/g,"")};function ma(a,b){return a<b?-1:a>b?1:0};function na(a,b){b.unshift(a);ja.call(this,ka.apply(null,b));b.shift()}u(na,ja);na.prototype.name="AssertionError";function oa(a,b){throw new na("Failure"+(a?": "+a:""),Array.prototype.slice.call(arguments,1));};function w(){0!=qa&&(ra[this[q]||(this[q]=++ea)]=this);this.i=this.i;this.w=this.w}var qa=0,ra={};w.prototype.i=!1;w.prototype.Z=function(){if(!this.i&&(this.i=!0,this.A(),0!=qa)){var a=this[q]||(this[q]=++ea);delete ra[a]}};w.prototype.A=function(){if(this.w)for(;this.w.length;)this.w.shift()()};var sa=Array.prototype.indexOf?function(a,b){return Array.prototype.indexOf.call(a,b,void 0)}:function(a,b){if(l(a))return l(b)&&1==b.length?a.indexOf(b,0):-1;for(var c=0;c<a.length;c++)if(c in a&&a[c]===b)return c;return-1},ta=Array.prototype.forEach?function(a,b,c){Array.prototype.forEach.call(a,b,c)}:function(a,b,c){for(var d=a.length,e=l(a)?a.split(""):a,f=0;f<d;f++)f in e&&b.call(c,e[f],f,a)};
	function ua(a){a:{var b=va;for(var c=a.length,d=l(a)?a.split(""):a,e=0;e<c;e++)if(e in d&&b.call(void 0,d[e],e,a)){b=e;break a}b=-1}return 0>b?null:l(a)?a.charAt(b):a[b]}function wa(a){if(!n(a))for(var b=a.length-1;0<=b;b--)delete a[b];a.length=0}function xa(a){return Array.prototype.concat.apply([],arguments)}function ya(a){var b=a.length;if(0<b){for(var c=Array(b),d=0;d<b;d++)c[d]=a[d];return c}return[]};var x;a:{var za=k.navigator;if(za){var Aa=za.userAgent;if(Aa){x=Aa;break a}}x=""}function y(a){return-1!=x.indexOf(a)};function Ba(a,b,c){for(var d in a)b.call(c,a[d],d,a)}function Ca(a){var b=[],c=0,d;for(d in a)b[c++]=a[d];return b}function Da(a){var b=[],c=0,d;for(d in a)b[c++]=d;return b}function Ea(a){var b={},c;for(c in a)b[c]=a[c];return b}var Fa="constructor hasOwnProperty isPrototypeOf propertyIsEnumerable toLocaleString toString valueOf".split(" ");
	function Ga(a,b){for(var c,d,e=1;e<arguments.length;e++){d=arguments[e];for(c in d)a[c]=d[c];for(var f=0;f<Fa.length;f++)c=Fa[f],Object.prototype.hasOwnProperty.call(d,c)&&(a[c]=d[c])}};function Ha(a){Ha[" "](a);return a}Ha[" "]=aa;function Ia(a,b){var c=Ja;return Object.prototype.hasOwnProperty.call(c,a)?c[a]:c[a]=b(a)};var Ka=y("Opera"),z=y("Trident")||y("MSIE"),La=y("Edge"),Ma=y("Gecko")&&!(-1!=x.toLowerCase().indexOf("webkit")&&!y("Edge"))&&!(y("Trident")||y("MSIE"))&&!y("Edge"),Na=-1!=x.toLowerCase().indexOf("webkit")&&!y("Edge");function Oa(){var a=k.document;return a?a.documentMode:void 0}var Pa;
	a:{var Qa="",Ra=function(){var a=x;if(Ma)return/rv:([^\);]+)(\)|;)/.exec(a);if(La)return/Edge\/([\d\.]+)/.exec(a);if(z)return/\b(?:MSIE|rv)[: ]([^\);]+)(\)|;)/.exec(a);if(Na)return/WebKit\/(\S+)/.exec(a);if(Ka)return/(?:Version)[ \/]?(\S+)/.exec(a)}();Ra&&(Qa=Ra?Ra[1]:"");if(z){var Sa=Oa();if(null!=Sa&&Sa>parseFloat(Qa)){Pa=String(Sa);break a}}Pa=Qa}var Ja={};
	function Ta(a){return Ia(a,function(){for(var b=0,c=la(String(Pa)).split("."),d=la(String(a)).split("."),e=Math.max(c.length,d.length),f=0;0==b&&f<e;f++){var h=c[f]||"",m=d[f]||"";do{h=/(\d*)(\D*)(.*)/.exec(h)||["","","",""];m=/(\d*)(\D*)(.*)/.exec(m)||["","","",""];if(0==h[0].length&&0==m[0].length)break;b=ma(0==h[1].length?0:parseInt(h[1],10),0==m[1].length?0:parseInt(m[1],10))||ma(0==h[2].length,0==m[2].length)||ma(h[2],m[2]);h=h[3];m=m[3]}while(0==b)}return 0<=b})}var Ua;var Va=k.document;
	Ua=Va&&z?Oa()||("CSS1Compat"==Va.compatMode?parseInt(Pa,10):5):void 0;var Wa=Object.freeze||function(a){return a};var Xa=!z||9<=Number(Ua),Ya=z&&!Ta("9"),Za=function(){if(!k.addEventListener||!Object.defineProperty)return!1;var a=!1,b=Object.defineProperty({},"passive",{get:function(){a=!0}});k.addEventListener("test",aa,b);k.removeEventListener("test",aa,b);return a}();function A(a,b){this.type=a;this.a=this.target=b;this.Pa=!0}A.prototype.b=function(){this.Pa=!1};function $a(a,b){A.call(this,a?a.type:"");this.relatedTarget=this.a=this.target=null;this.button=this.screenY=this.screenX=this.clientY=this.clientX=0;this.key="";this.metaKey=this.shiftKey=this.altKey=this.ctrlKey=!1;this.pointerId=0;this.pointerType="";this.c=null;if(a){var c=this.type=a.type,d=a.changedTouches?a.changedTouches[0]:null;this.target=a.target||a.srcElement;this.a=b;if(b=a.relatedTarget){if(Ma){a:{try{Ha(b.nodeName);var e=!0;break a}catch(f){}e=!1}e||(b=null)}}else"mouseover"==c?b=
	a.fromElement:"mouseout"==c&&(b=a.toElement);this.relatedTarget=b;null===d?(this.clientX=void 0!==a.clientX?a.clientX:a.pageX,this.clientY=void 0!==a.clientY?a.clientY:a.pageY,this.screenX=a.screenX||0,this.screenY=a.screenY||0):(this.clientX=void 0!==d.clientX?d.clientX:d.pageX,this.clientY=void 0!==d.clientY?d.clientY:d.pageY,this.screenX=d.screenX||0,this.screenY=d.screenY||0);this.button=a.button;this.key=a.key||"";this.ctrlKey=a.ctrlKey;this.altKey=a.altKey;this.shiftKey=a.shiftKey;this.metaKey=
	a.metaKey;this.pointerId=a.pointerId||0;this.pointerType=l(a.pointerType)?a.pointerType:ab[a.pointerType]||"";this.c=a;a.defaultPrevented&&this.b()}}u($a,A);var ab=Wa({2:"touch",3:"pen",4:"mouse"});$a.prototype.b=function(){$a.H.b.call(this);var a=this.c;if(a.preventDefault)a.preventDefault();else if(a.returnValue=!1,Ya)try{if(a.ctrlKey||112<=a.keyCode&&123>=a.keyCode)a.keyCode=-1}catch(b){}};var bb="closure_listenable_"+(1E6*Math.random()|0);function cb(a){return!(!a||!a[bb])}var db=0;function eb(a,b,c,d,e){this.listener=a;this.a=null;this.src=b;this.type=c;this.capture=!!d;this.ga=e;this.key=++db;this.Y=this.ca=!1}function fb(a){a.Y=!0;a.listener=null;a.a=null;a.src=null;a.ga=null};function gb(a){this.src=a;this.a={};this.b=0}gb.prototype.add=function(a,b,c,d,e){var f=a.toString();a=this.a[f];a||(a=this.a[f]=[],this.b++);var h=hb(a,b,d,e);-1<h?(b=a[h],c||(b.ca=!1)):(b=new eb(b,this.src,f,!!d,e),b.ca=c,a.push(b));return b};function ib(a,b){var c=b.type;if(c in a.a){var d=a.a[c],e=sa(d,b),f;(f=0<=e)&&Array.prototype.splice.call(d,e,1);f&&(fb(b),0==a.a[c].length&&(delete a.a[c],a.b--))}}function jb(a,b,c,d,e){a=a.a[b.toString()];b=-1;a&&(b=hb(a,c,d,e));return-1<b?a[b]:null}
	function hb(a,b,c,d){for(var e=0;e<a.length;++e){var f=a[e];if(!f.Y&&f.listener==b&&f.capture==!!c&&f.ga==d)return e}return-1};var kb="closure_lm_"+(1E6*Math.random()|0),lb={},mb=0;function nb(a,b,c,d,e){if(d&&d.once)return ob(a,b,c,d,e);if(n(b)){for(var f=0;f<b.length;f++)nb(a,b[f],c,d,e);return null}c=pb(c);return cb(a)?a.aa(b,c,p(d)?!!d.capture:!!d,e):qb(a,b,c,!1,d,e)}
	function qb(a,b,c,d,e,f){if(!b)throw Error("Invalid event type");var h=p(e)?!!e.capture:!!e,m=rb(a);m||(a[kb]=m=new gb(a));c=m.add(b,c,d,h,f);if(c.a)return c;d=sb();c.a=d;d.src=a;d.listener=c;if(a.addEventListener)Za||(e=h),void 0===e&&(e=!1),a.addEventListener(b.toString(),d,e);else if(a.attachEvent)a.attachEvent(tb(b.toString()),d);else if(a.addListener&&a.removeListener)a.addListener(d);else throw Error("addEventListener and attachEvent are unavailable.");mb++;return c}
	function sb(){var a=ub,b=Xa?function(c){return a.call(b.src,b.listener,c)}:function(c){c=a.call(b.src,b.listener,c);if(!c)return c};return b}function ob(a,b,c,d,e){if(n(b)){for(var f=0;f<b.length;f++)ob(a,b[f],c,d,e);return null}c=pb(c);return cb(a)?a.Ha(b,c,p(d)?!!d.capture:!!d,e):qb(a,b,c,!0,d,e)}function vb(a,b,c,d,e){if(n(b))for(var f=0;f<b.length;f++)vb(a,b[f],c,d,e);else d=p(d)?!!d.capture:!!d,c=pb(c),cb(a)?a.va(b,c,d,e):a&&(a=rb(a))&&(b=jb(a,b,c,d,e))&&wb(b)}
	function wb(a){if("number"!=typeof a&&a&&!a.Y){var b=a.src;if(cb(b))ib(b.c,a);else{var c=a.type,d=a.a;b.removeEventListener?b.removeEventListener(c,d,a.capture):b.detachEvent?b.detachEvent(tb(c),d):b.addListener&&b.removeListener&&b.removeListener(d);mb--;(c=rb(b))?(ib(c,a),0==c.b&&(c.src=null,b[kb]=null)):fb(a)}}}function tb(a){return a in lb?lb[a]:lb[a]="on"+a}
	function xb(a,b,c,d){var e=!0;if(a=rb(a))if(b=a.a[b.toString()])for(b=b.concat(),a=0;a<b.length;a++){var f=b[a];f&&f.capture==c&&!f.Y&&(f=yb(f,d),e=e&&!1!==f)}return e}function yb(a,b){var c=a.listener,d=a.ga||a.src;a.ca&&wb(a);return c.call(d,b)}
	function ub(a,b){if(a.Y)return!0;if(!Xa){if(!b)a:{b=["window","event"];for(var c=k,d=0;d<b.length;d++)if(c=c[b[d]],null==c){b=null;break a}b=c}d=b;b=new $a(d,this);c=!0;if(!(0>d.keyCode||void 0!=d.returnValue)){a:{var e=!1;if(0==d.keyCode)try{d.keyCode=-1;break a}catch(h){e=!0}if(e||void 0==d.returnValue)d.returnValue=!0}d=[];for(e=b.a;e;e=e.parentNode)d.push(e);a=a.type;for(e=d.length-1;0<=e;e--){b.a=d[e];var f=xb(d[e],a,!0,b);c=c&&f}for(e=0;e<d.length;e++)b.a=d[e],f=xb(d[e],a,!1,b),c=c&&f}return c}return yb(a,
	new $a(b,this))}function rb(a){a=a[kb];return a instanceof gb?a:null}var zb="__closure_events_fn_"+(1E9*Math.random()>>>0);function pb(a){if(da(a))return a;a[zb]||(a[zb]=function(b){return a.handleEvent(b)});return a[zb]};function B(){w.call(this);this.c=new gb(this);this.P=this;this.K=null}u(B,w);B.prototype[bb]=!0;g=B.prototype;g.addEventListener=function(a,b,c,d){nb(this,a,b,c,d)};g.removeEventListener=function(a,b,c,d){vb(this,a,b,c,d)};
	g.dispatchEvent=function(a){var b,c=this.K;if(c)for(b=[];c;c=c.K)b.push(c);c=this.P;var d=a.type||a;if(l(a))a=new A(a,c);else if(a instanceof A)a.target=a.target||c;else{var e=a;a=new A(d,c);Ga(a,e)}e=!0;if(b)for(var f=b.length-1;0<=f;f--){var h=a.a=b[f];e=Ab(h,d,!0,a)&&e}h=a.a=c;e=Ab(h,d,!0,a)&&e;e=Ab(h,d,!1,a)&&e;if(b)for(f=0;f<b.length;f++)h=a.a=b[f],e=Ab(h,d,!1,a)&&e;return e};
	g.A=function(){B.H.A.call(this);if(this.c){var a=this.c,b=0,c;for(c in a.a){for(var d=a.a[c],e=0;e<d.length;e++)++b,fb(d[e]);delete a.a[c];a.b--}}this.K=null};g.aa=function(a,b,c,d){return this.c.add(String(a),b,!1,c,d)};g.Ha=function(a,b,c,d){return this.c.add(String(a),b,!0,c,d)};g.va=function(a,b,c,d){var e=this.c;a=String(a).toString();if(a in e.a){var f=e.a[a];b=hb(f,b,c,d);-1<b&&(fb(f[b]),Array.prototype.splice.call(f,b,1),0==f.length&&(delete e.a[a],e.b--))}};
	function Ab(a,b,c,d){b=a.c.a[String(b)];if(!b)return!0;b=b.concat();for(var e=!0,f=0;f<b.length;++f){var h=b[f];if(h&&!h.Y&&h.capture==c){var m=h.listener,v=h.ga||h.src;h.ca&&ib(a.c,h);e=!1!==m.call(v,d)&&e}}return e&&0!=d.Pa};function Bb(a){return/^\s*$/.test(a)?!1:/^[\],:{}\s\u2028\u2029]*$/.test(a.replace(/\\["\\\/bfnrtu]/g,"@").replace(/(?:"[^"\\\n\r\u2028\u2029\x00-\x08\x0a-\x1f]*"|true|false|null|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?)[\s\u2028\u2029]*(?=:|,|]|}|$)/g,"]").replace(/(?:^|:|,)(?:[\s\u2028\u2029]*\[)+/g,""))}function Cb(a){a=String(a);if(Bb(a))try{return eval("("+a+")")}catch(b){}throw Error("Invalid JSON string: "+a);}function Db(a){var b=[];Eb(new Fb,a,b);return b.join("")}function Fb(){}
	function Eb(a,b,c){if(null==b)c.push("null");else{if("object"==typeof b){if(n(b)){var d=b;b=d.length;c.push("[");for(var e="",f=0;f<b;f++)c.push(e),Eb(a,d[f],c),e=",";c.push("]");return}if(b instanceof String||b instanceof Number||b instanceof Boolean)b=b.valueOf();else{c.push("{");e="";for(d in b)Object.prototype.hasOwnProperty.call(b,d)&&(f=b[d],"function"!=typeof f&&(c.push(e),Gb(d,c),c.push(":"),Eb(a,f,c),e=","));c.push("}");return}}switch(typeof b){case "string":Gb(b,c);break;case "number":c.push(isFinite(b)&&
	!isNaN(b)?String(b):"null");break;case "boolean":c.push(String(b));break;case "function":c.push("null");break;default:throw Error("Unknown type: "+typeof b);}}}var Hb={'"':'\\"',"\\":"\\\\","/":"\\/","\b":"\\b","\f":"\\f","\n":"\\n","\r":"\\r","\t":"\\t","\x0B":"\\u000b"},Ib=/\uffff/.test("\uffff")?/[\\"\x00-\x1f\x7f-\uffff]/g:/[\\"\x00-\x1f\x7f-\xff]/g;
	function Gb(a,b){b.push('"',a.replace(Ib,function(a){var b=Hb[a];b||(b="\\u"+(a.charCodeAt(0)|65536).toString(16).substr(1),Hb[a]=b);return b}),'"')};function Jb(a,b){this.c=a;this.f=b;this.b=0;this.a=null}Jb.prototype.get=function(){if(0<this.b){this.b--;var a=this.a;this.a=a.next;a.next=null}else a=this.c();return a};function Kb(){this.b=this.a=null}var Nb=new Jb(function(){return new Lb},function(a){a.reset()});Kb.prototype.add=function(a,b){var c=Nb.get();c.set(a,b);this.b?this.b.next=c:this.a=c;this.b=c};function Ob(){var a=Pb,b=null;a.a&&(b=a.a,a.a=a.a.next,a.a||(a.b=null),b.next=null);return b}function Lb(){this.next=this.b=this.a=null}Lb.prototype.set=function(a,b){this.a=a;this.b=b;this.next=null};Lb.prototype.reset=function(){this.next=this.b=this.a=null};function Qb(a){k.setTimeout(function(){throw a;},0)}var Rb;
	function Sb(){var a=k.MessageChannel;"undefined"===typeof a&&"undefined"!==typeof window&&window.postMessage&&window.addEventListener&&!y("Presto")&&(a=function(){var a=document.createElement("IFRAME");a.style.display="none";a.src="";document.documentElement.appendChild(a);var b=a.contentWindow;a=b.document;a.open();a.write("");a.close();var c="callImmediate"+Math.random(),d="file:"==b.location.protocol?"*":b.location.protocol+"//"+b.location.host;a=r(function(a){if(("*"==d||a.origin==d)&&a.data==
	c)this.port1.onmessage()},this);b.addEventListener("message",a,!1);this.port1={};this.port2={postMessage:function(){b.postMessage(c,d)}}});if("undefined"!==typeof a&&!y("Trident")&&!y("MSIE")){var b=new a,c={},d=c;b.port1.onmessage=function(){if(void 0!==c.next){c=c.next;var a=c.za;c.za=null;a()}};return function(a){d.next={za:a};d=d.next;b.port2.postMessage(0)}}return"undefined"!==typeof document&&"onreadystatechange"in document.createElement("SCRIPT")?function(a){var b=document.createElement("SCRIPT");
	b.onreadystatechange=function(){b.onreadystatechange=null;b.parentNode.removeChild(b);b=null;a();a=null};document.documentElement.appendChild(b)}:function(a){k.setTimeout(a,0)}};var Tb;function Ub(){if(-1!=String(k.Promise).indexOf("[native code]")){var a=k.Promise.resolve(void 0);Tb=function(){a.then(Vb)}}else Tb=function(){var a=Vb;!da(k.setImmediate)||k.Window&&k.Window.prototype&&!y("Edge")&&k.Window.prototype.setImmediate==k.setImmediate?(Rb||(Rb=Sb()),Rb(a)):k.setImmediate(a)}}var Wb=!1,Pb=new Kb;function Vb(){for(var a;a=Ob();){try{a.a.call(a.b)}catch(c){Qb(c)}var b=Nb;b.f(a);100>b.b&&(b.b++,a.next=b.a,b.a=a)}Wb=!1};function Xb(a,b){B.call(this);this.b=a||1;this.a=b||k;this.f=r(this.kb,this);this.g=t()}u(Xb,B);g=Xb.prototype;g.$=!1;g.L=null;g.kb=function(){if(this.$){var a=t()-this.g;0<a&&a<.8*this.b?this.L=this.a.setTimeout(this.f,this.b-a):(this.L&&(this.a.clearTimeout(this.L),this.L=null),this.dispatchEvent("tick"),this.$&&(this.L=this.a.setTimeout(this.f,this.b),this.g=t()))}};g.start=function(){this.$=!0;this.L||(this.L=this.a.setTimeout(this.f,this.b),this.g=t())};
	function Yb(a){a.$=!1;a.L&&(a.a.clearTimeout(a.L),a.L=null)}g.A=function(){Xb.H.A.call(this);Yb(this);delete this.a};function Zb(a,b,c){if(da(a))c&&(a=r(a,c));else if(a&&"function"==typeof a.handleEvent)a=r(a.handleEvent,a);else throw Error("Invalid listener argument");return 2147483647<Number(b)?-1:k.setTimeout(a,b||0)};function $b(a,b,c){w.call(this);this.f=null!=c?r(a,c):a;this.c=b;this.b=r(this.eb,this);this.a=[]}u($b,w);g=$b.prototype;g.ha=!1;g.X=null;g.Xa=function(a){this.a=arguments;this.X?this.ha=!0:ac(this)};g.A=function(){$b.H.A.call(this);this.X&&(k.clearTimeout(this.X),this.X=null,this.ha=!1,this.a=[])};g.eb=function(){this.X=null;this.ha&&(this.ha=!1,ac(this))};function ac(a){a.X=Zb(a.b,a.c);a.f.apply(null,a.a)};function C(a){w.call(this);this.b=a;this.a={}}u(C,w);var bc=[];C.prototype.aa=function(a,b,c,d){n(b)||(b&&(bc[0]=b.toString()),b=bc);for(var e=0;e<b.length;e++){var f=nb(a,b[e],c||this.handleEvent,d||!1,this.b||this);if(!f)break;this.a[f.key]=f}return this};
	C.prototype.va=function(a,b,c,d,e){if(n(b))for(var f=0;f<b.length;f++)this.va(a,b[f],c,d,e);else c=c||this.handleEvent,d=p(d)?!!d.capture:!!d,e=e||this.b||this,c=pb(c),d=!!d,b=cb(a)?jb(a.c,String(b),c,d,e):a?(a=rb(a))?jb(a,b,c,d,e):null:null,b&&(wb(b),delete this.a[b.key])};function cc(a){Ba(a.a,function(a,c){this.a.hasOwnProperty(c)&&wb(a)},a);a.a={}}C.prototype.A=function(){C.H.A.call(this);cc(this)};C.prototype.handleEvent=function(){throw Error("EventHandler.handleEvent not implemented");};function dc(a,b,c){this.reset(a,b,c,void 0,void 0)}dc.prototype.a=null;var ec=0;dc.prototype.reset=function(a,b,c,d,e){"number"==typeof e||ec++;d||t();delete this.a};function fc(a){this.f=a;this.b=this.c=this.a=null}function D(a,b){this.name=a;this.value=b}D.prototype.toString=function(){return this.name};var gc=new D("SEVERE",1E3),hc=new D("WARNING",900),ic=new D("INFO",800),jc=new D("CONFIG",700),kc=new D("FINE",500);function lc(a){if(a.c)return a.c;if(a.a)return lc(a.a);oa("Root logger has no level set.");return null}fc.prototype.log=function(a,b,c){if(a.value>=lc(this).value)for(da(b)&&(b=b()),a=new dc(a,String(b),this.f),c&&(a.a=c),c=this;c;)c=c.a};
	var mc={},nc=null;function oc(a){nc||(nc=new fc(""),mc[""]=nc,nc.c=jc);var b;if(!(b=mc[a])){b=new fc(a);var c=a.lastIndexOf("."),d=a.substr(c+1);c=oc(a.substr(0,c));c.b||(c.b={});c.b[d]=b;b.a=c;mc[a]=b}return b};function E(a,b){a&&a.log(hc,b,void 0)}function pc(a,b){a&&a.log(ic,b,void 0)}function F(a,b){a&&a.log(kc,b,void 0)};function qc(){this.a=oc("goog.labs.net.webChannel.WebChannelDebug");this.b=!0}qc.prototype.Ea=function(){this.b=!1};function rc(a,b,c,d,e,f){H(a,function(){if(a.b)if(f){var h="";for(var m=f.split("&"),v=0;v<m.length;v++){var G=m[v].split("=");if(1<G.length){var Z=G[0];G=G[1];var Mb=Z.split("_");h=2<=Mb.length&&"type"==Mb[1]?h+(Z+"="+G+"&"):h+(Z+"=redacted&")}}}else h=null;else h=f;return"XMLHTTP REQ ("+d+") [attempt "+e+"]: "+b+"\n"+c+"\n"+h})}
	function sc(a,b,c,d,e,f,h){H(a,function(){return"XMLHTTP RESP ("+d+") [ attempt "+e+"]: "+b+"\n"+c+"\n"+f+" "+h})}function tc(a,b,c,d){H(a,function(){return"XMLHTTP TEXT ("+b+"): "+uc(a,c)+(d?" "+d:"")})}function vc(a,b){H(a,function(){return"TIMEOUT: "+b})}function I(a,b){F(a.a,b)}function wc(a,b,c){(a=a.a)&&a.log(gc,c||"Exception",b)}function H(a,b){pc(a.a,b)}function xc(a,b){(a=a.a)&&a.log(gc,b,void 0)}
	function uc(a,b){if(!a.b)return b;if(!b)return null;try{var c=JSON.parse(b);if(c)for(var d=0;d<c.length;d++)if(n(c[d])){var e=c[d];if(!(2>e.length)){var f=e[1];if(n(f)&&!(1>f.length)){var h=f[0];if("noop"!=h&&"stop"!=h&&"close"!=h)for(var m=1;m<f.length;m++)f[m]=""}}}return Db(c)}catch(v){return I(a,"Exception parsing expected JS array - probably was not JS"),b}};var yc=new B;function zc(a){A.call(this,"serverreachability",a)}u(zc,A);function Ac(a){yc.dispatchEvent(new zc(yc,a))}function Bc(a){A.call(this,"statevent",a)}u(Bc,A);function J(a){yc.dispatchEvent(new Bc(yc,a))}function Cc(a){A.call(this,"timingevent",a)}u(Cc,A);function Dc(a,b,c){yc.dispatchEvent(new Cc(yc,a,b,c))}function Ec(a,b){if(!da(a))throw Error("Fn must not be null and must be a function");return k.setTimeout(function(){a()},b)};var Fc={NO_ERROR:0,lb:1,sb:2,rb:3,ob:4,qb:5,tb:6,Ra:7,TIMEOUT:8,wb:9};var Gc={nb:"complete",Ab:"success",Sa:"error",Ra:"abort",yb:"ready",zb:"readystatechange",TIMEOUT:"timeout",ub:"incrementaldata",xb:"progress",pb:"downloadprogress",Bb:"uploadprogress"};function Hc(){}Hc.prototype.a=null;function Ic(a){var b;(b=a.a)||(b={},Jc(a)&&(b[0]=!0,b[1]=!0),b=a.a=b);return b};var Kc;function Lc(){}u(Lc,Hc);function Mc(a){return(a=Jc(a))?new ActiveXObject(a):new XMLHttpRequest}function Jc(a){if(!a.b&&"undefined"==typeof XMLHttpRequest&&"undefined"!=typeof ActiveXObject){for(var b=["MSXML2.XMLHTTP.6.0","MSXML2.XMLHTTP.3.0","MSXML2.XMLHTTP","Microsoft.XMLHTTP"],c=0;c<b.length;c++){var d=b[c];try{return new ActiveXObject(d),a.b=d}catch(e){}}throw Error("Could not create ActiveXObject. ActiveX might be disabled, or MSXML might not be installed");}return a.b}Kc=new Lc;function K(a,b,c,d){this.i=a;this.b=b;this.f=c;this.T=d||1;this.N=new C(this);this.S=Nc;a=this.I=new Xb;a.b=Oc;a.L&&a.$?(Yb(a),a.start()):a.L&&Yb(a);this.j=null;this.c=!1;this.m=this.g=this.h=this.K=this.D=this.U=this.w=null;this.u=[];this.a=null;this.F=0;this.l=this.o=null;this.C=-1;this.B=!1;this.P=0;this.J=null;this.M=!1}var Nc=45E3,Oc=250;
	function Pc(a,b){switch(a){case 0:return"Non-200 return code ("+b+")";case 1:return"XMLHTTP failure (no data)";case 2:return"HttpConnection timeout";default:return"Unknown error"}}var Qc={},Rc={};g=K.prototype;g.setTimeout=function(a){this.S=a};function Sc(a,b,c){a.K=1;a.h=Tc(L(b));a.m=c;a.M=!0;Uc(a,null)}function Vc(a,b,c,d){a.K=1;a.h=Tc(L(b));a.m=null;a.M=c;Uc(a,d)}
	function Uc(a,b){a.D=t();Wc(a);a.g=L(a.h);Xc(a.g,"t",a.T);a.F=0;a.a=a.i.da(a.i.ia()?b:null);0<a.P&&(a.J=new $b(r(a.Qa,a,a.a),a.P));a.N.aa(a.a,"readystatechange",a.hb);b=a.j?Ea(a.j):{};a.m?(a.o||(a.o="POST"),b["Content-Type"]="application/x-www-form-urlencoded",a.a.fa(a.g,a.o,a.m,b)):(a.o="GET",a.a.fa(a.g,a.o,null,b));Ac(1);rc(a.b,a.o,a.g,a.f,a.T,a.m)}g.hb=function(a){a=a.target;var b=this.J;b&&3==M(a)?(I(this.b,"Throttling readystatechange."),b.Xa()):this.Qa(a)};
	g.Qa=function(a){try{a==this.a?Yc(this):E(this.b.a,"Called back with an unexpected xmlhttp")}catch(c){if(I(this.b,"Failed call to OnXmlHttpReadyStateChanged_"),this.a&&this.a.V()){var b=this;wc(this.b,c,function(){return"ResponseText: "+b.a.V()})}else wc(this.b,c,"No response text")}finally{}};
	function Yc(a){var b=M(a.a),c=a.a.Fa(),d=a.a.W();if(!(3>b||3==b&&!Ka&&!a.a.V())){a.B||4!=b||7==c||(8==c||0>=d?Ac(3):Ac(2));Zc(a);var e=a.a.W();a.C=e;(c=a.a.V())||I(a.b,function(){return"No response text for uri "+a.g+" status "+e});a.c=200==e;sc(a.b,a.o,a.g,a.f,a.T,b,e);a.c?(a.M?($c(a,b,c),Ka&&a.c&&3==b&&ad(a)):(tc(a.b,a.f,c,null),bd(a,c)),4==b&&cd(a),a.c&&!a.B&&(4==b?a.i.ua(a):(a.c=!1,Wc(a)))):(400==e&&0<c.indexOf("Unknown SID")?(a.l=3,J(12),E(a.b.a,"XMLHTTP Unknown SID ("+a.f+")")):(a.l=0,J(13),
	E(a.b.a,"XMLHTTP Bad status "+e+" ("+a.f+")")),cd(a),dd(a))}}function $c(a,b,c){for(var d=!0;!a.B&&a.F<c.length;){var e=ed(a,c);if(e==Rc){4==b&&(a.l=4,J(14),d=!1);tc(a.b,a.f,null,"[Incomplete Response]");break}else if(e==Qc){a.l=4;J(15);tc(a.b,a.f,c,"[Invalid Chunk]");d=!1;break}else tc(a.b,a.f,e,null),bd(a,e)}4==b&&0==c.length&&(a.l=1,J(16),d=!1);a.c=a.c&&d;d||(tc(a.b,a.f,c,"[Invalid Chunked Response]"),cd(a),dd(a))}
	g.gb=function(){var a=M(this.a),b=this.a.V();this.F<b.length&&(Zc(this),$c(this,a,b),this.c&&4!=a&&Wc(this))};function ad(a){a.N.aa(a.I,"tick",a.gb);a.I.start()}function ed(a,b){var c=a.F,d=b.indexOf("\n",c);if(-1==d)return Rc;c=Number(b.substring(c,d));if(isNaN(c))return Qc;d+=1;if(d+c>b.length)return Rc;b=b.substr(d,c);a.F=d+c;return b}g.cancel=function(){this.B=!0;cd(this)};function Wc(a){a.U=t()+a.S;fd(a,a.S)}
	function fd(a,b){if(null!=a.w)throw Error("WatchDog timer not null");a.w=Ec(r(a.fb,a),b)}function Zc(a){a.w&&(k.clearTimeout(a.w),a.w=null)}g.fb=function(){this.w=null;var a=t();0<=a-this.U?(this.c&&xc(this.b,"Received watchdog timeout even though request loaded successfully"),vc(this.b,this.g),2!=this.K&&(Ac(3),J(17)),cd(this),this.l=2,dd(this)):(E(this.b.a,"WatchDog timer called too early"),fd(this,this.U-a))};function dd(a){a.i.Ja()||a.B||a.i.ua(a)}
	function cd(a){Zc(a);var b=a.J;b&&"function"==typeof b.Z&&b.Z();a.J=null;Yb(a.I);cc(a.N);a.a&&(b=a.a,a.a=null,b.abort(),b.Z())}function bd(a,b){try{a.i.Ma(a,b),Ac(4)}catch(c){wc(a.b,c,"Error in httprequest callback")}};function gd(a){if(a.v&&"function"==typeof a.v)return a.v();if(l(a))return a.split("");if(ca(a)){for(var b=[],c=a.length,d=0;d<c;d++)b.push(a[d]);return b}return Ca(a)}
	function hd(a,b){if(a.forEach&&"function"==typeof a.forEach)a.forEach(b,void 0);else if(ca(a)||l(a))ta(a,b,void 0);else{if(a.O&&"function"==typeof a.O)var c=a.O();else if(a.v&&"function"==typeof a.v)c=void 0;else if(ca(a)||l(a)){c=[];for(var d=a.length,e=0;e<d;e++)c.push(e)}else c=Da(a);d=gd(a);e=d.length;for(var f=0;f<e;f++)b.call(void 0,d[f],c&&c[f],a)}};function N(a,b){this.b={};this.a=[];this.c=0;var c=arguments.length;if(1<c){if(c%2)throw Error("Uneven number of arguments");for(var d=0;d<c;d+=2)this.set(arguments[d],arguments[d+1])}else if(a){a instanceof N?(c=a.O(),d=a.v()):(c=Da(a),d=Ca(a));for(var e=0;e<c.length;e++)this.set(c[e],d[e])}}g=N.prototype;g.s=function(){return this.c};g.v=function(){id(this);for(var a=[],b=0;b<this.a.length;b++)a.push(this.b[this.a[b]]);return a};g.O=function(){id(this);return this.a.concat()};
	function jd(a){a.b={};a.a.length=0;a.c=0}function kd(a,b){return O(a.b,b)?(delete a.b[b],a.c--,a.a.length>2*a.c&&id(a),!0):!1}function id(a){if(a.c!=a.a.length){for(var b=0,c=0;b<a.a.length;){var d=a.a[b];O(a.b,d)&&(a.a[c++]=d);b++}a.a.length=c}if(a.c!=a.a.length){var e={};for(c=b=0;b<a.a.length;)d=a.a[b],O(e,d)||(a.a[c++]=d,e[d]=1),b++;a.a.length=c}}g.get=function(a,b){return O(this.b,a)?this.b[a]:b};g.set=function(a,b){O(this.b,a)||(this.c++,this.a.push(a));this.b[a]=b};
	g.forEach=function(a,b){for(var c=this.O(),d=0;d<c.length;d++){var e=c[d],f=this.get(e);a.call(b,f,e,this)}};function O(a,b){return Object.prototype.hasOwnProperty.call(a,b)};var ld=/^(?:([^:/?#.]+):)?(?:\/\/(?:([^/?#]*)@)?([^/#?]*?)(?::([0-9]+))?(?=[/#?]|$))?([^?#]+)?(?:\?([^#]*))?(?:#([\s\S]*))?$/;function md(a,b){if(a){a=a.split("&");for(var c=0;c<a.length;c++){var d=a[c].indexOf("="),e=null;if(0<=d){var f=a[c].substring(0,d);e=a[c].substring(d+1)}else f=a[c];b(f,e?decodeURIComponent(e.replace(/\+/g," ")):"")}}};function P(a,b){this.b=this.j=this.f="";this.i=null;this.g=this.a="";this.h=!1;var c;a instanceof P?(this.h=void 0!==b?b:a.h,nd(this,a.f),this.j=a.j,od(this,a.b),pd(this,a.i),this.a=a.a,qd(this,rd(a.c)),this.g=a.g):a&&(c=String(a).match(ld))?(this.h=!!b,nd(this,c[1]||"",!0),this.j=sd(c[2]||""),od(this,c[3]||"",!0),pd(this,c[4]),this.a=sd(c[5]||"",!0),qd(this,c[6]||"",!0),this.g=sd(c[7]||"")):(this.h=!!b,this.c=new td(null,this.h))}
	P.prototype.toString=function(){var a=[],b=this.f;b&&a.push(ud(b,vd,!0),":");var c=this.b;if(c||"file"==b)a.push("//"),(b=this.j)&&a.push(ud(b,vd,!0),"@"),a.push(encodeURIComponent(String(c)).replace(/%25([0-9a-fA-F]{2})/g,"%$1")),c=this.i,null!=c&&a.push(":",String(c));if(c=this.a)this.b&&"/"!=c.charAt(0)&&a.push("/"),a.push(ud(c,"/"==c.charAt(0)?wd:xd,!0));(c=this.c.toString())&&a.push("?",c);(c=this.g)&&a.push("#",ud(c,yd));return a.join("")};
	P.prototype.resolve=function(a){var b=L(this),c=!!a.f;c?nd(b,a.f):c=!!a.j;c?b.j=a.j:c=!!a.b;c?od(b,a.b):c=null!=a.i;var d=a.a;if(c)pd(b,a.i);else if(c=!!a.a){if("/"!=d.charAt(0))if(this.b&&!this.a)d="/"+d;else{var e=b.a.lastIndexOf("/");-1!=e&&(d=b.a.substr(0,e+1)+d)}e=d;if(".."==e||"."==e)d="";else if(-1!=e.indexOf("./")||-1!=e.indexOf("/.")){d=0==e.lastIndexOf("/",0);e=e.split("/");for(var f=[],h=0;h<e.length;){var m=e[h++];"."==m?d&&h==e.length&&f.push(""):".."==m?((1<f.length||1==f.length&&""!=
	f[0])&&f.pop(),d&&h==e.length&&f.push("")):(f.push(m),d=!0)}d=f.join("/")}else d=e}c?b.a=d:c=""!==a.c.toString();c?qd(b,rd(a.c)):c=!!a.g;c&&(b.g=a.g);return b};function L(a){return new P(a)}function nd(a,b,c){a.f=c?sd(b,!0):b;a.f&&(a.f=a.f.replace(/:$/,""))}function od(a,b,c){a.b=c?sd(b,!0):b}function pd(a,b){if(b){b=Number(b);if(isNaN(b)||0>b)throw Error("Bad port number "+b);a.i=b}else a.i=null}function qd(a,b,c){b instanceof td?(a.c=b,zd(a.c,a.h)):(c||(b=ud(b,Ad)),a.c=new td(b,a.h))}
	function Q(a,b,c){a.c.set(b,c)}function Xc(a,b,c){n(c)||(c=[String(c)]);Bd(a.c,b,c)}function Tc(a){Q(a,"zx",Math.floor(2147483648*Math.random()).toString(36)+Math.abs(Math.floor(2147483648*Math.random())^t()).toString(36));return a}function Cd(a){return a instanceof P?L(a):new P(a,void 0)}function Dd(a,b,c,d){var e=new P(null,void 0);a&&nd(e,a);b&&od(e,b);c&&pd(e,c);d&&(e.a=d);return e}function sd(a,b){return a?b?decodeURI(a.replace(/%25/g,"%2525")):decodeURIComponent(a):""}
	function ud(a,b,c){return l(a)?(a=encodeURI(a).replace(b,Ed),c&&(a=a.replace(/%25([0-9a-fA-F]{2})/g,"%$1")),a):null}function Ed(a){a=a.charCodeAt(0);return"%"+(a>>4&15).toString(16)+(a&15).toString(16)}var vd=/[#\/\?@]/g,xd=/[#\?:]/g,wd=/[#\?]/g,Ad=/[#\?@]/g,yd=/#/g;function td(a,b){this.b=this.a=null;this.c=a||null;this.f=!!b}function R(a){a.a||(a.a=new N,a.b=0,a.c&&md(a.c,function(b,c){a.add(decodeURIComponent(b.replace(/\+/g," ")),c)}))}g=td.prototype;g.s=function(){R(this);return this.b};
	g.add=function(a,b){R(this);this.c=null;a=Fd(this,a);var c=this.a.get(a);c||this.a.set(a,c=[]);c.push(b);this.b+=1;return this};function Gd(a,b){R(a);b=Fd(a,b);O(a.a.b,b)&&(a.c=null,a.b-=a.a.get(b).length,kd(a.a,b))}function Hd(a,b){R(a);b=Fd(a,b);return O(a.a.b,b)}g.forEach=function(a,b){R(this);this.a.forEach(function(c,d){ta(c,function(c){a.call(b,c,d,this)},this)},this)};
	g.O=function(){R(this);for(var a=this.a.v(),b=this.a.O(),c=[],d=0;d<b.length;d++)for(var e=a[d],f=0;f<e.length;f++)c.push(b[d]);return c};g.v=function(a){R(this);var b=[];if(l(a))Hd(this,a)&&(b=xa(b,this.a.get(Fd(this,a))));else{a=this.a.v();for(var c=0;c<a.length;c++)b=xa(b,a[c])}return b};g.set=function(a,b){R(this);this.c=null;a=Fd(this,a);Hd(this,a)&&(this.b-=this.a.get(a).length);this.a.set(a,[b]);this.b+=1;return this};g.get=function(a,b){a=a?this.v(a):[];return 0<a.length?String(a[0]):b};
	function Bd(a,b,c){Gd(a,b);0<c.length&&(a.c=null,a.a.set(Fd(a,b),ya(c)),a.b+=c.length)}g.toString=function(){if(this.c)return this.c;if(!this.a)return"";for(var a=[],b=this.a.O(),c=0;c<b.length;c++){var d=b[c],e=encodeURIComponent(String(d));d=this.v(d);for(var f=0;f<d.length;f++){var h=e;""!==d[f]&&(h+="="+encodeURIComponent(String(d[f])));a.push(h)}}return this.c=a.join("&")};function rd(a){var b=new td;b.c=a.c;a.a&&(b.a=new N(a.a),b.b=a.b);return b}
	function Fd(a,b){b=String(b);a.f&&(b=b.toLowerCase());return b}function zd(a,b){b&&!a.f&&(R(a),a.c=null,a.a.forEach(function(a,b){var c=b.toLowerCase();b!=c&&(Gd(this,b),Bd(this,c,a))},a));a.f=b};function Id(){this.a=t()}var Jd=null;Id.prototype.set=function(a){this.a=a};Id.prototype.reset=function(){this.set(t())};Id.prototype.get=function(){return this.a};function Kd(){Jd||(Jd=new Id)}function Ld(){Jd||(Jd=new Id)}u(Ld,Kd);function Md(){}var Nd={OPEN:"a",mb:"b",Sa:"c",vb:"d"};function Od(){A.call(this,"d")}u(Od,A);function Pd(){A.call(this,"c")}u(Pd,A);function Qd(a,b){this.a=a;this.b=b;this.c=this.i=null;this.h=!1;this.l=null;this.f=-1;this.m=this.g=null}g=Qd.prototype;g.R=null;
	function Rd(a){I(a.b,"TestConnection: starting stage 2");var b=a.a.I.a;if(null!=b)I(a.b,function(){return true?"Buffered":"Unbuffered"}),J(4),b?(J(10),Sd(a.a,a,!1)):(J(11),Sd(a.a,a,!0));else{a.c=new K(a,a.b,void 0,void 0);a.c.j=a.i;var c=Td(a.a,a.g,a.l);J(4);Xc(c,"TYPE","xmlhttp");var d=a.a.j,e=a.a.K;d&&e&&Q(c,d,e);Vc(a.c,c,!1,a.g)}}g.da=function(a){return this.a.da(a)};g.abort=function(){this.c&&(this.c.cancel(),this.c=null);this.f=-1};
	g.Ja=function(){return!1};
	g.Ma=function(a,b){this.f=a.C;if(0==this.R){I(this.b,"TestConnection: Got data for stage 1");if(!this.a.D&&(a=a.a)){var c=a.a?a.a.getResponseHeader("X-Client-Wire-Protocol"):null;this.m=c?c:null;this.a.j&&((a=a.a?a.a.getResponseHeader("X-HTTP-Session-Id"):null)?this.a.K=a:E(this.b.a,"Missing X_HTTP_SESSION_ID in the handshake response"))}if(b){try{var d=this.a.ma.a.parse(b)}catch(e){wc(this.b,e);Ud(this.a,this);return}this.g=d[0]}else I(this.b,"TestConnection: Null responseText"),Ud(this.a,this)}else if(1==
	this.R)if(this.h)J(6);else if("11111"==b){if(J(5),this.h=!0,!z||10<=Number(Ua))this.f=200,this.c.cancel(),I(this.b,"Test connection succeeded; using streaming connection"),J(11),Sd(this.a,this,!0)}else J(7),this.h=!1};
	g.ua=function(){this.f=this.c.C;this.c.c?0==this.R?(this.R=1,I(this.b,"TestConnection: request complete for initial check"),Rd(this)):1==this.R&&(I(this.b,"TestConnection: request complete for stage 2"),this.h?(I(this.b,"Test connection succeeded; using streaming connection"),J(11),Sd(this.a,this,!0)):(I(this.b,"Test connection failed; not using streaming"),J(10),Sd(this.a,this,!1))):(I(this.b,"TestConnection: request failed, in state "+this.R),0==this.R?J(8):1==this.R&&J(9),Ud(this.a,this))};
	g.ia=function(){return this.a.ia()};g.ra=function(){return this.a.ra()};function Vd(){this.a=this.b=null};function S(){this.a=new N}function Wd(a){var b=typeof a;return"object"==b&&a||"function"==b?"o"+(a[q]||(a[q]=++ea)):b.charAt(0)+a}S.prototype.s=function(){return this.a.s()};S.prototype.add=function(a){this.a.set(Wd(a),a)};S.prototype.contains=function(a){a=Wd(a);return O(this.a.b,a)};S.prototype.v=function(){return this.a.v()};function Xd(a,b){this.a=a;this.b=b};function Yd(a){this.g=a||Zd;this.f=k.pa&&k.pa.Ka&&k.pa.Ka()&&k.pa.Ka().Db?this.g:1;this.a=null;1<this.f&&(this.a=new S);this.b=null;this.c=[]}var Zd=10;function $d(a,b){a.a||-1==b.indexOf("spdy")&&-1==b.indexOf("quic")&&-1==b.indexOf("h2")||(a.f=a.g,a.a=new S,a.b&&(ae(a,a.b),a.b=null))}function be(a){return a.b?!0:a.a?a.a.s()>=a.f:!1}function ce(a,b){return a.b?a.b==b:a.a?a.a.contains(b):!1}function ae(a,b){a.a?a.a.add(b):a.b=b}
	function de(a,b){a.b&&a.b==b?a.b=null:a.a&&a.a.contains(b)&&kd(a.a.a,Wd(b))}Yd.prototype.cancel=function(){this.c=ee(this);this.b?(this.b.cancel(),this.b=null):this.a&&0!=this.a.a.c&&(ta(this.a.v(),function(a){a.cancel()}),jd(this.a.a))};function ee(a){if(null!=a.b)return a.c.concat(a.b.u);if(null!=a.a&&0!=a.a.a.c){var b=a.c;ta(a.a.v(),function(a){b=b.concat(a.u)});return b}return ya(a.c)}function fe(a,b){a.c=a.c.concat(b)};function ge(){}ge.prototype.stringify=function(a){return k.JSON.stringify(a,void 0)};ge.prototype.parse=function(a){return k.JSON.parse(a,void 0)};function he(){this.a=new ge}function ie(a,b,c){var d=c||"";try{hd(a,function(a,c){var e=a;p(a)&&(e=Db(a));b.push(d+c+"="+encodeURIComponent(e))})}catch(e){throw b.push(d+"type="+encodeURIComponent("_badmap")),e;}};function je(a,b){var c=new qc;I(c,"TestLoadImage: loading "+a);var d=new Image;d.onload=ia(ke,c,d,"TestLoadImage: loaded",!0,b);d.onerror=ia(ke,c,d,"TestLoadImage: error",!1,b);d.onabort=ia(ke,c,d,"TestLoadImage: abort",!1,b);d.ontimeout=ia(ke,c,d,"TestLoadImage: timeout",!1,b);k.setTimeout(function(){if(d.ontimeout)d.ontimeout()},1E4);d.src=a}function ke(a,b,c,d,e){try{I(a,c),b.onload=null,b.onerror=null,b.onabort=null,b.ontimeout=null,e(d)}catch(f){wc(a,f)}};function T(a){B.call(this);this.headers=new N;this.F=a||null;this.f=!1;this.D=this.a=null;this.M=this.u="";this.j=0;this.g="";this.h=this.J=this.o=this.I=!1;this.l=0;this.B=null;this.N=le;this.C=this.m=!1}u(T,B);var le="";T.prototype.b=oc("goog.net.XhrIo");var me=/^https?$/i,ne=["POST","PUT"];g=T.prototype;
	g.fa=function(a,b,c,d){if(this.a)throw Error("[goog.net.XhrIo] Object is active with another request="+this.u+"; newUri="+a);b=b?b.toUpperCase():"GET";this.u=a;this.g="";this.j=0;this.M=b;this.I=!1;this.f=!0;this.a=this.F?Mc(this.F):Mc(Kc);this.D=this.F?Ic(this.F):Ic(Kc);this.a.onreadystatechange=r(this.La,this);try{F(this.b,U(this,"Opening Xhr")),this.J=!0,this.a.open(b,String(a),!0),this.J=!1}catch(f){F(this.b,U(this,"Error opening Xhr: "+f.message));oe(this,f);return}a=c||"";var e=new N(this.headers);
	d&&hd(d,function(a,b){e.set(b,a)});d=ua(e.O());c=k.FormData&&a instanceof k.FormData;!(0<=sa(ne,b))||d||c||e.set("Content-Type","application/x-www-form-urlencoded;charset=utf-8");e.forEach(function(a,b){this.a.setRequestHeader(b,a)},this);this.N&&(this.a.responseType=this.N);"withCredentials"in this.a&&this.a.withCredentials!==this.m&&(this.a.withCredentials=this.m);try{pe(this),0<this.l&&(this.C=qe(this.a),F(this.b,U(this,"Will abort after "+this.l+"ms if incomplete, xhr2 "+this.C)),this.C?(this.a.timeout=
	this.l,this.a.ontimeout=r(this.Ia,this)):this.B=Zb(this.Ia,this.l,this)),F(this.b,U(this,"Sending request")),this.o=!0,this.a.send(a),this.o=!1}catch(f){F(this.b,U(this,"Send error: "+f.message)),oe(this,f)}};function qe(a){return z&&Ta(9)&&"number"==typeof a.timeout&&void 0!==a.ontimeout}function va(a){return"content-type"==a.toLowerCase()}
	g.Ia=function(){"undefined"!=typeof goog&&this.a&&(this.g="Timed out after "+this.l+"ms, aborting",this.j=8,F(this.b,U(this,this.g)),this.dispatchEvent("timeout"),this.abort(8))};function oe(a,b){a.f=!1;a.a&&(a.h=!0,a.a.abort(),a.h=!1);a.g=b;a.j=5;re(a);se(a)}function re(a){a.I||(a.I=!0,a.dispatchEvent("complete"),a.dispatchEvent("error"))}
	g.abort=function(a){this.a&&this.f&&(F(this.b,U(this,"Aborting")),this.f=!1,this.h=!0,this.a.abort(),this.h=!1,this.j=a||7,this.dispatchEvent("complete"),this.dispatchEvent("abort"),se(this))};g.A=function(){this.a&&(this.f&&(this.f=!1,this.h=!0,this.a.abort(),this.h=!1),se(this,!0));T.H.A.call(this)};g.La=function(){this.i||(this.J||this.o||this.h?te(this):this.cb())};g.cb=function(){te(this)};
	function te(a){if(a.f&&"undefined"!=typeof goog)if(a.D[1]&&4==M(a)&&2==a.W())F(a.b,U(a,"Local request error detected and ignored"));else if(a.o&&4==M(a))Zb(a.La,0,a);else if(a.dispatchEvent("readystatechange"),4==M(a)){F(a.b,U(a,"Request complete"));a.f=!1;try{var b=a.W();a:switch(b){case 200:case 201:case 202:case 204:case 206:case 304:case 1223:var c=!0;break a;default:c=!1}var d;if(!(d=c)){var e;if(e=0===b){var f=String(a.u).match(ld)[1]||null;if(!f&&k.self&&k.self.location){var h=k.self.location.protocol;
	f=h.substr(0,h.length-1)}e=!me.test(f?f.toLowerCase():"")}d=e}d?(a.dispatchEvent("complete"),a.dispatchEvent("success")):(a.j=6,a.g=a.Ga()+" ["+a.W()+"]",re(a))}finally{se(a)}}}function se(a,b){if(a.a){pe(a);var c=a.a,d=a.D[0]?aa:null;a.a=null;a.D=null;b||a.dispatchEvent("ready");try{c.onreadystatechange=d}catch(e){(a=a.b)&&a.log(gc,"Problem encountered resetting onreadystatechange: "+e.message,void 0)}}}function pe(a){a.a&&a.C&&(a.a.ontimeout=null);a.B&&(k.clearTimeout(a.B),a.B=null)}
	function M(a){return a.a?a.a.readyState:0}g.W=function(){try{return 2<M(this)?this.a.status:-1}catch(a){return-1}};g.Ga=function(){try{return 2<M(this)?this.a.statusText:""}catch(a){return F(this.b,"Can not get status: "+a.message),""}};g.V=function(){try{return this.a?this.a.responseText:""}catch(a){return F(this.b,"Can not get responseText: "+a.message),""}};
	g.Ya=function(a){if(this.a){var b=this.a.responseText;a&&0==b.indexOf(a)&&(b=b.substring(a.length));a:{a=b;if(k.JSON)try{var c=k.JSON.parse(a);break a}catch(d){}c=Cb(a)}return c}};g.Fa=function(){return this.j};g.ab=function(){return l(this.g)?this.g:String(this.g)};function U(a,b){return b+" ["+a.M+" "+a.u+" "+a.W()+"]"};function ue(a){var b="";Ba(a,function(a,d){b+=d;b+=":";b+=a;b+="\r\n"});return b}function ve(a,b,c){a:{for(d in c){var d=!1;break a}d=!0}if(d)return a;c=ue(c);if(l(a)){b=encodeURIComponent(String(b));c=null!=c?"="+encodeURIComponent(String(c)):"";if(b+=c){c=a.indexOf("#");0>c&&(c=a.length);d=a.indexOf("?");if(0>d||d>c){d=c;var e=""}else e=a.substring(d+1,c);a=[a.substr(0,d),e,a.substr(c)];c=a[1];a[1]=b?c?c+"&"+b:b:c;a=a[0]+(a[1]?"?"+a[1]:"")+a[2]}return a}Q(a,b,c);return a};function we(a){this.ya=0;this.g=[];this.a=new qc;this.I=new Vd;this.ja=this.wa=this.F=this.ka=this.b=this.K=this.j=this.U=this.h=this.M=this.i=null;this.Ua=this.P=0;this.la=this.B=this.o=this.m=this.l=this.f=null;this.u=this.xa=this.N=-1;this.T=this.w=this.C=0;this.S=a&&a.supportsCrossDomainXhr||!1;this.J="";this.c=new Yd(a&&a.concurrentRequestLimit);this.ma=new he;this.D=a&&void 0!==a.backgroundChannelTest?a.backgroundChannelTest:!0;this.Ta=a&&a.fastHandshake||!1;a&&a.Ea&&this.a.Ea()}g=we.prototype;
	g.oa=8;g.G=1;function xe(a){I(a.a,"disconnect()");ye(a);if(3==a.G){var b=a.P++,c=L(a.F);Q(c,"SID",a.J);Q(c,"RID",b);Q(c,"TYPE","terminate");ze(a,c);b=new K(a,a.a,b,void 0);b.K=2;b.h=Tc(L(c));c=!1;k.navigator&&k.navigator.sendBeacon&&(c=k.navigator.sendBeacon(b.h.toString(),""));!c&&k.Image&&((new Image).src=b.h,c=!0);c||(b.a=b.i.da(null),b.a.fa(b.h));b.D=t();Wc(b)}Ae(a)}
	function ye(a){a.B&&(a.B.abort(),a.B=null);a.b&&(a.b.cancel(),a.b=null);a.m&&(k.clearTimeout(a.m),a.m=null);Be(a);a.c.cancel();a.l&&(k.clearTimeout(a.l),a.l=null)}function Ce(a,b){1E3==a.g.length&&xc(a.a,function(){return"Already have 1000 queued maps upon queueing "+Db(b)});a.g.push(new Xd(a.Ua++,b));3==a.G&&De(a)}g.Ja=function(){return 0==this.G};function De(a){be(a.c)||a.l||(a.l=Ec(r(a.Oa,a),0),a.C=0)}
	function Ee(a,b){var c=a.c;if((c.b?1:c.a?c.a.s():0)>=a.c.f-(a.l?1:0))return xc(a.a,"Unexpected retry request is scheduled."),!1;if(a.l)return I(a.a,"Use the retry request that is already scheduled."),a.g=b.u.concat(a.g),!0;if(1==a.G||2==a.G||2<=a.C)return!1;I(a.a,"Going to retry POST");a.l=Ec(r(a.Oa,a,b),Fe(a,a.C));a.C++;return!0}
	g.Oa=function(a){this.l=null;I(this.a,"startForwardChannel_");if(1==this.G)if(a)xc(this.a,"Not supposed to retry the open");else{I(this.a,"open_()");this.P=Math.floor(1E5*Math.random());a=this.P++;var b=new K(this,this.a,a,void 0),c=this.i;this.M&&(c?(c=Ea(c),Ga(c,this.M)):c=this.M);null===this.h&&(b.j=c);var d=Ge(this,b),e=L(this.F);Q(e,"RID",a);Q(e,"CVER",21);this.D&&this.j&&Q(e,"X-HTTP-Session-Id",this.j);ze(this,e);this.h&&c&&ve(e,this.h,c);ae(this.c,b);this.Ta?(Q(e,"$req",d),Sc(b,e,null)):Sc(b,
	e,d);this.G=2}else 3==this.G&&(a?He(this,a):0==this.g.length?I(this.a,"startForwardChannel_ returned: nothing to send"):be(this.c)?xc(this.a,"startForwardChannel_ returned: connection already in progress"):(He(this),I(this.a,"startForwardChannel_ finished, sent request")))};
	function He(a,b){var c;b?c=b.f:c=a.P++;var d=L(a.F);Q(d,"SID",a.J);Q(d,"RID",c);Q(d,"AID",a.N);ze(a,d);a.h&&a.i&&ve(d,a.h,a.i);c=new K(a,a.a,c,a.C+1);null===a.h&&(c.j=a.i);b&&(a.g=b.u.concat(a.g));b=Ge(a,c);c.setTimeout(1E4+Math.round(1E4*Math.random()));ae(a.c,c);Sc(c,d,b)}function ze(a,b){a.f&&hd({},function(a,d){Q(b,d,a)})}
	function Ge(a,b){var c=Math.min(a.g.length,1E3),d=a.f?r(a.f.Va,a.f,a):null;a:for(var e=a.g,f=-1;;){var h=["count="+c];-1==f?0<c?(f=e[0].a,h.push("ofs="+f)):f=0:h.push("ofs="+f);for(var m=!0,v=0;v<c;v++){var G=e[v].a,Z=e[v].b;G-=f;if(0>G)f=Math.max(0,e[v].a-100),m=!1;else try{ie(Z,h,"req"+G+"_")}catch(Mb){d&&d(Z)}}if(m){d=h.join("&");break a}}a=a.g.splice(0,c);b.u=a;return d}function Ie(a){if(!a.b&&!a.m){a.T=1;var b=a.Na;Tb||Ub();Wb||(Tb(),Wb=!0);Pb.add(b,a);a.w=0}}
	function Je(a){if(a.b||a.m)return xc(a.a,"Request already in progress"),!1;if(3<=a.w)return!1;I(a.a,"Going to retry GET");a.T++;a.m=Ec(r(a.Na,a),Fe(a,a.w));a.w++;return!0}
	g.Na=function(){this.m=null;I(this.a,"Creating new HttpRequest");this.b=new K(this,this.a,"rpc",this.T);null===this.h&&(this.b.j=this.i);this.b.P=0;var a=L(this.wa);Q(a,"RID","rpc");Q(a,"SID",this.J);Q(a,"CI",this.la?"0":"1");Q(a,"AID",this.N);ze(this,a);Q(a,"TYPE","xmlhttp");this.h&&this.i&&ve(a,this.h,this.i);Vc(this.b,a,!0,this.ja);I(this.a,"New Request created")};
	function Sd(a,b,c){I(a.a,"Test Connection Finished");var d=b.m;d&&$d(a.c,d);a.la=c;a.u=b.f;I(a.a,"connectChannel_()");a.F=Ke(a,a.ka);De(a)}function Ud(a,b){I(a.a,"Test Connection Failed");a.u=b.f;V(a,2)}
	g.Ma=function(a,b){if(0!=this.G&&(this.b==a||ce(this.c,a)))if(this.u=a.C,ce(this.c,a)&&3==this.G){try{var c=this.ma.a.parse(b)}catch(f){c=null}if(n(c)&&3==c.length)if(b=c,0==b[0])a:if(I(this.a,"Server claims our backchannel is missing."),this.m)I(this.a,"But we are currently starting the request.");else{if(this.b)if(this.b.D+3E3<a.D)Be(this),this.b.cancel(),this.b=null;else break a;else E(this.a.a,"We do not have a BackChannel established");Je(this);J(18)}else this.xa=b[1],a=this.xa-this.N,0<a&&(b=
	b[2],I(this.a,b+" bytes (in "+a+" arrays) are outstanding on the BackChannel"),37500>b&&this.la&&0==this.w&&!this.o&&(this.o=Ec(r(this.bb,this),6E3)));else I(this.a,"Bad POST response data returned"),V(this,11)}else if(this.b==a&&Be(this),!/^[\s\xa0]*$/.test(b))for(b=c=this.ma.a.parse(b),c=0;c<b.length;c++){var d=b[c];this.N=d[0];d=d[1];if(2==this.G)if("c"==d[0]){this.J=d[1];this.ja=d[2];var e=d[3];null!=e&&(this.oa=e,H(this.a,"VER="+this.oa));d=d[4];null!=d&&(this.ya=d,H(this.a,"SVER="+this.ya));
	this.D&&(d=a.a)&&((e=d.a?d.a.getResponseHeader("X-Client-Wire-Protocol"):null)&&$d(this.c,e),this.j&&((d=d.a?d.a.getResponseHeader("X-HTTP-Session-Id"):null)?(this.K=d,Q(this.F,this.j,d)):E(this.a.a,"Missing X_HTTP_SESSION_ID in the handshake response")));this.G=3;this.f&&this.f.Da();this.wa=Td(this,this.ja,this.ka);Ie(this)}else"stop"!=d[0]&&"close"!=d[0]||V(this,7);else 3==this.G&&("stop"==d[0]||"close"==d[0]?"stop"==d[0]?V(this,7):xe(this):"noop"!=d[0]&&this.f&&this.f.Ca(d),this.w=0)}};
	g.bb=function(){null!=this.o&&(this.o=null,this.b.cancel(),this.b=null,Je(this),J(19))};function Be(a){null!=a.o&&(k.clearTimeout(a.o),a.o=null)}
	g.ua=function(a){I(this.a,"Request complete");var b=null;if(this.b==a){Be(this);this.b=null;var c=2}else if(ce(this.c,a))b=a.u,de(this.c,a),c=1;else return;this.u=a.C;if(0!=this.G)if(a.c)1==c?(Dc(a.m?a.m.length:0,t()-a.D,this.C),De(this)):Ie(this);else{var d=a.l;if(3==d||0==d&&0<this.u)I(this.a,"Not retrying due to error type");else{var e=this;I(this.a,function(){return"Maybe retrying, last error: "+Pc(d,e.u)});if(1==c&&Ee(this,a)||2==c&&Je(this))return;I(this.a,"Exceeded max number of retries")}b&&
	0<b.length&&fe(this.c,b);I(this.a,"Error: HTTP request failed");switch(d){case 1:V(this,5);break;case 4:V(this,10);break;case 3:V(this,6);break;default:V(this,2)}}};function Fe(a,b){var c=5E3+Math.floor(1E4*Math.random());a.ra()||(I(a.a,"Inactive channel"),c*=2);return c*b}
	function V(a,b){H(a.a,"Error code "+b);if(2==b){var c=null;a.f&&(c=null);var d=r(a.jb,a);c||(c=new P("//www.google.com/images/cleardot.gif"),k.location&&"http"==k.location.protocol||nd(c,"https"),Tc(c));je(c.toString(),d)}else J(2);I(a.a,"HttpChannel: error - "+b);a.G=0;a.f&&a.f.Ba(b);Ae(a);ye(a)}g.jb=function(a){a?(H(this.a,"Successfully pinged google.com"),J(2)):(H(this.a,"Failed to ping google.com"),J(1))};
	function Ae(a){a.G=0;a.u=-1;if(a.f){var b=ee(a.c);if(0!=b.length||0!=a.g.length)I(a.a,function(){return"Number of undelivered maps, pending: "+b.length+", outgoing: "+a.g.length}),a.c.c.length=0,ya(a.g),a.g.length=0;a.f.Aa()}}function Ke(a,b){b=Le(a,null,b);I(a.a,"GetForwardChannelUri: "+b);return b}function Td(a,b,c){b=Le(a,a.ia()?b:null,c);I(a.a,"GetBackChannelUri: "+b);return b}
	function Le(a,b,c){var d=Cd(c);if(""!=d.b)b&&od(d,b+"."+d.b),pd(d,d.i);else{var e=k.location,f;b?f=b+"."+e.hostname:f=e.hostname;d=Dd(e.protocol,f,e.port,c)}a.U&&Ba(a.U,function(a,b){Q(d,b,a)});b=a.j;c=a.K;b&&c&&Q(d,b,c);Q(d,"VER",a.oa);ze(a,d);return d}g.da=function(a){if(a&&!this.S)throw Error("Can't create secondary domain capable XhrIo object.");a=new T;a.m=this.S;return a};g.ra=function(){return!!this.f&&!0};g.ia=function(){return this.S};new Ld;function Me(){}g=Me.prototype;g.Da=function(){};
	g.Ca=function(){};g.Ba=function(){};g.Aa=function(){};g.Va=function(){};function Ne(a){for(var b=arguments[0],c=1;c<arguments.length;c++){var d=arguments[c];if(0==d.lastIndexOf("/",0))b=d;else{var e;(e=""==b)||(e=b.length-1,e=0<=e&&b.indexOf("/",e)==e);e?b+=d:b+="/"+d}}return b};function Oe(){if(z&&!(10<=Number(Ua)))throw Error("Environmental error: no available transport.");}Oe.prototype.a=function(a,b){return new W(a,b)};
	function W(a,b){B.call(this);this.a=new we(b);this.b=a;this.m=b&&b.testUrl?b.testUrl:Ne(this.b,"test");this.f=oc("goog.labs.net.webChannel.WebChannelBaseTransport");this.g=b&&b.messageUrlParams||null;a=b&&b.messageHeaders||null;b&&b.clientProtocolHeaderRequired&&(a?a["X-Client-Protocol"]="webchannel":a={"X-Client-Protocol":"webchannel"});this.a.i=a;a=b&&b.initMessageHeaders||null;b&&b.messageContentType&&(a?a["X-WebChannel-Content-Type"]=b.messageContentType:a={"X-WebChannel-Content-Type":b.messageContentType});
	this.a.M=a;(a=b&&b.httpHeadersOverwriteParam)&&!/^[\s\xa0]*$/.test(a)&&(this.a.h=a);this.l=b&&b.supportsCrossDomainXhr||!1;this.j=b&&b.sendRawJson||!1;(b=b&&b.httpSessionIdParam)&&!/^[\s\xa0]*$/.test(b)&&(this.a.j=b,a=this.g,null!==a&&b in a&&(a=this.g,b in a&&delete a[b],E(this.f,"Ignore httpSessionIdParam also specified with messageUrlParams: "+b)));this.h=new Pe(this)}u(W,B);g=W.prototype;g.addEventListener=function(a,b,c,d){W.H.addEventListener.call(this,a,b,c,d)};
	g.removeEventListener=function(a,b,c,d){W.H.removeEventListener.call(this,a,b,c,d)};
	g.Za=function(){this.a.f=this.h;this.l&&(this.a.S=!0);var a=this.a,b=this.m,c=this.b,d=this.g||void 0;I(a.a,"connect()");J(0);a.ka=c;a.U=d||{};a.D&&(I(a.a,"connect() bypassed channel-test."),a.I.b=[],a.I.a=!1);I(a.a,"connectTest_()");a.B=new Qd(a,a.a);null===a.h&&(a.B.i=a.i);c=b;a.h&&a.i&&(c=ve(b,a.h,a.i));a=a.B;a.l=c;b=Ke(a.a,a.l);J(3);c=a.a.I.b;null!=c?(a.g=c[0],a.R=1,Rd(a)):(Xc(b,"MODE","init"),!a.a.D&&a.a.j&&Xc(b,"X-HTTP-Session-Id",a.a.j),a.c=new K(a,a.b,void 0,void 0),a.c.j=a.i,Vc(a.c,b,!1,
	null),a.R=0)};g.close=function(){xe(this.a)};g.$a=function(a){if(l(a)){var b={};b.__data__=a;Ce(this.a,b)}else this.j?(b={},b.__data__=Db(a),Ce(this.a,b)):Ce(this.a,a)};g.A=function(){this.a.f=null;delete this.h;xe(this.a);delete this.a;W.H.A.call(this)};function Qe(a){Od.call(this);var b=a.__sm__;if(b){a:{for(var c in b){a=c;break a}a=void 0}(this.c=a)?(a=this.c,this.data=null!==b&&a in b?b[a]:void 0):this.data=b}else this.data=a}u(Qe,Od);function Re(){Pd.call(this);this.status=1}u(Re,Pd);
	function Pe(a){this.a=a}u(Pe,Me);Pe.prototype.Da=function(){pc(this.a.f,"WebChannel opened on "+this.a.b);this.a.dispatchEvent("a")};Pe.prototype.Ca=function(a){this.a.dispatchEvent(new Qe(a))};Pe.prototype.Ba=function(a){pc(this.a.f,"WebChannel aborted on "+this.a.b+" due to channel error: "+a);this.a.dispatchEvent(new Re(a))};Pe.prototype.Aa=function(){pc(this.a.f,"WebChannel closed on "+this.a.b);this.a.dispatchEvent("b")};var Se=ia(function(a,b){function c(){}c.prototype=a.prototype;var d=new c;a.apply(d,Array.prototype.slice.call(arguments,1));return d},Oe);function Te(){this.b=[];this.a=[]}function Ue(a){0==a.b.length&&(a.b=a.a,a.b.reverse(),a.a=[]);return a.b.pop()}Te.prototype.s=function(){return this.b.length+this.a.length};Te.prototype.contains=function(a){return 0<=sa(this.b,a)||0<=sa(this.a,a)};Te.prototype.v=function(){for(var a=[],b=this.b.length-1;0<=b;--b)a.push(this.b[b]);var c=this.a.length;for(b=0;b<c;++b)a.push(this.a[b]);return a};function Ve(a,b){w.call(this);this.h=a||0;this.c=b||10;if(this.h>this.c)throw Error(We);this.a=new Te;this.b=new S;this.g=null;this.ba()}u(Ve,w);var We="[goog.structs.Pool] Min can not be greater than max";g=Ve.prototype;g.ea=function(){var a=t();if(!(null!=this.g&&0>a-this.g)){for(var b;0<this.a.s()&&(b=Ue(this.a),!this.ta(b));)this.ba();!b&&this.s()<this.c&&(b=this.qa());b&&(this.g=a,this.b.add(b));return b}};g.ib=function(a){return kd(this.b.a,Wd(a))?(this.na(a),!0):!1};
	g.na=function(a){kd(this.b.a,Wd(a));this.ta(a)&&this.s()<this.c?this.a.a.push(a):Xe(a)};g.ba=function(){for(var a=this.a;this.s()<this.h;){var b=this.qa();a.a.push(b)}for(;this.s()>this.c&&0<this.a.s();)Xe(Ue(a))};g.qa=function(){return{}};function Xe(a){if("function"==typeof a.Z)a.Z();else for(var b in a)a[b]=null}g.ta=function(a){return"function"==typeof a.Wa?a.Wa():!0};g.contains=function(a){return this.a.contains(a)||this.b.contains(a)};g.s=function(){return this.a.s()+this.b.s()};
	g.A=function(){Ve.H.A.call(this);if(0<this.b.s())throw Error("[goog.structs.Pool] Objects not released");delete this.b;for(var a=this.a;0!=a.b.length||0!=a.a.length;)Xe(Ue(a));delete this.a};function Ye(a,b){this.a=a;this.b=b};function Ze(a){this.a=[];if(a)a:{if(a instanceof Ze){var b=a.O();a=a.v();if(0>=this.s()){for(var c=this.a,d=0;d<b.length;d++)c.push(new Ye(b[d],a[d]));break a}}else b=Da(a),a=Ca(a);for(d=0;d<b.length;d++)$e(this,b[d],a[d])}}function $e(a,b,c){var d=a.a;d.push(new Ye(b,c));b=d.length-1;a=a.a;for(c=a[b];0<b;)if(d=b-1>>1,a[d].a>c.a)a[b]=a[d],b=d;else break;a[b]=c}Ze.prototype.v=function(){for(var a=this.a,b=[],c=a.length,d=0;d<c;d++)b.push(a[d].b);return b};
	Ze.prototype.O=function(){for(var a=this.a,b=[],c=a.length,d=0;d<c;d++)b.push(a[d].a);return b};Ze.prototype.s=function(){return this.a.length};function af(){Ze.call(this)}u(af,Ze);function X(a,b){this.f=new af;Ve.call(this,a,b)}u(X,Ve);g=X.prototype;g.ea=function(a,b){if(!a)return X.H.ea.call(this);$e(this.f,void 0!==b?b:100,a);this.sa()};g.sa=function(){for(var a=this.f;0<a.s();){var b=this.ea();if(b){var c=a,d=c.a,e=d.length;var f=d[0];if(0>=e)f=void 0;else{if(1==e)wa(d);else{d[0]=d.pop();d=0;c=c.a;e=c.length;for(var h=c[d];d<e>>1;){var m=2*d+1,v=2*d+2;m=v<e&&c[v].a<c[m].a?v:m;if(c[m].a>h.a)break;c[d]=c[m];d=m}c[d]=h}f=f.b}f.apply(this,[b])}else break}};
	g.na=function(a){X.H.na.call(this,a);this.sa()};g.ba=function(){X.H.ba.call(this);this.sa()};g.A=function(){X.H.A.call(this);k.clearTimeout(void 0);wa(this.f.a);this.f=null};function Y(a,b,c,d){this.l=a;this.j=!!d;X.call(this,b,c)}u(Y,X);Y.prototype.qa=function(){var a=new T,b=this.l;b&&b.forEach(function(b,d){a.headers.set(d,b)});this.j&&(a.m=!0);return a};Y.prototype.ta=function(a){return!a.i&&!a.a};Oe.prototype.createWebChannel=Oe.prototype.a;W.prototype.send=W.prototype.$a;W.prototype.open=W.prototype.Za;W.prototype.close=W.prototype.close;Fc.NO_ERROR=0;Fc.TIMEOUT=8;Fc.HTTP_ERROR=6;Gc.COMPLETE="complete";Md.EventType=Nd;Nd.OPEN="a";Nd.CLOSE="b";Nd.ERROR="c";Nd.MESSAGE="d";B.prototype.listen=B.prototype.aa;Y.prototype.getObject=Y.prototype.ea;Y.prototype.releaseObject=Y.prototype.ib;T.prototype.listenOnce=T.prototype.Ha;T.prototype.getLastError=T.prototype.ab;T.prototype.getLastErrorCode=T.prototype.Fa;
	T.prototype.getStatus=T.prototype.W;T.prototype.getStatusText=T.prototype.Ga;T.prototype.getResponseJson=T.prototype.Ya;T.prototype.getResponseText=T.prototype.V;T.prototype.getResponseText=T.prototype.V;T.prototype.send=T.prototype.fa;module.exports={createWebChannelTransport:Se,ErrorCode:Fc,EventType:Gc,WebChannel:Md,XhrIoPool:Y};}).call(typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : typeof window !== 'undefined' ? window : {})
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(334);

/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(23);
	var bind = __webpack_require__(182);
	var Axios = __webpack_require__(336);
	var defaults = __webpack_require__(111);
	
	/**
	 * Create an instance of Axios
	 *
	 * @param {Object} defaultConfig The default config for the instance
	 * @return {Axios} A new instance of Axios
	 */
	function createInstance(defaultConfig) {
	  var context = new Axios(defaultConfig);
	  var instance = bind(Axios.prototype.request, context);
	
	  // Copy axios.prototype to instance
	  utils.extend(instance, Axios.prototype, context);
	
	  // Copy context to instance
	  utils.extend(instance, context);
	
	  return instance;
	}
	
	// Create the default instance to be exported
	var axios = createInstance(defaults);
	
	// Expose Axios class to allow class inheritance
	axios.Axios = Axios;
	
	// Factory for creating new instances
	axios.create = function create(instanceConfig) {
	  return createInstance(utils.merge(defaults, instanceConfig));
	};
	
	// Expose Cancel & CancelToken
	axios.Cancel = __webpack_require__(179);
	axios.CancelToken = __webpack_require__(335);
	axios.isCancel = __webpack_require__(180);
	
	// Expose all/spread
	axios.all = function all(promises) {
	  return Promise.all(promises);
	};
	axios.spread = __webpack_require__(350);
	
	module.exports = axios;
	
	// Allow use of default import syntax in TypeScript
	module.exports.default = axios;


/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var Cancel = __webpack_require__(179);
	
	/**
	 * A `CancelToken` is an object that can be used to request cancellation of an operation.
	 *
	 * @class
	 * @param {Function} executor The executor function.
	 */
	function CancelToken(executor) {
	  if (typeof executor !== 'function') {
	    throw new TypeError('executor must be a function.');
	  }
	
	  var resolvePromise;
	  this.promise = new Promise(function promiseExecutor(resolve) {
	    resolvePromise = resolve;
	  });
	
	  var token = this;
	  executor(function cancel(message) {
	    if (token.reason) {
	      // Cancellation has already been requested
	      return;
	    }
	
	    token.reason = new Cancel(message);
	    resolvePromise(token.reason);
	  });
	}
	
	/**
	 * Throws a `Cancel` if cancellation has been requested.
	 */
	CancelToken.prototype.throwIfRequested = function throwIfRequested() {
	  if (this.reason) {
	    throw this.reason;
	  }
	};
	
	/**
	 * Returns an object that contains a new `CancelToken` and a function that, when called,
	 * cancels the `CancelToken`.
	 */
	CancelToken.source = function source() {
	  var cancel;
	  var token = new CancelToken(function executor(c) {
	    cancel = c;
	  });
	  return {
	    token: token,
	    cancel: cancel
	  };
	};
	
	module.exports = CancelToken;


/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var defaults = __webpack_require__(111);
	var utils = __webpack_require__(23);
	var InterceptorManager = __webpack_require__(337);
	var dispatchRequest = __webpack_require__(338);
	
	/**
	 * Create a new instance of Axios
	 *
	 * @param {Object} instanceConfig The default config for the instance
	 */
	function Axios(instanceConfig) {
	  this.defaults = instanceConfig;
	  this.interceptors = {
	    request: new InterceptorManager(),
	    response: new InterceptorManager()
	  };
	}
	
	/**
	 * Dispatch a request
	 *
	 * @param {Object} config The config specific for this request (merged with this.defaults)
	 */
	Axios.prototype.request = function request(config) {
	  /*eslint no-param-reassign:0*/
	  // Allow for axios('example/url'[, config]) a la fetch API
	  if (typeof config === 'string') {
	    config = utils.merge({
	      url: arguments[0]
	    }, arguments[1]);
	  }
	
	  config = utils.merge(defaults, this.defaults, { method: 'get' }, config);
	  config.method = config.method.toLowerCase();
	
	  // Hook up interceptors middleware
	  var chain = [dispatchRequest, undefined];
	  var promise = Promise.resolve(config);
	
	  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
	    chain.unshift(interceptor.fulfilled, interceptor.rejected);
	  });
	
	  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
	    chain.push(interceptor.fulfilled, interceptor.rejected);
	  });
	
	  while (chain.length) {
	    promise = promise.then(chain.shift(), chain.shift());
	  }
	
	  return promise;
	};
	
	// Provide aliases for supported request methods
	utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
	  /*eslint func-names:0*/
	  Axios.prototype[method] = function(url, config) {
	    return this.request(utils.merge(config || {}, {
	      method: method,
	      url: url
	    }));
	  };
	});
	
	utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
	  /*eslint func-names:0*/
	  Axios.prototype[method] = function(url, data, config) {
	    return this.request(utils.merge(config || {}, {
	      method: method,
	      url: url,
	      data: data
	    }));
	  };
	});
	
	module.exports = Axios;


/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(23);
	
	function InterceptorManager() {
	  this.handlers = [];
	}
	
	/**
	 * Add a new interceptor to the stack
	 *
	 * @param {Function} fulfilled The function to handle `then` for a `Promise`
	 * @param {Function} rejected The function to handle `reject` for a `Promise`
	 *
	 * @return {Number} An ID used to remove interceptor later
	 */
	InterceptorManager.prototype.use = function use(fulfilled, rejected) {
	  this.handlers.push({
	    fulfilled: fulfilled,
	    rejected: rejected
	  });
	  return this.handlers.length - 1;
	};
	
	/**
	 * Remove an interceptor from the stack
	 *
	 * @param {Number} id The ID that was returned by `use`
	 */
	InterceptorManager.prototype.eject = function eject(id) {
	  if (this.handlers[id]) {
	    this.handlers[id] = null;
	  }
	};
	
	/**
	 * Iterate over all the registered interceptors
	 *
	 * This method is particularly useful for skipping over any
	 * interceptors that may have become `null` calling `eject`.
	 *
	 * @param {Function} fn The function to call for each interceptor
	 */
	InterceptorManager.prototype.forEach = function forEach(fn) {
	  utils.forEach(this.handlers, function forEachHandler(h) {
	    if (h !== null) {
	      fn(h);
	    }
	  });
	};
	
	module.exports = InterceptorManager;


/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(23);
	var transformData = __webpack_require__(341);
	var isCancel = __webpack_require__(180);
	var defaults = __webpack_require__(111);
	var isAbsoluteURL = __webpack_require__(346);
	var combineURLs = __webpack_require__(344);
	
	/**
	 * Throws a `Cancel` if cancellation has been requested.
	 */
	function throwIfCancellationRequested(config) {
	  if (config.cancelToken) {
	    config.cancelToken.throwIfRequested();
	  }
	}
	
	/**
	 * Dispatch a request to the server using the configured adapter.
	 *
	 * @param {object} config The config that is to be used for the request
	 * @returns {Promise} The Promise to be fulfilled
	 */
	module.exports = function dispatchRequest(config) {
	  throwIfCancellationRequested(config);
	
	  // Support baseURL config
	  if (config.baseURL && !isAbsoluteURL(config.url)) {
	    config.url = combineURLs(config.baseURL, config.url);
	  }
	
	  // Ensure headers exist
	  config.headers = config.headers || {};
	
	  // Transform request data
	  config.data = transformData(
	    config.data,
	    config.headers,
	    config.transformRequest
	  );
	
	  // Flatten headers
	  config.headers = utils.merge(
	    config.headers.common || {},
	    config.headers[config.method] || {},
	    config.headers || {}
	  );
	
	  utils.forEach(
	    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
	    function cleanHeaderConfig(method) {
	      delete config.headers[method];
	    }
	  );
	
	  var adapter = config.adapter || defaults.adapter;
	
	  return adapter(config).then(function onAdapterResolution(response) {
	    throwIfCancellationRequested(config);
	
	    // Transform response data
	    response.data = transformData(
	      response.data,
	      response.headers,
	      config.transformResponse
	    );
	
	    return response;
	  }, function onAdapterRejection(reason) {
	    if (!isCancel(reason)) {
	      throwIfCancellationRequested(config);
	
	      // Transform response data
	      if (reason && reason.response) {
	        reason.response.data = transformData(
	          reason.response.data,
	          reason.response.headers,
	          config.transformResponse
	        );
	      }
	    }
	
	    return Promise.reject(reason);
	  });
	};


/***/ }),
/* 339 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Update an Error with the specified config, error code, and response.
	 *
	 * @param {Error} error The error to update.
	 * @param {Object} config The config.
	 * @param {string} [code] The error code (for example, 'ECONNABORTED').
	 * @param {Object} [request] The request.
	 * @param {Object} [response] The response.
	 * @returns {Error} The error.
	 */
	module.exports = function enhanceError(error, config, code, request, response) {
	  error.config = config;
	  if (code) {
	    error.code = code;
	  }
	  error.request = request;
	  error.response = response;
	  return error;
	};


/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var createError = __webpack_require__(181);
	
	/**
	 * Resolve or reject a Promise based on response status.
	 *
	 * @param {Function} resolve A function that resolves the promise.
	 * @param {Function} reject A function that rejects the promise.
	 * @param {object} response The response.
	 */
	module.exports = function settle(resolve, reject, response) {
	  var validateStatus = response.config.validateStatus;
	  // Note: status is not exposed by XDomainRequest
	  if (!response.status || !validateStatus || validateStatus(response.status)) {
	    resolve(response);
	  } else {
	    reject(createError(
	      'Request failed with status code ' + response.status,
	      response.config,
	      null,
	      response.request,
	      response
	    ));
	  }
	};


/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(23);
	
	/**
	 * Transform the data for a request or a response
	 *
	 * @param {Object|String} data The data to be transformed
	 * @param {Array} headers The headers for the request or response
	 * @param {Array|Function} fns A single function or Array of functions
	 * @returns {*} The resulting transformed data
	 */
	module.exports = function transformData(data, headers, fns) {
	  /*eslint no-param-reassign:0*/
	  utils.forEach(fns, function transform(fn) {
	    data = fn(data, headers);
	  });
	
	  return data;
	};


/***/ }),
/* 342 */
/***/ (function(module, exports) {

	'use strict';
	
	// btoa polyfill for IE<10 courtesy https://github.com/davidchambers/Base64.js
	
	var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
	
	function E() {
	  this.message = 'String contains an invalid character';
	}
	E.prototype = new Error;
	E.prototype.code = 5;
	E.prototype.name = 'InvalidCharacterError';
	
	function btoa(input) {
	  var str = String(input);
	  var output = '';
	  for (
	    // initialize result and counter
	    var block, charCode, idx = 0, map = chars;
	    // if the next str index does not exist:
	    //   change the mapping table to "="
	    //   check if d has no fractional digits
	    str.charAt(idx | 0) || (map = '=', idx % 1);
	    // "8 - idx % 1 * 8" generates the sequence 2, 4, 6, 8
	    output += map.charAt(63 & block >> 8 - idx % 1 * 8)
	  ) {
	    charCode = str.charCodeAt(idx += 3 / 4);
	    if (charCode > 0xFF) {
	      throw new E();
	    }
	    block = block << 8 | charCode;
	  }
	  return output;
	}
	
	module.exports = btoa;


/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(23);
	
	function encode(val) {
	  return encodeURIComponent(val).
	    replace(/%40/gi, '@').
	    replace(/%3A/gi, ':').
	    replace(/%24/g, '$').
	    replace(/%2C/gi, ',').
	    replace(/%20/g, '+').
	    replace(/%5B/gi, '[').
	    replace(/%5D/gi, ']');
	}
	
	/**
	 * Build a URL by appending params to the end
	 *
	 * @param {string} url The base of the url (e.g., http://www.google.com)
	 * @param {object} [params] The params to be appended
	 * @returns {string} The formatted url
	 */
	module.exports = function buildURL(url, params, paramsSerializer) {
	  /*eslint no-param-reassign:0*/
	  if (!params) {
	    return url;
	  }
	
	  var serializedParams;
	  if (paramsSerializer) {
	    serializedParams = paramsSerializer(params);
	  } else if (utils.isURLSearchParams(params)) {
	    serializedParams = params.toString();
	  } else {
	    var parts = [];
	
	    utils.forEach(params, function serialize(val, key) {
	      if (val === null || typeof val === 'undefined') {
	        return;
	      }
	
	      if (utils.isArray(val)) {
	        key = key + '[]';
	      }
	
	      if (!utils.isArray(val)) {
	        val = [val];
	      }
	
	      utils.forEach(val, function parseValue(v) {
	        if (utils.isDate(v)) {
	          v = v.toISOString();
	        } else if (utils.isObject(v)) {
	          v = JSON.stringify(v);
	        }
	        parts.push(encode(key) + '=' + encode(v));
	      });
	    });
	
	    serializedParams = parts.join('&');
	  }
	
	  if (serializedParams) {
	    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
	  }
	
	  return url;
	};


/***/ }),
/* 344 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Creates a new URL by combining the specified URLs
	 *
	 * @param {string} baseURL The base URL
	 * @param {string} relativeURL The relative URL
	 * @returns {string} The combined URL
	 */
	module.exports = function combineURLs(baseURL, relativeURL) {
	  return relativeURL
	    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
	    : baseURL;
	};


/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(23);
	
	module.exports = (
	  utils.isStandardBrowserEnv() ?
	
	  // Standard browser envs support document.cookie
	  (function standardBrowserEnv() {
	    return {
	      write: function write(name, value, expires, path, domain, secure) {
	        var cookie = [];
	        cookie.push(name + '=' + encodeURIComponent(value));
	
	        if (utils.isNumber(expires)) {
	          cookie.push('expires=' + new Date(expires).toGMTString());
	        }
	
	        if (utils.isString(path)) {
	          cookie.push('path=' + path);
	        }
	
	        if (utils.isString(domain)) {
	          cookie.push('domain=' + domain);
	        }
	
	        if (secure === true) {
	          cookie.push('secure');
	        }
	
	        document.cookie = cookie.join('; ');
	      },
	
	      read: function read(name) {
	        var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
	        return (match ? decodeURIComponent(match[3]) : null);
	      },
	
	      remove: function remove(name) {
	        this.write(name, '', Date.now() - 86400000);
	      }
	    };
	  })() :
	
	  // Non standard browser env (web workers, react-native) lack needed support.
	  (function nonStandardBrowserEnv() {
	    return {
	      write: function write() {},
	      read: function read() { return null; },
	      remove: function remove() {}
	    };
	  })()
	);


/***/ }),
/* 346 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Determines whether the specified URL is absolute
	 *
	 * @param {string} url The URL to test
	 * @returns {boolean} True if the specified URL is absolute, otherwise false
	 */
	module.exports = function isAbsoluteURL(url) {
	  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
	  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
	  // by any combination of letters, digits, plus, period, or hyphen.
	  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
	};


/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(23);
	
	module.exports = (
	  utils.isStandardBrowserEnv() ?
	
	  // Standard browser envs have full support of the APIs needed to test
	  // whether the request URL is of the same origin as current location.
	  (function standardBrowserEnv() {
	    var msie = /(msie|trident)/i.test(navigator.userAgent);
	    var urlParsingNode = document.createElement('a');
	    var originURL;
	
	    /**
	    * Parse a URL to discover it's components
	    *
	    * @param {String} url The URL to be parsed
	    * @returns {Object}
	    */
	    function resolveURL(url) {
	      var href = url;
	
	      if (msie) {
	        // IE needs attribute set twice to normalize properties
	        urlParsingNode.setAttribute('href', href);
	        href = urlParsingNode.href;
	      }
	
	      urlParsingNode.setAttribute('href', href);
	
	      // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
	      return {
	        href: urlParsingNode.href,
	        protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
	        host: urlParsingNode.host,
	        search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
	        hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
	        hostname: urlParsingNode.hostname,
	        port: urlParsingNode.port,
	        pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
	                  urlParsingNode.pathname :
	                  '/' + urlParsingNode.pathname
	      };
	    }
	
	    originURL = resolveURL(window.location.href);
	
	    /**
	    * Determine if a URL shares the same origin as the current location
	    *
	    * @param {String} requestURL The URL to test
	    * @returns {boolean} True if URL shares the same origin, otherwise false
	    */
	    return function isURLSameOrigin(requestURL) {
	      var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
	      return (parsed.protocol === originURL.protocol &&
	            parsed.host === originURL.host);
	    };
	  })() :
	
	  // Non standard browser envs (web workers, react-native) lack needed support.
	  (function nonStandardBrowserEnv() {
	    return function isURLSameOrigin() {
	      return true;
	    };
	  })()
	);


/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(23);
	
	module.exports = function normalizeHeaderName(headers, normalizedName) {
	  utils.forEach(headers, function processHeader(value, name) {
	    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
	      headers[normalizedName] = value;
	      delete headers[name];
	    }
	  });
	};


/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(23);
	
	// Headers whose duplicates are ignored by node
	// c.f. https://nodejs.org/api/http.html#http_message_headers
	var ignoreDuplicateOf = [
	  'age', 'authorization', 'content-length', 'content-type', 'etag',
	  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
	  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
	  'referer', 'retry-after', 'user-agent'
	];
	
	/**
	 * Parse headers into an object
	 *
	 * ```
	 * Date: Wed, 27 Aug 2014 08:58:49 GMT
	 * Content-Type: application/json
	 * Connection: keep-alive
	 * Transfer-Encoding: chunked
	 * ```
	 *
	 * @param {String} headers Headers needing to be parsed
	 * @returns {Object} Headers parsed into an object
	 */
	module.exports = function parseHeaders(headers) {
	  var parsed = {};
	  var key;
	  var val;
	  var i;
	
	  if (!headers) { return parsed; }
	
	  utils.forEach(headers.split('\n'), function parser(line) {
	    i = line.indexOf(':');
	    key = utils.trim(line.substr(0, i)).toLowerCase();
	    val = utils.trim(line.substr(i + 1));
	
	    if (key) {
	      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
	        return;
	      }
	      if (key === 'set-cookie') {
	        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
	      } else {
	        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
	      }
	    }
	  });
	
	  return parsed;
	};


/***/ }),
/* 350 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Syntactic sugar for invoking a function and expanding an array for arguments.
	 *
	 * Common use case would be to use `Function.prototype.apply`.
	 *
	 *  ```js
	 *  function f(x, y, z) {}
	 *  var args = [1, 2, 3];
	 *  f.apply(null, args);
	 *  ```
	 *
	 * With `spread` this example can be re-written.
	 *
	 *  ```js
	 *  spread(function(x, y, z) {})([1, 2, 3]);
	 *  ```
	 *
	 * @param {Function} callback
	 * @returns {Function}
	 */
	module.exports = function spread(callback) {
	  return function wrap(arr) {
	    return callback.apply(null, arr);
	  };
	};


/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(64);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	__webpack_require__(494);
	
	var Calendar = function (_React$Component) {
	  _inherits(Calendar, _React$Component);
	
	  function Calendar() {
	    _classCallCheck(this, Calendar);
	
	    return _possibleConstructorReturn(this, (Calendar.__proto__ || Object.getPrototypeOf(Calendar)).apply(this, arguments));
	  }
	
	  _createClass(Calendar, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'row' },
	        _react2.default.createElement(
	          'div',
	          { className: 'calendar' },
	          _react2.default.createElement(
	            'div',
	            { title: 'Add to Calendar', className: 'addeventatc my-green darken-2 btn' },
	            'P\u0159idat do kalend\xE1\u0159e',
	            _react2.default.createElement(
	              'i',
	              { className: 'material-icons left' },
	              'event'
	            ),
	            _react2.default.createElement(
	              'span',
	              { className: 'start' },
	              '05/05/2018 01:00 PM'
	            ),
	            _react2.default.createElement(
	              'span',
	              { className: 'end' },
	              '05/06/2018 12:00 AM'
	            ),
	            _react2.default.createElement(
	              'span',
	              { className: 'timezone' },
	              'Europe/Prague'
	            ),
	            _react2.default.createElement(
	              'span',
	              { className: 'title' },
	              'Ev\u010Da a Kuba - Svatba'
	            ),
	            _react2.default.createElement(
	              'span',
	              { className: 'description' },
	              'V\xEDce na http://svatba.kinst.cz'
	            ),
	            _react2.default.createElement(
	              'span',
	              { className: 'location' },
	              'Statek Benice, Benice 1, Chr\xE1\u0161\u0165any'
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Calendar;
	}(_react2.default.Component);
	
	Calendar.defaultProps = {};
	
	exports.default = Calendar;

/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(64);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Rsvp = __webpack_require__(354);
	
	var _Rsvp2 = _interopRequireDefault(_Rsvp);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	__webpack_require__(495);
	
	
	var benicePhoto = __webpack_require__(498);
	var beniceMap = __webpack_require__(499);
	
	var Content = function (_React$Component) {
	  _inherits(Content, _React$Component);
	
	  function Content() {
	    _classCallCheck(this, Content);
	
	    return _possibleConstructorReturn(this, (Content.__proto__ || Object.getPrototypeOf(Content)).apply(this, arguments));
	  }
	
	  _createClass(Content, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'content' },
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col l12 s12' },
	            _react2.default.createElement(
	              'div',
	              { className: 'card welcome' },
	              _react2.default.createElement(
	                'div',
	                { className: 'card-content' },
	                _react2.default.createElement(
	                  'p',
	                  { className: 'center-align' },
	                  'R\xE1di bychom V\xE1s pozvali na na\u0161i svatbu, kter\xE1 se bude konat ',
	                  _react2.default.createElement(
	                    'b',
	                    null,
	                    '5. kv\u011Btna 2018 na statku v Benic\xEDch'
	                  ),
	                  '.',
	                  _react2.default.createElement('br', null),
	                  'Na t\xE9to str\xE1nce najdete v\u0161echny detaily t\xFDkaj\xEDc\xED se svatebn\xEDho dne. Budeme se na V\xE1s t\u011B\u0161it.',
	                  _react2.default.createElement('br', null),
	                  _react2.default.createElement('br', null),
	                  _react2.default.createElement(
	                    'i',
	                    null,
	                    'Ev\u010Da a Kuba'
	                  )
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col s12 l8' },
	            _react2.default.createElement(
	              'div',
	              { className: 'card' },
	              _react2.default.createElement(
	                'div',
	                { className: 'card-content' },
	                _react2.default.createElement(
	                  'span',
	                  { className: 'card-title' },
	                  'M\xEDsto kon\xE1n\xED svatby'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'row' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'col m5' },
	                    _react2.default.createElement(
	                      'p',
	                      null,
	                      _react2.default.createElement('br', null),
	                      _react2.default.createElement(
	                        'a',
	                        { href: 'https://goo.gl/maps/XDeDmmkUFL22', className: 'place-title', target: '_blank' },
	                        'Barokn\xED statek Benice'
	                      ),
	                      _react2.default.createElement('br', null),
	                      'Benice 1',
	                      _react2.default.createElement('br', null),
	                      '257 44 Chr\xE1\u0161\u0165any',
	                      _react2.default.createElement('br', null),
	                      _react2.default.createElement(
	                        'a',
	                        { href: 'https://www.favory.cz' },
	                        'www.favory.cz'
	                      )
	                    ),
	                    _react2.default.createElement('br', null),
	                    _react2.default.createElement(
	                      'b',
	                      null,
	                      'Cesta z Prahy'
	                    ),
	                    _react2.default.createElement(
	                      'p',
	                      null,
	                      'cca. 50km (45 min) - viz. mapa n\xED\u017Ee'
	                    ),
	                    _react2.default.createElement('br', null)
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'col m7' },
	                    _react2.default.createElement('img', { src: benicePhoto, alt: 'Foto Benice' })
	                  )
	                ),
	                _react2.default.createElement('br', null),
	                _react2.default.createElement('img', { src: beniceMap, alt: 'Mapa' })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'card map' },
	              _react2.default.createElement(
	                'div',
	                { className: 'card-content' },
	                _react2.default.createElement('iframe', { frameBorder: '0',
	                  src: 'https://www.google.com/maps/embed/v1/place?q=place_id:ChIJ-0uLP4OBC0cRlbImaS1I6Qk&key=AIzaSyBWSJXLHMOLjj1s3omYoe2tUx167w_j8Mc&center=49.951569,14.248960&zoom=9',
	                  allowFullScreen: true })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'card' },
	              _react2.default.createElement(
	                'div',
	                { className: 'card-content' },
	                _react2.default.createElement(
	                  'span',
	                  { className: 'card-title' },
	                  'Ubytov\xE1n\xED'
	                ),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  'V Benic\xEDch lze samoz\u0159ejm\u011B vyu\u017E\xEDt mo\u017Enosti ubytov\xE1n\xED a to za 500K\u010D za osobu. Jeliko\u017E je po\u010Det l\u016F\u017Eek omezen\xFD, jsou k dispozici tak\xE9 matrace za 200K\u010D za osobu, kter\xE9 se mohou rozm\xEDstit do jednotliv\xFDch pokoj\u016F \u010Di jsou zde v\u011Bt\u0161\xED pokoje pouze pro matrace \u2013 v\u010Detn\u011B soci\xE1ln\xEDho za\u0159\xEDzen\xED. S touto variantou a\u0165 pros\xEDm p\u0159edb\u011B\u017En\u011B po\u010D\xEDtaj\xED bezd\u011Btn\xED host\xE9 do t\u0159iceti let (bude t\u0159eba si p\u0159iv\xE9st vlastn\xED spac\xE1k).'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'card' },
	              _react2.default.createElement(
	                'div',
	                { className: 'card-content' },
	                _react2.default.createElement(
	                  'span',
	                  { className: 'card-title' },
	                  'Dal\u0161\xED informace'
	                ),
	                _react2.default.createElement(
	                  'b',
	                  null,
	                  'Svatebn\xED dary'
	                ),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  'Nejv\u011Bt\u0161\xEDm darem je pro n\xE1s Va\u0161e \xFA\u010Dast na svatb\u011B. Pokud byste n\xE1s v\u0161ak i p\u0159esto n\u011Bjak\xFDm darem cht\u011Bli poct\xEDt, ocen\xEDme jak\xFDkoliv p\u0159\xEDsp\u011Bvek na svatebn\xED cestu.'
	                ),
	                _react2.default.createElement('br', null),
	                _react2.default.createElement(
	                  'b',
	                  null,
	                  'Hudba'
	                ),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  'Jeliko\u017E si svatebn\xED Playlist sestavujeme sami, budeme moc r\xE1di, pokud n\xE1m ka\u017Ed\xFD po\u0161lete jednu a\u017E dv\u011B p\xEDsn\u011B, kter\xE9 byste ocenili a mysl\xEDte, \u017Ee by nem\u011Bly chyb\u011Bt.'
	                ),
	                _react2.default.createElement('br', null),
	                _react2.default.createElement(
	                  'b',
	                  null,
	                  'Dress code'
	                ),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  'Hodn\u011B lid\xED se n\xE1s ptalo, do jak\xE9 barvy m\xE1me svatbu lad\u011Bnou a jak\xFD je dresscode. Barvy dekorace lad\xEDme do b\xEDla se zelenou ve form\u011B r\u016Fzn\xFDch rostlin, nemysl\xEDme v\u0161ak, \u017Ee byste museli nutn\u011B v\u0161ichni ladit ke svatebn\xEDmu stolu. Z toho d\u016Fvodu \u017E\xE1dn\xFD dresscode nen\xED, sta\u010D\xED, kdy\u017E budete v\u0161ichni p\u011Bkn\xED a spokojen\xED.'
	                ),
	                _react2.default.createElement('br', null),
	                _react2.default.createElement(
	                  'b',
	                  null,
	                  'D\u011Bti'
	                ),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  'V\u0161echny d\u011Bti jsou samoz\u0159ejm\u011B v\xEDt\xE1ny jeliko\u017E jsou va\u0161\xED sou\u010D\xE1st\xED. Budeme v\u0161ak r\xE1di, pokud se b\u011Bhem ob\u0159adu o sv\xE9 potomky postar\xE1te a zajist\xEDme tak klidn\xFD pr\u016Fb\u011Bh.'
	                )
	              )
	            ),
	            _react2.default.createElement(_Rsvp2.default, null),
	            _react2.default.createElement(
	              'div',
	              { className: 'row' },
	              _react2.default.createElement(
	                'div',
	                { className: 'card' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'video-wrapper' },
	                  _react2.default.createElement('iframe', { src: 'https://www.youtube.com/embed/mx8ZU3aK7rQ?autoplay=1&showinfo=0&controls=0&loop=1&modestbranding=1&rel=0&playlist=mx8ZU3aK7rQ',
	                    frameBorder: '0', allowFullScreen: true })
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'col s12 l4' },
	            _react2.default.createElement(
	              'div',
	              { className: 'card schedule' },
	              _react2.default.createElement(
	                'div',
	                { className: 'card-content' },
	                _react2.default.createElement(
	                  'span',
	                  { className: 'card-title' },
	                  'Harmonogram dne'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  null,
	                  _react2.default.createElement(
	                    'blockquote',
	                    null,
	                    _react2.default.createElement(
	                      'h4',
	                      null,
	                      '12:00 - 13:00'
	                    ),
	                    _react2.default.createElement(
	                      'p',
	                      null,
	                      'P\u0159\xEDjezd a ubytov\xE1n\xED host\u016F'
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'blockquote',
	                    null,
	                    _react2.default.createElement(
	                      'h4',
	                      null,
	                      '14:00'
	                    ),
	                    _react2.default.createElement(
	                      'p',
	                      null,
	                      'Svatebn\xED ob\u0159ad'
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'blockquote',
	                    null,
	                    _react2.default.createElement(
	                      'h4',
	                      null,
	                      '14:30'
	                    ),
	                    _react2.default.createElement(
	                      'p',
	                      null,
	                      'Fotografov\xE1n\xED svateb\u010Dan\u016F'
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'blockquote',
	                    null,
	                    _react2.default.createElement(
	                      'h4',
	                      null,
	                      '15:00'
	                    ),
	                    _react2.default.createElement(
	                      'p',
	                      null,
	                      'Svatebn\xED p\u0159\xEDpitek a n\xE1sledn\xFD raut'
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'blockquote',
	                    null,
	                    _react2.default.createElement(
	                      'h4',
	                      null,
	                      '17:30'
	                    ),
	                    _react2.default.createElement(
	                      'p',
	                      null,
	                      'Kr\xE1jen\xED svatebn\xEDho dortu'
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'blockquote',
	                    null,
	                    _react2.default.createElement(
	                      'h4',
	                      null,
	                      '18:30'
	                    ),
	                    _react2.default.createElement(
	                      'p',
	                      null,
	                      'Ve\u010Dern\xED grilov\xE1n\xED'
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'blockquote',
	                    null,
	                    _react2.default.createElement(
	                      'h4',
	                      null,
	                      '19:30'
	                    ),
	                    _react2.default.createElement(
	                      'p',
	                      null,
	                      'Prvn\xED tanec novoman\u017Eel\u016F'
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'blockquote',
	                    null,
	                    _react2.default.createElement(
	                      'h4',
	                      null,
	                      '20:30'
	                    ),
	                    _react2.default.createElement(
	                      'p',
	                      null,
	                      'H\xE1zen\xED kytic\xED'
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'blockquote',
	                    null,
	                    _react2.default.createElement(
	                      'h4',
	                      null,
	                      '21:00'
	                    ),
	                    _react2.default.createElement(
	                      'p',
	                      null,
	                      'Ve\u010Dern\xED z\xE1bava'
	                    )
	                  )
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Content;
	}(_react2.default.Component);
	
	Content.defaultProps = {};
	
	exports.default = Content;

/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(64);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Calendar = __webpack_require__(351);
	
	var _Calendar2 = _interopRequireDefault(_Calendar);
	
	var _Content = __webpack_require__(352);
	
	var _Content2 = _interopRequireDefault(_Content);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	__webpack_require__(493);
	var firebase = __webpack_require__(194);
	
	
	var config = {
	  apiKey: "AIzaSyCG1uH3AyDRneozpEx-DWqaop26rDtEJao",
	  authDomain: "kinstovic-svatba.firebaseapp.com",
	  databaseURL: "https://kinstovic-svatba.firebaseio.com",
	  projectId: "kinstovic-svatba",
	  storageBucket: "kinstovic-svatba.appspot.com",
	  messagingSenderId: "423155957920"
	};
	if (!firebase.apps.length) firebase.initializeApp(config);
	
	var heading = __webpack_require__(404);
	
	var AppComponent = function (_React$Component) {
	  _inherits(AppComponent, _React$Component);
	
	  function AppComponent() {
	    _classCallCheck(this, AppComponent);
	
	    return _possibleConstructorReturn(this, (AppComponent.__proto__ || Object.getPrototypeOf(AppComponent)).apply(this, arguments));
	  }
	
	  _createClass(AppComponent, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'index' },
	        _react2.default.createElement(
	          'header',
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	              'h1',
	              null,
	              'Ev\u010Da a Kuba - 5. 5. 2018'
	            ),
	            _react2.default.createElement('img', { id: 'heading', src: heading, alt: 'Ev\u010Da a Kuba - 5. 5. 2018' })
	          )
	        ),
	        _react2.default.createElement(
	          'main',
	          null,
	          _react2.default.createElement(_Calendar2.default, null),
	          _react2.default.createElement(_Content2.default, null)
	        ),
	        _react2.default.createElement(
	          'footer',
	          { className: 'page-footer gold' },
	          _react2.default.createElement(
	            'div',
	            { className: 'container' },
	            _react2.default.createElement(
	              'div',
	              { className: 'row' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col l6 s12' },
	                _react2.default.createElement(
	                  'h5',
	                  { className: 'white-text' },
	                  'T\u011B\u0161\xEDme se na va\u0161i n\xE1v\u0161t\u011Bvu'
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'footer-copyright' },
	            _react2.default.createElement(
	              'div',
	              { className: 'container' },
	              '\xA9 2018 Eva Kufnerov\xE1 a Jakub Kin\u0161t',
	              _react2.default.createElement(
	                'div',
	                { className: 'right' },
	                _react2.default.createElement(
	                  'a',
	                  { className: 'grey-text text-lighten-4', href: 'mailto:jakub@kinst.cz' },
	                  'jakub@kinst.cz'
	                ),
	                '\xA0',
	                _react2.default.createElement(
	                  'span',
	                  { className: 'grey-text text-lighten-7' },
	                  '/'
	                ),
	                '\xA0',
	                _react2.default.createElement(
	                  'a',
	                  { className: 'grey-text text-lighten-4', href: 'mailto:eva@kinst.cz' },
	                  'eva@kinst.cz'
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return AppComponent;
	}(_react2.default.Component);
	
	AppComponent.defaultProps = {};
	
	exports.default = AppComponent;

/***/ }),
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(64);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _axios = __webpack_require__(333);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	__webpack_require__(496);
	
	var firebase = __webpack_require__(194);
	__webpack_require__(408);
	
	var Rsvp = function (_React$Component) {
	  _inherits(Rsvp, _React$Component);
	
	  function Rsvp(props) {
	    _classCallCheck(this, Rsvp);
	
	    var _this = _possibleConstructorReturn(this, (Rsvp.__proto__ || Object.getPrototypeOf(Rsvp)).call(this, props));
	
	    _this.state = {
	      name: '',
	      coming: true,
	      plusOne: false,
	      accomodation: false,
	      message: '',
	      sent: false
	    };
	
	    // this.handleChange = this.handleChange.bind(this);
	    _this.handleSubmit = _this.handleSubmit.bind(_this);
	    return _this;
	  }
	
	  _createClass(Rsvp, [{
	    key: 'handleSubmit',
	    value: function handleSubmit(event) {
	      var _this2 = this;
	
	      console.log('Sending RSVP: ', this.state);
	
	      this.setState({
	        sent: true
	      });
	
	      ga('send', 'event', 'RSVP', 'Přijde', this.state.coming ? 'ANO' : 'NE', {
	        'dimension1': this.state.message,
	        'dimension3': this.state.plusOne,
	        'dimension4': this.state.accomodation,
	        'dimension5': this.state.name
	      });
	      var data = {
	        name: this.state.name,
	        message: this.state.message,
	        coming: this.state.coming,
	        plusOne: this.state.plusOne,
	        accomodation: this.state.accomodation
	      };
	
	      _axios2.default.post('https://us-central1-kinstovic-svatba.cloudfunctions.net/postRsvp', data).then(function (response) {
	        console.log('Sent to API', response);
	      });
	
	      firebase.firestore().collection('rsvp').add(data).then(function () {
	        Materialize.toast('Děkujeme a těšíme se na vás!', 4000);
	      }).catch(function (error) {
	        console.error(error);
	        Materialize.toast('Chyba', 4000);
	        _this2.setState({
	          sent: false
	        });
	      });
	      event.preventDefault();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'card ' + (this.state.sent ? 'hide' : 'show') },
	        _react2.default.createElement(
	          'div',
	          { className: 'card-content' },
	          _react2.default.createElement(
	            'span',
	            { className: 'card-title' },
	            'Potvrzen\xED \xFA\u010Dasti'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'Pros\xEDme V\xE1s o v\u010Dasn\xE9 potvrzen\xED Va\u0161\xED \xFA\u010Dasti na ob\u0159adu i p\u0159\xEDpadn\xE9ho ubytov\xE1n\xED. M\u016F\u017Eete k tomu vyu\u017E\xEDt n\xE1sleduj\xEDc\xED formul\xE1\u0159, p\u0159\xEDpadn\u011B n\xE1s jakkoliv jinak kontaktovat.'
	          ),
	          _react2.default.createElement('br', null),
	          _react2.default.createElement(
	            'form',
	            { onSubmit: this.handleSubmit },
	            _react2.default.createElement(
	              'div',
	              { className: 'row' },
	              _react2.default.createElement(
	                'div',
	                { className: 'input-field col l8 s12' },
	                _react2.default.createElement('input', { id: 'last_name', type: 'text', className: 'validate', value: this.state.name,
	                  onChange: function onChange(event) {
	                    return _this3.setState({ name: event.target.value });
	                  } }),
	                _react2.default.createElement(
	                  'label',
	                  { htmlFor: 'last_name' },
	                  'Jm\xE9no a P\u0159\xEDjmen\xED'
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col l4 s12 checkboxes' },
	                _react2.default.createElement('input', { name: 'coming', type: 'radio', id: 'coming', value: 'true', checked: this.state.coming,
	                  onChange: function onChange(event) {
	                    return _this3.setState({ coming: event.target.checked });
	                  } }),
	                _react2.default.createElement(
	                  'label',
	                  { htmlFor: 'coming' },
	                  'Doraz\xEDm'
	                ),
	                _react2.default.createElement('br', null),
	                _react2.default.createElement('input', { name: 'coming', type: 'radio', id: 'notComing', value: 'false', checked: !this.state.coming,
	                  onChange: function onChange(event) {
	                    return _this3.setState({ coming: !event.target.checked });
	                  } }),
	                _react2.default.createElement(
	                  'label',
	                  { htmlFor: 'notComing' },
	                  'Nemohu dorazit'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'row' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col l6 s12' },
	                _react2.default.createElement('input', { type: 'checkbox', className: 'filled-in', id: 'plusOne', checked: this.state.plusOne,
	                  onChange: function onChange(event) {
	                    return _this3.setState({ plusOne: event.target.checked });
	                  } }),
	                _react2.default.createElement(
	                  'label',
	                  { htmlFor: 'plusOne' },
	                  'Beru s sebou partnera/partnerku'
	                ),
	                _react2.default.createElement('br', null),
	                _react2.default.createElement('input', { type: 'checkbox', className: 'filled-in', id: 'accomodation', checked: this.state.accomodation,
	                  onChange: function onChange(event) {
	                    return _this3.setState({ accomodation: event.target.checked });
	                  } }),
	                _react2.default.createElement(
	                  'label',
	                  { htmlFor: 'accomodation' },
	                  'Chci za\u0159\xEDdit ubytov\xE1n\xED'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'row' },
	              _react2.default.createElement(
	                'div',
	                { className: 'input-field col l12 s12' },
	                _react2.default.createElement('textarea', { id: 'message', className: 'materialize-textarea', value: this.state.message,
	                  onChange: function onChange(event) {
	                    return _this3.setState({ message: event.target.value });
	                  } }),
	                _react2.default.createElement(
	                  'label',
	                  { htmlFor: 'message' },
	                  'Dal\u0161\xED sd\u011Blen\xED'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'input-field' },
	              _react2.default.createElement('input', { type: 'submit', className: 'fill btn my-green darken-3', value: 'Potvrdit \xFA\u010Dast',
	                disabled: this.state.name.trim() === '' })
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Rsvp;
	}(_react2.default.Component);
	
	Rsvp.defaultProps = {};
	
	exports.default = Rsvp;

/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(379);
	module.exports = __webpack_require__(112).Object.assign;


/***/ }),
/* 356 */
/***/ (function(module, exports) {

	module.exports = function (it) {
	  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
	  return it;
	};


/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(115);
	module.exports = function (it) {
	  if (!isObject(it)) throw TypeError(it + ' is not an object!');
	  return it;
	};


/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

	// false -> Array#indexOf
	// true  -> Array#includes
	var toIObject = __webpack_require__(188);
	var toLength = __webpack_require__(376);
	var toAbsoluteIndex = __webpack_require__(375);
	module.exports = function (IS_INCLUDES) {
	  return function ($this, el, fromIndex) {
	    var O = toIObject($this);
	    var length = toLength(O.length);
	    var index = toAbsoluteIndex(fromIndex, length);
	    var value;
	    // Array#includes uses SameValueZero equality algorithm
	    // eslint-disable-next-line no-self-compare
	    if (IS_INCLUDES && el != el) while (length > index) {
	      value = O[index++];
	      // eslint-disable-next-line no-self-compare
	      if (value != value) return true;
	    // Array#indexOf ignores holes, Array#includes - not
	    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
	      if (O[index] === el) return IS_INCLUDES || index || 0;
	    } return !IS_INCLUDES && -1;
	  };
	};


/***/ }),
/* 359 */
/***/ (function(module, exports) {

	var toString = {}.toString;
	
	module.exports = function (it) {
	  return toString.call(it).slice(8, -1);
	};


/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

	// optional / simple context binding
	var aFunction = __webpack_require__(356);
	module.exports = function (fn, that, length) {
	  aFunction(fn);
	  if (that === undefined) return fn;
	  switch (length) {
	    case 1: return function (a) {
	      return fn.call(that, a);
	    };
	    case 2: return function (a, b) {
	      return fn.call(that, a, b);
	    };
	    case 3: return function (a, b, c) {
	      return fn.call(that, a, b, c);
	    };
	  }
	  return function (/* ...args */) {
	    return fn.apply(that, arguments);
	  };
	};


/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(115);
	var document = __webpack_require__(80).document;
	// typeof document.createElement is 'object' in old IE
	var is = isObject(document) && isObject(document.createElement);
	module.exports = function (it) {
	  return is ? document.createElement(it) : {};
	};


/***/ }),
/* 362 */
/***/ (function(module, exports) {

	// IE 8- don't enum bug keys
	module.exports = (
	  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
	).split(',');


/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(80);
	var core = __webpack_require__(112);
	var hide = __webpack_require__(185);
	var redefine = __webpack_require__(372);
	var ctx = __webpack_require__(360);
	var PROTOTYPE = 'prototype';
	
	var $export = function (type, name, source) {
	  var IS_FORCED = type & $export.F;
	  var IS_GLOBAL = type & $export.G;
	  var IS_STATIC = type & $export.S;
	  var IS_PROTO = type & $export.P;
	  var IS_BIND = type & $export.B;
	  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE];
	  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
	  var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
	  var key, own, out, exp;
	  if (IS_GLOBAL) source = name;
	  for (key in source) {
	    // contains in native
	    own = !IS_FORCED && target && target[key] !== undefined;
	    // export native or passed
	    out = (own ? target : source)[key];
	    // bind timers to global for call from export context
	    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
	    // extend global
	    if (target) redefine(target, key, out, type & $export.U);
	    // export
	    if (exports[key] != out) hide(exports, key, exp);
	    if (IS_PROTO && expProto[key] != out) expProto[key] = out;
	  }
	};
	global.core = core;
	// type bitmap
	$export.F = 1;   // forced
	$export.G = 2;   // global
	$export.S = 4;   // static
	$export.P = 8;   // proto
	$export.B = 16;  // bind
	$export.W = 32;  // wrap
	$export.U = 64;  // safe
	$export.R = 128; // real proto method for `library`
	module.exports = $export;


/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = !__webpack_require__(113) && !__webpack_require__(114)(function () {
	  return Object.defineProperty(__webpack_require__(361)('div'), 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 19.1.2.1 Object.assign(target, source, ...)
	var getKeys = __webpack_require__(369);
	var gOPS = __webpack_require__(367);
	var pIE = __webpack_require__(370);
	var toObject = __webpack_require__(377);
	var IObject = __webpack_require__(186);
	var $assign = Object.assign;
	
	// should work with symbols and should have deterministic property order (V8 bug)
	module.exports = !$assign || __webpack_require__(114)(function () {
	  var A = {};
	  var B = {};
	  // eslint-disable-next-line no-undef
	  var S = Symbol();
	  var K = 'abcdefghijklmnopqrst';
	  A[S] = 7;
	  K.split('').forEach(function (k) { B[k] = k; });
	  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
	}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
	  var T = toObject(target);
	  var aLen = arguments.length;
	  var index = 1;
	  var getSymbols = gOPS.f;
	  var isEnum = pIE.f;
	  while (aLen > index) {
	    var S = IObject(arguments[index++]);
	    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
	    var length = keys.length;
	    var j = 0;
	    var key;
	    while (length > j) if (isEnum.call(S, key = keys[j++])) T[key] = S[key];
	  } return T;
	} : $assign;


/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(357);
	var IE8_DOM_DEFINE = __webpack_require__(364);
	var toPrimitive = __webpack_require__(378);
	var dP = Object.defineProperty;
	
	exports.f = __webpack_require__(113) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
	  anObject(O);
	  P = toPrimitive(P, true);
	  anObject(Attributes);
	  if (IE8_DOM_DEFINE) try {
	    return dP(O, P, Attributes);
	  } catch (e) { /* empty */ }
	  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
	  if ('value' in Attributes) O[P] = Attributes.value;
	  return O;
	};


/***/ }),
/* 367 */
/***/ (function(module, exports) {

	exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

	var has = __webpack_require__(184);
	var toIObject = __webpack_require__(188);
	var arrayIndexOf = __webpack_require__(358)(false);
	var IE_PROTO = __webpack_require__(373)('IE_PROTO');
	
	module.exports = function (object, names) {
	  var O = toIObject(object);
	  var i = 0;
	  var result = [];
	  var key;
	  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
	  // Don't enum bug & hidden keys
	  while (names.length > i) if (has(O, key = names[i++])) {
	    ~arrayIndexOf(result, key) || result.push(key);
	  }
	  return result;
	};


/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.14 / 15.2.3.14 Object.keys(O)
	var $keys = __webpack_require__(368);
	var enumBugKeys = __webpack_require__(362);
	
	module.exports = Object.keys || function keys(O) {
	  return $keys(O, enumBugKeys);
	};


/***/ }),
/* 370 */
/***/ (function(module, exports) {

	exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 371 */
/***/ (function(module, exports) {

	module.exports = function (bitmap, value) {
	  return {
	    enumerable: !(bitmap & 1),
	    configurable: !(bitmap & 2),
	    writable: !(bitmap & 4),
	    value: value
	  };
	};


/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(80);
	var hide = __webpack_require__(185);
	var has = __webpack_require__(184);
	var SRC = __webpack_require__(189)('src');
	var TO_STRING = 'toString';
	var $toString = Function[TO_STRING];
	var TPL = ('' + $toString).split(TO_STRING);
	
	__webpack_require__(112).inspectSource = function (it) {
	  return $toString.call(it);
	};
	
	(module.exports = function (O, key, val, safe) {
	  var isFunction = typeof val == 'function';
	  if (isFunction) has(val, 'name') || hide(val, 'name', key);
	  if (O[key] === val) return;
	  if (isFunction) has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
	  if (O === global) {
	    O[key] = val;
	  } else if (!safe) {
	    delete O[key];
	    hide(O, key, val);
	  } else if (O[key]) {
	    O[key] = val;
	  } else {
	    hide(O, key, val);
	  }
	// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
	})(Function.prototype, TO_STRING, function toString() {
	  return typeof this == 'function' && this[SRC] || $toString.call(this);
	});


/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

	var shared = __webpack_require__(374)('keys');
	var uid = __webpack_require__(189);
	module.exports = function (key) {
	  return shared[key] || (shared[key] = uid(key));
	};


/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(80);
	var SHARED = '__core-js_shared__';
	var store = global[SHARED] || (global[SHARED] = {});
	module.exports = function (key) {
	  return store[key] || (store[key] = {});
	};


/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(187);
	var max = Math.max;
	var min = Math.min;
	module.exports = function (index, length) {
	  index = toInteger(index);
	  return index < 0 ? max(index + length, 0) : min(index, length);
	};


/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.15 ToLength
	var toInteger = __webpack_require__(187);
	var min = Math.min;
	module.exports = function (it) {
	  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
	};


/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.13 ToObject(argument)
	var defined = __webpack_require__(183);
	module.exports = function (it) {
	  return Object(defined(it));
	};


/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.1 ToPrimitive(input [, PreferredType])
	var isObject = __webpack_require__(115);
	// instead of the ES6 spec version, we didn't implement @@toPrimitive case
	// and the second argument - flag - preferred type is a string
	module.exports = function (it, S) {
	  if (!isObject(it)) return it;
	  var fn, val;
	  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  throw TypeError("Can't convert object to primitive value");
	};


/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.3.1 Object.assign(target, source)
	var $export = __webpack_require__(363);
	
	$export($export.S + $export.F, 'Object', { assign: __webpack_require__(365) });


/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(7);
	
	var emptyObject = __webpack_require__(82);
	var _invariant = __webpack_require__(3);
	
	if (false) {
	  var warning = require('fbjs/lib/warning');
	}
	
	var MIXINS_KEY = 'mixins';
	
	// Helper function to allow the creation of anonymous functions which do not
	// have .name set to the name of the variable being assigned to.
	function identity(fn) {
	  return fn;
	}
	
	var ReactPropTypeLocationNames;
	if (false) {
	  ReactPropTypeLocationNames = {
	    prop: 'prop',
	    context: 'context',
	    childContext: 'child context'
	  };
	} else {
	  ReactPropTypeLocationNames = {};
	}
	
	function factory(ReactComponent, isValidElement, ReactNoopUpdateQueue) {
	  /**
	   * Policies that describe methods in `ReactClassInterface`.
	   */
	
	  var injectedMixins = [];
	
	  /**
	   * Composite components are higher-level components that compose other composite
	   * or host components.
	   *
	   * To create a new type of `ReactClass`, pass a specification of
	   * your new class to `React.createClass`. The only requirement of your class
	   * specification is that you implement a `render` method.
	   *
	   *   var MyComponent = React.createClass({
	   *     render: function() {
	   *       return <div>Hello World</div>;
	   *     }
	   *   });
	   *
	   * The class specification supports a specific protocol of methods that have
	   * special meaning (e.g. `render`). See `ReactClassInterface` for
	   * more the comprehensive protocol. Any other properties and methods in the
	   * class specification will be available on the prototype.
	   *
	   * @interface ReactClassInterface
	   * @internal
	   */
	  var ReactClassInterface = {
	    /**
	     * An array of Mixin objects to include when defining your component.
	     *
	     * @type {array}
	     * @optional
	     */
	    mixins: 'DEFINE_MANY',
	
	    /**
	     * An object containing properties and methods that should be defined on
	     * the component's constructor instead of its prototype (static methods).
	     *
	     * @type {object}
	     * @optional
	     */
	    statics: 'DEFINE_MANY',
	
	    /**
	     * Definition of prop types for this component.
	     *
	     * @type {object}
	     * @optional
	     */
	    propTypes: 'DEFINE_MANY',
	
	    /**
	     * Definition of context types for this component.
	     *
	     * @type {object}
	     * @optional
	     */
	    contextTypes: 'DEFINE_MANY',
	
	    /**
	     * Definition of context types this component sets for its children.
	     *
	     * @type {object}
	     * @optional
	     */
	    childContextTypes: 'DEFINE_MANY',
	
	    // ==== Definition methods ====
	
	    /**
	     * Invoked when the component is mounted. Values in the mapping will be set on
	     * `this.props` if that prop is not specified (i.e. using an `in` check).
	     *
	     * This method is invoked before `getInitialState` and therefore cannot rely
	     * on `this.state` or use `this.setState`.
	     *
	     * @return {object}
	     * @optional
	     */
	    getDefaultProps: 'DEFINE_MANY_MERGED',
	
	    /**
	     * Invoked once before the component is mounted. The return value will be used
	     * as the initial value of `this.state`.
	     *
	     *   getInitialState: function() {
	     *     return {
	     *       isOn: false,
	     *       fooBaz: new BazFoo()
	     *     }
	     *   }
	     *
	     * @return {object}
	     * @optional
	     */
	    getInitialState: 'DEFINE_MANY_MERGED',
	
	    /**
	     * @return {object}
	     * @optional
	     */
	    getChildContext: 'DEFINE_MANY_MERGED',
	
	    /**
	     * Uses props from `this.props` and state from `this.state` to render the
	     * structure of the component.
	     *
	     * No guarantees are made about when or how often this method is invoked, so
	     * it must not have side effects.
	     *
	     *   render: function() {
	     *     var name = this.props.name;
	     *     return <div>Hello, {name}!</div>;
	     *   }
	     *
	     * @return {ReactComponent}
	     * @required
	     */
	    render: 'DEFINE_ONCE',
	
	    // ==== Delegate methods ====
	
	    /**
	     * Invoked when the component is initially created and about to be mounted.
	     * This may have side effects, but any external subscriptions or data created
	     * by this method must be cleaned up in `componentWillUnmount`.
	     *
	     * @optional
	     */
	    componentWillMount: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component has been mounted and has a DOM representation.
	     * However, there is no guarantee that the DOM node is in the document.
	     *
	     * Use this as an opportunity to operate on the DOM when the component has
	     * been mounted (initialized and rendered) for the first time.
	     *
	     * @param {DOMElement} rootNode DOM element representing the component.
	     * @optional
	     */
	    componentDidMount: 'DEFINE_MANY',
	
	    /**
	     * Invoked before the component receives new props.
	     *
	     * Use this as an opportunity to react to a prop transition by updating the
	     * state using `this.setState`. Current props are accessed via `this.props`.
	     *
	     *   componentWillReceiveProps: function(nextProps, nextContext) {
	     *     this.setState({
	     *       likesIncreasing: nextProps.likeCount > this.props.likeCount
	     *     });
	     *   }
	     *
	     * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
	     * transition may cause a state change, but the opposite is not true. If you
	     * need it, you are probably looking for `componentWillUpdate`.
	     *
	     * @param {object} nextProps
	     * @optional
	     */
	    componentWillReceiveProps: 'DEFINE_MANY',
	
	    /**
	     * Invoked while deciding if the component should be updated as a result of
	     * receiving new props, state and/or context.
	     *
	     * Use this as an opportunity to `return false` when you're certain that the
	     * transition to the new props/state/context will not require a component
	     * update.
	     *
	     *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
	     *     return !equal(nextProps, this.props) ||
	     *       !equal(nextState, this.state) ||
	     *       !equal(nextContext, this.context);
	     *   }
	     *
	     * @param {object} nextProps
	     * @param {?object} nextState
	     * @param {?object} nextContext
	     * @return {boolean} True if the component should update.
	     * @optional
	     */
	    shouldComponentUpdate: 'DEFINE_ONCE',
	
	    /**
	     * Invoked when the component is about to update due to a transition from
	     * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
	     * and `nextContext`.
	     *
	     * Use this as an opportunity to perform preparation before an update occurs.
	     *
	     * NOTE: You **cannot** use `this.setState()` in this method.
	     *
	     * @param {object} nextProps
	     * @param {?object} nextState
	     * @param {?object} nextContext
	     * @param {ReactReconcileTransaction} transaction
	     * @optional
	     */
	    componentWillUpdate: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component's DOM representation has been updated.
	     *
	     * Use this as an opportunity to operate on the DOM when the component has
	     * been updated.
	     *
	     * @param {object} prevProps
	     * @param {?object} prevState
	     * @param {?object} prevContext
	     * @param {DOMElement} rootNode DOM element representing the component.
	     * @optional
	     */
	    componentDidUpdate: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component is about to be removed from its parent and have
	     * its DOM representation destroyed.
	     *
	     * Use this as an opportunity to deallocate any external resources.
	     *
	     * NOTE: There is no `componentDidUnmount` since your component will have been
	     * destroyed by that point.
	     *
	     * @optional
	     */
	    componentWillUnmount: 'DEFINE_MANY',
	
	    /**
	     * Replacement for (deprecated) `componentWillMount`.
	     *
	     * @optional
	     */
	    UNSAFE_componentWillMount: 'DEFINE_MANY',
	
	    /**
	     * Replacement for (deprecated) `componentWillReceiveProps`.
	     *
	     * @optional
	     */
	    UNSAFE_componentWillReceiveProps: 'DEFINE_MANY',
	
	    /**
	     * Replacement for (deprecated) `componentWillUpdate`.
	     *
	     * @optional
	     */
	    UNSAFE_componentWillUpdate: 'DEFINE_MANY',
	
	    // ==== Advanced methods ====
	
	    /**
	     * Updates the component's currently mounted DOM representation.
	     *
	     * By default, this implements React's rendering and reconciliation algorithm.
	     * Sophisticated clients may wish to override this.
	     *
	     * @param {ReactReconcileTransaction} transaction
	     * @internal
	     * @overridable
	     */
	    updateComponent: 'OVERRIDE_BASE'
	  };
	
	  /**
	   * Similar to ReactClassInterface but for static methods.
	   */
	  var ReactClassStaticInterface = {
	    /**
	     * This method is invoked after a component is instantiated and when it
	     * receives new props. Return an object to update state in response to
	     * prop changes. Return null to indicate no change to state.
	     *
	     * If an object is returned, its keys will be merged into the existing state.
	     *
	     * @return {object || null}
	     * @optional
	     */
	    getDerivedStateFromProps: 'DEFINE_MANY_MERGED'
	  };
	
	  /**
	   * Mapping from class specification keys to special processing functions.
	   *
	   * Although these are declared like instance properties in the specification
	   * when defining classes using `React.createClass`, they are actually static
	   * and are accessible on the constructor instead of the prototype. Despite
	   * being static, they must be defined outside of the "statics" key under
	   * which all other static methods are defined.
	   */
	  var RESERVED_SPEC_KEYS = {
	    displayName: function(Constructor, displayName) {
	      Constructor.displayName = displayName;
	    },
	    mixins: function(Constructor, mixins) {
	      if (mixins) {
	        for (var i = 0; i < mixins.length; i++) {
	          mixSpecIntoComponent(Constructor, mixins[i]);
	        }
	      }
	    },
	    childContextTypes: function(Constructor, childContextTypes) {
	      if (false) {
	        validateTypeDef(Constructor, childContextTypes, 'childContext');
	      }
	      Constructor.childContextTypes = _assign(
	        {},
	        Constructor.childContextTypes,
	        childContextTypes
	      );
	    },
	    contextTypes: function(Constructor, contextTypes) {
	      if (false) {
	        validateTypeDef(Constructor, contextTypes, 'context');
	      }
	      Constructor.contextTypes = _assign(
	        {},
	        Constructor.contextTypes,
	        contextTypes
	      );
	    },
	    /**
	     * Special case getDefaultProps which should move into statics but requires
	     * automatic merging.
	     */
	    getDefaultProps: function(Constructor, getDefaultProps) {
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps = createMergedResultFunction(
	          Constructor.getDefaultProps,
	          getDefaultProps
	        );
	      } else {
	        Constructor.getDefaultProps = getDefaultProps;
	      }
	    },
	    propTypes: function(Constructor, propTypes) {
	      if (false) {
	        validateTypeDef(Constructor, propTypes, 'prop');
	      }
	      Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
	    },
	    statics: function(Constructor, statics) {
	      mixStaticSpecIntoComponent(Constructor, statics);
	    },
	    autobind: function() {}
	  };
	
	  function validateTypeDef(Constructor, typeDef, location) {
	    for (var propName in typeDef) {
	      if (typeDef.hasOwnProperty(propName)) {
	        // use a warning instead of an _invariant so components
	        // don't show up in prod but only in __DEV__
	        if (false) {
	          warning(
	            typeof typeDef[propName] === 'function',
	            '%s: %s type `%s` is invalid; it must be a function, usually from ' +
	              'React.PropTypes.',
	            Constructor.displayName || 'ReactClass',
	            ReactPropTypeLocationNames[location],
	            propName
	          );
	        }
	      }
	    }
	  }
	
	  function validateMethodOverride(isAlreadyDefined, name) {
	    var specPolicy = ReactClassInterface.hasOwnProperty(name)
	      ? ReactClassInterface[name]
	      : null;
	
	    // Disallow overriding of base class methods unless explicitly allowed.
	    if (ReactClassMixin.hasOwnProperty(name)) {
	      _invariant(
	        specPolicy === 'OVERRIDE_BASE',
	        'ReactClassInterface: You are attempting to override ' +
	          '`%s` from your class specification. Ensure that your method names ' +
	          'do not overlap with React methods.',
	        name
	      );
	    }
	
	    // Disallow defining methods more than once unless explicitly allowed.
	    if (isAlreadyDefined) {
	      _invariant(
	        specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED',
	        'ReactClassInterface: You are attempting to define ' +
	          '`%s` on your component more than once. This conflict may be due ' +
	          'to a mixin.',
	        name
	      );
	    }
	  }
	
	  /**
	   * Mixin helper which handles policy validation and reserved
	   * specification keys when building React classes.
	   */
	  function mixSpecIntoComponent(Constructor, spec) {
	    if (!spec) {
	      if (false) {
	        var typeofSpec = typeof spec;
	        var isMixinValid = typeofSpec === 'object' && spec !== null;
	
	        if (process.env.NODE_ENV !== 'production') {
	          warning(
	            isMixinValid,
	            "%s: You're attempting to include a mixin that is either null " +
	              'or not an object. Check the mixins included by the component, ' +
	              'as well as any mixins they include themselves. ' +
	              'Expected object but got %s.',
	            Constructor.displayName || 'ReactClass',
	            spec === null ? null : typeofSpec
	          );
	        }
	      }
	
	      return;
	    }
	
	    _invariant(
	      typeof spec !== 'function',
	      "ReactClass: You're attempting to " +
	        'use a component class or function as a mixin. Instead, just use a ' +
	        'regular object.'
	    );
	    _invariant(
	      !isValidElement(spec),
	      "ReactClass: You're attempting to " +
	        'use a component as a mixin. Instead, just use a regular object.'
	    );
	
	    var proto = Constructor.prototype;
	    var autoBindPairs = proto.__reactAutoBindPairs;
	
	    // By handling mixins before any other properties, we ensure the same
	    // chaining order is applied to methods with DEFINE_MANY policy, whether
	    // mixins are listed before or after these methods in the spec.
	    if (spec.hasOwnProperty(MIXINS_KEY)) {
	      RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
	    }
	
	    for (var name in spec) {
	      if (!spec.hasOwnProperty(name)) {
	        continue;
	      }
	
	      if (name === MIXINS_KEY) {
	        // We have already handled mixins in a special case above.
	        continue;
	      }
	
	      var property = spec[name];
	      var isAlreadyDefined = proto.hasOwnProperty(name);
	      validateMethodOverride(isAlreadyDefined, name);
	
	      if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
	        RESERVED_SPEC_KEYS[name](Constructor, property);
	      } else {
	        // Setup methods on prototype:
	        // The following member methods should not be automatically bound:
	        // 1. Expected ReactClass methods (in the "interface").
	        // 2. Overridden methods (that were mixed in).
	        var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
	        var isFunction = typeof property === 'function';
	        var shouldAutoBind =
	          isFunction &&
	          !isReactClassMethod &&
	          !isAlreadyDefined &&
	          spec.autobind !== false;
	
	        if (shouldAutoBind) {
	          autoBindPairs.push(name, property);
	          proto[name] = property;
	        } else {
	          if (isAlreadyDefined) {
	            var specPolicy = ReactClassInterface[name];
	
	            // These cases should already be caught by validateMethodOverride.
	            _invariant(
	              isReactClassMethod &&
	                (specPolicy === 'DEFINE_MANY_MERGED' ||
	                  specPolicy === 'DEFINE_MANY'),
	              'ReactClass: Unexpected spec policy %s for key %s ' +
	                'when mixing in component specs.',
	              specPolicy,
	              name
	            );
	
	            // For methods which are defined more than once, call the existing
	            // methods before calling the new property, merging if appropriate.
	            if (specPolicy === 'DEFINE_MANY_MERGED') {
	              proto[name] = createMergedResultFunction(proto[name], property);
	            } else if (specPolicy === 'DEFINE_MANY') {
	              proto[name] = createChainedFunction(proto[name], property);
	            }
	          } else {
	            proto[name] = property;
	            if (false) {
	              // Add verbose displayName to the function, which helps when looking
	              // at profiling tools.
	              if (typeof property === 'function' && spec.displayName) {
	                proto[name].displayName = spec.displayName + '_' + name;
	              }
	            }
	          }
	        }
	      }
	    }
	  }
	
	  function mixStaticSpecIntoComponent(Constructor, statics) {
	    if (!statics) {
	      return;
	    }
	
	    for (var name in statics) {
	      var property = statics[name];
	      if (!statics.hasOwnProperty(name)) {
	        continue;
	      }
	
	      var isReserved = name in RESERVED_SPEC_KEYS;
	      _invariant(
	        !isReserved,
	        'ReactClass: You are attempting to define a reserved ' +
	          'property, `%s`, that shouldn\'t be on the "statics" key. Define it ' +
	          'as an instance property instead; it will still be accessible on the ' +
	          'constructor.',
	        name
	      );
	
	      var isAlreadyDefined = name in Constructor;
	      if (isAlreadyDefined) {
	        var specPolicy = ReactClassStaticInterface.hasOwnProperty(name)
	          ? ReactClassStaticInterface[name]
	          : null;
	
	        _invariant(
	          specPolicy === 'DEFINE_MANY_MERGED',
	          'ReactClass: You are attempting to define ' +
	            '`%s` on your component more than once. This conflict may be ' +
	            'due to a mixin.',
	          name
	        );
	
	        Constructor[name] = createMergedResultFunction(Constructor[name], property);
	
	        return;
	      }
	
	      Constructor[name] = property;
	    }
	  }
	
	  /**
	   * Merge two objects, but throw if both contain the same key.
	   *
	   * @param {object} one The first object, which is mutated.
	   * @param {object} two The second object
	   * @return {object} one after it has been mutated to contain everything in two.
	   */
	  function mergeIntoWithNoDuplicateKeys(one, two) {
	    _invariant(
	      one && two && typeof one === 'object' && typeof two === 'object',
	      'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.'
	    );
	
	    for (var key in two) {
	      if (two.hasOwnProperty(key)) {
	        _invariant(
	          one[key] === undefined,
	          'mergeIntoWithNoDuplicateKeys(): ' +
	            'Tried to merge two objects with the same key: `%s`. This conflict ' +
	            'may be due to a mixin; in particular, this may be caused by two ' +
	            'getInitialState() or getDefaultProps() methods returning objects ' +
	            'with clashing keys.',
	          key
	        );
	        one[key] = two[key];
	      }
	    }
	    return one;
	  }
	
	  /**
	   * Creates a function that invokes two functions and merges their return values.
	   *
	   * @param {function} one Function to invoke first.
	   * @param {function} two Function to invoke second.
	   * @return {function} Function that invokes the two argument functions.
	   * @private
	   */
	  function createMergedResultFunction(one, two) {
	    return function mergedResult() {
	      var a = one.apply(this, arguments);
	      var b = two.apply(this, arguments);
	      if (a == null) {
	        return b;
	      } else if (b == null) {
	        return a;
	      }
	      var c = {};
	      mergeIntoWithNoDuplicateKeys(c, a);
	      mergeIntoWithNoDuplicateKeys(c, b);
	      return c;
	    };
	  }
	
	  /**
	   * Creates a function that invokes two functions and ignores their return vales.
	   *
	   * @param {function} one Function to invoke first.
	   * @param {function} two Function to invoke second.
	   * @return {function} Function that invokes the two argument functions.
	   * @private
	   */
	  function createChainedFunction(one, two) {
	    return function chainedFunction() {
	      one.apply(this, arguments);
	      two.apply(this, arguments);
	    };
	  }
	
	  /**
	   * Binds a method to the component.
	   *
	   * @param {object} component Component whose method is going to be bound.
	   * @param {function} method Method to be bound.
	   * @return {function} The bound method.
	   */
	  function bindAutoBindMethod(component, method) {
	    var boundMethod = method.bind(component);
	    if (false) {
	      boundMethod.__reactBoundContext = component;
	      boundMethod.__reactBoundMethod = method;
	      boundMethod.__reactBoundArguments = null;
	      var componentName = component.constructor.displayName;
	      var _bind = boundMethod.bind;
	      boundMethod.bind = function(newThis) {
	        for (
	          var _len = arguments.length,
	            args = Array(_len > 1 ? _len - 1 : 0),
	            _key = 1;
	          _key < _len;
	          _key++
	        ) {
	          args[_key - 1] = arguments[_key];
	        }
	
	        // User is trying to bind() an autobound method; we effectively will
	        // ignore the value of "this" that the user is trying to use, so
	        // let's warn.
	        if (newThis !== component && newThis !== null) {
	          if (process.env.NODE_ENV !== 'production') {
	            warning(
	              false,
	              'bind(): React component methods may only be bound to the ' +
	                'component instance. See %s',
	              componentName
	            );
	          }
	        } else if (!args.length) {
	          if (process.env.NODE_ENV !== 'production') {
	            warning(
	              false,
	              'bind(): You are binding a component method to the component. ' +
	                'React does this for you automatically in a high-performance ' +
	                'way, so you can safely remove this call. See %s',
	              componentName
	            );
	          }
	          return boundMethod;
	        }
	        var reboundMethod = _bind.apply(boundMethod, arguments);
	        reboundMethod.__reactBoundContext = component;
	        reboundMethod.__reactBoundMethod = method;
	        reboundMethod.__reactBoundArguments = args;
	        return reboundMethod;
	      };
	    }
	    return boundMethod;
	  }
	
	  /**
	   * Binds all auto-bound methods in a component.
	   *
	   * @param {object} component Component whose method is going to be bound.
	   */
	  function bindAutoBindMethods(component) {
	    var pairs = component.__reactAutoBindPairs;
	    for (var i = 0; i < pairs.length; i += 2) {
	      var autoBindKey = pairs[i];
	      var method = pairs[i + 1];
	      component[autoBindKey] = bindAutoBindMethod(component, method);
	    }
	  }
	
	  var IsMountedPreMixin = {
	    componentDidMount: function() {
	      this.__isMounted = true;
	    }
	  };
	
	  var IsMountedPostMixin = {
	    componentWillUnmount: function() {
	      this.__isMounted = false;
	    }
	  };
	
	  /**
	   * Add more to the ReactClass base class. These are all legacy features and
	   * therefore not already part of the modern ReactComponent.
	   */
	  var ReactClassMixin = {
	    /**
	     * TODO: This will be deprecated because state should always keep a consistent
	     * type signature and the only use case for this, is to avoid that.
	     */
	    replaceState: function(newState, callback) {
	      this.updater.enqueueReplaceState(this, newState, callback);
	    },
	
	    /**
	     * Checks whether or not this composite component is mounted.
	     * @return {boolean} True if mounted, false otherwise.
	     * @protected
	     * @final
	     */
	    isMounted: function() {
	      if (false) {
	        warning(
	          this.__didWarnIsMounted,
	          '%s: isMounted is deprecated. Instead, make sure to clean up ' +
	            'subscriptions and pending requests in componentWillUnmount to ' +
	            'prevent memory leaks.',
	          (this.constructor && this.constructor.displayName) ||
	            this.name ||
	            'Component'
	        );
	        this.__didWarnIsMounted = true;
	      }
	      return !!this.__isMounted;
	    }
	  };
	
	  var ReactClassComponent = function() {};
	  _assign(
	    ReactClassComponent.prototype,
	    ReactComponent.prototype,
	    ReactClassMixin
	  );
	
	  /**
	   * Creates a composite component class given a class specification.
	   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
	   *
	   * @param {object} spec Class specification (which must define `render`).
	   * @return {function} Component constructor function.
	   * @public
	   */
	  function createClass(spec) {
	    // To keep our warnings more understandable, we'll use a little hack here to
	    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
	    // unnecessarily identify a class without displayName as 'Constructor'.
	    var Constructor = identity(function(props, context, updater) {
	      // This constructor gets overridden by mocks. The argument is used
	      // by mocks to assert on what gets mounted.
	
	      if (false) {
	        warning(
	          this instanceof Constructor,
	          'Something is calling a React component directly. Use a factory or ' +
	            'JSX instead. See: https://fb.me/react-legacyfactory'
	        );
	      }
	
	      // Wire up auto-binding
	      if (this.__reactAutoBindPairs.length) {
	        bindAutoBindMethods(this);
	      }
	
	      this.props = props;
	      this.context = context;
	      this.refs = emptyObject;
	      this.updater = updater || ReactNoopUpdateQueue;
	
	      this.state = null;
	
	      // ReactClasses doesn't have constructors. Instead, they use the
	      // getInitialState and componentWillMount methods for initialization.
	
	      var initialState = this.getInitialState ? this.getInitialState() : null;
	      if (false) {
	        // We allow auto-mocks to proceed as if they're returning null.
	        if (
	          initialState === undefined &&
	          this.getInitialState._isMockFunction
	        ) {
	          // This is probably bad practice. Consider warning here and
	          // deprecating this convenience.
	          initialState = null;
	        }
	      }
	      _invariant(
	        typeof initialState === 'object' && !Array.isArray(initialState),
	        '%s.getInitialState(): must return an object or null',
	        Constructor.displayName || 'ReactCompositeComponent'
	      );
	
	      this.state = initialState;
	    });
	    Constructor.prototype = new ReactClassComponent();
	    Constructor.prototype.constructor = Constructor;
	    Constructor.prototype.__reactAutoBindPairs = [];
	
	    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));
	
	    mixSpecIntoComponent(Constructor, IsMountedPreMixin);
	    mixSpecIntoComponent(Constructor, spec);
	    mixSpecIntoComponent(Constructor, IsMountedPostMixin);
	
	    // Initialize the defaultProps property after all mixins have been merged.
	    if (Constructor.getDefaultProps) {
	      Constructor.defaultProps = Constructor.getDefaultProps();
	    }
	
	    if (false) {
	      // This is a tag to indicate that the use of these method names is ok,
	      // since it's used with createClass. If it's not, then it's likely a
	      // mistake so we'll warn you to use the static property, property
	      // initializer or constructor respectively.
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps.isReactClassApproved = {};
	      }
	      if (Constructor.prototype.getInitialState) {
	        Constructor.prototype.getInitialState.isReactClassApproved = {};
	      }
	    }
	
	    _invariant(
	      Constructor.prototype.render,
	      'createClass(...): Class specification must implement a `render` method.'
	    );
	
	    if (false) {
	      warning(
	        !Constructor.prototype.componentShouldUpdate,
	        '%s has a method called ' +
	          'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' +
	          'The name is phrased as a question because the function is ' +
	          'expected to return a value.',
	        spec.displayName || 'A component'
	      );
	      warning(
	        !Constructor.prototype.componentWillRecieveProps,
	        '%s has a method called ' +
	          'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?',
	        spec.displayName || 'A component'
	      );
	      warning(
	        !Constructor.prototype.UNSAFE_componentWillRecieveProps,
	        '%s has a method called UNSAFE_componentWillRecieveProps(). ' +
	          'Did you mean UNSAFE_componentWillReceiveProps()?',
	        spec.displayName || 'A component'
	      );
	    }
	
	    // Reduce time spent doing lookups by setting these on the prototype.
	    for (var methodName in ReactClassInterface) {
	      if (!Constructor.prototype[methodName]) {
	        Constructor.prototype[methodName] = null;
	      }
	    }
	
	    return Constructor;
	  }
	
	  return createClass;
	}
	
	module.exports = factory;


/***/ }),
/* 381 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(81)();
	// imports
	
	
	// module
	exports.push([module.id, "body{color:#575757;background:#fffdf9;background-image:url(" + __webpack_require__(398) + "),url(" + __webpack_require__(397) + ");background-repeat:no-repeat,no-repeat;background-position:100% 0,0 0;background-size:30%}body a{color:#96895a}body .card .card-content .card-title{font-weight:400;margin-bottom:18px}.index h1{display:none}.index img#heading{display:block;margin:auto;margin-top:15%;width:55%}@media only screen and (min-width:480px){.index img#heading{width:40%}}@media only screen and (min-width:720px){.index img#heading{width:30%}}.index .card-content{background-image:url(" + __webpack_require__(403) + ");background-position:100% 100%;background-repeat:no-repeat;background-size:200px}.input-field input[type=text]:focus+label,.materialize-textarea:focus:not([readonly])+label{color:#96895a!important}.input-field input[type=text]:focus,.materialize-textarea:focus:not([readonly]){border-bottom:1px solid #96895a!important;box-shadow:0 1px 0 0 #96895a!important}[type=checkbox].filled-in:checked+label:after{border:2px solid #96895a;background-color:#96895a}[type=radio]:checked+label:after,[type=radio]:checked+label:before{border-color:#96895a!important}[type=radio]:checked+label:after{background-color:#96895a!important}.fill{width:100%}.gold{background-color:#96895a}.gold-text{color:#96895a}.my-green{background-color:#97ac85}.my-green-text{color:#97ac85}.btn.my-green:hover{background-color:#b0c89b}blockquote{border-color:#97ac85}blockquote:nth-child(2n){border-color:#96895a}.schedule blockquote{margin-bottom:30px}.schedule blockquote h4{margin-bottom:4px}.schedule blockquote p{font-size:1.2em}", ""]);
	
	// exports


/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(81)();
	// imports
	
	
	// module
	exports.push([module.id, ".calendar{text-align:center}.calendar .addeventatc{position:relative}.calendar .addeventatc_dropdown{width:215px;position:absolute;z-index:99999;padding:6px 0 0;background:#fff;text-align:left;display:none;margin-top:2px;margin-left:-1px;border-top:1px solid #c8c8c8;border-right:1px solid #bebebe;border-bottom:1px solid #a8a8a8;border-left:1px solid #bebebe;box-shadow:1px 3px 6px rgba(0,0,0,.15)}.calendar .addeventatc_dropdown span{display:block;line-height:100%;background:#fff;text-decoration:none;font-size:14px;color:#333;padding:9px 10px 9px 40px}.calendar .addeventatc_dropdown span:hover{background-color:#f4f4f4;color:#000;text-decoration:none;font-size:14px}.calendar .addeventatc_dropdown em{color:#999!important;font-size:12px!important}.calendar .addeventatc_dropdown .frs{background:#fff;color:#cacaca!important;cursor:pointer;font-size:9px!important;font-style:normal!important;font-weight:400!important;line-height:110%!important;padding-left:10px;position:absolute;right:10px;text-align:right;text-decoration:none;top:5px;z-index:101}.calendar .addeventatc_dropdown .frs:hover{color:#999!important}.calendar .addeventatc_dropdown .ateappleical{background:url(" + __webpack_require__(399) + ") 13px 50% no-repeat;background-size:14px auto}.calendar .addeventatc_dropdown .ategoogle{background:url(" + __webpack_require__(401) + ") 13px 50% no-repeat;background-size:16px auto}.calendar .addeventatc_dropdown .ateoutlook{background:url(" + __webpack_require__(193) + ") 12px 50% no-repeat;background-size:16px auto}.calendar .addeventatc_dropdown .ateoutlookcom{background:url(" + __webpack_require__(193) + ") 12px 50% no-repeat;background-size:16px auto}.calendar .addeventatc_dropdown .ateyahoo{background:url(" + __webpack_require__(402) + ") 12px 50% no-repeat;background-size:16px auto}.calendar .addeventatc_dropdown .atefacebook{background:url(" + __webpack_require__(400) + ") 13px 50% no-repeat;background-size:14px auto}.calendar .addeventatc_dropdown .copyx{height:21px;display:block;position:relative;cursor:default}.calendar .addeventatc_dropdown .brx{height:1px;overflow:hidden;background:#e0e0e0;position:absolute;z-index:100;left:10px;right:10px;top:9px}", ""]);
	
	// exports


/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(81)();
	// imports
	
	
	// module
	exports.push([module.id, ".content{margin:3%}.content .welcome{font-size:1.25em}.content .video-wrapper{position:relative;padding-bottom:53.5%;padding-top:25px;height:0}.content .video-wrapper iframe{position:absolute;top:0;left:0;width:100%;height:100%}.content .place-title{font-size:1.4em}.content .card-content img{width:100%}.content .map .card-content{padding:0}.content .map iframe{display:block;border:0;width:100%;height:400px}", ""]);
	
	// exports


/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(81)();
	// imports
	
	
	// module
	exports.push([module.id, ".checkboxes{margin-top:10px}", ""]);
	
	// exports


/***/ }),
/* 385 */
/***/ (function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var _hyphenPattern = /-(.)/g;
	
	/**
	 * Camelcases a hyphenated string, for example:
	 *
	 *   > camelize('background-color')
	 *   < "backgroundColor"
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function camelize(string) {
	  return string.replace(_hyphenPattern, function (_, character) {
	    return character.toUpperCase();
	  });
	}
	
	module.exports = camelize;

/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	var camelize = __webpack_require__(385);
	
	var msPattern = /^-ms-/;
	
	/**
	 * Camelcases a hyphenated CSS property name, for example:
	 *
	 *   > camelizeStyleName('background-color')
	 *   < "backgroundColor"
	 *   > camelizeStyleName('-moz-transition')
	 *   < "MozTransition"
	 *   > camelizeStyleName('-ms-transition')
	 *   < "msTransition"
	 *
	 * As Andi Smith suggests
	 * (http://www.andismith.com/blog/2012/02/modernizr-prefixed/), an `-ms` prefix
	 * is converted to lowercase `ms`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function camelizeStyleName(string) {
	  return camelize(string.replace(msPattern, 'ms-'));
	}
	
	module.exports = camelizeStyleName;

/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	var isTextNode = __webpack_require__(395);
	
	/*eslint-disable no-bitwise */
	
	/**
	 * Checks if a given DOM node contains or is another DOM node.
	 */
	function containsNode(outerNode, innerNode) {
	  if (!outerNode || !innerNode) {
	    return false;
	  } else if (outerNode === innerNode) {
	    return true;
	  } else if (isTextNode(outerNode)) {
	    return false;
	  } else if (isTextNode(innerNode)) {
	    return containsNode(outerNode, innerNode.parentNode);
	  } else if ('contains' in outerNode) {
	    return outerNode.contains(innerNode);
	  } else if (outerNode.compareDocumentPosition) {
	    return !!(outerNode.compareDocumentPosition(innerNode) & 16);
	  } else {
	    return false;
	  }
	}
	
	module.exports = containsNode;

/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var invariant = __webpack_require__(3);
	
	/**
	 * Convert array-like objects to arrays.
	 *
	 * This API assumes the caller knows the contents of the data type. For less
	 * well defined inputs use createArrayFromMixed.
	 *
	 * @param {object|function|filelist} obj
	 * @return {array}
	 */
	function toArray(obj) {
	  var length = obj.length;
	
	  // Some browsers builtin objects can report typeof 'function' (e.g. NodeList
	  // in old versions of Safari).
	  !(!Array.isArray(obj) && (typeof obj === 'object' || typeof obj === 'function')) ?  false ? invariant(false, 'toArray: Array-like object expected') : invariant(false) : void 0;
	
	  !(typeof length === 'number') ?  false ? invariant(false, 'toArray: Object needs a length property') : invariant(false) : void 0;
	
	  !(length === 0 || length - 1 in obj) ?  false ? invariant(false, 'toArray: Object should have keys for indices') : invariant(false) : void 0;
	
	  !(typeof obj.callee !== 'function') ?  false ? invariant(false, 'toArray: Object can\'t be `arguments`. Use rest params ' + '(function(...args) {}) or Array.from() instead.') : invariant(false) : void 0;
	
	  // Old IE doesn't give collections access to hasOwnProperty. Assume inputs
	  // without method will throw during the slice call and skip straight to the
	  // fallback.
	  if (obj.hasOwnProperty) {
	    try {
	      return Array.prototype.slice.call(obj);
	    } catch (e) {
	      // IE < 9 does not support Array#slice on collections objects
	    }
	  }
	
	  // Fall back to copying key by key. This assumes all keys have a value,
	  // so will not preserve sparsely populated inputs.
	  var ret = Array(length);
	  for (var ii = 0; ii < length; ii++) {
	    ret[ii] = obj[ii];
	  }
	  return ret;
	}
	
	/**
	 * Perform a heuristic test to determine if an object is "array-like".
	 *
	 *   A monk asked Joshu, a Zen master, "Has a dog Buddha nature?"
	 *   Joshu replied: "Mu."
	 *
	 * This function determines if its argument has "array nature": it returns
	 * true if the argument is an actual array, an `arguments' object, or an
	 * HTMLCollection (e.g. node.childNodes or node.getElementsByTagName()).
	 *
	 * It will return false for other array-like objects like Filelist.
	 *
	 * @param {*} obj
	 * @return {boolean}
	 */
	function hasArrayNature(obj) {
	  return (
	    // not null/false
	    !!obj && (
	    // arrays are objects, NodeLists are functions in Safari
	    typeof obj == 'object' || typeof obj == 'function') &&
	    // quacks like an array
	    'length' in obj &&
	    // not window
	    !('setInterval' in obj) &&
	    // no DOM node should be considered an array-like
	    // a 'select' element has 'length' and 'item' properties on IE8
	    typeof obj.nodeType != 'number' && (
	    // a real array
	    Array.isArray(obj) ||
	    // arguments
	    'callee' in obj ||
	    // HTMLCollection/NodeList
	    'item' in obj)
	  );
	}
	
	/**
	 * Ensure that the argument is an array by wrapping it in an array if it is not.
	 * Creates a copy of the argument if it is already an array.
	 *
	 * This is mostly useful idiomatically:
	 *
	 *   var createArrayFromMixed = require('createArrayFromMixed');
	 *
	 *   function takesOneOrMoreThings(things) {
	 *     things = createArrayFromMixed(things);
	 *     ...
	 *   }
	 *
	 * This allows you to treat `things' as an array, but accept scalars in the API.
	 *
	 * If you need to convert an array-like object, like `arguments`, into an array
	 * use toArray instead.
	 *
	 * @param {*} obj
	 * @return {array}
	 */
	function createArrayFromMixed(obj) {
	  if (!hasArrayNature(obj)) {
	    return [obj];
	  } else if (Array.isArray(obj)) {
	    return obj.slice();
	  } else {
	    return toArray(obj);
	  }
	}
	
	module.exports = createArrayFromMixed;

/***/ }),
/* 389 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	/*eslint-disable fb-www/unsafe-html*/
	
	var ExecutionEnvironment = __webpack_require__(16);
	
	var createArrayFromMixed = __webpack_require__(388);
	var getMarkupWrap = __webpack_require__(390);
	var invariant = __webpack_require__(3);
	
	/**
	 * Dummy container used to render all markup.
	 */
	var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;
	
	/**
	 * Pattern used by `getNodeName`.
	 */
	var nodeNamePattern = /^\s*<(\w+)/;
	
	/**
	 * Extracts the `nodeName` of the first element in a string of markup.
	 *
	 * @param {string} markup String of markup.
	 * @return {?string} Node name of the supplied markup.
	 */
	function getNodeName(markup) {
	  var nodeNameMatch = markup.match(nodeNamePattern);
	  return nodeNameMatch && nodeNameMatch[1].toLowerCase();
	}
	
	/**
	 * Creates an array containing the nodes rendered from the supplied markup. The
	 * optionally supplied `handleScript` function will be invoked once for each
	 * <script> element that is rendered. If no `handleScript` function is supplied,
	 * an exception is thrown if any <script> elements are rendered.
	 *
	 * @param {string} markup A string of valid HTML markup.
	 * @param {?function} handleScript Invoked once for each rendered <script>.
	 * @return {array<DOMElement|DOMTextNode>} An array of rendered nodes.
	 */
	function createNodesFromMarkup(markup, handleScript) {
	  var node = dummyNode;
	  !!!dummyNode ?  false ? invariant(false, 'createNodesFromMarkup dummy not initialized') : invariant(false) : void 0;
	  var nodeName = getNodeName(markup);
	
	  var wrap = nodeName && getMarkupWrap(nodeName);
	  if (wrap) {
	    node.innerHTML = wrap[1] + markup + wrap[2];
	
	    var wrapDepth = wrap[0];
	    while (wrapDepth--) {
	      node = node.lastChild;
	    }
	  } else {
	    node.innerHTML = markup;
	  }
	
	  var scripts = node.getElementsByTagName('script');
	  if (scripts.length) {
	    !handleScript ?  false ? invariant(false, 'createNodesFromMarkup(...): Unexpected <script> element rendered.') : invariant(false) : void 0;
	    createArrayFromMixed(scripts).forEach(handleScript);
	  }
	
	  var nodes = Array.from(node.childNodes);
	  while (node.lastChild) {
	    node.removeChild(node.lastChild);
	  }
	  return nodes;
	}
	
	module.exports = createNodesFromMarkup;

/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	/*eslint-disable fb-www/unsafe-html */
	
	var ExecutionEnvironment = __webpack_require__(16);
	
	var invariant = __webpack_require__(3);
	
	/**
	 * Dummy container used to detect which wraps are necessary.
	 */
	var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;
	
	/**
	 * Some browsers cannot use `innerHTML` to render certain elements standalone,
	 * so we wrap them, render the wrapped nodes, then extract the desired node.
	 *
	 * In IE8, certain elements cannot render alone, so wrap all elements ('*').
	 */
	
	var shouldWrap = {};
	
	var selectWrap = [1, '<select multiple="true">', '</select>'];
	var tableWrap = [1, '<table>', '</table>'];
	var trWrap = [3, '<table><tbody><tr>', '</tr></tbody></table>'];
	
	var svgWrap = [1, '<svg xmlns="http://www.w3.org/2000/svg">', '</svg>'];
	
	var markupWrap = {
	  '*': [1, '?<div>', '</div>'],
	
	  'area': [1, '<map>', '</map>'],
	  'col': [2, '<table><tbody></tbody><colgroup>', '</colgroup></table>'],
	  'legend': [1, '<fieldset>', '</fieldset>'],
	  'param': [1, '<object>', '</object>'],
	  'tr': [2, '<table><tbody>', '</tbody></table>'],
	
	  'optgroup': selectWrap,
	  'option': selectWrap,
	
	  'caption': tableWrap,
	  'colgroup': tableWrap,
	  'tbody': tableWrap,
	  'tfoot': tableWrap,
	  'thead': tableWrap,
	
	  'td': trWrap,
	  'th': trWrap
	};
	
	// Initialize the SVG elements since we know they'll always need to be wrapped
	// consistently. If they are created inside a <div> they will be initialized in
	// the wrong namespace (and will not display).
	var svgElements = ['circle', 'clipPath', 'defs', 'ellipse', 'g', 'image', 'line', 'linearGradient', 'mask', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'text', 'tspan'];
	svgElements.forEach(function (nodeName) {
	  markupWrap[nodeName] = svgWrap;
	  shouldWrap[nodeName] = true;
	});
	
	/**
	 * Gets the markup wrap configuration for the supplied `nodeName`.
	 *
	 * NOTE: This lazily detects which wraps are necessary for the current browser.
	 *
	 * @param {string} nodeName Lowercase `nodeName`.
	 * @return {?array} Markup wrap configuration, if applicable.
	 */
	function getMarkupWrap(nodeName) {
	  !!!dummyNode ?  false ? invariant(false, 'Markup wrapping node not initialized') : invariant(false) : void 0;
	  if (!markupWrap.hasOwnProperty(nodeName)) {
	    nodeName = '*';
	  }
	  if (!shouldWrap.hasOwnProperty(nodeName)) {
	    if (nodeName === '*') {
	      dummyNode.innerHTML = '<link />';
	    } else {
	      dummyNode.innerHTML = '<' + nodeName + '></' + nodeName + '>';
	    }
	    shouldWrap[nodeName] = !dummyNode.firstChild;
	  }
	  return shouldWrap[nodeName] ? markupWrap[nodeName] : null;
	}
	
	module.exports = getMarkupWrap;

/***/ }),
/* 391 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	/**
	 * Gets the scroll position of the supplied element or window.
	 *
	 * The return values are unbounded, unlike `getScrollPosition`. This means they
	 * may be negative or exceed the element boundaries (which is possible using
	 * inertial scrolling).
	 *
	 * @param {DOMWindow|DOMElement} scrollable
	 * @return {object} Map with `x` and `y` keys.
	 */
	
	function getUnboundedScrollPosition(scrollable) {
	  if (scrollable.Window && scrollable instanceof scrollable.Window) {
	    return {
	      x: scrollable.pageXOffset || scrollable.document.documentElement.scrollLeft,
	      y: scrollable.pageYOffset || scrollable.document.documentElement.scrollTop
	    };
	  }
	  return {
	    x: scrollable.scrollLeft,
	    y: scrollable.scrollTop
	  };
	}
	
	module.exports = getUnboundedScrollPosition;

/***/ }),
/* 392 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var _uppercasePattern = /([A-Z])/g;
	
	/**
	 * Hyphenates a camelcased string, for example:
	 *
	 *   > hyphenate('backgroundColor')
	 *   < "background-color"
	 *
	 * For CSS style names, use `hyphenateStyleName` instead which works properly
	 * with all vendor prefixes, including `ms`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function hyphenate(string) {
	  return string.replace(_uppercasePattern, '-$1').toLowerCase();
	}
	
	module.exports = hyphenate;

/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	var hyphenate = __webpack_require__(392);
	
	var msPattern = /^ms-/;
	
	/**
	 * Hyphenates a camelcased CSS property name, for example:
	 *
	 *   > hyphenateStyleName('backgroundColor')
	 *   < "background-color"
	 *   > hyphenateStyleName('MozTransition')
	 *   < "-moz-transition"
	 *   > hyphenateStyleName('msTransition')
	 *   < "-ms-transition"
	 *
	 * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
	 * is converted to `-ms-`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function hyphenateStyleName(string) {
	  return hyphenate(string).replace(msPattern, '-ms-');
	}
	
	module.exports = hyphenateStyleName;

/***/ }),
/* 394 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	/**
	 * @param {*} object The object to check.
	 * @return {boolean} Whether or not the object is a DOM node.
	 */
	function isNode(object) {
	  var doc = object ? object.ownerDocument || object : document;
	  var defaultView = doc.defaultView || window;
	  return !!(object && (typeof defaultView.Node === 'function' ? object instanceof defaultView.Node : typeof object === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string'));
	}
	
	module.exports = isNode;

/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var isNode = __webpack_require__(394);
	
	/**
	 * @param {*} object The object to check.
	 * @return {boolean} Whether or not the object is a DOM text node.
	 */
	function isTextNode(object) {
	  return isNode(object) && object.nodeType == 3;
	}
	
	module.exports = isTextNode;

/***/ }),
/* 396 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 * @typechecks static-only
	 */
	
	'use strict';
	
	/**
	 * Memoizes the return value of a function that accepts one string argument.
	 */
	
	function memoizeStringOnly(callback) {
	  var cache = {};
	  return function (string) {
	    if (!cache.hasOwnProperty(string)) {
	      cache[string] = callback.call(this, string);
	    }
	    return cache[string];
	  };
	}
	
	module.exports = memoizeStringOnly;

/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "aa089db4f5258d836b0837bba9eca6c1.svg";

/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "c444204bcb2a95d7a80828ff288293ed.svg";

/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "5a3173dc0b5808faaf679199a7edaefb.svg";

/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "32e35398b19d2cee936d210d2ea097c3.svg";

/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "03ef36be6f461ab392d5c46ae8e4226c.svg";

/***/ }),
/* 402 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "1e116fbb68c40d3ab77ee999833f5c84.svg";

/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "0f5906aaa117022227abc46b93a33368.svg";

/***/ }),
/* 404 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "ae712d205517c02a874497f4ee259d1c.svg";

/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	__webpack_require__(301);
	module.exports = __webpack_require__(26).default;


/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	__webpack_require__(223);


/***/ }),
/* 407 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	module.exports = __webpack_require__(224);


/***/ }),
/* 408 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	__webpack_require__(258);


/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	__webpack_require__(295);


/***/ }),
/* 410 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	__webpack_require__(305);


/***/ }),
/* 411 */
/***/ (function(module, exports) {

	/*!
	 * Determine if an object is a Buffer
	 *
	 * @author   Feross Aboukhadijeh <https://feross.org>
	 * @license  MIT
	 */
	
	// The _isBuffer check is for Safari 5-7 support, because it's missing
	// Object.prototype.constructor. Remove this eventually
	module.exports = function (obj) {
	  return obj != null && (isBuffer(obj) || isSlowBuffer(obj) || !!obj._isBuffer)
	}
	
	function isBuffer (obj) {
	  return !!obj.constructor && typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj)
	}
	
	// For Node v0.10 support. Remove this eventually.
	function isSlowBuffer (obj) {
	  return typeof obj.readFloatLE === 'function' && typeof obj.slice === 'function' && isBuffer(obj.slice(0, 0))
	}


/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(setImmediate) {(function (root) {
	
	  // Store setTimeout reference so promise-polyfill will be unaffected by
	  // other code modifying setTimeout (like sinon.useFakeTimers())
	  var setTimeoutFunc = setTimeout;
	
	  function noop() {}
	  
	  // Polyfill for Function.prototype.bind
	  function bind(fn, thisArg) {
	    return function () {
	      fn.apply(thisArg, arguments);
	    };
	  }
	
	  function Promise(fn) {
	    if (!(this instanceof Promise)) throw new TypeError('Promises must be constructed via new');
	    if (typeof fn !== 'function') throw new TypeError('not a function');
	    this._state = 0;
	    this._handled = false;
	    this._value = undefined;
	    this._deferreds = [];
	
	    doResolve(fn, this);
	  }
	
	  function handle(self, deferred) {
	    while (self._state === 3) {
	      self = self._value;
	    }
	    if (self._state === 0) {
	      self._deferreds.push(deferred);
	      return;
	    }
	    self._handled = true;
	    Promise._immediateFn(function () {
	      var cb = self._state === 1 ? deferred.onFulfilled : deferred.onRejected;
	      if (cb === null) {
	        (self._state === 1 ? resolve : reject)(deferred.promise, self._value);
	        return;
	      }
	      var ret;
	      try {
	        ret = cb(self._value);
	      } catch (e) {
	        reject(deferred.promise, e);
	        return;
	      }
	      resolve(deferred.promise, ret);
	    });
	  }
	
	  function resolve(self, newValue) {
	    try {
	      // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
	      if (newValue === self) throw new TypeError('A promise cannot be resolved with itself.');
	      if (newValue && (typeof newValue === 'object' || typeof newValue === 'function')) {
	        var then = newValue.then;
	        if (newValue instanceof Promise) {
	          self._state = 3;
	          self._value = newValue;
	          finale(self);
	          return;
	        } else if (typeof then === 'function') {
	          doResolve(bind(then, newValue), self);
	          return;
	        }
	      }
	      self._state = 1;
	      self._value = newValue;
	      finale(self);
	    } catch (e) {
	      reject(self, e);
	    }
	  }
	
	  function reject(self, newValue) {
	    self._state = 2;
	    self._value = newValue;
	    finale(self);
	  }
	
	  function finale(self) {
	    if (self._state === 2 && self._deferreds.length === 0) {
	      Promise._immediateFn(function() {
	        if (!self._handled) {
	          Promise._unhandledRejectionFn(self._value);
	        }
	      });
	    }
	
	    for (var i = 0, len = self._deferreds.length; i < len; i++) {
	      handle(self, self._deferreds[i]);
	    }
	    self._deferreds = null;
	  }
	
	  function Handler(onFulfilled, onRejected, promise) {
	    this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
	    this.onRejected = typeof onRejected === 'function' ? onRejected : null;
	    this.promise = promise;
	  }
	
	  /**
	   * Take a potentially misbehaving resolver function and make sure
	   * onFulfilled and onRejected are only called once.
	   *
	   * Makes no guarantees about asynchrony.
	   */
	  function doResolve(fn, self) {
	    var done = false;
	    try {
	      fn(function (value) {
	        if (done) return;
	        done = true;
	        resolve(self, value);
	      }, function (reason) {
	        if (done) return;
	        done = true;
	        reject(self, reason);
	      });
	    } catch (ex) {
	      if (done) return;
	      done = true;
	      reject(self, ex);
	    }
	  }
	
	  Promise.prototype['catch'] = function (onRejected) {
	    return this.then(null, onRejected);
	  };
	
	  Promise.prototype.then = function (onFulfilled, onRejected) {
	    var prom = new (this.constructor)(noop);
	
	    handle(this, new Handler(onFulfilled, onRejected, prom));
	    return prom;
	  };
	
	  Promise.all = function (arr) {
	    return new Promise(function (resolve, reject) {
	      if (!arr || typeof arr.length === 'undefined') throw new TypeError('Promise.all accepts an array');
	      var args = Array.prototype.slice.call(arr);
	      if (args.length === 0) return resolve([]);
	      var remaining = args.length;
	
	      function res(i, val) {
	        try {
	          if (val && (typeof val === 'object' || typeof val === 'function')) {
	            var then = val.then;
	            if (typeof then === 'function') {
	              then.call(val, function (val) {
	                res(i, val);
	              }, reject);
	              return;
	            }
	          }
	          args[i] = val;
	          if (--remaining === 0) {
	            resolve(args);
	          }
	        } catch (ex) {
	          reject(ex);
	        }
	      }
	
	      for (var i = 0; i < args.length; i++) {
	        res(i, args[i]);
	      }
	    });
	  };
	
	  Promise.resolve = function (value) {
	    if (value && typeof value === 'object' && value.constructor === Promise) {
	      return value;
	    }
	
	    return new Promise(function (resolve) {
	      resolve(value);
	    });
	  };
	
	  Promise.reject = function (value) {
	    return new Promise(function (resolve, reject) {
	      reject(value);
	    });
	  };
	
	  Promise.race = function (values) {
	    return new Promise(function (resolve, reject) {
	      for (var i = 0, len = values.length; i < len; i++) {
	        values[i].then(resolve, reject);
	      }
	    });
	  };
	
	  // Use polyfill for setImmediate for performance gains
	  Promise._immediateFn = (typeof setImmediate === 'function' && function (fn) { setImmediate(fn); }) ||
	    function (fn) {
	      setTimeoutFunc(fn, 0);
	    };
	
	  Promise._unhandledRejectionFn = function _unhandledRejectionFn(err) {
	    if (typeof console !== 'undefined' && console) {
	      console.warn('Possible Unhandled Promise Rejection:', err); // eslint-disable-line no-console
	    }
	  };
	
	  /**
	   * Set the immediate function to execute callbacks
	   * @param fn {function} Function to execute
	   * @deprecated
	   */
	  Promise._setImmediateFn = function _setImmediateFn(fn) {
	    Promise._immediateFn = fn;
	  };
	
	  /**
	   * Change the function to execute on unhandled rejection
	   * @param {function} fn Function to execute on unhandled rejection
	   * @deprecated
	   */
	  Promise._setUnhandledRejectionFn = function _setUnhandledRejectionFn(fn) {
	    Promise._unhandledRejectionFn = fn;
	  };
	  
	  if (typeof module !== 'undefined' && module.exports) {
	    module.exports = Promise;
	  } else if (!root.Promise) {
	    root.Promise = Promise;
	  }
	
	})(this);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(497).setImmediate))

/***/ }),
/* 413 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	if (false) {
	  var invariant = require('fbjs/lib/invariant');
	  var warning = require('fbjs/lib/warning');
	  var ReactPropTypesSecret = require('./lib/ReactPropTypesSecret');
	  var loggedTypeFailures = {};
	}
	
	/**
	 * Assert that the values match with the type specs.
	 * Error messages are memorized and will only be shown once.
	 *
	 * @param {object} typeSpecs Map of name to a ReactPropType
	 * @param {object} values Runtime values that need to be type-checked
	 * @param {string} location e.g. "prop", "context", "child context"
	 * @param {string} componentName Name of the component for error messages.
	 * @param {?Function} getStack Returns the component stack.
	 * @private
	 */
	function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
	  if (false) {
	    for (var typeSpecName in typeSpecs) {
	      if (typeSpecs.hasOwnProperty(typeSpecName)) {
	        var error;
	        // Prop type validation may throw. In case they do, we don't want to
	        // fail the render phase where it didn't fail before. So we log it.
	        // After these have been cleaned up, we'll let them throw.
	        try {
	          // This is intentionally an invariant that gets caught. It's the same
	          // behavior as without this statement except with a better message.
	          invariant(typeof typeSpecs[typeSpecName] === 'function', '%s: %s type `%s` is invalid; it must be a function, usually from ' + 'the `prop-types` package, but received `%s`.', componentName || 'React class', location, typeSpecName, typeof typeSpecs[typeSpecName]);
	          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
	        } catch (ex) {
	          error = ex;
	        }
	        warning(!error || error instanceof Error, '%s: type specification of %s `%s` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a %s. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).', componentName || 'React class', location, typeSpecName, typeof error);
	        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	          // Only monitor this failure once because there tends to be a lot of the
	          // same error.
	          loggedTypeFailures[error.message] = true;
	
	          var stack = getStack ? getStack() : '';
	
	          warning(false, 'Failed %s type: %s%s', location, error.message, stack != null ? stack : '');
	        }
	      }
	    }
	  }
	}
	
	module.exports = checkPropTypes;


/***/ }),
/* 414 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var emptyFunction = __webpack_require__(24);
	var invariant = __webpack_require__(3);
	var warning = __webpack_require__(5);
	var assign = __webpack_require__(7);
	
	var ReactPropTypesSecret = __webpack_require__(415);
	var checkPropTypes = __webpack_require__(413);
	
	module.exports = function(isValidElement, throwOnDirectAccess) {
	  /* global Symbol */
	  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
	
	  /**
	   * Returns the iterator method function contained on the iterable object.
	   *
	   * Be sure to invoke the function with the iterable as context:
	   *
	   *     var iteratorFn = getIteratorFn(myIterable);
	   *     if (iteratorFn) {
	   *       var iterator = iteratorFn.call(myIterable);
	   *       ...
	   *     }
	   *
	   * @param {?object} maybeIterable
	   * @return {?function}
	   */
	  function getIteratorFn(maybeIterable) {
	    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	    if (typeof iteratorFn === 'function') {
	      return iteratorFn;
	    }
	  }
	
	  /**
	   * Collection of methods that allow declaration and validation of props that are
	   * supplied to React components. Example usage:
	   *
	   *   var Props = require('ReactPropTypes');
	   *   var MyArticle = React.createClass({
	   *     propTypes: {
	   *       // An optional string prop named "description".
	   *       description: Props.string,
	   *
	   *       // A required enum prop named "category".
	   *       category: Props.oneOf(['News','Photos']).isRequired,
	   *
	   *       // A prop named "dialog" that requires an instance of Dialog.
	   *       dialog: Props.instanceOf(Dialog).isRequired
	   *     },
	   *     render: function() { ... }
	   *   });
	   *
	   * A more formal specification of how these methods are used:
	   *
	   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
	   *   decl := ReactPropTypes.{type}(.isRequired)?
	   *
	   * Each and every declaration produces a function with the same signature. This
	   * allows the creation of custom validation functions. For example:
	   *
	   *  var MyLink = React.createClass({
	   *    propTypes: {
	   *      // An optional string or URI prop named "href".
	   *      href: function(props, propName, componentName) {
	   *        var propValue = props[propName];
	   *        if (propValue != null && typeof propValue !== 'string' &&
	   *            !(propValue instanceof URI)) {
	   *          return new Error(
	   *            'Expected a string or an URI for ' + propName + ' in ' +
	   *            componentName
	   *          );
	   *        }
	   *      }
	   *    },
	   *    render: function() {...}
	   *  });
	   *
	   * @internal
	   */
	
	  var ANONYMOUS = '<<anonymous>>';
	
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
	  var ReactPropTypes = {
	    array: createPrimitiveTypeChecker('array'),
	    bool: createPrimitiveTypeChecker('boolean'),
	    func: createPrimitiveTypeChecker('function'),
	    number: createPrimitiveTypeChecker('number'),
	    object: createPrimitiveTypeChecker('object'),
	    string: createPrimitiveTypeChecker('string'),
	    symbol: createPrimitiveTypeChecker('symbol'),
	
	    any: createAnyTypeChecker(),
	    arrayOf: createArrayOfTypeChecker,
	    element: createElementTypeChecker(),
	    instanceOf: createInstanceTypeChecker,
	    node: createNodeChecker(),
	    objectOf: createObjectOfTypeChecker,
	    oneOf: createEnumTypeChecker,
	    oneOfType: createUnionTypeChecker,
	    shape: createShapeTypeChecker,
	    exact: createStrictShapeTypeChecker,
	  };
	
	  /**
	   * inlined Object.is polyfill to avoid requiring consumers ship their own
	   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	   */
	  /*eslint-disable no-self-compare*/
	  function is(x, y) {
	    // SameValue algorithm
	    if (x === y) {
	      // Steps 1-5, 7-10
	      // Steps 6.b-6.e: +0 != -0
	      return x !== 0 || 1 / x === 1 / y;
	    } else {
	      // Step 6.a: NaN == NaN
	      return x !== x && y !== y;
	    }
	  }
	  /*eslint-enable no-self-compare*/
	
	  /**
	   * We use an Error-like object for backward compatibility as people may call
	   * PropTypes directly and inspect their output. However, we don't use real
	   * Errors anymore. We don't inspect their stack anyway, and creating them
	   * is prohibitively expensive if they are created too often, such as what
	   * happens in oneOfType() for any type before the one that matched.
	   */
	  function PropTypeError(message) {
	    this.message = message;
	    this.stack = '';
	  }
	  // Make `instanceof Error` still work for returned errors.
	  PropTypeError.prototype = Error.prototype;
	
	  function createChainableTypeChecker(validate) {
	    if (false) {
	      var manualPropTypeCallCache = {};
	      var manualPropTypeWarningCount = 0;
	    }
	    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
	      componentName = componentName || ANONYMOUS;
	      propFullName = propFullName || propName;
	
	      if (secret !== ReactPropTypesSecret) {
	        if (throwOnDirectAccess) {
	          // New behavior only for users of `prop-types` package
	          invariant(
	            false,
	            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	            'Use `PropTypes.checkPropTypes()` to call them. ' +
	            'Read more at http://fb.me/use-check-prop-types'
	          );
	        } else if (false) {
	          // Old behavior for people using React.PropTypes
	          var cacheKey = componentName + ':' + propName;
	          if (
	            !manualPropTypeCallCache[cacheKey] &&
	            // Avoid spamming the console because they are often not actionable except for lib authors
	            manualPropTypeWarningCount < 3
	          ) {
	            warning(
	              false,
	              'You are manually calling a React.PropTypes validation ' +
	              'function for the `%s` prop on `%s`. This is deprecated ' +
	              'and will throw in the standalone `prop-types` package. ' +
	              'You may be seeing this warning due to a third-party PropTypes ' +
	              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.',
	              propFullName,
	              componentName
	            );
	            manualPropTypeCallCache[cacheKey] = true;
	            manualPropTypeWarningCount++;
	          }
	        }
	      }
	      if (props[propName] == null) {
	        if (isRequired) {
	          if (props[propName] === null) {
	            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
	          }
	          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
	        }
	        return null;
	      } else {
	        return validate(props, propName, componentName, location, propFullName);
	      }
	    }
	
	    var chainedCheckType = checkType.bind(null, false);
	    chainedCheckType.isRequired = checkType.bind(null, true);
	
	    return chainedCheckType;
	  }
	
	  function createPrimitiveTypeChecker(expectedType) {
	    function validate(props, propName, componentName, location, propFullName, secret) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== expectedType) {
	        // `propValue` being instance of, say, date/regexp, pass the 'object'
	        // check, but we can offer a more precise error message here rather than
	        // 'of type `object`'.
	        var preciseType = getPreciseType(propValue);
	
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createAnyTypeChecker() {
	    return createChainableTypeChecker(emptyFunction.thatReturnsNull);
	  }
	
	  function createArrayOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
	      }
	      var propValue = props[propName];
	      if (!Array.isArray(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
	      }
	      for (var i = 0; i < propValue.length; i++) {
	        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
	        if (error instanceof Error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createElementTypeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      if (!isValidElement(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createInstanceTypeChecker(expectedClass) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!(props[propName] instanceof expectedClass)) {
	        var expectedClassName = expectedClass.name || ANONYMOUS;
	        var actualClassName = getClassName(props[propName]);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createEnumTypeChecker(expectedValues) {
	    if (!Array.isArray(expectedValues)) {
	       false ? warning(false, 'Invalid argument supplied to oneOf, expected an instance of array.') : void 0;
	      return emptyFunction.thatReturnsNull;
	    }
	
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      for (var i = 0; i < expectedValues.length; i++) {
	        if (is(propValue, expectedValues[i])) {
	          return null;
	        }
	      }
	
	      var valuesString = JSON.stringify(expectedValues);
	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createObjectOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
	      }
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
	      }
	      for (var key in propValue) {
	        if (propValue.hasOwnProperty(key)) {
	          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	          if (error instanceof Error) {
	            return error;
	          }
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createUnionTypeChecker(arrayOfTypeCheckers) {
	    if (!Array.isArray(arrayOfTypeCheckers)) {
	       false ? warning(false, 'Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
	      return emptyFunction.thatReturnsNull;
	    }
	
	    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	      var checker = arrayOfTypeCheckers[i];
	      if (typeof checker !== 'function') {
	        warning(
	          false,
	          'Invalid argument supplied to oneOfType. Expected an array of check functions, but ' +
	          'received %s at index %s.',
	          getPostfixForTypeWarning(checker),
	          i
	        );
	        return emptyFunction.thatReturnsNull;
	      }
	    }
	
	    function validate(props, propName, componentName, location, propFullName) {
	      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	        var checker = arrayOfTypeCheckers[i];
	        if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret) == null) {
	          return null;
	        }
	      }
	
	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createNodeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!isNode(props[propName])) {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createShapeTypeChecker(shapeTypes) {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	      }
	      for (var key in shapeTypes) {
	        var checker = shapeTypes[key];
	        if (!checker) {
	          continue;
	        }
	        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	        if (error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createStrictShapeTypeChecker(shapeTypes) {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	      }
	      // We need to check all keys in case some are required but missing from
	      // props.
	      var allKeys = assign({}, props[propName], shapeTypes);
	      for (var key in allKeys) {
	        var checker = shapeTypes[key];
	        if (!checker) {
	          return new PropTypeError(
	            'Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' +
	            '\nBad object: ' + JSON.stringify(props[propName], null, '  ') +
	            '\nValid keys: ' +  JSON.stringify(Object.keys(shapeTypes), null, '  ')
	          );
	        }
	        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	        if (error) {
	          return error;
	        }
	      }
	      return null;
	    }
	
	    return createChainableTypeChecker(validate);
	  }
	
	  function isNode(propValue) {
	    switch (typeof propValue) {
	      case 'number':
	      case 'string':
	      case 'undefined':
	        return true;
	      case 'boolean':
	        return !propValue;
	      case 'object':
	        if (Array.isArray(propValue)) {
	          return propValue.every(isNode);
	        }
	        if (propValue === null || isValidElement(propValue)) {
	          return true;
	        }
	
	        var iteratorFn = getIteratorFn(propValue);
	        if (iteratorFn) {
	          var iterator = iteratorFn.call(propValue);
	          var step;
	          if (iteratorFn !== propValue.entries) {
	            while (!(step = iterator.next()).done) {
	              if (!isNode(step.value)) {
	                return false;
	              }
	            }
	          } else {
	            // Iterator will provide entry [k,v] tuples rather than values.
	            while (!(step = iterator.next()).done) {
	              var entry = step.value;
	              if (entry) {
	                if (!isNode(entry[1])) {
	                  return false;
	                }
	              }
	            }
	          }
	        } else {
	          return false;
	        }
	
	        return true;
	      default:
	        return false;
	    }
	  }
	
	  function isSymbol(propType, propValue) {
	    // Native Symbol.
	    if (propType === 'symbol') {
	      return true;
	    }
	
	    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
	    if (propValue['@@toStringTag'] === 'Symbol') {
	      return true;
	    }
	
	    // Fallback for non-spec compliant Symbols which are polyfilled.
	    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
	      return true;
	    }
	
	    return false;
	  }
	
	  // Equivalent of `typeof` but with special handling for array and regexp.
	  function getPropType(propValue) {
	    var propType = typeof propValue;
	    if (Array.isArray(propValue)) {
	      return 'array';
	    }
	    if (propValue instanceof RegExp) {
	      // Old webkits (at least until Android 4.0) return 'function' rather than
	      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
	      // passes PropTypes.object.
	      return 'object';
	    }
	    if (isSymbol(propType, propValue)) {
	      return 'symbol';
	    }
	    return propType;
	  }
	
	  // This handles more types than `getPropType`. Only used for error messages.
	  // See `createPrimitiveTypeChecker`.
	  function getPreciseType(propValue) {
	    if (typeof propValue === 'undefined' || propValue === null) {
	      return '' + propValue;
	    }
	    var propType = getPropType(propValue);
	    if (propType === 'object') {
	      if (propValue instanceof Date) {
	        return 'date';
	      } else if (propValue instanceof RegExp) {
	        return 'regexp';
	      }
	    }
	    return propType;
	  }
	
	  // Returns a string that is postfixed to a warning about an invalid type.
	  // For example, "undefined" or "of type array"
	  function getPostfixForTypeWarning(value) {
	    var type = getPreciseType(value);
	    switch (type) {
	      case 'array':
	      case 'object':
	        return 'an ' + type;
	      case 'boolean':
	      case 'date':
	      case 'regexp':
	        return 'a ' + type;
	      default:
	        return type;
	    }
	  }
	
	  // Returns class name of the object, if any.
	  function getClassName(propValue) {
	    if (!propValue.constructor || !propValue.constructor.name) {
	      return ANONYMOUS;
	    }
	    return propValue.constructor.name;
	  }
	
	  ReactPropTypes.checkPropTypes = checkPropTypes;
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};


/***/ }),
/* 415 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	module.exports = ReactPropTypesSecret;


/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(430);


/***/ }),
/* 417 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ARIADOMPropertyConfig = {
	  Properties: {
	    // Global States and Properties
	    'aria-current': 0, // state
	    'aria-details': 0,
	    'aria-disabled': 0, // state
	    'aria-hidden': 0, // state
	    'aria-invalid': 0, // state
	    'aria-keyshortcuts': 0,
	    'aria-label': 0,
	    'aria-roledescription': 0,
	    // Widget Attributes
	    'aria-autocomplete': 0,
	    'aria-checked': 0,
	    'aria-expanded': 0,
	    'aria-haspopup': 0,
	    'aria-level': 0,
	    'aria-modal': 0,
	    'aria-multiline': 0,
	    'aria-multiselectable': 0,
	    'aria-orientation': 0,
	    'aria-placeholder': 0,
	    'aria-pressed': 0,
	    'aria-readonly': 0,
	    'aria-required': 0,
	    'aria-selected': 0,
	    'aria-sort': 0,
	    'aria-valuemax': 0,
	    'aria-valuemin': 0,
	    'aria-valuenow': 0,
	    'aria-valuetext': 0,
	    // Live Region Attributes
	    'aria-atomic': 0,
	    'aria-busy': 0,
	    'aria-live': 0,
	    'aria-relevant': 0,
	    // Drag-and-Drop Attributes
	    'aria-dropeffect': 0,
	    'aria-grabbed': 0,
	    // Relationship Attributes
	    'aria-activedescendant': 0,
	    'aria-colcount': 0,
	    'aria-colindex': 0,
	    'aria-colspan': 0,
	    'aria-controls': 0,
	    'aria-describedby': 0,
	    'aria-errormessage': 0,
	    'aria-flowto': 0,
	    'aria-labelledby': 0,
	    'aria-owns': 0,
	    'aria-posinset': 0,
	    'aria-rowcount': 0,
	    'aria-rowindex': 0,
	    'aria-rowspan': 0,
	    'aria-setsize': 0
	  },
	  DOMAttributeNames: {},
	  DOMPropertyNames: {}
	};
	
	module.exports = ARIADOMPropertyConfig;

/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactDOMComponentTree = __webpack_require__(9);
	
	var focusNode = __webpack_require__(191);
	
	var AutoFocusUtils = {
	  focusDOMComponent: function () {
	    focusNode(ReactDOMComponentTree.getNodeFromInstance(this));
	  }
	};
	
	module.exports = AutoFocusUtils;

/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var EventPropagators = __webpack_require__(60);
	var ExecutionEnvironment = __webpack_require__(16);
	var FallbackCompositionState = __webpack_require__(425);
	var SyntheticCompositionEvent = __webpack_require__(462);
	var SyntheticInputEvent = __webpack_require__(465);
	
	var END_KEYCODES = [9, 13, 27, 32]; // Tab, Return, Esc, Space
	var START_KEYCODE = 229;
	
	var canUseCompositionEvent = ExecutionEnvironment.canUseDOM && 'CompositionEvent' in window;
	
	var documentMode = null;
	if (ExecutionEnvironment.canUseDOM && 'documentMode' in document) {
	  documentMode = document.documentMode;
	}
	
	// Webkit offers a very useful `textInput` event that can be used to
	// directly represent `beforeInput`. The IE `textinput` event is not as
	// useful, so we don't use it.
	var canUseTextInputEvent = ExecutionEnvironment.canUseDOM && 'TextEvent' in window && !documentMode && !isPresto();
	
	// In IE9+, we have access to composition events, but the data supplied
	// by the native compositionend event may be incorrect. Japanese ideographic
	// spaces, for instance (\u3000) are not recorded correctly.
	var useFallbackCompositionData = ExecutionEnvironment.canUseDOM && (!canUseCompositionEvent || documentMode && documentMode > 8 && documentMode <= 11);
	
	/**
	 * Opera <= 12 includes TextEvent in window, but does not fire
	 * text input events. Rely on keypress instead.
	 */
	function isPresto() {
	  var opera = window.opera;
	  return typeof opera === 'object' && typeof opera.version === 'function' && parseInt(opera.version(), 10) <= 12;
	}
	
	var SPACEBAR_CODE = 32;
	var SPACEBAR_CHAR = String.fromCharCode(SPACEBAR_CODE);
	
	// Events and their corresponding property names.
	var eventTypes = {
	  beforeInput: {
	    phasedRegistrationNames: {
	      bubbled: 'onBeforeInput',
	      captured: 'onBeforeInputCapture'
	    },
	    dependencies: ['topCompositionEnd', 'topKeyPress', 'topTextInput', 'topPaste']
	  },
	  compositionEnd: {
	    phasedRegistrationNames: {
	      bubbled: 'onCompositionEnd',
	      captured: 'onCompositionEndCapture'
	    },
	    dependencies: ['topBlur', 'topCompositionEnd', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
	  },
	  compositionStart: {
	    phasedRegistrationNames: {
	      bubbled: 'onCompositionStart',
	      captured: 'onCompositionStartCapture'
	    },
	    dependencies: ['topBlur', 'topCompositionStart', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
	  },
	  compositionUpdate: {
	    phasedRegistrationNames: {
	      bubbled: 'onCompositionUpdate',
	      captured: 'onCompositionUpdateCapture'
	    },
	    dependencies: ['topBlur', 'topCompositionUpdate', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
	  }
	};
	
	// Track whether we've ever handled a keypress on the space key.
	var hasSpaceKeypress = false;
	
	/**
	 * Return whether a native keypress event is assumed to be a command.
	 * This is required because Firefox fires `keypress` events for key commands
	 * (cut, copy, select-all, etc.) even though no character is inserted.
	 */
	function isKeypressCommand(nativeEvent) {
	  return (nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) &&
	  // ctrlKey && altKey is equivalent to AltGr, and is not a command.
	  !(nativeEvent.ctrlKey && nativeEvent.altKey);
	}
	
	/**
	 * Translate native top level events into event types.
	 *
	 * @param {string} topLevelType
	 * @return {object}
	 */
	function getCompositionEventType(topLevelType) {
	  switch (topLevelType) {
	    case 'topCompositionStart':
	      return eventTypes.compositionStart;
	    case 'topCompositionEnd':
	      return eventTypes.compositionEnd;
	    case 'topCompositionUpdate':
	      return eventTypes.compositionUpdate;
	  }
	}
	
	/**
	 * Does our fallback best-guess model think this event signifies that
	 * composition has begun?
	 *
	 * @param {string} topLevelType
	 * @param {object} nativeEvent
	 * @return {boolean}
	 */
	function isFallbackCompositionStart(topLevelType, nativeEvent) {
	  return topLevelType === 'topKeyDown' && nativeEvent.keyCode === START_KEYCODE;
	}
	
	/**
	 * Does our fallback mode think that this event is the end of composition?
	 *
	 * @param {string} topLevelType
	 * @param {object} nativeEvent
	 * @return {boolean}
	 */
	function isFallbackCompositionEnd(topLevelType, nativeEvent) {
	  switch (topLevelType) {
	    case 'topKeyUp':
	      // Command keys insert or clear IME input.
	      return END_KEYCODES.indexOf(nativeEvent.keyCode) !== -1;
	    case 'topKeyDown':
	      // Expect IME keyCode on each keydown. If we get any other
	      // code we must have exited earlier.
	      return nativeEvent.keyCode !== START_KEYCODE;
	    case 'topKeyPress':
	    case 'topMouseDown':
	    case 'topBlur':
	      // Events are not possible without cancelling IME.
	      return true;
	    default:
	      return false;
	  }
	}
	
	/**
	 * Google Input Tools provides composition data via a CustomEvent,
	 * with the `data` property populated in the `detail` object. If this
	 * is available on the event object, use it. If not, this is a plain
	 * composition event and we have nothing special to extract.
	 *
	 * @param {object} nativeEvent
	 * @return {?string}
	 */
	function getDataFromCustomEvent(nativeEvent) {
	  var detail = nativeEvent.detail;
	  if (typeof detail === 'object' && 'data' in detail) {
	    return detail.data;
	  }
	  return null;
	}
	
	// Track the current IME composition fallback object, if any.
	var currentComposition = null;
	
	/**
	 * @return {?object} A SyntheticCompositionEvent.
	 */
	function extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	  var eventType;
	  var fallbackData;
	
	  if (canUseCompositionEvent) {
	    eventType = getCompositionEventType(topLevelType);
	  } else if (!currentComposition) {
	    if (isFallbackCompositionStart(topLevelType, nativeEvent)) {
	      eventType = eventTypes.compositionStart;
	    }
	  } else if (isFallbackCompositionEnd(topLevelType, nativeEvent)) {
	    eventType = eventTypes.compositionEnd;
	  }
	
	  if (!eventType) {
	    return null;
	  }
	
	  if (useFallbackCompositionData) {
	    // The current composition is stored statically and must not be
	    // overwritten while composition continues.
	    if (!currentComposition && eventType === eventTypes.compositionStart) {
	      currentComposition = FallbackCompositionState.getPooled(nativeEventTarget);
	    } else if (eventType === eventTypes.compositionEnd) {
	      if (currentComposition) {
	        fallbackData = currentComposition.getData();
	      }
	    }
	  }
	
	  var event = SyntheticCompositionEvent.getPooled(eventType, targetInst, nativeEvent, nativeEventTarget);
	
	  if (fallbackData) {
	    // Inject data generated from fallback path into the synthetic event.
	    // This matches the property of native CompositionEventInterface.
	    event.data = fallbackData;
	  } else {
	    var customData = getDataFromCustomEvent(nativeEvent);
	    if (customData !== null) {
	      event.data = customData;
	    }
	  }
	
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	  return event;
	}
	
	/**
	 * @param {string} topLevelType Record from `EventConstants`.
	 * @param {object} nativeEvent Native browser event.
	 * @return {?string} The string corresponding to this `beforeInput` event.
	 */
	function getNativeBeforeInputChars(topLevelType, nativeEvent) {
	  switch (topLevelType) {
	    case 'topCompositionEnd':
	      return getDataFromCustomEvent(nativeEvent);
	    case 'topKeyPress':
	      /**
	       * If native `textInput` events are available, our goal is to make
	       * use of them. However, there is a special case: the spacebar key.
	       * In Webkit, preventing default on a spacebar `textInput` event
	       * cancels character insertion, but it *also* causes the browser
	       * to fall back to its default spacebar behavior of scrolling the
	       * page.
	       *
	       * Tracking at:
	       * https://code.google.com/p/chromium/issues/detail?id=355103
	       *
	       * To avoid this issue, use the keypress event as if no `textInput`
	       * event is available.
	       */
	      var which = nativeEvent.which;
	      if (which !== SPACEBAR_CODE) {
	        return null;
	      }
	
	      hasSpaceKeypress = true;
	      return SPACEBAR_CHAR;
	
	    case 'topTextInput':
	      // Record the characters to be added to the DOM.
	      var chars = nativeEvent.data;
	
	      // If it's a spacebar character, assume that we have already handled
	      // it at the keypress level and bail immediately. Android Chrome
	      // doesn't give us keycodes, so we need to blacklist it.
	      if (chars === SPACEBAR_CHAR && hasSpaceKeypress) {
	        return null;
	      }
	
	      return chars;
	
	    default:
	      // For other native event types, do nothing.
	      return null;
	  }
	}
	
	/**
	 * For browsers that do not provide the `textInput` event, extract the
	 * appropriate string to use for SyntheticInputEvent.
	 *
	 * @param {string} topLevelType Record from `EventConstants`.
	 * @param {object} nativeEvent Native browser event.
	 * @return {?string} The fallback string for this `beforeInput` event.
	 */
	function getFallbackBeforeInputChars(topLevelType, nativeEvent) {
	  // If we are currently composing (IME) and using a fallback to do so,
	  // try to extract the composed characters from the fallback object.
	  // If composition event is available, we extract a string only at
	  // compositionevent, otherwise extract it at fallback events.
	  if (currentComposition) {
	    if (topLevelType === 'topCompositionEnd' || !canUseCompositionEvent && isFallbackCompositionEnd(topLevelType, nativeEvent)) {
	      var chars = currentComposition.getData();
	      FallbackCompositionState.release(currentComposition);
	      currentComposition = null;
	      return chars;
	    }
	    return null;
	  }
	
	  switch (topLevelType) {
	    case 'topPaste':
	      // If a paste event occurs after a keypress, throw out the input
	      // chars. Paste events should not lead to BeforeInput events.
	      return null;
	    case 'topKeyPress':
	      /**
	       * As of v27, Firefox may fire keypress events even when no character
	       * will be inserted. A few possibilities:
	       *
	       * - `which` is `0`. Arrow keys, Esc key, etc.
	       *
	       * - `which` is the pressed key code, but no char is available.
	       *   Ex: 'AltGr + d` in Polish. There is no modified character for
	       *   this key combination and no character is inserted into the
	       *   document, but FF fires the keypress for char code `100` anyway.
	       *   No `input` event will occur.
	       *
	       * - `which` is the pressed key code, but a command combination is
	       *   being used. Ex: `Cmd+C`. No character is inserted, and no
	       *   `input` event will occur.
	       */
	      if (nativeEvent.which && !isKeypressCommand(nativeEvent)) {
	        return String.fromCharCode(nativeEvent.which);
	      }
	      return null;
	    case 'topCompositionEnd':
	      return useFallbackCompositionData ? null : nativeEvent.data;
	    default:
	      return null;
	  }
	}
	
	/**
	 * Extract a SyntheticInputEvent for `beforeInput`, based on either native
	 * `textInput` or fallback behavior.
	 *
	 * @return {?object} A SyntheticInputEvent.
	 */
	function extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	  var chars;
	
	  if (canUseTextInputEvent) {
	    chars = getNativeBeforeInputChars(topLevelType, nativeEvent);
	  } else {
	    chars = getFallbackBeforeInputChars(topLevelType, nativeEvent);
	  }
	
	  // If no characters are being inserted, no BeforeInput event should
	  // be fired.
	  if (!chars) {
	    return null;
	  }
	
	  var event = SyntheticInputEvent.getPooled(eventTypes.beforeInput, targetInst, nativeEvent, nativeEventTarget);
	
	  event.data = chars;
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	  return event;
	}
	
	/**
	 * Create an `onBeforeInput` event to match
	 * http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105/#events-inputevents.
	 *
	 * This event plugin is based on the native `textInput` event
	 * available in Chrome, Safari, Opera, and IE. This event fires after
	 * `onKeyPress` and `onCompositionEnd`, but before `onInput`.
	 *
	 * `beforeInput` is spec'd but not implemented in any browsers, and
	 * the `input` event does not provide any useful information about what has
	 * actually been added, contrary to the spec. Thus, `textInput` is the best
	 * available event to identify the characters that have actually been inserted
	 * into the target node.
	 *
	 * This plugin is also responsible for emitting `composition` events, thus
	 * allowing us to share composition fallback code for both `beforeInput` and
	 * `composition` event types.
	 */
	var BeforeInputEventPlugin = {
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    return [extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget), extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget)];
	  }
	};
	
	module.exports = BeforeInputEventPlugin;

/***/ }),
/* 420 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var CSSProperty = __webpack_require__(196);
	var ExecutionEnvironment = __webpack_require__(16);
	var ReactInstrumentation = __webpack_require__(25);
	
	var camelizeStyleName = __webpack_require__(386);
	var dangerousStyleValue = __webpack_require__(471);
	var hyphenateStyleName = __webpack_require__(393);
	var memoizeStringOnly = __webpack_require__(396);
	var warning = __webpack_require__(5);
	
	var processStyleName = memoizeStringOnly(function (styleName) {
	  return hyphenateStyleName(styleName);
	});
	
	var hasShorthandPropertyBug = false;
	var styleFloatAccessor = 'cssFloat';
	if (ExecutionEnvironment.canUseDOM) {
	  var tempStyle = document.createElement('div').style;
	  try {
	    // IE8 throws "Invalid argument." if resetting shorthand style properties.
	    tempStyle.font = '';
	  } catch (e) {
	    hasShorthandPropertyBug = true;
	  }
	  // IE8 only supports accessing cssFloat (standard) as styleFloat
	  if (document.documentElement.style.cssFloat === undefined) {
	    styleFloatAccessor = 'styleFloat';
	  }
	}
	
	if (false) {
	  // 'msTransform' is correct, but the other prefixes should be capitalized
	  var badVendoredStyleNamePattern = /^(?:webkit|moz|o)[A-Z]/;
	
	  // style values shouldn't contain a semicolon
	  var badStyleValueWithSemicolonPattern = /;\s*$/;
	
	  var warnedStyleNames = {};
	  var warnedStyleValues = {};
	  var warnedForNaNValue = false;
	
	  var warnHyphenatedStyleName = function (name, owner) {
	    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
	      return;
	    }
	
	    warnedStyleNames[name] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported style property %s. Did you mean %s?%s', name, camelizeStyleName(name), checkRenderMessage(owner)) : void 0;
	  };
	
	  var warnBadVendoredStyleName = function (name, owner) {
	    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
	      return;
	    }
	
	    warnedStyleNames[name] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported vendor-prefixed style property %s. Did you mean %s?%s', name, name.charAt(0).toUpperCase() + name.slice(1), checkRenderMessage(owner)) : void 0;
	  };
	
	  var warnStyleValueWithSemicolon = function (name, value, owner) {
	    if (warnedStyleValues.hasOwnProperty(value) && warnedStyleValues[value]) {
	      return;
	    }
	
	    warnedStyleValues[value] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, "Style property values shouldn't contain a semicolon.%s " + 'Try "%s: %s" instead.', checkRenderMessage(owner), name, value.replace(badStyleValueWithSemicolonPattern, '')) : void 0;
	  };
	
	  var warnStyleValueIsNaN = function (name, value, owner) {
	    if (warnedForNaNValue) {
	      return;
	    }
	
	    warnedForNaNValue = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, '`NaN` is an invalid value for the `%s` css style property.%s', name, checkRenderMessage(owner)) : void 0;
	  };
	
	  var checkRenderMessage = function (owner) {
	    if (owner) {
	      var name = owner.getName();
	      if (name) {
	        return ' Check the render method of `' + name + '`.';
	      }
	    }
	    return '';
	  };
	
	  /**
	   * @param {string} name
	   * @param {*} value
	   * @param {ReactDOMComponent} component
	   */
	  var warnValidStyle = function (name, value, component) {
	    var owner;
	    if (component) {
	      owner = component._currentElement._owner;
	    }
	    if (name.indexOf('-') > -1) {
	      warnHyphenatedStyleName(name, owner);
	    } else if (badVendoredStyleNamePattern.test(name)) {
	      warnBadVendoredStyleName(name, owner);
	    } else if (badStyleValueWithSemicolonPattern.test(value)) {
	      warnStyleValueWithSemicolon(name, value, owner);
	    }
	
	    if (typeof value === 'number' && isNaN(value)) {
	      warnStyleValueIsNaN(name, value, owner);
	    }
	  };
	}
	
	/**
	 * Operations for dealing with CSS properties.
	 */
	var CSSPropertyOperations = {
	  /**
	   * Serializes a mapping of style properties for use as inline styles:
	   *
	   *   > createMarkupForStyles({width: '200px', height: 0})
	   *   "width:200px;height:0;"
	   *
	   * Undefined values are ignored so that declarative programming is easier.
	   * The result should be HTML-escaped before insertion into the DOM.
	   *
	   * @param {object} styles
	   * @param {ReactDOMComponent} component
	   * @return {?string}
	   */
	  createMarkupForStyles: function (styles, component) {
	    var serialized = '';
	    for (var styleName in styles) {
	      if (!styles.hasOwnProperty(styleName)) {
	        continue;
	      }
	      var isCustomProperty = styleName.indexOf('--') === 0;
	      var styleValue = styles[styleName];
	      if (false) {
	        if (!isCustomProperty) {
	          warnValidStyle(styleName, styleValue, component);
	        }
	      }
	      if (styleValue != null) {
	        serialized += processStyleName(styleName) + ':';
	        serialized += dangerousStyleValue(styleName, styleValue, component, isCustomProperty) + ';';
	      }
	    }
	    return serialized || null;
	  },
	
	  /**
	   * Sets the value for multiple styles on a node.  If a value is specified as
	   * '' (empty string), the corresponding style property will be unset.
	   *
	   * @param {DOMElement} node
	   * @param {object} styles
	   * @param {ReactDOMComponent} component
	   */
	  setValueForStyles: function (node, styles, component) {
	    if (false) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: component._debugID,
	        type: 'update styles',
	        payload: styles
	      });
	    }
	
	    var style = node.style;
	    for (var styleName in styles) {
	      if (!styles.hasOwnProperty(styleName)) {
	        continue;
	      }
	      var isCustomProperty = styleName.indexOf('--') === 0;
	      if (false) {
	        if (!isCustomProperty) {
	          warnValidStyle(styleName, styles[styleName], component);
	        }
	      }
	      var styleValue = dangerousStyleValue(styleName, styles[styleName], component, isCustomProperty);
	      if (styleName === 'float' || styleName === 'cssFloat') {
	        styleName = styleFloatAccessor;
	      }
	      if (isCustomProperty) {
	        style.setProperty(styleName, styleValue);
	      } else if (styleValue) {
	        style[styleName] = styleValue;
	      } else {
	        var expansion = hasShorthandPropertyBug && CSSProperty.shorthandPropertyExpansions[styleName];
	        if (expansion) {
	          // Shorthand property that IE8 won't like unsetting, so unset each
	          // component to placate it
	          for (var individualStyleName in expansion) {
	            style[individualStyleName] = '';
	          }
	        } else {
	          style[styleName] = '';
	        }
	      }
	    }
	  }
	};
	
	module.exports = CSSPropertyOperations;

/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var EventPluginHub = __webpack_require__(59);
	var EventPropagators = __webpack_require__(60);
	var ExecutionEnvironment = __webpack_require__(16);
	var ReactDOMComponentTree = __webpack_require__(9);
	var ReactUpdates = __webpack_require__(28);
	var SyntheticEvent = __webpack_require__(31);
	
	var inputValueTracking = __webpack_require__(212);
	var getEventTarget = __webpack_require__(129);
	var isEventSupported = __webpack_require__(130);
	var isTextInputElement = __webpack_require__(214);
	
	var eventTypes = {
	  change: {
	    phasedRegistrationNames: {
	      bubbled: 'onChange',
	      captured: 'onChangeCapture'
	    },
	    dependencies: ['topBlur', 'topChange', 'topClick', 'topFocus', 'topInput', 'topKeyDown', 'topKeyUp', 'topSelectionChange']
	  }
	};
	
	function createAndAccumulateChangeEvent(inst, nativeEvent, target) {
	  var event = SyntheticEvent.getPooled(eventTypes.change, inst, nativeEvent, target);
	  event.type = 'change';
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	  return event;
	}
	/**
	 * For IE shims
	 */
	var activeElement = null;
	var activeElementInst = null;
	
	/**
	 * SECTION: handle `change` event
	 */
	function shouldUseChangeEvent(elem) {
	  var nodeName = elem.nodeName && elem.nodeName.toLowerCase();
	  return nodeName === 'select' || nodeName === 'input' && elem.type === 'file';
	}
	
	var doesChangeEventBubble = false;
	if (ExecutionEnvironment.canUseDOM) {
	  // See `handleChange` comment below
	  doesChangeEventBubble = isEventSupported('change') && (!document.documentMode || document.documentMode > 8);
	}
	
	function manualDispatchChangeEvent(nativeEvent) {
	  var event = createAndAccumulateChangeEvent(activeElementInst, nativeEvent, getEventTarget(nativeEvent));
	
	  // If change and propertychange bubbled, we'd just bind to it like all the
	  // other events and have it go through ReactBrowserEventEmitter. Since it
	  // doesn't, we manually listen for the events and so we have to enqueue and
	  // process the abstract event manually.
	  //
	  // Batching is necessary here in order to ensure that all event handlers run
	  // before the next rerender (including event handlers attached to ancestor
	  // elements instead of directly on the input). Without this, controlled
	  // components don't work properly in conjunction with event bubbling because
	  // the component is rerendered and the value reverted before all the event
	  // handlers can run. See https://github.com/facebook/react/issues/708.
	  ReactUpdates.batchedUpdates(runEventInBatch, event);
	}
	
	function runEventInBatch(event) {
	  EventPluginHub.enqueueEvents(event);
	  EventPluginHub.processEventQueue(false);
	}
	
	function startWatchingForChangeEventIE8(target, targetInst) {
	  activeElement = target;
	  activeElementInst = targetInst;
	  activeElement.attachEvent('onchange', manualDispatchChangeEvent);
	}
	
	function stopWatchingForChangeEventIE8() {
	  if (!activeElement) {
	    return;
	  }
	  activeElement.detachEvent('onchange', manualDispatchChangeEvent);
	  activeElement = null;
	  activeElementInst = null;
	}
	
	function getInstIfValueChanged(targetInst, nativeEvent) {
	  var updated = inputValueTracking.updateValueIfChanged(targetInst);
	  var simulated = nativeEvent.simulated === true && ChangeEventPlugin._allowSimulatedPassThrough;
	
	  if (updated || simulated) {
	    return targetInst;
	  }
	}
	
	function getTargetInstForChangeEvent(topLevelType, targetInst) {
	  if (topLevelType === 'topChange') {
	    return targetInst;
	  }
	}
	
	function handleEventsForChangeEventIE8(topLevelType, target, targetInst) {
	  if (topLevelType === 'topFocus') {
	    // stopWatching() should be a noop here but we call it just in case we
	    // missed a blur event somehow.
	    stopWatchingForChangeEventIE8();
	    startWatchingForChangeEventIE8(target, targetInst);
	  } else if (topLevelType === 'topBlur') {
	    stopWatchingForChangeEventIE8();
	  }
	}
	
	/**
	 * SECTION: handle `input` event
	 */
	var isInputEventSupported = false;
	if (ExecutionEnvironment.canUseDOM) {
	  // IE9 claims to support the input event but fails to trigger it when
	  // deleting text, so we ignore its input events.
	
	  isInputEventSupported = isEventSupported('input') && (!document.documentMode || document.documentMode > 9);
	}
	
	/**
	 * (For IE <=9) Starts tracking propertychange events on the passed-in element
	 * and override the value property so that we can distinguish user events from
	 * value changes in JS.
	 */
	function startWatchingForValueChange(target, targetInst) {
	  activeElement = target;
	  activeElementInst = targetInst;
	  activeElement.attachEvent('onpropertychange', handlePropertyChange);
	}
	
	/**
	 * (For IE <=9) Removes the event listeners from the currently-tracked element,
	 * if any exists.
	 */
	function stopWatchingForValueChange() {
	  if (!activeElement) {
	    return;
	  }
	  activeElement.detachEvent('onpropertychange', handlePropertyChange);
	
	  activeElement = null;
	  activeElementInst = null;
	}
	
	/**
	 * (For IE <=9) Handles a propertychange event, sending a `change` event if
	 * the value of the active element has changed.
	 */
	function handlePropertyChange(nativeEvent) {
	  if (nativeEvent.propertyName !== 'value') {
	    return;
	  }
	  if (getInstIfValueChanged(activeElementInst, nativeEvent)) {
	    manualDispatchChangeEvent(nativeEvent);
	  }
	}
	
	function handleEventsForInputEventPolyfill(topLevelType, target, targetInst) {
	  if (topLevelType === 'topFocus') {
	    // In IE8, we can capture almost all .value changes by adding a
	    // propertychange handler and looking for events with propertyName
	    // equal to 'value'
	    // In IE9, propertychange fires for most input events but is buggy and
	    // doesn't fire when text is deleted, but conveniently, selectionchange
	    // appears to fire in all of the remaining cases so we catch those and
	    // forward the event if the value has changed
	    // In either case, we don't want to call the event handler if the value
	    // is changed from JS so we redefine a setter for `.value` that updates
	    // our activeElementValue variable, allowing us to ignore those changes
	    //
	    // stopWatching() should be a noop here but we call it just in case we
	    // missed a blur event somehow.
	    stopWatchingForValueChange();
	    startWatchingForValueChange(target, targetInst);
	  } else if (topLevelType === 'topBlur') {
	    stopWatchingForValueChange();
	  }
	}
	
	// For IE8 and IE9.
	function getTargetInstForInputEventPolyfill(topLevelType, targetInst, nativeEvent) {
	  if (topLevelType === 'topSelectionChange' || topLevelType === 'topKeyUp' || topLevelType === 'topKeyDown') {
	    // On the selectionchange event, the target is just document which isn't
	    // helpful for us so just check activeElement instead.
	    //
	    // 99% of the time, keydown and keyup aren't necessary. IE8 fails to fire
	    // propertychange on the first input event after setting `value` from a
	    // script and fires only keydown, keypress, keyup. Catching keyup usually
	    // gets it and catching keydown lets us fire an event for the first
	    // keystroke if user does a key repeat (it'll be a little delayed: right
	    // before the second keystroke). Other input methods (e.g., paste) seem to
	    // fire selectionchange normally.
	    return getInstIfValueChanged(activeElementInst, nativeEvent);
	  }
	}
	
	/**
	 * SECTION: handle `click` event
	 */
	function shouldUseClickEvent(elem) {
	  // Use the `click` event to detect changes to checkbox and radio inputs.
	  // This approach works across all browsers, whereas `change` does not fire
	  // until `blur` in IE8.
	  var nodeName = elem.nodeName;
	  return nodeName && nodeName.toLowerCase() === 'input' && (elem.type === 'checkbox' || elem.type === 'radio');
	}
	
	function getTargetInstForClickEvent(topLevelType, targetInst, nativeEvent) {
	  if (topLevelType === 'topClick') {
	    return getInstIfValueChanged(targetInst, nativeEvent);
	  }
	}
	
	function getTargetInstForInputOrChangeEvent(topLevelType, targetInst, nativeEvent) {
	  if (topLevelType === 'topInput' || topLevelType === 'topChange') {
	    return getInstIfValueChanged(targetInst, nativeEvent);
	  }
	}
	
	function handleControlledInputBlur(inst, node) {
	  // TODO: In IE, inst is occasionally null. Why?
	  if (inst == null) {
	    return;
	  }
	
	  // Fiber and ReactDOM keep wrapper state in separate places
	  var state = inst._wrapperState || node._wrapperState;
	
	  if (!state || !state.controlled || node.type !== 'number') {
	    return;
	  }
	
	  // If controlled, assign the value attribute to the current value on blur
	  var value = '' + node.value;
	  if (node.getAttribute('value') !== value) {
	    node.setAttribute('value', value);
	  }
	}
	
	/**
	 * This plugin creates an `onChange` event that normalizes change events
	 * across form elements. This event fires at a time when it's possible to
	 * change the element's value without seeing a flicker.
	 *
	 * Supported elements are:
	 * - input (see `isTextInputElement`)
	 * - textarea
	 * - select
	 */
	var ChangeEventPlugin = {
	  eventTypes: eventTypes,
	
	  _allowSimulatedPassThrough: true,
	  _isInputEventSupported: isInputEventSupported,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var targetNode = targetInst ? ReactDOMComponentTree.getNodeFromInstance(targetInst) : window;
	
	    var getTargetInstFunc, handleEventFunc;
	    if (shouldUseChangeEvent(targetNode)) {
	      if (doesChangeEventBubble) {
	        getTargetInstFunc = getTargetInstForChangeEvent;
	      } else {
	        handleEventFunc = handleEventsForChangeEventIE8;
	      }
	    } else if (isTextInputElement(targetNode)) {
	      if (isInputEventSupported) {
	        getTargetInstFunc = getTargetInstForInputOrChangeEvent;
	      } else {
	        getTargetInstFunc = getTargetInstForInputEventPolyfill;
	        handleEventFunc = handleEventsForInputEventPolyfill;
	      }
	    } else if (shouldUseClickEvent(targetNode)) {
	      getTargetInstFunc = getTargetInstForClickEvent;
	    }
	
	    if (getTargetInstFunc) {
	      var inst = getTargetInstFunc(topLevelType, targetInst, nativeEvent);
	      if (inst) {
	        var event = createAndAccumulateChangeEvent(inst, nativeEvent, nativeEventTarget);
	        return event;
	      }
	    }
	
	    if (handleEventFunc) {
	      handleEventFunc(topLevelType, targetNode, targetInst);
	    }
	
	    // When blurring, set the value attribute for number inputs
	    if (topLevelType === 'topBlur') {
	      handleControlledInputBlur(targetInst, targetNode);
	    }
	  }
	};
	
	module.exports = ChangeEventPlugin;

/***/ }),
/* 422 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(6);
	
	var DOMLazyTree = __webpack_require__(44);
	var ExecutionEnvironment = __webpack_require__(16);
	
	var createNodesFromMarkup = __webpack_require__(389);
	var emptyFunction = __webpack_require__(24);
	var invariant = __webpack_require__(3);
	
	var Danger = {
	  /**
	   * Replaces a node with a string of markup at its current position within its
	   * parent. The markup must render into a single root node.
	   *
	   * @param {DOMElement} oldChild Child node to replace.
	   * @param {string} markup Markup to render in place of the child node.
	   * @internal
	   */
	  dangerouslyReplaceNodeWithMarkup: function (oldChild, markup) {
	    !ExecutionEnvironment.canUseDOM ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot render markup in a worker thread. Make sure `window` and `document` are available globally before requiring React when unit testing or use ReactDOMServer.renderToString() for server rendering.') : _prodInvariant('56') : void 0;
	    !markup ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Missing markup.') : _prodInvariant('57') : void 0;
	    !(oldChild.nodeName !== 'HTML') ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot replace markup of the <html> node. This is because browser quirks make this unreliable and/or slow. If you want to render to the root you must use server rendering. See ReactDOMServer.renderToString().') : _prodInvariant('58') : void 0;
	
	    if (typeof markup === 'string') {
	      var newChild = createNodesFromMarkup(markup, emptyFunction)[0];
	      oldChild.parentNode.replaceChild(newChild, oldChild);
	    } else {
	      DOMLazyTree.replaceChildWithTree(oldChild, markup);
	    }
	  }
	};
	
	module.exports = Danger;

/***/ }),
/* 423 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Module that is injectable into `EventPluginHub`, that specifies a
	 * deterministic ordering of `EventPlugin`s. A convenient way to reason about
	 * plugins, without having to package every one of them. This is better than
	 * having plugins be ordered in the same order that they are injected because
	 * that ordering would be influenced by the packaging order.
	 * `ResponderEventPlugin` must occur before `SimpleEventPlugin` so that
	 * preventing default on events is convenient in `SimpleEventPlugin` handlers.
	 */
	
	var DefaultEventPluginOrder = ['ResponderEventPlugin', 'SimpleEventPlugin', 'TapEventPlugin', 'EnterLeaveEventPlugin', 'ChangeEventPlugin', 'SelectEventPlugin', 'BeforeInputEventPlugin'];
	
	module.exports = DefaultEventPluginOrder;

/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var EventPropagators = __webpack_require__(60);
	var ReactDOMComponentTree = __webpack_require__(9);
	var SyntheticMouseEvent = __webpack_require__(84);
	
	var eventTypes = {
	  mouseEnter: {
	    registrationName: 'onMouseEnter',
	    dependencies: ['topMouseOut', 'topMouseOver']
	  },
	  mouseLeave: {
	    registrationName: 'onMouseLeave',
	    dependencies: ['topMouseOut', 'topMouseOver']
	  }
	};
	
	var EnterLeaveEventPlugin = {
	  eventTypes: eventTypes,
	
	  /**
	   * For almost every interaction we care about, there will be both a top-level
	   * `mouseover` and `mouseout` event that occurs. Only use `mouseout` so that
	   * we do not extract duplicate events. However, moving the mouse into the
	   * browser from outside will not fire a `mouseout` event. In this case, we use
	   * the `mouseover` top-level event.
	   */
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    if (topLevelType === 'topMouseOver' && (nativeEvent.relatedTarget || nativeEvent.fromElement)) {
	      return null;
	    }
	    if (topLevelType !== 'topMouseOut' && topLevelType !== 'topMouseOver') {
	      // Must not be a mouse in or mouse out - ignoring.
	      return null;
	    }
	
	    var win;
	    if (nativeEventTarget.window === nativeEventTarget) {
	      // `nativeEventTarget` is probably a window object.
	      win = nativeEventTarget;
	    } else {
	      // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
	      var doc = nativeEventTarget.ownerDocument;
	      if (doc) {
	        win = doc.defaultView || doc.parentWindow;
	      } else {
	        win = window;
	      }
	    }
	
	    var from;
	    var to;
	    if (topLevelType === 'topMouseOut') {
	      from = targetInst;
	      var related = nativeEvent.relatedTarget || nativeEvent.toElement;
	      to = related ? ReactDOMComponentTree.getClosestInstanceFromNode(related) : null;
	    } else {
	      // Moving to a node from outside the window.
	      from = null;
	      to = targetInst;
	    }
	
	    if (from === to) {
	      // Nothing pertains to our managed components.
	      return null;
	    }
	
	    var fromNode = from == null ? win : ReactDOMComponentTree.getNodeFromInstance(from);
	    var toNode = to == null ? win : ReactDOMComponentTree.getNodeFromInstance(to);
	
	    var leave = SyntheticMouseEvent.getPooled(eventTypes.mouseLeave, from, nativeEvent, nativeEventTarget);
	    leave.type = 'mouseleave';
	    leave.target = fromNode;
	    leave.relatedTarget = toNode;
	
	    var enter = SyntheticMouseEvent.getPooled(eventTypes.mouseEnter, to, nativeEvent, nativeEventTarget);
	    enter.type = 'mouseenter';
	    enter.target = toNode;
	    enter.relatedTarget = fromNode;
	
	    EventPropagators.accumulateEnterLeaveDispatches(leave, enter, from, to);
	
	    return [leave, enter];
	  }
	};
	
	module.exports = EnterLeaveEventPlugin;

/***/ }),
/* 425 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(7);
	
	var PooledClass = __webpack_require__(38);
	
	var getTextContentAccessor = __webpack_require__(211);
	
	/**
	 * This helper class stores information about text content of a target node,
	 * allowing comparison of content before and after a given event.
	 *
	 * Identify the node where selection currently begins, then observe
	 * both its text content and its current position in the DOM. Since the
	 * browser may natively replace the target node during composition, we can
	 * use its position to find its replacement.
	 *
	 * @param {DOMEventTarget} root
	 */
	function FallbackCompositionState(root) {
	  this._root = root;
	  this._startText = this.getText();
	  this._fallbackText = null;
	}
	
	_assign(FallbackCompositionState.prototype, {
	  destructor: function () {
	    this._root = null;
	    this._startText = null;
	    this._fallbackText = null;
	  },
	
	  /**
	   * Get current text of input.
	   *
	   * @return {string}
	   */
	  getText: function () {
	    if ('value' in this._root) {
	      return this._root.value;
	    }
	    return this._root[getTextContentAccessor()];
	  },
	
	  /**
	   * Determine the differing substring between the initially stored
	   * text content and the current content.
	   *
	   * @return {string}
	   */
	  getData: function () {
	    if (this._fallbackText) {
	      return this._fallbackText;
	    }
	
	    var start;
	    var startValue = this._startText;
	    var startLength = startValue.length;
	    var end;
	    var endValue = this.getText();
	    var endLength = endValue.length;
	
	    for (start = 0; start < startLength; start++) {
	      if (startValue[start] !== endValue[start]) {
	        break;
	      }
	    }
	
	    var minEnd = startLength - start;
	    for (end = 1; end <= minEnd; end++) {
	      if (startValue[startLength - end] !== endValue[endLength - end]) {
	        break;
	      }
	    }
	
	    var sliceTail = end > 1 ? 1 - end : undefined;
	    this._fallbackText = endValue.slice(start, sliceTail);
	    return this._fallbackText;
	  }
	});
	
	PooledClass.addPoolingTo(FallbackCompositionState);
	
	module.exports = FallbackCompositionState;

/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(45);
	
	var MUST_USE_PROPERTY = DOMProperty.injection.MUST_USE_PROPERTY;
	var HAS_BOOLEAN_VALUE = DOMProperty.injection.HAS_BOOLEAN_VALUE;
	var HAS_NUMERIC_VALUE = DOMProperty.injection.HAS_NUMERIC_VALUE;
	var HAS_POSITIVE_NUMERIC_VALUE = DOMProperty.injection.HAS_POSITIVE_NUMERIC_VALUE;
	var HAS_OVERLOADED_BOOLEAN_VALUE = DOMProperty.injection.HAS_OVERLOADED_BOOLEAN_VALUE;
	
	var HTMLDOMPropertyConfig = {
	  isCustomAttribute: RegExp.prototype.test.bind(new RegExp('^(data|aria)-[' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$')),
	  Properties: {
	    /**
	     * Standard Properties
	     */
	    accept: 0,
	    acceptCharset: 0,
	    accessKey: 0,
	    action: 0,
	    allowFullScreen: HAS_BOOLEAN_VALUE,
	    allowTransparency: 0,
	    alt: 0,
	    // specifies target context for links with `preload` type
	    as: 0,
	    async: HAS_BOOLEAN_VALUE,
	    autoComplete: 0,
	    // autoFocus is polyfilled/normalized by AutoFocusUtils
	    // autoFocus: HAS_BOOLEAN_VALUE,
	    autoPlay: HAS_BOOLEAN_VALUE,
	    capture: HAS_BOOLEAN_VALUE,
	    cellPadding: 0,
	    cellSpacing: 0,
	    charSet: 0,
	    challenge: 0,
	    checked: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    cite: 0,
	    classID: 0,
	    className: 0,
	    cols: HAS_POSITIVE_NUMERIC_VALUE,
	    colSpan: 0,
	    content: 0,
	    contentEditable: 0,
	    contextMenu: 0,
	    controls: HAS_BOOLEAN_VALUE,
	    controlsList: 0,
	    coords: 0,
	    crossOrigin: 0,
	    data: 0, // For `<object />` acts as `src`.
	    dateTime: 0,
	    'default': HAS_BOOLEAN_VALUE,
	    defer: HAS_BOOLEAN_VALUE,
	    dir: 0,
	    disabled: HAS_BOOLEAN_VALUE,
	    download: HAS_OVERLOADED_BOOLEAN_VALUE,
	    draggable: 0,
	    encType: 0,
	    form: 0,
	    formAction: 0,
	    formEncType: 0,
	    formMethod: 0,
	    formNoValidate: HAS_BOOLEAN_VALUE,
	    formTarget: 0,
	    frameBorder: 0,
	    headers: 0,
	    height: 0,
	    hidden: HAS_BOOLEAN_VALUE,
	    high: 0,
	    href: 0,
	    hrefLang: 0,
	    htmlFor: 0,
	    httpEquiv: 0,
	    icon: 0,
	    id: 0,
	    inputMode: 0,
	    integrity: 0,
	    is: 0,
	    keyParams: 0,
	    keyType: 0,
	    kind: 0,
	    label: 0,
	    lang: 0,
	    list: 0,
	    loop: HAS_BOOLEAN_VALUE,
	    low: 0,
	    manifest: 0,
	    marginHeight: 0,
	    marginWidth: 0,
	    max: 0,
	    maxLength: 0,
	    media: 0,
	    mediaGroup: 0,
	    method: 0,
	    min: 0,
	    minLength: 0,
	    // Caution; `option.selected` is not updated if `select.multiple` is
	    // disabled with `removeAttribute`.
	    multiple: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    muted: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    name: 0,
	    nonce: 0,
	    noValidate: HAS_BOOLEAN_VALUE,
	    open: HAS_BOOLEAN_VALUE,
	    optimum: 0,
	    pattern: 0,
	    placeholder: 0,
	    playsInline: HAS_BOOLEAN_VALUE,
	    poster: 0,
	    preload: 0,
	    profile: 0,
	    radioGroup: 0,
	    readOnly: HAS_BOOLEAN_VALUE,
	    referrerPolicy: 0,
	    rel: 0,
	    required: HAS_BOOLEAN_VALUE,
	    reversed: HAS_BOOLEAN_VALUE,
	    role: 0,
	    rows: HAS_POSITIVE_NUMERIC_VALUE,
	    rowSpan: HAS_NUMERIC_VALUE,
	    sandbox: 0,
	    scope: 0,
	    scoped: HAS_BOOLEAN_VALUE,
	    scrolling: 0,
	    seamless: HAS_BOOLEAN_VALUE,
	    selected: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    shape: 0,
	    size: HAS_POSITIVE_NUMERIC_VALUE,
	    sizes: 0,
	    span: HAS_POSITIVE_NUMERIC_VALUE,
	    spellCheck: 0,
	    src: 0,
	    srcDoc: 0,
	    srcLang: 0,
	    srcSet: 0,
	    start: HAS_NUMERIC_VALUE,
	    step: 0,
	    style: 0,
	    summary: 0,
	    tabIndex: 0,
	    target: 0,
	    title: 0,
	    // Setting .type throws on non-<input> tags
	    type: 0,
	    useMap: 0,
	    value: 0,
	    width: 0,
	    wmode: 0,
	    wrap: 0,
	
	    /**
	     * RDFa Properties
	     */
	    about: 0,
	    datatype: 0,
	    inlist: 0,
	    prefix: 0,
	    // property is also supported for OpenGraph in meta tags.
	    property: 0,
	    resource: 0,
	    'typeof': 0,
	    vocab: 0,
	
	    /**
	     * Non-standard Properties
	     */
	    // autoCapitalize and autoCorrect are supported in Mobile Safari for
	    // keyboard hints.
	    autoCapitalize: 0,
	    autoCorrect: 0,
	    // autoSave allows WebKit/Blink to persist values of input fields on page reloads
	    autoSave: 0,
	    // color is for Safari mask-icon link
	    color: 0,
	    // itemProp, itemScope, itemType are for
	    // Microdata support. See http://schema.org/docs/gs.html
	    itemProp: 0,
	    itemScope: HAS_BOOLEAN_VALUE,
	    itemType: 0,
	    // itemID and itemRef are for Microdata support as well but
	    // only specified in the WHATWG spec document. See
	    // https://html.spec.whatwg.org/multipage/microdata.html#microdata-dom-api
	    itemID: 0,
	    itemRef: 0,
	    // results show looking glass icon and recent searches on input
	    // search fields in WebKit/Blink
	    results: 0,
	    // IE-only attribute that specifies security restrictions on an iframe
	    // as an alternative to the sandbox attribute on IE<10
	    security: 0,
	    // IE-only attribute that controls focus behavior
	    unselectable: 0
	  },
	  DOMAttributeNames: {
	    acceptCharset: 'accept-charset',
	    className: 'class',
	    htmlFor: 'for',
	    httpEquiv: 'http-equiv'
	  },
	  DOMPropertyNames: {},
	  DOMMutationMethods: {
	    value: function (node, value) {
	      if (value == null) {
	        return node.removeAttribute('value');
	      }
	
	      // Number inputs get special treatment due to some edge cases in
	      // Chrome. Let everything else assign the value attribute as normal.
	      // https://github.com/facebook/react/issues/7253#issuecomment-236074326
	      if (node.type !== 'number' || node.hasAttribute('value') === false) {
	        node.setAttribute('value', '' + value);
	      } else if (node.validity && !node.validity.badInput && node.ownerDocument.activeElement !== node) {
	        // Don't assign an attribute if validation reports bad
	        // input. Chrome will clear the value. Additionally, don't
	        // operate on inputs that have focus, otherwise Chrome might
	        // strip off trailing decimal places and cause the user's
	        // cursor position to jump to the beginning of the input.
	        //
	        // In ReactDOMInput, we have an onBlur event that will trigger
	        // this function again when focus is lost.
	        node.setAttribute('value', '' + value);
	      }
	    }
	  }
	};
	
	module.exports = HTMLDOMPropertyConfig;

/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactReconciler = __webpack_require__(46);
	
	var instantiateReactComponent = __webpack_require__(213);
	var KeyEscapeUtils = __webpack_require__(121);
	var shouldUpdateReactComponent = __webpack_require__(131);
	var traverseAllChildren = __webpack_require__(216);
	var warning = __webpack_require__(5);
	
	var ReactComponentTreeHook;
	
	if (typeof process !== 'undefined' && process.env && ("production") === 'test') {
	  // Temporary hack.
	  // Inline requires don't work well with Jest:
	  // https://github.com/facebook/react/issues/7240
	  // Remove the inline requires when we don't need them anymore:
	  // https://github.com/facebook/react/pull/7178
	  ReactComponentTreeHook = __webpack_require__(218);
	}
	
	function instantiateChild(childInstances, child, name, selfDebugID) {
	  // We found a component instance.
	  var keyUnique = childInstances[name] === undefined;
	  if (false) {
	    if (!ReactComponentTreeHook) {
	      ReactComponentTreeHook = require('react/lib/ReactComponentTreeHook');
	    }
	    if (!keyUnique) {
	      process.env.NODE_ENV !== 'production' ? warning(false, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeHook.getStackAddendumByID(selfDebugID)) : void 0;
	    }
	  }
	  if (child != null && keyUnique) {
	    childInstances[name] = instantiateReactComponent(child, true);
	  }
	}
	
	/**
	 * ReactChildReconciler provides helpers for initializing or updating a set of
	 * children. Its output is suitable for passing it onto ReactMultiChild which
	 * does diffed reordering and insertion.
	 */
	var ReactChildReconciler = {
	  /**
	   * Generates a "mount image" for each of the supplied children. In the case
	   * of `ReactDOMComponent`, a mount image is a string of markup.
	   *
	   * @param {?object} nestedChildNodes Nested child maps.
	   * @return {?object} A set of child instances.
	   * @internal
	   */
	  instantiateChildren: function (nestedChildNodes, transaction, context, selfDebugID) // 0 in production and for roots
	  {
	    if (nestedChildNodes == null) {
	      return null;
	    }
	    var childInstances = {};
	
	    if (false) {
	      traverseAllChildren(nestedChildNodes, function (childInsts, child, name) {
	        return instantiateChild(childInsts, child, name, selfDebugID);
	      }, childInstances);
	    } else {
	      traverseAllChildren(nestedChildNodes, instantiateChild, childInstances);
	    }
	    return childInstances;
	  },
	
	  /**
	   * Updates the rendered children and returns a new set of children.
	   *
	   * @param {?object} prevChildren Previously initialized set of children.
	   * @param {?object} nextChildren Flat child element maps.
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   * @return {?object} A new set of child instances.
	   * @internal
	   */
	  updateChildren: function (prevChildren, nextChildren, mountImages, removedNodes, transaction, hostParent, hostContainerInfo, context, selfDebugID) // 0 in production and for roots
	  {
	    // We currently don't have a way to track moves here but if we use iterators
	    // instead of for..in we can zip the iterators and check if an item has
	    // moved.
	    // TODO: If nothing has changed, return the prevChildren object so that we
	    // can quickly bailout if nothing has changed.
	    if (!nextChildren && !prevChildren) {
	      return;
	    }
	    var name;
	    var prevChild;
	    for (name in nextChildren) {
	      if (!nextChildren.hasOwnProperty(name)) {
	        continue;
	      }
	      prevChild = prevChildren && prevChildren[name];
	      var prevElement = prevChild && prevChild._currentElement;
	      var nextElement = nextChildren[name];
	      if (prevChild != null && shouldUpdateReactComponent(prevElement, nextElement)) {
	        ReactReconciler.receiveComponent(prevChild, nextElement, transaction, context);
	        nextChildren[name] = prevChild;
	      } else {
	        if (prevChild) {
	          removedNodes[name] = ReactReconciler.getHostNode(prevChild);
	          ReactReconciler.unmountComponent(prevChild, false);
	        }
	        // The child must be instantiated before it's mounted.
	        var nextChildInstance = instantiateReactComponent(nextElement, true);
	        nextChildren[name] = nextChildInstance;
	        // Creating mount image now ensures refs are resolved in right order
	        // (see https://github.com/facebook/react/pull/7101 for explanation).
	        var nextChildMountImage = ReactReconciler.mountComponent(nextChildInstance, transaction, hostParent, hostContainerInfo, context, selfDebugID);
	        mountImages.push(nextChildMountImage);
	      }
	    }
	    // Unmount children that are no longer present.
	    for (name in prevChildren) {
	      if (prevChildren.hasOwnProperty(name) && !(nextChildren && nextChildren.hasOwnProperty(name))) {
	        prevChild = prevChildren[name];
	        removedNodes[name] = ReactReconciler.getHostNode(prevChild);
	        ReactReconciler.unmountComponent(prevChild, false);
	      }
	    }
	  },
	
	  /**
	   * Unmounts all rendered children. This should be used to clean up children
	   * when this component is unmounted.
	   *
	   * @param {?object} renderedChildren Previously initialized set of children.
	   * @internal
	   */
	  unmountChildren: function (renderedChildren, safely) {
	    for (var name in renderedChildren) {
	      if (renderedChildren.hasOwnProperty(name)) {
	        var renderedChild = renderedChildren[name];
	        ReactReconciler.unmountComponent(renderedChild, safely);
	      }
	    }
	  }
	};
	
	module.exports = ReactChildReconciler;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(58)))

/***/ }),
/* 428 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMChildrenOperations = __webpack_require__(117);
	var ReactDOMIDOperations = __webpack_require__(435);
	
	/**
	 * Abstracts away all functionality of the reconciler that requires knowledge of
	 * the browser context. TODO: These callers should be refactored to avoid the
	 * need for this injection.
	 */
	var ReactComponentBrowserEnvironment = {
	  processChildrenUpdates: ReactDOMIDOperations.dangerouslyProcessChildrenUpdates,
	
	  replaceNodeWithMarkup: DOMChildrenOperations.dangerouslyReplaceNodeWithMarkup
	};
	
	module.exports = ReactComponentBrowserEnvironment;

/***/ }),
/* 429 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(6),
	    _assign = __webpack_require__(7);
	
	var React = __webpack_require__(47);
	var ReactComponentEnvironment = __webpack_require__(123);
	var ReactCurrentOwner = __webpack_require__(32);
	var ReactErrorUtils = __webpack_require__(124);
	var ReactInstanceMap = __webpack_require__(61);
	var ReactInstrumentation = __webpack_require__(25);
	var ReactNodeTypes = __webpack_require__(206);
	var ReactReconciler = __webpack_require__(46);
	
	if (false) {
	  var checkReactTypeSpec = require('./checkReactTypeSpec');
	}
	
	var emptyObject = __webpack_require__(82);
	var invariant = __webpack_require__(3);
	var shallowEqual = __webpack_require__(116);
	var shouldUpdateReactComponent = __webpack_require__(131);
	var warning = __webpack_require__(5);
	
	var CompositeTypes = {
	  ImpureClass: 0,
	  PureClass: 1,
	  StatelessFunctional: 2
	};
	
	function StatelessComponent(Component) {}
	StatelessComponent.prototype.render = function () {
	  var Component = ReactInstanceMap.get(this)._currentElement.type;
	  var element = Component(this.props, this.context, this.updater);
	  warnIfInvalidElement(Component, element);
	  return element;
	};
	
	function warnIfInvalidElement(Component, element) {
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(element === null || element === false || React.isValidElement(element), '%s(...): A valid React element (or null) must be returned. You may have ' + 'returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component') : void 0;
	    process.env.NODE_ENV !== 'production' ? warning(!Component.childContextTypes, '%s(...): childContextTypes cannot be defined on a functional component.', Component.displayName || Component.name || 'Component') : void 0;
	  }
	}
	
	function shouldConstruct(Component) {
	  return !!(Component.prototype && Component.prototype.isReactComponent);
	}
	
	function isPureComponent(Component) {
	  return !!(Component.prototype && Component.prototype.isPureReactComponent);
	}
	
	// Separated into a function to contain deoptimizations caused by try/finally.
	function measureLifeCyclePerf(fn, debugID, timerType) {
	  if (debugID === 0) {
	    // Top-level wrappers (see ReactMount) and empty components (see
	    // ReactDOMEmptyComponent) are invisible to hooks and devtools.
	    // Both are implementation details that should go away in the future.
	    return fn();
	  }
	
	  ReactInstrumentation.debugTool.onBeginLifeCycleTimer(debugID, timerType);
	  try {
	    return fn();
	  } finally {
	    ReactInstrumentation.debugTool.onEndLifeCycleTimer(debugID, timerType);
	  }
	}
	
	/**
	 * ------------------ The Life-Cycle of a Composite Component ------------------
	 *
	 * - constructor: Initialization of state. The instance is now retained.
	 *   - componentWillMount
	 *   - render
	 *   - [children's constructors]
	 *     - [children's componentWillMount and render]
	 *     - [children's componentDidMount]
	 *     - componentDidMount
	 *
	 *       Update Phases:
	 *       - componentWillReceiveProps (only called if parent updated)
	 *       - shouldComponentUpdate
	 *         - componentWillUpdate
	 *           - render
	 *           - [children's constructors or receive props phases]
	 *         - componentDidUpdate
	 *
	 *     - componentWillUnmount
	 *     - [children's componentWillUnmount]
	 *   - [children destroyed]
	 * - (destroyed): The instance is now blank, released by React and ready for GC.
	 *
	 * -----------------------------------------------------------------------------
	 */
	
	/**
	 * An incrementing ID assigned to each component when it is mounted. This is
	 * used to enforce the order in which `ReactUpdates` updates dirty components.
	 *
	 * @private
	 */
	var nextMountID = 1;
	
	/**
	 * @lends {ReactCompositeComponent.prototype}
	 */
	var ReactCompositeComponent = {
	  /**
	   * Base constructor for all composite component.
	   *
	   * @param {ReactElement} element
	   * @final
	   * @internal
	   */
	  construct: function (element) {
	    this._currentElement = element;
	    this._rootNodeID = 0;
	    this._compositeType = null;
	    this._instance = null;
	    this._hostParent = null;
	    this._hostContainerInfo = null;
	
	    // See ReactUpdateQueue
	    this._updateBatchNumber = null;
	    this._pendingElement = null;
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	
	    this._renderedNodeType = null;
	    this._renderedComponent = null;
	    this._context = null;
	    this._mountOrder = 0;
	    this._topLevelWrapper = null;
	
	    // See ReactUpdates and ReactUpdateQueue.
	    this._pendingCallbacks = null;
	
	    // ComponentWillUnmount shall only be called once
	    this._calledComponentWillUnmount = false;
	
	    if (false) {
	      this._warnedAboutRefsInRender = false;
	    }
	  },
	
	  /**
	   * Initializes the component, renders markup, and registers event listeners.
	   *
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {?object} hostParent
	   * @param {?object} hostContainerInfo
	   * @param {?object} context
	   * @return {?string} Rendered markup to be inserted into the DOM.
	   * @final
	   * @internal
	   */
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    var _this = this;
	
	    this._context = context;
	    this._mountOrder = nextMountID++;
	    this._hostParent = hostParent;
	    this._hostContainerInfo = hostContainerInfo;
	
	    var publicProps = this._currentElement.props;
	    var publicContext = this._processContext(context);
	
	    var Component = this._currentElement.type;
	
	    var updateQueue = transaction.getUpdateQueue();
	
	    // Initialize the public class
	    var doConstruct = shouldConstruct(Component);
	    var inst = this._constructComponent(doConstruct, publicProps, publicContext, updateQueue);
	    var renderedElement;
	
	    // Support functional components
	    if (!doConstruct && (inst == null || inst.render == null)) {
	      renderedElement = inst;
	      warnIfInvalidElement(Component, renderedElement);
	      !(inst === null || inst === false || React.isValidElement(inst)) ?  false ? invariant(false, '%s(...): A valid React element (or null) must be returned. You may have returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component') : _prodInvariant('105', Component.displayName || Component.name || 'Component') : void 0;
	      inst = new StatelessComponent(Component);
	      this._compositeType = CompositeTypes.StatelessFunctional;
	    } else {
	      if (isPureComponent(Component)) {
	        this._compositeType = CompositeTypes.PureClass;
	      } else {
	        this._compositeType = CompositeTypes.ImpureClass;
	      }
	    }
	
	    if (false) {
	      // This will throw later in _renderValidatedComponent, but add an early
	      // warning now to help debugging
	      if (inst.render == null) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): No `render` method found on the returned component ' + 'instance: you may have forgotten to define `render`.', Component.displayName || Component.name || 'Component') : void 0;
	      }
	
	      var propsMutated = inst.props !== publicProps;
	      var componentName = Component.displayName || Component.name || 'Component';
	
	      process.env.NODE_ENV !== 'production' ? warning(inst.props === undefined || !propsMutated, '%s(...): When calling super() in `%s`, make sure to pass ' + "up the same props that your component's constructor was passed.", componentName, componentName) : void 0;
	    }
	
	    // These should be set up in the constructor, but as a convenience for
	    // simpler class abstractions, we set them up after the fact.
	    inst.props = publicProps;
	    inst.context = publicContext;
	    inst.refs = emptyObject;
	    inst.updater = updateQueue;
	
	    this._instance = inst;
	
	    // Store a reference from the instance back to the internal representation
	    ReactInstanceMap.set(inst, this);
	
	    if (false) {
	      // Since plain JS classes are defined without any special initialization
	      // logic, we can not catch common errors early. Therefore, we have to
	      // catch them here, at initialization time, instead.
	      process.env.NODE_ENV !== 'production' ? warning(!inst.getInitialState || inst.getInitialState.isReactClassApproved || inst.state, 'getInitialState was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Did you mean to define a state property instead?', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.getDefaultProps || inst.getDefaultProps.isReactClassApproved, 'getDefaultProps was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Use a static property to define defaultProps instead.', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.propTypes, 'propTypes was defined as an instance property on %s. Use a static ' + 'property to define propTypes instead.', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.contextTypes, 'contextTypes was defined as an instance property on %s. Use a ' + 'static property to define contextTypes instead.', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentShouldUpdate !== 'function', '%s has a method called ' + 'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' + 'The name is phrased as a question because the function is ' + 'expected to return a value.', this.getName() || 'A component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentDidUnmount !== 'function', '%s has a method called ' + 'componentDidUnmount(). But there is no such lifecycle method. ' + 'Did you mean componentWillUnmount()?', this.getName() || 'A component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentWillRecieveProps !== 'function', '%s has a method called ' + 'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?', this.getName() || 'A component') : void 0;
	    }
	
	    var initialState = inst.state;
	    if (initialState === undefined) {
	      inst.state = initialState = null;
	    }
	    !(typeof initialState === 'object' && !Array.isArray(initialState)) ?  false ? invariant(false, '%s.state: must be set to an object or null', this.getName() || 'ReactCompositeComponent') : _prodInvariant('106', this.getName() || 'ReactCompositeComponent') : void 0;
	
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	
	    var markup;
	    if (inst.unstable_handleError) {
	      markup = this.performInitialMountWithErrorHandling(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    } else {
	      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    }
	
	    if (inst.componentDidMount) {
	      if (false) {
	        transaction.getReactMountReady().enqueue(function () {
	          measureLifeCyclePerf(function () {
	            return inst.componentDidMount();
	          }, _this._debugID, 'componentDidMount');
	        });
	      } else {
	        transaction.getReactMountReady().enqueue(inst.componentDidMount, inst);
	      }
	    }
	
	    return markup;
	  },
	
	  _constructComponent: function (doConstruct, publicProps, publicContext, updateQueue) {
	    if (false) {
	      ReactCurrentOwner.current = this;
	      try {
	        return this._constructComponentWithoutOwner(doConstruct, publicProps, publicContext, updateQueue);
	      } finally {
	        ReactCurrentOwner.current = null;
	      }
	    } else {
	      return this._constructComponentWithoutOwner(doConstruct, publicProps, publicContext, updateQueue);
	    }
	  },
	
	  _constructComponentWithoutOwner: function (doConstruct, publicProps, publicContext, updateQueue) {
	    var Component = this._currentElement.type;
	
	    if (doConstruct) {
	      if (false) {
	        return measureLifeCyclePerf(function () {
	          return new Component(publicProps, publicContext, updateQueue);
	        }, this._debugID, 'ctor');
	      } else {
	        return new Component(publicProps, publicContext, updateQueue);
	      }
	    }
	
	    // This can still be an instance in case of factory components
	    // but we'll count this as time spent rendering as the more common case.
	    if (false) {
	      return measureLifeCyclePerf(function () {
	        return Component(publicProps, publicContext, updateQueue);
	      }, this._debugID, 'render');
	    } else {
	      return Component(publicProps, publicContext, updateQueue);
	    }
	  },
	
	  performInitialMountWithErrorHandling: function (renderedElement, hostParent, hostContainerInfo, transaction, context) {
	    var markup;
	    var checkpoint = transaction.checkpoint();
	    try {
	      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    } catch (e) {
	      // Roll back to checkpoint, handle error (which may add items to the transaction), and take a new checkpoint
	      transaction.rollback(checkpoint);
	      this._instance.unstable_handleError(e);
	      if (this._pendingStateQueue) {
	        this._instance.state = this._processPendingState(this._instance.props, this._instance.context);
	      }
	      checkpoint = transaction.checkpoint();
	
	      this._renderedComponent.unmountComponent(true);
	      transaction.rollback(checkpoint);
	
	      // Try again - we've informed the component about the error, so they can render an error message this time.
	      // If this throws again, the error will bubble up (and can be caught by a higher error boundary).
	      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    }
	    return markup;
	  },
	
	  performInitialMount: function (renderedElement, hostParent, hostContainerInfo, transaction, context) {
	    var inst = this._instance;
	
	    var debugID = 0;
	    if (false) {
	      debugID = this._debugID;
	    }
	
	    if (inst.componentWillMount) {
	      if (false) {
	        measureLifeCyclePerf(function () {
	          return inst.componentWillMount();
	        }, debugID, 'componentWillMount');
	      } else {
	        inst.componentWillMount();
	      }
	      // When mounting, calls to `setState` by `componentWillMount` will set
	      // `this._pendingStateQueue` without triggering a re-render.
	      if (this._pendingStateQueue) {
	        inst.state = this._processPendingState(inst.props, inst.context);
	      }
	    }
	
	    // If not a stateless component, we now render
	    if (renderedElement === undefined) {
	      renderedElement = this._renderValidatedComponent();
	    }
	
	    var nodeType = ReactNodeTypes.getType(renderedElement);
	    this._renderedNodeType = nodeType;
	    var child = this._instantiateReactComponent(renderedElement, nodeType !== ReactNodeTypes.EMPTY /* shouldHaveDebugID */
	    );
	    this._renderedComponent = child;
	
	    var markup = ReactReconciler.mountComponent(child, transaction, hostParent, hostContainerInfo, this._processChildContext(context), debugID);
	
	    if (false) {
	      if (debugID !== 0) {
	        var childDebugIDs = child._debugID !== 0 ? [child._debugID] : [];
	        ReactInstrumentation.debugTool.onSetChildren(debugID, childDebugIDs);
	      }
	    }
	
	    return markup;
	  },
	
	  getHostNode: function () {
	    return ReactReconciler.getHostNode(this._renderedComponent);
	  },
	
	  /**
	   * Releases any resources allocated by `mountComponent`.
	   *
	   * @final
	   * @internal
	   */
	  unmountComponent: function (safely) {
	    if (!this._renderedComponent) {
	      return;
	    }
	
	    var inst = this._instance;
	
	    if (inst.componentWillUnmount && !inst._calledComponentWillUnmount) {
	      inst._calledComponentWillUnmount = true;
	
	      if (safely) {
	        var name = this.getName() + '.componentWillUnmount()';
	        ReactErrorUtils.invokeGuardedCallback(name, inst.componentWillUnmount.bind(inst));
	      } else {
	        if (false) {
	          measureLifeCyclePerf(function () {
	            return inst.componentWillUnmount();
	          }, this._debugID, 'componentWillUnmount');
	        } else {
	          inst.componentWillUnmount();
	        }
	      }
	    }
	
	    if (this._renderedComponent) {
	      ReactReconciler.unmountComponent(this._renderedComponent, safely);
	      this._renderedNodeType = null;
	      this._renderedComponent = null;
	      this._instance = null;
	    }
	
	    // Reset pending fields
	    // Even if this component is scheduled for another update in ReactUpdates,
	    // it would still be ignored because these fields are reset.
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	    this._pendingCallbacks = null;
	    this._pendingElement = null;
	
	    // These fields do not really need to be reset since this object is no
	    // longer accessible.
	    this._context = null;
	    this._rootNodeID = 0;
	    this._topLevelWrapper = null;
	
	    // Delete the reference from the instance to this internal representation
	    // which allow the internals to be properly cleaned up even if the user
	    // leaks a reference to the public instance.
	    ReactInstanceMap.remove(inst);
	
	    // Some existing components rely on inst.props even after they've been
	    // destroyed (in event handlers).
	    // TODO: inst.props = null;
	    // TODO: inst.state = null;
	    // TODO: inst.context = null;
	  },
	
	  /**
	   * Filters the context object to only contain keys specified in
	   * `contextTypes`
	   *
	   * @param {object} context
	   * @return {?object}
	   * @private
	   */
	  _maskContext: function (context) {
	    var Component = this._currentElement.type;
	    var contextTypes = Component.contextTypes;
	    if (!contextTypes) {
	      return emptyObject;
	    }
	    var maskedContext = {};
	    for (var contextName in contextTypes) {
	      maskedContext[contextName] = context[contextName];
	    }
	    return maskedContext;
	  },
	
	  /**
	   * Filters the context object to only contain keys specified in
	   * `contextTypes`, and asserts that they are valid.
	   *
	   * @param {object} context
	   * @return {?object}
	   * @private
	   */
	  _processContext: function (context) {
	    var maskedContext = this._maskContext(context);
	    if (false) {
	      var Component = this._currentElement.type;
	      if (Component.contextTypes) {
	        this._checkContextTypes(Component.contextTypes, maskedContext, 'context');
	      }
	    }
	    return maskedContext;
	  },
	
	  /**
	   * @param {object} currentContext
	   * @return {object}
	   * @private
	   */
	  _processChildContext: function (currentContext) {
	    var Component = this._currentElement.type;
	    var inst = this._instance;
	    var childContext;
	
	    if (inst.getChildContext) {
	      if (false) {
	        ReactInstrumentation.debugTool.onBeginProcessingChildContext();
	        try {
	          childContext = inst.getChildContext();
	        } finally {
	          ReactInstrumentation.debugTool.onEndProcessingChildContext();
	        }
	      } else {
	        childContext = inst.getChildContext();
	      }
	    }
	
	    if (childContext) {
	      !(typeof Component.childContextTypes === 'object') ?  false ? invariant(false, '%s.getChildContext(): childContextTypes must be defined in order to use getChildContext().', this.getName() || 'ReactCompositeComponent') : _prodInvariant('107', this.getName() || 'ReactCompositeComponent') : void 0;
	      if (false) {
	        this._checkContextTypes(Component.childContextTypes, childContext, 'child context');
	      }
	      for (var name in childContext) {
	        !(name in Component.childContextTypes) ?  false ? invariant(false, '%s.getChildContext(): key "%s" is not defined in childContextTypes.', this.getName() || 'ReactCompositeComponent', name) : _prodInvariant('108', this.getName() || 'ReactCompositeComponent', name) : void 0;
	      }
	      return _assign({}, currentContext, childContext);
	    }
	    return currentContext;
	  },
	
	  /**
	   * Assert that the context types are valid
	   *
	   * @param {object} typeSpecs Map of context field to a ReactPropType
	   * @param {object} values Runtime values that need to be type-checked
	   * @param {string} location e.g. "prop", "context", "child context"
	   * @private
	   */
	  _checkContextTypes: function (typeSpecs, values, location) {
	    if (false) {
	      checkReactTypeSpec(typeSpecs, values, location, this.getName(), null, this._debugID);
	    }
	  },
	
	  receiveComponent: function (nextElement, transaction, nextContext) {
	    var prevElement = this._currentElement;
	    var prevContext = this._context;
	
	    this._pendingElement = null;
	
	    this.updateComponent(transaction, prevElement, nextElement, prevContext, nextContext);
	  },
	
	  /**
	   * If any of `_pendingElement`, `_pendingStateQueue`, or `_pendingForceUpdate`
	   * is set, update the component.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  performUpdateIfNecessary: function (transaction) {
	    if (this._pendingElement != null) {
	      ReactReconciler.receiveComponent(this, this._pendingElement, transaction, this._context);
	    } else if (this._pendingStateQueue !== null || this._pendingForceUpdate) {
	      this.updateComponent(transaction, this._currentElement, this._currentElement, this._context, this._context);
	    } else {
	      this._updateBatchNumber = null;
	    }
	  },
	
	  /**
	   * Perform an update to a mounted component. The componentWillReceiveProps and
	   * shouldComponentUpdate methods are called, then (assuming the update isn't
	   * skipped) the remaining update lifecycle methods are called and the DOM
	   * representation is updated.
	   *
	   * By default, this implements React's rendering and reconciliation algorithm.
	   * Sophisticated clients may wish to override this.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @param {ReactElement} prevParentElement
	   * @param {ReactElement} nextParentElement
	   * @internal
	   * @overridable
	   */
	  updateComponent: function (transaction, prevParentElement, nextParentElement, prevUnmaskedContext, nextUnmaskedContext) {
	    var inst = this._instance;
	    !(inst != null) ?  false ? invariant(false, 'Attempted to update component `%s` that has already been unmounted (or failed to mount).', this.getName() || 'ReactCompositeComponent') : _prodInvariant('136', this.getName() || 'ReactCompositeComponent') : void 0;
	
	    var willReceive = false;
	    var nextContext;
	
	    // Determine if the context has changed or not
	    if (this._context === nextUnmaskedContext) {
	      nextContext = inst.context;
	    } else {
	      nextContext = this._processContext(nextUnmaskedContext);
	      willReceive = true;
	    }
	
	    var prevProps = prevParentElement.props;
	    var nextProps = nextParentElement.props;
	
	    // Not a simple state update but a props update
	    if (prevParentElement !== nextParentElement) {
	      willReceive = true;
	    }
	
	    // An update here will schedule an update but immediately set
	    // _pendingStateQueue which will ensure that any state updates gets
	    // immediately reconciled instead of waiting for the next batch.
	    if (willReceive && inst.componentWillReceiveProps) {
	      if (false) {
	        measureLifeCyclePerf(function () {
	          return inst.componentWillReceiveProps(nextProps, nextContext);
	        }, this._debugID, 'componentWillReceiveProps');
	      } else {
	        inst.componentWillReceiveProps(nextProps, nextContext);
	      }
	    }
	
	    var nextState = this._processPendingState(nextProps, nextContext);
	    var shouldUpdate = true;
	
	    if (!this._pendingForceUpdate) {
	      if (inst.shouldComponentUpdate) {
	        if (false) {
	          shouldUpdate = measureLifeCyclePerf(function () {
	            return inst.shouldComponentUpdate(nextProps, nextState, nextContext);
	          }, this._debugID, 'shouldComponentUpdate');
	        } else {
	          shouldUpdate = inst.shouldComponentUpdate(nextProps, nextState, nextContext);
	        }
	      } else {
	        if (this._compositeType === CompositeTypes.PureClass) {
	          shouldUpdate = !shallowEqual(prevProps, nextProps) || !shallowEqual(inst.state, nextState);
	        }
	      }
	    }
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(shouldUpdate !== undefined, '%s.shouldComponentUpdate(): Returned undefined instead of a ' + 'boolean value. Make sure to return true or false.', this.getName() || 'ReactCompositeComponent') : void 0;
	    }
	
	    this._updateBatchNumber = null;
	    if (shouldUpdate) {
	      this._pendingForceUpdate = false;
	      // Will set `this.props`, `this.state` and `this.context`.
	      this._performComponentUpdate(nextParentElement, nextProps, nextState, nextContext, transaction, nextUnmaskedContext);
	    } else {
	      // If it's determined that a component should not update, we still want
	      // to set props and state but we shortcut the rest of the update.
	      this._currentElement = nextParentElement;
	      this._context = nextUnmaskedContext;
	      inst.props = nextProps;
	      inst.state = nextState;
	      inst.context = nextContext;
	    }
	  },
	
	  _processPendingState: function (props, context) {
	    var inst = this._instance;
	    var queue = this._pendingStateQueue;
	    var replace = this._pendingReplaceState;
	    this._pendingReplaceState = false;
	    this._pendingStateQueue = null;
	
	    if (!queue) {
	      return inst.state;
	    }
	
	    if (replace && queue.length === 1) {
	      return queue[0];
	    }
	
	    var nextState = _assign({}, replace ? queue[0] : inst.state);
	    for (var i = replace ? 1 : 0; i < queue.length; i++) {
	      var partial = queue[i];
	      _assign(nextState, typeof partial === 'function' ? partial.call(inst, nextState, props, context) : partial);
	    }
	
	    return nextState;
	  },
	
	  /**
	   * Merges new props and state, notifies delegate methods of update and
	   * performs update.
	   *
	   * @param {ReactElement} nextElement Next element
	   * @param {object} nextProps Next public object to set as properties.
	   * @param {?object} nextState Next object to set as state.
	   * @param {?object} nextContext Next public object to set as context.
	   * @param {ReactReconcileTransaction} transaction
	   * @param {?object} unmaskedContext
	   * @private
	   */
	  _performComponentUpdate: function (nextElement, nextProps, nextState, nextContext, transaction, unmaskedContext) {
	    var _this2 = this;
	
	    var inst = this._instance;
	
	    var hasComponentDidUpdate = Boolean(inst.componentDidUpdate);
	    var prevProps;
	    var prevState;
	    var prevContext;
	    if (hasComponentDidUpdate) {
	      prevProps = inst.props;
	      prevState = inst.state;
	      prevContext = inst.context;
	    }
	
	    if (inst.componentWillUpdate) {
	      if (false) {
	        measureLifeCyclePerf(function () {
	          return inst.componentWillUpdate(nextProps, nextState, nextContext);
	        }, this._debugID, 'componentWillUpdate');
	      } else {
	        inst.componentWillUpdate(nextProps, nextState, nextContext);
	      }
	    }
	
	    this._currentElement = nextElement;
	    this._context = unmaskedContext;
	    inst.props = nextProps;
	    inst.state = nextState;
	    inst.context = nextContext;
	
	    this._updateRenderedComponent(transaction, unmaskedContext);
	
	    if (hasComponentDidUpdate) {
	      if (false) {
	        transaction.getReactMountReady().enqueue(function () {
	          measureLifeCyclePerf(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), _this2._debugID, 'componentDidUpdate');
	        });
	      } else {
	        transaction.getReactMountReady().enqueue(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), inst);
	      }
	    }
	  },
	
	  /**
	   * Call the component's `render` method and update the DOM accordingly.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  _updateRenderedComponent: function (transaction, context) {
	    var prevComponentInstance = this._renderedComponent;
	    var prevRenderedElement = prevComponentInstance._currentElement;
	    var nextRenderedElement = this._renderValidatedComponent();
	
	    var debugID = 0;
	    if (false) {
	      debugID = this._debugID;
	    }
	
	    if (shouldUpdateReactComponent(prevRenderedElement, nextRenderedElement)) {
	      ReactReconciler.receiveComponent(prevComponentInstance, nextRenderedElement, transaction, this._processChildContext(context));
	    } else {
	      var oldHostNode = ReactReconciler.getHostNode(prevComponentInstance);
	      ReactReconciler.unmountComponent(prevComponentInstance, false);
	
	      var nodeType = ReactNodeTypes.getType(nextRenderedElement);
	      this._renderedNodeType = nodeType;
	      var child = this._instantiateReactComponent(nextRenderedElement, nodeType !== ReactNodeTypes.EMPTY /* shouldHaveDebugID */
	      );
	      this._renderedComponent = child;
	
	      var nextMarkup = ReactReconciler.mountComponent(child, transaction, this._hostParent, this._hostContainerInfo, this._processChildContext(context), debugID);
	
	      if (false) {
	        if (debugID !== 0) {
	          var childDebugIDs = child._debugID !== 0 ? [child._debugID] : [];
	          ReactInstrumentation.debugTool.onSetChildren(debugID, childDebugIDs);
	        }
	      }
	
	      this._replaceNodeWithMarkup(oldHostNode, nextMarkup, prevComponentInstance);
	    }
	  },
	
	  /**
	   * Overridden in shallow rendering.
	   *
	   * @protected
	   */
	  _replaceNodeWithMarkup: function (oldHostNode, nextMarkup, prevInstance) {
	    ReactComponentEnvironment.replaceNodeWithMarkup(oldHostNode, nextMarkup, prevInstance);
	  },
	
	  /**
	   * @protected
	   */
	  _renderValidatedComponentWithoutOwnerOrContext: function () {
	    var inst = this._instance;
	    var renderedElement;
	
	    if (false) {
	      renderedElement = measureLifeCyclePerf(function () {
	        return inst.render();
	      }, this._debugID, 'render');
	    } else {
	      renderedElement = inst.render();
	    }
	
	    if (false) {
	      // We allow auto-mocks to proceed as if they're returning null.
	      if (renderedElement === undefined && inst.render._isMockFunction) {
	        // This is probably bad practice. Consider warning here and
	        // deprecating this convenience.
	        renderedElement = null;
	      }
	    }
	
	    return renderedElement;
	  },
	
	  /**
	   * @private
	   */
	  _renderValidatedComponent: function () {
	    var renderedElement;
	    if (("production") !== 'production' || this._compositeType !== CompositeTypes.StatelessFunctional) {
	      ReactCurrentOwner.current = this;
	      try {
	        renderedElement = this._renderValidatedComponentWithoutOwnerOrContext();
	      } finally {
	        ReactCurrentOwner.current = null;
	      }
	    } else {
	      renderedElement = this._renderValidatedComponentWithoutOwnerOrContext();
	    }
	    !(
	    // TODO: An `isValidNode` function would probably be more appropriate
	    renderedElement === null || renderedElement === false || React.isValidElement(renderedElement)) ?  false ? invariant(false, '%s.render(): A valid React element (or null) must be returned. You may have returned undefined, an array or some other invalid object.', this.getName() || 'ReactCompositeComponent') : _prodInvariant('109', this.getName() || 'ReactCompositeComponent') : void 0;
	
	    return renderedElement;
	  },
	
	  /**
	   * Lazily allocates the refs object and stores `component` as `ref`.
	   *
	   * @param {string} ref Reference name.
	   * @param {component} component Component to store as `ref`.
	   * @final
	   * @private
	   */
	  attachRef: function (ref, component) {
	    var inst = this.getPublicInstance();
	    !(inst != null) ?  false ? invariant(false, 'Stateless function components cannot have refs.') : _prodInvariant('110') : void 0;
	    var publicComponentInstance = component.getPublicInstance();
	    if (false) {
	      var componentName = component && component.getName ? component.getName() : 'a component';
	      process.env.NODE_ENV !== 'production' ? warning(publicComponentInstance != null || component._compositeType !== CompositeTypes.StatelessFunctional, 'Stateless function components cannot be given refs ' + '(See ref "%s" in %s created by %s). ' + 'Attempts to access this ref will fail.', ref, componentName, this.getName()) : void 0;
	    }
	    var refs = inst.refs === emptyObject ? inst.refs = {} : inst.refs;
	    refs[ref] = publicComponentInstance;
	  },
	
	  /**
	   * Detaches a reference name.
	   *
	   * @param {string} ref Name to dereference.
	   * @final
	   * @private
	   */
	  detachRef: function (ref) {
	    var refs = this.getPublicInstance().refs;
	    delete refs[ref];
	  },
	
	  /**
	   * Get a text description of the component that can be used to identify it
	   * in error messages.
	   * @return {string} The name or null.
	   * @internal
	   */
	  getName: function () {
	    var type = this._currentElement.type;
	    var constructor = this._instance && this._instance.constructor;
	    return type.displayName || constructor && constructor.displayName || type.name || constructor && constructor.name || null;
	  },
	
	  /**
	   * Get the publicly accessible representation of this component - i.e. what
	   * is exposed by refs and returned by render. Can be null for stateless
	   * components.
	   *
	   * @return {ReactComponent} the public component instance.
	   * @internal
	   */
	  getPublicInstance: function () {
	    var inst = this._instance;
	    if (this._compositeType === CompositeTypes.StatelessFunctional) {
	      return null;
	    }
	    return inst;
	  },
	
	  // Stub
	  _instantiateReactComponent: null
	};
	
	module.exports = ReactCompositeComponent;

/***/ }),
/* 430 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	/* globals __REACT_DEVTOOLS_GLOBAL_HOOK__*/
	
	'use strict';
	
	var ReactDOMComponentTree = __webpack_require__(9);
	var ReactDefaultInjection = __webpack_require__(443);
	var ReactMount = __webpack_require__(205);
	var ReactReconciler = __webpack_require__(46);
	var ReactUpdates = __webpack_require__(28);
	var ReactVersion = __webpack_require__(456);
	
	var findDOMNode = __webpack_require__(472);
	var getHostComponentFromComposite = __webpack_require__(210);
	var renderSubtreeIntoContainer = __webpack_require__(479);
	var warning = __webpack_require__(5);
	
	ReactDefaultInjection.inject();
	
	var ReactDOM = {
	  findDOMNode: findDOMNode,
	  render: ReactMount.render,
	  unmountComponentAtNode: ReactMount.unmountComponentAtNode,
	  version: ReactVersion,
	
	  /* eslint-disable camelcase */
	  unstable_batchedUpdates: ReactUpdates.batchedUpdates,
	  unstable_renderSubtreeIntoContainer: renderSubtreeIntoContainer
	  /* eslint-enable camelcase */
	};
	
	// Inject the runtime into a devtools global hook regardless of browser.
	// Allows for debugging when the hook is injected on the page.
	if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined' && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.inject === 'function') {
	  __REACT_DEVTOOLS_GLOBAL_HOOK__.inject({
	    ComponentTree: {
	      getClosestInstanceFromNode: ReactDOMComponentTree.getClosestInstanceFromNode,
	      getNodeFromInstance: function (inst) {
	        // inst is an internal instance (but could be a composite)
	        if (inst._renderedComponent) {
	          inst = getHostComponentFromComposite(inst);
	        }
	        if (inst) {
	          return ReactDOMComponentTree.getNodeFromInstance(inst);
	        } else {
	          return null;
	        }
	      }
	    },
	    Mount: ReactMount,
	    Reconciler: ReactReconciler
	  });
	}
	
	if (false) {
	  var ExecutionEnvironment = require('fbjs/lib/ExecutionEnvironment');
	  if (ExecutionEnvironment.canUseDOM && window.top === window.self) {
	    // First check if devtools is not installed
	    if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined') {
	      // If we're in Chrome or Firefox, provide a download link if not installed.
	      if (navigator.userAgent.indexOf('Chrome') > -1 && navigator.userAgent.indexOf('Edge') === -1 || navigator.userAgent.indexOf('Firefox') > -1) {
	        // Firefox does not have the issue with devtools loaded over file://
	        var showFileUrlMessage = window.location.protocol.indexOf('http') === -1 && navigator.userAgent.indexOf('Firefox') === -1;
	        console.debug('Download the React DevTools ' + (showFileUrlMessage ? 'and use an HTTP server (instead of a file: URL) ' : '') + 'for a better development experience: ' + 'https://fb.me/react-devtools');
	      }
	    }
	
	    var testFunc = function testFn() {};
	    process.env.NODE_ENV !== 'production' ? warning((testFunc.name || testFunc.toString()).indexOf('testFn') !== -1, "It looks like you're using a minified copy of the development build " + 'of React. When deploying React apps to production, make sure to use ' + 'the production build which skips development warnings and is faster. ' + 'See https://fb.me/react-minification for more details.') : void 0;
	
	    // If we're in IE8, check to see if we are in compatibility mode and provide
	    // information on preventing compatibility mode
	    var ieCompatibilityMode = document.documentMode && document.documentMode < 8;
	
	    process.env.NODE_ENV !== 'production' ? warning(!ieCompatibilityMode, 'Internet Explorer is running in compatibility mode; please add the ' + 'following tag to your HTML to prevent this from happening: ' + '<meta http-equiv="X-UA-Compatible" content="IE=edge" />') : void 0;
	
	    var expectedFeatures = [
	    // shims
	    Array.isArray, Array.prototype.every, Array.prototype.forEach, Array.prototype.indexOf, Array.prototype.map, Date.now, Function.prototype.bind, Object.keys, String.prototype.trim];
	
	    for (var i = 0; i < expectedFeatures.length; i++) {
	      if (!expectedFeatures[i]) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'One or more ES5 shims expected by React are not available: ' + 'https://fb.me/react-warning-polyfills') : void 0;
	        break;
	      }
	    }
	  }
	}
	
	if (false) {
	  var ReactInstrumentation = require('./ReactInstrumentation');
	  var ReactDOMUnknownPropertyHook = require('./ReactDOMUnknownPropertyHook');
	  var ReactDOMNullInputValuePropHook = require('./ReactDOMNullInputValuePropHook');
	  var ReactDOMInvalidARIAHook = require('./ReactDOMInvalidARIAHook');
	
	  ReactInstrumentation.debugTool.addHook(ReactDOMUnknownPropertyHook);
	  ReactInstrumentation.debugTool.addHook(ReactDOMNullInputValuePropHook);
	  ReactInstrumentation.debugTool.addHook(ReactDOMInvalidARIAHook);
	}
	
	module.exports = ReactDOM;

/***/ }),
/* 431 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	/* global hasOwnProperty:true */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(6),
	    _assign = __webpack_require__(7);
	
	var AutoFocusUtils = __webpack_require__(418);
	var CSSPropertyOperations = __webpack_require__(420);
	var DOMLazyTree = __webpack_require__(44);
	var DOMNamespaces = __webpack_require__(118);
	var DOMProperty = __webpack_require__(45);
	var DOMPropertyOperations = __webpack_require__(198);
	var EventPluginHub = __webpack_require__(59);
	var EventPluginRegistry = __webpack_require__(119);
	var ReactBrowserEventEmitter = __webpack_require__(83);
	var ReactDOMComponentFlags = __webpack_require__(199);
	var ReactDOMComponentTree = __webpack_require__(9);
	var ReactDOMInput = __webpack_require__(436);
	var ReactDOMOption = __webpack_require__(437);
	var ReactDOMSelect = __webpack_require__(200);
	var ReactDOMTextarea = __webpack_require__(440);
	var ReactInstrumentation = __webpack_require__(25);
	var ReactMultiChild = __webpack_require__(449);
	var ReactServerRenderingTransaction = __webpack_require__(454);
	
	var emptyFunction = __webpack_require__(24);
	var escapeTextContentForBrowser = __webpack_require__(86);
	var invariant = __webpack_require__(3);
	var isEventSupported = __webpack_require__(130);
	var shallowEqual = __webpack_require__(116);
	var inputValueTracking = __webpack_require__(212);
	var validateDOMNesting = __webpack_require__(132);
	var warning = __webpack_require__(5);
	
	var Flags = ReactDOMComponentFlags;
	var deleteListener = EventPluginHub.deleteListener;
	var getNode = ReactDOMComponentTree.getNodeFromInstance;
	var listenTo = ReactBrowserEventEmitter.listenTo;
	var registrationNameModules = EventPluginRegistry.registrationNameModules;
	
	// For quickly matching children type, to test if can be treated as content.
	var CONTENT_TYPES = { string: true, number: true };
	
	var STYLE = 'style';
	var HTML = '__html';
	var RESERVED_PROPS = {
	  children: null,
	  dangerouslySetInnerHTML: null,
	  suppressContentEditableWarning: null
	};
	
	// Node type for document fragments (Node.DOCUMENT_FRAGMENT_NODE).
	var DOC_FRAGMENT_TYPE = 11;
	
	function getDeclarationErrorAddendum(internalInstance) {
	  if (internalInstance) {
	    var owner = internalInstance._currentElement._owner || null;
	    if (owner) {
	      var name = owner.getName();
	      if (name) {
	        return ' This DOM node was rendered by `' + name + '`.';
	      }
	    }
	  }
	  return '';
	}
	
	function friendlyStringify(obj) {
	  if (typeof obj === 'object') {
	    if (Array.isArray(obj)) {
	      return '[' + obj.map(friendlyStringify).join(', ') + ']';
	    } else {
	      var pairs = [];
	      for (var key in obj) {
	        if (Object.prototype.hasOwnProperty.call(obj, key)) {
	          var keyEscaped = /^[a-z$_][\w$_]*$/i.test(key) ? key : JSON.stringify(key);
	          pairs.push(keyEscaped + ': ' + friendlyStringify(obj[key]));
	        }
	      }
	      return '{' + pairs.join(', ') + '}';
	    }
	  } else if (typeof obj === 'string') {
	    return JSON.stringify(obj);
	  } else if (typeof obj === 'function') {
	    return '[function object]';
	  }
	  // Differs from JSON.stringify in that undefined because undefined and that
	  // inf and nan don't become null
	  return String(obj);
	}
	
	var styleMutationWarning = {};
	
	function checkAndWarnForMutatedStyle(style1, style2, component) {
	  if (style1 == null || style2 == null) {
	    return;
	  }
	  if (shallowEqual(style1, style2)) {
	    return;
	  }
	
	  var componentName = component._tag;
	  var owner = component._currentElement._owner;
	  var ownerName;
	  if (owner) {
	    ownerName = owner.getName();
	  }
	
	  var hash = ownerName + '|' + componentName;
	
	  if (styleMutationWarning.hasOwnProperty(hash)) {
	    return;
	  }
	
	  styleMutationWarning[hash] = true;
	
	   false ? warning(false, '`%s` was passed a style object that has previously been mutated. ' + 'Mutating `style` is deprecated. Consider cloning it beforehand. Check ' + 'the `render` %s. Previous style: %s. Mutated style: %s.', componentName, owner ? 'of `' + ownerName + '`' : 'using <' + componentName + '>', friendlyStringify(style1), friendlyStringify(style2)) : void 0;
	}
	
	/**
	 * @param {object} component
	 * @param {?object} props
	 */
	function assertValidProps(component, props) {
	  if (!props) {
	    return;
	  }
	  // Note the use of `==` which checks for null or undefined.
	  if (voidElementTags[component._tag]) {
	    !(props.children == null && props.dangerouslySetInnerHTML == null) ?  false ? invariant(false, '%s is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`.%s', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : _prodInvariant('137', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : void 0;
	  }
	  if (props.dangerouslySetInnerHTML != null) {
	    !(props.children == null) ?  false ? invariant(false, 'Can only set one of `children` or `props.dangerouslySetInnerHTML`.') : _prodInvariant('60') : void 0;
	    !(typeof props.dangerouslySetInnerHTML === 'object' && HTML in props.dangerouslySetInnerHTML) ?  false ? invariant(false, '`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://fb.me/react-invariant-dangerously-set-inner-html for more information.') : _prodInvariant('61') : void 0;
	  }
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(props.innerHTML == null, 'Directly setting property `innerHTML` is not permitted. ' + 'For more information, lookup documentation on `dangerouslySetInnerHTML`.') : void 0;
	    process.env.NODE_ENV !== 'production' ? warning(props.suppressContentEditableWarning || !props.contentEditable || props.children == null, 'A component is `contentEditable` and contains `children` managed by ' + 'React. It is now your responsibility to guarantee that none of ' + 'those nodes are unexpectedly modified or duplicated. This is ' + 'probably not intentional.') : void 0;
	    process.env.NODE_ENV !== 'production' ? warning(props.onFocusIn == null && props.onFocusOut == null, 'React uses onFocus and onBlur instead of onFocusIn and onFocusOut. ' + 'All React events are normalized to bubble, so onFocusIn and onFocusOut ' + 'are not needed/supported by React.') : void 0;
	  }
	  !(props.style == null || typeof props.style === 'object') ?  false ? invariant(false, 'The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + \'em\'}} when using JSX.%s', getDeclarationErrorAddendum(component)) : _prodInvariant('62', getDeclarationErrorAddendum(component)) : void 0;
	}
	
	function enqueuePutListener(inst, registrationName, listener, transaction) {
	  if (transaction instanceof ReactServerRenderingTransaction) {
	    return;
	  }
	  if (false) {
	    // IE8 has no API for event capturing and the `onScroll` event doesn't
	    // bubble.
	    process.env.NODE_ENV !== 'production' ? warning(registrationName !== 'onScroll' || isEventSupported('scroll', true), "This browser doesn't support the `onScroll` event") : void 0;
	  }
	  var containerInfo = inst._hostContainerInfo;
	  var isDocumentFragment = containerInfo._node && containerInfo._node.nodeType === DOC_FRAGMENT_TYPE;
	  var doc = isDocumentFragment ? containerInfo._node : containerInfo._ownerDocument;
	  listenTo(registrationName, doc);
	  transaction.getReactMountReady().enqueue(putListener, {
	    inst: inst,
	    registrationName: registrationName,
	    listener: listener
	  });
	}
	
	function putListener() {
	  var listenerToPut = this;
	  EventPluginHub.putListener(listenerToPut.inst, listenerToPut.registrationName, listenerToPut.listener);
	}
	
	function inputPostMount() {
	  var inst = this;
	  ReactDOMInput.postMountWrapper(inst);
	}
	
	function textareaPostMount() {
	  var inst = this;
	  ReactDOMTextarea.postMountWrapper(inst);
	}
	
	function optionPostMount() {
	  var inst = this;
	  ReactDOMOption.postMountWrapper(inst);
	}
	
	var setAndValidateContentChildDev = emptyFunction;
	if (false) {
	  setAndValidateContentChildDev = function (content) {
	    var hasExistingContent = this._contentDebugID != null;
	    var debugID = this._debugID;
	    // This ID represents the inlined child that has no backing instance:
	    var contentDebugID = -debugID;
	
	    if (content == null) {
	      if (hasExistingContent) {
	        ReactInstrumentation.debugTool.onUnmountComponent(this._contentDebugID);
	      }
	      this._contentDebugID = null;
	      return;
	    }
	
	    validateDOMNesting(null, String(content), this, this._ancestorInfo);
	    this._contentDebugID = contentDebugID;
	    if (hasExistingContent) {
	      ReactInstrumentation.debugTool.onBeforeUpdateComponent(contentDebugID, content);
	      ReactInstrumentation.debugTool.onUpdateComponent(contentDebugID);
	    } else {
	      ReactInstrumentation.debugTool.onBeforeMountComponent(contentDebugID, content, debugID);
	      ReactInstrumentation.debugTool.onMountComponent(contentDebugID);
	      ReactInstrumentation.debugTool.onSetChildren(debugID, [contentDebugID]);
	    }
	  };
	}
	
	// There are so many media events, it makes sense to just
	// maintain a list rather than create a `trapBubbledEvent` for each
	var mediaEvents = {
	  topAbort: 'abort',
	  topCanPlay: 'canplay',
	  topCanPlayThrough: 'canplaythrough',
	  topDurationChange: 'durationchange',
	  topEmptied: 'emptied',
	  topEncrypted: 'encrypted',
	  topEnded: 'ended',
	  topError: 'error',
	  topLoadedData: 'loadeddata',
	  topLoadedMetadata: 'loadedmetadata',
	  topLoadStart: 'loadstart',
	  topPause: 'pause',
	  topPlay: 'play',
	  topPlaying: 'playing',
	  topProgress: 'progress',
	  topRateChange: 'ratechange',
	  topSeeked: 'seeked',
	  topSeeking: 'seeking',
	  topStalled: 'stalled',
	  topSuspend: 'suspend',
	  topTimeUpdate: 'timeupdate',
	  topVolumeChange: 'volumechange',
	  topWaiting: 'waiting'
	};
	
	function trackInputValue() {
	  inputValueTracking.track(this);
	}
	
	function trapBubbledEventsLocal() {
	  var inst = this;
	  // If a component renders to null or if another component fatals and causes
	  // the state of the tree to be corrupted, `node` here can be null.
	  !inst._rootNodeID ?  false ? invariant(false, 'Must be mounted to trap events') : _prodInvariant('63') : void 0;
	  var node = getNode(inst);
	  !node ?  false ? invariant(false, 'trapBubbledEvent(...): Requires node to be rendered.') : _prodInvariant('64') : void 0;
	
	  switch (inst._tag) {
	    case 'iframe':
	    case 'object':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topLoad', 'load', node)];
	      break;
	    case 'video':
	    case 'audio':
	      inst._wrapperState.listeners = [];
	      // Create listener for each media event
	      for (var event in mediaEvents) {
	        if (mediaEvents.hasOwnProperty(event)) {
	          inst._wrapperState.listeners.push(ReactBrowserEventEmitter.trapBubbledEvent(event, mediaEvents[event], node));
	        }
	      }
	      break;
	    case 'source':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topError', 'error', node)];
	      break;
	    case 'img':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topError', 'error', node), ReactBrowserEventEmitter.trapBubbledEvent('topLoad', 'load', node)];
	      break;
	    case 'form':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topReset', 'reset', node), ReactBrowserEventEmitter.trapBubbledEvent('topSubmit', 'submit', node)];
	      break;
	    case 'input':
	    case 'select':
	    case 'textarea':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topInvalid', 'invalid', node)];
	      break;
	  }
	}
	
	function postUpdateSelectWrapper() {
	  ReactDOMSelect.postUpdateWrapper(this);
	}
	
	// For HTML, certain tags should omit their close tag. We keep a whitelist for
	// those special-case tags.
	
	var omittedCloseTags = {
	  area: true,
	  base: true,
	  br: true,
	  col: true,
	  embed: true,
	  hr: true,
	  img: true,
	  input: true,
	  keygen: true,
	  link: true,
	  meta: true,
	  param: true,
	  source: true,
	  track: true,
	  wbr: true
	  // NOTE: menuitem's close tag should be omitted, but that causes problems.
	};
	
	var newlineEatingTags = {
	  listing: true,
	  pre: true,
	  textarea: true
	};
	
	// For HTML, certain tags cannot have children. This has the same purpose as
	// `omittedCloseTags` except that `menuitem` should still have its closing tag.
	
	var voidElementTags = _assign({
	  menuitem: true
	}, omittedCloseTags);
	
	// We accept any tag to be rendered but since this gets injected into arbitrary
	// HTML, we want to make sure that it's a safe tag.
	// http://www.w3.org/TR/REC-xml/#NT-Name
	
	var VALID_TAG_REGEX = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/; // Simplified subset
	var validatedTagCache = {};
	var hasOwnProperty = {}.hasOwnProperty;
	
	function validateDangerousTag(tag) {
	  if (!hasOwnProperty.call(validatedTagCache, tag)) {
	    !VALID_TAG_REGEX.test(tag) ?  false ? invariant(false, 'Invalid tag: %s', tag) : _prodInvariant('65', tag) : void 0;
	    validatedTagCache[tag] = true;
	  }
	}
	
	function isCustomComponent(tagName, props) {
	  return tagName.indexOf('-') >= 0 || props.is != null;
	}
	
	var globalIdCounter = 1;
	
	/**
	 * Creates a new React class that is idempotent and capable of containing other
	 * React components. It accepts event listeners and DOM properties that are
	 * valid according to `DOMProperty`.
	 *
	 *  - Event listeners: `onClick`, `onMouseDown`, etc.
	 *  - DOM properties: `className`, `name`, `title`, etc.
	 *
	 * The `style` property functions differently from the DOM API. It accepts an
	 * object mapping of style properties to values.
	 *
	 * @constructor ReactDOMComponent
	 * @extends ReactMultiChild
	 */
	function ReactDOMComponent(element) {
	  var tag = element.type;
	  validateDangerousTag(tag);
	  this._currentElement = element;
	  this._tag = tag.toLowerCase();
	  this._namespaceURI = null;
	  this._renderedChildren = null;
	  this._previousStyle = null;
	  this._previousStyleCopy = null;
	  this._hostNode = null;
	  this._hostParent = null;
	  this._rootNodeID = 0;
	  this._domID = 0;
	  this._hostContainerInfo = null;
	  this._wrapperState = null;
	  this._topLevelWrapper = null;
	  this._flags = 0;
	  if (false) {
	    this._ancestorInfo = null;
	    setAndValidateContentChildDev.call(this, null);
	  }
	}
	
	ReactDOMComponent.displayName = 'ReactDOMComponent';
	
	ReactDOMComponent.Mixin = {
	  /**
	   * Generates root tag markup then recurses. This method has side effects and
	   * is not idempotent.
	   *
	   * @internal
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {?ReactDOMComponent} the parent component instance
	   * @param {?object} info about the host container
	   * @param {object} context
	   * @return {string} The computed markup.
	   */
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    this._rootNodeID = globalIdCounter++;
	    this._domID = hostContainerInfo._idCounter++;
	    this._hostParent = hostParent;
	    this._hostContainerInfo = hostContainerInfo;
	
	    var props = this._currentElement.props;
	
	    switch (this._tag) {
	      case 'audio':
	      case 'form':
	      case 'iframe':
	      case 'img':
	      case 'link':
	      case 'object':
	      case 'source':
	      case 'video':
	        this._wrapperState = {
	          listeners: null
	        };
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'input':
	        ReactDOMInput.mountWrapper(this, props, hostParent);
	        props = ReactDOMInput.getHostProps(this, props);
	        transaction.getReactMountReady().enqueue(trackInputValue, this);
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'option':
	        ReactDOMOption.mountWrapper(this, props, hostParent);
	        props = ReactDOMOption.getHostProps(this, props);
	        break;
	      case 'select':
	        ReactDOMSelect.mountWrapper(this, props, hostParent);
	        props = ReactDOMSelect.getHostProps(this, props);
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'textarea':
	        ReactDOMTextarea.mountWrapper(this, props, hostParent);
	        props = ReactDOMTextarea.getHostProps(this, props);
	        transaction.getReactMountReady().enqueue(trackInputValue, this);
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	    }
	
	    assertValidProps(this, props);
	
	    // We create tags in the namespace of their parent container, except HTML
	    // tags get no namespace.
	    var namespaceURI;
	    var parentTag;
	    if (hostParent != null) {
	      namespaceURI = hostParent._namespaceURI;
	      parentTag = hostParent._tag;
	    } else if (hostContainerInfo._tag) {
	      namespaceURI = hostContainerInfo._namespaceURI;
	      parentTag = hostContainerInfo._tag;
	    }
	    if (namespaceURI == null || namespaceURI === DOMNamespaces.svg && parentTag === 'foreignobject') {
	      namespaceURI = DOMNamespaces.html;
	    }
	    if (namespaceURI === DOMNamespaces.html) {
	      if (this._tag === 'svg') {
	        namespaceURI = DOMNamespaces.svg;
	      } else if (this._tag === 'math') {
	        namespaceURI = DOMNamespaces.mathml;
	      }
	    }
	    this._namespaceURI = namespaceURI;
	
	    if (false) {
	      var parentInfo;
	      if (hostParent != null) {
	        parentInfo = hostParent._ancestorInfo;
	      } else if (hostContainerInfo._tag) {
	        parentInfo = hostContainerInfo._ancestorInfo;
	      }
	      if (parentInfo) {
	        // parentInfo should always be present except for the top-level
	        // component when server rendering
	        validateDOMNesting(this._tag, null, this, parentInfo);
	      }
	      this._ancestorInfo = validateDOMNesting.updatedAncestorInfo(parentInfo, this._tag, this);
	    }
	
	    var mountImage;
	    if (transaction.useCreateElement) {
	      var ownerDocument = hostContainerInfo._ownerDocument;
	      var el;
	      if (namespaceURI === DOMNamespaces.html) {
	        if (this._tag === 'script') {
	          // Create the script via .innerHTML so its "parser-inserted" flag is
	          // set to true and it does not execute
	          var div = ownerDocument.createElement('div');
	          var type = this._currentElement.type;
	          div.innerHTML = '<' + type + '></' + type + '>';
	          el = div.removeChild(div.firstChild);
	        } else if (props.is) {
	          el = ownerDocument.createElement(this._currentElement.type, props.is);
	        } else {
	          // Separate else branch instead of using `props.is || undefined` above becuase of a Firefox bug.
	          // See discussion in https://github.com/facebook/react/pull/6896
	          // and discussion in https://bugzilla.mozilla.org/show_bug.cgi?id=1276240
	          el = ownerDocument.createElement(this._currentElement.type);
	        }
	      } else {
	        el = ownerDocument.createElementNS(namespaceURI, this._currentElement.type);
	      }
	      ReactDOMComponentTree.precacheNode(this, el);
	      this._flags |= Flags.hasCachedChildNodes;
	      if (!this._hostParent) {
	        DOMPropertyOperations.setAttributeForRoot(el);
	      }
	      this._updateDOMProperties(null, props, transaction);
	      var lazyTree = DOMLazyTree(el);
	      this._createInitialChildren(transaction, props, context, lazyTree);
	      mountImage = lazyTree;
	    } else {
	      var tagOpen = this._createOpenTagMarkupAndPutListeners(transaction, props);
	      var tagContent = this._createContentMarkup(transaction, props, context);
	      if (!tagContent && omittedCloseTags[this._tag]) {
	        mountImage = tagOpen + '/>';
	      } else {
	        mountImage = tagOpen + '>' + tagContent + '</' + this._currentElement.type + '>';
	      }
	    }
	
	    switch (this._tag) {
	      case 'input':
	        transaction.getReactMountReady().enqueue(inputPostMount, this);
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'textarea':
	        transaction.getReactMountReady().enqueue(textareaPostMount, this);
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'select':
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'button':
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'option':
	        transaction.getReactMountReady().enqueue(optionPostMount, this);
	        break;
	    }
	
	    return mountImage;
	  },
	
	  /**
	   * Creates markup for the open tag and all attributes.
	   *
	   * This method has side effects because events get registered.
	   *
	   * Iterating over object properties is faster than iterating over arrays.
	   * @see http://jsperf.com/obj-vs-arr-iteration
	   *
	   * @private
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} props
	   * @return {string} Markup of opening tag.
	   */
	  _createOpenTagMarkupAndPutListeners: function (transaction, props) {
	    var ret = '<' + this._currentElement.type;
	
	    for (var propKey in props) {
	      if (!props.hasOwnProperty(propKey)) {
	        continue;
	      }
	      var propValue = props[propKey];
	      if (propValue == null) {
	        continue;
	      }
	      if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (propValue) {
	          enqueuePutListener(this, propKey, propValue, transaction);
	        }
	      } else {
	        if (propKey === STYLE) {
	          if (propValue) {
	            if (false) {
	              // See `_updateDOMProperties`. style block
	              this._previousStyle = propValue;
	            }
	            propValue = this._previousStyleCopy = _assign({}, props.style);
	          }
	          propValue = CSSPropertyOperations.createMarkupForStyles(propValue, this);
	        }
	        var markup = null;
	        if (this._tag != null && isCustomComponent(this._tag, props)) {
	          if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
	            markup = DOMPropertyOperations.createMarkupForCustomAttribute(propKey, propValue);
	          }
	        } else {
	          markup = DOMPropertyOperations.createMarkupForProperty(propKey, propValue);
	        }
	        if (markup) {
	          ret += ' ' + markup;
	        }
	      }
	    }
	
	    // For static pages, no need to put React ID and checksum. Saves lots of
	    // bytes.
	    if (transaction.renderToStaticMarkup) {
	      return ret;
	    }
	
	    if (!this._hostParent) {
	      ret += ' ' + DOMPropertyOperations.createMarkupForRoot();
	    }
	    ret += ' ' + DOMPropertyOperations.createMarkupForID(this._domID);
	    return ret;
	  },
	
	  /**
	   * Creates markup for the content between the tags.
	   *
	   * @private
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} props
	   * @param {object} context
	   * @return {string} Content markup.
	   */
	  _createContentMarkup: function (transaction, props, context) {
	    var ret = '';
	
	    // Intentional use of != to avoid catching zero/false.
	    var innerHTML = props.dangerouslySetInnerHTML;
	    if (innerHTML != null) {
	      if (innerHTML.__html != null) {
	        ret = innerHTML.__html;
	      }
	    } else {
	      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
	      var childrenToUse = contentToUse != null ? null : props.children;
	      if (contentToUse != null) {
	        // TODO: Validate that text is allowed as a child of this node
	        ret = escapeTextContentForBrowser(contentToUse);
	        if (false) {
	          setAndValidateContentChildDev.call(this, contentToUse);
	        }
	      } else if (childrenToUse != null) {
	        var mountImages = this.mountChildren(childrenToUse, transaction, context);
	        ret = mountImages.join('');
	      }
	    }
	    if (newlineEatingTags[this._tag] && ret.charAt(0) === '\n') {
	      // text/html ignores the first character in these tags if it's a newline
	      // Prefer to break application/xml over text/html (for now) by adding
	      // a newline specifically to get eaten by the parser. (Alternately for
	      // textareas, replacing "^\n" with "\r\n" doesn't get eaten, and the first
	      // \r is normalized out by HTMLTextAreaElement#value.)
	      // See: <http://www.w3.org/TR/html-polyglot/#newlines-in-textarea-and-pre>
	      // See: <http://www.w3.org/TR/html5/syntax.html#element-restrictions>
	      // See: <http://www.w3.org/TR/html5/syntax.html#newlines>
	      // See: Parsing of "textarea" "listing" and "pre" elements
	      //  from <http://www.w3.org/TR/html5/syntax.html#parsing-main-inbody>
	      return '\n' + ret;
	    } else {
	      return ret;
	    }
	  },
	
	  _createInitialChildren: function (transaction, props, context, lazyTree) {
	    // Intentional use of != to avoid catching zero/false.
	    var innerHTML = props.dangerouslySetInnerHTML;
	    if (innerHTML != null) {
	      if (innerHTML.__html != null) {
	        DOMLazyTree.queueHTML(lazyTree, innerHTML.__html);
	      }
	    } else {
	      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
	      var childrenToUse = contentToUse != null ? null : props.children;
	      // TODO: Validate that text is allowed as a child of this node
	      if (contentToUse != null) {
	        // Avoid setting textContent when the text is empty. In IE11 setting
	        // textContent on a text area will cause the placeholder to not
	        // show within the textarea until it has been focused and blurred again.
	        // https://github.com/facebook/react/issues/6731#issuecomment-254874553
	        if (contentToUse !== '') {
	          if (false) {
	            setAndValidateContentChildDev.call(this, contentToUse);
	          }
	          DOMLazyTree.queueText(lazyTree, contentToUse);
	        }
	      } else if (childrenToUse != null) {
	        var mountImages = this.mountChildren(childrenToUse, transaction, context);
	        for (var i = 0; i < mountImages.length; i++) {
	          DOMLazyTree.queueChild(lazyTree, mountImages[i]);
	        }
	      }
	    }
	  },
	
	  /**
	   * Receives a next element and updates the component.
	   *
	   * @internal
	   * @param {ReactElement} nextElement
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} context
	   */
	  receiveComponent: function (nextElement, transaction, context) {
	    var prevElement = this._currentElement;
	    this._currentElement = nextElement;
	    this.updateComponent(transaction, prevElement, nextElement, context);
	  },
	
	  /**
	   * Updates a DOM component after it has already been allocated and
	   * attached to the DOM. Reconciles the root DOM node, then recurses.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @param {ReactElement} prevElement
	   * @param {ReactElement} nextElement
	   * @internal
	   * @overridable
	   */
	  updateComponent: function (transaction, prevElement, nextElement, context) {
	    var lastProps = prevElement.props;
	    var nextProps = this._currentElement.props;
	
	    switch (this._tag) {
	      case 'input':
	        lastProps = ReactDOMInput.getHostProps(this, lastProps);
	        nextProps = ReactDOMInput.getHostProps(this, nextProps);
	        break;
	      case 'option':
	        lastProps = ReactDOMOption.getHostProps(this, lastProps);
	        nextProps = ReactDOMOption.getHostProps(this, nextProps);
	        break;
	      case 'select':
	        lastProps = ReactDOMSelect.getHostProps(this, lastProps);
	        nextProps = ReactDOMSelect.getHostProps(this, nextProps);
	        break;
	      case 'textarea':
	        lastProps = ReactDOMTextarea.getHostProps(this, lastProps);
	        nextProps = ReactDOMTextarea.getHostProps(this, nextProps);
	        break;
	    }
	
	    assertValidProps(this, nextProps);
	    this._updateDOMProperties(lastProps, nextProps, transaction);
	    this._updateDOMChildren(lastProps, nextProps, transaction, context);
	
	    switch (this._tag) {
	      case 'input':
	        // Update the wrapper around inputs *after* updating props. This has to
	        // happen after `_updateDOMProperties`. Otherwise HTML5 input validations
	        // raise warnings and prevent the new value from being assigned.
	        ReactDOMInput.updateWrapper(this);
	
	        // We also check that we haven't missed a value update, such as a
	        // Radio group shifting the checked value to another named radio input.
	        inputValueTracking.updateValueIfChanged(this);
	        break;
	      case 'textarea':
	        ReactDOMTextarea.updateWrapper(this);
	        break;
	      case 'select':
	        // <select> value update needs to occur after <option> children
	        // reconciliation
	        transaction.getReactMountReady().enqueue(postUpdateSelectWrapper, this);
	        break;
	    }
	  },
	
	  /**
	   * Reconciles the properties by detecting differences in property values and
	   * updating the DOM as necessary. This function is probably the single most
	   * critical path for performance optimization.
	   *
	   * TODO: Benchmark whether checking for changed values in memory actually
	   *       improves performance (especially statically positioned elements).
	   * TODO: Benchmark the effects of putting this at the top since 99% of props
	   *       do not change for a given reconciliation.
	   * TODO: Benchmark areas that can be improved with caching.
	   *
	   * @private
	   * @param {object} lastProps
	   * @param {object} nextProps
	   * @param {?DOMElement} node
	   */
	  _updateDOMProperties: function (lastProps, nextProps, transaction) {
	    var propKey;
	    var styleName;
	    var styleUpdates;
	    for (propKey in lastProps) {
	      if (nextProps.hasOwnProperty(propKey) || !lastProps.hasOwnProperty(propKey) || lastProps[propKey] == null) {
	        continue;
	      }
	      if (propKey === STYLE) {
	        var lastStyle = this._previousStyleCopy;
	        for (styleName in lastStyle) {
	          if (lastStyle.hasOwnProperty(styleName)) {
	            styleUpdates = styleUpdates || {};
	            styleUpdates[styleName] = '';
	          }
	        }
	        this._previousStyleCopy = null;
	      } else if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (lastProps[propKey]) {
	          // Only call deleteListener if there was a listener previously or
	          // else willDeleteListener gets called when there wasn't actually a
	          // listener (e.g., onClick={null})
	          deleteListener(this, propKey);
	        }
	      } else if (isCustomComponent(this._tag, lastProps)) {
	        if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
	          DOMPropertyOperations.deleteValueForAttribute(getNode(this), propKey);
	        }
	      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
	        DOMPropertyOperations.deleteValueForProperty(getNode(this), propKey);
	      }
	    }
	    for (propKey in nextProps) {
	      var nextProp = nextProps[propKey];
	      var lastProp = propKey === STYLE ? this._previousStyleCopy : lastProps != null ? lastProps[propKey] : undefined;
	      if (!nextProps.hasOwnProperty(propKey) || nextProp === lastProp || nextProp == null && lastProp == null) {
	        continue;
	      }
	      if (propKey === STYLE) {
	        if (nextProp) {
	          if (false) {
	            checkAndWarnForMutatedStyle(this._previousStyleCopy, this._previousStyle, this);
	            this._previousStyle = nextProp;
	          }
	          nextProp = this._previousStyleCopy = _assign({}, nextProp);
	        } else {
	          this._previousStyleCopy = null;
	        }
	        if (lastProp) {
	          // Unset styles on `lastProp` but not on `nextProp`.
	          for (styleName in lastProp) {
	            if (lastProp.hasOwnProperty(styleName) && (!nextProp || !nextProp.hasOwnProperty(styleName))) {
	              styleUpdates = styleUpdates || {};
	              styleUpdates[styleName] = '';
	            }
	          }
	          // Update styles that changed since `lastProp`.
	          for (styleName in nextProp) {
	            if (nextProp.hasOwnProperty(styleName) && lastProp[styleName] !== nextProp[styleName]) {
	              styleUpdates = styleUpdates || {};
	              styleUpdates[styleName] = nextProp[styleName];
	            }
	          }
	        } else {
	          // Relies on `updateStylesByID` not mutating `styleUpdates`.
	          styleUpdates = nextProp;
	        }
	      } else if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (nextProp) {
	          enqueuePutListener(this, propKey, nextProp, transaction);
	        } else if (lastProp) {
	          deleteListener(this, propKey);
	        }
	      } else if (isCustomComponent(this._tag, nextProps)) {
	        if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
	          DOMPropertyOperations.setValueForAttribute(getNode(this), propKey, nextProp);
	        }
	      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
	        var node = getNode(this);
	        // If we're updating to null or undefined, we should remove the property
	        // from the DOM node instead of inadvertently setting to a string. This
	        // brings us in line with the same behavior we have on initial render.
	        if (nextProp != null) {
	          DOMPropertyOperations.setValueForProperty(node, propKey, nextProp);
	        } else {
	          DOMPropertyOperations.deleteValueForProperty(node, propKey);
	        }
	      }
	    }
	    if (styleUpdates) {
	      CSSPropertyOperations.setValueForStyles(getNode(this), styleUpdates, this);
	    }
	  },
	
	  /**
	   * Reconciles the children with the various properties that affect the
	   * children content.
	   *
	   * @param {object} lastProps
	   * @param {object} nextProps
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   */
	  _updateDOMChildren: function (lastProps, nextProps, transaction, context) {
	    var lastContent = CONTENT_TYPES[typeof lastProps.children] ? lastProps.children : null;
	    var nextContent = CONTENT_TYPES[typeof nextProps.children] ? nextProps.children : null;
	
	    var lastHtml = lastProps.dangerouslySetInnerHTML && lastProps.dangerouslySetInnerHTML.__html;
	    var nextHtml = nextProps.dangerouslySetInnerHTML && nextProps.dangerouslySetInnerHTML.__html;
	
	    // Note the use of `!=` which checks for null or undefined.
	    var lastChildren = lastContent != null ? null : lastProps.children;
	    var nextChildren = nextContent != null ? null : nextProps.children;
	
	    // If we're switching from children to content/html or vice versa, remove
	    // the old content
	    var lastHasContentOrHtml = lastContent != null || lastHtml != null;
	    var nextHasContentOrHtml = nextContent != null || nextHtml != null;
	    if (lastChildren != null && nextChildren == null) {
	      this.updateChildren(null, transaction, context);
	    } else if (lastHasContentOrHtml && !nextHasContentOrHtml) {
	      this.updateTextContent('');
	      if (false) {
	        ReactInstrumentation.debugTool.onSetChildren(this._debugID, []);
	      }
	    }
	
	    if (nextContent != null) {
	      if (lastContent !== nextContent) {
	        this.updateTextContent('' + nextContent);
	        if (false) {
	          setAndValidateContentChildDev.call(this, nextContent);
	        }
	      }
	    } else if (nextHtml != null) {
	      if (lastHtml !== nextHtml) {
	        this.updateMarkup('' + nextHtml);
	      }
	      if (false) {
	        ReactInstrumentation.debugTool.onSetChildren(this._debugID, []);
	      }
	    } else if (nextChildren != null) {
	      if (false) {
	        setAndValidateContentChildDev.call(this, null);
	      }
	
	      this.updateChildren(nextChildren, transaction, context);
	    }
	  },
	
	  getHostNode: function () {
	    return getNode(this);
	  },
	
	  /**
	   * Destroys all event registrations for this instance. Does not remove from
	   * the DOM. That must be done by the parent.
	   *
	   * @internal
	   */
	  unmountComponent: function (safely) {
	    switch (this._tag) {
	      case 'audio':
	      case 'form':
	      case 'iframe':
	      case 'img':
	      case 'link':
	      case 'object':
	      case 'source':
	      case 'video':
	        var listeners = this._wrapperState.listeners;
	        if (listeners) {
	          for (var i = 0; i < listeners.length; i++) {
	            listeners[i].remove();
	          }
	        }
	        break;
	      case 'input':
	      case 'textarea':
	        inputValueTracking.stopTracking(this);
	        break;
	      case 'html':
	      case 'head':
	      case 'body':
	        /**
	         * Components like <html> <head> and <body> can't be removed or added
	         * easily in a cross-browser way, however it's valuable to be able to
	         * take advantage of React's reconciliation for styling and <title>
	         * management. So we just document it and throw in dangerous cases.
	         */
	         true ?  false ? invariant(false, '<%s> tried to unmount. Because of cross-browser quirks it is impossible to unmount some top-level components (eg <html>, <head>, and <body>) reliably and efficiently. To fix this, have a single top-level component that never unmounts render these elements.', this._tag) : _prodInvariant('66', this._tag) : void 0;
	        break;
	    }
	
	    this.unmountChildren(safely);
	    ReactDOMComponentTree.uncacheNode(this);
	    EventPluginHub.deleteAllListeners(this);
	    this._rootNodeID = 0;
	    this._domID = 0;
	    this._wrapperState = null;
	
	    if (false) {
	      setAndValidateContentChildDev.call(this, null);
	    }
	  },
	
	  getPublicInstance: function () {
	    return getNode(this);
	  }
	};
	
	_assign(ReactDOMComponent.prototype, ReactDOMComponent.Mixin, ReactMultiChild.Mixin);
	
	module.exports = ReactDOMComponent;

/***/ }),
/* 432 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var validateDOMNesting = __webpack_require__(132);
	
	var DOC_NODE_TYPE = 9;
	
	function ReactDOMContainerInfo(topLevelWrapper, node) {
	  var info = {
	    _topLevelWrapper: topLevelWrapper,
	    _idCounter: 1,
	    _ownerDocument: node ? node.nodeType === DOC_NODE_TYPE ? node : node.ownerDocument : null,
	    _node: node,
	    _tag: node ? node.nodeName.toLowerCase() : null,
	    _namespaceURI: node ? node.namespaceURI : null
	  };
	  if (false) {
	    info._ancestorInfo = node ? validateDOMNesting.updatedAncestorInfo(null, info._tag, null) : null;
	  }
	  return info;
	}
	
	module.exports = ReactDOMContainerInfo;

/***/ }),
/* 433 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(7);
	
	var DOMLazyTree = __webpack_require__(44);
	var ReactDOMComponentTree = __webpack_require__(9);
	
	var ReactDOMEmptyComponent = function (instantiate) {
	  // ReactCompositeComponent uses this:
	  this._currentElement = null;
	  // ReactDOMComponentTree uses these:
	  this._hostNode = null;
	  this._hostParent = null;
	  this._hostContainerInfo = null;
	  this._domID = 0;
	};
	_assign(ReactDOMEmptyComponent.prototype, {
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    var domID = hostContainerInfo._idCounter++;
	    this._domID = domID;
	    this._hostParent = hostParent;
	    this._hostContainerInfo = hostContainerInfo;
	
	    var nodeValue = ' react-empty: ' + this._domID + ' ';
	    if (transaction.useCreateElement) {
	      var ownerDocument = hostContainerInfo._ownerDocument;
	      var node = ownerDocument.createComment(nodeValue);
	      ReactDOMComponentTree.precacheNode(this, node);
	      return DOMLazyTree(node);
	    } else {
	      if (transaction.renderToStaticMarkup) {
	        // Normally we'd insert a comment node, but since this is a situation
	        // where React won't take over (static pages), we can simply return
	        // nothing.
	        return '';
	      }
	      return '<!--' + nodeValue + '-->';
	    }
	  },
	  receiveComponent: function () {},
	  getHostNode: function () {
	    return ReactDOMComponentTree.getNodeFromInstance(this);
	  },
	  unmountComponent: function () {
	    ReactDOMComponentTree.uncacheNode(this);
	  }
	});
	
	module.exports = ReactDOMEmptyComponent;

/***/ }),
/* 434 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactDOMFeatureFlags = {
	  useCreateElement: true,
	  useFiber: false
	};
	
	module.exports = ReactDOMFeatureFlags;

/***/ }),
/* 435 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMChildrenOperations = __webpack_require__(117);
	var ReactDOMComponentTree = __webpack_require__(9);
	
	/**
	 * Operations used to process updates to DOM nodes.
	 */
	var ReactDOMIDOperations = {
	  /**
	   * Updates a component's children by processing a series of updates.
	   *
	   * @param {array<object>} updates List of update configurations.
	   * @internal
	   */
	  dangerouslyProcessChildrenUpdates: function (parentInst, updates) {
	    var node = ReactDOMComponentTree.getNodeFromInstance(parentInst);
	    DOMChildrenOperations.processUpdates(node, updates);
	  }
	};
	
	module.exports = ReactDOMIDOperations;

/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(6),
	    _assign = __webpack_require__(7);
	
	var DOMPropertyOperations = __webpack_require__(198);
	var LinkedValueUtils = __webpack_require__(122);
	var ReactDOMComponentTree = __webpack_require__(9);
	var ReactUpdates = __webpack_require__(28);
	
	var invariant = __webpack_require__(3);
	var warning = __webpack_require__(5);
	
	var didWarnValueLink = false;
	var didWarnCheckedLink = false;
	var didWarnValueDefaultValue = false;
	var didWarnCheckedDefaultChecked = false;
	var didWarnControlledToUncontrolled = false;
	var didWarnUncontrolledToControlled = false;
	
	function forceUpdateIfMounted() {
	  if (this._rootNodeID) {
	    // DOM component is still mounted; update
	    ReactDOMInput.updateWrapper(this);
	  }
	}
	
	function isControlled(props) {
	  var usesChecked = props.type === 'checkbox' || props.type === 'radio';
	  return usesChecked ? props.checked != null : props.value != null;
	}
	
	/**
	 * Implements an <input> host component that allows setting these optional
	 * props: `checked`, `value`, `defaultChecked`, and `defaultValue`.
	 *
	 * If `checked` or `value` are not supplied (or null/undefined), user actions
	 * that affect the checked state or value will trigger updates to the element.
	 *
	 * If they are supplied (and not null/undefined), the rendered element will not
	 * trigger updates to the element. Instead, the props must change in order for
	 * the rendered element to be updated.
	 *
	 * The rendered element will be initialized as unchecked (or `defaultChecked`)
	 * with an empty value (or `defaultValue`).
	 *
	 * @see http://www.w3.org/TR/2012/WD-html5-20121025/the-input-element.html
	 */
	var ReactDOMInput = {
	  getHostProps: function (inst, props) {
	    var value = LinkedValueUtils.getValue(props);
	    var checked = LinkedValueUtils.getChecked(props);
	
	    var hostProps = _assign({
	      // Make sure we set .type before any other properties (setting .value
	      // before .type means .value is lost in IE11 and below)
	      type: undefined,
	      // Make sure we set .step before .value (setting .value before .step
	      // means .value is rounded on mount, based upon step precision)
	      step: undefined,
	      // Make sure we set .min & .max before .value (to ensure proper order
	      // in corner cases such as min or max deriving from value, e.g. Issue #7170)
	      min: undefined,
	      max: undefined
	    }, props, {
	      defaultChecked: undefined,
	      defaultValue: undefined,
	      value: value != null ? value : inst._wrapperState.initialValue,
	      checked: checked != null ? checked : inst._wrapperState.initialChecked,
	      onChange: inst._wrapperState.onChange
	    });
	
	    return hostProps;
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      LinkedValueUtils.checkPropTypes('input', props, inst._currentElement._owner);
	
	      var owner = inst._currentElement._owner;
	
	      if (props.valueLink !== undefined && !didWarnValueLink) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '`valueLink` prop on `input` is deprecated; set `value` and `onChange` instead.') : void 0;
	        didWarnValueLink = true;
	      }
	      if (props.checkedLink !== undefined && !didWarnCheckedLink) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '`checkedLink` prop on `input` is deprecated; set `value` and `onChange` instead.') : void 0;
	        didWarnCheckedLink = true;
	      }
	      if (props.checked !== undefined && props.defaultChecked !== undefined && !didWarnCheckedDefaultChecked) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s contains an input of type %s with both checked and defaultChecked props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the checked prop, or the defaultChecked prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnCheckedDefaultChecked = true;
	      }
	      if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s contains an input of type %s with both value and defaultValue props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnValueDefaultValue = true;
	      }
	    }
	
	    var defaultValue = props.defaultValue;
	    inst._wrapperState = {
	      initialChecked: props.checked != null ? props.checked : props.defaultChecked,
	      initialValue: props.value != null ? props.value : defaultValue,
	      listeners: null,
	      onChange: _handleChange.bind(inst),
	      controlled: isControlled(props)
	    };
	  },
	
	  updateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    if (false) {
	      var controlled = isControlled(props);
	      var owner = inst._currentElement._owner;
	
	      if (!inst._wrapperState.controlled && controlled && !didWarnUncontrolledToControlled) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s is changing an uncontrolled input of type %s to be controlled. ' + 'Input elements should not switch from uncontrolled to controlled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnUncontrolledToControlled = true;
	      }
	      if (inst._wrapperState.controlled && !controlled && !didWarnControlledToUncontrolled) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s is changing a controlled input of type %s to be uncontrolled. ' + 'Input elements should not switch from controlled to uncontrolled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnControlledToUncontrolled = true;
	      }
	    }
	
	    // TODO: Shouldn't this be getChecked(props)?
	    var checked = props.checked;
	    if (checked != null) {
	      DOMPropertyOperations.setValueForProperty(ReactDOMComponentTree.getNodeFromInstance(inst), 'checked', checked || false);
	    }
	
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      if (value === 0 && node.value === '') {
	        node.value = '0';
	        // Note: IE9 reports a number inputs as 'text', so check props instead.
	      } else if (props.type === 'number') {
	        // Simulate `input.valueAsNumber`. IE9 does not support it
	        var valueAsNumber = parseFloat(node.value, 10) || 0;
	
	        if (
	        // eslint-disable-next-line
	        value != valueAsNumber ||
	        // eslint-disable-next-line
	        value == valueAsNumber && node.value != value) {
	          // Cast `value` to a string to ensure the value is set correctly. While
	          // browsers typically do this as necessary, jsdom doesn't.
	          node.value = '' + value;
	        }
	      } else if (node.value !== '' + value) {
	        // Cast `value` to a string to ensure the value is set correctly. While
	        // browsers typically do this as necessary, jsdom doesn't.
	        node.value = '' + value;
	      }
	    } else {
	      if (props.value == null && props.defaultValue != null) {
	        // In Chrome, assigning defaultValue to certain input types triggers input validation.
	        // For number inputs, the display value loses trailing decimal points. For email inputs,
	        // Chrome raises "The specified value <x> is not a valid email address".
	        //
	        // Here we check to see if the defaultValue has actually changed, avoiding these problems
	        // when the user is inputting text
	        //
	        // https://github.com/facebook/react/issues/7253
	        if (node.defaultValue !== '' + props.defaultValue) {
	          node.defaultValue = '' + props.defaultValue;
	        }
	      }
	      if (props.checked == null && props.defaultChecked != null) {
	        node.defaultChecked = !!props.defaultChecked;
	      }
	    }
	  },
	
	  postMountWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    // This is in postMount because we need access to the DOM node, which is not
	    // available until after the component has mounted.
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	
	    // Detach value from defaultValue. We won't do anything if we're working on
	    // submit or reset inputs as those values & defaultValues are linked. They
	    // are not resetable nodes so this operation doesn't matter and actually
	    // removes browser-default values (eg "Submit Query") when no value is
	    // provided.
	
	    switch (props.type) {
	      case 'submit':
	      case 'reset':
	        break;
	      case 'color':
	      case 'date':
	      case 'datetime':
	      case 'datetime-local':
	      case 'month':
	      case 'time':
	      case 'week':
	        // This fixes the no-show issue on iOS Safari and Android Chrome:
	        // https://github.com/facebook/react/issues/7233
	        node.value = '';
	        node.value = node.defaultValue;
	        break;
	      default:
	        node.value = node.value;
	        break;
	    }
	
	    // Normally, we'd just do `node.checked = node.checked` upon initial mount, less this bug
	    // this is needed to work around a chrome bug where setting defaultChecked
	    // will sometimes influence the value of checked (even after detachment).
	    // Reference: https://bugs.chromium.org/p/chromium/issues/detail?id=608416
	    // We need to temporarily unset name to avoid disrupting radio button groups.
	    var name = node.name;
	    if (name !== '') {
	      node.name = '';
	    }
	    node.defaultChecked = !node.defaultChecked;
	    node.defaultChecked = !node.defaultChecked;
	    if (name !== '') {
	      node.name = name;
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	
	  // Here we use asap to wait until all updates have propagated, which
	  // is important when using controlled components within layers:
	  // https://github.com/facebook/react/issues/1698
	  ReactUpdates.asap(forceUpdateIfMounted, this);
	
	  var name = props.name;
	  if (props.type === 'radio' && name != null) {
	    var rootNode = ReactDOMComponentTree.getNodeFromInstance(this);
	    var queryRoot = rootNode;
	
	    while (queryRoot.parentNode) {
	      queryRoot = queryRoot.parentNode;
	    }
	
	    // If `rootNode.form` was non-null, then we could try `form.elements`,
	    // but that sometimes behaves strangely in IE8. We could also try using
	    // `form.getElementsByName`, but that will only return direct children
	    // and won't include inputs that use the HTML5 `form=` attribute. Since
	    // the input might not even be in a form, let's just use the global
	    // `querySelectorAll` to ensure we don't miss anything.
	    var group = queryRoot.querySelectorAll('input[name=' + JSON.stringify('' + name) + '][type="radio"]');
	
	    for (var i = 0; i < group.length; i++) {
	      var otherNode = group[i];
	      if (otherNode === rootNode || otherNode.form !== rootNode.form) {
	        continue;
	      }
	      // This will throw if radio buttons rendered by different copies of React
	      // and the same name are rendered into the same form (same as #1939).
	      // That's probably okay; we don't support it just as we don't support
	      // mixing React radio buttons with non-React ones.
	      var otherInstance = ReactDOMComponentTree.getInstanceFromNode(otherNode);
	      !otherInstance ?  false ? invariant(false, 'ReactDOMInput: Mixing React and non-React radio inputs with the same `name` is not supported.') : _prodInvariant('90') : void 0;
	      // If this is a controlled radio button group, forcing the input that
	      // was previously checked to update will cause it to be come re-checked
	      // as appropriate.
	      ReactUpdates.asap(forceUpdateIfMounted, otherInstance);
	    }
	  }
	
	  return returnValue;
	}
	
	module.exports = ReactDOMInput;

/***/ }),
/* 437 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(7);
	
	var React = __webpack_require__(47);
	var ReactDOMComponentTree = __webpack_require__(9);
	var ReactDOMSelect = __webpack_require__(200);
	
	var warning = __webpack_require__(5);
	var didWarnInvalidOptionChildren = false;
	
	function flattenChildren(children) {
	  var content = '';
	
	  // Flatten children and warn if they aren't strings or numbers;
	  // invalid types are ignored.
	  React.Children.forEach(children, function (child) {
	    if (child == null) {
	      return;
	    }
	    if (typeof child === 'string' || typeof child === 'number') {
	      content += child;
	    } else if (!didWarnInvalidOptionChildren) {
	      didWarnInvalidOptionChildren = true;
	       false ? warning(false, 'Only strings and numbers are supported as <option> children.') : void 0;
	    }
	  });
	
	  return content;
	}
	
	/**
	 * Implements an <option> host component that warns when `selected` is set.
	 */
	var ReactDOMOption = {
	  mountWrapper: function (inst, props, hostParent) {
	    // TODO (yungsters): Remove support for `selected` in <option>.
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(props.selected == null, 'Use the `defaultValue` or `value` props on <select> instead of ' + 'setting `selected` on <option>.') : void 0;
	    }
	
	    // Look up whether this option is 'selected'
	    var selectValue = null;
	    if (hostParent != null) {
	      var selectParent = hostParent;
	
	      if (selectParent._tag === 'optgroup') {
	        selectParent = selectParent._hostParent;
	      }
	
	      if (selectParent != null && selectParent._tag === 'select') {
	        selectValue = ReactDOMSelect.getSelectValueContext(selectParent);
	      }
	    }
	
	    // If the value is null (e.g., no specified value or after initial mount)
	    // or missing (e.g., for <datalist>), we don't change props.selected
	    var selected = null;
	    if (selectValue != null) {
	      var value;
	      if (props.value != null) {
	        value = props.value + '';
	      } else {
	        value = flattenChildren(props.children);
	      }
	      selected = false;
	      if (Array.isArray(selectValue)) {
	        // multiple
	        for (var i = 0; i < selectValue.length; i++) {
	          if ('' + selectValue[i] === value) {
	            selected = true;
	            break;
	          }
	        }
	      } else {
	        selected = '' + selectValue === value;
	      }
	    }
	
	    inst._wrapperState = { selected: selected };
	  },
	
	  postMountWrapper: function (inst) {
	    // value="" should make a value attribute (#6219)
	    var props = inst._currentElement.props;
	    if (props.value != null) {
	      var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	      node.setAttribute('value', props.value);
	    }
	  },
	
	  getHostProps: function (inst, props) {
	    var hostProps = _assign({ selected: undefined, children: undefined }, props);
	
	    // Read state only from initial mount because <select> updates value
	    // manually; we need the initial state only for server rendering
	    if (inst._wrapperState.selected != null) {
	      hostProps.selected = inst._wrapperState.selected;
	    }
	
	    var content = flattenChildren(props.children);
	
	    if (content) {
	      hostProps.children = content;
	    }
	
	    return hostProps;
	  }
	};
	
	module.exports = ReactDOMOption;

/***/ }),
/* 438 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(16);
	
	var getNodeForCharacterOffset = __webpack_require__(476);
	var getTextContentAccessor = __webpack_require__(211);
	
	/**
	 * While `isCollapsed` is available on the Selection object and `collapsed`
	 * is available on the Range object, IE11 sometimes gets them wrong.
	 * If the anchor/focus nodes and offsets are the same, the range is collapsed.
	 */
	function isCollapsed(anchorNode, anchorOffset, focusNode, focusOffset) {
	  return anchorNode === focusNode && anchorOffset === focusOffset;
	}
	
	/**
	 * Get the appropriate anchor and focus node/offset pairs for IE.
	 *
	 * The catch here is that IE's selection API doesn't provide information
	 * about whether the selection is forward or backward, so we have to
	 * behave as though it's always forward.
	 *
	 * IE text differs from modern selection in that it behaves as though
	 * block elements end with a new line. This means character offsets will
	 * differ between the two APIs.
	 *
	 * @param {DOMElement} node
	 * @return {object}
	 */
	function getIEOffsets(node) {
	  var selection = document.selection;
	  var selectedRange = selection.createRange();
	  var selectedLength = selectedRange.text.length;
	
	  // Duplicate selection so we can move range without breaking user selection.
	  var fromStart = selectedRange.duplicate();
	  fromStart.moveToElementText(node);
	  fromStart.setEndPoint('EndToStart', selectedRange);
	
	  var startOffset = fromStart.text.length;
	  var endOffset = startOffset + selectedLength;
	
	  return {
	    start: startOffset,
	    end: endOffset
	  };
	}
	
	/**
	 * @param {DOMElement} node
	 * @return {?object}
	 */
	function getModernOffsets(node) {
	  var selection = window.getSelection && window.getSelection();
	
	  if (!selection || selection.rangeCount === 0) {
	    return null;
	  }
	
	  var anchorNode = selection.anchorNode;
	  var anchorOffset = selection.anchorOffset;
	  var focusNode = selection.focusNode;
	  var focusOffset = selection.focusOffset;
	
	  var currentRange = selection.getRangeAt(0);
	
	  // In Firefox, range.startContainer and range.endContainer can be "anonymous
	  // divs", e.g. the up/down buttons on an <input type="number">. Anonymous
	  // divs do not seem to expose properties, triggering a "Permission denied
	  // error" if any of its properties are accessed. The only seemingly possible
	  // way to avoid erroring is to access a property that typically works for
	  // non-anonymous divs and catch any error that may otherwise arise. See
	  // https://bugzilla.mozilla.org/show_bug.cgi?id=208427
	  try {
	    /* eslint-disable no-unused-expressions */
	    currentRange.startContainer.nodeType;
	    currentRange.endContainer.nodeType;
	    /* eslint-enable no-unused-expressions */
	  } catch (e) {
	    return null;
	  }
	
	  // If the node and offset values are the same, the selection is collapsed.
	  // `Selection.isCollapsed` is available natively, but IE sometimes gets
	  // this value wrong.
	  var isSelectionCollapsed = isCollapsed(selection.anchorNode, selection.anchorOffset, selection.focusNode, selection.focusOffset);
	
	  var rangeLength = isSelectionCollapsed ? 0 : currentRange.toString().length;
	
	  var tempRange = currentRange.cloneRange();
	  tempRange.selectNodeContents(node);
	  tempRange.setEnd(currentRange.startContainer, currentRange.startOffset);
	
	  var isTempRangeCollapsed = isCollapsed(tempRange.startContainer, tempRange.startOffset, tempRange.endContainer, tempRange.endOffset);
	
	  var start = isTempRangeCollapsed ? 0 : tempRange.toString().length;
	  var end = start + rangeLength;
	
	  // Detect whether the selection is backward.
	  var detectionRange = document.createRange();
	  detectionRange.setStart(anchorNode, anchorOffset);
	  detectionRange.setEnd(focusNode, focusOffset);
	  var isBackward = detectionRange.collapsed;
	
	  return {
	    start: isBackward ? end : start,
	    end: isBackward ? start : end
	  };
	}
	
	/**
	 * @param {DOMElement|DOMTextNode} node
	 * @param {object} offsets
	 */
	function setIEOffsets(node, offsets) {
	  var range = document.selection.createRange().duplicate();
	  var start, end;
	
	  if (offsets.end === undefined) {
	    start = offsets.start;
	    end = start;
	  } else if (offsets.start > offsets.end) {
	    start = offsets.end;
	    end = offsets.start;
	  } else {
	    start = offsets.start;
	    end = offsets.end;
	  }
	
	  range.moveToElementText(node);
	  range.moveStart('character', start);
	  range.setEndPoint('EndToStart', range);
	  range.moveEnd('character', end - start);
	  range.select();
	}
	
	/**
	 * In modern non-IE browsers, we can support both forward and backward
	 * selections.
	 *
	 * Note: IE10+ supports the Selection object, but it does not support
	 * the `extend` method, which means that even in modern IE, it's not possible
	 * to programmatically create a backward selection. Thus, for all IE
	 * versions, we use the old IE API to create our selections.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @param {object} offsets
	 */
	function setModernOffsets(node, offsets) {
	  if (!window.getSelection) {
	    return;
	  }
	
	  var selection = window.getSelection();
	  var length = node[getTextContentAccessor()].length;
	  var start = Math.min(offsets.start, length);
	  var end = offsets.end === undefined ? start : Math.min(offsets.end, length);
	
	  // IE 11 uses modern selection, but doesn't support the extend method.
	  // Flip backward selections, so we can set with a single range.
	  if (!selection.extend && start > end) {
	    var temp = end;
	    end = start;
	    start = temp;
	  }
	
	  var startMarker = getNodeForCharacterOffset(node, start);
	  var endMarker = getNodeForCharacterOffset(node, end);
	
	  if (startMarker && endMarker) {
	    var range = document.createRange();
	    range.setStart(startMarker.node, startMarker.offset);
	    selection.removeAllRanges();
	
	    if (start > end) {
	      selection.addRange(range);
	      selection.extend(endMarker.node, endMarker.offset);
	    } else {
	      range.setEnd(endMarker.node, endMarker.offset);
	      selection.addRange(range);
	    }
	  }
	}
	
	var useIEOffsets = ExecutionEnvironment.canUseDOM && 'selection' in document && !('getSelection' in window);
	
	var ReactDOMSelection = {
	  /**
	   * @param {DOMElement} node
	   */
	  getOffsets: useIEOffsets ? getIEOffsets : getModernOffsets,
	
	  /**
	   * @param {DOMElement|DOMTextNode} node
	   * @param {object} offsets
	   */
	  setOffsets: useIEOffsets ? setIEOffsets : setModernOffsets
	};
	
	module.exports = ReactDOMSelection;

/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(6),
	    _assign = __webpack_require__(7);
	
	var DOMChildrenOperations = __webpack_require__(117);
	var DOMLazyTree = __webpack_require__(44);
	var ReactDOMComponentTree = __webpack_require__(9);
	
	var escapeTextContentForBrowser = __webpack_require__(86);
	var invariant = __webpack_require__(3);
	var validateDOMNesting = __webpack_require__(132);
	
	/**
	 * Text nodes violate a couple assumptions that React makes about components:
	 *
	 *  - When mounting text into the DOM, adjacent text nodes are merged.
	 *  - Text nodes cannot be assigned a React root ID.
	 *
	 * This component is used to wrap strings between comment nodes so that they
	 * can undergo the same reconciliation that is applied to elements.
	 *
	 * TODO: Investigate representing React components in the DOM with text nodes.
	 *
	 * @class ReactDOMTextComponent
	 * @extends ReactComponent
	 * @internal
	 */
	var ReactDOMTextComponent = function (text) {
	  // TODO: This is really a ReactText (ReactNode), not a ReactElement
	  this._currentElement = text;
	  this._stringText = '' + text;
	  // ReactDOMComponentTree uses these:
	  this._hostNode = null;
	  this._hostParent = null;
	
	  // Properties
	  this._domID = 0;
	  this._mountIndex = 0;
	  this._closingComment = null;
	  this._commentNodes = null;
	};
	
	_assign(ReactDOMTextComponent.prototype, {
	  /**
	   * Creates the markup for this text node. This node is not intended to have
	   * any features besides containing text content.
	   *
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @return {string} Markup for this text node.
	   * @internal
	   */
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    if (false) {
	      var parentInfo;
	      if (hostParent != null) {
	        parentInfo = hostParent._ancestorInfo;
	      } else if (hostContainerInfo != null) {
	        parentInfo = hostContainerInfo._ancestorInfo;
	      }
	      if (parentInfo) {
	        // parentInfo should always be present except for the top-level
	        // component when server rendering
	        validateDOMNesting(null, this._stringText, this, parentInfo);
	      }
	    }
	
	    var domID = hostContainerInfo._idCounter++;
	    var openingValue = ' react-text: ' + domID + ' ';
	    var closingValue = ' /react-text ';
	    this._domID = domID;
	    this._hostParent = hostParent;
	    if (transaction.useCreateElement) {
	      var ownerDocument = hostContainerInfo._ownerDocument;
	      var openingComment = ownerDocument.createComment(openingValue);
	      var closingComment = ownerDocument.createComment(closingValue);
	      var lazyTree = DOMLazyTree(ownerDocument.createDocumentFragment());
	      DOMLazyTree.queueChild(lazyTree, DOMLazyTree(openingComment));
	      if (this._stringText) {
	        DOMLazyTree.queueChild(lazyTree, DOMLazyTree(ownerDocument.createTextNode(this._stringText)));
	      }
	      DOMLazyTree.queueChild(lazyTree, DOMLazyTree(closingComment));
	      ReactDOMComponentTree.precacheNode(this, openingComment);
	      this._closingComment = closingComment;
	      return lazyTree;
	    } else {
	      var escapedText = escapeTextContentForBrowser(this._stringText);
	
	      if (transaction.renderToStaticMarkup) {
	        // Normally we'd wrap this between comment nodes for the reasons stated
	        // above, but since this is a situation where React won't take over
	        // (static pages), we can simply return the text as it is.
	        return escapedText;
	      }
	
	      return '<!--' + openingValue + '-->' + escapedText + '<!--' + closingValue + '-->';
	    }
	  },
	
	  /**
	   * Updates this component by updating the text content.
	   *
	   * @param {ReactText} nextText The next text content
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  receiveComponent: function (nextText, transaction) {
	    if (nextText !== this._currentElement) {
	      this._currentElement = nextText;
	      var nextStringText = '' + nextText;
	      if (nextStringText !== this._stringText) {
	        // TODO: Save this as pending props and use performUpdateIfNecessary
	        // and/or updateComponent to do the actual update for consistency with
	        // other component types?
	        this._stringText = nextStringText;
	        var commentNodes = this.getHostNode();
	        DOMChildrenOperations.replaceDelimitedText(commentNodes[0], commentNodes[1], nextStringText);
	      }
	    }
	  },
	
	  getHostNode: function () {
	    var hostNode = this._commentNodes;
	    if (hostNode) {
	      return hostNode;
	    }
	    if (!this._closingComment) {
	      var openingComment = ReactDOMComponentTree.getNodeFromInstance(this);
	      var node = openingComment.nextSibling;
	      while (true) {
	        !(node != null) ?  false ? invariant(false, 'Missing closing comment for text component %s', this._domID) : _prodInvariant('67', this._domID) : void 0;
	        if (node.nodeType === 8 && node.nodeValue === ' /react-text ') {
	          this._closingComment = node;
	          break;
	        }
	        node = node.nextSibling;
	      }
	    }
	    hostNode = [this._hostNode, this._closingComment];
	    this._commentNodes = hostNode;
	    return hostNode;
	  },
	
	  unmountComponent: function () {
	    this._closingComment = null;
	    this._commentNodes = null;
	    ReactDOMComponentTree.uncacheNode(this);
	  }
	});
	
	module.exports = ReactDOMTextComponent;

/***/ }),
/* 440 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(6),
	    _assign = __webpack_require__(7);
	
	var LinkedValueUtils = __webpack_require__(122);
	var ReactDOMComponentTree = __webpack_require__(9);
	var ReactUpdates = __webpack_require__(28);
	
	var invariant = __webpack_require__(3);
	var warning = __webpack_require__(5);
	
	var didWarnValueLink = false;
	var didWarnValDefaultVal = false;
	
	function forceUpdateIfMounted() {
	  if (this._rootNodeID) {
	    // DOM component is still mounted; update
	    ReactDOMTextarea.updateWrapper(this);
	  }
	}
	
	/**
	 * Implements a <textarea> host component that allows setting `value`, and
	 * `defaultValue`. This differs from the traditional DOM API because value is
	 * usually set as PCDATA children.
	 *
	 * If `value` is not supplied (or null/undefined), user actions that affect the
	 * value will trigger updates to the element.
	 *
	 * If `value` is supplied (and not null/undefined), the rendered element will
	 * not trigger updates to the element. Instead, the `value` prop must change in
	 * order for the rendered element to be updated.
	 *
	 * The rendered element will be initialized with an empty value, the prop
	 * `defaultValue` if specified, or the children content (deprecated).
	 */
	var ReactDOMTextarea = {
	  getHostProps: function (inst, props) {
	    !(props.dangerouslySetInnerHTML == null) ?  false ? invariant(false, '`dangerouslySetInnerHTML` does not make sense on <textarea>.') : _prodInvariant('91') : void 0;
	
	    // Always set children to the same thing. In IE9, the selection range will
	    // get reset if `textContent` is mutated.  We could add a check in setTextContent
	    // to only set the value if/when the value differs from the node value (which would
	    // completely solve this IE9 bug), but Sebastian+Ben seemed to like this solution.
	    // The value can be a boolean or object so that's why it's forced to be a string.
	    var hostProps = _assign({}, props, {
	      value: undefined,
	      defaultValue: undefined,
	      children: '' + inst._wrapperState.initialValue,
	      onChange: inst._wrapperState.onChange
	    });
	
	    return hostProps;
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      LinkedValueUtils.checkPropTypes('textarea', props, inst._currentElement._owner);
	      if (props.valueLink !== undefined && !didWarnValueLink) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '`valueLink` prop on `textarea` is deprecated; set `value` and `onChange` instead.') : void 0;
	        didWarnValueLink = true;
	      }
	      if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValDefaultVal) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'Textarea elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled textarea ' + 'and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
	        didWarnValDefaultVal = true;
	      }
	    }
	
	    var value = LinkedValueUtils.getValue(props);
	    var initialValue = value;
	
	    // Only bother fetching default value if we're going to use it
	    if (value == null) {
	      var defaultValue = props.defaultValue;
	      // TODO (yungsters): Remove support for children content in <textarea>.
	      var children = props.children;
	      if (children != null) {
	        if (false) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'Use the `defaultValue` or `value` props instead of setting ' + 'children on <textarea>.') : void 0;
	        }
	        !(defaultValue == null) ?  false ? invariant(false, 'If you supply `defaultValue` on a <textarea>, do not pass children.') : _prodInvariant('92') : void 0;
	        if (Array.isArray(children)) {
	          !(children.length <= 1) ?  false ? invariant(false, '<textarea> can only have at most one child.') : _prodInvariant('93') : void 0;
	          children = children[0];
	        }
	
	        defaultValue = '' + children;
	      }
	      if (defaultValue == null) {
	        defaultValue = '';
	      }
	      initialValue = defaultValue;
	    }
	
	    inst._wrapperState = {
	      initialValue: '' + initialValue,
	      listeners: null,
	      onChange: _handleChange.bind(inst)
	    };
	  },
	
	  updateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      // Cast `value` to a string to ensure the value is set correctly. While
	      // browsers typically do this as necessary, jsdom doesn't.
	      var newValue = '' + value;
	
	      // To avoid side effects (such as losing text selection), only set value if changed
	      if (newValue !== node.value) {
	        node.value = newValue;
	      }
	      if (props.defaultValue == null) {
	        node.defaultValue = newValue;
	      }
	    }
	    if (props.defaultValue != null) {
	      node.defaultValue = props.defaultValue;
	    }
	  },
	
	  postMountWrapper: function (inst) {
	    // This is in postMount because we need access to the DOM node, which is not
	    // available until after the component has mounted.
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var textContent = node.textContent;
	
	    // Only set node.value if textContent is equal to the expected
	    // initial value. In IE10/IE11 there is a bug where the placeholder attribute
	    // will populate textContent as well.
	    // https://developer.microsoft.com/microsoft-edge/platform/issues/101525/
	    if (textContent === inst._wrapperState.initialValue) {
	      node.value = textContent;
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	  ReactUpdates.asap(forceUpdateIfMounted, this);
	  return returnValue;
	}
	
	module.exports = ReactDOMTextarea;

/***/ }),
/* 441 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(6);
	
	var invariant = __webpack_require__(3);
	
	/**
	 * Return the lowest common ancestor of A and B, or null if they are in
	 * different trees.
	 */
	function getLowestCommonAncestor(instA, instB) {
	  !('_hostNode' in instA) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
	  !('_hostNode' in instB) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
	
	  var depthA = 0;
	  for (var tempA = instA; tempA; tempA = tempA._hostParent) {
	    depthA++;
	  }
	  var depthB = 0;
	  for (var tempB = instB; tempB; tempB = tempB._hostParent) {
	    depthB++;
	  }
	
	  // If A is deeper, crawl up.
	  while (depthA - depthB > 0) {
	    instA = instA._hostParent;
	    depthA--;
	  }
	
	  // If B is deeper, crawl up.
	  while (depthB - depthA > 0) {
	    instB = instB._hostParent;
	    depthB--;
	  }
	
	  // Walk in lockstep until we find a match.
	  var depth = depthA;
	  while (depth--) {
	    if (instA === instB) {
	      return instA;
	    }
	    instA = instA._hostParent;
	    instB = instB._hostParent;
	  }
	  return null;
	}
	
	/**
	 * Return if A is an ancestor of B.
	 */
	function isAncestor(instA, instB) {
	  !('_hostNode' in instA) ?  false ? invariant(false, 'isAncestor: Invalid argument.') : _prodInvariant('35') : void 0;
	  !('_hostNode' in instB) ?  false ? invariant(false, 'isAncestor: Invalid argument.') : _prodInvariant('35') : void 0;
	
	  while (instB) {
	    if (instB === instA) {
	      return true;
	    }
	    instB = instB._hostParent;
	  }
	  return false;
	}
	
	/**
	 * Return the parent instance of the passed-in instance.
	 */
	function getParentInstance(inst) {
	  !('_hostNode' in inst) ?  false ? invariant(false, 'getParentInstance: Invalid argument.') : _prodInvariant('36') : void 0;
	
	  return inst._hostParent;
	}
	
	/**
	 * Simulates the traversal of a two-phase, capture/bubble event dispatch.
	 */
	function traverseTwoPhase(inst, fn, arg) {
	  var path = [];
	  while (inst) {
	    path.push(inst);
	    inst = inst._hostParent;
	  }
	  var i;
	  for (i = path.length; i-- > 0;) {
	    fn(path[i], 'captured', arg);
	  }
	  for (i = 0; i < path.length; i++) {
	    fn(path[i], 'bubbled', arg);
	  }
	}
	
	/**
	 * Traverses the ID hierarchy and invokes the supplied `cb` on any IDs that
	 * should would receive a `mouseEnter` or `mouseLeave` event.
	 *
	 * Does not invoke the callback on the nearest common ancestor because nothing
	 * "entered" or "left" that element.
	 */
	function traverseEnterLeave(from, to, fn, argFrom, argTo) {
	  var common = from && to ? getLowestCommonAncestor(from, to) : null;
	  var pathFrom = [];
	  while (from && from !== common) {
	    pathFrom.push(from);
	    from = from._hostParent;
	  }
	  var pathTo = [];
	  while (to && to !== common) {
	    pathTo.push(to);
	    to = to._hostParent;
	  }
	  var i;
	  for (i = 0; i < pathFrom.length; i++) {
	    fn(pathFrom[i], 'bubbled', argFrom);
	  }
	  for (i = pathTo.length; i-- > 0;) {
	    fn(pathTo[i], 'captured', argTo);
	  }
	}
	
	module.exports = {
	  isAncestor: isAncestor,
	  getLowestCommonAncestor: getLowestCommonAncestor,
	  getParentInstance: getParentInstance,
	  traverseTwoPhase: traverseTwoPhase,
	  traverseEnterLeave: traverseEnterLeave
	};

/***/ }),
/* 442 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(7);
	
	var ReactUpdates = __webpack_require__(28);
	var Transaction = __webpack_require__(85);
	
	var emptyFunction = __webpack_require__(24);
	
	var RESET_BATCHED_UPDATES = {
	  initialize: emptyFunction,
	  close: function () {
	    ReactDefaultBatchingStrategy.isBatchingUpdates = false;
	  }
	};
	
	var FLUSH_BATCHED_UPDATES = {
	  initialize: emptyFunction,
	  close: ReactUpdates.flushBatchedUpdates.bind(ReactUpdates)
	};
	
	var TRANSACTION_WRAPPERS = [FLUSH_BATCHED_UPDATES, RESET_BATCHED_UPDATES];
	
	function ReactDefaultBatchingStrategyTransaction() {
	  this.reinitializeTransaction();
	}
	
	_assign(ReactDefaultBatchingStrategyTransaction.prototype, Transaction, {
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  }
	});
	
	var transaction = new ReactDefaultBatchingStrategyTransaction();
	
	var ReactDefaultBatchingStrategy = {
	  isBatchingUpdates: false,
	
	  /**
	   * Call the provided function in a context within which calls to `setState`
	   * and friends are batched such that components aren't updated unnecessarily.
	   */
	  batchedUpdates: function (callback, a, b, c, d, e) {
	    var alreadyBatchingUpdates = ReactDefaultBatchingStrategy.isBatchingUpdates;
	
	    ReactDefaultBatchingStrategy.isBatchingUpdates = true;
	
	    // The code is written this way to avoid extra allocations
	    if (alreadyBatchingUpdates) {
	      return callback(a, b, c, d, e);
	    } else {
	      return transaction.perform(callback, null, a, b, c, d, e);
	    }
	  }
	};
	
	module.exports = ReactDefaultBatchingStrategy;

/***/ }),
/* 443 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ARIADOMPropertyConfig = __webpack_require__(417);
	var BeforeInputEventPlugin = __webpack_require__(419);
	var ChangeEventPlugin = __webpack_require__(421);
	var DefaultEventPluginOrder = __webpack_require__(423);
	var EnterLeaveEventPlugin = __webpack_require__(424);
	var HTMLDOMPropertyConfig = __webpack_require__(426);
	var ReactComponentBrowserEnvironment = __webpack_require__(428);
	var ReactDOMComponent = __webpack_require__(431);
	var ReactDOMComponentTree = __webpack_require__(9);
	var ReactDOMEmptyComponent = __webpack_require__(433);
	var ReactDOMTreeTraversal = __webpack_require__(441);
	var ReactDOMTextComponent = __webpack_require__(439);
	var ReactDefaultBatchingStrategy = __webpack_require__(442);
	var ReactEventListener = __webpack_require__(446);
	var ReactInjection = __webpack_require__(447);
	var ReactReconcileTransaction = __webpack_require__(452);
	var SVGDOMPropertyConfig = __webpack_require__(457);
	var SelectEventPlugin = __webpack_require__(458);
	var SimpleEventPlugin = __webpack_require__(459);
	
	var alreadyInjected = false;
	
	function inject() {
	  if (alreadyInjected) {
	    // TODO: This is currently true because these injections are shared between
	    // the client and the server package. They should be built independently
	    // and not share any injection state. Then this problem will be solved.
	    return;
	  }
	  alreadyInjected = true;
	
	  ReactInjection.EventEmitter.injectReactEventListener(ReactEventListener);
	
	  /**
	   * Inject modules for resolving DOM hierarchy and plugin ordering.
	   */
	  ReactInjection.EventPluginHub.injectEventPluginOrder(DefaultEventPluginOrder);
	  ReactInjection.EventPluginUtils.injectComponentTree(ReactDOMComponentTree);
	  ReactInjection.EventPluginUtils.injectTreeTraversal(ReactDOMTreeTraversal);
	
	  /**
	   * Some important event plugins included by default (without having to require
	   * them).
	   */
	  ReactInjection.EventPluginHub.injectEventPluginsByName({
	    SimpleEventPlugin: SimpleEventPlugin,
	    EnterLeaveEventPlugin: EnterLeaveEventPlugin,
	    ChangeEventPlugin: ChangeEventPlugin,
	    SelectEventPlugin: SelectEventPlugin,
	    BeforeInputEventPlugin: BeforeInputEventPlugin
	  });
	
	  ReactInjection.HostComponent.injectGenericComponentClass(ReactDOMComponent);
	
	  ReactInjection.HostComponent.injectTextComponentClass(ReactDOMTextComponent);
	
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(ARIADOMPropertyConfig);
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(HTMLDOMPropertyConfig);
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(SVGDOMPropertyConfig);
	
	  ReactInjection.EmptyComponent.injectEmptyComponentFactory(function (instantiate) {
	    return new ReactDOMEmptyComponent(instantiate);
	  });
	
	  ReactInjection.Updates.injectReconcileTransaction(ReactReconcileTransaction);
	  ReactInjection.Updates.injectBatchingStrategy(ReactDefaultBatchingStrategy);
	
	  ReactInjection.Component.injectEnvironment(ReactComponentBrowserEnvironment);
	}
	
	module.exports = {
	  inject: inject
	};

/***/ }),
/* 444 */
219,
/* 445 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var EventPluginHub = __webpack_require__(59);
	
	function runEventQueueInBatch(events) {
	  EventPluginHub.enqueueEvents(events);
	  EventPluginHub.processEventQueue(false);
	}
	
	var ReactEventEmitterMixin = {
	  /**
	   * Streams a fired top-level event to `EventPluginHub` where plugins have the
	   * opportunity to create `ReactEvent`s to be dispatched.
	   */
	  handleTopLevel: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var events = EventPluginHub.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
	    runEventQueueInBatch(events);
	  }
	};
	
	module.exports = ReactEventEmitterMixin;

/***/ }),
/* 446 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(7);
	
	var EventListener = __webpack_require__(190);
	var ExecutionEnvironment = __webpack_require__(16);
	var PooledClass = __webpack_require__(38);
	var ReactDOMComponentTree = __webpack_require__(9);
	var ReactUpdates = __webpack_require__(28);
	
	var getEventTarget = __webpack_require__(129);
	var getUnboundedScrollPosition = __webpack_require__(391);
	
	/**
	 * Find the deepest React component completely containing the root of the
	 * passed-in instance (for use when entire React trees are nested within each
	 * other). If React trees are not nested, returns null.
	 */
	function findParent(inst) {
	  // TODO: It may be a good idea to cache this to prevent unnecessary DOM
	  // traversal, but caching is difficult to do correctly without using a
	  // mutation observer to listen for all DOM changes.
	  while (inst._hostParent) {
	    inst = inst._hostParent;
	  }
	  var rootNode = ReactDOMComponentTree.getNodeFromInstance(inst);
	  var container = rootNode.parentNode;
	  return ReactDOMComponentTree.getClosestInstanceFromNode(container);
	}
	
	// Used to store ancestor hierarchy in top level callback
	function TopLevelCallbackBookKeeping(topLevelType, nativeEvent) {
	  this.topLevelType = topLevelType;
	  this.nativeEvent = nativeEvent;
	  this.ancestors = [];
	}
	_assign(TopLevelCallbackBookKeeping.prototype, {
	  destructor: function () {
	    this.topLevelType = null;
	    this.nativeEvent = null;
	    this.ancestors.length = 0;
	  }
	});
	PooledClass.addPoolingTo(TopLevelCallbackBookKeeping, PooledClass.twoArgumentPooler);
	
	function handleTopLevelImpl(bookKeeping) {
	  var nativeEventTarget = getEventTarget(bookKeeping.nativeEvent);
	  var targetInst = ReactDOMComponentTree.getClosestInstanceFromNode(nativeEventTarget);
	
	  // Loop through the hierarchy, in case there's any nested components.
	  // It's important that we build the array of ancestors before calling any
	  // event handlers, because event handlers can modify the DOM, leading to
	  // inconsistencies with ReactMount's node cache. See #1105.
	  var ancestor = targetInst;
	  do {
	    bookKeeping.ancestors.push(ancestor);
	    ancestor = ancestor && findParent(ancestor);
	  } while (ancestor);
	
	  for (var i = 0; i < bookKeeping.ancestors.length; i++) {
	    targetInst = bookKeeping.ancestors[i];
	    ReactEventListener._handleTopLevel(bookKeeping.topLevelType, targetInst, bookKeeping.nativeEvent, getEventTarget(bookKeeping.nativeEvent));
	  }
	}
	
	function scrollValueMonitor(cb) {
	  var scrollPosition = getUnboundedScrollPosition(window);
	  cb(scrollPosition);
	}
	
	var ReactEventListener = {
	  _enabled: true,
	  _handleTopLevel: null,
	
	  WINDOW_HANDLE: ExecutionEnvironment.canUseDOM ? window : null,
	
	  setHandleTopLevel: function (handleTopLevel) {
	    ReactEventListener._handleTopLevel = handleTopLevel;
	  },
	
	  setEnabled: function (enabled) {
	    ReactEventListener._enabled = !!enabled;
	  },
	
	  isEnabled: function () {
	    return ReactEventListener._enabled;
	  },
	
	  /**
	   * Traps top-level events by using event bubbling.
	   *
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {string} handlerBaseName Event name (e.g. "click").
	   * @param {object} element Element on which to attach listener.
	   * @return {?object} An object with a remove function which will forcefully
	   *                  remove the listener.
	   * @internal
	   */
	  trapBubbledEvent: function (topLevelType, handlerBaseName, element) {
	    if (!element) {
	      return null;
	    }
	    return EventListener.listen(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
	  },
	
	  /**
	   * Traps a top-level event by using event capturing.
	   *
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {string} handlerBaseName Event name (e.g. "click").
	   * @param {object} element Element on which to attach listener.
	   * @return {?object} An object with a remove function which will forcefully
	   *                  remove the listener.
	   * @internal
	   */
	  trapCapturedEvent: function (topLevelType, handlerBaseName, element) {
	    if (!element) {
	      return null;
	    }
	    return EventListener.capture(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
	  },
	
	  monitorScrollValue: function (refresh) {
	    var callback = scrollValueMonitor.bind(null, refresh);
	    EventListener.listen(window, 'scroll', callback);
	  },
	
	  dispatchEvent: function (topLevelType, nativeEvent) {
	    if (!ReactEventListener._enabled) {
	      return;
	    }
	
	    var bookKeeping = TopLevelCallbackBookKeeping.getPooled(topLevelType, nativeEvent);
	    try {
	      // Event queue being processed in the same cycle allows
	      // `preventDefault`.
	      ReactUpdates.batchedUpdates(handleTopLevelImpl, bookKeeping);
	    } finally {
	      TopLevelCallbackBookKeeping.release(bookKeeping);
	    }
	  }
	};
	
	module.exports = ReactEventListener;

/***/ }),
/* 447 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(45);
	var EventPluginHub = __webpack_require__(59);
	var EventPluginUtils = __webpack_require__(120);
	var ReactComponentEnvironment = __webpack_require__(123);
	var ReactEmptyComponent = __webpack_require__(201);
	var ReactBrowserEventEmitter = __webpack_require__(83);
	var ReactHostComponent = __webpack_require__(203);
	var ReactUpdates = __webpack_require__(28);
	
	var ReactInjection = {
	  Component: ReactComponentEnvironment.injection,
	  DOMProperty: DOMProperty.injection,
	  EmptyComponent: ReactEmptyComponent.injection,
	  EventPluginHub: EventPluginHub.injection,
	  EventPluginUtils: EventPluginUtils.injection,
	  EventEmitter: ReactBrowserEventEmitter.injection,
	  HostComponent: ReactHostComponent.injection,
	  Updates: ReactUpdates.injection
	};
	
	module.exports = ReactInjection;

/***/ }),
/* 448 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var adler32 = __webpack_require__(470);
	
	var TAG_END = /\/?>/;
	var COMMENT_START = /^<\!\-\-/;
	
	var ReactMarkupChecksum = {
	  CHECKSUM_ATTR_NAME: 'data-react-checksum',
	
	  /**
	   * @param {string} markup Markup string
	   * @return {string} Markup string with checksum attribute attached
	   */
	  addChecksumToMarkup: function (markup) {
	    var checksum = adler32(markup);
	
	    // Add checksum (handle both parent tags, comments and self-closing tags)
	    if (COMMENT_START.test(markup)) {
	      return markup;
	    } else {
	      return markup.replace(TAG_END, ' ' + ReactMarkupChecksum.CHECKSUM_ATTR_NAME + '="' + checksum + '"$&');
	    }
	  },
	
	  /**
	   * @param {string} markup to use
	   * @param {DOMElement} element root React element
	   * @returns {boolean} whether or not the markup is the same
	   */
	  canReuseMarkup: function (markup, element) {
	    var existingChecksum = element.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	    existingChecksum = existingChecksum && parseInt(existingChecksum, 10);
	    var markupChecksum = adler32(markup);
	    return markupChecksum === existingChecksum;
	  }
	};
	
	module.exports = ReactMarkupChecksum;

/***/ }),
/* 449 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(6);
	
	var ReactComponentEnvironment = __webpack_require__(123);
	var ReactInstanceMap = __webpack_require__(61);
	var ReactInstrumentation = __webpack_require__(25);
	
	var ReactCurrentOwner = __webpack_require__(32);
	var ReactReconciler = __webpack_require__(46);
	var ReactChildReconciler = __webpack_require__(427);
	
	var emptyFunction = __webpack_require__(24);
	var flattenChildren = __webpack_require__(473);
	var invariant = __webpack_require__(3);
	
	/**
	 * Make an update for markup to be rendered and inserted at a supplied index.
	 *
	 * @param {string} markup Markup that renders into an element.
	 * @param {number} toIndex Destination index.
	 * @private
	 */
	function makeInsertMarkup(markup, afterNode, toIndex) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'INSERT_MARKUP',
	    content: markup,
	    fromIndex: null,
	    fromNode: null,
	    toIndex: toIndex,
	    afterNode: afterNode
	  };
	}
	
	/**
	 * Make an update for moving an existing element to another index.
	 *
	 * @param {number} fromIndex Source index of the existing element.
	 * @param {number} toIndex Destination index of the element.
	 * @private
	 */
	function makeMove(child, afterNode, toIndex) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'MOVE_EXISTING',
	    content: null,
	    fromIndex: child._mountIndex,
	    fromNode: ReactReconciler.getHostNode(child),
	    toIndex: toIndex,
	    afterNode: afterNode
	  };
	}
	
	/**
	 * Make an update for removing an element at an index.
	 *
	 * @param {number} fromIndex Index of the element to remove.
	 * @private
	 */
	function makeRemove(child, node) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'REMOVE_NODE',
	    content: null,
	    fromIndex: child._mountIndex,
	    fromNode: node,
	    toIndex: null,
	    afterNode: null
	  };
	}
	
	/**
	 * Make an update for setting the markup of a node.
	 *
	 * @param {string} markup Markup that renders into an element.
	 * @private
	 */
	function makeSetMarkup(markup) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'SET_MARKUP',
	    content: markup,
	    fromIndex: null,
	    fromNode: null,
	    toIndex: null,
	    afterNode: null
	  };
	}
	
	/**
	 * Make an update for setting the text content.
	 *
	 * @param {string} textContent Text content to set.
	 * @private
	 */
	function makeTextContent(textContent) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'TEXT_CONTENT',
	    content: textContent,
	    fromIndex: null,
	    fromNode: null,
	    toIndex: null,
	    afterNode: null
	  };
	}
	
	/**
	 * Push an update, if any, onto the queue. Creates a new queue if none is
	 * passed and always returns the queue. Mutative.
	 */
	function enqueue(queue, update) {
	  if (update) {
	    queue = queue || [];
	    queue.push(update);
	  }
	  return queue;
	}
	
	/**
	 * Processes any enqueued updates.
	 *
	 * @private
	 */
	function processQueue(inst, updateQueue) {
	  ReactComponentEnvironment.processChildrenUpdates(inst, updateQueue);
	}
	
	var setChildrenForInstrumentation = emptyFunction;
	if (false) {
	  var getDebugID = function (inst) {
	    if (!inst._debugID) {
	      // Check for ART-like instances. TODO: This is silly/gross.
	      var internal;
	      if (internal = ReactInstanceMap.get(inst)) {
	        inst = internal;
	      }
	    }
	    return inst._debugID;
	  };
	  setChildrenForInstrumentation = function (children) {
	    var debugID = getDebugID(this);
	    // TODO: React Native empty components are also multichild.
	    // This means they still get into this method but don't have _debugID.
	    if (debugID !== 0) {
	      ReactInstrumentation.debugTool.onSetChildren(debugID, children ? Object.keys(children).map(function (key) {
	        return children[key]._debugID;
	      }) : []);
	    }
	  };
	}
	
	/**
	 * ReactMultiChild are capable of reconciling multiple children.
	 *
	 * @class ReactMultiChild
	 * @internal
	 */
	var ReactMultiChild = {
	  /**
	   * Provides common functionality for components that must reconcile multiple
	   * children. This is used by `ReactDOMComponent` to mount, update, and
	   * unmount child components.
	   *
	   * @lends {ReactMultiChild.prototype}
	   */
	  Mixin: {
	    _reconcilerInstantiateChildren: function (nestedChildren, transaction, context) {
	      if (false) {
	        var selfDebugID = getDebugID(this);
	        if (this._currentElement) {
	          try {
	            ReactCurrentOwner.current = this._currentElement._owner;
	            return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context, selfDebugID);
	          } finally {
	            ReactCurrentOwner.current = null;
	          }
	        }
	      }
	      return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context);
	    },
	
	    _reconcilerUpdateChildren: function (prevChildren, nextNestedChildrenElements, mountImages, removedNodes, transaction, context) {
	      var nextChildren;
	      var selfDebugID = 0;
	      if (false) {
	        selfDebugID = getDebugID(this);
	        if (this._currentElement) {
	          try {
	            ReactCurrentOwner.current = this._currentElement._owner;
	            nextChildren = flattenChildren(nextNestedChildrenElements, selfDebugID);
	          } finally {
	            ReactCurrentOwner.current = null;
	          }
	          ReactChildReconciler.updateChildren(prevChildren, nextChildren, mountImages, removedNodes, transaction, this, this._hostContainerInfo, context, selfDebugID);
	          return nextChildren;
	        }
	      }
	      nextChildren = flattenChildren(nextNestedChildrenElements, selfDebugID);
	      ReactChildReconciler.updateChildren(prevChildren, nextChildren, mountImages, removedNodes, transaction, this, this._hostContainerInfo, context, selfDebugID);
	      return nextChildren;
	    },
	
	    /**
	     * Generates a "mount image" for each of the supplied children. In the case
	     * of `ReactDOMComponent`, a mount image is a string of markup.
	     *
	     * @param {?object} nestedChildren Nested child maps.
	     * @return {array} An array of mounted representations.
	     * @internal
	     */
	    mountChildren: function (nestedChildren, transaction, context) {
	      var children = this._reconcilerInstantiateChildren(nestedChildren, transaction, context);
	      this._renderedChildren = children;
	
	      var mountImages = [];
	      var index = 0;
	      for (var name in children) {
	        if (children.hasOwnProperty(name)) {
	          var child = children[name];
	          var selfDebugID = 0;
	          if (false) {
	            selfDebugID = getDebugID(this);
	          }
	          var mountImage = ReactReconciler.mountComponent(child, transaction, this, this._hostContainerInfo, context, selfDebugID);
	          child._mountIndex = index++;
	          mountImages.push(mountImage);
	        }
	      }
	
	      if (false) {
	        setChildrenForInstrumentation.call(this, children);
	      }
	
	      return mountImages;
	    },
	
	    /**
	     * Replaces any rendered children with a text content string.
	     *
	     * @param {string} nextContent String of content.
	     * @internal
	     */
	    updateTextContent: function (nextContent) {
	      var prevChildren = this._renderedChildren;
	      // Remove any rendered children.
	      ReactChildReconciler.unmountChildren(prevChildren, false);
	      for (var name in prevChildren) {
	        if (prevChildren.hasOwnProperty(name)) {
	           true ?  false ? invariant(false, 'updateTextContent called on non-empty component.') : _prodInvariant('118') : void 0;
	        }
	      }
	      // Set new text content.
	      var updates = [makeTextContent(nextContent)];
	      processQueue(this, updates);
	    },
	
	    /**
	     * Replaces any rendered children with a markup string.
	     *
	     * @param {string} nextMarkup String of markup.
	     * @internal
	     */
	    updateMarkup: function (nextMarkup) {
	      var prevChildren = this._renderedChildren;
	      // Remove any rendered children.
	      ReactChildReconciler.unmountChildren(prevChildren, false);
	      for (var name in prevChildren) {
	        if (prevChildren.hasOwnProperty(name)) {
	           true ?  false ? invariant(false, 'updateTextContent called on non-empty component.') : _prodInvariant('118') : void 0;
	        }
	      }
	      var updates = [makeSetMarkup(nextMarkup)];
	      processQueue(this, updates);
	    },
	
	    /**
	     * Updates the rendered children with new children.
	     *
	     * @param {?object} nextNestedChildrenElements Nested child element maps.
	     * @param {ReactReconcileTransaction} transaction
	     * @internal
	     */
	    updateChildren: function (nextNestedChildrenElements, transaction, context) {
	      // Hook used by React ART
	      this._updateChildren(nextNestedChildrenElements, transaction, context);
	    },
	
	    /**
	     * @param {?object} nextNestedChildrenElements Nested child element maps.
	     * @param {ReactReconcileTransaction} transaction
	     * @final
	     * @protected
	     */
	    _updateChildren: function (nextNestedChildrenElements, transaction, context) {
	      var prevChildren = this._renderedChildren;
	      var removedNodes = {};
	      var mountImages = [];
	      var nextChildren = this._reconcilerUpdateChildren(prevChildren, nextNestedChildrenElements, mountImages, removedNodes, transaction, context);
	      if (!nextChildren && !prevChildren) {
	        return;
	      }
	      var updates = null;
	      var name;
	      // `nextIndex` will increment for each child in `nextChildren`, but
	      // `lastIndex` will be the last index visited in `prevChildren`.
	      var nextIndex = 0;
	      var lastIndex = 0;
	      // `nextMountIndex` will increment for each newly mounted child.
	      var nextMountIndex = 0;
	      var lastPlacedNode = null;
	      for (name in nextChildren) {
	        if (!nextChildren.hasOwnProperty(name)) {
	          continue;
	        }
	        var prevChild = prevChildren && prevChildren[name];
	        var nextChild = nextChildren[name];
	        if (prevChild === nextChild) {
	          updates = enqueue(updates, this.moveChild(prevChild, lastPlacedNode, nextIndex, lastIndex));
	          lastIndex = Math.max(prevChild._mountIndex, lastIndex);
	          prevChild._mountIndex = nextIndex;
	        } else {
	          if (prevChild) {
	            // Update `lastIndex` before `_mountIndex` gets unset by unmounting.
	            lastIndex = Math.max(prevChild._mountIndex, lastIndex);
	            // The `removedNodes` loop below will actually remove the child.
	          }
	          // The child must be instantiated before it's mounted.
	          updates = enqueue(updates, this._mountChildAtIndex(nextChild, mountImages[nextMountIndex], lastPlacedNode, nextIndex, transaction, context));
	          nextMountIndex++;
	        }
	        nextIndex++;
	        lastPlacedNode = ReactReconciler.getHostNode(nextChild);
	      }
	      // Remove children that are no longer present.
	      for (name in removedNodes) {
	        if (removedNodes.hasOwnProperty(name)) {
	          updates = enqueue(updates, this._unmountChild(prevChildren[name], removedNodes[name]));
	        }
	      }
	      if (updates) {
	        processQueue(this, updates);
	      }
	      this._renderedChildren = nextChildren;
	
	      if (false) {
	        setChildrenForInstrumentation.call(this, nextChildren);
	      }
	    },
	
	    /**
	     * Unmounts all rendered children. This should be used to clean up children
	     * when this component is unmounted. It does not actually perform any
	     * backend operations.
	     *
	     * @internal
	     */
	    unmountChildren: function (safely) {
	      var renderedChildren = this._renderedChildren;
	      ReactChildReconciler.unmountChildren(renderedChildren, safely);
	      this._renderedChildren = null;
	    },
	
	    /**
	     * Moves a child component to the supplied index.
	     *
	     * @param {ReactComponent} child Component to move.
	     * @param {number} toIndex Destination index of the element.
	     * @param {number} lastIndex Last index visited of the siblings of `child`.
	     * @protected
	     */
	    moveChild: function (child, afterNode, toIndex, lastIndex) {
	      // If the index of `child` is less than `lastIndex`, then it needs to
	      // be moved. Otherwise, we do not need to move it because a child will be
	      // inserted or moved before `child`.
	      if (child._mountIndex < lastIndex) {
	        return makeMove(child, afterNode, toIndex);
	      }
	    },
	
	    /**
	     * Creates a child component.
	     *
	     * @param {ReactComponent} child Component to create.
	     * @param {string} mountImage Markup to insert.
	     * @protected
	     */
	    createChild: function (child, afterNode, mountImage) {
	      return makeInsertMarkup(mountImage, afterNode, child._mountIndex);
	    },
	
	    /**
	     * Removes a child component.
	     *
	     * @param {ReactComponent} child Child to remove.
	     * @protected
	     */
	    removeChild: function (child, node) {
	      return makeRemove(child, node);
	    },
	
	    /**
	     * Mounts a child with the supplied name.
	     *
	     * NOTE: This is part of `updateChildren` and is here for readability.
	     *
	     * @param {ReactComponent} child Component to mount.
	     * @param {string} name Name of the child.
	     * @param {number} index Index at which to insert the child.
	     * @param {ReactReconcileTransaction} transaction
	     * @private
	     */
	    _mountChildAtIndex: function (child, mountImage, afterNode, index, transaction, context) {
	      child._mountIndex = index;
	      return this.createChild(child, afterNode, mountImage);
	    },
	
	    /**
	     * Unmounts a rendered child.
	     *
	     * NOTE: This is part of `updateChildren` and is here for readability.
	     *
	     * @param {ReactComponent} child Component to unmount.
	     * @private
	     */
	    _unmountChild: function (child, node) {
	      var update = this.removeChild(child, node);
	      child._mountIndex = null;
	      return update;
	    }
	  }
	};
	
	module.exports = ReactMultiChild;

/***/ }),
/* 450 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(6);
	
	var invariant = __webpack_require__(3);
	
	/**
	 * @param {?object} object
	 * @return {boolean} True if `object` is a valid owner.
	 * @final
	 */
	function isValidOwner(object) {
	  return !!(object && typeof object.attachRef === 'function' && typeof object.detachRef === 'function');
	}
	
	/**
	 * ReactOwners are capable of storing references to owned components.
	 *
	 * All components are capable of //being// referenced by owner components, but
	 * only ReactOwner components are capable of //referencing// owned components.
	 * The named reference is known as a "ref".
	 *
	 * Refs are available when mounted and updated during reconciliation.
	 *
	 *   var MyComponent = React.createClass({
	 *     render: function() {
	 *       return (
	 *         <div onClick={this.handleClick}>
	 *           <CustomComponent ref="custom" />
	 *         </div>
	 *       );
	 *     },
	 *     handleClick: function() {
	 *       this.refs.custom.handleClick();
	 *     },
	 *     componentDidMount: function() {
	 *       this.refs.custom.initialize();
	 *     }
	 *   });
	 *
	 * Refs should rarely be used. When refs are used, they should only be done to
	 * control data that is not handled by React's data flow.
	 *
	 * @class ReactOwner
	 */
	var ReactOwner = {
	  /**
	   * Adds a component by ref to an owner component.
	   *
	   * @param {ReactComponent} component Component to reference.
	   * @param {string} ref Name by which to refer to the component.
	   * @param {ReactOwner} owner Component on which to record the ref.
	   * @final
	   * @internal
	   */
	  addComponentAsRefTo: function (component, ref, owner) {
	    !isValidOwner(owner) ?  false ? invariant(false, 'addComponentAsRefTo(...): Only a ReactOwner can have refs. You might be adding a ref to a component that was not created inside a component\'s `render` method, or you have multiple copies of React loaded (details: https://fb.me/react-refs-must-have-owner).') : _prodInvariant('119') : void 0;
	    owner.attachRef(ref, component);
	  },
	
	  /**
	   * Removes a component by ref from an owner component.
	   *
	   * @param {ReactComponent} component Component to dereference.
	   * @param {string} ref Name of the ref to remove.
	   * @param {ReactOwner} owner Component on which the ref is recorded.
	   * @final
	   * @internal
	   */
	  removeComponentAsRefFrom: function (component, ref, owner) {
	    !isValidOwner(owner) ?  false ? invariant(false, 'removeComponentAsRefFrom(...): Only a ReactOwner can have refs. You might be removing a ref to a component that was not created inside a component\'s `render` method, or you have multiple copies of React loaded (details: https://fb.me/react-refs-must-have-owner).') : _prodInvariant('120') : void 0;
	    var ownerPublicInstance = owner.getPublicInstance();
	    // Check that `component`'s owner is still alive and that `component` is still the current ref
	    // because we do not want to detach the ref if another component stole it.
	    if (ownerPublicInstance && ownerPublicInstance.refs[ref] === component.getPublicInstance()) {
	      owner.detachRef(ref);
	    }
	  }
	};
	
	module.exports = ReactOwner;

/***/ }),
/* 451 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	module.exports = ReactPropTypesSecret;

/***/ }),
/* 452 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(7);
	
	var CallbackQueue = __webpack_require__(197);
	var PooledClass = __webpack_require__(38);
	var ReactBrowserEventEmitter = __webpack_require__(83);
	var ReactInputSelection = __webpack_require__(204);
	var ReactInstrumentation = __webpack_require__(25);
	var Transaction = __webpack_require__(85);
	var ReactUpdateQueue = __webpack_require__(125);
	
	/**
	 * Ensures that, when possible, the selection range (currently selected text
	 * input) is not disturbed by performing the transaction.
	 */
	var SELECTION_RESTORATION = {
	  /**
	   * @return {Selection} Selection information.
	   */
	  initialize: ReactInputSelection.getSelectionInformation,
	  /**
	   * @param {Selection} sel Selection information returned from `initialize`.
	   */
	  close: ReactInputSelection.restoreSelection
	};
	
	/**
	 * Suppresses events (blur/focus) that could be inadvertently dispatched due to
	 * high level DOM manipulations (like temporarily removing a text input from the
	 * DOM).
	 */
	var EVENT_SUPPRESSION = {
	  /**
	   * @return {boolean} The enabled status of `ReactBrowserEventEmitter` before
	   * the reconciliation.
	   */
	  initialize: function () {
	    var currentlyEnabled = ReactBrowserEventEmitter.isEnabled();
	    ReactBrowserEventEmitter.setEnabled(false);
	    return currentlyEnabled;
	  },
	
	  /**
	   * @param {boolean} previouslyEnabled Enabled status of
	   *   `ReactBrowserEventEmitter` before the reconciliation occurred. `close`
	   *   restores the previous value.
	   */
	  close: function (previouslyEnabled) {
	    ReactBrowserEventEmitter.setEnabled(previouslyEnabled);
	  }
	};
	
	/**
	 * Provides a queue for collecting `componentDidMount` and
	 * `componentDidUpdate` callbacks during the transaction.
	 */
	var ON_DOM_READY_QUEUEING = {
	  /**
	   * Initializes the internal `onDOMReady` queue.
	   */
	  initialize: function () {
	    this.reactMountReady.reset();
	  },
	
	  /**
	   * After DOM is flushed, invoke all registered `onDOMReady` callbacks.
	   */
	  close: function () {
	    this.reactMountReady.notifyAll();
	  }
	};
	
	/**
	 * Executed within the scope of the `Transaction` instance. Consider these as
	 * being member methods, but with an implied ordering while being isolated from
	 * each other.
	 */
	var TRANSACTION_WRAPPERS = [SELECTION_RESTORATION, EVENT_SUPPRESSION, ON_DOM_READY_QUEUEING];
	
	if (false) {
	  TRANSACTION_WRAPPERS.push({
	    initialize: ReactInstrumentation.debugTool.onBeginFlush,
	    close: ReactInstrumentation.debugTool.onEndFlush
	  });
	}
	
	/**
	 * Currently:
	 * - The order that these are listed in the transaction is critical:
	 * - Suppresses events.
	 * - Restores selection range.
	 *
	 * Future:
	 * - Restore document/overflow scroll positions that were unintentionally
	 *   modified via DOM insertions above the top viewport boundary.
	 * - Implement/integrate with customized constraint based layout system and keep
	 *   track of which dimensions must be remeasured.
	 *
	 * @class ReactReconcileTransaction
	 */
	function ReactReconcileTransaction(useCreateElement) {
	  this.reinitializeTransaction();
	  // Only server-side rendering really needs this option (see
	  // `ReactServerRendering`), but server-side uses
	  // `ReactServerRenderingTransaction` instead. This option is here so that it's
	  // accessible and defaults to false when `ReactDOMComponent` and
	  // `ReactDOMTextComponent` checks it in `mountComponent`.`
	  this.renderToStaticMarkup = false;
	  this.reactMountReady = CallbackQueue.getPooled(null);
	  this.useCreateElement = useCreateElement;
	}
	
	var Mixin = {
	  /**
	   * @see Transaction
	   * @abstract
	   * @final
	   * @return {array<object>} List of operation wrap procedures.
	   *   TODO: convert to array<TransactionWrapper>
	   */
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  /**
	   * @return {object} The queue to collect `onDOMReady` callbacks with.
	   */
	  getReactMountReady: function () {
	    return this.reactMountReady;
	  },
	
	  /**
	   * @return {object} The queue to collect React async events.
	   */
	  getUpdateQueue: function () {
	    return ReactUpdateQueue;
	  },
	
	  /**
	   * Save current transaction state -- if the return value from this method is
	   * passed to `rollback`, the transaction will be reset to that state.
	   */
	  checkpoint: function () {
	    // reactMountReady is the our only stateful wrapper
	    return this.reactMountReady.checkpoint();
	  },
	
	  rollback: function (checkpoint) {
	    this.reactMountReady.rollback(checkpoint);
	  },
	
	  /**
	   * `PooledClass` looks for this, and will invoke this before allowing this
	   * instance to be reused.
	   */
	  destructor: function () {
	    CallbackQueue.release(this.reactMountReady);
	    this.reactMountReady = null;
	  }
	};
	
	_assign(ReactReconcileTransaction.prototype, Transaction, Mixin);
	
	PooledClass.addPoolingTo(ReactReconcileTransaction);
	
	module.exports = ReactReconcileTransaction;

/***/ }),
/* 453 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var ReactOwner = __webpack_require__(450);
	
	var ReactRef = {};
	
	function attachRef(ref, component, owner) {
	  if (typeof ref === 'function') {
	    ref(component.getPublicInstance());
	  } else {
	    // Legacy ref
	    ReactOwner.addComponentAsRefTo(component, ref, owner);
	  }
	}
	
	function detachRef(ref, component, owner) {
	  if (typeof ref === 'function') {
	    ref(null);
	  } else {
	    // Legacy ref
	    ReactOwner.removeComponentAsRefFrom(component, ref, owner);
	  }
	}
	
	ReactRef.attachRefs = function (instance, element) {
	  if (element === null || typeof element !== 'object') {
	    return;
	  }
	  var ref = element.ref;
	  if (ref != null) {
	    attachRef(ref, instance, element._owner);
	  }
	};
	
	ReactRef.shouldUpdateRefs = function (prevElement, nextElement) {
	  // If either the owner or a `ref` has changed, make sure the newest owner
	  // has stored a reference to `this`, and the previous owner (if different)
	  // has forgotten the reference to `this`. We use the element instead
	  // of the public this.props because the post processing cannot determine
	  // a ref. The ref conceptually lives on the element.
	
	  // TODO: Should this even be possible? The owner cannot change because
	  // it's forbidden by shouldUpdateReactComponent. The ref can change
	  // if you swap the keys of but not the refs. Reconsider where this check
	  // is made. It probably belongs where the key checking and
	  // instantiateReactComponent is done.
	
	  var prevRef = null;
	  var prevOwner = null;
	  if (prevElement !== null && typeof prevElement === 'object') {
	    prevRef = prevElement.ref;
	    prevOwner = prevElement._owner;
	  }
	
	  var nextRef = null;
	  var nextOwner = null;
	  if (nextElement !== null && typeof nextElement === 'object') {
	    nextRef = nextElement.ref;
	    nextOwner = nextElement._owner;
	  }
	
	  return prevRef !== nextRef ||
	  // If owner changes but we have an unchanged function ref, don't update refs
	  typeof nextRef === 'string' && nextOwner !== prevOwner;
	};
	
	ReactRef.detachRefs = function (instance, element) {
	  if (element === null || typeof element !== 'object') {
	    return;
	  }
	  var ref = element.ref;
	  if (ref != null) {
	    detachRef(ref, instance, element._owner);
	  }
	};
	
	module.exports = ReactRef;

/***/ }),
/* 454 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(7);
	
	var PooledClass = __webpack_require__(38);
	var Transaction = __webpack_require__(85);
	var ReactInstrumentation = __webpack_require__(25);
	var ReactServerUpdateQueue = __webpack_require__(455);
	
	/**
	 * Executed within the scope of the `Transaction` instance. Consider these as
	 * being member methods, but with an implied ordering while being isolated from
	 * each other.
	 */
	var TRANSACTION_WRAPPERS = [];
	
	if (false) {
	  TRANSACTION_WRAPPERS.push({
	    initialize: ReactInstrumentation.debugTool.onBeginFlush,
	    close: ReactInstrumentation.debugTool.onEndFlush
	  });
	}
	
	var noopCallbackQueue = {
	  enqueue: function () {}
	};
	
	/**
	 * @class ReactServerRenderingTransaction
	 * @param {boolean} renderToStaticMarkup
	 */
	function ReactServerRenderingTransaction(renderToStaticMarkup) {
	  this.reinitializeTransaction();
	  this.renderToStaticMarkup = renderToStaticMarkup;
	  this.useCreateElement = false;
	  this.updateQueue = new ReactServerUpdateQueue(this);
	}
	
	var Mixin = {
	  /**
	   * @see Transaction
	   * @abstract
	   * @final
	   * @return {array} Empty list of operation wrap procedures.
	   */
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  /**
	   * @return {object} The queue to collect `onDOMReady` callbacks with.
	   */
	  getReactMountReady: function () {
	    return noopCallbackQueue;
	  },
	
	  /**
	   * @return {object} The queue to collect React async events.
	   */
	  getUpdateQueue: function () {
	    return this.updateQueue;
	  },
	
	  /**
	   * `PooledClass` looks for this, and will invoke this before allowing this
	   * instance to be reused.
	   */
	  destructor: function () {},
	
	  checkpoint: function () {},
	
	  rollback: function () {}
	};
	
	_assign(ReactServerRenderingTransaction.prototype, Transaction, Mixin);
	
	PooledClass.addPoolingTo(ReactServerRenderingTransaction);
	
	module.exports = ReactServerRenderingTransaction;

/***/ }),
/* 455 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ReactUpdateQueue = __webpack_require__(125);
	
	var warning = __webpack_require__(5);
	
	function warnNoop(publicInstance, callerName) {
	  if (false) {
	    var constructor = publicInstance.constructor;
	    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounting component. ' + 'This usually means you called %s() outside componentWillMount() on the server. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
	  }
	}
	
	/**
	 * This is the update queue used for server rendering.
	 * It delegates to ReactUpdateQueue while server rendering is in progress and
	 * switches to ReactNoopUpdateQueue after the transaction has completed.
	 * @class ReactServerUpdateQueue
	 * @param {Transaction} transaction
	 */
	
	var ReactServerUpdateQueue = function () {
	  function ReactServerUpdateQueue(transaction) {
	    _classCallCheck(this, ReactServerUpdateQueue);
	
	    this.transaction = transaction;
	  }
	
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	
	
	  ReactServerUpdateQueue.prototype.isMounted = function isMounted(publicInstance) {
	    return false;
	  };
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueCallback = function enqueueCallback(publicInstance, callback, callerName) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueCallback(publicInstance, callback, callerName);
	    }
	  };
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueForceUpdate = function enqueueForceUpdate(publicInstance) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueForceUpdate(publicInstance);
	    } else {
	      warnNoop(publicInstance, 'forceUpdate');
	    }
	  };
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object|function} completeState Next state.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueReplaceState = function enqueueReplaceState(publicInstance, completeState) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueReplaceState(publicInstance, completeState);
	    } else {
	      warnNoop(publicInstance, 'replaceState');
	    }
	  };
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object|function} partialState Next partial state to be merged with state.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueSetState = function enqueueSetState(publicInstance, partialState) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueSetState(publicInstance, partialState);
	    } else {
	      warnNoop(publicInstance, 'setState');
	    }
	  };
	
	  return ReactServerUpdateQueue;
	}();
	
	module.exports = ReactServerUpdateQueue;

/***/ }),
/* 456 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	module.exports = '15.6.2';

/***/ }),
/* 457 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var NS = {
	  xlink: 'http://www.w3.org/1999/xlink',
	  xml: 'http://www.w3.org/XML/1998/namespace'
	};
	
	// We use attributes for everything SVG so let's avoid some duplication and run
	// code instead.
	// The following are all specified in the HTML config already so we exclude here.
	// - class (as className)
	// - color
	// - height
	// - id
	// - lang
	// - max
	// - media
	// - method
	// - min
	// - name
	// - style
	// - target
	// - type
	// - width
	var ATTRS = {
	  accentHeight: 'accent-height',
	  accumulate: 0,
	  additive: 0,
	  alignmentBaseline: 'alignment-baseline',
	  allowReorder: 'allowReorder',
	  alphabetic: 0,
	  amplitude: 0,
	  arabicForm: 'arabic-form',
	  ascent: 0,
	  attributeName: 'attributeName',
	  attributeType: 'attributeType',
	  autoReverse: 'autoReverse',
	  azimuth: 0,
	  baseFrequency: 'baseFrequency',
	  baseProfile: 'baseProfile',
	  baselineShift: 'baseline-shift',
	  bbox: 0,
	  begin: 0,
	  bias: 0,
	  by: 0,
	  calcMode: 'calcMode',
	  capHeight: 'cap-height',
	  clip: 0,
	  clipPath: 'clip-path',
	  clipRule: 'clip-rule',
	  clipPathUnits: 'clipPathUnits',
	  colorInterpolation: 'color-interpolation',
	  colorInterpolationFilters: 'color-interpolation-filters',
	  colorProfile: 'color-profile',
	  colorRendering: 'color-rendering',
	  contentScriptType: 'contentScriptType',
	  contentStyleType: 'contentStyleType',
	  cursor: 0,
	  cx: 0,
	  cy: 0,
	  d: 0,
	  decelerate: 0,
	  descent: 0,
	  diffuseConstant: 'diffuseConstant',
	  direction: 0,
	  display: 0,
	  divisor: 0,
	  dominantBaseline: 'dominant-baseline',
	  dur: 0,
	  dx: 0,
	  dy: 0,
	  edgeMode: 'edgeMode',
	  elevation: 0,
	  enableBackground: 'enable-background',
	  end: 0,
	  exponent: 0,
	  externalResourcesRequired: 'externalResourcesRequired',
	  fill: 0,
	  fillOpacity: 'fill-opacity',
	  fillRule: 'fill-rule',
	  filter: 0,
	  filterRes: 'filterRes',
	  filterUnits: 'filterUnits',
	  floodColor: 'flood-color',
	  floodOpacity: 'flood-opacity',
	  focusable: 0,
	  fontFamily: 'font-family',
	  fontSize: 'font-size',
	  fontSizeAdjust: 'font-size-adjust',
	  fontStretch: 'font-stretch',
	  fontStyle: 'font-style',
	  fontVariant: 'font-variant',
	  fontWeight: 'font-weight',
	  format: 0,
	  from: 0,
	  fx: 0,
	  fy: 0,
	  g1: 0,
	  g2: 0,
	  glyphName: 'glyph-name',
	  glyphOrientationHorizontal: 'glyph-orientation-horizontal',
	  glyphOrientationVertical: 'glyph-orientation-vertical',
	  glyphRef: 'glyphRef',
	  gradientTransform: 'gradientTransform',
	  gradientUnits: 'gradientUnits',
	  hanging: 0,
	  horizAdvX: 'horiz-adv-x',
	  horizOriginX: 'horiz-origin-x',
	  ideographic: 0,
	  imageRendering: 'image-rendering',
	  'in': 0,
	  in2: 0,
	  intercept: 0,
	  k: 0,
	  k1: 0,
	  k2: 0,
	  k3: 0,
	  k4: 0,
	  kernelMatrix: 'kernelMatrix',
	  kernelUnitLength: 'kernelUnitLength',
	  kerning: 0,
	  keyPoints: 'keyPoints',
	  keySplines: 'keySplines',
	  keyTimes: 'keyTimes',
	  lengthAdjust: 'lengthAdjust',
	  letterSpacing: 'letter-spacing',
	  lightingColor: 'lighting-color',
	  limitingConeAngle: 'limitingConeAngle',
	  local: 0,
	  markerEnd: 'marker-end',
	  markerMid: 'marker-mid',
	  markerStart: 'marker-start',
	  markerHeight: 'markerHeight',
	  markerUnits: 'markerUnits',
	  markerWidth: 'markerWidth',
	  mask: 0,
	  maskContentUnits: 'maskContentUnits',
	  maskUnits: 'maskUnits',
	  mathematical: 0,
	  mode: 0,
	  numOctaves: 'numOctaves',
	  offset: 0,
	  opacity: 0,
	  operator: 0,
	  order: 0,
	  orient: 0,
	  orientation: 0,
	  origin: 0,
	  overflow: 0,
	  overlinePosition: 'overline-position',
	  overlineThickness: 'overline-thickness',
	  paintOrder: 'paint-order',
	  panose1: 'panose-1',
	  pathLength: 'pathLength',
	  patternContentUnits: 'patternContentUnits',
	  patternTransform: 'patternTransform',
	  patternUnits: 'patternUnits',
	  pointerEvents: 'pointer-events',
	  points: 0,
	  pointsAtX: 'pointsAtX',
	  pointsAtY: 'pointsAtY',
	  pointsAtZ: 'pointsAtZ',
	  preserveAlpha: 'preserveAlpha',
	  preserveAspectRatio: 'preserveAspectRatio',
	  primitiveUnits: 'primitiveUnits',
	  r: 0,
	  radius: 0,
	  refX: 'refX',
	  refY: 'refY',
	  renderingIntent: 'rendering-intent',
	  repeatCount: 'repeatCount',
	  repeatDur: 'repeatDur',
	  requiredExtensions: 'requiredExtensions',
	  requiredFeatures: 'requiredFeatures',
	  restart: 0,
	  result: 0,
	  rotate: 0,
	  rx: 0,
	  ry: 0,
	  scale: 0,
	  seed: 0,
	  shapeRendering: 'shape-rendering',
	  slope: 0,
	  spacing: 0,
	  specularConstant: 'specularConstant',
	  specularExponent: 'specularExponent',
	  speed: 0,
	  spreadMethod: 'spreadMethod',
	  startOffset: 'startOffset',
	  stdDeviation: 'stdDeviation',
	  stemh: 0,
	  stemv: 0,
	  stitchTiles: 'stitchTiles',
	  stopColor: 'stop-color',
	  stopOpacity: 'stop-opacity',
	  strikethroughPosition: 'strikethrough-position',
	  strikethroughThickness: 'strikethrough-thickness',
	  string: 0,
	  stroke: 0,
	  strokeDasharray: 'stroke-dasharray',
	  strokeDashoffset: 'stroke-dashoffset',
	  strokeLinecap: 'stroke-linecap',
	  strokeLinejoin: 'stroke-linejoin',
	  strokeMiterlimit: 'stroke-miterlimit',
	  strokeOpacity: 'stroke-opacity',
	  strokeWidth: 'stroke-width',
	  surfaceScale: 'surfaceScale',
	  systemLanguage: 'systemLanguage',
	  tableValues: 'tableValues',
	  targetX: 'targetX',
	  targetY: 'targetY',
	  textAnchor: 'text-anchor',
	  textDecoration: 'text-decoration',
	  textRendering: 'text-rendering',
	  textLength: 'textLength',
	  to: 0,
	  transform: 0,
	  u1: 0,
	  u2: 0,
	  underlinePosition: 'underline-position',
	  underlineThickness: 'underline-thickness',
	  unicode: 0,
	  unicodeBidi: 'unicode-bidi',
	  unicodeRange: 'unicode-range',
	  unitsPerEm: 'units-per-em',
	  vAlphabetic: 'v-alphabetic',
	  vHanging: 'v-hanging',
	  vIdeographic: 'v-ideographic',
	  vMathematical: 'v-mathematical',
	  values: 0,
	  vectorEffect: 'vector-effect',
	  version: 0,
	  vertAdvY: 'vert-adv-y',
	  vertOriginX: 'vert-origin-x',
	  vertOriginY: 'vert-origin-y',
	  viewBox: 'viewBox',
	  viewTarget: 'viewTarget',
	  visibility: 0,
	  widths: 0,
	  wordSpacing: 'word-spacing',
	  writingMode: 'writing-mode',
	  x: 0,
	  xHeight: 'x-height',
	  x1: 0,
	  x2: 0,
	  xChannelSelector: 'xChannelSelector',
	  xlinkActuate: 'xlink:actuate',
	  xlinkArcrole: 'xlink:arcrole',
	  xlinkHref: 'xlink:href',
	  xlinkRole: 'xlink:role',
	  xlinkShow: 'xlink:show',
	  xlinkTitle: 'xlink:title',
	  xlinkType: 'xlink:type',
	  xmlBase: 'xml:base',
	  xmlns: 0,
	  xmlnsXlink: 'xmlns:xlink',
	  xmlLang: 'xml:lang',
	  xmlSpace: 'xml:space',
	  y: 0,
	  y1: 0,
	  y2: 0,
	  yChannelSelector: 'yChannelSelector',
	  z: 0,
	  zoomAndPan: 'zoomAndPan'
	};
	
	var SVGDOMPropertyConfig = {
	  Properties: {},
	  DOMAttributeNamespaces: {
	    xlinkActuate: NS.xlink,
	    xlinkArcrole: NS.xlink,
	    xlinkHref: NS.xlink,
	    xlinkRole: NS.xlink,
	    xlinkShow: NS.xlink,
	    xlinkTitle: NS.xlink,
	    xlinkType: NS.xlink,
	    xmlBase: NS.xml,
	    xmlLang: NS.xml,
	    xmlSpace: NS.xml
	  },
	  DOMAttributeNames: {}
	};
	
	Object.keys(ATTRS).forEach(function (key) {
	  SVGDOMPropertyConfig.Properties[key] = 0;
	  if (ATTRS[key]) {
	    SVGDOMPropertyConfig.DOMAttributeNames[key] = ATTRS[key];
	  }
	});
	
	module.exports = SVGDOMPropertyConfig;

/***/ }),
/* 458 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var EventPropagators = __webpack_require__(60);
	var ExecutionEnvironment = __webpack_require__(16);
	var ReactDOMComponentTree = __webpack_require__(9);
	var ReactInputSelection = __webpack_require__(204);
	var SyntheticEvent = __webpack_require__(31);
	
	var getActiveElement = __webpack_require__(192);
	var isTextInputElement = __webpack_require__(214);
	var shallowEqual = __webpack_require__(116);
	
	var skipSelectionChangeEvent = ExecutionEnvironment.canUseDOM && 'documentMode' in document && document.documentMode <= 11;
	
	var eventTypes = {
	  select: {
	    phasedRegistrationNames: {
	      bubbled: 'onSelect',
	      captured: 'onSelectCapture'
	    },
	    dependencies: ['topBlur', 'topContextMenu', 'topFocus', 'topKeyDown', 'topKeyUp', 'topMouseDown', 'topMouseUp', 'topSelectionChange']
	  }
	};
	
	var activeElement = null;
	var activeElementInst = null;
	var lastSelection = null;
	var mouseDown = false;
	
	// Track whether a listener exists for this plugin. If none exist, we do
	// not extract events. See #3639.
	var hasListener = false;
	
	/**
	 * Get an object which is a unique representation of the current selection.
	 *
	 * The return value will not be consistent across nodes or browsers, but
	 * two identical selections on the same node will return identical objects.
	 *
	 * @param {DOMElement} node
	 * @return {object}
	 */
	function getSelection(node) {
	  if ('selectionStart' in node && ReactInputSelection.hasSelectionCapabilities(node)) {
	    return {
	      start: node.selectionStart,
	      end: node.selectionEnd
	    };
	  } else if (window.getSelection) {
	    var selection = window.getSelection();
	    return {
	      anchorNode: selection.anchorNode,
	      anchorOffset: selection.anchorOffset,
	      focusNode: selection.focusNode,
	      focusOffset: selection.focusOffset
	    };
	  } else if (document.selection) {
	    var range = document.selection.createRange();
	    return {
	      parentElement: range.parentElement(),
	      text: range.text,
	      top: range.boundingTop,
	      left: range.boundingLeft
	    };
	  }
	}
	
	/**
	 * Poll selection to see whether it's changed.
	 *
	 * @param {object} nativeEvent
	 * @return {?SyntheticEvent}
	 */
	function constructSelectEvent(nativeEvent, nativeEventTarget) {
	  // Ensure we have the right element, and that the user is not dragging a
	  // selection (this matches native `select` event behavior). In HTML5, select
	  // fires only on input and textarea thus if there's no focused element we
	  // won't dispatch.
	  if (mouseDown || activeElement == null || activeElement !== getActiveElement()) {
	    return null;
	  }
	
	  // Only fire when selection has actually changed.
	  var currentSelection = getSelection(activeElement);
	  if (!lastSelection || !shallowEqual(lastSelection, currentSelection)) {
	    lastSelection = currentSelection;
	
	    var syntheticEvent = SyntheticEvent.getPooled(eventTypes.select, activeElementInst, nativeEvent, nativeEventTarget);
	
	    syntheticEvent.type = 'select';
	    syntheticEvent.target = activeElement;
	
	    EventPropagators.accumulateTwoPhaseDispatches(syntheticEvent);
	
	    return syntheticEvent;
	  }
	
	  return null;
	}
	
	/**
	 * This plugin creates an `onSelect` event that normalizes select events
	 * across form elements.
	 *
	 * Supported elements are:
	 * - input (see `isTextInputElement`)
	 * - textarea
	 * - contentEditable
	 *
	 * This differs from native browser implementations in the following ways:
	 * - Fires on contentEditable fields as well as inputs.
	 * - Fires for collapsed selection.
	 * - Fires after user input.
	 */
	var SelectEventPlugin = {
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    if (!hasListener) {
	      return null;
	    }
	
	    var targetNode = targetInst ? ReactDOMComponentTree.getNodeFromInstance(targetInst) : window;
	
	    switch (topLevelType) {
	      // Track the input node that has focus.
	      case 'topFocus':
	        if (isTextInputElement(targetNode) || targetNode.contentEditable === 'true') {
	          activeElement = targetNode;
	          activeElementInst = targetInst;
	          lastSelection = null;
	        }
	        break;
	      case 'topBlur':
	        activeElement = null;
	        activeElementInst = null;
	        lastSelection = null;
	        break;
	      // Don't fire the event while the user is dragging. This matches the
	      // semantics of the native select event.
	      case 'topMouseDown':
	        mouseDown = true;
	        break;
	      case 'topContextMenu':
	      case 'topMouseUp':
	        mouseDown = false;
	        return constructSelectEvent(nativeEvent, nativeEventTarget);
	      // Chrome and IE fire non-standard event when selection is changed (and
	      // sometimes when it hasn't). IE's event fires out of order with respect
	      // to key and input events on deletion, so we discard it.
	      //
	      // Firefox doesn't support selectionchange, so check selection status
	      // after each key entry. The selection changes after keydown and before
	      // keyup, but we check on keydown as well in the case of holding down a
	      // key, when multiple keydown events are fired but only one keyup is.
	      // This is also our approach for IE handling, for the reason above.
	      case 'topSelectionChange':
	        if (skipSelectionChangeEvent) {
	          break;
	        }
	      // falls through
	      case 'topKeyDown':
	      case 'topKeyUp':
	        return constructSelectEvent(nativeEvent, nativeEventTarget);
	    }
	
	    return null;
	  },
	
	  didPutListener: function (inst, registrationName, listener) {
	    if (registrationName === 'onSelect') {
	      hasListener = true;
	    }
	  }
	};
	
	module.exports = SelectEventPlugin;

/***/ }),
/* 459 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(6);
	
	var EventListener = __webpack_require__(190);
	var EventPropagators = __webpack_require__(60);
	var ReactDOMComponentTree = __webpack_require__(9);
	var SyntheticAnimationEvent = __webpack_require__(460);
	var SyntheticClipboardEvent = __webpack_require__(461);
	var SyntheticEvent = __webpack_require__(31);
	var SyntheticFocusEvent = __webpack_require__(464);
	var SyntheticKeyboardEvent = __webpack_require__(466);
	var SyntheticMouseEvent = __webpack_require__(84);
	var SyntheticDragEvent = __webpack_require__(463);
	var SyntheticTouchEvent = __webpack_require__(467);
	var SyntheticTransitionEvent = __webpack_require__(468);
	var SyntheticUIEvent = __webpack_require__(62);
	var SyntheticWheelEvent = __webpack_require__(469);
	
	var emptyFunction = __webpack_require__(24);
	var getEventCharCode = __webpack_require__(127);
	var invariant = __webpack_require__(3);
	
	/**
	 * Turns
	 * ['abort', ...]
	 * into
	 * eventTypes = {
	 *   'abort': {
	 *     phasedRegistrationNames: {
	 *       bubbled: 'onAbort',
	 *       captured: 'onAbortCapture',
	 *     },
	 *     dependencies: ['topAbort'],
	 *   },
	 *   ...
	 * };
	 * topLevelEventsToDispatchConfig = {
	 *   'topAbort': { sameConfig }
	 * };
	 */
	var eventTypes = {};
	var topLevelEventsToDispatchConfig = {};
	['abort', 'animationEnd', 'animationIteration', 'animationStart', 'blur', 'canPlay', 'canPlayThrough', 'click', 'contextMenu', 'copy', 'cut', 'doubleClick', 'drag', 'dragEnd', 'dragEnter', 'dragExit', 'dragLeave', 'dragOver', 'dragStart', 'drop', 'durationChange', 'emptied', 'encrypted', 'ended', 'error', 'focus', 'input', 'invalid', 'keyDown', 'keyPress', 'keyUp', 'load', 'loadedData', 'loadedMetadata', 'loadStart', 'mouseDown', 'mouseMove', 'mouseOut', 'mouseOver', 'mouseUp', 'paste', 'pause', 'play', 'playing', 'progress', 'rateChange', 'reset', 'scroll', 'seeked', 'seeking', 'stalled', 'submit', 'suspend', 'timeUpdate', 'touchCancel', 'touchEnd', 'touchMove', 'touchStart', 'transitionEnd', 'volumeChange', 'waiting', 'wheel'].forEach(function (event) {
	  var capitalizedEvent = event[0].toUpperCase() + event.slice(1);
	  var onEvent = 'on' + capitalizedEvent;
	  var topEvent = 'top' + capitalizedEvent;
	
	  var type = {
	    phasedRegistrationNames: {
	      bubbled: onEvent,
	      captured: onEvent + 'Capture'
	    },
	    dependencies: [topEvent]
	  };
	  eventTypes[event] = type;
	  topLevelEventsToDispatchConfig[topEvent] = type;
	});
	
	var onClickListeners = {};
	
	function getDictionaryKey(inst) {
	  // Prevents V8 performance issue:
	  // https://github.com/facebook/react/pull/7232
	  return '.' + inst._rootNodeID;
	}
	
	function isInteractive(tag) {
	  return tag === 'button' || tag === 'input' || tag === 'select' || tag === 'textarea';
	}
	
	var SimpleEventPlugin = {
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var dispatchConfig = topLevelEventsToDispatchConfig[topLevelType];
	    if (!dispatchConfig) {
	      return null;
	    }
	    var EventConstructor;
	    switch (topLevelType) {
	      case 'topAbort':
	      case 'topCanPlay':
	      case 'topCanPlayThrough':
	      case 'topDurationChange':
	      case 'topEmptied':
	      case 'topEncrypted':
	      case 'topEnded':
	      case 'topError':
	      case 'topInput':
	      case 'topInvalid':
	      case 'topLoad':
	      case 'topLoadedData':
	      case 'topLoadedMetadata':
	      case 'topLoadStart':
	      case 'topPause':
	      case 'topPlay':
	      case 'topPlaying':
	      case 'topProgress':
	      case 'topRateChange':
	      case 'topReset':
	      case 'topSeeked':
	      case 'topSeeking':
	      case 'topStalled':
	      case 'topSubmit':
	      case 'topSuspend':
	      case 'topTimeUpdate':
	      case 'topVolumeChange':
	      case 'topWaiting':
	        // HTML Events
	        // @see http://www.w3.org/TR/html5/index.html#events-0
	        EventConstructor = SyntheticEvent;
	        break;
	      case 'topKeyPress':
	        // Firefox creates a keypress event for function keys too. This removes
	        // the unwanted keypress events. Enter is however both printable and
	        // non-printable. One would expect Tab to be as well (but it isn't).
	        if (getEventCharCode(nativeEvent) === 0) {
	          return null;
	        }
	      /* falls through */
	      case 'topKeyDown':
	      case 'topKeyUp':
	        EventConstructor = SyntheticKeyboardEvent;
	        break;
	      case 'topBlur':
	      case 'topFocus':
	        EventConstructor = SyntheticFocusEvent;
	        break;
	      case 'topClick':
	        // Firefox creates a click event on right mouse clicks. This removes the
	        // unwanted click events.
	        if (nativeEvent.button === 2) {
	          return null;
	        }
	      /* falls through */
	      case 'topDoubleClick':
	      case 'topMouseDown':
	      case 'topMouseMove':
	      case 'topMouseUp':
	      // TODO: Disabled elements should not respond to mouse events
	      /* falls through */
	      case 'topMouseOut':
	      case 'topMouseOver':
	      case 'topContextMenu':
	        EventConstructor = SyntheticMouseEvent;
	        break;
	      case 'topDrag':
	      case 'topDragEnd':
	      case 'topDragEnter':
	      case 'topDragExit':
	      case 'topDragLeave':
	      case 'topDragOver':
	      case 'topDragStart':
	      case 'topDrop':
	        EventConstructor = SyntheticDragEvent;
	        break;
	      case 'topTouchCancel':
	      case 'topTouchEnd':
	      case 'topTouchMove':
	      case 'topTouchStart':
	        EventConstructor = SyntheticTouchEvent;
	        break;
	      case 'topAnimationEnd':
	      case 'topAnimationIteration':
	      case 'topAnimationStart':
	        EventConstructor = SyntheticAnimationEvent;
	        break;
	      case 'topTransitionEnd':
	        EventConstructor = SyntheticTransitionEvent;
	        break;
	      case 'topScroll':
	        EventConstructor = SyntheticUIEvent;
	        break;
	      case 'topWheel':
	        EventConstructor = SyntheticWheelEvent;
	        break;
	      case 'topCopy':
	      case 'topCut':
	      case 'topPaste':
	        EventConstructor = SyntheticClipboardEvent;
	        break;
	    }
	    !EventConstructor ?  false ? invariant(false, 'SimpleEventPlugin: Unhandled event type, `%s`.', topLevelType) : _prodInvariant('86', topLevelType) : void 0;
	    var event = EventConstructor.getPooled(dispatchConfig, targetInst, nativeEvent, nativeEventTarget);
	    EventPropagators.accumulateTwoPhaseDispatches(event);
	    return event;
	  },
	
	  didPutListener: function (inst, registrationName, listener) {
	    // Mobile Safari does not fire properly bubble click events on
	    // non-interactive elements, which means delegated click listeners do not
	    // fire. The workaround for this bug involves attaching an empty click
	    // listener on the target node.
	    // http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
	    if (registrationName === 'onClick' && !isInteractive(inst._tag)) {
	      var key = getDictionaryKey(inst);
	      var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	      if (!onClickListeners[key]) {
	        onClickListeners[key] = EventListener.listen(node, 'click', emptyFunction);
	      }
	    }
	  },
	
	  willDeleteListener: function (inst, registrationName) {
	    if (registrationName === 'onClick' && !isInteractive(inst._tag)) {
	      var key = getDictionaryKey(inst);
	      onClickListeners[key].remove();
	      delete onClickListeners[key];
	    }
	  }
	};
	
	module.exports = SimpleEventPlugin;

/***/ }),
/* 460 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(31);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/css3-animations/#AnimationEvent-interface
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/AnimationEvent
	 */
	var AnimationEventInterface = {
	  animationName: null,
	  elapsedTime: null,
	  pseudoElement: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticAnimationEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticAnimationEvent, AnimationEventInterface);
	
	module.exports = SyntheticAnimationEvent;

/***/ }),
/* 461 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(31);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/clipboard-apis/
	 */
	var ClipboardEventInterface = {
	  clipboardData: function (event) {
	    return 'clipboardData' in event ? event.clipboardData : window.clipboardData;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticClipboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticClipboardEvent, ClipboardEventInterface);
	
	module.exports = SyntheticClipboardEvent;

/***/ }),
/* 462 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(31);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/#events-compositionevents
	 */
	var CompositionEventInterface = {
	  data: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticCompositionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticCompositionEvent, CompositionEventInterface);
	
	module.exports = SyntheticCompositionEvent;

/***/ }),
/* 463 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticMouseEvent = __webpack_require__(84);
	
	/**
	 * @interface DragEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var DragEventInterface = {
	  dataTransfer: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticDragEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticMouseEvent.augmentClass(SyntheticDragEvent, DragEventInterface);
	
	module.exports = SyntheticDragEvent;

/***/ }),
/* 464 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(62);
	
	/**
	 * @interface FocusEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var FocusEventInterface = {
	  relatedTarget: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticFocusEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticFocusEvent, FocusEventInterface);
	
	module.exports = SyntheticFocusEvent;

/***/ }),
/* 465 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(31);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105
	 *      /#events-inputevents
	 */
	var InputEventInterface = {
	  data: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticInputEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticInputEvent, InputEventInterface);
	
	module.exports = SyntheticInputEvent;

/***/ }),
/* 466 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(62);
	
	var getEventCharCode = __webpack_require__(127);
	var getEventKey = __webpack_require__(474);
	var getEventModifierState = __webpack_require__(128);
	
	/**
	 * @interface KeyboardEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var KeyboardEventInterface = {
	  key: getEventKey,
	  location: null,
	  ctrlKey: null,
	  shiftKey: null,
	  altKey: null,
	  metaKey: null,
	  repeat: null,
	  locale: null,
	  getModifierState: getEventModifierState,
	  // Legacy Interface
	  charCode: function (event) {
	    // `charCode` is the result of a KeyPress event and represents the value of
	    // the actual printable character.
	
	    // KeyPress is deprecated, but its replacement is not yet final and not
	    // implemented in any major browser. Only KeyPress has charCode.
	    if (event.type === 'keypress') {
	      return getEventCharCode(event);
	    }
	    return 0;
	  },
	  keyCode: function (event) {
	    // `keyCode` is the result of a KeyDown/Up event and represents the value of
	    // physical keyboard key.
	
	    // The actual meaning of the value depends on the users' keyboard layout
	    // which cannot be detected. Assuming that it is a US keyboard layout
	    // provides a surprisingly accurate mapping for US and European users.
	    // Due to this, it is left to the user to implement at this time.
	    if (event.type === 'keydown' || event.type === 'keyup') {
	      return event.keyCode;
	    }
	    return 0;
	  },
	  which: function (event) {
	    // `which` is an alias for either `keyCode` or `charCode` depending on the
	    // type of the event.
	    if (event.type === 'keypress') {
	      return getEventCharCode(event);
	    }
	    if (event.type === 'keydown' || event.type === 'keyup') {
	      return event.keyCode;
	    }
	    return 0;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticKeyboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticKeyboardEvent, KeyboardEventInterface);
	
	module.exports = SyntheticKeyboardEvent;

/***/ }),
/* 467 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(62);
	
	var getEventModifierState = __webpack_require__(128);
	
	/**
	 * @interface TouchEvent
	 * @see http://www.w3.org/TR/touch-events/
	 */
	var TouchEventInterface = {
	  touches: null,
	  targetTouches: null,
	  changedTouches: null,
	  altKey: null,
	  metaKey: null,
	  ctrlKey: null,
	  shiftKey: null,
	  getModifierState: getEventModifierState
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticTouchEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticTouchEvent, TouchEventInterface);
	
	module.exports = SyntheticTouchEvent;

/***/ }),
/* 468 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(31);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/2009/WD-css3-transitions-20090320/#transition-events-
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/TransitionEvent
	 */
	var TransitionEventInterface = {
	  propertyName: null,
	  elapsedTime: null,
	  pseudoElement: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticTransitionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticTransitionEvent, TransitionEventInterface);
	
	module.exports = SyntheticTransitionEvent;

/***/ }),
/* 469 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticMouseEvent = __webpack_require__(84);
	
	/**
	 * @interface WheelEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var WheelEventInterface = {
	  deltaX: function (event) {
	    return 'deltaX' in event ? event.deltaX : // Fallback to `wheelDeltaX` for Webkit and normalize (right is positive).
	    'wheelDeltaX' in event ? -event.wheelDeltaX : 0;
	  },
	  deltaY: function (event) {
	    return 'deltaY' in event ? event.deltaY : // Fallback to `wheelDeltaY` for Webkit and normalize (down is positive).
	    'wheelDeltaY' in event ? -event.wheelDeltaY : // Fallback to `wheelDelta` for IE<9 and normalize (down is positive).
	    'wheelDelta' in event ? -event.wheelDelta : 0;
	  },
	  deltaZ: null,
	
	  // Browsers without "deltaMode" is reporting in raw wheel delta where one
	  // notch on the scroll is always +/- 120, roughly equivalent to pixels.
	  // A good approximation of DOM_DELTA_LINE (1) is 5% of viewport size or
	  // ~40 pixels, for DOM_DELTA_SCREEN (2) it is 87.5% of viewport size.
	  deltaMode: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticMouseEvent}
	 */
	function SyntheticWheelEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticMouseEvent.augmentClass(SyntheticWheelEvent, WheelEventInterface);
	
	module.exports = SyntheticWheelEvent;

/***/ }),
/* 470 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var MOD = 65521;
	
	// adler32 is not cryptographically strong, and is only used to sanity check that
	// markup generated on the server matches the markup generated on the client.
	// This implementation (a modified version of the SheetJS version) has been optimized
	// for our use case, at the expense of conforming to the adler32 specification
	// for non-ascii inputs.
	function adler32(data) {
	  var a = 1;
	  var b = 0;
	  var i = 0;
	  var l = data.length;
	  var m = l & ~0x3;
	  while (i < m) {
	    var n = Math.min(i + 4096, m);
	    for (; i < n; i += 4) {
	      b += (a += data.charCodeAt(i)) + (a += data.charCodeAt(i + 1)) + (a += data.charCodeAt(i + 2)) + (a += data.charCodeAt(i + 3));
	    }
	    a %= MOD;
	    b %= MOD;
	  }
	  for (; i < l; i++) {
	    b += a += data.charCodeAt(i);
	  }
	  a %= MOD;
	  b %= MOD;
	  return a | b << 16;
	}
	
	module.exports = adler32;

/***/ }),
/* 471 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var CSSProperty = __webpack_require__(196);
	var warning = __webpack_require__(5);
	
	var isUnitlessNumber = CSSProperty.isUnitlessNumber;
	var styleWarnings = {};
	
	/**
	 * Convert a value into the proper css writable value. The style name `name`
	 * should be logical (no hyphens), as specified
	 * in `CSSProperty.isUnitlessNumber`.
	 *
	 * @param {string} name CSS property name such as `topMargin`.
	 * @param {*} value CSS property value such as `10px`.
	 * @param {ReactDOMComponent} component
	 * @return {string} Normalized style value with dimensions applied.
	 */
	function dangerousStyleValue(name, value, component, isCustomProperty) {
	  // Note that we've removed escapeTextForBrowser() calls here since the
	  // whole string will be escaped when the attribute is injected into
	  // the markup. If you provide unsafe user data here they can inject
	  // arbitrary CSS which may be problematic (I couldn't repro this):
	  // https://www.owasp.org/index.php/XSS_Filter_Evasion_Cheat_Sheet
	  // http://www.thespanner.co.uk/2007/11/26/ultimate-xss-css-injection/
	  // This is not an XSS hole but instead a potential CSS injection issue
	  // which has lead to a greater discussion about how we're going to
	  // trust URLs moving forward. See #2115901
	
	  var isEmpty = value == null || typeof value === 'boolean' || value === '';
	  if (isEmpty) {
	    return '';
	  }
	
	  var isNonNumeric = isNaN(value);
	  if (isCustomProperty || isNonNumeric || value === 0 || isUnitlessNumber.hasOwnProperty(name) && isUnitlessNumber[name]) {
	    return '' + value; // cast to string
	  }
	
	  if (typeof value === 'string') {
	    if (false) {
	      // Allow '0' to pass through without warning. 0 is already special and
	      // doesn't require units, so we don't need to warn about it.
	      if (component && value !== '0') {
	        var owner = component._currentElement._owner;
	        var ownerName = owner ? owner.getName() : null;
	        if (ownerName && !styleWarnings[ownerName]) {
	          styleWarnings[ownerName] = {};
	        }
	        var warned = false;
	        if (ownerName) {
	          var warnings = styleWarnings[ownerName];
	          warned = warnings[name];
	          if (!warned) {
	            warnings[name] = true;
	          }
	        }
	        if (!warned) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'a `%s` tag (owner: `%s`) was passed a numeric string value ' + 'for CSS property `%s` (value: `%s`) which will be treated ' + 'as a unitless number in a future version of React.', component._currentElement.type, ownerName || 'unknown', name, value) : void 0;
	        }
	      }
	    }
	    value = value.trim();
	  }
	  return value + 'px';
	}
	
	module.exports = dangerousStyleValue;

/***/ }),
/* 472 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(6);
	
	var ReactCurrentOwner = __webpack_require__(32);
	var ReactDOMComponentTree = __webpack_require__(9);
	var ReactInstanceMap = __webpack_require__(61);
	
	var getHostComponentFromComposite = __webpack_require__(210);
	var invariant = __webpack_require__(3);
	var warning = __webpack_require__(5);
	
	/**
	 * Returns the DOM node rendered by this element.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.finddomnode
	 *
	 * @param {ReactComponent|DOMElement} componentOrElement
	 * @return {?DOMElement} The root node of this element.
	 */
	function findDOMNode(componentOrElement) {
	  if (false) {
	    var owner = ReactCurrentOwner.current;
	    if (owner !== null) {
	      process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing findDOMNode inside its render(). ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : void 0;
	      owner._warnedAboutRefsInRender = true;
	    }
	  }
	  if (componentOrElement == null) {
	    return null;
	  }
	  if (componentOrElement.nodeType === 1) {
	    return componentOrElement;
	  }
	
	  var inst = ReactInstanceMap.get(componentOrElement);
	  if (inst) {
	    inst = getHostComponentFromComposite(inst);
	    return inst ? ReactDOMComponentTree.getNodeFromInstance(inst) : null;
	  }
	
	  if (typeof componentOrElement.render === 'function') {
	     true ?  false ? invariant(false, 'findDOMNode was called on an unmounted component.') : _prodInvariant('44') : void 0;
	  } else {
	     true ?  false ? invariant(false, 'Element appears to be neither ReactComponent nor DOMNode (keys: %s)', Object.keys(componentOrElement)) : _prodInvariant('45', Object.keys(componentOrElement)) : void 0;
	  }
	}
	
	module.exports = findDOMNode;

/***/ }),
/* 473 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var KeyEscapeUtils = __webpack_require__(121);
	var traverseAllChildren = __webpack_require__(216);
	var warning = __webpack_require__(5);
	
	var ReactComponentTreeHook;
	
	if (typeof process !== 'undefined' && process.env && ("production") === 'test') {
	  // Temporary hack.
	  // Inline requires don't work well with Jest:
	  // https://github.com/facebook/react/issues/7240
	  // Remove the inline requires when we don't need them anymore:
	  // https://github.com/facebook/react/pull/7178
	  ReactComponentTreeHook = __webpack_require__(218);
	}
	
	/**
	 * @param {function} traverseContext Context passed through traversal.
	 * @param {?ReactComponent} child React child component.
	 * @param {!string} name String name of key path to child.
	 * @param {number=} selfDebugID Optional debugID of the current internal instance.
	 */
	function flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID) {
	  // We found a component instance.
	  if (traverseContext && typeof traverseContext === 'object') {
	    var result = traverseContext;
	    var keyUnique = result[name] === undefined;
	    if (false) {
	      if (!ReactComponentTreeHook) {
	        ReactComponentTreeHook = require('react/lib/ReactComponentTreeHook');
	      }
	      if (!keyUnique) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeHook.getStackAddendumByID(selfDebugID)) : void 0;
	      }
	    }
	    if (keyUnique && child != null) {
	      result[name] = child;
	    }
	  }
	}
	
	/**
	 * Flattens children that are typically specified as `props.children`. Any null
	 * children will not be included in the resulting object.
	 * @return {!object} flattened children keyed by name.
	 */
	function flattenChildren(children, selfDebugID) {
	  if (children == null) {
	    return children;
	  }
	  var result = {};
	
	  if (false) {
	    traverseAllChildren(children, function (traverseContext, child, name) {
	      return flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID);
	    }, result);
	  } else {
	    traverseAllChildren(children, flattenSingleChildIntoContext, result);
	  }
	  return result;
	}
	
	module.exports = flattenChildren;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(58)))

/***/ }),
/* 474 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var getEventCharCode = __webpack_require__(127);
	
	/**
	 * Normalization of deprecated HTML5 `key` values
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
	 */
	var normalizeKey = {
	  Esc: 'Escape',
	  Spacebar: ' ',
	  Left: 'ArrowLeft',
	  Up: 'ArrowUp',
	  Right: 'ArrowRight',
	  Down: 'ArrowDown',
	  Del: 'Delete',
	  Win: 'OS',
	  Menu: 'ContextMenu',
	  Apps: 'ContextMenu',
	  Scroll: 'ScrollLock',
	  MozPrintableKey: 'Unidentified'
	};
	
	/**
	 * Translation from legacy `keyCode` to HTML5 `key`
	 * Only special keys supported, all others depend on keyboard layout or browser
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
	 */
	var translateToKey = {
	  8: 'Backspace',
	  9: 'Tab',
	  12: 'Clear',
	  13: 'Enter',
	  16: 'Shift',
	  17: 'Control',
	  18: 'Alt',
	  19: 'Pause',
	  20: 'CapsLock',
	  27: 'Escape',
	  32: ' ',
	  33: 'PageUp',
	  34: 'PageDown',
	  35: 'End',
	  36: 'Home',
	  37: 'ArrowLeft',
	  38: 'ArrowUp',
	  39: 'ArrowRight',
	  40: 'ArrowDown',
	  45: 'Insert',
	  46: 'Delete',
	  112: 'F1',
	  113: 'F2',
	  114: 'F3',
	  115: 'F4',
	  116: 'F5',
	  117: 'F6',
	  118: 'F7',
	  119: 'F8',
	  120: 'F9',
	  121: 'F10',
	  122: 'F11',
	  123: 'F12',
	  144: 'NumLock',
	  145: 'ScrollLock',
	  224: 'Meta'
	};
	
	/**
	 * @param {object} nativeEvent Native browser event.
	 * @return {string} Normalized `key` property.
	 */
	function getEventKey(nativeEvent) {
	  if (nativeEvent.key) {
	    // Normalize inconsistent values reported by browsers due to
	    // implementations of a working draft specification.
	
	    // FireFox implements `key` but returns `MozPrintableKey` for all
	    // printable characters (normalized to `Unidentified`), ignore it.
	    var key = normalizeKey[nativeEvent.key] || nativeEvent.key;
	    if (key !== 'Unidentified') {
	      return key;
	    }
	  }
	
	  // Browser does not implement `key`, polyfill as much of it as we can.
	  if (nativeEvent.type === 'keypress') {
	    var charCode = getEventCharCode(nativeEvent);
	
	    // The enter-key is technically both printable and non-printable and can
	    // thus be captured by `keypress`, no other non-printable key should.
	    return charCode === 13 ? 'Enter' : String.fromCharCode(charCode);
	  }
	  if (nativeEvent.type === 'keydown' || nativeEvent.type === 'keyup') {
	    // While user keyboard layout determines the actual meaning of each
	    // `keyCode` value, almost all function keys have a universal value.
	    return translateToKey[nativeEvent.keyCode] || 'Unidentified';
	  }
	  return '';
	}
	
	module.exports = getEventKey;

/***/ }),
/* 475 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	/* global Symbol */
	
	var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
	
	/**
	 * Returns the iterator method function contained on the iterable object.
	 *
	 * Be sure to invoke the function with the iterable as context:
	 *
	 *     var iteratorFn = getIteratorFn(myIterable);
	 *     if (iteratorFn) {
	 *       var iterator = iteratorFn.call(myIterable);
	 *       ...
	 *     }
	 *
	 * @param {?object} maybeIterable
	 * @return {?function}
	 */
	function getIteratorFn(maybeIterable) {
	  var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	  if (typeof iteratorFn === 'function') {
	    return iteratorFn;
	  }
	}
	
	module.exports = getIteratorFn;

/***/ }),
/* 476 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Given any node return the first leaf node without children.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @return {DOMElement|DOMTextNode}
	 */
	
	function getLeafNode(node) {
	  while (node && node.firstChild) {
	    node = node.firstChild;
	  }
	  return node;
	}
	
	/**
	 * Get the next sibling within a container. This will walk up the
	 * DOM if a node's siblings have been exhausted.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @return {?DOMElement|DOMTextNode}
	 */
	function getSiblingNode(node) {
	  while (node) {
	    if (node.nextSibling) {
	      return node.nextSibling;
	    }
	    node = node.parentNode;
	  }
	}
	
	/**
	 * Get object describing the nodes which contain characters at offset.
	 *
	 * @param {DOMElement|DOMTextNode} root
	 * @param {number} offset
	 * @return {?object}
	 */
	function getNodeForCharacterOffset(root, offset) {
	  var node = getLeafNode(root);
	  var nodeStart = 0;
	  var nodeEnd = 0;
	
	  while (node) {
	    if (node.nodeType === 3) {
	      nodeEnd = nodeStart + node.textContent.length;
	
	      if (nodeStart <= offset && nodeEnd >= offset) {
	        return {
	          node: node,
	          offset: offset - nodeStart
	        };
	      }
	
	      nodeStart = nodeEnd;
	    }
	
	    node = getLeafNode(getSiblingNode(node));
	  }
	}
	
	module.exports = getNodeForCharacterOffset;

/***/ }),
/* 477 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(16);
	
	/**
	 * Generate a mapping of standard vendor prefixes using the defined style property and event name.
	 *
	 * @param {string} styleProp
	 * @param {string} eventName
	 * @returns {object}
	 */
	function makePrefixMap(styleProp, eventName) {
	  var prefixes = {};
	
	  prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
	  prefixes['Webkit' + styleProp] = 'webkit' + eventName;
	  prefixes['Moz' + styleProp] = 'moz' + eventName;
	  prefixes['ms' + styleProp] = 'MS' + eventName;
	  prefixes['O' + styleProp] = 'o' + eventName.toLowerCase();
	
	  return prefixes;
	}
	
	/**
	 * A list of event names to a configurable list of vendor prefixes.
	 */
	var vendorPrefixes = {
	  animationend: makePrefixMap('Animation', 'AnimationEnd'),
	  animationiteration: makePrefixMap('Animation', 'AnimationIteration'),
	  animationstart: makePrefixMap('Animation', 'AnimationStart'),
	  transitionend: makePrefixMap('Transition', 'TransitionEnd')
	};
	
	/**
	 * Event names that have already been detected and prefixed (if applicable).
	 */
	var prefixedEventNames = {};
	
	/**
	 * Element to check for prefixes on.
	 */
	var style = {};
	
	/**
	 * Bootstrap if a DOM exists.
	 */
	if (ExecutionEnvironment.canUseDOM) {
	  style = document.createElement('div').style;
	
	  // On some platforms, in particular some releases of Android 4.x,
	  // the un-prefixed "animation" and "transition" properties are defined on the
	  // style object but the events that fire will still be prefixed, so we need
	  // to check if the un-prefixed events are usable, and if not remove them from the map.
	  if (!('AnimationEvent' in window)) {
	    delete vendorPrefixes.animationend.animation;
	    delete vendorPrefixes.animationiteration.animation;
	    delete vendorPrefixes.animationstart.animation;
	  }
	
	  // Same as above
	  if (!('TransitionEvent' in window)) {
	    delete vendorPrefixes.transitionend.transition;
	  }
	}
	
	/**
	 * Attempts to determine the correct vendor prefixed event name.
	 *
	 * @param {string} eventName
	 * @returns {string}
	 */
	function getVendorPrefixedEventName(eventName) {
	  if (prefixedEventNames[eventName]) {
	    return prefixedEventNames[eventName];
	  } else if (!vendorPrefixes[eventName]) {
	    return eventName;
	  }
	
	  var prefixMap = vendorPrefixes[eventName];
	
	  for (var styleProp in prefixMap) {
	    if (prefixMap.hasOwnProperty(styleProp) && styleProp in style) {
	      return prefixedEventNames[eventName] = prefixMap[styleProp];
	    }
	  }
	
	  return '';
	}
	
	module.exports = getVendorPrefixedEventName;

/***/ }),
/* 478 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var escapeTextContentForBrowser = __webpack_require__(86);
	
	/**
	 * Escapes attribute value to prevent scripting attacks.
	 *
	 * @param {*} value Value to escape.
	 * @return {string} An escaped string.
	 */
	function quoteAttributeValueForBrowser(value) {
	  return '"' + escapeTextContentForBrowser(value) + '"';
	}
	
	module.exports = quoteAttributeValueForBrowser;

/***/ }),
/* 479 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactMount = __webpack_require__(205);
	
	module.exports = ReactMount.renderSubtreeIntoContainer;

/***/ }),
/* 480 */
121,
/* 481 */
[500, 63],
/* 482 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var PooledClass = __webpack_require__(481);
	var ReactElement = __webpack_require__(48);
	
	var emptyFunction = __webpack_require__(24);
	var traverseAllChildren = __webpack_require__(491);
	
	var twoArgumentPooler = PooledClass.twoArgumentPooler;
	var fourArgumentPooler = PooledClass.fourArgumentPooler;
	
	var userProvidedKeyEscapeRegex = /\/+/g;
	function escapeUserProvidedKey(text) {
	  return ('' + text).replace(userProvidedKeyEscapeRegex, '$&/');
	}
	
	/**
	 * PooledClass representing the bookkeeping associated with performing a child
	 * traversal. Allows avoiding binding callbacks.
	 *
	 * @constructor ForEachBookKeeping
	 * @param {!function} forEachFunction Function to perform traversal with.
	 * @param {?*} forEachContext Context to perform context with.
	 */
	function ForEachBookKeeping(forEachFunction, forEachContext) {
	  this.func = forEachFunction;
	  this.context = forEachContext;
	  this.count = 0;
	}
	ForEachBookKeeping.prototype.destructor = function () {
	  this.func = null;
	  this.context = null;
	  this.count = 0;
	};
	PooledClass.addPoolingTo(ForEachBookKeeping, twoArgumentPooler);
	
	function forEachSingleChild(bookKeeping, child, name) {
	  var func = bookKeeping.func,
	      context = bookKeeping.context;
	
	  func.call(context, child, bookKeeping.count++);
	}
	
	/**
	 * Iterates through children that are typically specified as `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.foreach
	 *
	 * The provided forEachFunc(child, index) will be called for each
	 * leaf child.
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} forEachFunc
	 * @param {*} forEachContext Context for forEachContext.
	 */
	function forEachChildren(children, forEachFunc, forEachContext) {
	  if (children == null) {
	    return children;
	  }
	  var traverseContext = ForEachBookKeeping.getPooled(forEachFunc, forEachContext);
	  traverseAllChildren(children, forEachSingleChild, traverseContext);
	  ForEachBookKeeping.release(traverseContext);
	}
	
	/**
	 * PooledClass representing the bookkeeping associated with performing a child
	 * mapping. Allows avoiding binding callbacks.
	 *
	 * @constructor MapBookKeeping
	 * @param {!*} mapResult Object containing the ordered map of results.
	 * @param {!function} mapFunction Function to perform mapping with.
	 * @param {?*} mapContext Context to perform mapping with.
	 */
	function MapBookKeeping(mapResult, keyPrefix, mapFunction, mapContext) {
	  this.result = mapResult;
	  this.keyPrefix = keyPrefix;
	  this.func = mapFunction;
	  this.context = mapContext;
	  this.count = 0;
	}
	MapBookKeeping.prototype.destructor = function () {
	  this.result = null;
	  this.keyPrefix = null;
	  this.func = null;
	  this.context = null;
	  this.count = 0;
	};
	PooledClass.addPoolingTo(MapBookKeeping, fourArgumentPooler);
	
	function mapSingleChildIntoContext(bookKeeping, child, childKey) {
	  var result = bookKeeping.result,
	      keyPrefix = bookKeeping.keyPrefix,
	      func = bookKeeping.func,
	      context = bookKeeping.context;
	
	
	  var mappedChild = func.call(context, child, bookKeeping.count++);
	  if (Array.isArray(mappedChild)) {
	    mapIntoWithKeyPrefixInternal(mappedChild, result, childKey, emptyFunction.thatReturnsArgument);
	  } else if (mappedChild != null) {
	    if (ReactElement.isValidElement(mappedChild)) {
	      mappedChild = ReactElement.cloneAndReplaceKey(mappedChild,
	      // Keep both the (mapped) and old keys if they differ, just as
	      // traverseAllChildren used to do for objects as children
	      keyPrefix + (mappedChild.key && (!child || child.key !== mappedChild.key) ? escapeUserProvidedKey(mappedChild.key) + '/' : '') + childKey);
	    }
	    result.push(mappedChild);
	  }
	}
	
	function mapIntoWithKeyPrefixInternal(children, array, prefix, func, context) {
	  var escapedPrefix = '';
	  if (prefix != null) {
	    escapedPrefix = escapeUserProvidedKey(prefix) + '/';
	  }
	  var traverseContext = MapBookKeeping.getPooled(array, escapedPrefix, func, context);
	  traverseAllChildren(children, mapSingleChildIntoContext, traverseContext);
	  MapBookKeeping.release(traverseContext);
	}
	
	/**
	 * Maps children that are typically specified as `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.map
	 *
	 * The provided mapFunction(child, key, index) will be called for each
	 * leaf child.
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} func The map function.
	 * @param {*} context Context for mapFunction.
	 * @return {object} Object containing the ordered map of results.
	 */
	function mapChildren(children, func, context) {
	  if (children == null) {
	    return children;
	  }
	  var result = [];
	  mapIntoWithKeyPrefixInternal(children, result, null, func, context);
	  return result;
	}
	
	function forEachSingleChildDummy(traverseContext, child, name) {
	  return null;
	}
	
	/**
	 * Count the number of children that are typically specified as
	 * `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.count
	 *
	 * @param {?*} children Children tree container.
	 * @return {number} The number of children.
	 */
	function countChildren(children, context) {
	  return traverseAllChildren(children, forEachSingleChildDummy, null);
	}
	
	/**
	 * Flatten a children object (typically specified as `props.children`) and
	 * return an array with appropriately re-keyed children.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.toarray
	 */
	function toArray(children) {
	  var result = [];
	  mapIntoWithKeyPrefixInternal(children, result, null, emptyFunction.thatReturnsArgument);
	  return result;
	}
	
	var ReactChildren = {
	  forEach: forEachChildren,
	  map: mapChildren,
	  mapIntoWithKeyPrefixInternal: mapIntoWithKeyPrefixInternal,
	  count: countChildren,
	  toArray: toArray
	};
	
	module.exports = ReactChildren;

/***/ }),
/* 483 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactElement = __webpack_require__(48);
	
	/**
	 * Create a factory that creates HTML tag elements.
	 *
	 * @private
	 */
	var createDOMFactory = ReactElement.createFactory;
	if (false) {
	  var ReactElementValidator = require('./ReactElementValidator');
	  createDOMFactory = ReactElementValidator.createFactory;
	}
	
	/**
	 * Creates a mapping from supported HTML tags to `ReactDOMComponent` classes.
	 *
	 * @public
	 */
	var ReactDOMFactories = {
	  a: createDOMFactory('a'),
	  abbr: createDOMFactory('abbr'),
	  address: createDOMFactory('address'),
	  area: createDOMFactory('area'),
	  article: createDOMFactory('article'),
	  aside: createDOMFactory('aside'),
	  audio: createDOMFactory('audio'),
	  b: createDOMFactory('b'),
	  base: createDOMFactory('base'),
	  bdi: createDOMFactory('bdi'),
	  bdo: createDOMFactory('bdo'),
	  big: createDOMFactory('big'),
	  blockquote: createDOMFactory('blockquote'),
	  body: createDOMFactory('body'),
	  br: createDOMFactory('br'),
	  button: createDOMFactory('button'),
	  canvas: createDOMFactory('canvas'),
	  caption: createDOMFactory('caption'),
	  cite: createDOMFactory('cite'),
	  code: createDOMFactory('code'),
	  col: createDOMFactory('col'),
	  colgroup: createDOMFactory('colgroup'),
	  data: createDOMFactory('data'),
	  datalist: createDOMFactory('datalist'),
	  dd: createDOMFactory('dd'),
	  del: createDOMFactory('del'),
	  details: createDOMFactory('details'),
	  dfn: createDOMFactory('dfn'),
	  dialog: createDOMFactory('dialog'),
	  div: createDOMFactory('div'),
	  dl: createDOMFactory('dl'),
	  dt: createDOMFactory('dt'),
	  em: createDOMFactory('em'),
	  embed: createDOMFactory('embed'),
	  fieldset: createDOMFactory('fieldset'),
	  figcaption: createDOMFactory('figcaption'),
	  figure: createDOMFactory('figure'),
	  footer: createDOMFactory('footer'),
	  form: createDOMFactory('form'),
	  h1: createDOMFactory('h1'),
	  h2: createDOMFactory('h2'),
	  h3: createDOMFactory('h3'),
	  h4: createDOMFactory('h4'),
	  h5: createDOMFactory('h5'),
	  h6: createDOMFactory('h6'),
	  head: createDOMFactory('head'),
	  header: createDOMFactory('header'),
	  hgroup: createDOMFactory('hgroup'),
	  hr: createDOMFactory('hr'),
	  html: createDOMFactory('html'),
	  i: createDOMFactory('i'),
	  iframe: createDOMFactory('iframe'),
	  img: createDOMFactory('img'),
	  input: createDOMFactory('input'),
	  ins: createDOMFactory('ins'),
	  kbd: createDOMFactory('kbd'),
	  keygen: createDOMFactory('keygen'),
	  label: createDOMFactory('label'),
	  legend: createDOMFactory('legend'),
	  li: createDOMFactory('li'),
	  link: createDOMFactory('link'),
	  main: createDOMFactory('main'),
	  map: createDOMFactory('map'),
	  mark: createDOMFactory('mark'),
	  menu: createDOMFactory('menu'),
	  menuitem: createDOMFactory('menuitem'),
	  meta: createDOMFactory('meta'),
	  meter: createDOMFactory('meter'),
	  nav: createDOMFactory('nav'),
	  noscript: createDOMFactory('noscript'),
	  object: createDOMFactory('object'),
	  ol: createDOMFactory('ol'),
	  optgroup: createDOMFactory('optgroup'),
	  option: createDOMFactory('option'),
	  output: createDOMFactory('output'),
	  p: createDOMFactory('p'),
	  param: createDOMFactory('param'),
	  picture: createDOMFactory('picture'),
	  pre: createDOMFactory('pre'),
	  progress: createDOMFactory('progress'),
	  q: createDOMFactory('q'),
	  rp: createDOMFactory('rp'),
	  rt: createDOMFactory('rt'),
	  ruby: createDOMFactory('ruby'),
	  s: createDOMFactory('s'),
	  samp: createDOMFactory('samp'),
	  script: createDOMFactory('script'),
	  section: createDOMFactory('section'),
	  select: createDOMFactory('select'),
	  small: createDOMFactory('small'),
	  source: createDOMFactory('source'),
	  span: createDOMFactory('span'),
	  strong: createDOMFactory('strong'),
	  style: createDOMFactory('style'),
	  sub: createDOMFactory('sub'),
	  summary: createDOMFactory('summary'),
	  sup: createDOMFactory('sup'),
	  table: createDOMFactory('table'),
	  tbody: createDOMFactory('tbody'),
	  td: createDOMFactory('td'),
	  textarea: createDOMFactory('textarea'),
	  tfoot: createDOMFactory('tfoot'),
	  th: createDOMFactory('th'),
	  thead: createDOMFactory('thead'),
	  time: createDOMFactory('time'),
	  title: createDOMFactory('title'),
	  tr: createDOMFactory('tr'),
	  track: createDOMFactory('track'),
	  u: createDOMFactory('u'),
	  ul: createDOMFactory('ul'),
	  'var': createDOMFactory('var'),
	  video: createDOMFactory('video'),
	  wbr: createDOMFactory('wbr'),
	
	  // SVG
	  circle: createDOMFactory('circle'),
	  clipPath: createDOMFactory('clipPath'),
	  defs: createDOMFactory('defs'),
	  ellipse: createDOMFactory('ellipse'),
	  g: createDOMFactory('g'),
	  image: createDOMFactory('image'),
	  line: createDOMFactory('line'),
	  linearGradient: createDOMFactory('linearGradient'),
	  mask: createDOMFactory('mask'),
	  path: createDOMFactory('path'),
	  pattern: createDOMFactory('pattern'),
	  polygon: createDOMFactory('polygon'),
	  polyline: createDOMFactory('polyline'),
	  radialGradient: createDOMFactory('radialGradient'),
	  rect: createDOMFactory('rect'),
	  stop: createDOMFactory('stop'),
	  svg: createDOMFactory('svg'),
	  text: createDOMFactory('text'),
	  tspan: createDOMFactory('tspan')
	};
	
	module.exports = ReactDOMFactories;

/***/ }),
/* 484 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _require = __webpack_require__(48),
	    isValidElement = _require.isValidElement;
	
	var factory = __webpack_require__(195);
	
	module.exports = factory(isValidElement);

/***/ }),
/* 485 */
456,
/* 486 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _require = __webpack_require__(217),
	    Component = _require.Component;
	
	var _require2 = __webpack_require__(48),
	    isValidElement = _require2.isValidElement;
	
	var ReactNoopUpdateQueue = __webpack_require__(220);
	var factory = __webpack_require__(380);
	
	module.exports = factory(Component, isValidElement, ReactNoopUpdateQueue);

/***/ }),
/* 487 */
475,
/* 488 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var nextDebugID = 1;
	
	function getNextDebugID() {
	  return nextDebugID++;
	}
	
	module.exports = getNextDebugID;

/***/ }),
/* 489 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Forked from fbjs/warning:
	 * https://github.com/facebook/fbjs/blob/e66ba20ad5be433eb54423f2b097d829324d9de6/packages/fbjs/src/__forks__/warning.js
	 *
	 * Only change is we use console.warn instead of console.error,
	 * and do nothing when 'console' is not supported.
	 * This really simplifies the code.
	 * ---
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var lowPriorityWarning = function () {};
	
	if (false) {
	  var printWarning = function (format) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    var argIndex = 0;
	    var message = 'Warning: ' + format.replace(/%s/g, function () {
	      return args[argIndex++];
	    });
	    if (typeof console !== 'undefined') {
	      console.warn(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	
	  lowPriorityWarning = function (condition, format) {
	    if (format === undefined) {
	      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
	    }
	    if (!condition) {
	      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
	        args[_key2 - 2] = arguments[_key2];
	      }
	
	      printWarning.apply(undefined, [format].concat(args));
	    }
	  };
	}
	
	module.exports = lowPriorityWarning;

/***/ }),
/* 490 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	'use strict';
	
	var _prodInvariant = __webpack_require__(63);
	
	var ReactElement = __webpack_require__(48);
	
	var invariant = __webpack_require__(3);
	
	/**
	 * Returns the first child in a collection of children and verifies that there
	 * is only one child in the collection.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.only
	 *
	 * The current implementation of this function assumes that a single child gets
	 * passed without a wrapper, but the purpose of this helper function is to
	 * abstract away the particular structure of children.
	 *
	 * @param {?object} children Child collection structure.
	 * @return {ReactElement} The first and only `ReactElement` contained in the
	 * structure.
	 */
	function onlyChild(children) {
	  !ReactElement.isValidElement(children) ?  false ? invariant(false, 'React.Children.only expected to receive a single React element child.') : _prodInvariant('143') : void 0;
	  return children;
	}
	
	module.exports = onlyChild;

/***/ }),
/* 491 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(63);
	
	var ReactCurrentOwner = __webpack_require__(32);
	var REACT_ELEMENT_TYPE = __webpack_require__(219);
	
	var getIteratorFn = __webpack_require__(487);
	var invariant = __webpack_require__(3);
	var KeyEscapeUtils = __webpack_require__(480);
	var warning = __webpack_require__(5);
	
	var SEPARATOR = '.';
	var SUBSEPARATOR = ':';
	
	/**
	 * This is inlined from ReactElement since this file is shared between
	 * isomorphic and renderers. We could extract this to a
	 *
	 */
	
	/**
	 * TODO: Test that a single child and an array with one item have the same key
	 * pattern.
	 */
	
	var didWarnAboutMaps = false;
	
	/**
	 * Generate a key string that identifies a component within a set.
	 *
	 * @param {*} component A component that could contain a manual key.
	 * @param {number} index Index that is used if a manual key is not provided.
	 * @return {string}
	 */
	function getComponentKey(component, index) {
	  // Do some typechecking here since we call this blindly. We want to ensure
	  // that we don't block potential future ES APIs.
	  if (component && typeof component === 'object' && component.key != null) {
	    // Explicit key
	    return KeyEscapeUtils.escape(component.key);
	  }
	  // Implicit key determined by the index in the set
	  return index.toString(36);
	}
	
	/**
	 * @param {?*} children Children tree container.
	 * @param {!string} nameSoFar Name of the key path so far.
	 * @param {!function} callback Callback to invoke with each child found.
	 * @param {?*} traverseContext Used to pass information throughout the traversal
	 * process.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
	  var type = typeof children;
	
	  if (type === 'undefined' || type === 'boolean') {
	    // All of the above are perceived as null.
	    children = null;
	  }
	
	  if (children === null || type === 'string' || type === 'number' ||
	  // The following is inlined from ReactElement. This means we can optimize
	  // some checks. React Fiber also inlines this logic for similar purposes.
	  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
	    callback(traverseContext, children,
	    // If it's the only child, treat the name as if it was wrapped in an array
	    // so that it's consistent if the number of children grows.
	    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
	    return 1;
	  }
	
	  var child;
	  var nextName;
	  var subtreeCount = 0; // Count of children found in the current subtree.
	  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;
	
	  if (Array.isArray(children)) {
	    for (var i = 0; i < children.length; i++) {
	      child = children[i];
	      nextName = nextNamePrefix + getComponentKey(child, i);
	      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	    }
	  } else {
	    var iteratorFn = getIteratorFn(children);
	    if (iteratorFn) {
	      var iterator = iteratorFn.call(children);
	      var step;
	      if (iteratorFn !== children.entries) {
	        var ii = 0;
	        while (!(step = iterator.next()).done) {
	          child = step.value;
	          nextName = nextNamePrefix + getComponentKey(child, ii++);
	          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	        }
	      } else {
	        if (false) {
	          var mapsAsChildrenAddendum = '';
	          if (ReactCurrentOwner.current) {
	            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
	            if (mapsAsChildrenOwnerName) {
	              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
	            }
	          }
	          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
	          didWarnAboutMaps = true;
	        }
	        // Iterator will provide entry [k,v] tuples rather than values.
	        while (!(step = iterator.next()).done) {
	          var entry = step.value;
	          if (entry) {
	            child = entry[1];
	            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
	            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	          }
	        }
	      }
	    } else if (type === 'object') {
	      var addendum = '';
	      if (false) {
	        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
	        if (children._isReactElement) {
	          addendum = " It looks like you're using an element created by a different " + 'version of React. Make sure to use only one copy of React.';
	        }
	        if (ReactCurrentOwner.current) {
	          var name = ReactCurrentOwner.current.getName();
	          if (name) {
	            addendum += ' Check the render method of `' + name + '`.';
	          }
	        }
	      }
	      var childrenString = String(children);
	       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
	    }
	  }
	
	  return subtreeCount;
	}
	
	/**
	 * Traverses children that are typically specified as `props.children`, but
	 * might also be specified through attributes:
	 *
	 * - `traverseAllChildren(this.props.children, ...)`
	 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
	 *
	 * The `traverseContext` is an optional argument that is passed through the
	 * entire traversal. It can be used to store accumulations or anything else that
	 * the callback might find relevant.
	 *
	 * @param {?*} children Children tree object.
	 * @param {!function} callback To invoke upon traversing each child.
	 * @param {?*} traverseContext Context for traversal.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildren(children, callback, traverseContext) {
	  if (children == null) {
	    return 0;
	  }
	
	  return traverseAllChildrenImpl(children, '', callback, traverseContext);
	}
	
	module.exports = traverseAllChildren;

/***/ }),
/* 492 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
	    "use strict";
	
	    if (global.setImmediate) {
	        return;
	    }
	
	    var nextHandle = 1; // Spec says greater than zero
	    var tasksByHandle = {};
	    var currentlyRunningATask = false;
	    var doc = global.document;
	    var registerImmediate;
	
	    function setImmediate(callback) {
	      // Callback can either be a function or a string
	      if (typeof callback !== "function") {
	        callback = new Function("" + callback);
	      }
	      // Copy function arguments
	      var args = new Array(arguments.length - 1);
	      for (var i = 0; i < args.length; i++) {
	          args[i] = arguments[i + 1];
	      }
	      // Store and register the task
	      var task = { callback: callback, args: args };
	      tasksByHandle[nextHandle] = task;
	      registerImmediate(nextHandle);
	      return nextHandle++;
	    }
	
	    function clearImmediate(handle) {
	        delete tasksByHandle[handle];
	    }
	
	    function run(task) {
	        var callback = task.callback;
	        var args = task.args;
	        switch (args.length) {
	        case 0:
	            callback();
	            break;
	        case 1:
	            callback(args[0]);
	            break;
	        case 2:
	            callback(args[0], args[1]);
	            break;
	        case 3:
	            callback(args[0], args[1], args[2]);
	            break;
	        default:
	            callback.apply(undefined, args);
	            break;
	        }
	    }
	
	    function runIfPresent(handle) {
	        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
	        // So if we're currently running a task, we'll need to delay this invocation.
	        if (currentlyRunningATask) {
	            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
	            // "too much recursion" error.
	            setTimeout(runIfPresent, 0, handle);
	        } else {
	            var task = tasksByHandle[handle];
	            if (task) {
	                currentlyRunningATask = true;
	                try {
	                    run(task);
	                } finally {
	                    clearImmediate(handle);
	                    currentlyRunningATask = false;
	                }
	            }
	        }
	    }
	
	    function installNextTickImplementation() {
	        registerImmediate = function(handle) {
	            process.nextTick(function () { runIfPresent(handle); });
	        };
	    }
	
	    function canUsePostMessage() {
	        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
	        // where `global.postMessage` means something completely different and can't be used for this purpose.
	        if (global.postMessage && !global.importScripts) {
	            var postMessageIsAsynchronous = true;
	            var oldOnMessage = global.onmessage;
	            global.onmessage = function() {
	                postMessageIsAsynchronous = false;
	            };
	            global.postMessage("", "*");
	            global.onmessage = oldOnMessage;
	            return postMessageIsAsynchronous;
	        }
	    }
	
	    function installPostMessageImplementation() {
	        // Installs an event handler on `global` for the `message` event: see
	        // * https://developer.mozilla.org/en/DOM/window.postMessage
	        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages
	
	        var messagePrefix = "setImmediate$" + Math.random() + "$";
	        var onGlobalMessage = function(event) {
	            if (event.source === global &&
	                typeof event.data === "string" &&
	                event.data.indexOf(messagePrefix) === 0) {
	                runIfPresent(+event.data.slice(messagePrefix.length));
	            }
	        };
	
	        if (global.addEventListener) {
	            global.addEventListener("message", onGlobalMessage, false);
	        } else {
	            global.attachEvent("onmessage", onGlobalMessage);
	        }
	
	        registerImmediate = function(handle) {
	            global.postMessage(messagePrefix + handle, "*");
	        };
	    }
	
	    function installMessageChannelImplementation() {
	        var channel = new MessageChannel();
	        channel.port1.onmessage = function(event) {
	            var handle = event.data;
	            runIfPresent(handle);
	        };
	
	        registerImmediate = function(handle) {
	            channel.port2.postMessage(handle);
	        };
	    }
	
	    function installReadyStateChangeImplementation() {
	        var html = doc.documentElement;
	        registerImmediate = function(handle) {
	            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
	            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
	            var script = doc.createElement("script");
	            script.onreadystatechange = function () {
	                runIfPresent(handle);
	                script.onreadystatechange = null;
	                html.removeChild(script);
	                script = null;
	            };
	            html.appendChild(script);
	        };
	    }
	
	    function installSetTimeoutImplementation() {
	        registerImmediate = function(handle) {
	            setTimeout(runIfPresent, 0, handle);
	        };
	    }
	
	    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
	    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
	    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;
	
	    // Don't get fooled by e.g. browserify environments.
	    if ({}.toString.call(global.process) === "[object process]") {
	        // For Node.js before 0.9
	        installNextTickImplementation();
	
	    } else if (canUsePostMessage()) {
	        // For non-IE10 modern browsers
	        installPostMessageImplementation();
	
	    } else if (global.MessageChannel) {
	        // For web workers, where supported
	        installMessageChannelImplementation();
	
	    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
	        // For IE 6–8
	        installReadyStateChangeImplementation();
	
	    } else {
	        // For older browsers
	        installSetTimeoutImplementation();
	    }
	
	    attachTo.setImmediate = setImmediate;
	    attachTo.clearImmediate = clearImmediate;
	}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(58)))

/***/ }),
/* 493 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(381);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(88)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../node_modules/css-loader/index.js!./App.css", function() {
				var newContent = require("!!../../node_modules/css-loader/index.js!./App.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 494 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(382);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(88)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../node_modules/css-loader/index.js!./Calendar.css", function() {
				var newContent = require("!!../../node_modules/css-loader/index.js!./Calendar.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 495 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(383);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(88)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../node_modules/css-loader/index.js!./Content.css", function() {
				var newContent = require("!!../../node_modules/css-loader/index.js!./Content.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 496 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(384);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(88)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../node_modules/css-loader/index.js!./Rsvp.css", function() {
				var newContent = require("!!../../node_modules/css-loader/index.js!./Rsvp.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 497 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var apply = Function.prototype.apply;
	
	// DOM APIs, for completeness
	
	exports.setTimeout = function() {
	  return new Timeout(apply.call(setTimeout, window, arguments), clearTimeout);
	};
	exports.setInterval = function() {
	  return new Timeout(apply.call(setInterval, window, arguments), clearInterval);
	};
	exports.clearTimeout =
	exports.clearInterval = function(timeout) {
	  if (timeout) {
	    timeout.close();
	  }
	};
	
	function Timeout(id, clearFn) {
	  this._id = id;
	  this._clearFn = clearFn;
	}
	Timeout.prototype.unref = Timeout.prototype.ref = function() {};
	Timeout.prototype.close = function() {
	  this._clearFn.call(window, this._id);
	};
	
	// Does not start the time, just sets up the members needed.
	exports.enroll = function(item, msecs) {
	  clearTimeout(item._idleTimeoutId);
	  item._idleTimeout = msecs;
	};
	
	exports.unenroll = function(item) {
	  clearTimeout(item._idleTimeoutId);
	  item._idleTimeout = -1;
	};
	
	exports._unrefActive = exports.active = function(item) {
	  clearTimeout(item._idleTimeoutId);
	
	  var msecs = item._idleTimeout;
	  if (msecs >= 0) {
	    item._idleTimeoutId = setTimeout(function onTimeout() {
	      if (item._onTimeout)
	        item._onTimeout();
	    }, msecs);
	  }
	};
	
	// setimmediate attaches itself to the global object
	__webpack_require__(492);
	// On some exotic environments, it's not clear which object `setimmeidate` was
	// able to install onto.  Search each possibility in the same order as the
	// `setimmediate` library.
	exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
	                       (typeof global !== "undefined" && global.setImmediate) ||
	                       (this && this.setImmediate);
	exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
	                         (typeof global !== "undefined" && global.clearImmediate) ||
	                         (this && this.clearImmediate);
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 498 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "bde9befe774e22bde0f3992684d92056.jpg";

/***/ }),
/* 499 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "d69399a526fa8534c9e2cb9afd2674a6.png";

/***/ }),
/* 500 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(__webpack_module_template_argument_0__);
	
	var invariant = __webpack_require__(3);
	
	/**
	 * Static poolers. Several custom versions for each potential number of
	 * arguments. A completely generic pooler is easy to implement, but would
	 * require accessing the `arguments` object. In each of these, `this` refers to
	 * the Class itself, not an instance. If any others are needed, simply add them
	 * here, or in their own files.
	 */
	var oneArgumentPooler = function (copyFieldsFrom) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, copyFieldsFrom);
	    return instance;
	  } else {
	    return new Klass(copyFieldsFrom);
	  }
	};
	
	var twoArgumentPooler = function (a1, a2) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2);
	    return instance;
	  } else {
	    return new Klass(a1, a2);
	  }
	};
	
	var threeArgumentPooler = function (a1, a2, a3) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3);
	  }
	};
	
	var fourArgumentPooler = function (a1, a2, a3, a4) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3, a4);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3, a4);
	  }
	};
	
	var standardReleaser = function (instance) {
	  var Klass = this;
	  !(instance instanceof Klass) ?  false ? invariant(false, 'Trying to release an instance into a pool of a different type.') : _prodInvariant('25') : void 0;
	  instance.destructor();
	  if (Klass.instancePool.length < Klass.poolSize) {
	    Klass.instancePool.push(instance);
	  }
	};
	
	var DEFAULT_POOL_SIZE = 10;
	var DEFAULT_POOLER = oneArgumentPooler;
	
	/**
	 * Augments `CopyConstructor` to be a poolable class, augmenting only the class
	 * itself (statically) not adding any prototypical fields. Any CopyConstructor
	 * you give this may have a `poolSize` property, and will look for a
	 * prototypical `destructor` on instances.
	 *
	 * @param {Function} CopyConstructor Constructor that can be used to reset.
	 * @param {Function} pooler Customizable pooler.
	 */
	var addPoolingTo = function (CopyConstructor, pooler) {
	  // Casting as any so that flow ignores the actual implementation and trusts
	  // it to match the type we declared
	  var NewKlass = CopyConstructor;
	  NewKlass.instancePool = [];
	  NewKlass.getPooled = pooler || DEFAULT_POOLER;
	  if (!NewKlass.poolSize) {
	    NewKlass.poolSize = DEFAULT_POOL_SIZE;
	  }
	  NewKlass.release = standardReleaser;
	  return NewKlass;
	};
	
	var PooledClass = {
	  addPoolingTo: addPoolingTo,
	  oneArgumentPooler: oneArgumentPooler,
	  twoArgumentPooler: twoArgumentPooler,
	  threeArgumentPooler: threeArgumentPooler,
	  fourArgumentPooler: fourArgumentPooler
	};
	
	module.exports = PooledClass;

/***/ })
/******/ ])));


// WEBPACK FOOTER //
// app.js